(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.hu.eI === region.gG.eI)
	{
		return 'on line ' + region.hu.eI;
	}
	return 'on lines ' + region.hu.eI + ' through ' + region.gG.eI;
}



// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iA,
		impl.jR,
		impl.nh,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		cg: func(record.cg),
		f7: record.f7,
		fV: record.fV
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.cg;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.f7;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.fV) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iA,
		impl.jR,
		impl.nh,
		function(sendToApp, initialModel) {
			var view = impl.nE;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.iA,
		impl.jR,
		impl.nh,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.hn && impl.hn(sendToApp)
			var view = impl.nE;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.O);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.jJ) && (_VirtualDom_doc.title = title = doc.jJ);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.ml;
	var onUrlRequest = impl.mm;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		hn: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.jh === next.jh
							&& curr.gR === next.gR
							&& curr.ja.a === next.ja.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		iA: function(flags)
		{
			return A3(impl.iA, flags, _Browser_getUrl(), key);
		},
		nE: impl.nE,
		jR: impl.jR,
		nh: impl.nh
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { lf: 'hidden', ky: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { lf: 'mozHidden', ky: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { lf: 'msHidden', ky: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { lf: 'webkitHidden', ky: 'webkitvisibilitychange' }
		: { lf: 'hidden', ky: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		jq: _Browser_getScene(),
		jW: {
			nL: _Browser_window.pageXOffset,
			nN: _Browser_window.pageYOffset,
			jZ: _Browser_doc.documentElement.clientWidth,
			iv: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		jZ: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		iv: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			jq: {
				jZ: node.scrollWidth,
				iv: node.scrollHeight
			},
			jW: {
				nL: node.scrollLeft,
				nN: node.scrollTop,
				jZ: node.clientWidth,
				iv: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			jq: _Browser_getScene(),
			jW: {
				nL: x,
				nN: y,
				jZ: _Browser_doc.documentElement.clientWidth,
				iv: _Browser_doc.documentElement.clientHeight
			},
			gF: {
				nL: x + rect.left,
				nN: y + rect.top,
				jZ: rect.width,
				iv: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.a4.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.a4.b, xhr)); });
		$elm$core$Maybe$isJust(request.bf) && _Http_track(router, xhr, request.bf.a);

		try {
			xhr.open(request.ba, request.G, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.G));
		}

		_Http_configureRequest(xhr, request);

		request.O.a && xhr.setRequestHeader('Content-Type', request.O.a);
		xhr.send(request.O.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.ah; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.be.a || 0;
	xhr.responseType = request.a4.d;
	xhr.withCredentials = request.ke;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		G: xhr.responseURL,
		e_: xhr.status,
		hw: xhr.statusText,
		ah: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			mZ: event.loaded,
			de: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			mC: event.loaded,
			de: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.l8) { flags += 'm'; }
	if (options.kx) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});




// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.kN))
		{
			lang = options.kN.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.k7.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.nj,
		breaks: gfm && gfm.ku,
		sanitize: options.mU,
		smartypants: options.m5
	};
}



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}

var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$LinkClicked = function (a) {
	return {$: 8, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $author$project$Main$UrlChange = function (a) {
	return {$: 5, a: a};
};
var $elm$core$List$cons = _List_cons;
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.R) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.V),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.V);
		} else {
			var treeLen = builder.R * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.W) : builder.W;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.R);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.V) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.V);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{W: nodeList, R: (len / $elm$core$Array$branchFactor) | 0, V: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {ir: fragment, gR: host, mv: path, ja: port_, jh: protocol, bw: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$application = _Browser_application;
var $elm$json$Json$Decode$field = _Json_decodeField;
var $author$project$Auth0$Auth0Config = F3(
	function (domain, clientId, redirectURL) {
		return {h8: clientId, ii: domain, jk: redirectURL};
	});
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $author$project$Ports$fetchCsrfToken = _Platform_outgoingPort(
	'fetchCsrfToken',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Main$authenticateStep1 = $author$project$Ports$fetchCsrfToken(0);
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Ports$consoleInfo = _Platform_outgoingPort('consoleInfo', $elm$json$Json$Encode$string);
var $author$project$Api$Endpoint$create = function (flags) {
	return {fg: flags.fg, ks: $elm$core$Maybe$Nothing, kH: $elm$core$Maybe$Nothing, g6: flags.g6, g7: flags.g7};
};
var $author$project$SharedConfig$create = F2(
	function (flags, key) {
		return {
			gr: $author$project$Api$Endpoint$create(flags),
			gv: flags.gv,
			iJ: key
		};
	});
var $author$project$Locale$Hungarian$isFirstNameFirst = false;
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix = {$: 6};
var $ryan_haskell$date_format$DateFormat$dayOfMonthSuffix = $ryan_haskell$date_format$DateFormat$DayOfMonthSuffix;
var $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryan_haskell$date_format$DateFormat$dayOfWeekNameFull = $ryan_haskell$date_format$DateFormat$DayOfWeekNameFull;
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.hu, posixMinutes) < 0) {
					return posixMinutes + era.f;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryan_haskell$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.ns(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		fq: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		iT: month,
		j1: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).fq;
	});
var $ryan_haskell$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryan_haskell$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $ryan_haskell$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryan_haskell$date_format$DateFormat$days)))));
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $ryan_haskell$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryan_haskell$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryan_haskell$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryan_haskell$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).iT;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryan_haskell$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryan_haskell$date_format$DateFormat$months))));
	});
var $ryan_haskell$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryan_haskell$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).j1;
	});
var $ryan_haskell$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryan_haskell$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryan_haskell$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryan_haskell$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryan_haskell$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$core$String$toLower = _String_toLower;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$core$Basics$round = _Basics_round;
var $ryan_haskell$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryan_haskell$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryan_haskell$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryan_haskell$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryan_haskell$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryan_haskell$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.nu(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.nv(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					1 + A2($ryan_haskell$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($ryan_haskell$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.nw(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.nx(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.ef(num));
				}(
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($ryan_haskell$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryan_haskell$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryan_haskell$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryan_haskell$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					$ryan_haskell$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryan_haskell$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryan_haskell$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryan_haskell$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryan_haskell$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {ns: toAmPm, nu: toMonthAbbreviation, nv: toMonthName, ef: toOrdinalSuffix, nw: toWeekdayAbbreviation, nx: toWeekdayName};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Locale$Hungarian$toHungarianAmPm = function (hour) {
	return (hour > 11) ? 'du.' : 'de.';
};
var $author$project$Locale$Hungarian$toHungarianMonthAbbreviaton = function (month) {
	switch (month) {
		case 0:
			return 'jan.';
		case 1:
			return 'febr.';
		case 2:
			return 'márc.';
		case 3:
			return 'ápr.';
		case 4:
			return 'máj.';
		case 5:
			return 'jún.';
		case 6:
			return 'júl.';
		case 7:
			return 'aug.';
		case 8:
			return 'szept.';
		case 9:
			return 'okt.';
		case 10:
			return 'nov.';
		default:
			return 'dec.';
	}
};
var $author$project$Locale$Hungarian$toHungarianMonthName = function (month) {
	switch (month) {
		case 0:
			return 'január';
		case 1:
			return 'február';
		case 2:
			return 'március';
		case 3:
			return 'április';
		case 4:
			return 'május';
		case 5:
			return 'június';
		case 6:
			return 'július';
		case 7:
			return 'augusztus';
		case 8:
			return 'szeptember';
		case 9:
			return 'október';
		case 10:
			return 'november';
		default:
			return 'decemeber';
	}
};
var $author$project$Locale$Hungarian$toHungarianWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'hétfő';
		case 1:
			return 'kedd';
		case 2:
			return 'szerda';
		case 3:
			return 'csütörtök';
		case 4:
			return 'péntek';
		case 5:
			return 'szombat';
		default:
			return 'vasárnap';
	}
};
var $author$project$Locale$Hungarian$hungarian = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$author$project$Locale$Hungarian$toHungarianMonthName,
	$author$project$Locale$Hungarian$toHungarianMonthAbbreviaton,
	$author$project$Locale$Hungarian$toHungarianWeekdayName,
	$author$project$Locale$Hungarian$toHungarianWeekdayName,
	$author$project$Locale$Hungarian$toHungarianAmPm,
	$elm$core$Basics$always('.'));
var $ryan_haskell$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryan_haskell$date_format$DateFormat$monthNameFull = $ryan_haskell$date_format$DateFormat$MonthNameFull;
var $ryan_haskell$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryan_haskell$date_format$DateFormat$text = $ryan_haskell$date_format$DateFormat$Text;
var $ryan_haskell$date_format$DateFormat$YearNumber = {$: 16};
var $ryan_haskell$date_format$DateFormat$yearNumber = $ryan_haskell$date_format$DateFormat$YearNumber;
var $author$project$Locale$Hungarian$dateFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('. '),
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')')
		]));
var $ryan_haskell$date_format$DateFormat$HourMilitaryNumber = {$: 24};
var $ryan_haskell$date_format$DateFormat$hourMilitaryNumber = $ryan_haskell$date_format$DateFormat$HourMilitaryNumber;
var $ryan_haskell$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryan_haskell$date_format$DateFormat$minuteFixed = $ryan_haskell$date_format$DateFormat$MinuteFixed;
var $author$project$Locale$Hungarian$dateTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text('. '),
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')'),
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Locale$Hungarian$formatDays = function (weekdays) {
	var weekdayToText = function (weekday) {
		switch (weekday) {
			case 'MO':
				return 'hétfőn';
			case 'TU':
				return 'kedden';
			case 'WE':
				return 'szerdán';
			case 'TH':
				return 'csütörtökön';
			case 'FR':
				return 'pénteken';
			default:
				return '';
		}
	};
	if (!weekdays.$) {
		var weekdays_ = weekdays.a;
		return A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, weekdayToText, weekdays_));
	} else {
		return '';
	}
};
var $author$project$Locale$Hungarian$formatRecurring = F2(
	function (frequency, interval) {
		var _v0 = _Utils_Tuple2(frequency, interval);
		if (((_v0.a === 'Weekly') && (!_v0.b.$)) && (_v0.b.a === 2)) {
			return 'kéthetente ';
		} else {
			return 'minden héten ';
		}
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Hungarian$nameList = function (names) {
	var _v0 = $elm$core$List$reverse(names);
	if (!_v0.b) {
		return '';
	} else {
		if (!_v0.b.b) {
			var x = _v0.a;
			return x;
		} else {
			var x = _v0.a;
			var xs = _v0.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(xs)) + (' és ' + x);
		}
	}
};
var $ryan_haskell$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryan_haskell$date_format$DateFormat$dayOfMonthNumber = $ryan_haskell$date_format$DateFormat$DayOfMonthNumber;
var $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryan_haskell$date_format$DateFormat$monthNameAbbreviated = $ryan_haskell$date_format$DateFormat$MonthNameAbbreviated;
var $author$project$Locale$Hungarian$termFormatter = F3(
	function (zone, start, end) {
		var sameYear = _Utils_eq(
			A2($elm$time$Time$toYear, zone, start),
			A2($elm$time$Time$toYear, zone, end));
		var sameMonth = _Utils_eq(
			A2($elm$time$Time$toMonth, zone, start),
			A2($elm$time$Time$toMonth, zone, end));
		var sameDay = _Utils_eq(
			A2($elm$time$Time$toDay, zone, start),
			A2($elm$time$Time$toDay, zone, end));
		var _v0 = _Utils_Tuple3(sameYear, sameMonth, sameDay);
		if (_v0.a) {
			if (_v0.b) {
				if (_v0.c) {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text('. '),
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text('.'),
								$ryan_haskell$date_format$DateFormat$text(' ('),
								$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
								$ryan_haskell$date_format$DateFormat$text(')')
							]),
						zone,
						start);
					return startDate;
				} else {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text('. '),
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
							]),
						zone,
						start);
					var endDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$author$project$Locale$Hungarian$hungarian,
						_List_fromArray(
							[$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix]),
						zone,
						end);
					return startDate + (' – ' + endDate);
				}
			} else {
				var startDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$author$project$Locale$Hungarian$hungarian,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$yearNumber,
							$ryan_haskell$date_format$DateFormat$text('. '),
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
						]),
					zone,
					start);
				var endDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$author$project$Locale$Hungarian$hungarian,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix
						]),
					zone,
					end);
				return startDate + (' – ' + endDate);
			}
		} else {
			var startDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$author$project$Locale$Hungarian$hungarian,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$yearNumber,
						$ryan_haskell$date_format$DateFormat$text('. '),
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
					]),
				zone,
				start);
			var endDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$author$project$Locale$Hungarian$hungarian,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$yearNumber,
						$ryan_haskell$date_format$DateFormat$text('. '),
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix
					]),
				zone,
				end);
			return startDate + (' – ' + endDate);
		}
	});
var $author$project$Locale$Hungarian$timeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$author$project$Locale$Hungarian$hungarian,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $rl_king$elm_iso3166_country_codes$Iso3166$Hungarian$toName = function (c) {
	switch (c) {
		case 0:
			return 'Andorra';
		case 1:
			return 'Egyesült Arab Emírségek';
		case 2:
			return 'Afganisztán';
		case 3:
			return 'Antigua és Barbuda';
		case 4:
			return 'Anguilla';
		case 5:
			return 'Albánia';
		case 6:
			return 'Örményország';
		case 7:
			return 'Angola';
		case 8:
			return 'Antarktisz';
		case 9:
			return 'Argentína';
		case 10:
			return 'Amerikai Szamoa';
		case 11:
			return 'Ausztria';
		case 12:
			return 'Ausztrália';
		case 13:
			return 'Aruba';
		case 14:
			return 'Åland';
		case 15:
			return 'Azerbajdzsán';
		case 16:
			return 'Bosznia-Hercegovina';
		case 17:
			return 'Barbados';
		case 18:
			return 'Banglades';
		case 19:
			return 'Belgium';
		case 20:
			return 'Burkina Faso';
		case 21:
			return 'Bulgária';
		case 22:
			return 'Bahrein';
		case 23:
			return 'Burundi';
		case 24:
			return 'Benin';
		case 25:
			return 'Saint-Barthélemy';
		case 26:
			return 'Bermuda';
		case 27:
			return 'Brunei';
		case 28:
			return 'Bolívia';
		case 29:
			return 'Karibi Hollandia (Bonaire, Saba, Sint Eustatius)';
		case 30:
			return 'Brazília';
		case 31:
			return 'Bahama-szigetek';
		case 32:
			return 'Bhután';
		case 33:
			return 'Bouvet-sziget';
		case 34:
			return 'Botswana';
		case 35:
			return 'Fehéroroszország';
		case 36:
			return 'Belize';
		case 37:
			return 'Kanada';
		case 38:
			return 'Kókusz (Keeling)-szigetek';
		case 39:
			return 'Kongói Demokratikus Köztársaság (Zaire)';
		case 40:
			return 'Közép-Afrika';
		case 41:
			return 'Kongói Köztársaság (Kongó)';
		case 42:
			return 'Svájc';
		case 43:
			return 'Elefántcsontpart';
		case 44:
			return 'Cook-szigetek';
		case 45:
			return 'Chile';
		case 46:
			return 'Kamerun';
		case 47:
			return 'Kína';
		case 48:
			return 'Kolumbia';
		case 49:
			return 'Costa Rica';
		case 50:
			return 'Kuba';
		case 51:
			return 'Zöld-foki Köztársaság';
		case 52:
			return 'Curaçao';
		case 53:
			return 'Karácsony-sziget';
		case 54:
			return 'Ciprus';
		case 55:
			return 'Csehország';
		case 56:
			return 'Németország';
		case 57:
			return 'Dzsibuti';
		case 58:
			return 'Dánia';
		case 59:
			return 'Dominikai Közösség';
		case 60:
			return 'Dominikai Köztársaság';
		case 61:
			return 'Algéria';
		case 62:
			return 'Ecuador';
		case 63:
			return 'Észtország';
		case 64:
			return 'Egyiptom';
		case 65:
			return 'Nyugat-Szahara';
		case 66:
			return 'Eritrea';
		case 67:
			return 'Spanyolország';
		case 68:
			return 'Etiópia';
		case 69:
			return 'Finnország';
		case 70:
			return 'Fidzsi';
		case 71:
			return 'Falkland-szigetek';
		case 72:
			return 'Mikronézia';
		case 73:
			return 'Feröer';
		case 74:
			return 'Franciaország';
		case 75:
			return 'Gabon';
		case 76:
			return 'Egyesült Királyság';
		case 77:
			return 'Grenada';
		case 78:
			return 'Grúzia';
		case 79:
			return 'Francia Guyana Francia Guyana';
		case 80:
			return 'Guernsey Bailiffség';
		case 81:
			return 'Ghána';
		case 82:
			return 'Gibraltár';
		case 83:
			return 'Grönland';
		case 84:
			return 'Gambia';
		case 85:
			return 'Guinea';
		case 86:
			return 'Guadeloupe';
		case 87:
			return 'Egyenlítői-Guinea';
		case 88:
			return 'Görögország';
		case 89:
			return 'Déli-Georgia és Déli-Sandwich-szigetek';
		case 90:
			return 'Guatemala';
		case 91:
			return 'Guam';
		case 92:
			return 'Bissau-Guinea';
		case 93:
			return 'Guyana';
		case 94:
			return 'Hongkong';
		case 95:
			return 'Heard-sziget és McDonald-szigetek';
		case 96:
			return 'Honduras';
		case 97:
			return 'Horvátország';
		case 98:
			return 'Haiti';
		case 99:
			return 'Magyarország';
		case 100:
			return 'Indonézia';
		case 101:
			return 'Írország';
		case 102:
			return 'Izrael';
		case 103:
			return 'Man-sziget';
		case 104:
			return 'India';
		case 105:
			return 'Brit Indiai-óceáni Terület';
		case 106:
			return 'Irak';
		case 107:
			return 'Irán';
		case 108:
			return 'Izland';
		case 109:
			return 'Olaszország';
		case 110:
			return 'Jersey Bailiffség';
		case 111:
			return 'Jamaica';
		case 112:
			return 'Jordánia';
		case 113:
			return 'Japán';
		case 114:
			return 'Kenya';
		case 115:
			return 'Kirgizisztán';
		case 116:
			return 'Kambodzsa';
		case 117:
			return 'Kiribati';
		case 118:
			return 'Comore-szigetek';
		case 119:
			return 'Saint Kitts és Nevis';
		case 120:
			return 'Észak-Korea (Koreai NDK)';
		case 121:
			return 'Dél-Korea (Koreai Köztársaság)';
		case 122:
			return 'Kuvait';
		case 123:
			return 'Kajmán-szigetek';
		case 124:
			return 'Kazahsztán';
		case 125:
			return 'Laosz';
		case 126:
			return 'Libanon';
		case 127:
			return 'Saint Lucia';
		case 128:
			return 'Liechtenstein';
		case 129:
			return 'Srí Lanka';
		case 130:
			return 'Libéria';
		case 131:
			return 'Lesotho';
		case 132:
			return 'Litvánia';
		case 133:
			return 'Luxemburg';
		case 134:
			return 'Lettország';
		case 135:
			return 'Líbia';
		case 136:
			return 'Marokkó';
		case 137:
			return 'Monaco';
		case 138:
			return 'Moldova';
		case 139:
			return 'Montenegró';
		case 140:
			return 'Saint-Martin';
		case 141:
			return 'Madagaszkár';
		case 142:
			return 'Marshall-szigetek';
		case 143:
			return 'Észak-Macedónia';
		case 144:
			return 'Mali';
		case 145:
			return 'Mianmar';
		case 146:
			return 'Mongólia';
		case 147:
			return 'Makaó';
		case 148:
			return 'Északi-Mariana-szigetek';
		case 149:
			return 'Martinique';
		case 150:
			return 'Mauritánia';
		case 151:
			return 'Montserrat';
		case 152:
			return 'Málta';
		case 153:
			return 'Mauritius';
		case 154:
			return 'Maldív-szigetek';
		case 155:
			return 'Malawi';
		case 156:
			return 'Mexikó';
		case 157:
			return 'Malajzia';
		case 158:
			return 'Mozambik';
		case 159:
			return 'Namíbia';
		case 160:
			return 'Új-Kaledónia';
		case 161:
			return 'Niger';
		case 162:
			return 'Norfolk-sziget';
		case 163:
			return 'Nigéria';
		case 164:
			return 'Nicaragua';
		case 165:
			return 'Hollandia';
		case 166:
			return 'Norvégia';
		case 167:
			return 'Nepál';
		case 168:
			return 'Nauru';
		case 169:
			return 'Niue';
		case 170:
			return 'Új-Zéland';
		case 171:
			return 'Omán';
		case 172:
			return 'Panama';
		case 173:
			return 'Peru';
		case 174:
			return 'Francia Polinézia';
		case 175:
			return 'Pápua Új-Guinea';
		case 176:
			return 'Fülöp-szigetek';
		case 177:
			return 'Pakisztán';
		case 178:
			return 'Lengyelország';
		case 179:
			return 'Saint-Pierre és Miquelon';
		case 180:
			return 'Pitcairn-szigetek';
		case 181:
			return 'Puerto Rico';
		case 182:
			return 'Palesztina';
		case 183:
			return 'Portugália';
		case 184:
			return 'Palau';
		case 185:
			return 'Paraguay';
		case 186:
			return 'Katar';
		case 187:
			return 'Réunion';
		case 188:
			return 'Románia';
		case 189:
			return 'Szerbia';
		case 190:
			return 'Oroszország';
		case 191:
			return 'Ruanda';
		case 192:
			return 'Szaúd-Arábia';
		case 193:
			return 'Salamon-szigetek';
		case 194:
			return 'Seychelle-szigetek';
		case 195:
			return 'Szudán';
		case 196:
			return 'Svédország';
		case 197:
			return 'Szingapúr';
		case 198:
			return 'Szent Ilona';
		case 199:
			return 'Szlovénia';
		case 200:
			return 'Spitzbergák és Jan Mayen-sziget';
		case 201:
			return 'Szlovákia';
		case 202:
			return 'Sierra Leone';
		case 203:
			return 'San Marino';
		case 204:
			return 'Szenegál';
		case 205:
			return 'Szomália';
		case 206:
			return 'Suriname';
		case 207:
			return 'Dél-Szudán';
		case 208:
			return 'São Tomé és Príncipe';
		case 209:
			return 'Salvador';
		case 210:
			return 'Sint Maarten';
		case 211:
			return 'Szíria';
		case 212:
			return 'Szváziföld';
		case 213:
			return 'Turks- és Caicos-szigetek';
		case 214:
			return 'Csád';
		case 215:
			return 'Francia déli és antarktiszi területek';
		case 216:
			return 'Togo';
		case 217:
			return 'Thaiföld';
		case 218:
			return 'Tádzsikisztán';
		case 219:
			return 'Tokelau-szigetek';
		case 220:
			return 'Kelet-Timor';
		case 221:
			return 'Türkmenisztán';
		case 222:
			return 'Tunézia';
		case 223:
			return 'Tonga';
		case 224:
			return 'Törökország';
		case 225:
			return 'Trinidad és Tobago';
		case 226:
			return 'Tuvalu';
		case 227:
			return 'Tajvan';
		case 228:
			return 'Tanzánia';
		case 229:
			return 'Ukrajna';
		case 230:
			return 'Uganda';
		case 231:
			return 'Amerikai Csendes-óceáni szigetek';
		case 232:
			return 'Amerikai Egyesült Államok';
		case 233:
			return 'Uruguay';
		case 234:
			return 'Üzbegisztán';
		case 235:
			return 'Vatikán';
		case 236:
			return 'Saint Vincent és a Grenadine-szigetek';
		case 237:
			return 'Venezuela';
		case 238:
			return 'Brit Virgin-szigetek';
		case 239:
			return 'Amerikai Virgin-szigetek';
		case 240:
			return 'Vietnám';
		case 241:
			return 'Vanuatu';
		case 242:
			return 'Wallis és Futuna';
		case 243:
			return 'Szamoa';
		case 244:
			return 'Jemen';
		case 245:
			return 'Mayotte';
		case 246:
			return 'Dél-afrikai Köztársaság';
		case 247:
			return 'Zambia';
		default:
			return 'Zimbabwe';
	}
};
var $author$project$Locale$Hungarian$translator = function (str) {
	switch (str.$) {
		case 0:
			var s = str.a;
			return s;
		case 1:
			return 'Változott: ';
		case 2:
			var caption = str.a;
			return caption;
		case 3:
			var caption = str.a;
			var from = str.b;
			var to = str.c;
			var visualizeEmpty = function (s) {
				return $elm$core$String$isEmpty(s) ? '∅' : s;
			};
			return caption + (' (' + (visualizeEmpty(from) + (' → ' + (visualizeEmpty(to) + ')'))));
		case 4:
			return 'Az értesítések betöltése sikertelen';
		case 5:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> feltöltött egy új tanulási szerződést <i>' + (student + '</i> gyerekhez.')));
		case 6:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> frissítette <i>' + (student + '</i> tanulási szerződését.')));
		case 8:
			return 'Jelenleg nincsenek értesítések.';
		case 7:
			return 'Értesítések betöltése...';
		case 9:
			var person = str.a;
			return '<i>' + (person + '</i> mentornaplója frissült.');
		case 10:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> frissítette a tanáradatait.');
		case 11:
			var student = str.a;
			return '<i>' + (student + '</i> részt vett egy foglalkozáson.');
		case 12:
			var person = str.a;
			return '<i>' + (person + '</i> frissítette az elérhetőségeit.');
		case 13:
			var approvedBy = str.a;
			var student = str.b;
			return '<i>' + (approvedBy + ('</i> frissítette <i>' + (student + '</i> gyerekadatait.')));
		case 14:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> frissítette a tanáradatait.');
		case 15:
			return 'Legutóbbi értesítések';
		case 16:
			return 'Megnézem';
		case 17:
			return 'Tanulási szerződés';
		case 18:
			var count = str.a;
			return $elm$core$String$fromInt(count) + ' tanulási eredmény hozzáadása';
		case 19:
			return 'Méltatás';
		case 20:
			return 'Tanulási eredmény visszavonása';
		case 21:
			return 'Ismerj el egy tanulási eredményt';
		case 22:
			return 'Ha töröljük a tanulási eredményt, akkor azt nem számítjuk be többé az eredményszámításba. Biztos ezt szeretnéd?';
		case 23:
			return 'Hiba történt a tanulási eredmény visszavonása közben';
		case 24:
			return 'Sikeresen töröltem a tanulási eredményt.';
		case 25:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Miből látod, hogy ',
						$author$project$Locale$Hungarian$nameList(names),
						' elért tanulási eredményeket?'
					]));
		case 26:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Kedves ',
						$author$project$Locale$Hungarian$nameList(names),
						'! Még ezt szeretném mondani a fenti visszajelzéssel kapcsolatban:'
					]));
		case 27:
			var names = str.a;
			return $author$project$Locale$Hungarian$nameList(names) + ' tanulási eredményeit elismerted.';
		case 28:
			return 'Műveletek';
		case 30:
			return '+';
		case 29:
			return '-';
		case 31:
			return 'Létrehozás';
		case 32:
			return 'Törlés';
		case 33:
			return 'Szerkesztés';
		case 34:
			return 'Belépés';
		case 35:
			return 'Visszaállítás';
		case 36:
			return 'Mentés';
		case 37:
			return 'OK';
		case 38:
			return 'Megnézem';
		case 39:
			return 'Mégse';
		case 40:
			return 'Kiválasztás';
		case 41:
			return 'Kiválasztás törlése';
		case 42:
			return 'Szűrők';
		case 43:
			return 'A Google Tantermek kurzus lista betöltése sikertelen';
		case 44:
			var animal = str.a;
			var count = str.b;
			return $elm$core$String$fromInt(count) + (' ' + animal);
		case 45:
			return 'Counter';
		case 46:
			var code = str.a;
			return $rl_king$elm_iso3166_country_codes$Iso3166$Hungarian$toName(code);
		case 47:
			return 'Egész napos hiányzások';
		case 48:
			return 'A hiányzási adatok betöltése sikertelen';
		case 49:
			return 'Egész napos jelenlét';
		case 50:
			return 'Vedd ki a pipát azoknak a neve elől, akik egész nap hiányoztak. Ha valakinek a neve előtt pipát látsz, az nem jelenti azt, hogy ő egész nap jelen volt, csak annyit, hogy nem hiányzott minden óráról.';
		case 52:
			return 'ÉÉÉÉ-HH-NN';
		case 51:
			return 'A visszajelzés adatok betöltése sikertelen';
		case 53:
			return 'A dátum várt formátuma: ÉÉÉÉ-HH-NN';
		case 54:
			return 'A telefonszám várt formátuma: +36301234567';
		case 55:
			return 'Helytelen webcím';
		case 56:
			var mime = str.a;
			return 'Nem támogatott fájlformátum: ' + mime;
		case 58:
			var size = str.a;
			return 'A fájl túl nagy (' + ($elm$core$String$fromInt((((size / 1024) | 0) / 1024) | 0) + 'MB)');
		case 57:
			return 'Az idő várt 24-órás formátuma: ÓÓ:PP';
		case 59:
			return 'A vége dátum nem lehet hamarabb, mint a kezdő dátum!';
		case 60:
			return 'Nincs kiválasztható opció';
		case 61:
			return 'Hiba történt a dokumentum feltöltése közben';
		case 62:
			return 'Nincs kiválasztva';
		case 63:
			return ' – nem kötelező';
		case 64:
			return 'Több elem kiválasztásához tartsd nyomva a <kbd>Ctrl</kbd> (Windows/Linux) vagy <kbd>Cmd</kbd> (Mac) billentyűt, miközben egérrel kattintva kijelölöd őket.';
		case 65:
			return 'Nem töltöttél fel dokumentumot!';
		case 66:
			return 'Nem lehet üres!';
		case 67:
			return 'Kérlek, írj kicsit hosszabban!';
		case 68:
			return 'Kérlek, válassz egy lehetőséget!';
		case 69:
			return 'Hiba történt az adatok mentése közben';
		case 70:
			return 'Összes kijelölése';
		case 71:
			return 'Egyik sem';
		case 72:
			return 'ÓÓ:PP';
		case 73:
			return 'My BPS';
		case 74:
			return 'Lezárt modulok';
		case 75:
			return 'Az értesítők betöltése sikertelen';
		case 76:
			return 'Osztályzatok PDF-ben';
		case 77:
			return 'Visszajelzések PDF-ben';
		case 78:
			return 'felmentve';
		case 79:
			return 'Betöltöm az értesítőket, kérlek, várj...';
		case 80:
			return 'Nincsen elérhető értesítő a gyerek számára';
		case 81:
			return 'Tantárgy';
		case 82:
			return 'Szöveges értékelés';
		case 83:
			return 'Elért';
		case 84:
			return 'Elért tanulási eredmények';
		case 85:
			return 'Osztályzat';
		case 86:
			return 'Azt szeretnénk, hogy a jegyek az iskolai mindennapokban minél inkább háttérbe szoruljanak, ezért az osztályzatokat tartalmazó év végi értesítőt a 21/22-es tanévtől nem küldjük ki. Szülőként ezt a dokumentumot külön igényelned kell. Az <a href=\"https://forms.gle/JSnaSzAmgNRttLNw7\" target=\"_blank\">igényléshez ezt az űrlapot</a> szükséges kitöltened.';
		case 87:
			return 'Értesítők';
		case 88:
			return 'Kattints ide, ha szeretnéd tantárgyankénti bontásban böngészni a visszajelzéseket.';
		case 89:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' félév'));
		case 90:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' évvége'));
		case 91:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' osztályozó vizsga'));
		case 92:
			return 'Féléves keret';
		case 93:
			return 'Éves keret';
		case 94:
			return 'Félévi értesítő';
		case 95:
			return 'Évvégi értesítő';
		case 96:
			return 'Osztályozó vizsga értesítő';
		case 112:
			return 'F';
		case 113:
			return 'Érdemjegy áttekintő';
		case 114:
			return 'Betöltöm az érdemjegyeket, kérlek, várj...';
		case 115:
			return 'Értesítési időszak';
		case 116:
			return 'Évfolyam';
		case 117:
			return 'Iskola';
		case 118:
			return 'Gyerek';
		case 119:
			return 'Nincsenek elérhető értesítők.';
		case 120:
			return 'Nincsenek gyerekek az iskoládban. Ha ez szerinted téves, szólj nekünk.';
		case 97:
			return 'Tantárgyi osztályzatok';
		case 98:
			return 'Ha a gyerekednek szüksége van arra, hogy a tanárai a szöveges értékeléseit osztályzatokra váltsák át, akkor jelöld ki a tantárgy melletti check-boxot és kattints az Osztályzatokat igénylek gombra. Kérjük, csak azokból a tárgyakból igényelj osztályzatot, amelyekre a gyerekednek valami miatt aktuálisan szüksége van.';
		case 99:
			return 'Osztályzatokat igénylek';
		case 100:
			return 'Osztályzatok igénylése';
		case 101:
			return 'Osztályzat státusza';
		case 102:
			return 'Nincsen elérhető értesítő ami alapján osztályzatot igényelhetsz.';
		case 103:
			return 'Nincsenek tantárgyak, amelyekból osztályzatot igényelhetsz.';
		case 104:
			return 'Nem igényelt';
		case 105:
			return 'Hiba történt az osztályzatigénylés közben.';
		case 106:
			return 'Osztályzatigénylés sikeres.';
		case 107:
			return 'Tantárgy';
		case 108:
			return 'Osztályzás folyamatban';
		case 109:
			return 'Indoklás';
		case 110:
			return 'Indokold miért akarsz osztályzatot igényelni';
		case 111:
			return 'Osztályozás alól felmentve';
		case 121:
			return 'Szülők:';
		case 122:
			return 'A tanárok és szülők elérhetőségeit a telefonkönyvben találod.';
		case 123:
			return 'Telefonkönyv';
		case 124:
			return 'Itt egy helyen eléred a mikroiskola gyerekeit és a legfontosabb dokumentumaikat.';
		case 125:
			return 'Gyerekek';
		case 126:
			return 'Adatlap';
		case 127:
			return 'Aktív';
		case 128:
			return 'Inaktív';
		case 129:
			return 'Nem töltöttél fel igazoló dokumentumot!';
		case 130:
			return 'Az igazoló dokumentumot az szmsz-ben meghatározott módon tároljuk.';
		case 131:
			return 'A tanulási értékelések betöltése sikertelen';
		case 132:
			return 'Vége dátum';
		case 133:
			return 'Kezdő dátum';
		case 134:
			return 'Gyerek';
		case 135:
			return 'Dokumentum link';
		case 136:
			return 'A tanulási szerződések betöltése sikertelen';
		case 137:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, start, end);
		case 138:
			var name = str.a;
			return name + ' tanulási szerződése';
		case 140:
			return 'Jelenleg nincs feltöltve tanulási szerződés. Ha szerinted hiányzik valami, kérlek, lépj kapcsolatba a gyereked mentorával.';
		case 141:
			return 'Még nem töltöttél fel tanulási szerződéseket. Vigyél fel egy újat!';
		case 142:
			return 'A keresett tanulási szerződés nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 139:
			return 'Betöltöm a tanulási szerződéseket, kérlek, várj...';
		case 143:
			return 'Sikeresen elmentettem a tanulási szerződést.';
		case 144:
			return 'Tanulási szerződés szerkesztése';
		case 145:
			return 'Új tanulási szerződés feltöltése';
		case 146:
			return 'Tanulási szerződések';
		case 147:
			return 'Saját csoport';
		case 148:
			return 'Mikroiskola csoport';
		case 149:
			return 'Hiba történt a csoport törlése közben.';
		case 150:
			return 'Sikeresen töröltem a csoportot.';
		case 151:
			return 'A csoportok betöltése sikertelen';
		case 152:
			return 'Nincsenek gyerekek a csoportban.';
		case 153:
			return 'Megosztás';
		case 154:
			return 'Csoport neve';
		case 155:
			return 'Iskola kiválasztása';
		case 156:
			return 'Gyerekek kiválasztása';
		case 157:
			return 'Csoport szerkesztése';
		case 158:
			return 'Új csoport létrehozása';
		case 159:
			return 'Csoportok listája';
		case 160:
			return 'Minden csoport';
		case 161:
			return 'Nem találhatók csoportok';
		case 162:
			return 'Betöltöm a csoportokat, kérlek, várj...';
		case 163:
			return 'Saját csoportok';
		case 164:
			return 'Mikroiskola csoportok';
		case 165:
			return 'Keresés a csoport címében és a tagok között';
		case 166:
			return 'Csoportok';
		case 167:
			return 'Hiba történt a csoport mentése közben.';
		case 168:
			return 'Sikeresen elmentettem a csoportot.';
		case 169:
			return 'Csoportok';
		case 170:
			return 'Válaszd ki a csoportot a legördülő listából, hogy a tagjait hozzá add a modulod résztvevőihez.';
		case 171:
			return 'Adj csoportokat a modulodhoz';
		case 172:
			return 'Csoportok';
		case 173:
			return 'Indul a My BPS, egy pillanat az egész...';
		case 174:
			return 'Belépés a My BPS-be';
		case 175:
			return 'A MyBPS csak a BPS-es gyerekek, szülők és tanárok számára elérhető.';
		case 176:
			return 'Kijelentkezés...';
		case 177:
			return 'Tanulási eredmények böngésző';
		case 178:
			return 'NAT tanulási eredmények böngésző';
		case 179:
			return 'Tanterv';
		case 180:
			return 'Évfolyam';
		case 181:
			var goalStart = str.a;
			var goalEnd = str.b;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Azaz legalább ',
						$elm$core$String$fromInt(goalStart),
						' tanulási eredmény kell a ketteshez, és ',
						$elm$core$String$fromInt(goalEnd),
						' az ötöshöz.'
					]));
		case 182:
			var name = str.a.ha;
			var first = str.a.a;
			var last = str.a.b;
			return _Utils_eq(first, last) ? (name + (' (' + ($elm$core$String$fromInt(first) + ')'))) : (name + (' (' + ($elm$core$String$fromInt(first) + ('-' + ($elm$core$String$fromInt(last) + ')')))));
		case 183:
			return 'Tantárgyak';
		case 184:
			return 'Keresés a tanulási eredményekben';
		case 185:
			return 'Összesen';
		case 186:
			return 'év alatt';
		case 187:
			return 'trimeszterenként*';
		case 188:
			return 'Megszerezhető tanulási eredmény';
		case 189:
			return 'Nincsenek a modulhoz felvett gyerekek tantervjének megfelelő tanulasi eredmények.';
		case 190:
			return 'Nincsenek gyerekek az iskoládban. Ha ez szerinted téves, szólj nekünk.';
		case 191:
			var name = str.a;
			var grade = str.b;
			return name + (' (' + (grade + '. évf.)'));
		case 192:
			return 'Teljesítte (név szerint)';
		case 193:
			return 'Tantárgy';
		case 194:
			return 'Teljesítte (%)';
		case 195:
			return 'Eredmények';
		case 196:
			return 'Portfolió történet megtekintése';
		case 197:
			return 'Modulzáró visszajelzés megtekintése';
		case 203:
			return 'Sajnálom, ez nem sikerült';
		case 204:
			return 'Belépés sikertelen:';
		case 205:
			return 'Kijelentkezés sikertelen:';
		case 206:
			var url = str.a;
			return 'Nem található weboldal a ' + (url + ' címen.');
		case 207:
			return 'Az adatlapod letöltése sikertelen:';
		case 208:
			return 'Próbáld újra, amit legutoljára csináltál. Gyakran ez csak egy átmeneti hiba. A hibáról automatikusan értesültünk. Ha a probléma tartósan fent áll, kérlek, írj nekünk a <a href=\"mailto:tech@budapestschool.org\">tech@budapestschool.org</a> címen, és utána járunk a hibának.';
		case 209:
			return 'Jó hír, hogy egy újabb verziója elérhető az alkalmazásnak.';
		case 210:
			return 'Töltsd újra az appot, hogy használhasd!';
		case 211:
			return 'Modulzáró visszajelzés';
		case 212:
			return 'Minden modul elvégzése után a modul céljai, témája, fókusza alapján a gyerekek visszajelzést kapnak a tanulásukról, alkotásaikról, eredményeikről, fejlődésükről és viselkedésükről.';
		case 213:
			return 'Ehhez a modulhoz nem tartoznak még értékelőtáblázatok.';
		case 214:
			return 'Kinek adsz most visszajelzést?';
		case 215:
			return 'Hiba történt a visszajelzés mentése közben';
		case 216:
			return 'Sikeresen elmentettem a visszajelzést.';
		case 217:
			return 'Túl sok a diák a modulzáró visszajelzésben.';
		case 218:
			return 'Modulzárás áttekintő (1. trimeszter)';
		case 219:
			return 'Betöltöm a modulzárás adatokat, kérlek, várj...';
		case 220:
			return 'Modulzárás áttekintő';
		case 221:
			return 'Gyerek';
		case 222:
			return 'Modul';
		case 223:
			return 'Modul lezárva?';
		case 224:
			return 'Iskola';
		case 225:
			return 'Csak mentoráltak';
		case 226:
			return 'Típus';
		case 198:
			var comment = str.a;
			return 'Mentortanári megjegyzés: ' + comment;
		case 199:
			return 'Mentortanári megjegyzés';
		case 200:
			return 'A táblázatról a szűlőknek lehetnek kérdései: miért ilyen sok a környezetismeret? miért ilyen kevés a matek? miért lett a 3-as énekből? hogy lett félév alatt 5-os matekból? Mit mondanál, hogy értse, mi van a számok mögött?';
		case 201:
			var names = str.a;
			return 'Kedves ' + ($author$project$Locale$Hungarian$nameList(names) + '! Az összesítő táblázat értelmezéséhez fontos tudnotok, hogy...');
		case 202:
			return 'Sikeresen elmentettem a mentortanári megjegyzést.';
		case 227:
			return 'Modul';
		case 228:
			return 'Cím';
		case 229:
			return 'Leírás';
		case 230:
			return 'Gyakoriság';
		case 231:
			return 'A megadott napokon';
		case 232:
			return 'Kezdődik';
		case 233:
			return 'Befejeződik';
		case 234:
			return 'Ezen a napon';
		case 235:
			return 'Első alkalom';
		case 236:
			return 'Utolsó alkalom';
		case 237:
			return 'A modulórák betöltése sikertelen';
		case 238:
			var title = str.a.jJ;
			var frequency = str.a.Q;
			var interval = str.a.iF;
			var weekdays = str.a.J;
			var isRecurring = str.a.lA;
			var startTime = str.a.M;
			var endTime = str.a.C;
			var startDate = str.a.hv;
			var endDate = str.a.gH;
			return isRecurring ? (title + (': ' + ((startDate + (' és ' + (endDate + ' között '))) + (A2($author$project$Locale$Hungarian$formatRecurring, frequency, interval) + ($author$project$Locale$Hungarian$formatDays(weekdays) + (' ' + (startTime + (' - ' + endTime)))))))) : (title + (': ' + (startDate + (', ' + (startTime + (' - ' + (endTime + ' között')))))));
		case 239:
			return 'Nem magyar állampolgár esetén a Magyarország területén való tartózkodás jogcíme és a tartózkodásra jogosító okirat megnevezése, száma';
		case 240:
			return 'Tartózkodási hely';
		case 241:
			return 'Végzettségével, szakképzettségével kapcsolatos adatok';
		case 242:
			return 'Az óraadó tanár adatok betöltése sikertelen';
		case 243:
			return 'Sikeresen elmentettem az óraadó tanár adatokat.';
		case 244:
			return 'Óraadó tanár adatok';
		case 245:
			return 'Betöltöm az óraadó tanár adatokat, kérlek, várj...';
		case 246:
			return 'A keresett óraadó tanár adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 247:
			var name = str.a;
			return 'Modulvezető: ' + name;
		case 261:
			return 'A modulok betöltése sikertelen';
		case 248:
			return 'Modul törlése';
		case 249:
			return 'Modulzáró visszajelzés';
		case 250:
			return 'Másolat létrehozása';
		case 251:
			return 'Létrehozás és modulóra hozzáadása';
		case 252:
			return 'Új modul létrehozása ebből';
		case 253:
			return 'Mentés sablonként';
		case 254:
			return 'Új modulóra';
		case 255:
			return 'Új portfolió történet';
		case 256:
			var title = str.a;
			return 'Másolat: ' + title;
		case 257:
			return 'A modul egy lezárt időszakhoz tartozik.';
		case 258:
			return 'A modul egy lezárt időszakhoz tartozik. Szerkesztése nem lehetséges.';
		case 259:
			return 'Modulzáró visszajelzés';
		case 260:
			var title = str.a;
			return 'Ha kitörlöd a(z) <b> ' + (title + '</b> modult, az összes kapcsolódó modulóra is törlése kerül. Mehet?');
		case 262:
			return 'Modulvezető';
		case 263:
			return 'Google Tanterem kurzus';
		case 264:
			return 'A modul lényege néhány mondatban';
		case 265:
			return 'Ebben a modulban arról fogunk tanulni, hogy…\nA fontosabb tevékenységek, amikre számíthatsz…\nA megszerzett tudással…\n';
		case 267:
			return 'Migrálható az e-Krétába?';
		case 268:
			return 'Nem';
		case 269:
			return 'Igen';
		case 266:
			return 'Modul kapcsolódó anyagai (URL)';
		case 270:
			return 'Értékelés';
		case 271:
			return 'Célok, amelyeket a gyerekek elérnek a modul végére';
		case 272:
			return 'Mit fognak tudni?';
		case 273:
			return 'A modul végére megismered/megérted/felfedezed/tudni fogod, hogy…';
		case 274:
			return 'Mire lesznek képesek?';
		case 275:
			return 'A modul végére képes leszel/fejlődsz abban, hogy/elsajátítod…/használni tudod…';
		case 276:
			return 'Mit fognak létrehozni?';
		case 277:
			return 'A modul végére létrehozod/megalkotod/kitalálod/elkészíted/megtervezed…';
		case 278:
			return 'Gyerekek';
		case 279:
			return 'Tanárok';
		case 280:
			return 'Iskola';
		case 281:
			return 'Cím';
		case 283:
			return 'Vége dátum';
		case 282:
			return 'Kezdő dátum';
		case 284:
			return 'Megszerezhető tanulási eredmények';
		case 285:
			return 'Évfolyamok';
		case 286:
			return 'Tanárok';
		case 287:
			return 'Iskolák';
		case 288:
			return 'Tantárgyak';
		case 289:
			return 'Szűrők bekapcsolva:';
		case 290:
			return 'Összes iskola';
		case 291:
			return 'Iskola';
		case 292:
			return 'Saját modulok';
		case 293:
			return 'Sablonok';
		case 294:
			return 'Segítség modul létrehozáshoz';
		case 298:
			return 'A keresett modul nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 295:
			return 'Betöltöm a modulokat, kérlek, várj...';
		case 296:
			return 'További modulok betöltése';
		case 297:
			return 'Nem találhatók modulok.';
		case 299:
			return 'Hiba történt a modul törlése közben';
		case 300:
			return 'Sikeresen töröltem a modult.';
		case 301:
			return 'Migrációra kész';
		case 302:
			return 'Nincsen értékelőtáblázat megadva';
		case 303:
			return 'Nincsenek megadva gyerekek még';
		case 304:
			return 'Modulórák';
		case 305:
			return 'Sikeresen elmentettem a modult.';
		case 306:
			return 'Keresés a modul címekben és leírásokban';
		case 307:
			return 'Csoportos kiválasztás';
		case 308:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, start, end);
		case 309:
			return 'Modul szerkesztése';
		case 310:
			return 'Új modul létrehozása';
		case 311:
			return 'Új modul sablonból';
		case 312:
			return 'Modulok';
		case 313:
			var count = str.a;
			return 'NAT tanulási eredmények (' + ($elm$core$String$fromInt(count) + ')');
		case 314:
			return 'Értékelőtáblázatok';
		case 315:
			return 'Új értékelőtáblázat hozzáadása';
		case 316:
			return 'Értékelőtáblázatok kiválasztása';
		case 317:
			return 'Figyelem!';
		case 318:
			return 'A modul migrálhatóvá állításával a modul kezdő- és záró dátuma, illetve a modulhoz rendelt modulórák nem módosíthatóak.';
		case 319:
			return 'Hozzájárulások módosítása';
		case 320:
			return 'Érdemjegy áttekintő';
		case 321:
			return 'Hiányzások igazolása';
		case 322:
			return 'A hiányzások igazolását továbbfejlesztettük, most már a my.BPS-ben, a gyereked mellett kis helikopter ikonnal tudod megnézni és igazolni ezeket.';
		case 323:
			return 'Tanulási szerződések';
		case 324:
			return 'Switch to English';
		case 325:
			return 'Átváltás magyarra';
		case 326:
			return 'Bántottak? Segítünk!';
		case 327:
			return 'Kijelentkezés';
		case 328:
			return 'Modulzárás áttekintő';
		case 329:
			return 'Modulok';
		case 330:
			return 'Modulok listája';
		case 331:
			return 'Új modul hozzáadása';
		case 332:
			return 'Értesítések';
		case 333:
			return 'Áttekintés';
		case 334:
			return 'Telefonkönyv';
		case 335:
			return 'Portfolió';
		case 336:
			return 'Történetek listája';
		case 337:
			return 'Új történet hozzáadása';
		case 338:
			return 'Adatlap';
		case 339:
			return 'Visszajelzés összesítő';
		case 340:
			return 'Gyerekek';
		case 341:
			return 'Gyerekek listája';
		case 342:
			return 'Órarend';
		case 343:
			return 'Értesítések';
		case 344:
			return 'Email cím';
		case 345:
			return 'Név előtag';
		case 346:
			return 'Keresztnév';
		case 347:
			var first = str.a;
			var last = str.b;
			return last + (' ' + first);
		case 349:
			return 'Vezetéknév';
		case 348:
			return 'A név vezetéknév–keresztnév formátumú';
		case 350:
			return 'Mentor';
		case 351:
			return 'Telefonszám';
		case 367:
			return 'Telephely';
		case 352:
			return 'Iskola';
		case 353:
			return 'Állandó lakcím';
		case 354:
			return 'Ország';
		case 355:
			return 'Irányítószám';
		case 356:
			return 'Város';
		case 357:
			return 'Közterület neve';
		case 358:
			return 'Közterület jellege';
		case 359:
			return 'Házszám';
		case 360:
			return 'Emelet, ajtó';
		case 361:
			return 'Születési hely';
		case 362:
			return 'Születési ország';
		case 363:
			return 'Születési dátum';
		case 364:
			return 'Állampolgárság';
		case 365:
			return 'TAJ szám';
		case 366:
			return 'Oktatási azonosító';
		case 368:
			return 'Az OM szám 11 számjegyből áll';
		case 369:
			return 'A TAJ szám 9 számjegyből áll';
		case 370:
			return 'A telefonkönyv betöltése sikertelen';
		case 371:
			return 'Mindenki';
		case 372:
			return 'Szülők';
		case 373:
			return 'Tanárok';
		case 374:
			return 'Letöltöm a telefonkönyv adatokat, kérlek, várj...';
		case 375:
			return 'Keresés';
		case 376:
			return 'Telefonkönyv';
		case 377:
			return 'Visszajelzés';
		case 378:
			return 'Google Tanterem';
		case 379:
			return 'Modulzáróként jelölöm';
		case 380:
			return 'A portfolió történet egy lezárt időszakhoz tartozik.';
		case 381:
			return 'A portfolió történet egy lezárt időszakhoz tartozik. Szerkesztése nem lehetséges.';
		case 382:
			return 'Segítség portfolió történet létrehozásahoz';
		case 383:
			return 'Mi történt?';
		case 384:
			return 'Kép/videó';
		case 385:
			return 'Kapcsolódó modul';
		case 386:
			return 'Feltöltötte';
		case 387:
			return 'Ideje';
		case 388:
			return 'Iskola';
		case 389:
			return 'Résztvevő gyerekek';
		case 390:
			return 'A portfoliók betöltése sikertelen';
		case 391:
			return 'A portfoliókhoz tartozó tanárok és gyerekek betöltése sikertelen';
		case 392:
			return 'Szűrők bekapcsolva:';
		case 393:
			return 'Összes';
		case 394:
			return 'Gyerekem';
		case 395:
			return 'Saját iskola';
		case 396:
			return 'Saját történetek';
		case 397:
			return 'Google Tanterem';
		case 398:
			return 'Modulok';
		case 399:
			return 'Saját modulok';
		case 400:
			return 'Egyik sem';
		case 401:
			return 'Gyerekek';
		case 402:
			return 'Tanárok';
		case 403:
			return 'Típus';
		case 404:
			return 'Összes';
		case 405:
			return 'Csak visszajelzéssel';
		case 406:
			return 'Csak modulzárók';
		case 407:
			return 'További portfolió történetek betöltése';
		case 408:
			var size = str.a;
			return 'Maximális fájl méret ' + ($elm$core$String$fromInt(size) + ' MB. Támogatott fájl formátumok: JPEG, MP4, PDF, PNG, Quicktime');
		case 411:
			return 'Portfolió sztori törlése';
		case 409:
			return 'Portfolió sztori szerkesztése';
		case 410:
			return 'Új portfolió sztori létrehozása';
		case 412:
			return 'Betöltöm a portfolió sztorikat, kérlek, várj...';
		case 413:
			return 'Ha törlöd a portfolió sztorit, annak tartalma és csatolmányai nem lesznek többet elérhetők. Biztos ezt szeretnéd?';
		case 414:
			return 'Hiba történt a portfolió sztori törlése közben';
		case 415:
			return 'Sikeresen töröltem a portfolió sztorit.';
		case 416:
			return 'Nem találhatók portfolió történetek.';
		case 417:
			return 'Sikeresen elmentettem a portfolió sztorit.';
		case 418:
			return 'Hiba történt a portfólió sztori mentése közben.';
		case 419:
			return 'Keresés a történetleírások és gyerekek között';
		case 420:
			var creator = str.a;
			return creator + ' megosztott egy történetet.';
		case 421:
			var creator = str.a;
			var students = str.b;
			var module_ = str.c;
			return creator + (' modulzáró visszajelzést adott ' + ($author$project$Locale$Hungarian$nameList(students) + (' részére a(z) ' + (module_ + ' c. modulról.'))));
		case 422:
			var names = str.a;
			return 'Résztvevő gyerekek: ' + $author$project$Locale$Hungarian$nameList(names);
		case 423:
			return 'Portfolió történetek';
		case 424:
			var email = str.a;
			return 'Ez a kép jelenik meg a telefonkönyvben. Szeretnéd megváltoztatni? Menj el a <a href=\"https://gravatar.com/\">gravatar.com</a> oldalra, és tölts fel egy képet, ami a megadott email címhez (<b>' + (email + '</b>) kapcsolódik.');
		case 425:
			var name = str.a;
			return name + ' elérhetőségeinek szerkesztése';
		case 426:
			return 'Betöltöm az adatlapokat, kérlek, várj...';
		case 427:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 428:
			return 'Az adatlap betöltése sikertelen';
		case 429:
			return 'Sikeresen elmentettem az adatlapot.';
		case 430:
			return 'Alapadatok';
		case 431:
			return 'Válassz ki egy értékelőtáblázatot';
		case 432:
			var title = str.a;
			return 'Kiválasztott értékelőtáblázat: ' + title;
		case 433:
			return 'Adj visszajelzést';
		case 434:
			return 'Szempont';
		case 435:
			return 'Tantárgy';
		case 436:
			return 'Nem tudtam létrehozni az értékelőtáblázatot.';
		case 438:
			return 'Hiba történt az értékelőtáblázat törlése közben';
		case 437:
			return 'Sikeresen töröltem az értékelőtáblázatot.';
		case 440:
			return 'Hiba történt az értékelőtáblázat mentése közben';
		case 439:
			return 'Sikeresen elmentettem az értékelőtáblázatot.';
		case 445:
			return 'Nem találhatók értékelőtáblázatok';
		case 446:
			return 'Saját értékelőtáblázatok';
		case 447:
			return 'Összes megosztott';
		case 448:
			return 'Kiválasztva';
		case 449:
			return 'Értékelőtáblázat szerkesztése';
		case 441:
			return 'Privát';
		case 442:
			return 'Másolatot készítek';
		case 443:
			return 'Iskolákkal megosztott';
		case 444:
			return 'Az értékelőtáblázatok betöltése sikertelen.';
		case 452:
			return 'Betöltöm az értékelőtáblázatokat, kérlek, várj...';
		case 450:
			return 'Segítség értékelőtáblázat létrehozáshoz';
		case 451:
			return 'Kérlek, vedd figyelembe, hogy az értékelőtáblázat szerkesztése nincs hatással a korábban már megadott visszajelzésekre - azokban az értékelőtáblázatnak a korábbi állapota marad meg. Természetesen a szerkesztés után adott visszajelzésekben már az értékelőtáblázat új tartalma fog megjelenni.';
		case 453:
			return 'Keresés az értékelőtáblázat szerzőkben, címekben és leírásokban';
		case 454:
			return 'Értékelőtáblázatok';
		case 455:
			return 'Értékelőtáblázat választása';
		case 456:
			return 'Nincsenek a szűrőfeltételeknek megfelelő visszajelzések.';
		case 457:
			return 'Nincsenek gyerekek az iskoládban. Ha ez szerinted téves, szólj nekünk.';
		case 458:
			return 'Betöltöm a rubric visszajelzéseket, kérlek, várj...';
		case 459:
			return 'Visszajelzés összesítő';
		case 460:
			return 'Ezen az oldalon megtudhatod, hogy a gyerekek a különböző tantárgyakból mennyi visszajelzést kaptak. Kérlek, vedd figyelembe, hogy az oldal mögötti adatok csak pár percenként frissülnek. Ezért kérünk, ne építs arra, hogy egy visszajelzés megadásának hatására itt azonnal ugranak majd a számok, erre egy keveset várni kell. Köszönjük a megértésedet!';
		case 461:
			return 'Iskola';
		case 462:
			return 'Név';
		case 463:
			return 'Évfolyam';
		case 464:
			return 'Tantárgy';
		case 465:
			return 'Visszajelzések a modulokban';
		case 466:
			return 'Kapott visszajelzések az első félévben';
		case 467:
			return 'Kapott visszajelzések a tanévben';
		case 480:
			var zone = str.a;
			var startDate = str.b;
			var endDate = str.c;
			return A3($author$project$Locale$Hungarian$termFormatter, zone, startDate, endDate);
		case 481:
			return 'A hiányzások betöltése sikertelen';
		case 482:
			return 'Betöltöm a hiányzásokat, kérlek, várj...';
		case 483:
			return 'Nincsenek hiányzások rögzítve. Ha ez szerinted téves, szólj nekünk.';
		case 484:
			var name = str.a;
			return 'Itt látod ' + (name + ' hiányzásait ebben a tanévben');
		case 485:
			return 'igazolatlan';
		case 486:
			return 'orvos által igazolt';
		case 487:
			return 'szülő által igazolt';
		case 488:
			return 'mentortanár által igazolt';
		case 489:
			return 'hibajelzés beküldve';
		case 468:
			return 'Orvosi igazolás';
		case 469:
			return 'Szülői igazolás';
		case 470:
			return 'Mentortanári igazolás';
		case 471:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'Ha igazolni szeretnéd <b>' + (name + ('</b> számára a <b>' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + '</b> napi hiányzást, kérlek, adj meg indoklást és szükség esetén csatold az igazoló dokumentumot!')));
		case 472:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'Ha igazolni szeretnéd <b>' + (name + ('</b> számára a <b>' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + '</b> napi hiányzást, kérlek, adj meg indoklást és csatold az igazoló dokumentumot!')));
		case 473:
			return 'Hibát jelzek!';
		case 474:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return 'Tévesen rögzítették a tanárok a gyereked hiányzását a ' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + ' napon? Kérjük, az Ok gomb megnyomásával jelezd a hibát! Erről a mentortanár és a tanügyi csapatunk emailben értesül, és fel fogják venni veled a kapcsolatot a helyzet tisztázása érdekében.');
		case 475:
			return 'Mi történt?';
		case 476:
			return 'Igazoló dokumentum';
		case 477:
			var size = str.a;
			return 'Maximális fájl méret ' + ($elm$core$String$fromInt(size) + ' MB. Támogatott fájl formátumok: PDF, JPEG, PNG');
		case 479:
			return 'Nem sikerült elmenteni az igazolást :(';
		case 478:
			return 'Sikeresen elmentettem az igazolást :)';
		case 490:
			var name = str.a;
			return 'Mentor: ' + name;
		case 491:
			return 'Hiányzó mentor!';
		case 492:
			return 'Nem találhatók gyerekek.';
		case 493:
			return 'A keresett gyerek nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nem létezik.';
		case 494:
			var names = str.a;
			return 'Szülők: ' + $author$project$Locale$Hungarian$nameList(names);
		case 495:
			return 'A tanulási eredmények betöltése sikertelen';
		case 496:
			return 'További gyerekek betöltése';
		case 497:
			return 'általános iskolai nevelés-oktatás';
		case 498:
			return 'gimnáziumi nevelés-oktatás';
		case 499:
			return 'szakiskolai nevelés-oktatás';
		case 504:
			return 'angol';
		case 505:
			return 'német';
		case 506:
			return 'francia';
		case 507:
			return 'spanyol';
		case 508:
			return 'olasz';
		case 500:
			return 'BTMN';
		case 501:
			return 'SNI1';
		case 502:
			return 'SNI2';
		case 503:
			return 'nincs';
		case 509:
			return 'A NEK azonosító 16 karakter hosszú';
		case 510:
			return 'ovi 1. évfolyam';
		case 511:
			return 'ovi 2. évfolyam';
		case 512:
			return 'ovi 3. évfolyam';
		case 513:
			return '1. évfolyam';
		case 514:
			return '2. évfolyam';
		case 515:
			return '3. évfolyam';
		case 516:
			return '4. évfolyam';
		case 517:
			return '5. évfolyam';
		case 518:
			return '6. évfolyam';
		case 519:
			return '7. évfolyam';
		case 520:
			return '8. évfolyam';
		case 521:
			return '9. évfolyam';
		case 522:
			return '10. évfolyam';
		case 523:
			return '11. évfolyam';
		case 524:
			return '12. évfolyam';
		case 525:
			return 'állapot';
		case 526:
			return 'Lakcímkártya; nem magyar állampolgár esetén tartózkodás engedély (dokumentum)';
		case 527:
			return 'Felvételi mikor volt, milyen eredménnyel';
		case 528:
			return 'Anya születési neve';
		case 529:
			return 'Köznevelési alapfeladat, amelyre a jogviszony irányul';
		case 530:
			return 'Jogviszony szünetelésének dátuma, oka';
		case 531:
			return 'Igazolt/igazolatlan órák száma';
		case 532:
			return 'Iskolai gyerekbaleset dátuma, leírása';
		case 533:
			return 'Kompetenciatesztek eredményei, mérési azonosító';
		case 534:
			return 'Utolsó lezárt tanév bizonyítványa (dokumentum)';
		case 535:
			return 'Szorgalom, magatartás, tudás minősítés (dokumentum)';
		case 536:
			return 'Vizsgaadatok (dátum, eredmény, vizsgáztató tanár)';
		case 537:
			return 'Fegyelmi és kártérítési ügyekkel kapcsolatos adatok: ügy száma, rövid leírása (indulásának oka, megoldásának, befejezésének formája, tartalma)';
		case 538:
			return 'Diákigazolvány sorszáma';
		case 539:
			return 'Tankönyvellátás';
		case 540:
			return 'Évfolyamismétlés';
		case 541:
			return 'Határon túli kirándulás';
		case 542:
			return 'Speciális státusz';
		case 543:
			return '<b>SNI1:</b> Enyhe értelmi fogyatékos, beszédfogyatékos vagy pszichés fejlődési zavarral küzdő sajátos nevelési igényű gyermek.<br/><b>SNI2:</b> Mozgásszervi, érzékszervi, középsúlyos értelmi fogyatékos, autizmus spektrum zavarral küzdő vagy halmozottan fogyatékos gyermek.<br/><b>BTMN:</b> Szakértői vélemény alapján beilleszkedési, tanulási, és magatartási nehézséggel küzdő gyerek.';
		case 544:
			return 'Szakvélemény (dokumentum)';
		case 545:
			return 'Egyéni munkarend';
		case 546:
			return 'Egyéni munkarendre vonatkozó adatok (dokumentum)';
		case 547:
			return 'Hányadik osztályba kerül';
		case 548:
			return 'Első idegen nyelv';
		case 549:
			return 'Második idegen nyelv';
		case 550:
			return 'Diákigazolvány (dokumentum)';
		case 551:
			return 'Születési anyakönyvi kivonat (dokumentum)';
		case 552:
			return 'Személyi igazolvány vagy útlevél (dokumentum)';
		case 553:
			return ' - kötelező, ha a gyerek már iskolába jár';
		case 554:
			return 'Adóazonosító (dokumentum)';
		case 555:
			return 'TAJ kártya (dokumentum)';
		case 556:
			return 'NEK azonosító';
		case 557:
			return 'NEK adatlap (dokumentum)';
		case 558:
			var count = str.a;
			return (count === 1) ? 'Törvényes képviselő' : 'Törvényes képviselők';
		case 559:
			return 'Új fájl…';
		case 560:
			return 'Megtekintés';
		case 561:
			return 'Fájl feltöltve — ';
		case 562:
			return 'Maximális fájl méret 10MB. Támogatott fájl formátumok: PDF, JPG, PNG';
		case 564:
			return 'A gyerekadatok betöltése sikertelen';
		case 565:
			return 'Hiba történt a dokumentum letöltése közben';
		case 563:
			return 'A diákigazolvány sorszáma 10 számjegyből áll';
		case 566:
			return 'Sikeresen elmentettem a gyerekadatokat.';
		case 567:
			return 'Gyerekadatok';
		case 568:
			var name = str.a;
			return name + ' gyerekadatok';
		case 569:
			return 'Szülő tölti ki';
		case 570:
			return 'Iskola tölti ki';
		case 571:
			return 'Betöltöm a gyerekadatokat, kérlek, várj...';
		case 572:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 573:
			return 'A gyerek lista betöltése sikertelen';
		case 574:
			return 'Mindenki';
		case 575:
			return 'Mentoráltjaim';
		case 576:
			return 'Betöltöm a gyerek listát, kérlek, várj...';
		case 577:
			return 'Gyerekek';
		case 578:
			return 'Új tanulási szerződés...';
		case 580:
			return 'Mentortanári megjegyzés az eredményekhez';
		case 579:
			return 'Tanulási szerződés';
		case 581:
			return 'Adatlap';
		case 582:
			return 'Értesítők';
		case 583:
			return 'Hiányzások';
		case 584:
			return 'Órarend';
		case 585:
			return 'Trimeszter visszajelzések';
		case 586:
			return 'Tantárgyi visszajelzések';
		case 587:
			return 'Keresés a gyerekek nevében';
		case 594:
			return 'Betöltöm a tantárgyi visszajelzéseket, kérlek, várj...';
		case 593:
			return 'A tantárgyi visszajelzések betöltése sikertelen';
		case 588:
			return 'Minden tantárgy';
		case 589:
			var studentName = str.a;
			var studentGrade = str.b;
			var subjectName = str.c;
			return 'Visszajelzések ' + (studentName + (' (' + (studentGrade + (') számára ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return s + ' tantárgyból';
					},
					subjectName))))));
		case 591:
			return 'Tantárgyi visszajelzések';
		case 592:
			return 'Válassz tantárgyat';
		case 590:
			return 'Ezen az oldalon látod a kiválasztott gyerek kiválasztott tantárgyból kapott értékelőtáblázat-sorait időrendben. ' + 'Az egyes visszajelzéseket az időpontokra kattintva tudod részletesebben is megnézni.';
		case 596:
			return 'A tantárgy lista betöltése sikertelen';
		case 595:
			return 'Letöltöm a tantárgyak listáját, kérlek, várj...';
		case 597:
			return 'Felhasználóváltás';
		case 598:
			return 'Miért van szükséged felhasználót váltani? Ezt az üzenetet naplózzuk.';
		case 599:
			var name = str.a;
			return 'Felhasználóváltás sikeres. Üdv ' + (name + '!');
		case 600:
			return 'Felhasználóváltás';
		case 601:
			return 'State';
		case 602:
			return 'Tanár';
		case 603:
			return 'Születési keresztnév';
		case 604:
			return 'Születési vezetéknév';
		case 605:
			return 'A születési név vezetéknév–keresztnév formátumú';
		case 606:
			return 'Anyja neve, előtag';
		case 607:
			return 'Anyja keresztneve';
		case 608:
			return 'Anyja vezetéknéve';
		case 609:
			return 'Az anyja neve vezetéknév–keresztnév formátumú';
		case 610:
			return 'Legmagasabb iskolai végzettség';
		case 611:
			return 'Szakmai gyakorlat éveinek száma';
		case 612:
			return 'Akadémiai tag?';
		case 613:
			return 'Diploma (dokumentum)';
		case 614:
			return 'Egyetem';
		case 615:
			return 'Főiskola';
		case 616:
			return 'Középiskola';
		case 617:
			return 'Születési adatok';
		case 618:
			return 'Elérhetőségek';
		case 619:
			return 'Szakmai adatok';
		case 620:
			return 'A tanáradatok betöltése sikertelen';
		case 621:
			return 'Maximális fájl méret 10MB. Támogatott fájlformátumok: PDF, JPG, PNG';
		case 622:
			return 'Sikeresen elmentettem a tanáradatokat.';
		case 623:
			return 'Tanáradatok';
		case 624:
			var name = str.a;
			return name + ' tanáradatok';
		case 625:
			return 'Betöltöm a tanáradatokat, kérlek, várj...';
		case 626:
			return 'A keresett adatlap nem található. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 627:
			return 'Az iskola lista betöltése sikertelen';
		case 628:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$dateFormatter, zone, time);
		case 629:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$dateTimeFormatter, zone, time);
		case 631:
			var zone = str.a;
			var time1 = str.b;
			var time2 = str.c;
			return A2($author$project$Locale$Hungarian$dateFormatter, zone, time1) + (', ' + (A2($author$project$Locale$Hungarian$timeFormatter, zone, time1) + ('-' + A2($author$project$Locale$Hungarian$timeFormatter, zone, time2))));
		case 630:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$Hungarian$timeFormatter, zone, time);
		case 632:
			return 'Hetente';
		case 633:
			return 'Kéthetente';
		case 634:
			return 'Egyszeri alkalom';
		case 635:
			var day = str.a;
			return $author$project$Locale$Hungarian$hungarian.nx(day);
		case 636:
			return 'Az órarend betöltése sikertelen';
		case 637:
			return 'Új modulóra létrehozása';
		case 638:
			return 'Modulóra szerkesztése';
		case 639:
			return 'Google Meet';
		case 640:
			return 'Jelenléti ív';
		case 641:
			return 'Modulóra szerkesztése';
		case 642:
			return 'Modulóra törlése';
		case 643:
			return 'Összes alkalom törlése';
		case 645:
			return 'Ez és ezt követő alkalmak törlése';
		case 644:
			return 'Ezen alkalom törlése';
		case 646:
			return 'Ezt és ezt követő alkalmakat';
		case 647:
			return 'Minden alkalmat';
		case 648:
			return 'Tanárok órarendjei';
		case 649:
			return 'Gyerekek órarendjei';
		case 650:
			return 'Órarend betöltése...';
		case 651:
			return 'Órarend';
		case 653:
			return 'Hiba történt a modulóra mentése közben';
		case 652:
			return 'Sikeresen elmentettem a modulóra változásokat.';
		case 654:
			return 'Résztvevők';
		case 655:
			return 'Hiányzók';
		case 656:
			return 'Mely modulóra alkalmakat szeretnéd megváltoztatni?';
		case 657:
			return '<ul>' + ('<li><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> Ha visszamenőlegesen újraütemezel órát, azzal a kitöltött jelenléti ívek elvesznek.</li>' + ('<li>A Google Naptárba csak a jövőbeli változásokat szinkronizáljuk.</li>' + '</ul>'));
		case 658:
			return '<p><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> ' + ('Ha már egy elkezdett modul óráit szünteted meg, a kitöltött jelenléti ívek elvesznek.</p>' + '<p>Ha be szeretnél fejezni hamarabb egy modult, csak ezt és az ezt követő alkalmakat töröld.</p>');
		case 659:
			return '<p><mark>A modulórákhoz jelenléti ívek tartoznak.</mark> ' + 'Ha már egy elkezdett modul óráit szünteted meg, a kitöltött jelenléti ívek elvesznek.</p>';
		case 660:
			return 'Sikeresen töröltem a modulórát.';
		case 661:
			return 'Hiba történt a modulóra törlése közben';
		case 662:
			return 'Sikeresen elmentettem az órarend változásokat.';
		case 663:
			return 'Sikeresen lemondtam a választott modulóra alkalmat.';
		case 664:
			var title = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return title + (' (' + (A3($author$project$Locale$Hungarian$termFormatter, zone, start, end) + ')'));
		case 665:
			var name = str.a;
			return 'Modul: ' + name;
		case 666:
			var creator = str.a;
			var student = str.b;
			return creator + (' trimeszterzáró visszajelzést adott ' + (student + ' részére'));
		case 667:
			var name = str.a;
			return 'Kedves ' + (name + '! Az elmúlt trimeszterrel kapcsolatban azt szeretném neked elmondani, hogy…');
		case 668:
			return 'Trimeszterzáró visszajelzés';
		case 669:
			var name = str.a.ha;
			var startYear = str.a.d9;
			var endYear = str.a.dH;
			var trimester = str.a.jP;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						name,
						' részére, ',
						$elm$core$String$fromInt(startYear),
						'/',
						$elm$core$String$fromInt(endYear),
						'. tanév ',
						$elm$core$String$fromInt(trimester),
						'. trimeszter'
					]));
		case 670:
			return 'Értékelőtáblázat kiválasztása…';
		case 671:
			return 'Sikeresen elmentettem a trimeszterzáró visszajelzést.';
		case 672:
			return 'Hiba történt a trimeszterzáró visszajelzés mentése közben';
		case 673:
			return 'Kérlek, értékeld a szempontokat!';
		case 674:
			return 'Trimeszterzáró visszajelzés hozzáadása';
		case 675:
			return 'Trimeszter visszajelzések';
		case 676:
			return 'Trimeszter visszajelzések';
		case 677:
			return 'Trimeszter visszajelzések betöltése...';
		case 678:
			return 'Nem találhatók trimeszter visszajelzések. Talán törölték, nincs hozzá jogosultságod, vagy csak egyszerűen nincs ilyen.';
		case 679:
			return 'A trimeszter visszajelzések betöltése sikertelen';
		case 680:
			var studentName = str.a;
			return studentName + ' még nem kapott trimeszterzáró visszajelzést. ';
		case 681:
			var studentName = str.a;
			return studentName + ' még nem kapott modulzáró visszajelzést.';
		case 682:
			return 'Készíts visszajelzést számára arról, hogy sikerült a trimeszter!';
		case 683:
			return 'Korábbi évek';
		case 684:
			return '1. trimeszter';
		case 685:
			return '2. trimeszter';
		case 686:
			return '3. trimeszter';
		case 687:
			return 'Sikeresen töröltem a visszajelzést.';
		case 688:
			var grade = str.a;
			return $elm$core$String$fromInt(grade) + '. évfolyam félévi visszajelzések letöltése';
		case 689:
			var grade = str.a;
			return $elm$core$String$fromInt(grade) + '. évfolyam évvégi visszajelzések letöltése';
		case 690:
			var schoolYear = str.a;
			var trimester = str.b;
			return $elm$core$String$fromInt(schoolYear) + ('. tanév ' + ($elm$core$String$fromInt(trimester) + '. trimeszter visszajelzések letöltése'));
		case 691:
			return 'Hiba történt a trimeszter visszajelzés törlése közben';
		case 692:
			return 'Elmentettem a beállításokat.';
		default:
			return 'Hiba történt a beállítások mentése közben';
	}
};
var $author$project$Locale$hungarian = {kz: 'hu', ls: $author$project$Locale$Hungarian$isFirstNameFirst, hy: $author$project$Locale$Hungarian$translator};
var $author$project$Locale$defaultLanguage = $author$project$Locale$hungarian;
var $author$project$Route$PageNotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Route$auth0Url = 'auth0';
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {cM: frag, i5: params, cC: unvisited, nD: value, dp: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.cC;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.nD);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.nD);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.mv),
					$elm$url$Url$Parser$prepareQuery(url.bw),
					url.ir,
					$elm$core$Basics$identity)));
	});
var $author$project$Route$Auth0Callback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Route$Counter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Route$GenericProfileUpdate = function (a) {
	return {$: 33, a: a};
};
var $author$project$Route$GradeReportCard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Route$GradeRequestList = function (a) {
	return {$: 7, a: a};
};
var $author$project$Route$GradesOverview = function (a) {
	return {$: 8, a: a};
};
var $author$project$Route$Home = {$: 9};
var $author$project$Route$LearningContractsCreate = {$: 10};
var $author$project$Route$LearningContractsList = {$: 11};
var $author$project$Route$LearningContractsUpdate = function (a) {
	return {$: 12, a: a};
};
var $author$project$Route$LearningGroupCreate = {$: 13};
var $author$project$Route$LearningGroupList = {$: 14};
var $author$project$Route$LearningGroupUpdate = function (a) {
	return {$: 15, a: a};
};
var $author$project$Route$LoBrowser = {$: 16};
var $author$project$Route$Login = {$: 1};
var $author$project$Route$Logout = {$: 2};
var $author$project$Route$ModuleClosureOverview = function (a) {
	return {$: 17, a: a};
};
var $author$project$Route$ModuleTeacherProfileUpdate = function (a) {
	return {$: 19, a: a};
};
var $author$project$Route$ModulesClosure = function (a) {
	return {$: 18, a: a};
};
var $author$project$Route$ModulesCreate = {$: 20};
var $author$project$Route$ModulesCreateFromTemplate = function (a) {
	return {$: 21, a: a};
};
var $author$project$Route$ModulesDetail = function (a) {
	return {$: 22, a: a};
};
var $author$project$Route$ModulesDuplicate = function (a) {
	return {$: 23, a: a};
};
var $author$project$Route$ModulesList = {$: 24};
var $author$project$Route$ModulesUpdate = function (a) {
	return {$: 25, a: a};
};
var $author$project$Route$NotificationList = {$: 26};
var $author$project$Route$PhoneBook = {$: 27};
var $author$project$Route$PortfoliosCreate = function (a) {
	return {$: 28, a: a};
};
var $author$project$Route$PortfoliosDetail = function (a) {
	return {$: 29, a: a};
};
var $author$project$Route$PortfoliosList = function (a) {
	return {$: 30, a: a};
};
var $author$project$Route$PortfoliosListMyChildren = {$: 31};
var $author$project$Route$PortfoliosUpdate = function (a) {
	return {$: 32, a: a};
};
var $author$project$Route$RubricSubjectOverview = function (a) {
	return {$: 38, a: a};
};
var $author$project$Route$RubricsCreate = {$: 34};
var $author$project$Route$RubricsList = {$: 35};
var $author$project$Route$RubricsUpdate = function (a) {
	return {$: 36, a: a};
};
var $author$project$Route$RubricsView = function (a) {
	return {$: 37, a: a};
};
var $author$project$Route$StudentAbsenceList = function (a) {
	return {$: 5, a: a};
};
var $author$project$Route$StudentList = {$: 41};
var $author$project$Route$StudentProfileNekUpdate = function (a) {
	return {$: 39, a: a};
};
var $author$project$Route$StudentProfileUpdate = function (a) {
	return {$: 40, a: a};
};
var $author$project$Route$SubjectFeedbackCard = F2(
	function (a, b) {
		return {$: 42, a: a, b: b};
	});
var $author$project$Route$TeacherProfilesUpdate = function (a) {
	return {$: 43, a: a};
};
var $author$project$Route$TimetableCalendar = function (a) {
	return {$: 44, a: a};
};
var $author$project$Route$TimetableCreateEvent = function (a) {
	return {$: 45, a: a};
};
var $author$project$Route$TimetableUpdateEvent = function (a) {
	return {$: 46, a: a};
};
var $author$project$Route$TrimesterFeedbackReport = function (a) {
	return {$: 47, a: a};
};
var $author$project$Route$counterUrl = 'counter';
var $author$project$Route$createUrlSuffix = 'new';
var $author$project$Route$duplicateUrlSuffix = 'duplicate';
var $author$project$Route$editUrlSuffix = 'edit';
var $author$project$Route$gradeRequestUrl = 'grade-requests';
var $author$project$Route$gradesOverviewUrl = 'grades';
var $author$project$Route$homeUrl = 'home';
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.dp;
			var unvisited = _v0.cC;
			var params = _v0.i5;
			var frag = _v0.cM;
			var value = _v0.nD;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$Internal$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$Query$custom = F2(
	function (key, func) {
		return function (dict) {
			return func(
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Dict$get, key, dict)));
		};
	});
var $elm$url$Url$Parser$Query$int = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$String$toInt(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$learningContractsUrl = 'learningcontracts';
var $author$project$Route$learningGroupsUrl = 'learning-groups';
var $author$project$Route$loBrowserUrl = 'lolo';
var $author$project$Route$logoutUrl = 'logout';
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.dp;
		var unvisited = _v0.cC;
		var params = _v0.i5;
		var frag = _v0.cM;
		var value = _v0.nD;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.dp;
			var unvisited = _v1.cC;
			var params = _v1.i5;
			var frag = _v1.cM;
			var value = _v1.nD;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $author$project$Route$moduleClosureOverviewUrl = 'module-closures';
var $author$project$Route$moduleClosureUrlPart = 'closing-feedback';
var $author$project$Route$moduleParam = 'm';
var $author$project$Route$moduleTeacherProfilesUrlSuffix = 'module-teacher';
var $author$project$Route$modulesUrl = 'modules';
var $author$project$Route$notificationsUrl = 'notifications';
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $author$project$Route$GradesOverviewListQuery = F3(
	function (school, term, years) {
		return {bp: school, jH: term, gk: years};
	});
var $author$project$Route$gradesTermParam = 'term';
var $author$project$Route$gradesYearParam = 'year';
var $elm$url$Url$Parser$Query$map3 = F4(
	function (func, _v0, _v1, _v2) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		return function (dict) {
			return A3(
				func,
				a(dict),
				b(dict),
				c(dict));
		};
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $author$project$Route$parseIntList = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		$elm$core$List$filterMap($elm$core$String$toInt));
};
var $author$project$Route$schoolParam = 'school';
var $elm$url$Url$Parser$Query$string = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$custom,
		key,
		function (stringList) {
			if (stringList.b && (!stringList.b.b)) {
				var str = stringList.a;
				return $elm$core$Maybe$Just(str);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		});
};
var $author$project$Route$parseGradesListQuery = A4(
	$elm$url$Url$Parser$Query$map3,
	$author$project$Route$GradesOverviewListQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$schoolParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$gradesTermParam),
	$author$project$Route$parseIntList($author$project$Route$gradesYearParam));
var $author$project$Route$LoStudentOverviewListQuery = F4(
	function (students, subjects, school, module_) {
		return {fK: module_, bp: school, e1: students, jB: subjects};
	});
var $elm$url$Url$Parser$Query$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var a = _v0;
		var b = _v1;
		var c = _v2;
		var d = _v3;
		return function (dict) {
			return A4(
				func,
				a(dict),
				b(dict),
				c(dict),
				d(dict));
		};
	});
var $author$project$Route$studentParam = 's';
var $author$project$Route$subjectParam = 'subject';
var $author$project$Route$parseLoStudentOverviewListQuery = A5(
	$elm$url$Url$Parser$Query$map4,
	$author$project$Route$LoStudentOverviewListQuery,
	$author$project$Route$parseIntList($author$project$Route$studentParam),
	$author$project$Route$parseIntList($author$project$Route$subjectParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$schoolParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam));
var $author$project$Route$ModuleClosureOverviewListQuery = F2(
	function (school, onlyMentees) {
		return {cn: onlyMentees, bp: school};
	});
var $elm$url$Url$Parser$Query$map2 = F3(
	function (func, _v0, _v1) {
		var a = _v0;
		var b = _v1;
		return function (dict) {
			return A2(
				func,
				a(dict),
				b(dict));
		};
	});
var $author$project$Route$menteesParam = 'mentees';
var $elm$url$Url$Parser$Query$enum = F2(
	function (key, dict) {
		return A2(
			$elm$url$Url$Parser$Query$custom,
			key,
			function (stringList) {
				if (stringList.b && (!stringList.b.b)) {
					var str = stringList.a;
					return A2($elm$core$Dict$get, str, dict);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $author$project$Route$parseBool = function (key) {
	return A2(
		$elm$url$Url$Parser$Query$enum,
		key,
		$elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('true', true),
					_Utils_Tuple2('false', false)
				])));
};
var $author$project$Route$parseModuleClosureOverviewListQuery = A3(
	$elm$url$Url$Parser$Query$map2,
	$author$project$Route$ModuleClosureOverviewListQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$schoolParam),
	$author$project$Route$parseBool($author$project$Route$menteesParam));
var $author$project$Route$PortfoliosListQuery = F4(
	function (students, startDate, endDate, withFeedback) {
		return {gH: endDate, hv: startDate, e1: students, nJ: withFeedback};
	});
var $author$project$Route$endDateParam = 'end_date';
var $author$project$Route$startDateParam = 'start_date';
var $author$project$Route$withFeedbackParam = 'with_feedback';
var $author$project$Route$parsePortfoliosListQuery = A5(
	$elm$url$Url$Parser$Query$map4,
	$author$project$Route$PortfoliosListQuery,
	$author$project$Route$parseIntList($author$project$Route$studentParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$startDateParam),
	$elm$url$Url$Parser$Query$string($author$project$Route$endDateParam),
	$author$project$Route$parseBool($author$project$Route$withFeedbackParam));
var $author$project$Route$TimetableCreateQuery = F3(
	function (moduleId, start, end) {
		return {gG: end, iS: moduleId, hu: start};
	});
var $author$project$Route$endParam = 'end';
var $author$project$Route$startParam = 'start';
var $author$project$Route$parseTimetableCreateQuery = A4(
	$elm$url$Url$Parser$Query$map3,
	$author$project$Route$TimetableCreateQuery,
	$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$startParam),
	$elm$url$Url$Parser$Query$int($author$project$Route$endParam));
var $author$project$Route$TimetableUpdateQuery = F2(
	function (eventId, occId) {
		return {im: eventId, he: occId};
	});
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Route$parseTimetableUpdateQuery = A2(
	$elm$url$Url$Parser$map,
	$author$project$Route$TimetableUpdateQuery,
	A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $elm$url$Url$Parser$int));
var $author$project$Route$personParam = 'p';
var $author$project$Route$phoneBookUrl = 'contacts';
var $author$project$Route$portfoliosMyChildrenSuffix = 'my-family';
var $author$project$Route$portfoliosUrl = 'portfolios';
var $author$project$Route$profilesUrl = 'profile';
var $elm$url$Url$Parser$query = function (_v0) {
	var queryParser = _v0;
	return function (_v1) {
		var visited = _v1.dp;
		var unvisited = _v1.cC;
		var params = _v1.i5;
		var frag = _v1.cM;
		var value = _v1.nD;
		return _List_fromArray(
			[
				A5(
				$elm$url$Url$Parser$State,
				visited,
				unvisited,
				params,
				frag,
				value(
					queryParser(params)))
			]);
	};
};
var $elm$url$Url$Parser$questionMark = F2(
	function (parser, queryParser) {
		return A2(
			$elm$url$Url$Parser$slash,
			parser,
			$elm$url$Url$Parser$query(queryParser));
	});
var $author$project$Route$rubricSubjectOverviewUrl = 'rubrics-subjects';
var $author$project$Route$rubricsUrl = 'rubrics';
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.dp;
		var unvisited = _v0.cC;
		var params = _v0.i5;
		var frag = _v0.cM;
		var value = _v0.nD;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $author$project$Route$scheduleUrlSuffix = 'schedule';
var $author$project$Route$studentAbsenceListUrl = 'student-absence';
var $author$project$Route$studentProfilesNekUrlSuffix = 'nek';
var $author$project$Route$studentProfilesUrlSuffix = 'student';
var $author$project$Route$studentsUrl = 'students';
var $author$project$Route$subjectFeedbackUrlPart = 'subject-feedback';
var $author$project$Route$teacherProfilesUrlSuffix = 'teacher';
var $author$project$Route$timetableEventsUrlPart = 'events';
var $author$project$Route$timetableUrl = 'timetable';
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Route$trimesterFeedbackReportUrl = 'trimester-feedback-report';
var $author$project$Route$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2($elm$url$Url$Parser$map, $author$project$Route$Login, $elm$url$Url$Parser$top),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Logout,
			$elm$url$Url$Parser$s($author$project$Route$logoutUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Auth0Callback,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$auth0Url),
				$elm$url$Url$Parser$Query$string('id_token'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Counter,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$counterUrl),
				$elm$url$Url$Parser$Query$int('count'))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentAbsenceList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$studentAbsenceListUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GradeReportCard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s('grade-report')))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GradeRequestList,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$gradeRequestUrl)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GradesOverview,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$gradesOverviewUrl),
				$author$project$Route$parseGradesListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$Home,
			$elm$url$Url$Parser$s($author$project$Route$homeUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsList,
			$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningContractsUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningContractsUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupList,
			$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LearningGroupUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$learningGroupsUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$LoBrowser,
			$elm$url$Url$Parser$s($author$project$Route$loBrowserUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModuleClosureOverview,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$moduleClosureOverviewUrl),
				$author$project$Route$parseModuleClosureOverviewListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModuleTeacherProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$moduleTeacherProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesList,
			$elm$url$Url$Parser$s($author$project$Route$modulesUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesCreateFromTemplate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesDuplicate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$duplicateUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$ModulesClosure,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$modulesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$moduleClosureUrlPart)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$NotificationList,
			$elm$url$Url$Parser$s($author$project$Route$notificationsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PhoneBook,
			$elm$url$Url$Parser$s($author$project$Route$phoneBookUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix),
					$elm$url$Url$Parser$Query$int($author$project$Route$moduleParam)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosList,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$author$project$Route$parsePortfoliosListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosListMyChildren,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				$elm$url$Url$Parser$s($author$project$Route$portfoliosMyChildrenSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$PortfoliosUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$portfoliosUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$GenericProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				$elm$url$Url$Parser$s($author$project$Route$createUrlSuffix))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsList,
			$elm$url$Url$Parser$s($author$project$Route$rubricsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricSubjectOverview,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$rubricSubjectOverviewUrl),
				$author$project$Route$parseLoStudentOverviewListQuery)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$editUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$RubricsView,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$rubricsUrl),
				$elm$url$Url$Parser$int)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentProfileUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$studentProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentProfileNekUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$studentProfilesNekUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$StudentList,
			$elm$url$Url$Parser$s($author$project$Route$studentsUrl)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$SubjectFeedbackCard,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					A2(
						$elm$url$Url$Parser$questionMark,
						$elm$url$Url$Parser$s($author$project$Route$subjectFeedbackUrlPart),
						$elm$url$Url$Parser$Query$int($author$project$Route$subjectParam))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TeacherProfilesUpdate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$teacherProfilesUrlSuffix)))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableUpdateEvent,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$s($author$project$Route$timetableEventsUrlPart),
					$author$project$Route$parseTimetableUpdateQuery))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableCreateEvent,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				A2(
					$elm$url$Url$Parser$questionMark,
					$elm$url$Url$Parser$s($author$project$Route$scheduleUrlSuffix),
					$author$project$Route$parseTimetableCreateQuery))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TimetableCalendar,
			A2(
				$elm$url$Url$Parser$questionMark,
				$elm$url$Url$Parser$s($author$project$Route$timetableUrl),
				$author$project$Route$parseIntList($author$project$Route$personParam))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Route$TrimesterFeedbackReport,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s($author$project$Route$profilesUrl),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$int,
					$elm$url$Url$Parser$s($author$project$Route$trimesterFeedbackReportUrl))))
		]));
var $author$project$Route$fromUrl = function (url) {
	var route = A2($elm$core$String$startsWith, '/' + $author$project$Route$auth0Url, url.mv) ? A2(
		$elm$url$Url$Parser$parse,
		$author$project$Route$parser,
		_Utils_update(
			url,
			{ir: $elm$core$Maybe$Nothing, bw: url.ir})) : A2($elm$url$Url$Parser$parse, $author$project$Route$parser, url);
	return A2(
		$elm$core$Maybe$withDefault,
		$author$project$Route$PageNotFound(url),
		route);
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Route$fromString = function (path) {
	var url = $elm$url$Url$fromString('http://foobar.hu' + path);
	return A2($elm$core$Maybe$map, $author$project$Route$fromUrl, url);
};
var $author$project$Main$getInitialRoute = F2(
	function (storedUrl, route) {
		if (!route.$) {
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Route$Home,
				A2($elm$core$Maybe$andThen, $author$project$Route$fromString, storedUrl));
		} else {
			return route;
		}
	});
var $author$project$Main$Auth0CallbackCalled = function (a) {
	return {$: 0, a: a};
};
var $author$project$Main$Authenticated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Main$AutoLogin = {$: 1};
var $author$project$Main$LoggedOut = {$: 0};
var $author$project$Main$initAuthState = function (route) {
	_v0$2:
	while (true) {
		switch (route.$) {
			case 2:
				return $author$project$Main$LoggedOut;
			case 0:
				if (!route.a.$) {
					var token = route.a.a;
					return $author$project$Main$Authenticated(
						$author$project$Main$Auth0CallbackCalled(token));
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$Main$AutoLogin;
};
var $author$project$Pages$NotLoaded = {$: 0};
var $author$project$Pages$notLoaded = $author$project$Pages$NotLoaded;
var $elm$browser$Browser$Navigation$replaceUrl = _Browser_replaceUrl;
var $author$project$Route$analyticsLearningContractUrl = 'learningcontract';
var $author$project$Route$gradeReportUrlPart = 'grade-report';
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$int = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$core$String$fromInt(value));
	});
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $author$project$Route$gradesListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$url$Url$Builder$int($author$project$Route$gradesYearParam),
						$elm$core$Maybe$Just),
					query.gk),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$string($author$project$Route$gradesTermParam),
								$elm$core$Maybe$Just),
							query.jH)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$int($author$project$Route$schoolParam),
								$elm$core$Maybe$Just),
							query.bp))
					]))));
};
var $author$project$Route$loStudentOverviewListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$url$Url$Builder$int($author$project$Route$studentParam),
						$elm$core$Maybe$Just),
					query.e1),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$subjectParam),
							$elm$core$Maybe$Just),
						query.jB),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$url$Url$Builder$int($author$project$Route$schoolParam),
									$elm$core$Maybe$Just),
								query.bp)),
							A2(
							$elm$core$Maybe$withDefault,
							$elm$core$Maybe$Nothing,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$url$Url$Builder$int($author$project$Route$moduleParam),
									$elm$core$Maybe$Just),
								query.fK))
						])))));
};
var $author$project$Route$maybeIntParam = F2(
	function (key, maybeInt) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (_int) {
					return $elm$url$Url$Builder$toQuery(
						_List_fromArray(
							[
								A2($elm$url$Url$Builder$int, key, _int)
							]));
				},
				maybeInt));
	});
var $author$project$Route$buildBool = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$string,
			key,
			value ? 'true' : 'false');
	});
var $author$project$Route$moduleClosureOverviewListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$schoolParam),
							$elm$core$Maybe$Just),
						query.bp)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Route$buildBool($author$project$Route$menteesParam),
							$elm$core$Maybe$Just),
						query.cn))
				])));
};
var $author$project$Route$portfoliosListQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_Utils_ap(
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$url$Url$Builder$int($author$project$Route$studentParam),
						$elm$core$Maybe$Just),
					query.e1),
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$string($author$project$Route$startDateParam),
								$elm$core$Maybe$Just),
							query.hv)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$url$Url$Builder$string($author$project$Route$endDateParam),
								$elm$core$Maybe$Just),
							query.gH)),
						A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Maybe$Nothing,
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Route$buildBool($author$project$Route$withFeedbackParam),
								$elm$core$Maybe$Just),
							query.nJ))
					]))));
};
var $author$project$Route$timetableCreateQueryAsParam = function (query) {
	return $elm$url$Url$Builder$toQuery(
		A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$moduleParam),
							$elm$core$Maybe$Just),
						query.iS)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$startParam),
							$elm$core$Maybe$Just),
						query.hu)),
					A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$int($author$project$Route$endParam),
							$elm$core$Maybe$Just),
						query.gG))
				])));
};
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.jh;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.ir,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.bw,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.ja,
					_Utils_ap(http, url.gR)),
				url.mv)));
};
var $author$project$Route$toString = function (page) {
	var join = function (pieces) {
		return '/' + A2($elm$core$String$join, '/', pieces);
	};
	switch (page.$) {
		case 48:
			return join(
				_List_fromArray(
					[$author$project$Route$analyticsLearningContractUrl]));
		case 0:
			return join(
				_List_fromArray(
					[$author$project$Route$auth0Url]));
		case 1:
			return join(_List_Nil);
		case 2:
			return join(
				_List_fromArray(
					[$author$project$Route$logoutUrl]));
		case 3:
			var url = page.a;
			return $elm$url$Url$toString(url);
		case 4:
			var count = page.a;
			if (!count.$) {
				var count_ = count.a;
				return join(
					_List_fromArray(
						[
							$author$project$Route$counterUrl + ('?count=' + $elm$core$String$fromInt(count_))
						]));
			} else {
				return join(
					_List_fromArray(
						[$author$project$Route$counterUrl]));
			}
		case 5:
			var studentId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$studentAbsenceListUrl,
						$elm$core$String$fromInt(studentId)
					]));
		case 9:
			return join(
				_List_fromArray(
					[$author$project$Route$homeUrl]));
		case 6:
			var personId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$gradeReportUrlPart
					]));
		case 8:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$gradesOverviewUrl,
						$author$project$Route$gradesListQueryAsParam(query)
					]));
		case 7:
			var personId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$gradeRequestUrl
					]));
		case 10:
			return join(
				_List_fromArray(
					[$author$project$Route$learningContractsUrl, $author$project$Route$createUrlSuffix]));
		case 11:
			return join(
				_List_fromArray(
					[$author$project$Route$learningContractsUrl]));
		case 12:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$learningContractsUrl,
						$elm$core$String$fromInt(id)
					]));
		case 13:
			return join(
				_List_fromArray(
					[$author$project$Route$learningGroupsUrl, $author$project$Route$createUrlSuffix]));
		case 14:
			return join(
				_List_fromArray(
					[$author$project$Route$learningGroupsUrl]));
		case 15:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$learningGroupsUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 16:
			return join(
				_List_fromArray(
					[$author$project$Route$loBrowserUrl]));
		case 17:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$moduleClosureOverviewUrl,
						$author$project$Route$moduleClosureOverviewListQueryAsParam(query)
					]));
		case 19:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$moduleTeacherProfilesUrlSuffix
					]));
		case 20:
			return join(
				_List_fromArray(
					[$author$project$Route$modulesUrl, $author$project$Route$createUrlSuffix]));
		case 24:
			return join(
				_List_fromArray(
					[$author$project$Route$modulesUrl]));
		case 22:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id)
					]));
		case 21:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$createUrlSuffix
					]));
		case 23:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$duplicateUrlSuffix
					]));
		case 25:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 18:
			var moduleId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$modulesUrl,
						$elm$core$String$fromInt(moduleId),
						$author$project$Route$moduleClosureUrlPart
					]));
		case 26:
			return join(
				_List_fromArray(
					[$author$project$Route$notificationsUrl]));
		case 27:
			return join(
				_List_fromArray(
					[$author$project$Route$phoneBookUrl]));
		case 29:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$elm$core$String$fromInt(id)
					]));
		case 32:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 28:
			var maybeModuleId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$author$project$Route$createUrlSuffix,
						A2($author$project$Route$maybeIntParam, $author$project$Route$moduleParam, maybeModuleId)
					]));
		case 30:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$portfoliosUrl,
						$author$project$Route$portfoliosListQueryAsParam(query)
					]));
		case 31:
			return join(
				_List_fromArray(
					[$author$project$Route$portfoliosUrl, $author$project$Route$portfoliosMyChildrenSuffix]));
		case 33:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id)
					]));
		case 34:
			return join(
				_List_fromArray(
					[$author$project$Route$rubricsUrl, $author$project$Route$createUrlSuffix]));
		case 35:
			return join(
				_List_fromArray(
					[$author$project$Route$rubricsUrl]));
		case 38:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricSubjectOverviewUrl,
						$author$project$Route$loStudentOverviewListQueryAsParam(query)
					]));
		case 36:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricsUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$editUrlSuffix
					]));
		case 37:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$rubricsUrl,
						$elm$core$String$fromInt(id)
					]));
		case 40:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$studentProfilesUrlSuffix
					]));
		case 39:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$studentProfilesNekUrlSuffix
					]));
		case 41:
			return join(
				_List_fromArray(
					[$author$project$Route$studentsUrl]));
		case 42:
			var studentId = page.a;
			var maybeSubjectId = page.b;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(studentId),
						$author$project$Route$subjectFeedbackUrlPart,
						A2($author$project$Route$maybeIntParam, $author$project$Route$subjectParam, maybeSubjectId)
					]));
		case 43:
			var id = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(id),
						$author$project$Route$teacherProfilesUrlSuffix
					]));
		case 46:
			var eventId = page.a.im;
			var occId = page.a.he;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$author$project$Route$timetableEventsUrlPart,
						$elm$core$String$fromInt(eventId),
						$elm$core$String$fromInt(occId)
					]));
		case 45:
			var query = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$author$project$Route$scheduleUrlSuffix,
						$author$project$Route$timetableCreateQueryAsParam(query)
					]));
		case 44:
			var people = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$timetableUrl,
						$elm$url$Url$Builder$toQuery(
						A2(
							$elm$core$List$map,
							$elm$url$Url$Builder$int($author$project$Route$personParam),
							people))
					]));
		default:
			var personId = page.a;
			return join(
				_List_fromArray(
					[
						$author$project$Route$profilesUrl,
						$elm$core$String$fromInt(personId),
						$author$project$Route$trimesterFeedbackReportUrl
					]));
	}
};
var $author$project$Route$replaceUrl = F2(
	function (key, route) {
		return A2(
			$elm$browser$Browser$Navigation$replaceUrl,
			key,
			$author$project$Route$toString(route));
	});
var $author$project$Main$init = F3(
	function (flags, url, key) {
		var route = $author$project$Route$fromUrl(url);
		var initialRoute = A2($author$project$Main$getInitialRoute, flags.lQ, route);
		var model = {
			kl: A3($author$project$Auth0$Auth0Config, flags.km, flags.kk, flags.kj),
			aR: $author$project$Main$initAuthState(route),
			bz: _List_Nil,
			fB: false,
			iJ: key,
			lP: $author$project$Locale$defaultLanguage,
			dW: flags.dW,
			d0: $elm$core$Maybe$Nothing,
			bu: $author$project$Pages$notLoaded,
			cr: initialRoute,
			bx: A2($author$project$SharedConfig$create, flags, key)
		};
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($author$project$Route$replaceUrl, model.bx.iJ, model.cr),
						$author$project$Ports$consoleInfo('Build revision: ' + flags.gv),
						$author$project$Main$authenticateStep1
					])));
	});
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Main$GotCsrfToken = function (a) {
	return {$: 10, a: a};
};
var $author$project$Main$NewAppVersionIsAvailable = {$: 9};
var $author$project$Main$PageMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Ports$appUpdateReciever = _Platform_incomingPort(
	'appUpdateReciever',
	$elm$json$Json$Decode$null(0));
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $author$project$Ports$csrfTokenReciever = _Platform_incomingPort('csrfTokenReciever', $elm$json$Json$Decode$string);
var $elm$core$Platform$Sub$map = _Platform_map;
var $author$project$Pages$CounterMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Pages$LearningGroupFormMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$LearningGroupSelectorMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$ModulesMainMsg = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$PortfolioFormMsg = function (a) {
	return {$: 19, a: a};
};
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $author$project$Element$Counter$AnimalMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Multiselect$Click = {$: 1};
var $author$project$Multiselect$Opened = 2;
var $author$project$Multiselect$isOpened = function (_v0) {
	var model = _v0;
	return model.N === 2;
};
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {i7: pids, jC: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {il: event, iJ: key};
	});
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.i7,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.iJ;
		var event = _v0.il;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.jC);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $author$project$Multiselect$subscriptions = function (model) {
	return $author$project$Multiselect$isOpened(model) ? $elm$browser$Browser$Events$onClick(
		$elm$json$Json$Decode$succeed($author$project$Multiselect$Click)) : $elm$core$Platform$Sub$none;
};
var $author$project$Element$Counter$subscriptions = function (_v0) {
	var animalSelectorModel = _v0.br;
	return A2(
		$elm$core$Platform$Sub$map,
		$author$project$Element$Counter$AnimalMsg,
		$author$project$Multiselect$subscriptions(animalSelectorModel.bt.aC.nE.eZ));
};
var $author$project$Element$LearningGroupForm$StudentsFieldMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$LearningGroupForm$subscriptions = function (_v0) {
	var page = _v0.bm;
	if (page.$ === 1) {
		var form = page.a.bt;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Element$LearningGroupForm$StudentsFieldMsg,
			$author$project$Multiselect$subscriptions(form.e1.nE.eZ));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupSelector$subscriptions = function (model) {
	var _v0 = model.bm;
	if (_v0.$ === 1) {
		var form = _v0.a.bt;
		return A2(
			$elm$core$Platform$Sub$map,
			$author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg,
			$author$project$Multiselect$subscriptions(form.cc.nE.eZ));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$ModulesMain$FormMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$ModulesMain$LearningGroupSelectorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$PopupMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Element$ModulesMain$Students = function (a) {
	return {$: 12, a: a};
};
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Element$ModulesMain$subscriptions = function (_v0) {
	var page = _v0.bm;
	var popupModel = _v0.c3;
	if (page.$ === 3) {
		var formPageModel = page.a;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Students),
					$author$project$Multiselect$subscriptions(formPageModel.bt.e1.nE.eZ)),
					function () {
					if ((!popupModel.$) && (popupModel.a.$ === 2)) {
						var learningGroupSelectorModel = popupModel.a.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$LearningGroupSelectorMsg),
							$author$project$Element$LearningGroupSelector$subscriptions(learningGroupSelectorModel));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}()
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Element$PortfolioForm$ModuleFieldMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$PortfolioForm$StudentsFieldMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$PortfolioForm$subscriptions = function (_v0) {
	var page = _v0.bm;
	if (page.$ === 1) {
		var form = page.a.bt;
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Element$PortfolioForm$ModuleFieldMsg,
					$author$project$Multiselect$subscriptions(form.fK.nE.eZ)),
					A2(
					$elm$core$Platform$Sub$map,
					$author$project$Element$PortfolioForm$StudentsFieldMsg,
					$author$project$Multiselect$subscriptions(form.e1.nE.eZ))
				]));
	} else {
		return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Pages$subscriptions = function (model) {
	switch (model.$) {
		case 20:
			var portfolioFormModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$PortfolioFormMsg,
				$author$project$Element$PortfolioForm$subscriptions(portfolioFormModel));
		case 2:
			var counterModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$CounterMsg,
				$author$project$Element$Counter$subscriptions(counterModel));
		case 14:
			var modulesMainModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$ModulesMainMsg,
				$author$project$Element$ModulesMain$subscriptions(modulesMainModel));
		case 10:
			var learningGroupFormModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$LearningGroupFormMsg,
				$author$project$Element$LearningGroupForm$subscriptions(learningGroupFormModel));
		case 11:
			var learningGroupSelectorModel = model.a;
			return A2(
				$elm$core$Platform$Sub$map,
				$author$project$Pages$LearningGroupSelectorMsg,
				$author$project$Element$LearningGroupSelector$subscriptions(learningGroupSelectorModel));
		default:
			return $elm$core$Platform$Sub$none;
	}
};
var $author$project$Main$subscriptions = function (_v0) {
	var pageModel = _v0.bu;
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$appUpdateReciever(
				$elm$core$Basics$always($author$project$Main$NewAppVersionIsAvailable)),
				$author$project$Ports$csrfTokenReciever($author$project$Main$GotCsrfToken),
				A2(
				$elm$core$Platform$Sub$map,
				$author$project$Main$PageMsg,
				$author$project$Pages$subscriptions(pageModel))
			]));
};
var $author$project$Pages$HomePageMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$HomePage$ListElementMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$LoadMoreModules = {$: 16};
var $author$project$Element$PortfolioList$LoadMoreStories = {$: 9};
var $author$project$Element$StudentList$LoadMoreStudents = {$: 6};
var $author$project$Main$LogOutRequest = {$: 4};
var $author$project$Main$LogResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Main$LogoutResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$MainErrorLogin = {$: 204};
var $author$project$Locale$Messages$MainErrorLogout = {$: 205};
var $author$project$Locale$Messages$MainErrorProfileDownload = {$: 207};
var $author$project$Pages$ModuleSingleMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Main$NoOp = {$: 13};
var $author$project$Element$ModuleSingle$PortfolioListMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$Navbar$RouteChanged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StudentListMsg = function (a) {
	return {$: 27, a: a};
};
var $author$project$Main$Viewer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$dictToString = function (d) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var k = _v0.a;
				var v = _v0.b;
				return k + (': ' + v);
			},
			$elm$core$Dict$toList(d)));
};
var $author$project$Api$httpErrorToHumans = function (error) {
	switch (error.$) {
		case 0:
			var str = error.a;
			return 'bad URL; ' + str;
		case 3:
			var metadata = error.b;
			return $elm$core$String$fromInt(metadata.e_) + (' ' + metadata.hw);
		case 4:
			var body = error.a;
			return 'bad body; ' + body;
		case 5:
			var metadata = error.a;
			return 'bad header; ' + $author$project$Api$dictToString(metadata.ah);
		case 2:
			return 'network error';
		case 1:
			return 'response timeout';
		default:
			return '';
	}
};
var $author$project$Main$addError = F3(
	function (model, message, error) {
		return _Utils_update(
			model,
			{
				bz: A2(
					$elm$core$List$cons,
					message + (' ' + $author$project$Api$httpErrorToHumans(error)),
					model.bz)
			});
	});
var $author$project$Auth0$auth0AuthorizeURL = F2(
	function (auth0Config, silent) {
		var scopes = _List_fromArray(
			['openid', 'name', 'email']);
		var scopeParam = $elm$url$Url$percentEncode(
			A2($elm$core$String$join, ' ', scopes));
		var responseType = 'id_token';
		var maybeConn = $elm$core$Maybe$Nothing;
		var connectionParam = A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function (c) {
					return '&connection=' + c;
				},
				maybeConn));
		return 'https://' + (auth0Config.ii + ('/authorize' + (('?response_type=' + responseType) + ('&nonce=foobar' + (('&client_id=' + auth0Config.h8) + (connectionParam + (('&redirect_uri=' + auth0Config.jk) + (('&scope=' + scopeParam) + (silent ? '&prompt=none' : '')))))))));
	});
var $author$project$Main$LoginResponse = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Api$Endpoint$Endpoint = $elm$core$Basics$identity;
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $author$project$Api$Endpoint$toQueryParameters = function (params) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var name = _v0.a;
			var value = _v0.b;
			return A2($elm$url$Url$Builder$string, name, value);
		},
		params);
};
var $author$project$Api$Endpoint$url = F3(
	function (protoAndHost, paths, params) {
		var queryParams = $author$project$Api$Endpoint$toQueryParameters(params);
		return A3($elm$url$Url$Builder$crossOrigin, protoAndHost, paths, queryParams);
	});
var $author$project$Api$Endpoint$endpoint = F3(
	function (config, paths, params) {
		var pathsWithTrailingSlash = _Utils_ap(
			paths,
			_List_fromArray(
				['']));
		return A3($author$project$Api$Endpoint$url, config.fg, pathsWithTrailingSlash, params);
	});
var $author$project$Api$Endpoint$login = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'login']),
		_List_Nil);
};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Api$BadBody = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$BadStatus = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Api$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Api$NetworkError = {$: 2};
var $author$project$Api$Timeout = {$: 1};
var $author$project$Api$resolveWithErrorDetailed = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Api$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Api$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A3($author$project$Api$BadStatus, metadata.e_, metadata, body));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$author$project$Api$BadBody,
					toResult(body));
		}
	});
var $author$project$Api$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$author$project$Api$resolveWithErrorDetailed(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {jm: reqs, jC: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.bf;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.jm));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.jC)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					ke: r.ke,
					O: r.O,
					a4: A2(_Http_mapExpect, func, r.a4),
					ah: r.ah,
					ba: r.ba,
					be: r.be,
					bf: r.bf,
					G: r.G
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{ke: true, O: r.O, a4: r.a4, ah: r.ah, ba: r.ba, be: r.be, bf: r.bf, G: r.G}));
};
var $author$project$Api$Endpoint$toString = function (_v0) {
	var str = _v0;
	return str;
};
var $author$project$Api$Endpoint$request = function (config) {
	return $elm$http$Http$riskyRequest(
		{
			O: config.O,
			a4: config.a4,
			ah: config.ah,
			ba: config.ba,
			be: config.be,
			bf: config.bf,
			G: $author$project$Api$Endpoint$toString(config.G)
		});
};
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Api$toHeaders = function (config) {
	return _Utils_ap(
		function () {
			var _v0 = config.kH;
			if (!_v0.$) {
				var token = _v0.a;
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'X-CsrfToken', token)
					]);
			} else {
				return _List_Nil;
			}
		}(),
		function () {
			var _v1 = config.ks;
			if (!_v1.$) {
				var bearer = _v1.a;
				return _List_fromArray(
					[
						A2($elm$http$Http$header, 'Authorization', 'Bearer ' + bearer)
					]);
			} else {
				return _List_Nil;
			}
		}());
};
var $author$project$Api$post = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				O: body,
				a4: A2($author$project$Api$expectJson, toMsg, decoder),
				ah: $author$project$Api$toHeaders(config),
				ba: 'POST',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$Api$login = F2(
	function (config, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$login(config),
			config,
			$elm$http$Http$emptyBody,
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Api$Endpoint$verifyToken = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['api-token-verify']),
		_List_Nil);
};
var $author$project$Auth0$verifyToken = F3(
	function (config, token, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$verifyToken(config),
			config,
			$elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'token',
							$elm$json$Json$Encode$string(token))
						]))),
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Main$authenticateStep2 = F2(
	function (authState, backend) {
		switch (authState.$) {
			case 2:
				switch (authState.a.$) {
					case 0:
						var token = authState.a.a;
						return A3($author$project$Auth0$verifyToken, backend, token, $author$project$Main$LoginResponse);
					case 1:
						var _v1 = authState.a;
						return $elm$core$Platform$Cmd$none;
					default:
						return $elm$core$Platform$Cmd$none;
				}
			case 1:
				return A2($author$project$Api$login, backend, $author$project$Main$LoginResponse);
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Notification$remove = F2(
	function (id, notifications) {
		return A2($elm$core$Dict$remove, id, notifications);
	});
var $author$project$Session$clearNotification = F2(
	function (id, session) {
		return _Utils_update(
			session,
			{
				fM: A2($author$project$Notification$remove, id, session.fM)
			});
	});
var $author$project$Ports$consoleError = _Platform_outgoingPort('consoleError', $elm$json$Json$Encode$string);
var $author$project$Notification$empty = $elm$core$Dict$empty;
var $author$project$Session$create = function (viewer) {
	return {lP: viewer.m$.lP, fM: $author$project$Notification$empty, hy: viewer.m$.lP.hy, nH: viewer};
};
var $author$project$Log$ErrorLevel = 0;
var $author$project$Api$Endpoint$log = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'log']),
		_List_Nil);
};
var $author$project$Log$logEventNameToString = function (_v0) {
	var eventNameStr = _v0;
	return eventNameStr;
};
var $author$project$Log$logLevelToString = function (level) {
	if (level === 1) {
		return 'info';
	} else {
		return 'error';
	}
};
var $elm$http$Http$multipartBody = function (parts) {
	return A2(
		_Http_pair,
		'',
		_Http_toFormData(parts));
};
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {lm: index, lW: match, mh: number, ng: submatches};
	});
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{kx: false, l8: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $author$project$Log$removeWhitespaces = function (str) {
	var pattern = '\n|\t|[ ]{2,}';
	var maybeRegex = $elm$regex$Regex$fromString(pattern);
	var regex = A2($elm$core$Maybe$withDefault, $elm$regex$Regex$never, maybeRegex);
	var normalize = A2(
		$elm$regex$Regex$replace,
		regex,
		function (_v0) {
			return '';
		});
	return normalize(str);
};
var $elm$http$Http$stringPart = _Http_pair;
var $author$project$Log$makeFormData = F2(
	function (maxLength, event) {
		var normalizedMessage = A3(
			$elm$core$String$slice,
			0,
			maxLength,
			$author$project$Log$removeWhitespaces(event.cg));
		return $elm$http$Http$multipartBody(
			_List_fromArray(
				[
					A2($elm$http$Http$stringPart, 'client_id', event.h8),
					A2($elm$http$Http$stringPart, 'client_version', event.cE),
					A2(
					$elm$http$Http$stringPart,
					'level',
					$author$project$Log$logLevelToString(event.cX)),
					A2(
					$elm$http$Http$stringPart,
					'event_name',
					$author$project$Log$logEventNameToString(event.b3)),
					A2($elm$http$Http$stringPart, 'message', normalizedMessage)
				]));
	});
var $author$project$Log$log = F3(
	function (config, event, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$log(config.gr),
			config.gr,
			A2($author$project$Log$makeFormData, config.gr.g7, event),
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $author$project$Log$err = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var event = {h8: config.gr.g6, cE: config.gv, b3: eventName, cX: 0, cg: message};
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$Log$log, config, event, toMsg),
					$author$project$Ports$consoleError(
					$author$project$Log$logEventNameToString(event.b3) + (' ' + event.cg))
				]));
	});
var $author$project$Api$httpErrorToRobots = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return 'bad url|' + url;
		case 3:
			var metadata = error.b;
			var body = error.c;
			return $elm$core$String$fromInt(metadata.e_) + (' ' + (metadata.hw + ('|' + body)));
		case 4:
			var body = error.a;
			return 'bad body|' + body;
		case 5:
			var metadata = error.a;
			return 'bad header|' + $author$project$Api$dictToString(metadata.ah);
		case 2:
			return 'network error';
		case 1:
			return 'response timeout';
		default:
			var msg = error.a;
			return 'error|' + msg;
	}
};
var $author$project$Log$msgSeperator = ';';
var $author$project$Log$error = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var error_ = _v0.c;
		if (!message.$) {
			var message_ = message.a;
			return A3(
				$author$project$Log$err,
				config,
				_Utils_Tuple2(
					eventName,
					_Utils_ap(
						message_,
						_Utils_ap(
							$author$project$Log$msgSeperator,
							$author$project$Api$httpErrorToRobots(error_)))),
				toMsg);
		} else {
			return A3(
				$author$project$Log$err,
				config,
				_Utils_Tuple2(
					eventName,
					$author$project$Api$httpErrorToRobots(error_)),
				toMsg);
		}
	});
var $author$project$Main$BackendLoggedIn = {$: 1};
var $author$project$Main$ViewerDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$get = F3(
	function (url, config, expect) {
		return $author$project$Api$Endpoint$request(
			{
				O: $elm$http$Http$emptyBody,
				a4: expect,
				ah: $author$project$Api$toHeaders(config),
				ba: 'GET',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$Api$Endpoint$me = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'people', 'me']),
		_List_Nil);
};
var $author$project$Person$Active = 1;
var $author$project$Person$Person = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (phoneNumber) {
				return function (email) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlaceTown) {
										return function (roles) {
											return function (mentees) {
												return function (sponsorOf) {
													return function (relatedPeople) {
														return function (settings) {
															return function (state) {
																return function (accessRoles) {
																	return {hO: accessRoles, aE: birthDate, aG: birthPlaceCountry, aH: birthPlaceTown, K: email, k3: firstName, gT: id, ak: lastName, lZ: mentees, c1: permanentAddress, aQ: phoneNumber, mG: relatedPeople, c6: roles, m$: settings, m8: sponsorOf, eZ: state, nn: temporaryAddress};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Person$Auditor = 1;
var $author$project$Person$BpsStaff = 0;
var $author$project$Person$Impersonator = 2;
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Person$accessRoleDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (role) {
		switch (role) {
			case 'bps_staff':
				return $elm$json$Json$Decode$succeed(0);
			case 'auditor':
				return $elm$json$Json$Decode$succeed(1);
			case 'impersonator':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown access role: ' + role);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Person$accessRolesDecoder = $elm$json$Json$Decode$list($author$project$Person$accessRoleDecoder);
var $author$project$Person$Address = F9(
	function (isPermanent, country, town, postcode, pob, streetName, streetType, streetNumber, streetDoor) {
		return {kF: country, iH: isPermanent, i8: pob, mA: postcode, na: streetDoor, nb: streetName, nc: streetNumber, nd: streetType, ny: town};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Person$addressDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'street_door',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'street_number',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'street_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'street_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'pob',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'postcode',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'town',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'country',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_permanent',
									$elm$json$Json$Decode$bool,
									$elm$json$Json$Decode$succeed($author$project$Person$Address))))))))));
var $author$project$UserSettings$default = {gT: -1, lP: $author$project$Locale$defaultLanguage};
var $author$project$Person$Roles = $elm$core$Basics$identity;
var $author$project$Person$emptyRoles = _List_Nil;
var $author$project$Person$Future = 2;
var $author$project$Person$Left = 0;
var $author$project$Person$membershipStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'left':
				return $elm$json$Json$Decode$succeed(0);
			case 'active':
				return $elm$json$Json$Decode$succeed(1);
			case 'future':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown membership state: ' + state);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Person$NestedPerson = F4(
	function (id, firstName, lastName, email) {
		return {K: email, k3: firstName, gT: id, ak: lastName};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (path, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$at, path, $elm$json$Json$Decode$value),
				input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					return A2(
						$elm$json$Json$Decode$at,
						path,
						nullOr(valDecoder));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				_List_fromArray(
					[key]),
				valDecoder,
				fallback),
			decoder);
	});
var $author$project$Person$nestedPersonDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'email',
	$elm$json$Json$Decode$string,
	'',
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'last_name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'first_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id',
				$elm$json$Json$Decode$int,
				$elm$json$Json$Decode$succeed($author$project$Person$NestedPerson)))));
var $author$project$Person$nestedPeopleDecoder = $elm$json$Json$Decode$list($author$project$Person$nestedPersonDecoder);
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Team$TeamId = $elm$core$Basics$identity;
var $author$project$Team$teamIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Person$rolesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Basics$identity,
	$elm$json$Json$Decode$list(
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$index, 1, $author$project$Team$teamIdDecoder))));
var $author$project$UserSettings$UserSettings = F2(
	function (id, language) {
		return {gT: id, lP: language};
	});
var $author$project$Locale$English$isFirstNameFirst = true;
var $ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryan_haskell$date_format$DateFormat$Language$english = A6(
	$ryan_haskell$date_format$DateFormat$Language$Language,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryan_haskell$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryan_haskell$date_format$DateFormat$Language$toEnglishAmPm,
	$ryan_haskell$date_format$DateFormat$Language$toEnglishSuffix);
var $author$project$Locale$English$dateFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(', '),
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')')
		]));
var $author$project$Locale$English$dateTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$monthNameFull,
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$dayOfMonthSuffix,
			$ryan_haskell$date_format$DateFormat$text(', '),
			$ryan_haskell$date_format$DateFormat$yearNumber,
			$ryan_haskell$date_format$DateFormat$text(' ('),
			$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
			$ryan_haskell$date_format$DateFormat$text(')'),
			$ryan_haskell$date_format$DateFormat$text(' '),
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Locale$English$formatDays = function (weekdays) {
	var weekdayToText = function (weekday) {
		switch (weekday) {
			case 'MO':
				return 'Monday';
			case 'TU':
				return 'Tuesday';
			case 'WE':
				return 'Wednesday';
			case 'TH':
				return 'Thursday';
			case 'FR':
				return 'Friday';
			default:
				return '';
		}
	};
	if (!weekdays.$) {
		var weekdays_ = weekdays.a;
		return A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, weekdayToText, weekdays_));
	} else {
		return '';
	}
};
var $author$project$Locale$English$formatRecurring = F2(
	function (frequency, interval) {
		var _v0 = _Utils_Tuple2(frequency, interval);
		if (((_v0.a === 'Weekly') && (!_v0.b.$)) && (_v0.b.a === 2)) {
			return 'every other week ';
		} else {
			return 'every week ';
		}
	});
var $author$project$Locale$English$nameList = function (names) {
	var _v0 = $elm$core$List$reverse(names);
	if (!_v0.b) {
		return '';
	} else {
		if (!_v0.b.b) {
			var x = _v0.a;
			return x;
		} else {
			var x = _v0.a;
			var xs = _v0.b;
			return A2(
				$elm$core$String$join,
				', ',
				$elm$core$List$reverse(xs)) + (' and ' + x);
		}
	}
};
var $author$project$Locale$English$termFormatter = F3(
	function (zone, start, end) {
		var sameYear = _Utils_eq(
			A2($elm$time$Time$toYear, zone, start),
			A2($elm$time$Time$toYear, zone, end));
		var sameMonth = _Utils_eq(
			A2($elm$time$Time$toMonth, zone, start),
			A2($elm$time$Time$toMonth, zone, end));
		var sameDay = _Utils_eq(
			A2($elm$time$Time$toDay, zone, start),
			A2($elm$time$Time$toDay, zone, end));
		var _v0 = _Utils_Tuple3(sameYear, sameMonth, sameDay);
		if (_v0.a) {
			if (_v0.b) {
				if (_v0.c) {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text(', '),
								$ryan_haskell$date_format$DateFormat$yearNumber,
								$ryan_haskell$date_format$DateFormat$text(' ('),
								$ryan_haskell$date_format$DateFormat$dayOfWeekNameFull,
								$ryan_haskell$date_format$DateFormat$text(')')
							]),
						zone,
						start);
					return startDate;
				} else {
					var startDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$monthNameFull,
								$ryan_haskell$date_format$DateFormat$text(' '),
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
							]),
						zone,
						start);
					var endDate = A4(
						$ryan_haskell$date_format$DateFormat$formatWithLanguage,
						$ryan_haskell$date_format$DateFormat$Language$english,
						_List_fromArray(
							[
								$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
								$ryan_haskell$date_format$DateFormat$text(', '),
								$ryan_haskell$date_format$DateFormat$yearNumber
							]),
						zone,
						end);
					return startDate + ('—' + endDate);
				}
			} else {
				var startDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$ryan_haskell$date_format$DateFormat$Language$english,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber
						]),
					zone,
					start);
				var endDate = A4(
					$ryan_haskell$date_format$DateFormat$formatWithLanguage,
					$ryan_haskell$date_format$DateFormat$Language$english,
					_List_fromArray(
						[
							$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
							$ryan_haskell$date_format$DateFormat$text(' '),
							$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
							$ryan_haskell$date_format$DateFormat$text(', '),
							$ryan_haskell$date_format$DateFormat$yearNumber
						]),
					zone,
					end);
				return startDate + ('—' + endDate);
			}
		} else {
			var startDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$ryan_haskell$date_format$DateFormat$Language$english,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
						$ryan_haskell$date_format$DateFormat$text(', '),
						$ryan_haskell$date_format$DateFormat$yearNumber
					]),
				zone,
				start);
			var endDate = A4(
				$ryan_haskell$date_format$DateFormat$formatWithLanguage,
				$ryan_haskell$date_format$DateFormat$Language$english,
				_List_fromArray(
					[
						$ryan_haskell$date_format$DateFormat$monthNameAbbreviated,
						$ryan_haskell$date_format$DateFormat$text(' '),
						$ryan_haskell$date_format$DateFormat$dayOfMonthNumber,
						$ryan_haskell$date_format$DateFormat$text(', '),
						$ryan_haskell$date_format$DateFormat$yearNumber
					]),
				zone,
				end);
			return startDate + ('—' + endDate);
		}
	});
var $author$project$Locale$English$timeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryNumber,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $rl_king$elm_iso3166_country_codes$Iso3166$English$toName = function (c) {
	switch (c) {
		case 0:
			return 'Andorra';
		case 1:
			return 'United Arab Emirates';
		case 2:
			return 'Afghanistan';
		case 3:
			return 'Antigua and Barbuda';
		case 4:
			return 'Anguilla';
		case 5:
			return 'Albania';
		case 6:
			return 'Armenia';
		case 7:
			return 'Angola';
		case 8:
			return 'Antarctica';
		case 9:
			return 'Argentina';
		case 10:
			return 'American Samoa';
		case 11:
			return 'Austria';
		case 12:
			return 'Australia';
		case 13:
			return 'Aruba';
		case 14:
			return 'Åland Islands';
		case 15:
			return 'Azerbaijan';
		case 16:
			return 'Bosnia and Herzegovina';
		case 17:
			return 'Barbados';
		case 18:
			return 'Bangladesh';
		case 19:
			return 'Belgium';
		case 20:
			return 'Burkina Faso';
		case 21:
			return 'Bulgaria';
		case 22:
			return 'Bahrain';
		case 23:
			return 'Burundi';
		case 24:
			return 'Benin';
		case 25:
			return 'Saint Barthélemy';
		case 26:
			return 'Bermuda';
		case 27:
			return 'Brunei Darussalam';
		case 28:
			return 'Bolivia (Plurinational State of)';
		case 29:
			return 'Bonaire, Sint Eustatius and Saba';
		case 30:
			return 'Brazil';
		case 31:
			return 'Bahamas';
		case 32:
			return 'Bhutan';
		case 33:
			return 'Bouvet Island';
		case 34:
			return 'Botswana';
		case 35:
			return 'Belarus';
		case 36:
			return 'Belize';
		case 37:
			return 'Canada';
		case 38:
			return 'Cocos (Keeling) Islands';
		case 39:
			return 'Congo, Democratic Republic of the';
		case 40:
			return 'Central African Republic';
		case 41:
			return 'Congo';
		case 42:
			return 'Switzerland';
		case 43:
			return 'Côte d\'Ivoire';
		case 44:
			return 'Cook Islands';
		case 45:
			return 'Chile';
		case 46:
			return 'Cameroon';
		case 47:
			return 'China';
		case 48:
			return 'Colombia';
		case 49:
			return 'Costa Rica';
		case 50:
			return 'Cuba';
		case 51:
			return 'Cabo Verde';
		case 52:
			return 'Curaçao';
		case 53:
			return 'Christmas Island';
		case 54:
			return 'Cyprus';
		case 55:
			return 'Czechia';
		case 56:
			return 'Germany';
		case 57:
			return 'Djibouti';
		case 58:
			return 'Denmark';
		case 59:
			return 'Dominica';
		case 60:
			return 'Dominican Republic';
		case 61:
			return 'Algeria';
		case 62:
			return 'Ecuador';
		case 63:
			return 'Estonia';
		case 64:
			return 'Egypt';
		case 65:
			return 'Western Sahara';
		case 66:
			return 'Eritrea';
		case 67:
			return 'Spain';
		case 68:
			return 'Ethiopia';
		case 69:
			return 'Finland';
		case 70:
			return 'Fiji';
		case 71:
			return 'Falkland Islands (Malvinas)';
		case 72:
			return 'Micronesia (Federated States of)';
		case 73:
			return 'Faroe Islands';
		case 74:
			return 'France';
		case 75:
			return 'Gabon';
		case 76:
			return 'United Kingdom of Great Britain and Northern Ireland';
		case 77:
			return 'Grenada';
		case 78:
			return 'Georgia';
		case 79:
			return 'French Guiana';
		case 80:
			return 'Guernsey';
		case 81:
			return 'Ghana';
		case 82:
			return 'Gibraltar';
		case 83:
			return 'Greenland';
		case 84:
			return 'Gambia';
		case 85:
			return 'Guinea';
		case 86:
			return 'Guadeloupe';
		case 87:
			return 'Equatorial Guinea';
		case 88:
			return 'Greece';
		case 89:
			return 'South Georgia and the South Sandwich Islands';
		case 90:
			return 'Guatemala';
		case 91:
			return 'Guam';
		case 92:
			return 'Guinea-Bissau';
		case 93:
			return 'Guyana';
		case 94:
			return 'Hong Kong';
		case 95:
			return 'Heard Island and McDonald Islands';
		case 96:
			return 'Honduras';
		case 97:
			return 'Croatia';
		case 98:
			return 'Haiti';
		case 99:
			return 'Hungary';
		case 100:
			return 'Indonesia';
		case 101:
			return 'Ireland';
		case 102:
			return 'Israel';
		case 103:
			return 'Isle of Man';
		case 104:
			return 'India';
		case 105:
			return 'British Indian Ocean Territory';
		case 106:
			return 'Iraq';
		case 107:
			return 'Iran (Islamic Republic of)';
		case 108:
			return 'Iceland';
		case 109:
			return 'Italy';
		case 110:
			return 'Jersey';
		case 111:
			return 'Jamaica';
		case 112:
			return 'Jordan';
		case 113:
			return 'Japan';
		case 114:
			return 'Kenya';
		case 115:
			return 'Kyrgyzstan';
		case 116:
			return 'Cambodia';
		case 117:
			return 'Kiribati';
		case 118:
			return 'Comoros';
		case 119:
			return 'Saint Kitts and Nevis';
		case 120:
			return 'Korea (Democratic People\'s Republic of)';
		case 121:
			return 'Korea, Republic of';
		case 122:
			return 'Kuwait';
		case 123:
			return 'Cayman Islands';
		case 124:
			return 'Kazakhstan';
		case 125:
			return 'Lao People\'s Democratic Republic';
		case 126:
			return 'Lebanon';
		case 127:
			return 'Saint Lucia';
		case 128:
			return 'Liechtenstein';
		case 129:
			return 'Sri Lanka';
		case 130:
			return 'Liberia';
		case 131:
			return 'Lesotho';
		case 132:
			return 'Lithuania';
		case 133:
			return 'Luxembourg';
		case 134:
			return 'Latvia';
		case 135:
			return 'Libya';
		case 136:
			return 'Morocco';
		case 137:
			return 'Monaco';
		case 138:
			return 'Moldova, Republic of';
		case 139:
			return 'Montenegro';
		case 140:
			return 'Saint Martin (French part)';
		case 141:
			return 'Madagascar';
		case 142:
			return 'Marshall Islands';
		case 143:
			return 'North Macedonia';
		case 144:
			return 'Mali';
		case 145:
			return 'Myanmar';
		case 146:
			return 'Mongolia';
		case 147:
			return 'Macao';
		case 148:
			return 'Northern Mariana Islands';
		case 149:
			return 'Martinique';
		case 150:
			return 'Mauritania';
		case 151:
			return 'Montserrat';
		case 152:
			return 'Malta';
		case 153:
			return 'Mauritius';
		case 154:
			return 'Maldives';
		case 155:
			return 'Malawi';
		case 156:
			return 'Mexico';
		case 157:
			return 'Malaysia';
		case 158:
			return 'Mozambique';
		case 159:
			return 'Namibia';
		case 160:
			return 'New Caledonia';
		case 161:
			return 'Niger';
		case 162:
			return 'Norfolk Island';
		case 163:
			return 'Nigeria';
		case 164:
			return 'Nicaragua';
		case 165:
			return 'Netherlands';
		case 166:
			return 'Norway';
		case 167:
			return 'Nepal';
		case 168:
			return 'Nauru';
		case 169:
			return 'Niue';
		case 170:
			return 'New Zealand';
		case 171:
			return 'Oman';
		case 172:
			return 'Panama';
		case 173:
			return 'Peru';
		case 174:
			return 'French Polynesia';
		case 175:
			return 'Papua New Guinea';
		case 176:
			return 'Philippines';
		case 177:
			return 'Pakistan';
		case 178:
			return 'Poland';
		case 179:
			return 'Saint Pierre and Miquelon';
		case 180:
			return 'Pitcairn';
		case 181:
			return 'Puerto Rico';
		case 182:
			return 'Palestine, State of';
		case 183:
			return 'Portugal';
		case 184:
			return 'Palau';
		case 185:
			return 'Paraguay';
		case 186:
			return 'Qatar';
		case 187:
			return 'Réunion';
		case 188:
			return 'Romania';
		case 189:
			return 'Serbia';
		case 190:
			return 'Russian Federation';
		case 191:
			return 'Rwanda';
		case 192:
			return 'Saudi Arabia';
		case 193:
			return 'Solomon Islands';
		case 194:
			return 'Seychelles';
		case 195:
			return 'Sudan';
		case 196:
			return 'Sweden';
		case 197:
			return 'Singapore';
		case 198:
			return 'Saint Helena, Ascension and Tristan da Cunha';
		case 199:
			return 'Slovenia';
		case 200:
			return 'Svalbard and Jan Mayen';
		case 201:
			return 'Slovakia';
		case 202:
			return 'Sierra Leone';
		case 203:
			return 'San Marino';
		case 204:
			return 'Senegal';
		case 205:
			return 'Somalia';
		case 206:
			return 'Suriname';
		case 207:
			return 'South Sudan';
		case 208:
			return 'Sao Tome and Principe';
		case 209:
			return 'El Salvador';
		case 210:
			return 'Sint Maarten (Dutch part)';
		case 211:
			return 'Syrian Arab Republic';
		case 212:
			return 'Eswatini';
		case 213:
			return 'Turks and Caicos Islands';
		case 214:
			return 'Chad';
		case 215:
			return 'French Southern Territories';
		case 216:
			return 'Togo';
		case 217:
			return 'Thailand';
		case 218:
			return 'Tajikistan';
		case 219:
			return 'Tokelau';
		case 220:
			return 'Timor-Leste';
		case 221:
			return 'Turkmenistan';
		case 222:
			return 'Tunisia';
		case 223:
			return 'Tonga';
		case 224:
			return 'Türkiye';
		case 225:
			return 'Trinidad and Tobago';
		case 226:
			return 'Tuvalu';
		case 227:
			return 'Taiwan, Province of China';
		case 228:
			return 'Tanzania, United Republic of';
		case 229:
			return 'Ukraine';
		case 230:
			return 'Uganda';
		case 231:
			return 'United States Minor Outlying Islands';
		case 232:
			return 'United States of America';
		case 233:
			return 'Uruguay';
		case 234:
			return 'Uzbekistan';
		case 235:
			return 'Holy See';
		case 236:
			return 'Saint Vincent and the Grenadines';
		case 237:
			return 'Venezuela (Bolivarian Republic of)';
		case 238:
			return 'Virgin Islands (British)';
		case 239:
			return 'Virgin Islands (U.S.)';
		case 240:
			return 'Viet Nam';
		case 241:
			return 'Vanuatu';
		case 242:
			return 'Wallis and Futuna';
		case 243:
			return 'Samoa';
		case 244:
			return 'Yemen';
		case 245:
			return 'Mayotte';
		case 246:
			return 'South Africa';
		case 247:
			return 'Zambia';
		default:
			return 'Zimbabwe';
	}
};
var $author$project$Locale$English$translator = function (str) {
	switch (str.$) {
		case 0:
			var s = str.a;
			return s;
		case 1:
			return 'Changed: ';
		case 2:
			var caption = str.a;
			return caption;
		case 3:
			var caption = str.a;
			var from = str.b;
			var to = str.c;
			var visualizeEmpty = function (s) {
				return $elm$core$String$isEmpty(s) ? '∅' : s;
			};
			return caption + (' (' + (visualizeEmpty(from) + (' → ' + (visualizeEmpty(to) + ')'))));
		case 4:
			return 'Downloading recent notifications failed';
		case 5:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> uploaded a new learning contract for <i>' + (student + '</i>.')));
		case 6:
			var teacher = str.a;
			var student = str.b;
			return '<i>' + (teacher + ('</i> updated the learning contract of <i>' + (student + '</i>.')));
		case 8:
			return 'There are currently no notifications.';
		case 7:
			return 'Loading notifications...';
		case 9:
			var person = str.a;
			return '<i>' + (person + '</i>\'s mentor memo was updated.');
		case 10:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> updated their teacher data.');
		case 11:
			var student = str.a;
			return '<i>' + (student + '</i> participated in an activity.');
		case 12:
			var person = str.a;
			return '<i>' + (person + '</i> updated their contact data.');
		case 13:
			var approvedBy = str.a;
			var student = str.b;
			return '<i>' + (approvedBy + ('</i> updated the child data of <i>' + (student + '</i>.')));
		case 14:
			var teacher = str.a;
			return '<i>' + (teacher + '</i> updated their teacher data.');
		case 15:
			return 'Most recent notifications';
		case 16:
			return 'View';
		case 17:
			return 'Learning contract';
		case 18:
			var count = str.a;
			return (count > 1) ? ('Add ' + ($elm$core$String$fromInt(count) + ' learning outcomes')) : ('Add ' + ($elm$core$String$fromInt(count) + ' learning outcome'));
		case 19:
			return 'Appreciation';
		case 20:
			return 'Revoke badge';
		case 21:
			return 'Grant a new badge';
		case 22:
			return 'If you revoke the badge, it won\'t be calculated in the progress report any more. Are you sure you want to revoke it?';
		case 23:
			return 'An error occured while revoking the badge';
		case 24:
			return 'Badge was successfully revoked.';
		case 25:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'How can you see that ',
						$author$project$Locale$English$nameList(names),
						' achieved the learning outcome(s)?'
					]));
		case 26:
			var names = str.a;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'Dear ',
						$author$project$Locale$English$nameList(names),
						'! I would like to add the following to your feedback:'
					]));
		case 27:
			var name = str.a;
			return 'You have granted badge to ' + ($author$project$Locale$English$nameList(name) + '.');
		case 28:
			return 'Actions';
		case 30:
			return '+';
		case 29:
			return '-';
		case 31:
			return 'Create';
		case 32:
			return 'Delete';
		case 33:
			return 'Edit';
		case 34:
			return 'Login';
		case 35:
			return 'Reset';
		case 36:
			return 'Save';
		case 37:
			return 'OK';
		case 39:
			return 'Cancel';
		case 38:
			return 'Details';
		case 40:
			return 'Select';
		case 41:
			return 'Deselect';
		case 42:
			return 'Filters';
		case 43:
			return 'Downloading Google Classroom course list failed';
		case 44:
			var animal = str.a;
			var count = str.b;
			return $elm$core$String$fromInt(count) + (' ' + animal);
		case 46:
			var code = str.a;
			return $rl_king$elm_iso3166_country_codes$Iso3166$English$toName(code);
		case 45:
			return 'Counter';
		case 47:
			return 'Full day absences';
		case 48:
			return 'Downloading attendance data failed';
		case 49:
			return 'Full day attendance';
		case 50:
			return 'Remove the checkmark from the students who were absent all day. If you see a checkmark next to a students name it means that they are marked present at some (not necessairly all) classes of the day.';
		case 51:
			return 'Downloading feedback data failed';
		case 52:
			return 'YYYY-MM-DD';
		case 53:
			return 'Date expected in format: YYYY-MM-DD';
		case 54:
			return 'Phone number expected in format: +36301234567';
		case 55:
			return 'Invalid URL address';
		case 56:
			var mime = str.a;
			return 'Not supported file format: ' + mime;
		case 57:
			return 'Time expected in 24-hour format: HH:MM';
		case 58:
			var size = str.a;
			return 'The file is too big (' + ($elm$core$String$fromInt((((size / 1024) | 0) / 1024) | 0) + 'MB)');
		case 59:
			return 'The end date can not be earlier than the start date!';
		case 60:
			return 'No options found';
		case 61:
			return 'An error occured while uploading the document';
		case 62:
			return 'Not selected';
		case 63:
			return ' – optional';
		case 64:
			return 'For choosing multiple items, press and hold down the <kbd>Ctrl</kbd> (Windows/Linux) or <kbd>Cmd</kbd> (Mac) key while you\'re selecting them with a mouse click.';
		case 65:
			return 'You did not upload document!';
		case 66:
			return 'Cannot be blank!';
		case 67:
			return 'Please, write a bit more!';
		case 68:
			return 'Please select an option!';
		case 69:
			return 'An error occured while saving data';
		case 70:
			return 'Select all';
		case 71:
			return 'Select none';
		case 72:
			return 'HH:MM';
		case 73:
			return 'My BPS';
		case 74:
			return 'Closed modules';
		case 75:
			return 'Downloading grade reports failed';
		case 79:
			return 'Downloading the grade reports, please wait...';
		case 80:
			return 'There are no available grade reports for the child';
		case 76:
			return 'Grade report as PDF';
		case 77:
			return 'Feedback report as PDF';
		case 78:
			return 'excempted';
		case 81:
			return 'Subject';
		case 82:
			return 'Text Appraisal';
		case 83:
			return 'Achieved';
		case 84:
			return 'Achieved learning outcomes';
		case 85:
			return 'Grade';
		case 86:
			return 'We would like to reduce the significance of the grades in the everyday school life. Therefore the end of year grade reports aren\'t automatically sent out as from the school year 21/22. As a parent, if you want to access it, you need to request this document by <a href=\"https://forms.gle/JSnaSzAmgNRttLNw7\" target=\"_blank\">filling out this form</a>.';
		case 87:
			return 'Grade reports';
		case 88:
			return 'Click here if you want to browse feedbacks by subjects.';
		case 92:
			return 'Semester target';
		case 93:
			return 'Annual target';
		case 89:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' mid year'));
		case 90:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' end of year'));
		case 91:
			var startYear = str.a;
			var endYear = str.b;
			return $elm$core$String$fromInt(startYear) + ('/' + ($elm$core$String$fromInt(endYear) + ' grading exam'));
		case 94:
			return 'Mid year report';
		case 95:
			return 'End of year report';
		case 96:
			return 'Grading exam report';
		case 112:
			return 'E';
		case 113:
			return 'Grades overview';
		case 114:
			return 'Loading grades, please wait...';
		case 115:
			return 'Report term';
		case 116:
			return 'Grade';
		case 117:
			return 'School';
		case 118:
			return 'Student';
		case 119:
			return 'There are no available grade reports.';
		case 120:
			return 'There are no children in your school. If you believe this is a mistake, please contact us.';
		case 99:
			return 'Request grades';
		case 100:
			return 'Grade request form';
		case 97:
			return 'Subject grades';
		case 121:
			return 'Parents:';
		case 122:
			return 'You can find the contacts of the teachers and parents in the phonebook.';
		case 123:
			return 'Phonebook';
		case 124:
			return 'Here you find your children and their most important documents in one place.';
		case 125:
			return 'Children';
		case 126:
			return 'Profile';
		case 127:
			return 'Active';
		case 128:
			return 'Inactive';
		case 129:
			return 'You did not upload justifying document!';
		case 130:
			return 'We store the justifying document in accordance with by-law.';
		case 131:
			return 'Downloading learning assessments failed';
		case 132:
			return 'End date';
		case 133:
			return 'Start date';
		case 135:
			return 'Document link';
		case 134:
			return 'Child';
		case 136:
			return 'Downloading learning contracts failed';
		case 137:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, start, end);
		case 138:
			var name = str.a;
			return name + '\'s learning contract';
		case 140:
			return 'There are no learning contracts uploaded. If you think something is missing, please contact the mentor of your child.';
		case 141:
			return 'You haven\'t uploaded learning contracts yet. Go ahead, and add one.';
		case 142:
			return 'The learning contract you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 139:
			return 'Downloading learning contacts, please wait...';
		case 143:
			return 'Learning contract was successfully saved.';
		case 144:
			return 'Edit learning contract';
		case 145:
			return 'Add new learning contract';
		case 146:
			return 'Learning contracts';
		case 147:
			return 'Own group';
		case 148:
			return 'School group';
		case 149:
			return 'An error occured while deleting the learning group';
		case 150:
			return 'Learning group was successfully deleted.';
		case 151:
			return 'Loading groups failed';
		case 152:
			return 'There are no students in this group.';
		case 153:
			return 'Share';
		case 154:
			return 'Group name';
		case 155:
			return 'School selection';
		case 156:
			return 'Children selection';
		case 157:
			return 'Edit learning group';
		case 158:
			return 'Add new learning group';
		case 159:
			return 'List groups';
		case 160:
			return 'All groups';
		case 161:
			return 'No groups found.';
		case 162:
			return 'Downloading groups, please wait...';
		case 163:
			return 'Own groups';
		case 164:
			return 'School groups';
		case 165:
			return 'Search by group name and among members';
		case 166:
			return 'Groups';
		case 167:
			return 'An error occured while saving the learning group';
		case 168:
			return 'Learning group was successfully saved.';
		case 169:
			return 'Groups';
		case 170:
			return 'Select the group from the dropdown list to add its members to the participants of your module.';
		case 171:
			return 'Add groups to module';
		case 172:
			return 'Groups';
		case 173:
			return 'Loading My BPS, hold on...';
		case 174:
			return 'Login to My BPS';
		case 175:
			return 'MyBPS is only available to BPS children, parents and teachers.';
		case 176:
			return 'Logging out...';
		case 177:
			return 'Learning outcome browser';
		case 178:
			return 'NAT learning outcome browser';
		case 179:
			return 'Curriculum';
		case 180:
			return 'Grades';
		case 181:
			var goalStart = str.a;
			var goalEnd = str.b;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'So at least ',
						$elm$core$String$fromInt(goalStart),
						' learning outcomes are required for grade 2, and ',
						$elm$core$String$fromInt(goalEnd),
						' for grade 5.'
					]));
		case 182:
			var name = str.a.ha;
			var first = str.a.a;
			var last = str.a.b;
			return _Utils_eq(first, last) ? (name + (' (' + ($elm$core$String$fromInt(first) + ')'))) : (name + (' (' + ($elm$core$String$fromInt(first) + ('-' + ($elm$core$String$fromInt(last) + ')')))));
		case 183:
			return 'Subjects';
		case 184:
			return 'Search in learning outcomes';
		case 185:
			return 'Total';
		case 186:
			return 'Years';
		case 187:
			return 'Per trimester';
		case 188:
			return 'Achievable learning outcome';
		case 189:
			return 'There are no eligible learning outcomes for the module\'s children according to their curriculum.';
		case 190:
			return 'There are no children in your school. If you believe this is a mistake, please contact us.';
		case 191:
			var name = str.a;
			var grade = str.b;
			return name + (' (' + (grade + ' grader)'));
		case 192:
			return 'Achieved (by names)';
		case 193:
			return 'Subject';
		case 194:
			return 'Achieved (%)';
		case 195:
			return 'Badges';
		case 196:
			return 'View portfolio story';
		case 197:
			return 'View module closure feedback';
		case 198:
			var comment = str.a;
			return 'Mentor comment: ' + comment;
		case 199:
			return 'Mentor comment';
		case 200:
			return 'A táblázatról a szűlőknek lehetnek kérdései: miért ilyen sok a környezetismeret? miért ilyen kevés a matek? miért lett a 3-as énekből? hogy lett félév alatt 5-os matekból? Mit mondanál, hogy értse, mi van a számok mögött?';
		case 201:
			var names = str.a;
			return 'Kedves ' + ($author$project$Locale$English$nameList(names) + '! Az összesítő táblázat értelmezéséhez fontos tudnotok, hogy...');
		case 202:
			return 'Mentor comment was succesfully saved.';
		case 203:
			return 'Sorry, something went wrong';
		case 204:
			return 'Login failed:';
		case 205:
			return 'Logout failed:';
		case 206:
			var url = str.a;
			return 'The page you requested at ' + (url + ' was not found.');
		case 207:
			return 'Dowloading your profile failed:';
		case 208:
			return 'Try again the last action you performed, often it\'s a temporary issue. We automatically got notified of the issue. If the problem persists, please contact us at <a href=\"mailto:tech@budapestschool.org\">tech@budapestschool.org</a> and we\'ll look into the issue.';
		case 209:
			return 'Good news, a more recent version of the app is available.';
		case 210:
			return 'Reload the app for the updates.';
		case 211:
			return 'Module closing feedback';
		case 212:
			return 'Upon completing each module, based on the goals, topic, focus of the module, the children recieve feedback about their learning process, products, results, development and behaviours.';
		case 213:
			return 'This module doesn\'t have rubrics yet.';
		case 214:
			return 'Whom will you give feedback to?';
		case 215:
			return 'An error occured while saving the feedback';
		case 216:
			return 'Feedback was successfully saved.';
		case 217:
			return 'Too many students in module closure feedback.';
		case 218:
			return 'Module closure overview (3rd trimester)';
		case 219:
			return 'Loading module closures, please wait...';
		case 220:
			return 'Module closure overview';
		case 221:
			return 'Student';
		case 222:
			return 'Module';
		case 223:
			return 'Module closed?';
		case 224:
			return 'School';
		case 225:
			return 'Only mentees';
		case 226:
			return 'Type';
		case 227:
			return 'Module';
		case 228:
			return 'Title';
		case 229:
			return 'Notes';
		case 230:
			return 'Frequency';
		case 231:
			return 'On specific days';
		case 232:
			return 'Starts at';
		case 233:
			return 'Finishes at';
		case 234:
			return 'On this day';
		case 235:
			return 'Last occasion';
		case 236:
			return 'Last occasion';
		case 237:
			return 'Downloading module events failed';
		case 238:
			var title = str.a.jJ;
			var frequency = str.a.Q;
			var interval = str.a.iF;
			var weekdays = str.a.J;
			var isRecurring = str.a.lA;
			var startTime = str.a.M;
			var endTime = str.a.C;
			var startDate = str.a.hv;
			var endDate = str.a.gH;
			return isRecurring ? (title + (': ' + (('between ' + (startDate + (' and ' + (endDate + ' ')))) + (A2($author$project$Locale$English$formatRecurring, frequency, interval) + ($author$project$Locale$English$formatDays(weekdays) + (' ' + (startTime + (' - ' + endTime)))))))) : (title + (': ' + (startDate + (', ' + ('between ' + (startTime + (' - ' + endTime)))))));
		case 239:
			return 'Nem magyar állampolgár esetén a Magyarország területén való tartózkodás jogcíme és a tartózkodásra jogosító okirat megnevezése, száma';
		case 240:
			return 'Tartózkodási hely';
		case 241:
			return 'Végzettségével, szakképzettségével kapcsolatos adatok';
		case 242:
			return 'Downloading module teacher profile failed';
		case 243:
			return 'Module teacher profile data was successfully saved.';
		case 244:
			return 'Module teacher profile';
		case 245:
			return 'Loading module teacher profile, please wait...';
		case 246:
			return 'The module teacher profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 247:
			var name = str.a;
			return 'Module leader: ' + name;
		case 248:
			return 'Delete module';
		case 249:
			return 'Module final assessment';
		case 250:
			return 'Create copy';
		case 251:
			return 'Create and add module event';
		case 252:
			return 'Create new module from this';
		case 253:
			return 'Save as template';
		case 254:
			return 'New module event';
		case 255:
			return 'New portfolio story';
		case 256:
			var title = str.a;
			return 'Copy of ' + title;
		case 257:
			return 'The module belongs to a closed term.';
		case 258:
			return 'The module belongs to a closed term and cannot be edited any more.';
		case 259:
			return 'Module closing feedback';
		case 260:
			var title = str.a;
			return 'If you delete the module <b> ' + (title + '</b>, all related module events will be removed too. OK?');
		case 261:
			return 'Downloading modules failed';
		case 262:
			return 'Module leader';
		case 263:
			return 'Google Classroom course';
		case 264:
			return 'Objective of the module';
		case 265:
			return 'In this module, we will learn about…\nKey activities you can expect are…\nWith the knowledge gained…\n';
		case 266:
			return 'Related module materials (URL)';
		case 267:
			return 'Is module migratable to e-Kreta?';
		case 268:
			return 'No';
		case 269:
			return 'Yes';
		case 270:
			return 'Evaluation';
		case 271:
			return 'Goals the children will reach by the end of the module';
		case 272:
			return 'What are they gonna learn?';
		case 273:
			return 'By the end of the module, you will learn/understand/explore…';
		case 274:
			return 'What skills are they gonna develop?';
		case 275:
			return 'By the end of the module, you can/will develop…';
		case 276:
			return 'What are they gonna achieve?';
		case 277:
			return 'By the end of the module, you will create/make/figure out/plan out…';
		case 278:
			return 'Children';
		case 279:
			return 'Teachers';
		case 280:
			return 'School';
		case 281:
			return 'Title';
		case 283:
			return 'End date';
		case 282:
			return 'Start date';
		case 284:
			return 'Achievable learning outcomes';
		case 285:
			return 'Grades';
		case 286:
			return 'Teachers';
		case 287:
			return 'Schools';
		case 288:
			return 'Subjects';
		case 289:
			return 'Enabled filters:';
		case 290:
			return 'All schools';
		case 291:
			return 'Own school';
		case 292:
			return 'Own modules';
		case 293:
			return 'Templates';
		case 294:
			return 'Help on module creation';
		case 298:
			return 'The module you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 295:
			return 'Downloading modules, please wait...';
		case 296:
			return 'Load more modules';
		case 297:
			return 'No modules found.';
		case 299:
			return 'An error occured while deleting the module';
		case 300:
			return 'Module was successfully deleted.';
		case 301:
			return 'Ready for migration';
		case 302:
			return 'No rubrics assigned yet';
		case 303:
			return 'No children assigned yet';
		case 304:
			return 'Module events';
		case 305:
			return 'Module was successfully saved.';
		case 306:
			return 'Search in module titles and descriptions';
		case 307:
			return 'Group selection';
		case 308:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, start, end);
		case 309:
			return 'Edit module';
		case 310:
			return 'Create new module';
		case 311:
			return 'Create module from template';
		case 312:
			return 'Modules';
		case 313:
			var count = str.a;
			return 'NAT learning outcomes (' + ($elm$core$String$fromInt(count) + ')');
		case 314:
			return 'Rubrics';
		case 315:
			return 'Add new rubric';
		case 316:
			return 'Change the set of rubrics';
		case 317:
			return 'Warning';
		case 318:
			return 'By marking the module as migratable, the module\'s start and end dates, as well as the assigned module events, cannot be modified.';
		case 319:
			return 'Change amounts';
		case 320:
			return 'Grades overview';
		case 98:
			return 'If your child needs their teachers to convert their text appraisala into grades, please check the box next to the subject and click the \'Request grades\' button. Please request grades only for the subjects your child currently needs for any specific reason.';
		case 101:
			return 'Grade status';
		case 102:
			return 'There are no available grade reports based on which you can request a grade.';
		case 103:
			return 'There are no subjects available for requesting grades from.';
		case 104:
			return 'Not requested';
		case 105:
			return 'An error occured while requesting grades.';
		case 106:
			return 'Grades were requested successfully.';
		case 107:
			return 'Subject';
		case 108:
			return 'Grading in progress';
		case 109:
			return 'Justification';
		case 110:
			return 'Explain why you want to request a grade';
		case 111:
			return 'Waived';
		case 321:
			return 'Justify absences';
		case 322:
			return 'Justification of absences has been improved and moved to my.BPS. Look for the helicopter icon to browse and justify your child\'s absences.';
		case 323:
			return 'Learning contracts';
		case 324:
			return 'Switch to English';
		case 325:
			return 'Átváltás magyarra';
		case 326:
			return 'Report harassment';
		case 327:
			return 'Log out';
		case 328:
			return 'Module closure overview';
		case 329:
			return 'Modules';
		case 330:
			return 'List modules';
		case 331:
			return 'Add new module';
		case 332:
			return 'Notifications';
		case 333:
			return 'Overviews';
		case 334:
			return 'Phonebook';
		case 335:
			return 'Portolios';
		case 336:
			return 'List stories';
		case 337:
			return 'Add new story';
		case 338:
			return 'Profile';
		case 339:
			return 'Rubric feedbacks overview';
		case 340:
			return 'Children';
		case 341:
			return 'List children';
		case 342:
			return 'Timetable';
		case 343:
			return 'Notifications';
		case 344:
			return 'Email';
		case 345:
			return 'Name prefix';
		case 346:
			return 'First Name';
		case 347:
			var first = str.a;
			var last = str.b;
			return first + (' ' + last);
		case 349:
			return 'Last Name';
		case 348:
			return 'Name has family name first';
		case 350:
			return 'Mentor';
		case 351:
			return 'Phone Number';
		case 367:
			return 'Site';
		case 352:
			return 'School';
		case 353:
			return 'Permanent address';
		case 354:
			return 'Country';
		case 355:
			return 'Postcode';
		case 356:
			return 'City/Town';
		case 357:
			return 'Street name';
		case 358:
			return 'Street type';
		case 359:
			return 'Street number';
		case 360:
			return 'Floor, door';
		case 361:
			return 'Birthplace, town';
		case 362:
			return 'Birthplace, country';
		case 363:
			return 'Birthdate';
		case 364:
			return 'Nationality';
		case 365:
			return 'SSN';
		case 366:
			return 'Education ID';
		case 368:
			return 'Educational ID has to be 11 digits';
		case 369:
			return 'Social security number has to be 9 digits';
		case 370:
			return 'Loading the phonebook failed';
		case 371:
			return 'Everyone';
		case 372:
			return 'Parents';
		case 373:
			return 'Teachers';
		case 374:
			return 'Downloading your contacts, please wait...';
		case 375:
			return 'Search';
		case 376:
			return 'Phonebook';
		case 377:
			return 'Give feedback';
		case 378:
			return 'Google Classroom';
		case 379:
			return 'Mark as module closing';
		case 380:
			return 'The portfolio story belongs to a closed term.';
		case 381:
			return 'The portfolio story belongs to a closed term and cannot be edited any more.';
		case 382:
			return 'Help on portfolio story creation';
		case 383:
			return 'What happened?';
		case 384:
			return 'Photo/Video';
		case 385:
			return 'Related module';
		case 386:
			return 'Uploaded by';
		case 387:
			return 'Happened at';
		case 388:
			return 'School';
		case 389:
			return 'Participating children';
		case 390:
			return 'Loading portfolios failed';
		case 391:
			return 'Loading teachers and children for portfolios failed';
		case 392:
			return 'Enabled filters:';
		case 393:
			return 'All';
		case 394:
			return 'My children';
		case 395:
			return 'School';
		case 396:
			return 'Own stories';
		case 397:
			return 'Google Classroom';
		case 398:
			return 'Modules';
		case 399:
			return 'Own modules';
		case 400:
			return 'None';
		case 401:
			return 'Children';
		case 402:
			return 'Teachers';
		case 403:
			return 'Type';
		case 404:
			return 'All';
		case 405:
			return 'Only with feedback';
		case 406:
			return 'Only module closures';
		case 407:
			return 'Load more portfolio stories';
		case 408:
			var size = str.a;
			return 'Maximum file size is ' + ($elm$core$String$fromInt(size) + 'MB. Supported file formats are: JPEG, MP4, PDF, PNG, Quicktime');
		case 411:
			return 'Delete portfolio story';
		case 409:
			return 'Edit portfolio story';
		case 410:
			return 'Add new portfolio story';
		case 412:
			return 'Loading portfolio stories, please wait...';
		case 413:
			return 'If you remove the portfolio story, its content and attachments will no longer be available. Are you sure you want to remove it?';
		case 414:
			return 'An error occured while deleting the portfolio story.';
		case 415:
			return 'Portfolio story was successfuly deleted.';
		case 416:
			return 'No portfolio stories found.';
		case 417:
			return 'Portfolio story was successfully saved.';
		case 418:
			return 'An error occured while saving the portfolio story.';
		case 419:
			return 'Search in story descriptions and children';
		case 420:
			var creator = str.a;
			return creator + ' shared a story.';
		case 421:
			var creator = str.a;
			var students = str.b;
			var module_ = str.c;
			return creator + (' gave module closing feedback to ' + ($author$project$Locale$English$nameList(students) + (' of module ' + (module_ + '.'))));
		case 422:
			var names = str.a;
			return 'Participating children: ' + $author$project$Locale$English$nameList(names);
		case 423:
			return 'Portfolio stories';
		case 424:
			var email = str.a;
			return 'This is the picture that appears in the phonebook. Would you like to change it? Go to <a href=\"https://gravatar.com/\">gravatar.com</a> and upload a picture associated with the given email address(<b>' + (email + '</b>).');
		case 425:
			var name = str.a;
			return 'Edit contact data of ' + name;
		case 426:
			return 'Loading your profile, please wait...';
		case 427:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 428:
			return 'Loading profile data failed';
		case 429:
			return 'Profile data was successfully saved.';
		case 430:
			return 'Basic profile';
		case 431:
			return 'Select a rubric';
		case 432:
			var title = str.a;
			return 'Selected rubric: ' + title;
		case 433:
			return 'Give feedback';
		case 434:
			return 'Aspect';
		case 435:
			return 'Subject';
		case 436:
			return 'New rubric can not be created';
		case 437:
			return 'Rubric was successfully deleted.';
		case 438:
			return 'An error occured while deleting the rubric';
		case 439:
			return 'Rubric was successfully saved.';
		case 440:
			return 'An error occured while saving the rubric';
		case 441:
			return 'Private';
		case 442:
			return 'Create a new like this';
		case 443:
			return 'Shared with schools';
		case 444:
			return 'Loading the rubrics failed';
		case 445:
			return 'No rubrics found.';
		case 446:
			return 'Own rubrics';
		case 447:
			return 'All shared';
		case 448:
			return 'Selected';
		case 452:
			return 'Loading rubrics, please wait...';
		case 449:
			return 'Edit rubric';
		case 450:
			return 'Help on rubric creation';
		case 451:
			return 'Please keep in mind that editing a rubric will not affect feedbacks given before the change - those will still contain the previous content of the rubric. Obviously if you give a feedback after the edit, that will contain the changes you have made.';
		case 453:
			return 'Search in the author, title and content of rubrics';
		case 454:
			return 'Rubrics';
		case 455:
			return 'Selecting a rubric';
		case 456:
			return 'There are no rubric feedbacks matching the filter criteria.';
		case 457:
			return 'There are no children in your school. If you believe this is a mistake, please contact us.';
		case 458:
			return 'Loading rubric feedbacks, please wait...';
		case 459:
			return 'Rubric feedbacks summary';
		case 460:
			return 'On this page you can see which student got how many rubric feedbacks from each subject. Please note that the data behind this page refreshes with a few minutes delay. Hence we ask you to not expect the numbers below to change instantly after you gave a feedback, but be patient. Thanks for your understanding.';
		case 461:
			return 'School';
		case 462:
			return 'Name';
		case 463:
			return 'Grade';
		case 464:
			return 'Subject';
		case 465:
			return 'Feedbacks in modules';
		case 466:
			return 'Feedbacks given in the first semester';
		case 467:
			return 'Feedbacks given in the school year';
		case 480:
			var zone = str.a;
			var startDate = str.b;
			var endDate = str.c;
			return A3($author$project$Locale$English$termFormatter, zone, startDate, endDate);
		case 481:
			return 'Downloading absence data failed';
		case 482:
			return 'Loading absence data, please wait...';
		case 483:
			return 'There are no absences registered. If you believe this is a mistake, please contact us.';
		case 484:
			var name = str.a;
			return 'Absences of ' + (name + ' in this school year');
		case 485:
			return 'unjustified';
		case 486:
			return 'justified by doctor';
		case 487:
			return 'justified by parent';
		case 488:
			return 'justified by mentor';
		case 489:
			return 'questioned';
		case 468:
			return 'Justify as doctor';
		case 469:
			return 'Justify as parent';
		case 470:
			return 'Justify as mentor';
		case 471:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'If you want to justify the absence on <b>' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ('</b> for <b>' + (name + '</b>, please provide a reason and upload the justifying document if needed.')));
		case 472:
			var name = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return 'If you want to justify the absence on <b>' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ('</b> for <b>' + (name + '</b>, please provide a reason and upload the justifying document.')));
		case 473:
			return 'I think there\'s a mistake!';
		case 474:
			var zone = str.a;
			var start = str.b;
			var end = str.c;
			return 'If you think the teachers registered the absence at ' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ' erroneously, please tell us by clicking Ok. We will send an email to the mentor teacher and our tanügy team. They will contact you to resolve the issue.');
		case 475:
			return 'What happened?';
		case 476:
			return 'Justifying document';
		case 477:
			var size = str.a;
			return 'Maximum file size is ' + ($elm$core$String$fromInt(size) + 'MB. Supported file formats are: PDF, JPEG, PNG');
		case 479:
			return 'Failed to save justification :(';
		case 478:
			return 'Student absence justification was successfully saved :)';
		case 490:
			var name = str.a;
			return 'Mentor: ' + name;
		case 491:
			return 'Missing mentor!';
		case 495:
			return 'Downloading learning outcomes failed';
		case 496:
			return 'Load more children';
		case 492:
			return 'No students found.';
		case 493:
			return 'The student you were looking for is not found. Maybe they were deleted, you don\'t have permission to view them or they never existed.';
		case 494:
			var names = str.a;
			return 'Parents: ' + $author$project$Locale$English$nameList(names);
		case 497:
			return 'általános iskolai nevelés-oktatás';
		case 498:
			return 'gimnáziumi nevelés-oktatás';
		case 499:
			return 'szakiskolai nevelés-oktatás';
		case 504:
			return 'English';
		case 505:
			return 'German';
		case 506:
			return 'French';
		case 507:
			return 'Spanish';
		case 508:
			return 'Italian';
		case 500:
			return 'BTMN';
		case 501:
			return 'SNI1';
		case 502:
			return 'SNI2';
		case 503:
			return 'none';
		case 509:
			return 'NEK ID is 16-character long';
		case 510:
			return 'kindergarten 1st grade';
		case 511:
			return 'kindergarten 2nd grade';
		case 512:
			return 'kindergarten 3rd grade';
		case 513:
			return '1st grade';
		case 514:
			return '2nd grade';
		case 515:
			return '3rd grade';
		case 516:
			return '4th grade';
		case 517:
			return '5th grade';
		case 518:
			return '6th grade';
		case 519:
			return '7th grade';
		case 520:
			return '8th grade';
		case 521:
			return '9th grade';
		case 522:
			return '10th grade';
		case 523:
			return '11th grade';
		case 524:
			return '12th grade';
		case 525:
			return 'status';
		case 526:
			return 'Address card; in case of foreigners, residence permit (document)';
		case 527:
			return 'Felvételi mikor volt, milyen eredménnyel';
		case 528:
			return 'Mother\'s maiden name';
		case 529:
			return 'Köznevelési alapfeladat, amelyre a jogviszony irányul';
		case 530:
			return 'Jogviszony szünetelésének dátuma, oka';
		case 531:
			return 'Igazolt/igazolatlan órák száma';
		case 532:
			return 'Iskolai gyerekbaleset dátuma, leírása';
		case 533:
			return 'Kompetenciatesztek eredményei, mérési azonosító';
		case 534:
			return 'Report card from last finished school year (document)';
		case 535:
			return 'Szorgalom, magatartás, tudás minősítés (dokumentum)';
		case 536:
			return 'Vizsgaadatok (dátum, eredmény, vizsgáztató tanár)';
		case 537:
			return 'Fegyelmi és kártérítési ügyekkel kapcsolatos adatok: ügy száma, rövid leírása (indulásának oka, megoldásának, befejezésének formája, tartalma)';
		case 538:
			return 'Diákigazolvány sorszáma';
		case 539:
			return 'Tankönyvellátás';
		case 540:
			return 'Évfolyamismétlés';
		case 541:
			return 'Határon túli kirándulás';
		case 542:
			return 'Special status';
		case 543:
			return '<b>SNI1:</b> Enyhe értelmi fogyatékos, beszédfogyatékos vagy pszichés fejlődési zavarral küzdő sajátos nevelési igényű gyermek.<br/><b>SNI2:</b> Mozgásszervi, érzékszervi, középsúlyos értelmi fogyatékos, autizmus spektrum zavarral küzdő vagy halmozottan fogyatékos gyermek.<br/><b>BTMN:</b> Szakértői vélemény alapján beilleszkedési, tanulási, és magatartási nehézséggel küzdő gyerek.';
		case 544:
			return 'Expert report (document)';
		case 545:
			return 'Egyéni munkarend';
		case 546:
			return 'Egyéni munkarendre vonatkozó adatok (dokumentum)';
		case 547:
			return 'Hányadik osztályba kerül';
		case 548:
			return 'First foreign language';
		case 549:
			return 'Second foreign language';
		case 550:
			return 'Student card (document)';
		case 551:
			return 'Birth certificate (document)';
		case 552:
			return 'ID card or passport (document)';
		case 553:
			return ' - required if the child goes to school';
		case 554:
			return 'Tax ID (document)';
		case 555:
			return 'Social security ID (document)';
		case 556:
			return 'NEK id';
		case 557:
			return 'NEK id (document)';
		case 558:
			var count = str.a;
			return (count === 1) ? 'Legal representative' : 'Legal representatives';
		case 559:
			return 'New file…';
		case 560:
			return 'View';
		case 561:
			return 'File uploaded — ';
		case 562:
			return 'Maximum file size is 10MB. Supported file formats are: PDF, JPG, PNG';
		case 563:
			return 'Student card ID has to be 10 digits';
		case 564:
			return 'Downloading child profile failed';
		case 565:
			return 'An error occured while downloading the document';
		case 566:
			return 'Student profile data was successfully saved.';
		case 567:
			return 'Student profile';
		case 568:
			var name = str.a;
			return 'Student profile of ' + name;
		case 569:
			return 'Parents need to fill it out';
		case 570:
			return 'School needs to fill it out';
		case 571:
			return 'Loading child profile, please wait...';
		case 572:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 573:
			return 'Downloading the child list failed';
		case 574:
			return 'Everyone';
		case 575:
			return 'My mentees';
		case 576:
			return 'Downloading the child list, please wait...';
		case 577:
			return 'Children';
		case 578:
			return 'Add learning contract...';
		case 580:
			return 'Mentor comment';
		case 579:
			return 'Learning contract';
		case 581:
			return 'Profile';
		case 582:
			return 'Grade reports';
		case 583:
			return 'Absences';
		case 584:
			return 'Timetable';
		case 585:
			return 'Trimester feedbacks';
		case 586:
			return 'Subject feedbacks';
		case 587:
			return 'Search in student names';
		case 594:
			return 'Loading subject feedbacks, please wait...';
		case 593:
			return 'Downloading subject feedbacks failed';
		case 588:
			return 'All subjects';
		case 589:
			var studentName = str.a;
			var studentGrade = str.b;
			var subjectName = str.c;
			return 'Feedbacks for ' + (studentName + (' (' + (studentGrade + (') on ' + A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function (s) {
						return 'subject ' + s;
					},
					subjectName))))));
		case 590:
			return 'On this page you see the rubric lines given for the selected student on the selected subject, ordered by creation time. ' + 'You can navigate to the original feedbacks by clicking on the timestamps.';
		case 591:
			return 'Subject feedbacks';
		case 592:
			return 'Select subject';
		case 596:
			return 'Downloading subjects failed';
		case 595:
			return 'Downloading subjects';
		case 597:
			return 'Switch user';
		case 598:
			return 'Why do you need to switch user? This message will be recorded.';
		case 599:
			var name = str.a;
			return 'Switch user attempt was successful. Welcome, ' + (name + '!');
		case 600:
			return 'Switch user';
		case 601:
			return 'State';
		case 602:
			return 'Teacher';
		case 603:
			return 'Birth first name';
		case 604:
			return 'Birth last name';
		case 605:
			return 'Birth name has family name first';
		case 606:
			return 'Mother\'s name prefix';
		case 607:
			return 'Mother\'s first name';
		case 608:
			return 'Mother\'s last name';
		case 609:
			return 'Mother\'s name has family name first';
		case 610:
			return 'Highest level of education';
		case 611:
			return 'Number of years in apprenticeship';
		case 612:
			return 'Is member of academy?';
		case 613:
			return 'Diploma (document)';
		case 614:
			return 'University';
		case 615:
			return 'College';
		case 616:
			return 'Secondary school';
		case 617:
			return 'Birth data';
		case 618:
			return 'Contact details';
		case 619:
			return 'Professional details';
		case 620:
			return 'Downloading teacher profile failed';
		case 621:
			return 'Maximum file size is 10MB. Supported file formats are: PDF, JPG, PNG';
		case 622:
			return 'Teacher profile data was successfully saved.';
		case 623:
			return 'Teacher profile';
		case 624:
			var name = str.a;
			return 'Teacher profile of ' + name;
		case 625:
			return 'Loading teacher profile, please wait...';
		case 626:
			return 'The profile you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 627:
			return 'Downloading schools failed';
		case 628:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$dateFormatter, zone, time);
		case 629:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$dateTimeFormatter, zone, time);
		case 630:
			var zone = str.a;
			var time = str.b;
			return A2($author$project$Locale$English$timeFormatter, zone, time);
		case 631:
			var zone = str.a;
			var time1 = str.b;
			var time2 = str.c;
			return A2($author$project$Locale$English$dateFormatter, zone, time1) + (', ' + (A2($author$project$Locale$English$timeFormatter, zone, time1) + ('-' + A2($author$project$Locale$English$timeFormatter, zone, time2))));
		case 632:
			return 'Weekly';
		case 633:
			return 'Biweekly';
		case 634:
			return 'Happens once';
		case 635:
			var day = str.a;
			return $ryan_haskell$date_format$DateFormat$Language$english.nx(day);
		case 636:
			return 'Downloading the timetable failed';
		case 637:
			return 'Add new module event';
		case 638:
			return 'Edit module event';
		case 639:
			return 'Google Meet';
		case 640:
			return 'Attendance sheet';
		case 641:
			return 'Edit module event';
		case 642:
			return 'Delete module event';
		case 643:
			return 'Delete all occasions';
		case 644:
			return 'Delete this occasion';
		case 645:
			return 'Delete this and following occasions';
		case 646:
			return 'This and following occasions';
		case 647:
			return 'All occasions';
		case 648:
			return 'Timetables of teachers';
		case 649:
			return 'Timetables of children';
		case 650:
			return 'Loading timetable...';
		case 651:
			return 'Timetable';
		case 653:
			return 'An error occured while saving the module event';
		case 652:
			return 'Module event changes were successfully saved.';
		case 654:
			return 'Participants';
		case 655:
			return 'Absents';
		case 656:
			return 'Which occasions would you like to change?';
		case 657:
			return '<ul>' + ('<li><mark>Attendance information is tracked for each module events.</mark> If you reschedule past occasions, their attendance sheets will be lost.</li>' + ('<li>We only synchronize future occasions to Google Calendar.</li>' + '</ul>'));
		case 658:
			return '<p><mark>Attendance information is tracked for each module events.</mark>' + ('If you delete events of a module that was already started, the attendance sheets will be lost too.</p>' + '<p>If you want to finish a module sooner, only remove the future occasions.</p>');
		case 659:
			return '<p><mark>Attendance information is tracked for each module events.</mark>' + 'If you delete events of a module that was already started, the attendance sheets will be lost too.</p>';
		case 660:
			return 'Module event was successfuly deleted.';
		case 661:
			return 'An error occured while deleting the module event';
		case 662:
			return 'Timetable changes were successfully saved.';
		case 663:
			return 'The selected module event occasion was successfully canceled.';
		case 664:
			var title = str.a;
			var zone = str.b;
			var start = str.c;
			var end = str.d;
			return title + (' (' + (A3($author$project$Locale$English$termFormatter, zone, start, end) + ')'));
		case 665:
			var name = str.a;
			return 'Module: ' + name;
		case 666:
			var creator = str.a;
			var student = str.b;
			return creator + (' gave trimester closure feedback to ' + student);
		case 667:
			var name = str.a;
			return 'Dear ' + (name + '! About the past, trimester I would like to tell you that…');
		case 668:
			return 'Trimester closing feedback';
		case 669:
			var name = str.a.ha;
			var startYear = str.a.d9;
			var endYear = str.a.dH;
			var trimester = str.a.jP;
			return $elm$core$String$concat(
				_List_fromArray(
					[
						'To ',
						name,
						', ',
						$elm$core$String$fromInt(startYear),
						'/',
						$elm$core$String$fromInt(endYear),
						'. school year ',
						$elm$core$String$fromInt(trimester),
						'. trimester'
					]));
		case 670:
			return 'Select a rubric…';
		case 671:
			return 'Trimester closing feedback was succesfully saved.';
		case 672:
			return 'An error occured while saving the trimester closing feedback';
		case 673:
			return 'Please evaluate the aspects!';
		case 674:
			return 'Add trimester closing feedback';
		case 675:
			return 'Trimester feedback';
		case 676:
			return 'Trimester feedback';
		case 677:
			return 'Loading trimester feedback...';
		case 678:
			return 'The trimester feedback you were looking for is not found. Maybe it was deleted, you don\'t have permission to it or it never existed.';
		case 679:
			return 'Downloading the trimester feedback failed';
		case 680:
			var studentName = str.a;
			return studentName + ' hasn\'t recieved trimester closing feedback, yet. ';
		case 681:
			var studentName = str.a;
			return studentName + ' hasn\'t recieved any module closing feedback, yet.';
		case 682:
			return 'Give them feedback about their progress in the trimester!';
		case 683:
			return 'Past years';
		case 684:
			return '1st trimester';
		case 685:
			return '2nd trimester';
		case 686:
			return '3rd trimester';
		case 687:
			return 'Trimester feedback was successfuly deleted.';
		case 688:
			var grade = str.a;
			return 'Download mid year feedback for grade ' + $elm$core$String$fromInt(grade);
		case 689:
			var grade = str.a;
			return 'Download end of year feedback for grade ' + $elm$core$String$fromInt(grade);
		case 690:
			var schoolYear = str.a;
			var trimester = str.b;
			return 'Download feedback for ' + ($elm$core$String$fromInt(trimester) + (' trimester of school year ' + $elm$core$String$fromInt(schoolYear)));
		case 691:
			return 'An error occured while deleting the trimester feedback';
		case 692:
			return 'Settings saved.';
		default:
			return 'An error occured while saving the settings';
	}
};
var $author$project$Locale$english = {kz: 'en', ls: $author$project$Locale$English$isFirstNameFirst, hy: $author$project$Locale$English$translator};
var $author$project$Locale$fromCode = function (langCode) {
	switch (langCode) {
		case 'hu':
			return $elm$core$Maybe$Just($author$project$Locale$hungarian);
		case 'en':
			return $elm$core$Maybe$Just($author$project$Locale$english);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Locale$languageDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$json$Json$Decode$fail('Unknown language code: ' + s),
			A2(
				$elm$core$Maybe$map,
				$elm$json$Json$Decode$succeed,
				$author$project$Locale$fromCode(s)));
	},
	$elm$json$Json$Decode$string);
var $author$project$UserSettings$userSettingsDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'language',
	$author$project$Locale$languageDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$UserSettings$UserSettings)));
var $author$project$Person$personDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'access_roles',
	$author$project$Person$accessRolesDecoder,
	_List_Nil,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'state',
		$author$project$Person$membershipStateDecoder,
		1,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'settings',
			$author$project$UserSettings$userSettingsDecoder,
			$author$project$UserSettings$default,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'related_people',
				$author$project$Person$nestedPeopleDecoder,
				_List_Nil,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'sponsor_of',
					$author$project$Person$nestedPeopleDecoder,
					_List_Nil,
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'mentees',
						$author$project$Person$nestedPeopleDecoder,
						_List_Nil,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'roles',
							$author$project$Person$rolesDecoder,
							$author$project$Person$emptyRoles,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'birthplace',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'birthplace_country',
									$elm$json$Json$Decode$string,
									'',
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'birthdate',
										$elm$json$Json$Decode$string,
										'',
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'temporary_address',
											$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
											$elm$core$Maybe$Nothing,
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'permanent_address',
												$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
												$elm$core$Maybe$Nothing,
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'email',
													$elm$json$Json$Decode$string,
													'',
													A4(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
														'phone_number',
														$elm$json$Json$Decode$string,
														'',
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'first_name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$int,
																	$elm$json$Json$Decode$succeed($author$project$Person$Person))))))))))))))))));
var $author$project$Person$fetchViewer = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$me(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$personDecoder));
	});
var $author$project$Log$LogEventName = $elm$core$Basics$identity;
var $author$project$Log$msgLogin = 'login';
var $author$project$Log$InfoLevel = 1;
var $author$project$Log$ok = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var messages = _v0.b;
		var event = {
			h8: config.gr.g6,
			cE: config.gv,
			b3: eventName,
			cX: 1,
			cg: A2($elm$core$String$join, $author$project$Log$msgSeperator, messages)
		};
		return A3($author$project$Log$log, config, event, toMsg);
	});
var $author$project$Log$paramOk = 'ok';
var $author$project$Main$fetchViewer = function (model) {
	var sharedConfig = model.bx;
	return _Utils_Tuple2(
		_Utils_update(
			model,
			{
				aR: $author$project$Main$Authenticated($author$project$Main$BackendLoggedIn)
			}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Log$ok,
					sharedConfig,
					_Utils_Tuple2(
						$author$project$Log$msgLogin,
						_List_fromArray(
							[$author$project$Log$paramOk])),
					$elm$core$Basics$always($author$project$Main$NoOp)),
					A2($author$project$Person$fetchViewer, sharedConfig.gr, $author$project$Main$ViewerDownloaded)
				])));
};
var $author$project$Pages$isPageLoaded = function (model) {
	return !_Utils_eq(model, $author$project$Pages$notLoaded);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Api$Endpoint$logout = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'logout']),
		_List_Nil);
};
var $author$project$Api$logout = F2(
	function (config, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$logout(config),
			config,
			$elm$http$Http$emptyBody,
			callback,
			$elm$json$Json$Decode$succeed(0));
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $author$project$Main$mapPagesToProgram = F2(
	function (model, _v0) {
		var pageModel = _v0.a;
		var pageCmd = _v0.b;
		var session_ = _v0.c;
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					aR: $author$project$Main$Authenticated(
						$author$project$Main$Viewer(session_)),
					bu: pageModel
				}),
			A2($elm$core$Platform$Cmd$map, $author$project$Main$PageMsg, pageCmd));
	});
var $author$project$Main$mapProgram = F3(
	function (model, element, _return) {
		var modelWithSession = _Utils_update(
			model,
			{
				aR: $author$project$Main$Authenticated(
					$author$project$Main$Viewer(_return.cv))
			});
		return _Utils_Tuple2(
			A2(element.h_, modelWithSession, _return.dY),
			A2($elm$core$Platform$Cmd$map, element.iV, _return.dz));
	});
var $author$project$Log$msgAppUpdateRequest = 'scope_update_request';
var $author$project$Log$msgAutoLogin = 'auto_login';
var $author$project$Log$msgLogout = 'logout';
var $author$project$Log$msgOpenStartPage = 'open_start_page';
var $author$project$Log$msgPageNotFound = 'page_not_found';
var $author$project$Log$msgProfileDownload = 'profile_download';
var $author$project$Main$NavbarMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$Navbar$AbsenceJustificationClicked = {$: 4};
var $author$project$Element$Navbar$ActionItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$Navbar$LanguageChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$LearningGroupList = {$: 159};
var $author$project$Locale$Messages$LoBrowserTitle = {$: 178};
var $author$project$Locale$Messages$NavAdminTeamMembership = {$: 319};
var $author$project$Element$Navbar$NavDropdown = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$Navbar$NavDropdownRight = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Locale$Messages$NavGradesOverview = {$: 320};
var $author$project$Locale$Messages$NavJustifyAbsences = {$: 321};
var $author$project$Locale$Messages$NavLanguageEnglish = {$: 324};
var $author$project$Locale$Messages$NavLanguageHungarian = {$: 325};
var $author$project$Locale$Messages$NavLearningContracts = {$: 323};
var $author$project$Locale$Messages$NavLogout = {$: 327};
var $author$project$Locale$Messages$NavModuleClosureOverview = {$: 328};
var $author$project$Locale$Messages$NavModules = {$: 329};
var $author$project$Locale$Messages$NavModulesList = {$: 330};
var $author$project$Locale$Messages$NavModulesNew = {$: 331};
var $author$project$Locale$Messages$NavNotifications = {$: 332};
var $author$project$Locale$Messages$NavOverviews = {$: 333};
var $author$project$Locale$Messages$NavPhoneBook = {$: 334};
var $author$project$Locale$Messages$NavPortfolios = {$: 335};
var $author$project$Locale$Messages$NavPortfoliosList = {$: 336};
var $author$project$Locale$Messages$NavPortfoliosNew = {$: 337};
var $author$project$Locale$Messages$NavProfile = {$: 338};
var $author$project$Locale$Messages$NavRubricSubjectOverview = {$: 339};
var $author$project$Locale$Messages$NavSafeguard = {$: 326};
var $author$project$Element$Navbar$NavSingle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Locale$Messages$NavStudents = {$: 340};
var $author$project$Locale$Messages$NavStudentsList = {$: 341};
var $author$project$Locale$Messages$NavTimetable = {$: 342};
var $author$project$Locale$Messages$PersonFullName = F2(
	function (a, b) {
		return {$: 347, a: a, b: b};
	});
var $author$project$Element$Navbar$RouteItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Locale$Messages$RubricsTitle = {$: 454};
var $author$project$Element$Navbar$UrlItem = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Route$blankGradesListQuery = {bp: $elm$core$Maybe$Nothing, jH: $elm$core$Maybe$Nothing, gk: _List_Nil};
var $author$project$Route$blankLoStudentOverviewListQuery = {fK: $elm$core$Maybe$Nothing, bp: $elm$core$Maybe$Nothing, e1: _List_Nil, jB: _List_Nil};
var $author$project$Route$blankModuleClosureOverviewListQuery = {cn: $elm$core$Maybe$Nothing, bp: $elm$core$Maybe$Nothing};
var $author$project$Route$blankPortfoliosListQuery = {gH: $elm$core$Maybe$Nothing, hv: $elm$core$Maybe$Nothing, e1: _List_Nil, nJ: $elm$core$Maybe$Nothing};
var $author$project$Person$isActiveMember = function (person) {
	return person.eZ === 1;
};
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $author$project$Person$hasRole = F2(
	function (role, person) {
		var _v0 = person.c6;
		var roles = _v0;
		return A2(
			$elm$core$List$any,
			function (r) {
				return _Utils_eq(r.a, role);
			},
			roles);
	});
var $author$project$Person$roleModuleTeacher = 'module_teacher';
var $author$project$Person$isModuleTeacher = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleModuleTeacher, person);
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Basics$not = _Basics_not;
var $author$project$Person$isSponsor = function (person) {
	return !$elm$core$List$isEmpty(person.m8);
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $author$project$Person$hasAccessRole = F2(
	function (person, role) {
		return A2($elm$core$List$member, role, person.hO);
	});
var $author$project$ACL$isStaff = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 0);
};
var $author$project$Person$roleStudent = 'student';
var $author$project$Person$isStudent = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleStudent, person);
};
var $author$project$ACL$isSchoolMember = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || ($author$project$Person$isSponsor(person) || $author$project$Person$isStudent(person)));
};
var $author$project$ACL$canCreatePortfolios = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canManageModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewLearningContracts = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$Person$roleTeacher = 'teacher';
var $author$project$Person$isTeacher = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleTeacher, person);
};
var $author$project$ACL$canViewLearningGroup = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person));
};
var $author$project$ACL$canViewLearningOutcomes = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$isAuditor = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 1);
};
var $author$project$ACL$canViewModules = function (person) {
	return $author$project$Person$isActiveMember(person) && ($author$project$ACL$isSchoolMember(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewOverviews = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewPhonebook = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canViewPortfolios = function (person) {
	return $author$project$Person$isActiveMember(person) && ($author$project$ACL$isSchoolMember(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewPortfoliosSchool = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewRubricSubjectOverview = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$canViewRubrics = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || $author$project$ACL$isAuditor(person));
};
var $author$project$ACL$canViewStudents = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$ACL$everyone = true;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Array$repeat = F2(
	function (n, e) {
		return A2(
			$elm$core$Array$initialize,
			n,
			function (_v0) {
				return e;
			});
	});
var $truqu$elm_md5$MD5$emptyWords = A2($elm$core$Array$repeat, 16, 0);
var $truqu$elm_md5$MD5$addUnsigned = F2(
	function (x, y) {
		return 4294967295 & (x + y);
	});
var $elm$core$Bitwise$or = _Bitwise_or;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $truqu$elm_md5$MD5$rotateLeft = F2(
	function (bits, input) {
		return (input << bits) | (input >>> (32 - bits));
	});
var $truqu$elm_md5$MD5$cmn = F8(
	function (fun, a, b, c, d, x, s, ac) {
		return A2(
			$truqu$elm_md5$MD5$addUnsigned,
			b,
			A2(
				$truqu$elm_md5$MD5$rotateLeft,
				s,
				A2(
					$truqu$elm_md5$MD5$addUnsigned,
					a,
					A2(
						$truqu$elm_md5$MD5$addUnsigned,
						ac,
						A2(
							$truqu$elm_md5$MD5$addUnsigned,
							A3(fun, b, c, d),
							x)))));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $truqu$elm_md5$MD5$f = F3(
	function (x, y, z) {
		return z ^ (x & (y ^ z));
	});
var $truqu$elm_md5$MD5$ff = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$f, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$g = F3(
	function (x, y, z) {
		return y ^ (z & (x ^ y));
	});
var $truqu$elm_md5$MD5$gg = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$g, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$h = F3(
	function (x, y, z) {
		return z ^ (x ^ y);
	});
var $truqu$elm_md5$MD5$hh = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$h, a, b, c, d, x, s, ac);
	});
var $elm$core$Bitwise$complement = _Bitwise_complement;
var $truqu$elm_md5$MD5$i = F3(
	function (x, y, z) {
		return y ^ (x | (~z));
	});
var $truqu$elm_md5$MD5$ii = F7(
	function (a, b, c, d, x, s, ac) {
		return A8($truqu$elm_md5$MD5$cmn, $truqu$elm_md5$MD5$i, a, b, c, d, x, s, ac);
	});
var $truqu$elm_md5$MD5$hex_ = F2(
	function (xs, acc) {
		var a = acc.fb;
		var b = acc.fh;
		var c = acc.fm;
		var d = acc.fp;
		if ((((((((((((((((xs.b && xs.b.b) && xs.b.b.b) && xs.b.b.b.b) && xs.b.b.b.b.b) && xs.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b) && (!xs.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b.b)) {
			var x0 = xs.a;
			var _v1 = xs.b;
			var x1 = _v1.a;
			var _v2 = _v1.b;
			var x2 = _v2.a;
			var _v3 = _v2.b;
			var x3 = _v3.a;
			var _v4 = _v3.b;
			var x4 = _v4.a;
			var _v5 = _v4.b;
			var x5 = _v5.a;
			var _v6 = _v5.b;
			var x6 = _v6.a;
			var _v7 = _v6.b;
			var x7 = _v7.a;
			var _v8 = _v7.b;
			var x8 = _v8.a;
			var _v9 = _v8.b;
			var x9 = _v9.a;
			var _v10 = _v9.b;
			var x10 = _v10.a;
			var _v11 = _v10.b;
			var x11 = _v11.a;
			var _v12 = _v11.b;
			var x12 = _v12.a;
			var _v13 = _v12.b;
			var x13 = _v13.a;
			var _v14 = _v13.b;
			var x14 = _v14.a;
			var _v15 = _v14.b;
			var x15 = _v15.a;
			var s44 = 21;
			var s43 = 15;
			var s42 = 10;
			var s41 = 6;
			var s34 = 23;
			var s33 = 16;
			var s32 = 11;
			var s31 = 4;
			var s24 = 20;
			var s23 = 14;
			var s22 = 9;
			var s21 = 5;
			var s14 = 22;
			var s13 = 17;
			var s12 = 12;
			var s11 = 7;
			var d00 = d;
			var c00 = c;
			var b00 = b;
			var a00 = a;
			var a01 = A7($truqu$elm_md5$MD5$ff, a00, b00, c00, d00, x0, s11, 3614090360);
			var d01 = A7($truqu$elm_md5$MD5$ff, d00, a01, b00, c00, x1, s12, 3905402710);
			var c01 = A7($truqu$elm_md5$MD5$ff, c00, d01, a01, b00, x2, s13, 606105819);
			var b01 = A7($truqu$elm_md5$MD5$ff, b00, c01, d01, a01, x3, s14, 3250441966);
			var a02 = A7($truqu$elm_md5$MD5$ff, a01, b01, c01, d01, x4, s11, 4118548399);
			var d02 = A7($truqu$elm_md5$MD5$ff, d01, a02, b01, c01, x5, s12, 1200080426);
			var c02 = A7($truqu$elm_md5$MD5$ff, c01, d02, a02, b01, x6, s13, 2821735955);
			var b02 = A7($truqu$elm_md5$MD5$ff, b01, c02, d02, a02, x7, s14, 4249261313);
			var a03 = A7($truqu$elm_md5$MD5$ff, a02, b02, c02, d02, x8, s11, 1770035416);
			var d03 = A7($truqu$elm_md5$MD5$ff, d02, a03, b02, c02, x9, s12, 2336552879);
			var c03 = A7($truqu$elm_md5$MD5$ff, c02, d03, a03, b02, x10, s13, 4294925233);
			var b03 = A7($truqu$elm_md5$MD5$ff, b02, c03, d03, a03, x11, s14, 2304563134);
			var a04 = A7($truqu$elm_md5$MD5$ff, a03, b03, c03, d03, x12, s11, 1804603682);
			var d04 = A7($truqu$elm_md5$MD5$ff, d03, a04, b03, c03, x13, s12, 4254626195);
			var c04 = A7($truqu$elm_md5$MD5$ff, c03, d04, a04, b03, x14, s13, 2792965006);
			var b04 = A7($truqu$elm_md5$MD5$ff, b03, c04, d04, a04, x15, s14, 1236535329);
			var a05 = A7($truqu$elm_md5$MD5$gg, a04, b04, c04, d04, x1, s21, 4129170786);
			var d05 = A7($truqu$elm_md5$MD5$gg, d04, a05, b04, c04, x6, s22, 3225465664);
			var c05 = A7($truqu$elm_md5$MD5$gg, c04, d05, a05, b04, x11, s23, 643717713);
			var b05 = A7($truqu$elm_md5$MD5$gg, b04, c05, d05, a05, x0, s24, 3921069994);
			var a06 = A7($truqu$elm_md5$MD5$gg, a05, b05, c05, d05, x5, s21, 3593408605);
			var d06 = A7($truqu$elm_md5$MD5$gg, d05, a06, b05, c05, x10, s22, 38016083);
			var c06 = A7($truqu$elm_md5$MD5$gg, c05, d06, a06, b05, x15, s23, 3634488961);
			var b06 = A7($truqu$elm_md5$MD5$gg, b05, c06, d06, a06, x4, s24, 3889429448);
			var a07 = A7($truqu$elm_md5$MD5$gg, a06, b06, c06, d06, x9, s21, 568446438);
			var d07 = A7($truqu$elm_md5$MD5$gg, d06, a07, b06, c06, x14, s22, 3275163606);
			var c07 = A7($truqu$elm_md5$MD5$gg, c06, d07, a07, b06, x3, s23, 4107603335);
			var b07 = A7($truqu$elm_md5$MD5$gg, b06, c07, d07, a07, x8, s24, 1163531501);
			var a08 = A7($truqu$elm_md5$MD5$gg, a07, b07, c07, d07, x13, s21, 2850285829);
			var d08 = A7($truqu$elm_md5$MD5$gg, d07, a08, b07, c07, x2, s22, 4243563512);
			var c08 = A7($truqu$elm_md5$MD5$gg, c07, d08, a08, b07, x7, s23, 1735328473);
			var b08 = A7($truqu$elm_md5$MD5$gg, b07, c08, d08, a08, x12, s24, 2368359562);
			var a09 = A7($truqu$elm_md5$MD5$hh, a08, b08, c08, d08, x5, s31, 4294588738);
			var d09 = A7($truqu$elm_md5$MD5$hh, d08, a09, b08, c08, x8, s32, 2272392833);
			var c09 = A7($truqu$elm_md5$MD5$hh, c08, d09, a09, b08, x11, s33, 1839030562);
			var b09 = A7($truqu$elm_md5$MD5$hh, b08, c09, d09, a09, x14, s34, 4259657740);
			var a10 = A7($truqu$elm_md5$MD5$hh, a09, b09, c09, d09, x1, s31, 2763975236);
			var d10 = A7($truqu$elm_md5$MD5$hh, d09, a10, b09, c09, x4, s32, 1272893353);
			var c10 = A7($truqu$elm_md5$MD5$hh, c09, d10, a10, b09, x7, s33, 4139469664);
			var b10 = A7($truqu$elm_md5$MD5$hh, b09, c10, d10, a10, x10, s34, 3200236656);
			var a11 = A7($truqu$elm_md5$MD5$hh, a10, b10, c10, d10, x13, s31, 681279174);
			var d11 = A7($truqu$elm_md5$MD5$hh, d10, a11, b10, c10, x0, s32, 3936430074);
			var c11 = A7($truqu$elm_md5$MD5$hh, c10, d11, a11, b10, x3, s33, 3572445317);
			var b11 = A7($truqu$elm_md5$MD5$hh, b10, c11, d11, a11, x6, s34, 76029189);
			var a12 = A7($truqu$elm_md5$MD5$hh, a11, b11, c11, d11, x9, s31, 3654602809);
			var d12 = A7($truqu$elm_md5$MD5$hh, d11, a12, b11, c11, x12, s32, 3873151461);
			var c12 = A7($truqu$elm_md5$MD5$hh, c11, d12, a12, b11, x15, s33, 530742520);
			var b12 = A7($truqu$elm_md5$MD5$hh, b11, c12, d12, a12, x2, s34, 3299628645);
			var a13 = A7($truqu$elm_md5$MD5$ii, a12, b12, c12, d12, x0, s41, 4096336452);
			var d13 = A7($truqu$elm_md5$MD5$ii, d12, a13, b12, c12, x7, s42, 1126891415);
			var c13 = A7($truqu$elm_md5$MD5$ii, c12, d13, a13, b12, x14, s43, 2878612391);
			var b13 = A7($truqu$elm_md5$MD5$ii, b12, c13, d13, a13, x5, s44, 4237533241);
			var a14 = A7($truqu$elm_md5$MD5$ii, a13, b13, c13, d13, x12, s41, 1700485571);
			var d14 = A7($truqu$elm_md5$MD5$ii, d13, a14, b13, c13, x3, s42, 2399980690);
			var c14 = A7($truqu$elm_md5$MD5$ii, c13, d14, a14, b13, x10, s43, 4293915773);
			var b14 = A7($truqu$elm_md5$MD5$ii, b13, c14, d14, a14, x1, s44, 2240044497);
			var a15 = A7($truqu$elm_md5$MD5$ii, a14, b14, c14, d14, x8, s41, 1873313359);
			var d15 = A7($truqu$elm_md5$MD5$ii, d14, a15, b14, c14, x15, s42, 4264355552);
			var c15 = A7($truqu$elm_md5$MD5$ii, c14, d15, a15, b14, x6, s43, 2734768916);
			var b15 = A7($truqu$elm_md5$MD5$ii, b14, c15, d15, a15, x13, s44, 1309151649);
			var a16 = A7($truqu$elm_md5$MD5$ii, a15, b15, c15, d15, x4, s41, 4149444226);
			var d16 = A7($truqu$elm_md5$MD5$ii, d15, a16, b15, c15, x11, s42, 3174756917);
			var c16 = A7($truqu$elm_md5$MD5$ii, c15, d16, a16, b15, x2, s43, 718787259);
			var b16 = A7($truqu$elm_md5$MD5$ii, b15, c16, d16, a16, x9, s44, 3951481745);
			var b17 = A2($truqu$elm_md5$MD5$addUnsigned, b00, b16);
			var c17 = A2($truqu$elm_md5$MD5$addUnsigned, c00, c16);
			var d17 = A2($truqu$elm_md5$MD5$addUnsigned, d00, d16);
			var a17 = A2($truqu$elm_md5$MD5$addUnsigned, a00, a16);
			return {fb: a17, fh: b17, fm: c17, fp: d17};
		} else {
			return acc;
		}
	});
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $truqu$elm_md5$MD5$iget = F2(
	function (index, array) {
		return A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Array$get, index, array));
	});
var $elm$core$Elm$JsArray$unsafeSet = _JsArray_unsafeSet;
var $elm$core$Array$setHelp = F4(
	function (shift, index, value, tree) {
		var pos = $elm$core$Array$bitMask & (index >>> shift);
		var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
		if (!_v0.$) {
			var subTree = _v0.a;
			var newSub = A4($elm$core$Array$setHelp, shift - $elm$core$Array$shiftStep, index, value, subTree);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$SubTree(newSub),
				tree);
		} else {
			var values = _v0.a;
			var newLeaf = A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, values);
			return A3(
				$elm$core$Elm$JsArray$unsafeSet,
				pos,
				$elm$core$Array$Leaf(newLeaf),
				tree);
		}
	});
var $elm$core$Array$set = F3(
	function (index, value, array) {
		var len = array.a;
		var startShift = array.b;
		var tree = array.c;
		var tail = array.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? array : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			tree,
			A3($elm$core$Elm$JsArray$unsafeSet, $elm$core$Array$bitMask & index, value, tail)) : A4(
			$elm$core$Array$Array_elm_builtin,
			len,
			startShift,
			A4($elm$core$Array$setHelp, startShift, index, value, tree),
			tail));
	});
var $truqu$elm_md5$MD5$consume = F2(
	function (_char, _v0) {
		var hashState = _v0.a;
		var _v1 = _v0.b;
		var byteCount = _v1.a;
		var words = _v1.b;
		var totalByteCount = _v0.c;
		var wordCount = (byteCount / 4) | 0;
		var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
		var bytePosition = 8 * (byteCount % 4);
		var code = _char << bytePosition;
		var newWord = oldWord | code;
		var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
		return (byteCount === 63) ? _Utils_Tuple3(
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState),
			_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
			totalByteCount + 1) : _Utils_Tuple3(
			hashState,
			_Utils_Tuple2(byteCount + 1, newWords),
			totalByteCount + 1);
	});
var $truqu$elm_md5$MD5$finishUp = function (_v0) {
	var hashState = _v0.a;
	var _v1 = _v0.b;
	var byteCount = _v1.a;
	var words = _v1.b;
	var totalByteCount = _v0.c;
	var wordCount = (byteCount / 4) | 0;
	var oldWord = A2($truqu$elm_md5$MD5$iget, wordCount, words);
	var bytePosition = 8 * (byteCount % 4);
	var code = 128 << bytePosition;
	var newWord = oldWord | code;
	var newWords = A3($elm$core$Array$set, wordCount, newWord, words);
	return (wordCount < 14) ? function (x) {
		return A2($truqu$elm_md5$MD5$hex_, x, hashState);
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, newWords)))) : function (x) {
		return A2(
			$truqu$elm_md5$MD5$hex_,
			x,
			A2(
				$truqu$elm_md5$MD5$hex_,
				$elm$core$Array$toList(newWords),
				hashState));
	}(
		$elm$core$Array$toList(
			A3(
				$elm$core$Array$set,
				15,
				totalByteCount >>> 29,
				A3($elm$core$Array$set, 14, totalByteCount << 3, $truqu$elm_md5$MD5$emptyWords))));
};
var $elm$core$String$foldl = _String_foldl;
var $zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8 = F3(
	function (add, _char, acc) {
		return (_char < 128) ? A2(add, _char, acc) : ((_char < 2048) ? A2(
			add,
			128 | (63 & _char),
			A2(add, 192 | (_char >>> 6), acc)) : ((_char < 65536) ? A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(add, 224 | (_char >>> 12), acc))) : A2(
			add,
			128 | (63 & _char),
			A2(
				add,
				128 | (63 & (_char >>> 6)),
				A2(
					add,
					128 | (63 & (_char >>> 12)),
					A2(add, 240 | (_char >>> 18), acc))))));
	});
var $zwilias$elm_utf_tools$String$UTF8$foldl = F3(
	function (op, initialAcc, input) {
		return A3(
			$elm$core$String$foldl,
			F2(
				function (_char, acc) {
					return A3(
						$zwilias$elm_utf_tools$String$UTF8$utf32ToUtf8,
						op,
						$elm$core$Char$toCode(_char),
						acc);
				}),
			initialAcc,
			input);
	});
var $truqu$elm_md5$MD5$State = F4(
	function (a, b, c, d) {
		return {fb: a, fh: b, fm: c, fp: d};
	});
var $truqu$elm_md5$MD5$initialHashState = A4($truqu$elm_md5$MD5$State, 1732584193, 4023233417, 2562383102, 271733878);
var $truqu$elm_md5$MD5$hash = function (input) {
	return $truqu$elm_md5$MD5$finishUp(
		A3(
			$zwilias$elm_utf_tools$String$UTF8$foldl,
			$truqu$elm_md5$MD5$consume,
			_Utils_Tuple3(
				$truqu$elm_md5$MD5$initialHashState,
				_Utils_Tuple2(0, $truqu$elm_md5$MD5$emptyWords),
				0),
			input));
};
var $truqu$elm_md5$MD5$bytes = function (string) {
	var _v0 = $truqu$elm_md5$MD5$hash(string);
	var a = _v0.fb;
	var b = _v0.fh;
	var c = _v0.fm;
	var d = _v0.fp;
	return _List_fromArray(
		[a & 255, (a >>> 8) & 255, (a >>> 16) & 255, (a >>> 24) & 255, b & 255, (b >>> 8) & 255, (b >>> 16) & 255, (b >>> 24) & 255, c & 255, (c >>> 8) & 255, (c >>> 16) & 255, (c >>> 24) & 255, d & 255, (d >>> 8) & 255, (d >>> 16) & 255, (d >>> 24) & 255]);
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $truqu$elm_md5$MD5$toHex = function (_byte) {
	switch (_byte) {
		case 0:
			return '0';
		case 1:
			return '1';
		case 2:
			return '2';
		case 3:
			return '3';
		case 4:
			return '4';
		case 5:
			return '5';
		case 6:
			return '6';
		case 7:
			return '7';
		case 8:
			return '8';
		case 9:
			return '9';
		case 10:
			return 'a';
		case 11:
			return 'b';
		case 12:
			return 'c';
		case 13:
			return 'd';
		case 14:
			return 'e';
		case 15:
			return 'f';
		default:
			return _Utils_ap(
				$truqu$elm_md5$MD5$toHex((_byte / 16) | 0),
				$truqu$elm_md5$MD5$toHex(_byte % 16));
	}
};
var $truqu$elm_md5$MD5$hex = function (s) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (b, acc) {
				return _Utils_ap(
					acc,
					A3(
						$elm$core$String$padLeft,
						2,
						'0',
						$truqu$elm_md5$MD5$toHex(b)));
			}),
		'',
		$truqu$elm_md5$MD5$bytes(s));
};
var $author$project$Util$Media$gravatar = F2(
	function (size, email) {
		return 'https://gravatar.com/avatar/' + ($truqu$elm_md5$MD5$hex(email) + ('?s=' + ($elm$core$String$fromInt(size) + '&d=retro')));
	});
var $author$project$Person$roleOperator = 'operator';
var $author$project$Person$isOperator = function (person) {
	return A2($author$project$Person$hasRole, $author$project$Person$roleOperator, person);
};
var $author$project$ACL$isOperator = $author$project$Person$isOperator;
var $author$project$ACL$isSponsor = $author$project$Person$isSponsor;
var $author$project$Element$Navbar$buildMenu = F2(
	function (viewer, language) {
		return _List_fromArray(
			[
				$author$project$Element$Navbar$NavSingle(
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$PhoneBook,
					{
						kJ: 'nav-phonebook',
						g$: $author$project$ACL$canViewPhonebook(viewer),
						lO: $author$project$Locale$Messages$NavPhoneBook,
						lY: $elm$core$Maybe$Nothing
					})),
				A2(
				$author$project$Element$Navbar$NavDropdown,
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$StudentList,
					{
						kJ: 'nav-students',
						g$: $author$project$ACL$canViewStudents(viewer),
						lO: $author$project$Locale$Messages$NavStudents,
						lY: $elm$core$Maybe$Nothing
					}),
				_List_fromArray(
					[
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$StudentList,
						{
							kJ: 'nav-students-list',
							g$: $author$project$ACL$canViewStudents(viewer),
							lO: $author$project$Locale$Messages$NavStudentsList,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$LearningGroupList,
						{
							kJ: 'nav-learninggroup-list',
							g$: $author$project$ACL$canViewLearningGroup(viewer),
							lO: $author$project$Locale$Messages$LearningGroupList,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$LearningContractsList,
						{
							kJ: 'nav-learningcontracts',
							g$: $author$project$ACL$canViewLearningContracts(viewer),
							lO: $author$project$Locale$Messages$NavLearningContracts,
							lY: $elm$core$Maybe$Nothing
						})
					])),
				A2(
				$author$project$Element$Navbar$NavDropdown,
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$ModulesList,
					{
						kJ: 'nav-modules',
						g$: $author$project$ACL$canViewModules(viewer),
						lO: $author$project$Locale$Messages$NavModules,
						lY: $elm$core$Maybe$Nothing
					}),
				_List_fromArray(
					[
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$ModulesList,
						{
							kJ: 'nav-modules-list',
							g$: $author$project$ACL$canViewModules(viewer),
							lO: $author$project$Locale$Messages$NavModulesList,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$ModulesCreate,
						{
							kJ: 'nav-modules-new',
							g$: $author$project$ACL$canManageModules(viewer),
							lO: $author$project$Locale$Messages$NavModulesNew,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$TimetableCalendar(_List_Nil),
						{
							kJ: 'nav-timetable',
							g$: $author$project$ACL$isStaff(viewer) || ($author$project$Person$isModuleTeacher(viewer) || $author$project$Person$isStudent(viewer)),
							lO: $author$project$Locale$Messages$NavTimetable,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$RubricsList,
						{
							kJ: 'nav-rubrics',
							g$: $author$project$ACL$canViewRubrics(viewer),
							lO: $author$project$Locale$Messages$RubricsTitle,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$LoBrowser,
						{
							kJ: 'nav-lolo',
							g$: $author$project$ACL$canViewLearningOutcomes(viewer),
							lO: $author$project$Locale$Messages$LoBrowserTitle,
							lY: $elm$core$Maybe$Nothing
						})
					])),
				A2(
				$author$project$Element$Navbar$NavDropdown,
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery),
					{
						kJ: 'nav-portfolios',
						g$: $author$project$ACL$canViewPortfolios(viewer),
						lO: $author$project$Locale$Messages$NavPortfolios,
						lY: $elm$core$Maybe$Nothing
					}),
				_List_fromArray(
					[
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery),
						{
							kJ: 'nav-portfolios-list',
							g$: $author$project$ACL$canViewPortfolios(viewer),
							lO: $author$project$Locale$Messages$NavPortfoliosList,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$PortfoliosCreate($elm$core$Maybe$Nothing),
						{
							kJ: 'nav-portfolios-new',
							g$: $author$project$ACL$canCreatePortfolios(viewer),
							lO: $author$project$Locale$Messages$NavPortfoliosNew,
							lY: $elm$core$Maybe$Nothing
						})
					])),
				A2(
				$author$project$Element$Navbar$NavDropdownRight,
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$GenericProfileUpdate(viewer.gT),
					{
						kJ: 'nav-profile',
						g$: $author$project$ACL$everyone,
						lO: A2($author$project$Locale$Messages$PersonFullName, viewer.k3, viewer.ak),
						lY: $elm$core$Maybe$Just(
							A2($author$project$Util$Media$gravatar, 48, viewer.K))
					}),
				_List_fromArray(
					[
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$GenericProfileUpdate(viewer.gT),
						{kJ: 'nav-profile-edit', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavProfile, lY: $elm$core$Maybe$Nothing}),
						_Utils_eq(language, $author$project$Locale$hungarian) ? A2(
						$author$project$Element$Navbar$ActionItem,
						$author$project$Element$Navbar$LanguageChanged($author$project$Locale$english),
						{kJ: 'nav-lang-en', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavLanguageEnglish, lY: $elm$core$Maybe$Nothing}) : A2(
						$author$project$Element$Navbar$ActionItem,
						$author$project$Element$Navbar$LanguageChanged($author$project$Locale$hungarian),
						{kJ: 'nav-lang-hu', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavLanguageHungarian, lY: $elm$core$Maybe$Nothing}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$NotificationList,
						{kJ: 'nav-notifications', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavNotifications, lY: $elm$core$Maybe$Nothing}),
						A2(
						$author$project$Element$Navbar$ActionItem,
						$author$project$Element$Navbar$AbsenceJustificationClicked,
						{
							kJ: 'nav-justify-absences',
							g$: $author$project$ACL$isSponsor(viewer),
							lO: $author$project$Locale$Messages$NavJustifyAbsences,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$UrlItem,
						'https://admin.budapestschool.org/admin/people/teammembership/',
						{
							kJ: 'nav-admin-team-membership',
							g$: $author$project$ACL$isOperator(viewer),
							lO: $author$project$Locale$Messages$NavAdminTeamMembership,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$UrlItem,
						'https://docs.google.com/forms/d/e/1FAIpQLSfXG2AmSdjbS2n69Fw_8jc2toU4pZO9vYJ017dvgdgeAdD7SA/viewform',
						{kJ: 'safeguarding', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavSafeguard, lY: $elm$core$Maybe$Nothing}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$Logout,
						{kJ: 'logout', g$: $author$project$ACL$everyone, lO: $author$project$Locale$Messages$NavLogout, lY: $elm$core$Maybe$Nothing})
					])),
				A2(
				$author$project$Element$Navbar$NavDropdown,
				A2(
					$author$project$Element$Navbar$RouteItem,
					$author$project$Route$GradesOverview($author$project$Route$blankGradesListQuery),
					{
						kJ: 'nav-overviews',
						g$: $author$project$ACL$canViewOverviews(viewer),
						lO: $author$project$Locale$Messages$NavOverviews,
						lY: $elm$core$Maybe$Nothing
					}),
				_List_fromArray(
					[
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$GradesOverview($author$project$Route$blankGradesListQuery),
						{kJ: 'nav-grades-overview', g$: false, lO: $author$project$Locale$Messages$NavGradesOverview, lY: $elm$core$Maybe$Nothing}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$RubricSubjectOverview($author$project$Route$blankLoStudentOverviewListQuery),
						{
							kJ: 'nav-rubric-subject-overview',
							g$: $author$project$ACL$canViewRubricSubjectOverview(viewer),
							lO: $author$project$Locale$Messages$NavRubricSubjectOverview,
							lY: $elm$core$Maybe$Nothing
						}),
						A2(
						$author$project$Element$Navbar$RouteItem,
						$author$project$Route$ModuleClosureOverview($author$project$Route$blankModuleClosureOverviewListQuery),
						{
							kJ: 'nav-mclosure-overview',
							g$: $author$project$ACL$canViewStudents(viewer) && $author$project$ACL$canViewPortfoliosSchool(viewer),
							lO: $author$project$Locale$Messages$NavModuleClosureOverview,
							lY: $elm$core$Maybe$Nothing
						})
					]))
			]);
	});
var $author$project$Application$Boundaries$save = F2(
	function (model, session) {
		return {dz: $elm$core$Platform$Cmd$none, dY: model, fY: $elm$core$Maybe$Nothing, cv: session};
	});
var $author$project$Element$Navbar$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			dP: false,
			dW: params.dW,
			eL: A2($author$project$Element$Navbar$buildMenu, session.nH, session.lP),
			cr: params.cr
		};
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$Navbar$LanguageSet = $elm$core$Basics$identity;
var $author$project$Locale$Messages$NavJustifyAbsencesMovedNotification = {$: 322};
var $author$project$Element$Navbar$NoOp = {$: 6};
var $author$project$Locale$Messages$UserSettingsSaveError = {$: 693};
var $author$project$Locale$Messages$UserSettingsSaveSuccess = {$: 692};
var $author$project$Element$Navbar$UserSettingsSaved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Application$Boundaries$andThenCmd = F2(
	function (cmd_, _return) {
		return _Utils_update(
			_return,
			{
				dz: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[_return.dz, cmd_]))
			});
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $author$project$Notification$add = F2(
	function (notification, notifications) {
		var nextId = $elm$core$Dict$size(notifications) + 1;
		return A3($elm$core$Dict$insert, nextId, notification, notifications);
	});
var $author$project$Notification$ErrorNotice = 0;
var $author$project$Notification$error = function (message) {
	return {cX: 0, cg: message};
};
var $author$project$Session$error = F3(
	function (session, _v0, message) {
		var notification = $author$project$Notification$error(message);
		return _Utils_update(
			session,
			{
				fM: A2($author$project$Notification$add, notification, session.fM)
			});
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $elm$browser$Browser$Dom$blur = _Browser_call('blur');
var $author$project$Element$Navbar$hideNavItem = function (itemId) {
	return A2(
		$elm$core$Task$attempt,
		$elm$core$Basics$always($author$project$Element$Navbar$NoOp),
		$elm$browser$Browser$Dom$blur(itemId));
};
var $author$project$Log$msgUserSettings = 'user_settings';
var $author$project$Notification$SuccessNotice = 1;
var $author$project$Notification$ok = function (message) {
	return {cX: 1, cg: message};
};
var $author$project$Session$ok = F2(
	function (session, message) {
		var notification = $author$project$Notification$ok(message);
		return _Utils_update(
			session,
			{
				fM: A2($author$project$Notification$add, notification, session.fM)
			});
	});
var $author$project$Application$Boundaries$reply = F2(
	function (cmd, prev) {
		return _Utils_update(
			prev,
			{
				fY: $elm$core$Maybe$Just(cmd)
			});
	});
var $author$project$Api$put = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				O: body,
				a4: A2($author$project$Api$expectJson, toMsg, decoder),
				ah: $author$project$Api$toHeaders(config),
				ba: 'PUT',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$Api$Endpoint$userSettings = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'user-settings',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $elm$json$Json$Encode$int = _Json_wrap;
var $author$project$UserSettings$userSettingsEncoder = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(settings.gT)),
				_Utils_Tuple2(
				'language',
				$elm$json$Json$Encode$string(settings.lP.kz))
			]));
};
var $author$project$UserSettings$saveSettings = F3(
	function (config, settings, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$userSettings, config, settings.gT),
			config,
			$elm$http$Http$jsonBody(
				$author$project$UserSettings$userSettingsEncoder(settings)),
			callback,
			$author$project$UserSettings$userSettingsDecoder);
	});
var $author$project$Ports$setPageLanguage = _Platform_outgoingPort('setPageLanguage', $elm$json$Json$Encode$string);
var $author$project$Session$updateLanguage = F2(
	function (lang, session) {
		var viewer = session.nH;
		var settings = viewer.m$;
		return _Utils_update(
			session,
			{
				lP: lang,
				hy: lang.hy,
				nH: _Utils_update(
					viewer,
					{
						m$: _Utils_update(
							settings,
							{lP: lang})
					})
			});
	});
var $author$project$Element$Navbar$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		switch (msg.$) {
			case 0:
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{dP: !model.dP}),
					session);
			case 2:
				var itemId = msg.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$Navbar$hideNavItem(itemId),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var route = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{dP: false, cr: route}),
					session);
			case 4:
				var session2 = A2(
					$author$project$Session$ok,
					session,
					t_($author$project$Locale$Messages$NavJustifyAbsencesMovedNotification));
				return A2($author$project$Application$Boundaries$save, model, session2);
			case 3:
				var lang = msg.a;
				var session2 = A2($author$project$Session$updateLanguage, lang, session);
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Ports$setPageLanguage(lang.kz),
					A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3($author$project$UserSettings$saveSettings, model.bN.gr, session2.nH.m$, $author$project$Element$Navbar$UserSettingsSaved),
						A2($author$project$Application$Boundaries$save, model, session2)));
			case 5:
				if (!msg.a.$) {
					var settings = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$reply,
						settings.lP,
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A2(
								$author$project$Session$ok,
								session,
								t_($author$project$Locale$Messages$UserSettingsSaveSuccess))));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3($author$project$Log$msgUserSettings, $elm$core$Maybe$Nothing, error),
							$elm$core$Basics$always($author$project$Element$Navbar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$UserSettingsSaveError))));
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$Navbar$BurgerToggled = {$: 0};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$UI$attrCyData = $elm$html$Html$Attributes$attribute('data-cy');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Route$href = function (targetRoute) {
	return $elm$html$Html$Attributes$href(
		$author$project$Route$toString(targetRoute));
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$nav = _VirtualDom_node('nav');
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$span = _VirtualDom_node('span');
var $author$project$Element$Navbar$navBurger = F2(
	function (target, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-expanded', 'false'),
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'menu'),
					$elm$html$Html$Attributes$class('navbar-burger burger'),
					A2($elm$html$Html$Attributes$attribute, 'data-target', target),
					A2($elm$html$Html$Attributes$attribute, 'role', 'button'),
					$author$project$UI$attrCyData('burger'),
					$elm$html$Html$Events$onClick(toMsg)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true')
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$Navbar$isParent = F3(
	function (menu, child, parent) {
		var isChild = function (navItem) {
			switch (navItem.$) {
				case 0:
					var route = navItem.a;
					return _Utils_eq(route, child);
				case 1:
					return false;
				default:
					return false;
			}
		};
		var anyIsChild = function (children) {
			return A2($elm$core$List$any, isChild, children);
		};
		var routeIsParentAndChildIsAmongChildren = F2(
			function (route, children) {
				return _Utils_eq(route, parent) && anyIsChild(children);
			});
		return A2(
			$elm$core$List$any,
			function (navItem) {
				switch (navItem.$) {
					case 0:
						return false;
					case 1:
						var navGenericItem = navItem.a;
						var children = navItem.b;
						switch (navGenericItem.$) {
							case 0:
								var route = navGenericItem.a;
								return A2(routeIsParentAndChildIsAmongChildren, route, children);
							case 1:
								return false;
							default:
								return false;
						}
					default:
						var navGenericItem = navItem.a;
						var children = navItem.b;
						switch (navGenericItem.$) {
							case 0:
								var route = navGenericItem.a;
								return A2(routeIsParentAndChildIsAmongChildren, route, children);
							case 1:
								return false;
							default:
								return false;
						}
				}
			},
			menu);
	});
var $author$project$Element$Navbar$NavItemClicked = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$UI$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$UI$actionLink = F3(
	function (msg, attrs, content) {
		return A2(
			$elm$html$Html$a,
			_Utils_ap(
				_List_fromArray(
					[
						$elm$html$Html$Attributes$target('_self'),
						$author$project$UI$onClickPreventDefault(msg)
					]),
				attrs),
			content);
	});
var $author$project$Route$isActivePage = F2(
	function (current, target) {
		return _Utils_eq(current, target);
	});
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $hecrj$html_parser$Html$Parser$Element = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$backtrackable = $elm$parser$Parser$Advanced$backtrackable;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {kA: col, kE: contextStack, mB: problem, mR: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.mR, s.kA, x, s.l));
	});
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.f, s.e);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{kA: 1, l: s.l, p: s.p, f: s.f + 1, mR: s.mR + 1, e: s.e}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{kA: s.kA + 1, l: s.l, p: s.p, f: newOffset, mR: s.mR, e: s.e}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.e);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.f, offset) < 0,
					0,
					{kA: col, l: s0.l, p: s0.p, f: offset, mR: row, e: s0.e});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.f, s.mR, s.kA, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $hecrj$html_parser$Html$Parser$chompOneOrMore = function (fn) {
	return A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$chompIf(fn),
		$elm$parser$Parser$chompWhile(fn));
};
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.f, s1.f, s0.e),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $hecrj$html_parser$Html$Parser$isSpaceCharacter = function (c) {
	return (c === ' ') || ((c === '\t') || ((c === '\n') || ((c === '\u000D') || ((c === '\u000C') || (c === '\u00A0')))));
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $hecrj$html_parser$Html$Parser$closingTag = function (name) {
	var chompName = A2(
		$elm$parser$Parser$andThen,
		function (closingName) {
			return _Utils_eq(
				$elm$core$String$toLower(closingName),
				name) ? $elm$parser$Parser$succeed(0) : $elm$parser$Parser$problem('closing tag does not match opening tag: ' + name);
		},
		$elm$parser$Parser$getChompedString(
			$hecrj$html_parser$Html$Parser$chompOneOrMore(
				function (c) {
					return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && (c !== '>');
				})));
	return A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<')),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('/'))),
				chompName),
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('>')));
};
var $hecrj$html_parser$Html$Parser$Comment = function (a) {
	return {$: 2, a: a};
};
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.f, s.mR, s.kA, s.e);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.l)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.f, newOffset) < 0,
			0,
			{kA: newCol, l: s.l, p: s.p, f: newOffset, mR: newRow, e: s.e});
	};
};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $elm$parser$Parser$chompUntil = function (str) {
	return $elm$parser$Parser$Advanced$chompUntil(
		$elm$parser$Parser$toToken(str));
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.f, s.mR, s.kA, s.e);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{kA: newCol, l: s.l, p: s.p, f: newOffset, mR: newRow, e: s.e});
	};
};
var $elm$parser$Parser$token = function (str) {
	return $elm$parser$Parser$Advanced$token(
		$elm$parser$Parser$toToken(str));
};
var $hecrj$html_parser$Html$Parser$commentString = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$token('<!')),
		$elm$parser$Parser$token('--')),
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$getChompedString(
			$elm$parser$Parser$chompUntil('-->')),
		$elm$parser$Parser$token('-->')));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $hecrj$html_parser$Html$Parser$comment = A2($elm$parser$Parser$map, $hecrj$html_parser$Html$Parser$Comment, $hecrj$html_parser$Html$Parser$commentString);
var $hecrj$html_parser$Html$Parser$voidElements = _List_fromArray(
	['area', 'base', 'br', 'col', 'embed', 'hr', 'img', 'input', 'link', 'meta', 'param', 'source', 'track', 'wbr']);
var $hecrj$html_parser$Html$Parser$isVoidElement = function (name) {
	return A2($elm$core$List$member, name, $hecrj$html_parser$Html$Parser$voidElements);
};
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $hecrj$html_parser$Html$Parser$many = function (parser_) {
	return A2(
		$elm$parser$Parser$loop,
		_List_Nil,
		function (list) {
			return $elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$map,
						function (_new) {
							return $elm$parser$Parser$Loop(
								A2($elm$core$List$cons, _new, list));
						},
						parser_),
						$elm$parser$Parser$succeed(
						$elm$parser$Parser$Done(
							$elm$core$List$reverse(list)))
					]));
		});
};
var $hecrj$html_parser$Html$Parser$isTagAttributeCharacter = function (c) {
	return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '>') && ((c !== '/') && (c !== '=')))));
};
var $hecrj$html_parser$Html$Parser$tagAttributeName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($hecrj$html_parser$Html$Parser$isTagAttributeCharacter)));
var $hecrj$html_parser$Html$Parser$chompSemicolon = $elm$parser$Parser$chompIf(
	$elm$core$Basics$eq(';'));
var $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('Aacute', 'Á'),
			_Utils_Tuple2('aacute', 'á'),
			_Utils_Tuple2('Abreve', 'Ă'),
			_Utils_Tuple2('abreve', 'ă'),
			_Utils_Tuple2('ac', '∾'),
			_Utils_Tuple2('acd', '∿'),
			_Utils_Tuple2('acE', '∾̳'),
			_Utils_Tuple2('Acirc', 'Â'),
			_Utils_Tuple2('acirc', 'â'),
			_Utils_Tuple2('acute', '´'),
			_Utils_Tuple2('Acy', 'А'),
			_Utils_Tuple2('acy', 'а'),
			_Utils_Tuple2('AElig', 'Æ'),
			_Utils_Tuple2('aelig', 'æ'),
			_Utils_Tuple2('af', '\u2061'),
			_Utils_Tuple2('Afr', '\uD835\uDD04'),
			_Utils_Tuple2('afr', '\uD835\uDD1E'),
			_Utils_Tuple2('Agrave', 'À'),
			_Utils_Tuple2('agrave', 'à'),
			_Utils_Tuple2('alefsym', 'ℵ'),
			_Utils_Tuple2('aleph', 'ℵ'),
			_Utils_Tuple2('Alpha', 'Α'),
			_Utils_Tuple2('alpha', 'α'),
			_Utils_Tuple2('Amacr', 'Ā'),
			_Utils_Tuple2('amacr', 'ā'),
			_Utils_Tuple2('amalg', '⨿'),
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('AMP', '&'),
			_Utils_Tuple2('andand', '⩕'),
			_Utils_Tuple2('And', '⩓'),
			_Utils_Tuple2('and', '∧'),
			_Utils_Tuple2('andd', '⩜'),
			_Utils_Tuple2('andslope', '⩘'),
			_Utils_Tuple2('andv', '⩚'),
			_Utils_Tuple2('ang', '∠'),
			_Utils_Tuple2('ange', '⦤'),
			_Utils_Tuple2('angle', '∠'),
			_Utils_Tuple2('angmsdaa', '⦨'),
			_Utils_Tuple2('angmsdab', '⦩'),
			_Utils_Tuple2('angmsdac', '⦪'),
			_Utils_Tuple2('angmsdad', '⦫'),
			_Utils_Tuple2('angmsdae', '⦬'),
			_Utils_Tuple2('angmsdaf', '⦭'),
			_Utils_Tuple2('angmsdag', '⦮'),
			_Utils_Tuple2('angmsdah', '⦯'),
			_Utils_Tuple2('angmsd', '∡'),
			_Utils_Tuple2('angrt', '∟'),
			_Utils_Tuple2('angrtvb', '⊾'),
			_Utils_Tuple2('angrtvbd', '⦝'),
			_Utils_Tuple2('angsph', '∢'),
			_Utils_Tuple2('angst', 'Å'),
			_Utils_Tuple2('angzarr', '⍼'),
			_Utils_Tuple2('Aogon', 'Ą'),
			_Utils_Tuple2('aogon', 'ą'),
			_Utils_Tuple2('Aopf', '\uD835\uDD38'),
			_Utils_Tuple2('aopf', '\uD835\uDD52'),
			_Utils_Tuple2('apacir', '⩯'),
			_Utils_Tuple2('ap', '≈'),
			_Utils_Tuple2('apE', '⩰'),
			_Utils_Tuple2('ape', '≊'),
			_Utils_Tuple2('apid', '≋'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('ApplyFunction', '\u2061'),
			_Utils_Tuple2('approx', '≈'),
			_Utils_Tuple2('approxeq', '≊'),
			_Utils_Tuple2('Aring', 'Å'),
			_Utils_Tuple2('aring', 'å'),
			_Utils_Tuple2('Ascr', '\uD835\uDC9C'),
			_Utils_Tuple2('ascr', '\uD835\uDCB6'),
			_Utils_Tuple2('Assign', '≔'),
			_Utils_Tuple2('ast', '*'),
			_Utils_Tuple2('asymp', '≈'),
			_Utils_Tuple2('asympeq', '≍'),
			_Utils_Tuple2('Atilde', 'Ã'),
			_Utils_Tuple2('atilde', 'ã'),
			_Utils_Tuple2('Auml', 'Ä'),
			_Utils_Tuple2('auml', 'ä'),
			_Utils_Tuple2('awconint', '∳'),
			_Utils_Tuple2('awint', '⨑'),
			_Utils_Tuple2('backcong', '≌'),
			_Utils_Tuple2('backepsilon', '϶'),
			_Utils_Tuple2('backprime', '‵'),
			_Utils_Tuple2('backsim', '∽'),
			_Utils_Tuple2('backsimeq', '⋍'),
			_Utils_Tuple2('Backslash', '∖'),
			_Utils_Tuple2('Barv', '⫧'),
			_Utils_Tuple2('barvee', '⊽'),
			_Utils_Tuple2('barwed', '⌅'),
			_Utils_Tuple2('Barwed', '⌆'),
			_Utils_Tuple2('barwedge', '⌅'),
			_Utils_Tuple2('bbrk', '⎵'),
			_Utils_Tuple2('bbrktbrk', '⎶'),
			_Utils_Tuple2('bcong', '≌'),
			_Utils_Tuple2('Bcy', 'Б'),
			_Utils_Tuple2('bcy', 'б'),
			_Utils_Tuple2('bdquo', '„'),
			_Utils_Tuple2('becaus', '∵'),
			_Utils_Tuple2('because', '∵'),
			_Utils_Tuple2('Because', '∵'),
			_Utils_Tuple2('bemptyv', '⦰'),
			_Utils_Tuple2('bepsi', '϶'),
			_Utils_Tuple2('bernou', 'ℬ'),
			_Utils_Tuple2('Bernoullis', 'ℬ'),
			_Utils_Tuple2('Beta', 'Β'),
			_Utils_Tuple2('beta', 'β'),
			_Utils_Tuple2('beth', 'ℶ'),
			_Utils_Tuple2('between', '≬'),
			_Utils_Tuple2('Bfr', '\uD835\uDD05'),
			_Utils_Tuple2('bfr', '\uD835\uDD1F'),
			_Utils_Tuple2('bigcap', '⋂'),
			_Utils_Tuple2('bigcirc', '◯'),
			_Utils_Tuple2('bigcup', '⋃'),
			_Utils_Tuple2('bigodot', '⨀'),
			_Utils_Tuple2('bigoplus', '⨁'),
			_Utils_Tuple2('bigotimes', '⨂'),
			_Utils_Tuple2('bigsqcup', '⨆'),
			_Utils_Tuple2('bigstar', '★'),
			_Utils_Tuple2('bigtriangledown', '▽'),
			_Utils_Tuple2('bigtriangleup', '△'),
			_Utils_Tuple2('biguplus', '⨄'),
			_Utils_Tuple2('bigvee', '⋁'),
			_Utils_Tuple2('bigwedge', '⋀'),
			_Utils_Tuple2('bkarow', '⤍'),
			_Utils_Tuple2('blacklozenge', '⧫'),
			_Utils_Tuple2('blacksquare', '▪'),
			_Utils_Tuple2('blacktriangle', '▴'),
			_Utils_Tuple2('blacktriangledown', '▾'),
			_Utils_Tuple2('blacktriangleleft', '◂'),
			_Utils_Tuple2('blacktriangleright', '▸'),
			_Utils_Tuple2('blank', '␣'),
			_Utils_Tuple2('blk12', '▒'),
			_Utils_Tuple2('blk14', '░'),
			_Utils_Tuple2('blk34', '▓'),
			_Utils_Tuple2('block', '█'),
			_Utils_Tuple2('bne', '=⃥'),
			_Utils_Tuple2('bnequiv', '≡⃥'),
			_Utils_Tuple2('bNot', '⫭'),
			_Utils_Tuple2('bnot', '⌐'),
			_Utils_Tuple2('Bopf', '\uD835\uDD39'),
			_Utils_Tuple2('bopf', '\uD835\uDD53'),
			_Utils_Tuple2('bot', '⊥'),
			_Utils_Tuple2('bottom', '⊥'),
			_Utils_Tuple2('bowtie', '⋈'),
			_Utils_Tuple2('boxbox', '⧉'),
			_Utils_Tuple2('boxdl', '┐'),
			_Utils_Tuple2('boxdL', '╕'),
			_Utils_Tuple2('boxDl', '╖'),
			_Utils_Tuple2('boxDL', '╗'),
			_Utils_Tuple2('boxdr', '┌'),
			_Utils_Tuple2('boxdR', '╒'),
			_Utils_Tuple2('boxDr', '╓'),
			_Utils_Tuple2('boxDR', '╔'),
			_Utils_Tuple2('boxh', '─'),
			_Utils_Tuple2('boxH', '═'),
			_Utils_Tuple2('boxhd', '┬'),
			_Utils_Tuple2('boxHd', '╤'),
			_Utils_Tuple2('boxhD', '╥'),
			_Utils_Tuple2('boxHD', '╦'),
			_Utils_Tuple2('boxhu', '┴'),
			_Utils_Tuple2('boxHu', '╧'),
			_Utils_Tuple2('boxhU', '╨'),
			_Utils_Tuple2('boxHU', '╩'),
			_Utils_Tuple2('boxminus', '⊟'),
			_Utils_Tuple2('boxplus', '⊞'),
			_Utils_Tuple2('boxtimes', '⊠'),
			_Utils_Tuple2('boxul', '┘'),
			_Utils_Tuple2('boxuL', '╛'),
			_Utils_Tuple2('boxUl', '╜'),
			_Utils_Tuple2('boxUL', '╝'),
			_Utils_Tuple2('boxur', '└'),
			_Utils_Tuple2('boxuR', '╘'),
			_Utils_Tuple2('boxUr', '╙'),
			_Utils_Tuple2('boxUR', '╚'),
			_Utils_Tuple2('boxv', '│'),
			_Utils_Tuple2('boxV', '║'),
			_Utils_Tuple2('boxvh', '┼'),
			_Utils_Tuple2('boxvH', '╪'),
			_Utils_Tuple2('boxVh', '╫'),
			_Utils_Tuple2('boxVH', '╬'),
			_Utils_Tuple2('boxvl', '┤'),
			_Utils_Tuple2('boxvL', '╡'),
			_Utils_Tuple2('boxVl', '╢'),
			_Utils_Tuple2('boxVL', '╣'),
			_Utils_Tuple2('boxvr', '├'),
			_Utils_Tuple2('boxvR', '╞'),
			_Utils_Tuple2('boxVr', '╟'),
			_Utils_Tuple2('boxVR', '╠'),
			_Utils_Tuple2('bprime', '‵'),
			_Utils_Tuple2('breve', '˘'),
			_Utils_Tuple2('Breve', '˘'),
			_Utils_Tuple2('brvbar', '¦'),
			_Utils_Tuple2('bscr', '\uD835\uDCB7'),
			_Utils_Tuple2('Bscr', 'ℬ'),
			_Utils_Tuple2('bsemi', '⁏'),
			_Utils_Tuple2('bsim', '∽'),
			_Utils_Tuple2('bsime', '⋍'),
			_Utils_Tuple2('bsolb', '⧅'),
			_Utils_Tuple2('bsol', '\\'),
			_Utils_Tuple2('bsolhsub', '⟈'),
			_Utils_Tuple2('bull', '•'),
			_Utils_Tuple2('bullet', '•'),
			_Utils_Tuple2('bump', '≎'),
			_Utils_Tuple2('bumpE', '⪮'),
			_Utils_Tuple2('bumpe', '≏'),
			_Utils_Tuple2('Bumpeq', '≎'),
			_Utils_Tuple2('bumpeq', '≏'),
			_Utils_Tuple2('Cacute', 'Ć'),
			_Utils_Tuple2('cacute', 'ć'),
			_Utils_Tuple2('capand', '⩄'),
			_Utils_Tuple2('capbrcup', '⩉'),
			_Utils_Tuple2('capcap', '⩋'),
			_Utils_Tuple2('cap', '∩'),
			_Utils_Tuple2('Cap', '⋒'),
			_Utils_Tuple2('capcup', '⩇'),
			_Utils_Tuple2('capdot', '⩀'),
			_Utils_Tuple2('CapitalDifferentialD', 'ⅅ'),
			_Utils_Tuple2('caps', '∩︀'),
			_Utils_Tuple2('caret', '⁁'),
			_Utils_Tuple2('caron', 'ˇ'),
			_Utils_Tuple2('Cayleys', 'ℭ'),
			_Utils_Tuple2('ccaps', '⩍'),
			_Utils_Tuple2('Ccaron', 'Č'),
			_Utils_Tuple2('ccaron', 'č'),
			_Utils_Tuple2('Ccedil', 'Ç'),
			_Utils_Tuple2('ccedil', 'ç'),
			_Utils_Tuple2('Ccirc', 'Ĉ'),
			_Utils_Tuple2('ccirc', 'ĉ'),
			_Utils_Tuple2('Cconint', '∰'),
			_Utils_Tuple2('ccups', '⩌'),
			_Utils_Tuple2('ccupssm', '⩐'),
			_Utils_Tuple2('Cdot', 'Ċ'),
			_Utils_Tuple2('cdot', 'ċ'),
			_Utils_Tuple2('cedil', '¸'),
			_Utils_Tuple2('Cedilla', '¸'),
			_Utils_Tuple2('cemptyv', '⦲'),
			_Utils_Tuple2('cent', '¢'),
			_Utils_Tuple2('centerdot', '·'),
			_Utils_Tuple2('CenterDot', '·'),
			_Utils_Tuple2('cfr', '\uD835\uDD20'),
			_Utils_Tuple2('Cfr', 'ℭ'),
			_Utils_Tuple2('CHcy', 'Ч'),
			_Utils_Tuple2('chcy', 'ч'),
			_Utils_Tuple2('check', '✓'),
			_Utils_Tuple2('checkmark', '✓'),
			_Utils_Tuple2('Chi', 'Χ'),
			_Utils_Tuple2('chi', 'χ'),
			_Utils_Tuple2('circ', 'ˆ'),
			_Utils_Tuple2('circeq', '≗'),
			_Utils_Tuple2('circlearrowleft', '↺'),
			_Utils_Tuple2('circlearrowright', '↻'),
			_Utils_Tuple2('circledast', '⊛'),
			_Utils_Tuple2('circledcirc', '⊚'),
			_Utils_Tuple2('circleddash', '⊝'),
			_Utils_Tuple2('CircleDot', '⊙'),
			_Utils_Tuple2('circledR', '®'),
			_Utils_Tuple2('circledS', 'Ⓢ'),
			_Utils_Tuple2('CircleMinus', '⊖'),
			_Utils_Tuple2('CirclePlus', '⊕'),
			_Utils_Tuple2('CircleTimes', '⊗'),
			_Utils_Tuple2('cir', '○'),
			_Utils_Tuple2('cirE', '⧃'),
			_Utils_Tuple2('cire', '≗'),
			_Utils_Tuple2('cirfnint', '⨐'),
			_Utils_Tuple2('cirmid', '⫯'),
			_Utils_Tuple2('cirscir', '⧂'),
			_Utils_Tuple2('ClockwiseContourIntegral', '∲'),
			_Utils_Tuple2('CloseCurlyDoubleQuote', '”'),
			_Utils_Tuple2('CloseCurlyQuote', '’'),
			_Utils_Tuple2('clubs', '♣'),
			_Utils_Tuple2('clubsuit', '♣'),
			_Utils_Tuple2('colon', ':'),
			_Utils_Tuple2('Colon', '∷'),
			_Utils_Tuple2('Colone', '⩴'),
			_Utils_Tuple2('colone', '≔'),
			_Utils_Tuple2('coloneq', '≔'),
			_Utils_Tuple2('comma', ','),
			_Utils_Tuple2('commat', '@'),
			_Utils_Tuple2('comp', '∁'),
			_Utils_Tuple2('compfn', '∘'),
			_Utils_Tuple2('complement', '∁'),
			_Utils_Tuple2('complexes', 'ℂ'),
			_Utils_Tuple2('cong', '≅'),
			_Utils_Tuple2('congdot', '⩭'),
			_Utils_Tuple2('Congruent', '≡'),
			_Utils_Tuple2('conint', '∮'),
			_Utils_Tuple2('Conint', '∯'),
			_Utils_Tuple2('ContourIntegral', '∮'),
			_Utils_Tuple2('copf', '\uD835\uDD54'),
			_Utils_Tuple2('Copf', 'ℂ'),
			_Utils_Tuple2('coprod', '∐'),
			_Utils_Tuple2('Coproduct', '∐'),
			_Utils_Tuple2('copy', '©'),
			_Utils_Tuple2('COPY', '©'),
			_Utils_Tuple2('copysr', '℗'),
			_Utils_Tuple2('CounterClockwiseContourIntegral', '∳'),
			_Utils_Tuple2('crarr', '↵'),
			_Utils_Tuple2('cross', '✗'),
			_Utils_Tuple2('Cross', '⨯'),
			_Utils_Tuple2('Cscr', '\uD835\uDC9E'),
			_Utils_Tuple2('cscr', '\uD835\uDCB8'),
			_Utils_Tuple2('csub', '⫏'),
			_Utils_Tuple2('csube', '⫑'),
			_Utils_Tuple2('csup', '⫐'),
			_Utils_Tuple2('csupe', '⫒'),
			_Utils_Tuple2('ctdot', '⋯'),
			_Utils_Tuple2('cudarrl', '⤸'),
			_Utils_Tuple2('cudarrr', '⤵'),
			_Utils_Tuple2('cuepr', '⋞'),
			_Utils_Tuple2('cuesc', '⋟'),
			_Utils_Tuple2('cularr', '↶'),
			_Utils_Tuple2('cularrp', '⤽'),
			_Utils_Tuple2('cupbrcap', '⩈'),
			_Utils_Tuple2('cupcap', '⩆'),
			_Utils_Tuple2('CupCap', '≍'),
			_Utils_Tuple2('cup', '∪'),
			_Utils_Tuple2('Cup', '⋓'),
			_Utils_Tuple2('cupcup', '⩊'),
			_Utils_Tuple2('cupdot', '⊍'),
			_Utils_Tuple2('cupor', '⩅'),
			_Utils_Tuple2('cups', '∪︀'),
			_Utils_Tuple2('curarr', '↷'),
			_Utils_Tuple2('curarrm', '⤼'),
			_Utils_Tuple2('curlyeqprec', '⋞'),
			_Utils_Tuple2('curlyeqsucc', '⋟'),
			_Utils_Tuple2('curlyvee', '⋎'),
			_Utils_Tuple2('curlywedge', '⋏'),
			_Utils_Tuple2('curren', '¤'),
			_Utils_Tuple2('curvearrowleft', '↶'),
			_Utils_Tuple2('curvearrowright', '↷'),
			_Utils_Tuple2('cuvee', '⋎'),
			_Utils_Tuple2('cuwed', '⋏'),
			_Utils_Tuple2('cwconint', '∲'),
			_Utils_Tuple2('cwint', '∱'),
			_Utils_Tuple2('cylcty', '⌭'),
			_Utils_Tuple2('dagger', '†'),
			_Utils_Tuple2('Dagger', '‡'),
			_Utils_Tuple2('daleth', 'ℸ'),
			_Utils_Tuple2('darr', '↓'),
			_Utils_Tuple2('Darr', '↡'),
			_Utils_Tuple2('dArr', '⇓'),
			_Utils_Tuple2('dash', '‐'),
			_Utils_Tuple2('Dashv', '⫤'),
			_Utils_Tuple2('dashv', '⊣'),
			_Utils_Tuple2('dbkarow', '⤏'),
			_Utils_Tuple2('dblac', '˝'),
			_Utils_Tuple2('Dcaron', 'Ď'),
			_Utils_Tuple2('dcaron', 'ď'),
			_Utils_Tuple2('Dcy', 'Д'),
			_Utils_Tuple2('dcy', 'д'),
			_Utils_Tuple2('ddagger', '‡'),
			_Utils_Tuple2('ddarr', '⇊'),
			_Utils_Tuple2('DD', 'ⅅ'),
			_Utils_Tuple2('dd', 'ⅆ'),
			_Utils_Tuple2('DDotrahd', '⤑'),
			_Utils_Tuple2('ddotseq', '⩷'),
			_Utils_Tuple2('deg', '°'),
			_Utils_Tuple2('Del', '∇'),
			_Utils_Tuple2('Delta', 'Δ'),
			_Utils_Tuple2('delta', 'δ'),
			_Utils_Tuple2('demptyv', '⦱'),
			_Utils_Tuple2('dfisht', '⥿'),
			_Utils_Tuple2('Dfr', '\uD835\uDD07'),
			_Utils_Tuple2('dfr', '\uD835\uDD21'),
			_Utils_Tuple2('dHar', '⥥'),
			_Utils_Tuple2('dharl', '⇃'),
			_Utils_Tuple2('dharr', '⇂'),
			_Utils_Tuple2('DiacriticalAcute', '´'),
			_Utils_Tuple2('DiacriticalDot', '˙'),
			_Utils_Tuple2('DiacriticalDoubleAcute', '˝'),
			_Utils_Tuple2('DiacriticalGrave', '`'),
			_Utils_Tuple2('DiacriticalTilde', '˜'),
			_Utils_Tuple2('diam', '⋄'),
			_Utils_Tuple2('diamond', '⋄'),
			_Utils_Tuple2('Diamond', '⋄'),
			_Utils_Tuple2('diamondsuit', '♦'),
			_Utils_Tuple2('diams', '♦'),
			_Utils_Tuple2('die', '¨'),
			_Utils_Tuple2('DifferentialD', 'ⅆ'),
			_Utils_Tuple2('digamma', 'ϝ'),
			_Utils_Tuple2('disin', '⋲'),
			_Utils_Tuple2('div', '÷'),
			_Utils_Tuple2('divide', '÷'),
			_Utils_Tuple2('divideontimes', '⋇'),
			_Utils_Tuple2('divonx', '⋇'),
			_Utils_Tuple2('DJcy', 'Ђ'),
			_Utils_Tuple2('djcy', 'ђ'),
			_Utils_Tuple2('dlcorn', '⌞'),
			_Utils_Tuple2('dlcrop', '⌍'),
			_Utils_Tuple2('dollar', '$'),
			_Utils_Tuple2('Dopf', '\uD835\uDD3B'),
			_Utils_Tuple2('dopf', '\uD835\uDD55'),
			_Utils_Tuple2('Dot', '¨'),
			_Utils_Tuple2('dot', '˙'),
			_Utils_Tuple2('DotDot', '⃜'),
			_Utils_Tuple2('doteq', '≐'),
			_Utils_Tuple2('doteqdot', '≑'),
			_Utils_Tuple2('DotEqual', '≐'),
			_Utils_Tuple2('dotminus', '∸'),
			_Utils_Tuple2('dotplus', '∔'),
			_Utils_Tuple2('dotsquare', '⊡'),
			_Utils_Tuple2('doublebarwedge', '⌆'),
			_Utils_Tuple2('DoubleContourIntegral', '∯'),
			_Utils_Tuple2('DoubleDot', '¨'),
			_Utils_Tuple2('DoubleDownArrow', '⇓'),
			_Utils_Tuple2('DoubleLeftArrow', '⇐'),
			_Utils_Tuple2('DoubleLeftRightArrow', '⇔'),
			_Utils_Tuple2('DoubleLeftTee', '⫤'),
			_Utils_Tuple2('DoubleLongLeftArrow', '⟸'),
			_Utils_Tuple2('DoubleLongLeftRightArrow', '⟺'),
			_Utils_Tuple2('DoubleLongRightArrow', '⟹'),
			_Utils_Tuple2('DoubleRightArrow', '⇒'),
			_Utils_Tuple2('DoubleRightTee', '⊨'),
			_Utils_Tuple2('DoubleUpArrow', '⇑'),
			_Utils_Tuple2('DoubleUpDownArrow', '⇕'),
			_Utils_Tuple2('DoubleVerticalBar', '∥'),
			_Utils_Tuple2('DownArrowBar', '⤓'),
			_Utils_Tuple2('downarrow', '↓'),
			_Utils_Tuple2('DownArrow', '↓'),
			_Utils_Tuple2('Downarrow', '⇓'),
			_Utils_Tuple2('DownArrowUpArrow', '⇵'),
			_Utils_Tuple2('DownBreve', '̑'),
			_Utils_Tuple2('downdownarrows', '⇊'),
			_Utils_Tuple2('downharpoonleft', '⇃'),
			_Utils_Tuple2('downharpoonright', '⇂'),
			_Utils_Tuple2('DownLeftRightVector', '⥐'),
			_Utils_Tuple2('DownLeftTeeVector', '⥞'),
			_Utils_Tuple2('DownLeftVectorBar', '⥖'),
			_Utils_Tuple2('DownLeftVector', '↽'),
			_Utils_Tuple2('DownRightTeeVector', '⥟'),
			_Utils_Tuple2('DownRightVectorBar', '⥗'),
			_Utils_Tuple2('DownRightVector', '⇁'),
			_Utils_Tuple2('DownTeeArrow', '↧'),
			_Utils_Tuple2('DownTee', '⊤'),
			_Utils_Tuple2('drbkarow', '⤐'),
			_Utils_Tuple2('drcorn', '⌟'),
			_Utils_Tuple2('drcrop', '⌌'),
			_Utils_Tuple2('Dscr', '\uD835\uDC9F'),
			_Utils_Tuple2('dscr', '\uD835\uDCB9'),
			_Utils_Tuple2('DScy', 'Ѕ'),
			_Utils_Tuple2('dscy', 'ѕ'),
			_Utils_Tuple2('dsol', '⧶'),
			_Utils_Tuple2('Dstrok', 'Đ'),
			_Utils_Tuple2('dstrok', 'đ'),
			_Utils_Tuple2('dtdot', '⋱'),
			_Utils_Tuple2('dtri', '▿'),
			_Utils_Tuple2('dtrif', '▾'),
			_Utils_Tuple2('duarr', '⇵'),
			_Utils_Tuple2('duhar', '⥯'),
			_Utils_Tuple2('dwangle', '⦦'),
			_Utils_Tuple2('DZcy', 'Џ'),
			_Utils_Tuple2('dzcy', 'џ'),
			_Utils_Tuple2('dzigrarr', '⟿'),
			_Utils_Tuple2('Eacute', 'É'),
			_Utils_Tuple2('eacute', 'é'),
			_Utils_Tuple2('easter', '⩮'),
			_Utils_Tuple2('Ecaron', 'Ě'),
			_Utils_Tuple2('ecaron', 'ě'),
			_Utils_Tuple2('Ecirc', 'Ê'),
			_Utils_Tuple2('ecirc', 'ê'),
			_Utils_Tuple2('ecir', '≖'),
			_Utils_Tuple2('ecolon', '≕'),
			_Utils_Tuple2('Ecy', 'Э'),
			_Utils_Tuple2('ecy', 'э'),
			_Utils_Tuple2('eDDot', '⩷'),
			_Utils_Tuple2('Edot', 'Ė'),
			_Utils_Tuple2('edot', 'ė'),
			_Utils_Tuple2('eDot', '≑'),
			_Utils_Tuple2('ee', 'ⅇ'),
			_Utils_Tuple2('efDot', '≒'),
			_Utils_Tuple2('Efr', '\uD835\uDD08'),
			_Utils_Tuple2('efr', '\uD835\uDD22'),
			_Utils_Tuple2('eg', '⪚'),
			_Utils_Tuple2('Egrave', 'È'),
			_Utils_Tuple2('egrave', 'è'),
			_Utils_Tuple2('egs', '⪖'),
			_Utils_Tuple2('egsdot', '⪘'),
			_Utils_Tuple2('el', '⪙'),
			_Utils_Tuple2('Element', '∈'),
			_Utils_Tuple2('elinters', '⏧'),
			_Utils_Tuple2('ell', 'ℓ'),
			_Utils_Tuple2('els', '⪕'),
			_Utils_Tuple2('elsdot', '⪗'),
			_Utils_Tuple2('Emacr', 'Ē'),
			_Utils_Tuple2('emacr', 'ē'),
			_Utils_Tuple2('empty', '∅'),
			_Utils_Tuple2('emptyset', '∅'),
			_Utils_Tuple2('EmptySmallSquare', '◻'),
			_Utils_Tuple2('emptyv', '∅'),
			_Utils_Tuple2('EmptyVerySmallSquare', '▫'),
			_Utils_Tuple2('emsp13', '\u2004'),
			_Utils_Tuple2('emsp14', '\u2005'),
			_Utils_Tuple2('emsp', '\u2003'),
			_Utils_Tuple2('ENG', 'Ŋ'),
			_Utils_Tuple2('eng', 'ŋ'),
			_Utils_Tuple2('ensp', '\u2002'),
			_Utils_Tuple2('Eogon', 'Ę'),
			_Utils_Tuple2('eogon', 'ę'),
			_Utils_Tuple2('Eopf', '\uD835\uDD3C'),
			_Utils_Tuple2('eopf', '\uD835\uDD56'),
			_Utils_Tuple2('epar', '⋕'),
			_Utils_Tuple2('eparsl', '⧣'),
			_Utils_Tuple2('eplus', '⩱'),
			_Utils_Tuple2('epsi', 'ε'),
			_Utils_Tuple2('Epsilon', 'Ε'),
			_Utils_Tuple2('epsilon', 'ε'),
			_Utils_Tuple2('epsiv', 'ϵ'),
			_Utils_Tuple2('eqcirc', '≖'),
			_Utils_Tuple2('eqcolon', '≕'),
			_Utils_Tuple2('eqsim', '≂'),
			_Utils_Tuple2('eqslantgtr', '⪖'),
			_Utils_Tuple2('eqslantless', '⪕'),
			_Utils_Tuple2('Equal', '⩵'),
			_Utils_Tuple2('equals', '='),
			_Utils_Tuple2('EqualTilde', '≂'),
			_Utils_Tuple2('equest', '≟'),
			_Utils_Tuple2('Equilibrium', '⇌'),
			_Utils_Tuple2('equiv', '≡'),
			_Utils_Tuple2('equivDD', '⩸'),
			_Utils_Tuple2('eqvparsl', '⧥'),
			_Utils_Tuple2('erarr', '⥱'),
			_Utils_Tuple2('erDot', '≓'),
			_Utils_Tuple2('escr', 'ℯ'),
			_Utils_Tuple2('Escr', 'ℰ'),
			_Utils_Tuple2('esdot', '≐'),
			_Utils_Tuple2('Esim', '⩳'),
			_Utils_Tuple2('esim', '≂'),
			_Utils_Tuple2('Eta', 'Η'),
			_Utils_Tuple2('eta', 'η'),
			_Utils_Tuple2('ETH', 'Ð'),
			_Utils_Tuple2('eth', 'ð'),
			_Utils_Tuple2('Euml', 'Ë'),
			_Utils_Tuple2('euml', 'ë'),
			_Utils_Tuple2('euro', '€'),
			_Utils_Tuple2('excl', '!'),
			_Utils_Tuple2('exist', '∃'),
			_Utils_Tuple2('Exists', '∃'),
			_Utils_Tuple2('expectation', 'ℰ'),
			_Utils_Tuple2('exponentiale', 'ⅇ'),
			_Utils_Tuple2('ExponentialE', 'ⅇ'),
			_Utils_Tuple2('fallingdotseq', '≒'),
			_Utils_Tuple2('Fcy', 'Ф'),
			_Utils_Tuple2('fcy', 'ф'),
			_Utils_Tuple2('female', '♀'),
			_Utils_Tuple2('ffilig', 'ﬃ'),
			_Utils_Tuple2('fflig', 'ﬀ'),
			_Utils_Tuple2('ffllig', 'ﬄ'),
			_Utils_Tuple2('Ffr', '\uD835\uDD09'),
			_Utils_Tuple2('ffr', '\uD835\uDD23'),
			_Utils_Tuple2('filig', 'ﬁ'),
			_Utils_Tuple2('FilledSmallSquare', '◼'),
			_Utils_Tuple2('FilledVerySmallSquare', '▪'),
			_Utils_Tuple2('fjlig', 'fj'),
			_Utils_Tuple2('flat', '♭'),
			_Utils_Tuple2('fllig', 'ﬂ'),
			_Utils_Tuple2('fltns', '▱'),
			_Utils_Tuple2('fnof', 'ƒ'),
			_Utils_Tuple2('Fopf', '\uD835\uDD3D'),
			_Utils_Tuple2('fopf', '\uD835\uDD57'),
			_Utils_Tuple2('forall', '∀'),
			_Utils_Tuple2('ForAll', '∀'),
			_Utils_Tuple2('fork', '⋔'),
			_Utils_Tuple2('forkv', '⫙'),
			_Utils_Tuple2('Fouriertrf', 'ℱ'),
			_Utils_Tuple2('fpartint', '⨍'),
			_Utils_Tuple2('frac12', '½'),
			_Utils_Tuple2('frac13', '⅓'),
			_Utils_Tuple2('frac14', '¼'),
			_Utils_Tuple2('frac15', '⅕'),
			_Utils_Tuple2('frac16', '⅙'),
			_Utils_Tuple2('frac18', '⅛'),
			_Utils_Tuple2('frac23', '⅔'),
			_Utils_Tuple2('frac25', '⅖'),
			_Utils_Tuple2('frac34', '¾'),
			_Utils_Tuple2('frac35', '⅗'),
			_Utils_Tuple2('frac38', '⅜'),
			_Utils_Tuple2('frac45', '⅘'),
			_Utils_Tuple2('frac56', '⅚'),
			_Utils_Tuple2('frac58', '⅝'),
			_Utils_Tuple2('frac78', '⅞'),
			_Utils_Tuple2('frasl', '⁄'),
			_Utils_Tuple2('frown', '⌢'),
			_Utils_Tuple2('fscr', '\uD835\uDCBB'),
			_Utils_Tuple2('Fscr', 'ℱ'),
			_Utils_Tuple2('gacute', 'ǵ'),
			_Utils_Tuple2('Gamma', 'Γ'),
			_Utils_Tuple2('gamma', 'γ'),
			_Utils_Tuple2('Gammad', 'Ϝ'),
			_Utils_Tuple2('gammad', 'ϝ'),
			_Utils_Tuple2('gap', '⪆'),
			_Utils_Tuple2('Gbreve', 'Ğ'),
			_Utils_Tuple2('gbreve', 'ğ'),
			_Utils_Tuple2('Gcedil', 'Ģ'),
			_Utils_Tuple2('Gcirc', 'Ĝ'),
			_Utils_Tuple2('gcirc', 'ĝ'),
			_Utils_Tuple2('Gcy', 'Г'),
			_Utils_Tuple2('gcy', 'г'),
			_Utils_Tuple2('Gdot', 'Ġ'),
			_Utils_Tuple2('gdot', 'ġ'),
			_Utils_Tuple2('ge', '≥'),
			_Utils_Tuple2('gE', '≧'),
			_Utils_Tuple2('gEl', '⪌'),
			_Utils_Tuple2('gel', '⋛'),
			_Utils_Tuple2('geq', '≥'),
			_Utils_Tuple2('geqq', '≧'),
			_Utils_Tuple2('geqslant', '⩾'),
			_Utils_Tuple2('gescc', '⪩'),
			_Utils_Tuple2('ges', '⩾'),
			_Utils_Tuple2('gesdot', '⪀'),
			_Utils_Tuple2('gesdoto', '⪂'),
			_Utils_Tuple2('gesdotol', '⪄'),
			_Utils_Tuple2('gesl', '⋛︀'),
			_Utils_Tuple2('gesles', '⪔'),
			_Utils_Tuple2('Gfr', '\uD835\uDD0A'),
			_Utils_Tuple2('gfr', '\uD835\uDD24'),
			_Utils_Tuple2('gg', '≫'),
			_Utils_Tuple2('Gg', '⋙'),
			_Utils_Tuple2('ggg', '⋙'),
			_Utils_Tuple2('gimel', 'ℷ'),
			_Utils_Tuple2('GJcy', 'Ѓ'),
			_Utils_Tuple2('gjcy', 'ѓ'),
			_Utils_Tuple2('gla', '⪥'),
			_Utils_Tuple2('gl', '≷'),
			_Utils_Tuple2('glE', '⪒'),
			_Utils_Tuple2('glj', '⪤'),
			_Utils_Tuple2('gnap', '⪊'),
			_Utils_Tuple2('gnapprox', '⪊'),
			_Utils_Tuple2('gne', '⪈'),
			_Utils_Tuple2('gnE', '≩'),
			_Utils_Tuple2('gneq', '⪈'),
			_Utils_Tuple2('gneqq', '≩'),
			_Utils_Tuple2('gnsim', '⋧'),
			_Utils_Tuple2('Gopf', '\uD835\uDD3E'),
			_Utils_Tuple2('gopf', '\uD835\uDD58'),
			_Utils_Tuple2('grave', '`'),
			_Utils_Tuple2('GreaterEqual', '≥'),
			_Utils_Tuple2('GreaterEqualLess', '⋛'),
			_Utils_Tuple2('GreaterFullEqual', '≧'),
			_Utils_Tuple2('GreaterGreater', '⪢'),
			_Utils_Tuple2('GreaterLess', '≷'),
			_Utils_Tuple2('GreaterSlantEqual', '⩾'),
			_Utils_Tuple2('GreaterTilde', '≳'),
			_Utils_Tuple2('Gscr', '\uD835\uDCA2'),
			_Utils_Tuple2('gscr', 'ℊ'),
			_Utils_Tuple2('gsim', '≳'),
			_Utils_Tuple2('gsime', '⪎'),
			_Utils_Tuple2('gsiml', '⪐'),
			_Utils_Tuple2('gtcc', '⪧'),
			_Utils_Tuple2('gtcir', '⩺'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('GT', '>'),
			_Utils_Tuple2('Gt', '≫'),
			_Utils_Tuple2('gtdot', '⋗'),
			_Utils_Tuple2('gtlPar', '⦕'),
			_Utils_Tuple2('gtquest', '⩼'),
			_Utils_Tuple2('gtrapprox', '⪆'),
			_Utils_Tuple2('gtrarr', '⥸'),
			_Utils_Tuple2('gtrdot', '⋗'),
			_Utils_Tuple2('gtreqless', '⋛'),
			_Utils_Tuple2('gtreqqless', '⪌'),
			_Utils_Tuple2('gtrless', '≷'),
			_Utils_Tuple2('gtrsim', '≳'),
			_Utils_Tuple2('gvertneqq', '≩︀'),
			_Utils_Tuple2('gvnE', '≩︀'),
			_Utils_Tuple2('Hacek', 'ˇ'),
			_Utils_Tuple2('hairsp', '\u200A'),
			_Utils_Tuple2('half', '½'),
			_Utils_Tuple2('hamilt', 'ℋ'),
			_Utils_Tuple2('HARDcy', 'Ъ'),
			_Utils_Tuple2('hardcy', 'ъ'),
			_Utils_Tuple2('harrcir', '⥈'),
			_Utils_Tuple2('harr', '↔'),
			_Utils_Tuple2('hArr', '⇔'),
			_Utils_Tuple2('harrw', '↭'),
			_Utils_Tuple2('Hat', '^'),
			_Utils_Tuple2('hbar', 'ℏ'),
			_Utils_Tuple2('Hcirc', 'Ĥ'),
			_Utils_Tuple2('hcirc', 'ĥ'),
			_Utils_Tuple2('hearts', '♥'),
			_Utils_Tuple2('heartsuit', '♥'),
			_Utils_Tuple2('hellip', '…'),
			_Utils_Tuple2('hercon', '⊹'),
			_Utils_Tuple2('hfr', '\uD835\uDD25'),
			_Utils_Tuple2('Hfr', 'ℌ'),
			_Utils_Tuple2('HilbertSpace', 'ℋ'),
			_Utils_Tuple2('hksearow', '⤥'),
			_Utils_Tuple2('hkswarow', '⤦'),
			_Utils_Tuple2('hoarr', '⇿'),
			_Utils_Tuple2('homtht', '∻'),
			_Utils_Tuple2('hookleftarrow', '↩'),
			_Utils_Tuple2('hookrightarrow', '↪'),
			_Utils_Tuple2('hopf', '\uD835\uDD59'),
			_Utils_Tuple2('Hopf', 'ℍ'),
			_Utils_Tuple2('horbar', '―'),
			_Utils_Tuple2('HorizontalLine', '─'),
			_Utils_Tuple2('hscr', '\uD835\uDCBD'),
			_Utils_Tuple2('Hscr', 'ℋ'),
			_Utils_Tuple2('hslash', 'ℏ'),
			_Utils_Tuple2('Hstrok', 'Ħ'),
			_Utils_Tuple2('hstrok', 'ħ'),
			_Utils_Tuple2('HumpDownHump', '≎'),
			_Utils_Tuple2('HumpEqual', '≏'),
			_Utils_Tuple2('hybull', '⁃'),
			_Utils_Tuple2('hyphen', '‐'),
			_Utils_Tuple2('Iacute', 'Í'),
			_Utils_Tuple2('iacute', 'í'),
			_Utils_Tuple2('ic', '\u2063'),
			_Utils_Tuple2('Icirc', 'Î'),
			_Utils_Tuple2('icirc', 'î'),
			_Utils_Tuple2('Icy', 'И'),
			_Utils_Tuple2('icy', 'и'),
			_Utils_Tuple2('Idot', 'İ'),
			_Utils_Tuple2('IEcy', 'Е'),
			_Utils_Tuple2('iecy', 'е'),
			_Utils_Tuple2('iexcl', '¡'),
			_Utils_Tuple2('iff', '⇔'),
			_Utils_Tuple2('ifr', '\uD835\uDD26'),
			_Utils_Tuple2('Ifr', 'ℑ'),
			_Utils_Tuple2('Igrave', 'Ì'),
			_Utils_Tuple2('igrave', 'ì'),
			_Utils_Tuple2('ii', 'ⅈ'),
			_Utils_Tuple2('iiiint', '⨌'),
			_Utils_Tuple2('iiint', '∭'),
			_Utils_Tuple2('iinfin', '⧜'),
			_Utils_Tuple2('iiota', '℩'),
			_Utils_Tuple2('IJlig', 'Ĳ'),
			_Utils_Tuple2('ijlig', 'ĳ'),
			_Utils_Tuple2('Imacr', 'Ī'),
			_Utils_Tuple2('imacr', 'ī'),
			_Utils_Tuple2('image', 'ℑ'),
			_Utils_Tuple2('ImaginaryI', 'ⅈ'),
			_Utils_Tuple2('imagline', 'ℐ'),
			_Utils_Tuple2('imagpart', 'ℑ'),
			_Utils_Tuple2('imath', 'ı'),
			_Utils_Tuple2('Im', 'ℑ'),
			_Utils_Tuple2('imof', '⊷'),
			_Utils_Tuple2('imped', 'Ƶ'),
			_Utils_Tuple2('Implies', '⇒'),
			_Utils_Tuple2('incare', '℅'),
			_Utils_Tuple2('in', '∈'),
			_Utils_Tuple2('infin', '∞'),
			_Utils_Tuple2('infintie', '⧝'),
			_Utils_Tuple2('inodot', 'ı'),
			_Utils_Tuple2('intcal', '⊺'),
			_Utils_Tuple2('int', '∫'),
			_Utils_Tuple2('Int', '∬'),
			_Utils_Tuple2('integers', 'ℤ'),
			_Utils_Tuple2('Integral', '∫'),
			_Utils_Tuple2('intercal', '⊺'),
			_Utils_Tuple2('Intersection', '⋂'),
			_Utils_Tuple2('intlarhk', '⨗'),
			_Utils_Tuple2('intprod', '⨼'),
			_Utils_Tuple2('InvisibleComma', '\u2063'),
			_Utils_Tuple2('InvisibleTimes', '\u2062'),
			_Utils_Tuple2('IOcy', 'Ё'),
			_Utils_Tuple2('iocy', 'ё'),
			_Utils_Tuple2('Iogon', 'Į'),
			_Utils_Tuple2('iogon', 'į'),
			_Utils_Tuple2('Iopf', '\uD835\uDD40'),
			_Utils_Tuple2('iopf', '\uD835\uDD5A'),
			_Utils_Tuple2('Iota', 'Ι'),
			_Utils_Tuple2('iota', 'ι'),
			_Utils_Tuple2('iprod', '⨼'),
			_Utils_Tuple2('iquest', '¿'),
			_Utils_Tuple2('iscr', '\uD835\uDCBE'),
			_Utils_Tuple2('Iscr', 'ℐ'),
			_Utils_Tuple2('isin', '∈'),
			_Utils_Tuple2('isindot', '⋵'),
			_Utils_Tuple2('isinE', '⋹'),
			_Utils_Tuple2('isins', '⋴'),
			_Utils_Tuple2('isinsv', '⋳'),
			_Utils_Tuple2('isinv', '∈'),
			_Utils_Tuple2('it', '\u2062'),
			_Utils_Tuple2('Itilde', 'Ĩ'),
			_Utils_Tuple2('itilde', 'ĩ'),
			_Utils_Tuple2('Iukcy', 'І'),
			_Utils_Tuple2('iukcy', 'і'),
			_Utils_Tuple2('Iuml', 'Ï'),
			_Utils_Tuple2('iuml', 'ï'),
			_Utils_Tuple2('Jcirc', 'Ĵ'),
			_Utils_Tuple2('jcirc', 'ĵ'),
			_Utils_Tuple2('Jcy', 'Й'),
			_Utils_Tuple2('jcy', 'й'),
			_Utils_Tuple2('Jfr', '\uD835\uDD0D'),
			_Utils_Tuple2('jfr', '\uD835\uDD27'),
			_Utils_Tuple2('jmath', 'ȷ'),
			_Utils_Tuple2('Jopf', '\uD835\uDD41'),
			_Utils_Tuple2('jopf', '\uD835\uDD5B'),
			_Utils_Tuple2('Jscr', '\uD835\uDCA5'),
			_Utils_Tuple2('jscr', '\uD835\uDCBF'),
			_Utils_Tuple2('Jsercy', 'Ј'),
			_Utils_Tuple2('jsercy', 'ј'),
			_Utils_Tuple2('Jukcy', 'Є'),
			_Utils_Tuple2('jukcy', 'є'),
			_Utils_Tuple2('Kappa', 'Κ'),
			_Utils_Tuple2('kappa', 'κ'),
			_Utils_Tuple2('kappav', 'ϰ'),
			_Utils_Tuple2('Kcedil', 'Ķ'),
			_Utils_Tuple2('kcedil', 'ķ'),
			_Utils_Tuple2('Kcy', 'К'),
			_Utils_Tuple2('kcy', 'к'),
			_Utils_Tuple2('Kfr', '\uD835\uDD0E'),
			_Utils_Tuple2('kfr', '\uD835\uDD28'),
			_Utils_Tuple2('kgreen', 'ĸ'),
			_Utils_Tuple2('KHcy', 'Х'),
			_Utils_Tuple2('khcy', 'х'),
			_Utils_Tuple2('KJcy', 'Ќ'),
			_Utils_Tuple2('kjcy', 'ќ'),
			_Utils_Tuple2('Kopf', '\uD835\uDD42'),
			_Utils_Tuple2('kopf', '\uD835\uDD5C'),
			_Utils_Tuple2('Kscr', '\uD835\uDCA6'),
			_Utils_Tuple2('kscr', '\uD835\uDCC0'),
			_Utils_Tuple2('lAarr', '⇚'),
			_Utils_Tuple2('Lacute', 'Ĺ'),
			_Utils_Tuple2('lacute', 'ĺ'),
			_Utils_Tuple2('laemptyv', '⦴'),
			_Utils_Tuple2('lagran', 'ℒ'),
			_Utils_Tuple2('Lambda', 'Λ'),
			_Utils_Tuple2('lambda', 'λ'),
			_Utils_Tuple2('lang', '⟨'),
			_Utils_Tuple2('Lang', '⟪'),
			_Utils_Tuple2('langd', '⦑'),
			_Utils_Tuple2('langle', '⟨'),
			_Utils_Tuple2('lap', '⪅'),
			_Utils_Tuple2('Laplacetrf', 'ℒ'),
			_Utils_Tuple2('laquo', '«'),
			_Utils_Tuple2('larrb', '⇤'),
			_Utils_Tuple2('larrbfs', '⤟'),
			_Utils_Tuple2('larr', '←'),
			_Utils_Tuple2('Larr', '↞'),
			_Utils_Tuple2('lArr', '⇐'),
			_Utils_Tuple2('larrfs', '⤝'),
			_Utils_Tuple2('larrhk', '↩'),
			_Utils_Tuple2('larrlp', '↫'),
			_Utils_Tuple2('larrpl', '⤹'),
			_Utils_Tuple2('larrsim', '⥳'),
			_Utils_Tuple2('larrtl', '↢'),
			_Utils_Tuple2('latail', '⤙'),
			_Utils_Tuple2('lAtail', '⤛'),
			_Utils_Tuple2('lat', '⪫'),
			_Utils_Tuple2('late', '⪭'),
			_Utils_Tuple2('lates', '⪭︀'),
			_Utils_Tuple2('lbarr', '⤌'),
			_Utils_Tuple2('lBarr', '⤎'),
			_Utils_Tuple2('lbbrk', '❲'),
			_Utils_Tuple2('lbrace', '{'),
			_Utils_Tuple2('lbrack', '['),
			_Utils_Tuple2('lbrke', '⦋'),
			_Utils_Tuple2('lbrksld', '⦏'),
			_Utils_Tuple2('lbrkslu', '⦍'),
			_Utils_Tuple2('Lcaron', 'Ľ'),
			_Utils_Tuple2('lcaron', 'ľ'),
			_Utils_Tuple2('Lcedil', 'Ļ'),
			_Utils_Tuple2('lcedil', 'ļ'),
			_Utils_Tuple2('lceil', '⌈'),
			_Utils_Tuple2('lcub', '{'),
			_Utils_Tuple2('Lcy', 'Л'),
			_Utils_Tuple2('lcy', 'л'),
			_Utils_Tuple2('ldca', '⤶'),
			_Utils_Tuple2('ldquo', '“'),
			_Utils_Tuple2('ldquor', '„'),
			_Utils_Tuple2('ldrdhar', '⥧'),
			_Utils_Tuple2('ldrushar', '⥋'),
			_Utils_Tuple2('ldsh', '↲'),
			_Utils_Tuple2('le', '≤'),
			_Utils_Tuple2('lE', '≦'),
			_Utils_Tuple2('LeftAngleBracket', '⟨'),
			_Utils_Tuple2('LeftArrowBar', '⇤'),
			_Utils_Tuple2('leftarrow', '←'),
			_Utils_Tuple2('LeftArrow', '←'),
			_Utils_Tuple2('Leftarrow', '⇐'),
			_Utils_Tuple2('LeftArrowRightArrow', '⇆'),
			_Utils_Tuple2('leftarrowtail', '↢'),
			_Utils_Tuple2('LeftCeiling', '⌈'),
			_Utils_Tuple2('LeftDoubleBracket', '⟦'),
			_Utils_Tuple2('LeftDownTeeVector', '⥡'),
			_Utils_Tuple2('LeftDownVectorBar', '⥙'),
			_Utils_Tuple2('LeftDownVector', '⇃'),
			_Utils_Tuple2('LeftFloor', '⌊'),
			_Utils_Tuple2('leftharpoondown', '↽'),
			_Utils_Tuple2('leftharpoonup', '↼'),
			_Utils_Tuple2('leftleftarrows', '⇇'),
			_Utils_Tuple2('leftrightarrow', '↔'),
			_Utils_Tuple2('LeftRightArrow', '↔'),
			_Utils_Tuple2('Leftrightarrow', '⇔'),
			_Utils_Tuple2('leftrightarrows', '⇆'),
			_Utils_Tuple2('leftrightharpoons', '⇋'),
			_Utils_Tuple2('leftrightsquigarrow', '↭'),
			_Utils_Tuple2('LeftRightVector', '⥎'),
			_Utils_Tuple2('LeftTeeArrow', '↤'),
			_Utils_Tuple2('LeftTee', '⊣'),
			_Utils_Tuple2('LeftTeeVector', '⥚'),
			_Utils_Tuple2('leftthreetimes', '⋋'),
			_Utils_Tuple2('LeftTriangleBar', '⧏'),
			_Utils_Tuple2('LeftTriangle', '⊲'),
			_Utils_Tuple2('LeftTriangleEqual', '⊴'),
			_Utils_Tuple2('LeftUpDownVector', '⥑'),
			_Utils_Tuple2('LeftUpTeeVector', '⥠'),
			_Utils_Tuple2('LeftUpVectorBar', '⥘'),
			_Utils_Tuple2('LeftUpVector', '↿'),
			_Utils_Tuple2('LeftVectorBar', '⥒'),
			_Utils_Tuple2('LeftVector', '↼'),
			_Utils_Tuple2('lEg', '⪋'),
			_Utils_Tuple2('leg', '⋚'),
			_Utils_Tuple2('leq', '≤'),
			_Utils_Tuple2('leqq', '≦'),
			_Utils_Tuple2('leqslant', '⩽'),
			_Utils_Tuple2('lescc', '⪨'),
			_Utils_Tuple2('les', '⩽'),
			_Utils_Tuple2('lesdot', '⩿'),
			_Utils_Tuple2('lesdoto', '⪁'),
			_Utils_Tuple2('lesdotor', '⪃'),
			_Utils_Tuple2('lesg', '⋚︀'),
			_Utils_Tuple2('lesges', '⪓'),
			_Utils_Tuple2('lessapprox', '⪅'),
			_Utils_Tuple2('lessdot', '⋖'),
			_Utils_Tuple2('lesseqgtr', '⋚'),
			_Utils_Tuple2('lesseqqgtr', '⪋'),
			_Utils_Tuple2('LessEqualGreater', '⋚'),
			_Utils_Tuple2('LessFullEqual', '≦'),
			_Utils_Tuple2('LessGreater', '≶'),
			_Utils_Tuple2('lessgtr', '≶'),
			_Utils_Tuple2('LessLess', '⪡'),
			_Utils_Tuple2('lesssim', '≲'),
			_Utils_Tuple2('LessSlantEqual', '⩽'),
			_Utils_Tuple2('LessTilde', '≲'),
			_Utils_Tuple2('lfisht', '⥼'),
			_Utils_Tuple2('lfloor', '⌊'),
			_Utils_Tuple2('Lfr', '\uD835\uDD0F'),
			_Utils_Tuple2('lfr', '\uD835\uDD29'),
			_Utils_Tuple2('lg', '≶'),
			_Utils_Tuple2('lgE', '⪑'),
			_Utils_Tuple2('lHar', '⥢'),
			_Utils_Tuple2('lhard', '↽'),
			_Utils_Tuple2('lharu', '↼'),
			_Utils_Tuple2('lharul', '⥪'),
			_Utils_Tuple2('lhblk', '▄'),
			_Utils_Tuple2('LJcy', 'Љ'),
			_Utils_Tuple2('ljcy', 'љ'),
			_Utils_Tuple2('llarr', '⇇'),
			_Utils_Tuple2('ll', '≪'),
			_Utils_Tuple2('Ll', '⋘'),
			_Utils_Tuple2('llcorner', '⌞'),
			_Utils_Tuple2('Lleftarrow', '⇚'),
			_Utils_Tuple2('llhard', '⥫'),
			_Utils_Tuple2('lltri', '◺'),
			_Utils_Tuple2('Lmidot', 'Ŀ'),
			_Utils_Tuple2('lmidot', 'ŀ'),
			_Utils_Tuple2('lmoustache', '⎰'),
			_Utils_Tuple2('lmoust', '⎰'),
			_Utils_Tuple2('lnap', '⪉'),
			_Utils_Tuple2('lnapprox', '⪉'),
			_Utils_Tuple2('lne', '⪇'),
			_Utils_Tuple2('lnE', '≨'),
			_Utils_Tuple2('lneq', '⪇'),
			_Utils_Tuple2('lneqq', '≨'),
			_Utils_Tuple2('lnsim', '⋦'),
			_Utils_Tuple2('loang', '⟬'),
			_Utils_Tuple2('loarr', '⇽'),
			_Utils_Tuple2('lobrk', '⟦'),
			_Utils_Tuple2('longleftarrow', '⟵'),
			_Utils_Tuple2('LongLeftArrow', '⟵'),
			_Utils_Tuple2('Longleftarrow', '⟸'),
			_Utils_Tuple2('longleftrightarrow', '⟷'),
			_Utils_Tuple2('LongLeftRightArrow', '⟷'),
			_Utils_Tuple2('Longleftrightarrow', '⟺'),
			_Utils_Tuple2('longmapsto', '⟼'),
			_Utils_Tuple2('longrightarrow', '⟶'),
			_Utils_Tuple2('LongRightArrow', '⟶'),
			_Utils_Tuple2('Longrightarrow', '⟹'),
			_Utils_Tuple2('looparrowleft', '↫'),
			_Utils_Tuple2('looparrowright', '↬'),
			_Utils_Tuple2('lopar', '⦅'),
			_Utils_Tuple2('Lopf', '\uD835\uDD43'),
			_Utils_Tuple2('lopf', '\uD835\uDD5D'),
			_Utils_Tuple2('loplus', '⨭'),
			_Utils_Tuple2('lotimes', '⨴'),
			_Utils_Tuple2('lowast', '∗'),
			_Utils_Tuple2('lowbar', '_'),
			_Utils_Tuple2('LowerLeftArrow', '↙'),
			_Utils_Tuple2('LowerRightArrow', '↘'),
			_Utils_Tuple2('loz', '◊'),
			_Utils_Tuple2('lozenge', '◊'),
			_Utils_Tuple2('lozf', '⧫'),
			_Utils_Tuple2('lpar', '('),
			_Utils_Tuple2('lparlt', '⦓'),
			_Utils_Tuple2('lrarr', '⇆'),
			_Utils_Tuple2('lrcorner', '⌟'),
			_Utils_Tuple2('lrhar', '⇋'),
			_Utils_Tuple2('lrhard', '⥭'),
			_Utils_Tuple2('lrm', '\u200E'),
			_Utils_Tuple2('lrtri', '⊿'),
			_Utils_Tuple2('lsaquo', '‹'),
			_Utils_Tuple2('lscr', '\uD835\uDCC1'),
			_Utils_Tuple2('Lscr', 'ℒ'),
			_Utils_Tuple2('lsh', '↰'),
			_Utils_Tuple2('Lsh', '↰'),
			_Utils_Tuple2('lsim', '≲'),
			_Utils_Tuple2('lsime', '⪍'),
			_Utils_Tuple2('lsimg', '⪏'),
			_Utils_Tuple2('lsqb', '['),
			_Utils_Tuple2('lsquo', '‘'),
			_Utils_Tuple2('lsquor', '‚'),
			_Utils_Tuple2('Lstrok', 'Ł'),
			_Utils_Tuple2('lstrok', 'ł'),
			_Utils_Tuple2('ltcc', '⪦'),
			_Utils_Tuple2('ltcir', '⩹'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('LT', '<'),
			_Utils_Tuple2('Lt', '≪'),
			_Utils_Tuple2('ltdot', '⋖'),
			_Utils_Tuple2('lthree', '⋋'),
			_Utils_Tuple2('ltimes', '⋉'),
			_Utils_Tuple2('ltlarr', '⥶'),
			_Utils_Tuple2('ltquest', '⩻'),
			_Utils_Tuple2('ltri', '◃'),
			_Utils_Tuple2('ltrie', '⊴'),
			_Utils_Tuple2('ltrif', '◂'),
			_Utils_Tuple2('ltrPar', '⦖'),
			_Utils_Tuple2('lurdshar', '⥊'),
			_Utils_Tuple2('luruhar', '⥦'),
			_Utils_Tuple2('lvertneqq', '≨︀'),
			_Utils_Tuple2('lvnE', '≨︀'),
			_Utils_Tuple2('macr', '¯'),
			_Utils_Tuple2('male', '♂'),
			_Utils_Tuple2('malt', '✠'),
			_Utils_Tuple2('maltese', '✠'),
			_Utils_Tuple2('Map', '⤅'),
			_Utils_Tuple2('map', '↦'),
			_Utils_Tuple2('mapsto', '↦'),
			_Utils_Tuple2('mapstodown', '↧'),
			_Utils_Tuple2('mapstoleft', '↤'),
			_Utils_Tuple2('mapstoup', '↥'),
			_Utils_Tuple2('marker', '▮'),
			_Utils_Tuple2('mcomma', '⨩'),
			_Utils_Tuple2('Mcy', 'М'),
			_Utils_Tuple2('mcy', 'м'),
			_Utils_Tuple2('mdash', '—'),
			_Utils_Tuple2('mDDot', '∺'),
			_Utils_Tuple2('measuredangle', '∡'),
			_Utils_Tuple2('MediumSpace', '\u205F'),
			_Utils_Tuple2('Mellintrf', 'ℳ'),
			_Utils_Tuple2('Mfr', '\uD835\uDD10'),
			_Utils_Tuple2('mfr', '\uD835\uDD2A'),
			_Utils_Tuple2('mho', '℧'),
			_Utils_Tuple2('micro', 'µ'),
			_Utils_Tuple2('midast', '*'),
			_Utils_Tuple2('midcir', '⫰'),
			_Utils_Tuple2('mid', '∣'),
			_Utils_Tuple2('middot', '·'),
			_Utils_Tuple2('minusb', '⊟'),
			_Utils_Tuple2('minus', '−'),
			_Utils_Tuple2('minusd', '∸'),
			_Utils_Tuple2('minusdu', '⨪'),
			_Utils_Tuple2('MinusPlus', '∓'),
			_Utils_Tuple2('mlcp', '⫛'),
			_Utils_Tuple2('mldr', '…'),
			_Utils_Tuple2('mnplus', '∓'),
			_Utils_Tuple2('models', '⊧'),
			_Utils_Tuple2('Mopf', '\uD835\uDD44'),
			_Utils_Tuple2('mopf', '\uD835\uDD5E'),
			_Utils_Tuple2('mp', '∓'),
			_Utils_Tuple2('mscr', '\uD835\uDCC2'),
			_Utils_Tuple2('Mscr', 'ℳ'),
			_Utils_Tuple2('mstpos', '∾'),
			_Utils_Tuple2('Mu', 'Μ'),
			_Utils_Tuple2('mu', 'μ'),
			_Utils_Tuple2('multimap', '⊸'),
			_Utils_Tuple2('mumap', '⊸'),
			_Utils_Tuple2('nabla', '∇'),
			_Utils_Tuple2('Nacute', 'Ń'),
			_Utils_Tuple2('nacute', 'ń'),
			_Utils_Tuple2('nang', '∠⃒'),
			_Utils_Tuple2('nap', '≉'),
			_Utils_Tuple2('napE', '⩰̸'),
			_Utils_Tuple2('napid', '≋̸'),
			_Utils_Tuple2('napos', 'ŉ'),
			_Utils_Tuple2('napprox', '≉'),
			_Utils_Tuple2('natural', '♮'),
			_Utils_Tuple2('naturals', 'ℕ'),
			_Utils_Tuple2('natur', '♮'),
			_Utils_Tuple2('nbsp', '\u00A0'),
			_Utils_Tuple2('nbump', '≎̸'),
			_Utils_Tuple2('nbumpe', '≏̸'),
			_Utils_Tuple2('ncap', '⩃'),
			_Utils_Tuple2('Ncaron', 'Ň'),
			_Utils_Tuple2('ncaron', 'ň'),
			_Utils_Tuple2('Ncedil', 'Ņ'),
			_Utils_Tuple2('ncedil', 'ņ'),
			_Utils_Tuple2('ncong', '≇'),
			_Utils_Tuple2('ncongdot', '⩭̸'),
			_Utils_Tuple2('ncup', '⩂'),
			_Utils_Tuple2('Ncy', 'Н'),
			_Utils_Tuple2('ncy', 'н'),
			_Utils_Tuple2('ndash', '–'),
			_Utils_Tuple2('nearhk', '⤤'),
			_Utils_Tuple2('nearr', '↗'),
			_Utils_Tuple2('neArr', '⇗'),
			_Utils_Tuple2('nearrow', '↗'),
			_Utils_Tuple2('ne', '≠'),
			_Utils_Tuple2('nedot', '≐̸'),
			_Utils_Tuple2('NegativeMediumSpace', '\u200B'),
			_Utils_Tuple2('NegativeThickSpace', '\u200B'),
			_Utils_Tuple2('NegativeThinSpace', '\u200B'),
			_Utils_Tuple2('NegativeVeryThinSpace', '\u200B'),
			_Utils_Tuple2('nequiv', '≢'),
			_Utils_Tuple2('nesear', '⤨'),
			_Utils_Tuple2('nesim', '≂̸'),
			_Utils_Tuple2('NestedGreaterGreater', '≫'),
			_Utils_Tuple2('NestedLessLess', '≪'),
			_Utils_Tuple2('NewLine', '\n'),
			_Utils_Tuple2('nexist', '∄'),
			_Utils_Tuple2('nexists', '∄'),
			_Utils_Tuple2('Nfr', '\uD835\uDD11'),
			_Utils_Tuple2('nfr', '\uD835\uDD2B'),
			_Utils_Tuple2('ngE', '≧̸'),
			_Utils_Tuple2('nge', '≱'),
			_Utils_Tuple2('ngeq', '≱'),
			_Utils_Tuple2('ngeqq', '≧̸'),
			_Utils_Tuple2('ngeqslant', '⩾̸'),
			_Utils_Tuple2('nges', '⩾̸'),
			_Utils_Tuple2('nGg', '⋙̸'),
			_Utils_Tuple2('ngsim', '≵'),
			_Utils_Tuple2('nGt', '≫⃒'),
			_Utils_Tuple2('ngt', '≯'),
			_Utils_Tuple2('ngtr', '≯'),
			_Utils_Tuple2('nGtv', '≫̸'),
			_Utils_Tuple2('nharr', '↮'),
			_Utils_Tuple2('nhArr', '⇎'),
			_Utils_Tuple2('nhpar', '⫲'),
			_Utils_Tuple2('ni', '∋'),
			_Utils_Tuple2('nis', '⋼'),
			_Utils_Tuple2('nisd', '⋺'),
			_Utils_Tuple2('niv', '∋'),
			_Utils_Tuple2('NJcy', 'Њ'),
			_Utils_Tuple2('njcy', 'њ'),
			_Utils_Tuple2('nlarr', '↚'),
			_Utils_Tuple2('nlArr', '⇍'),
			_Utils_Tuple2('nldr', '‥'),
			_Utils_Tuple2('nlE', '≦̸'),
			_Utils_Tuple2('nle', '≰'),
			_Utils_Tuple2('nleftarrow', '↚'),
			_Utils_Tuple2('nLeftarrow', '⇍'),
			_Utils_Tuple2('nleftrightarrow', '↮'),
			_Utils_Tuple2('nLeftrightarrow', '⇎'),
			_Utils_Tuple2('nleq', '≰'),
			_Utils_Tuple2('nleqq', '≦̸'),
			_Utils_Tuple2('nleqslant', '⩽̸'),
			_Utils_Tuple2('nles', '⩽̸'),
			_Utils_Tuple2('nless', '≮'),
			_Utils_Tuple2('nLl', '⋘̸'),
			_Utils_Tuple2('nlsim', '≴'),
			_Utils_Tuple2('nLt', '≪⃒'),
			_Utils_Tuple2('nlt', '≮'),
			_Utils_Tuple2('nltri', '⋪'),
			_Utils_Tuple2('nltrie', '⋬'),
			_Utils_Tuple2('nLtv', '≪̸'),
			_Utils_Tuple2('nmid', '∤'),
			_Utils_Tuple2('NoBreak', '\u2060'),
			_Utils_Tuple2('NonBreakingSpace', '\u00A0'),
			_Utils_Tuple2('nopf', '\uD835\uDD5F'),
			_Utils_Tuple2('Nopf', 'ℕ'),
			_Utils_Tuple2('Not', '⫬'),
			_Utils_Tuple2('not', '¬'),
			_Utils_Tuple2('NotCongruent', '≢'),
			_Utils_Tuple2('NotCupCap', '≭'),
			_Utils_Tuple2('NotDoubleVerticalBar', '∦'),
			_Utils_Tuple2('NotElement', '∉'),
			_Utils_Tuple2('NotEqual', '≠'),
			_Utils_Tuple2('NotEqualTilde', '≂̸'),
			_Utils_Tuple2('NotExists', '∄'),
			_Utils_Tuple2('NotGreater', '≯'),
			_Utils_Tuple2('NotGreaterEqual', '≱'),
			_Utils_Tuple2('NotGreaterFullEqual', '≧̸'),
			_Utils_Tuple2('NotGreaterGreater', '≫̸'),
			_Utils_Tuple2('NotGreaterLess', '≹'),
			_Utils_Tuple2('NotGreaterSlantEqual', '⩾̸'),
			_Utils_Tuple2('NotGreaterTilde', '≵'),
			_Utils_Tuple2('NotHumpDownHump', '≎̸'),
			_Utils_Tuple2('NotHumpEqual', '≏̸'),
			_Utils_Tuple2('notin', '∉'),
			_Utils_Tuple2('notindot', '⋵̸'),
			_Utils_Tuple2('notinE', '⋹̸'),
			_Utils_Tuple2('notinva', '∉'),
			_Utils_Tuple2('notinvb', '⋷'),
			_Utils_Tuple2('notinvc', '⋶'),
			_Utils_Tuple2('NotLeftTriangleBar', '⧏̸'),
			_Utils_Tuple2('NotLeftTriangle', '⋪'),
			_Utils_Tuple2('NotLeftTriangleEqual', '⋬'),
			_Utils_Tuple2('NotLess', '≮'),
			_Utils_Tuple2('NotLessEqual', '≰'),
			_Utils_Tuple2('NotLessGreater', '≸'),
			_Utils_Tuple2('NotLessLess', '≪̸'),
			_Utils_Tuple2('NotLessSlantEqual', '⩽̸'),
			_Utils_Tuple2('NotLessTilde', '≴'),
			_Utils_Tuple2('NotNestedGreaterGreater', '⪢̸'),
			_Utils_Tuple2('NotNestedLessLess', '⪡̸'),
			_Utils_Tuple2('notni', '∌'),
			_Utils_Tuple2('notniva', '∌'),
			_Utils_Tuple2('notnivb', '⋾'),
			_Utils_Tuple2('notnivc', '⋽'),
			_Utils_Tuple2('NotPrecedes', '⊀'),
			_Utils_Tuple2('NotPrecedesEqual', '⪯̸'),
			_Utils_Tuple2('NotPrecedesSlantEqual', '⋠'),
			_Utils_Tuple2('NotReverseElement', '∌'),
			_Utils_Tuple2('NotRightTriangleBar', '⧐̸'),
			_Utils_Tuple2('NotRightTriangle', '⋫'),
			_Utils_Tuple2('NotRightTriangleEqual', '⋭'),
			_Utils_Tuple2('NotSquareSubset', '⊏̸'),
			_Utils_Tuple2('NotSquareSubsetEqual', '⋢'),
			_Utils_Tuple2('NotSquareSuperset', '⊐̸'),
			_Utils_Tuple2('NotSquareSupersetEqual', '⋣'),
			_Utils_Tuple2('NotSubset', '⊂⃒'),
			_Utils_Tuple2('NotSubsetEqual', '⊈'),
			_Utils_Tuple2('NotSucceeds', '⊁'),
			_Utils_Tuple2('NotSucceedsEqual', '⪰̸'),
			_Utils_Tuple2('NotSucceedsSlantEqual', '⋡'),
			_Utils_Tuple2('NotSucceedsTilde', '≿̸'),
			_Utils_Tuple2('NotSuperset', '⊃⃒'),
			_Utils_Tuple2('NotSupersetEqual', '⊉'),
			_Utils_Tuple2('NotTilde', '≁'),
			_Utils_Tuple2('NotTildeEqual', '≄'),
			_Utils_Tuple2('NotTildeFullEqual', '≇'),
			_Utils_Tuple2('NotTildeTilde', '≉'),
			_Utils_Tuple2('NotVerticalBar', '∤'),
			_Utils_Tuple2('nparallel', '∦'),
			_Utils_Tuple2('npar', '∦'),
			_Utils_Tuple2('nparsl', '⫽⃥'),
			_Utils_Tuple2('npart', '∂̸'),
			_Utils_Tuple2('npolint', '⨔'),
			_Utils_Tuple2('npr', '⊀'),
			_Utils_Tuple2('nprcue', '⋠'),
			_Utils_Tuple2('nprec', '⊀'),
			_Utils_Tuple2('npreceq', '⪯̸'),
			_Utils_Tuple2('npre', '⪯̸'),
			_Utils_Tuple2('nrarrc', '⤳̸'),
			_Utils_Tuple2('nrarr', '↛'),
			_Utils_Tuple2('nrArr', '⇏'),
			_Utils_Tuple2('nrarrw', '↝̸'),
			_Utils_Tuple2('nrightarrow', '↛'),
			_Utils_Tuple2('nRightarrow', '⇏'),
			_Utils_Tuple2('nrtri', '⋫'),
			_Utils_Tuple2('nrtrie', '⋭'),
			_Utils_Tuple2('nsc', '⊁'),
			_Utils_Tuple2('nsccue', '⋡'),
			_Utils_Tuple2('nsce', '⪰̸'),
			_Utils_Tuple2('Nscr', '\uD835\uDCA9'),
			_Utils_Tuple2('nscr', '\uD835\uDCC3'),
			_Utils_Tuple2('nshortmid', '∤'),
			_Utils_Tuple2('nshortparallel', '∦'),
			_Utils_Tuple2('nsim', '≁'),
			_Utils_Tuple2('nsime', '≄'),
			_Utils_Tuple2('nsimeq', '≄'),
			_Utils_Tuple2('nsmid', '∤'),
			_Utils_Tuple2('nspar', '∦'),
			_Utils_Tuple2('nsqsube', '⋢'),
			_Utils_Tuple2('nsqsupe', '⋣'),
			_Utils_Tuple2('nsub', '⊄'),
			_Utils_Tuple2('nsubE', '⫅̸'),
			_Utils_Tuple2('nsube', '⊈'),
			_Utils_Tuple2('nsubset', '⊂⃒'),
			_Utils_Tuple2('nsubseteq', '⊈'),
			_Utils_Tuple2('nsubseteqq', '⫅̸'),
			_Utils_Tuple2('nsucc', '⊁'),
			_Utils_Tuple2('nsucceq', '⪰̸'),
			_Utils_Tuple2('nsup', '⊅'),
			_Utils_Tuple2('nsupE', '⫆̸'),
			_Utils_Tuple2('nsupe', '⊉'),
			_Utils_Tuple2('nsupset', '⊃⃒'),
			_Utils_Tuple2('nsupseteq', '⊉'),
			_Utils_Tuple2('nsupseteqq', '⫆̸'),
			_Utils_Tuple2('ntgl', '≹'),
			_Utils_Tuple2('Ntilde', 'Ñ'),
			_Utils_Tuple2('ntilde', 'ñ'),
			_Utils_Tuple2('ntlg', '≸'),
			_Utils_Tuple2('ntriangleleft', '⋪'),
			_Utils_Tuple2('ntrianglelefteq', '⋬'),
			_Utils_Tuple2('ntriangleright', '⋫'),
			_Utils_Tuple2('ntrianglerighteq', '⋭'),
			_Utils_Tuple2('Nu', 'Ν'),
			_Utils_Tuple2('nu', 'ν'),
			_Utils_Tuple2('num', '#'),
			_Utils_Tuple2('numero', '№'),
			_Utils_Tuple2('numsp', '\u2007'),
			_Utils_Tuple2('nvap', '≍⃒'),
			_Utils_Tuple2('nvdash', '⊬'),
			_Utils_Tuple2('nvDash', '⊭'),
			_Utils_Tuple2('nVdash', '⊮'),
			_Utils_Tuple2('nVDash', '⊯'),
			_Utils_Tuple2('nvge', '≥⃒'),
			_Utils_Tuple2('nvgt', '>⃒'),
			_Utils_Tuple2('nvHarr', '⤄'),
			_Utils_Tuple2('nvinfin', '⧞'),
			_Utils_Tuple2('nvlArr', '⤂'),
			_Utils_Tuple2('nvle', '≤⃒'),
			_Utils_Tuple2('nvlt', '<⃒'),
			_Utils_Tuple2('nvltrie', '⊴⃒'),
			_Utils_Tuple2('nvrArr', '⤃'),
			_Utils_Tuple2('nvrtrie', '⊵⃒'),
			_Utils_Tuple2('nvsim', '∼⃒'),
			_Utils_Tuple2('nwarhk', '⤣'),
			_Utils_Tuple2('nwarr', '↖'),
			_Utils_Tuple2('nwArr', '⇖'),
			_Utils_Tuple2('nwarrow', '↖'),
			_Utils_Tuple2('nwnear', '⤧'),
			_Utils_Tuple2('Oacute', 'Ó'),
			_Utils_Tuple2('oacute', 'ó'),
			_Utils_Tuple2('oast', '⊛'),
			_Utils_Tuple2('Ocirc', 'Ô'),
			_Utils_Tuple2('ocirc', 'ô'),
			_Utils_Tuple2('ocir', '⊚'),
			_Utils_Tuple2('Ocy', 'О'),
			_Utils_Tuple2('ocy', 'о'),
			_Utils_Tuple2('odash', '⊝'),
			_Utils_Tuple2('Odblac', 'Ő'),
			_Utils_Tuple2('odblac', 'ő'),
			_Utils_Tuple2('odiv', '⨸'),
			_Utils_Tuple2('odot', '⊙'),
			_Utils_Tuple2('odsold', '⦼'),
			_Utils_Tuple2('OElig', 'Œ'),
			_Utils_Tuple2('oelig', 'œ'),
			_Utils_Tuple2('ofcir', '⦿'),
			_Utils_Tuple2('Ofr', '\uD835\uDD12'),
			_Utils_Tuple2('ofr', '\uD835\uDD2C'),
			_Utils_Tuple2('ogon', '˛'),
			_Utils_Tuple2('Ograve', 'Ò'),
			_Utils_Tuple2('ograve', 'ò'),
			_Utils_Tuple2('ogt', '⧁'),
			_Utils_Tuple2('ohbar', '⦵'),
			_Utils_Tuple2('ohm', 'Ω'),
			_Utils_Tuple2('oint', '∮'),
			_Utils_Tuple2('olarr', '↺'),
			_Utils_Tuple2('olcir', '⦾'),
			_Utils_Tuple2('olcross', '⦻'),
			_Utils_Tuple2('oline', '‾'),
			_Utils_Tuple2('olt', '⧀'),
			_Utils_Tuple2('Omacr', 'Ō'),
			_Utils_Tuple2('omacr', 'ō'),
			_Utils_Tuple2('Omega', 'Ω'),
			_Utils_Tuple2('omega', 'ω'),
			_Utils_Tuple2('Omicron', 'Ο'),
			_Utils_Tuple2('omicron', 'ο'),
			_Utils_Tuple2('omid', '⦶'),
			_Utils_Tuple2('ominus', '⊖'),
			_Utils_Tuple2('Oopf', '\uD835\uDD46'),
			_Utils_Tuple2('oopf', '\uD835\uDD60'),
			_Utils_Tuple2('opar', '⦷'),
			_Utils_Tuple2('OpenCurlyDoubleQuote', '“'),
			_Utils_Tuple2('OpenCurlyQuote', '‘'),
			_Utils_Tuple2('operp', '⦹'),
			_Utils_Tuple2('oplus', '⊕'),
			_Utils_Tuple2('orarr', '↻'),
			_Utils_Tuple2('Or', '⩔'),
			_Utils_Tuple2('or', '∨'),
			_Utils_Tuple2('ord', '⩝'),
			_Utils_Tuple2('order', 'ℴ'),
			_Utils_Tuple2('orderof', 'ℴ'),
			_Utils_Tuple2('ordf', 'ª'),
			_Utils_Tuple2('ordm', 'º'),
			_Utils_Tuple2('origof', '⊶'),
			_Utils_Tuple2('oror', '⩖'),
			_Utils_Tuple2('orslope', '⩗'),
			_Utils_Tuple2('orv', '⩛'),
			_Utils_Tuple2('oS', 'Ⓢ'),
			_Utils_Tuple2('Oscr', '\uD835\uDCAA'),
			_Utils_Tuple2('oscr', 'ℴ'),
			_Utils_Tuple2('Oslash', 'Ø'),
			_Utils_Tuple2('oslash', 'ø'),
			_Utils_Tuple2('osol', '⊘'),
			_Utils_Tuple2('Otilde', 'Õ'),
			_Utils_Tuple2('otilde', 'õ'),
			_Utils_Tuple2('otimesas', '⨶'),
			_Utils_Tuple2('Otimes', '⨷'),
			_Utils_Tuple2('otimes', '⊗'),
			_Utils_Tuple2('Ouml', 'Ö'),
			_Utils_Tuple2('ouml', 'ö'),
			_Utils_Tuple2('ovbar', '⌽'),
			_Utils_Tuple2('OverBar', '‾'),
			_Utils_Tuple2('OverBrace', '⏞'),
			_Utils_Tuple2('OverBracket', '⎴'),
			_Utils_Tuple2('OverParenthesis', '⏜'),
			_Utils_Tuple2('para', '¶'),
			_Utils_Tuple2('parallel', '∥'),
			_Utils_Tuple2('par', '∥'),
			_Utils_Tuple2('parsim', '⫳'),
			_Utils_Tuple2('parsl', '⫽'),
			_Utils_Tuple2('part', '∂'),
			_Utils_Tuple2('PartialD', '∂'),
			_Utils_Tuple2('Pcy', 'П'),
			_Utils_Tuple2('pcy', 'п'),
			_Utils_Tuple2('percnt', '%'),
			_Utils_Tuple2('period', '.'),
			_Utils_Tuple2('permil', '‰'),
			_Utils_Tuple2('perp', '⊥'),
			_Utils_Tuple2('pertenk', '‱'),
			_Utils_Tuple2('Pfr', '\uD835\uDD13'),
			_Utils_Tuple2('pfr', '\uD835\uDD2D'),
			_Utils_Tuple2('Phi', 'Φ'),
			_Utils_Tuple2('phi', 'φ'),
			_Utils_Tuple2('phiv', 'ϕ'),
			_Utils_Tuple2('phmmat', 'ℳ'),
			_Utils_Tuple2('phone', '☎'),
			_Utils_Tuple2('Pi', 'Π'),
			_Utils_Tuple2('pi', 'π'),
			_Utils_Tuple2('pitchfork', '⋔'),
			_Utils_Tuple2('piv', 'ϖ'),
			_Utils_Tuple2('planck', 'ℏ'),
			_Utils_Tuple2('planckh', 'ℎ'),
			_Utils_Tuple2('plankv', 'ℏ'),
			_Utils_Tuple2('plusacir', '⨣'),
			_Utils_Tuple2('plusb', '⊞'),
			_Utils_Tuple2('pluscir', '⨢'),
			_Utils_Tuple2('plus', '+'),
			_Utils_Tuple2('plusdo', '∔'),
			_Utils_Tuple2('plusdu', '⨥'),
			_Utils_Tuple2('pluse', '⩲'),
			_Utils_Tuple2('PlusMinus', '±'),
			_Utils_Tuple2('plusmn', '±'),
			_Utils_Tuple2('plussim', '⨦'),
			_Utils_Tuple2('plustwo', '⨧'),
			_Utils_Tuple2('pm', '±'),
			_Utils_Tuple2('Poincareplane', 'ℌ'),
			_Utils_Tuple2('pointint', '⨕'),
			_Utils_Tuple2('popf', '\uD835\uDD61'),
			_Utils_Tuple2('Popf', 'ℙ'),
			_Utils_Tuple2('pound', '£'),
			_Utils_Tuple2('prap', '⪷'),
			_Utils_Tuple2('Pr', '⪻'),
			_Utils_Tuple2('pr', '≺'),
			_Utils_Tuple2('prcue', '≼'),
			_Utils_Tuple2('precapprox', '⪷'),
			_Utils_Tuple2('prec', '≺'),
			_Utils_Tuple2('preccurlyeq', '≼'),
			_Utils_Tuple2('Precedes', '≺'),
			_Utils_Tuple2('PrecedesEqual', '⪯'),
			_Utils_Tuple2('PrecedesSlantEqual', '≼'),
			_Utils_Tuple2('PrecedesTilde', '≾'),
			_Utils_Tuple2('preceq', '⪯'),
			_Utils_Tuple2('precnapprox', '⪹'),
			_Utils_Tuple2('precneqq', '⪵'),
			_Utils_Tuple2('precnsim', '⋨'),
			_Utils_Tuple2('pre', '⪯'),
			_Utils_Tuple2('prE', '⪳'),
			_Utils_Tuple2('precsim', '≾'),
			_Utils_Tuple2('prime', '′'),
			_Utils_Tuple2('Prime', '″'),
			_Utils_Tuple2('primes', 'ℙ'),
			_Utils_Tuple2('prnap', '⪹'),
			_Utils_Tuple2('prnE', '⪵'),
			_Utils_Tuple2('prnsim', '⋨'),
			_Utils_Tuple2('prod', '∏'),
			_Utils_Tuple2('Product', '∏'),
			_Utils_Tuple2('profalar', '⌮'),
			_Utils_Tuple2('profline', '⌒'),
			_Utils_Tuple2('profsurf', '⌓'),
			_Utils_Tuple2('prop', '∝'),
			_Utils_Tuple2('Proportional', '∝'),
			_Utils_Tuple2('Proportion', '∷'),
			_Utils_Tuple2('propto', '∝'),
			_Utils_Tuple2('prsim', '≾'),
			_Utils_Tuple2('prurel', '⊰'),
			_Utils_Tuple2('Pscr', '\uD835\uDCAB'),
			_Utils_Tuple2('pscr', '\uD835\uDCC5'),
			_Utils_Tuple2('Psi', 'Ψ'),
			_Utils_Tuple2('psi', 'ψ'),
			_Utils_Tuple2('puncsp', '\u2008'),
			_Utils_Tuple2('Qfr', '\uD835\uDD14'),
			_Utils_Tuple2('qfr', '\uD835\uDD2E'),
			_Utils_Tuple2('qint', '⨌'),
			_Utils_Tuple2('qopf', '\uD835\uDD62'),
			_Utils_Tuple2('Qopf', 'ℚ'),
			_Utils_Tuple2('qprime', '⁗'),
			_Utils_Tuple2('Qscr', '\uD835\uDCAC'),
			_Utils_Tuple2('qscr', '\uD835\uDCC6'),
			_Utils_Tuple2('quaternions', 'ℍ'),
			_Utils_Tuple2('quatint', '⨖'),
			_Utils_Tuple2('quest', '?'),
			_Utils_Tuple2('questeq', '≟'),
			_Utils_Tuple2('quot', '\"'),
			_Utils_Tuple2('QUOT', '\"'),
			_Utils_Tuple2('rAarr', '⇛'),
			_Utils_Tuple2('race', '∽̱'),
			_Utils_Tuple2('Racute', 'Ŕ'),
			_Utils_Tuple2('racute', 'ŕ'),
			_Utils_Tuple2('radic', '√'),
			_Utils_Tuple2('raemptyv', '⦳'),
			_Utils_Tuple2('rang', '⟩'),
			_Utils_Tuple2('Rang', '⟫'),
			_Utils_Tuple2('rangd', '⦒'),
			_Utils_Tuple2('range', '⦥'),
			_Utils_Tuple2('rangle', '⟩'),
			_Utils_Tuple2('raquo', '»'),
			_Utils_Tuple2('rarrap', '⥵'),
			_Utils_Tuple2('rarrb', '⇥'),
			_Utils_Tuple2('rarrbfs', '⤠'),
			_Utils_Tuple2('rarrc', '⤳'),
			_Utils_Tuple2('rarr', '→'),
			_Utils_Tuple2('Rarr', '↠'),
			_Utils_Tuple2('rArr', '⇒'),
			_Utils_Tuple2('rarrfs', '⤞'),
			_Utils_Tuple2('rarrhk', '↪'),
			_Utils_Tuple2('rarrlp', '↬'),
			_Utils_Tuple2('rarrpl', '⥅'),
			_Utils_Tuple2('rarrsim', '⥴'),
			_Utils_Tuple2('Rarrtl', '⤖'),
			_Utils_Tuple2('rarrtl', '↣'),
			_Utils_Tuple2('rarrw', '↝'),
			_Utils_Tuple2('ratail', '⤚'),
			_Utils_Tuple2('rAtail', '⤜'),
			_Utils_Tuple2('ratio', '∶'),
			_Utils_Tuple2('rationals', 'ℚ'),
			_Utils_Tuple2('rbarr', '⤍'),
			_Utils_Tuple2('rBarr', '⤏'),
			_Utils_Tuple2('RBarr', '⤐'),
			_Utils_Tuple2('rbbrk', '❳'),
			_Utils_Tuple2('rbrace', '}'),
			_Utils_Tuple2('rbrack', ']'),
			_Utils_Tuple2('rbrke', '⦌'),
			_Utils_Tuple2('rbrksld', '⦎'),
			_Utils_Tuple2('rbrkslu', '⦐'),
			_Utils_Tuple2('Rcaron', 'Ř'),
			_Utils_Tuple2('rcaron', 'ř'),
			_Utils_Tuple2('Rcedil', 'Ŗ'),
			_Utils_Tuple2('rcedil', 'ŗ'),
			_Utils_Tuple2('rceil', '⌉'),
			_Utils_Tuple2('rcub', '}'),
			_Utils_Tuple2('Rcy', 'Р'),
			_Utils_Tuple2('rcy', 'р'),
			_Utils_Tuple2('rdca', '⤷'),
			_Utils_Tuple2('rdldhar', '⥩'),
			_Utils_Tuple2('rdquo', '”'),
			_Utils_Tuple2('rdquor', '”'),
			_Utils_Tuple2('rdsh', '↳'),
			_Utils_Tuple2('real', 'ℜ'),
			_Utils_Tuple2('realine', 'ℛ'),
			_Utils_Tuple2('realpart', 'ℜ'),
			_Utils_Tuple2('reals', 'ℝ'),
			_Utils_Tuple2('Re', 'ℜ'),
			_Utils_Tuple2('rect', '▭'),
			_Utils_Tuple2('reg', '®'),
			_Utils_Tuple2('REG', '®'),
			_Utils_Tuple2('ReverseElement', '∋'),
			_Utils_Tuple2('ReverseEquilibrium', '⇋'),
			_Utils_Tuple2('ReverseUpEquilibrium', '⥯'),
			_Utils_Tuple2('rfisht', '⥽'),
			_Utils_Tuple2('rfloor', '⌋'),
			_Utils_Tuple2('rfr', '\uD835\uDD2F'),
			_Utils_Tuple2('Rfr', 'ℜ'),
			_Utils_Tuple2('rHar', '⥤'),
			_Utils_Tuple2('rhard', '⇁'),
			_Utils_Tuple2('rharu', '⇀'),
			_Utils_Tuple2('rharul', '⥬'),
			_Utils_Tuple2('Rho', 'Ρ'),
			_Utils_Tuple2('rho', 'ρ'),
			_Utils_Tuple2('rhov', 'ϱ'),
			_Utils_Tuple2('RightAngleBracket', '⟩'),
			_Utils_Tuple2('RightArrowBar', '⇥'),
			_Utils_Tuple2('rightarrow', '→'),
			_Utils_Tuple2('RightArrow', '→'),
			_Utils_Tuple2('Rightarrow', '⇒'),
			_Utils_Tuple2('RightArrowLeftArrow', '⇄'),
			_Utils_Tuple2('rightarrowtail', '↣'),
			_Utils_Tuple2('RightCeiling', '⌉'),
			_Utils_Tuple2('RightDoubleBracket', '⟧'),
			_Utils_Tuple2('RightDownTeeVector', '⥝'),
			_Utils_Tuple2('RightDownVectorBar', '⥕'),
			_Utils_Tuple2('RightDownVector', '⇂'),
			_Utils_Tuple2('RightFloor', '⌋'),
			_Utils_Tuple2('rightharpoondown', '⇁'),
			_Utils_Tuple2('rightharpoonup', '⇀'),
			_Utils_Tuple2('rightleftarrows', '⇄'),
			_Utils_Tuple2('rightleftharpoons', '⇌'),
			_Utils_Tuple2('rightrightarrows', '⇉'),
			_Utils_Tuple2('rightsquigarrow', '↝'),
			_Utils_Tuple2('RightTeeArrow', '↦'),
			_Utils_Tuple2('RightTee', '⊢'),
			_Utils_Tuple2('RightTeeVector', '⥛'),
			_Utils_Tuple2('rightthreetimes', '⋌'),
			_Utils_Tuple2('RightTriangleBar', '⧐'),
			_Utils_Tuple2('RightTriangle', '⊳'),
			_Utils_Tuple2('RightTriangleEqual', '⊵'),
			_Utils_Tuple2('RightUpDownVector', '⥏'),
			_Utils_Tuple2('RightUpTeeVector', '⥜'),
			_Utils_Tuple2('RightUpVectorBar', '⥔'),
			_Utils_Tuple2('RightUpVector', '↾'),
			_Utils_Tuple2('RightVectorBar', '⥓'),
			_Utils_Tuple2('RightVector', '⇀'),
			_Utils_Tuple2('ring', '˚'),
			_Utils_Tuple2('risingdotseq', '≓'),
			_Utils_Tuple2('rlarr', '⇄'),
			_Utils_Tuple2('rlhar', '⇌'),
			_Utils_Tuple2('rlm', '\u200F'),
			_Utils_Tuple2('rmoustache', '⎱'),
			_Utils_Tuple2('rmoust', '⎱'),
			_Utils_Tuple2('rnmid', '⫮'),
			_Utils_Tuple2('roang', '⟭'),
			_Utils_Tuple2('roarr', '⇾'),
			_Utils_Tuple2('robrk', '⟧'),
			_Utils_Tuple2('ropar', '⦆'),
			_Utils_Tuple2('ropf', '\uD835\uDD63'),
			_Utils_Tuple2('Ropf', 'ℝ'),
			_Utils_Tuple2('roplus', '⨮'),
			_Utils_Tuple2('rotimes', '⨵'),
			_Utils_Tuple2('RoundImplies', '⥰'),
			_Utils_Tuple2('rpar', ')'),
			_Utils_Tuple2('rpargt', '⦔'),
			_Utils_Tuple2('rppolint', '⨒'),
			_Utils_Tuple2('rrarr', '⇉'),
			_Utils_Tuple2('Rrightarrow', '⇛'),
			_Utils_Tuple2('rsaquo', '›'),
			_Utils_Tuple2('rscr', '\uD835\uDCC7'),
			_Utils_Tuple2('Rscr', 'ℛ'),
			_Utils_Tuple2('rsh', '↱'),
			_Utils_Tuple2('Rsh', '↱'),
			_Utils_Tuple2('rsqb', ']'),
			_Utils_Tuple2('rsquo', '’'),
			_Utils_Tuple2('rsquor', '’'),
			_Utils_Tuple2('rthree', '⋌'),
			_Utils_Tuple2('rtimes', '⋊'),
			_Utils_Tuple2('rtri', '▹'),
			_Utils_Tuple2('rtrie', '⊵'),
			_Utils_Tuple2('rtrif', '▸'),
			_Utils_Tuple2('rtriltri', '⧎'),
			_Utils_Tuple2('RuleDelayed', '⧴'),
			_Utils_Tuple2('ruluhar', '⥨'),
			_Utils_Tuple2('rx', '℞'),
			_Utils_Tuple2('Sacute', 'Ś'),
			_Utils_Tuple2('sacute', 'ś'),
			_Utils_Tuple2('sbquo', '‚'),
			_Utils_Tuple2('scap', '⪸'),
			_Utils_Tuple2('Scaron', 'Š'),
			_Utils_Tuple2('scaron', 'š'),
			_Utils_Tuple2('Sc', '⪼'),
			_Utils_Tuple2('sc', '≻'),
			_Utils_Tuple2('sccue', '≽'),
			_Utils_Tuple2('sce', '⪰'),
			_Utils_Tuple2('scE', '⪴'),
			_Utils_Tuple2('Scedil', 'Ş'),
			_Utils_Tuple2('scedil', 'ş'),
			_Utils_Tuple2('Scirc', 'Ŝ'),
			_Utils_Tuple2('scirc', 'ŝ'),
			_Utils_Tuple2('scnap', '⪺'),
			_Utils_Tuple2('scnE', '⪶'),
			_Utils_Tuple2('scnsim', '⋩'),
			_Utils_Tuple2('scpolint', '⨓'),
			_Utils_Tuple2('scsim', '≿'),
			_Utils_Tuple2('Scy', 'С'),
			_Utils_Tuple2('scy', 'с'),
			_Utils_Tuple2('sdotb', '⊡'),
			_Utils_Tuple2('sdot', '⋅'),
			_Utils_Tuple2('sdote', '⩦'),
			_Utils_Tuple2('searhk', '⤥'),
			_Utils_Tuple2('searr', '↘'),
			_Utils_Tuple2('seArr', '⇘'),
			_Utils_Tuple2('searrow', '↘'),
			_Utils_Tuple2('sect', '§'),
			_Utils_Tuple2('semi', ';'),
			_Utils_Tuple2('seswar', '⤩'),
			_Utils_Tuple2('setminus', '∖'),
			_Utils_Tuple2('setmn', '∖'),
			_Utils_Tuple2('sext', '✶'),
			_Utils_Tuple2('Sfr', '\uD835\uDD16'),
			_Utils_Tuple2('sfr', '\uD835\uDD30'),
			_Utils_Tuple2('sfrown', '⌢'),
			_Utils_Tuple2('sharp', '♯'),
			_Utils_Tuple2('SHCHcy', 'Щ'),
			_Utils_Tuple2('shchcy', 'щ'),
			_Utils_Tuple2('SHcy', 'Ш'),
			_Utils_Tuple2('shcy', 'ш'),
			_Utils_Tuple2('ShortDownArrow', '↓'),
			_Utils_Tuple2('ShortLeftArrow', '←'),
			_Utils_Tuple2('shortmid', '∣'),
			_Utils_Tuple2('shortparallel', '∥'),
			_Utils_Tuple2('ShortRightArrow', '→'),
			_Utils_Tuple2('ShortUpArrow', '↑'),
			_Utils_Tuple2('shy', '\u00AD'),
			_Utils_Tuple2('Sigma', 'Σ'),
			_Utils_Tuple2('sigma', 'σ'),
			_Utils_Tuple2('sigmaf', 'ς'),
			_Utils_Tuple2('sigmav', 'ς'),
			_Utils_Tuple2('sim', '∼'),
			_Utils_Tuple2('simdot', '⩪'),
			_Utils_Tuple2('sime', '≃'),
			_Utils_Tuple2('simeq', '≃'),
			_Utils_Tuple2('simg', '⪞'),
			_Utils_Tuple2('simgE', '⪠'),
			_Utils_Tuple2('siml', '⪝'),
			_Utils_Tuple2('simlE', '⪟'),
			_Utils_Tuple2('simne', '≆'),
			_Utils_Tuple2('simplus', '⨤'),
			_Utils_Tuple2('simrarr', '⥲'),
			_Utils_Tuple2('slarr', '←'),
			_Utils_Tuple2('SmallCircle', '∘'),
			_Utils_Tuple2('smallsetminus', '∖'),
			_Utils_Tuple2('smashp', '⨳'),
			_Utils_Tuple2('smeparsl', '⧤'),
			_Utils_Tuple2('smid', '∣'),
			_Utils_Tuple2('smile', '⌣'),
			_Utils_Tuple2('smt', '⪪'),
			_Utils_Tuple2('smte', '⪬'),
			_Utils_Tuple2('smtes', '⪬︀'),
			_Utils_Tuple2('SOFTcy', 'Ь'),
			_Utils_Tuple2('softcy', 'ь'),
			_Utils_Tuple2('solbar', '⌿'),
			_Utils_Tuple2('solb', '⧄'),
			_Utils_Tuple2('sol', '/'),
			_Utils_Tuple2('Sopf', '\uD835\uDD4A'),
			_Utils_Tuple2('sopf', '\uD835\uDD64'),
			_Utils_Tuple2('spades', '♠'),
			_Utils_Tuple2('spadesuit', '♠'),
			_Utils_Tuple2('spar', '∥'),
			_Utils_Tuple2('sqcap', '⊓'),
			_Utils_Tuple2('sqcaps', '⊓︀'),
			_Utils_Tuple2('sqcup', '⊔'),
			_Utils_Tuple2('sqcups', '⊔︀'),
			_Utils_Tuple2('Sqrt', '√'),
			_Utils_Tuple2('sqsub', '⊏'),
			_Utils_Tuple2('sqsube', '⊑'),
			_Utils_Tuple2('sqsubset', '⊏'),
			_Utils_Tuple2('sqsubseteq', '⊑'),
			_Utils_Tuple2('sqsup', '⊐'),
			_Utils_Tuple2('sqsupe', '⊒'),
			_Utils_Tuple2('sqsupset', '⊐'),
			_Utils_Tuple2('sqsupseteq', '⊒'),
			_Utils_Tuple2('square', '□'),
			_Utils_Tuple2('Square', '□'),
			_Utils_Tuple2('SquareIntersection', '⊓'),
			_Utils_Tuple2('SquareSubset', '⊏'),
			_Utils_Tuple2('SquareSubsetEqual', '⊑'),
			_Utils_Tuple2('SquareSuperset', '⊐'),
			_Utils_Tuple2('SquareSupersetEqual', '⊒'),
			_Utils_Tuple2('SquareUnion', '⊔'),
			_Utils_Tuple2('squarf', '▪'),
			_Utils_Tuple2('squ', '□'),
			_Utils_Tuple2('squf', '▪'),
			_Utils_Tuple2('srarr', '→'),
			_Utils_Tuple2('Sscr', '\uD835\uDCAE'),
			_Utils_Tuple2('sscr', '\uD835\uDCC8'),
			_Utils_Tuple2('ssetmn', '∖'),
			_Utils_Tuple2('ssmile', '⌣'),
			_Utils_Tuple2('sstarf', '⋆'),
			_Utils_Tuple2('Star', '⋆'),
			_Utils_Tuple2('star', '☆'),
			_Utils_Tuple2('starf', '★'),
			_Utils_Tuple2('straightepsilon', 'ϵ'),
			_Utils_Tuple2('straightphi', 'ϕ'),
			_Utils_Tuple2('strns', '¯'),
			_Utils_Tuple2('sub', '⊂'),
			_Utils_Tuple2('Sub', '⋐'),
			_Utils_Tuple2('subdot', '⪽'),
			_Utils_Tuple2('subE', '⫅'),
			_Utils_Tuple2('sube', '⊆'),
			_Utils_Tuple2('subedot', '⫃'),
			_Utils_Tuple2('submult', '⫁'),
			_Utils_Tuple2('subnE', '⫋'),
			_Utils_Tuple2('subne', '⊊'),
			_Utils_Tuple2('subplus', '⪿'),
			_Utils_Tuple2('subrarr', '⥹'),
			_Utils_Tuple2('subset', '⊂'),
			_Utils_Tuple2('Subset', '⋐'),
			_Utils_Tuple2('subseteq', '⊆'),
			_Utils_Tuple2('subseteqq', '⫅'),
			_Utils_Tuple2('SubsetEqual', '⊆'),
			_Utils_Tuple2('subsetneq', '⊊'),
			_Utils_Tuple2('subsetneqq', '⫋'),
			_Utils_Tuple2('subsim', '⫇'),
			_Utils_Tuple2('subsub', '⫕'),
			_Utils_Tuple2('subsup', '⫓'),
			_Utils_Tuple2('succapprox', '⪸'),
			_Utils_Tuple2('succ', '≻'),
			_Utils_Tuple2('succcurlyeq', '≽'),
			_Utils_Tuple2('Succeeds', '≻'),
			_Utils_Tuple2('SucceedsEqual', '⪰'),
			_Utils_Tuple2('SucceedsSlantEqual', '≽'),
			_Utils_Tuple2('SucceedsTilde', '≿'),
			_Utils_Tuple2('succeq', '⪰'),
			_Utils_Tuple2('succnapprox', '⪺'),
			_Utils_Tuple2('succneqq', '⪶'),
			_Utils_Tuple2('succnsim', '⋩'),
			_Utils_Tuple2('succsim', '≿'),
			_Utils_Tuple2('SuchThat', '∋'),
			_Utils_Tuple2('sum', '∑'),
			_Utils_Tuple2('Sum', '∑'),
			_Utils_Tuple2('sung', '♪'),
			_Utils_Tuple2('sup1', '¹'),
			_Utils_Tuple2('sup2', '²'),
			_Utils_Tuple2('sup3', '³'),
			_Utils_Tuple2('sup', '⊃'),
			_Utils_Tuple2('Sup', '⋑'),
			_Utils_Tuple2('supdot', '⪾'),
			_Utils_Tuple2('supdsub', '⫘'),
			_Utils_Tuple2('supE', '⫆'),
			_Utils_Tuple2('supe', '⊇'),
			_Utils_Tuple2('supedot', '⫄'),
			_Utils_Tuple2('Superset', '⊃'),
			_Utils_Tuple2('SupersetEqual', '⊇'),
			_Utils_Tuple2('suphsol', '⟉'),
			_Utils_Tuple2('suphsub', '⫗'),
			_Utils_Tuple2('suplarr', '⥻'),
			_Utils_Tuple2('supmult', '⫂'),
			_Utils_Tuple2('supnE', '⫌'),
			_Utils_Tuple2('supne', '⊋'),
			_Utils_Tuple2('supplus', '⫀'),
			_Utils_Tuple2('supset', '⊃'),
			_Utils_Tuple2('Supset', '⋑'),
			_Utils_Tuple2('supseteq', '⊇'),
			_Utils_Tuple2('supseteqq', '⫆'),
			_Utils_Tuple2('supsetneq', '⊋'),
			_Utils_Tuple2('supsetneqq', '⫌'),
			_Utils_Tuple2('supsim', '⫈'),
			_Utils_Tuple2('supsub', '⫔'),
			_Utils_Tuple2('supsup', '⫖'),
			_Utils_Tuple2('swarhk', '⤦'),
			_Utils_Tuple2('swarr', '↙'),
			_Utils_Tuple2('swArr', '⇙'),
			_Utils_Tuple2('swarrow', '↙'),
			_Utils_Tuple2('swnwar', '⤪'),
			_Utils_Tuple2('szlig', 'ß'),
			_Utils_Tuple2('Tab', '\t'),
			_Utils_Tuple2('target', '⌖'),
			_Utils_Tuple2('Tau', 'Τ'),
			_Utils_Tuple2('tau', 'τ'),
			_Utils_Tuple2('tbrk', '⎴'),
			_Utils_Tuple2('Tcaron', 'Ť'),
			_Utils_Tuple2('tcaron', 'ť'),
			_Utils_Tuple2('Tcedil', 'Ţ'),
			_Utils_Tuple2('tcedil', 'ţ'),
			_Utils_Tuple2('Tcy', 'Т'),
			_Utils_Tuple2('tcy', 'т'),
			_Utils_Tuple2('tdot', '⃛'),
			_Utils_Tuple2('telrec', '⌕'),
			_Utils_Tuple2('Tfr', '\uD835\uDD17'),
			_Utils_Tuple2('tfr', '\uD835\uDD31'),
			_Utils_Tuple2('there4', '∴'),
			_Utils_Tuple2('therefore', '∴'),
			_Utils_Tuple2('Therefore', '∴'),
			_Utils_Tuple2('Theta', 'Θ'),
			_Utils_Tuple2('theta', 'θ'),
			_Utils_Tuple2('thetasym', 'ϑ'),
			_Utils_Tuple2('thetav', 'ϑ'),
			_Utils_Tuple2('thickapprox', '≈'),
			_Utils_Tuple2('thicksim', '∼'),
			_Utils_Tuple2('ThickSpace', '\u205F\u200A'),
			_Utils_Tuple2('ThinSpace', '\u2009'),
			_Utils_Tuple2('thinsp', '\u2009'),
			_Utils_Tuple2('thkap', '≈'),
			_Utils_Tuple2('thksim', '∼'),
			_Utils_Tuple2('THORN', 'Þ'),
			_Utils_Tuple2('thorn', 'þ'),
			_Utils_Tuple2('tilde', '˜'),
			_Utils_Tuple2('Tilde', '∼'),
			_Utils_Tuple2('TildeEqual', '≃'),
			_Utils_Tuple2('TildeFullEqual', '≅'),
			_Utils_Tuple2('TildeTilde', '≈'),
			_Utils_Tuple2('timesbar', '⨱'),
			_Utils_Tuple2('timesb', '⊠'),
			_Utils_Tuple2('times', '×'),
			_Utils_Tuple2('timesd', '⨰'),
			_Utils_Tuple2('tint', '∭'),
			_Utils_Tuple2('toea', '⤨'),
			_Utils_Tuple2('topbot', '⌶'),
			_Utils_Tuple2('topcir', '⫱'),
			_Utils_Tuple2('top', '⊤'),
			_Utils_Tuple2('Topf', '\uD835\uDD4B'),
			_Utils_Tuple2('topf', '\uD835\uDD65'),
			_Utils_Tuple2('topfork', '⫚'),
			_Utils_Tuple2('tosa', '⤩'),
			_Utils_Tuple2('tprime', '‴'),
			_Utils_Tuple2('trade', '™'),
			_Utils_Tuple2('TRADE', '™'),
			_Utils_Tuple2('triangle', '▵'),
			_Utils_Tuple2('triangledown', '▿'),
			_Utils_Tuple2('triangleleft', '◃'),
			_Utils_Tuple2('trianglelefteq', '⊴'),
			_Utils_Tuple2('triangleq', '≜'),
			_Utils_Tuple2('triangleright', '▹'),
			_Utils_Tuple2('trianglerighteq', '⊵'),
			_Utils_Tuple2('tridot', '◬'),
			_Utils_Tuple2('trie', '≜'),
			_Utils_Tuple2('triminus', '⨺'),
			_Utils_Tuple2('TripleDot', '⃛'),
			_Utils_Tuple2('triplus', '⨹'),
			_Utils_Tuple2('trisb', '⧍'),
			_Utils_Tuple2('tritime', '⨻'),
			_Utils_Tuple2('trpezium', '⏢'),
			_Utils_Tuple2('Tscr', '\uD835\uDCAF'),
			_Utils_Tuple2('tscr', '\uD835\uDCC9'),
			_Utils_Tuple2('TScy', 'Ц'),
			_Utils_Tuple2('tscy', 'ц'),
			_Utils_Tuple2('TSHcy', 'Ћ'),
			_Utils_Tuple2('tshcy', 'ћ'),
			_Utils_Tuple2('Tstrok', 'Ŧ'),
			_Utils_Tuple2('tstrok', 'ŧ'),
			_Utils_Tuple2('twixt', '≬'),
			_Utils_Tuple2('twoheadleftarrow', '↞'),
			_Utils_Tuple2('twoheadrightarrow', '↠'),
			_Utils_Tuple2('Uacute', 'Ú'),
			_Utils_Tuple2('uacute', 'ú'),
			_Utils_Tuple2('uarr', '↑'),
			_Utils_Tuple2('Uarr', '↟'),
			_Utils_Tuple2('uArr', '⇑'),
			_Utils_Tuple2('Uarrocir', '⥉'),
			_Utils_Tuple2('Ubrcy', 'Ў'),
			_Utils_Tuple2('ubrcy', 'ў'),
			_Utils_Tuple2('Ubreve', 'Ŭ'),
			_Utils_Tuple2('ubreve', 'ŭ'),
			_Utils_Tuple2('Ucirc', 'Û'),
			_Utils_Tuple2('ucirc', 'û'),
			_Utils_Tuple2('Ucy', 'У'),
			_Utils_Tuple2('ucy', 'у'),
			_Utils_Tuple2('udarr', '⇅'),
			_Utils_Tuple2('Udblac', 'Ű'),
			_Utils_Tuple2('udblac', 'ű'),
			_Utils_Tuple2('udhar', '⥮'),
			_Utils_Tuple2('ufisht', '⥾'),
			_Utils_Tuple2('Ufr', '\uD835\uDD18'),
			_Utils_Tuple2('ufr', '\uD835\uDD32'),
			_Utils_Tuple2('Ugrave', 'Ù'),
			_Utils_Tuple2('ugrave', 'ù'),
			_Utils_Tuple2('uHar', '⥣'),
			_Utils_Tuple2('uharl', '↿'),
			_Utils_Tuple2('uharr', '↾'),
			_Utils_Tuple2('uhblk', '▀'),
			_Utils_Tuple2('ulcorn', '⌜'),
			_Utils_Tuple2('ulcorner', '⌜'),
			_Utils_Tuple2('ulcrop', '⌏'),
			_Utils_Tuple2('ultri', '◸'),
			_Utils_Tuple2('Umacr', 'Ū'),
			_Utils_Tuple2('umacr', 'ū'),
			_Utils_Tuple2('uml', '¨'),
			_Utils_Tuple2('UnderBar', '_'),
			_Utils_Tuple2('UnderBrace', '⏟'),
			_Utils_Tuple2('UnderBracket', '⎵'),
			_Utils_Tuple2('UnderParenthesis', '⏝'),
			_Utils_Tuple2('Union', '⋃'),
			_Utils_Tuple2('UnionPlus', '⊎'),
			_Utils_Tuple2('Uogon', 'Ų'),
			_Utils_Tuple2('uogon', 'ų'),
			_Utils_Tuple2('Uopf', '\uD835\uDD4C'),
			_Utils_Tuple2('uopf', '\uD835\uDD66'),
			_Utils_Tuple2('UpArrowBar', '⤒'),
			_Utils_Tuple2('uparrow', '↑'),
			_Utils_Tuple2('UpArrow', '↑'),
			_Utils_Tuple2('Uparrow', '⇑'),
			_Utils_Tuple2('UpArrowDownArrow', '⇅'),
			_Utils_Tuple2('updownarrow', '↕'),
			_Utils_Tuple2('UpDownArrow', '↕'),
			_Utils_Tuple2('Updownarrow', '⇕'),
			_Utils_Tuple2('UpEquilibrium', '⥮'),
			_Utils_Tuple2('upharpoonleft', '↿'),
			_Utils_Tuple2('upharpoonright', '↾'),
			_Utils_Tuple2('uplus', '⊎'),
			_Utils_Tuple2('UpperLeftArrow', '↖'),
			_Utils_Tuple2('UpperRightArrow', '↗'),
			_Utils_Tuple2('upsi', 'υ'),
			_Utils_Tuple2('Upsi', 'ϒ'),
			_Utils_Tuple2('upsih', 'ϒ'),
			_Utils_Tuple2('Upsilon', 'Υ'),
			_Utils_Tuple2('upsilon', 'υ'),
			_Utils_Tuple2('UpTeeArrow', '↥'),
			_Utils_Tuple2('UpTee', '⊥'),
			_Utils_Tuple2('upuparrows', '⇈'),
			_Utils_Tuple2('urcorn', '⌝'),
			_Utils_Tuple2('urcorner', '⌝'),
			_Utils_Tuple2('urcrop', '⌎'),
			_Utils_Tuple2('Uring', 'Ů'),
			_Utils_Tuple2('uring', 'ů'),
			_Utils_Tuple2('urtri', '◹'),
			_Utils_Tuple2('Uscr', '\uD835\uDCB0'),
			_Utils_Tuple2('uscr', '\uD835\uDCCA'),
			_Utils_Tuple2('utdot', '⋰'),
			_Utils_Tuple2('Utilde', 'Ũ'),
			_Utils_Tuple2('utilde', 'ũ'),
			_Utils_Tuple2('utri', '▵'),
			_Utils_Tuple2('utrif', '▴'),
			_Utils_Tuple2('uuarr', '⇈'),
			_Utils_Tuple2('Uuml', 'Ü'),
			_Utils_Tuple2('uuml', 'ü'),
			_Utils_Tuple2('uwangle', '⦧'),
			_Utils_Tuple2('vangrt', '⦜'),
			_Utils_Tuple2('varepsilon', 'ϵ'),
			_Utils_Tuple2('varkappa', 'ϰ'),
			_Utils_Tuple2('varnothing', '∅'),
			_Utils_Tuple2('varphi', 'ϕ'),
			_Utils_Tuple2('varpi', 'ϖ'),
			_Utils_Tuple2('varpropto', '∝'),
			_Utils_Tuple2('varr', '↕'),
			_Utils_Tuple2('vArr', '⇕'),
			_Utils_Tuple2('varrho', 'ϱ'),
			_Utils_Tuple2('varsigma', 'ς'),
			_Utils_Tuple2('varsubsetneq', '⊊︀'),
			_Utils_Tuple2('varsubsetneqq', '⫋︀'),
			_Utils_Tuple2('varsupsetneq', '⊋︀'),
			_Utils_Tuple2('varsupsetneqq', '⫌︀'),
			_Utils_Tuple2('vartheta', 'ϑ'),
			_Utils_Tuple2('vartriangleleft', '⊲'),
			_Utils_Tuple2('vartriangleright', '⊳'),
			_Utils_Tuple2('vBar', '⫨'),
			_Utils_Tuple2('Vbar', '⫫'),
			_Utils_Tuple2('vBarv', '⫩'),
			_Utils_Tuple2('Vcy', 'В'),
			_Utils_Tuple2('vcy', 'в'),
			_Utils_Tuple2('vdash', '⊢'),
			_Utils_Tuple2('vDash', '⊨'),
			_Utils_Tuple2('Vdash', '⊩'),
			_Utils_Tuple2('VDash', '⊫'),
			_Utils_Tuple2('Vdashl', '⫦'),
			_Utils_Tuple2('veebar', '⊻'),
			_Utils_Tuple2('vee', '∨'),
			_Utils_Tuple2('Vee', '⋁'),
			_Utils_Tuple2('veeeq', '≚'),
			_Utils_Tuple2('vellip', '⋮'),
			_Utils_Tuple2('verbar', '|'),
			_Utils_Tuple2('Verbar', '‖'),
			_Utils_Tuple2('vert', '|'),
			_Utils_Tuple2('Vert', '‖'),
			_Utils_Tuple2('VerticalBar', '∣'),
			_Utils_Tuple2('VerticalLine', '|'),
			_Utils_Tuple2('VerticalSeparator', '❘'),
			_Utils_Tuple2('VerticalTilde', '≀'),
			_Utils_Tuple2('VeryThinSpace', '\u200A'),
			_Utils_Tuple2('Vfr', '\uD835\uDD19'),
			_Utils_Tuple2('vfr', '\uD835\uDD33'),
			_Utils_Tuple2('vltri', '⊲'),
			_Utils_Tuple2('vnsub', '⊂⃒'),
			_Utils_Tuple2('vnsup', '⊃⃒'),
			_Utils_Tuple2('Vopf', '\uD835\uDD4D'),
			_Utils_Tuple2('vopf', '\uD835\uDD67'),
			_Utils_Tuple2('vprop', '∝'),
			_Utils_Tuple2('vrtri', '⊳'),
			_Utils_Tuple2('Vscr', '\uD835\uDCB1'),
			_Utils_Tuple2('vscr', '\uD835\uDCCB'),
			_Utils_Tuple2('vsubnE', '⫋︀'),
			_Utils_Tuple2('vsubne', '⊊︀'),
			_Utils_Tuple2('vsupnE', '⫌︀'),
			_Utils_Tuple2('vsupne', '⊋︀'),
			_Utils_Tuple2('Vvdash', '⊪'),
			_Utils_Tuple2('vzigzag', '⦚'),
			_Utils_Tuple2('Wcirc', 'Ŵ'),
			_Utils_Tuple2('wcirc', 'ŵ'),
			_Utils_Tuple2('wedbar', '⩟'),
			_Utils_Tuple2('wedge', '∧'),
			_Utils_Tuple2('Wedge', '⋀'),
			_Utils_Tuple2('wedgeq', '≙'),
			_Utils_Tuple2('weierp', '℘'),
			_Utils_Tuple2('Wfr', '\uD835\uDD1A'),
			_Utils_Tuple2('wfr', '\uD835\uDD34'),
			_Utils_Tuple2('Wopf', '\uD835\uDD4E'),
			_Utils_Tuple2('wopf', '\uD835\uDD68'),
			_Utils_Tuple2('wp', '℘'),
			_Utils_Tuple2('wr', '≀'),
			_Utils_Tuple2('wreath', '≀'),
			_Utils_Tuple2('Wscr', '\uD835\uDCB2'),
			_Utils_Tuple2('wscr', '\uD835\uDCCC'),
			_Utils_Tuple2('xcap', '⋂'),
			_Utils_Tuple2('xcirc', '◯'),
			_Utils_Tuple2('xcup', '⋃'),
			_Utils_Tuple2('xdtri', '▽'),
			_Utils_Tuple2('Xfr', '\uD835\uDD1B'),
			_Utils_Tuple2('xfr', '\uD835\uDD35'),
			_Utils_Tuple2('xharr', '⟷'),
			_Utils_Tuple2('xhArr', '⟺'),
			_Utils_Tuple2('Xi', 'Ξ'),
			_Utils_Tuple2('xi', 'ξ'),
			_Utils_Tuple2('xlarr', '⟵'),
			_Utils_Tuple2('xlArr', '⟸'),
			_Utils_Tuple2('xmap', '⟼'),
			_Utils_Tuple2('xnis', '⋻'),
			_Utils_Tuple2('xodot', '⨀'),
			_Utils_Tuple2('Xopf', '\uD835\uDD4F'),
			_Utils_Tuple2('xopf', '\uD835\uDD69'),
			_Utils_Tuple2('xoplus', '⨁'),
			_Utils_Tuple2('xotime', '⨂'),
			_Utils_Tuple2('xrarr', '⟶'),
			_Utils_Tuple2('xrArr', '⟹'),
			_Utils_Tuple2('Xscr', '\uD835\uDCB3'),
			_Utils_Tuple2('xscr', '\uD835\uDCCD'),
			_Utils_Tuple2('xsqcup', '⨆'),
			_Utils_Tuple2('xuplus', '⨄'),
			_Utils_Tuple2('xutri', '△'),
			_Utils_Tuple2('xvee', '⋁'),
			_Utils_Tuple2('xwedge', '⋀'),
			_Utils_Tuple2('Yacute', 'Ý'),
			_Utils_Tuple2('yacute', 'ý'),
			_Utils_Tuple2('YAcy', 'Я'),
			_Utils_Tuple2('yacy', 'я'),
			_Utils_Tuple2('Ycirc', 'Ŷ'),
			_Utils_Tuple2('ycirc', 'ŷ'),
			_Utils_Tuple2('Ycy', 'Ы'),
			_Utils_Tuple2('ycy', 'ы'),
			_Utils_Tuple2('yen', '¥'),
			_Utils_Tuple2('Yfr', '\uD835\uDD1C'),
			_Utils_Tuple2('yfr', '\uD835\uDD36'),
			_Utils_Tuple2('YIcy', 'Ї'),
			_Utils_Tuple2('yicy', 'ї'),
			_Utils_Tuple2('Yopf', '\uD835\uDD50'),
			_Utils_Tuple2('yopf', '\uD835\uDD6A'),
			_Utils_Tuple2('Yscr', '\uD835\uDCB4'),
			_Utils_Tuple2('yscr', '\uD835\uDCCE'),
			_Utils_Tuple2('YUcy', 'Ю'),
			_Utils_Tuple2('yucy', 'ю'),
			_Utils_Tuple2('yuml', 'ÿ'),
			_Utils_Tuple2('Yuml', 'Ÿ'),
			_Utils_Tuple2('Zacute', 'Ź'),
			_Utils_Tuple2('zacute', 'ź'),
			_Utils_Tuple2('Zcaron', 'Ž'),
			_Utils_Tuple2('zcaron', 'ž'),
			_Utils_Tuple2('Zcy', 'З'),
			_Utils_Tuple2('zcy', 'з'),
			_Utils_Tuple2('Zdot', 'Ż'),
			_Utils_Tuple2('zdot', 'ż'),
			_Utils_Tuple2('zeetrf', 'ℨ'),
			_Utils_Tuple2('ZeroWidthSpace', '\u200B'),
			_Utils_Tuple2('Zeta', 'Ζ'),
			_Utils_Tuple2('zeta', 'ζ'),
			_Utils_Tuple2('zfr', '\uD835\uDD37'),
			_Utils_Tuple2('Zfr', 'ℨ'),
			_Utils_Tuple2('ZHcy', 'Ж'),
			_Utils_Tuple2('zhcy', 'ж'),
			_Utils_Tuple2('zigrarr', '⇝'),
			_Utils_Tuple2('zopf', '\uD835\uDD6B'),
			_Utils_Tuple2('Zopf', 'ℤ'),
			_Utils_Tuple2('Zscr', '\uD835\uDCB5'),
			_Utils_Tuple2('zscr', '\uD835\uDCCF'),
			_Utils_Tuple2('zwj', '\u200D'),
			_Utils_Tuple2('zwnj', '\u200C')
		]));
var $hecrj$html_parser$Html$Parser$namedCharacterReference = A2(
	$elm$parser$Parser$map,
	function (reference) {
		return A2(
			$elm$core$Maybe$withDefault,
			'&' + (reference + ';'),
			A2($elm$core$Dict$get, reference, $hecrj$html_parser$Html$Parser$NamedCharacterReferences$dict));
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isAlpha)));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Char$isHexDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return ((48 <= code) && (code <= 57)) || (((65 <= code) && (code <= 70)) || ((97 <= code) && (code <= 102)));
};
var $hecrj$html_parser$Html$Parser$hexadecimal = A2(
	$elm$parser$Parser$andThen,
	function (hex) {
		var _v0 = $rtfeldman$elm_hex$Hex$fromString(
			$elm$core$String$toLower(hex));
		if (!_v0.$) {
			var value = _v0.a;
			return $elm$parser$Parser$succeed(value);
		} else {
			var error = _v0.a;
			return $elm$parser$Parser$problem(error);
		}
	},
	$elm$parser$Parser$getChompedString(
		$hecrj$html_parser$Html$Parser$chompOneOrMore($elm$core$Char$isHexDigit)));
var $elm$parser$Parser$ExpectingInt = {$: 1};
var $elm$parser$Parser$Advanced$consumeBase = _Parser_consumeBase;
var $elm$parser$Parser$Advanced$consumeBase16 = _Parser_consumeBase16;
var $elm$parser$Parser$Advanced$bumpOffset = F2(
	function (newOffset, s) {
		return {kA: s.kA + (newOffset - s.f), l: s.l, p: s.p, f: newOffset, mR: s.mR, e: s.e};
	});
var $elm$parser$Parser$Advanced$chompBase10 = _Parser_chompBase10;
var $elm$parser$Parser$Advanced$isAsciiCode = _Parser_isAsciiCode;
var $elm$parser$Parser$Advanced$consumeExp = F2(
	function (offset, src) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 101, offset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 69, offset, src)) {
			var eOffset = offset + 1;
			var expOffset = (A3($elm$parser$Parser$Advanced$isAsciiCode, 43, eOffset, src) || A3($elm$parser$Parser$Advanced$isAsciiCode, 45, eOffset, src)) ? (eOffset + 1) : eOffset;
			var newOffset = A2($elm$parser$Parser$Advanced$chompBase10, expOffset, src);
			return _Utils_eq(expOffset, newOffset) ? (-newOffset) : newOffset;
		} else {
			return offset;
		}
	});
var $elm$parser$Parser$Advanced$consumeDotAndExp = F2(
	function (offset, src) {
		return A3($elm$parser$Parser$Advanced$isAsciiCode, 46, offset, src) ? A2(
			$elm$parser$Parser$Advanced$consumeExp,
			A2($elm$parser$Parser$Advanced$chompBase10, offset + 1, src),
			src) : A2($elm$parser$Parser$Advanced$consumeExp, offset, src);
	});
var $elm$parser$Parser$Advanced$finalizeInt = F5(
	function (invalid, handler, startOffset, _v0, s) {
		var endOffset = _v0.a;
		var n = _v0.b;
		if (handler.$ === 1) {
			var x = handler.a;
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A2($elm$parser$Parser$Advanced$fromState, s, x));
		} else {
			var toValue = handler.a;
			return _Utils_eq(startOffset, endOffset) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				_Utils_cmp(s.f, startOffset) < 0,
				A2($elm$parser$Parser$Advanced$fromState, s, invalid)) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				toValue(n),
				A2($elm$parser$Parser$Advanced$bumpOffset, endOffset, s));
		}
	});
var $elm$core$String$toFloat = _String_toFloat;
var $elm$parser$Parser$Advanced$finalizeFloat = F6(
	function (invalid, expecting, intSettings, floatSettings, intPair, s) {
		var intOffset = intPair.a;
		var floatOffset = A2($elm$parser$Parser$Advanced$consumeDotAndExp, intOffset, s.e);
		if (floatOffset < 0) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				true,
				A4($elm$parser$Parser$Advanced$fromInfo, s.mR, s.kA - (floatOffset + s.f), invalid, s.l));
		} else {
			if (_Utils_eq(s.f, floatOffset)) {
				return A2(
					$elm$parser$Parser$Advanced$Bad,
					false,
					A2($elm$parser$Parser$Advanced$fromState, s, expecting));
			} else {
				if (_Utils_eq(intOffset, floatOffset)) {
					return A5($elm$parser$Parser$Advanced$finalizeInt, invalid, intSettings, s.f, intPair, s);
				} else {
					if (floatSettings.$ === 1) {
						var x = floatSettings.a;
						return A2(
							$elm$parser$Parser$Advanced$Bad,
							true,
							A2($elm$parser$Parser$Advanced$fromState, s, invalid));
					} else {
						var toValue = floatSettings.a;
						var _v1 = $elm$core$String$toFloat(
							A3($elm$core$String$slice, s.f, floatOffset, s.e));
						if (_v1.$ === 1) {
							return A2(
								$elm$parser$Parser$Advanced$Bad,
								true,
								A2($elm$parser$Parser$Advanced$fromState, s, invalid));
						} else {
							var n = _v1.a;
							return A3(
								$elm$parser$Parser$Advanced$Good,
								true,
								toValue(n),
								A2($elm$parser$Parser$Advanced$bumpOffset, floatOffset, s));
						}
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$number = function (c) {
	return function (s) {
		if (A3($elm$parser$Parser$Advanced$isAsciiCode, 48, s.f, s.e)) {
			var zeroOffset = s.f + 1;
			var baseOffset = zeroOffset + 1;
			return A3($elm$parser$Parser$Advanced$isAsciiCode, 120, zeroOffset, s.e) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ln,
				c.iw,
				baseOffset,
				A2($elm$parser$Parser$Advanced$consumeBase16, baseOffset, s.e),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 111, zeroOffset, s.e) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ln,
				c.i0,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 8, baseOffset, s.e),
				s) : (A3($elm$parser$Parser$Advanced$isAsciiCode, 98, zeroOffset, s.e) ? A5(
				$elm$parser$Parser$Advanced$finalizeInt,
				c.ln,
				c.h$,
				baseOffset,
				A3($elm$parser$Parser$Advanced$consumeBase, 2, baseOffset, s.e),
				s) : A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.ln,
				c.$9,
				c.iE,
				c.iq,
				_Utils_Tuple2(zeroOffset, 0),
				s)));
		} else {
			return A6(
				$elm$parser$Parser$Advanced$finalizeFloat,
				c.ln,
				c.$9,
				c.iE,
				c.iq,
				A3($elm$parser$Parser$Advanced$consumeBase, 10, s.f, s.e),
				s);
		}
	};
};
var $elm$parser$Parser$Advanced$int = F2(
	function (expecting, invalid) {
		return $elm$parser$Parser$Advanced$number(
			{
				h$: $elm$core$Result$Err(invalid),
				$9: expecting,
				iq: $elm$core$Result$Err(invalid),
				iw: $elm$core$Result$Err(invalid),
				iE: $elm$core$Result$Ok($elm$core$Basics$identity),
				ln: invalid,
				i0: $elm$core$Result$Err(invalid)
			});
	});
var $elm$parser$Parser$int = A2($elm$parser$Parser$Advanced$int, $elm$parser$Parser$ExpectingInt, $elm$parser$Parser$ExpectingInt);
var $hecrj$html_parser$Html$Parser$numericCharacterReference = function () {
	var codepoint = $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						function (c) {
							return (c === 'x') || (c === 'X');
						})),
				$hecrj$html_parser$Html$Parser$hexadecimal),
				A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompWhile(
						$elm$core$Basics$eq('0'))),
				$elm$parser$Parser$int)
			]));
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq('#'))),
		A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, $elm$core$Char$fromCode, $elm$core$String$fromChar),
			codepoint));
}();
var $hecrj$html_parser$Html$Parser$characterReference = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$chompIf(
			$elm$core$Basics$eq('&'))),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$namedCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$backtrackable($hecrj$html_parser$Html$Parser$numericCharacterReference),
				$hecrj$html_parser$Html$Parser$chompSemicolon),
				$elm$parser$Parser$succeed('&')
			])));
var $hecrj$html_parser$Html$Parser$tagAttributeQuotedValue = function (quote) {
	var isQuotedValueChar = function (c) {
		return (!_Utils_eq(c, quote)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))),
		A2(
			$elm$parser$Parser$ignorer,
			A2(
				$elm$parser$Parser$map,
				$elm$core$String$join(''),
				$hecrj$html_parser$Html$Parser$many(
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$getChompedString(
								$hecrj$html_parser$Html$Parser$chompOneOrMore(isQuotedValueChar)),
								$hecrj$html_parser$Html$Parser$characterReference
							])))),
			$elm$parser$Parser$chompIf(
				$elm$core$Basics$eq(quote))));
};
var $hecrj$html_parser$Html$Parser$oneOrMore = F2(
	function (type_, parser_) {
		return A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			function (list) {
				return $elm$parser$Parser$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$map,
							function (_new) {
								return $elm$parser$Parser$Loop(
									A2($elm$core$List$cons, _new, list));
							},
							parser_),
							$elm$core$List$isEmpty(list) ? $elm$parser$Parser$problem('expecting at least one ' + type_) : $elm$parser$Parser$succeed(
							$elm$parser$Parser$Done(
								$elm$core$List$reverse(list)))
						]));
			});
	});
var $hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue = function () {
	var isUnquotedValueChar = function (c) {
		return (!$hecrj$html_parser$Html$Parser$isSpaceCharacter(c)) && ((c !== '\"') && ((c !== '\'') && ((c !== '=') && ((c !== '<') && ((c !== '>') && ((c !== '`') && (c !== '&')))))));
	};
	return A2(
		$elm$parser$Parser$map,
		$elm$core$String$join(''),
		A2(
			$hecrj$html_parser$Html$Parser$oneOrMore,
			'attribute value',
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$getChompedString(
						$hecrj$html_parser$Html$Parser$chompOneOrMore(isUnquotedValueChar)),
						$hecrj$html_parser$Html$Parser$characterReference
					]))));
}();
var $hecrj$html_parser$Html$Parser$tagAttributeValue = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('='))),
				$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						$hecrj$html_parser$Html$Parser$tagAttributeUnquotedValue,
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\"'),
						$hecrj$html_parser$Html$Parser$tagAttributeQuotedValue('\'')
					]))),
			$elm$parser$Parser$succeed('')
		]));
var $hecrj$html_parser$Html$Parser$tagAttribute = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Tuple$pair),
		A2(
			$elm$parser$Parser$ignorer,
			$hecrj$html_parser$Html$Parser$tagAttributeName,
			$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
	A2(
		$elm$parser$Parser$ignorer,
		$hecrj$html_parser$Html$Parser$tagAttributeValue,
		$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter)));
var $hecrj$html_parser$Html$Parser$tagAttributes = $hecrj$html_parser$Html$Parser$many($hecrj$html_parser$Html$Parser$tagAttribute);
var $hecrj$html_parser$Html$Parser$tagName = A2(
	$elm$parser$Parser$map,
	$elm$core$String$toLower,
	$elm$parser$Parser$getChompedString(
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$chompIf($elm$core$Char$isAlphaNum),
			$elm$parser$Parser$chompWhile(
				function (c) {
					return $elm$core$Char$isAlphaNum(c) || (c === '-');
				}))));
var $hecrj$html_parser$Html$Parser$Text = function (a) {
	return {$: 0, a: a};
};
var $hecrj$html_parser$Html$Parser$text = A2(
	$elm$parser$Parser$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$String$join(''),
		$hecrj$html_parser$Html$Parser$Text),
	A2(
		$hecrj$html_parser$Html$Parser$oneOrMore,
		'text element',
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$getChompedString(
					$hecrj$html_parser$Html$Parser$chompOneOrMore(
						function (c) {
							return (c !== '<') && (c !== '&');
						})),
					$hecrj$html_parser$Html$Parser$characterReference
				]))));
function $hecrj$html_parser$Html$Parser$cyclic$node() {
	return $elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				$hecrj$html_parser$Html$Parser$text,
				$hecrj$html_parser$Html$Parser$comment,
				$hecrj$html_parser$Html$Parser$cyclic$element()
			]));
}
function $hecrj$html_parser$Html$Parser$cyclic$element() {
	return A2(
		$elm$parser$Parser$andThen,
		function (_v0) {
			var name = _v0.a;
			var attributes = _v0.b;
			return $hecrj$html_parser$Html$Parser$isVoidElement(name) ? A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A3($hecrj$html_parser$Html$Parser$Element, name, attributes, _List_Nil)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$chompIf(
								$elm$core$Basics$eq('/')),
								$elm$parser$Parser$succeed(0)
							]))),
				$elm$parser$Parser$chompIf(
					$elm$core$Basics$eq('>'))) : A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A2($hecrj$html_parser$Html$Parser$Element, name, attributes)),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('>'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$many(
						$elm$parser$Parser$backtrackable(
							$hecrj$html_parser$Html$Parser$cyclic$node())),
					$hecrj$html_parser$Html$Parser$closingTag(name)));
		},
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Tuple$pair),
					$elm$parser$Parser$chompIf(
						$elm$core$Basics$eq('<'))),
				A2(
					$elm$parser$Parser$ignorer,
					$hecrj$html_parser$Html$Parser$tagName,
					$elm$parser$Parser$chompWhile($hecrj$html_parser$Html$Parser$isSpaceCharacter))),
			$hecrj$html_parser$Html$Parser$tagAttributes));
}
var $hecrj$html_parser$Html$Parser$node = $hecrj$html_parser$Html$Parser$cyclic$node();
$hecrj$html_parser$Html$Parser$cyclic$node = function () {
	return $hecrj$html_parser$Html$Parser$node;
};
var $hecrj$html_parser$Html$Parser$element = $hecrj$html_parser$Html$Parser$cyclic$element();
$hecrj$html_parser$Html$Parser$cyclic$element = function () {
	return $hecrj$html_parser$Html$Parser$element;
};
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {kA: col, mB: problem, mR: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.mR, p.kA, p.mB);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{kA: 1, l: _List_Nil, p: 1, f: 0, mR: 1, e: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $hecrj$html_parser$Html$Parser$run = function (str) {
	return $elm$core$String$isEmpty(str) ? $elm$core$Result$Ok(_List_Nil) : A2(
		$elm$parser$Parser$run,
		A2($hecrj$html_parser$Html$Parser$oneOrMore, 'node', $hecrj$html_parser$Html$Parser$node),
		str);
};
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $hecrj$html_parser$Html$Parser$Util$toAttribute = function (_v0) {
	var name = _v0.a;
	var value = _v0.b;
	return A2($elm$html$Html$Attributes$attribute, name, value);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDom = function (nodes) {
	return A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach, nodes);
};
var $hecrj$html_parser$Html$Parser$Util$toVirtualDomEach = function (node) {
	switch (node.$) {
		case 1:
			var name = node.a;
			var attrs = node.b;
			var children = node.c;
			return A3(
				$elm$html$Html$node,
				name,
				A2($elm$core$List$map, $hecrj$html_parser$Html$Parser$Util$toAttribute, attrs),
				$hecrj$html_parser$Html$Parser$Util$toVirtualDom(children));
		case 0:
			var s = node.a;
			return $elm$html$Html$text(s);
		default:
			return $elm$html$Html$text('');
	}
};
var $author$project$UI$textToHtml = function (t) {
	var _v0 = $hecrj$html_parser$Html$Parser$run(t);
	if (!_v0.$) {
		var nodes = _v0.a;
		return $hecrj$html_parser$Html$Parser$Util$toVirtualDom(nodes);
	} else {
		return _List_Nil;
	}
};
var $author$project$UI$caption = F2(
	function (t_, message) {
		var txt = t_(message);
		return A2($elm$core$String$contains, '</', txt) ? A2(
			$elm$html$Html$span,
			_List_Nil,
			$author$project$UI$textToHtml(txt)) : $elm$html$Html$text(txt);
	});
var $elm$html$Html$figure = _VirtualDom_node('figure');
var $elm$html$Html$Attributes$height = function (n) {
	return A2(
		_VirtualDom_attribute,
		'height',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$width = function (n) {
	return A2(
		_VirtualDom_attribute,
		'width',
		$elm$core$String$fromInt(n));
};
var $author$project$Element$Navbar$navbarMedia = F2(
	function (t_, viewConfig) {
		var _v0 = viewConfig.lY;
		if (!_v0.$) {
			var media = _v0.a;
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$figure,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('image is-48x48 is-hidden-touch is-spaced')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-rounded'),
									$elm$html$Html$Attributes$src(media),
									$elm$html$Html$Attributes$alt(
									t_(viewConfig.lO)),
									$elm$html$Html$Attributes$width(48),
									$elm$html$Html$Attributes$height(48)
								]),
							_List_Nil)
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-hidden-desktop')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, viewConfig.lO)
						]))
				]);
		} else {
			return _List_fromArray(
				[
					A2($author$project$UI$caption, t_, viewConfig.lO)
				]);
		}
	});
var $author$project$UI$none = $elm$html$Html$text('');
var $author$project$UI$when = F2(
	function (cond, view) {
		return cond ? view : $author$project$UI$none;
	});
var $author$project$Element$Navbar$navbarItem = F3(
	function (t_, currentRoute, item) {
		switch (item.$) {
			case 0:
				var route = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.kJ;
				var isVisible = viewConfig.g$;
				return A2(
					$author$project$UI$when,
					isVisible,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$id(dataTag),
								$elm$html$Html$Attributes$class('navbar-item'),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'is-active',
										A2($author$project$Route$isActivePage, currentRoute, route))
									])),
								$elm$html$Html$Events$onClick(
								$author$project$Element$Navbar$NavItemClicked(dataTag)),
								$author$project$Route$href(route)
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
			case 1:
				var action = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.kJ;
				var isVisible = viewConfig.g$;
				return A2(
					$author$project$UI$when,
					isVisible,
					A3(
						$author$project$UI$actionLink,
						action,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
			default:
				var url = item.a;
				var viewConfig = item.b;
				var dataTag = viewConfig.kJ;
				var isVisible = viewConfig.g$;
				return A2(
					$author$project$UI$when,
					isVisible,
					A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$UI$attrCyData(dataTag),
								$elm$html$Html$Attributes$class('navbar-item'),
								$elm$html$Html$Attributes$href(url),
								$elm$html$Html$Attributes$target('_blank')
							]),
						A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)));
		}
	});
var $author$project$Element$Navbar$navbarDropDown = F5(
	function (t_, model, isRight, item, navItems) {
		switch (item.$) {
			case 0:
				var route = item.a;
				var viewConfig = item.b;
				return A2(
					$author$project$UI$when,
					viewConfig.g$,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item has-dropdown is-hoverable')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$UI$attrCyData(viewConfig.kJ),
										$elm$html$Html$Attributes$class('navbar-link'),
										$author$project$Route$href(route),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												A3($author$project$Element$Navbar$isParent, model.eL, model.cr, route))
											]))
									]),
								A2($author$project$Element$Navbar$navbarMedia, t_, viewConfig)),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-dropdown is-boxed'),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('is-right', isRight)
											]))
									]),
								A2(
									$elm$core$List$map,
									A2($author$project$Element$Navbar$navbarItem, t_, model.cr),
									navItems))
							])));
			case 1:
				return $author$project$UI$none;
			default:
				return $author$project$UI$none;
		}
	});
var $author$project$Element$Navbar$view = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var viewRightMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-end')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					switch (item.$) {
						case 0:
							return $author$project$UI$none;
						case 1:
							return $author$project$UI$none;
						default:
							var parent = item.a;
							var children = item.b;
							return A5($author$project$Element$Navbar$navbarDropDown, t_, model, true, parent, children);
					}
				},
				model.eL));
		var viewLeftMenu = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-start')
				]),
			A2(
				$elm$core$List$map,
				function (item) {
					switch (item.$) {
						case 0:
							var single = item.a;
							return A3($author$project$Element$Navbar$navbarItem, t_, model.cr, single);
						case 1:
							var parent = item.a;
							var children = item.b;
							return A5($author$project$Element$Navbar$navbarDropDown, t_, model, false, parent, children);
						default:
							return $author$project$UI$none;
					}
				},
				model.eL));
		var viewBrand = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('navbar-brand')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('navbar-item'),
							$author$project$Route$href($author$project$Route$Home),
							$author$project$UI$attrCyData('nav-home')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$img,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$src(model.dW)
								]),
							_List_Nil)
						])),
					A2($author$project$Element$Navbar$navBurger, 'mainNav', $author$project$Element$Navbar$BurgerToggled)
				]));
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'aria-label', 'main navigation'),
					$elm$html$Html$Attributes$class('navbar'),
					A2($elm$html$Html$Attributes$attribute, 'role', 'navigation')
				]),
			_List_fromArray(
				[
					viewBrand,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('navbar-menu'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-active', model.dP)
								])),
							$elm$html$Html$Attributes$id('mainNav')
						]),
					_List_fromArray(
						[viewLeftMenu, viewRightMenu]))
				]));
	});
var $author$project$Element$Navbar$element = {iA: $author$project$Element$Navbar$init, jR: $author$project$Element$Navbar$update, nE: $author$project$Element$Navbar$view};
var $author$project$Main$navbar = {
	h_: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					d0: $elm$core$Maybe$Just(x)
				});
		}),
	gF: $author$project$Element$Navbar$element,
	iV: $author$project$Main$NavbarMsg
};
var $author$project$Application$Boundaries$initElement = F4(
	function (config, session, element, params) {
		return A3(element.gF.iA, config, session, params);
	});
var $author$project$Main$openNavbar = F2(
	function (session_, model) {
		var params = {dW: model.dW, cr: model.cr};
		return A3(
			$author$project$Main$mapProgram,
			model,
			$author$project$Main$navbar,
			A4($author$project$Application$Boundaries$initElement, model.bx, session_, $author$project$Main$navbar, params));
	});
var $author$project$Ports$loadManifest = _Platform_outgoingPort('loadManifest', $elm$json$Json$Encode$string);
var $author$project$Ports$resetManifest = _Platform_outgoingPort(
	'resetManifest',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Pages$toManifestUrl = function (model) {
	switch (model.$) {
		case 20:
			return $elm$core$Maybe$Just('/portfolios.webmanifest');
		case 18:
			return $elm$core$Maybe$Just('/phonebook.webmanifest');
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$andThenLoadManifest = function (_v0) {
	var model = _v0.a;
	var cmd = _v0.b;
	var manifestCmd = A2(
		$elm$core$Maybe$withDefault,
		$author$project$Ports$resetManifest(0),
		A2(
			$elm$core$Maybe$map,
			$author$project$Ports$loadManifest,
			$author$project$Pages$toManifestUrl(model.bu)));
	return _Utils_Tuple2(
		model,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					cmd,
					A2($elm$core$Platform$Cmd$map, $author$project$Main$PageMsg, manifestCmd)
				])));
};
var $author$project$Element$Timetable$Calendar = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$CloseModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$Create = {$: 0};
var $author$project$Element$LearningGroupForm$Create = {$: 0};
var $author$project$Element$PortfolioForm$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$CreateEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$CreateEventSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$CreateModule = {$: 0};
var $author$project$Element$ModulesMain$CreateModuleFromTemplate = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$DuplicateModule = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$FullProfile = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningContracts$List = {$: 1};
var $author$project$Element$ModulesMain$ListModules = {$: 2};
var $author$project$Module$ModuleId = $elm$core$Basics$identity;
var $author$project$Element$PortfolioList$MyChildren = {$: 0};
var $author$project$Element$StudentProfileForm$NekProfile = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$NotAsked = {$: 0};
var $author$project$Element$PortfolioSingle$Page = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricSubjectOverview$Page = $elm$core$Basics$identity;
var $author$project$Element$RubricsList$Page = {$: 0};
var $author$project$Element$RubricsSingle$Page = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioList$SpecificStudents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$Update = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$UpdateEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$Timetable$UpdateEventSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$UpdateGroup = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$UpdateModule = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$ViewModule = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.e),
			s.f) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Form$dateToMillis = function (value) {
	return $elm$time$Time$posixToMillis(
		A2(
			$elm$core$Result$withDefault,
			$elm$time$Time$millisToPosix(0),
			$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(value)));
};
var $author$project$Element$PortfolioList$AnyBody = {$: 2};
var $author$project$Element$PortfolioList$defaultParams = {gG: $elm$core$Maybe$Nothing, g9: _List_Nil, mn: false, hu: $elm$core$Maybe$Nothing, e1: $author$project$Element$PortfolioList$AnyBody};
var $author$project$Application$V2$SharedConfig$fromV1 = function (config) {
	return {gr: config.gr, gv: config.gv};
};
var $author$project$Application$V2$Boundaries$addReply = F2(
	function (reply, _return) {
		return _Utils_update(
			_return,
			{fY: reply});
	});
var $author$project$Application$V2$Boundaries$andThenCmd = F2(
	function (cmd_, _return) {
		return _Utils_update(
			_return,
			{
				dz: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[_return.dz, cmd_]))
			});
	});
var $author$project$Application$V2$Boundaries$save = F2(
	function (model, session) {
		return {dz: $elm$core$Platform$Cmd$none, dY: model, fY: $elm$core$Maybe$Nothing, cv: session};
	});
var $author$project$Application$V2$Boundaries$initElement = F5(
	function (key, config, session, element, params) {
		var _v0 = A3(element.gF.iA, config, session, params);
		var model = _v0.a;
		var effect = _v0.b;
		var reply = _v0.c;
		var cmd = A2(element.gF.hh, key, effect);
		return A2(
			$author$project$Application$V2$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$V2$Boundaries$addReply,
				reply,
				A2($author$project$Application$V2$Boundaries$save, model, session)));
	});
var $author$project$Pages$mapProgram = F3(
	function (model, element, _return) {
		return _Utils_Tuple3(
			A2(element.h_, model, _return.dY),
			A2($elm$core$Platform$Cmd$map, element.iV, _return.dz),
			_return.cv);
	});
var $author$project$Pages$mapProgramV2 = F3(
	function (model, element, _return) {
		return _Utils_Tuple3(
			A2(element.jS, model, _return.dY),
			A2($elm$core$Platform$Cmd$map, element.bZ, _return.dz),
			_return.cv);
	});
var $author$project$Pages$CounterModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$GenericProfileFormModel = function (a) {
	return {$: 19, a: a};
};
var $author$project$Pages$GenericProfileFormMsg = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$GradeReportCardModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$GradeReportCardMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Pages$GradeRequestListModel = function (a) {
	return {$: 5, a: a};
};
var $author$project$Pages$GradeRequestListMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$GradesOverviewModel = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$GradesOverviewMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Pages$HomePageModel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$LearningContractsModel = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$LearningContractsMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Pages$LearningGroupFormModel = function (a) {
	return {$: 10, a: a};
};
var $author$project$Pages$LearningGroupListModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$LearningGroupListMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Pages$LearningGroupSelectorModel = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$LoBrowserModel = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$LoBrowserMsg = function (a) {
	return {$: 11, a: a};
};
var $author$project$Pages$LoStudentOverviewModel = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$LoStudentOverviewMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Pages$ModuleClosureOverviewModel = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$ModuleClosureOverviewMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Pages$ModuleSingleModel = function (a) {
	return {$: 15, a: a};
};
var $author$project$Pages$ModuleTeacherProfilesModel = function (a) {
	return {$: 8, a: a};
};
var $author$project$Pages$ModuleTeacherProfilesMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Pages$ModulesMainModel = function (a) {
	return {$: 14, a: a};
};
var $author$project$Pages$NotificationListModel = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$NotificationListMsg = function (a) {
	return {$: 16, a: a};
};
var $author$project$Pages$PhoneBookModel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Pages$PhoneBookMsg = function (a) {
	return {$: 17, a: a};
};
var $author$project$Pages$PortfolioFormModel = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$PortfolioListModel = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$PortfolioListMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Pages$PortfolioSingleModel = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$PortfolioSingleMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$Pages$RubricSubjectOverviewModel = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$RubricSubjectOverviewMsg = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$RubricsFormModel = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$RubricsFormMsg = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$RubricsListModel = function (a) {
	return {$: 23, a: a};
};
var $author$project$Pages$RubricsListMsg = function (a) {
	return {$: 22, a: a};
};
var $author$project$Pages$RubricsSingleModel = function (a) {
	return {$: 25, a: a};
};
var $author$project$Pages$RubricsSingleMsg = function (a) {
	return {$: 24, a: a};
};
var $author$project$Pages$StudentAbsenceListModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Pages$StudentAbsenceListMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Pages$StudentListModel = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$StudentProfileFormModel = function (a) {
	return {$: 27, a: a};
};
var $author$project$Pages$StudentProfileFormMsg = function (a) {
	return {$: 26, a: a};
};
var $author$project$Pages$SubjectFeedbackCardModel = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$SubjectFeedbackCardMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Pages$TeacherProfileFormModel = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$TeacherProfileFormMsg = function (a) {
	return {$: 29, a: a};
};
var $author$project$Pages$TimetableModel = function (a) {
	return {$: 31, a: a};
};
var $author$project$Pages$TimetableMsg = function (a) {
	return {$: 30, a: a};
};
var $author$project$Pages$TrimesterFeedbackReportModel = function (a) {
	return {$: 32, a: a};
};
var $author$project$Pages$TrimesterFeedbackReportMsg = function (a) {
	return {$: 31, a: a};
};
var $author$project$Form$Create = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Counter$NoEffect = {$: 0};
var $author$project$Form$NotTouched = 0;
var $author$project$Element$Counter$animalOptions = _List_fromArray(
	[
		_Utils_Tuple2('bárány', 'bárány'),
		_Utils_Tuple2('kecske', 'kecske'),
		_Utils_Tuple2('ökör', 'ökör'),
		_Utils_Tuple2('galamb', 'galamb'),
		_Utils_Tuple2('nyúl', 'nyúl')
	]);
var $author$project$Locale$Messages$NOTRANS = function (a) {
	return {$: 0, a: a};
};
var $author$project$Multiselect$Hide = 1;
var $author$project$Multiselect$defaultConfig = {cR: 1, lx: true, nl: 'id_multiselect', ej: _List_Nil};
var $author$project$Multiselect$Closed = 0;
var $author$project$Multiselect$Model = $elm$core$Basics$identity;
var $author$project$Multiselect$initModel = function (config) {
	var values = config.ej;
	var inputInMenu = config.cR;
	return {
		b2: $elm$core$Maybe$Nothing,
		I: values,
		L: $elm$core$List$head(values),
		T: $elm$core$Maybe$Just(''),
		cR: inputInMenu,
		fy: 23.0,
		lx: config.lx,
		bH: false,
		z: _List_Nil,
		N: 0,
		nl: config.nl,
		ej: values
	};
};
var $author$project$Form$toMultiselectValues = function (options) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			$elm$core$List$map(
				function (option) {
					return _Utils_Tuple2(option.nD, option.lO);
				}),
			options));
};
var $author$project$Element$Counter$initAnimalField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				lx: false,
				nl: 'Animal',
				ej: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Locale$Messages$FormRequiredSelection = {$: 68};
var $author$project$Form$requiredChoice = F3(
	function (t_, blankValue, value) {
		return _Utils_eq(blankValue, value) ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredSelection)) : $elm$core$Result$Ok(value);
	});
var $author$project$Form$mapMultiselect = F2(
	function (updateState, field) {
		var view = field.nE;
		return _Utils_update(
			field,
			{
				nE: _Utils_update(
					view,
					{
						eZ: updateState(view.eZ)
					})
			});
	});
var $author$project$Multiselect$getValues = function (_v0) {
	var model = _v0;
	return model.ej;
};
var $author$project$Multiselect$valuesWithoutSelected = function (_v0) {
	var selected = _v0.z;
	var values = _v0.ej;
	return A2(
		$elm$core$List$filter,
		function (value) {
			return !A2($elm$core$List$member, value, selected);
		},
		values);
};
var $author$project$Multiselect$populateValues = F3(
	function (_v0, values, selected) {
		var model = _v0;
		var filtered = $elm$core$List$isEmpty(selected) ? values : $author$project$Multiselect$valuesWithoutSelected(
			{z: selected, ej: values});
		return _Utils_update(
			model,
			{I: filtered, z: selected, ej: values});
	});
var $author$project$Form$setMultiselectSelection_ = F2(
	function (selected, state) {
		return A3(
			$author$project$Multiselect$populateValues,
			state,
			$author$project$Multiselect$getValues(state),
			selected);
	});
var $author$project$Form$setMultiselectSelection = F2(
	function (options, field) {
		var selected = $author$project$Form$toMultiselectValues(
			$elm$core$Maybe$Just(options));
		return A2(
			$author$project$Form$mapMultiselect,
			$author$project$Form$setMultiselectSelection_(selected),
			field);
	});
var $author$project$Element$Counter$buildForm = F2(
	function (t_, animalSelectOptions) {
		var selectedFirstOption = $elm$core$List$head(animalSelectOptions);
		var animalField = {
			kU: false,
			mu: A2($author$project$Form$requiredChoice, t_, '!!!'),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aC: value});
				}),
			nD: function ($) {
				return $.aC;
			},
			nE: {
				kJ: 'animal',
				lj: 'fa-cube',
				lO: t_(
					$author$project$Locale$Messages$NOTRANS('Milyen állatot szeretnél számolni?')),
				mp: $elm$core$Maybe$Just(animalSelectOptions),
				eZ: $author$project$Element$Counter$initAnimalField(
					$elm$core$Maybe$Just(animalSelectOptions)),
				bZ: $author$project$Element$Counter$AnimalMsg
			}
		};
		return {
			aC: A2(
				$author$project$Form$setMultiselectSelection,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (o) {
							return _List_fromArray(
								[o]);
						},
						selectedFirstOption)),
				animalField)
		};
	});
var $author$project$Element$Counter$emptyForm = {aC: 'bárány'};
var $author$project$Form$toSelectOption = function (_v0) {
	var value = _v0.a;
	var label = _v0.b;
	return {lO: label, nD: value};
};
var $author$project$Form$toSelectOptions = function (choices) {
	return A2($elm$core$List$map, $author$project$Form$toSelectOption, choices);
};
var $author$project$Element$Counter$init = F3(
	function (config, session, count) {
		return _Utils_Tuple3(
			{
				br: {
					hQ: $author$project$Form$Create(0),
					bt: A2(
						$author$project$Element$Counter$buildForm,
						session.hy,
						$author$project$Form$toSelectOptions($author$project$Element$Counter$animalOptions)),
					eZ: 0,
					ej: $author$project$Element$Counter$emptyForm
				},
				bN: config,
				dB: A2(
					$elm$core$Maybe$withDefault,
					$elm$core$String$length(session.nH.k3),
					count),
				cv: session
			},
			$author$project$Element$Counter$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$Multiselect$domScrollToY = F2(
	function (id, y) {
		return A2(
			$elm$core$Task$andThen,
			function (vp) {
				return A3($elm$browser$Browser$Dom$setViewportOf, id, vp.jW.nL, y);
			},
			$elm$browser$Browser$Dom$getViewportOf(id));
	});
var $author$project$Multiselect$domScrollY = function (id) {
	return A2(
		$elm$core$Task$map,
		function (vp) {
			return vp.jW.nN;
		},
		$elm$browser$Browser$Dom$getViewportOf(id));
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Multiselect$perform = function (effect) {
	switch (effect.$) {
		case 0:
			return $elm$core$Platform$Cmd$none;
		case 1:
			var effects = effect.a;
			return $elm$core$Platform$Cmd$batch(
				A2($elm$core$List$map, $author$project$Multiselect$perform, effects));
		case 2:
			var elementName = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				$elm$browser$Browser$Dom$focus(elementName));
		case 3:
			var elementName = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				$author$project$Multiselect$domScrollY(elementName));
		case 4:
			var elementName = effect.a;
			var y = effect.b;
			var toMsg = effect.c;
			return A2(
				$elm$core$Task$attempt,
				toMsg,
				A2($author$project$Multiselect$domScrollToY, elementName, y));
		default:
			var ms = effect.a;
			var toMsg = effect.b;
			return A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always(toMsg),
				$elm$core$Process$sleep(ms));
	}
};
var $author$project$Api$postV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var decoder = _v0.dC;
	var toMsg = _v0.bZ;
	var body = _v0.O;
	return $author$project$Api$Endpoint$request(
		{
			O: $elm$http$Http$jsonBody(body),
			a4: A2($author$project$Api$expectJson, toMsg, decoder),
			ah: $author$project$Api$toHeaders(config.gr),
			ba: 'POST',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $author$project$Element$Counter$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 2:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$Counter$perform(key),
						effects));
			default:
				var cmd = effect.a;
				if (!cmd.$) {
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				} else {
					var route = cmd.a;
					return A2($author$project$Route$replaceUrl, key, route);
				}
		}
	});
var $author$project$Element$Counter$Animal = $elm$core$Basics$identity;
var $author$project$Element$Counter$MultiselectEffect = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Multiselect$getSelectedValues = function (_v0) {
	var model = _v0;
	return model.z;
};
var $author$project$Form$getMultiselectFieldSelectedValue = function (field) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			$elm$core$List$head(
				$author$project$Multiselect$getSelectedValues(field.nE.eZ))));
};
var $author$project$Element$Counter$Balance = $elm$core$Basics$identity;
var $author$project$Element$Counter$BatchEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$Counter$Cmd = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$CounterClickCount = F2(
	function (a, b) {
		return {$: 44, a: a, b: b};
	});
var $author$project$Element$Counter$LogOk = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Counter$NoOp = {$: 0};
var $author$project$Element$Counter$UpdateUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Log$msgClick = 'click';
var $author$project$Log$encodeLogEvent = F2(
	function (maxLength, event) {
		var normalizedMessage = A3(
			$elm$core$String$slice,
			0,
			maxLength,
			$author$project$Log$removeWhitespaces(event.cg));
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'client_id',
					$elm$json$Json$Encode$string(event.h8)),
					_Utils_Tuple2(
					'client_version',
					$elm$json$Json$Encode$string(event.cE)),
					_Utils_Tuple2(
					'level',
					$elm$json$Json$Encode$string(
						$author$project$Log$logLevelToString(event.cX))),
					_Utils_Tuple2(
					'event_name',
					$elm$json$Json$Encode$string(
						$author$project$Log$logEventNameToString(event.b3))),
					_Utils_Tuple2(
					'message',
					$elm$json$Json$Encode$string(normalizedMessage))
				]));
	});
var $author$project$Log$okV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var messages = _v0.b;
		var event = {
			h8: config.gr.g6,
			cE: config.gv,
			b3: eventName,
			cX: 1,
			cg: A2($elm$core$String$join, $author$project$Log$msgSeperator, messages)
		};
		return {
			O: A2($author$project$Log$encodeLogEvent, config.gr.g7, event),
			bN: config,
			dC: $elm$json$Json$Decode$succeed(0),
			bZ: toMsg,
			G: $author$project$Api$Endpoint$log(config.gr)
		};
	});
var $author$project$Element$Counter$updateCounter = F2(
	function (counter, model) {
		var session = model.cv;
		var updateUrlCmd = $author$project$Element$Counter$Cmd(
			$author$project$Element$Counter$UpdateUrl(
				$author$project$Route$Counter(
					$elm$core$Maybe$Just(counter))));
		var reply = counter;
		var logCmd = $author$project$Element$Counter$Cmd(
			$author$project$Element$Counter$LogOk(
				A3(
					$author$project$Log$okV2,
					model.bN,
					_Utils_Tuple2(
						$author$project$Log$msgClick,
						_List_fromArray(
							[
								$elm$core$String$fromInt(counter)
							])),
					$elm$core$Basics$always($author$project$Element$Counter$NoOp))));
		var animal = $author$project$Form$getMultiselectFieldSelectedValue(model.br.bt.aC);
		var model2 = _Utils_update(
			model,
			{
				dB: counter,
				cv: A2(
					$author$project$Session$ok,
					model.cv,
					session.hy(
						A2($author$project$Locale$Messages$CounterClickCount, animal, counter)))
			});
		return _Utils_Tuple3(
			model2,
			$author$project$Element$Counter$BatchEffect(
				_List_fromArray(
					[logCmd, updateUrlCmd])),
			$elm$core$Maybe$Just(reply));
	});
var $author$project$Form$EditedButNotSaved = 1;
var $author$project$Form$markEdited = function (field) {
	return _Utils_update(
		field,
		{kU: true});
};
var $author$project$Element$Counter$updateForm = F2(
	function (msg, formPage) {
		var form = formPage.bt;
		var values = formPage.ej;
		var editedFormPage = _Utils_update(
			formPage,
			{eZ: 1});
		var value = msg;
		return _Utils_update(
			editedFormPage,
			{
				bt: _Utils_update(
					form,
					{
						aC: $author$project$Form$markEdited(form.aC)
					}),
				ej: A2(
					form.aC.jR,
					A2($elm$core$Maybe$withDefault, '???', value),
					values)
			});
	});
var $author$project$Multiselect$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Multiselect$Cleared = {$: 2};
var $author$project$Multiselect$DisableProtection = {$: 3};
var $author$project$Multiselect$DomScrollToY = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Multiselect$DomScrollY = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Multiselect$NoEffect = {$: 0};
var $author$project$Multiselect$NotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Multiselect$ScrollResult = function (a) {
	return {$: 9, a: a};
};
var $author$project$Multiselect$ScrollY = function (a) {
	return {$: 14, a: a};
};
var $author$project$Multiselect$Selected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Multiselect$Show = 0;
var $author$project$Multiselect$Unselected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Multiselect$addSelected = F2(
	function (item, model) {
		return model.lx ? _Utils_ap(
			model.z,
			_List_fromArray(
				[item])) : _List_fromArray(
			[item]);
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Multiselect$Keycodes$backspace = 8;
var $author$project$Multiselect$Sleep = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Multiselect$delayInMs = F2(
	function (ms, msg) {
		return A2($author$project$Multiselect$Sleep, ms, msg);
	});
var $author$project$Multiselect$Keycodes$downArrow = 40;
var $author$project$Multiselect$Keycodes$end = 35;
var $author$project$Multiselect$Keycodes$escape = 27;
var $author$project$Multiselect$fitViewPort = F2(
	function (_v0, _v1) {
		var top = _v0.a;
		var bottom = _v0.b;
		var vpTop = _v1.a;
		var vpBottom = _v1.b;
		return (_Utils_cmp(top, vpTop) < 0) ? top : ((_Utils_cmp(bottom, vpBottom) > 0) ? (vpTop + (bottom - vpBottom)) : vpTop);
	});
var $author$project$Multiselect$FocusInput = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Multiselect$FocusResult = function (a) {
	return {$: 8, a: a};
};
var $author$project$Multiselect$focusInput = function (model) {
	return A2($author$project$Multiselect$FocusInput, 'multiselectInput' + model.nl, $author$project$Multiselect$FocusResult);
};
var $author$project$Multiselect$SelectCss$itemHeight = 32;
var $author$project$Multiselect$getBoundaries = function (i) {
	return _Utils_Tuple2(i * $author$project$Multiselect$SelectCss$itemHeight, (i * $author$project$Multiselect$SelectCss$itemHeight) + $author$project$Multiselect$SelectCss$itemHeight);
};
var $author$project$Multiselect$SelectCss$menuHeight = 150;
var $author$project$Multiselect$getViewPortBoundaries = function (i) {
	return _Utils_Tuple2(i, i + $author$project$Multiselect$SelectCss$menuHeight);
};
var $author$project$Multiselect$Keycodes$home = 36;
var $author$project$Multiselect$indexOf = F2(
	function (el, list) {
		var helper = F2(
			function (l, index) {
				helper:
				while (true) {
					if (!l.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var xs = l.b;
						if (_Utils_eq(x, el)) {
							return $elm$core$Maybe$Just(index);
						} else {
							var $temp$l = xs,
								$temp$index = index + 1;
							l = $temp$l;
							index = $temp$index;
							continue helper;
						}
					}
				}
			});
		return A2(helper, list, 0);
	});
var $author$project$Multiselect$lastElem = A2(
	$elm$core$List$foldl,
	A2($elm$core$Basics$composeR, $elm$core$Maybe$Just, $elm$core$Basics$always),
	$elm$core$Maybe$Nothing);
var $author$project$Multiselect$nextItem = F2(
	function (list, item) {
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? $elm$core$List$head(list) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $author$project$Multiselect$nextSelectedItem = F2(
	function (list, item) {
		var takeLast = function (l) {
			if (!l.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				if (!l.b.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var _v3 = l.b;
					var y = _v3.a;
					return $elm$core$Maybe$Just(y);
				}
			}
		};
		var findNextInList = function (l) {
			findNextInList:
			while (true) {
				if (!l.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					if (!l.b.b) {
						var x = l.a;
						return _Utils_eq(x, item) ? takeLast(
							$elm$core$List$reverse(list)) : $elm$core$Maybe$Nothing;
					} else {
						var x = l.a;
						var _v1 = l.b;
						var y = _v1.a;
						var rest = _v1.b;
						if (_Utils_eq(x, item)) {
							return $elm$core$Maybe$Just(y);
						} else {
							var $temp$l = A2($elm$core$List$cons, y, rest);
							l = $temp$l;
							continue findNextInList;
						}
					}
				}
			}
		};
		return findNextInList(list);
	});
var $author$project$Multiselect$Keycodes$pageDown = 34;
var $author$project$Multiselect$Keycodes$pageUp = 33;
var $author$project$Multiselect$prevItem = F2(
	function (list, item) {
		return A2(
			$author$project$Multiselect$nextItem,
			$elm$core$List$reverse(list),
			item);
	});
var $author$project$Multiselect$Keycodes$return = 13;
var $author$project$Multiselect$Keycodes$tab = 9;
var $author$project$Multiselect$Keycodes$upArrow = 38;
var $author$project$Multiselect$update = F2(
	function (msg, _v0) {
		var model = _v0;
		switch (msg.$) {
			case 0:
				return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
			case 4:
				return (model.N === 2) ? _Utils_Tuple3(
					_Utils_update(
						model,
						{N: 0}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{N: 2}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Nothing);
			case 1:
				return model.bH ? _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: false}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{N: 0}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: false}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				return model.bH ? _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing) : _Utils_Tuple3(
					_Utils_update(
						model,
						{bH: true, N: 2}),
					$author$project$Multiselect$BatchEffect(
						_List_fromArray(
							[
								$author$project$Multiselect$focusInput(model),
								A2($author$project$Multiselect$delayInMs, 100, $author$project$Multiselect$DisableProtection)
							])),
					$elm$core$Maybe$Nothing);
			case 9:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b2: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v3 = model.T;
					if (_v3.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just('')
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b2: $elm$core$Maybe$Nothing}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 8:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b2: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v5 = model.T;
					if (_v5.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									T: $elm$core$Maybe$Just('')
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{b2: $elm$core$Maybe$Nothing}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 11:
				var value = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{fy: value}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 10:
				var value = msg.a;
				if (model.bH) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{bH: false}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var lowerValue = $elm$core$String$toLower(value);
					var valuesMatchingSearch = A2(
						$elm$core$List$filter,
						function (_v8) {
							var val = _v8.b;
							return A2(
								$elm$core$String$contains,
								lowerValue,
								$elm$core$String$toLower(val));
						},
						model.ej);
					var maybePrefixedWithValue = ((model.cR === 1) || ((value === '') || A2(
						$elm$core$List$any,
						function (_v7) {
							var val = _v7.b;
							return _Utils_eq(
								$elm$core$String$toLower(val),
								value);
						},
						valuesMatchingSearch))) ? valuesMatchingSearch : A2(
						$elm$core$List$cons,
						_Utils_Tuple2(value, value),
						valuesMatchingSearch);
					var filtered = $author$project$Multiselect$valuesWithoutSelected(
						{z: model.z, ej: maybePrefixedWithValue});
					var _v6 = model.L;
					if (_v6.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: filtered,
									L: $elm$core$List$head(filtered),
									T: $elm$core$Maybe$Just(value),
									N: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v6.a;
						return (!$elm$core$List$length(
							A2(
								$elm$core$List$filter,
								function (i) {
									return _Utils_eq(i, item);
								},
								filtered))) ? _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: filtered,
									L: $elm$core$List$head(filtered),
									T: $elm$core$Maybe$Just(value),
									N: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing) : _Utils_Tuple3(
							_Utils_update(
								model,
								{
									I: filtered,
									T: $elm$core$Maybe$Just(value),
									N: $elm$core$List$isEmpty(filtered) ? 0 : 2
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				}
			case 5:
				var item = msg.a;
				var selected = A2($author$project$Multiselect$addSelected, item, model);
				var filtered = $author$project$Multiselect$valuesWithoutSelected(
					{z: selected, ej: model.ej});
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							I: filtered,
							L: A2($author$project$Multiselect$nextSelectedItem, model.I, item),
							T: $elm$core$Maybe$Nothing,
							z: selected,
							N: ($elm$core$List$isEmpty(filtered) || (!model.lx)) ? 0 : 2
						}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Just(
						$author$project$Multiselect$Selected(item)));
			case 6:
				var item = msg.a;
				var selected = A2(
					$elm$core$List$filter,
					function (value) {
						return !_Utils_eq(value, item);
					},
					model.z);
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							I: $author$project$Multiselect$valuesWithoutSelected(
								{z: selected, ej: model.ej}),
							L: $elm$core$Maybe$Just(item),
							z: selected
						}),
					A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
					$elm$core$Maybe$Just(
						$author$project$Multiselect$Unselected(item)));
			case 7:
				var selected = _List_Nil;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							I: $author$project$Multiselect$valuesWithoutSelected(
								{z: selected, ej: model.ej}),
							T: $elm$core$Maybe$Nothing,
							z: selected,
							N: 0
						}),
					$author$project$Multiselect$focusInput(model),
					$elm$core$Maybe$Just($author$project$Multiselect$Cleared));
			case 12:
				var item = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							L: $elm$core$Maybe$Just(item)
						}),
					$author$project$Multiselect$NoEffect,
					$elm$core$Maybe$Nothing);
			case 14:
				var result = msg.a;
				if (result.$ === 1) {
					var id = result.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								b2: $elm$core$Maybe$Just('Could not find dom id: ' + id)
							}),
						$author$project$Multiselect$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var y = result.a;
					var _v10 = model.L;
					if (_v10.$ === 1) {
						return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
					} else {
						var item = _v10.a;
						var _v11 = A2($author$project$Multiselect$indexOf, item, model.I);
						if (_v11.$ === 1) {
							return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
						} else {
							var idx = _v11.a;
							var vpBoundaries = $author$project$Multiselect$getViewPortBoundaries(y);
							var boundaries = $author$project$Multiselect$getBoundaries(idx);
							var scroll = A2($author$project$Multiselect$fitViewPort, boundaries, vpBoundaries);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{b2: $elm$core$Maybe$Nothing}),
								A3($author$project$Multiselect$DomScrollToY, 'multiselectMenu' + model.nl, scroll, $author$project$Multiselect$ScrollResult),
								$elm$core$Maybe$Nothing);
						}
					}
				}
			default:
				var key = msg.a;
				if (_Utils_eq(key, $author$project$Multiselect$Keycodes$upArrow)) {
					var _v12 = model.L;
					if (_v12.$ === 1) {
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									L: $elm$core$List$head(model.I)
								}),
							$author$project$Multiselect$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						var item = _v12.a;
						var prev = A2($author$project$Multiselect$prevItem, model.I, item);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{L: prev}),
							A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
							$elm$core$Maybe$Nothing);
					}
				} else {
					if (_Utils_eq(key, $author$project$Multiselect$Keycodes$downArrow)) {
						var _v13 = model.L;
						if (_v13.$ === 1) {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										L: $elm$core$List$head(model.I)
									}),
								$author$project$Multiselect$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							var item = _v13.a;
							var next = A2($author$project$Multiselect$nextItem, model.I, item);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{L: next}),
								A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
								$elm$core$Maybe$Nothing);
						}
					} else {
						if (_Utils_eq(key, $author$project$Multiselect$Keycodes$pageUp) || _Utils_eq(key, $author$project$Multiselect$Keycodes$home)) {
							var first = $elm$core$List$head(model.I);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{L: first}),
								A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
								$elm$core$Maybe$Nothing);
						} else {
							if (_Utils_eq(key, $author$project$Multiselect$Keycodes$pageDown) || _Utils_eq(key, $author$project$Multiselect$Keycodes$end)) {
								var last = $author$project$Multiselect$lastElem(model.I);
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{L: last}),
									A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
									$elm$core$Maybe$Nothing);
							} else {
								if (_Utils_eq(key, $author$project$Multiselect$Keycodes$return) && ((model.N === 2) || $elm$core$List$isEmpty(model.I))) {
									var _v14 = model.L;
									if (_v14.$ === 1) {
										var _v15 = model.T;
										if (_v15.$ === 1) {
											return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
										} else {
											if (_v15.a === '') {
												return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
											} else {
												var input_ = _v15.a;
												return _Utils_Tuple3(
													model,
													$author$project$Multiselect$NoEffect,
													$elm$core$Maybe$Just(
														$author$project$Multiselect$NotFound(input_)));
											}
										}
									} else {
										var _v16 = _v14.a;
										var id = _v16.a;
										var val = _v16.b;
										var lowerVal = $elm$core$String$toLower(val);
										if ((!model.cR) && (_Utils_eq(
											$elm$core$Maybe$Just(val),
											model.T) && A2(
											$elm$core$List$all,
											function (_v17) {
												var value = _v17.b;
												return !_Utils_eq(
													$elm$core$String$toLower(value),
													lowerVal);
											},
											model.ej))) {
											return _Utils_Tuple3(
												model,
												$author$project$Multiselect$NoEffect,
												$elm$core$Maybe$Just(
													$author$project$Multiselect$NotFound(val)));
										} else {
											var item = _Utils_Tuple2(id, val);
											var selected = A2($author$project$Multiselect$addSelected, item, model);
											var filtered = $author$project$Multiselect$valuesWithoutSelected(
												{z: selected, ej: model.ej});
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{
														I: filtered,
														L: A2($author$project$Multiselect$nextSelectedItem, model.I, item),
														T: $elm$core$Maybe$Nothing,
														z: selected,
														N: $elm$core$List$isEmpty(filtered) ? 0 : 2
													}),
												$author$project$Multiselect$focusInput(model),
												$elm$core$Maybe$Just(
													$author$project$Multiselect$Selected(item)));
										}
									}
								} else {
									if (_Utils_eq(key, $author$project$Multiselect$Keycodes$escape)) {
										return _Utils_Tuple3(
											_Utils_update(
												model,
												{bH: true, N: 0}),
											$author$project$Multiselect$NoEffect,
											$elm$core$Maybe$Nothing);
									} else {
										if (_Utils_eq(key, $author$project$Multiselect$Keycodes$tab)) {
											return _Utils_Tuple3(
												_Utils_update(
													model,
													{N: 0}),
												$author$project$Multiselect$NoEffect,
												$elm$core$Maybe$Nothing);
										} else {
											if (_Utils_eq(key, $author$project$Multiselect$Keycodes$backspace)) {
												var _v18 = model.T;
												if ((!_v18.$) && (_v18.a === '')) {
													var _v19 = $author$project$Multiselect$lastElem(model.z);
													if (_v19.$ === 1) {
														return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
													} else {
														var item = _v19.a;
														var selected = A2(
															$elm$core$List$filter,
															function (value) {
																return !_Utils_eq(value, item);
															},
															model.z);
														return _Utils_Tuple3(
															_Utils_update(
																model,
																{
																	I: $author$project$Multiselect$valuesWithoutSelected(
																		{z: selected, ej: model.ej}),
																	L: $elm$core$Maybe$Just(item),
																	z: selected
																}),
															$author$project$Multiselect$BatchEffect(
																_List_fromArray(
																	[
																		A2($author$project$Multiselect$DomScrollY, 'multiselectMenu' + model.nl, $author$project$Multiselect$ScrollY),
																		$author$project$Multiselect$focusInput(model)
																	])),
															$elm$core$Maybe$Just(
																$author$project$Multiselect$Unselected(item)));
													}
												} else {
													return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
												}
											} else {
												return _Utils_Tuple3(model, $author$project$Multiselect$NoEffect, $elm$core$Maybe$Nothing);
											}
										}
									}
								}
							}
						}
					}
				}
		}
	});
var $author$project$Form$updateMultiselectField = F2(
	function (fieldMsg, field) {
		var fieldView = field.nE;
		var _v0 = A2($author$project$Multiselect$update, fieldMsg, fieldView.eZ);
		var updatedState = _v0.a;
		var effect = _v0.b;
		var outMsg = _v0.c;
		return _Utils_Tuple3(
			_Utils_update(
				field,
				{
					nE: _Utils_update(
						fieldView,
						{eZ: updatedState})
				}),
			effect,
			outMsg);
	});
var $author$project$Element$Counter$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 1:
				return A2($author$project$Element$Counter$updateCounter, model.dB + 1, model);
			case 2:
				return A2($author$project$Element$Counter$updateCounter, model.dB - 1, model);
			case 3:
				var fieldMsg = msg.a;
				var selector = model.br;
				var form = model.br.bt;
				var field = model.br.bt.aC;
				var _v1 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
				var updatedField = _v1.a;
				var effect = _v1.b;
				var outMsg = _v1.c;
				var formMsg = $elm$core$Maybe$Just(
					$author$project$Form$getMultiselectFieldSelectedValue(updatedField));
				var model2 = _Utils_update(
					model,
					{
						br: _Utils_update(
							selector,
							{
								bt: _Utils_update(
									form,
									{aC: updatedField})
							})
					});
				var model3 = function () {
					if (!outMsg.$) {
						return _Utils_update(
							model2,
							{
								br: A2($author$project$Element$Counter$updateForm, formMsg, model2.br)
							});
					} else {
						return model2;
					}
				}();
				return _Utils_Tuple3(
					model3,
					A2($author$project$Element$Counter$MultiselectEffect, $author$project$Element$Counter$AnimalMsg, effect),
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(model, $author$project$Element$Counter$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$BtnCounterDecrement = {$: 29};
var $author$project$Locale$Messages$BtnCounterIncrement = {$: 30};
var $author$project$Element$Counter$Decrement = {$: 2};
var $author$project$Element$Counter$Increment = {$: 1};
var $elm$html$Html$button = _VirtualDom_node('button');
var $author$project$UI$level_ = F3(
	function (isAlwaysHorizontal, left, right) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('level'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-mobile', isAlwaysHorizontal)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-left')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						left)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-right')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						right))
				]));
	});
var $author$project$UI$level = $author$project$UI$level_(false);
var $elm$html$Html$label = _VirtualDom_node('label');
var $author$project$Locale$Messages$FormOptional = {$: 63};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $elm$html$Html$i = _VirtualDom_node('i');
var $author$project$UI$maybe = F2(
	function (data, viewData) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$UI$none,
			A2($elm$core$Maybe$map, viewData, data));
	});
var $author$project$UI$label_ = F4(
	function (htmlTag, t_, message, field) {
		var message_ = function () {
			if (!message.$) {
				var m = message.a;
				return $elm$core$Maybe$Just(
					t_(m));
			} else {
				return field.mK ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$FormOptional));
			}
		}();
		var messageToHtml = function (m) {
			return A2(
				$author$project$UI$maybe,
				m,
				function (m_) {
					return A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('is-italic has-text-weight-light')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(m_)
							]));
				});
		};
		return A2(
			htmlTag,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('label'),
					$elm$html$Html$Attributes$for(field.nE.kJ)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(field.nE.lO),
					messageToHtml(message_)
				]));
	});
var $author$project$UI$fieldLabel = F2(
	function (t_, field) {
		return A4($author$project$UI$label_, $elm$html$Html$label, t_, $elm$core$Maybe$Nothing, field);
	});
var $author$project$Form$isFieldValid = F2(
	function (field, values) {
		var _v0 = field.mu(
			field.nD(values));
		if (_v0.$ === 1) {
			return false;
		} else {
			return true;
		}
	});
var $author$project$UI$Icon$IconFaClass = function (a) {
	return {$: 2, a: a};
};
var $author$project$UI$Icon$face = function (class_) {
	return $author$project$UI$Icon$IconFaClass(class_);
};
var $author$project$UI$Icon$altText = function (attr) {
	if (attr.$ === 3) {
		var text_ = attr.a;
		return $elm$core$Maybe$Just(text_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$bulmaClass = function (attr) {
	if (!attr.$) {
		var class_ = attr.a;
		return $elm$core$Maybe$Just(class_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$faCategory = function (attr) {
	if (attr.$ === 1) {
		var category_ = attr.a;
		return $elm$core$Maybe$Just(category_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$faClass = function (attr) {
	if (attr.$ === 2) {
		var class_ = attr.a;
		return $elm$core$Maybe$Just(class_);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$UI$Icon$filterAttr = F2(
	function (getAttrValue, attributes) {
		return A2($elm$core$List$filterMap, getAttrValue, attributes);
	});
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$UI$Icon$toClassList = function (classes) {
	return A2(
		$elm$core$List$map,
		function (class_) {
			return _Utils_Tuple2(class_, true);
		},
		classes);
};
var $author$project$UI$Icon$icon = function (attributes) {
	var categoryClass = A2(
		$elm$core$Maybe$withDefault,
		'fas',
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$faCategory, attributes))));
	var altText_ = A2(
		$elm$core$Maybe$withDefault,
		'',
		$elm$core$List$head(
			$elm$core$List$reverse(
				A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$altText, attributes))));
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('icon'),
				$elm$html$Html$Attributes$classList(
				$author$project$UI$Icon$toClassList(
					A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$bulmaClass, attributes)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$i,
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
						$elm$html$Html$Attributes$class(categoryClass),
						$elm$html$Html$Attributes$classList(
						$author$project$UI$Icon$toClassList(
							A2($author$project$UI$Icon$filterAttr, $author$project$UI$Icon$faClass, attributes))),
						$elm$html$Html$Attributes$title(altText_)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('is-sr-only')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(altText_)
							]))
					]))
			]));
};
var $author$project$UI$Icon$IconBulmaClass = function (a) {
	return {$: 0, a: a};
};
var $author$project$UI$Icon$style = function (class_) {
	return $author$project$UI$Icon$IconBulmaClass(class_);
};
var $author$project$UI$Icon$loadingOptions = function (attributes) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$Icon$icon(
				_Utils_ap(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-spinner fa-spin fa-lg'),
							$author$project$UI$Icon$style('is-medium is-block has-text-grey')
						]),
					attributes))
			]));
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Form$fieldError = F2(
	function (field, values) {
		var _v0 = field.mu(
			field.nD(values));
		if (_v0.$ === 1) {
			var error = _v0.a;
			return $elm$core$Maybe$Just(error);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$html$Html$p = _VirtualDom_node('p');
var $author$project$UI$validationError = F2(
	function (field, values) {
		var _v0 = _Utils_Tuple2(
			A2($author$project$Form$fieldError, field, values),
			field.kU);
		if ((!_v0.a.$) && _v0.b) {
			var error = _v0.a.a;
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('help is-danger'),
						$author$project$UI$attrCyData(field.nE.kJ + '-error')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					]));
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Multiselect$ClickOnComponent = {$: 2};
var $author$project$Multiselect$Toggle = {$: 4};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Property = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.nD);
	});
var $rtfeldman$elm_css$Css$borderBottomWidth = $rtfeldman$elm_css$Css$prop1('border-bottom-width');
var $rtfeldman$elm_css$Css$borderColor3 = F3(
	function (c1, c2, c3) {
		var value = c1.nD + (' ' + (c2.nD + (' ' + c3.nD)));
		return A2($rtfeldman$elm_css$Css$property, 'border-color', value);
	});
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $rtfeldman$elm_css$Css$borderRightWidth = $rtfeldman$elm_css$Css$prop1('border-right-width');
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		ep: 1,
		et: 0,
		bM: 0,
		eE: 0,
		eU: 0,
		nD: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$fromList = _String_fromList;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				ep: alpha / 255,
				et: blue,
				bM: 0,
				eE: green,
				eU: red,
				nD: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $rtfeldman$elm_css$Css$inlineBlock = {P: 0, nD: 'inline-block'};
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			hN: 0,
			h4: 0,
			dL: 0,
			a7: 0,
			U: 0,
			dS: 0,
			cd: 0,
			dT: 0,
			dU: 0,
			cV: 0,
			cW: 0,
			bQ: 0,
			dV: 0,
			cl: numericValue,
			ed: 0,
			ei: unitLabel,
			e9: units,
			nD: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $rtfeldman$elm_css$Css$relative = {eR: 0, nD: 'relative'};
var $rtfeldman$elm_css$Css$solid = {bg: 0, dj: 0, nD: 'solid'};
var $rtfeldman$elm_css$Css$transparent = {bM: 0, nD: 'transparent'};
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$zero = {U: 0, dS: 0, cd: 0, dT: 0, dU: 0, cV: 0, cW: 0, mh: 0, cl: 0, fS: 0, ei: '', e9: 0, nD: '0'};
var $author$project$Multiselect$SelectCss$arrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#999'),
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative)
		]));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $author$project$Multiselect$SelectCss$arrowUpside = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$transparent,
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid),
			$rtfeldman$elm_css$Css$borderTopWidth(
			$rtfeldman$elm_css$Css$px(2.5)),
			$rtfeldman$elm_css$Css$borderLeftWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderRightWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$borderBottomWidth(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$width($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-2.5))
		]));
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $rtfeldman$elm_css$Css$cursor = $rtfeldman$elm_css$Css$prop1('cursor');
var $rtfeldman$elm_css$Css$middle = $rtfeldman$elm_css$Css$prop1('middle');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$pointer = {g: 0, nD: 'pointer'};
var $rtfeldman$elm_css$Css$tableCell = {P: 0, nD: 'table-cell'};
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$verticalAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'verticalAlign',
		'vertical-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$Multiselect$SelectCss$arrowWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(25)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$px(5))
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.kK) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.ha, record.kK, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{kK: decl, ha: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactDeclarations = function (declarations) {
	var _v0 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v0.a;
	var compactedDeclarations = _v0.b;
	return A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
};
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.h6;
	var imports = _v0.iz;
	var namespaces = _v0.iW;
	var declarations = _v0.kL;
	return {
		h6: charset,
		kL: $rtfeldman$elm_css$Css$Structure$compactDeclarations(declarations),
		iz: imports,
		iW: namespaces
	};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $rtfeldman$elm_css$Css$String$mapJoinHelp = F4(
	function (map, sep, strs, result) {
		mapJoinHelp:
		while (true) {
			if (!strs.b) {
				return result;
			} else {
				if (!strs.b.b) {
					var first = strs.a;
					return result + (map(first) + '');
				} else {
					var first = strs.a;
					var rest = strs.b;
					var $temp$map = map,
						$temp$sep = sep,
						$temp$strs = rest,
						$temp$result = result + (map(first) + (sep + ''));
					map = $temp$map;
					sep = $temp$sep;
					strs = $temp$strs;
					result = $temp$result;
					continue mapJoinHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$Css$String$mapJoin = F3(
	function (map, sep, strs) {
		return A4($rtfeldman$elm_css$Css$String$mapJoinHelp, map, sep, strs, '');
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.io + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.nD)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, ' and ', expressions);
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
		'\n',
		mediaQueries);
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		function (_v0) {
			var prop = _v0;
			return prop + ';';
		},
		'',
		properties);
};
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors);
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return _Utils_ap(
				str,
				A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, '', repeatableSimpleSelectors));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return $rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator) + (' ' + $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$Maybe$withDefault,
		'',
		A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement));
	return A2(
		$elm$core$String$append,
		A2($elm$core$String$join, ' ', segments),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = function (_v0) {
	var firstSelector = _v0.a;
	var otherSelectors = _v0.b;
	var properties = _v0.c;
	var selectorStr = A3(
		$rtfeldman$elm_css$Css$String$mapJoin,
		$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
		',',
		A2($elm$core$List$cons, firstSelector, otherSelectors));
	return selectorStr + ('{' + ($rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties) + '}'));
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock(styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, ', ', mediaQueries);
			var blocks = A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, '\n', styleBlocks);
			return '@media ' + (query + ('{' + (blocks + '}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.ha;
			var declaration = decl.a.kK;
			return '@keyframes ' + (name + ('{' + (declaration + '}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.h6;
	var imports = _v0.iz;
	var namespaces = _v0.iW;
	var declarations = _v0.kL;
	return $rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$importToString, '\n', imports) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, '\n', namespaces) + (A3($rtfeldman$elm_css$Css$String$mapJoin, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, '\n', declarations) + '')));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $robinheghan$murmur3$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {dy: charsProcessed, dO: hash, jv: seed, d7: shift};
	});
var $robinheghan$murmur3$Murmur3$c1 = 3432918353;
var $robinheghan$murmur3$Murmur3$c2 = 461845907;
var $robinheghan$murmur3$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $robinheghan$murmur3$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $robinheghan$murmur3$Murmur3$finalize = function (data) {
	var acc = (!(!data.dO)) ? (data.jv ^ A2(
		$robinheghan$murmur3$Murmur3$multiplyBy,
		$robinheghan$murmur3$Murmur3$c2,
		A2(
			$robinheghan$murmur3$Murmur3$rotlBy,
			15,
			A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, data.dO)))) : data.jv;
	var h0 = acc ^ data.dy;
	var h1 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($robinheghan$murmur3$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $robinheghan$murmur3$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$robinheghan$murmur3$Murmur3$multiplyBy,
			5,
			A2(
				$robinheghan$murmur3$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$robinheghan$murmur3$Murmur3$multiplyBy,
					$robinheghan$murmur3$Murmur3$c2,
					A2(
						$robinheghan$murmur3$Murmur3$rotlBy,
						15,
						A2($robinheghan$murmur3$Murmur3$multiplyBy, $robinheghan$murmur3$Murmur3$c1, k1))))) + 3864292196;
	});
var $robinheghan$murmur3$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.dO | ((255 & $elm$core$Char$toCode(c)) << data.d7);
		var _v0 = data.d7;
		if (_v0 === 24) {
			return {
				dy: data.dy + 1,
				dO: 0,
				jv: A2($robinheghan$murmur3$Murmur3$mix, data.jv, res),
				d7: 0
			};
		} else {
			return {dy: data.dy + 1, dO: res, jv: data.jv, d7: data.d7 + 8};
		}
	});
var $robinheghan$murmur3$Murmur3$hashString = F2(
	function (seed, str) {
		return $robinheghan$murmur3$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$robinheghan$murmur3$Murmur3$hashFold,
				A4($robinheghan$murmur3$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$initialSeed = 15739;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($robinheghan$murmur3$Murmur3$hashString, $rtfeldman$elm_css$Hash$initialSeed, str)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$PageRule(properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{kK: str, ha: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$PageRule(properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.h6;
	var imports = _v0.iz;
	var namespaces = _v0.iW;
	var snippets = _v0.jx;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {h6: charset, kL: declarations, iz: imports, iW: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {h6: $elm$core$Maybe$Nothing, iz: _List_Nil, iW: _List_Nil, jx: snippets};
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin = '\u0007';
var $rtfeldman$elm_css$VirtualDom$Styled$templateSelector = $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$ClassSelector($rtfeldman$elm_css$VirtualDom$Styled$classnameStandin)
		]));
var $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate = function (styles) {
	if (!styles.b) {
		return '';
	} else {
		var otherwise = styles;
		return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				_List_fromArray(
					[
						A2($rtfeldman$elm_css$VirtualDom$Styled$makeSnippet, styles, $rtfeldman$elm_css$VirtualDom$Styled$templateSelector)
					])));
	}
};
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var cssTemplate = $rtfeldman$elm_css$VirtualDom$Styled$getCssTemplate(styles);
	var classProperty = A2($elm$virtual_dom$VirtualDom$attribute, '', '');
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, true, cssTemplate);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $author$project$Multiselect$withOptions = F2(
	function (options, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			function (m) {
				return {cg: m, fV: options.fV, f7: options.f7};
			},
			decoder);
	});
var $author$project$Multiselect$onClickNoDefault = function (message) {
	var config = {fV: true, f7: true};
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'click',
		A2(
			$author$project$Multiselect$withOptions,
			config,
			$elm$json$Json$Decode$succeed(message)));
};
var $rtfeldman$elm_css$VirtualDom$Styled$attribute = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$attribute, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$rel = $rtfeldman$elm_css$VirtualDom$Styled$attribute('rel');
var $author$project$Multiselect$arrow = function (model) {
	var arrowRel = $author$project$Multiselect$isOpened(model) ? 'arrowUpside' : 'arrow';
	var arrowCss = $author$project$Multiselect$isOpened(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$arrowUpside]) : _List_fromArray(
		[$author$project$Multiselect$SelectCss$arrow]);
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$arrowWrap])),
				$author$project$Multiselect$onClickNoDefault($author$project$Multiselect$Toggle)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(arrowCss),
						$rtfeldman$elm_css$Html$Styled$Attributes$rel(arrowRel)
					]),
				_List_Nil)
			]));
};
var $author$project$Multiselect$Clear = {$: 7};
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $rtfeldman$elm_css$Css$lineHeight = $rtfeldman$elm_css$Css$prop1('line-height');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		cW: 0,
		bQ: 0,
		dV: 0,
		mh: 0,
		fP: 0,
		cl: val,
		ei: '',
		e9: 0,
		nD: $elm$core$String$fromFloat(val)
	};
};
var $author$project$Multiselect$SelectCss$clear = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$fontSize(
			$rtfeldman$elm_css$Css$px(18)),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.nD);
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$hover = $rtfeldman$elm_css$Css$pseudoClass('hover');
var $author$project$Multiselect$SelectCss$clearWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$px(17)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#999')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$tableCell),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$hover(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$color(
					$rtfeldman$elm_css$Css$hex('#D0021B'))
				]))
		]));
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Multiselect$clear = function (_v0) {
	var model = _v0;
	return (!$elm$core$List$isEmpty(model.z)) ? A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$clearWrap])),
				$author$project$Multiselect$onClickNoDefault($author$project$Multiselect$Clear),
				$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectClear' + model.nl)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$clear]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text('×')
					]))
			])) : A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
};
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.nD);
};
var $rtfeldman$elm_css$Css$prop3 = F4(
	function (key, argA, argB, argC) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.nD + (' ' + (argB.nD + (' ' + argC.nD))));
	});
var $rtfeldman$elm_css$Css$border3 = $rtfeldman$elm_css$Css$prop3('border');
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$table = {P: 0, nD: 'table'};
var $author$project$Multiselect$SelectCss$container = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderRadius(
			$rtfeldman$elm_css$Css$px(4)),
			A3(
			$rtfeldman$elm_css$Css$borderColor3,
			$rtfeldman$elm_css$Css$hex('#d9d9d9'),
			$rtfeldman$elm_css$Css$hex('#ccc'),
			$rtfeldman$elm_css$Css$hex('#b3b3b3')),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333')),
			$rtfeldman$elm_css$Css$height(
			$rtfeldman$elm_css$Css$px(34)),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$table)
		]));
var $author$project$Multiselect$controlId = function (_v0) {
	var model = _v0;
	return 'multiselectControl' + model.nl;
};
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.nD);
};
var $author$project$Multiselect$SelectCss$boxShadowCustom = function (p) {
	return A2($rtfeldman$elm_css$Css$property, 'box-shadow', p);
};
var $author$project$Multiselect$SelectCss$focused = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#007eff')),
			$author$project$Multiselect$SelectCss$boxShadowCustom('inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 0 3px rgba(0, 126, 255, 0.1)')
		]));
var $author$project$Multiselect$Focused = 1;
var $author$project$Multiselect$isFocused = function (_v0) {
	var model = _v0;
	return model.N === 1;
};
var $author$project$Multiselect$OnHover = function (a) {
	return {$: 12, a: a};
};
var $author$project$Multiselect$OnSelect = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$absolute = {eR: 0, nD: 'absolute'};
var $rtfeldman$elm_css$Css$borderBottomLeftRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-left-radius');
var $rtfeldman$elm_css$Css$borderBottomRightRadius = $rtfeldman$elm_css$Css$prop1('border-bottom-right-radius');
var $rtfeldman$elm_css$Css$borderTopColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-top-color', c.nD);
};
var $rtfeldman$elm_css$Css$prop4 = F5(
	function (key, argA, argB, argC, argD) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.nD + (' ' + (argB.nD + (' ' + (argC.nD + (' ' + argD.nD))))));
	});
var $rtfeldman$elm_css$Css$boxShadow4 = $rtfeldman$elm_css$Css$prop4('box-shadow');
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		cL: 0,
		fz: 0,
		cW: 0,
		bQ: 0,
		mh: 0,
		fP: 0,
		cl: val,
		ei: '',
		e9: 0,
		nD: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $rtfeldman$elm_css$Css$maxHeight = $rtfeldman$elm_css$Css$prop1('max-height');
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $rtfeldman$elm_css$Css$cssFunction = F2(
	function (funcName, args) {
		return funcName + ('(' + (A2($elm$core$String$join, ',', args) + ')'));
	});
var $rtfeldman$elm_css$Css$rgba = F4(
	function (r, g, b, alpha) {
		return {
			ep: alpha,
			et: b,
			bM: 0,
			eE: g,
			eU: r,
			nD: A2(
				$rtfeldman$elm_css$Css$cssFunction,
				'rgba',
				_Utils_ap(
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[r, g, b])),
					_List_fromArray(
						[
							$elm$core$String$fromFloat(alpha)
						])))
		};
	});
var $rtfeldman$elm_css$Css$scroll = {er: 0, h0: 0, iC: 0, d1: 0, mX: 0, nD: 'scroll'};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$Multiselect$SelectCss$menu = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomRightRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$borderBottomLeftRadius(
			$rtfeldman$elm_css$Css$px(4)),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A3(
			$rtfeldman$elm_css$Css$border3,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$solid,
			$rtfeldman$elm_css$Css$hex('#ccc')),
			$rtfeldman$elm_css$Css$borderTopColor(
			$rtfeldman$elm_css$Css$hex('#e6e6e6')),
			A4(
			$rtfeldman$elm_css$Css$boxShadow4,
			$rtfeldman$elm_css$Css$zero,
			$rtfeldman$elm_css$Css$px(1),
			$rtfeldman$elm_css$Css$zero,
			A4($rtfeldman$elm_css$Css$rgba, 0, 0, 0, 0.06)),
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(-1)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($author$project$Multiselect$SelectCss$menuHeight)),
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100)),
			$rtfeldman$elm_css$Css$zIndex(
			$rtfeldman$elm_css$Css$int(1)),
			$rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$scroll)
		]));
var $rtfeldman$elm_css$Css$prop2 = F3(
	function (key, argA, argB) {
		return A2($rtfeldman$elm_css$Css$property, key, argA.nD + (' ' + argB.nD));
	});
var $rtfeldman$elm_css$Css$padding2 = $rtfeldman$elm_css$Css$prop2('padding');
var $author$project$Multiselect$SelectCss$menuItem = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#666')),
			$rtfeldman$elm_css$Css$cursor($rtfeldman$elm_css$Css$pointer),
			A2(
			$rtfeldman$elm_css$Css$padding2,
			$rtfeldman$elm_css$Css$px(8),
			$rtfeldman$elm_css$Css$px(10)),
			$rtfeldman$elm_css$Css$maxHeight(
			$rtfeldman$elm_css$Css$px($author$project$Multiselect$SelectCss$itemHeight))
		]));
var $author$project$Multiselect$SelectCss$menuItemHovered = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$backgroundColor(
			A4($rtfeldman$elm_css$Css$rgba, 0, 126, 255, 0.08)),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#333'))
		]));
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onMouseOver = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Multiselect$menu = function (_v0) {
	var model = _v0;
	var _v1 = model.N;
	if (_v1 === 2) {
		var hovered = function () {
			var _v3 = model.L;
			if (_v3.$ === 1) {
				return '';
			} else {
				var _v4 = _v3.a;
				var id = _v4.a;
				return id;
			}
		}();
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$Multiselect$SelectCss$menu])),
					$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectMenu' + model.nl)
				]),
			A2(
				$elm$core$List$map,
				function (_v2) {
					var name = _v2.a;
					var value = _v2.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_Utils_eq(name, hovered) ? _List_fromArray(
									[$author$project$Multiselect$SelectCss$menuItemHovered, $author$project$Multiselect$SelectCss$menuItem]) : _List_fromArray(
									[$author$project$Multiselect$SelectCss$menuItem])),
								$author$project$Multiselect$onClickNoDefault(
								$author$project$Multiselect$OnSelect(
									_Utils_Tuple2(name, value))),
								$rtfeldman$elm_css$Html$Styled$Events$onMouseOver(
								$author$project$Multiselect$OnHover(
									_Utils_Tuple2(name, value)))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(value)
							]));
				},
				model.I));
	} else {
		return A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, _List_Nil);
	}
};
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Multiselect$SelectCss$opened = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderBottomLeftRadius($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$borderBottomRightRadius($rtfeldman$elm_css$Css$zero)
		]));
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $author$project$Multiselect$Adjust = function (a) {
	return {$: 11, a: a};
};
var $author$project$Multiselect$Filter = function (a) {
	return {$: 10, a: a};
};
var $author$project$Multiselect$Shortcut = function (a) {
	return {$: 13, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$classList = function (classes) {
	return $rtfeldman$elm_css$Html$Styled$Attributes$class(
		A3(
			$rtfeldman$elm_css$Css$String$mapJoin,
			$elm$core$Tuple$first,
			' ',
			A2($elm$core$List$filter, $elm$core$Tuple$second, classes)));
};
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $rtfeldman$elm_css$Css$border = $rtfeldman$elm_css$Css$prop1('border');
var $rtfeldman$elm_css$Css$initial = {hU: 0, Z: 0, er: 0, hX: 0, du: 0, hY: 0, dv: 0, b0: 0, bg: 0, fj: 0, bM: 0, g: 0, P: 0, dL: 0, gK: 0, eB: 0, fw: 0, cK: 0, a7: 0, eC: 0, w: 0, cL: 0, fz: 0, iI: 0, g0: 0, U: 0, dS: 0, cd: 0, dT: 0, dU: 0, cV: 0, cW: 0, bQ: 0, dV: 0, fH: 0, i: 0, h: 0, hd: 0, mh: 0, cl: 0, fS: 0, d1: 0, bG: 0, f9: 0, ec: 0, dj: 0, ed: 0, ee: 0, dk: 0, bq: 0, ei: '', e9: 0, nD: 'initial', fa: 0, dq: 0};
var $rtfeldman$elm_css$Css$inherit = _Utils_update(
	$rtfeldman$elm_css$Css$initial,
	{nD: 'inherit'});
var $rtfeldman$elm_css$Css$none = {du: 0, h0: 0, bg: 0, g: 0, P: 0, li: 0, iC: 0, g0: 0, dU: 0, cV: 0, bQ: 0, i: 0, h: 0, hd: 0, fS: 0, mz: 0, bG: 0, f_: 0, mW: 0, ec: 0, dk: 0, bq: 0, B: 0, nB: 0, nD: 'none'};
var $rtfeldman$elm_css$Css$outlineStyle = $rtfeldman$elm_css$Css$prop1('outline-style');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$Multiselect$SelectCss$input = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$border($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$px(14)),
			$rtfeldman$elm_css$Css$outlineStyle($rtfeldman$elm_css$Css$none),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $rtfeldman$elm_css$Css$fontStyle = $rtfeldman$elm_css$Css$prop1('font-style');
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.nD;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $rtfeldman$elm_css$Css$normal = {ip: 0, eC: 0, cL: 0, dV: 0, i4: 0, nD: 'normal', dq: 0};
var $rtfeldman$elm_css$Css$overflow = $rtfeldman$elm_css$Css$prop1('overflow');
var $author$project$Multiselect$SelectCss$inputMirrow = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute),
			$rtfeldman$elm_css$Css$top(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$left(
			$rtfeldman$elm_css$Css$px(-100)),
			$rtfeldman$elm_css$Css$height($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$overflow($rtfeldman$elm_css$Css$scroll),
			$rtfeldman$elm_css$Css$fontWeight($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontStyle($rtfeldman$elm_css$Css$normal),
			$rtfeldman$elm_css$Css$fontSize($rtfeldman$elm_css$Css$inherit),
			$rtfeldman$elm_css$Css$lineHeight(
			$rtfeldman$elm_css$Css$num(1))
		]));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $author$project$Multiselect$SelectCss$inputWrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock),
			$rtfeldman$elm_css$Css$marginLeft(
			$rtfeldman$elm_css$Css$px(5)),
			$rtfeldman$elm_css$Css$padding($rtfeldman$elm_css$Css$zero),
			$rtfeldman$elm_css$Css$verticalAlign($rtfeldman$elm_css$Css$middle),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(8))
		]));
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$previousSibling = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'previousSibling', decoder);
};
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $author$project$Multiselect$onKeyDown = function (tagger) {
	var domF = $debois$elm_dom$DOM$target(
		$debois$elm_dom$DOM$previousSibling($debois$elm_dom$DOM$offsetWidth));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keypress',
		A2($elm$json$Json$Decode$map, tagger, domF));
};
var $rtfeldman$elm_css$Html$Styled$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Multiselect$onKeyPress = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keydown',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$keyCode));
};
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$Multiselect$onKeyUp = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'keyup',
		A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue));
};
var $author$project$Multiselect$Start = {$: 0};
var $author$project$Multiselect$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Multiselect$preventDefaultButtons = function () {
	var options = {fV: true, f7: false};
	var filterKey = function (code) {
		return (_Utils_eq(code, $author$project$Multiselect$Keycodes$upArrow) || _Utils_eq(code, $author$project$Multiselect$Keycodes$downArrow)) ? $elm$core$Result$Ok(code) : $elm$core$Result$Err('ignored input');
	};
	var decoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$always($author$project$Multiselect$Start),
		A2(
			$elm$json$Json$Decode$andThen,
			A2($elm$core$Basics$composeR, filterKey, $author$project$Multiselect$fromResult),
			$rtfeldman$elm_css$Html$Styled$Events$keyCode));
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$custom,
		'keydown',
		A2($author$project$Multiselect$withOptions, options, decoder));
}();
var $rtfeldman$elm_css$Html$Styled$Attributes$property = $rtfeldman$elm_css$VirtualDom$Styled$property;
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			false,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Multiselect$input = function (_v0) {
	var model = _v0;
	var w = $elm$core$String$fromFloat(model.fy + 23.0);
	var inputStyle = A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', w + 'px');
	var forceClear = function () {
		var _v1 = model.T;
		if (_v1.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$Attributes$value('');
		} else {
			return $rtfeldman$elm_css$Html$Styled$Attributes$classList(_List_Nil);
		}
	}();
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$author$project$Multiselect$preventDefaultButtons,
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$inputWrap]))
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$inputMirrow]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($elm$core$Maybe$withDefault, '', model.T))
					])),
				A2(
				$rtfeldman$elm_css$Html$Styled$input,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$id('multiselectInput' + model.nl),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$Multiselect$SelectCss$input])),
						$author$project$Multiselect$onKeyDown($author$project$Multiselect$Adjust),
						$author$project$Multiselect$onKeyPress($author$project$Multiselect$Shortcut),
						$author$project$Multiselect$onKeyUp($author$project$Multiselect$Filter),
						inputStyle,
						A2(
						$rtfeldman$elm_css$Html$Styled$Attributes$property,
						'type',
						$elm$json$Json$Encode$string('text')),
						forceClear
					]),
				_List_Nil)
			]));
};
var $author$project$Multiselect$isMultiSelect = function (_v0) {
	var model = _v0;
	return model.lx;
};
var $author$project$Multiselect$RemoveItem = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $author$project$Multiselect$Bulma$tag = F3(
	function (isRemovable, name, value) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$span,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$class('tag is-link is-light is-medium')
				]),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$text(value),
					isRemovable ? A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$class('delete is-small'),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Multiselect$RemoveItem(
								_Utils_Tuple2(name, value)))
						]),
					_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Multiselect$Bulma$tags = function (model) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$class('control p-2')
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$class('tags')
					]),
				_Utils_ap(
					A2(
						$elm$core$List$map,
						function (_v0) {
							var name = _v0.a;
							var value = _v0.b;
							return A3(
								$author$project$Multiselect$Bulma$tag,
								$author$project$Multiselect$isMultiSelect(model),
								name,
								value);
						},
						$author$project$Multiselect$getSelectedValues(model)),
					_List_fromArray(
						[
							$author$project$Multiselect$input(model)
						])))
			]));
};
var $author$project$Multiselect$SelectCss$wrap = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative),
			$rtfeldman$elm_css$Css$width(
			$rtfeldman$elm_css$Css$pct(100))
		]));
var $author$project$Multiselect$Bulma$styledView = function (model) {
	var inputCss = $author$project$Multiselect$isFocused(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$container, $author$project$Multiselect$SelectCss$focused]) : ($author$project$Multiselect$isOpened(model) ? _List_fromArray(
		[$author$project$Multiselect$SelectCss$container, $author$project$Multiselect$SelectCss$opened]) : _List_fromArray(
		[$author$project$Multiselect$SelectCss$container]));
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$Multiselect$SelectCss$wrap])),
				$rtfeldman$elm_css$Html$Styled$Attributes$id(
				$author$project$Multiselect$controlId(model)),
				$rtfeldman$elm_css$Html$Styled$Events$onClick($author$project$Multiselect$ClickOnComponent)
			]),
		_List_fromArray(
			[
				A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(inputCss)
					]),
				_List_fromArray(
					[
						$author$project$Multiselect$Bulma$tags(model),
						$author$project$Multiselect$clear(model),
						$author$project$Multiselect$arrow(model)
					])),
				$author$project$Multiselect$menu(model)
			]));
};
var $rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				return styles;
			} else {
				return A3(
					$elm$core$Dict$insert,
					cssTemplate,
					$rtfeldman$elm_css$Hash$fromString(cssTemplate),
					styles);
			}
		} else {
			return styles;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string(classname));
			} else {
				return A2(
					$elm$virtual_dom$VirtualDom$property,
					'className',
					$elm$json$Json$Encode$string('_unstyled'));
			}
		} else {
			return val;
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS = F2(
	function (styles, _v0) {
		var val = _v0.a;
		var isCssStyles = _v0.b;
		var cssTemplate = _v0.c;
		if (isCssStyles) {
			var _v1 = A2($elm$core$Dict$get, cssTemplate, styles);
			if (!_v1.$) {
				var classname = _v1.a;
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', classname);
			} else {
				return A2($elm$virtual_dom$VirtualDom$attribute, 'class', '_unstyled');
			}
		} else {
			return val;
		}
	});
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$nodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_nodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(finalStyles),
						properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration = F3(
	function (template, classname, declaration) {
		return declaration + ('\n' + A3($elm$core$String$replace, $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, classname, template));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return A3($elm$core$Dict$foldl, $rtfeldman$elm_css$VirtualDom$Styled$styleToDeclaration, '', dict);
};
var $rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration = F2(
	function (scopingPrefix, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (template, classname, declaration) {
					return declaration + ('\n' + A3($elm$core$String$replace, '.' + $rtfeldman$elm_css$VirtualDom$Styled$classnameStandin, '#' + (scopingPrefix + ('.' + classname)), template));
				}),
			'',
			dict);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = F2(
	function (maybeNonce, accumulatedStyles) {
		var cssText = function () {
			if (!accumulatedStyles.$) {
				var allStyles = accumulatedStyles.a;
				return $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(allStyles);
			} else {
				var scope = accumulatedStyles.a;
				var rootStyles = accumulatedStyles.b;
				var descendantStyles = accumulatedStyles.c;
				return A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope, rootStyles) + ('\n' + A2($rtfeldman$elm_css$VirtualDom$Styled$toScopedDeclaration, scope + ' ', descendantStyles));
			}
		}();
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			'span',
			_List_fromArray(
				[
					A2($elm$virtual_dom$VirtualDom$attribute, 'style', 'display: none;'),
					A2($elm$virtual_dom$VirtualDom$attribute, 'class', 'elm-css-style-wrapper')
				]),
			_List_fromArray(
				[
					A3(
					$elm$virtual_dom$VirtualDom$node,
					'style',
					function () {
						if (!maybeNonce.$) {
							var nonce = maybeNonce.a;
							return _List_fromArray(
								[
									A2($elm$virtual_dom$VirtualDom$attribute, 'nonce', nonce)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					$elm$core$List$singleton(
						$elm$virtual_dom$VirtualDom$text(cssText)))
				]));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F4(
	function (maybeNonce, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F3(
	function (maybeNonce, accumulatedStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toStyleNode, maybeNonce, accumulatedStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F4(
	function (maybeNonce, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute(styles),
			properties);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F5(
	function (maybeNonce, ns, elemType, properties, keyedChildren) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A3(
			$rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles),
			keyedChildNodes);
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F5(
	function (maybeNonce, ns, elemType, properties, children) {
		var initialStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, $elm$core$Dict$empty, properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = A2(
			$rtfeldman$elm_css$VirtualDom$Styled$toStyleNode,
			maybeNonce,
			$rtfeldman$elm_css$VirtualDom$Styled$UnscopedStyles(styles));
		var unstyledProperties = A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttributeNS(styles),
			properties);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyle, $elm$core$Maybe$Nothing, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, $elm$core$Maybe$Nothing, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A5($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, $elm$core$Maybe$Nothing, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Multiselect$Bulma$view = A2($elm$core$Basics$composeR, $author$project$Multiselect$Bulma$styledView, $rtfeldman$elm_css$Html$Styled$toUnstyled);
var $author$project$UI$multiselectChoiceField = F3(
	function (t_, field, values) {
		var view = field.nE;
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = view.mp;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$author$project$UI$attrCyData(view.kJ)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$map,
									view.bZ,
									$author$project$Multiselect$Bulma$view(view.eZ))
								]));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $elm$html$Html$section = _VirtualDom_node('section');
var $author$project$UI$section = function (content) {
	return A2(
		$elm$html$Html$section,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('section')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container')
					]),
				content)
			]));
};
var $author$project$UI$tag = F2(
	function (style, content) {
		return A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tag'),
					$elm$html$Html$Attributes$class(style)
				]),
			content);
	});
var $author$project$Element$Counter$view = function (_v0) {
	var counter = _v0.dB;
	var animalSelectorModel = _v0.br;
	var session = _v0.cv;
	var animal = $author$project$Form$getMultiselectFieldSelectedValue(animalSelectorModel.bt.aC);
	return $author$project$UI$section(
		_List_fromArray(
			[
				A2(
				$author$project$UI$caption,
				session.hy,
				$author$project$Locale$Messages$NOTRANS('Itt számolhatsz bárányokat. Használd a + és - gombokat.')),
				A2(
				$author$project$UI$level,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button'),
								$elm$html$Html$Events$onClick($author$project$Element$Counter$Decrement)
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$BtnCounterDecrement)
							])),
						A2(
						$author$project$UI$tag,
						'is-info is-light',
						_List_fromArray(
							[
								A2(
								$author$project$UI$caption,
								session.hy,
								A2($author$project$Locale$Messages$CounterClickCount, animal, counter))
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('button'),
								$elm$html$Html$Events$onClick($author$project$Element$Counter$Increment)
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$BtnCounterIncrement)
							]))
					]),
				_List_Nil),
				A3($author$project$UI$multiselectChoiceField, session.hy, animalSelectorModel.bt.aC, animalSelectorModel.ej)
			]));
};
var $author$project$Element$Counter$element = {iA: $author$project$Element$Counter$init, hh: $author$project$Element$Counter$perform, jR: $author$project$Element$Counter$update, nE: $author$project$Element$Counter$view};
var $author$project$Element$GenericProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GenericProfileForm$ProfileDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$person = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Person$fetchProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$person, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$personDecoder));
	});
var $author$project$Element$GenericProfileForm$init = F3(
	function (config, session, personId) {
		var model = {
			bN: config,
			bm: $author$project$Element$GenericProfileForm$LoadingPage(personId)
		};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$Person$fetchProfile, config.gr, personId, $author$project$Element$GenericProfileForm$ProfileDownloaded),
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$GenericProfileForm$FormPage = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$FormSaveError = {$: 69};
var $author$project$Element$GenericProfileForm$NoOp = {$: 5};
var $author$project$Element$GenericProfileForm$NotFoundPage = {$: 0};
var $author$project$Form$Processing = 2;
var $author$project$Element$GenericProfileForm$ProfileSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$ProfilesDownloadError = {$: 428};
var $author$project$Locale$Messages$ProfilesSaveSuccess = {$: 429};
var $author$project$Form$SavingError = 3;
var $author$project$Element$GenericProfileForm$BirthDate = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$GenericProfileForm$BirthPlaceCountry = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$GenericProfileForm$BirthPlaceTown = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$GenericProfileForm$Email = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GenericProfileForm$FirstName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GenericProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GenericProfileForm$LastName = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressCountry = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$GenericProfileForm$PermanentAddressTown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$PersonAddressCountry = {$: 354};
var $author$project$Locale$Messages$PersonAddressPostcode = {$: 355};
var $author$project$Locale$Messages$PersonAddressStreetDoor = {$: 360};
var $author$project$Locale$Messages$PersonAddressStreetName = {$: 357};
var $author$project$Locale$Messages$PersonAddressStreetNumber = {$: 359};
var $author$project$Locale$Messages$PersonAddressStreetType = {$: 358};
var $author$project$Locale$Messages$PersonAddressTown = {$: 356};
var $author$project$Locale$Messages$PersonBirthDate = {$: 363};
var $author$project$Locale$Messages$PersonBirthPlaceCountry = {$: 362};
var $author$project$Locale$Messages$PersonBirthPlaceTown = {$: 361};
var $author$project$Locale$Messages$PersonEmail = {$: 344};
var $author$project$Locale$Messages$PersonFirstName = {$: 346};
var $author$project$Locale$Messages$PersonLastName = {$: 349};
var $author$project$Locale$Messages$PersonPhone = {$: 351};
var $author$project$Element$GenericProfileForm$Phone = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$Country = function (a) {
	return {$: 46, a: a};
};
var $rl_king$elm_iso3166_country_codes$Iso3166$AD = 0;
var $rl_king$elm_iso3166_country_codes$Iso3166$AE = 1;
var $rl_king$elm_iso3166_country_codes$Iso3166$AF = 2;
var $rl_king$elm_iso3166_country_codes$Iso3166$AG = 3;
var $rl_king$elm_iso3166_country_codes$Iso3166$AI = 4;
var $rl_king$elm_iso3166_country_codes$Iso3166$AL = 5;
var $rl_king$elm_iso3166_country_codes$Iso3166$AM = 6;
var $rl_king$elm_iso3166_country_codes$Iso3166$AO = 7;
var $rl_king$elm_iso3166_country_codes$Iso3166$AQ = 8;
var $rl_king$elm_iso3166_country_codes$Iso3166$AR = 9;
var $rl_king$elm_iso3166_country_codes$Iso3166$AS = 10;
var $rl_king$elm_iso3166_country_codes$Iso3166$AT = 11;
var $rl_king$elm_iso3166_country_codes$Iso3166$AU = 12;
var $rl_king$elm_iso3166_country_codes$Iso3166$AW = 13;
var $rl_king$elm_iso3166_country_codes$Iso3166$AX = 14;
var $rl_king$elm_iso3166_country_codes$Iso3166$AZ = 15;
var $rl_king$elm_iso3166_country_codes$Iso3166$BA = 16;
var $rl_king$elm_iso3166_country_codes$Iso3166$BB = 17;
var $rl_king$elm_iso3166_country_codes$Iso3166$BD = 18;
var $rl_king$elm_iso3166_country_codes$Iso3166$BE = 19;
var $rl_king$elm_iso3166_country_codes$Iso3166$BF = 20;
var $rl_king$elm_iso3166_country_codes$Iso3166$BG = 21;
var $rl_king$elm_iso3166_country_codes$Iso3166$BH = 22;
var $rl_king$elm_iso3166_country_codes$Iso3166$BI = 23;
var $rl_king$elm_iso3166_country_codes$Iso3166$BJ = 24;
var $rl_king$elm_iso3166_country_codes$Iso3166$BL = 25;
var $rl_king$elm_iso3166_country_codes$Iso3166$BM = 26;
var $rl_king$elm_iso3166_country_codes$Iso3166$BN = 27;
var $rl_king$elm_iso3166_country_codes$Iso3166$BO = 28;
var $rl_king$elm_iso3166_country_codes$Iso3166$BQ = 29;
var $rl_king$elm_iso3166_country_codes$Iso3166$BR = 30;
var $rl_king$elm_iso3166_country_codes$Iso3166$BS = 31;
var $rl_king$elm_iso3166_country_codes$Iso3166$BT = 32;
var $rl_king$elm_iso3166_country_codes$Iso3166$BV = 33;
var $rl_king$elm_iso3166_country_codes$Iso3166$BW = 34;
var $rl_king$elm_iso3166_country_codes$Iso3166$BY = 35;
var $rl_king$elm_iso3166_country_codes$Iso3166$BZ = 36;
var $rl_king$elm_iso3166_country_codes$Iso3166$CA = 37;
var $rl_king$elm_iso3166_country_codes$Iso3166$CC = 38;
var $rl_king$elm_iso3166_country_codes$Iso3166$CD = 39;
var $rl_king$elm_iso3166_country_codes$Iso3166$CF = 40;
var $rl_king$elm_iso3166_country_codes$Iso3166$CG = 41;
var $rl_king$elm_iso3166_country_codes$Iso3166$CH = 42;
var $rl_king$elm_iso3166_country_codes$Iso3166$CI = 43;
var $rl_king$elm_iso3166_country_codes$Iso3166$CK = 44;
var $rl_king$elm_iso3166_country_codes$Iso3166$CL = 45;
var $rl_king$elm_iso3166_country_codes$Iso3166$CM = 46;
var $rl_king$elm_iso3166_country_codes$Iso3166$CN = 47;
var $rl_king$elm_iso3166_country_codes$Iso3166$CO = 48;
var $rl_king$elm_iso3166_country_codes$Iso3166$CR = 49;
var $rl_king$elm_iso3166_country_codes$Iso3166$CU = 50;
var $rl_king$elm_iso3166_country_codes$Iso3166$CV = 51;
var $rl_king$elm_iso3166_country_codes$Iso3166$CW = 52;
var $rl_king$elm_iso3166_country_codes$Iso3166$CX = 53;
var $rl_king$elm_iso3166_country_codes$Iso3166$CY = 54;
var $rl_king$elm_iso3166_country_codes$Iso3166$CZ = 55;
var $rl_king$elm_iso3166_country_codes$Iso3166$DE = 56;
var $rl_king$elm_iso3166_country_codes$Iso3166$DJ = 57;
var $rl_king$elm_iso3166_country_codes$Iso3166$DK = 58;
var $rl_king$elm_iso3166_country_codes$Iso3166$DM = 59;
var $rl_king$elm_iso3166_country_codes$Iso3166$DO = 60;
var $rl_king$elm_iso3166_country_codes$Iso3166$DZ = 61;
var $rl_king$elm_iso3166_country_codes$Iso3166$EC = 62;
var $rl_king$elm_iso3166_country_codes$Iso3166$EE = 63;
var $rl_king$elm_iso3166_country_codes$Iso3166$EG = 64;
var $rl_king$elm_iso3166_country_codes$Iso3166$EH = 65;
var $rl_king$elm_iso3166_country_codes$Iso3166$ER = 66;
var $rl_king$elm_iso3166_country_codes$Iso3166$ES = 67;
var $rl_king$elm_iso3166_country_codes$Iso3166$ET = 68;
var $rl_king$elm_iso3166_country_codes$Iso3166$FI = 69;
var $rl_king$elm_iso3166_country_codes$Iso3166$FJ = 70;
var $rl_king$elm_iso3166_country_codes$Iso3166$FK = 71;
var $rl_king$elm_iso3166_country_codes$Iso3166$FM = 72;
var $rl_king$elm_iso3166_country_codes$Iso3166$FO = 73;
var $rl_king$elm_iso3166_country_codes$Iso3166$FR = 74;
var $rl_king$elm_iso3166_country_codes$Iso3166$GA = 75;
var $rl_king$elm_iso3166_country_codes$Iso3166$GB = 76;
var $rl_king$elm_iso3166_country_codes$Iso3166$GD = 77;
var $rl_king$elm_iso3166_country_codes$Iso3166$GE = 78;
var $rl_king$elm_iso3166_country_codes$Iso3166$GF = 79;
var $rl_king$elm_iso3166_country_codes$Iso3166$GG = 80;
var $rl_king$elm_iso3166_country_codes$Iso3166$GH = 81;
var $rl_king$elm_iso3166_country_codes$Iso3166$GI = 82;
var $rl_king$elm_iso3166_country_codes$Iso3166$GL = 83;
var $rl_king$elm_iso3166_country_codes$Iso3166$GM = 84;
var $rl_king$elm_iso3166_country_codes$Iso3166$GN = 85;
var $rl_king$elm_iso3166_country_codes$Iso3166$GP = 86;
var $rl_king$elm_iso3166_country_codes$Iso3166$GQ = 87;
var $rl_king$elm_iso3166_country_codes$Iso3166$GR = 88;
var $rl_king$elm_iso3166_country_codes$Iso3166$GS = 89;
var $rl_king$elm_iso3166_country_codes$Iso3166$GT_ = 90;
var $rl_king$elm_iso3166_country_codes$Iso3166$GU = 91;
var $rl_king$elm_iso3166_country_codes$Iso3166$GW = 92;
var $rl_king$elm_iso3166_country_codes$Iso3166$GY = 93;
var $rl_king$elm_iso3166_country_codes$Iso3166$HK = 94;
var $rl_king$elm_iso3166_country_codes$Iso3166$HM = 95;
var $rl_king$elm_iso3166_country_codes$Iso3166$HN = 96;
var $rl_king$elm_iso3166_country_codes$Iso3166$HR = 97;
var $rl_king$elm_iso3166_country_codes$Iso3166$HT = 98;
var $rl_king$elm_iso3166_country_codes$Iso3166$HU = 99;
var $rl_king$elm_iso3166_country_codes$Iso3166$ID = 100;
var $rl_king$elm_iso3166_country_codes$Iso3166$IE = 101;
var $rl_king$elm_iso3166_country_codes$Iso3166$IL = 102;
var $rl_king$elm_iso3166_country_codes$Iso3166$IM = 103;
var $rl_king$elm_iso3166_country_codes$Iso3166$IN = 104;
var $rl_king$elm_iso3166_country_codes$Iso3166$IO = 105;
var $rl_king$elm_iso3166_country_codes$Iso3166$IQ = 106;
var $rl_king$elm_iso3166_country_codes$Iso3166$IR = 107;
var $rl_king$elm_iso3166_country_codes$Iso3166$IS = 108;
var $rl_king$elm_iso3166_country_codes$Iso3166$IT = 109;
var $rl_king$elm_iso3166_country_codes$Iso3166$JE = 110;
var $rl_king$elm_iso3166_country_codes$Iso3166$JM = 111;
var $rl_king$elm_iso3166_country_codes$Iso3166$JO = 112;
var $rl_king$elm_iso3166_country_codes$Iso3166$JP = 113;
var $rl_king$elm_iso3166_country_codes$Iso3166$KE = 114;
var $rl_king$elm_iso3166_country_codes$Iso3166$KG = 115;
var $rl_king$elm_iso3166_country_codes$Iso3166$KH = 116;
var $rl_king$elm_iso3166_country_codes$Iso3166$KI = 117;
var $rl_king$elm_iso3166_country_codes$Iso3166$KM = 118;
var $rl_king$elm_iso3166_country_codes$Iso3166$KN = 119;
var $rl_king$elm_iso3166_country_codes$Iso3166$KP = 120;
var $rl_king$elm_iso3166_country_codes$Iso3166$KR = 121;
var $rl_king$elm_iso3166_country_codes$Iso3166$KW = 122;
var $rl_king$elm_iso3166_country_codes$Iso3166$KY = 123;
var $rl_king$elm_iso3166_country_codes$Iso3166$KZ = 124;
var $rl_king$elm_iso3166_country_codes$Iso3166$LA = 125;
var $rl_king$elm_iso3166_country_codes$Iso3166$LB = 126;
var $rl_king$elm_iso3166_country_codes$Iso3166$LC = 127;
var $rl_king$elm_iso3166_country_codes$Iso3166$LI = 128;
var $rl_king$elm_iso3166_country_codes$Iso3166$LK = 129;
var $rl_king$elm_iso3166_country_codes$Iso3166$LR = 130;
var $rl_king$elm_iso3166_country_codes$Iso3166$LS = 131;
var $rl_king$elm_iso3166_country_codes$Iso3166$LT_ = 132;
var $rl_king$elm_iso3166_country_codes$Iso3166$LU = 133;
var $rl_king$elm_iso3166_country_codes$Iso3166$LV = 134;
var $rl_king$elm_iso3166_country_codes$Iso3166$LY = 135;
var $rl_king$elm_iso3166_country_codes$Iso3166$MA = 136;
var $rl_king$elm_iso3166_country_codes$Iso3166$MC = 137;
var $rl_king$elm_iso3166_country_codes$Iso3166$MD = 138;
var $rl_king$elm_iso3166_country_codes$Iso3166$ME = 139;
var $rl_king$elm_iso3166_country_codes$Iso3166$MF = 140;
var $rl_king$elm_iso3166_country_codes$Iso3166$MG = 141;
var $rl_king$elm_iso3166_country_codes$Iso3166$MH = 142;
var $rl_king$elm_iso3166_country_codes$Iso3166$MK = 143;
var $rl_king$elm_iso3166_country_codes$Iso3166$ML = 144;
var $rl_king$elm_iso3166_country_codes$Iso3166$MM = 145;
var $rl_king$elm_iso3166_country_codes$Iso3166$MN = 146;
var $rl_king$elm_iso3166_country_codes$Iso3166$MO = 147;
var $rl_king$elm_iso3166_country_codes$Iso3166$MP = 148;
var $rl_king$elm_iso3166_country_codes$Iso3166$MQ = 149;
var $rl_king$elm_iso3166_country_codes$Iso3166$MR = 150;
var $rl_king$elm_iso3166_country_codes$Iso3166$MS = 151;
var $rl_king$elm_iso3166_country_codes$Iso3166$MT = 152;
var $rl_king$elm_iso3166_country_codes$Iso3166$MU = 153;
var $rl_king$elm_iso3166_country_codes$Iso3166$MV = 154;
var $rl_king$elm_iso3166_country_codes$Iso3166$MW = 155;
var $rl_king$elm_iso3166_country_codes$Iso3166$MX = 156;
var $rl_king$elm_iso3166_country_codes$Iso3166$MY = 157;
var $rl_king$elm_iso3166_country_codes$Iso3166$MZ = 158;
var $rl_king$elm_iso3166_country_codes$Iso3166$NA = 159;
var $rl_king$elm_iso3166_country_codes$Iso3166$NC = 160;
var $rl_king$elm_iso3166_country_codes$Iso3166$NE = 161;
var $rl_king$elm_iso3166_country_codes$Iso3166$NF = 162;
var $rl_king$elm_iso3166_country_codes$Iso3166$NG = 163;
var $rl_king$elm_iso3166_country_codes$Iso3166$NI = 164;
var $rl_king$elm_iso3166_country_codes$Iso3166$NL = 165;
var $rl_king$elm_iso3166_country_codes$Iso3166$NO = 166;
var $rl_king$elm_iso3166_country_codes$Iso3166$NP = 167;
var $rl_king$elm_iso3166_country_codes$Iso3166$NR = 168;
var $rl_king$elm_iso3166_country_codes$Iso3166$NU = 169;
var $rl_king$elm_iso3166_country_codes$Iso3166$NZ = 170;
var $rl_king$elm_iso3166_country_codes$Iso3166$OM = 171;
var $rl_king$elm_iso3166_country_codes$Iso3166$PA = 172;
var $rl_king$elm_iso3166_country_codes$Iso3166$PE = 173;
var $rl_king$elm_iso3166_country_codes$Iso3166$PF = 174;
var $rl_king$elm_iso3166_country_codes$Iso3166$PG = 175;
var $rl_king$elm_iso3166_country_codes$Iso3166$PH = 176;
var $rl_king$elm_iso3166_country_codes$Iso3166$PK = 177;
var $rl_king$elm_iso3166_country_codes$Iso3166$PL = 178;
var $rl_king$elm_iso3166_country_codes$Iso3166$PM = 179;
var $rl_king$elm_iso3166_country_codes$Iso3166$PN = 180;
var $rl_king$elm_iso3166_country_codes$Iso3166$PR = 181;
var $rl_king$elm_iso3166_country_codes$Iso3166$PS = 182;
var $rl_king$elm_iso3166_country_codes$Iso3166$PT = 183;
var $rl_king$elm_iso3166_country_codes$Iso3166$PW = 184;
var $rl_king$elm_iso3166_country_codes$Iso3166$PY = 185;
var $rl_king$elm_iso3166_country_codes$Iso3166$QA = 186;
var $rl_king$elm_iso3166_country_codes$Iso3166$RE = 187;
var $rl_king$elm_iso3166_country_codes$Iso3166$RO = 188;
var $rl_king$elm_iso3166_country_codes$Iso3166$RS = 189;
var $rl_king$elm_iso3166_country_codes$Iso3166$RU = 190;
var $rl_king$elm_iso3166_country_codes$Iso3166$RW = 191;
var $rl_king$elm_iso3166_country_codes$Iso3166$SA = 192;
var $rl_king$elm_iso3166_country_codes$Iso3166$SB = 193;
var $rl_king$elm_iso3166_country_codes$Iso3166$SC = 194;
var $rl_king$elm_iso3166_country_codes$Iso3166$SD = 195;
var $rl_king$elm_iso3166_country_codes$Iso3166$SE = 196;
var $rl_king$elm_iso3166_country_codes$Iso3166$SG = 197;
var $rl_king$elm_iso3166_country_codes$Iso3166$SH = 198;
var $rl_king$elm_iso3166_country_codes$Iso3166$SI = 199;
var $rl_king$elm_iso3166_country_codes$Iso3166$SJ = 200;
var $rl_king$elm_iso3166_country_codes$Iso3166$SK = 201;
var $rl_king$elm_iso3166_country_codes$Iso3166$SL = 202;
var $rl_king$elm_iso3166_country_codes$Iso3166$SM = 203;
var $rl_king$elm_iso3166_country_codes$Iso3166$SN = 204;
var $rl_king$elm_iso3166_country_codes$Iso3166$SO = 205;
var $rl_king$elm_iso3166_country_codes$Iso3166$SR = 206;
var $rl_king$elm_iso3166_country_codes$Iso3166$SS = 207;
var $rl_king$elm_iso3166_country_codes$Iso3166$ST = 208;
var $rl_king$elm_iso3166_country_codes$Iso3166$SV = 209;
var $rl_king$elm_iso3166_country_codes$Iso3166$SX = 210;
var $rl_king$elm_iso3166_country_codes$Iso3166$SY = 211;
var $rl_king$elm_iso3166_country_codes$Iso3166$SZ = 212;
var $rl_king$elm_iso3166_country_codes$Iso3166$TC = 213;
var $rl_king$elm_iso3166_country_codes$Iso3166$TD = 214;
var $rl_king$elm_iso3166_country_codes$Iso3166$TF = 215;
var $rl_king$elm_iso3166_country_codes$Iso3166$TG = 216;
var $rl_king$elm_iso3166_country_codes$Iso3166$TH = 217;
var $rl_king$elm_iso3166_country_codes$Iso3166$TJ = 218;
var $rl_king$elm_iso3166_country_codes$Iso3166$TK = 219;
var $rl_king$elm_iso3166_country_codes$Iso3166$TL = 220;
var $rl_king$elm_iso3166_country_codes$Iso3166$TM = 221;
var $rl_king$elm_iso3166_country_codes$Iso3166$TN = 222;
var $rl_king$elm_iso3166_country_codes$Iso3166$TO = 223;
var $rl_king$elm_iso3166_country_codes$Iso3166$TR = 224;
var $rl_king$elm_iso3166_country_codes$Iso3166$TT = 225;
var $rl_king$elm_iso3166_country_codes$Iso3166$TV = 226;
var $rl_king$elm_iso3166_country_codes$Iso3166$TW = 227;
var $rl_king$elm_iso3166_country_codes$Iso3166$TZ = 228;
var $rl_king$elm_iso3166_country_codes$Iso3166$UA = 229;
var $rl_king$elm_iso3166_country_codes$Iso3166$UG = 230;
var $rl_king$elm_iso3166_country_codes$Iso3166$UM = 231;
var $rl_king$elm_iso3166_country_codes$Iso3166$US = 232;
var $rl_king$elm_iso3166_country_codes$Iso3166$UY = 233;
var $rl_king$elm_iso3166_country_codes$Iso3166$UZ = 234;
var $rl_king$elm_iso3166_country_codes$Iso3166$VA = 235;
var $rl_king$elm_iso3166_country_codes$Iso3166$VC = 236;
var $rl_king$elm_iso3166_country_codes$Iso3166$VE = 237;
var $rl_king$elm_iso3166_country_codes$Iso3166$VG = 238;
var $rl_king$elm_iso3166_country_codes$Iso3166$VI = 239;
var $rl_king$elm_iso3166_country_codes$Iso3166$VN = 240;
var $rl_king$elm_iso3166_country_codes$Iso3166$VU = 241;
var $rl_king$elm_iso3166_country_codes$Iso3166$WF = 242;
var $rl_king$elm_iso3166_country_codes$Iso3166$WS = 243;
var $rl_king$elm_iso3166_country_codes$Iso3166$YE = 244;
var $rl_king$elm_iso3166_country_codes$Iso3166$YT = 245;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZA = 246;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZM = 247;
var $rl_king$elm_iso3166_country_codes$Iso3166$ZW = 248;
var $rl_king$elm_iso3166_country_codes$Iso3166$all = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248]);
var $rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2 = function (c) {
	switch (c) {
		case 0:
			return 'ad';
		case 1:
			return 'ae';
		case 2:
			return 'af';
		case 3:
			return 'ag';
		case 4:
			return 'ai';
		case 5:
			return 'al';
		case 6:
			return 'am';
		case 7:
			return 'ao';
		case 8:
			return 'aq';
		case 9:
			return 'ar';
		case 10:
			return 'as';
		case 11:
			return 'at';
		case 12:
			return 'au';
		case 13:
			return 'aw';
		case 14:
			return 'ax';
		case 15:
			return 'az';
		case 16:
			return 'ba';
		case 17:
			return 'bb';
		case 18:
			return 'bd';
		case 19:
			return 'be';
		case 20:
			return 'bf';
		case 21:
			return 'bg';
		case 22:
			return 'bh';
		case 23:
			return 'bi';
		case 24:
			return 'bj';
		case 25:
			return 'bl';
		case 26:
			return 'bm';
		case 27:
			return 'bn';
		case 28:
			return 'bo';
		case 29:
			return 'bq';
		case 30:
			return 'br';
		case 31:
			return 'bs';
		case 32:
			return 'bt';
		case 33:
			return 'bv';
		case 34:
			return 'bw';
		case 35:
			return 'by';
		case 36:
			return 'bz';
		case 37:
			return 'ca';
		case 38:
			return 'cc';
		case 39:
			return 'cd';
		case 40:
			return 'cf';
		case 41:
			return 'cg';
		case 42:
			return 'ch';
		case 43:
			return 'ci';
		case 44:
			return 'ck';
		case 45:
			return 'cl';
		case 46:
			return 'cm';
		case 47:
			return 'cn';
		case 48:
			return 'co';
		case 49:
			return 'cr';
		case 50:
			return 'cu';
		case 51:
			return 'cv';
		case 52:
			return 'cw';
		case 53:
			return 'cx';
		case 54:
			return 'cy';
		case 55:
			return 'cz';
		case 56:
			return 'de';
		case 57:
			return 'dj';
		case 58:
			return 'dk';
		case 59:
			return 'dm';
		case 60:
			return 'do';
		case 61:
			return 'dz';
		case 62:
			return 'ec';
		case 63:
			return 'ee';
		case 64:
			return 'eg';
		case 65:
			return 'eh';
		case 66:
			return 'er';
		case 67:
			return 'es';
		case 68:
			return 'et';
		case 69:
			return 'fi';
		case 70:
			return 'fj';
		case 71:
			return 'fk';
		case 72:
			return 'fm';
		case 73:
			return 'fo';
		case 74:
			return 'fr';
		case 75:
			return 'ga';
		case 76:
			return 'gb';
		case 77:
			return 'gd';
		case 78:
			return 'ge';
		case 79:
			return 'gf';
		case 80:
			return 'gg';
		case 81:
			return 'gh';
		case 82:
			return 'gi';
		case 83:
			return 'gl';
		case 84:
			return 'gm';
		case 85:
			return 'gn';
		case 86:
			return 'gp';
		case 87:
			return 'gq';
		case 88:
			return 'gr';
		case 89:
			return 'gs';
		case 90:
			return 'gt';
		case 91:
			return 'gu';
		case 92:
			return 'gw';
		case 93:
			return 'gy';
		case 94:
			return 'hk';
		case 95:
			return 'hm';
		case 96:
			return 'hn';
		case 97:
			return 'hr';
		case 98:
			return 'ht';
		case 99:
			return 'hu';
		case 100:
			return 'id';
		case 101:
			return 'ie';
		case 102:
			return 'il';
		case 103:
			return 'im';
		case 104:
			return 'in';
		case 105:
			return 'io';
		case 106:
			return 'iq';
		case 107:
			return 'ir';
		case 108:
			return 'is';
		case 109:
			return 'it';
		case 110:
			return 'je';
		case 111:
			return 'jm';
		case 112:
			return 'jo';
		case 113:
			return 'jp';
		case 114:
			return 'ke';
		case 115:
			return 'kg';
		case 116:
			return 'kh';
		case 117:
			return 'ki';
		case 118:
			return 'km';
		case 119:
			return 'kn';
		case 120:
			return 'kp';
		case 121:
			return 'kr';
		case 122:
			return 'kw';
		case 123:
			return 'ky';
		case 124:
			return 'kz';
		case 125:
			return 'la';
		case 126:
			return 'lb';
		case 127:
			return 'lc';
		case 128:
			return 'li';
		case 129:
			return 'lk';
		case 130:
			return 'lr';
		case 131:
			return 'ls';
		case 132:
			return 'lt';
		case 133:
			return 'lu';
		case 134:
			return 'lv';
		case 135:
			return 'ly';
		case 136:
			return 'ma';
		case 137:
			return 'mc';
		case 138:
			return 'md';
		case 139:
			return 'me';
		case 140:
			return 'mf';
		case 141:
			return 'mg';
		case 142:
			return 'mh';
		case 143:
			return 'mk';
		case 144:
			return 'ml';
		case 145:
			return 'mm';
		case 146:
			return 'mn';
		case 147:
			return 'mo';
		case 148:
			return 'mp';
		case 149:
			return 'mq';
		case 150:
			return 'mr';
		case 151:
			return 'ms';
		case 152:
			return 'mt';
		case 153:
			return 'mu';
		case 154:
			return 'mv';
		case 155:
			return 'mw';
		case 156:
			return 'mx';
		case 157:
			return 'my';
		case 158:
			return 'mz';
		case 159:
			return 'na';
		case 160:
			return 'nc';
		case 161:
			return 'ne';
		case 162:
			return 'nf';
		case 163:
			return 'ng';
		case 164:
			return 'ni';
		case 165:
			return 'nl';
		case 166:
			return 'no';
		case 167:
			return 'np';
		case 168:
			return 'nr';
		case 169:
			return 'nu';
		case 170:
			return 'nz';
		case 171:
			return 'om';
		case 172:
			return 'pa';
		case 173:
			return 'pe';
		case 174:
			return 'pf';
		case 175:
			return 'pg';
		case 176:
			return 'ph';
		case 177:
			return 'pk';
		case 178:
			return 'pl';
		case 179:
			return 'pm';
		case 180:
			return 'pn';
		case 181:
			return 'pr';
		case 182:
			return 'ps';
		case 183:
			return 'pt';
		case 184:
			return 'pw';
		case 185:
			return 'py';
		case 186:
			return 'qa';
		case 187:
			return 're';
		case 188:
			return 'ro';
		case 189:
			return 'rs';
		case 190:
			return 'ru';
		case 191:
			return 'rw';
		case 192:
			return 'sa';
		case 193:
			return 'sb';
		case 194:
			return 'sc';
		case 195:
			return 'sd';
		case 196:
			return 'se';
		case 197:
			return 'sg';
		case 198:
			return 'sh';
		case 199:
			return 'si';
		case 200:
			return 'sj';
		case 201:
			return 'sk';
		case 202:
			return 'sl';
		case 203:
			return 'sm';
		case 204:
			return 'sn';
		case 205:
			return 'so';
		case 206:
			return 'sr';
		case 207:
			return 'ss';
		case 208:
			return 'st';
		case 209:
			return 'sv';
		case 210:
			return 'sx';
		case 211:
			return 'sy';
		case 212:
			return 'sz';
		case 213:
			return 'tc';
		case 214:
			return 'td';
		case 215:
			return 'tf';
		case 216:
			return 'tg';
		case 217:
			return 'th';
		case 218:
			return 'tj';
		case 219:
			return 'tk';
		case 220:
			return 'tl';
		case 221:
			return 'tm';
		case 222:
			return 'tn';
		case 223:
			return 'to';
		case 224:
			return 'tr';
		case 225:
			return 'tt';
		case 226:
			return 'tv';
		case 227:
			return 'tw';
		case 228:
			return 'tz';
		case 229:
			return 'ua';
		case 230:
			return 'ug';
		case 231:
			return 'um';
		case 232:
			return 'us';
		case 233:
			return 'uy';
		case 234:
			return 'uz';
		case 235:
			return 'va';
		case 236:
			return 'vc';
		case 237:
			return 've';
		case 238:
			return 'vg';
		case 239:
			return 'vi';
		case 240:
			return 'vn';
		case 241:
			return 'vu';
		case 242:
			return 'wf';
		case 243:
			return 'ws';
		case 244:
			return 'ye';
		case 245:
			return 'yt';
		case 246:
			return 'za';
		case 247:
			return 'zm';
		default:
			return 'zw';
	}
};
var $author$project$Person$countries = function (t_) {
	return A2(
		$elm$core$List$map,
		function (code) {
			return _Utils_Tuple2(
				$elm$core$String$toUpper(
					$rl_king$elm_iso3166_country_codes$Iso3166$toAlpha2(code)),
				t_(
					$author$project$Locale$Messages$Country(code)));
		},
		$rl_king$elm_iso3166_country_codes$Iso3166$all);
};
var $author$project$Locale$Messages$FormInvalidDate = {$: 53};
var $author$project$Locale$Messages$FormRequiredValue = {$: 66};
var $elm$regex$Regex$contains = _Regex_contains;
var $author$project$Form$validDateFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{4}-[0-9]{2}-[0-9]{2}$'));
var $author$project$Form$requiredDate = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validDateFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidDate)));
	});
var $author$project$Locale$Messages$FormInvalidPhoneNumber = {$: 54};
var $author$project$Form$validPhoneNumberFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\+\\d{9,15}$'));
var $author$project$Form$requiredPhoneNumber = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validPhoneNumberFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidPhoneNumber)));
	});
var $elm$core$String$trim = _String_trim;
var $author$project$Form$requiredText = F2(
	function (t_, value) {
		return ($elm$core$String$trim(value) !== '') ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue));
	});
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Locale$Hungarian$strCompare = F2(
	function (str1, str2) {
		var sameRanks = $elm$core$Dict$fromList(
			_List_fromArray(
				[
					_Utils_Tuple2('á', 'a'),
					_Utils_Tuple2('é', 'e'),
					_Utils_Tuple2('í', 'i'),
					_Utils_Tuple2('ó', 'o'),
					_Utils_Tuple2('ö', 'o'),
					_Utils_Tuple2('ő', 'o'),
					_Utils_Tuple2('ú', 'u'),
					_Utils_Tuple2('ü', 'u'),
					_Utils_Tuple2('ű', 'u'),
					_Utils_Tuple2('Á', 'A'),
					_Utils_Tuple2('É', 'E'),
					_Utils_Tuple2('Í', 'I'),
					_Utils_Tuple2('Ó', 'O'),
					_Utils_Tuple2('Ö', 'O'),
					_Utils_Tuple2('Ő', 'O'),
					_Utils_Tuple2('Ú', 'U'),
					_Utils_Tuple2('Ü', 'U'),
					_Utils_Tuple2('Ű', 'U')
				]));
		var getSameRankAlpha = function (_char) {
			return A2($elm$core$Dict$get, _char, sameRanks);
		};
		var specialsToAlpha = function (str) {
			return A3(
				$elm$core$String$foldl,
				F2(
					function (c, acc) {
						return _Utils_ap(
							acc,
							$elm$core$String$fromChar(
								A2(
									$elm$core$Maybe$withDefault,
									c,
									getSameRankAlpha(c))));
					}),
				'',
				str);
		};
		return A2(
			$elm$core$Basics$compare,
			specialsToAlpha(str1),
			specialsToAlpha(str2));
	});
var $author$project$Util$List$sortBy = F2(
	function (getter, list) {
		return A2(
			$elm$core$List$sortWith,
			F2(
				function (a, b) {
					return A2(
						$author$project$Locale$Hungarian$strCompare,
						getter(a),
						getter(b));
				}),
			list);
	});
var $author$project$Form$toSortedSelectOptions = function (choices) {
	return A2(
		$elm$core$List$map,
		$author$project$Form$toSelectOption,
		A2($author$project$Util$List$sortBy, $elm$core$Tuple$second, choices));
};
var $author$project$Element$GenericProfileForm$buildForm = function (t_) {
	return {
		aE: {
			kU: false,
			mu: $author$project$Form$requiredDate(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aE: value});
				}),
			nD: function ($) {
				return $.aE;
			},
			nE: {
				kJ: 'birthdate',
				lO: t_($author$project$Locale$Messages$PersonBirthDate),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthDate)
			}
		},
		aG: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aG: value});
				}),
			nD: function ($) {
				return $.aG;
			},
			nE: {
				kJ: 'birthplace_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthPlaceCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aH: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aH: value});
				}),
			nD: function ($) {
				return $.aH;
			},
			nE: {
				kJ: 'birthplace',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$BirthPlaceTown),
				bv: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				hH: 'text'
			}
		},
		K: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{K: value});
				}),
			nD: function ($) {
				return $.K;
			},
			nE: {
				kJ: 'email',
				lj: 'fa-envelope',
				lO: t_($author$project$Locale$Messages$PersonEmail),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$Email),
				bv: t_($author$project$Locale$Messages$PersonEmail),
				hH: 'email'
			}
		},
		k3: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{k3: value});
				}),
			nD: function ($) {
				return $.k3;
			},
			nE: {
				kJ: 'firstname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonFirstName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$FirstName),
				bv: t_($author$project$Locale$Messages$PersonFirstName),
				hH: 'text'
			}
		},
		ak: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ak: value});
				}),
			nD: function ($) {
				return $.ak;
			},
			nE: {
				kJ: 'lastname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonLastName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$LastName),
				bv: t_($author$project$Locale$Messages$PersonLastName),
				hH: 'text'
			}
		},
		aU: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aU: value});
				}),
			nD: function ($) {
				return $.aU;
			},
			nE: {
				kJ: 'permanent_address_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aV: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aV: value});
				}),
			nD: function ($) {
				return $.aV;
			},
			nE: {
				kJ: 'permanent_address_postcode',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressPostcode),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressPostcode),
				bv: t_($author$project$Locale$Messages$PersonAddressPostcode),
				hH: 'text'
			}
		},
		aW: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aW: value});
				}),
			nD: function ($) {
				return $.aW;
			},
			nE: {
				kJ: 'permanent_address_street_door',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetDoor),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				hH: 'text'
			}
		},
		aX: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aX: value});
				}),
			nD: function ($) {
				return $.aX;
			},
			nE: {
				kJ: 'permanent_address_street_name',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetName),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetName),
				hH: 'text'
			}
		},
		aY: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aY: value});
				}),
			nD: function ($) {
				return $.aY;
			},
			nE: {
				kJ: 'permanent_address_street_number',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetNumber),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				hH: 'text'
			}
		},
		aZ: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aZ: value});
				}),
			nD: function ($) {
				return $.aZ;
			},
			nE: {
				kJ: 'permanent_address_street_type',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetType),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressStreetType),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetType),
				hH: 'text'
			}
		},
		a_: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a_: value});
				}),
			nD: function ($) {
				return $.a_;
			},
			nE: {
				kJ: 'permanent_address_town',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$PermanentAddressTown),
				bv: t_($author$project$Locale$Messages$PersonAddressTown),
				hH: 'text'
			}
		},
		aQ: {
			kU: false,
			mu: $author$project$Form$requiredPhoneNumber(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aQ: value});
				}),
			nD: function ($) {
				return $.aQ;
			},
			nE: {
				kJ: 'phone',
				lj: 'fa-phone',
				lO: t_($author$project$Locale$Messages$PersonPhone),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GenericProfileForm$FormMsg, $author$project$Element$GenericProfileForm$Phone),
				bv: t_($author$project$Locale$Messages$PersonPhone),
				hH: 'phone'
			}
		}
	};
};
var $author$project$Element$GenericProfileForm$fillForm = function (person) {
	return {
		aE: person.aE,
		aG: person.aG,
		aH: person.aH,
		K: person.K,
		k3: person.k3,
		ak: person.ak,
		aU: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kF;
				},
				person.c1)),
		aV: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mA;
				},
				person.c1)),
		aW: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.na;
				},
				person.c1)),
		aX: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				person.c1)),
		aY: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nc;
				},
				person.c1)),
		aZ: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nd;
				},
				person.c1)),
		a_: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ny;
				},
				person.c1)),
		aQ: person.aQ
	};
};
var $author$project$Element$GenericProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.k3, values) && (A2($author$project$Form$isFieldValid, form.ak, values) && (A2($author$project$Form$isFieldValid, form.K, values) && (A2($author$project$Form$isFieldValid, form.aQ, values) && (A2($author$project$Form$isFieldValid, form.aU, values) && (A2($author$project$Form$isFieldValid, form.aV, values) && (A2($author$project$Form$isFieldValid, form.a_, values) && (A2($author$project$Form$isFieldValid, form.aX, values) && (A2($author$project$Form$isFieldValid, form.aZ, values) && (A2($author$project$Form$isFieldValid, form.aY, values) && (A2($author$project$Form$isFieldValid, form.aW, values) && (A2($author$project$Form$isFieldValid, form.aE, values) && (A2($author$project$Form$isFieldValid, form.aG, values) && A2($author$project$Form$isFieldValid, form.aH, values)))))))))))));
	});
var $author$project$Log$msgEmailChange = 'email_change';
var $author$project$Log$msgProfileSave = 'profile_save';
var $author$project$Person$UnsavedProfile = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (phoneNumber) {
				return function (email) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlaceTown) {
										return {aE: birthDate, aG: birthPlaceCountry, aH: birthPlaceTown, K: email, k3: firstName, gT: id, ak: lastName, c1: permanentAddress, aQ: phoneNumber, nn: temporaryAddress};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$GenericProfileForm$saveForm = F3(
	function (form, values, person) {
		return $author$project$Person$UnsavedProfile(person.gT)(
			form.k3.nD(values))(
			form.ak.nD(values))(
			form.aQ.nD(values))(
			form.K.nD(values))(
			A9(
				$author$project$Person$Address,
				true,
				form.aU.nD(values),
				form.a_.nD(values),
				form.aV.nD(values),
				'',
				form.aX.nD(values),
				form.aZ.nD(values),
				form.aY.nD(values),
				form.aW.nD(values)))($elm$core$Maybe$Nothing)(
			form.aE.nD(values))(
			form.aG.nD(values))(
			form.aH.nD(values));
	});
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Person$addressEncoder = function (address) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'is_permanent',
				$elm$json$Json$Encode$bool(address.iH)),
				_Utils_Tuple2(
				'country',
				$elm$json$Json$Encode$string(address.kF)),
				_Utils_Tuple2(
				'town',
				$elm$json$Json$Encode$string(address.ny)),
				_Utils_Tuple2(
				'postcode',
				$elm$json$Json$Encode$string(address.mA)),
				_Utils_Tuple2(
				'pob',
				$elm$json$Json$Encode$string(address.i8)),
				_Utils_Tuple2(
				'street_name',
				$elm$json$Json$Encode$string(address.nb)),
				_Utils_Tuple2(
				'street_type',
				$elm$json$Json$Encode$string(address.nd)),
				_Utils_Tuple2(
				'street_number',
				$elm$json$Json$Encode$string(address.nc)),
				_Utils_Tuple2(
				'street_door',
				$elm$json$Json$Encode$string(address.na))
			]));
};
var $author$project$Data$encodeNullable = function (valueEncoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(valueEncoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Person$profileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(profile.gT)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(profile.k3)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(profile.ak)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(profile.K)),
				_Utils_Tuple2(
				'phone_number',
				$elm$json$Json$Encode$string(profile.aQ)),
				_Utils_Tuple2(
				'permanent_address',
				$author$project$Person$addressEncoder(profile.c1)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, profile.nn)),
				_Utils_Tuple2(
				'birthdate',
				$elm$json$Json$Encode$string(profile.aE)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(profile.aG)),
				_Utils_Tuple2(
				'birthplace',
				$elm$json$Json$Encode$string(profile.aH))
			]));
};
var $author$project$Person$saveProfile = F4(
	function (config, profile, id, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$person, config, id),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Person$profileEncoder(profile)),
			callback,
			$author$project$Person$personDecoder);
	});
var $author$project$Ports$scrollToElement = _Platform_outgoingPort('scrollToElement', $elm$json$Json$Encode$string);
var $author$project$Ports$scrollToFormError = $author$project$Ports$scrollToElement('div[class~=has-errors]');
var $author$project$Element$GenericProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							k3: $author$project$Form$markEdited(form.k3)
						}),
					A2(form.k3.jR, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ak: $author$project$Form$markEdited(form.ak)
						}),
					A2(form.ak.jR, value, formValues));
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							K: $author$project$Form$markEdited(form.K)
						}),
					A2(form.K.jR, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aQ: $author$project$Form$markEdited(form.aQ)
						}),
					A2(form.aQ.jR, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aU: $author$project$Form$markEdited(form.aU)
						}),
					A2(form.aU.jR, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aV: $author$project$Form$markEdited(form.aV)
						}),
					A2(form.aV.jR, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a_: $author$project$Form$markEdited(form.a_)
						}),
					A2(form.a_.jR, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aX: $author$project$Form$markEdited(form.aX)
						}),
					A2(form.aX.jR, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aZ: $author$project$Form$markEdited(form.aZ)
						}),
					A2(form.aZ.jR, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aY: $author$project$Form$markEdited(form.aY)
						}),
					A2(form.aY.jR, value, formValues));
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aW: $author$project$Form$markEdited(form.aW)
						}),
					A2(form.aW.jR, value, formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aH: $author$project$Form$markEdited(form.aH)
						}),
					A2(form.aH.jR, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aG: $author$project$Form$markEdited(form.aG)
						}),
					A2(form.aG.jR, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aE: $author$project$Form$markEdited(form.aE)
						}),
					A2(form.aE.jR, value, formValues));
		}
	});
var $author$project$Element$GenericProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			aE: $author$project$Form$markEdited(form.aE),
			aG: $author$project$Form$markEdited(form.aG),
			aH: $author$project$Form$markEdited(form.aH),
			K: $author$project$Form$markEdited(form.K),
			k3: $author$project$Form$markEdited(form.k3),
			ak: $author$project$Form$markEdited(form.ak),
			aU: $author$project$Form$markEdited(form.aU),
			aV: $author$project$Form$markEdited(form.aV),
			aW: $author$project$Form$markEdited(form.aW),
			aX: $author$project$Form$markEdited(form.aX),
			aY: $author$project$Form$markEdited(form.aY),
			aZ: $author$project$Form$markEdited(form.aZ),
			a_: $author$project$Form$markEdited(form.a_),
			aQ: $author$project$Form$markEdited(form.aQ)
		});
};
var $author$project$Element$GenericProfileForm$update = F3(
	function (session, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$8:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var _v2 = _v0.b;
						var form = _v2.b;
						var person = _v2.d;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bm: A4(
										$author$project$Element$GenericProfileForm$FormPage,
										0,
										form,
										$author$project$Element$GenericProfileForm$fillForm(person),
										person)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 0:
					if (_v0.b.$ === 2) {
						var fieldMsg = _v0.a.a;
						var _v3 = _v0.b;
						var form = _v3.b;
						var values = _v3.c;
						var person = _v3.d;
						var _v4 = A3($author$project$Element$GenericProfileForm$updateForm, fieldMsg, form, values);
						var form2 = _v4.a;
						var values2 = _v4.b;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bm: A4($author$project$Element$GenericProfileForm$FormPage, 1, form2, values2, person)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var _v5 = _v0.a;
						var _v6 = _v0.b;
						var form = _v6.b;
						var values = _v6.c;
						var person = _v6.d;
						return A2($author$project$Element$GenericProfileForm$isFormValid, form, values) ? A2(
							$author$project$Application$Boundaries$andThenCmd,
							A4(
								$author$project$Person$saveProfile,
								model.bN.gr,
								A3($author$project$Element$GenericProfileForm$saveForm, form, values, person),
								person.gT,
								$author$project$Element$GenericProfileForm$ProfileSaved),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: A4($author$project$Element$GenericProfileForm$FormPage, 2, form, values, person)
									}),
								session)) : A2(
							$author$project$Application$Boundaries$andThenCmd,
							$author$project$Ports$scrollToFormError,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: A4(
											$author$project$Element$GenericProfileForm$FormPage,
											1,
											$author$project$Element$GenericProfileForm$validateForm(form),
											values,
											person)
									}),
								session));
					} else {
						break _v0$8;
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var person = _v0.a.a.a;
							return $author$project$Person$isTeacher(person) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$author$project$Route$replaceUrl,
									model.bN.iJ,
									$author$project$Route$TeacherProfilesUpdate(person.gT)),
								A2($author$project$Application$Boundaries$save, model, session)) : ($author$project$Person$isStudent(person) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$author$project$Route$replaceUrl,
									model.bN.iJ,
									$author$project$Route$StudentProfileUpdate(person.gT)),
								A2($author$project$Application$Boundaries$save, model, session)) : A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$ok,
									model.bN,
									_Utils_Tuple2(
										$author$project$Log$msgProfileDownload,
										_List_fromArray(
											[
												$elm$core$String$fromInt(person.gT),
												$author$project$Log$paramOk
											])),
									$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: A4(
												$author$project$Element$GenericProfileForm$FormPage,
												0,
												$author$project$Element$GenericProfileForm$buildForm(session.hy),
												$author$project$Element$GenericProfileForm$fillForm(person),
												person)
										}),
									session)));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 1) {
							var error = _v0.a.a.a;
							var id = _v0.b.a;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$ProfilesDownloadError));
							var model2 = _Utils_update(
								model,
								{bm: $author$project$Element$GenericProfileForm$NotFoundPage});
							var cmd = A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3(
									$author$project$Log$msgProfileDownload,
									$elm$core$Maybe$Just(
										$elm$core$String$fromInt(id)),
									error),
								$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				case 4:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 2) {
							var newPerson = _v0.a.a.a;
							var _v7 = _v0.b;
							var form = _v7.b;
							var values = _v7.c;
							var person = _v7.d;
							var session2 = A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$ProfilesSaveSuccess));
							var model2 = _Utils_update(
								model,
								{
									bm: A4($author$project$Element$GenericProfileForm$FormPage, 0, form, values, newPerson)
								});
							var cmd = $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A3(
										$author$project$Log$ok,
										model.bN,
										_Utils_Tuple2(
											$author$project$Log$msgProfileSave,
											_List_fromArray(
												[
													$elm$core$String$fromInt(newPerson.gT)
												])),
										$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)),
										(!_Utils_eq(newPerson.K, person.K)) ? A3(
										$author$project$Log$ok,
										model.bN,
										_Utils_Tuple2(
											$author$project$Log$msgEmailChange,
											_List_fromArray(
												[person.K, newPerson.K])),
										$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp)) : $elm$core$Platform$Cmd$none
									]));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 2) {
							var error = _v0.a.a.a;
							var _v8 = _v0.b;
							var form = _v8.b;
							var values = _v8.c;
							var person = _v8.d;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bm: A4($author$project$Element$GenericProfileForm$FormPage, 3, form, values, person)
								});
							var cmd = A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3($author$project$Log$msgProfileSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$GenericProfileForm$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				default:
					var _v9 = _v0.a;
					return A2($author$project$Application$Boundaries$save, model, session);
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$ProfilesLoadingProgress = {$: 426};
var $author$project$Locale$Messages$ProfilesNotFound = {$: 427};
var $author$project$Locale$Messages$ProfilesTitle = {$: 430};
var $author$project$UI$notification = function (children) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('notification is-link is-light')
			]),
		children);
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$UI$panelBlock = function (block) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel-block')
			]),
		_List_fromArray(
			[block]));
};
var $author$project$UI$panel = function (_v0) {
	var theme = _v0.nq;
	var dataTag = _v0.kJ;
	var heading = _v0.le;
	var tabs = _v0.nk;
	var blocks = _v0.kt;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel'),
				$elm$html$Html$Attributes$class(theme),
				$author$project$UI$attrCyData(dataTag)
			]),
		A2(
			$elm$core$List$cons,
			A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('panel-heading')
					]),
				heading),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$nav,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-tabs')
						]),
					tabs),
				A2($elm$core$List$map, $author$project$UI$panelBlock, blocks))));
};
var $elm$html$Html$progress = _VirtualDom_node('progress');
var $author$project$UI$progressBar = F2(
	function (style, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('hero')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('hero-body')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('title is-5 is-spaced'),
													$elm$html$Html$Attributes$for('progressbar')
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(message)
												]))
										])),
									A2(
									$elm$html$Html$progress,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$id('progressbar'),
											$elm$html$Html$Attributes$class('progress is-medium'),
											$elm$html$Html$Attributes$class(style)
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]))
				]));
	});
var $author$project$Locale$Messages$BtnReset = {$: 35};
var $author$project$Locale$Messages$BtnSave = {$: 36};
var $author$project$Element$GenericProfileForm$FormReset = {$: 2};
var $author$project$Element$GenericProfileForm$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$PersonAddress = {$: 353};
var $author$project$Locale$Messages$ProfilesGravatar = function (a) {
	return {$: 424, a: a};
};
var $author$project$Locale$Messages$ProfilesHeading = function (a) {
	return {$: 425, a: a};
};
var $author$project$Element$GenericProfileForm$birthPlaceTownMaxLength = 60;
var $author$project$Locale$Messages$FormEmptyOptions = {$: 60};
var $author$project$Locale$Messages$FormNotSelected = {$: 62};
var $author$project$Form$SelectOption = F2(
	function (value, label) {
		return {lO: label, nD: value};
	});
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $author$project$UI$onChange = function (onChangeAction) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, onChangeAction, $elm$html$Html$Events$targetValue));
};
var $elm$html$Html$select = _VirtualDom_node('select');
var $elm$html$Html$option = _VirtualDom_node('option');
var $elm$html$Html$Attributes$selected = $elm$html$Html$Attributes$boolProperty('selected');
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$UI$selectOption = function (config) {
	return A2(
		$elm$html$Html$option,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$value(config.c_.nD),
				$elm$html$Html$Attributes$selected(config.z),
				$elm$html$Html$Attributes$disabled(config.dD)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(config.c_.lO)
			]));
};
var $author$project$UI$select_ = F4(
	function (isEditable, classList_, view, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control has-icons-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select'),
							$elm$html$Html$Attributes$classList(classList_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(view.kJ),
									$author$project$UI$onChange(view.aT),
									$author$project$UI$attrCyData(view.kJ),
									$elm$html$Html$Attributes$disabled(!isEditable)
								]),
							A2($elm$core$List$map, $author$project$UI$selectOption, options)),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(view.lj),
									$author$project$UI$Icon$style('is-left')
								]))
						]))
				]));
	});
var $author$project$UI$validationClassList = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return _List_fromArray(
			[
				_Utils_Tuple2('is-danger', field.kU && (!valid)),
				_Utils_Tuple2('is-success', field.kU && valid)
			]);
	});
var $author$project$UI$choiceField_ = F4(
	function (isEditable, t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValue = field.nD(values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = field.nE.mp;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						if (!_v0.a.b) {
							return A4(
								$author$project$UI$select_,
								isEditable,
								A2($author$project$UI$validationClassList, field, values),
								field.nE,
								_List_fromArray(
									[
										{
										dD: true,
										c_: A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormEmptyOptions)),
										z: false
									}
									]));
						} else {
							var options = _v0.a;
							return A4(
								$author$project$UI$select_,
								isEditable,
								A2($author$project$UI$validationClassList, field, values),
								field.nE,
								A2(
									$elm$core$List$map,
									function (option) {
										return {
											dD: false,
											c_: option,
											z: _Utils_eq(option.nD, selectedValue)
										};
									},
									A2(
										$elm$core$List$cons,
										A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormNotSelected)),
										options)));
						}
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$choiceField = $author$project$UI$choiceField_(true);
var $author$project$UI$columns = function (cols) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('columns is-fullwidth')
			]),
		A2(
			$elm$core$List$map,
			function (c) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					_List_fromArray(
						[c]));
			},
			cols));
};
var $author$project$Locale$Messages$FormDateFormat = {$: 52};
var $author$project$UI$Icon$check = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-check'),
			attributes));
};
var $author$project$UI$fieldValidationStatus = F2(
	function (edited, valid) {
		var _v0 = _Utils_Tuple2(edited, valid);
		if (_v0.a) {
			if (_v0.b) {
				return $author$project$UI$Icon$check(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-right has-text-success')
						]));
			} else {
				return $author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-exclamation-triangle'),
							$author$project$UI$Icon$style('is-right has-text-danger')
						]));
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Attributes$maxlength = function (n) {
	return A2(
		_VirtualDom_attribute,
		'maxlength',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $elm$html$Html$Attributes$readonly = $elm$html$Html$Attributes$boolProperty('readOnly');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$UI$editableTextField = F5(
	function (editable, maxLength, t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var maxLengthAttribute = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (ml) {
					return _List_fromArray(
						[
							$elm$html$Html$Attributes$maxlength(ml)
						]);
				},
				maxLength));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control has-icons-left has-icons-right')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_Utils_ap(
								_List_fromArray(
									[
										$elm$html$Html$Attributes$id(field.nE.kJ),
										$elm$html$Html$Attributes$class('input'),
										$elm$html$Html$Attributes$classList(
										A2($author$project$UI$validationClassList, field, values)),
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2('is-static', !editable)
											])),
										$elm$html$Html$Attributes$placeholder(field.nE.bv),
										$elm$html$Html$Attributes$type_(field.nE.hH),
										$elm$html$Html$Attributes$value(
										field.nD(values)),
										$elm$html$Html$Events$onInput(field.nE.aT),
										$author$project$UI$attrCyData(field.nE.kJ),
										$elm$html$Html$Attributes$readonly(!editable)
									]),
								maxLengthAttribute),
							_List_Nil),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(field.nE.lj),
									$author$project$UI$Icon$style('is-left')
								])),
							A2($author$project$UI$fieldValidationStatus, field.kU, valid),
							A2($author$project$UI$validationError, field, values)
						]))
				]));
	});
var $author$project$UI$staticTextField = A2($author$project$UI$editableTextField, false, $elm$core$Maybe$Nothing);
var $author$project$UI$textField = A2($author$project$UI$editableTextField, true, $elm$core$Maybe$Nothing);
var $author$project$UI$dateField = F4(
	function (t_, field, values, editable) {
		var fieldConfig = {
			kU: field.kU,
			mu: field.mu,
			mK: field.mK,
			jR: field.jR,
			nD: field.nD,
			nE: {
				kJ: field.nE.kJ,
				lj: 'fa-calendar',
				lO: field.nE.lO,
				aT: field.nE.aT,
				bv: t_($author$project$Locale$Messages$FormDateFormat),
				hH: 'date'
			}
		};
		return editable ? A3($author$project$UI$textField, t_, fieldConfig, values) : A3($author$project$UI$staticTextField, t_, fieldConfig, values);
	});
var $author$project$Person$fullName = F2(
	function (t_, person) {
		return t_(
			A2($author$project$Locale$Messages$PersonFullName, person.k3, person.ak));
	});
var $author$project$UI$gravatar = function (email) {
	var size = 64;
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(
				A2($author$project$Util$Media$gravatar, size, email)),
				$elm$html$Html$Attributes$width(size),
				$elm$html$Html$Attributes$height(size)
			]),
		_List_Nil);
};
var $author$project$Form$isProcessing = function (formState) {
	return formState === 2;
};
var $author$project$UI$limitedTextField = function (limit) {
	return A2(
		$author$project$UI$editableTextField,
		true,
		$elm$core$Maybe$Just(limit));
};
var $elm$html$Html$article = _VirtualDom_node('article');
var $author$project$UI$mediaObject_ = F5(
	function (size, media, content, navigation, right) {
		return A2(
			$elm$html$Html$article,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('media')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$figure,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-left')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('image'),
									$elm$html$Html$Attributes$class(size)
								]),
							media)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-content')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('content')
								]),
							content),
						navigation)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('media-right')
						]),
					right)
				]));
	});
var $author$project$UI$mediaObject = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-64x64', media, content, navigation, right);
	});
var $author$project$UI$resetButton = F4(
	function (label, disabled_, loading, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link is-light'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-loading', loading)
								])),
							$elm$html$Html$Attributes$disabled(disabled_),
							$author$project$UI$attrCyData('reset'),
							$elm$html$Html$Events$onClick(toMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Form$resetDisabled = function (formState) {
	return (!formState) || (formState === 2);
};
var $elm$html$Html$small = _VirtualDom_node('small');
var $author$project$Form$submissionDisabled = F2(
	function (formState, formValid) {
		return ((!formValid) && (formState === 1)) || (formState !== 1);
	});
var $author$project$UI$submitButton = F4(
	function (label, disabled_, loading, toMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-loading', loading)
								])),
							$elm$html$Html$Attributes$disabled(disabled_),
							$author$project$UI$attrCyData('save'),
							$elm$html$Html$Events$onClick(toMsg)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(label)
						]))
				]));
	});
var $author$project$Element$GenericProfileForm$viewForm = F6(
	function (t_, language, formState, form, formValues, person) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$ProfilesHeading(
								A2($author$project$Person$fullName, t_, person)))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$mediaObject,
							_List_fromArray(
								[
									$author$project$UI$gravatar(person.K)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$small,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ProfilesGravatar(person.K))))
								]),
							_List_Nil,
							_List_Nil)
						])),
					$author$project$UI$columns(
					language.ls ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.k3, formValues),
							A3($author$project$UI$textField, t_, form.ak, formValues)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ak, formValues),
							A3($author$project$UI$textField, t_, form.k3, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.K, formValues),
							A3($author$project$UI$textField, t_, form.aQ, formValues)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aU, formValues),
							A3($author$project$UI$textField, t_, form.a_, formValues),
							A3($author$project$UI$textField, t_, form.aV, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aX, formValues),
							A3($author$project$UI$textField, t_, form.aZ, formValues),
							A3($author$project$UI$textField, t_, form.aY, formValues),
							A3($author$project$UI$textField, t_, form.aW, formValues)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aG, formValues),
							A4($author$project$UI$limitedTextField, $author$project$Element$GenericProfileForm$birthPlaceTownMaxLength, t_, form.aH, formValues),
							A4($author$project$UI$dateField, t_, form.aE, formValues, true)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field is-grouped')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							A2($author$project$Form$submissionDisabled, formState, true),
							$author$project$Form$isProcessing(formState),
							$author$project$Element$GenericProfileForm$FormSubmitted),
							A4(
							$author$project$UI$resetButton,
							t_($author$project$Locale$Messages$BtnReset),
							$author$project$Form$resetDisabled(formState),
							$author$project$Form$isProcessing(formState),
							$author$project$Element$GenericProfileForm$FormReset)
						]))
				]));
	});
var $author$project$Element$GenericProfileForm$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 2:
				var formState = _v0.a;
				var form = _v0.b;
				var values = _v0.c;
				var person = _v0.d;
				return $author$project$UI$panel(
					{
						kt: _List_fromArray(
							[
								A6($author$project$Element$GenericProfileForm$viewForm, t_, session.lP, formState, form, values, person)
							]),
						kJ: 'profile-form',
						le: _List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ProfilesTitle)
							]),
						nk: _List_Nil,
						nq: 'is-light'
					});
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$ProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ProfilesNotFound)
						]));
		}
	});
var $author$project$Element$GenericProfileForm$element = {iA: $author$project$Element$GenericProfileForm$init, jR: $author$project$Element$GenericProfileForm$update, nE: $author$project$Element$GenericProfileForm$view};
var $author$project$RemoteData$Loading = {$: 1};
var $author$project$Element$GradeReportCard$PortfolioStoriesDownloading = {$: 0};
var $author$project$Element$GradeReportCard$StoriesDownloadResponse = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GradeReportCard$StudentProfileDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeReportCard$SubjectListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$PortfolioStory$PortfolioStory = function (id) {
	return function (type_) {
		return function (description) {
			return function (media) {
				return function (module_) {
					return function (isLocked) {
						return function (createdBy) {
							return function (createdAt) {
								return function (team) {
									return function (students) {
										return function (badges) {
											return function (classroomSubmission) {
												return {hZ: badges, h7: classroomSubmission, gz: createdAt, kG: createdBy, gD: description, gT: id, lw: isLocked, lY: media, fK: module_, e1: students, jF: team, hH: type_};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Badge$Badge = F7(
	function (id, description, isLocked, storyId, learningOutcomes, feedback, createdBy) {
		return {kG: createdBy, gD: description, gJ: feedback, gT: id, lw: isLocked, g3: learningOutcomes, hx: storyId};
	});
var $author$project$LearningOutcome$all = _List_fromArray(
	[
		{
		cG: 'studio',
		gD: 'A gyakorlatban alkalmazza az adatok védelmét biztosító lehetőségeket.',
		a: 9,
		gT: 307,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a digitális személyazonosság és az információhitelesség fogalmával.',
		a: 9,
		gT: 306,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az e-világ -- e-szolgáltatások, e-ügyintézés, e-kereskedelem, e-állampolgárság, it-gazdaság, környezet, kultúra, információvédelem -- biztonsági és jogi kérdéseivel.',
		a: 9,
		gT: 305,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'studio',
		gD: 'Az iskolai oktatáshoz kapcsolódó mobileszközökre fejlesztett alkalmazások használata során együttműködik társaival.',
		a: 9,
		gT: 304,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Az applikációkat önállóan telepíti.',
		a: 9,
		gT: 303,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Céljainak megfelelő alkalmazást választ, az alkalmazás funkcióira, kezelőfelületére vonatkozó igényeit megfogalmazza.',
		a: 9,
		gT: 302,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és használja a mobiltechnológiát, kezeli a mobileszközök operációs rendszereit és használ mobilalkalmazásokat.',
		a: 9,
		gT: 301,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Az online kommunikáció során alkalmazza a kialakult viselkedési kultúrát és szokásokat, a szerepelvárásokat.',
		a: 9,
		gT: 300,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a fogyatékkal élők közötti kommunikáció eszközeit és formáit.',
		a: 9,
		gT: 299,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Használja a két- vagy többrésztvevős kommunikációs lehetőségeket és alkalmazásokat.',
		a: 9,
		gT: 298,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Etikus módon használja fel az információforrásokat, tisztában van a hivatkozás szabályaival.',
		a: 9,
		gT: 297,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az információkeresési stratégiákat és technikákat, a találati listát a problémának megfelelően szűri, ellenőrzi annak hitelességét.',
		a: 9,
		gT: 296,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Tapasztalatokat szerez a kezdőértékek változtatásának hatásairól a szimulációs programokban.',
		a: 9,
		gT: 295,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'studio',
		gD: 'Hétköznapi, oktatáshoz készült szimulációs programokat használ.',
		a: 9,
		gT: 294,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'studio',
		gD: 'Tapasztalatokkal rendelkezik hétköznapi jelenségek számítógépes szimulációjáról.',
		a: 9,
		gT: 293,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'studio',
		gD: 'Strukturáltan tárolt nagy adathalmazokat kezel, azokból egyedi és összesített adatokat nyer ki.',
		a: 9,
		gT: 292,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'studio',
		gD: 'A feladatmegoldás során az adatbázisba adatokat visz be, módosít és töröl, űrlapokat használ, jelentéseket nyomtat.',
		a: 9,
		gT: 291,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'studio',
		gD: 'Az adatbázisban interaktív módon keres, rendez és szűr.',
		a: 9,
		gT: 290,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az adatbázis-kezelés alapfogalmait.',
		a: 9,
		gT: 289,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'studio',
		gD: 'Az adatokat diagramon szemlélteti.',
		a: 9,
		gT: 288,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'studio',
		gD: 'Nagy adathalmazokat tud kezelni.',
		a: 9,
		gT: 287,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'studio',
		gD: 'A problémamegoldás során függvényeket célszerűen használ.',
		a: 9,
		gT: 286,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'studio',
		gD: 'Táblázatkezelővel adatelemzést és számításokat végez.',
		a: 9,
		gT: 285,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'studio',
		gD: 'Adatokat táblázatba rendez.',
		a: 9,
		gT: 284,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'studio',
		gD: 'A feladat megoldásának helyességét teszteli.',
		a: 9,
		gT: 283,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Szekvencia, elágazás és ciklus segítségével algoritmust hoz létre, és azt egy magas szintű formális programozási nyelven kódolja.',
		a: 9,
		gT: 282,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Példákban, feladatok megoldásában használja egy formális programozási nyelv fejlesztői környezetének alapszolgáltatásait.',
		a: 9,
		gT: 281,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Érti egy algoritmus-leíró eszköz alapvető építőelemeit, érti a típusalgoritmusok felhasználásának lehetőségeit.',
		a: 9,
		gT: 280,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az elemi és összetett adattípusok közötti különbségeket.',
		a: 9,
		gT: 279,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a következő elemi adattípusok közötti különbségeket: egész, valós szám, karakter, szöveg, logikai.',
		a: 9,
		gT: 278,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Érti az egyszerű problémák megoldásához szükséges tevékenységek lépéseit és kapcsolatukat.',
		a: 9,
		gT: 277,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a raszter-, a vektorgrafikus ábrák tárolási és szerkesztési módszereivel',
		a: 9,
		gT: 276,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'studio',
		gD: 'Digitálisan rögzít képet, hangot és videót, azokat manipulálja.',
		a: 9,
		gT: 275,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'studio',
		gD: 'Létrehoz vektorgrafikus ábrákat.',
		a: 9,
		gT: 274,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'studio',
		gD: 'Létrehozza az adott probléma megoldásához szükséges rasztergrafikus ábrákat.',
		a: 9,
		gT: 273,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a html formátumú dokumentumok szerkezeti elemeit, érti a css használatának alapelveit; több lapból álló webhelyet készít.',
		a: 9,
		gT: 272,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'studio',
		gD: 'Dokumentumokat szerkeszt és helyez el tartalomkezelő rendszerben.',
		a: 9,
		gT: 271,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az információkeresés során gyűjtött multimédiás alapelemeket új dokumentumok készítéséhez.',
		a: 9,
		gT: 270,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'studio',
		gD: 'Gyakorlatot szerez a fotó-, hang-, videó-, multimédia-szerkesztő, a bemutató-készítő eszközök használatában.',
		a: 9,
		gT: 269,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'studio',
		gD: 'Tapasztalatokkal rendelkezik a formanyomtatványok, a sablonok, az előre definiált stílusok használatáról.',
		a: 9,
		gT: 268,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Speciális dokumentumokat hoz létre, alakít át és formáz meg.',
		a: 9,
		gT: 267,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri egy adott feladat megoldásához szükséges digitális eszközök és szoftverek kiválasztásának szempontjait.',
		a: 9,
		gT: 266,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Használja az állományok tömörítését és a tömörített állományok kibontását.',
		a: 9,
		gT: 265,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a digitális kártevők elleni védekezés lehetőségeivel.',
		a: 9,
		gT: 264,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'studio',
		gD: 'Használja az operációs rendszer segédprogramjait, és elvégzi a munkakörnyezet beállításait.',
		a: 9,
		gT: 263,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'studio',
		gD: 'Követi a technológiai változásokat a digitális információforrások használatával.',
		a: 9,
		gT: 262,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'studio',
		gD: 'Igénybe veszi az operációs rendszer és a számítógépes hálózat alapszolgáltatásait.',
		a: 9,
		gT: 261,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'studio',
		gD: 'Céljainak megfelelően használja a mobileszközök és a számítógépek operációs rendszereit.',
		a: 9,
		gT: 260,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan használja az informatikai eszközöket, elkerüli a tipikus felhasználói hibákat, elhárítja az egyszerűbb felhasználói hibákat.',
		a: 9,
		gT: 259,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'studio',
		gD: 'Tudatosan alakítja informatikai környezetét, ismeri az ergonomikus informatikai környezet jellemzőit, figyelembe veszi a digitális eszközök egészségkárosító hatásait, óvja maga és környezete egészségét.',
		a: 9,
		gT: 258,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a digitális eszközök és a számítógépek fő egységeit, ezek fejlődésének főbb állomásait, tendenciáit.',
		a: 9,
		gT: 257,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és tudja használni a célszerűen választott informatikai eszközöket és a működtető szoftvereit, ismeri a felhasználási lehetőségeket.',
		a: 9,
		gT: 256,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az e-világ elvárásait, lehetőségeit és veszélyeit.',
		a: 9,
		gT: 255,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Hatékonyan keres információt; az ikt-tudáselemek felhasználásával társaival együttműködve problémákat old meg.',
		a: 9,
		gT: 254,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri az algoritmikus probléma megoldásához szükséges módszereket és eszközöket, megoldásukhoz egy magas szintű formális programozási nyelv fejlesztői környezetét önállóan használja.',
		a: 9,
		gT: 253,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri az adatkezelés alapfogalmait, képes a nagyobb adatmennyiség tárolását, hatékony feldolgozását biztosító eszközök és módszerek alapszintű használatára, érti a működésüket.',
		a: 9,
		gT: 252,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Gyakorlatot szerez dokumentumok létrehozását segítő eszközök használatában.',
		a: 9,
		gT: 251,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az informatikai eszközök és a működtető szoftvereik célszerű választásának alapelveit, használja a digitális hálózatok alapszolgáltatásait, az online kommunikáció eszközeit, tisztában van az ezzel járó veszélyekkel, ezzel összefüggésben ismeri a segítségnyújtási, segítségkérési lehetőségeket.',
		a: 9,
		gT: 250,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az életkorának és érdeklődésének megfelelő digitális műfajok főbb jellemzőit.',
		a: 9,
		gT: 687,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is megfelelő nyelvi eszközökkel alkot szöveget szóban és írásban.',
		a: 9,
		gT: 686,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat a természeteshez közelítő célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 685,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 684,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkalmazza az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 683,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is megérti az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 682,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkot szöveget szóban és írásban.',
		a: 9,
		gT: 681,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a legfőbb nyelvi dialektusok egyes elemeit is tartalmazó szóbeli közléseket.',
		a: 9,
		gT: 680,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a nyelvi változatokról megszerzett ismereteit informális kommunikációjában.',
		a: 9,
		gT: 679,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'studio',
		gD: 'Megfogalmaz főbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 678,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a legfőbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 677,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'studio',
		gD: 'Interkulturális ismeretei segítségével társasági szempontból is megfelelő kommunikációt folytat írásban és szóban.',
		a: 9,
		gT: 676,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó tanult nyelvi elemeket magabiztosan használja.',
		a: 9,
		gT: 675,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'Kikövetkezteti a célnyelvi kultúrákhoz kapcsolódó egyszerű, ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 674,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'Környezetének kulturális értékeit célnyelven közvetíti.',
		a: 9,
		gT: 673,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Interkulturális tudatosságára építve felismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket, és a magyar értékek átadására képessé válik.',
		a: 9,
		gT: 672,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket.',
		a: 9,
		gT: 671,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Átadja célnyelven a magyar értékeket.',
		a: 9,
		gT: 670,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és keresi a főbb hasonlóságokat és különbségeket saját anyanyelvi és a célnyelvi közösség szokásai, értékei, attitűdjei és meggyőződései között.',
		a: 9,
		gT: 669,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Tájékozott, és alkalmazni is tudja a célnyelvi országokra jellemző alapvető érintkezési és udvariassági szokásokat.',
		a: 9,
		gT: 668,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Tájékozott a célnyelvi országok jellemzőiben és kulturális sajátosságaiban.',
		a: 9,
		gT: 667,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a célnyelvi országok történelmének és jelenének legfontosabb vonásait,',
		a: 9,
		gT: 666,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a célnyelvi kultúráról megszerzett ismereteit informális kommunikációjában,',
		a: 9,
		gT: 665,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközöket és felületeket is használ a célnyelven ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 664,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközöket és felületeket is magabiztosan használ nyelvtudása fejlesztésére.',
		a: 9,
		gT: 663,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik releváns digitális tartalmak használatára beszédkészségének, szókincsének és kiejtésének továbbfejlesztése céljából.',
		a: 9,
		gT: 662,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvi produkciójában és recepciójában önállóságot mutat, és egyre kevesebb korlát akadályozza.',
		a: 9,
		gT: 661,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Beszéd- és írásprodukcióját tudatosan megtervezi, hiányosságait igyekszik kompenzálni.',
		a: 9,
		gT: 660,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 659,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 658,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvtanulási céljai érdekében él a valós nyelvhasználati lehetőségekkel.',
		a: 9,
		gT: 657,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Hiányosságait, hibáit felismeri, azokat egyre hatékonyabban kompenzálja, javítja a tanult stratégiák felhasználásával.',
		a: 9,
		gT: 656,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 655,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Egyre tudatosabban használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 654,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Használ önértékelési módokat nyelvtudása felmérésére.',
		a: 9,
		gT: 653,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvi haladását fel tudja mérni.',
		a: 9,
		gT: 652,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Az első idegen nyelvből sikeres érettségit tesz legalább középszinten.',
		a: 9,
		gT: 651,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Céljai eléréséhez önszabályozóan is dolgozik.',
		a: 9,
		gT: 650,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Hatékonyan alkalmazza a tanult nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 649,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Használja a nyelvtanulási és nyelvhasználati stratégiákat nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 648,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Beazonosít nyelvtanulási célokat és ismeri az ezekhez tartozó nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 647,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Céljai eléréséhez társaival párban és csoportban is együttműködik.',
		a: 9,
		gT: 646,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket, módokat.',
		a: 9,
		gT: 645,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvtanulási céljai érdekében tudatosabban foglalkozik a célnyelvvel.',
		a: 9,
		gT: 644,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Megfogalmaz hosszú távú nyelvtanulási célokat saját maga számára.',
		a: 9,
		gT: 643,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 642,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Hibáiból levont következtetéseire többnyire épít nyelvtudása fejlesztése érdekében.',
		a: 9,
		gT: 641,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Hibáit az esetek többségében önállóan is képes javítani.',
		a: 9,
		gT: 640,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Használ ismeretterjesztő anyagokat nyelvtudása fejlesztésére.',
		a: 9,
		gT: 639,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Használ célnyelvi tartalmakat ismeretszerzésre.',
		a: 9,
		gT: 638,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Használ célnyelvi elemeket más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 637,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja a célnyelvű, legfőbb hazai és nemzetközi híreket ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 636,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 635,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvtanulási céljai érdekében alkalmazza a tanórán kívüli nyelvtanulási lehetőségeket.',
		a: 9,
		gT: 634,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Megértést nehezítő hibáit önállóan javítani tudja.',
		a: 9,
		gT: 633,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 632,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Szükség esetén eltér az előre elgondoltaktól, és mondandóját a beszédpartnerekhez, hallgatósághoz igazítja.',
		a: 9,
		gT: 631,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Szociokulturális ismeretei (például célnyelvi társadalmi szokások, testbeszéd) már lehetővé teszik azt, hogy társasági szempontból is megfelelő kommunikációt folytasson.',
		a: 9,
		gT: 630,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi funkciókat és nyelvi eszköztárát életkorának megfelelő élethelyzetekben megfelelően alkalmazza.',
		a: 9,
		gT: 629,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Szóbeli és írásbeli közlései során változatos nyelvi struktúrákat használ.',
		a: 9,
		gT: 628,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemeket adaptálni tudja kevésbé begyakorolt helyzetekhez is.',
		a: 9,
		gT: 627,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Mondanivalóját kifejti kevésbé ismerős helyzetekben is nyelvi eszközök széles körének használatával.',
		a: 9,
		gT: 626,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Nem értés esetén képes a tartalom tisztázására.',
		a: 9,
		gT: 625,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'A társalgás vagy eszmecsere menetének fenntartásához alkalmazza a rendelkezésére álló nyelvi és stratégiai eszközöket.',
		a: 9,
		gT: 624,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Félreértéshez vezető hibáit kijavítja, ha beszédpartnere jelzi a problémát; a kommunikáció megszakadása esetén más stratégiát alkalmazva újrakezdi a mondandóját.',
		a: 9,
		gT: 623,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Ismert témákban a szövegösszefüggés alapján kikövetkezteti az ismeretlen szavak jelentését, megérti az ismeretlen szavakat is tartalmazó mondat jelentését.',
		a: 9,
		gT: 622,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Körülírással közvetíti a jelentéstartalmat, ha a megfelelő szót nem ismeri.',
		a: 9,
		gT: 621,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Használ kiemelést, hangsúlyozást, helyesbítést.',
		a: 9,
		gT: 620,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Képes rendszerezni kommunikációját: jelzi szándékát, kezdeményez, összefoglal és lezár.',
		a: 9,
		gT: 619,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Több különálló elemet összekapcsol összefüggő lineáris szempontsorrá.',
		a: 9,
		gT: 618,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'A kohéziós eszközök szélesebb körét alkalmazza szóbeli vagy írásbeli megnyilatkozásainak érthetőbb, koherensebb szöveggé szervezéséhez.',
		a: 9,
		gT: 617,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Összekapcsolja a mondatokat megfelelő kötőszavakkal, így követhető leírást ad, vagy nem kronológiai sorrendben lévő eseményeket is elbeszél.',
		a: 9,
		gT: 616,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez emlékezést és nem emlékezést.',
		a: 9,
		gT: 615,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ok-okozat viszony vagy cél meghatározását.',
		a: 9,
		gT: 614,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez segítségkérést, ajánlást és ezekre történő reagálást.',
		a: 9,
		gT: 613,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ítéletet, kritikát, tanácsadást.',
		a: 9,
		gT: 612,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez kötelezettséget, szándékot, kívánságot, engedélykérést, feltételezést.',
		a: 9,
		gT: 611,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez érdeklődést és érdektelenséget, szemrehányást, reklamálást.',
		a: 9,
		gT: 610,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével további alapvető érzéseket fejez ki (pl. aggódást, félelmet, kételyt).',
		a: 9,
		gT: 609,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'studio',
		gD: 'Írásban közvetít célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 608,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Írott szöveget igénylő projektmunkát készít olvasóközönségnek.',
		a: 9,
		gT: 607,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Környezeti témákban a kommunikációs helyzetek széles körében hatékonyan ad át és cserél információt.',
		a: 9,
		gT: 606,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Összefoglal és lejegyzetel, írásban közvetít rövid olvasott vagy hallott szövegeket.',
		a: 9,
		gT: 605,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Ismer más tantárgyi tartalmakat, részinformációkat célnyelven,',
		a: 9,
		gT: 604,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Használ célnyelvi tartalmakat tudásmegosztásra.',
		a: 9,
		gT: 603,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Egyénileg vagy kooperáció során létrehozott projektmunkával kapcsolatos kiselőadást tart önállóan, összefüggő és folyékony előadásmóddal, digitális eszközök segítségével, felkészülést követően.',
		a: 9,
		gT: 602,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Összetett információkat ad át és cserél.',
		a: 9,
		gT: 601,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Írásban és szóban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 600,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Írásban átad nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciók során.',
		a: 9,
		gT: 599,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Véleményét írásban változatos nyelvi eszközökkel megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 598,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Véleményét írásban, tanult nyelvi eszközökkel megfogalmazza és arról írásban interakciót folytat.',
		a: 9,
		gT: 597,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Informális és életkorának megfelelő formális írásos üzeneteket ír, digitális felületen is.',
		a: 9,
		gT: 596,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 595,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre jellemzően célnyelvi eszközökkel is reagál tanórai szituációkban.',
		a: 9,
		gT: 594,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Egyre szélesebb körű témákban, nyelvi kommunikációt igénylő helyzetekben reagál megfelelő módon, felhasználva általános és nyelvi háttértudását, ismereteit, alkalmazkodva a társadalmi normákhoz.',
		a: 9,
		gT: 593,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Társaival a kooperatív munkaformákban és a projektfeladatok megoldása során is törekszik a célnyelvi kommunikációra.',
		a: 9,
		gT: 592,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Aktívan, kezdeményezően és magabiztosan vesz részt a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 591,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A mindennapi élet különböző területein, a kommunikációs helyzetek széles körében tesz fel releváns kérdéseket információszerzés céljából, és válaszol megfelelő módon a hozzá intézett célnyelvi kérdésekre.',
		a: 9,
		gT: 590,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Érzelmeit, véleményét változatos nyelvi eszközökkel szóban megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 589,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Előkészület nélkül részt tud venni személyes jellegű, vagy érdeklődési körének megfelelő ismert témáról folytatott társalgásban,',
		a: 9,
		gT: 588,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A társalgást hatékonyan és udvariasan fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt, akár ismeretlen beszélgetőtárs esetében is.',
		a: 9,
		gT: 587,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Társalgást kezdeményez, a megértést fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt az egyes tématartományokon belül, akár anyanyelvű beszélgetőtárs esetében is.',
		a: 9,
		gT: 586,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A társalgásba aktívan, kezdeményezően és egyre magabiztosabban bekapcsolódik az érdeklődési körébe tartozó témák esetén vagy az ajánlott tématartományokon belül.',
		a: 9,
		gT: 585,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Szóban ad át nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 584,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Részt vesz a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 583,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Egyre változatosabb, hosszabb, összetettebb és elvontabb szövegeket, tartalmakat értelmez és használ.',
		a: 9,
		gT: 582,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Keresi az érdeklődésének megfelelő, célnyelvi, autentikus szövegeket szórakozásra és ismeretszerzésre tanórán kívül is.',
		a: 9,
		gT: 581,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az írott szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 580,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Kiszűr konkrét információkat nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 579,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti és értelmezi az írott szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 578,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó írott szöveg tartalmát.',
		a: 9,
		gT: 577,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'A szövegkörnyezet alapján kikövetkezteti a szövegben előforduló ismeretlen szavak jelentését.',
		a: 9,
		gT: 576,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi a számára ismerős, elvontabb tartalmú szövegekben megjelenő ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 575,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti és értelmezi az összefüggéseket és a részleteket az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 574,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti és értelmezi a lényeget az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 573,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Elolvas és értelmez nyelvi szintjének megfelelő irodalmi szövegeket.',
		a: 9,
		gT: 572,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megért szokványos tempóban folyó autentikus szórakoztató és ismeretterjesztő tartalmakat, változatos csatornákon.',
		a: 9,
		gT: 571,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti és értelmezi a legtöbb televíziós hírműsort.',
		a: 9,
		gT: 570,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét akár anyanyelvi beszélők köznyelvi kommunikációjában a számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 569,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 568,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 567,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a hangzó szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 566,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti az elvontabb tartalmú hangzószövegek lényegét, valamint a beszélők véleményét is.',
		a: 9,
		gT: 565,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a hangzó szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 564,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó hangzó szöveg lényegi tartalmát.',
		a: 9,
		gT: 563,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti és értelmezi az összetettebb, az ajánlott témakörökhöz kapcsolódó összefüggő szövegeket, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 562,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti, értelmezi és összefoglalja az összetettebb, a tématartományhoz kapcsolódó összefüggő hangzó szöveget, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 561,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 560,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Kikövetkezteti a szövegben megjelenő elvontabb nyelvi elemek jelentését az ajánlott témakörökhöz kapcsolódó témákban.',
		a: 9,
		gT: 559,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi hírek, események lényegét.',
		a: 9,
		gT: 558,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi a szintjének megfelelő célnyelvi, komplexebb tanári magyarázatokat a nyelvórákon.',
		a: 9,
		gT: 557,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'A megfelelő szövegtípusok jellegzetességeit követi.',
		a: 9,
		gT: 556,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Beszámol akár az érdeklődési körén túlmutató közügyekkel, szórakozással kapcsolatos eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 555,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló, akár az érdeklődési körén túlmutató vagy elképzelt személyes eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 554,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'A szövegek létrehozásához nyomtatott vagy digitális segédeszközt, szótárt használ.',
		a: 9,
		gT: 553,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggő szövegeket ír önállóan, akár elvontabb témákban.',
		a: 9,
		gT: 552,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformában.',
		a: 9,
		gT: 551,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Megold változatos írásbeli, feladatokat szövegszinten.',
		a: 9,
		gT: 550,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Használ szövegkohéziós és figyelemvezető eszközöket.',
		a: 9,
		gT: 549,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a formális és informális regiszterhez köthető sajátosságokat.',
		a: 9,
		gT: 548,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Információt vagy véleményt közlő és kérő, összefüggő feljegyzéseket, üzeneteket ír.',
		a: 9,
		gT: 547,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Leír összetettebb cselekvéssort, történetet, személyes élményeket, elvontabb témákban.',
		a: 9,
		gT: 546,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Írásban röviden indokolja érzéseit, gondolatait, véleményét már elvontabb témákban.',
		a: 9,
		gT: 545,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a célnyelvi normához illeszkedő, természeteshez közelítő kiejtést, beszédtempót és intonációt.',
		a: 9,
		gT: 544,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggően, világosan és nagyrészt folyékonyan beszél az ajánlott tématartományhoz tartozó és az idevágó érettségi témákban, akár elvontabb tartalmakra is kitérve.',
		a: 9,
		gT: 543,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Beszámol akár az érdeklődési körén túlmutató környezeti eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 542,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Kreatív, változatos műfajú szövegeket alkot szóban, kooperatív munkaformákban.',
		a: 9,
		gT: 541,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggő, folyékony előadásmódú szóbeli prezentációt tart önállóan, felkészülést követően, az érettségi témakörök közül szabadon választott témában, ikt-eszközökkel támogatva mondanivalóját.',
		a: 9,
		gT: 540,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Közép- és emelt szintű nyelvi érettségi szóbeli feladatokat old meg.',
		a: 9,
		gT: 539,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Összefoglalja ismert témában nyomtatott vagy digitális alapú ifjúsági tartalmak lényegét röviden és érthetően.',
		a: 9,
		gT: 538,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Ajánlott tématartományhoz kapcsolódó képi hatás kapcsán saját gondolatait, véleményét és érzéseit is kifejti az ismert nyelvi eszközökkel.',
		a: 9,
		gT: 537,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló vagy elképzelt eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő rövid jellemzésével.',
		a: 9,
		gT: 536,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggően, érthetően és nagyrészt folyékonyan beszél az ajánlott tématartományokhoz tartozó és az érettségi témákban a tanult nyelvi eszközökkel, felkészülést követően.',
		a: 9,
		gT: 535,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Visszaad tankönyvi vagy más tanult szöveget, elbeszélést, nagyrészt folyamatos és érthető történetmeséléssel, a cselekményt logikusan összefűzve.',
		a: 9,
		gT: 534,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'studio',
		gD: 'Első idegen nyelvéből sikeresen érettségit tesz a céljainak megfelelő szinten.',
		a: 9,
		gT: 533,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Beazonosítja nyelvtanulási céljait és egyéni különbségeinek tudatában, ezeknek megfelelően fejleszti nyelvtudását.',
		a: 9,
		gT: 532,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 531,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 530,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Használ hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 529,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Felkészül az aktív nyelvtanulás eszközeivel az egész életen át történő tanulásra.',
		a: 9,
		gT: 528,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvtudását képes fejleszteni tanórán kívüli eszközökkel, lehetőségekkel és helyzetekben is, valamint a tanultakat és gimnáziumban a második idegen nyelv tanulásában is alkalmazza.',
		a: 9,
		gT: 527,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a nyelvi funkciókat és megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 526,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat és tartalmakat közvetít idegen nyelven.',
		a: 9,
		gT: 525,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Értelmez nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket kevésbé ismert témákban és szövegtípusokban is.',
		a: 9,
		gT: 524,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban létrehoz szövegeket különböző szövegtípusokban.',
		a: 9,
		gT: 523,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban is megold változatos kihívásokat igénylő, többnyire valós kommunikációs helyzeteket leképező feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 522,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a genetikai információ átadásának alapvető szabályait.',
		a: 9,
		gT: 1206,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a hálózatok és a hálózatkutatás szerepét modern világunkban, az életközösségek, a sejtszintű gondolkodás és az információs technológiák területén.',
		a: 9,
		gT: 1205,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az emberi szexualitás kulturális, társadalmi és biológiai alapjait. Önálló véleménye van a nemi szerepek fontosságáról, érti a nemi identitás komplex jellegét.',
		a: 9,
		gT: 1204,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az emberi szervezet egészségét alapvetően befolyásoló tényezőket, a stressz, az öröklött hajlamok és genetikai tulajdonságok, valamint a környezeti hatások szerepét',
		a: 9,
		gT: 1203,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a tanulás és az emberi kommunikáció biológiai alapjait',
		a: 9,
		gT: 1202,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az Univerzum létrejöttének ma ismert elméletével, valamint a Naprendszer kialakulásának folyamatával',
		a: 9,
		gT: 1201,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az emberi agy alapvető működési szabályait és az azt befolyásoló tényezőket',
		a: 9,
		gT: 1200,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az emberi táplálkozás során hasznos ételeket, megkülönbözteti a gyógyító és a káros anyagokat, önállóan tud egészséges ételt készíteni',
		a: 9,
		gT: 1199,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a föld légkörét befolyásoló globális folyamatokat (tengerek és szelek áramlása, klímaváltozás, üvegházhatású gázok)',
		a: 9,
		gT: 1198,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a talaj természetét és annak megművelésének különböző formáit',
		a: 9,
		gT: 1197,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a különböző kultúrák eltérő gazdasági termelési szokásait (növénytermesztés, állattartás)',
		a: 9,
		gT: 1196,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a vadon élő állatközösségeket fenyegető veszélyeket és azt a kihívást, amit ez az emberekre gyakorol',
		a: 9,
		gT: 1195,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a növények tápanyagigényét és fejlődésük alapjait',
		a: 9,
		gT: 1194,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Tudja, hogy milyen vízkészletekkel rendelkezik a Föld és azok felhasználásának milyen hatása van a környezeti, ipari, turisztikai és szállítmányozási folyamatokra',
		a: 9,
		gT: 1193,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a levegő és a víz fizikai és kémiai jellemzőit, felismeri ezek élettani hatásait',
		a: 9,
		gT: 1192,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Használja a regionalitás fogalmát és érti annak szerepét a gazdasági folyamatok alakulásában',
		a: 9,
		gT: 1191,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a városi és falusi életmód és életterek közötti különbségeket, azok környezetre gyakorolt hatását',
		a: 9,
		gT: 1190,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Megkülönbözteti egymástól a természetes és mesterséges anyagokat és felismeri, hogy miként állapítható egy anyag összetétele',
		a: 9,
		gT: 1189,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az energia fogalmát és az egyéni és társadalmi energiafelhasználás különböző lehetőségeit',
		a: 9,
		gT: 1188,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a hulladékgazdálkodás aktuális kihívásait',
		a: 9,
		gT: 1187,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a föld népességgének aktuális kihívásait beleértve azok társadalmi és egészségügyi kockázatait (betegség-megelőzés, járványok, élelmezés)',
		a: 9,
		gT: 1186,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a világ megismerésének egyik alapja a szerveződési szintek és típusok megértése (periódusos rendszer, sjetszintű szerveződések, állat és növényvilág rendszertana, a világegyetem szervező elvei)',
		a: 9,
		gT: 1185,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a tárgyak mozgása előrejelezhető (erők, égitestek mozgása, molekuláris mozgások, hangok, fények mozgása)',
		a: 9,
		gT: 1184,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a természet ismert rendszerei előrejelezhető módon változnak (evolúció, klímaváltozás, földtörténeti korok, Föld felszíni változása, tektonikus mozgások, ember környezeti hatásai stb.)',
		a: 9,
		gT: 1183,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy az anyag atomi természete határozza meg a fizikai és kémiai tulajdonságokat és azok kölcsönhatásából eredő módosulását. (Példák kísérletekre: kémiai reakciók, molekuláris biológiai, anyagok körforgása a különböző ökoszisztémákban)',
		a: 9,
		gT: 1182,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az energia felhasználásának és átalakulásának elméleti és gyakorlati lehetőségeit (energiaáramláson alapuló ökoszisztémák, a föld saját energiaforrásai stb.)',
		a: 9,
		gT: 1181,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a saját és társai által végzett tudományos kísérletek etikai és társadalmi vonatkozásait',
		a: 9,
		gT: 1180,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan és kiscsoportban biztonságosan végez természettduományos kísérleteket',
		a: 9,
		gT: 1179,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Tudományos kutatási eredményeket érthetően mutat be digitális eszközök segítségével',
		a: 9,
		gT: 1178,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Elméleti és gyakorlati eszközöket választ és alkalmaz egy adott tudományos probléma ismertetéséhez',
		a: 9,
		gT: 1177,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Hiteles források felhasználásával egy tudományos probléma kritikus elemzését adja a megszerzett információk alapján',
		a: 9,
		gT: 1176,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Érti a tudomány szerepét és szükségszerűségét a társadalmi folyamatok alakításában',
		a: 9,
		gT: 1175,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Tudományos kutatások során elvégzi a megszerzett adatok feldolgozását és értelmezését',
		a: 9,
		gT: 1174,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Önálló kutatása összeállításakor tudományos modelleket használ',
		a: 9,
		gT: 1173,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Önálló tudományos kutatást tervez meg és végez el',
		a: 9,
		gT: 1172,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a tudományos kutatás alapszabályait és azokat alkalmazza',
		a: 9,
		gT: 1171,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'studio',
		gD: 'A kommunikációs helyzetnek és a célnak megfelelően tudatosan alkalmazza a beszélt és írott nyelvet, reflektál saját és társai nyelvhasználatára.',
		a: 9,
		gT: 1697,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'A feladatokat komplex szempontoknak megfelelően oldja meg, azokat kiegészíti saját szempontjaival.',
		a: 9,
		gT: 1696,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, a források tartalmát mérlegelő módon gondolja végig.',
		a: 9,
		gT: 1695,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Vitahelyzetben figyelembe veszi mások álláspontját, a lehetséges ellenérveket is.',
		a: 9,
		gT: 1694,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Megnyilvánulásaiban, a vitákban alkalmazza az érvelés alapvető szabályait.',
		a: 9,
		gT: 1693,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'A környező világ jelenségeiről, szövegekről, műalkotásokról véleményt alkot, és azt érvekkel támasztja alá.',
		a: 9,
		gT: 1692,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Részt vesz irodalmi mű kreatív feldolgozásában, bemutatásában (pl. animáció, dramaturgia, átirat).',
		a: 9,
		gT: 1691,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Önismeretét irodalmi művek révén fejleszti.',
		a: 9,
		gT: 1690,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Választott olvasmányaira is vonatkoztatja a tanórán megismert kontextusteremtő eljárások tanulságait.',
		a: 9,
		gT: 1689,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Társai érdeklődését figyelembe véve ajánl olvasmányokat.',
		a: 9,
		gT: 1688,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Olvasmányai kiválasztásakor figyelembe veszi az alkotások kulturális regiszterét.',
		a: 9,
		gT: 1687,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Tudatosan keresi a történeti és esztétikai értékekkel rendelkező olvasmányokat, műalkotásokat.',
		a: 9,
		gT: 1686,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'A kötelező olvasmányokat elolvassa, és saját örömére is olvas.',
		a: 9,
		gT: 1685,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'studio',
		gD: 'Megadott vagy önállóan kiválasztott szempontok alapján az irodalmi művekről elemző esszét ír.',
		a: 9,
		gT: 1684,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Különböző, a munka világában is használt hivatalos szövegeket alkot hagyományos és digitális felületeken (pl. kérvény, beadvány, nyilatkozat, egyszerű szerződés, meghatalmazás, önéletrajz, motivációs levél).',
		a: 9,
		gT: 1683,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri, érti és etikusan alkalmazza a hagyományos, digitális és multimédiás szemléltetést.',
		a: 9,
		gT: 1682,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Érvelő esszét alkot megadott szempontok vagy szövegrészletek alapján.',
		a: 9,
		gT: 1681,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Az írásbeli szövegalkotáskor alkalmazza a tanult szerkesztési, stilisztikai ismereteket és a helyesírási szabályokat.',
		a: 9,
		gT: 1680,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'A tanult szövegtípusoknak megfelelő tartalommal és szerkezettel önállóan alkot különféle írásbeli szövegeket.',
		a: 9,
		gT: 1679,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Írásbeli és szóbeli nyelvhasználata, stílusa az adott kommunikációs helyzetnek megfelelő. írásképe tagolt, beszéde érthető, artikulált.',
		a: 9,
		gT: 1678,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és megnevezi a szóbeli előadásmód hatáskeltő eszközeit, hatékonyan alkalmazza azokat.',
		a: 9,
		gT: 1677,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Rendelkezik korának megfelelő retorikai ismeretekkel.',
		a: 9,
		gT: 1676,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Képes eltérő műfajú szóbeli szövegek alkotására: felelet, kiselőadás, hozzászólás, felszólalás.',
		a: 9,
		gT: 1675,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Megadott szempontrendszer alapján szóbeli feleletet készít.',
		a: 9,
		gT: 1674,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a tanult tantárgyak, tudományágak szakszókincsét, azokat a beszédhelyzetnek megfelelően használja.',
		a: 9,
		gT: 1673,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan értelmezi az ismeretlen kifejezéseket a szövegkörnyezet vagy digitális, illetve nyomtatott segédeszközök használatával.',
		a: 9,
		gT: 1672,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik arra, hogy a különböző típusú, stílusú és regiszterű szövegekben megismert, számára új kifejezéseket beépítse szókincsébe, azokat adekvát módon használja.',
		a: 9,
		gT: 1671,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Megtalálja a közös és eltérő jellemzőket a hagyományos és a digitális technikával előállított, tárolt szövegek között, és véleményt formál azok sajátosságairól.',
		a: 9,
		gT: 1670,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és értelmezi a szövegben a kétértelműséget és a félrevezető információt, valamint elemzi és értelmezi a szerző szándékát.',
		a: 9,
		gT: 1669,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, ezek eredményeit szintetizálja.',
		a: 9,
		gT: 1668,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Folyamatos és nem folyamatos, hagyományos és digitális szövegeket olvas és értelmez maga által választott releváns szempontok alapján.',
		a: 9,
		gT: 1667,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és értelmezésében figyelembe veszi a hallott és az írott szövegek közötti funkcionális és stiláris különbségeket.',
		a: 9,
		gT: 1666,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggő szóbeli szöveg (előadás, megbeszélés, vita) alapján önállóan vázlatot készít.',
		a: 9,
		gT: 1665,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Különböző típusú és célú szövegeket hallás alapján értelmez és megfelelő stratégia alkalmazásával értékel és összehasonlít.',
		a: 9,
		gT: 1664,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Egymással összefüggésben értelmezi a szöveg tartalmi elemeit és a hozzá kapcsolódó illusztrációkat, ábrákat.',
		a: 9,
		gT: 1663,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Azonosítja a szöveg szerkezeti elemeit, és figyelembe veszi azok funkcióit a szöveg értelmezésekor.',
		a: 9,
		gT: 1662,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Hosszabb terjedelmű szöveg alapján többszintű vázlatot vagy részletes gondolattérképet készít.',
		a: 9,
		gT: 1661,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'A megismert szöveg tartalmi és nyelvi minőségéről érvekkel alátámasztott véleményt alkot.',
		a: 9,
		gT: 1660,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'A különböző olvasási típusokat és a szövegfeldolgozási stratégiákat a szöveg típusának és az olvasás céljának megfelelően választja ki és kapcsolja össze.',
		a: 9,
		gT: 1659,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Különböző megjelenésű, típusú, műfajú, korú és összetettségű szövegeket olvas, értelmez.',
		a: 9,
		gT: 1658,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'studio',
		gD: 'Tanulmányai során ismereteket szerez a kulturális intézmények (múzeum, könyvtár, színház) és a nyomtatott, illetve digitális formában megjelenő kulturális folyóiratok, adatbázisok működéséről.',
		a: 9,
		gT: 1657,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tájékozottságot szerez régiója magyar irodalmáról.',
		a: 9,
		gT: 1656,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A mű értelmezésében összekapcsolja a szöveg poétikai tulajdonságait a mű nemzeti hagyományban betöltött szerepével.',
		a: 9,
		gT: 1655,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Szükség esetén a mű értelmezéséhez felhasználja történeti ismereteit.',
		a: 9,
		gT: 1654,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A tantárgyhoz kapcsolódó fogalmakkal bemutatja a lírai mű hangulati és hangnemi sajátosságait, hivatkozik a mű verstani felépítésére.',
		a: 9,
		gT: 1653,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A líra mű értelmezésében alkalmazza az általa tanult líraelméleti és líratörténeti fogalmakat (pl. lírai én, beszédhelyzetek, beszédmódok, ars poetica, szereplíra).',
		a: 9,
		gT: 1652,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A drámai mű értelmezésében alkalmazza az általa tanult drámaelméleti és drámatörténeti fogalmakat (pl. analitikus és abszurd dráma, epikus színház, elidegenedés).',
		a: 9,
		gT: 1651,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Epikai művekben értelmezi a különböző elbeszélésmódok szerepét (tudatábrázolás, egyenes és függő beszéd, mindentudó és korlátozott elbeszélő stb.).',
		a: 9,
		gT: 1650,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Epikai és drámai művekben rendszerbe foglalja a szereplők viszonyait, valamint összekapcsolja azok motivációját és cselekedeteit.',
		a: 9,
		gT: 1649,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Epikai és drámai művekben önállóan értelmezi a cselekményszálak, a szerkezet, az időszerkezet (lineáris, nem lineáris), a helyszínek és a jellemek összefüggéseit.',
		a: 9,
		gT: 1648,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlít egy adott irodalmi művet annak adaptációival (film, festmény, zenemű, animáció, stb.), összehasonlításkor figyelembe veszi az adott művészeti ágak jellemző tulajdonságait.',
		a: 9,
		gT: 1647,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összekapcsol irodalmi műveket különböző szempontok alapján (motívumok, történelmi, erkölcsi kérdésfelvetések, művek és parafrázisaik).',
		a: 9,
		gT: 1646,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összekapcsolja az irodalmi művek szövegének lehetséges értelmezéseit azok társadalmi-történelmi szerepével, jelentőségével.',
		a: 9,
		gT: 1645,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Az irodalmi mű értelmezése során figyelembe veszi a mű keletkezéstörténeti hátterét, a műhöz kapcsolható filozófiai, eszmetörténeti szempontokat is.',
		a: 9,
		gT: 1644,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összekapcsolja az irodalmi művek szerkezeti felépítését, nyelvi sajátosságait azok tartalmával és értékszerkezetével.',
		a: 9,
		gT: 1643,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezésében felhasználja irodalmi és művészeti, történelmi, művelődéstörténeti ismereteit.',
		a: 9,
		gT: 1642,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Megérti, elemzi az irodalmi mű jelentésszerkezetének szintjeit.',
		a: 9,
		gT: 1641,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és elkülöníti a műnemeket, illetve a műnemekhez tartozó műfajokat, megnevezi azok poétikai és retorikai jellemzőit.',
		a: 9,
		gT: 1640,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Elolvassa a kötelező olvasmányokat, és saját örömére is olvas.',
		a: 9,
		gT: 1639,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Etikusan és kritikusan használja a hagyományos, papír alapú, illetve a világhálón található és egyéb digitális adatbázisokat.',
		a: 9,
		gT: 1638,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tud helyesen írni, szükség esetén nyomtatott és digitális helyesírási segédleteket használ.',
		a: 9,
		gT: 1637,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar nyelv helyesírási, nyelvhelyességi szabályait.',
		a: 9,
		gT: 1636,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Érti, hogy nyelvünk a történelemben folyamatosan változik, ismeri a magyar nyelvtörténet nagy korszakait, kiemelkedő jelentőségű nyelvemlékeit.',
		a: 9,
		gT: 1635,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar nyelv eredetének hipotéziseit, és azok tudományosan megalapozott bizonyítékait.',
		a: 9,
		gT: 1634,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és érti a nyelvrokonság fogalmát, annak kritériumait.',
		a: 9,
		gT: 1633,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A retorikai ismereteit a gyakorlatban is alkalmazza.',
		a: 9,
		gT: 1632,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az általa tanult nyelvi, nyelvtani, helyesírási, nyelvhelyességi ismereteket.',
		a: 9,
		gT: 1631,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a nyelvhasználatban előforduló különféle nyelvváltozatokat (nyelvjárások, csoportnyelvek, rétegnyelvek), összehasonlítja azok főbb jellemzőit.',
		a: 9,
		gT: 1630,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Szövegelemzéskor felismeri az alakzatokat és a szóképeket, értelmezi azok hatását, szerepét, megnevezi típusaikat.',
		a: 9,
		gT: 1629,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a stílus fogalmát, a stíluselemeket, a stílushatást, a stíluskorszakokat, stílusrétegeket, ismereteit a szöveg befogadása és alkotása során alkalmazza.',
		a: 9,
		gT: 1628,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és alkalmazza a szövegösszetartó grammatikai és jelentésbeli elemeket, szövegépítése arányos és koherens.',
		a: 9,
		gT: 1627,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a szöveg fogalmát, jellemzőit, szerkezeti sajátosságait, valamint a különféle szövegtípusokat és megjelenésmódokat.',
		a: 9,
		gT: 1626,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és megnevezi a magyar és a tanult idegen nyelv közötti hasonlóságokat és eltéréseket.',
		a: 9,
		gT: 1625,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar nyelv hangtanát, alaktanát, szófajtanát, mondattanát, ismeri és alkalmazza a tanult elemzési eljárásokat.',
		a: 9,
		gT: 1624,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az anyanyelvét, annak szerkezeti felépítését, nyelvhasználata tudatos és helyes.',
		a: 9,
		gT: 1623,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Reflektál saját kommunikációjára, szükség esetén változtat azon.',
		a: 9,
		gT: 1622,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és elemzi a tömegkommunikáció befolyásoló eszközeit, azok céljait és hatásait.',
		a: 9,
		gT: 1621,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a kommunikáció zavarait, kezelésükre stratégiát dolgoz ki.',
		a: 9,
		gT: 1620,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Az anyanyelvről szerzett ismereteit alkalmazva képes a kommunikációjában a megfelelő nyelvváltozat kiválasztására, használatára.',
		a: 9,
		gT: 1619,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Találkozik az érdeklődésének megfelelő akár autentikus szövegekkel elektronikus, digitális csatornákon tanórán kívül is.',
		a: 9,
		gT: 2269,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Egyénileg vagy társaival együttműködve szóban vagy írásban projektmunkát vagy kiselőadást készít, és ezeket digitális eszközök segítségével is meg tudja valósítani.',
		a: 9,
		gT: 2268,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Következetesen alkalmazza a célnyelvi betű és jelkészletet',
		a: 9,
		gT: 2267,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'Idegen nyelvi kommunikációjában ismeri és használja a célnyelv főbb jellemzőit.',
		a: 9,
		gT: 2266,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó alapvető tanult nyelvi elemeket használja.',
		a: 9,
		gT: 2265,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'studio',
		gD: 'Megismerkedik hazánk legfőbb országismereti és történelmi eseményeivel célnyelven.',
		a: 9,
		gT: 2264,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Találkozik a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel.',
		a: 9,
		gT: 2263,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'studio',
		gD: 'Találkozik célnyelvi országismereti tartalmakkal.',
		a: 9,
		gT: 2262,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Célnyelvi kommunikációjába beépíti a tanult interkulturális ismereteket.',
		a: 9,
		gT: 2261,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'További országismereti tudásra tesz szert.',
		a: 9,
		gT: 2260,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri a célnyelvi országok főbb jellemzőit és kulturális sajátosságait.',
		a: 9,
		gT: 2259,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'studio',
		gD: 'Értelmez egyszerű, szórakoztató kisfilmeket',
		a: 9,
		gT: 2258,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Digitális eszközöket és felületeket is használ nyelvtudása fejlesztésére,',
		a: 9,
		gT: 2257,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja a célnyelvet szórakozásra és játékos nyelvtanulásra.',
		a: 9,
		gT: 2256,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'A tanórán kívüli, akár játékos nyelvtanulási lehetőségeket felismeri, és törekszik azokat kihasználni.',
		a: 9,
		gT: 2255,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'studio',
		gD: 'Társai haladásának értékelésében segítően részt vesz.',
		a: 9,
		gT: 2254,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvi haladását többnyire fel tudja mérni,',
		a: 9,
		gT: 2253,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'studio',
		gD: 'Céljai eléréséhez társaival párban és csoportban együttműködik.',
		a: 9,
		gT: 2252,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket.',
		a: 9,
		gT: 2251,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 2250,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'studio',
		gD: 'Ismer szavakat, szókapcsolatokat a célnyelven a témakörre jellemző, életkorának és érdeklődésének megfelelő más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 2249,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Hibáit többnyire észreveszi és javítja.',
		a: 9,
		gT: 2248,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Tudatosan használ alapszintű nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 2247,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'studio',
		gD: 'Ismerős és gyakori alapvető helyzetekben, akár telefonon vagy digitális csatornákon is, többnyire helyesen és érthetően fejezi ki magát az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 2246,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Megoszt alapvető személyes információkat és szükségleteket magáról egyszerű nyelvi elemekkel.',
		a: 9,
		gT: 2245,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Nem értés esetén a meg nem értett kulcsszavak vagy fordulatok ismétlését vagy magyarázatát kéri, visszakérdez, betűzést kér.',
		a: 9,
		gT: 2244,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmaz nyelvi funkciókat rövid társalgás megkezdéséhez, fenntartásához és befejezéséhez.',
		a: 9,
		gT: 2243,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Ismeretlen szavak valószínű jelentését szövegösszefüggések alapján kikövetkezteti az életkorának és érdeklődésének megfelelő, konkrét, rövid szövegekben.',
		a: 9,
		gT: 2242,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi eszközökkel és nonverbális elemek segítségével tisztázza mondanivalójának lényegét.',
		a: 9,
		gT: 2241,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Egyszerű mondatokat összekapcsolva mond el egymást követő eseményekből álló történetet, vagy leírást ad valamilyen témáról.',
		a: 9,
		gT: 2240,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Összekapcsolja az ismert nyelvi elemeket egyszerű kötőszavakkal (például: és, de, vagy).',
		a: 9,
		gT: 2239,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Találkozik életkorának és nyelvi szintjének megfelelő célnyelvi szórakoztató tartalmakkal.',
		a: 9,
		gT: 2238,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 2237,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja a célnyelvet ismeretszerzésre.',
		a: 9,
		gT: 2236,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Értelmez és használja az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is,',
		a: 9,
		gT: 2235,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Kifejez és érvekkel alátámasztva mutat be szükségességet, lehetőséget, képességet, bizonyosságot, bizonytalanságot.',
		a: 9,
		gT: 2234,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Kifejez alapvető érzéseket, például örömöt, sajnálkozást, bánatot, elégedettséget, elégedetlenséget, bosszúságot, csodálkozást, reményt.',
		a: 9,
		gT: 2233,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Kifejez kérést, javaslatot, meghívást, kínálást és ezekre reagálást.',
		a: 9,
		gT: 2232,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Információt cserél, információt kér, információt ad.',
		a: 9,
		gT: 2231,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Kifejez tetszést, nem tetszést, akaratot, kívánságot, tudást és nem tudást, ígéretet, szándékot, dicséretet, kritikát.',
		a: 9,
		gT: 2230,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Egyszerűen megfogalmazza személyes véleményét, másoktól véleményük kifejtését kéri, és arra reagál, elismeri vagy cáfolja mások állítását, kifejezi egyetértését vagy egyet nem értését.',
		a: 9,
		gT: 2229,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'studio',
		gD: 'Néhány szóból vagy mondatból álló jegyzetet készít írott szöveg alapján.',
		a: 9,
		gT: 2228,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Találkozik az életkorának és nyelvi szintjének megfelelő célnyelvi ismeretterjesztő tartalmakkal.',
		a: 9,
		gT: 2227,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja a célnyelvet tudásmegosztásra.',
		a: 9,
		gT: 2226,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Rövid, egyszerű, ismert nyelvi eszközökből álló kiselőadást tart változatos feladatok kapcsán, hagyományos vagy digitális alapú vizuális eszközök támogatásával.',
		a: 9,
		gT: 2225,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'studio',
		gD: 'Véleményét írásban, egyszerű nyelvi eszközökkel megfogalmazza, és arról írásban interakciót folytat.',
		a: 9,
		gT: 2224,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Üzeneteket ír,',
		a: 9,
		gT: 2223,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Bekapcsolódik a tanórán az interakciót igénylő nyelvi tevékenységekbe, abban társaival közösen részt vesz, a begyakorolt nyelvi elemeket tanári segítséggel a játék céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2222,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre is reagál egyszerű célnyelvi eszközökkel, személyes vagy online interakciókban.',
		a: 9,
		gT: 2221,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemeket többnyire megfelelően használja, beszédszándékainak megfelelően, egyszerű spontán helyzetekben.',
		a: 9,
		gT: 2220,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Véleményét, gondolatait, érzéseit egyre magabiztosabban fejezi ki a tanult nyelvi eszközökkel.',
		a: 9,
		gT: 2219,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Az életkorának megfelelő mindennapi helyzetekben a tanult nyelvi eszközökkel megfogalmazott kérdéseket tesz fel, és válaszol a hozzá intézett kérdésekre.',
		a: 9,
		gT: 2218,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Kommunikációt kezdeményez egyszerű hétköznapi témában, a beszélgetést követi, egyszerű, nyelvi eszközökkel fenntartja és lezárja.',
		a: 9,
		gT: 2217,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Megért és használ szavakat, szókapcsolatokat a célnyelvi, az életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel kapcsolatban',
		a: 9,
		gT: 2216,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Érdeklődése erősödik a célnyelvi irodalmi alkotások iránt.',
		a: 9,
		gT: 2215,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'A nyomtatott vagy digitális alapú írott szöveget felhasználja szórakozásra és ismeretszerzésre önállóan is.',
		a: 9,
		gT: 2214,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő írott, nyomtatott vagy digitális alapú szöveget a változatos nyelvórai tevékenységek és feladatmegoldás során.',
		a: 9,
		gT: 2213,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Összetettebb írott instrukciókat értelmez.',
		a: 9,
		gT: 2212,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megkülönbözteti a főbb, életkorának megfelelő írott szövegtípusokat.',
		a: 9,
		gT: 2211,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja más iskolai vagy iskolán kívül szerzett ismereteivel.',
		a: 9,
		gT: 2210,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó rövid írott szöveg tartalmát.',
		a: 9,
		gT: 2209,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi az életkorának megfelelő szituációkhoz kapcsolódó, írott szövegekben megjelenő összetettebb információkat.',
		a: 9,
		gT: 2208,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Hallgat az érdeklődésének megfelelő autentikus szövegeket elektronikus, digitális csatornákon, tanórán kívül is, szórakozásra vagy ismeretszerzésre.',
		a: 9,
		gT: 2207,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a főbb, életkorának megfelelő hangzószöveg-típusokat.',
		a: 9,
		gT: 2206,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmez életkorának megfelelő nyelvi helyzeteket hallott szöveg alapján.',
		a: 9,
		gT: 2205,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő hangzó szöveget a változatos nyelvórai tevékenységek és a feladatmegoldás során.',
		a: 9,
		gT: 2204,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő, élőszóban vagy digitális felületen elhangzó szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 2203,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó, élőszóban vagy digitális felületen elhangzó rövid szöveg tartalmát.',
		a: 9,
		gT: 2202,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi az életkorának megfelelő, élőszóban vagy digitális felületen elhangzó szövegekben a beszélők gondolatmenetét.',
		a: 9,
		gT: 2201,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi az életkorának és nyelvi szintjének megfelelő, egyszerű, hangzó szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2200,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a szintjének megfelelő, kevésbé ismert elemekből álló, nonverbális vagy vizuális eszközökkel támogatott célnyelvi óravezetést és utasításokat, kérdéseket.',
		a: 9,
		gT: 2199,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'A szövegek létrehozásához nyomtatott, illetve digitális alapú segédeszközt, szótárt használ.',
		a: 9,
		gT: 2198,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Rövid, összefüggő, papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformákban.',
		a: 9,
		gT: 2197,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Rövid szövegek írását igénylő kreatív munkát hoz létre önállóan.',
		a: 9,
		gT: 2196,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Rövid, egyszerű, összefüggő szövegeket ír a tanult nyelvi szerkezetek felhasználásával az ismert szövegtípusokban, az ajánlott tématartományokban.',
		a: 9,
		gT: 2195,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Megold játékos és változatos írásbeli feladatokat rövid szövegek szintjén.',
		a: 9,
		gT: 2194,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Változatos, kognitív kihívást jelentő szóbeli feladatokat old meg önállóan vagy kooperatív munkaformában, a tanult nyelvi eszközökkel, szükség szerint tanári segítséggel, élőszóban és digitális felületen.',
		a: 9,
		gT: 2193,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Képet jellemez röviden, egyszerűen, ismert nyelvi fordulatok segítségével, segítő tanári kérdések alapján, önállóan.',
		a: 9,
		gT: 2192,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Egyszerű nyelvi eszközökkel, felkészülést követően röviden, összefüggően beszél az ajánlott tématartományokhoz tartozó témákban, élőszóban és digitális felületen.',
		a: 9,
		gT: 2191,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Elmesél rövid történetet, egyszerűsített olvasmányt egyszerű nyelvi eszközökkel, önállóan, a cselekményt lineárisan összefűzve.',
		a: 9,
		gT: 2190,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Egyre magabiztosabban kapcsolódik be történetek kreatív alakításába, átfogalmazásába kooperatív munkaformában.',
		a: 9,
		gT: 2189,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Aktívan részt vesz az életkorának és érdeklődésének megfelelő gyermek-, illetve ifjúsági irodalmi alkotások közös előadásában.',
		a: 9,
		gT: 2188,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'studio',
		gD: 'Érti a nyelvtudás fontosságát, és motivációja a nyelvtanulásra tovább erősödik.',
		a: 9,
		gT: 2187,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 2186,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 2185,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Használ életkorának és nyelvi szintjének megfelelő hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 2184,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Nyelvtudását egyre inkább képes fejleszteni tanórán kívüli helyzetekben is különböző eszközökkel és lehetőségekkel.',
		a: 9,
		gT: 2183,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a tanult nyelvi funkciókat és a megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 2182,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat, valamint közvetít az élő idegen nyelven.',
		a: 9,
		gT: 2181,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Értelmez korának és nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket az ismert témákban és szövegtípusokban.',
		a: 9,
		gT: 2180,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban létrehoz rövid szövegeket, ismert nyelvi eszközökkel, a korának megfelelő szövegtípusokban.',
		a: 9,
		gT: 2179,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban megold változatos kihívásokat igénylő feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 2178,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Létrehoz nagyon egyszerű írott, pár szavas szöveget szóban vagy írásban digitális felületen.',
		a: 9,
		gT: 2177,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a tanult nyelvi elemeket életkorának megfelelő digitális tartalmakban, digitális csatornákon olvasott vagy hallott nagyon egyszerű szövegekben is.',
		a: 9,
		gT: 2176,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a főbb, célnyelvi kultúrához tartozó, ünnepekhez kapcsolódó alapszintű kifejezéseket, állandósult szókapcsolatokat és szokásokat.',
		a: 9,
		gT: 2175,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri a főbb, az adott célnyelvi kultúrákhoz tartozó országok nevét, földrajzi elhelyezkedését, főbb országismereti jellemzőit.',
		a: 9,
		gT: 2174,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'studio',
		gD: 'Alapvető célzott információt megszerez a tanult témákban tudásának bővítésére.',
		a: 9,
		gT: 2173,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Felhasznál és létrehoz rövid, nagyon egyszerű célnyelvi szövegeket szabadidős tevékenységek során.',
		a: 9,
		gT: 2172,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is.',
		a: 9,
		gT: 2171,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Egy feladat megoldásának sikerességét segítséggel értékelni tudja.',
		a: 9,
		gT: 2170,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'A célok eléréséhez társaival rövid feladatokban együttműködik.',
		a: 9,
		gT: 2169,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Szavak, kifejezések tanulásakor felismeri, ha új elemmel találkozik és rákérdez, vagy megfelelő tanulási stratégiával törekszik a megértésre.',
		a: 9,
		gT: 2168,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Új szavak, kifejezések tanulásakor ráismer a már korábban tanult szavakra, kifejezésekre.',
		a: 9,
		gT: 2167,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'studio',
		gD: 'Közöl alapvető személyes információkat magáról, egyszerű nyelvi elemek segítségével.',
		a: 9,
		gT: 2166,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és használja a legegyszerűbb, a nem értés, visszakérdezés és ismétlés, kérés kifejezésére használt mindennapi nyelvi funkciókat életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2165,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és használja a legegyszerűbb, a tudás és nem tudás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2164,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és használja a legegyszerűbb, a köszönet és az arra történő reagálás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2163,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és használja a legegyszerűbb, megszólításra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2162,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, bemutatkozásra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2161,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, üdvözlésre és elköszönésre használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2160,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'studio',
		gD: 'Elsajátítja a tanult szavak és állandósult szókapcsolatok célnyelvi normához közelítő kiejtését tanári minta követése által, vagy autentikus hangzó anyag, digitális technológia segítségével.',
		a: 9,
		gT: 2159,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Érzéseit egy-két szóval vagy begyakorolt állandósult nyelvi fordulatok segítségével kifejezi, főként rákérdezés alapján, nonverbális eszközökkel kísérve a célnyelvi megnyilatkozást.',
		a: 9,
		gT: 2158,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A tanórán bekapcsolódik a már ismert, szóbeli interakciót igénylő nyelvi tevékenységekbe, a begyakorolt nyelvi elemeket tanári segítséggel a tevékenység céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2157,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Rövid, néhány mondatból álló párbeszédet folytat, felkészülést követően.',
		a: 9,
		gT: 2156,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik arra, hogy a célnyelvet eszközként alkalmazza információszerzésre.',
		a: 9,
		gT: 2155,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'A tanórán begyakorolt, nagyon egyszerű, egyértelmű kommunikációs helyzetekben a megtanult, állandósult beszédfordulatok alkalmazásával kérdez vagy reagál, mondanivalóját segítséggel vagy nonverbális eszközökkel kifejezi.',
		a: 9,
		gT: 2154,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'studio',
		gD: 'Aktívan bekapcsolódik a közös meseolvasásba, a mese tartalmát követi.',
		a: 9,
		gT: 2153,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megtapasztalja a közös célnyelvi olvasás élményét.',
		a: 9,
		gT: 2152,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő írott szövegre az órai játékos alkotó, mozgásos vagy nyelvi fejlesztő tevékenységek során, kooperatív munkaformákban.',
		a: 9,
		gT: 2151,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Kiemeli az ismert nyelvi elemeket tartalmazó, egyszerű, írott, pár mondatos szöveg fő mondanivalóját.',
		a: 9,
		gT: 2150,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a nyelvi szintjének megfelelő, akár vizuális eszközökkel is támogatott írott utasításokat és kérdéseket, és ezekre megfelelő válaszreakciókat ad.',
		a: 9,
		gT: 2149,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Csendes olvasás keretében feldolgozva megért ismert szavakat tartalmazó, pár szóból vagy mondatból álló, akár illusztrációval támogatott szöveget.',
		a: 9,
		gT: 2148,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Beazonosítja a célzott információt az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű, a nyelvtanításhoz készült, illetve eredeti szövegben.',
		a: 9,
		gT: 2147,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Megkülönbözteti az anyanyelvi és a célnyelvi írott szövegben a betű- és jelkészlet közti különbségeket.',
		a: 9,
		gT: 2146,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'studio',
		gD: 'Figyel a célnyelvre jellemző hangok kiejtésére.',
		a: 9,
		gT: 2145,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri az anyanyelve és a célnyelv közötti legalapvetőbb kiejtésbeli különbségeket.',
		a: 9,
		gT: 2144,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi azokat az idegen nyelven szóban elhangzó nyelvórai szituációkat, melyeket anyanyelvén már ismer.',
		a: 9,
		gT: 2143,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri az anyanyelv és az idegen nyelv hangkészletét.',
		a: 9,
		gT: 2142,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő hangzó szövegre az órai alkotó jellegű nyelvi, mozgásos nyelvi és játékos nyelvi tevékenységek során.',
		a: 9,
		gT: 2141,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Azonosítja a célzott információt a nyelvi szintjének és életkorának megfelelő rövid hangzó szövegben.',
		a: 9,
		gT: 2140,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Kiszűri a lényeget az ismert nyelvi elemeket tartalmazó, nagyon rövid, egyszerű hangzó szövegből.',
		a: 9,
		gT: 2139,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Beazonosítja az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2138,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Megérti az élőszóban elhangzó, ismert témákhoz kapcsolódó, verbális, vizuális vagy nonverbális eszközökkel segített rövid kijelentéseket, kérdéseket.',
		a: 9,
		gT: 2137,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'studio',
		gD: 'Írásban megnevezi az ajánlott tématartományokban megjelölt, begyakorolt elemeket.',
		a: 9,
		gT: 2136,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Részt vesz kooperatív munkaformában végzett kreatív tevékenységekben, projektmunkában szavak, szószerkezetek, rövid mondatok leírásával, esetleg képi kiegészítéssel.',
		a: 9,
		gT: 2135,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Megold játékos írásbeli feladatokat a szavak, szószerkezetek, rövid mondatok szintjén.',
		a: 9,
		gT: 2134,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Lemásol tanult szavakat játékos, alkotó nyelvórai tevékenységek során.',
		a: 9,
		gT: 2133,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az adott nyelv ábécéjét.',
		a: 9,
		gT: 2132,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri az anyanyelvén, illetve a tanult idegen nyelven történő írásmód és betűkészlet közötti különbségeket.',
		a: 9,
		gT: 2131,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'studio',
		gD: 'Célnyelven megoszt egyedül vagy társaival együttműködésben megszerzett, alapvető információkat szóban, akár vizuális elemekkel támogatva.',
		a: 9,
		gT: 2130,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'studio',
		gD: 'Lebetűzi a tanult szavakat társaival közösen játékos tevékenységek kapcsán, szükség esetén segítséggel.',
		a: 9,
		gT: 2129,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'studio',
		gD: 'Lebetűzi a nevét.',
		a: 9,
		gT: 2128,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'studio',
		gD: 'Megismétli az élőszóban elhangzó egyszerű szavakat, kifejezéseket játékos, mozgást igénylő, kreatív nyelvórai tevékenységek során.',
		a: 9,
		gT: 2127,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'studio',
		gD: 'Célnyelvi tanulmányain keresztül nyitottabbá, a világ felé érdeklődőbbé válik.',
		a: 9,
		gT: 2126,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a tanult nyelvi elemek megfelelő kiejtésére.',
		a: 9,
		gT: 2125,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az adott célnyelvi kultúrákhoz tartozó országok fontosabb jellemzőit és a hozzájuk tartozó alapvető nyelvi elemeket.',
		a: 9,
		gT: 2124,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Elmondja magáról a legalapvetőbb információkat.',
		a: 9,
		gT: 2123,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri és használja a legegyszerűbb, mindennapi nyelvi funkciókat.',
		a: 9,
		gT: 2122,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Követi a szintjének megfelelő, vizuális vagy nonverbális eszközökkel támogatott, ismert célnyelvi óravezetést, utasításokat.',
		a: 9,
		gT: 2121,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Lemásol, leír szavakat és rövid, nagyon egyszerű szövegeket.',
		a: 9,
		gT: 2120,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szóban visszaad szavakat, esetleg rövid, nagyon egyszerű szövegeket hoz létre.',
		a: 9,
		gT: 2119,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Bekapcsolódik a szóbeliséget, írást, szövegértést vagy interakciót igénylő alapvető és korának megfelelő játékos, élményalapú élő idegen nyelvi tevékenységekbe.',
		a: 9,
		gT: 2118,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Megismerkedik az idegen nyelvvel, a nyelvtanulással és örömmel vesz részt az órákon.',
		a: 9,
		gT: 2117,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Szerkesztési feladatok euklideszi módon történő megoldásához dinamikus geometriai szoftvert használ.',
		a: 9,
		gT: 2116,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Kísérletezéshez, sejtés megfogalmazásához, egyenlet grafikus megoldásához és ellenőrzéshez dinamikus geometriai, grafikus és táblázatkezelő szoftvereket használ.',
		a: 9,
		gT: 2115,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Prezentációhoz informatív diákat készít, ezeket logikusan és következetesen egymás után fűzi és bemutatja.',
		a: 9,
		gT: 2114,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Ismereteit digitális forrásokból kiegészíti, számítógép segítségével elemzi és bemutatja.',
		a: 9,
		gT: 2113,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő informatikai alkalmazás segítségével szöveget szerkeszt, táblázatkezelő programmal diagramokat készít.',
		a: 9,
		gT: 2112,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Digitális környezetben matematikai alkalmazásokkal dolgozik.',
		a: 9,
		gT: 2111,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Számológép segítségével alapműveletekkel felírható számolási eredményt; négyzetgyököt; átlagot; szögfüggvények értékét, illetve abból szöget; logaritmust; faktoriálist; binomiális együtthatót; szórást meghatároz.',
		a: 9,
		gT: 2110,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Ismer a tananyaghoz kapcsolódó matematikatörténeti vonatkozásokat.',
		a: 9,
		gT: 2109,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Szöveg alapján táblázatot, grafikont készít, ábrát, kapcsolatokat szemléltető gráfot rajzol, és ezeket kombinálva prezentációt készít és mutat be.',
		a: 9,
		gT: 2108,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Matematika feladatok megoldását szakszerűen prezentálja írásban és szóban a szükséges alapfogalmak, azonosságok, definíciók és tételek segítségével.',
		a: 9,
		gT: 2107,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan kommunikál matematika tartalmú feladatokkal kapcsolatban.',
		a: 9,
		gT: 2106,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'A matematikai fogalmakat és jelöléseket megfelelően használja.',
		a: 9,
		gT: 2105,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'A megfelelő matematikai tankönyveket, feladatgyűjteményeket, internetes tartalmakat értőn olvassa, a matematikai tartalmat rendszerezetten kigyűjti és megérti.',
		a: 9,
		gT: 2104,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Meghatározza a valószínűséget visszatevéses, illetve visszatevés nélküli mintavétel esetén.',
		a: 9,
		gT: 2103,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és egyszerű esetekben alkalmazza a valószínűség geometriai modelljét.',
		a: 9,
		gT: 2102,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Konkrét valószínűségi kísérletek esetében az esemény, eseménytér, elemi esemény, relatív gyakoriság, valószínűség, egymást kizáró események, független események fogalmát megkülönbözteti és alkalmazza.',
		a: 9,
		gT: 2101,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Véletlen kísérletek adatait rendszerezi, relatív gyakoriságokat számol, nagy elemszám esetén számítógépet alkalmaz.',
		a: 9,
		gT: 2100,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a klasszikus valószínűségi modellt és a laplace-képletet.',
		a: 9,
		gT: 2099,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Tapasztalatai alapján véletlen jelenségek jövőbeni kimenetelére észszerűen tippel.',
		a: 9,
		gT: 2098,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Felismer grafikus manipulációkat diagramok esetén.',
		a: 9,
		gT: 2097,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a sodrófa (box-plot) diagramot adathalmazok jellemzésére, összehasonlítására.',
		a: 9,
		gT: 2096,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'studio',
		gD: 'Adatsokaságból adott szempont szerint oszlop- és kördiagramot készít hagyományos és digitális eszközzel.',
		a: 9,
		gT: 2095,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'studio',
		gD: 'Hagyományos és digitális forrásból származó adatsokaság alapvető statisztikai jellemzőit meghatározza, értelmezi és értékeli.',
		a: 9,
		gT: 2094,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'studio',
		gD: 'Adott cél érdekében tudatos adatgyűjtést és rendszerezést végez.',
		a: 9,
		gT: 2093,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'studio',
		gD: 'Mértani sorozatokra vonatkozó ismereteit használja gazdasági, pénzügyi, természettudományi és társadalomtudományi problémák megoldásában.',
		a: 9,
		gT: 2092,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'studio',
		gD: 'A számtani, mértani sorozatok első n tagjának összegét kiszámolja.',
		a: 9,
		gT: 2091,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'studio',
		gD: 'A számtani, mértani sorozat n-edik tagját felírja az első tag és a különbség (differencia)/hányados (kvóciens) ismeretében.',
		a: 9,
		gT: 2090,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'studio',
		gD: 'Számtani és mértani sorozatokat adott szabály alapján felír, folytat.',
		a: 9,
		gT: 2089,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'studio',
		gD: 'A grafikonról megállapítja függvények alapvető tulajdonságait.',
		a: 9,
		gT: 2088,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Adott értékkészletbeli elemhez megtalálja az értelmezési tartomány azon elemeit, amelyekhez a függvény az adott értéket rendeli.',
		a: 9,
		gT: 2087,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Képlettel adott függvényt hagyományosan és digitális eszközzel ábrázol.',
		a: 9,
		gT: 2086,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Táblázattal megadott függvény összetartozó értékeit ábrázolja koordináta-rendszerben.',
		a: 9,
		gT: 2085,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Adott képlet alapján helyettesítési értékeket számol, és azokat táblázatba rendezi.',
		a: 9,
		gT: 2084,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Megad hétköznapi életben előforduló hozzárendeléseket.',
		a: 9,
		gT: 2083,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'studio',
		gD: 'Megadja és alkalmazza a kör egyenletét a kör sugarának és a középpont koordinátáinak ismeretében.',
		a: 9,
		gT: 2082,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Kiszámítja egyenesek metszéspontjainak koordinátáit az egyenesek egyenletének ismeretében.',
		a: 9,
		gT: 2081,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Egyenesek egyenletéből következtet az egyenesek kölcsönös helyzetére.',
		a: 9,
		gT: 2080,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az egyenes egyenletét.',
		a: 9,
		gT: 2079,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Koordináták alapján számításokat végez szakaszokkal, vektorokkal.',
		a: 9,
		gT: 2078,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Koordináta-rendszerben ábrázol adott feltételeknek megfelelő ponthalmazokat.',
		a: 9,
		gT: 2077,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Megad pontot és vektort koordinátáival a derékszögű koordináta-rendszerben.',
		a: 9,
		gT: 2076,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a hasonló testek felszínének és térfogatának arányára vonatkozó tételeket.',
		a: 9,
		gT: 2075,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'studio',
		gD: 'Kiszámítja a speciális testek felszínét és térfogatát egyszerű esetekben.',
		a: 9,
		gT: 2074,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'studio',
		gD: 'Lerajzolja a kocka, téglatest, egyenes hasáb, egyenes körhenger, egyenes gúla, forgáskúp hálóját.',
		a: 9,
		gT: 2073,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a hasáb, a henger, a gúla, a kúp, a gömb, a csonkagúla, a csonkakúp (speciális testek) tulajdonságait.',
		a: 9,
		gT: 2072,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a szinusz- és a koszinusztételt.',
		a: 9,
		gT: 2071,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'A szögfüggvény értékének ismeretében meghatározza a szöget.',
		a: 9,
		gT: 2070,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a szögfüggvényeket egyszerű geometriai számítási feladatokban.',
		a: 9,
		gT: 2069,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a hegyes- és tompaszögek szögfüggvényeinek összefüggéseit.',
		a: 9,
		gT: 2068,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri tompaszögek szögfüggvényeinek származtatását a hegyesszögek szögfüggvényei alapján.',
		a: 9,
		gT: 2067,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri hegyesszögek szögfüggvényeinek definícióját a derékszögű háromszögben.',
		a: 9,
		gT: 2066,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a vektorokat feladatok megoldásában.',
		a: 9,
		gT: 2065,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismer és alkalmaz egyszerű vektorműveleteket.',
		a: 9,
		gT: 2064,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a vektorokkal kapcsolatos alapvető fogalmakat.',
		a: 9,
		gT: 2063,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Megszerkeszti egy alakzat tengelyes, illetve középpontos tükörképét, pont körüli elforgatottját, párhuzamos eltoltját hagyományosan és digitális eszközzel.',
		a: 9,
		gT: 2062,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a hasonló síkidomok kerületének és területének arányára vonatkozó tételeket.',
		a: 9,
		gT: 2061,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a középpontos hasonlósági transzformációt, a hasonlósági transzformációt és az alakzatok hasonlóságát.',
		a: 9,
		gT: 2060,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a síkbeli egybevágósági transzformációkat és tulajdonságaikat; alakzatok egybevágóságát.',
		a: 9,
		gT: 2059,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismer példákat geometriai transzformációkra.',
		a: 9,
		gT: 2058,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a thalész-tételt és megfordítását.',
		a: 9,
		gT: 2057,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a kör érintőjének fogalmát, kapcsolatát az érintési pontba húzott sugárral.',
		a: 9,
		gT: 2056,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'studio',
		gD: 'Ki tudja számolni a kör és részeinek kerületét, területét.',
		a: 9,
		gT: 2055,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'studio',
		gD: 'Átdarabolással kiszámítja sokszögek területét.',
		a: 9,
		gT: 2054,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a szabályos sokszög fogalmát; kiszámítja a konvex sokszög belső és külső szögeinek összegét.',
		a: 9,
		gT: 2053,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza speciális négyszögek tulajdonságait, területüket kiszámítja.',
		a: 9,
		gT: 2052,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Kiszámítja háromszögek területét.',
		a: 9,
		gT: 2051,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a pitagorasz-tételt és megfordítását.',
		a: 9,
		gT: 2050,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a háromszög nevezetes vonalaira, pontjaira és köreire vonatkozó fogalmakat és tételeket.',
		a: 9,
		gT: 2049,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a háromszögek oldalai, szögei, oldalai és szögei közötti kapcsolatokat; a speciális háromszögek tulajdonságait.',
		a: 9,
		gT: 2048,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az alapszerkesztéseket, és ezeket végre tudja hajtani hagyományos vagy digitális eszközzel.',
		a: 9,
		gT: 2047,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a nevezetes szögpárok tulajdonságait.',
		a: 9,
		gT: 2046,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és feladatmegoldásban alkalmazza a térelemek kölcsönös helyzetét, távolságát és hajlásszögét.',
		a: 9,
		gT: 2045,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és használja a pont, egyenes, sík (térelemek) és szög fogalmát.',
		a: 9,
		gT: 2044,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a százalékalap, -érték, -láb, -pont fogalmát.',
		a: 9,
		gT: 2043,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az egyenes és a fordított arányosságot.',
		a: 9,
		gT: 2042,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'studio',
		gD: 'Átalakít algebrai kifejezéseket összevonás, szorzattá alakítás, nevezetes azonosságok alkalmazásával.',
		a: 9,
		gT: 2041,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismer és alkalmaz egyszerű algebrai azonosságokat.',
		a: 9,
		gT: 2040,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Műveleteket végez algebrai kifejezésekkel.',
		a: 9,
		gT: 2039,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a logaritmus fogalmát.',
		a: 9,
		gT: 2038,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a racionális kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2037,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az egész kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2036,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a normálalak fogalmát.',
		a: 9,
		gT: 2035,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az n-edik gyök fogalmát.',
		a: 9,
		gT: 2034,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a négyzetgyök fogalmát és azonosságait.',
		a: 9,
		gT: 2033,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'studio',
		gD: 'Valós számok közelítő alakjaival számol, és megfelelően kerekít.',
		a: 9,
		gT: 2032,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'A számolással kapott eredményeket nagyságrendileg megbecsüli, és így ellenőrzi az eredményt.',
		a: 9,
		gT: 2031,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az abszolút érték, az ellentett és a reciprok fogalmát.',
		a: 9,
		gT: 2030,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a valós számok és a számegyenes kapcsolatát.',
		a: 9,
		gT: 2029,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Ismer példákat irracionális számokra.',
		a: 9,
		gT: 2028,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Racionális számokat tizedes tört és közönséges tört alakban is felír.',
		a: 9,
		gT: 2027,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'A kommutativitás, asszociativitás, disztributivitás műveleti azonosságokat helyesen alkalmazza különböző számolási helyzetekben.',
		a: 9,
		gT: 2026,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a számhalmazok épülésének matematikai vonatkozásait a természetes számoktól a valós számokig.',
		a: 9,
		gT: 2025,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'studio',
		gD: 'Érti a helyi értékes írásmódot 10-es és más alapú számrendszerekben.',
		a: 9,
		gT: 2024,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az oszthatósági szabályokat.',
		a: 9,
		gT: 2023,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Meghatározza két természetes szám legnagyobb közös osztóját és legkisebb közös többszörösét, és alkalmazza ezeket egyszerű gyakorlati feladatokban.',
		a: 9,
		gT: 2022,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összetett számokat felbont prímszámok szorzatára.',
		a: 9,
		gT: 2021,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az oszthatóság alapvető fogalmait.',
		a: 9,
		gT: 2020,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Sík- és térgeometriai feladatoknál a problémának megfelelő mértékegységben adja meg válaszát.',
		a: 9,
		gT: 2019,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a hosszúság, terület, térfogat, űrtartalom, idő mértékegységeit és az átváltási szabályokat. származtatott mértékegységeket átvált.',
		a: 9,
		gT: 2018,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a mérés alapelvét, alkalmazza konkrét alap- és származtatott mennyiségek esetén.',
		a: 9,
		gT: 2017,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'studio',
		gD: 'Egyenletek megoldását behelyettesítéssel, értékkészlet-vizsgálattal ellenőrzi.',
		a: 9,
		gT: 2016,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'studio',
		gD: 'Megold egyszerű, a megfelelő definíció alkalmazását igénylő exponenciális egyenleteket, egyenlőtlenségeket.',
		a: 9,
		gT: 2015,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'studio',
		gD: 'Megold másodfokú egyismeretlenes egyenleteket és egyenlőtlenségeket; ismeri és alkalmazza a diszkriminánst, a megoldóképletet és a gyöktényezős alakot.',
		a: 9,
		gT: 2014,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'studio',
		gD: 'Megold elsőfokú egyismeretlenes egyenleteket és egyenlőtlenségeket, elsőfokú kétismeretlenes egyenletrendszereket.',
		a: 9,
		gT: 2013,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza a következő egyenletmegoldási módszereket: mérlegelv, grafikus megoldás, szorzattá alakítás.',
		a: 9,
		gT: 2012,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'studio',
		gD: 'Geometriai szerkesztési feladatoknál vizsgálja és megállapítja a szerkeszthetőség feltételeit.',
		a: 9,
		gT: 2011,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'studio',
		gD: 'A modellben kapott megoldását az eredeti problémába visszahelyettesítve értelmezi, ellenőrzi és az észszerűségi szempontokat figyelembe véve adja meg válaszát.',
		a: 9,
		gT: 2010,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'studio',
		gD: 'A kiválasztott modellben megoldja a problémát.',
		a: 9,
		gT: 2009,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'studio',
		gD: 'A problémának megfelelő matematikai modellt választ, alkot.',
		a: 9,
		gT: 2008,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'studio',
		gD: 'Adott problémához megoldási stratégiát, algoritmust választ, készít.',
		a: 9,
		gT: 2007,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'studio',
		gD: 'Konkrét szituációkat szemléltet és egyszerű feladatokat megold gráfok segítségével.',
		a: 9,
		gT: 2006,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'studio',
		gD: 'Megold sorba rendezési és kiválasztási feladatokat.',
		a: 9,
		gT: 2005,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'studio',
		gD: 'Tud egyszerű állításokat indokolni és tételeket bizonyítani.',
		a: 9,
		gT: 2004,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Helyesen használja a „minden\" és „van olyan\" kifejezéseket.',
		a: 9,
		gT: 2003,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Megállapítja egyszerű „ha ... , akkor ...\" és „akkor és csak akkor\" típusú állítások logikai értékét.',
		a: 9,
		gT: 2002,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Megfogalmazza adott állítás megfordítását.',
		a: 9,
		gT: 2001,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és alkalmazza az „és\", a (megengedő és kizáró) „vagy\" logikai jelentését.',
		a: 9,
		gT: 2000,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a tagadás műveletét egyszerű feladatokban.',
		a: 9,
		gT: 1999,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Adott állításról eldönti, hogy igaz vagy hamis.',
		a: 9,
		gT: 1998,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a logikai szita elvét.',
		a: 9,
		gT: 1997,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Véges halmazok elemszámát meghatározza.',
		a: 9,
		gT: 1996,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Halmazokkal műveleteket végez, azokat ábrázolja és értelmezi.',
		a: 9,
		gT: 1995,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Halmazokat különböző módokon megad.',
		a: 9,
		gT: 1994,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Látja a halmazműveletek és a logikai műveletek közötti kapcsolatokat.',
		a: 9,
		gT: 1993,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatot.',
		a: 9,
		gT: 1992,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'studio',
		gD: 'Matematikai vagy hétköznapi nyelven megfogalmazott szövegből a matematikai tartalmú információkat kigyűjti, rendszerezi.',
		a: 9,
		gT: 1991,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'studio',
		gD: 'Adott halmazt diszjunkt részhalmazaira bont, osztályoz.',
		a: 9,
		gT: 1990,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'studio',
		gD: 'Matematikai ismereteit alkalmazza a pénzügyi tudatosság területét érintő feladatok megoldásában.',
		a: 9,
		gT: 1989,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'A matematikát más tantárgyakhoz kapcsolódó témákban is használja.',
		a: 9,
		gT: 1988,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'A matematika tanulása során digitális eszközöket és különböző információforrásokat használ.',
		a: 9,
		gT: 1987,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatokat.',
		a: 9,
		gT: 1986,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a hallott és olvasott matematikai tartalmú szövegeket.',
		a: 9,
		gT: 1985,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'A matematikai szakkifejezéseket és jelöléseket helyesen használja írásban és szóban egyaránt.',
		a: 9,
		gT: 1984,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Adatokat gyűjt, rendez, ábrázol, értelmez.',
		a: 9,
		gT: 1983,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Sejtéseket fogalmaz meg és logikus lépésekkel igazolja azokat.',
		a: 9,
		gT: 1982,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Megérti a környezetében jelen lévő logikai, mennyiségi, függvényszerű, térbeli és statisztikai kapcsolatokat.',
		a: 9,
		gT: 1981,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Ismeretei segítségével, a megfelelő modell alkalmazásával megold hétköznapi és matematikai problémákat, a megoldást ellenőrzi és értelmezi.',
		a: 9,
		gT: 1980,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a sikeres vállalkozás jellemzőit, képes azonosítani az esetleges kudarc okait, javaslatot tud tenni a problémák megoldására.',
		a: 10,
		gT: 2303,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a kezdeményezőkészség jelentőségét az állampolgári felelősségvállalásban.',
		a: 10,
		gT: 2302,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri a nem üzleti (társadalmi, kulturális, egyéb civil) kezdeményezések pénzügyi-gazdasági igényeit, lehetőségeit.',
		a: 10,
		gT: 2301,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tájékozott az üzleti terv tartalmi elemeiről.',
		a: 10,
		gT: 2300,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az üzleti tervezés szükségességével, mind egy új vállalkozás alapításakor, mind már meglévő vállalkozás működése esetén.',
		a: 10,
		gT: 2299,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Meg tudja becsülni egy vállalkozás lehetséges költségeit, képes adott időtartamra költségkalkulációt tervezni.',
		a: 10,
		gT: 2298,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a vállalkozásalapítás, -működtetés legfontosabb lépéseit, képes önálló vállalkozói ötlet kidolgozására.',
		a: 10,
		gT: 2297,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a nem nyereségérdekelt szervezetek gazdaságban betöltött szerepével.',
		a: 10,
		gT: 2296,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Érti a leggyakoribb vállalkozási formák jellemzőit, előnyeit, hátrányait.',
		a: 10,
		gT: 2295,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismer vállalkozókat, vállalatokat, össze tudja hasonlítani az alkalmazotti, és a vállalkozói személyiségjegyeket.',
		a: 10,
		gT: 2294,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az álláskeresés folyamatával, a munkaviszonnyal kapcsolatos jogaival, kötelezettségeivel.',
		a: 10,
		gT: 2293,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Önismereti tesztek, játékok segítségével képes átgondolni milyen foglalkozások, tevékenységek illeszkednek személyiségéhez.',
		a: 10,
		gT: 2292,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tud érvelni a családi költségvetés mellett, a tudatos, hatékony pénzgazdálkodás érdekében.',
		a: 10,
		gT: 2291,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A bankok kínálatából bankot, bankszámla csomagot tud választani.',
		a: 10,
		gT: 2290,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az egyes banki ügyletek előnyeivel, hátrányaival, kockázataival.',
		a: 10,
		gT: 2289,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Képes választani az egyes banki lehetőségek közül.',
		a: 10,
		gT: 2288,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a mai bankrendszer felépítését, az egyes pénzpiaci szereplők főbb feladatait.',
		a: 10,
		gT: 2287,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van azzal, hogy az adófizetés biztosítja részben az állami feladatok ellátásnak pénzügyi fedezetét.',
		a: 10,
		gT: 2286,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tudja értelmezni az állam gazdasági szerepvállalásának jelentőségét, ismeri főbb feladatait, azok hatásait.',
		a: 10,
		gT: 2285,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'A tanuló érti a nemzetgazdaság szereplőinek (háztartások, vállalatok, állam, pénzintézetek) feladatait, a köztük lévő kapcsolatrendszer sajátosságait.',
		a: 10,
		gT: 2284,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Betartja és betartatja a munkájához kapcsolódó biztonsági előírásokat (munka-, tűz-, baleset-, környezet és egészségvédelmi szabályok).',
		a: 11,
		gT: 3733,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Betartja és betartatja a munkájához kapcsolódó szerzői, felhasználási és személyiségi jogi előírásokat, valamint az adatvédelmi, média- és licencjogi szabályozásokat.',
		a: 11,
		gT: 3732,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Döntéseit a szakterület etikai, a szakma alapvető jogi, szerzői jogi szabályainak figyelembevételével hozza meg, és felelősséget vállal azokért.',
		a: 11,
		gT: 3731,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan képes munkaanyagait ismert szabályok alapján rendszerezni és archiválni.',
		a: 11,
		gT: 3730,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Instrukciók alapján és önállóan is képes a munkájához szükséges eszközök szakszerű üzemeltetésére, felhasználói szintű karbantartására.',
		a: 11,
		gT: 3729,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan és másokkal együttműködve is képes szoftveres környezetben mozgóképi tartalom előállító feladatok elvégzésére.',
		a: 11,
		gT: 3728,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Saját vizuális elképzeléseit, látásmódját képviseli, önálló javaslatokat fogalmaz meg.',
		a: 11,
		gT: 3727,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Kisebb léptékű produkciók komplex mozgóképkészítési feladatait képes önállóan megoldani, vagy a folyamatot irányítani.',
		a: 11,
		gT: 3726,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Nagyobb léptékű produkciók esetén feladatát képes instrukciók alapján, az elvárásokhoz igazodva elvégezni. Önellenőrzést végez, hibáit önállóan felismeri és korrigálja.',
		a: 11,
		gT: 3725,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'A kivitelezés céljának, formájának és kereteinek meghatározása során önállóan képes felelős döntést hozni.',
		a: 11,
		gT: 3724,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan és csoportmunkában is hatékonyan végzi feladatait, alkalmazkodik az elvárásokhoz, felelősséget vállal a saját és a közös munka szakmai minőségéért.',
		a: 11,
		gT: 3723,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Magára és munkakörnyezetére nézve kötelező érvényűnek tartja a biztonsági előírásokat (munka-, tűz-, baleset-, környezet és egészségvédelmi szabályok).',
		a: 11,
		gT: 3722,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Kötelező érvényűnek tartja a munkájához kapcsolódó szerzői, felhasználási és személyiségi jogi előírásokat, valamint az adatvédelmi, média- és licencjogi szabályozásokat.',
		a: 11,
		gT: 3721,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Írott és szóbeli szakmai kommunikációjában igényesen használja a magyar nyelvet, angol nyelvű szakmai szókincsét tudatosan fejleszti.',
		a: 11,
		gT: 3720,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Értékként tekint a filmtörténeti ismeretekre, érdeklődik a kortárs alkotók munkái iránt, figyelemmel kíséri a szakmai trendek alakulását.',
		a: 11,
		gT: 3719,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Munkáját körültekintően, felelősségteljesen végzi, ügyel a biztonságos adattárolásra.',
		a: 11,
		gT: 3718,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'A munkájához szükséges eszközöket, körültekintően, rendeltetésszerűen használja.',
		a: 11,
		gT: 3717,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Kitartóan, a részletekre is nagy figyelmet fordítva, precíz, minőségorientált munkát végez.',
		a: 11,
		gT: 3716,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Figyelemmel kíséri a vizuális és technikai környezet változásait, azokkal igyekszik lépést tartani.',
		a: 11,
		gT: 3715,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott szakmája elméleti alapjainak, eszközeinek, módszereinek és új eredményeinek megismerésére, az új szakmai tapasztalatokra.',
		a: 11,
		gT: 3714,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a színvonalas munkavégzésre.',
		a: 11,
		gT: 3713,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a határidők és a költségkeretek betartására.',
		a: 11,
		gT: 3712,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Együttműködésre törekszik a mozgóképi tartalomelőállítás különféle részterületein tevékenykedő más szakmák és művészeti ágak képviselőivel.',
		a: 11,
		gT: 3711,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a munkájához kapcsolódó szerzői, felhasználási és személyiségi jogi előírásokat, valamint az adatvédelmi, média- és licencjogi szabályozásokat.',
		a: 11,
		gT: 3710,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a szakma magyar és angol nyelvű terminológiáját.',
		a: 11,
		gT: 3709,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Az animációtörténetet, a filmtörténetet és a szakma technikatörténetét átfogóan ismeri.',
		a: 11,
		gT: 3708,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten ismeri a biztonságos archiválási stratégiákat, a prezentációs megoldásokat, és a publikálási lehetőségeket.',
		a: 11,
		gT: 3707,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten ismeri a felvételtechnikai, számítógépes és mozgókép-megjelenítő eszközöket, azok működését és karbantartásuk módját.',
		a: 11,
		gT: 3706,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten ismer felvételvezérlésre, rajzanimációra, videófeldolgozásra, utómunkára, filmtrükkök létrehozására, és mozgóképi tartalom megjelenítésére alkalmas szoftvereket.',
		a: 11,
		gT: 3705,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten ismeri a videótechnikai megoldásokat, a leképezett, rögzített látvány lehetőségeit, tulajdonságait, átfogó művészetelméleti és ábrázolási ismeretekkel rendelkezik.',
		a: 11,
		gT: 3704,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Behatóan ismeri az animációs technikai megoldásokat, a létrehozott (pl. rajzolt, modellezett, generált) látvány lehetőségeit, tulajdonságait, átfogó művészetelméleti és ábrázolási ismeretekkel rendelkezik.',
		a: 11,
		gT: 3703,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggésében ismeri a mozgókép- és animációkészítés tervezési, előkészítő, szervezési és kivitelezési feladatait.',
		a: 11,
		gT: 3702,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Rendszer-szerűen átlátja a projekt részfeladatait és a létrehozásukhoz szükséges tevékenységeket, erőforrásigényeket.',
		a: 11,
		gT: 3701,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Részletesen ismeri a mozgóképi vizuális kommunikáció alapelemeit.',
		a: 11,
		gT: 3700,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Munkája során alkalmazza a munkájához kapcsolódó biztonsági előírásokat (munka-, tűz-, baleset-, környezet és egészségvédelmi szabályok).',
		a: 11,
		gT: 3699,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazza a munkájához kapcsolódó szerzői, felhasználási és személyiségi jogi előírásokat, valamint az adatvédelmi, média- és licencjogi szabályozásokat.',
		a: 11,
		gT: 3698,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'A szakmai terminológiának megfelelően kommunikál magyarul, használja az angol szakmai kifejezéseket.',
		a: 11,
		gT: 3697,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Animáció- és filmtörténeti alkotásokról, korokról, stílusokról, a szakma technikatörténetének fejlődéséről, valamint saját munkájáról szóban és írásban is érthetően, színvonalasan kommunikál.',
		a: 11,
		gT: 3696,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai tevékenységét dokumentálja, anyagait rendszerezi, biztonsági másolatokat készít, elkészült munkáit prezentálja, publikálja és archiválja.',
		a: 11,
		gT: 3695,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Felvételtechnikai, számítógépes és mozgókép-megjelenítő eszközöket használ, azokat felhasználói szinten karbantartja.',
		a: 11,
		gT: 3694,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten használ felvételvezérlésre, rajzanimációra, videófeldolgozásra, utómunkára, filmtrükkök létrehozására alkalmas, valamint valósidejű effektek megjelenítésére alkalmas videóbejátszó szoftvereket.',
		a: 11,
		gT: 3693,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Művészetelméleti és ábrázolási ismereteit felhasználva látványtervezést végez.',
		a: 11,
		gT: 3692,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképi tartalmat hoz létre animációs technikákkal, általános és speciális videótechnikákkal.',
		a: 11,
		gT: 3691,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Mozgókép- és animációtervezési, előkészítő, szervezési és kivitelezési feladatokat végez.',
		a: 11,
		gT: 3690,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképi tartalomelőállítási munkafolyamatot tervez, ütemtervet és költségkalkulációt készít.',
		a: 11,
		gT: 3689,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Munkája során ismereteit felhasználva alkalmazza a mozgóképi vizuális kommunikáció alapelemeit.',
		a: 11,
		gT: 3688,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan képviseli szakmája saját független, kulturális nézeteit.',
		a: 11,
		gT: 3687,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Betartja a munka- és szerzői jogokat, felelősséget vállal a produktumok jogi- és etikai szabályait érintő tartalmáért.',
		a: 11,
		gT: 3686,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan végzi a dokumentálás folyamatát.',
		a: 11,
		gT: 3685,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önálló és megalapozott szakmai véleményt alkot.',
		a: 11,
		gT: 3684,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Magára és munkakörnyezetére nézve kötelező érvényűnek tartja a tűzvédelmi, környezetvédelmi és hulladékkezelési szabályokat.',
		a: 11,
		gT: 3683,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'A tervezés kontextusában önálló döntést hoz a vizuálisan alkalmazott képi-szöveges kompozíció tulajdonságáról, és annak stílusáról.',
		a: 11,
		gT: 3682,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan értelmezi a feladatot, és meghatározza a munkamenetet, teendőit.',
		a: 11,
		gT: 3681,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Munkatársaival szorosan együttműködve, a vezetői utasításokat betartva, önállóan vagy csapatban dolgozik.',
		a: 11,
		gT: 3680,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan vállalja a felelősséget feladatainak szakmai minőségéért.',
		a: 11,
		gT: 3679,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Digitális fotók, grafikák színkezelését, színrendszerét, a végfelhasználás technikai követelményeinek megfelelően önállóan beállítja.',
		a: 11,
		gT: 3678,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Felelős döntést hoz a kivitelezés céljának és technológiájának megfelelő alapanyag kiválasztásáról.',
		a: 11,
		gT: 3677,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'A projekt végfelhasználási célját és a megrendelő igényeit szem előtt tartva, korrigálja és megoldja a problémás tervezői részeket.',
		a: 11,
		gT: 3676,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan keres és kezdeményez új megoldásokat.',
		a: 11,
		gT: 3675,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önellenőrzést végez munkája minősége és hatékonysága érdekében.',
		a: 11,
		gT: 3674,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'A megrendelő igényeit bizalommal kezeli, azokért felelősséget vállal munkája eredményessége érdekében.',
		a: 11,
		gT: 3673,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Motivált a szakmai kiállításon, pályázaton, projektben való részvételre. Nyitott a nemzetközi, kulturális szakmai kiállításokra.',
		a: 11,
		gT: 3672,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Szem előtt tartja a munka- és szerzői jogokat.',
		a: 11,
		gT: 3671,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Adminisztrációs feladatai és részfeladatai megoldásában körültekintő.',
		a: 11,
		gT: 3670,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Új megoldásokat kezdeményez a prezentációkészítés területén. Szakmai előadói készségét folyamatosan fejleszti, önreflexiót végez.',
		a: 11,
		gT: 3669,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Tekintettel van a stúdió- és műhelymunka berendezésének biztonságos használatára.',
		a: 11,
		gT: 3668,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott a kortárs, vizuális trendekre, az új technikai megoldásokra, technológiai innovációra.',
		a: 11,
		gT: 3667,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'A más szakember által kialakított vizuális rendszert tiszteletben tartja, és alkalmazkodik hozzá. ',
		a: 11,
		gT: 3666,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Kreatívan és motiváltan viszonyul a projekt színvonalas megvalósításához.',
		a: 11,
		gT: 3665,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik az esztétikai és a funkcionális célok összeegyeztetésére. \u00A0',
		a: 11,
		gT: 3664,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Maximálisan törekszik a rábízott feladatokat pontosan és következetesen, a munkaformának megfelelően, optimális munkatempóban elvégezni. Fejleszti redukciós és absztrakciós készségeit a minél jobb minőségű tervezőmunka megvalósítása céljából.',
		a: 11,
		gT: 3663,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Motivált a különféle illusztrációs, ábrázolási módszerek és technikák innovatív megvalósítására. ',
		a: 11,
		gT: 3662,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'A képek digitalizálását, szerkesztését precízen, gondosan végzi.',
		a: 11,
		gT: 3661,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Elkötelezett a minőségi, szakmai munkára.',
		a: 11,
		gT: 3660,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Tervezési feladatait egyéni, kreatív módon közelíti meg, problémamegoldó képességét folyamatosan fejleszti. ',
		a: 11,
		gT: 3659,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Hajlandó az alapos és koncentrált gyűjtőmunkára, a kielégítő teljesítésre.',
		a: 11,
		gT: 3658,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik betartani az előírt, optimális ütemtervet.',
		a: 11,
		gT: 3657,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Írott és szóbeli kommunikációjában elkötelezett a magyar nyelv szakmai használatára. Angol nyelven, szakmai szókincsét tudatosan fejleszti.',
		a: 11,
		gT: 3656,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Kihívásként tekint a különböző megrendelői és munkaadói igényeket kielégítő feladatok teljesítésére.',
		a: 11,
		gT: 3655,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Szaktudása alapján meg tudja tervezni a vállalt feladat projektmenedzsment lépéseit.',
		a: 11,
		gT: 3654,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Alapismerettel rendelkezik a vállalkozásokra vonatkozó jogszabályokkal kapcsolatban.',
		a: 11,
		gT: 3653,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő ismeretekkel rendelkezik a grafikus munkák papíralapú és digitális dokumentálási szabályairól.',
		a: 11,
		gT: 3652,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Magas szinten használja a prezentációkészítés módszereit, a szakmai, szóbeli önkifejezés technikáit.',
		a: 11,
		gT: 3651,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a munkájához kapcsolódó biztonsági előírásokat (munka-, tűz-, baleset-, környezet és egészségvédelmi szabályok).',
		a: 11,
		gT: 3650,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az online megjelenés jellegzetes formai és technikai adottságait, vizuális hatásmechanizmusát, lehetőségeit.',
		a: 11,
		gT: 3649,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Terveit adott arculathoz, stílushoz, arányrendhez, vizuális üzenethez tudja illeszteni. ',
		a: 11,
		gT: 3648,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezni tud adott képi és szöveges információt, ki tudja szűrni a főbb tartalmat. Be tudja mutatni mindezt vizuálisan, ügyelve az összefüggésekre. Szöveges tartalomhoz megfelelő képet, képi megjelenést, stílust tud rendelni. ',
		a: 11,
		gT: 3647,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a kiadványok tipográfiai jellemzőit. Kreatív ötleteit hozzá tudja rendelni az adott feladat stílusához, funkcióihoz.',
		a: 11,
		gT: 3646,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten ismeri a redukciós, absztrakciós képalkotás módszereit. Ismeri a vizuális rendszer kialakításának, a kép, szöveg integrációjának lehetséges megoldásait.',
		a: 11,
		gT: 3645,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Tud képben, kompozícióban gondolkodni, behatóan ismeri a vizuális eszközök funkcionális alkalmazását. Átfogóan ismeri a különféle vektoros- és pixelgrafikus ábrázolási módszereket és technikákat.',
		a: 11,
		gT: 3644,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a nyomdai és online felhasználás technikai adottságait, és az ezekhez tartozó szoftveres beállításokat. ',
		a: 11,
		gT: 3643,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Magas szintű ismerettel rendelkezik a nyomdai alapanyagokról és azok használatáról.',
		a: 11,
		gT: 3642,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a grafikai technikák lehetőségeit és a kísérletezés jelentőségét. Tudja, hogy a vázlatok, tervek, makettek elkészítése segíti a koncepció kialakulását.',
		a: 11,
		gT: 3641,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Behatóan ismeri az információ keresés módszereit, az információ feldolgozás technikáit.',
		a: 11,
		gT: 3640,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Rendszerszerűen látja át egy adott projekt részfeladatait és a velük járó tevékenységet.',
		a: 11,
		gT: 3639,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri szakmája szakterminológiáját anyanyelven és angolul.',
		a: 11,
		gT: 3638,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van az üzleti kommunikáció írásbeli és szóbeli módszereivel, ismeri a tárgyalás, vita és érvelés szóbeli technikáit.',
		a: 11,
		gT: 3637,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Részt vesz hazai szakmai projektben, pályázatban, kiállításon.',
		a: 11,
		gT: 3636,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Grafikus vállalkozás indítását, működtetését tervezi, kooperatív feladatot tervez más stúdióval.',
		a: 11,
		gT: 3635,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Munkát, munkafolyamatot, dokumentál, archivál, fotódokumentációt készít.',
		a: 11,
		gT: 3634,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai prezentációt készít, szakmai témákban bemutatót tart.',
		a: 11,
		gT: 3633,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Napi tevékenységét a stúdió- és a műhelymunka során, a munka-, tűz-, baleset-, környezet és egészségvédelmi szabályok alapján végzi.',
		a: 11,
		gT: 3632,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Online felület grafikai tervét készíti el. Online felületre hirdetést, bannert, mozgó grafikát tervez.',
		a: 11,
		gT: 3631,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Kész arculatot alkalmaz, kiegészít, módosít.',
		a: 11,
		gT: 3630,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Meghívó, szórólap, egyéb kis terjedelmű nyomtatvány grafikai tervét készíti el. Plakátot, nyomdai felhasználású hirdetést tervez.',
		a: 11,
		gT: 3629,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Újsághoz, magazinhoz, prospektushoz, egyéb többoldalas kiadványhoz borító, címlap és belív layout-ot tervez.',
		a: 11,
		gT: 3628,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Piktogramot, logót, arculatot, arculati kézikönyvet, csomagolást, terülőmintát tervez.',
		a: 11,
		gT: 3627,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Manuális és digitális technikával ábrát, illusztrációt, szakillusztrációt, látványtervet készít.',
		a: 11,
		gT: 3626,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Eredeti képanyagot digitalizál, digitális képanyagot feldolgoz, szerkeszt az adott felhasználási cél ismeretében.',
		a: 11,
		gT: 3625,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Kiválasztja a feladatnak megfelelő hordozóanyagot, papírfajtát, alapanyagot.',
		a: 11,
		gT: 3624,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Technikai- és anyagkísérleteket végez. Terveket, változatokat, makettet készít, a problémás megoldásokat tovább fejleszti.',
		a: 11,
		gT: 3623,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai feladata megoldásához információt keres, gyűjtést végez.',
		a: 11,
		gT: 3622,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Megtervezi a munkafolyamatot, időbeosztást és költségkalkulációt készít.',
		a: 11,
		gT: 3621,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Fejlett szinten, a szakmai terminológiának megfelelő szókincs birtokában kommunikál magyarul és angol nyelven.',
		a: 11,
		gT: 3620,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Bizalmat alakít ki a megrendelővel, felméri annak igényeit, céljait, és szem előtt tartja azokat munkája során.',
		a: 11,
		gT: 3619,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Grafikus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan hoz döntéseket a vállalkozásában.',
		a: 11,
		gT: 3618,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Döntéseit a szakterület etikai, a szakma alapvető jogi szabályainak figyelembevételével hozza meg és felelősséget vállal azokért.',
		a: 11,
		gT: 3617,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan végzi a digitális archiválást, munkájáért felelősséget vállal.',
		a: 11,
		gT: 3616,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan választ és alkalmaz különböző digitális eszközöket.',
		a: 11,
		gT: 3615,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan választ szakmai céljainak megfelelő képfeldolgozó szoftvert.',
		a: 11,
		gT: 3614,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai céljainak megfelelően önállóan fogalmazza meg munkájának képi világát.',
		a: 11,
		gT: 3613,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Felelősséggel végzi munkáját önállóan és egy csoport tagjaként is.',
		a: 11,
		gT: 3612,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai céljainak megfelelően önállóan választ felvétel- és világítástechnikai eszközt.',
		a: 11,
		gT: 3611,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan végez kutatómunkát, megkeresi a fotográfiai munkájához szükséges inspirációs forrásokat.',
		a: 11,
		gT: 3610,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Elkötelezett a saját vállalkozása jogszerű és eredményes működtetéséért.',
		a: 11,
		gT: 3609,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Elkötelezett a törvényi előírások betartására.',
		a: 11,
		gT: 3608,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Kommunikációjában törekszik a közérthető megfogalmazásra, a szakmai terminológia használatára.',
		a: 11,
		gT: 3607,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a legkorszerűbb információs és kommunikációs eszközök és módszerek használatára.',
		a: 11,
		gT: 3606,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott az új technológiák és eszközök megismerésére, figyelemmel kíséri a szakmájával kapcsolatos innovációkat.',
		a: 11,
		gT: 3605,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Elkötelezett a minőségi munkavégzés mellett.',
		a: 11,
		gT: 3604,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiai sorozataiban törekszik a téma objektív megfogalmazására.',
		a: 11,
		gT: 3603,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a felvétel- és világítástechnikai eszközök változatos használatára.',
		a: 11,
		gT: 3602,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Elkötelezett a művészeti-és fotótörténeti források kutatásában, gyűjtésében.',
		a: 11,
		gT: 3601,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a vállalkozások fajtájával és működtetésével, jogi szabályozásával.',
		a: 11,
		gT: 3600,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a szerzői jog, a felhasználói szerződés és a személyiségi jog törvényi előírásait.',
		a: 11,
		gT: 3599,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a kommunikációs csatornákat, a kommunikáció szabályait.',
		a: 11,
		gT: 3598,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az archiválás digitális lehetőségeit, módszereit, szabályait.',
		a: 11,
		gT: 3597,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a digitális prezentáció összeállításának menetét, módját.',
		a: 11,
		gT: 3596,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Alapismeretekkel rendelkezik a tipográfia szabályairól, a szöveg és kép integrációjáról.',
		a: 11,
		gT: 3595,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Átfogó ismeretekkel rendelkezik a képfeldolgozó szoftverekkel kapcsolatban.',
		a: 11,
		gT: 3594,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a mozgókép formanyelvi kifejezőeszközeit és a technikai eszközök kezelésének módját.',
		a: 11,
		gT: 3593,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Rendelkezik a műteremben és szabadtérben végzett fotográfiai feladataihoz kapcsolódó alapvető és szakspecifikus ismeretekkel.',
		a: 11,
		gT: 3592,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a fénykép közvélemény formáló szerepét a médiában.',
		a: 11,
		gT: 3591,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a fotográfia felvétel- és világítástechnikai eszközeit.',
		a: 11,
		gT: 3590,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri a művészet-és fotótörténeti stílusjegyeket.',
		a: 11,
		gT: 3589,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiai vállalkozást indít, működtet.',
		a: 11,
		gT: 3588,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'A megrendelővel kötött szerződés szerint készít és használ fel álló- és mozgóképeket.',
		a: 11,
		gT: 3587,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Szóban és írásban kommunikál az ügyfelekkel, kollégákkal.',
		a: 11,
		gT: 3586,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Munkáit dokumentálja, digitálisan archiválja.',
		a: 11,
		gT: 3585,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Prezentációt tervez, készít. A feladatnak megfelelő célszoftvert kiválasztja és alkalmazza.',
		a: 11,
		gT: 3584,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Kiadványt szerkeszt, elvégzi a kép és szöveg integrációját.',
		a: 11,
		gT: 3583,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Képfeldolgozó programok használatával utómunkát végez.',
		a: 11,
		gT: 3582,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai feladatainak megoldásához mozgókép felvételt készít.',
		a: 11,
		gT: 3581,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiai feladatának megfelelően kiválasztja és alkalmazza a szükséges módszereket és eszközöket.',
		a: 11,
		gT: 3580,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Esemény- és riportfotó sorozatot és fotóesszét készít.',
		a: 11,
		gT: 3579,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai célhoz, feladathoz kiválasztja és helyesen használja a fotográfia felvétel- és világítástechnikai eszközeit.',
		a: 11,
		gT: 3578,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Művészeti és fotótörténeti ismereteit alkalmazza a fotográfiai tervezőmunkájában.',
		a: 11,
		gT: 3577,
		b: 13,
		e2: 'studio@11-13',
		jE: _List_fromArray(
			['Kreatív fotográfus Művészeti fotográfus'])
	},
		{
		cG: 'studio',
		gD: 'Vezetői iránymutatással végzi az anyag kiválasztását.',
		a: 9,
		gT: 3576,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Vezetői útmutatás mellett dolgozik.',
		a: 9,
		gT: 3575,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Betartja a munkájához kapcsolódó szabályokat (tűz-, baleset-, környezet és egészségvédelmi szabályok).',
		a: 9,
		gT: 3574,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Csoportmunkában a közös döntéseket elfogadva egyéni és csoportfelelősséget vállal.',
		a: 9,
		gT: 3573,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Problémamegoldó képességét egyszerűbb feladatokban önállóan alkalmazza.',
		a: 9,
		gT: 3572,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Önellenőrzést végez, hibáit önállóan kijavítja.',
		a: 9,
		gT: 3571,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Vezetői irányítás mellett szabadkézi vagy digitális eszközökkel tervez\u00A0 álló- vagy mozgóképet.',
		a: 9,
		gT: 3570,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Útmutatás alapján végzi tervező és kivitelező munkáját.',
		a: 9,
		gT: 3569,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Útmutatással végzi az analóg és a digitális színkeverést, betűhasználatot.',
		a: 9,
		gT: 3568,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik az anyagok gazdaságos felhasználására.',
		a: 9,
		gT: 3567,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a pontos, minőségben megfelelő munkavégzésre.',
		a: 9,
		gT: 3566,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott új technológia- és eszközhasználat megtanulására',
		a: 9,
		gT: 3565,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Írott kommunikációjában elkötelezett a magyar nyelvtan és helyesírás alkalmazása iránt, szóban a szakterminológai használatára.',
		a: 9,
		gT: 3564,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a csoportmunkában való eredményes együttműködésre, a konfliktusok közös megoldására.',
		a: 9,
		gT: 3563,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Fogékony a munka végzése során használandó, különböző szoftverek által nyújtott alkotói lehetőségekre.',
		a: 9,
		gT: 3562,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Lépést tart a technikai és vizuális környezet fejlődésével.',
		a: 9,
		gT: 3561,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik szakmai ismereteinek rendszeres bővítésére.',
		a: 9,
		gT: 3560,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott új elemeket is tartalmazó problémák kreatív megoldására.',
		a: 9,
		gT: 3559,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Törekszik a precíz munkára, a nyomdai és digitális színrendszerek helyes használatára, a tipográfiára és a szövegszedésre vonatkozó szabályok betartására.',
		a: 9,
		gT: 3558,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten ismeri a leggyakoribb papírfajtákat, azok használati tulajdonságait.',
		a: 9,
		gT: 3557,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapismeretekkel rendelkezik a nyomdaiparban használt nyomtatási technológiákról.',
		a: 9,
		gT: 3556,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapismeretekkel rendelkezik az egyszerű könyvkötészeti megoldásokról, műveletekről.',
		a: 9,
		gT: 3555,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapismeretekkel rendelkezik a kreatív-vizuális kivitelezői tevékenységekhez kapcsolódó munka-, tűz-, baleset-, környezet és egészségvédelmi szabályokról.',
		a: 9,
		gT: 3554,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten ismeri a szakmai terminológiát anyanyelven.',
		a: 9,
		gT: 3553,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az önálló ismeretszerzés, problémamegoldás alapvető módszereit, eszközeit, a kooperatív munka elvárásait.',
		a: 9,
		gT: 3552,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten ismeri a szabadkézi grafikai és képalkotó eszközöket, a vektor- és\u00A0 pixelgrafikus, kiadványszerkesztő szoftvereket és a képrögzítő eszközöket.',
		a: 9,
		gT: 3551,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a kiadványszerkesztő programokat, azok funkcióit.',
		a: 9,
		gT: 3550,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti alapismeretekkel rendelkezik.',
		a: 9,
		gT: 3549,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Érti a nyomdai és digitális média műfaji különbözőségeit, ismeri technikai sajátosságait, adottságait.',
		a: 9,
		gT: 3548,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten ismeri a kompozíciós, színelméleti és a tipográfiai előírásokat, elvárásokat.',
		a: 9,
		gT: 3547,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Kiválasztja a késztermék előállításához megfelelő papírt.',
		a: 9,
		gT: 3546,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Digitális technológiával színes nyomatot készít a késztermék továbbfeldolgozási műveleteinek figyelembevételével.',
		a: 9,
		gT: 3545,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Használja az egyszerű kézi könyvkötészeti technológiához kapcsolódó eszközöket, berendezéseket.',
		a: 9,
		gT: 3544,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Anyanyelven alapszintű – a szakmai terminológiának megfelelő - szókincs birtokában kommunikál.',
		a: 9,
		gT: 3543,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Az egyszerűbb feladatok rutinszerű elvégzése mellett új elemeket is tartalmazó problémákat másokkal együttműködve kreatívan megold. Ismeretei bővítéséhez információt gyűjt.',
		a: 9,
		gT: 3542,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten használja a digitális képalkotásra, képrögzítésre, képfeldolgozásra alkalmas pixel- és vektorgrafikus programokat.',
		a: 9,
		gT: 3541,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő szoftverek használatával elkészíti, integrálja és megjeleníti a különböző típusú\u00A0 vizuális alapelemeket (kép, betű, szín, forma).',
		a: 9,
		gT: 3540,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti ismereteit felhasználva szabadkézi vagy digitális eszközökkel készít álló- vagy mozgóképet.',
		a: 9,
		gT: 3539,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Az analóg és digitális média műfajaiban lévő lehetőségeket figyelembe véve alapszintű tervező és kivitelező munkát végez.',
		a: 9,
		gT: 3538,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'Képalkotó munkát végez komponálási ismeretekkel, tipográfiai konvenciók használatával és a vizuális kommunikáció alapelemeinek alkalmazásával. ',
		a: 9,
		gT: 3537,
		b: 10,
		e2: 'studio@9-10',
		jE: _List_fromArray(
			['Ágazati alapoktatás'])
	},
		{
		cG: 'studio',
		gD: 'A munka- és balesetvédelmi előírásokat betartja.',
		a: 9,
		gT: 3935,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Szakmai munkáit analóg és digitális formában archiválja.',
		a: 9,
		gT: 3934,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Saját munkájáról szóban és írásban is érthetően és színvonalasan kommunikál, prezentációt készít és tart.',
		a: 9,
		gT: 3933,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Analóg és digitális képet komponál, készít.',
		a: 9,
		gT: 3932,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Szabad kézi, vagy digitális vázlatokat készít.',
		a: 9,
		gT: 3931,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Elképzeléseit, ötleteit vizuális formában bemutatja.',
		a: 9,
		gT: 3930,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Az IKT adta lehetőségeket kihasználva bővíti művészettörténeti ismereteit, és az ismereteket munkájába beépíti.',
		a: 9,
		gT: 3929,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Művészettörténet '])
	},
		{
		cG: 'studio',
		gD: 'A műalkotásokat értelmezi.',
		a: 9,
		gT: 3928,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Művészettörténet '])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti ismereteit szakmai munkája során inspirációs forrásként használja, azokat szakmai munkájába beépíti.',
		a: 9,
		gT: 3927,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Művészettörténet '])
	},
		{
		cG: 'studio',
		gD: 'Elkészült munkáját bemutatja, publikálja.',
		a: 9,
		gT: 3926,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Szakmai tevékenységét dokumentálja, anyagait rendszerezi, archiválja és prezentálja.',
		a: 9,
		gT: 3925,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképfeldol-gozó és utómunka szoftvereket használ.',
		a: 9,
		gT: 3924,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Animációs feladatokat végez (pl. hagyományos vagy digitális 2D animáció, 3D animáció, interaktív vagy generatív animáció).',
		a: 9,
		gT: 3923,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Kivitelező feladatokat végez (pl. hagyományos vagy digitális 2D és 3D háttér készítés, báb- és díszletépítés, 3D modellezés, 3D nyomtatás).',
		a: 9,
		gT: 3922,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Stábot irányít, felvételvezetői, rendezői feladatokat lát el.',
		a: 9,
		gT: 3921,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Próbafelvételeket készít és a tapasztalatok alapján munkafolyamatot szervez.',
		a: 9,
		gT: 3920,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Technikai forgatókönyvet készít.',
		a: 9,
		gT: 3919,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Hang- és világítástechnikai eszközöket kezel.',
		a: 9,
		gT: 3918,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Kamerát és felvételtechnikai eszközöket kezel.',
		a: 9,
		gT: 3917,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Munkája során alkalmazza a kapcsolódó szerzői, felhasználási és személyiségi jogi előírásokat, valamint az adatvédelmi, média- és licencjogi szabályozásokat.',
		a: 9,
		gT: 3916,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Animatikot állít össze.',
		a: 9,
		gT: 3915,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Képes forgatókönyvet rajzol.',
		a: 9,
		gT: 3914,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Forgatókönyv alapján gyártási folyamatot tervez és azt részfeladatokra bontja, ütemtervet készít.',
		a: 9,
		gT: 3913,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Leírás vagy saját ötlet alapján karaktert tervez, karakterlapot állít össze, mozdulatterveket rajzol.',
		a: 9,
		gT: 3912,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Képes forgatókönyvet, beállítási rajzot, látványtervet készít.',
		a: 9,
		gT: 3911,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Ötleteit értékeli, kidolgozza és bemutatja.',
		a: 9,
		gT: 3910,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Mozgókép- és animációtervezői munkája során alkalmazza ábrázolási ismereteit.',
		a: 9,
		gT: 3909,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Dramaturgiai, formanyelvi ismereteit felhasználva mozgóképet tervez.',
		a: 9,
		gT: 3908,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgókép- és animációtervezés '])
	},
		{
		cG: 'studio',
		gD: 'Filmtörténeti alkotásokról, korokról, stílusokról, valamint saját munkájáról szóban és írásban is érthetően, színvonalasan kommunikál, prezentál',
		a: 9,
		gT: 3907,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Filmtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Filmtörténeti ismereteit szakmai munkájában inspirációs forrásként használja, azokat szakmai munkájába beépíti.',
		a: 9,
		gT: 3906,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Filmtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Filmet elemez.',
		a: 9,
		gT: 3905,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Filmtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Bővíti filmtörténeti ismereteit.',
		a: 9,
		gT: 3904,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Filmtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlítja a hazai és nemzetközi filmtörténet párhuzamos idősíkjait.',
		a: 9,
		gT: 3903,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Filmtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Zöldhátteres trükktechnikához jelenetet állít be, felvételt készít és feldolgozza.',
		a: 9,
		gT: 3902,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Speciális mozgókép '])
	},
		{
		cG: 'studio',
		gD: 'Térábrázolási ismereteinek felhasználásával térbeli (nem sík) felületre mozgóképi tartalmat tervez és készít.',
		a: 9,
		gT: 3901,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Speciális mozgókép '])
	},
		{
		cG: 'studio',
		gD: 'Felvételi és utómunka trükköket készít.',
		a: 9,
		gT: 3900,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Speciális mozgókép '])
	},
		{
		cG: 'studio',
		gD: 'Ötvözi az animációs és videótechnikákat',
		a: 9,
		gT: 3899,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Speciális mozgókép '])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten mozgóképes, animációs és utómunka szoftvereket kezel.',
		a: 9,
		gT: 3898,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Speciális mozgókép '])
	},
		{
		cG: 'studio',
		gD: 'Számítógépes munkaállomást üzemeltet.',
		a: 9,
		gT: 3897,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképes nyersanyagait szakszerűen tárolja és kezeli.',
		a: 9,
		gT: 3896,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten kezel speciális mozgóképkészítő szoftvereket.',
		a: 9,
		gT: 3895,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten használ utómunkára alkalmas szoftvereket.',
		a: 9,
		gT: 3894,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Szakszerűen használ felvételtechnikai eszközöket.',
		a: 9,
		gT: 3893,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Hangtechnikai ismereteit felhasználói szinten alkalmazza.',
		a: 9,
		gT: 3892,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Munkája során alkalmazza a fénytani és világítástechnikai ismereteit, világítástechnikai eszközöket kezel.',
		a: 9,
		gT: 3891,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Középszinten használ nonlineáris editálószoftvert, munkáit videó formátumban exportálja, projektfájljáról biztonsági másolatot készít.',
		a: 9,
		gT: 3890,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten kamerát kezel.',
		a: 9,
		gT: 3889,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Mozgóképkészítés '])
	},
		{
		cG: 'studio',
		gD: 'Animációtörténeti alkotásokról, korokról, stílusokról, hagyományos technikákról, valamint saját munkájáról szóban és írásban is érthetően, színvonalasan kommunikál, prezentál.',
		a: 9,
		gT: 3888,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Animációtörténeti ismereteit szakmai munkájában inspirációs forrásként használja, azokat szakmai munkájába beépíti.',
		a: 9,
		gT: 3887,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Animációs filmet elemez.',
		a: 9,
		gT: 3886,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Bővíti animációtörténeti ismereteit.',
		a: 9,
		gT: 3885,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlítja a hazai és nemzetközi animációtörténet párhuzamos idősíkjait.',
		a: 9,
		gT: 3884,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációtörténet '])
	},
		{
		cG: 'studio',
		gD: 'Interaktív felhasználásra animációt készít',
		a: 9,
		gT: 3883,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Bábokat, bábtechnikai kiegészítőket épít, bábokat animál.',
		a: 9,
		gT: 3882,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Képes forgatókönyvet, beállítási rajzot, látványtervet rajzol',
		a: 9,
		gT: 3881,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Alkalmazói szinten működtet 3D nyomtatót.',
		a: 9,
		gT: 3880,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Állóképekből mozgóképet állít össze.',
		a: 9,
		gT: 3879,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Munkája során alkalmazza ábrázolási ismereteit',
		a: 9,
		gT: 3878,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Munkája során szakszerűen használ digitális rajzeszközöket.',
		a: 9,
		gT: 3877,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Virtuális térben alkot, 3D szoftverekkel modellező és animációs munkát végez.',
		a: 9,
		gT: 3876,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'Animációs szoftverekkel alkalmazói szinten szakmai munkát végez.',
		a: 9,
		gT: 3875,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Animációs technikák '])
	},
		{
		cG: 'studio',
		gD: 'A tervezőmunkához és a kivitelezéshez kiválasztja a célnak megfelelő papírfajtákat.',
		a: 9,
		gT: 3874,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés alapismeretei '])
	},
		{
		cG: 'studio',
		gD: 'Tónus- és színhelyes digitális fényképet készít. Nyomdai kivitelezésre alapszinten előkészíti őket.',
		a: 9,
		gT: 3873,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés alapismeretei '])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten tervez feliratot, tipográfiai feladatokat lát el',
		a: 9,
		gT: 3872,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés alapismeretei '])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja az alapszintű színtani ismereteit a tervezés, kivitelezés és nyomdai előkészítés során.',
		a: 9,
		gT: 3871,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés alapismeretei '])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő szoftverek használatával elkészíti, integrálja és megjeleníti a különböző típusú vizuális alapelemeket (kép, betű, szín, forma)',
		a: 9,
		gT: 3870,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés szoftverei '])
	},
		{
		cG: 'studio',
		gD: 'Csomagolást tervez, készít.',
		a: 9,
		gT: 3869,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Digitális montírozást végez.',
		a: 9,
		gT: 3868,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Alapszintű animációt készít',
		a: 9,
		gT: 3867,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Munkájába alkalmazza művészettörténeti ismereteit.',
		a: 9,
		gT: 3866,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Saját munkájáról szóban és írásban is érthetően és színvonalasan kommunikál, prezentációt készít és tart',
		a: 9,
		gT: 3865,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti alkotásokról, korokról, saját munkájáról szóban és írásban is érthetően és színvonalasan kommunikál, prezentációt készít és tart.',
		a: 9,
		gT: 3864,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Művészettörténet '])
	},
		{
		cG: 'studio',
		gD: 'Az IKT adta lehetőségeket kihasználva bővíti művészettörténeti ismereteit, azt munkájába beépíti.',
		a: 9,
		gT: 3863,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'műalkotásokat értelmez.',
		a: 9,
		gT: 3862,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti ismereteit szakmai munkájában inspirációs forrásként használja, azokat szakmai munkájába beépíti.',
		a: 9,
		gT: 3861,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'Régi eszközök használatával korszerű tervet készít.',
		a: 9,
		gT: 3860,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafika szaktörténet és kortárs környezet tantárgy'])
	},
		{
		cG: 'studio',
		gD: 'A feladatnak megfelelő stílusú nyomtatványt tervez',
		a: 9,
		gT: 3859,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafika szaktörténet és kortárs környezet tantárgy'])
	},
		{
		cG: 'studio',
		gD: 'Inspirációt merít a szaktörténetből.',
		a: 9,
		gT: 3858,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafika szaktörténet és kortárs környezet tantárgy'])
	},
		{
		cG: 'studio',
		gD: 'Tudja, milyen betűtípusok használhatók együtt, ezzel elkerül néhány alapvető tervezési hibát.',
		a: 9,
		gT: 3857,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafika szaktörténet és kortárs környezet tantárgy'])
	},
		{
		cG: 'studio',
		gD: 'Munkájához alkalmazza szaktörténeti ismereteit.',
		a: 9,
		gT: 3856,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafika szaktörténet és kortárs környezet tantárgy'])
	},
		{
		cG: 'studio',
		gD: 'Grafikus munkát dokumentál.',
		a: 9,
		gT: 3855,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai tárgyban prezentál.',
		a: 9,
		gT: 3854,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai prezentációt készít.',
		a: 9,
		gT: 3853,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Munkát, munkafolyamatot, dokumentál, archivál.',
		a: 9,
		gT: 3852,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'A technikai elvárásoknak megfelelően elvégzi a digitális állomány nyomdai előkészítését, a grafikai tervek alapján a nyomdai utómunkákhoz szükséges digitális rajzokat.',
		a: 9,
		gT: 3851,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Plakátot, kisnyomtatványt készít.',
		a: 9,
		gT: 3850,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Készen kapott szöveget tördel.',
		a: 9,
		gT: 3849,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Újsághoz, magazinhoz, prospektushoz, egyéb többoldalas kiadványhoz layo-utot, borítót, címlapot készít elő.',
		a: 9,
		gT: 3848,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Piktogramot, logót, arculatot, csomagolást, terülőmintát készít.',
		a: 9,
		gT: 3847,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai tervezés és kivitelezési gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Illusztrációt készít',
		a: 9,
		gT: 3846,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Szabad kézzel feliratokat készít',
		a: 9,
		gT: 3845,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Ábrákon használt képi jeleket tudatosan, közvetlenül a célhoz rendelve alkalmazza.',
		a: 9,
		gT: 3844,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Következetesen alkalmazza a stílust.',
		a: 9,
		gT: 3843,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Digitális technikával illusztrációt, szakillusztrációt, ábrát, szakábrát készít.',
		a: 9,
		gT: 3842,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Manuális technikával illusztrációt, szakillusztrációt készít.',
		a: 9,
		gT: 3841,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, grafikai ábrázolás és technikai gyakorlat'])
	},
		{
		cG: 'studio',
		gD: 'Kiadványt a szerkeszt.',
		a: 9,
		gT: 3840,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, tervezés és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'Munkáit digitális és analóg prezentáció, vagy kiállítás formájában mutatja be',
		a: 9,
		gT: 3839,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, Portfólió és tipográfia'])
	},
		{
		cG: 'studio',
		gD: 'Megfogalmaz képi és szöveges üzeneteket',
		a: 9,
		gT: 3838,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, Portfólió és tipográfia'])
	},
		{
		cG: 'studio',
		gD: 'Helyén kezeli a tipográfiai formanyelvi eszközöket',
		a: 9,
		gT: 3837,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, Portfólió és tipográfia'])
	},
		{
		cG: 'studio',
		gD: 'Munkájában tipográfiai tudását alkalmazza',
		a: 9,
		gT: 3836,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, Portfólió és tipográfia'])
	},
		{
		cG: 'studio',
		gD: 'Munkáját a meg-rendelő igényeinek megfelelően utómunkázza',
		a: 9,
		gT: 3835,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiák nyomdai előkészítését végzi',
		a: 9,
		gT: 3834,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiáit analóg és digitális módon archiválja',
		a: 9,
		gT: 3833,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Online és offline adatbázisokat használ',
		a: 9,
		gT: 3832,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Analóg laborálást végez, filmet hív, képeket nagyít',
		a: 9,
		gT: 3831,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Digitális és analóg képkidolgozást, utómunkát végez',
		a: 9,
		gT: 3830,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képfeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Képes csoportban dolgozni',
		a: 9,
		gT: 3829,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'Különböző installációs és prezentációs technikákat alkalmaz',
		a: 9,
		gT: 3828,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'A képalkotás folyamatának alkalmazása',
		a: 9,
		gT: 3827,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'Fotótechnika elméleti ismereteit a gyakorlatban alkalmazza',
		a: 9,
		gT: 3826,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'Fotográfiai és mozgóképi, alkalmazott és alkotói feladatokat végez',
		a: 9,
		gT: 3825,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'Idő alapú alkalmazott és alkotói feladatokat végez',
		a: 9,
		gT: 3824,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'Képnyelvi eszközökkel dokumentarista asszociatív és narratív képsorokat készít.',
		a: 9,
		gT: 3823,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'kezeli a fotográfia és egyéb technikai médiumok formanyelvi eszközeit',
		a: 9,
		gT: 3822,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képalkotás és konzultáció'])
	},
		{
		cG: 'studio',
		gD: 'információ és anyaggyűjtés, terveket, vázlatokat, költségvetést készít',
		a: 9,
		gT: 3821,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Elemzi a szakmai formanyelvi eszközök különböző megjelenési formáját',
		a: 9,
		gT: 3820,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'A feladatot értelmez, koncepciót alakít ki, munkafolyamatot megtervezi, vizuális kommunikációs stratégiát épít.',
		a: 9,
		gT: 3819,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Munkájában képviseli a kortárs trendeket',
		a: 9,
		gT: 3818,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Munkáihoz inspirálódik a kortárs tendenciákból és alkotóktól.',
		a: 9,
		gT: 3817,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Munkájában felhasználja a fotó és technikai médium elméleti ismereteit.',
		a: 9,
		gT: 3816,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Munkájában alkalmazza a fotó és média történeti ismereteket',
		a: 9,
		gT: 3815,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, technikai médiumok története és elemzése'])
	},
		{
		cG: 'studio',
		gD: 'Munka és balesetvédelmi előírásokat betartja',
		a: 9,
		gT: 3814,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Szakmai munkáit analóg és digitális módon archiválja',
		a: 9,
		gT: 3813,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Tanáraival, társaival együttműködve kiállítást rendez.',
		a: 9,
		gT: 3812,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'A színek törvényszerűségeit és kifejezőerejét szakmai munkájában felhasználja',
		a: 9,
		gT: 3811,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Különböző manuális technikákkal festés, rajzolás, mintázás, montázs, kollázs, kevert és egyedi technikák alkalmazásával két és háromdimenziós alkotásokat készít',
		a: 9,
		gT: 3810,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Analóg és digitális képet komponál, készít',
		a: 9,
		gT: 3809,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, rajz'])
	},
		{
		cG: 'studio',
		gD: 'Szabadkézi, vagy digitális vázlatokat készít',
		a: 9,
		gT: 3808,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, rajz'])
	},
		{
		cG: 'studio',
		gD: 'Elképzeléseit, ötleteit vizuális formában bemutatja',
		a: 9,
		gT: 3807,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, Rajz '])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti alkotásokról, korokról, saját munkájáról szóban és írásban is érthetően és színvonalasan kommunikál, prezentációt készít és tart',
		a: 9,
		gT: 3806,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'Az IKT adta lehetőségeket kihasználva bővíti művészettörténeti ismereteit, azt munkájába beépíti',
		a: 9,
		gT: 3805,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'A műalkotásokat értelmezi',
		a: 9,
		gT: 3804,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti ismereteit szakmai munkájában inspirációs forrásként használja, azokat szakmai munkájába beépíti',
		a: 9,
		gT: 3803,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, művészettörténet'])
	},
		{
		cG: 'studio',
		gD: 'Kezeli és frissíti internetes információs és marketing felületeit.',
		a: 9,
		gT: 3802,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, marketing- és jogi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Értelmezi és szükség esetén megfogalmazza a munkájához kapcsolódó megbízási és felhasználói szerződéseket.',
		a: 9,
		gT: 3801,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, marketing- és jogi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Szakmai ismereteit és gyakorlatát szakszerűen megfogalmazza és az elvárt módon prezentálja.',
		a: 9,
		gT: 3800,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, marketing- és jogi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a munkájához szükséges jogi és etikai szabályokat, normákat.',
		a: 9,
		gT: 3799,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, marketing- és jogi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Fekete-fehér analóg nyersanyagot laborál',
		a: 9,
		gT: 3798,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképes anyagot speciális effektekkel lát el, hangot szinkronizál hozzá.',
		a: 9,
		gT: 3797,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Mozgóképes anyagot editál.',
		a: 9,
		gT: 3796,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Nyomdai előkészítést hajt végre fényképeken.',
		a: 9,
		gT: 3795,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Speciális képmódosításokat hajt végre fényképeken.',
		a: 9,
		gT: 3794,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Fényképének színtónusait, árnyalatait és a képhatárokat a felhasználás igényeinek megfelelően beállítja.',
		a: 9,
		gT: 3793,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotófeldolgozás'])
	},
		{
		cG: 'studio',
		gD: 'Szituációkat, élethelyzeteket mozgóképben rögzít.',
		a: 9,
		gT: 3792,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Speciális képhatásokat hoz létre az optikai és expozíciós értékek kreatív megválasztásával.',
		a: 9,
		gT: 3791,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Fények, fényforrások használatával hangulatokat teremt, tárgyak áthelyezésével tereket, kompozíciókat hoz létre.',
		a: 9,
		gT: 3790,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Adott élethelyzetben felismeri vagy létrehozza a kifejező, elvárt beállítást és fényképezőgéppel rögzíti azt.',
		a: 9,
		gT: 3789,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Fényt mér, expozíciós értékeket állít be és exponál.',
		a: 9,
		gT: 3788,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Fizikai adottságok és az aktuális elvárások figyelembevétel beállít és megvilágít egy arcot, egy teljes alakot.',
		a: 9,
		gT: 3787,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotóalkalmazás'])
	},
		{
		cG: 'studio',
		gD: 'Tudatosan hoz létre kompozíciót formák, színek és megvilágítások felhasználásával.',
		a: 9,
		gT: 3786,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képelemzés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri munkája során a környezeti elemek esztétikai összefüggéseit, alkalmazza rájuk a formanyelvi kifejezések lehetőségeit.',
		a: 9,
		gT: 3785,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képelemzés'])
	},
		{
		cG: 'studio',
		gD: 'Technikai és esztétikai jellemzőket ismer fel és értelmez stílustörténeti alkotásokon, majd munkájában alkalmazza.',
		a: 9,
		gT: 3784,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képelemzés'])
	},
		{
		cG: 'studio',
		gD: 'Művészettörténeti és szaktörténeti ismereteit beépíti munkájába, ötleteket merít belőlük.',
		a: 9,
		gT: 3783,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, képelemzés'])
	},
		{
		cG: 'studio',
		gD: 'Mozgókép felvételhez hangot rögzít.',
		a: 9,
		gT: 3782,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Papírképet, filmet szkennel, képet nyomtat.',
		a: 9,
		gT: 3781,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Monitoron, kijelzőn, ellenőrzi a kép minőségét.',
		a: 9,
		gT: 3780,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a digitális képérzékelő árnyalat visszaadó képességét.',
		a: 9,
		gT: 3779,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Helyesen választja meg az expozíció értékeit.',
		a: 9,
		gT: 3778,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Expozíció előtt fényt mér.',
		a: 9,
		gT: 3777,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Az elgondolt képi hatásnak megfelelően választ objektívet.',
		a: 9,
		gT: 3776,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Korrigálja egy fotó torzításait, életlenségeit.',
		a: 9,
		gT: 3775,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Színhelyesen exponál.',
		a: 9,
		gT: 3774,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Céljának megfelelően kiválasztja a szükséges fényforrást.',
		a: 9,
		gT: 3773,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fototechnika'])
	},
		{
		cG: 'studio',
		gD: 'Mikrofonokat integrál fényképezőgéphez.',
		a: 9,
		gT: 3772,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Akkumulátort, elemet és memóriakártyát cserél, kezel.',
		a: 9,
		gT: 3771,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Műtermi háttereket, derítőket használ és cserél. Informatikai rendszert használ.',
		a: 9,
		gT: 3770,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Üzembe helyez és működtet egy állandó fényforrást.',
		a: 9,
		gT: 3769,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Helyesen szinkronizálja fényképezőgépét egy vaku fényforráshoz.',
		a: 9,
		gT: 3768,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Fényképezőgépét és lámpáit stabilan rögzíti.',
		a: 9,
		gT: 3767,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználási módok alapján különbséget tesz objektívek között.',
		a: 9,
		gT: 3766,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a fényképezőgépek menürendszerét, kezelő gombjainak funkcióját.',
		a: 9,
		gT: 3765,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, fotográfiai eszközök'])
	},
		{
		cG: 'studio',
		gD: 'Egyszerű könyvkötészeti műveleteket végez.',
		a: 9,
		gT: 3764,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'Tervező- és kivitelezőmunkája során figyelembe veszi a média műfajainak sajátosságait.',
		a: 9,
		gT: 3763,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'A tervezőmunkához és a kivitelezéshez a célnak megfelelően használja a különböző papírfajtákat.',
		a: 9,
		gT: 3762,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'Képet digitalizál.',
		a: 9,
		gT: 3761,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés alapismeretei '])
	},
		{
		cG: 'studio',
		gD: 'Szín- és tónushelyes digitális fényképet készít, és nyomdai kivitelezéshez alapszinten előkészíti azt.',
		a: 9,
		gT: 3760,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'Alapszinten tervez feliratot, tipográfiai feladatokat lát el.',
		a: 9,
		gT: 3759,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'Felhasználja alapszintű színtani ismereteit a tervezés, kivitelezés és nyomdai előkészítés során.',
		a: 9,
		gT: 3758,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, viuális tervezés alapismeretei'])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő szoftverek használatával elkészíti, integrálja és megjeleníti a különböző típusú vizuális alapelemeket (kép, betű, szín, forma).',
		a: 9,
		gT: 3757,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, vizuális tervezés szoftverei'])
	},
		{
		cG: 'studio',
		gD: 'Digitális fényképeket dolgoz fel.',
		a: 9,
		gT: 3756,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés szoftverei '])
	},
		{
		cG: 'studio',
		gD: 'Megfelelő szoftvereket használva egyszerű ábrát készít.',
		a: 9,
		gT: 3755,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, A vizuális tervezés szoftverei '])
	},
		{
		cG: 'studio',
		gD: 'Könyvkötészeti munkát végez.',
		a: 9,
		gT: 3754,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Nyomtatási technológiát használ.',
		a: 9,
		gT: 3753,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, tervezés és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'Kiválasztja a célnak megfelelő anyagokat.',
		a: 9,
		gT: 3752,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, tervezés és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'Kiadványt szerkszt.',
		a: 9,
		gT: 3751,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Kreatív fotográfus - Művészeti fotográfus, tervezés- és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'Digitális fényképeket készít.',
		a: 9,
		gT: 3750,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Alapszintű animációt készít.',
		a: 9,
		gT: 3749,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, tervezés és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'Stilizálja a formát.',
		a: 9,
		gT: 3748,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Különböző eszközökkel illusztrációt készít.',
		a: 9,
		gT: 3747,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Igényes képeket tervez, alkot.',
		a: 9,
		gT: 3746,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Tervezés és kivitelezés '])
	},
		{
		cG: 'studio',
		gD: 'Munkájában alkalmazza művészettörténeti ismereteit.',
		a: 9,
		gT: 3745,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Grafikus, tervezés és kivitelezés'])
	},
		{
		cG: 'studio',
		gD: 'A munkaszerződések, munkaköri leírások szókincsét munkájára vonatkozóan alapvetően megérti.',
		a: 9,
		gT: 3744,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Az állásinterjúhoz kapcsolódóan telefonbeszélgetést folytat, időpontot egyeztet, tényeket tisztáz.',
		a: 9,
		gT: 3743,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Az állásinterjún, az állásinterjúra érkezéskor vagy a kapcsolódó telefonbeszélgetések során csevegést (small talk) kezdeményez, a társalgást fenntartja és befejezi. A kérdésekre megfelelő válaszokat ad.',
		a: 9,
		gT: 3742,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Felkészül az állásinterjúra a megpályázni kívánt állásnak megfelelően, a céljait szem előtt tartva kommunikál az interjú során.',
		a: 9,
		gT: 3741,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Kitölti és a munkaadóhoz eljuttatja a szükséges nyomtatványokat és dokumentumokat az álláskeresés folyamatának figyelembevételével',
		a: 9,
		gT: 3740,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'A tartalmi és formai követelményeknek megfelelő motivációs levelet ír, melyet a megpályázandó állás sajátosságaihoz igazít.',
		a: 9,
		gT: 3739,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'A tartalmi és formai követelményeknek megfelelő önéletrajzot fogalmaz.',
		a: 9,
		gT: 3738,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Internetes álláskereső oldalakon és egyéb fórumokon (újsághirdetések, szaklapok, szakmai kiadványok stb.) álláshirdetéseket keres. Az álláskereséshez használja a kapcsolati tőkéjét.',
		a: 9,
		gT: 3737,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói idegen nyelv'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri, megnevezi és leírja az álláskeresés módszereit.',
		a: 9,
		gT: 3736,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Szakképzési munkaviszonyt létesít.',
		a: 9,
		gT: 3735,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Megfogalmazza saját karriercéljait.',
		a: 9,
		gT: 3734,
		b: 13,
		e2: 'studio@9-13',
		jE: _List_fromArray(
			['Mozgókép- és animációkészítő, Munkavállalói ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Megoldást keres a testtartási rendellenesség kialakulásának megakadályozására, erre társait is motiválja.',
		a: 9,
		gT: 2767,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'A szabadban végzett foglalkozások során nem csupán ügyel környezete tisztaságára és rendjére, hanem erre felhívja társai figyelmét is.',
		a: 9,
		gT: 2766,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Az életkorának és alkati paramétereinek megfelelő pozitív, egészégtudatos, testmozgással összefüggő táplálkozási szokásokat alakít ki.',
		a: 9,
		gT: 2765,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Mindennapi életének részeként kezeli a testmozgás, a sportolás közbeni higiéniai és tisztálkodási szabályok betartását.',
		a: 9,
		gT: 2764,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Ismer és alkalmaz alapvető relaxációs technikákat.',
		a: 9,
		gT: 2763,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'A családi háttere és a közvetlen környezete adta lehetőségeihez mérten, belső igénytől vezérelve, alkotó módon, rendszeresen végez testmozgást.',
		a: 9,
		gT: 2762,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan, de tanári ellenőrzés mellett végez számára megfelelő uszodai tevékenységet.',
		a: 9,
		gT: 2761,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'A szárazföldi és az uszodai korrekciós gyakorlatait készségszinten sajátítja el, azokat tudatosan rögzíti.',
		a: 9,
		gT: 2760,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'Mindennapi tevékenységének tudatos részévé válik a korrekciós gyakorlatok végzése.',
		a: 9,
		gT: 2759,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'Belső igénytől vezérelve rendszeresen végez a biomechanikailag helyes testtartás kialakítását elősegítő gyakorlatokat.',
		a: 9,
		gT: 2758,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'Az egyéni képességeihez mérten, mindennapi szokásrendszerébe építve fejleszti keringési, légzési és mozgatórendszerét.',
		a: 9,
		gT: 2757,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'Megoldást keres a különböző veszély- és baleseti források elkerülésére, erre társait is motiválja.',
		a: 9,
		gT: 2756,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'studio',
		gD: 'A szabályjátékok alkotó részese, képes szabálykövető játékvezetésre.',
		a: 9,
		gT: 2755,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'studio',
		gD: 'A versengések és a versenyek közben közösségformáló, csapatkohéziót kialakító játékosként viselkedik.',
		a: 9,
		gT: 2754,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'studio',
		gD: 'A versengések és a versenyek közben toleráns a csapattársaival és az ellenfeleivel szemben, ezt tőlük is elvárja.',
		a: 9,
		gT: 2753,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'studio',
		gD: 'Játéktevékenységét kreativitást mutató játék- és együttműködési készség jellemzi.',
		a: 9,
		gT: 2752,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'studio',
		gD: 'A tanult testnevelési, népi és sportjátékok összetett technikai és taktikai elemeit kreatívan, az adott játékhelyzetnek megfelelően, célszerűen, készségszinten alkalmazza.',
		a: 9,
		gT: 2751,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan képes az elkerülhetetlen vízi veszélyhelyzetek célszerű kezelésére.',
		a: 9,
		gT: 2750,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Az elsajátított egy (vagy több) úszásnemben vízbiztosan, készségszinten úszik, a természetes vizekben is.',
		a: 9,
		gT: 2749,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Rendszeresen mozog, edz, sportol a szabad levegőn, erre − lehetőségeihez mérten − társait is motiválja.',
		a: 9,
		gT: 2748,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'A különböző eséstechnikák készségszintű elsajátítása mellett a választott küzdősport speciális mozgásformáit célszerűen alkalmazza.',
		a: 9,
		gT: 2747,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan képes az életben adódó, elkerülhetetlen veszélyhelyzetek célszerű hárítására.',
		a: 9,
		gT: 2746,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'A zenei ütemnek megfelelően, készségszintű koordinációval végzi a kiválasztott ritmikus gimnasztika, illetve aerobik mozgásformákat.',
		a: 9,
		gT: 2745,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'A torna, ritmikus gimnasztika, aerobik és tánc jellegű mozgásformákon keresztül fejleszti esztétikai-művészeti tudatosságát és kifejezőképességét.',
		a: 9,
		gT: 2744,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan képes az általa kiválasztott elemkapcsolatokból tornagyakorlatot összeállítani, majd bemutatni.',
		a: 9,
		gT: 2743,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Képes a kiválasztott ugró- és dobótechnikákat az ilyen jellegű játékok, versengések és versenyek közben, az eredményesség érdekében, egyéni sajátosságaihoz formálva hatékonyan alkalmazni.',
		a: 9,
		gT: 2742,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'A rajtolási módokat a játékok, versenyek, versengések közben hatékonyan, kreatívan alkalmazza.',
		a: 9,
		gT: 2741,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'A korábbi évfolyamokon elért eredményeihez képest folyamatosan javítja futóteljesítményét, amelyet önmaga is tudatosan nyomon követ.',
		a: 9,
		gT: 2740,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'studio',
		gD: 'Tanári ellenőrzés mellett digitálisan méri és értékeli a kondicionális és koordinációs képességeinek változásait, ezekből kiindulva felismeri saját motoros képességbeli hiányosságait, és ezeket a képességeket tudatosan és rendszeresen fejleszti.',
		a: 9,
		gT: 2739,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'A (meg)tanult erő-, gyorsaság-, állóképesség- és ügyességfejlesztő eljárásokat önállóan, tanári ellenőrzés nélkül alkalmazza.',
		a: 9,
		gT: 2738,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'A különböző sportágspecifikus mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten hajtja végre.',
		a: 9,
		gT: 2737,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Relatív erejének birtokában a tanult mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten kivitelezi.',
		a: 9,
		gT: 2736,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Olyan szintű motoros képességekkel rendelkezik, amelyek lehetővé teszik a tanult mozgásformák alkotó módon történő végrehajtását.',
		a: 9,
		gT: 2735,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Nyitott az alapvető és sportágspecifikus mozgásformák újszerű és alternatív környezetben történő felhasználására, végrehajtására.',
		a: 9,
		gT: 2734,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Sporttevékenységében spontán, automatikus forma- és szabálykövető attitűdöt követ.',
		a: 9,
		gT: 2733,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'A testedzéshez, a sportoláshoz kívánatosnak tartott jellemzőknek megfelelően (fegyelmezetten, határozottan, lelkiismeretesen, innovatívan és kezdeményezően) törekszik végrehajtani az elsajátított mozgásformákat.',
		a: 9,
		gT: 2732,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'A tanult mozgásformákat alkotó módon, a testedzés és a sportolás minden területén használja.',
		a: 9,
		gT: 2731,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Toleráns a testi és más fogyatékossággal élő személyek iránt, megismeri és tiszteletben tartja a szexuális kultúra alapelveit, elfogadja az egészségügyi szűrések és a környezetvédelem fontosságát.',
		a: 9,
		gT: 2730,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Társas-közösségi kapcsolatai, valamint stressztűrő és -kezelő képességei megfelelő szintre fejlődtek.',
		a: 9,
		gT: 2729,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Képes elhárítani a baleseti és veszélyforrásokat, magabiztosan segíteni és elsősegélyt nyújtani embertársainak.',
		a: 9,
		gT: 2728,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Megismeri és mindennapjai részévé teszi a mozgáshoz kapcsolódó helyes attitűdöket, a fizikailag aktív életmód és a társas-érzelmi jóllét élethosszig tartó jótékony hatásait.',
		a: 9,
		gT: 2727,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Alkotó módon használja a testnevelés életkorához igazodó ismeretanyagát, szakkifejezéseit, helyes terminológiáját.',
		a: 9,
		gT: 2726,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri, hogy a jelen társadalmi, gazdasági, politikai és kulturális viszonyai a múltbeli események, tényezők következményeiként alakultak ki.',
		a: 9,
		gT: 2913,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Feltevéseket fogalmaz meg, azok mellett érveket gyűjt, illetve mérlegeli az ellenérveket.',
		a: 9,
		gT: 2912,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlítja és kritikusan értékeli az egyes történelmi folyamatokkal, eseményekkel és személyekkel kapcsolatos eltérő álláspontokat.',
		a: 9,
		gT: 2911,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Képes felismerni konkrét történelmi helyzetekben, jelenségekben és folyamatokban valamely általános szabályszerűség érvényesülését.',
		a: 9,
		gT: 2910,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlít különböző, egymáshoz hasonló történeti helyzeteket, folyamatokat, jelenségeket.',
		a: 9,
		gT: 2909,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Képes összevetni, csoportosítani és súlyozni az egyes történelmi folyamatok, jelenségek, események okait, következményeit, és ítéletet alkotni azokról, valamint a benne résztvevők szándékairól.',
		a: 9,
		gT: 2908,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'A változás és a fejlődés fogalma közötti különbséget ismerve képes felismerni és bemutatni azokat azonos korszakon belül, vagy azokon átívelően.',
		a: 9,
		gT: 2907,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Képes különböző élethelyzetek, magatartásformák megfigyelése által következtetések levonására, erkölcsi kérdéseket is felvető történelmi helyzetek felismerésére és megítélésére.',
		a: 9,
		gT: 2906,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Önálló véleményt tud alkotni történelmi eseményekről, folyamatokról, jelenségekről és személyekről.',
		a: 9,
		gT: 2905,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Önálló kérdéseket fogalmaz meg történelmi folyamatok, jelenségek és események feltételeiről, okairól és következményeiről.',
		a: 9,
		gT: 2904,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Hipotéziseket alkot történelmi személyek, társadalmi csoportok és intézmények viselkedésének mozgatórugóiról.',
		a: 9,
		gT: 2903,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'A tanult ismereteket problémaközpontúan tudja rendezni.',
		a: 9,
		gT: 2902,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Képes felismerni, megfogalmazni és összehasonlítani különböző társadalmi és történelmi problémákat, értékrendeket, jelenségeket, folyamatokat.',
		a: 9,
		gT: 2901,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'studio',
		gD: 'Társaival képes megvitatni történelmi kérdéseket, amelynek során bizonyítékokon alapuló érvekkel megindokolja a véleményét, és választékosan reflektál mások véleményére, árnyalja saját álláspontját.',
		a: 9,
		gT: 2900,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Megadott szempontok alapján történelmi tárgyú szerkesztett szöveget (esszét) tud alkotni, amelynek során tételmondatokat fogalmaz meg, állításait több szempontból indokolja és következtetéseket von le.',
		a: 9,
		gT: 2899,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Történelmi tárgyú folyamatábrákat, digitális táblázatokat, diagramokat készít, történelmi, gazdasági, társadalmi és politikai modelleket vizuálisan is meg tud jeleníteni.',
		a: 9,
		gT: 2898,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Történelmi témáról kiselőadást, digitális prezentációt alkot és mutat be.',
		a: 9,
		gT: 2897,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Képes egy-egy korszakot átfogó módon bemutatni.',
		a: 9,
		gT: 2896,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Képes önállóan vázlatot készíteni és jegyzetelni.',
		a: 9,
		gT: 2895,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Össze tudja foglalni rövid és egyszerű szaktudományos szöveg tartalmát.',
		a: 9,
		gT: 2894,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Képes kiválasztani, rendezni és alkalmazni az azonos korhoz, témához kapcsolható fogalmakat.',
		a: 9,
		gT: 2893,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Fel tud ismerni fontosabb történelmi fogalmakat meghatározás alapján.',
		a: 9,
		gT: 2892,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Képes a történelmi jelenségeket általános és konkrét történelmi fogalmak, tartalmi és értelmező kulcsfogalmak felhasználásával értelmezni és értékelni.',
		a: 9,
		gT: 2891,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'studio',
		gD: 'Képes különböző időszakok történelmi térképeinek összehasonlítására, a történelmi tér változásainak és a történelmi mozgások követésére megadott szempontok alapján a változások hátterének feltárásával.',
		a: 9,
		gT: 2890,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'A földrajzi környezet és a történeti folyamatok összefüggéseit példákkal képes alátámasztani.',
		a: 9,
		gT: 2889,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Egyszerű történelmi térképvázlatot alkot hagyományos és digitális eljárással.',
		a: 9,
		gT: 2888,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Felismeri, hogy a magyar történelem az európai történelem része, és példákat tud hozni a magyar és európai történelem kölcsönhatásaira.',
		a: 9,
		gT: 2887,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Képes azonosítani a tanult egyetemes és magyar történelmi személyiségek közül a kortársakat.',
		a: 9,
		gT: 2886,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Össze tudja hasonlítani megadott szempontok alapján az egyes történelmi korszakok, időszakok jellegzetességeit az egyetemes és a magyar történelem egymáshoz kapcsolódó eseményeit.',
		a: 9,
		gT: 2885,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Az egyes események, folyamatok idejét konkrét történelmi korhoz, időszakhoz kapcsolja vagy viszonyítja, ismeri néhány kiemelten fontos esemény, jelenség időpontját, kronológiát használ és készít.',
		a: 9,
		gT: 2884,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar és az európai történelem tanult történelmi korszakait, időszakait, és képes azokat időben és térben elhelyezni.',
		a: 9,
		gT: 2883,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'studio',
		gD: 'Képes kiválasztani a megfelelő forrást valamely történelmi állítás, vélemény alátámasztására vagy cáfolására.',
		a: 9,
		gT: 2882,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Összehasonlítja a forrásokban talált információkat saját ismereteivel, illetve más források információival és megmagyarázza az eltérések okait.',
		a: 9,
		gT: 2881,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Képes a szándékainak megfelelő információkat kiválasztani különböző műfajú forrásokból.',
		a: 9,
		gT: 2880,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Képes azonosítani a különböző források szerzőinek a szándékát, bizonyítékok alapján értékeli egy forrás hitelességét.',
		a: 9,
		gT: 2879,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Tud forráskritikát végezni és különbséget tenni a források között hitelesség, típus és szövegösszefüggés alapján.',
		a: 9,
		gT: 2878,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan információkat tud gyűjteni, áttekinteni, rendszerezni és értelmezni különböző médiumokból és írásos vagy képi forrásokból, statisztikákból, diagramokból, térképekről, nyomtatott és digitális felületekről.',
		a: 9,
		gT: 2877,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Önállóan tud használni általános és történelmi, nyomtatott és digitális információforrásokat (tankönyv, kézikönyvek, szakkönyvek, lexikonok, képzőművészeti alkotások, könyvtár és egyéb adatbázisok, filmek, keresők).',
		a: 9,
		gT: 2876,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri hazája államszervezetét, választási rendszerét.',
		a: 9,
		gT: 2875,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyarság, illetve a kárpát-medence népei együttélésének jellemzőit, példákat hoz a magyar nemzet és a közép-európai régió népeinek kapcsolatára, különös tekintettel a visegrádi együttműködésre.',
		a: 9,
		gT: 2874,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar cigányság történetének főbb állomásait, bemutatja jelenkori helyzetét.',
		a: 9,
		gT: 2873,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a határon túli magyarság helyzetét, a megmaradásért való küzdelmét trianontól napjainkig.',
		a: 9,
		gT: 2872,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és reálisan látja a többpólusú világ jellemzőit napjainkban, elhelyezi magyarországot a globális világ folyamataiban.',
		a: 9,
		gT: 2871,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a gyarmati rendszer felbomlásának következményeit, india, kína és a közel-keleti régió helyzetét és jelentőségét.',
		a: 9,
		gT: 2870,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a kommunista diktatúra magyarországi kiépítését, működését és változatait, az 1956-os forradalom és szabadságharc okait, eseményeit és hőseit, összefüggéseiben szemléli a rendszerváltoztatás folyamatát, felismerve annak történelmi jelentőségét.',
		a: 9,
		gT: 2869,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Össze tudja hasonlítani a nyugati demokratikus világ és a kommunista szovjet blokk politikai és társadalmi berendezkedését, képes jellemezni a hidegháború időszakát, bemutatni a gyarmati rendszer felbomlását és az európai kommunista rendszerek összeomlását.',
		a: 9,
		gT: 2868,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja magyarország revíziós lépéseit, a háborús részvételét, az ország német megszállását, a magyar zsidóság tragédiáját, a szovjet megszállást, a polgári lakosság szenvedését, a hadifoglyok embertelen sorsát.',
		a: 9,
		gT: 2867,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Képes felidézni a második világháború okait, a háború jellemzőit és fontosabb fordulópontjait, ismeri a holokausztot és a hozzávezető okokat.',
		a: 9,
		gT: 2866,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Össze tudja hasonlítani a nemzetiszocialista és a kommunista ideológiát és diktatúrát, példák segítségével bemutatja a rendszerek embertelenségét és a velük szembeni ellenállás formáit.',
		a: 9,
		gT: 2865,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Tisztában van a trianoni békediktátum tartalmával és következményeivel, be tudja mutatni az ország talpra állását, a horthy-korszak politikai, gazdasági, társadalmi és kulturális viszonyait, felismeri a magyar külpolitika mozgásterének korlátozottságát.',
		a: 9,
		gT: 2864,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Képes felidézni azokat az okokat és körülményeket, amelyek a történelmi magyarország felbomlásához vezettek.',
		a: 9,
		gT: 2863,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja az első világháború magyar vonatkozásait, a háborús vereség következményeit; példákat tud hozni a háborús helytállásra.',
		a: 9,
		gT: 2862,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Fel tudja idézni az első világháború előzményeit, a háború jellemzőit és fontosabb fordulópontjait, értékeli a háborúkat lezáró békék tartalmát, és felismeri a háborúnak a 20. század egészére gyakorolt hatását.',
		a: 9,
		gT: 2861,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Fel tudja idézni az ipari forradalom szakaszait, illetve azok gazdasági, társadalmi, kulturális és politikai hatásait; képes bemutatni a modern polgári társadalom és állam jellemzőit és a 19. század főbb politikai eszméit, valamint felismeri a hasonlóságot és különbséget azok mai formái között.',
		a: 9,
		gT: 2860,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri és értékeli a magyar nemzetnek a polgári átalakulás és nemzeti függetlenség elérésére tett erőfeszítéseit a reformkor, az 1848/49-es forradalom és szabadságharc, illetve az azt követő időszakban; a kor kiemelkedő magyar politikusait és azok nézeteit, véleményt tud formálni a kiegyezésről.',
		a: 9,
		gT: 2859,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Összefüggéseiben és folyamatában fel tudja idézni, miként hatott a magyar történelemre a habsburg birodalomhoz való tartozás, bemutatja az együttműködés és konfrontáció megnyilvánulásait, a függetlenségi törekvéseket és értékeli a rákóczi-szabadságharc jelentőségét.',
		a: 9,
		gT: 2858,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Be tudja mutatni a kora újkor fő gazdasági és társadalmi folyamatait, ismeri a felvilágosodás eszméit, illetve azok kulturális és politikai hatását, valamint véleményt formál a francia forradalom európai hatásáról.',
		a: 9,
		gT: 2857,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyarság törökellenes küzdelmeit, fordulópontjait és hőseit; felismeri, hogy a magyar és az európai történelem alakulását meghatározóan befolyásolta a török megszállás.',
		a: 9,
		gT: 2856,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felidézi a középkori magyar állam történetének fordulópontjait, legfontosabb uralkodóink tetteit.',
		a: 9,
		gT: 2855,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Értékeli az államalapítás, valamint a kereszténység felvételének jelentőségét.',
		a: 9,
		gT: 2854,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a magyar nép őstörténetére és a honfoglalásra vonatkozó tudományos elképzeléseket és tényeket, tisztában van legfőbb vitatott kérdéseivel, a különböző tudományterületek kutatásainak főbb eredményeivel.',
		a: 9,
		gT: 2853,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Képes felidézni a középkor gazdasági és kulturális jellemzőit, világképét, a kor meghatározó birodalmait és bemutatni a rendi társadalmat.',
		a: 9,
		gT: 2852,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Bemutatja a keresztény vallás civilizációformáló hatását, a középkori egyházat, valamint a reformáció és a katolikus megújulás folyamatát és kulturális hatásait; érvel a vallási türelem, illetve a vallásszabadság mellett.',
		a: 9,
		gT: 2851,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Felidézi a monoteista vallások kialakulását, legfontosabb jellemzőiket, tanításaik főbb elemeit, és bemutatja terjedésüket.',
		a: 9,
		gT: 2850,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri az ókori civilizációk legfontosabb jellemzőit, valamint az athéni demokrácia és a római állam működését, hatásukat az európai civilizációra.',
		a: 9,
		gT: 2849,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'studio',
		gD: 'Megerősödik és elmélyül a társadalmi felelősség és normakövetés, az egyéni kezdeményezőkészség, a hazája, közösségei és embertársai iránt való felelősségvállalás, valamint a demokratikus elkötelezettség.',
		a: 9,
		gT: 2848,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Megerősödnek az európai civilizációs identitás alapelemei.',
		a: 9,
		gT: 2847,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Elmélyül a nemzeti identitás és hazaszeretet, büszke népe múltjára, ápolja hagyományait, és méltón emlékezik meg hazája nagyjairól.',
		a: 9,
		gT: 2846,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Kialakulnak a saját értékrend és történelemszemlélet alapjai.',
		a: 9,
		gT: 2845,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Kialakul és megerősödik a történelmi múlt, illetve a társadalmi, politikai, gazdasági és kulturális kérdések iránti érdeklődés.',
		a: 9,
		gT: 2844,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a demokratikus államszervezet működését, a társadalmi együttműködés szabályait, a piacgazdaság alapelveit; autonóm és felelős állampolgárként viselkedik.',
		a: 9,
		gT: 2843,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Képes a múlt eseményeit és jelenségeit a saját történelmi összefüggésükben értelmezni, illetve a jelen viszonyait kapcsolatba hozni a múltban történtekkel.',
		a: 9,
		gT: 2842,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Kialakul a hiteles és tárgyilagos forráshasználat és kritika igénye.',
		a: 9,
		gT: 2841,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Képes a tanulási célhoz megfelelő információforrást választani, a források között szelektálni, azokat szakszerűen feldolgozni és értelmezni.',
		a: 9,
		gT: 2840,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Képes következtetni történelmi események, folyamatok és jelenségek okaira és következményeire.',
		a: 9,
		gT: 2839,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Különbséget tud tenni történelmi tények és történelmi interpretáció, illetve vélemény között.',
		a: 9,
		gT: 2838,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Ismeri a közös magyar nemzeti és európai, valamint az egyetemes emberi civilizáció kulturális örökségének, kódrendszerének lényeges elemeit.',
		a: 9,
		gT: 2837,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Képes a múlt és jelen társadalmi, gazdasági, politikai és kulturális folyamatairól, jelenségeiről többszempontú, tárgyilagos érveléssel alátámasztott véleményt alkotni, ezekkel kapcsolatos problémákat megfogalmazni.',
		a: 9,
		gT: 2836,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'studio',
		gD: 'Megbízható ismeretekkel bír az európai, valamint az egyetemes történelem és mélyebb tudással rendelkezik a magyar történelem fontosabb eseményeiről, történelmi folyamatairól, fordulópontjairól.',
		a: 9,
		gT: 2835,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy a modul tervezés a célmeghatározással kezdődik. Leírod, hogy mit akarsz a modullal elérni.',
		a: 1,
		gT: 3518,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['modul'])
	},
		{
		cG: 'onboarding',
		gD: 'Érted, hogy nálunk te döntöd el, mi a tananyag, mi a tanmenet és milyen tankönyvet használsz.',
		a: 1,
		gT: 3517,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['modul'])
	},
		{
		cG: 'onboarding',
		gD: 'Hozzá tudsz rendelni tanulási eredményeket a modulodhoz.',
		a: 1,
		gT: 3516,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['modul'])
	},
		{
		cG: 'onboarding',
		gD: 'Értékelő táblázatot készítesz, érted, hogy mi a több szempontos visszajelzés.',
		a: 1,
		gT: 3515,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['modul'])
	},
		{
		cG: 'onboarding',
		gD: 'Ismered a cross- és monomodul kifejezéseket.',
		a: 1,
		gT: 3514,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['modul'])
	},
		{
		cG: 'onboarding',
		gD: 'Érted, hogy a gyereknek demonstrálnia kell a tudást, hogy elismerhesd a tanulási eredményt.',
		a: 1,
		gT: 3513,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['portfolio történet'])
	},
		{
		cG: 'onboarding',
		gD: 'Portfólió történetet rögzítesz gyerekhez.',
		a: 1,
		gT: 3512,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['portfolio történet'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy a tanulási eredmény elérése két pólusú: vagy megvan vagy nincs. A finomabb, részletesebb visszajelzést az értékelő táblázatok adják.',
		a: 1,
		gT: 3511,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['tanulási eredmény'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy a NAT néhány tanulási eredménye túl tág, nem elég specifikus, de ezeket át tudod magadnak fogalmazni.',
		a: 1,
		gT: 3510,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['tanulási eredmény'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy a tanulási eredmények elismerése alapján adunk osztályzatot.',
		a: 1,
		gT: 3509,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['tanulási eredmény'])
	},
		{
		cG: 'onboarding',
		gD: 'Érted, hogy a BPS tanulási eredményei a NAT-ot fedik le.',
		a: 1,
		gT: 3508,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['tanulási eredmény'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy mi a különbség a tanulási eredmény és a kompetencia között.',
		a: 1,
		gT: 3507,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['tanulási eredmény'])
	},
		{
		cG: 'onboarding',
		gD: 'Be tudsz lépni a mybps-be és javítod az adatokat.',
		a: 1,
		gT: 3506,
		b: 1,
		e2: 'bps  tanulásszervezés',
		jE: _List_fromArray(
			['mybps'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy ki Viki.',
		a: 1,
		gT: 3531,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Részt vesz az első heti hétfőkőn és havi szombaton'])
	},
		{
		cG: 'onboarding',
		gD: 'Részt vettél egy peer circle találkozón.',
		a: 1,
		gT: 3530,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Részt vesz az első heti hétfőkőn és havi szombaton'])
	},
		{
		cG: 'onboarding',
		gD: 'Munkacsoportba kerültél.',
		a: 1,
		gT: 3529,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Részt vesz az első heti hétfőkőn és havi szombaton'])
	},
		{
		cG: 'onboarding',
		gD: 'Tettél javaslatot amit az iskola tanárcsapata elfogadott és ezzel megváltoztattad az iskola működését.',
		a: 1,
		gT: 3528,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Rajon, hogy nem erti, hogyan dontunk a csapatban dolgokrol'])
	},
		{
		cG: 'onboarding',
		gD: '',
		a: 1,
		gT: 3527,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Rajon, hogy nem erti, hogyan dontunk a csapatban dolgokrol'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy együtt kell megterveznetek az órarendet és modulterveket a tanárcsapatoddal.',
		a: 1,
		gT: 3526,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['Rajon, hogy nem erti, hogyan dontunk a csapatban dolgokrol'])
	},
		{
		cG: 'onboarding',
		gD: 'Keresel magadnak mentort, felveszed a mybps-be és szervezel vele három találkozót.',
		a: 1,
		gT: 3525,
		b: 1,
		e2: 'bps mint szervezet',
		jE: _List_fromArray(
			['mentorálás (felnőtt-felnőtt)'])
	},
		{
		cG: 'onboarding',
		gD: 'Elolvastad a mentorált gyerekeid régebbi anyagait.',
		a: 1,
		gT: 3524,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['mentorálás'])
	},
		{
		cG: 'onboarding',
		gD: 'Minden mentorált gyereked szüleivel volt egy személyes kapcsolódásod.',
		a: 1,
		gT: 3523,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['mentorálás'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, mi a GROW modell, és használod gyerekkel.',
		a: 1,
		gT: 3522,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['mentorálás'])
	},
		{
		cG: 'onboarding',
		gD: 'Megkötöttél egy hármas szerződést.',
		a: 1,
		gT: 3521,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['hármas szerződés'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy mik a SMART célok és ezeket használod a hármas szerződésben.',
		a: 1,
		gT: 3520,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['hármas szerződés'])
	},
		{
		cG: 'onboarding',
		gD: 'Példának megnéztél 8 hármas szerződést a múltból, és írtál három dolgot, ami tetszett benne.',
		a: 1,
		gT: 3519,
		b: 1,
		e2: 'gyerek-tanár-szülő hármas',
		jE: _List_fromArray(
			['hármas szerződés'])
	},
		{
		cG: 'onboarding',
		gD: 'Aláírtad a szerződésed.',
		a: 1,
		gT: 3536,
		b: 1,
		e2: 'jogviszony',
		jE: _List_fromArray(
			['Megismeri a szerződés feltételeit, egyéni vállalkozása lesz, megtanul számlát kiállítani'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy az SZJA vagy a KATA (vagy mindkettő) bevallási kötelezettség vonatkozik-e rád.',
		a: 1,
		gT: 3535,
		b: 1,
		e2: 'jogviszony',
		jE: _List_fromArray(
			['Megismeri a szerződés feltételeit, egyéni vállalkozása lesz, megtanul számlát kiállítani'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy bevételi nyilvántartást kell vezetned, és a számláidat, bankkivonataidat le kell mentened.',
		a: 1,
		gT: 3534,
		b: 1,
		e2: 'jogviszony',
		jE: _List_fromArray(
			['Megismeri a szerződés feltételeit, egyéni vállalkozása lesz, megtanul számlát kiállítani'])
	},
		{
		cG: 'onboarding',
		gD: 'Tudod, hogy hova, hogyan és mikor kell adót fizetned.',
		a: 1,
		gT: 3533,
		b: 1,
		e2: 'jogviszony',
		jE: _List_fromArray(
			['Megismeri a szerződés feltételeit, egyéni vállalkozása lesz, megtanul számlát kiállítani'])
	},
		{
		cG: 'onboarding',
		gD: 'Kiállítasz egy folyamatos teljesítésű mintaszámlát.',
		a: 1,
		gT: 3532,
		b: 1,
		e2: 'jogviszony',
		jE: _List_fromArray(
			['Megismeri a szerződés feltételeit, egyéni vállalkozása lesz, megtanul számlát kiállítani'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy a mikroiskolád hogy áll az első trimeszter dokumentációjával myBPS-ben.',
		a: 1,
		gT: 3452,
		b: 1,
		e2: 'bps modell dokumentáció',
		jE: _List_fromArray(
			['Mikroiskola megérkezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy mik a félévzárás határidői a BPS-ben.',
		a: 1,
		gT: 3451,
		b: 1,
		e2: 'bps modell dokumentáció',
		jE: _List_fromArray(
			['Mikroiskola megérkezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megtudtad HP-tól, hogy miért van etika tantárgy.',
		a: 1,
		gT: 3501,
		b: 1,
		e2: 'etika',
		jE: _List_fromArray(
			['kultúra'])
	},
		{
		cG: 'pw21jan',
		gD: 'Lefotóztál egy napfelkeltét',
		a: 1,
		gT: 3500,
		b: 1,
		e2: 'etika',
		jE: _List_fromArray(
			['kultúra'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megnéztél egy filmet közösen más tanárokkal',
		a: 1,
		gT: 3499,
		b: 1,
		e2: 'etika',
		jE: _List_fromArray(
			['kultúra'])
	},
		{
		cG: 'pw21jan',
		gD: 'A csapatoddal van stratégiátok a leggyakoribb kommunikációs helyzetekre.',
		a: 1,
		gT: 3495,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kommunikációs playbook'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismered a mikroiskolád külső kommunikációs csatornáit, és tudod, hogy ezeken keresztül mikor, ki és mit kommunikál.',
		a: 1,
		gT: 3494,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kommunikációs playbook'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismered a belső kommunikációs folyamatokat a mikroiskolád stábján belül.',
		a: 1,
		gT: 3493,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kommunikációs playbook'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy kinek mi a feladata a mikroiskoiskolád kommunikációjában.',
		a: 1,
		gT: 3492,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kommunikációs playbook'])
	},
		{
		cG: 'pw21jan',
		gD: 'A mikroiskolád csapatával kidolgoztál egy saját kommunikációs playbookot.',
		a: 1,
		gT: 3491,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kommunikációs playbook'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismered azt a döntéshozatali folyamatot, amelynek eredményeként a szülők iskolát választanak.',
		a: 1,
		gT: 3490,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['bps üzenet'])
	},
		{
		cG: 'pw21jan',
		gD: 'Mozgósítani, alkalmazni tudod a BPS üzeneteit különböző kommunikációs helyzetekben.',
		a: 1,
		gT: 3489,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['bps üzenet'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismered a BPS legfontosabb üzeneteit.',
		a: 1,
		gT: 3488,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['bps üzenet'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megismered és különböző kommunikációs helyzetekben gyakoroltad a BPS válaszait a leendő szülők által leggyakrabban megfogalmazott kérdésekre.',
		a: 1,
		gT: 3487,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['bps üzenet'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy milyen kommunikációs krízisek vannak, és milyen alapszabályok vonatkoznak ezekre a helyzetekre',
		a: 1,
		gT: 3486,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['kríziskezelés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogyan hatnak ránk a történetek, és hogyan tudod kiváltani ezt a hatást saját történetekkel',
		a: 1,
		gT: 3485,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['történetmesélés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megírtad a saját BPS-sztoridat',
		a: 1,
		gT: 3484,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['történetmesélés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismersz konfliktuskezelő technikákat',
		a: 1,
		gT: 3483,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['konfliktuskezelés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megosztottál egy saját esetet a konfliktuskezelő workshopon',
		a: 1,
		gT: 3482,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['konfliktuskezelés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Elvégeztél egy 90 perces kommunikációs workshopot',
		a: 1,
		gT: 3481,
		b: 1,
		e2: 'kommunikáció',
		jE: _List_fromArray(
			['workshopok'])
	},
		{
		cG: 'pw21jan',
		gD: 'A peer circle csoportodban megosztasz egy saját élményt vagy dilemmát',
		a: 1,
		gT: 3505,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['közös munka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Beszélgetsz legalább három olyan emberrel, akivel eddig nem volt kapcsolatod',
		a: 1,
		gT: 3504,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['közös munka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Részt vettél egy akcióban, amit a hub szervezett, ahová te is tartozol a térkép alapján.',
		a: 1,
		gT: 3503,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['hub akció'])
	},
		{
		cG: 'pw21jan',
		gD: 'Szerveztél egy akciót a hub-nak, ahová te is tartozol a térkép alapján.',
		a: 1,
		gT: 3502,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['hub akció'])
	},
		{
		cG: 'pw21jan',
		gD: 'Az általad felvetett javaslatok, gondolatok is bekerülnek az Open Space beszélgető körök jegyzetei közé',
		a: 1,
		gT: 3461,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['open space'])
	},
		{
		cG: 'pw21jan',
		gD: 'Részt veszel két téma megbeszélésében',
		a: 1,
		gT: 3460,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['open space'])
	},
		{
		cG: 'pw21jan',
		gD: 'Egy általad javasolt téma is bekerül az Open space témái közé',
		a: 1,
		gT: 3459,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['open space'])
	},
		{
		cG: 'pw21jan',
		gD: 'Visszajelzést adsz a munkacsoport egy vagy több tagjának (például: a befektetett munkáról, a megbeszélésen való részvételről, megosztott tapasztalatokról, stb.)',
		a: 1,
		gT: 3458,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Munkacsoport'])
	},
		{
		cG: 'pw21jan',
		gD: 'Visszajelzést adsz a megbeszélésről a munkacsoport-vezetőnek',
		a: 1,
		gT: 3457,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Munkacsoport'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy a munkacsoportodban milyen feladatokat vállaltak a többiek',
		a: 1,
		gT: 3456,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Munkacsoport'])
	},
		{
		cG: 'pw21jan',
		gD: 'Vannak feladataid a munkacsoportban, és a csoportod többi tagja is tudja, hogy mit és milyen határidővel fogsz megcsinálni',
		a: 1,
		gT: 3455,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Munkacsoport'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tagja vagy egy munkacsoportnak.',
		a: 1,
		gT: 3454,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Munkacsoport'])
	},
		{
		cG: 'pw21jan',
		gD: 'Javasoltál az iskolád számára fontos témákat/kérdéseket a délutáni Open Space-re.',
		a: 1,
		gT: 3453,
		b: 1,
		e2: 'közös munka',
		jE: _List_fromArray(
			['Mikroiskola megérkezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Legalább három másik modultervre adtál szöveges visszajelzést',
		a: 1,
		gT: 3480,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megismerted más tanárok értékelő táblázat tervezési gyakorlatát.',
		a: 1,
		gT: 3479,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['visszajelzés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megismertél olyan technikákat, amelyekkel egy felsős vagy középiskolás gyereket segíteni tudsz az önreflexió elsajátításában.',
		a: 1,
		gT: 3478,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['önreflexió'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megismertél olyan tanulásszervezési technikákat, amelyekkel egy alsós gyereket segíteni tudsz az önálló tanulás elsajátításában.',
		a: 1,
		gT: 3477,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['önálló tanulás'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy milyen mérföldkövekből áll egy (pedagógiai) projekt folyamata.',
		a: 1,
		gT: 3476,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy mi a különbség a cross modul és a projekt között.',
		a: 1,
		gT: 3475,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Ismered egy modulterv értékelésének szempontjait.',
		a: 1,
		gT: 3474,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Visszajelzést kaptál a tervetekről a body groupotok tagjaitól.',
		a: 1,
		gT: 3473,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Visszajelzést kaptál a tervetekről a mentorotoktól.',
		a: 1,
		gT: 3472,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Tudod, hogy mik azok az alapkérdések, amelyeket egy tanulási élmény megtervezésekor mindenképp fel kell tenned magadnak.',
		a: 1,
		gT: 3471,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megosztottad egy vagy több tanártársaddal a saját reflexióidat a tanulásszervezési gyakorlatodról és szemléletmódodról',
		a: 1,
		gT: 3470,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Közelebbről megismerted egy vagy több tanártársad tanulásszervezési gyakorlatát, szemléletmódját.',
		a: 1,
		gT: 3469,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'A modultervhez extra tanulási eredményeket fogalmaztál meg.',
		a: 1,
		gT: 3468,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Kiválasztottad a modulhoz kapcsolódó tanulási eredményeket a NAT tanulási eredmények listából.',
		a: 1,
		gT: 3467,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['nat'])
	},
		{
		cG: 'pw21jan',
		gD: 'A tarlmaz legelább egy értékelő táblázatot is.',
		a: 1,
		gT: 3466,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['visszajelzés'])
	},
		{
		cG: 'pw21jan',
		gD: 'A modulterved tartalmaz blokkokat.',
		a: 1,
		gT: 3465,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'A modultervet kreatív és külső szemmel is érthető formában megosztottad a teljes tanárcsapattal.',
		a: 1,
		gT: 3464,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Van egy olyan átgondolt modulterved, amiben összhangban vannak egymással a célok, tanulási eredmények, tevékenységek és értékelési szempontok',
		a: 1,
		gT: 3463,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['tervezés'])
	},
		{
		cG: 'pw21jan',
		gD: 'Csapatban dolgozva megterveztél egy cross tanulási élményt, amit a következő trimeszterben megvalósíthatsz az iskoládban',
		a: 1,
		gT: 3462,
		b: 1,
		e2: 'modultervezés',
		jE: _List_fromArray(
			['csapatmunka'])
	},
		{
		cG: 'pw21jan',
		gD: 'Megtanultál néhány Qigong mozdulatot',
		a: 1,
		gT: 3498,
		b: 1,
		e2: 'mozgás',
		jE: _List_fromArray(
			['Qigong'])
	},
		{
		cG: 'pw21jan',
		gD: 'Szabadban sportoltál egy órát',
		a: 1,
		gT: 3497,
		b: 1,
		e2: 'mozgás',
		jE: _List_fromArray(
			['futás'])
	},
		{
		cG: 'pw21jan',
		gD: 'Jógáztál egy órát',
		a: 1,
		gT: 3496,
		b: 1,
		e2: 'mozgás',
		jE: _List_fromArray(
			['jóga'])
	},
		{
		cG: 'code',
		gD: 'A gyakorlatban alkalmazza az adatok védelmét biztosító lehetőségeket.',
		a: 9,
		gT: 307,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a digitális személyazonosság és az információhitelesség fogalmával.',
		a: 9,
		gT: 306,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van az e-világ -- e-szolgáltatások, e-ügyintézés, e-kereskedelem, e-állampolgárság, it-gazdaság, környezet, kultúra, információvédelem -- biztonsági és jogi kérdéseivel.',
		a: 9,
		gT: 305,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'code',
		gD: 'Az iskolai oktatáshoz kapcsolódó mobileszközökre fejlesztett alkalmazások használata során együttműködik társaival.',
		a: 9,
		gT: 304,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Az applikációkat önállóan telepíti.',
		a: 9,
		gT: 303,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Céljainak megfelelő alkalmazást választ, az alkalmazás funkcióira, kezelőfelületére vonatkozó igényeit megfogalmazza.',
		a: 9,
		gT: 302,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és használja a mobiltechnológiát, kezeli a mobileszközök operációs rendszereit és használ mobilalkalmazásokat.',
		a: 9,
		gT: 301,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Az online kommunikáció során alkalmazza a kialakult viselkedési kultúrát és szokásokat, a szerepelvárásokat.',
		a: 9,
		gT: 300,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a fogyatékkal élők közötti kommunikáció eszközeit és formáit.',
		a: 9,
		gT: 299,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Használja a két- vagy többrésztvevős kommunikációs lehetőségeket és alkalmazásokat.',
		a: 9,
		gT: 298,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Etikus módon használja fel az információforrásokat, tisztában van a hivatkozás szabályaival.',
		a: 9,
		gT: 297,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az információkeresési stratégiákat és technikákat, a találati listát a problémának megfelelően szűri, ellenőrzi annak hitelességét.',
		a: 9,
		gT: 296,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Tapasztalatokat szerez a kezdőértékek változtatásának hatásairól a szimulációs programokban.',
		a: 9,
		gT: 295,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'code',
		gD: 'Hétköznapi, oktatáshoz készült szimulációs programokat használ.',
		a: 9,
		gT: 294,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'code',
		gD: 'Tapasztalatokkal rendelkezik hétköznapi jelenségek számítógépes szimulációjáról.',
		a: 9,
		gT: 293,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'code',
		gD: 'Strukturáltan tárolt nagy adathalmazokat kezel, azokból egyedi és összesített adatokat nyer ki.',
		a: 9,
		gT: 292,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'code',
		gD: 'A feladatmegoldás során az adatbázisba adatokat visz be, módosít és töröl, űrlapokat használ, jelentéseket nyomtat.',
		a: 9,
		gT: 291,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'code',
		gD: 'Az adatbázisban interaktív módon keres, rendez és szűr.',
		a: 9,
		gT: 290,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az adatbázis-kezelés alapfogalmait.',
		a: 9,
		gT: 289,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'code',
		gD: 'Az adatokat diagramon szemlélteti.',
		a: 9,
		gT: 288,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'code',
		gD: 'Nagy adathalmazokat tud kezelni.',
		a: 9,
		gT: 287,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'code',
		gD: 'A problémamegoldás során függvényeket célszerűen használ.',
		a: 9,
		gT: 286,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'code',
		gD: 'Táblázatkezelővel adatelemzést és számításokat végez.',
		a: 9,
		gT: 285,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'code',
		gD: 'Adatokat táblázatba rendez.',
		a: 9,
		gT: 284,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'code',
		gD: 'A feladat megoldásának helyességét teszteli.',
		a: 9,
		gT: 283,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Szekvencia, elágazás és ciklus segítségével algoritmust hoz létre, és azt egy magas szintű formális programozási nyelven kódolja.',
		a: 9,
		gT: 282,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Példákban, feladatok megoldásában használja egy formális programozási nyelv fejlesztői környezetének alapszolgáltatásait.',
		a: 9,
		gT: 281,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Érti egy algoritmus-leíró eszköz alapvető építőelemeit, érti a típusalgoritmusok felhasználásának lehetőségeit.',
		a: 9,
		gT: 280,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az elemi és összetett adattípusok közötti különbségeket.',
		a: 9,
		gT: 279,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a következő elemi adattípusok közötti különbségeket: egész, valós szám, karakter, szöveg, logikai.',
		a: 9,
		gT: 278,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Érti az egyszerű problémák megoldásához szükséges tevékenységek lépéseit és kapcsolatukat.',
		a: 9,
		gT: 277,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a raszter-, a vektorgrafikus ábrák tárolási és szerkesztési módszereivel',
		a: 9,
		gT: 276,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'code',
		gD: 'Digitálisan rögzít képet, hangot és videót, azokat manipulálja.',
		a: 9,
		gT: 275,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'code',
		gD: 'Létrehoz vektorgrafikus ábrákat.',
		a: 9,
		gT: 274,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'code',
		gD: 'Létrehozza az adott probléma megoldásához szükséges rasztergrafikus ábrákat.',
		a: 9,
		gT: 273,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a html formátumú dokumentumok szerkezeti elemeit, érti a css használatának alapelveit; több lapból álló webhelyet készít.',
		a: 9,
		gT: 272,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'code',
		gD: 'Dokumentumokat szerkeszt és helyez el tartalomkezelő rendszerben.',
		a: 9,
		gT: 271,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az információkeresés során gyűjtött multimédiás alapelemeket új dokumentumok készítéséhez.',
		a: 9,
		gT: 270,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'code',
		gD: 'Gyakorlatot szerez a fotó-, hang-, videó-, multimédia-szerkesztő, a bemutató-készítő eszközök használatában.',
		a: 9,
		gT: 269,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'code',
		gD: 'Tapasztalatokkal rendelkezik a formanyomtatványok, a sablonok, az előre definiált stílusok használatáról.',
		a: 9,
		gT: 268,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'code',
		gD: 'Speciális dokumentumokat hoz létre, alakít át és formáz meg.',
		a: 9,
		gT: 267,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'code',
		gD: 'Ismeri egy adott feladat megoldásához szükséges digitális eszközök és szoftverek kiválasztásának szempontjait.',
		a: 9,
		gT: 266,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'code',
		gD: 'Használja az állományok tömörítését és a tömörített állományok kibontását.',
		a: 9,
		gT: 265,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a digitális kártevők elleni védekezés lehetőségeivel.',
		a: 9,
		gT: 264,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'code',
		gD: 'Használja az operációs rendszer segédprogramjait, és elvégzi a munkakörnyezet beállításait.',
		a: 9,
		gT: 263,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'code',
		gD: 'Követi a technológiai változásokat a digitális információforrások használatával.',
		a: 9,
		gT: 262,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'code',
		gD: 'Igénybe veszi az operációs rendszer és a számítógépes hálózat alapszolgáltatásait.',
		a: 9,
		gT: 261,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'code',
		gD: 'Céljainak megfelelően használja a mobileszközök és a számítógépek operációs rendszereit.',
		a: 9,
		gT: 260,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'code',
		gD: 'Önállóan használja az informatikai eszközöket, elkerüli a tipikus felhasználói hibákat, elhárítja az egyszerűbb felhasználói hibákat.',
		a: 9,
		gT: 259,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'code',
		gD: 'Tudatosan alakítja informatikai környezetét, ismeri az ergonomikus informatikai környezet jellemzőit, figyelembe veszi a digitális eszközök egészségkárosító hatásait, óvja maga és környezete egészségét.',
		a: 9,
		gT: 258,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a digitális eszközök és a számítógépek fő egységeit, ezek fejlődésének főbb állomásait, tendenciáit.',
		a: 9,
		gT: 257,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és tudja használni a célszerűen választott informatikai eszközöket és a működtető szoftvereit, ismeri a felhasználási lehetőségeket.',
		a: 9,
		gT: 256,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az e-világ elvárásait, lehetőségeit és veszélyeit.',
		a: 9,
		gT: 255,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Hatékonyan keres információt; az ikt-tudáselemek felhasználásával társaival együttműködve problémákat old meg.',
		a: 9,
		gT: 254,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Megismeri az algoritmikus probléma megoldásához szükséges módszereket és eszközöket, megoldásukhoz egy magas szintű formális programozási nyelv fejlesztői környezetét önállóan használja.',
		a: 9,
		gT: 253,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Megismeri az adatkezelés alapfogalmait, képes a nagyobb adatmennyiség tárolását, hatékony feldolgozását biztosító eszközök és módszerek alapszintű használatára, érti a működésüket.',
		a: 9,
		gT: 252,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Gyakorlatot szerez dokumentumok létrehozását segítő eszközök használatában.',
		a: 9,
		gT: 251,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az informatikai eszközök és a működtető szoftvereik célszerű választásának alapelveit, használja a digitális hálózatok alapszolgáltatásait, az online kommunikáció eszközeit, tisztában van az ezzel járó veszélyekkel, ezzel összefüggésben ismeri a segítségnyújtási, segítségkérési lehetőségeket.',
		a: 9,
		gT: 250,
		b: 9,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az életkorának és érdeklődésének megfelelő digitális műfajok főbb jellemzőit.',
		a: 9,
		gT: 687,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is megfelelő nyelvi eszközökkel alkot szöveget szóban és írásban.',
		a: 9,
		gT: 686,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat a természeteshez közelítő célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 685,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 684,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkalmazza az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 683,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is megérti az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 682,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkot szöveget szóban és írásban.',
		a: 9,
		gT: 681,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Megérti a legfőbb nyelvi dialektusok egyes elemeit is tartalmazó szóbeli közléseket.',
		a: 9,
		gT: 680,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a nyelvi változatokról megszerzett ismereteit informális kommunikációjában.',
		a: 9,
		gT: 679,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'code',
		gD: 'Megfogalmaz főbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 678,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a legfőbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 677,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'code',
		gD: 'Interkulturális ismeretei segítségével társasági szempontból is megfelelő kommunikációt folytat írásban és szóban.',
		a: 9,
		gT: 676,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó tanult nyelvi elemeket magabiztosan használja.',
		a: 9,
		gT: 675,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'Kikövetkezteti a célnyelvi kultúrákhoz kapcsolódó egyszerű, ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 674,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'Környezetének kulturális értékeit célnyelven közvetíti.',
		a: 9,
		gT: 673,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Interkulturális tudatosságára építve felismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket, és a magyar értékek átadására képessé válik.',
		a: 9,
		gT: 672,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket.',
		a: 9,
		gT: 671,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Átadja célnyelven a magyar értékeket.',
		a: 9,
		gT: 670,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és keresi a főbb hasonlóságokat és különbségeket saját anyanyelvi és a célnyelvi közösség szokásai, értékei, attitűdjei és meggyőződései között.',
		a: 9,
		gT: 669,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Tájékozott, és alkalmazni is tudja a célnyelvi országokra jellemző alapvető érintkezési és udvariassági szokásokat.',
		a: 9,
		gT: 668,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Tájékozott a célnyelvi országok jellemzőiben és kulturális sajátosságaiban.',
		a: 9,
		gT: 667,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a célnyelvi országok történelmének és jelenének legfontosabb vonásait,',
		a: 9,
		gT: 666,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a célnyelvi kultúráról megszerzett ismereteit informális kommunikációjában,',
		a: 9,
		gT: 665,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközöket és felületeket is használ a célnyelven ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 664,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközöket és felületeket is magabiztosan használ nyelvtudása fejlesztésére.',
		a: 9,
		gT: 663,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Törekszik releváns digitális tartalmak használatára beszédkészségének, szókincsének és kiejtésének továbbfejlesztése céljából.',
		a: 9,
		gT: 662,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Nyelvi produkciójában és recepciójában önállóságot mutat, és egyre kevesebb korlát akadályozza.',
		a: 9,
		gT: 661,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Beszéd- és írásprodukcióját tudatosan megtervezi, hiányosságait igyekszik kompenzálni.',
		a: 9,
		gT: 660,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 659,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 658,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Nyelvtanulási céljai érdekében él a valós nyelvhasználati lehetőségekkel.',
		a: 9,
		gT: 657,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Hiányosságait, hibáit felismeri, azokat egyre hatékonyabban kompenzálja, javítja a tanult stratégiák felhasználásával.',
		a: 9,
		gT: 656,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 655,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Egyre tudatosabban használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 654,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Használ önértékelési módokat nyelvtudása felmérésére.',
		a: 9,
		gT: 653,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Nyelvi haladását fel tudja mérni.',
		a: 9,
		gT: 652,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Az első idegen nyelvből sikeres érettségit tesz legalább középszinten.',
		a: 9,
		gT: 651,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Céljai eléréséhez önszabályozóan is dolgozik.',
		a: 9,
		gT: 650,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Hatékonyan alkalmazza a tanult nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 649,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Használja a nyelvtanulási és nyelvhasználati stratégiákat nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 648,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Beazonosít nyelvtanulási célokat és ismeri az ezekhez tartozó nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 647,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Céljai eléréséhez társaival párban és csoportban is együttműködik.',
		a: 9,
		gT: 646,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket, módokat.',
		a: 9,
		gT: 645,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Nyelvtanulási céljai érdekében tudatosabban foglalkozik a célnyelvvel.',
		a: 9,
		gT: 644,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Megfogalmaz hosszú távú nyelvtanulási célokat saját maga számára.',
		a: 9,
		gT: 643,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 642,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Hibáiból levont következtetéseire többnyire épít nyelvtudása fejlesztése érdekében.',
		a: 9,
		gT: 641,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Hibáit az esetek többségében önállóan is képes javítani.',
		a: 9,
		gT: 640,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Használ ismeretterjesztő anyagokat nyelvtudása fejlesztésére.',
		a: 9,
		gT: 639,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Használ célnyelvi tartalmakat ismeretszerzésre.',
		a: 9,
		gT: 638,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Használ célnyelvi elemeket más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 637,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Felhasználja a célnyelvű, legfőbb hazai és nemzetközi híreket ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 636,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 635,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Nyelvtanulási céljai érdekében alkalmazza a tanórán kívüli nyelvtanulási lehetőségeket.',
		a: 9,
		gT: 634,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Megértést nehezítő hibáit önállóan javítani tudja.',
		a: 9,
		gT: 633,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 632,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Szükség esetén eltér az előre elgondoltaktól, és mondandóját a beszédpartnerekhez, hallgatósághoz igazítja.',
		a: 9,
		gT: 631,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Szociokulturális ismeretei (például célnyelvi társadalmi szokások, testbeszéd) már lehetővé teszik azt, hogy társasági szempontból is megfelelő kommunikációt folytasson.',
		a: 9,
		gT: 630,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi funkciókat és nyelvi eszköztárát életkorának megfelelő élethelyzetekben megfelelően alkalmazza.',
		a: 9,
		gT: 629,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Szóbeli és írásbeli közlései során változatos nyelvi struktúrákat használ.',
		a: 9,
		gT: 628,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemeket adaptálni tudja kevésbé begyakorolt helyzetekhez is.',
		a: 9,
		gT: 627,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Mondanivalóját kifejti kevésbé ismerős helyzetekben is nyelvi eszközök széles körének használatával.',
		a: 9,
		gT: 626,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Nem értés esetén képes a tartalom tisztázására.',
		a: 9,
		gT: 625,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'A társalgás vagy eszmecsere menetének fenntartásához alkalmazza a rendelkezésére álló nyelvi és stratégiai eszközöket.',
		a: 9,
		gT: 624,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Félreértéshez vezető hibáit kijavítja, ha beszédpartnere jelzi a problémát; a kommunikáció megszakadása esetén más stratégiát alkalmazva újrakezdi a mondandóját.',
		a: 9,
		gT: 623,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Ismert témákban a szövegösszefüggés alapján kikövetkezteti az ismeretlen szavak jelentését, megérti az ismeretlen szavakat is tartalmazó mondat jelentését.',
		a: 9,
		gT: 622,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Körülírással közvetíti a jelentéstartalmat, ha a megfelelő szót nem ismeri.',
		a: 9,
		gT: 621,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Használ kiemelést, hangsúlyozást, helyesbítést.',
		a: 9,
		gT: 620,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Képes rendszerezni kommunikációját: jelzi szándékát, kezdeményez, összefoglal és lezár.',
		a: 9,
		gT: 619,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Több különálló elemet összekapcsol összefüggő lineáris szempontsorrá.',
		a: 9,
		gT: 618,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'A kohéziós eszközök szélesebb körét alkalmazza szóbeli vagy írásbeli megnyilatkozásainak érthetőbb, koherensebb szöveggé szervezéséhez.',
		a: 9,
		gT: 617,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Összekapcsolja a mondatokat megfelelő kötőszavakkal, így követhető leírást ad, vagy nem kronológiai sorrendben lévő eseményeket is elbeszél.',
		a: 9,
		gT: 616,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez emlékezést és nem emlékezést.',
		a: 9,
		gT: 615,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ok-okozat viszony vagy cél meghatározását.',
		a: 9,
		gT: 614,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez segítségkérést, ajánlást és ezekre történő reagálást.',
		a: 9,
		gT: 613,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ítéletet, kritikát, tanácsadást.',
		a: 9,
		gT: 612,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez kötelezettséget, szándékot, kívánságot, engedélykérést, feltételezést.',
		a: 9,
		gT: 611,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez érdeklődést és érdektelenséget, szemrehányást, reklamálást.',
		a: 9,
		gT: 610,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével további alapvető érzéseket fejez ki (pl. aggódást, félelmet, kételyt).',
		a: 9,
		gT: 609,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'code',
		gD: 'Írásban közvetít célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 608,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Írott szöveget igénylő projektmunkát készít olvasóközönségnek.',
		a: 9,
		gT: 607,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Környezeti témákban a kommunikációs helyzetek széles körében hatékonyan ad át és cserél információt.',
		a: 9,
		gT: 606,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Összefoglal és lejegyzetel, írásban közvetít rövid olvasott vagy hallott szövegeket.',
		a: 9,
		gT: 605,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Ismer más tantárgyi tartalmakat, részinformációkat célnyelven,',
		a: 9,
		gT: 604,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Használ célnyelvi tartalmakat tudásmegosztásra.',
		a: 9,
		gT: 603,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Egyénileg vagy kooperáció során létrehozott projektmunkával kapcsolatos kiselőadást tart önállóan, összefüggő és folyékony előadásmóddal, digitális eszközök segítségével, felkészülést követően.',
		a: 9,
		gT: 602,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Összetett információkat ad át és cserél.',
		a: 9,
		gT: 601,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Írásban és szóban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 600,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Írásban átad nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciók során.',
		a: 9,
		gT: 599,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Véleményét írásban változatos nyelvi eszközökkel megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 598,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Véleményét írásban, tanult nyelvi eszközökkel megfogalmazza és arról írásban interakciót folytat.',
		a: 9,
		gT: 597,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Informális és életkorának megfelelő formális írásos üzeneteket ír, digitális felületen is.',
		a: 9,
		gT: 596,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Szóban és írásban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 595,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre jellemzően célnyelvi eszközökkel is reagál tanórai szituációkban.',
		a: 9,
		gT: 594,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Egyre szélesebb körű témákban, nyelvi kommunikációt igénylő helyzetekben reagál megfelelő módon, felhasználva általános és nyelvi háttértudását, ismereteit, alkalmazkodva a társadalmi normákhoz.',
		a: 9,
		gT: 593,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Társaival a kooperatív munkaformákban és a projektfeladatok megoldása során is törekszik a célnyelvi kommunikációra.',
		a: 9,
		gT: 592,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Aktívan, kezdeményezően és magabiztosan vesz részt a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 591,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A mindennapi élet különböző területein, a kommunikációs helyzetek széles körében tesz fel releváns kérdéseket információszerzés céljából, és válaszol megfelelő módon a hozzá intézett célnyelvi kérdésekre.',
		a: 9,
		gT: 590,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Érzelmeit, véleményét változatos nyelvi eszközökkel szóban megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 589,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Előkészület nélkül részt tud venni személyes jellegű, vagy érdeklődési körének megfelelő ismert témáról folytatott társalgásban,',
		a: 9,
		gT: 588,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A társalgást hatékonyan és udvariasan fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt, akár ismeretlen beszélgetőtárs esetében is.',
		a: 9,
		gT: 587,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Társalgást kezdeményez, a megértést fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt az egyes tématartományokon belül, akár anyanyelvű beszélgetőtárs esetében is.',
		a: 9,
		gT: 586,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A társalgásba aktívan, kezdeményezően és egyre magabiztosabban bekapcsolódik az érdeklődési körébe tartozó témák esetén vagy az ajánlott tématartományokon belül.',
		a: 9,
		gT: 585,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Szóban ad át nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 584,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Részt vesz a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 583,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Egyre változatosabb, hosszabb, összetettebb és elvontabb szövegeket, tartalmakat értelmez és használ.',
		a: 9,
		gT: 582,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Keresi az érdeklődésének megfelelő, célnyelvi, autentikus szövegeket szórakozásra és ismeretszerzésre tanórán kívül is.',
		a: 9,
		gT: 581,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az írott szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 580,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Kiszűr konkrét információkat nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 579,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti és értelmezi az írott szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 578,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó írott szöveg tartalmát.',
		a: 9,
		gT: 577,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'A szövegkörnyezet alapján kikövetkezteti a szövegben előforduló ismeretlen szavak jelentését.',
		a: 9,
		gT: 576,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi a számára ismerős, elvontabb tartalmú szövegekben megjelenő ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 575,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti és értelmezi az összefüggéseket és a részleteket az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 574,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti és értelmezi a lényeget az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 573,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Elolvas és értelmez nyelvi szintjének megfelelő irodalmi szövegeket.',
		a: 9,
		gT: 572,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megért szokványos tempóban folyó autentikus szórakoztató és ismeretterjesztő tartalmakat, változatos csatornákon.',
		a: 9,
		gT: 571,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti és értelmezi a legtöbb televíziós hírműsort.',
		a: 9,
		gT: 570,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét akár anyanyelvi beszélők köznyelvi kommunikációjában a számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 569,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 568,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 567,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a hangzó szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 566,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti az elvontabb tartalmú hangzószövegek lényegét, valamint a beszélők véleményét is.',
		a: 9,
		gT: 565,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a hangzó szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 564,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó hangzó szöveg lényegi tartalmát.',
		a: 9,
		gT: 563,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti és értelmezi az összetettebb, az ajánlott témakörökhöz kapcsolódó összefüggő szövegeket, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 562,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti, értelmezi és összefoglalja az összetettebb, a tématartományhoz kapcsolódó összefüggő hangzó szöveget, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 561,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 560,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Kikövetkezteti a szövegben megjelenő elvontabb nyelvi elemek jelentését az ajánlott témakörökhöz kapcsolódó témákban.',
		a: 9,
		gT: 559,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi hírek, események lényegét.',
		a: 9,
		gT: 558,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi a szintjének megfelelő célnyelvi, komplexebb tanári magyarázatokat a nyelvórákon.',
		a: 9,
		gT: 557,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'A megfelelő szövegtípusok jellegzetességeit követi.',
		a: 9,
		gT: 556,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Beszámol akár az érdeklődési körén túlmutató közügyekkel, szórakozással kapcsolatos eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 555,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló, akár az érdeklődési körén túlmutató vagy elképzelt személyes eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 554,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'A szövegek létrehozásához nyomtatott vagy digitális segédeszközt, szótárt használ.',
		a: 9,
		gT: 553,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Összefüggő szövegeket ír önállóan, akár elvontabb témákban.',
		a: 9,
		gT: 552,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformában.',
		a: 9,
		gT: 551,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Megold változatos írásbeli, feladatokat szövegszinten.',
		a: 9,
		gT: 550,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Használ szövegkohéziós és figyelemvezető eszközöket.',
		a: 9,
		gT: 549,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a formális és informális regiszterhez köthető sajátosságokat.',
		a: 9,
		gT: 548,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Információt vagy véleményt közlő és kérő, összefüggő feljegyzéseket, üzeneteket ír.',
		a: 9,
		gT: 547,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Leír összetettebb cselekvéssort, történetet, személyes élményeket, elvontabb témákban.',
		a: 9,
		gT: 546,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Írásban röviden indokolja érzéseit, gondolatait, véleményét már elvontabb témákban.',
		a: 9,
		gT: 545,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a célnyelvi normához illeszkedő, természeteshez közelítő kiejtést, beszédtempót és intonációt.',
		a: 9,
		gT: 544,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Összefüggően, világosan és nagyrészt folyékonyan beszél az ajánlott tématartományhoz tartozó és az idevágó érettségi témákban, akár elvontabb tartalmakra is kitérve.',
		a: 9,
		gT: 543,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Beszámol akár az érdeklődési körén túlmutató környezeti eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 542,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Kreatív, változatos műfajú szövegeket alkot szóban, kooperatív munkaformákban.',
		a: 9,
		gT: 541,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Összefüggő, folyékony előadásmódú szóbeli prezentációt tart önállóan, felkészülést követően, az érettségi témakörök közül szabadon választott témában, ikt-eszközökkel támogatva mondanivalóját.',
		a: 9,
		gT: 540,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Közép- és emelt szintű nyelvi érettségi szóbeli feladatokat old meg.',
		a: 9,
		gT: 539,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Összefoglalja ismert témában nyomtatott vagy digitális alapú ifjúsági tartalmak lényegét röviden és érthetően.',
		a: 9,
		gT: 538,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Ajánlott tématartományhoz kapcsolódó képi hatás kapcsán saját gondolatait, véleményét és érzéseit is kifejti az ismert nyelvi eszközökkel.',
		a: 9,
		gT: 537,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló vagy elképzelt eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő rövid jellemzésével.',
		a: 9,
		gT: 536,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Összefüggően, érthetően és nagyrészt folyékonyan beszél az ajánlott tématartományokhoz tartozó és az érettségi témákban a tanult nyelvi eszközökkel, felkészülést követően.',
		a: 9,
		gT: 535,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Visszaad tankönyvi vagy más tanult szöveget, elbeszélést, nagyrészt folyamatos és érthető történetmeséléssel, a cselekményt logikusan összefűzve.',
		a: 9,
		gT: 534,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'code',
		gD: 'Első idegen nyelvéből sikeresen érettségit tesz a céljainak megfelelő szinten.',
		a: 9,
		gT: 533,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Beazonosítja nyelvtanulási céljait és egyéni különbségeinek tudatában, ezeknek megfelelően fejleszti nyelvtudását.',
		a: 9,
		gT: 532,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 531,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 530,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Használ hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 529,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Felkészül az aktív nyelvtanulás eszközeivel az egész életen át történő tanulásra.',
		a: 9,
		gT: 528,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Nyelvtudását képes fejleszteni tanórán kívüli eszközökkel, lehetőségekkel és helyzetekben is, valamint a tanultakat és gimnáziumban a második idegen nyelv tanulásában is alkalmazza.',
		a: 9,
		gT: 527,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a nyelvi funkciókat és megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 526,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat és tartalmakat közvetít idegen nyelven.',
		a: 9,
		gT: 525,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Értelmez nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket kevésbé ismert témákban és szövegtípusokban is.',
		a: 9,
		gT: 524,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szóban és írásban létrehoz szövegeket különböző szövegtípusokban.',
		a: 9,
		gT: 523,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szóban és írásban is megold változatos kihívásokat igénylő, többnyire valós kommunikációs helyzeteket leképező feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 522,
		b: 13,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a genetikai információ átadásának alapvető szabályait.',
		a: 9,
		gT: 1206,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hálózatok és a hálózatkutatás szerepét modern világunkban, az életközösségek, a sejtszintű gondolkodás és az információs technológiák területén.',
		a: 9,
		gT: 1205,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az emberi szexualitás kulturális, társadalmi és biológiai alapjait. Önálló véleménye van a nemi szerepek fontosságáról, érti a nemi identitás komplex jellegét.',
		a: 9,
		gT: 1204,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az emberi szervezet egészségét alapvetően befolyásoló tényezőket, a stressz, az öröklött hajlamok és genetikai tulajdonságok, valamint a környezeti hatások szerepét',
		a: 9,
		gT: 1203,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a tanulás és az emberi kommunikáció biológiai alapjait',
		a: 9,
		gT: 1202,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van az Univerzum létrejöttének ma ismert elméletével, valamint a Naprendszer kialakulásának folyamatával',
		a: 9,
		gT: 1201,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az emberi agy alapvető működési szabályait és az azt befolyásoló tényezőket',
		a: 9,
		gT: 1200,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az emberi táplálkozás során hasznos ételeket, megkülönbözteti a gyógyító és a káros anyagokat, önállóan tud egészséges ételt készíteni',
		a: 9,
		gT: 1199,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a föld légkörét befolyásoló globális folyamatokat (tengerek és szelek áramlása, klímaváltozás, üvegházhatású gázok)',
		a: 9,
		gT: 1198,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a talaj természetét és annak megművelésének különböző formáit',
		a: 9,
		gT: 1197,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a különböző kultúrák eltérő gazdasági termelési szokásait (növénytermesztés, állattartás)',
		a: 9,
		gT: 1196,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a vadon élő állatközösségeket fenyegető veszélyeket és azt a kihívást, amit ez az emberekre gyakorol',
		a: 9,
		gT: 1195,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a növények tápanyagigényét és fejlődésük alapjait',
		a: 9,
		gT: 1194,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Tudja, hogy milyen vízkészletekkel rendelkezik a Föld és azok felhasználásának milyen hatása van a környezeti, ipari, turisztikai és szállítmányozási folyamatokra',
		a: 9,
		gT: 1193,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a levegő és a víz fizikai és kémiai jellemzőit, felismeri ezek élettani hatásait',
		a: 9,
		gT: 1192,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Használja a regionalitás fogalmát és érti annak szerepét a gazdasági folyamatok alakulásában',
		a: 9,
		gT: 1191,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a városi és falusi életmód és életterek közötti különbségeket, azok környezetre gyakorolt hatását',
		a: 9,
		gT: 1190,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Megkülönbözteti egymástól a természetes és mesterséges anyagokat és felismeri, hogy miként állapítható egy anyag összetétele',
		a: 9,
		gT: 1189,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az energia fogalmát és az egyéni és társadalmi energiafelhasználás különböző lehetőségeit',
		a: 9,
		gT: 1188,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hulladékgazdálkodás aktuális kihívásait',
		a: 9,
		gT: 1187,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a föld népességgének aktuális kihívásait beleértve azok társadalmi és egészségügyi kockázatait (betegség-megelőzés, járványok, élelmezés)',
		a: 9,
		gT: 1186,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a világ megismerésének egyik alapja a szerveződési szintek és típusok megértése (periódusos rendszer, sjetszintű szerveződések, állat és növényvilág rendszertana, a világegyetem szervező elvei)',
		a: 9,
		gT: 1185,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a tárgyak mozgása előrejelezhető (erők, égitestek mozgása, molekuláris mozgások, hangok, fények mozgása)',
		a: 9,
		gT: 1184,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy a természet ismert rendszerei előrejelezhető módon változnak (evolúció, klímaváltozás, földtörténeti korok, Föld felszíni változása, tektonikus mozgások, ember környezeti hatásai stb.)',
		a: 9,
		gT: 1183,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és kísérletei során alkalmazza azt a tudást, hogy az anyag atomi természete határozza meg a fizikai és kémiai tulajdonságokat és azok kölcsönhatásából eredő módosulását. (Példák kísérletekre: kémiai reakciók, molekuláris biológiai, anyagok körforgása a különböző ökoszisztémákban)',
		a: 9,
		gT: 1182,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az energia felhasználásának és átalakulásának elméleti és gyakorlati lehetőségeit (energiaáramláson alapuló ökoszisztémák, a föld saját energiaforrásai stb.)',
		a: 9,
		gT: 1181,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a saját és társai által végzett tudományos kísérletek etikai és társadalmi vonatkozásait',
		a: 9,
		gT: 1180,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Önállóan és kiscsoportban biztonságosan végez természettduományos kísérleteket',
		a: 9,
		gT: 1179,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Tudományos kutatási eredményeket érthetően mutat be digitális eszközök segítségével',
		a: 9,
		gT: 1178,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Elméleti és gyakorlati eszközöket választ és alkalmaz egy adott tudományos probléma ismertetéséhez',
		a: 9,
		gT: 1177,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Hiteles források felhasználásával egy tudományos probléma kritikus elemzését adja a megszerzett információk alapján',
		a: 9,
		gT: 1176,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Érti a tudomány szerepét és szükségszerűségét a társadalmi folyamatok alakításában',
		a: 9,
		gT: 1175,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Tudományos kutatások során elvégzi a megszerzett adatok feldolgozását és értelmezését',
		a: 9,
		gT: 1174,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Önálló kutatása összeállításakor tudományos modelleket használ',
		a: 9,
		gT: 1173,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Önálló tudományos kutatást tervez meg és végez el',
		a: 9,
		gT: 1172,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a tudományos kutatás alapszabályait és azokat alkalmazza',
		a: 9,
		gT: 1171,
		b: 9,
		e2: 'Komplex természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'komplex természettudomány'])
	},
		{
		cG: 'code',
		gD: 'A kommunikációs helyzetnek és a célnak megfelelően tudatosan alkalmazza a beszélt és írott nyelvet, reflektál saját és társai nyelvhasználatára.',
		a: 9,
		gT: 1697,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'A feladatokat komplex szempontoknak megfelelően oldja meg, azokat kiegészíti saját szempontjaival.',
		a: 9,
		gT: 1696,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, a források tartalmát mérlegelő módon gondolja végig.',
		a: 9,
		gT: 1695,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'Vitahelyzetben figyelembe veszi mások álláspontját, a lehetséges ellenérveket is.',
		a: 9,
		gT: 1694,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'Megnyilvánulásaiban, a vitákban alkalmazza az érvelés alapvető szabályait.',
		a: 9,
		gT: 1693,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'A környező világ jelenségeiről, szövegekről, műalkotásokról véleményt alkot, és azt érvekkel támasztja alá.',
		a: 9,
		gT: 1692,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'code',
		gD: 'Részt vesz irodalmi mű kreatív feldolgozásában, bemutatásában (pl. animáció, dramaturgia, átirat).',
		a: 9,
		gT: 1691,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Önismeretét irodalmi művek révén fejleszti.',
		a: 9,
		gT: 1690,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Választott olvasmányaira is vonatkoztatja a tanórán megismert kontextusteremtő eljárások tanulságait.',
		a: 9,
		gT: 1689,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Társai érdeklődését figyelembe véve ajánl olvasmányokat.',
		a: 9,
		gT: 1688,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Olvasmányai kiválasztásakor figyelembe veszi az alkotások kulturális regiszterét.',
		a: 9,
		gT: 1687,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Tudatosan keresi a történeti és esztétikai értékekkel rendelkező olvasmányokat, műalkotásokat.',
		a: 9,
		gT: 1686,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'A kötelező olvasmányokat elolvassa, és saját örömére is olvas.',
		a: 9,
		gT: 1685,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'code',
		gD: 'Megadott vagy önállóan kiválasztott szempontok alapján az irodalmi művekről elemző esszét ír.',
		a: 9,
		gT: 1684,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Különböző, a munka világában is használt hivatalos szövegeket alkot hagyományos és digitális felületeken (pl. kérvény, beadvány, nyilatkozat, egyszerű szerződés, meghatalmazás, önéletrajz, motivációs levél).',
		a: 9,
		gT: 1683,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Ismeri, érti és etikusan alkalmazza a hagyományos, digitális és multimédiás szemléltetést.',
		a: 9,
		gT: 1682,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Érvelő esszét alkot megadott szempontok vagy szövegrészletek alapján.',
		a: 9,
		gT: 1681,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Az írásbeli szövegalkotáskor alkalmazza a tanult szerkesztési, stilisztikai ismereteket és a helyesírási szabályokat.',
		a: 9,
		gT: 1680,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'A tanult szövegtípusoknak megfelelő tartalommal és szerkezettel önállóan alkot különféle írásbeli szövegeket.',
		a: 9,
		gT: 1679,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Írásbeli és szóbeli nyelvhasználata, stílusa az adott kommunikációs helyzetnek megfelelő. írásképe tagolt, beszéde érthető, artikulált.',
		a: 9,
		gT: 1678,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és megnevezi a szóbeli előadásmód hatáskeltő eszközeit, hatékonyan alkalmazza azokat.',
		a: 9,
		gT: 1677,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Rendelkezik korának megfelelő retorikai ismeretekkel.',
		a: 9,
		gT: 1676,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Képes eltérő műfajú szóbeli szövegek alkotására: felelet, kiselőadás, hozzászólás, felszólalás.',
		a: 9,
		gT: 1675,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Megadott szempontrendszer alapján szóbeli feleletet készít.',
		a: 9,
		gT: 1674,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a tanult tantárgyak, tudományágak szakszókincsét, azokat a beszédhelyzetnek megfelelően használja.',
		a: 9,
		gT: 1673,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan értelmezi az ismeretlen kifejezéseket a szövegkörnyezet vagy digitális, illetve nyomtatott segédeszközök használatával.',
		a: 9,
		gT: 1672,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik arra, hogy a különböző típusú, stílusú és regiszterű szövegekben megismert, számára új kifejezéseket beépítse szókincsébe, azokat adekvát módon használja.',
		a: 9,
		gT: 1671,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Megtalálja a közös és eltérő jellemzőket a hagyományos és a digitális technikával előállított, tárolt szövegek között, és véleményt formál azok sajátosságairól.',
		a: 9,
		gT: 1670,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és értelmezi a szövegben a kétértelműséget és a félrevezető információt, valamint elemzi és értelmezi a szerző szándékát.',
		a: 9,
		gT: 1669,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, ezek eredményeit szintetizálja.',
		a: 9,
		gT: 1668,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Folyamatos és nem folyamatos, hagyományos és digitális szövegeket olvas és értelmez maga által választott releváns szempontok alapján.',
		a: 9,
		gT: 1667,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és értelmezésében figyelembe veszi a hallott és az írott szövegek közötti funkcionális és stiláris különbségeket.',
		a: 9,
		gT: 1666,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Összefüggő szóbeli szöveg (előadás, megbeszélés, vita) alapján önállóan vázlatot készít.',
		a: 9,
		gT: 1665,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Különböző típusú és célú szövegeket hallás alapján értelmez és megfelelő stratégia alkalmazásával értékel és összehasonlít.',
		a: 9,
		gT: 1664,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Egymással összefüggésben értelmezi a szöveg tartalmi elemeit és a hozzá kapcsolódó illusztrációkat, ábrákat.',
		a: 9,
		gT: 1663,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Azonosítja a szöveg szerkezeti elemeit, és figyelembe veszi azok funkcióit a szöveg értelmezésekor.',
		a: 9,
		gT: 1662,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Hosszabb terjedelmű szöveg alapján többszintű vázlatot vagy részletes gondolattérképet készít.',
		a: 9,
		gT: 1661,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'A megismert szöveg tartalmi és nyelvi minőségéről érvekkel alátámasztott véleményt alkot.',
		a: 9,
		gT: 1660,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'A különböző olvasási típusokat és a szövegfeldolgozási stratégiákat a szöveg típusának és az olvasás céljának megfelelően választja ki és kapcsolja össze.',
		a: 9,
		gT: 1659,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Különböző megjelenésű, típusú, műfajú, korú és összetettségű szövegeket olvas, értelmez.',
		a: 9,
		gT: 1658,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'code',
		gD: 'Tanulmányai során ismereteket szerez a kulturális intézmények (múzeum, könyvtár, színház) és a nyomtatott, illetve digitális formában megjelenő kulturális folyóiratok, adatbázisok működéséről.',
		a: 9,
		gT: 1657,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tájékozottságot szerez régiója magyar irodalmáról.',
		a: 9,
		gT: 1656,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A mű értelmezésében összekapcsolja a szöveg poétikai tulajdonságait a mű nemzeti hagyományban betöltött szerepével.',
		a: 9,
		gT: 1655,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Szükség esetén a mű értelmezéséhez felhasználja történeti ismereteit.',
		a: 9,
		gT: 1654,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A tantárgyhoz kapcsolódó fogalmakkal bemutatja a lírai mű hangulati és hangnemi sajátosságait, hivatkozik a mű verstani felépítésére.',
		a: 9,
		gT: 1653,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A líra mű értelmezésében alkalmazza az általa tanult líraelméleti és líratörténeti fogalmakat (pl. lírai én, beszédhelyzetek, beszédmódok, ars poetica, szereplíra).',
		a: 9,
		gT: 1652,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A drámai mű értelmezésében alkalmazza az általa tanult drámaelméleti és drámatörténeti fogalmakat (pl. analitikus és abszurd dráma, epikus színház, elidegenedés).',
		a: 9,
		gT: 1651,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Epikai művekben értelmezi a különböző elbeszélésmódok szerepét (tudatábrázolás, egyenes és függő beszéd, mindentudó és korlátozott elbeszélő stb.).',
		a: 9,
		gT: 1650,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Epikai és drámai művekben rendszerbe foglalja a szereplők viszonyait, valamint összekapcsolja azok motivációját és cselekedeteit.',
		a: 9,
		gT: 1649,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Epikai és drámai művekben önállóan értelmezi a cselekményszálak, a szerkezet, az időszerkezet (lineáris, nem lineáris), a helyszínek és a jellemek összefüggéseit.',
		a: 9,
		gT: 1648,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összehasonlít egy adott irodalmi művet annak adaptációival (film, festmény, zenemű, animáció, stb.), összehasonlításkor figyelembe veszi az adott művészeti ágak jellemző tulajdonságait.',
		a: 9,
		gT: 1647,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összekapcsol irodalmi műveket különböző szempontok alapján (motívumok, történelmi, erkölcsi kérdésfelvetések, művek és parafrázisaik).',
		a: 9,
		gT: 1646,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összekapcsolja az irodalmi művek szövegének lehetséges értelmezéseit azok társadalmi-történelmi szerepével, jelentőségével.',
		a: 9,
		gT: 1645,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Az irodalmi mű értelmezése során figyelembe veszi a mű keletkezéstörténeti hátterét, a műhöz kapcsolható filozófiai, eszmetörténeti szempontokat is.',
		a: 9,
		gT: 1644,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összekapcsolja az irodalmi művek szerkezeti felépítését, nyelvi sajátosságait azok tartalmával és értékszerkezetével.',
		a: 9,
		gT: 1643,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Értelmezésében felhasználja irodalmi és művészeti, történelmi, művelődéstörténeti ismereteit.',
		a: 9,
		gT: 1642,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Megérti, elemzi az irodalmi mű jelentésszerkezetének szintjeit.',
		a: 9,
		gT: 1641,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és elkülöníti a műnemeket, illetve a műnemekhez tartozó műfajokat, megnevezi azok poétikai és retorikai jellemzőit.',
		a: 9,
		gT: 1640,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Elolvassa a kötelező olvasmányokat, és saját örömére is olvas.',
		a: 9,
		gT: 1639,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Etikusan és kritikusan használja a hagyományos, papír alapú, illetve a világhálón található és egyéb digitális adatbázisokat.',
		a: 9,
		gT: 1638,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tud helyesen írni, szükség esetén nyomtatott és digitális helyesírási segédleteket használ.',
		a: 9,
		gT: 1637,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar nyelv helyesírási, nyelvhelyességi szabályait.',
		a: 9,
		gT: 1636,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Érti, hogy nyelvünk a történelemben folyamatosan változik, ismeri a magyar nyelvtörténet nagy korszakait, kiemelkedő jelentőségű nyelvemlékeit.',
		a: 9,
		gT: 1635,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar nyelv eredetének hipotéziseit, és azok tudományosan megalapozott bizonyítékait.',
		a: 9,
		gT: 1634,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és érti a nyelvrokonság fogalmát, annak kritériumait.',
		a: 9,
		gT: 1633,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A retorikai ismereteit a gyakorlatban is alkalmazza.',
		a: 9,
		gT: 1632,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az általa tanult nyelvi, nyelvtani, helyesírási, nyelvhelyességi ismereteket.',
		a: 9,
		gT: 1631,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a nyelvhasználatban előforduló különféle nyelvváltozatokat (nyelvjárások, csoportnyelvek, rétegnyelvek), összehasonlítja azok főbb jellemzőit.',
		a: 9,
		gT: 1630,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Szövegelemzéskor felismeri az alakzatokat és a szóképeket, értelmezi azok hatását, szerepét, megnevezi típusaikat.',
		a: 9,
		gT: 1629,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a stílus fogalmát, a stíluselemeket, a stílushatást, a stíluskorszakokat, stílusrétegeket, ismereteit a szöveg befogadása és alkotása során alkalmazza.',
		a: 9,
		gT: 1628,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és alkalmazza a szövegösszetartó grammatikai és jelentésbeli elemeket, szövegépítése arányos és koherens.',
		a: 9,
		gT: 1627,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a szöveg fogalmát, jellemzőit, szerkezeti sajátosságait, valamint a különféle szövegtípusokat és megjelenésmódokat.',
		a: 9,
		gT: 1626,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és megnevezi a magyar és a tanult idegen nyelv közötti hasonlóságokat és eltéréseket.',
		a: 9,
		gT: 1625,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar nyelv hangtanát, alaktanát, szófajtanát, mondattanát, ismeri és alkalmazza a tanult elemzési eljárásokat.',
		a: 9,
		gT: 1624,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az anyanyelvét, annak szerkezeti felépítését, nyelvhasználata tudatos és helyes.',
		a: 9,
		gT: 1623,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Reflektál saját kommunikációjára, szükség esetén változtat azon.',
		a: 9,
		gT: 1622,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és elemzi a tömegkommunikáció befolyásoló eszközeit, azok céljait és hatásait.',
		a: 9,
		gT: 1621,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a kommunikáció zavarait, kezelésükre stratégiát dolgoz ki.',
		a: 9,
		gT: 1620,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Az anyanyelvről szerzett ismereteit alkalmazva képes a kommunikációjában a megfelelő nyelvváltozat kiválasztására, használatára.',
		a: 9,
		gT: 1619,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Találkozik az érdeklődésének megfelelő akár autentikus szövegekkel elektronikus, digitális csatornákon tanórán kívül is.',
		a: 9,
		gT: 2269,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Egyénileg vagy társaival együttműködve szóban vagy írásban projektmunkát vagy kiselőadást készít, és ezeket digitális eszközök segítségével is meg tudja valósítani.',
		a: 9,
		gT: 2268,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Következetesen alkalmazza a célnyelvi betű és jelkészletet',
		a: 9,
		gT: 2267,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'Idegen nyelvi kommunikációjában ismeri és használja a célnyelv főbb jellemzőit.',
		a: 9,
		gT: 2266,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó alapvető tanult nyelvi elemeket használja.',
		a: 9,
		gT: 2265,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'code',
		gD: 'Megismerkedik hazánk legfőbb országismereti és történelmi eseményeivel célnyelven.',
		a: 9,
		gT: 2264,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Találkozik a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel.',
		a: 9,
		gT: 2263,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'code',
		gD: 'Találkozik célnyelvi országismereti tartalmakkal.',
		a: 9,
		gT: 2262,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Célnyelvi kommunikációjába beépíti a tanult interkulturális ismereteket.',
		a: 9,
		gT: 2261,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'További országismereti tudásra tesz szert.',
		a: 9,
		gT: 2260,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Megismeri a célnyelvi országok főbb jellemzőit és kulturális sajátosságait.',
		a: 9,
		gT: 2259,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'code',
		gD: 'Értelmez egyszerű, szórakoztató kisfilmeket',
		a: 9,
		gT: 2258,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Digitális eszközöket és felületeket is használ nyelvtudása fejlesztésére,',
		a: 9,
		gT: 2257,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Felhasználja a célnyelvet szórakozásra és játékos nyelvtanulásra.',
		a: 9,
		gT: 2256,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'A tanórán kívüli, akár játékos nyelvtanulási lehetőségeket felismeri, és törekszik azokat kihasználni.',
		a: 9,
		gT: 2255,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'code',
		gD: 'Társai haladásának értékelésében segítően részt vesz.',
		a: 9,
		gT: 2254,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Nyelvi haladását többnyire fel tudja mérni,',
		a: 9,
		gT: 2253,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'code',
		gD: 'Céljai eléréséhez társaival párban és csoportban együttműködik.',
		a: 9,
		gT: 2252,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket.',
		a: 9,
		gT: 2251,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 2250,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'code',
		gD: 'Ismer szavakat, szókapcsolatokat a célnyelven a témakörre jellemző, életkorának és érdeklődésének megfelelő más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 2249,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Hibáit többnyire észreveszi és javítja.',
		a: 9,
		gT: 2248,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Tudatosan használ alapszintű nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 2247,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'code',
		gD: 'Ismerős és gyakori alapvető helyzetekben, akár telefonon vagy digitális csatornákon is, többnyire helyesen és érthetően fejezi ki magát az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 2246,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Megoszt alapvető személyes információkat és szükségleteket magáról egyszerű nyelvi elemekkel.',
		a: 9,
		gT: 2245,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Nem értés esetén a meg nem értett kulcsszavak vagy fordulatok ismétlését vagy magyarázatát kéri, visszakérdez, betűzést kér.',
		a: 9,
		gT: 2244,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Alkalmaz nyelvi funkciókat rövid társalgás megkezdéséhez, fenntartásához és befejezéséhez.',
		a: 9,
		gT: 2243,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Ismeretlen szavak valószínű jelentését szövegösszefüggések alapján kikövetkezteti az életkorának és érdeklődésének megfelelő, konkrét, rövid szövegekben.',
		a: 9,
		gT: 2242,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi eszközökkel és nonverbális elemek segítségével tisztázza mondanivalójának lényegét.',
		a: 9,
		gT: 2241,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Egyszerű mondatokat összekapcsolva mond el egymást követő eseményekből álló történetet, vagy leírást ad valamilyen témáról.',
		a: 9,
		gT: 2240,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Összekapcsolja az ismert nyelvi elemeket egyszerű kötőszavakkal (például: és, de, vagy).',
		a: 9,
		gT: 2239,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Találkozik életkorának és nyelvi szintjének megfelelő célnyelvi szórakoztató tartalmakkal.',
		a: 9,
		gT: 2238,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 2237,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Felhasználja a célnyelvet ismeretszerzésre.',
		a: 9,
		gT: 2236,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Értelmez és használja az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is,',
		a: 9,
		gT: 2235,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Kifejez és érvekkel alátámasztva mutat be szükségességet, lehetőséget, képességet, bizonyosságot, bizonytalanságot.',
		a: 9,
		gT: 2234,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Kifejez alapvető érzéseket, például örömöt, sajnálkozást, bánatot, elégedettséget, elégedetlenséget, bosszúságot, csodálkozást, reményt.',
		a: 9,
		gT: 2233,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Kifejez kérést, javaslatot, meghívást, kínálást és ezekre reagálást.',
		a: 9,
		gT: 2232,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Információt cserél, információt kér, információt ad.',
		a: 9,
		gT: 2231,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Kifejez tetszést, nem tetszést, akaratot, kívánságot, tudást és nem tudást, ígéretet, szándékot, dicséretet, kritikát.',
		a: 9,
		gT: 2230,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Egyszerűen megfogalmazza személyes véleményét, másoktól véleményük kifejtését kéri, és arra reagál, elismeri vagy cáfolja mások állítását, kifejezi egyetértését vagy egyet nem értését.',
		a: 9,
		gT: 2229,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'code',
		gD: 'Néhány szóból vagy mondatból álló jegyzetet készít írott szöveg alapján.',
		a: 9,
		gT: 2228,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Találkozik az életkorának és nyelvi szintjének megfelelő célnyelvi ismeretterjesztő tartalmakkal.',
		a: 9,
		gT: 2227,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Felhasználja a célnyelvet tudásmegosztásra.',
		a: 9,
		gT: 2226,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Rövid, egyszerű, ismert nyelvi eszközökből álló kiselőadást tart változatos feladatok kapcsán, hagyományos vagy digitális alapú vizuális eszközök támogatásával.',
		a: 9,
		gT: 2225,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'code',
		gD: 'Véleményét írásban, egyszerű nyelvi eszközökkel megfogalmazza, és arról írásban interakciót folytat.',
		a: 9,
		gT: 2224,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Üzeneteket ír,',
		a: 9,
		gT: 2223,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Bekapcsolódik a tanórán az interakciót igénylő nyelvi tevékenységekbe, abban társaival közösen részt vesz, a begyakorolt nyelvi elemeket tanári segítséggel a játék céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2222,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre is reagál egyszerű célnyelvi eszközökkel, személyes vagy online interakciókban.',
		a: 9,
		gT: 2221,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemeket többnyire megfelelően használja, beszédszándékainak megfelelően, egyszerű spontán helyzetekben.',
		a: 9,
		gT: 2220,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Véleményét, gondolatait, érzéseit egyre magabiztosabban fejezi ki a tanult nyelvi eszközökkel.',
		a: 9,
		gT: 2219,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Az életkorának megfelelő mindennapi helyzetekben a tanult nyelvi eszközökkel megfogalmazott kérdéseket tesz fel, és válaszol a hozzá intézett kérdésekre.',
		a: 9,
		gT: 2218,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Kommunikációt kezdeményez egyszerű hétköznapi témában, a beszélgetést követi, egyszerű, nyelvi eszközökkel fenntartja és lezárja.',
		a: 9,
		gT: 2217,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Megért és használ szavakat, szókapcsolatokat a célnyelvi, az életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel kapcsolatban',
		a: 9,
		gT: 2216,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Érdeklődése erősödik a célnyelvi irodalmi alkotások iránt.',
		a: 9,
		gT: 2215,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'A nyomtatott vagy digitális alapú írott szöveget felhasználja szórakozásra és ismeretszerzésre önállóan is.',
		a: 9,
		gT: 2214,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő írott, nyomtatott vagy digitális alapú szöveget a változatos nyelvórai tevékenységek és feladatmegoldás során.',
		a: 9,
		gT: 2213,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Összetettebb írott instrukciókat értelmez.',
		a: 9,
		gT: 2212,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megkülönbözteti a főbb, életkorának megfelelő írott szövegtípusokat.',
		a: 9,
		gT: 2211,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja más iskolai vagy iskolán kívül szerzett ismereteivel.',
		a: 9,
		gT: 2210,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó rövid írott szöveg tartalmát.',
		a: 9,
		gT: 2209,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi az életkorának megfelelő szituációkhoz kapcsolódó, írott szövegekben megjelenő összetettebb információkat.',
		a: 9,
		gT: 2208,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Hallgat az érdeklődésének megfelelő autentikus szövegeket elektronikus, digitális csatornákon, tanórán kívül is, szórakozásra vagy ismeretszerzésre.',
		a: 9,
		gT: 2207,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a főbb, életkorának megfelelő hangzószöveg-típusokat.',
		a: 9,
		gT: 2206,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmez életkorának megfelelő nyelvi helyzeteket hallott szöveg alapján.',
		a: 9,
		gT: 2205,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő hangzó szöveget a változatos nyelvórai tevékenységek és a feladatmegoldás során.',
		a: 9,
		gT: 2204,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő, élőszóban vagy digitális felületen elhangzó szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 2203,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó, élőszóban vagy digitális felületen elhangzó rövid szöveg tartalmát.',
		a: 9,
		gT: 2202,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi az életkorának megfelelő, élőszóban vagy digitális felületen elhangzó szövegekben a beszélők gondolatmenetét.',
		a: 9,
		gT: 2201,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi az életkorának és nyelvi szintjének megfelelő, egyszerű, hangzó szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2200,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a szintjének megfelelő, kevésbé ismert elemekből álló, nonverbális vagy vizuális eszközökkel támogatott célnyelvi óravezetést és utasításokat, kérdéseket.',
		a: 9,
		gT: 2199,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'A szövegek létrehozásához nyomtatott, illetve digitális alapú segédeszközt, szótárt használ.',
		a: 9,
		gT: 2198,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Rövid, összefüggő, papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformákban.',
		a: 9,
		gT: 2197,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Rövid szövegek írását igénylő kreatív munkát hoz létre önállóan.',
		a: 9,
		gT: 2196,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Rövid, egyszerű, összefüggő szövegeket ír a tanult nyelvi szerkezetek felhasználásával az ismert szövegtípusokban, az ajánlott tématartományokban.',
		a: 9,
		gT: 2195,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Megold játékos és változatos írásbeli feladatokat rövid szövegek szintjén.',
		a: 9,
		gT: 2194,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Változatos, kognitív kihívást jelentő szóbeli feladatokat old meg önállóan vagy kooperatív munkaformában, a tanult nyelvi eszközökkel, szükség szerint tanári segítséggel, élőszóban és digitális felületen.',
		a: 9,
		gT: 2193,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Képet jellemez röviden, egyszerűen, ismert nyelvi fordulatok segítségével, segítő tanári kérdések alapján, önállóan.',
		a: 9,
		gT: 2192,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Egyszerű nyelvi eszközökkel, felkészülést követően röviden, összefüggően beszél az ajánlott tématartományokhoz tartozó témákban, élőszóban és digitális felületen.',
		a: 9,
		gT: 2191,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Elmesél rövid történetet, egyszerűsített olvasmányt egyszerű nyelvi eszközökkel, önállóan, a cselekményt lineárisan összefűzve.',
		a: 9,
		gT: 2190,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Egyre magabiztosabban kapcsolódik be történetek kreatív alakításába, átfogalmazásába kooperatív munkaformában.',
		a: 9,
		gT: 2189,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Aktívan részt vesz az életkorának és érdeklődésének megfelelő gyermek-, illetve ifjúsági irodalmi alkotások közös előadásában.',
		a: 9,
		gT: 2188,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'code',
		gD: 'Érti a nyelvtudás fontosságát, és motivációja a nyelvtanulásra tovább erősödik.',
		a: 9,
		gT: 2187,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 2186,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 2185,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Használ életkorának és nyelvi szintjének megfelelő hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 2184,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Nyelvtudását egyre inkább képes fejleszteni tanórán kívüli helyzetekben is különböző eszközökkel és lehetőségekkel.',
		a: 9,
		gT: 2183,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a tanult nyelvi funkciókat és a megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 2182,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat, valamint közvetít az élő idegen nyelven.',
		a: 9,
		gT: 2181,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Értelmez korának és nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket az ismert témákban és szövegtípusokban.',
		a: 9,
		gT: 2180,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szóban és írásban létrehoz rövid szövegeket, ismert nyelvi eszközökkel, a korának megfelelő szövegtípusokban.',
		a: 9,
		gT: 2179,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szóban és írásban megold változatos kihívásokat igénylő feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 2178,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Létrehoz nagyon egyszerű írott, pár szavas szöveget szóban vagy írásban digitális felületen.',
		a: 9,
		gT: 2177,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Megérti a tanult nyelvi elemeket életkorának megfelelő digitális tartalmakban, digitális csatornákon olvasott vagy hallott nagyon egyszerű szövegekben is.',
		a: 9,
		gT: 2176,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a főbb, célnyelvi kultúrához tartozó, ünnepekhez kapcsolódó alapszintű kifejezéseket, állandósult szókapcsolatokat és szokásokat.',
		a: 9,
		gT: 2175,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Megismeri a főbb, az adott célnyelvi kultúrákhoz tartozó országok nevét, földrajzi elhelyezkedését, főbb országismereti jellemzőit.',
		a: 9,
		gT: 2174,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'code',
		gD: 'Alapvető célzott információt megszerez a tanult témákban tudásának bővítésére.',
		a: 9,
		gT: 2173,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Felhasznál és létrehoz rövid, nagyon egyszerű célnyelvi szövegeket szabadidős tevékenységek során.',
		a: 9,
		gT: 2172,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Felismeri az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is.',
		a: 9,
		gT: 2171,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Egy feladat megoldásának sikerességét segítséggel értékelni tudja.',
		a: 9,
		gT: 2170,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'A célok eléréséhez társaival rövid feladatokban együttműködik.',
		a: 9,
		gT: 2169,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Szavak, kifejezések tanulásakor felismeri, ha új elemmel találkozik és rákérdez, vagy megfelelő tanulási stratégiával törekszik a megértésre.',
		a: 9,
		gT: 2168,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Új szavak, kifejezések tanulásakor ráismer a már korábban tanult szavakra, kifejezésekre.',
		a: 9,
		gT: 2167,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'code',
		gD: 'Közöl alapvető személyes információkat magáról, egyszerű nyelvi elemek segítségével.',
		a: 9,
		gT: 2166,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és használja a legegyszerűbb, a nem értés, visszakérdezés és ismétlés, kérés kifejezésére használt mindennapi nyelvi funkciókat életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2165,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és használja a legegyszerűbb, a tudás és nem tudás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2164,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és használja a legegyszerűbb, a köszönet és az arra történő reagálás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2163,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és használja a legegyszerűbb, megszólításra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2162,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, bemutatkozásra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2161,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, üdvözlésre és elköszönésre használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2160,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'code',
		gD: 'Elsajátítja a tanult szavak és állandósult szókapcsolatok célnyelvi normához közelítő kiejtését tanári minta követése által, vagy autentikus hangzó anyag, digitális technológia segítségével.',
		a: 9,
		gT: 2159,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Érzéseit egy-két szóval vagy begyakorolt állandósult nyelvi fordulatok segítségével kifejezi, főként rákérdezés alapján, nonverbális eszközökkel kísérve a célnyelvi megnyilatkozást.',
		a: 9,
		gT: 2158,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A tanórán bekapcsolódik a már ismert, szóbeli interakciót igénylő nyelvi tevékenységekbe, a begyakorolt nyelvi elemeket tanári segítséggel a tevékenység céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2157,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Rövid, néhány mondatból álló párbeszédet folytat, felkészülést követően.',
		a: 9,
		gT: 2156,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Törekszik arra, hogy a célnyelvet eszközként alkalmazza információszerzésre.',
		a: 9,
		gT: 2155,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'A tanórán begyakorolt, nagyon egyszerű, egyértelmű kommunikációs helyzetekben a megtanult, állandósult beszédfordulatok alkalmazásával kérdez vagy reagál, mondanivalóját segítséggel vagy nonverbális eszközökkel kifejezi.',
		a: 9,
		gT: 2154,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'code',
		gD: 'Aktívan bekapcsolódik a közös meseolvasásba, a mese tartalmát követi.',
		a: 9,
		gT: 2153,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megtapasztalja a közös célnyelvi olvasás élményét.',
		a: 9,
		gT: 2152,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő írott szövegre az órai játékos alkotó, mozgásos vagy nyelvi fejlesztő tevékenységek során, kooperatív munkaformákban.',
		a: 9,
		gT: 2151,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Kiemeli az ismert nyelvi elemeket tartalmazó, egyszerű, írott, pár mondatos szöveg fő mondanivalóját.',
		a: 9,
		gT: 2150,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti a nyelvi szintjének megfelelő, akár vizuális eszközökkel is támogatott írott utasításokat és kérdéseket, és ezekre megfelelő válaszreakciókat ad.',
		a: 9,
		gT: 2149,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Csendes olvasás keretében feldolgozva megért ismert szavakat tartalmazó, pár szóból vagy mondatból álló, akár illusztrációval támogatott szöveget.',
		a: 9,
		gT: 2148,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Beazonosítja a célzott információt az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű, a nyelvtanításhoz készült, illetve eredeti szövegben.',
		a: 9,
		gT: 2147,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Megkülönbözteti az anyanyelvi és a célnyelvi írott szövegben a betű- és jelkészlet közti különbségeket.',
		a: 9,
		gT: 2146,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'code',
		gD: 'Figyel a célnyelvre jellemző hangok kiejtésére.',
		a: 9,
		gT: 2145,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri az anyanyelve és a célnyelv közötti legalapvetőbb kiejtésbeli különbségeket.',
		a: 9,
		gT: 2144,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Értelmezi azokat az idegen nyelven szóban elhangzó nyelvórai szituációkat, melyeket anyanyelvén már ismer.',
		a: 9,
		gT: 2143,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri az anyanyelv és az idegen nyelv hangkészletét.',
		a: 9,
		gT: 2142,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő hangzó szövegre az órai alkotó jellegű nyelvi, mozgásos nyelvi és játékos nyelvi tevékenységek során.',
		a: 9,
		gT: 2141,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Azonosítja a célzott információt a nyelvi szintjének és életkorának megfelelő rövid hangzó szövegben.',
		a: 9,
		gT: 2140,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Kiszűri a lényeget az ismert nyelvi elemeket tartalmazó, nagyon rövid, egyszerű hangzó szövegből.',
		a: 9,
		gT: 2139,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Beazonosítja az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2138,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Megérti az élőszóban elhangzó, ismert témákhoz kapcsolódó, verbális, vizuális vagy nonverbális eszközökkel segített rövid kijelentéseket, kérdéseket.',
		a: 9,
		gT: 2137,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'code',
		gD: 'Írásban megnevezi az ajánlott tématartományokban megjelölt, begyakorolt elemeket.',
		a: 9,
		gT: 2136,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Részt vesz kooperatív munkaformában végzett kreatív tevékenységekben, projektmunkában szavak, szószerkezetek, rövid mondatok leírásával, esetleg képi kiegészítéssel.',
		a: 9,
		gT: 2135,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Megold játékos írásbeli feladatokat a szavak, szószerkezetek, rövid mondatok szintjén.',
		a: 9,
		gT: 2134,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Lemásol tanult szavakat játékos, alkotó nyelvórai tevékenységek során.',
		a: 9,
		gT: 2133,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az adott nyelv ábécéjét.',
		a: 9,
		gT: 2132,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Felismeri az anyanyelvén, illetve a tanult idegen nyelven történő írásmód és betűkészlet közötti különbségeket.',
		a: 9,
		gT: 2131,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'code',
		gD: 'Célnyelven megoszt egyedül vagy társaival együttműködésben megszerzett, alapvető információkat szóban, akár vizuális elemekkel támogatva.',
		a: 9,
		gT: 2130,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'code',
		gD: 'Lebetűzi a tanult szavakat társaival közösen játékos tevékenységek kapcsán, szükség esetén segítséggel.',
		a: 9,
		gT: 2129,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'code',
		gD: 'Lebetűzi a nevét.',
		a: 9,
		gT: 2128,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'code',
		gD: 'Megismétli az élőszóban elhangzó egyszerű szavakat, kifejezéseket játékos, mozgást igénylő, kreatív nyelvórai tevékenységek során.',
		a: 9,
		gT: 2127,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'code',
		gD: 'Célnyelvi tanulmányain keresztül nyitottabbá, a világ felé érdeklődőbbé válik.',
		a: 9,
		gT: 2126,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a tanult nyelvi elemek megfelelő kiejtésére.',
		a: 9,
		gT: 2125,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az adott célnyelvi kultúrákhoz tartozó országok fontosabb jellemzőit és a hozzájuk tartozó alapvető nyelvi elemeket.',
		a: 9,
		gT: 2124,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Elmondja magáról a legalapvetőbb információkat.',
		a: 9,
		gT: 2123,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Felismeri és használja a legegyszerűbb, mindennapi nyelvi funkciókat.',
		a: 9,
		gT: 2122,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Követi a szintjének megfelelő, vizuális vagy nonverbális eszközökkel támogatott, ismert célnyelvi óravezetést, utasításokat.',
		a: 9,
		gT: 2121,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Lemásol, leír szavakat és rövid, nagyon egyszerű szövegeket.',
		a: 9,
		gT: 2120,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szóban visszaad szavakat, esetleg rövid, nagyon egyszerű szövegeket hoz létre.',
		a: 9,
		gT: 2119,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Bekapcsolódik a szóbeliséget, írást, szövegértést vagy interakciót igénylő alapvető és korának megfelelő játékos, élményalapú élő idegen nyelvi tevékenységekbe.',
		a: 9,
		gT: 2118,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Megismerkedik az idegen nyelvvel, a nyelvtanulással és örömmel vesz részt az órákon.',
		a: 9,
		gT: 2117,
		b: 13,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'code',
		gD: 'Szerkesztési feladatok euklideszi módon történő megoldásához dinamikus geometriai szoftvert használ.',
		a: 9,
		gT: 2116,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Kísérletezéshez, sejtés megfogalmazásához, egyenlet grafikus megoldásához és ellenőrzéshez dinamikus geometriai, grafikus és táblázatkezelő szoftvereket használ.',
		a: 9,
		gT: 2115,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Prezentációhoz informatív diákat készít, ezeket logikusan és következetesen egymás után fűzi és bemutatja.',
		a: 9,
		gT: 2114,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Ismereteit digitális forrásokból kiegészíti, számítógép segítségével elemzi és bemutatja.',
		a: 9,
		gT: 2113,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Megfelelő informatikai alkalmazás segítségével szöveget szerkeszt, táblázatkezelő programmal diagramokat készít.',
		a: 9,
		gT: 2112,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Digitális környezetben matematikai alkalmazásokkal dolgozik.',
		a: 9,
		gT: 2111,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Számológép segítségével alapműveletekkel felírható számolási eredményt; négyzetgyököt; átlagot; szögfüggvények értékét, illetve abból szöget; logaritmust; faktoriálist; binomiális együtthatót; szórást meghatároz.',
		a: 9,
		gT: 2110,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Ismer a tananyaghoz kapcsolódó matematikatörténeti vonatkozásokat.',
		a: 9,
		gT: 2109,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Szöveg alapján táblázatot, grafikont készít, ábrát, kapcsolatokat szemléltető gráfot rajzol, és ezeket kombinálva prezentációt készít és mutat be.',
		a: 9,
		gT: 2108,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Matematika feladatok megoldását szakszerűen prezentálja írásban és szóban a szükséges alapfogalmak, azonosságok, definíciók és tételek segítségével.',
		a: 9,
		gT: 2107,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Önállóan kommunikál matematika tartalmú feladatokkal kapcsolatban.',
		a: 9,
		gT: 2106,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'A matematikai fogalmakat és jelöléseket megfelelően használja.',
		a: 9,
		gT: 2105,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'A megfelelő matematikai tankönyveket, feladatgyűjteményeket, internetes tartalmakat értőn olvassa, a matematikai tartalmat rendszerezetten kigyűjti és megérti.',
		a: 9,
		gT: 2104,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Meghatározza a valószínűséget visszatevéses, illetve visszatevés nélküli mintavétel esetén.',
		a: 9,
		gT: 2103,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és egyszerű esetekben alkalmazza a valószínűség geometriai modelljét.',
		a: 9,
		gT: 2102,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Konkrét valószínűségi kísérletek esetében az esemény, eseménytér, elemi esemény, relatív gyakoriság, valószínűség, egymást kizáró események, független események fogalmát megkülönbözteti és alkalmazza.',
		a: 9,
		gT: 2101,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Véletlen kísérletek adatait rendszerezi, relatív gyakoriságokat számol, nagy elemszám esetén számítógépet alkalmaz.',
		a: 9,
		gT: 2100,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a klasszikus valószínűségi modellt és a laplace-képletet.',
		a: 9,
		gT: 2099,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Tapasztalatai alapján véletlen jelenségek jövőbeni kimenetelére észszerűen tippel.',
		a: 9,
		gT: 2098,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'code',
		gD: 'Felismer grafikus manipulációkat diagramok esetén.',
		a: 9,
		gT: 2097,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a sodrófa (box-plot) diagramot adathalmazok jellemzésére, összehasonlítására.',
		a: 9,
		gT: 2096,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'code',
		gD: 'Adatsokaságból adott szempont szerint oszlop- és kördiagramot készít hagyományos és digitális eszközzel.',
		a: 9,
		gT: 2095,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'code',
		gD: 'Hagyományos és digitális forrásból származó adatsokaság alapvető statisztikai jellemzőit meghatározza, értelmezi és értékeli.',
		a: 9,
		gT: 2094,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'code',
		gD: 'Adott cél érdekében tudatos adatgyűjtést és rendszerezést végez.',
		a: 9,
		gT: 2093,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'code',
		gD: 'Mértani sorozatokra vonatkozó ismereteit használja gazdasági, pénzügyi, természettudományi és társadalomtudományi problémák megoldásában.',
		a: 9,
		gT: 2092,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'code',
		gD: 'A számtani, mértani sorozatok első n tagjának összegét kiszámolja.',
		a: 9,
		gT: 2091,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'code',
		gD: 'A számtani, mértani sorozat n-edik tagját felírja az első tag és a különbség (differencia)/hányados (kvóciens) ismeretében.',
		a: 9,
		gT: 2090,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'code',
		gD: 'Számtani és mértani sorozatokat adott szabály alapján felír, folytat.',
		a: 9,
		gT: 2089,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'code',
		gD: 'A grafikonról megállapítja függvények alapvető tulajdonságait.',
		a: 9,
		gT: 2088,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Adott értékkészletbeli elemhez megtalálja az értelmezési tartomány azon elemeit, amelyekhez a függvény az adott értéket rendeli.',
		a: 9,
		gT: 2087,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Képlettel adott függvényt hagyományosan és digitális eszközzel ábrázol.',
		a: 9,
		gT: 2086,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Táblázattal megadott függvény összetartozó értékeit ábrázolja koordináta-rendszerben.',
		a: 9,
		gT: 2085,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Adott képlet alapján helyettesítési értékeket számol, és azokat táblázatba rendezi.',
		a: 9,
		gT: 2084,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Megad hétköznapi életben előforduló hozzárendeléseket.',
		a: 9,
		gT: 2083,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'code',
		gD: 'Megadja és alkalmazza a kör egyenletét a kör sugarának és a középpont koordinátáinak ismeretében.',
		a: 9,
		gT: 2082,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Kiszámítja egyenesek metszéspontjainak koordinátáit az egyenesek egyenletének ismeretében.',
		a: 9,
		gT: 2081,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Egyenesek egyenletéből következtet az egyenesek kölcsönös helyzetére.',
		a: 9,
		gT: 2080,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az egyenes egyenletét.',
		a: 9,
		gT: 2079,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Koordináták alapján számításokat végez szakaszokkal, vektorokkal.',
		a: 9,
		gT: 2078,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Koordináta-rendszerben ábrázol adott feltételeknek megfelelő ponthalmazokat.',
		a: 9,
		gT: 2077,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Megad pontot és vektort koordinátáival a derékszögű koordináta-rendszerben.',
		a: 9,
		gT: 2076,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a hasonló testek felszínének és térfogatának arányára vonatkozó tételeket.',
		a: 9,
		gT: 2075,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'code',
		gD: 'Kiszámítja a speciális testek felszínét és térfogatát egyszerű esetekben.',
		a: 9,
		gT: 2074,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'code',
		gD: 'Lerajzolja a kocka, téglatest, egyenes hasáb, egyenes körhenger, egyenes gúla, forgáskúp hálóját.',
		a: 9,
		gT: 2073,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a hasáb, a henger, a gúla, a kúp, a gömb, a csonkagúla, a csonkakúp (speciális testek) tulajdonságait.',
		a: 9,
		gT: 2072,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a szinusz- és a koszinusztételt.',
		a: 9,
		gT: 2071,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'A szögfüggvény értékének ismeretében meghatározza a szöget.',
		a: 9,
		gT: 2070,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a szögfüggvényeket egyszerű geometriai számítási feladatokban.',
		a: 9,
		gT: 2069,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hegyes- és tompaszögek szögfüggvényeinek összefüggéseit.',
		a: 9,
		gT: 2068,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri tompaszögek szögfüggvényeinek származtatását a hegyesszögek szögfüggvényei alapján.',
		a: 9,
		gT: 2067,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'Ismeri hegyesszögek szögfüggvényeinek definícióját a derékszögű háromszögben.',
		a: 9,
		gT: 2066,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a vektorokat feladatok megoldásában.',
		a: 9,
		gT: 2065,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismer és alkalmaz egyszerű vektorműveleteket.',
		a: 9,
		gT: 2064,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a vektorokkal kapcsolatos alapvető fogalmakat.',
		a: 9,
		gT: 2063,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Megszerkeszti egy alakzat tengelyes, illetve középpontos tükörképét, pont körüli elforgatottját, párhuzamos eltoltját hagyományosan és digitális eszközzel.',
		a: 9,
		gT: 2062,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a hasonló síkidomok kerületének és területének arányára vonatkozó tételeket.',
		a: 9,
		gT: 2061,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a középpontos hasonlósági transzformációt, a hasonlósági transzformációt és az alakzatok hasonlóságát.',
		a: 9,
		gT: 2060,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a síkbeli egybevágósági transzformációkat és tulajdonságaikat; alakzatok egybevágóságát.',
		a: 9,
		gT: 2059,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismer példákat geometriai transzformációkra.',
		a: 9,
		gT: 2058,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a thalész-tételt és megfordítását.',
		a: 9,
		gT: 2057,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a kör érintőjének fogalmát, kapcsolatát az érintési pontba húzott sugárral.',
		a: 9,
		gT: 2056,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'code',
		gD: 'Ki tudja számolni a kör és részeinek kerületét, területét.',
		a: 9,
		gT: 2055,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'code',
		gD: 'Átdarabolással kiszámítja sokszögek területét.',
		a: 9,
		gT: 2054,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a szabályos sokszög fogalmát; kiszámítja a konvex sokszög belső és külső szögeinek összegét.',
		a: 9,
		gT: 2053,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza speciális négyszögek tulajdonságait, területüket kiszámítja.',
		a: 9,
		gT: 2052,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Kiszámítja háromszögek területét.',
		a: 9,
		gT: 2051,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a pitagorasz-tételt és megfordítását.',
		a: 9,
		gT: 2050,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a háromszög nevezetes vonalaira, pontjaira és köreire vonatkozó fogalmakat és tételeket.',
		a: 9,
		gT: 2049,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a háromszögek oldalai, szögei, oldalai és szögei közötti kapcsolatokat; a speciális háromszögek tulajdonságait.',
		a: 9,
		gT: 2048,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az alapszerkesztéseket, és ezeket végre tudja hajtani hagyományos vagy digitális eszközzel.',
		a: 9,
		gT: 2047,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a nevezetes szögpárok tulajdonságait.',
		a: 9,
		gT: 2046,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és feladatmegoldásban alkalmazza a térelemek kölcsönös helyzetét, távolságát és hajlásszögét.',
		a: 9,
		gT: 2045,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és használja a pont, egyenes, sík (térelemek) és szög fogalmát.',
		a: 9,
		gT: 2044,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a százalékalap, -érték, -láb, -pont fogalmát.',
		a: 9,
		gT: 2043,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az egyenes és a fordított arányosságot.',
		a: 9,
		gT: 2042,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'code',
		gD: 'Átalakít algebrai kifejezéseket összevonás, szorzattá alakítás, nevezetes azonosságok alkalmazásával.',
		a: 9,
		gT: 2041,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismer és alkalmaz egyszerű algebrai azonosságokat.',
		a: 9,
		gT: 2040,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Műveleteket végez algebrai kifejezésekkel.',
		a: 9,
		gT: 2039,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a logaritmus fogalmát.',
		a: 9,
		gT: 2038,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a racionális kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2037,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az egész kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2036,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a normálalak fogalmát.',
		a: 9,
		gT: 2035,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az n-edik gyök fogalmát.',
		a: 9,
		gT: 2034,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a négyzetgyök fogalmát és azonosságait.',
		a: 9,
		gT: 2033,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'code',
		gD: 'Valós számok közelítő alakjaival számol, és megfelelően kerekít.',
		a: 9,
		gT: 2032,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'A számolással kapott eredményeket nagyságrendileg megbecsüli, és így ellenőrzi az eredményt.',
		a: 9,
		gT: 2031,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az abszolút érték, az ellentett és a reciprok fogalmát.',
		a: 9,
		gT: 2030,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a valós számok és a számegyenes kapcsolatát.',
		a: 9,
		gT: 2029,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Ismer példákat irracionális számokra.',
		a: 9,
		gT: 2028,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Racionális számokat tizedes tört és közönséges tört alakban is felír.',
		a: 9,
		gT: 2027,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'A kommutativitás, asszociativitás, disztributivitás műveleti azonosságokat helyesen alkalmazza különböző számolási helyzetekben.',
		a: 9,
		gT: 2026,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a számhalmazok épülésének matematikai vonatkozásait a természetes számoktól a valós számokig.',
		a: 9,
		gT: 2025,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'code',
		gD: 'Érti a helyi értékes írásmódot 10-es és más alapú számrendszerekben.',
		a: 9,
		gT: 2024,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az oszthatósági szabályokat.',
		a: 9,
		gT: 2023,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Meghatározza két természetes szám legnagyobb közös osztóját és legkisebb közös többszörösét, és alkalmazza ezeket egyszerű gyakorlati feladatokban.',
		a: 9,
		gT: 2022,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összetett számokat felbont prímszámok szorzatára.',
		a: 9,
		gT: 2021,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az oszthatóság alapvető fogalmait.',
		a: 9,
		gT: 2020,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Sík- és térgeometriai feladatoknál a problémának megfelelő mértékegységben adja meg válaszát.',
		a: 9,
		gT: 2019,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hosszúság, terület, térfogat, űrtartalom, idő mértékegységeit és az átváltási szabályokat. származtatott mértékegységeket átvált.',
		a: 9,
		gT: 2018,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a mérés alapelvét, alkalmazza konkrét alap- és származtatott mennyiségek esetén.',
		a: 9,
		gT: 2017,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'code',
		gD: 'Egyenletek megoldását behelyettesítéssel, értékkészlet-vizsgálattal ellenőrzi.',
		a: 9,
		gT: 2016,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'code',
		gD: 'Megold egyszerű, a megfelelő definíció alkalmazását igénylő exponenciális egyenleteket, egyenlőtlenségeket.',
		a: 9,
		gT: 2015,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'code',
		gD: 'Megold másodfokú egyismeretlenes egyenleteket és egyenlőtlenségeket; ismeri és alkalmazza a diszkriminánst, a megoldóképletet és a gyöktényezős alakot.',
		a: 9,
		gT: 2014,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'code',
		gD: 'Megold elsőfokú egyismeretlenes egyenleteket és egyenlőtlenségeket, elsőfokú kétismeretlenes egyenletrendszereket.',
		a: 9,
		gT: 2013,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza a következő egyenletmegoldási módszereket: mérlegelv, grafikus megoldás, szorzattá alakítás.',
		a: 9,
		gT: 2012,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'code',
		gD: 'Geometriai szerkesztési feladatoknál vizsgálja és megállapítja a szerkeszthetőség feltételeit.',
		a: 9,
		gT: 2011,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'code',
		gD: 'A modellben kapott megoldását az eredeti problémába visszahelyettesítve értelmezi, ellenőrzi és az észszerűségi szempontokat figyelembe véve adja meg válaszát.',
		a: 9,
		gT: 2010,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'code',
		gD: 'A kiválasztott modellben megoldja a problémát.',
		a: 9,
		gT: 2009,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'code',
		gD: 'A problémának megfelelő matematikai modellt választ, alkot.',
		a: 9,
		gT: 2008,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'code',
		gD: 'Adott problémához megoldási stratégiát, algoritmust választ, készít.',
		a: 9,
		gT: 2007,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'code',
		gD: 'Konkrét szituációkat szemléltet és egyszerű feladatokat megold gráfok segítségével.',
		a: 9,
		gT: 2006,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'code',
		gD: 'Megold sorba rendezési és kiválasztási feladatokat.',
		a: 9,
		gT: 2005,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'code',
		gD: 'Tud egyszerű állításokat indokolni és tételeket bizonyítani.',
		a: 9,
		gT: 2004,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Helyesen használja a „minden\" és „van olyan\" kifejezéseket.',
		a: 9,
		gT: 2003,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Megállapítja egyszerű „ha ... , akkor ...\" és „akkor és csak akkor\" típusú állítások logikai értékét.',
		a: 9,
		gT: 2002,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Megfogalmazza adott állítás megfordítását.',
		a: 9,
		gT: 2001,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és alkalmazza az „és\", a (megengedő és kizáró) „vagy\" logikai jelentését.',
		a: 9,
		gT: 2000,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a tagadás műveletét egyszerű feladatokban.',
		a: 9,
		gT: 1999,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Adott állításról eldönti, hogy igaz vagy hamis.',
		a: 9,
		gT: 1998,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a logikai szita elvét.',
		a: 9,
		gT: 1997,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Véges halmazok elemszámát meghatározza.',
		a: 9,
		gT: 1996,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Halmazokkal műveleteket végez, azokat ábrázolja és értelmezi.',
		a: 9,
		gT: 1995,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Halmazokat különböző módokon megad.',
		a: 9,
		gT: 1994,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Látja a halmazműveletek és a logikai műveletek közötti kapcsolatokat.',
		a: 9,
		gT: 1993,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatot.',
		a: 9,
		gT: 1992,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'code',
		gD: 'Matematikai vagy hétköznapi nyelven megfogalmazott szövegből a matematikai tartalmú információkat kigyűjti, rendszerezi.',
		a: 9,
		gT: 1991,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'code',
		gD: 'Adott halmazt diszjunkt részhalmazaira bont, osztályoz.',
		a: 9,
		gT: 1990,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'code',
		gD: 'Matematikai ismereteit alkalmazza a pénzügyi tudatosság területét érintő feladatok megoldásában.',
		a: 9,
		gT: 1989,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'A matematikát más tantárgyakhoz kapcsolódó témákban is használja.',
		a: 9,
		gT: 1988,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'A matematika tanulása során digitális eszközöket és különböző információforrásokat használ.',
		a: 9,
		gT: 1987,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatokat.',
		a: 9,
		gT: 1986,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Megérti a hallott és olvasott matematikai tartalmú szövegeket.',
		a: 9,
		gT: 1985,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'A matematikai szakkifejezéseket és jelöléseket helyesen használja írásban és szóban egyaránt.',
		a: 9,
		gT: 1984,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Adatokat gyűjt, rendez, ábrázol, értelmez.',
		a: 9,
		gT: 1983,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Sejtéseket fogalmaz meg és logikus lépésekkel igazolja azokat.',
		a: 9,
		gT: 1982,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Megérti a környezetében jelen lévő logikai, mennyiségi, függvényszerű, térbeli és statisztikai kapcsolatokat.',
		a: 9,
		gT: 1981,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Ismeretei segítségével, a megfelelő modell alkalmazásával megold hétköznapi és matematikai problémákat, a megoldást ellenőrzi és értelmezi.',
		a: 9,
		gT: 1980,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a sikeres vállalkozás jellemzőit, képes azonosítani az esetleges kudarc okait, javaslatot tud tenni a problémák megoldására.',
		a: 10,
		gT: 2303,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felismeri a kezdeményezőkészség jelentőségét az állampolgári felelősségvállalásban.',
		a: 10,
		gT: 2302,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Megismeri a nem üzleti (társadalmi, kulturális, egyéb civil) kezdeményezések pénzügyi-gazdasági igényeit, lehetőségeit.',
		a: 10,
		gT: 2301,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tájékozott az üzleti terv tartalmi elemeiről.',
		a: 10,
		gT: 2300,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van az üzleti tervezés szükségességével, mind egy új vállalkozás alapításakor, mind már meglévő vállalkozás működése esetén.',
		a: 10,
		gT: 2299,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Meg tudja becsülni egy vállalkozás lehetséges költségeit, képes adott időtartamra költségkalkulációt tervezni.',
		a: 10,
		gT: 2298,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a vállalkozásalapítás, -működtetés legfontosabb lépéseit, képes önálló vállalkozói ötlet kidolgozására.',
		a: 10,
		gT: 2297,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a nem nyereségérdekelt szervezetek gazdaságban betöltött szerepével.',
		a: 10,
		gT: 2296,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Érti a leggyakoribb vállalkozási formák jellemzőit, előnyeit, hátrányait.',
		a: 10,
		gT: 2295,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismer vállalkozókat, vállalatokat, össze tudja hasonlítani az alkalmazotti, és a vállalkozói személyiségjegyeket.',
		a: 10,
		gT: 2294,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van az álláskeresés folyamatával, a munkaviszonnyal kapcsolatos jogaival, kötelezettségeivel.',
		a: 10,
		gT: 2293,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Önismereti tesztek, játékok segítségével képes átgondolni milyen foglalkozások, tevékenységek illeszkednek személyiségéhez.',
		a: 10,
		gT: 2292,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tud érvelni a családi költségvetés mellett, a tudatos, hatékony pénzgazdálkodás érdekében.',
		a: 10,
		gT: 2291,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A bankok kínálatából bankot, bankszámla csomagot tud választani.',
		a: 10,
		gT: 2290,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van az egyes banki ügyletek előnyeivel, hátrányaival, kockázataival.',
		a: 10,
		gT: 2289,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Képes választani az egyes banki lehetőségek közül.',
		a: 10,
		gT: 2288,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a mai bankrendszer felépítését, az egyes pénzpiaci szereplők főbb feladatait.',
		a: 10,
		gT: 2287,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van azzal, hogy az adófizetés biztosítja részben az állami feladatok ellátásnak pénzügyi fedezetét.',
		a: 10,
		gT: 2286,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tudja értelmezni az állam gazdasági szerepvállalásának jelentőségét, ismeri főbb feladatait, azok hatásait.',
		a: 10,
		gT: 2285,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A tanuló érti a nemzetgazdaság szereplőinek (háztartások, vállalatok, állam, pénzintézetek) feladatait, a köztük lévő kapcsolatrendszer sajátosságait.',
		a: 10,
		gT: 2284,
		b: 10,
		e2: 'Pénzügyi és vállalkozói ismeretek',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'pénzügyi és vállalkozói ismeretek'])
	},
		{
		cG: 'code',
		gD: 'A projektcsapat tagjaival egyeztetve, de önállóan elkészíti az elvégzett munka eredményét bemutató prezentációt.',
		a: 9,
		gT: 2356,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a tömör, lényegre törő, de szakszerű bemutató összeállítására.',
		a: 9,
		gT: 2355,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hatékony prezentálás szabályait, a prezentációs szoftverek lehetőségeit.',
		a: 9,
		gT: 2354,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Az elkészült termékhez prezentációt készít és bemutatja, előadja azt munkatársainak, vezetőinek, ügyfeleinek.',
		a: 9,
		gT: 2353,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az irodai szoftverek főbb funkcióit, felhasználási területeit.',
		a: 9,
		gT: 2352,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Munkája során hatékonyan használja az irodai szoftvereket.',
		a: 9,
		gT: 2351,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A projektekben irányítás alatt, társaival közösen dolgozik. A ráosztott feladatrészt önállóan végzi el.',
		a: 9,
		gT: 2350,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Más munkáját és a csoport belső szabályait tiszteletben tartva, együttműködően vesz részt a csapatmunkában.',
		a: 9,
		gT: 2349,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a projektmenedzsment lépéseit (kezdeményezés, követés, végrehajtás, ellenőrzés, dokumentáció, zárás).',
		a: 9,
		gT: 2348,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Társaival hatékonyan együttműködve, csapatban dolgozik egy informatikai projekten. A projektek végrehajtása során társaival tudatosan és célirányosan kommunikál.',
		a: 9,
		gT: 2347,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A Git verziókezelőt, valamint a csoportmunkát támogató eszközöket és szolgáltatásokat önállóan használja.',
		a: 9,
		gT: 2346,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a feladatainak megoldásában a hatékony csoportmunkát támogató online eszközöket kihasználni.',
		a: 9,
		gT: 2345,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a Git, valamint a csoportmunkát támogató eszközök és online szolgáltatások célját, működési módját, legfontosabb funkcióit.',
		a: 9,
		gT: 2344,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Git verziókezelő rendszert, valamint fejlesztést és csoportmunkát támogató online eszközöket és szolgáltatásokat (pl.: GitHub, Slack, Trello, Microsoft Teams, Webex Teams) használ.',
		a: 9,
		gT: 2343,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan készít egyszerű alkalmazásokat.',
		a: 9,
		gT: 2342,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Jól átlátható kódszerkezet kialakítására törekszik.',
		a: 9,
		gT: 2341,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a Python nyelv elemeit, azok céljait (vezérlési szerkezetek, adatszerkezetek, változók, aritmetikai és logikai kifejezések, függvények, modulok, csomagok). Ismeri az algoritmus fogalmát, annak szerepét.',
		a: 9,
		gT: 2340,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Munkája során jelentkező problémák kezelésére vagy folyamatok automatizálására egyszerű alkalmazásokat készít Python programozási nyelv segítségével.',
		a: 9,
		gT: 2339,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan létrehozza és megformázza a weboldalt.',
		a: 9,
		gT: 2338,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A felhasználói igényeknek megfelelő funkcionalitás és design összhangjára törekszik.',
		a: 9,
		gT: 2337,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a HTML5, a CSS3 alapvető elemeit, a stíluslapok fogalmát, felépítését. Érti a reszponzív megjelenítéshez használt módszereket, keretrendszerek előnyeit, a reszponzív webdizájn alapelveit.',
		a: 9,
		gT: 2336,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Szabványos, reszponzív megjelenítést biztosító weblapokat hoz létre és formáz meg stíluslapok segítségével.',
		a: 9,
		gT: 2335,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan szerez információkat a témában releváns szakmai platformokról.',
		a: 9,
		gT: 2334,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Nyitott és érdeklődő a legmodernebb információs technológiák és trendek iránt.',
		a: 9,
		gT: 2333,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Naprakész információkkal rendelkezik a legmodernebb információs technológiákkal és trendekkel kapcsolatban.',
		a: 9,
		gT: 2332,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Internetes források és tudásbázisok segítségével követi, valamint feladatainak elvégzéséhez lehetőség szerint alkalmazza a legmodernebb információs technológiákat és trendeket (virtualizáció, felhőtechnológia, IoT, mesterséges intelligencia, gépi tanulás stb.).',
		a: 9,
		gT: 2331,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan behatárolja a hibát. Egyszerűbb problémákat önállóan, összetettebbeket szakmai irányítással hárít el.',
		a: 9,
		gT: 2330,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az otthoni és kisvállalati informatikai környezetben leggyakrabban felmerülő hibákat (pl. hibás IP-beállítás, kilazult csatlakozó) és azok elhárításának módjait.',
		a: 9,
		gT: 2329,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Megkeresi és elhárítja az otthoni és kisvállalati informatikai környezetben jelentkező hardveres és szoftveres hibákat.',
		a: 9,
		gT: 2328,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a fontosabb hálózatbiztonsági elveket, szabályokat, támadás típusokat, valamint a szoftveres és hardveres védekezési módszereket.',
		a: 9,
		gT: 2327,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazza a hálózatbiztonsággal kapcsolatos legfontosabb irányelveket (pl. erős jelszavak használata, vírusvédelem alkalmazása, tűzfal használat).',
		a: 9,
		gT: 2326,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a kis- és közepes vállalati hálózatok legfontosabb összetevőinek (pl. kábelrendező szekrény, kapcsoló, forgalomirányító) szerepét, jellemzőit, csatlakozási módjukat és alapszintű hálózati beállításait.',
		a: 9,
		gT: 2325,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Néhány alhálózatból álló kis- és közepes vállalati hálózatot alakít ki forgalomirányító és kapcsoló segítségével, elvégzi az eszközök alapszintű hálózati beállításait (pl. forgalomirányító interfészeinek IP-cím beállítása, alapértelmezett átjáró beállítása).',
		a: 9,
		gT: 2324,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a felhasználói igények megismerésére, megértésére, és szem előtt tartja azokat a hálózat kialakításakor.',
		a: 9,
		gT: 2323,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az informatikai hálózatok felépítését, alapvető technológiáit (pl. Ethernet), protokolljait (pl. IP, HTTP) és szabványait (pl. 802.11-es WiFi szabványok). Ismeri az otthoni és irodai hálózatok legfontosabb összetevőinek (kábelezés, WiFi router, PC, mobiltelefon stb.) szerepét, jellemzőit, csatlakozási módjukat és alapszintű hálózati beállításait.',
		a: 9,
		gT: 2322,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Otthoni vagy irodai hálózatot alakít ki WiFi router segítségével, elvégzi WiFi router konfigurálását, a vezetékes- és vezeték nélküli eszközök (PC, mobiltelefon, set-top box stb.), csatlakoztatását és hálózati beállítását.',
		a: 9,
		gT: 2321,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A hibamentes folyamatos működés elérése érdekében fontosnak tartja a megelőző karbantartások elvégzését.',
		a: 9,
		gT: 2320,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van vele, hogy miért szükséges az informatikai és távközlési eszközök rendszeres és eseti karbantartása. Ismeri legalapvetőbb karbantartási eljárásokat.',
		a: 9,
		gT: 2319,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Alapvető karbantartási feladatokat lát el az általa megismert informatikai és távközlési berendezéseken (pl. szellőzés és csatlakozások ellenőrzése, tisztítása).',
		a: 9,
		gT: 2318,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Az informatikai berendezésekre vonatkozó munka- és balesetvédelmi szabályokat a saját és mások testi épsége érdekében betartja és betartatja.',
		a: 9,
		gT: 2317,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a végrehajtandó műveletek precíz és előírásoknak megfelelő elvégzésére.',
		a: 9,
		gT: 2316,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az otthoni és irodai informatikai környezetet alkotó legáltalánosabb összetevők (PC, nyomtató, mobiltelefon, WiFi router stb.) szerepét, alapvető működési módjukat. Ismeri a PC és a mobil eszközök főbb alkatrészeit (pl. alaplap, CPU, memória) és azok szerepét.',
		a: 9,
		gT: 2315,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Elvégzi a PC perifériáinak csatlakoztatását, szükség esetén új alkatrészt szerel be vagy alkatrészt cserél egy számítógépben.',
		a: 9,
		gT: 2314,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan elvégzi a kívánt szoftverek telepítését, szükség esetén gondoskodik az eszközön korábban tárolt adatok biztonsági mentéséről.',
		a: 9,
		gT: 2313,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a felhasználói igényekhez alkalmazkodó szoftverkörnyezet kialakítására.',
		a: 9,
		gT: 2312,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a számítógépen és a mobil informatikai eszközökön használt operációs rendszerek telepítési és frissítési módjait, alapvető parancsait és szolgáltatásait, valamint alapvető beállítási lehetőségeit.',
		a: 9,
		gT: 2311,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Elvégzi a számítógépen és a mobil eszközökön az operációs rendszer (pl. Windows, Linux, Android, iOS), valamint az alkalmazói szoftverek telepítését, frissítését és alapszintű beállítását. Grafikus felületen, valamint parancssorban használja a Windows, és Linux operációs rendszerek alapszintű parancsait és szolgáltatásait (pl. állomány- és könyvtárkezelési műveletek, jogosultságok beállítása, szövegfájlokkal végzett műveletek, folyamatok kezelése).',
		a: 9,
		gT: 2310,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az elektromos mennyiségek mérési metódusait, a mérőműszerek használatát.',
		a: 9,
		gT: 2309,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Alapvető villamos méréseket végez önállóan a megépített áramkörökön.',
		a: 9,
		gT: 2308,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Az elektromos berendezésekre vonatkozó munka- és balesetvédelmi szabályokat a saját és mások testi épsége érdekében betartja és betartatja.',
		a: 9,
		gT: 2307,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A funkcionalitás biztosítása mellett törekszik az esztétikus kialakításra (pl. minőségi forrasztás, egyenletes alkatrész sűrűség, olvashatóság).',
		a: 9,
		gT: 2306,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az elektronikai alapfogalmakat, kapcsolódó fizikai törvényeket, alapvető alkatrészeket és kapcsolásokat.',
		a: 9,
		gT: 2305,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Adott kapcsolási rajz alapján egyszerűbb áramköröket épít próbapanel segítségével vagy forrasztásos technológiával.',
		a: 9,
		gT: 2304,
		b: 10,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az IPv4 és IPv6 címzési rendszerét és a legalapvetőbb hálózati protokollok szerepét és működési módját (IP, TCP, UDP, DHCP, HTTP, HTTPS, telnet, ssh, SMTP, POP3, IMAP4, DNS, TLS/SSL stb.). Ismeri a végponti berendezések IP-beállítási és hibaelhárítási lehetőségeit. Ismeri az otthoni és kisvállalati hálózatokban működő multifunkciós forgalomirányítók szolgáltatásait, azok beállításának módszereit.',
		a: 11,
		gT: 2431,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A szoftverfejlesztés és tesztelési munkakörnyezetének kialakításához beállítja a hálózati eszközöket, elvégzi a vezetékes és vezetéknélküli eszközök csatlakoztatását és hálózatbiztonsági beállítását. A fejlesztett szoftverben biztonságos, HTTPS protokollt használó webes kommunikációt valósít meg.',
		a: 11,
		gT: 2430,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Az elvégzett eszköz- és szoftvertelepítésekért felelősséget vállal.',
		a: 11,
		gT: 2429,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A szoftverrendszerek bevezetése és a működési környezet kialakítása során törekszik az ügyfelek elvárásainak megfelelni, valamint tiszteletben tartja az ügyfél vállalati szabályait.',
		a: 11,
		gT: 2428,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a számítógép és a mobil informatikai eszközök felépítését (főbb komponenseket, azok feladatait) és működését. Ismeri az eszközök operációs rendszerének és alkalmazói szoftvereinek telepítési és beállítási lehetőségeit.',
		a: 11,
		gT: 2427,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Részt vesz szoftverrendszerek ügyfeleknél történő bevezetésében, a működési környezetet biztosító IT-környezet telepítésében és beállításában.',
		a: 11,
		gT: 2426,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Nyitott az új technológiák megismerésére, és törekszik azok hatékony, a felhasználói igényeknek és a költséghatékonysági elvárásoknak megfelelő felhasználására a szoftverfejlesztési feladatokban.',
		a: 11,
		gT: 2425,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Alapszintű alkalmazási szinten ismeri a legmodernebb információs technológiákat és trendeket (virtualizáció, felhőtechnológia, IoT, mesterséges intelligencia, gépi tanulás stb.).',
		a: 11,
		gT: 2424,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Munkája során cél szerint alkalmazza a legmodernebb információs technológiákat és trendeket (virtaulizáció, felhőtechnológia, IoT, mesterséges intelligencia, gépi tanulás stb.).',
		a: 11,
		gT: 2423,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Felelősséget vállal az általa készített műszaki tartalmú dokumentációkért.',
		a: 11,
		gT: 2422,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Precízen készíti el a műszaki tartalmú dokumentációkat, prezentációkat. Törekszik arra, hogy a dokumentumok könnyen értelmezhetők és mások által is szerkeszthetők legyenek.',
		a: 11,
		gT: 2421,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az irodai szoftverek haladó szintű szolgáltatásait.',
		a: 11,
		gT: 2420,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Munkája során hatékonyan használja az irodai szoftvereket, műszaki tartalmú dokumentumokat és bemutatókat készít.',
		a: 11,
		gT: 2419,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Internetes információszerzéssel önállóan old meg problémákat és hárít el hibákat.',
		a: 11,
		gT: 2418,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a hibák elhárítására, megoldására, és arra, hogy azokkal lehetőség szerint ne okozzon újabb hibákat.',
		a: 11,
		gT: 2417,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a munkájához kapcsolódó internetes keresési módszereket és tudásbázisokat.',
		a: 11,
		gT: 2416,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a hibakeresés szisztematikus módszereit, a problémák elhárításának lépéseit.',
		a: 11,
		gT: 2415,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Szoftverfejlesztés vagy -tesztelés során felmerülő problémákat old meg és hibákat hárít el webes kereséssel és internetes tudásbázisok használatával (pl. Stack Overflow).',
		a: 11,
		gT: 2414,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Saját fejlesztésként megvalósított kisebb projektekben önállóan végzi a tesztelést, tesztelői szerepben nagyobb projektekben irányítás mellett végez meghatározott tesztelési feladatokat.',
		a: 11,
		gT: 2413,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a mindenre kiterjedő, az összes lehetséges hibát felderítő tesztelésre, valamint a tesztek körültekintő dokumentálására.',
		a: 11,
		gT: 2412,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a unit tesztelés, valamint más tesztelési, hibakeresési technikák alapelveit és alapvető eszközeit.',
		a: 11,
		gT: 2411,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Manuális és automatizált szoftvertesztelést végezve ellenőrzi a szoftver hibátlan működését, dokumentálja a tesztek eredményét.',
		a: 11,
		gT: 2410,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kevésbé összetett portálokat igényes vizuális megjelenést biztosító sablonok, valamint magas funkcionalitást biztosító beépülők használatával önállóan valósít meg. Összetettebb projekteken irányítás mellett, grafikus tervezőkkel, UX szakemberekkel és más fejlesztőkkel együttműködve dolgozik.',
		a: 11,
		gT: 2409,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik az igényes kialakítású és a felhasználók számára könnyű használatot biztosító webhelyek kialakításra.',
		a: 11,
		gT: 2408,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a tartalomkezelő-rendszerek célját és alapvető szolgáltatásait. Ismeri a beépülők célját és alkalmazási területeit.',
		a: 11,
		gT: 2407,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Tartalomkezelő rendszer (CMS, pl. WordPress) segítségével webhelyet készít, egyéni problémák megoldására saját beépülőket hoz létre.',
		a: 11,
		gT: 2406,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb projektekben önállóan tervezi meg a szükséges osztályokat, nagyobb projektekben irányítás mellett, a projektben a projektcsapat által létrehozott osztálystruktúrát használva, illetve azt kiegészítve végzi a fejlesztést.',
		a: 11,
		gT: 2405,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik az OOP technológia nyújtotta előnyök kihasználására, valamint igyekszik követni az OOP irányelveket és ajánlásokat.',
		a: 11,
		gT: 2404,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az objektumorientált programozás elvét, tisztában van az öröklődés, a polimorfizmus, a metódus/konstruktor túlterhelés fogalmával.',
		a: 11,
		gT: 2403,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Objektum orientált (OOP) programozási módszertant alkalmazó asztali, webes és mobil alkalmazást készít.',
		a: 11,
		gT: 2402,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb backend alkalmazásokat önállóan készít el, nagyobb projektekben részletes specifikációt követve, irányítás mellett végzi el a kijelölt komponensek fejlesztését.',
		a: 11,
		gT: 2401,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Igyekszik backend működését leíró precíz, a frontend fejlesztők számára könnyen értelmezhető dokumentáció készítésére.',
		a: 11,
		gT: 2400,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Érti a RESTful szoftverarchitektúra lényegét. Tisztában van legalább egy backend készítésére szolgáló nyelv vagy keretrendszer működési módjával, nyelvi és strukturális elemeivel. Alkalmazás szintjén ismeri az objektum-relációs leképzés technológiát (ORM).',
		a: 11,
		gT: 2399,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'RESTful alkalmazás adatbázis-kezelési feladatokat is ellátó szerveroldali komponensének (backend) fejlesztését végzi erre alkalmas nyelv vagy keretrendszer segítségével (pl. Node.js, Spring, Laravel).',
		a: 11,
		gT: 2398,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb frontend alkalmazásokat önállóan készít el, nagyobb projektekben irányítás mellett végzi el a kijelölt komponensek fejlesztését.',
		a: 11,
		gT: 2397,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik maximálisan kihasználni a választott keretrendszer előnyeit, követi az ajánlott fejlesztési mintákat.',
		a: 11,
		gT: 2396,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Érti a frontend fejlesztésre szolgáló JavaScript keretrendszerek célját. Meg tudja nevezni a 3-4 legelterjedtebb keretrendszert. Alkalmazás szintjén ismeri a könyvtárak és modulok kezelését végző csomagkezelő rendszereket (package manager, pl. npm, yarn). Ismeri a választott JavaScript keretrendszer működési elvét, nyelvi és strukturális elemeit.',
		a: 11,
		gT: 2395,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Webes környezetben futtatható kliens oldali (frontend) alkalmazást készít JavaScript keretrendszer (pl. React, Vue, Angular) segítségével.',
		a: 11,
		gT: 2394,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb projektek mobil eszközökre optimalizált kliens oldali alkalmazását önállóan megvalósítja meg.',
		a: 11,
		gT: 2393,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a felhasználó számára minél könnyebb használatot biztosító felhasználói felület és működési mód kialakítására.',
		a: 11,
		gT: 2392,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a választott mobil alkalmazás fejlesztésére alkalmas nyelvet és fejlesztői környezetet. Tisztában van a mobil alkalmazásfejlesztés alapelveivel.',
		a: 11,
		gT: 2391,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önálló- vagy komplex szoftverrendszerek részét képző kliens oldali alkalmazásokat fejleszt mobil eszközökre.',
		a: 11,
		gT: 2390,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb projektekhez néhány táblás adatbázist önállóan tervez meg, nagyobb projektekben a biztosított adatbáziskörnyezetet használva önállóan valósít meg lekérdezéseket.',
		a: 11,
		gT: 2389,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a redundanciamentes, világos szerkezetű, legcélravezetőbb kialakítású adatbázis szerkezet megvalósítására.',
		a: 11,
		gT: 2388,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a relációs adatbázis-tervezés és -kezelés alapelveivel. Haladó szinten ismeri a különböző típusú SQL lekérdezéseket, azok nyelvi elemeit és lehetőségeit.',
		a: 11,
		gT: 2387,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Adatkezelő alkalmazásokhoz relációs adatbázist tervez és hoz létre, többtáblás lekérdezéseket készít.',
		a: 11,
		gT: 2386,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb asztali alkalmazás-fejlesztési projekteken önállóan, összetettebbekben részfeladatokat megvalósítva, irányítás mellett dolgozik.',
		a: 11,
		gT: 2385,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a felhasználó számára minél könnyebb használatot biztosító felhasználói felület és működési mód kialakítására.',
		a: 11,
		gT: 2384,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a választott magas szintű programozási nyelv alapvető nyelvi elemeit, illetve a hozzá tartozó fejlesztési környezetet.',
		a: 11,
		gT: 2383,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Adatbázis-kezelést is végző konzolos vagy grafikus felületű asztali alkalmazást készít magas szintű programozási nyelvet (C#, Java) használva.',
		a: 11,
		gT: 2382,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik arra, hogy az elkészített kódja jól átlátható, és mások számára is értelmezhető legyen.',
		a: 11,
		gT: 2381,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a tiszta kód készítésének alapelveit.',
		a: 11,
		gT: 2380,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A tiszta kód elveinek megfelelő, megfelelő mennyiségű megjegyzéssel ellátott, kellőképpen tagolt, jól átlátható, kódot készít.',
		a: 11,
		gT: 2379,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a REST szoftverarchitektúra elvével, alkalmazás szintjén ismeri az AJAX technológiát.',
		a: 11,
		gT: 2378,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'RESTful alkalmazás kliens oldali komponensének fejlesztését végzi JavaScript nyelven.',
		a: 11,
		gT: 2377,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Egyszerűbb JavaScript programozási feladatokat önállóan végez el.',
		a: 11,
		gT: 2376,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Alkalmazási szinten ismeri a JavaScript alapvető nyelvi elemeit, valamint az aszinkron programozás és az AJAX technológia működési elvét. Tisztában van a legfrissebb ECMAScript változatok (ES6 vagy újabb) hatékonyság növelő funkcióival.',
		a: 11,
		gT: 2375,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Egyszerűbb webhelyek dinamikus viselkedését (eseménykezelés, animáció stb.) biztosító kódot, készít JavaScript nyelven.',
		a: 11,
		gT: 2374,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kisebb webfejlesztési projekteken önállóan, összetettebbekben részfeladatokat megvalósítva, irányítás mellett dolgozik.',
		a: 11,
		gT: 2373,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Törekszik a weblapok igényes és a használatot megkönnyítő kialakítására.',
		a: 11,
		gT: 2372,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a HTML5 és a CSS3 szabvány alapvető nyelvi elemeit és eszközeit (strukturális és szemantikus HTML-elemek, attribútumok, listák, táblázatok, stílus jellemzők és függvények). Ismeri a a reszponzív webdizájn alapelveit és a Bootstrap keretrendszer alapvető szolgáltatásait.',
		a: 11,
		gT: 2371,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Szabványos, reszponzív megjelenítést biztosító weblapokat hoz létre és formáz meg stíluslapok segítségével. Kereső optimalizálási beállításokat alkalmaz.',
		a: 11,
		gT: 2370,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Felelősségi körébe tartozó feladatokkal kapcsolatban a vállalati kommunikációs szabályokat betartva, önállóan kommunikál az ügyfelekkel és munkatársaival.',
		a: 11,
		gT: 2369,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Kommunikációjában konstruktív, együttműködő, udvarias. Feladatainak a felhasználói igényeknek leginkább megfelelő, minőségi megoldására törekszik.',
		a: 11,
		gT: 2368,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Angol nyelvismerettel rendelkezik (KER B1 szint). Ismeri a gyakran használt szakmai kifejezéseket angolul.',
		a: 11,
		gT: 2367,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a különböző kommunikációs formákra (e-mail, chat, telefon, prezentáció stb.) vonatkozó etikai és belső kommunikációs szabályokat.',
		a: 11,
		gT: 2366,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'A megfelelő kommunikációs forma (e-mail, chat, telefon, prezentáció stb.) kiválasztásával munkatársaival és az ügyfelekkel hatékonyan kommunikál műszaki és egyéb információkról magyarul és angolul.',
		a: 11,
		gT: 2365,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Önállóan dönt a fejlesztés során használt technológiákról és eszközökről.',
		a: 11,
		gT: 2364,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Nyitott az új technológiák megismerésére, tudását folyamatosan fejleszti.',
		a: 11,
		gT: 2363,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Elegendő ismerettel rendelkezik a meghatározó szoftverfejlesztési technológiák (programozási nyelvek, keretrendszerek, könyvtárak stb.), illetve módszerek erősségeiről és hátrányairól.',
		a: 11,
		gT: 2362,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Az általa végzett szoftverfejlesztési feladatok esetében kiválasztja a legmegfelelőbb technikákat, eljárásokat és módszereket.',
		a: 11,
		gT: 2361,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Szoftverfejlesztési projektekben irányítás alatt dolgozik, a rábízott részfeladatok megvalósításáért felelősséget vállal.',
		a: 11,
		gT: 2360,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Igyekszik munkatársaival hatékonyan, igazi csapatjátékosként együtt dolgozni. Törekszik a csoporton belül megkapott feladatok precíz, határidőre történő elkészítésére, társai segítésére.',
		a: 11,
		gT: 2359,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a legelterjedtebb csoportmunkaeszközöket, valamint a Git verziókezelőrendszer szolgáltatásait.',
		a: 11,
		gT: 2358,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Használja a Git verziókezelő rendszert, valamint a fejlesztést támogató csoportmunkaeszközöket és szolgáltatásokat (pl. GitHub, Slack, Trello, Microsoft Teams, Webex Teams).',
		a: 11,
		gT: 2357,
		b: 13,
		e2: 'Szoftverfejlesztés és -tesztelés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'szoftverfejlesztés és -tesztelés'])
	},
		{
		cG: 'code',
		gD: 'Megoldást keres a testtartási rendellenesség kialakulásának megakadályozására, erre társait is motiválja.',
		a: 9,
		gT: 2767,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'A szabadban végzett foglalkozások során nem csupán ügyel környezete tisztaságára és rendjére, hanem erre felhívja társai figyelmét is.',
		a: 9,
		gT: 2766,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Az életkorának és alkati paramétereinek megfelelő pozitív, egészégtudatos, testmozgással összefüggő táplálkozási szokásokat alakít ki.',
		a: 9,
		gT: 2765,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Mindennapi életének részeként kezeli a testmozgás, a sportolás közbeni higiéniai és tisztálkodási szabályok betartását.',
		a: 9,
		gT: 2764,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Ismer és alkalmaz alapvető relaxációs technikákat.',
		a: 9,
		gT: 2763,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'A családi háttere és a közvetlen környezete adta lehetőségeihez mérten, belső igénytől vezérelve, alkotó módon, rendszeresen végez testmozgást.',
		a: 9,
		gT: 2762,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'Önállóan, de tanári ellenőrzés mellett végez számára megfelelő uszodai tevékenységet.',
		a: 9,
		gT: 2761,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'A szárazföldi és az uszodai korrekciós gyakorlatait készségszinten sajátítja el, azokat tudatosan rögzíti.',
		a: 9,
		gT: 2760,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'Mindennapi tevékenységének tudatos részévé válik a korrekciós gyakorlatok végzése.',
		a: 9,
		gT: 2759,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'Belső igénytől vezérelve rendszeresen végez a biomechanikailag helyes testtartás kialakítását elősegítő gyakorlatokat.',
		a: 9,
		gT: 2758,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'Az egyéni képességeihez mérten, mindennapi szokásrendszerébe építve fejleszti keringési, légzési és mozgatórendszerét.',
		a: 9,
		gT: 2757,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'Megoldást keres a különböző veszély- és baleseti források elkerülésére, erre társait is motiválja.',
		a: 9,
		gT: 2756,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'code',
		gD: 'A szabályjátékok alkotó részese, képes szabálykövető játékvezetésre.',
		a: 9,
		gT: 2755,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'code',
		gD: 'A versengések és a versenyek közben közösségformáló, csapatkohéziót kialakító játékosként viselkedik.',
		a: 9,
		gT: 2754,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'code',
		gD: 'A versengések és a versenyek közben toleráns a csapattársaival és az ellenfeleivel szemben, ezt tőlük is elvárja.',
		a: 9,
		gT: 2753,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'code',
		gD: 'Játéktevékenységét kreativitást mutató játék- és együttműködési készség jellemzi.',
		a: 9,
		gT: 2752,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'code',
		gD: 'A tanult testnevelési, népi és sportjátékok összetett technikai és taktikai elemeit kreatívan, az adott játékhelyzetnek megfelelően, célszerűen, készségszinten alkalmazza.',
		a: 9,
		gT: 2751,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'code',
		gD: 'Önállóan képes az elkerülhetetlen vízi veszélyhelyzetek célszerű kezelésére.',
		a: 9,
		gT: 2750,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Az elsajátított egy (vagy több) úszásnemben vízbiztosan, készségszinten úszik, a természetes vizekben is.',
		a: 9,
		gT: 2749,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Rendszeresen mozog, edz, sportol a szabad levegőn, erre − lehetőségeihez mérten − társait is motiválja.',
		a: 9,
		gT: 2748,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'A különböző eséstechnikák készségszintű elsajátítása mellett a választott küzdősport speciális mozgásformáit célszerűen alkalmazza.',
		a: 9,
		gT: 2747,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Önállóan képes az életben adódó, elkerülhetetlen veszélyhelyzetek célszerű hárítására.',
		a: 9,
		gT: 2746,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'A zenei ütemnek megfelelően, készségszintű koordinációval végzi a kiválasztott ritmikus gimnasztika, illetve aerobik mozgásformákat.',
		a: 9,
		gT: 2745,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'A torna, ritmikus gimnasztika, aerobik és tánc jellegű mozgásformákon keresztül fejleszti esztétikai-művészeti tudatosságát és kifejezőképességét.',
		a: 9,
		gT: 2744,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Önállóan képes az általa kiválasztott elemkapcsolatokból tornagyakorlatot összeállítani, majd bemutatni.',
		a: 9,
		gT: 2743,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Képes a kiválasztott ugró- és dobótechnikákat az ilyen jellegű játékok, versengések és versenyek közben, az eredményesség érdekében, egyéni sajátosságaihoz formálva hatékonyan alkalmazni.',
		a: 9,
		gT: 2742,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'A rajtolási módokat a játékok, versenyek, versengések közben hatékonyan, kreatívan alkalmazza.',
		a: 9,
		gT: 2741,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'A korábbi évfolyamokon elért eredményeihez képest folyamatosan javítja futóteljesítményét, amelyet önmaga is tudatosan nyomon követ.',
		a: 9,
		gT: 2740,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'code',
		gD: 'Tanári ellenőrzés mellett digitálisan méri és értékeli a kondicionális és koordinációs képességeinek változásait, ezekből kiindulva felismeri saját motoros képességbeli hiányosságait, és ezeket a képességeket tudatosan és rendszeresen fejleszti.',
		a: 9,
		gT: 2739,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'A (meg)tanult erő-, gyorsaság-, állóképesség- és ügyességfejlesztő eljárásokat önállóan, tanári ellenőrzés nélkül alkalmazza.',
		a: 9,
		gT: 2738,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'A különböző sportágspecifikus mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten hajtja végre.',
		a: 9,
		gT: 2737,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Relatív erejének birtokában a tanult mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten kivitelezi.',
		a: 9,
		gT: 2736,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Olyan szintű motoros képességekkel rendelkezik, amelyek lehetővé teszik a tanult mozgásformák alkotó módon történő végrehajtását.',
		a: 9,
		gT: 2735,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Nyitott az alapvető és sportágspecifikus mozgásformák újszerű és alternatív környezetben történő felhasználására, végrehajtására.',
		a: 9,
		gT: 2734,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Sporttevékenységében spontán, automatikus forma- és szabálykövető attitűdöt követ.',
		a: 9,
		gT: 2733,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'A testedzéshez, a sportoláshoz kívánatosnak tartott jellemzőknek megfelelően (fegyelmezetten, határozottan, lelkiismeretesen, innovatívan és kezdeményezően) törekszik végrehajtani az elsajátított mozgásformákat.',
		a: 9,
		gT: 2732,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'A tanult mozgásformákat alkotó módon, a testedzés és a sportolás minden területén használja.',
		a: 9,
		gT: 2731,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Toleráns a testi és más fogyatékossággal élő személyek iránt, megismeri és tiszteletben tartja a szexuális kultúra alapelveit, elfogadja az egészségügyi szűrések és a környezetvédelem fontosságát.',
		a: 9,
		gT: 2730,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Társas-közösségi kapcsolatai, valamint stressztűrő és -kezelő képességei megfelelő szintre fejlődtek.',
		a: 9,
		gT: 2729,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Képes elhárítani a baleseti és veszélyforrásokat, magabiztosan segíteni és elsősegélyt nyújtani embertársainak.',
		a: 9,
		gT: 2728,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Megismeri és mindennapjai részévé teszi a mozgáshoz kapcsolódó helyes attitűdöket, a fizikailag aktív életmód és a társas-érzelmi jóllét élethosszig tartó jótékony hatásait.',
		a: 9,
		gT: 2727,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Alkotó módon használja a testnevelés életkorához igazodó ismeretanyagát, szakkifejezéseit, helyes terminológiáját.',
		a: 9,
		gT: 2726,
		b: 13,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'code',
		gD: 'Felismeri, hogy a jelen társadalmi, gazdasági, politikai és kulturális viszonyai a múltbeli események, tényezők következményeiként alakultak ki.',
		a: 9,
		gT: 2913,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Feltevéseket fogalmaz meg, azok mellett érveket gyűjt, illetve mérlegeli az ellenérveket.',
		a: 9,
		gT: 2912,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Összehasonlítja és kritikusan értékeli az egyes történelmi folyamatokkal, eseményekkel és személyekkel kapcsolatos eltérő álláspontokat.',
		a: 9,
		gT: 2911,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Képes felismerni konkrét történelmi helyzetekben, jelenségekben és folyamatokban valamely általános szabályszerűség érvényesülését.',
		a: 9,
		gT: 2910,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Összehasonlít különböző, egymáshoz hasonló történeti helyzeteket, folyamatokat, jelenségeket.',
		a: 9,
		gT: 2909,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Képes összevetni, csoportosítani és súlyozni az egyes történelmi folyamatok, jelenségek, események okait, következményeit, és ítéletet alkotni azokról, valamint a benne résztvevők szándékairól.',
		a: 9,
		gT: 2908,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'A változás és a fejlődés fogalma közötti különbséget ismerve képes felismerni és bemutatni azokat azonos korszakon belül, vagy azokon átívelően.',
		a: 9,
		gT: 2907,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Képes különböző élethelyzetek, magatartásformák megfigyelése által következtetések levonására, erkölcsi kérdéseket is felvető történelmi helyzetek felismerésére és megítélésére.',
		a: 9,
		gT: 2906,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Önálló véleményt tud alkotni történelmi eseményekről, folyamatokról, jelenségekről és személyekről.',
		a: 9,
		gT: 2905,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Önálló kérdéseket fogalmaz meg történelmi folyamatok, jelenségek és események feltételeiről, okairól és következményeiről.',
		a: 9,
		gT: 2904,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Hipotéziseket alkot történelmi személyek, társadalmi csoportok és intézmények viselkedésének mozgatórugóiról.',
		a: 9,
		gT: 2903,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'A tanult ismereteket problémaközpontúan tudja rendezni.',
		a: 9,
		gT: 2902,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Képes felismerni, megfogalmazni és összehasonlítani különböző társadalmi és történelmi problémákat, értékrendeket, jelenségeket, folyamatokat.',
		a: 9,
		gT: 2901,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'code',
		gD: 'Társaival képes megvitatni történelmi kérdéseket, amelynek során bizonyítékokon alapuló érvekkel megindokolja a véleményét, és választékosan reflektál mások véleményére, árnyalja saját álláspontját.',
		a: 9,
		gT: 2900,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Megadott szempontok alapján történelmi tárgyú szerkesztett szöveget (esszét) tud alkotni, amelynek során tételmondatokat fogalmaz meg, állításait több szempontból indokolja és következtetéseket von le.',
		a: 9,
		gT: 2899,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Történelmi tárgyú folyamatábrákat, digitális táblázatokat, diagramokat készít, történelmi, gazdasági, társadalmi és politikai modelleket vizuálisan is meg tud jeleníteni.',
		a: 9,
		gT: 2898,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Történelmi témáról kiselőadást, digitális prezentációt alkot és mutat be.',
		a: 9,
		gT: 2897,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Képes egy-egy korszakot átfogó módon bemutatni.',
		a: 9,
		gT: 2896,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Képes önállóan vázlatot készíteni és jegyzetelni.',
		a: 9,
		gT: 2895,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Össze tudja foglalni rövid és egyszerű szaktudományos szöveg tartalmát.',
		a: 9,
		gT: 2894,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Képes kiválasztani, rendezni és alkalmazni az azonos korhoz, témához kapcsolható fogalmakat.',
		a: 9,
		gT: 2893,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Fel tud ismerni fontosabb történelmi fogalmakat meghatározás alapján.',
		a: 9,
		gT: 2892,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Képes a történelmi jelenségeket általános és konkrét történelmi fogalmak, tartalmi és értelmező kulcsfogalmak felhasználásával értelmezni és értékelni.',
		a: 9,
		gT: 2891,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'code',
		gD: 'Képes különböző időszakok történelmi térképeinek összehasonlítására, a történelmi tér változásainak és a történelmi mozgások követésére megadott szempontok alapján a változások hátterének feltárásával.',
		a: 9,
		gT: 2890,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'A földrajzi környezet és a történeti folyamatok összefüggéseit példákkal képes alátámasztani.',
		a: 9,
		gT: 2889,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Egyszerű történelmi térképvázlatot alkot hagyományos és digitális eljárással.',
		a: 9,
		gT: 2888,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Felismeri, hogy a magyar történelem az európai történelem része, és példákat tud hozni a magyar és európai történelem kölcsönhatásaira.',
		a: 9,
		gT: 2887,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Képes azonosítani a tanult egyetemes és magyar történelmi személyiségek közül a kortársakat.',
		a: 9,
		gT: 2886,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Össze tudja hasonlítani megadott szempontok alapján az egyes történelmi korszakok, időszakok jellegzetességeit az egyetemes és a magyar történelem egymáshoz kapcsolódó eseményeit.',
		a: 9,
		gT: 2885,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Az egyes események, folyamatok idejét konkrét történelmi korhoz, időszakhoz kapcsolja vagy viszonyítja, ismeri néhány kiemelten fontos esemény, jelenség időpontját, kronológiát használ és készít.',
		a: 9,
		gT: 2884,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar és az európai történelem tanult történelmi korszakait, időszakait, és képes azokat időben és térben elhelyezni.',
		a: 9,
		gT: 2883,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'code',
		gD: 'Képes kiválasztani a megfelelő forrást valamely történelmi állítás, vélemény alátámasztására vagy cáfolására.',
		a: 9,
		gT: 2882,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Összehasonlítja a forrásokban talált információkat saját ismereteivel, illetve más források információival és megmagyarázza az eltérések okait.',
		a: 9,
		gT: 2881,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Képes a szándékainak megfelelő információkat kiválasztani különböző műfajú forrásokból.',
		a: 9,
		gT: 2880,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Képes azonosítani a különböző források szerzőinek a szándékát, bizonyítékok alapján értékeli egy forrás hitelességét.',
		a: 9,
		gT: 2879,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Tud forráskritikát végezni és különbséget tenni a források között hitelesség, típus és szövegösszefüggés alapján.',
		a: 9,
		gT: 2878,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Önállóan információkat tud gyűjteni, áttekinteni, rendszerezni és értelmezni különböző médiumokból és írásos vagy képi forrásokból, statisztikákból, diagramokból, térképekről, nyomtatott és digitális felületekről.',
		a: 9,
		gT: 2877,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Önállóan tud használni általános és történelmi, nyomtatott és digitális információforrásokat (tankönyv, kézikönyvek, szakkönyvek, lexikonok, képzőművészeti alkotások, könyvtár és egyéb adatbázisok, filmek, keresők).',
		a: 9,
		gT: 2876,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'code',
		gD: 'Ismeri hazája államszervezetét, választási rendszerét.',
		a: 9,
		gT: 2875,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyarság, illetve a kárpát-medence népei együttélésének jellemzőit, példákat hoz a magyar nemzet és a közép-európai régió népeinek kapcsolatára, különös tekintettel a visegrádi együttműködésre.',
		a: 9,
		gT: 2874,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar cigányság történetének főbb állomásait, bemutatja jelenkori helyzetét.',
		a: 9,
		gT: 2873,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja a határon túli magyarság helyzetét, a megmaradásért való küzdelmét trianontól napjainkig.',
		a: 9,
		gT: 2872,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és reálisan látja a többpólusú világ jellemzőit napjainkban, elhelyezi magyarországot a globális világ folyamataiban.',
		a: 9,
		gT: 2871,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja a gyarmati rendszer felbomlásának következményeit, india, kína és a közel-keleti régió helyzetét és jelentőségét.',
		a: 9,
		gT: 2870,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja a kommunista diktatúra magyarországi kiépítését, működését és változatait, az 1956-os forradalom és szabadságharc okait, eseményeit és hőseit, összefüggéseiben szemléli a rendszerváltoztatás folyamatát, felismerve annak történelmi jelentőségét.',
		a: 9,
		gT: 2869,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Össze tudja hasonlítani a nyugati demokratikus világ és a kommunista szovjet blokk politikai és társadalmi berendezkedését, képes jellemezni a hidegháború időszakát, bemutatni a gyarmati rendszer felbomlását és az európai kommunista rendszerek összeomlását.',
		a: 9,
		gT: 2868,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja magyarország revíziós lépéseit, a háborús részvételét, az ország német megszállását, a magyar zsidóság tragédiáját, a szovjet megszállást, a polgári lakosság szenvedését, a hadifoglyok embertelen sorsát.',
		a: 9,
		gT: 2867,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Képes felidézni a második világháború okait, a háború jellemzőit és fontosabb fordulópontjait, ismeri a holokausztot és a hozzávezető okokat.',
		a: 9,
		gT: 2866,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Össze tudja hasonlítani a nemzetiszocialista és a kommunista ideológiát és diktatúrát, példák segítségével bemutatja a rendszerek embertelenségét és a velük szembeni ellenállás formáit.',
		a: 9,
		gT: 2865,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Tisztában van a trianoni békediktátum tartalmával és következményeivel, be tudja mutatni az ország talpra állását, a horthy-korszak politikai, gazdasági, társadalmi és kulturális viszonyait, felismeri a magyar külpolitika mozgásterének korlátozottságát.',
		a: 9,
		gT: 2864,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Képes felidézni azokat az okokat és körülményeket, amelyek a történelmi magyarország felbomlásához vezettek.',
		a: 9,
		gT: 2863,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja az első világháború magyar vonatkozásait, a háborús vereség következményeit; példákat tud hozni a háborús helytállásra.',
		a: 9,
		gT: 2862,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Fel tudja idézni az első világháború előzményeit, a háború jellemzőit és fontosabb fordulópontjait, értékeli a háborúkat lezáró békék tartalmát, és felismeri a háborúnak a 20. század egészére gyakorolt hatását.',
		a: 9,
		gT: 2861,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Fel tudja idézni az ipari forradalom szakaszait, illetve azok gazdasági, társadalmi, kulturális és politikai hatásait; képes bemutatni a modern polgári társadalom és állam jellemzőit és a 19. század főbb politikai eszméit, valamint felismeri a hasonlóságot és különbséget azok mai formái között.',
		a: 9,
		gT: 2860,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri és értékeli a magyar nemzetnek a polgári átalakulás és nemzeti függetlenség elérésére tett erőfeszítéseit a reformkor, az 1848/49-es forradalom és szabadságharc, illetve az azt követő időszakban; a kor kiemelkedő magyar politikusait és azok nézeteit, véleményt tud formálni a kiegyezésről.',
		a: 9,
		gT: 2859,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Összefüggéseiben és folyamatában fel tudja idézni, miként hatott a magyar történelemre a habsburg birodalomhoz való tartozás, bemutatja az együttműködés és konfrontáció megnyilvánulásait, a függetlenségi törekvéseket és értékeli a rákóczi-szabadságharc jelentőségét.',
		a: 9,
		gT: 2858,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Be tudja mutatni a kora újkor fő gazdasági és társadalmi folyamatait, ismeri a felvilágosodás eszméit, illetve azok kulturális és politikai hatását, valamint véleményt formál a francia forradalom európai hatásáról.',
		a: 9,
		gT: 2857,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyarság törökellenes küzdelmeit, fordulópontjait és hőseit; felismeri, hogy a magyar és az európai történelem alakulását meghatározóan befolyásolta a török megszállás.',
		a: 9,
		gT: 2856,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felidézi a középkori magyar állam történetének fordulópontjait, legfontosabb uralkodóink tetteit.',
		a: 9,
		gT: 2855,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Értékeli az államalapítás, valamint a kereszténység felvételének jelentőségét.',
		a: 9,
		gT: 2854,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a magyar nép őstörténetére és a honfoglalásra vonatkozó tudományos elképzeléseket és tényeket, tisztában van legfőbb vitatott kérdéseivel, a különböző tudományterületek kutatásainak főbb eredményeivel.',
		a: 9,
		gT: 2853,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Képes felidézni a középkor gazdasági és kulturális jellemzőit, világképét, a kor meghatározó birodalmait és bemutatni a rendi társadalmat.',
		a: 9,
		gT: 2852,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Bemutatja a keresztény vallás civilizációformáló hatását, a középkori egyházat, valamint a reformáció és a katolikus megújulás folyamatát és kulturális hatásait; érvel a vallási türelem, illetve a vallásszabadság mellett.',
		a: 9,
		gT: 2851,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Felidézi a monoteista vallások kialakulását, legfontosabb jellemzőiket, tanításaik főbb elemeit, és bemutatja terjedésüket.',
		a: 9,
		gT: 2850,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Ismeri az ókori civilizációk legfontosabb jellemzőit, valamint az athéni demokrácia és a római állam működését, hatásukat az európai civilizációra.',
		a: 9,
		gT: 2849,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'code',
		gD: 'Megerősödik és elmélyül a társadalmi felelősség és normakövetés, az egyéni kezdeményezőkészség, a hazája, közösségei és embertársai iránt való felelősségvállalás, valamint a demokratikus elkötelezettség.',
		a: 9,
		gT: 2848,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Megerősödnek az európai civilizációs identitás alapelemei.',
		a: 9,
		gT: 2847,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Elmélyül a nemzeti identitás és hazaszeretet, büszke népe múltjára, ápolja hagyományait, és méltón emlékezik meg hazája nagyjairól.',
		a: 9,
		gT: 2846,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Kialakulnak a saját értékrend és történelemszemlélet alapjai.',
		a: 9,
		gT: 2845,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Kialakul és megerősödik a történelmi múlt, illetve a társadalmi, politikai, gazdasági és kulturális kérdések iránti érdeklődés.',
		a: 9,
		gT: 2844,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a demokratikus államszervezet működését, a társadalmi együttműködés szabályait, a piacgazdaság alapelveit; autonóm és felelős állampolgárként viselkedik.',
		a: 9,
		gT: 2843,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Képes a múlt eseményeit és jelenségeit a saját történelmi összefüggésükben értelmezni, illetve a jelen viszonyait kapcsolatba hozni a múltban történtekkel.',
		a: 9,
		gT: 2842,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Kialakul a hiteles és tárgyilagos forráshasználat és kritika igénye.',
		a: 9,
		gT: 2841,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Képes a tanulási célhoz megfelelő információforrást választani, a források között szelektálni, azokat szakszerűen feldolgozni és értelmezni.',
		a: 9,
		gT: 2840,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Képes következtetni történelmi események, folyamatok és jelenségek okaira és következményeire.',
		a: 9,
		gT: 2839,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Különbséget tud tenni történelmi tények és történelmi interpretáció, illetve vélemény között.',
		a: 9,
		gT: 2838,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Ismeri a közös magyar nemzeti és európai, valamint az egyetemes emberi civilizáció kulturális örökségének, kódrendszerének lényeges elemeit.',
		a: 9,
		gT: 2837,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Képes a múlt és jelen társadalmi, gazdasági, politikai és kulturális folyamatairól, jelenségeiről többszempontú, tárgyilagos érveléssel alátámasztott véleményt alkotni, ezekkel kapcsolatos problémákat megfogalmazni.',
		a: 9,
		gT: 2836,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'code',
		gD: 'Megbízható ismeretekkel bír az európai, valamint az egyetemes történelem és mélyebb tudással rendelkezik a magyar történelem fontosabb eseményeiről, történelmi folyamatairól, fordulópontjairól.',
		a: 9,
		gT: 2835,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'A tanulási tevékenységek szakaszaiban használja az infokommunikációs eszközöket, lehetőségeket, tisztában van azok szerepével, innovációs potenciáljával és veszélyeivel is.',
		a: 12,
		gT: 71,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Megismerkedik a tudatos médiafogyasztói magatartással és a közösségi média használatával.',
		a: 12,
		gT: 70,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Tiszteletben tartja a másik ember értékvilágát, gondolatait és véleményét, ha szükséges, kritikusan viszonyul emberi cselekedetekhez, magatartásformákhoz.',
		a: 12,
		gT: 69,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy társaival együttműködve javaslatokat fogalmaz meg.',
		a: 12,
		gT: 68,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Képes arra, hogy feladatait akár önálló, akár társas tanulás révén végezze el, célorientáltan képes az együttműködésre.',
		a: 12,
		gT: 67,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a véleménynyilvánítás, érvelés, a párbeszéd és a vita társadalmi hasznosságát.',
		a: 12,
		gT: 66,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a vállalkozás indítását befolyásoló tényezőket.',
		a: 12,
		gT: 65,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Életvitelébe beépülnek a tudatos fogyasztás elemei, életmódjában figyelmet fordít a környezeti terhelés csökkentésére, érvényesíti a fogyasztóvédelmi szempontokat.',
		a: 12,
		gT: 64,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megérti a közteherviselés nemzetgazdasági, társadalmi és morális jelentőségét.',
		a: 12,
		gT: 63,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az állam gazdasági szerepvállalásának elemeit.',
		a: 12,
		gT: 62,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a megalapozott, körültekintő hitelfelvétel szempontjait, illetve feltételeit.',
		a: 12,
		gT: 61,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Saját pénzügyi döntéseit körültekintően, megalapozottan hozza meg.',
		a: 12,
		gT: 60,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megtervezi egy fiktív család költségvetését.',
		a: 12,
		gT: 59,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a munkavállalással kapcsolatos szabályokban.',
		a: 12,
		gT: 58,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Életkori sajátosságainak megfelelően jártasságot szerez a jog területének mindennapi életben való alkalmazásában.',
		a: 12,
		gT: 57,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a mindennapi ügyintézés alapintézményeit.',
		a: 12,
		gT: 56,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és értékeli a helyi, regionális és országos közgyűjtemények nemzeti kulturális örökség megőrzésében betöltött szerepét.',
		a: 12,
		gT: 55,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése, a honvédelem szerepének, feladatainak és lehe'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és felismeri a honvédelem mint nemzeti ügy jelentőségét.',
		a: 12,
		gT: 54,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése, a honvédelem szerepének, feladatainak és lehe'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a világ magyarsága mint nemzeti közösség összetartozásának jelentőségét.',
		a: 12,
		gT: 53,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése, a honvédelem szerepének, feladatainak és lehe'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményt alkot a nemzetállamok és a globalizáció összefüggéseiről.',
		a: 12,
		gT: 52,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése, a honvédelem szerepének, feladatainak és lehe'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nemzeti érzület sajátosságait és a hazafiság fontosságát, lehetséges megnyilvánulási formáit.',
		a: 12,
		gT: 51,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése, a honvédelem szerepének, feladatainak és lehe'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a törvényalkotás folyamatát.',
		a: 12,
		gT: 50,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a választójog feltételeit és a választások alapelveit.',
		a: 12,
		gT: 49,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és értelmezi az igazságosság, az esélyegyenlőség biztosításának jelentőségét és követelményeit.',
		a: 12,
		gT: 48,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a honvédelem szerepét az ország biztonságának fenntartásában, megismeri a haza védelmének legfontosabb feladatcsoportjait és területeit, az egyén kötelezettségeit.',
		a: 12,
		gT: 47,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a társadalmi normák és az egyéni cselekedetek, akaratok, célok egyeztetésének, összehangolásának követelményét. elméleti és tapasztalati úton ismereteket szerez a társadalmi felelősségvállalásról, a segítségre szorulók támogatásának lehetőségeiről.',
		a: 12,
		gT: 46,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja magyarország alaptörvényének legfontosabb részeit: alapvetés; az állam; szabadság és felelősség.',
		a: 12,
		gT: 45,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az alapvető emberi jogok egyetemes és társadalmi jelentőségét.',
		a: 12,
		gT: 44,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a családi szocializációnak az ember életútját befolyásoló jelentőségét.',
		a: 12,
		gT: 43,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és a családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy a családtagok milyen szerepet töltenek be a szocializáció folyamatában.',
		a: 12,
		gT: 42,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és a családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival megbeszéli a párválasztás, a családtervezés fontos szakaszait, szempontjait és a gyermekvállalás demográfiai jelentőségét: tájékozódás, minták, orientáló példák, átgondolt tervezés, felelősség.',
		a: 12,
		gT: 41,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és a családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a család mint a társadalom alapvető intézményének szerepét és jellemzőit.',
		a: 12,
		gT: 40,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és a családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a munka világát érintő alapvető jogi szabályozást, a munkaerőpiac jellemzőit, tájékozódik a foglalkoztatás és a szakmaszerkezet változásairól.',
		a: 12,
		gT: 39,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az életpálya-tervezés és a munkavállalás egyéni és társadalmi jelentőségét.',
		a: 12,
		gT: 38,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Saját pénzügyeiben tudatos döntéseket hoz.',
		a: 12,
		gT: 37,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'A mindennapi életének megszervezésében alkalmazza a jogi és gazdasági-pénzügyi ismereteit.',
		a: 12,
		gT: 36,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és vallja a haza védelmének, a nemzetért történő tenni akarás fontosságát.',
		a: 12,
		gT: 35,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a demokratikus jogállam működésének alapvető sajátosságait.',
		a: 12,
		gT: 34,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a választások alapelveit és a törvényhozás folyamatát.',
		a: 12,
		gT: 33,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli a nemzeti identitás jelentőségét az egyén és a közösség szempontjából is.',
		a: 12,
		gT: 32,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a család szerepét, alapvető feladatait az egyén és a nemzet szempontjából egyaránt.',
		a: 12,
		gT: 31,
		b: 12,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy segítséggel használja az infokommunikációs eszközöket.',
		a: 8,
		gT: 30,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy társaival együttműködve javaslatokat fogalmaz meg, tervet, tervezetet készít.',
		a: 8,
		gT: 29,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Képes arra, hogy feladatai egy részét a társas tanulás keretében végezze el.',
		a: 8,
		gT: 28,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a véleménynyilvánítás, érvelés, a párbeszéd és a vita társadalmi hasznosságát.',
		a: 8,
		gT: 27,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a társas együttműködés és a kommunikációs kultúra fejlesztése, a véleményalkotás támogatása'])
	},
		{
		cG: 'altgim',
		gD: 'Fogyasztási szokásaiban érvényesíti a tudatosság szempontjait is.',
		a: 8,
		gT: 26,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a közteherviselés gazdasági, társadalmi és erkölcsi jelentőségét, a társadalmi felelősségvállalás fontosságát.',
		a: 8,
		gT: 25,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az állam gazdasági szerepvállalásának területeit.',
		a: 8,
		gT: 24,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a családi háztartás gazdasági-pénzügyi fenntarthatóságának és a környezettudatos életvitel kialakításának társadalmi jelentőségét.',
		a: 8,
		gT: 23,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a családi háztartás összetevőit, értelmezi a család gazdálkodását meghatározó és befolyásoló tényezőket.',
		a: 8,
		gT: 22,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a fenntarthatóság és a pénzügyi tudatosság szemléletének és gyakorlatának továbbfejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Információkat gyűjt és értelmez a foglalkoztatási helyzetről, a szakmaszerkezet változásairól.',
		a: 8,
		gT: 21,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és értelmezi a diákmunka alapvető jogi feltételeit, kereteit.',
		a: 8,
		gT: 20,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az igazságszolgáltatás intézményeit és működésük jellemzőit, megismeri az alapvető ellátórendszereket és funkcióikat.',
		a: 8,
		gT: 19,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a mindennapi ügyintézés alapintézményeit, az alapvető ellátó rendszerek funkcióját és működési sajátosságait.',
		a: 8,
		gT: 18,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'felkészülés a felnőtt szerepekre'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és értelmezi a honvédelem jelentőségét, feladatait és szerepét.',
		a: 8,
		gT: 17,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a nemzetek, nemzetállamok fontosságát a globális világban.',
		a: 8,
		gT: 16,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a nemzeti identitás jelentőségét az egyén és a közösség szempontjából is.',
		a: 8,
		gT: 15,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri településének, lakóhelyének kulturális, néprajzi értékeit, a település történetének alapvető eseményeit és fordulópontjait.',
		a: 8,
		gT: 14,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a jogok és kötelességek közötti egyensúly kialakításának és fenntartásának fontosságát, megismeri a haza iránti kötelezettségeit, feladatait.',
		a: 8,
		gT: 13,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és a felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'A lakóhelyével kapcsolatos javaslatokat fogalmaz meg, tervet készít a település fejlesztésének lehetőségeiről.',
		a: 8,
		gT: 12,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és a felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a saját településének, lakóhelyének alapvető jellemzőit, értelmezi a településen működő intézmények és szervezetek szerepét és működését.',
		a: 8,
		gT: 11,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és a felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a törvényalkotás folyamatát.',
		a: 8,
		gT: 10,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és a felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar állam alapvető intézményeinek feladatkörét és működését.',
		a: 8,
		gT: 9,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az aktív társadalmi cselekvés és a felelős állampolgári magatartás megalapozása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a családi szocializációnak az ember életútját befolyásoló jelentőségét.',
		a: 8,
		gT: 8,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a családi kohézió alapelemeit, jellemzőit: együttműködés, szeretetközösség, kölcsönösség, tisztelet.',
		a: 8,
		gT: 7,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a család mint a társadalom alapvető intézményének szerepét és jellemzőit.',
		a: 8,
		gT: 6,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'az egyéni és családi szocializáció segítése'])
	},
		{
		cG: 'altgim',
		gD: 'Saját pénzügyeiben tudatos döntéseket hoz.',
		a: 8,
		gT: 5,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Jártasságot szerez mindennapi ügyeinek intézésében.',
		a: 8,
		gT: 4,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a demokratikus jogállam működésének alapvető sajátosságait, alapvető kötelezettségeit.',
		a: 8,
		gT: 3,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Lokálpatriotizmusa megerősödik, személyiségébe beépülnek a nemzeti közösséghez tartozás, a hazaszeretet emocionális összetevői.',
		a: 8,
		gT: 2,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a család, mint a társadalom alapvető intézményének szerepét, és értelmezi jellemzőit.',
		a: 8,
		gT: 1,
		b: 8,
		e2: 'Állampolgári ismeretek',
		jE: _List_fromArray(
			['állampolgári ismeretek', 'átfogó célként kitűzött tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kárpát-medence élővilágának sajátosságait, megőrzendő értékeit, ezeket összekapcsolja a hazai nemzeti parkok tevékenységével.',
		a: 9,
		gT: 161,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a föld és a kárpát-medence értékei'])
	},
		{
		cG: 'altgim',
		gD: 'Érvel a föld, mint élő bolygó egyedisége mellett, tényekre alapozottan és kritikusan értékeli a természeti okokból és az emberi hatásokra bekövetkező változásokat.',
		a: 9,
		gT: 160,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a föld és a kárpát-medence értékei'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a biotechnológiai eljárások és a bionika eredményeinek alkalmazási lehetőségeit, értékeli az információs technológiák alkalmazásának orvosi, biológiai jelentőségét.',
		a: 9,
		gT: 159,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a fenntartható életvitel, technológia és gazdálkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Történeti adatok és jelenkori esettanulmányok alapján értékeli a mezőgazdaság, erdő- és vadgazdaság, valamint a halászat természetes életközösségekre gyakorolt hatását, példák alapján bemutatja az ökológiai szempontú, fenntartható gazdálkodás technológiai lehetőségeit.',
		a: 9,
		gT: 158,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a fenntartható életvitel, technológia és gazdálkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli a környezet- és természetvédelem fontosságát, megérti a nemzetközi összefogások és a hazai törekvések jelentőségét, döntéshozatalai során saját személyes érdekein túl a természeti értékeket és egészség-megőrzési szempontokat is mérlegeli.',
		a: 9,
		gT: 157,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a fenntartható életvitel, technológia és gazdálkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és elfogadja, hogy a jövőbeli folyamatokat a jelen cselekvései alakítják, tudja, hogy a folyamatok tervezése, előrejelzése számítógépes modellek alapján lehetséges.',
		a: 9,
		gT: 156,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'a fenntartható életvitel, technológia és gazdálkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján elemzi a levegő-, a víz- és a talajszennyeződés, az ipari és természeti katasztrófák okait és ezek következményeit, az emberi tevékenységnek az élőhelyek változásához vezető hatását, ennek alapján magyarázza egyes fajok veszélyeztetettségét.',
		a: 9,
		gT: 155,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'az emberi tevékenység hatása a bioszférára'])
	},
		{
		cG: 'altgim',
		gD: 'A kutatások adatai és előrejelzései alapján értelmezi a globális éghajlatváltozás élővilágra gyakorolt helyi és bioszféra szintű következményeit.',
		a: 9,
		gT: 154,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'az emberi tevékenység hatása a bioszférára'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét példák alapján vizsgálja a bioszférában végbemenő folyamatokat, elemzi ezek idő- és térbeli viszonyait, azonosítja az emberi tevékenységgel való összefüggésüket.',
		a: 9,
		gT: 153,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a fenntarthatóság elve, szempontjai', 'az emberi tevékenység hatása a bioszférára'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az ökológiai rendszerek működése és a biológiai sokféleség közötti kapcsolatot, konkrét életközösségek vizsgálata alapján táplálkozási piramist, hálózatot elemez.',
		a: 9,
		gT: 152,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az életközösségek biológiai sokfélesége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az ökológiai egyensúly fogalmát, értékeli a jelentőségét, példákkal igazolja az egyensúly felborulásának lehetséges következményeit.',
		a: 9,
		gT: 151,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az életközösségek biológiai sokfélesége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a biológiai sokféleség fogalmát, ismer a meghatározásra alkalmas módszereket, értékeli a bioszféra stabilitásának megőrzésében játszott szerepét.',
		a: 9,
		gT: 150,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az életközösségek biológiai sokfélesége'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a természetes élőhelyeket veszélyeztető tényezőket, kifejti álláspontját az élőhelyvédelem szükségességéről, egyéni és társadalmi megvalósításának lehetőségeiről.',
		a: 9,
		gT: 149,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyi környezethez való alkalmazkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és példákkal igazolja az állatok viselkedésének a környezethez való alkalmazkodásban játszott szerepét.',
		a: 9,
		gT: 148,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyi környezethez való alkalmazkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a levegő-, a víz- és a talajszennyezés forrásait, a szennyező anyagok típusait és példáit, konkrét esetek alapján elemzi az életközösségekre gyakorolt hatásukat.',
		a: 9,
		gT: 147,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyek jellemzői, a populációk közötti kapcsolatok'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az ökológiai mutatókkal, bioindikációs vizsgálatokkal megvalósuló környezeti állapotelemzések céljait, adott esetben alkalmazza azok módszereit.',
		a: 9,
		gT: 146,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyek jellemzői, a populációk közötti kapcsolatok'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyelések, leírások és videók alapján azonosítja a populációk közötti kölcsönhatások típusait, az ezzel összefüggő etológiai jellemzőket, bemutatja ezek jellegét, jelentőségét.',
		a: 9,
		gT: 145,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyek jellemzői, a populációk közötti kapcsolatok'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal mutatja be a fontosabb hazai szárazföldi és vizes életközösségek típusait, azok jellemzőit és előfordulásait.',
		a: 9,
		gT: 144,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata', 'az élőhelyek jellemzői, a populációk közötti kapcsolatok'])
	},
		{
		cG: 'altgim',
		gD: 'Szükség esetén alkalmazza a felnőtt alapszintű újraélesztés műveleteit (cpr), képes a félautomata defibrillátort alkalmazni.',
		a: 9,
		gT: 143,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a sérült vagy beteg személy ellátását a rendelkezésre álló eszközökkel (vagy eszköz nélkül) megkezdeni, segítséget (szükség esetén mentőt) hívni.',
		a: 9,
		gT: 142,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a bekövetkezett balesetet, rosszullétet felismerni,',
		a: 9,
		gT: 141,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a leggyakoribb népbetegségek (pl. szívinfarktus, stroke, cukorbetegség, allergia, asztma) kockázati tényezőit, felismeri ezek kezdeti tüneteit.',
		a: 9,
		gT: 140,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a leggyakoribb fertőző betegségek kiváltó okait, ismeri a fertőzések elkerülésének lehetőségeit és a járványok elleni védekezés módjait.',
		a: 9,
		gT: 139,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a házi- és a szakorvosi ellátás funkcióit, ismeri az orvoshoz fordulás módját, tisztában van a kórházi ellátás indokaival, jellemzőivel.',
		a: 9,
		gT: 138,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az orvosi diagnosztika, a szűrővizsgálatok és védőoltások célját, lényegét, értékeli ezek szerepét a betegségek megelőzésében és a gyógyulásban.',
		a: 9,
		gT: 137,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az egészségügyi rendszer ismerete, elsősegélynyújtás'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai folyamatok alapján magyarázza a függőség kialakulását, felismeri a függőségekre vezető tényezőket, ezek kockázatait és következményeit.',
		a: 9,
		gT: 136,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'Az agy felépítése és funkciója alapján magyarázza az információk feldolgozásával, a tanulással összefüggő folyamatokat, értékeli a tanulási képesség jelentőségét az egyén és a közösség szempontjából.',
		a: 9,
		gT: 135,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az idegsejtek közötti jelátviteli folyamatokat, és kapcsolatba hozza azokat a tanulás és emlékezés folyamataival, a drogok hatásmechanizmusával.',
		a: 9,
		gT: 134,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mentális egészség jellemzőit, megérti annak feltételeit, ezek alapján megtervezi az egészségmegőrző magatartásához szükséges életviteli elemeket.',
		a: 9,
		gT: 133,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a gondolkodási folyamatokat és az érzelmi és motivációs működéseket meghatározó tényezőket, értékeli az érzelmi és az értelmi fejlődés kapcsolatát.',
		a: 9,
		gT: 132,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'A biológiai működések alapján magyarázza a stressz fogalmát, felismeri a tartós stressz egészségre gyakorolt káros hatásait, igyekszik azt elkerülni, csökkenteni.',
		a: 9,
		gT: 131,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'a lelki egyensúly és a testi állapot összefüggése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fogamzás feltételeit, a terhesség jeleit, bemutatja a magzat fejlődésének szakaszait, értékeli a terhesség alatti egészséges életmód jelentőségét.',
		a: 9,
		gT: 130,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi nemek és a szaporodás biológiai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a fogamzásgátlók hatékonyságáról szóló információkat, a személyre szabott, orvosilag ellenőrzött fogamzásgátlás fontosságát.',
		a: 9,
		gT: 129,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi nemek és a szaporodás biológiai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai ismereteit is figyelembe véve értékeli az emberi szexualitás párkapcsolattal és a tudatos családtervezéssel összefüggő jelentőségét.',
		a: 9,
		gT: 128,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi nemek és a szaporodás biológiai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a férfi és a női nemi szervek felépítését és működését, a másodlagos nemi jellegeket és azok kialakulási folyamatát, ismereteit összekapcsolja a szaporító szervrendszer egészségtanával.',
		a: 9,
		gT: 127,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi nemek és a szaporodás biológiai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Felsorolja az emberi egyedfejlődés főbb szakaszait, magyarázza hogyan és miért változik a szervezetünk az életkor előrehaladásával, értékeli a fejlődési szakaszok egészségvédelmi szempontjait, önmagát is elhelyezve ebben a rendszerben.',
		a: 9,
		gT: 126,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'Az ideg-, hormon- és immunrendszer elemzése alapján magyarázza az emberi szervezet információs rendszerének biológiai alapjait.',
		a: 9,
		gT: 125,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'A táplálkozás-, a légzés-, a keringés- és a kiválasztás szervrendszerének elemzése alapján magyarázza az emberi szervezet anyag- és energiaforgalmi működésének biológiai alapjait.',
		a: 9,
		gT: 124,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'Az emberi test kültakarójának, váz- és izomrendszerének elemzése alapján magyarázza az ember testképének, testalkatának és mozgásképességének biológiai alapjait.',
		a: 9,
		gT: 123,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'Elemzi az ember mozgásképességének biokémiai, szövettani és biomechanikai alapjait, ezeket összefüggésbe hozza a mindennapi élet, a sport és a munka mozgásformáival, értékeli a rendszeres testmozgás szerepét egészségének megőrzésében.',
		a: 9,
		gT: 122,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a környezeti állapot és az ember egészsége közötti összefüggéseket, azonosítja az ember egészségét veszélyeztető tényezőket, felismeri a megelőzés lehetőségeit, érvényesíti az elővigyázatosság elvét.',
		a: 9,
		gT: 121,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete és egészsége', 'az emberi szervezet anatómiája, élettana és egészségvédelme'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az evolúció befolyásolásának lehetséges módjait (például mesterséges szelekció, fajtanemesítés, géntechnológia), értékeli ezek előnyeit és esetleges hátrányait.',
		a: 9,
		gT: 120,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Morfológiai, molekuláris biológiai adatok alapján egyszerű származástani kapcsolatokat elemez, törzsfát készít.',
		a: 9,
		gT: 119,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és elfogadja, hogy a mai emberek egy fajhoz tartoznak, és az evolúció során kialakult nagyrasszok értékükben nem különböznek, a biológiai és kulturális örökségük az emberiség közös kincse.',
		a: 9,
		gT: 118,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal mutatja be az élővilág főbb csoportjainak evolúciós újításait, magyarázza, hogy ezek hogyan segítették elő az adott élőlénycsoport elterjedését.',
		a: 9,
		gT: 117,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal igazolja, hogy a szelekció a különböző szerveződési szinteken értelmezhető tulajdonságokon keresztül egyidejűleg hat.',
		a: 9,
		gT: 116,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a természetes változatosság szerveződését, az evolúciós változások eredetét és elterjedését magyarázó elemi folyamatokat, felismer és magyaráz mikro- és makroszintű evolúciós jelenségeket.',
		a: 9,
		gT: 115,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a biológiai evolúció, adaptív és nem adaptív folyamatok'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a kapcsolatot az életmód és a gének kifejeződése között, érti, hogy a sejt és az egész szervezet jellemzőinek kialakításában és fenntartásában kiemelt szerepe van a környezet általi génaktivitás-változásoknak.',
		a: 9,
		gT: 114,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a változékonyság molekuláris alapjai, egyedszintű öröklődés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a genetikai információ nemzedékek közötti átadásának törvényszerűségeit, ezeket konkrét esetek elemzésében alkalmazza.',
		a: 9,
		gT: 113,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a változékonyság molekuláris alapjai, egyedszintű öröklődés'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az örökítőanyagban tárolt információ és a kifejeződő tulajdonságok közötti összefüggést, megkülönbözteti a genotípust és a fenotípust.',
		a: 9,
		gT: 112,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a változékonyság molekuláris alapjai, egyedszintű öröklődés'])
	},
		{
		cG: 'altgim',
		gD: 'A géntechnológia céljának és módszertani alapjainak ismeretében, kritikai szemlélettel elemzi a genetikai módosítások előnyeit és kockázatait.',
		a: 9,
		gT: 111,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a változékonyság molekuláris alapjai, egyedszintű öröklődés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az örökítőanyag bázissorrendjének vagy bázisainak megváltozásához vezető folyamatokat, konkrét esetekben azonosítja ezek következményeit.',
		a: 9,
		gT: 110,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'a változékonyság molekuláris alapjai, egyedszintű öröklődés'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai és csillagászati tények alapján mérlegeli a földön kívüli élet valószínűsíthető feltételeit és lehetőségeit.',
		a: 9,
		gT: 109,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'az élet eredete és feltételei'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és tényekkel igazolja az ősbaktériumok különleges élőhelyeken való életképességét.',
		a: 9,
		gT: 108,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'az élet eredete és feltételei'])
	},
		{
		cG: 'altgim',
		gD: 'A földi élet keletkezését biológiai kísérletek és elméletek alapján magyarázza.',
		a: 9,
		gT: 107,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése, biológiai evolúció', 'az élet eredete és feltételei'])
	},
		{
		cG: 'altgim',
		gD: 'A sejtszintű anyagcsere folyamatok alapján magyarázza a növények és állatok közötti ökológiai szintű kapcsolatot, a termelő és fogyasztó szervezetek közötti anyagforgalmat.',
		a: 9,
		gT: 106,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a magasabb szerveződési szintek kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Vázlatrajzok, folyamatábrák és animációk alapján azonosítja a fotoszintézis és a sejtlégzés fő szakaszainak sejten belüli helyét és struktúráit, a fontosabb anyagokat és az energiaátalakítás jellemzőit.',
		a: 9,
		gT: 105,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a magasabb szerveződési szintek kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és példákkal bizonyítja az élőlények szén- és energiaforrásainak különféle lehetőségeit, az anyagcseretípusok közötti különbséget.',
		a: 9,
		gT: 104,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a magasabb szerveződési szintek kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Fénymikroszkópban, ábrán vagy fotón felismeri és jellemzi a főbb állati és növényi szövettípusokat, elemzi, hogy milyen funkciók hatékony elvégzésére specializálódtak.',
		a: 9,
		gT: 103,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a magasabb szerveződési szintek kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az őssejt fogalmát, különféle típusait és azok jellemzőit, különbséget tesz őssejt és daganatsejt között.',
		a: 9,
		gT: 102,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a magasabb szerveződési szintek kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az összefüggést a rák kialakulása és a sejtciklus zavarai között, megérti, hogy mit tesz a sejt és a szervezet a daganatok kialakulásának megelőzéséért.',
		a: 9,
		gT: 101,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja a sejtosztódás típusait, megfogalmazza ezek biológiai szerepét, megérti, hogy a soksejtű szervezetek a megtermékenyített petesejt és utódsejtjei meghatározott számú osztódásával és differenciálódásával alakulnak ki.',
		a: 9,
		gT: 100,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a sejtekben és a sejtek között bonyolult jelforgalmi hálózatok működnek, amelyek befolyásolják a génműködést, és felelősek lehetnek a normál és a kóros működésért is.',
		a: 9,
		gT: 99,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az örökítőanyag többszintű szerveződését, képek, animációk alapján értelmezi a sejtekben zajló biológiai információ tárolásának, átírásának és kifejeződésének folyamatait.',
		a: 9,
		gT: 98,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az összetett sejttípus mikroszkóppal megfigyelhető sejtalkotóit, magyarázza a sejt anyagcsere-folyamatainak lényegét.',
		a: 9,
		gT: 97,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Tényekkel igazolja a baktériumok anyagcsere sokfélesége, gyors szaporodása és alkalmazkodóképessége közötti összefüggést.',
		a: 9,
		gT: 96,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'A felépítés és működés összehasonlítása alapján bemutatja a sejtes szerveződés kétféle formájának közös jellemzőit és alapvető különbségeit, értékeli ezek jelentőségét.',
		a: 9,
		gT: 95,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'a sejt és a genom szerveződése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Ábrák, animációk alapján értelmezi, és biológiai tényekkel alátámasztja, hogy a vírusok az élő és élettelen határán állnak.',
		a: 9,
		gT: 94,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarázza, hogy a sejt az élő szervezetek szerkezeti és működési egysége.',
		a: 9,
		gT: 93,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli és példákkal igazolja a különféle szintű biológiai szabályozás szerepét az élő rendszerek normál működési állapotának fenntartásában.',
		a: 9,
		gT: 92,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti, miért és hogyan mehetnek végbe viszonylag alacsony hőmérsékleten, nagy sebességgel kémiai reakciók a sejtekben, vizsgálja az enzimműködést befolyásoló tényezőket.',
		a: 9,
		gT: 91,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'Tényekkel bizonyítja az élőlények elemi összetételének hasonlóságát, a biogén elemek, a víz, az atp és a makromolekulák élő szervezetekben betöltött alapvető szerepét.',
		a: 9,
		gT: 90,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja a biológiai problémákat és magyarázatokat a megfelelő szinttel összefüggésben értelmezni.',
		a: 9,
		gT: 89,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'az élő rendszerek szerveződése', 'az élővilág egysége, a felépítés és működés alapelvei'])
	},
		{
		cG: 'altgim',
		gD: 'A valós és virtuális tanulási közösségekben, másokkal együttműködve megtervez és kivitelez biológiai vizsgálatokat, projekteket.',
		a: 9,
		gT: 88,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'digitális kompetencia, kommunikáció és együttműködés'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a biotechnológia és a bioetika kérdéseiben, ezekről folyó vitákban tudományosan megalapozott érveket alkot.',
		a: 9,
		gT: 87,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'digitális kompetencia, kommunikáció és együttműködés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tudományos közlések lényegi jellemzőit.',
		a: 9,
		gT: 86,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'digitális kompetencia, kommunikáció és együttműködés'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai vizsgálatok során elvégzi az adatrögzítés és -rendezés műveleteit, ennek alapján tényekkel alátámasztott következtetéseket von le.',
		a: 9,
		gT: 85,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'digitális kompetencia, kommunikáció és együttműködés'])
	},
		{
		cG: 'altgim',
		gD: 'A biológiai jelenségek vizsgálata során digitális szöveget, képet, videót keres, értelmez és felhasznál, vizsgálja azok megbízhatóságát, jogszerű és etikus felhasználhatóságát.',
		a: 9,
		gT: 84,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'digitális kompetencia, kommunikáció és együttműködés'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a biológia molekuláris szintű vizsgálati módszereinek elméleti alapjait és felhasználási lehetőségeit, értékeli a biológiai kutatásokból származó nagy mennyiségű adat feldolgozásának jelentőségét.',
		a: 9,
		gT: 83,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási és gondolkodási készségek, eszközök és módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Egyénileg és másokkal együttműködve célszerűen és biztonságosan alkalmaz biológiai vizsgálati módszereket, ismeri a fénymikroszkóp működésének alapelvét, képes azt használni.',
		a: 9,
		gT: 82,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási és gondolkodási készségek, eszközök és módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai vonatkozású adatokat elemez, megfelelő formába rendez, ábrázol, ezek alapján előrejelzéseket, következtetéseket fogalmaz meg, a már ábrázolt adatokat értelmezi.',
		a: 9,
		gT: 81,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási és gondolkodási készségek, eszközök és módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'A vizsgált biológiai jelenségek magyarázatára előfeltevést fogalmaz meg, ennek bizonyítására vagy cáfolatára kísérletet tervez és kivitelez, azonosítja és beállítja a kísérleti változókat, megfigyeléseket és méréseket végez.',
		a: 9,
		gT: 80,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási és gondolkodási készségek, eszközök és módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Az élő rendszerek vizsgálata során felismeri az analógiákat, korrelációkat, alkalmazza a statisztikus és a rendszerszintű gondolkodás műveleteit, kritikusan és kreatívan mérlegeli a lehetőségeket, bizonyítékokra alapozva érvel, több szempontot is figyelembe vesz.',
		a: 9,
		gT: 79,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási és gondolkodási készségek, eszközök és módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal igazolja a biológiai ismereteknek a világképünk és a technológia fejlődésében betöltött szerepét, gazdasági és társadalmi jelentőségét.',
		a: 9,
		gT: 78,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási célok, társadalmi, technológiai jelentőség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a biológiai kutatások alapvető céljait, legfontosabb területeit, értékeli az élet megértésében, az élővilág megismerésében és megóvásában játszott szerepét.',
		a: 9,
		gT: 77,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya és tanulása', 'kutatási célok, társadalmi, technológiai jelentőség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a helyi és a globális környezeti problémák összefüggését, érvel a föld és a kárpát-medence természeti értékeinek védelme mellett, döntéseket hoz és cselekszik a fenntarthatóság érdekében.',
		a: 9,
		gT: 76,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Az emberi test és pszichikum felépítéséről és működéséről szerzett ismereteit önismeretének fejlesztésében, egészséges életvitelének kialakításában alkalmazza.',
		a: 9,
		gT: 75,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Életközösségek vizsgálata alapján értelmezi a környezet és az élőlények felépítése és működése közötti összefüggést, érti az ökológiai egyensúly jelentőségét, érvel a biológiai sokféleség megőrzése mellett.',
		a: 9,
		gT: 74,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Az élő rendszerek belső működése és környezettel való kapcsolataik elemzésében alkalmazza a rendszerszintű gondolkodás műveleteit.',
		a: 9,
		gT: 73,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'A mindennapi élettel összefüggő problémák megoldásában alkalmazza a természettudományos gondolkodás műveleteit, rendelkezik a biológiai problémák vizsgálatához szükséges gyakorlati készségekkel.',
		a: 9,
		gT: 72,
		b: 10,
		e2: 'Biológia',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer néhány, kisiskolások részére készített portált, információforrást, digitálistananyag-lelőhelyet.',
		a: 4,
		gT: 195,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológia alkalmazása, digitális tananyagok, oktatójátékok használata'])
	},
		{
		cG: 'altgim',
		gD: 'Képes feladat, probléma megoldásához megfelelő applikáció, digitális tananyag, oktatójáték, képességfejlesztő digitális alkalmazás kiválasztására.',
		a: 4,
		gT: 194,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológia alkalmazása, digitális tananyagok, oktatójátékok használata'])
	},
		{
		cG: 'altgim',
		gD: 'Közvetlen tapasztalatokat szerez a digitális eszközök használatával kapcsolatban.',
		a: 4,
		gT: 193,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológia alkalmazása, digitális tananyagok, oktatójátékok használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mobileszközök alkalmazásának előnyeit, korlátait, etikai vonatkozásait.',
		a: 4,
		gT: 192,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológia alkalmazása, digitális tananyagok, oktatójátékok használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a kapcsolattartás formáit és a kommunikáció lehetőségeit a digitális környezetben.',
		a: 4,
		gT: 191,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológia alkalmazása, digitális tananyagok, oktatójátékok használata'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a személyes adat fogalmával, törekszik megőrzésére, ismer néhány példát az e-világ veszélyeivel kapcsolatban.',
		a: 4,
		gT: 190,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'adataink védelme, internetbiztonság'])
	},
		{
		cG: 'altgim',
		gD: 'Kiválasztja a számára releváns információt, felismeri a hamis információt.',
		a: 4,
		gT: 189,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'adataink védelme, internetbiztonság'])
	},
		{
		cG: 'altgim',
		gD: 'Információkat keres az interneten, egyszerű eljárásokkal meggyőződik néhány, az interneten talált információ igazságértékéről.',
		a: 4,
		gT: 188,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'adataink védelme, internetbiztonság'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmaz néhány megadott algoritmust tevékenység, játék során, és néhány egyszerű esetben módosítja azokat.',
		a: 4,
		gT: 187,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'kódolás, folyamatok irányítása, a robotika alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Adott feltételeknek megfelelő kódsorozatot tervez és hajtat végre, történeteket, meserészleteket jelenít meg padlórobottal vagy más eszközzel.',
		a: 4,
		gT: 186,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'kódolás, folyamatok irányítása, a robotika alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'A valódi vagy szimulált programozható eszköz mozgását értékeli, hiba esetén módosítja a kódsorozatot a kívánt eredmény eléréséig. tapasztalatait megfogalmazza, megvitatja társaival.',
		a: 4,
		gT: 185,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'kódolás, folyamatok irányítása, a robotika alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Feladat, probléma megoldásához többféle algoritmust próbál ki.',
		a: 4,
		gT: 184,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmusok vizsgálata, előállítása'])
	},
		{
		cG: 'altgim',
		gD: 'Egy adott, mindennapi életből vett algoritmust elemi lépésekre bont, értelmezi a lépések sorrendjét, megfogalmazza az algoritmus várható kimenetelét.',
		a: 4,
		gT: 183,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmusok vizsgálata, előállítása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismer, eljátszik, végrehajt néhány hétköznapi tevékenysége során tapasztalt, elemi lépésekből álló, adott sorrendben végrehajtandó cselekvést.',
		a: 4,
		gT: 182,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmusok vizsgálata, előállítása'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű prezentációt, ábrát, egyéb segédletet készít.',
		a: 4,
		gT: 181,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a probléma megoldásához szükséges módszerek és eszközök kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Információt keres az interneten más tantárgyak tanulása során, és felhasználja azt.',
		a: 4,
		gT: 180,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a probléma megoldásához szükséges módszerek és eszközök kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a problémát, a megoldási lehetőségeket eljátssza, megfogalmazza, egyszerű eszközök segítségével megvalósítja.',
		a: 4,
		gT: 179,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a probléma megoldásához szükséges módszerek és eszközök kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Információkat keres, a talált adatokat felhasználja digitális produktumok létrehozására.',
		a: 4,
		gT: 178,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'adatok értelmezése, csoportosítása, tárolása'])
	},
		{
		cG: 'altgim',
		gD: 'Állításokat fogalmaz meg grafikonokról, infografikákról, táblázatokról; a kapott információkat felhasználja napi tevékenysége során.',
		a: 4,
		gT: 177,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'adatok értelmezése, csoportosítása, tárolása'])
	},
		{
		cG: 'altgim',
		gD: 'Egy rajzos dokumentumot adott szempontok alapján értékel, módosít.',
		a: 4,
		gT: 176,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'rajzos dokumentumok digitális létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Grafikai alkalmazással egyszerű, közvetlenül hasznosuló rajzot, grafikát, dokumentumot hoz létre.',
		a: 4,
		gT: 175,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'rajzos dokumentumok digitális létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján megfigyel néhány, grafikai alkalmazással készített produktumot; személyes véleményét megfogalmazza.',
		a: 4,
		gT: 174,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'rajzos dokumentumok digitális létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'A feladathoz, problémához digitális eszközt, illetve alkalmazást, applikációt, felhasználói felületet választ; felsorol néhány érvet választásával kapcsolatosan.',
		a: 4,
		gT: 173,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'gyermekeknek készített alkalmazások használata'])
	},
		{
		cG: 'altgim',
		gD: 'Kezdetben tanítói segítséggel, majd önállóan használ néhány, életkorának megfelelő alkalmazást, elsősorban információgyűjtés, gyakorlás, egyéni érdeklődésének kielégítése céljából.',
		a: 4,
		gT: 172,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'gyermekeknek készített alkalmazások használata'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy tanítói segítséggel választ más tantárgyak tanulásának támogatásához applikációkat, digitális tananyagot, oktatójátékot, képességfejlesztő digitális alkalmazást.',
		a: 4,
		gT: 171,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'gyermekeknek készített alkalmazások használata'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű feladatokat old meg informatikai eszközökkel. esetenként tanítói segítséggel összetett funkciókat is alkalmaz.',
		a: 4,
		gT: 170,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'ismerkedés az informatikai környezettel'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza, néhány példával alátámasztja, hogyan könnyíti meg a felhasználó munkáját az adott eszköz alkalmazása.',
		a: 4,
		gT: 169,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'ismerkedés az informatikai környezettel'])
	},
		{
		cG: 'altgim',
		gD: 'Közvetlen otthoni vagy iskolai környezetéből megnevez néhány informatikai eszközt, felsorolja fontosabb jellemzőit.',
		a: 4,
		gT: 168,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'ismerkedés az informatikai környezettel'])
	},
		{
		cG: 'altgim',
		gD: 'A rendelkezésére álló eszközökkel, forrásokból meggyőződik a talált vagy kapott információk helyességéről.',
		a: 4,
		gT: 167,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Eredményétől függően módosítja a problémamegoldás folyamatában az adott, egyszerű tevékenységsorokat.',
		a: 4,
		gT: 166,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Kiválasztja az általa ismert informatikai eszközök és alkalmazások közül azokat, melyek az adott probléma megoldásához szükségesek.',
		a: 4,
		gT: 165,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival együttműködve online és offline környezetben egyaránt megold különböző feladatokat, ötleteit, véleményét megfogalmazza, részt vesz a közös álláspont kialakításában.',
		a: 4,
		gT: 164,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megvizsgálja és értékeli az általa vagy társai által alkalmazott, létrehozott, megvalósított eljárásokat.',
		a: 4,
		gT: 163,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Elmélyülten dolgozik digitális környezetben, önellenőrzést végez.',
		a: 4,
		gT: 162,
		b: 4,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Online gyakorolja az állampolgári jogokat és kötelességeket.',
		a: 5,
		gT: 249,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs társadalom, e-világ lehetőségeinek, kockázatainak ismerete'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az információs társadalom múltját, jelenét és várható jövőjét.',
		a: 5,
		gT: 248,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs társadalom, e-világ lehetőségeinek, kockázatainak ismerete'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az információs technológia fejlődésének gazdasági, környezeti, kulturális hatásait.',
		a: 5,
		gT: 247,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs társadalom, e-világ lehetőségeinek, kockázatainak ismerete'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a digitális környezet, az e-világ etikai problémáit.',
		a: 5,
		gT: 246,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs társadalom, e-világ lehetőségeinek, kockázatainak ismerete'])
	},
		{
		cG: 'altgim',
		gD: 'Védekezik az internetes zaklatás különböző formái ellen, szükség esetén segítséget kér.',
		a: 5,
		gT: 245,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'együttműködés az információs technológiák használata során'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a hálózatokat és a személyes információkat érintő fenyegetésekkel, alkalmazza az adatok védelmét biztosító lehetőségeket.',
		a: 5,
		gT: 244,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'együttműködés az információs technológiák használata során'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik az iskolai oktatáshoz kapcsolódó mobileszközökre fejlesztett alkalmazások használatában.',
		a: 5,
		gT: 243,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'együttműködés az információs technológiák használata során'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a térinformatika és a 3d megjelenítés lehetőségeit.',
		a: 5,
		gT: 242,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'robotika'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik az eseményvezérlésről.',
		a: 5,
		gT: 241,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'robotika'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt szenzorok segítségével.',
		a: 5,
		gT: 240,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'robotika'])
	},
		{
		cG: 'altgim',
		gD: 'Mozgásokat vezérel szimulált vagy valós környezetben.',
		a: 5,
		gT: 239,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'robotika'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és betartja az elektronikus kommunikációs szabályokat.',
		a: 5,
		gT: 238,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológián alapuló kommunikációs formák használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri, használja az elektronikus kommunikáció lehetőségeit, a családi és az iskolai környezetének elektronikus szolgáltatásait.',
		a: 5,
		gT: 237,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információs technológián alapuló kommunikációs formák használata'])
	},
		{
		cG: 'altgim',
		gD: 'Az internetes adatbázis-kezelő rendszerek keresési űrlapját helyesen tölti ki.',
		a: 5,
		gT: 236,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információkeresési technikák alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan keres információt, a találatokat hatékonyan szűri.',
		a: 5,
		gT: 235,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információkeresési technikák alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az információkeresés technikáját, stratégiáját és több keresési szempont egyidejű érvényesítésének lehetőségét.',
		a: 5,
		gT: 234,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'az információkeresési technikák alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Vizsgálni tudja a szabályozó eszközök hatásait a tantárgyi alkalmazásokban.',
		a: 5,
		gT: 233,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'tantárgyi problémák vizsgálata digitális eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik hétköznapi jelenségek számítógépes szimulációjáról.',
		a: 5,
		gT: 232,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'tantárgyi problémák vizsgálata digitális eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'Problémákat old meg táblázatkezelő program segítségével.',
		a: 5,
		gT: 231,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'tantárgyi problémák vizsgálata digitális eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'Az adatok szemléltetéséhez diagramot készít.',
		a: 5,
		gT: 230,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatok kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Cellahivatkozásokat, matematikai tudásának megfelelő képleteket, egyszerű statisztikai függvényeket használ táblázatkezelő programban.',
		a: 5,
		gT: 229,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatok kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Az adatokat táblázatos formába rendezi és formázza.',
		a: 5,
		gT: 228,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatok kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'A probléma megoldásához vezérlési szerkezetet (szekvencia, elágazás és ciklus) alkalmaz a tanult blokkprogramozási nyelven.',
		a: 5,
		gT: 227,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a kódolás eszközeinek ismerete, a blokkprogramozás eszközeinek használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a blokkprogramozás alapvető építőelemeit.',
		a: 5,
		gT: 226,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a kódolás eszközeinek ismerete, a blokkprogramozás eszközeinek használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a programozási környezet alapvető eszközeit.',
		a: 5,
		gT: 225,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a kódolás eszközeinek ismerete, a blokkprogramozás eszközeinek használata'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat kezel a programozás eszközeivel.',
		a: 5,
		gT: 224,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a kódolás eszközeinek ismerete, a blokkprogramozás eszközeinek használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kódolás eszközeit.',
		a: 5,
		gT: 223,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'a kódolás eszközeinek ismerete, a blokkprogramozás eszközeinek használata'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű algoritmusokat elemez és készít.',
		a: 5,
		gT: 222,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'egyszerű algoritmusok elemzése, készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az algoritmus végrehajtásához szükséges adatok és az eredmények kapcsolatát.',
		a: 5,
		gT: 221,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'egyszerű algoritmusok elemzése, készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti, kezeli és használja az elemi adatokat.',
		a: 5,
		gT: 220,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'egyszerű algoritmusok elemzése, készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogyan történik az egyszerű algoritmusok végrehajtása a digitális eszközökön.',
		a: 5,
		gT: 219,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'egyszerű algoritmusok elemzése, készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutató-készítő vagy szövegszerkesztő programban rajzeszközökkel ábrát készít.',
		a: 5,
		gT: 218,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás elemek készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri egy bittérképes rajzolóprogram használatát, azzal ábrát készít.',
		a: 5,
		gT: 217,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás elemek készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális képeken képkorrekciót hajt végre.',
		a: 5,
		gT: 216,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás elemek készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökkel önállóan rögzít és tárol képet, hangot és videót.',
		a: 5,
		gT: 215,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás elemek készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Etikus módon használja fel az információforrásokat, tisztában van a hivatkozás szabályaival.',
		a: 5,
		gT: 214,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'különböző típusú dokumentumok iskolai, tanórai, hétköznapi célú felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a prezentációkészítés alapszabályait, és azokat alkalmazza.',
		a: 5,
		gT: 213,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'különböző típusú dokumentumok iskolai, tanórai, hétköznapi célú felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'A szöveges dokumentumokat többféle elrendezésben jeleníti meg papíron, tisztában van a nyomtatás környezetre gyakorolt hatásaival.',
		a: 5,
		gT: 212,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'különböző típusú dokumentumok iskolai, tanórai, hétköznapi célú felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és kritikusan használja a nyelvi eszközöket (például helyesírás-ellenőrzés, elválasztás).',
		a: 5,
		gT: 211,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'dokumentum létrehozása szövegszerkesztő és bemutató-készítő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'A tartalomnak megfelelően alakítja ki a szöveges vagy a multimédiás dokumentum szerkezetét, illeszti be, helyezi el és formázza meg a szükséges objektumokat.',
		a: 5,
		gT: 210,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'dokumentum létrehozása szövegszerkesztő és bemutató-készítő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és tudatosan alkalmazza a szöveges és multimédiás dokumentum készítése során a szöveg formázására, tipográfiájára vonatkozó alapelveket.',
		a: 5,
		gT: 209,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'dokumentum létrehozása szövegszerkesztő és bemutató-készítő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Egy adott feladat kapcsán önállóan hoz létre szöveges vagy multimédiás dokumentumokat.',
		a: 5,
		gT: 208,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'dokumentum létrehozása szövegszerkesztő és bemutató-készítő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik a digitális jelek minőségével, kódolásával, tömörítésével, továbbításával kapcsolatos problémák kezeléséről.',
		a: 5,
		gT: 207,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az operációs rendszerek önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a digitális hálózatok alapszolgáltatásait.',
		a: 5,
		gT: 206,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az operációs rendszerek önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan kezeli az operációs rendszer mappáit, fájljait és a felhőszolgáltatásokat.',
		a: 5,
		gT: 205,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az operációs rendszerek önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan használja az operációs rendszer felhasználói felületét.',
		a: 5,
		gT: 204,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az operációs rendszerek önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az informatikai eszközöket működtető szoftverek hibajelzéseit, és azokról beszámol.',
		a: 5,
		gT: 203,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Az informatikai eszközöket önállóan használja, a tipikus felhasználói hibákat elkerüli, és elhárítja az egyszerűbb felhasználói szintű hibákat.',
		a: 5,
		gT: 202,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Célszerűen választ a feladat megoldásához használható informatikai eszközök közül.',
		a: 5,
		gT: 201,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök önálló használata'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a digitális társadalom elvárásait, lehetőségeit és veszélyeit.',
		a: 5,
		gT: 200,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális tudáselemek felhasználásával, társaival együttműködve különböző problémákat old meg.',
		a: 5,
		gT: 199,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a felmerülő problémák megoldásának módjait, beleértve az adott feladat megoldásához szükséges algoritmus értelmezését, alkotását és számítógépes program készítését és kódolását a blokkprogramozás eszközeivel.',
		a: 5,
		gT: 198,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Elsajátítja a digitális írástudás eszközeit, azokkal feladatokat old meg.',
		a: 5,
		gT: 197,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan használja a digitális eszközöket, az online kommunikáció eszközeit, tisztában van az ezzel járó veszélyekkel.',
		a: 5,
		gT: 196,
		b: 8,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'A gyakorlatban alkalmazza az adatok védelmét biztosító lehetőségeket.',
		a: 9,
		gT: 307,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a digitális személyazonosság és az információhitelesség fogalmával.',
		a: 9,
		gT: 306,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az e-világ -- e-szolgáltatások, e-ügyintézés, e-kereskedelem, e-állampolgárság, it-gazdaság, környezet, kultúra, információvédelem -- biztonsági és jogi kérdéseivel.',
		a: 9,
		gT: 305,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'e-állampolgársági ismeretek, e-szolgáltatások, e-ügyintézés, e-kereskedelem'])
	},
		{
		cG: 'altgim',
		gD: 'Az iskolai oktatáshoz kapcsolódó mobileszközökre fejlesztett alkalmazások használata során együttműködik társaival.',
		a: 9,
		gT: 304,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Az applikációkat önállóan telepíti.',
		a: 9,
		gT: 303,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Céljainak megfelelő alkalmazást választ, az alkalmazás funkcióira, kezelőfelületére vonatkozó igényeit megfogalmazza.',
		a: 9,
		gT: 302,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a mobiltechnológiát, kezeli a mobileszközök operációs rendszereit és használ mobilalkalmazásokat.',
		a: 9,
		gT: 301,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'mobiltechnológiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Az online kommunikáció során alkalmazza a kialakult viselkedési kultúrát és szokásokat, a szerepelvárásokat.',
		a: 9,
		gT: 300,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a fogyatékkal élők közötti kommunikáció eszközeit és formáit.',
		a: 9,
		gT: 299,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a két- vagy többrésztvevős kommunikációs lehetőségeket és alkalmazásokat.',
		a: 9,
		gT: 298,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Etikus módon használja fel az információforrásokat, tisztában van a hivatkozás szabályaival.',
		a: 9,
		gT: 297,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az információkeresési stratégiákat és technikákat, a találati listát a problémának megfelelően szűri, ellenőrzi annak hitelességét.',
		a: 9,
		gT: 296,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'információs technológiák', 'információkeresés és online kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokat szerez a kezdőértékek változtatásának hatásairól a szimulációs programokban.',
		a: 9,
		gT: 295,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'altgim',
		gD: 'Hétköznapi, oktatáshoz készült szimulációs programokat használ.',
		a: 9,
		gT: 294,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik hétköznapi jelenségek számítógépes szimulációjáról.',
		a: 9,
		gT: 293,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'számítógépes szimuláció'])
	},
		{
		cG: 'altgim',
		gD: 'Strukturáltan tárolt nagy adathalmazokat kezel, azokból egyedi és összesített adatokat nyer ki.',
		a: 9,
		gT: 292,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'altgim',
		gD: 'A feladatmegoldás során az adatbázisba adatokat visz be, módosít és töröl, űrlapokat használ, jelentéseket nyomtat.',
		a: 9,
		gT: 291,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'altgim',
		gD: 'Az adatbázisban interaktív módon keres, rendez és szűr.',
		a: 9,
		gT: 290,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az adatbázis-kezelés alapfogalmait.',
		a: 9,
		gT: 289,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés adatbázis-kezelő rendszerrel'])
	},
		{
		cG: 'altgim',
		gD: 'Az adatokat diagramon szemlélteti.',
		a: 9,
		gT: 288,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Nagy adathalmazokat tud kezelni.',
		a: 9,
		gT: 287,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'A problémamegoldás során függvényeket célszerűen használ.',
		a: 9,
		gT: 286,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Táblázatkezelővel adatelemzést és számításokat végez.',
		a: 9,
		gT: 285,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat táblázatba rendez.',
		a: 9,
		gT: 284,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'adatkezelés táblázatkezelő alkalmazással'])
	},
		{
		cG: 'altgim',
		gD: 'A feladat megoldásának helyességét teszteli.',
		a: 9,
		gT: 283,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Szekvencia, elágazás és ciklus segítségével algoritmust hoz létre, és azt egy magas szintű formális programozási nyelven kódolja.',
		a: 9,
		gT: 282,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Példákban, feladatok megoldásában használja egy formális programozási nyelv fejlesztői környezetének alapszolgáltatásait.',
		a: 9,
		gT: 281,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Érti egy algoritmus-leíró eszköz alapvető építőelemeit, érti a típusalgoritmusok felhasználásának lehetőségeit.',
		a: 9,
		gT: 280,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elemi és összetett adattípusok közötti különbségeket.',
		a: 9,
		gT: 279,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a következő elemi adattípusok közötti különbségeket: egész, valós szám, karakter, szöveg, logikai.',
		a: 9,
		gT: 278,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az egyszerű problémák megoldásához szükséges tevékenységek lépéseit és kapcsolatukat.',
		a: 9,
		gT: 277,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'problémamegoldás informatikai eszközökkel és módszerekkel', 'algoritmizálás, módszerek, eszközök használata, típusalgoritmusok'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a raszter-, a vektorgrafikus ábrák tárolási és szerkesztési módszereivel',
		a: 9,
		gT: 276,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Digitálisan rögzít képet, hangot és videót, azokat manipulálja.',
		a: 9,
		gT: 275,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Létrehoz vektorgrafikus ábrákat.',
		a: 9,
		gT: 274,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Létrehozza az adott probléma megoldásához szükséges rasztergrafikus ábrákat.',
		a: 9,
		gT: 273,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'grafikus ábrák készítése és képszerkesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a html formátumú dokumentumok szerkezeti elemeit, érti a css használatának alapelveit; több lapból álló webhelyet készít.',
		a: 9,
		gT: 272,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Dokumentumokat szerkeszt és helyez el tartalomkezelő rendszerben.',
		a: 9,
		gT: 271,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az információkeresés során gyűjtött multimédiás alapelemeket új dokumentumok készítéséhez.',
		a: 9,
		gT: 270,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlatot szerez a fotó-, hang-, videó-, multimédia-szerkesztő, a bemutató-készítő eszközök használatában.',
		a: 9,
		gT: 269,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'multimédiás és webes dokumentumok szerkesztése és készítése'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatokkal rendelkezik a formanyomtatványok, a sablonok, az előre definiált stílusok használatáról.',
		a: 9,
		gT: 268,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Speciális dokumentumokat hoz létre, alakít át és formáz meg.',
		a: 9,
		gT: 267,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri egy adott feladat megoldásához szükséges digitális eszközök és szoftverek kiválasztásának szempontjait.',
		a: 9,
		gT: 266,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'digitális írástudás', 'nagyméretű szöveges dokumentumok szerkesztését elősegítő eszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Használja az állományok tömörítését és a tömörített állományok kibontását.',
		a: 9,
		gT: 265,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a digitális kártevők elleni védekezés lehetőségeivel.',
		a: 9,
		gT: 264,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'altgim',
		gD: 'Használja az operációs rendszer segédprogramjait, és elvégzi a munkakörnyezet beállításait.',
		a: 9,
		gT: 263,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'segédprogramok, digitális kártevők elleni védekezés, állományok tömörítése'])
	},
		{
		cG: 'altgim',
		gD: 'Követi a technológiai változásokat a digitális információforrások használatával.',
		a: 9,
		gT: 262,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'altgim',
		gD: 'Igénybe veszi az operációs rendszer és a számítógépes hálózat alapszolgáltatásait.',
		a: 9,
		gT: 261,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'altgim',
		gD: 'Céljainak megfelelően használja a mobileszközök és a számítógépek operációs rendszereit.',
		a: 9,
		gT: 260,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'a mobileszközök, számítógépek, hálózatok operációs rendszerei, felhőszolgáltatások'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan használja az informatikai eszközöket, elkerüli a tipikus felhasználói hibákat, elhárítja az egyszerűbb felhasználói hibákat.',
		a: 9,
		gT: 259,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan alakítja informatikai környezetét, ismeri az ergonomikus informatikai környezet jellemzőit, figyelembe veszi a digitális eszközök egészségkárosító hatásait, óvja maga és környezete egészségét.',
		a: 9,
		gT: 258,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a digitális eszközök és a számítógépek fő egységeit, ezek fejlődésének főbb állomásait, tendenciáit.',
		a: 9,
		gT: 257,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és tudja használni a célszerűen választott informatikai eszközöket és a működtető szoftvereit, ismeri a felhasználási lehetőségeket.',
		a: 9,
		gT: 256,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['digitális kultúra', 'az informatikai eszközök használata', 'az informatikai eszközök felhasználásának lehetőségei, az informatikai környezet'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az e-világ elvárásait, lehetőségeit és veszélyeit.',
		a: 9,
		gT: 255,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Hatékonyan keres információt; az ikt-tudáselemek felhasználásával társaival együttműködve problémákat old meg.',
		a: 9,
		gT: 254,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az algoritmikus probléma megoldásához szükséges módszereket és eszközöket, megoldásukhoz egy magas szintű formális programozási nyelv fejlesztői környezetét önállóan használja.',
		a: 9,
		gT: 253,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az adatkezelés alapfogalmait, képes a nagyobb adatmennyiség tárolását, hatékony feldolgozását biztosító eszközök és módszerek alapszintű használatára, érti a működésüket.',
		a: 9,
		gT: 252,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlatot szerez dokumentumok létrehozását segítő eszközök használatában.',
		a: 9,
		gT: 251,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az informatikai eszközök és a működtető szoftvereik célszerű választásának alapelveit, használja a digitális hálózatok alapszolgáltatásait, az online kommunikáció eszközeit, tisztában van az ezzel járó veszélyekkel, ezzel összefüggésben ismeri a segítségnyújtási, segítségkérési lehetőségeket.',
		a: 9,
		gT: 250,
		b: 12,
		e2: 'Digitális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'digitális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és azonosítja a dráma és a színház formanyelvi sajátosságait a látott előadásokban.',
		a: 7,
		gT: 339,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'a dráma és a színház művészete'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megvizsgálja a problémahelyzeteket és azok lehetséges megoldási alternatíváit.',
		a: 7,
		gT: 338,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'problémaközpontú gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és azonosítja a dramatikus szituációk jellemzőit (szereplők, viszonyrendszer, cél, szándék, akarat, konfliktus, feloldás).',
		a: 7,
		gT: 337,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'problémaközpontú gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A színházi előadást a dramatikus tevékenységek kiindulópontjául is használja.',
		a: 7,
		gT: 336,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'színházi élmény feldolgozása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a színházi élmény fontosságát.',
		a: 7,
		gT: 335,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'színházi élmény feldolgozása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a megélt, a látott-hallott-olvasott, a kitalált történeteket a különböző dramatikus tevékenységek révén.',
		a: 7,
		gT: 334,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'történetek feldolgozása'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti és alapszinten alkalmazza a dramaturgiai alapfogalmakat.',
		a: 7,
		gT: 333,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megismerés és értelmezés', 'történetek feldolgozása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a helyzetek feldolgozása során a szerkesztésben rejlő lehetőségeket.',
		a: 7,
		gT: 332,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'színjátékos eszközök használata'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a tanult dramatikus technikákat a helyzetek megjelenítésében.',
		a: 7,
		gT: 331,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'színjátékos eszközök használata'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a színházi kommunikáció erejét.',
		a: 7,
		gT: 330,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'színjátékos eszközök használata'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a feszültség élményét és szerepét a dramatikus tevékenységekben.',
		a: 7,
		gT: 329,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'improvizációs készség'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a kommunikációs jelek jelentéshordozó és jelentésteremtő erejét.',
		a: 7,
		gT: 328,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'improvizációs készség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alapszinten alkalmazza a kapcsolat létrehozásának és fenntartásának technikáit.',
		a: 7,
		gT: 327,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'improvizációs készség'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a szerepbe lépésben és az együttjátszásban rejlő lehetőségeket.',
		a: 7,
		gT: 326,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'improvizációs készség'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a tér sajátosságaiban rejlő lehetőségeket.',
		a: 7,
		gT: 325,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'térhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a tárgyi világ kínálta eszközöket, ezek művészi formáit (pl. a bábot és a maszkot).',
		a: 7,
		gT: 324,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'tárgyhasználat, bábhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Az alkotótevékenység során használja a megismert kifejezési formákat.',
		a: 7,
		gT: 323,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'verbális és nonverbális kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Adekvát módon alkalmazza a verbális és nonverbális kifejezés eszközeit.',
		a: 7,
		gT: 322,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'megjelenítés, kifejezés, közvetítés', 'verbális és nonverbális kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Fejleszti az együttműködésre és a konszenzus kialakítására irányuló gyakorlatát.',
		a: 7,
		gT: 321,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'ön- és társismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi önmagát a csoport részeként, illetve a csoportos tevékenység alkotó közreműködőjeként.',
		a: 7,
		gT: 320,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'ön- és társismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli, azonosítja és értelmezi a környezetéből érkező hatásokra adott saját válaszait.',
		a: 7,
		gT: 319,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'ön- és társismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Koncentrált figyelemmel végzi a játékszabályok adta keretek között tevékenységeit.',
		a: 7,
		gT: 318,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'figyelem, koncentráció'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan irányítja és összpontosítja figyelmét a környezete jelenségeire.',
		a: 7,
		gT: 317,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'figyelem, koncentráció'])
	},
		{
		cG: 'altgim',
		gD: 'Kitalál és alkalmaz elképzelt verbális, vokális, vizuális, kinetikus hatásokat.',
		a: 7,
		gT: 316,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'érzékelés, megfigyelés, felismerés, emlékezet, fantázia'])
	},
		{
		cG: 'altgim',
		gD: 'Felidézi a látott, hallott, érzékelt verbális, vokális, vizuális, kinetikus hatásokat.',
		a: 7,
		gT: 315,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'érzékelés, megfigyelés, felismerés, emlékezet, fantázia'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli, azonosítja és értelmezi a tárgyi világ jelenségeit.',
		a: 7,
		gT: 314,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'érzékelés, megfigyelés, felismerés, emlékezet, fantázia'])
	},
		{
		cG: 'altgim',
		gD: 'Felfedezi a tér, az idő, a tempó, a ritmus sajátosságait és összefüggéseit.',
		a: 7,
		gT: 313,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['dráma és színház', 'csoportos játék és együttműködés', 'érzékelés, megfigyelés, felismerés, emlékezet, fantázia'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza egy színházi előadás kapcsán élményeit, gondolatait.',
		a: 7,
		gT: 312,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'dráma és színház'])
	},
		{
		cG: 'altgim',
		gD: 'Saját gondolatot, témát, üzenetet fogalmaz meg a témához általa alkalmasnak ítélt dramatikus közlésformában.',
		a: 7,
		gT: 311,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'dráma és színház'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz többféle dramatikus tevékenységben tanári irányítással, önállóan, illetve társakkal való együttműködésben.',
		a: 7,
		gT: 310,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'dráma és színház'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a drámai és színházi kifejezés formáit.',
		a: 7,
		gT: 309,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'dráma és színház'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a különböző verbális és nonverbális kommunikációs eszközöket.',
		a: 7,
		gT: 308,
		b: 8,
		e2: 'Dráma és színház',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'dráma és színház'])
	},
		{
		cG: 'altgim',
		gD: 'Létrehoz nagyon egyszerű írott, pár szavas szöveget szóban vagy írásban digitális felületen.',
		a: 4,
		gT: 429,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a tanult nyelvi elemeket életkorának megfelelő digitális tartalmakban, digitális csatornákon olvasott vagy hallott nagyon egyszerű szövegekben is.',
		a: 4,
		gT: 428,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a főbb, célnyelvi kultúrához tartozó, ünnepekhez kapcsolódó alapszintű kifejezéseket, állandósult szókapcsolatokat és szokásokat.',
		a: 4,
		gT: 427,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a főbb, az adott célnyelvi kultúrákhoz tartozó országok nevét, földrajzi elhelyezkedését, főbb országismereti jellemzőit.',
		a: 4,
		gT: 426,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető célzott információt megszerez a tanult témákban tudásának bővítésére.',
		a: 4,
		gT: 425,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasznál és létrehoz rövid, nagyon egyszerű célnyelvi szövegeket szabadidős tevékenységek során.',
		a: 4,
		gT: 424,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is.',
		a: 4,
		gT: 423,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Egy feladat megoldásának sikerességét segítséggel értékelni tudja.',
		a: 4,
		gT: 422,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A célok eléréséhez társaival rövid feladatokban együttműködik.',
		a: 4,
		gT: 421,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Szavak, kifejezések tanulásakor felismeri, ha új elemmel találkozik és rákérdez, vagy megfelelő tanulási stratégiával törekszik a megértésre.',
		a: 4,
		gT: 420,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Új szavak, kifejezések tanulásakor ráismer a már korábban tanult szavakra, kifejezésekre.',
		a: 4,
		gT: 419,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Közöl alapvető személyes információkat magáról, egyszerű nyelvi elemek segítségével.',
		a: 4,
		gT: 418,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a nem értés, visszakérdezés és ismétlés, kérés kifejezésére használt mindennapi nyelvi funkciókat életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 417,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a tudás és nem tudás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 416,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a köszönet és az arra történő reagálás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 415,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, megszólításra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 414,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, bemutatkozásra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 413,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, üdvözlésre és elköszönésre használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 4,
		gT: 412,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Elsajátítja a tanult szavak és állandósult szókapcsolatok célnyelvi normához közelítő kiejtését tanári minta követése által, vagy autentikus hangzó anyag, digitális technológia segítségével.',
		a: 4,
		gT: 411,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Érzéseit egy-két szóval vagy begyakorolt állandósult nyelvi fordulatok segítségével kifejezi, főként rákérdezés alapján, nonverbális eszközökkel kísérve a célnyelvi megnyilatkozást.',
		a: 4,
		gT: 410,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán bekapcsolódik a már ismert, szóbeli interakciót igénylő nyelvi tevékenységekbe, a begyakorolt nyelvi elemeket tanári segítséggel a tevékenység céljainak megfelelően alkalmazza.',
		a: 4,
		gT: 409,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, néhány mondatból álló párbeszédet folytat, felkészülést követően.',
		a: 4,
		gT: 408,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik arra, hogy a célnyelvet eszközként alkalmazza információszerzésre.',
		a: 4,
		gT: 407,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán begyakorolt, nagyon egyszerű, egyértelmű kommunikációs helyzetekben a megtanult, állandósult beszédfordulatok alkalmazásával kérdez vagy reagál, mondanivalóját segítséggel vagy nonverbális eszközökkel kifejezi.',
		a: 4,
		gT: 406,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan bekapcsolódik a közös meseolvasásba, a mese tartalmát követi.',
		a: 4,
		gT: 405,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megtapasztalja a közös célnyelvi olvasás élményét.',
		a: 4,
		gT: 404,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő írott szövegre az órai játékos alkotó, mozgásos vagy nyelvi fejlesztő tevékenységek során, kooperatív munkaformákban.',
		a: 4,
		gT: 403,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemeli az ismert nyelvi elemeket tartalmazó, egyszerű, írott, pár mondatos szöveg fő mondanivalóját.',
		a: 4,
		gT: 402,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nyelvi szintjének megfelelő, akár vizuális eszközökkel is támogatott írott utasításokat és kérdéseket, és ezekre megfelelő válaszreakciókat ad.',
		a: 4,
		gT: 401,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Csendes olvasás keretében feldolgozva megért ismert szavakat tartalmazó, pár szóból vagy mondatból álló, akár illusztrációval támogatott szöveget.',
		a: 4,
		gT: 400,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosítja a célzott információt az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű, a nyelvtanításhoz készült, illetve eredeti szövegben.',
		a: 4,
		gT: 399,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti az anyanyelvi és a célnyelvi írott szövegben a betű- és jelkészlet közti különbségeket.',
		a: 4,
		gT: 398,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Figyel a célnyelvre jellemző hangok kiejtésére.',
		a: 4,
		gT: 397,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelve és a célnyelv közötti legalapvetőbb kiejtésbeli különbségeket.',
		a: 4,
		gT: 396,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi azokat az idegen nyelven szóban elhangzó nyelvórai szituációkat, melyeket anyanyelvén már ismer.',
		a: 4,
		gT: 395,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelv és az idegen nyelv hangkészletét.',
		a: 4,
		gT: 394,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő hangzó szövegre az órai alkotó jellegű nyelvi, mozgásos nyelvi és játékos nyelvi tevékenységek során.',
		a: 4,
		gT: 393,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a célzott információt a nyelvi szintjének és életkorának megfelelő rövid hangzó szövegben.',
		a: 4,
		gT: 392,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszűri a lényeget az ismert nyelvi elemeket tartalmazó, nagyon rövid, egyszerű hangzó szövegből.',
		a: 4,
		gT: 391,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosítja az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű szövegben a tanult nyelvi elemeket.',
		a: 4,
		gT: 390,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az élőszóban elhangzó, ismert témákhoz kapcsolódó, verbális, vizuális vagy nonverbális eszközökkel segített rövid kijelentéseket, kérdéseket.',
		a: 4,
		gT: 389,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban megnevezi az ajánlott tématartományokban megjelölt, begyakorolt elemeket.',
		a: 4,
		gT: 388,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz kooperatív munkaformában végzett kreatív tevékenységekben, projektmunkában szavak, szószerkezetek, rövid mondatok leírásával, esetleg képi kiegészítéssel.',
		a: 4,
		gT: 387,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megold játékos írásbeli feladatokat a szavak, szószerkezetek, rövid mondatok szintjén.',
		a: 4,
		gT: 386,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Lemásol tanult szavakat játékos, alkotó nyelvórai tevékenységek során.',
		a: 4,
		gT: 385,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az adott nyelv ábécéjét.',
		a: 4,
		gT: 384,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelvén, illetve a tanult idegen nyelven történő írásmód és betűkészlet közötti különbségeket.',
		a: 4,
		gT: 383,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelven megoszt egyedül vagy társaival együttműködésben megszerzett, alapvető információkat szóban, akár vizuális elemekkel támogatva.',
		a: 4,
		gT: 382,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Lebetűzi a tanult szavakat társaival közösen játékos tevékenységek kapcsán, szükség esetén segítséggel.',
		a: 4,
		gT: 381,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Lebetűzi a nevét.',
		a: 4,
		gT: 380,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Megismétli az élőszóban elhangzó egyszerű szavakat, kifejezéseket játékos, mozgást igénylő, kreatív nyelvórai tevékenységek során.',
		a: 4,
		gT: 379,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelvi tanulmányain keresztül nyitottabbá, a világ felé érdeklődőbbé válik.',
		a: 4,
		gT: 378,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a tanult nyelvi elemek megfelelő kiejtésére.',
		a: 4,
		gT: 377,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az adott célnyelvi kultúrákhoz tartozó országok fontosabb jellemzőit és a hozzájuk tartozó alapvető nyelvi elemeket.',
		a: 4,
		gT: 376,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Elmondja magáról a legalapvetőbb információkat.',
		a: 4,
		gT: 375,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, mindennapi nyelvi funkciókat.',
		a: 4,
		gT: 374,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Követi a szintjének megfelelő, vizuális vagy nonverbális eszközökkel támogatott, ismert célnyelvi óravezetést, utasításokat.',
		a: 4,
		gT: 373,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Lemásol, leír szavakat és rövid, nagyon egyszerű szövegeket.',
		a: 4,
		gT: 372,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban visszaad szavakat, esetleg rövid, nagyon egyszerű szövegeket hoz létre.',
		a: 4,
		gT: 371,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Bekapcsolódik a szóbeliséget, írást, szövegértést vagy interakciót igénylő alapvető és korának megfelelő játékos, élményalapú élő idegen nyelvi tevékenységekbe.',
		a: 4,
		gT: 370,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Megismerkedik az idegen nyelvvel, a nyelvtanulással és örömmel vesz részt az órákon.',
		a: 4,
		gT: 369,
		b: 4,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik az érdeklődésének megfelelő akár autentikus szövegekkel elektronikus, digitális csatornákon tanórán kívül is.',
		a: 5,
		gT: 521,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Egyénileg vagy társaival együttműködve szóban vagy írásban projektmunkát vagy kiselőadást készít, és ezeket digitális eszközök segítségével is meg tudja valósítani.',
		a: 5,
		gT: 520,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Következetesen alkalmazza a célnyelvi betű és jelkészletet',
		a: 5,
		gT: 519,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Idegen nyelvi kommunikációjában ismeri és használja a célnyelv főbb jellemzőit.',
		a: 5,
		gT: 518,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó alapvető tanult nyelvi elemeket használja.',
		a: 5,
		gT: 517,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismerkedik hazánk legfőbb országismereti és történelmi eseményeivel célnyelven.',
		a: 5,
		gT: 516,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel.',
		a: 5,
		gT: 515,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik célnyelvi országismereti tartalmakkal.',
		a: 5,
		gT: 514,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelvi kommunikációjába beépíti a tanult interkulturális ismereteket.',
		a: 5,
		gT: 513,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'További országismereti tudásra tesz szert.',
		a: 5,
		gT: 512,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a célnyelvi országok főbb jellemzőit és kulturális sajátosságait.',
		a: 5,
		gT: 511,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez egyszerű, szórakoztató kisfilmeket',
		a: 5,
		gT: 510,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközöket és felületeket is használ nyelvtudása fejlesztésére,',
		a: 5,
		gT: 509,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet szórakozásra és játékos nyelvtanulásra.',
		a: 5,
		gT: 508,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán kívüli, akár játékos nyelvtanulási lehetőségeket felismeri, és törekszik azokat kihasználni.',
		a: 5,
		gT: 507,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Társai haladásának értékelésében segítően részt vesz.',
		a: 5,
		gT: 506,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvi haladását többnyire fel tudja mérni,',
		a: 5,
		gT: 505,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez társaival párban és csoportban együttműködik.',
		a: 5,
		gT: 504,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket.',
		a: 5,
		gT: 503,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 5,
		gT: 502,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer szavakat, szókapcsolatokat a célnyelven a témakörre jellemző, életkorának és érdeklődésének megfelelő más tudásterületen megcélzott tartalmakból.',
		a: 5,
		gT: 501,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Hibáit többnyire észreveszi és javítja.',
		a: 5,
		gT: 500,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan használ alapszintű nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 5,
		gT: 499,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerős és gyakori alapvető helyzetekben, akár telefonon vagy digitális csatornákon is, többnyire helyesen és érthetően fejezi ki magát az ismert nyelvi eszközök segítségével.',
		a: 5,
		gT: 498,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megoszt alapvető személyes információkat és szükségleteket magáról egyszerű nyelvi elemekkel.',
		a: 5,
		gT: 497,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Nem értés esetén a meg nem értett kulcsszavak vagy fordulatok ismétlését vagy magyarázatát kéri, visszakérdez, betűzést kér.',
		a: 5,
		gT: 496,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmaz nyelvi funkciókat rövid társalgás megkezdéséhez, fenntartásához és befejezéséhez.',
		a: 5,
		gT: 495,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretlen szavak valószínű jelentését szövegösszefüggések alapján kikövetkezteti az életkorának és érdeklődésének megfelelő, konkrét, rövid szövegekben.',
		a: 5,
		gT: 494,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi eszközökkel és nonverbális elemek segítségével tisztázza mondanivalójának lényegét.',
		a: 5,
		gT: 493,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű mondatokat összekapcsolva mond el egymást követő eseményekből álló történetet, vagy leírást ad valamilyen témáról.',
		a: 5,
		gT: 492,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja az ismert nyelvi elemeket egyszerű kötőszavakkal (például: és, de, vagy).',
		a: 5,
		gT: 491,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik életkorának és nyelvi szintjének megfelelő célnyelvi szórakoztató tartalmakkal.',
		a: 5,
		gT: 490,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 5,
		gT: 489,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet ismeretszerzésre.',
		a: 5,
		gT: 488,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez és használja az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is,',
		a: 5,
		gT: 487,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez és érvekkel alátámasztva mutat be szükségességet, lehetőséget, képességet, bizonyosságot, bizonytalanságot.',
		a: 5,
		gT: 486,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez alapvető érzéseket, például örömöt, sajnálkozást, bánatot, elégedettséget, elégedetlenséget, bosszúságot, csodálkozást, reményt.',
		a: 5,
		gT: 485,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez kérést, javaslatot, meghívást, kínálást és ezekre reagálást.',
		a: 5,
		gT: 484,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Információt cserél, információt kér, információt ad.',
		a: 5,
		gT: 483,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez tetszést, nem tetszést, akaratot, kívánságot, tudást és nem tudást, ígéretet, szándékot, dicséretet, kritikát.',
		a: 5,
		gT: 482,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerűen megfogalmazza személyes véleményét, másoktól véleményük kifejtését kéri, és arra reagál, elismeri vagy cáfolja mások állítását, kifejezi egyetértését vagy egyet nem értését.',
		a: 5,
		gT: 481,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány szóból vagy mondatból álló jegyzetet készít írott szöveg alapján.',
		a: 5,
		gT: 480,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik az életkorának és nyelvi szintjének megfelelő célnyelvi ismeretterjesztő tartalmakkal.',
		a: 5,
		gT: 479,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet tudásmegosztásra.',
		a: 5,
		gT: 478,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, egyszerű, ismert nyelvi eszközökből álló kiselőadást tart változatos feladatok kapcsán, hagyományos vagy digitális alapú vizuális eszközök támogatásával.',
		a: 5,
		gT: 477,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét írásban, egyszerű nyelvi eszközökkel megfogalmazza, és arról írásban interakciót folytat.',
		a: 5,
		gT: 476,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Üzeneteket ír,',
		a: 5,
		gT: 475,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Bekapcsolódik a tanórán az interakciót igénylő nyelvi tevékenységekbe, abban társaival közösen részt vesz, a begyakorolt nyelvi elemeket tanári segítséggel a játék céljainak megfelelően alkalmazza.',
		a: 5,
		gT: 474,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre is reagál egyszerű célnyelvi eszközökkel, személyes vagy online interakciókban.',
		a: 5,
		gT: 473,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemeket többnyire megfelelően használja, beszédszándékainak megfelelően, egyszerű spontán helyzetekben.',
		a: 5,
		gT: 472,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét, gondolatait, érzéseit egyre magabiztosabban fejezi ki a tanult nyelvi eszközökkel.',
		a: 5,
		gT: 471,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának megfelelő mindennapi helyzetekben a tanult nyelvi eszközökkel megfogalmazott kérdéseket tesz fel, és válaszol a hozzá intézett kérdésekre.',
		a: 5,
		gT: 470,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációt kezdeményez egyszerű hétköznapi témában, a beszélgetést követi, egyszerű, nyelvi eszközökkel fenntartja és lezárja.',
		a: 5,
		gT: 469,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Megért és használ szavakat, szókapcsolatokat a célnyelvi, az életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel kapcsolatban',
		a: 5,
		gT: 468,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődése erősödik a célnyelvi irodalmi alkotások iránt.',
		a: 5,
		gT: 467,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'A nyomtatott vagy digitális alapú írott szöveget felhasználja szórakozásra és ismeretszerzésre önállóan is.',
		a: 5,
		gT: 466,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő írott, nyomtatott vagy digitális alapú szöveget a változatos nyelvórai tevékenységek és feladatmegoldás során.',
		a: 5,
		gT: 465,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Összetettebb írott instrukciókat értelmez.',
		a: 5,
		gT: 464,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a főbb, életkorának megfelelő írott szövegtípusokat.',
		a: 5,
		gT: 463,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja más iskolai vagy iskolán kívül szerzett ismereteivel.',
		a: 5,
		gT: 462,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó rövid írott szöveg tartalmát.',
		a: 5,
		gT: 461,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának megfelelő szituációkhoz kapcsolódó, írott szövegekben megjelenő összetettebb információkat.',
		a: 5,
		gT: 460,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Hallgat az érdeklődésének megfelelő autentikus szövegeket elektronikus, digitális csatornákon, tanórán kívül is, szórakozásra vagy ismeretszerzésre.',
		a: 5,
		gT: 459,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a főbb, életkorának megfelelő hangzószöveg-típusokat.',
		a: 5,
		gT: 458,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez életkorának megfelelő nyelvi helyzeteket hallott szöveg alapján.',
		a: 5,
		gT: 457,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő hangzó szöveget a változatos nyelvórai tevékenységek és a feladatmegoldás során.',
		a: 5,
		gT: 456,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő, élőszóban vagy digitális felületen elhangzó szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 5,
		gT: 455,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó, élőszóban vagy digitális felületen elhangzó rövid szöveg tartalmát.',
		a: 5,
		gT: 454,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának megfelelő, élőszóban vagy digitális felületen elhangzó szövegekben a beszélők gondolatmenetét.',
		a: 5,
		gT: 453,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának és nyelvi szintjének megfelelő, egyszerű, hangzó szövegben a tanult nyelvi elemeket.',
		a: 5,
		gT: 452,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a szintjének megfelelő, kevésbé ismert elemekből álló, nonverbális vagy vizuális eszközökkel támogatott célnyelvi óravezetést és utasításokat, kérdéseket.',
		a: 5,
		gT: 451,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegek létrehozásához nyomtatott, illetve digitális alapú segédeszközt, szótárt használ.',
		a: 5,
		gT: 450,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, összefüggő, papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformákban.',
		a: 5,
		gT: 449,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid szövegek írását igénylő kreatív munkát hoz létre önállóan.',
		a: 5,
		gT: 448,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, egyszerű, összefüggő szövegeket ír a tanult nyelvi szerkezetek felhasználásával az ismert szövegtípusokban, az ajánlott tématartományokban.',
		a: 5,
		gT: 447,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megold játékos és változatos írásbeli feladatokat rövid szövegek szintjén.',
		a: 5,
		gT: 446,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Változatos, kognitív kihívást jelentő szóbeli feladatokat old meg önállóan vagy kooperatív munkaformában, a tanult nyelvi eszközökkel, szükség szerint tanári segítséggel, élőszóban és digitális felületen.',
		a: 5,
		gT: 445,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Képet jellemez röviden, egyszerűen, ismert nyelvi fordulatok segítségével, segítő tanári kérdések alapján, önállóan.',
		a: 5,
		gT: 444,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű nyelvi eszközökkel, felkészülést követően röviden, összefüggően beszél az ajánlott tématartományokhoz tartozó témákban, élőszóban és digitális felületen.',
		a: 5,
		gT: 443,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Elmesél rövid történetet, egyszerűsített olvasmányt egyszerű nyelvi eszközökkel, önállóan, a cselekményt lineárisan összefűzve.',
		a: 5,
		gT: 442,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Egyre magabiztosabban kapcsolódik be történetek kreatív alakításába, átfogalmazásába kooperatív munkaformában.',
		a: 5,
		gT: 441,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz az életkorának és érdeklődésének megfelelő gyermek-, illetve ifjúsági irodalmi alkotások közös előadásában.',
		a: 5,
		gT: 440,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a nyelvtudás fontosságát, és motivációja a nyelvtanulásra tovább erősödik.',
		a: 5,
		gT: 439,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 5,
		gT: 438,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 5,
		gT: 437,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Használ életkorának és nyelvi szintjének megfelelő hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 5,
		gT: 436,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtudását egyre inkább képes fejleszteni tanórán kívüli helyzetekben is különböző eszközökkel és lehetőségekkel.',
		a: 5,
		gT: 435,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a tanult nyelvi funkciókat és a megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 5,
		gT: 434,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat, valamint közvetít az élő idegen nyelven.',
		a: 5,
		gT: 433,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez korának és nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket az ismert témákban és szövegtípusokban.',
		a: 5,
		gT: 432,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban létrehoz rövid szövegeket, ismert nyelvi eszközökkel, a korának megfelelő szövegtípusokban.',
		a: 5,
		gT: 431,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban megold változatos kihívásokat igénylő feladatokat az élő idegen nyelven.',
		a: 5,
		gT: 430,
		b: 8,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az életkorának és érdeklődésének megfelelő digitális műfajok főbb jellemzőit.',
		a: 9,
		gT: 687,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is megfelelő nyelvi eszközökkel alkot szöveget szóban és írásban.',
		a: 9,
		gT: 686,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat a természeteshez közelítő célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 685,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is folytat célnyelvi interakciót az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 684,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkalmazza az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 683,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is megérti az ismert témához kapcsolódó írott vagy hallott szövegeket.',
		a: 9,
		gT: 682,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökön és csatornákon keresztül is alkot szöveget szóban és írásban.',
		a: 9,
		gT: 681,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a legfőbb nyelvi dialektusok egyes elemeit is tartalmazó szóbeli közléseket.',
		a: 9,
		gT: 680,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a nyelvi változatokról megszerzett ismereteit informális kommunikációjában.',
		a: 9,
		gT: 679,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmaz főbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 678,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a legfőbb hasonlóságokat és különbségeket az ismert nyelvi változatok között.',
		a: 9,
		gT: 677,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'nyelvi változatok'])
	},
		{
		cG: 'altgim',
		gD: 'Interkulturális ismeretei segítségével társasági szempontból is megfelelő kommunikációt folytat írásban és szóban.',
		a: 9,
		gT: 676,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó tanult nyelvi elemeket magabiztosan használja.',
		a: 9,
		gT: 675,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Kikövetkezteti a célnyelvi kultúrákhoz kapcsolódó egyszerű, ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 674,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Környezetének kulturális értékeit célnyelven közvetíti.',
		a: 9,
		gT: 673,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Interkulturális tudatosságára építve felismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket, és a magyar értékek átadására képessé válik.',
		a: 9,
		gT: 672,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a célnyelvi és saját hazájának kultúrája közötti hasonlóságokat és különbségeket.',
		a: 9,
		gT: 671,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Átadja célnyelven a magyar értékeket.',
		a: 9,
		gT: 670,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és keresi a főbb hasonlóságokat és különbségeket saját anyanyelvi és a célnyelvi közösség szokásai, értékei, attitűdjei és meggyőződései között.',
		a: 9,
		gT: 669,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott, és alkalmazni is tudja a célnyelvi országokra jellemző alapvető érintkezési és udvariassági szokásokat.',
		a: 9,
		gT: 668,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a célnyelvi országok jellemzőiben és kulturális sajátosságaiban.',
		a: 9,
		gT: 667,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a célnyelvi országok történelmének és jelenének legfontosabb vonásait,',
		a: 9,
		gT: 666,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a célnyelvi kultúráról megszerzett ismereteit informális kommunikációjában,',
		a: 9,
		gT: 665,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközöket és felületeket is használ a célnyelven ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 664,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközöket és felületeket is magabiztosan használ nyelvtudása fejlesztésére.',
		a: 9,
		gT: 663,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik releváns digitális tartalmak használatára beszédkészségének, szókincsének és kiejtésének továbbfejlesztése céljából.',
		a: 9,
		gT: 662,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvi produkciójában és recepciójában önállóságot mutat, és egyre kevesebb korlát akadályozza.',
		a: 9,
		gT: 661,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Beszéd- és írásprodukcióját tudatosan megtervezi, hiányosságait igyekszik kompenzálni.',
		a: 9,
		gT: 660,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 659,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 658,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtanulási céljai érdekében él a valós nyelvhasználati lehetőségekkel.',
		a: 9,
		gT: 657,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Hiányosságait, hibáit felismeri, azokat egyre hatékonyabban kompenzálja, javítja a tanult stratégiák felhasználásával.',
		a: 9,
		gT: 656,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 655,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyre tudatosabban használja az ön-, tanári, vagy társai értékelését nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 654,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Használ önértékelési módokat nyelvtudása felmérésére.',
		a: 9,
		gT: 653,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvi haladását fel tudja mérni.',
		a: 9,
		gT: 652,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'a haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Az első idegen nyelvből sikeres érettségit tesz legalább középszinten.',
		a: 9,
		gT: 651,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez önszabályozóan is dolgozik.',
		a: 9,
		gT: 650,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Hatékonyan alkalmazza a tanult nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 649,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a nyelvtanulási és nyelvhasználati stratégiákat nyelvtudása fenntartására és fejlesztésére.',
		a: 9,
		gT: 648,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosít nyelvtanulási célokat és ismeri az ezekhez tartozó nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 647,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez társaival párban és csoportban is együttműködik.',
		a: 9,
		gT: 646,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket, módokat.',
		a: 9,
		gT: 645,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtanulási céljai érdekében tudatosabban foglalkozik a célnyelvvel.',
		a: 9,
		gT: 644,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmaz hosszú távú nyelvtanulási célokat saját maga számára.',
		a: 9,
		gT: 643,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 642,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Hibáiból levont következtetéseire többnyire épít nyelvtudása fejlesztése érdekében.',
		a: 9,
		gT: 641,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Hibáit az esetek többségében önállóan is képes javítani.',
		a: 9,
		gT: 640,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Használ ismeretterjesztő anyagokat nyelvtudása fejlesztésére.',
		a: 9,
		gT: 639,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Használ célnyelvi tartalmakat ismeretszerzésre.',
		a: 9,
		gT: 638,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Használ célnyelvi elemeket más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 637,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvű, legfőbb hazai és nemzetközi híreket ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 636,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 635,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtanulási céljai érdekében alkalmazza a tanórán kívüli nyelvtanulási lehetőségeket.',
		a: 9,
		gT: 634,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Megértést nehezítő hibáit önállóan javítani tudja.',
		a: 9,
		gT: 633,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Az ismert nyelvi elemeket vizsgahelyzetben is használja.',
		a: 9,
		gT: 632,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Szükség esetén eltér az előre elgondoltaktól, és mondandóját a beszédpartnerekhez, hallgatósághoz igazítja.',
		a: 9,
		gT: 631,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Szociokulturális ismeretei (például célnyelvi társadalmi szokások, testbeszéd) már lehetővé teszik azt, hogy társasági szempontból is megfelelő kommunikációt folytasson.',
		a: 9,
		gT: 630,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi funkciókat és nyelvi eszköztárát életkorának megfelelő élethelyzetekben megfelelően alkalmazza.',
		a: 9,
		gT: 629,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Szóbeli és írásbeli közlései során változatos nyelvi struktúrákat használ.',
		a: 9,
		gT: 628,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemeket adaptálni tudja kevésbé begyakorolt helyzetekhez is.',
		a: 9,
		gT: 627,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Mondanivalóját kifejti kevésbé ismerős helyzetekben is nyelvi eszközök széles körének használatával.',
		a: 9,
		gT: 626,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Nem értés esetén képes a tartalom tisztázására.',
		a: 9,
		gT: 625,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'A társalgás vagy eszmecsere menetének fenntartásához alkalmazza a rendelkezésére álló nyelvi és stratégiai eszközöket.',
		a: 9,
		gT: 624,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Félreértéshez vezető hibáit kijavítja, ha beszédpartnere jelzi a problémát; a kommunikáció megszakadása esetén más stratégiát alkalmazva újrakezdi a mondandóját.',
		a: 9,
		gT: 623,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Ismert témákban a szövegösszefüggés alapján kikövetkezteti az ismeretlen szavak jelentését, megérti az ismeretlen szavakat is tartalmazó mondat jelentését.',
		a: 9,
		gT: 622,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Körülírással közvetíti a jelentéstartalmat, ha a megfelelő szót nem ismeri.',
		a: 9,
		gT: 621,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Használ kiemelést, hangsúlyozást, helyesbítést.',
		a: 9,
		gT: 620,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Képes rendszerezni kommunikációját: jelzi szándékát, kezdeményez, összefoglal és lezár.',
		a: 9,
		gT: 619,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'kommunikációs stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Több különálló elemet összekapcsol összefüggő lineáris szempontsorrá.',
		a: 9,
		gT: 618,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'A kohéziós eszközök szélesebb körét alkalmazza szóbeli vagy írásbeli megnyilatkozásainak érthetőbb, koherensebb szöveggé szervezéséhez.',
		a: 9,
		gT: 617,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja a mondatokat megfelelő kötőszavakkal, így követhető leírást ad, vagy nem kronológiai sorrendben lévő eseményeket is elbeszél.',
		a: 9,
		gT: 616,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'pragmatikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez emlékezést és nem emlékezést.',
		a: 9,
		gT: 615,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ok-okozat viszony vagy cél meghatározását.',
		a: 9,
		gT: 614,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez segítségkérést, ajánlást és ezekre történő reagálást.',
		a: 9,
		gT: 613,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez ítéletet, kritikát, tanácsadást.',
		a: 9,
		gT: 612,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez kötelezettséget, szándékot, kívánságot, engedélykérést, feltételezést.',
		a: 9,
		gT: 611,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével kifejez érdeklődést és érdektelenséget, szemrehányást, reklamálást.',
		a: 9,
		gT: 610,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult kifejezések alkalmazásával és az alapvető nyelvi szokások követésével további alapvető érzéseket fejez ki (pl. aggódást, félelmet, kételyt).',
		a: 9,
		gT: 609,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'mindennapi idegennyelv-használat', 'szociolingvisztikai megfelelés'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban közvetít célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 608,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Írott szöveget igénylő projektmunkát készít olvasóközönségnek.',
		a: 9,
		gT: 607,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Környezeti témákban a kommunikációs helyzetek széles körében hatékonyan ad át és cserél információt.',
		a: 9,
		gT: 606,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Összefoglal és lejegyzetel, írásban közvetít rövid olvasott vagy hallott szövegeket.',
		a: 9,
		gT: 605,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer más tantárgyi tartalmakat, részinformációkat célnyelven,',
		a: 9,
		gT: 604,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'írásbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Használ célnyelvi tartalmakat tudásmegosztásra.',
		a: 9,
		gT: 603,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Egyénileg vagy kooperáció során létrehozott projektmunkával kapcsolatos kiselőadást tart önállóan, összefüggő és folyékony előadásmóddal, digitális eszközök segítségével, felkészülést követően.',
		a: 9,
		gT: 602,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Összetett információkat ad át és cserél.',
		a: 9,
		gT: 601,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'információközvetítés idegen nyelven', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban és szóban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 600,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban átad nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciók során.',
		a: 9,
		gT: 599,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét írásban változatos nyelvi eszközökkel megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 598,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét írásban, tanult nyelvi eszközökkel megfogalmazza és arról írásban interakciót folytat.',
		a: 9,
		gT: 597,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Informális és életkorának megfelelő formális írásos üzeneteket ír, digitális felületen is.',
		a: 9,
		gT: 596,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban, valós nyelvi interakciók során jó nyelvhelyességgel, megfelelő szókinccsel, a természeteshez közelítő szinten vesz részt az egyes tématartományokban és az idetartozó érettségi témákban.',
		a: 9,
		gT: 595,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre jellemzően célnyelvi eszközökkel is reagál tanórai szituációkban.',
		a: 9,
		gT: 594,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Egyre szélesebb körű témákban, nyelvi kommunikációt igénylő helyzetekben reagál megfelelő módon, felhasználva általános és nyelvi háttértudását, ismereteit, alkalmazkodva a társadalmi normákhoz.',
		a: 9,
		gT: 593,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival a kooperatív munkaformákban és a projektfeladatok megoldása során is törekszik a célnyelvi kommunikációra.',
		a: 9,
		gT: 592,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan, kezdeményezően és magabiztosan vesz részt a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 591,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A mindennapi élet különböző területein, a kommunikációs helyzetek széles körében tesz fel releváns kérdéseket információszerzés céljából, és válaszol megfelelő módon a hozzá intézett célnyelvi kérdésekre.',
		a: 9,
		gT: 590,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Érzelmeit, véleményét változatos nyelvi eszközökkel szóban megfogalmazza és arról interakciót folytat.',
		a: 9,
		gT: 589,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Előkészület nélkül részt tud venni személyes jellegű, vagy érdeklődési körének megfelelő ismert témáról folytatott társalgásban,',
		a: 9,
		gT: 588,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A társalgást hatékonyan és udvariasan fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt, akár ismeretlen beszélgetőtárs esetében is.',
		a: 9,
		gT: 587,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Társalgást kezdeményez, a megértést fenntartja, törekszik mások bevonására, és szükség esetén lezárja azt az egyes tématartományokon belül, akár anyanyelvű beszélgetőtárs esetében is.',
		a: 9,
		gT: 586,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A társalgásba aktívan, kezdeményezően és egyre magabiztosabban bekapcsolódik az érdeklődési körébe tartozó témák esetén vagy az ajánlott tématartományokon belül.',
		a: 9,
		gT: 585,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban ad át nyelvi szintjének megfelelő célnyelvi tartalmakat valós nyelvi interakciót leképező szituációkban.',
		a: 9,
		gT: 584,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz a változatos szóbeli interakciót és kognitív kihívást igénylő nyelvórai tevékenységekben.',
		a: 9,
		gT: 583,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Egyre változatosabb, hosszabb, összetettebb és elvontabb szövegeket, tartalmakat értelmez és használ.',
		a: 9,
		gT: 582,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Keresi az érdeklődésének megfelelő, célnyelvi, autentikus szövegeket szórakozásra és ismeretszerzésre tanórán kívül is.',
		a: 9,
		gT: 581,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az írott szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 580,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszűr konkrét információkat nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 579,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és értelmezi az írott szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 578,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó írott szöveg tartalmát.',
		a: 9,
		gT: 577,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegkörnyezet alapján kikövetkezteti a szövegben előforduló ismeretlen szavak jelentését.',
		a: 9,
		gT: 576,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a számára ismerős, elvontabb tartalmú szövegekben megjelenő ismeretlen nyelvi elemeket.',
		a: 9,
		gT: 575,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és értelmezi az összefüggéseket és a részleteket az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 574,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és értelmezi a lényeget az ajánlott tématartományokhoz kapcsolódó összefüggő, akár autentikus írott szövegekben.',
		a: 9,
		gT: 573,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Elolvas és értelmez nyelvi szintjének megfelelő irodalmi szövegeket.',
		a: 9,
		gT: 572,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megért szokványos tempóban folyó autentikus szórakoztató és ismeretterjesztő tartalmakat, változatos csatornákon.',
		a: 9,
		gT: 571,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és értelmezi a legtöbb televíziós hírműsort.',
		a: 9,
		gT: 570,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét akár anyanyelvi beszélők köznyelvi kommunikációjában a számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 569,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemek segítségével megérti a hangzó szöveg lényegét számára kevésbé ismert témákban és szituációkban is.',
		a: 9,
		gT: 568,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Célzottan keresi az érdeklődésének megfelelő autentikus szövegeket tanórán kívül is, ismeretszerzésre és szórakozásra.',
		a: 9,
		gT: 567,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a hangzó szövegből nyert információt feladatok megoldása során.',
		a: 9,
		gT: 566,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az elvontabb tartalmú hangzószövegek lényegét, valamint a beszélők véleményét is.',
		a: 9,
		gT: 565,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a hangzó szövegben megjelenő összetettebb részinformációkat.',
		a: 9,
		gT: 564,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az ismeretlen nyelvi elemeket is tartalmazó hangzó szöveg lényegi tartalmát.',
		a: 9,
		gT: 563,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és értelmezi az összetettebb, az ajánlott témakörökhöz kapcsolódó összefüggő szövegeket, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 562,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti, értelmezi és összefoglalja az összetettebb, a tématartományhoz kapcsolódó összefüggő hangzó szöveget, és értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 561,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a szövegben megjelenő összefüggéseket.',
		a: 9,
		gT: 560,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kikövetkezteti a szövegben megjelenő elvontabb nyelvi elemek jelentését az ajánlott témakörökhöz kapcsolódó témákban.',
		a: 9,
		gT: 559,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi hírek, események lényegét.',
		a: 9,
		gT: 558,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a szintjének megfelelő célnyelvi, komplexebb tanári magyarázatokat a nyelvórákon.',
		a: 9,
		gT: 557,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'A megfelelő szövegtípusok jellegzetességeit követi.',
		a: 9,
		gT: 556,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Beszámol akár az érdeklődési körén túlmutató közügyekkel, szórakozással kapcsolatos eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 555,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló, akár az érdeklődési körén túlmutató vagy elképzelt személyes eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 554,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegek létrehozásához nyomtatott vagy digitális segédeszközt, szótárt használ.',
		a: 9,
		gT: 553,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggő szövegeket ír önállóan, akár elvontabb témákban.',
		a: 9,
		gT: 552,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformában.',
		a: 9,
		gT: 551,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megold változatos írásbeli, feladatokat szövegszinten.',
		a: 9,
		gT: 550,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Használ szövegkohéziós és figyelemvezető eszközöket.',
		a: 9,
		gT: 549,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a formális és informális regiszterhez köthető sajátosságokat.',
		a: 9,
		gT: 548,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Információt vagy véleményt közlő és kérő, összefüggő feljegyzéseket, üzeneteket ír.',
		a: 9,
		gT: 547,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Leír összetettebb cselekvéssort, történetet, személyes élményeket, elvontabb témákban.',
		a: 9,
		gT: 546,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban röviden indokolja érzéseit, gondolatait, véleményét már elvontabb témákban.',
		a: 9,
		gT: 545,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a célnyelvi normához illeszkedő, természeteshez közelítő kiejtést, beszédtempót és intonációt.',
		a: 9,
		gT: 544,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggően, világosan és nagyrészt folyékonyan beszél az ajánlott tématartományhoz tartozó és az idevágó érettségi témákban, akár elvontabb tartalmakra is kitérve.',
		a: 9,
		gT: 543,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Beszámol akár az érdeklődési körén túlmutató környezeti eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő összetettebb, részletes és világos jellemzésével.',
		a: 9,
		gT: 542,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kreatív, változatos műfajú szövegeket alkot szóban, kooperatív munkaformákban.',
		a: 9,
		gT: 541,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggő, folyékony előadásmódú szóbeli prezentációt tart önállóan, felkészülést követően, az érettségi témakörök közül szabadon választott témában, ikt-eszközökkel támogatva mondanivalóját.',
		a: 9,
		gT: 540,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Közép- és emelt szintű nyelvi érettségi szóbeli feladatokat old meg.',
		a: 9,
		gT: 539,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Összefoglalja ismert témában nyomtatott vagy digitális alapú ifjúsági tartalmak lényegét röviden és érthetően.',
		a: 9,
		gT: 538,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ajánlott tématartományhoz kapcsolódó képi hatás kapcsán saját gondolatait, véleményét és érzéseit is kifejti az ismert nyelvi eszközökkel.',
		a: 9,
		gT: 537,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Beszámol saját élményen, tapasztalaton alapuló vagy elképzelt eseményről a cselekmény, a körülmények, az érzések és gondolatok ismert nyelvi eszközökkel történő rövid jellemzésével.',
		a: 9,
		gT: 536,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggően, érthetően és nagyrészt folyékonyan beszél az ajánlott tématartományokhoz tartozó és az érettségi témákban a tanult nyelvi eszközökkel, felkészülést követően.',
		a: 9,
		gT: 535,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Visszaad tankönyvi vagy más tanult szöveget, elbeszélést, nagyrészt folyamatos és érthető történetmeséléssel, a cselekményt logikusan összefűzve.',
		a: 9,
		gT: 534,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['első élő idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Első idegen nyelvéből sikeresen érettségit tesz a céljainak megfelelő szinten.',
		a: 9,
		gT: 533,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosítja nyelvtanulási céljait és egyéni különbségeinek tudatában, ezeknek megfelelően fejleszti nyelvtudását.',
		a: 9,
		gT: 532,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 531,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 530,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Használ hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 529,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Felkészül az aktív nyelvtanulás eszközeivel az egész életen át történő tanulásra.',
		a: 9,
		gT: 528,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtudását képes fejleszteni tanórán kívüli eszközökkel, lehetőségekkel és helyzetekben is, valamint a tanultakat és gimnáziumban a második idegen nyelv tanulásában is alkalmazza.',
		a: 9,
		gT: 527,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a nyelvi funkciókat és megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 526,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat és tartalmakat közvetít idegen nyelven.',
		a: 9,
		gT: 525,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket kevésbé ismert témákban és szövegtípusokban is.',
		a: 9,
		gT: 524,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban létrehoz szövegeket különböző szövegtípusokban.',
		a: 9,
		gT: 523,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban is megold változatos kihívásokat igénylő, többnyire valós kommunikációs helyzeteket leképező feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 522,
		b: 12,
		e2: 'Első élő idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'első élő idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Életkori sajátosságának megfelelően képessé válik a zeneművek érzelmi és intellektuális befogadására.',
		a: 1,
		gT: 715,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'A tanári instrukciók alapján alakít, finomít zenei előadásmódján.',
		a: 1,
		gT: 714,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a gyermekdalokhoz kapcsolódó játékokat.',
		a: 1,
		gT: 713,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz az iskola vagy a helyi közösség hagyományos ünnepein, tematikus projektjein.',
		a: 1,
		gT: 712,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid dallamsorokat rögtönöz.',
		a: 1,
		gT: 711,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző hangszíneket, hangmagasságokat, ellentétes dinamikai szinteket hallás után megfigyel és reprodukál.',
		a: 1,
		gT: 710,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű ritmussorokat rögtönöz.',
		a: 1,
		gT: 709,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján figyeli meg a hallgatott zeneművet.',
		a: 1,
		gT: 708,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneművek befogadásában kreatívan használja képzeletét.',
		a: 1,
		gT: 707,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Reprodukálja a tanult ritmusokat mozgással, testhangszerrel, valamint egyszerű ritmushangszerekkel.',
		a: 1,
		gT: 706,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli, hogy ugyanaz a dallamrészlet különböző magasságokban írható, olvasható.',
		a: 1,
		gT: 705,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel képes leírni és olvasni egyszerű ritmusokat, dallamfordulatokat.',
		a: 1,
		gT: 704,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'A dalokat tanári segítséggel szolmizálva énekli, kézjelekkel mutatja.',
		a: 1,
		gT: 703,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tanult, énekelt zenei anyaghoz köthető szolmizációs hangokat, kézjelről énekel.',
		a: 1,
		gT: 702,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri, énekli és alkalmazza a pentaton hangkészlet hangjait.',
		a: 1,
		gT: 701,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'A tanár által énekelt dalokat belső hallással követi.',
		a: 1,
		gT: 700,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli a hangok magasságának változásait, különböző hangszíneket, ellentétes dinamikai szinteket, ezeket felismeri az őt körülvevő világ hangjaiban, tanult dalokban, zeneművekben.',
		a: 1,
		gT: 699,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Ritmizálva szólaltat meg mondókákat, gyermekverseket.',
		a: 1,
		gT: 698,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a páros és a páratlan lüktetést.',
		a: 1,
		gT: 697,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és hangoztatja az összetett ritmusokat (szinkópa, nyújtott és éles ritmus), az egész értékű kottát, a pontozott fél értékű kottát és az egyedül álló nyolcadot azok szüneteivel, valamint tájékozódik a 4/4-es és 3/4-es ütemben.',
		a: 1,
		gT: 696,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és hangoztatja a negyed, nyolcadpár, fél értékű ritmusokat, a negyed és a fél értékű szünetet, tájékozódik a 2/4-es ütemben, felismeri és használja az ütemvonalat, záróvonalat, az ismétlőjelet.',
		a: 1,
		gT: 695,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli és hangoztatja az egyenletes lüktetést, az ütemhangsúlyt a tanult dalokban, zenei szemelvényekben.',
		a: 1,
		gT: 694,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Fogalmi szinten megkülönbözteti az egyenletes lüktetést és a ritmust.',
		a: 1,
		gT: 693,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalokhoz kapcsolódó játékokban, táncokban, dramatizált előadásokban osztálytársaival aktívan részt vesz.',
		a: 1,
		gT: 692,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Hangszerkíséretes dalokat énekel tanára vagy hangszeren játszó osztálytársa kíséretével.',
		a: 1,
		gT: 691,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalok, zenei részletek éneklésekor változatosan tudja használni hangerejét a zenei kifejezésnek megfelelően.',
		a: 1,
		gT: 690,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer legalább 180 gyermekdalt, magyar népdalt.',
		a: 1,
		gT: 689,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportosan vagy önállóan, életkorának és hangi sajátosságainak megfelelő hangmagasságban énekel, törekszik a tiszta intonációra és a daloknak megfelelő tempóra.',
		a: 1,
		gT: 688,
		b: 4,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'ének-zene'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló beszámolókat készít internetes és egyéb zenei adatbázisok, gyűjtemények felhasználásával.',
		a: 5,
		gT: 761,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és használ internetes zenei adatbázisokat, gyűjteményeket.',
		a: 5,
		gT: 760,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'A tanári instrukciók alapján alakít, finomít zenei előadásmódján.',
		a: 5,
		gT: 759,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli és felismeri az összefüggéseket zene és szövege, zenei eszközök és zenei mondanivaló között.',
		a: 5,
		gT: 758,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Képessé válik a zeneművek érzelmi és intellektuális befogadására.',
		a: 5,
		gT: 757,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz az iskola vagy a helyi közösség hagyományos ünnepein és tematikus projektjeiben.',
		a: 5,
		gT: 756,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult népdalokat tájegységekhez, azok ma is élő hagyományaihoz, jellegzetes népművészeti motívumaihoz, ételeihez köti.',
		a: 5,
		gT: 755,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a műzenét, népzenét és a népdalfeldolgozásokat.',
		a: 5,
		gT: 754,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a giusto, parlando és rubato előadásmódú népdalokat.',
		a: 5,
		gT: 753,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Hangzás és látvány alapján felismeri a legelterjedtebb népi hangszereket és hangszeregyütteseket.',
		a: 5,
		gT: 752,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer néhány magyar és más kultúrákra jellemző hangszert.',
		a: 5,
		gT: 751,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneműveket műfajok és zenei korszakok szerint értelmezi, ismeri történelmi, kulturális és társadalmi hátterüket.',
		a: 5,
		gT: 750,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneművek befogadásának előkészítése során részt vesz olyan közös kreatív zenélési formákban, melyek segítenek a remekművek közelébe jutni, felhasználja énekhangját, az akusztikus környezet hangjait, ütőhangszereket, egyszerűbb dallamhangszereket.',
		a: 5,
		gT: 749,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneművektől inspirálódva produktívan használja képzeletét, megfogalmazza a zene keltette érzéseit, gondolatait, véleményét.',
		a: 5,
		gT: 748,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult ritmikai és dallami elemeket alkalmazva egyszerű ritmussorokat, dallamokat kiegészít és improvizál.',
		a: 5,
		gT: 747,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megtalálja a kapcsolatot a zeneművek által közvetített élethelyzetek és a saját élethelyzete között.',
		a: 5,
		gT: 746,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány mondattal összefoglalja a zenemű mondanivalóját (például miért íródott, kinek szól, milyen gondolatokat, érzelmeket fejez ki).',
		a: 5,
		gT: 745,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdéseket vet fel a zenemű üzenetére és kifejezőeszközeire vonatkozóan, többféle szempontot érvényesítve alkot véleményt.',
		a: 5,
		gT: 744,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli az egyes hangszerek hangszínének a hangszerjáték és az előadásmód különbözőségéből adódó karakterét.',
		a: 5,
		gT: 743,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Követni tudja a zenei elemek összetartozását, egymást kiegészítő vagy egymástól eltérő struktúráját, a zenei kifejezésben betöltött funkcióját.',
		a: 5,
		gT: 742,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a tanult zenéket, megnevezi azok alkotóit és keletkezésüknek ismert körülményeit.',
		a: 5,
		gT: 741,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli, összehasonlítja a zenét és a cselekményt, azonosítja a témát és a szereplőket, hangulatot, műfajt, korszakot.',
		a: 5,
		gT: 740,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítani tudja a zenetörténeti stílusok főbb jellemzőit, a hozzájuk tartozó műfajokat, jellegzetes hangszereket, hangszer-összeállításokat, ismeri történelmi, kulturális és társadalmi hátterüket, mely segíti zeneértésüket.',
		a: 5,
		gT: 739,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Életkori sajátosságainak megfelelően megadott szempontok segítségével értelmezi a különböző műfajú és stílusú zenéket, követi a lineáris és vertikális zenei folyamatokat.',
		a: 5,
		gT: 738,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a homofon és polifon szerkesztést.',
		a: 5,
		gT: 737,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és azonosítja a különböző formarészek zenén belüli szerepét.',
		a: 5,
		gT: 736,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretlen kotta esetében is vizuálisan nyomon tudja követni a hallott ritmikai és dallami folyamatokat.',
		a: 5,
		gT: 735,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismerő kottaolvasással együttesen követi a ritmikai és dallami elemeket.',
		a: 5,
		gT: 734,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ütemmutató, violin- és basszuskulcsok.',
		a: 5,
		gT: 733,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi és beazonosítja a kottakép alapvető elemeit, például tempójelzés.',
		a: 5,
		gT: 732,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Fogalmi szinten ismeri a tiszta, kis- és nagy hangközöket (t1-t8), és a fél és egész hangos építkezés logikáját.',
		a: 5,
		gT: 731,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a hangköz és hármashangzat fogalmát és fogalmi szinten a hangközök harmóniaalkotó szerepét.',
		a: 5,
		gT: 730,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismerő kottaolvasással követi és értelmezi a módosított hangok szerepét a dalokban.',
		a: 5,
		gT: 729,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az előjegyzésekhez kapcsolódó abszolút hangneveket.',
		a: 5,
		gT: 728,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és jártasságot szerez a hétfokú skála szolmizációs hangjainak írásában és olvasásában.',
		a: 5,
		gT: 727,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Hallás útján megfigyeli a tanult zeneművekben a dúr és moll hangzását, melyeket zenei karakterekhez, hangulatokhoz kapcsol.',
		a: 5,
		gT: 726,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli a tanult dalokban a váltakozó ütemek lüktetését.',
		a: 5,
		gT: 725,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző ritmusképleteket eltérő tempókban is reprodukál.',
		a: 5,
		gT: 724,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az alapritmusok relációit (egész-, fél-, negyedérték, nyolcadpár, fél- és negyedszünet) és az összetett ritmusokat (szinkópa, kis- és nagy nyújtott, kis- és nagy éles, triola, tizenhatodos ritmusok), grafikai jelüket és értéküket.',
		a: 5,
		gT: 723,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalokhoz kapcsolódó dramatizált előadásokban osztálytársaival aktívan részt vesz.',
		a: 5,
		gT: 722,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Hangszerkíséretes dalokat énekel, tanára vagy hangszeren játszó osztálytársa kíséretével.',
		a: 5,
		gT: 721,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Változatosan tudja alkalmazni a tempó és dinamikai, előadási utasításokat (tempo giusto, parlando, rubato, piano, mezzoforte, forte).',
		a: 5,
		gT: 720,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Emlékezetből énekli a himnuszt és a szózatot.',
		a: 5,
		gT: 719,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: '127 új dalt ismer.',
		a: 5,
		gT: 718,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'A zenei karaktereket differenciáltan tudja megszólaltatni a népi vagy klasszikus stílusjegyeknek megfelelően egyszerű többszólamúságban is.',
		a: 5,
		gT: 717,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportosan vagy önállóan, életkorának és hangi sajátosságainak megfelelő hangmagasságban énekel, törekszik a tiszta intonációra, kifejező, a zene stílusának megfelelő előadásra.',
		a: 5,
		gT: 716,
		b: 8,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Zenei ízlése az értékek mentén fejlődik.',
		a: 9,
		gT: 800,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló kutatást végez feladatai megoldásához nyomtatott és digitális forrásokban.',
		a: 9,
		gT: 799,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalok üzenetét, saját életének, környezetének jelenségeire tudja vonatkoztatni.',
		a: 9,
		gT: 798,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi és önállóan véleményezi a zenéhez társított szöveg és a zene kapcsolatát.',
		a: 9,
		gT: 797,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Mondanivalójáról, és azt az adott zeneműből vett példákkal illusztrálja.',
		a: 9,
		gT: 796,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Órai tapasztalatai és saját ismeretanyaga alapján önálló véleményt alkot a zenemű',
		a: 9,
		gT: 795,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'A hallott zeneműveket érzelmi és intellektuális módon közelíti meg, érti és értékeli a művészeti alkotásokat.',
		a: 9,
		gT: 794,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'önálló tanulás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneműveket zenetörténeti kontextusba tudja helyezni, kapcsolatot talál történelmi, irodalmi, kultúrtörténeti vonatkozásokkal, azonosítja a műfaji jellemzőket',
		a: 9,
		gT: 793,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz az iskola vagy a helyi közösség hagyományos ünnepein, tematikus projektjein.',
		a: 9,
		gT: 792,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Fogalmi szinten tájékozott a zenének a viselkedésre, fejlődésre és agyműködésre gyakorolt hatásaiban.',
		a: 9,
		gT: 791,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a főbb fővárosi zenei intézményeket (például zeneakadémia, magyar állami operaház, müpa), főbb vidéki zenei centrumokat (például kodály központ -- pécs, kodály intézet -- kecskemét), továbbá lakóhelye művelődési intézményeit.',
		a: 9,
		gT: 790,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét, a tanár által választott műalkotásokon keresztül összehasonlítja a különböző művészeti ágak kifejezőeszközeit, például hogyan fejez ki azonos érzelmet, mondanivalót a zene és más művészetek.',
		a: 9,
		gT: 789,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét művek példáin keresztül tanári segítséggel elkülöníti és egymással kapcsolatba hozza az irodalomhoz és különböző művészeti ágakhoz (film, képzőművészet, tánc) tartozó alkotások jellemző vonásait a nyelvi, vizuális, mozgási és multimédiás művészetekben és a zenében.',
		a: 9,
		gT: 788,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult népdalokat tájegységekhez, azok ma is élő hagyományaihoz, jellegzetes népművészeti motívumaihoz, ételeihez köti.',
		a: 9,
		gT: 787,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a népdalok szövegét, mondanivalóját, megtalálja bennük önmagát.',
		a: 9,
		gT: 786,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer magyar és más kultúrákra jellemző zenei sajátságokat, s ezeket újonnan hallott zeneművekben is felfedezi.',
		a: 9,
		gT: 785,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'kulturális műveltség és kulturális befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz kreatív zenélési formákban.',
		a: 9,
		gT: 784,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Az elsajátított zenei anyagot élményszerűen alkalmazza tematikus projektekben.',
		a: 9,
		gT: 783,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Alapszintű ismereteket alkalmaz a digitális technika zenei felhasználásában.',
		a: 9,
		gT: 782,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Társítani tudja a zeneművekben megfogalmazott gondolatokat hangszerelési, szerkesztési megoldásokkal, kompozíciós technikákkal, formai megoldásokkal.',
		a: 9,
		gT: 781,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei alkotókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneműveket összekapcsolja élethelyzetekkel, melyeket saját élete és környezete jelenségeire, problémáira tud vonatkoztatni.',
		a: 9,
		gT: 780,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A dalok és a zeneművek befogadásához, azok előadásához felhasználja eddigi ritmikai, dallami, harmóniai ismereteit.',
		a: 9,
		gT: 779,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a különböző zenei interpretációk közötti különbségeket, s azokat véleményezi.',
		a: 9,
		gT: 778,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kezdetben tanári segítséggel, majd önállóan azonosítja a zenében megjelenő társadalmi, erkölcsi, vallási, és kulturális mintákat.',
		a: 9,
		gT: 777,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdéseket vet fel a zenemű üzenetére és kifejezőeszközeire vonatkozóan.',
		a: 9,
		gT: 776,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'A zeneműveket tanári segítséggel történelmi, földrajzi és társadalmi kontextusba helyezi.',
		a: 9,
		gT: 775,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kezdetben tanári segítséggel, majd önállóan felismeri adott zeneműben a stílus és korszak hatását.',
		a: 9,
		gT: 774,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tud tenni korszakok, műfajok között.',
		a: 9,
		gT: 773,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei befogadókészség'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és azonosítja a különböző formarészek zenén belüli szerepét.',
		a: 9,
		gT: 772,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Fogalmi szinten ismeri a hangközök harmóniaalkotó szerepét.',
		a: 9,
		gT: 771,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretlen kotta esetében is vizuálisan nyomon tudja követni a hallott ritmikai és dallami folyamatokat.',
		a: 9,
		gT: 770,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi és beazonosítja a kottakép alapvető elemeit, például tempójelzés, ütemmutató, violin- és basszuskulcsok.',
		a: 9,
		gT: 769,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismerő kottaolvasással követi a ritmikai és dallami elemeket.',
		a: 9,
		gT: 768,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'ritmikai és hallásfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalokhoz kapcsolódó dramatizált előadásokban osztálytársaival aktívan részt vesz.',
		a: 9,
		gT: 767,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Hangszerkíséretes dalokat énekel, tanára vagy hangszeren játszó osztálytársa kíséretével, a műdalok előadásában alkalmazkodni tud a hangszerkísérethez.',
		a: 9,
		gT: 766,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: '43 új dalt ismer.',
		a: 9,
		gT: 765,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Emlékezetből és kottakép segítségével énekel régi és új rétegű magyar népdalokat, más népek dalait, műdalokat, kánonokat.',
		a: 9,
		gT: 764,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult dalokat stílusosan, kifejezően adja elő.',
		a: 9,
		gT: 763,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportosan vagy önállóan, életkorának és hangi sajátosságainak megfelelő hangmagasságban énekel, törekszik a tiszta intonációra.',
		a: 9,
		gT: 762,
		b: 10,
		e2: 'Ének-zene',
		jE: _List_fromArray(
			['ének-zene', 'zenei előadókészség', 'éneklés'])
	},
		{
		cG: 'altgim',
		gD: 'A naponta használt csomagolóeszközök kiválasztásában megindokolja, hogy milyen elvek alkalmazása támogatja a környezetvédelmi szempontok érvényesülését, és ezekre társai figyelmét is felhívja.',
		a: 1,
		gT: 850,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'Játékvásárlási szokásaiban példát hoz olyan elemekre, amelyek révén figyelembe vehetők a környezetvédelmi szempontok, és felhívja társai figyelmét is ezekre.',
		a: 1,
		gT: 849,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'A szabályok jelentőségét különböző kontextusokban azonosítja és társaival megvitatja, a szabályszegés lehetséges következményeit megfogalmazza.',
		a: 1,
		gT: 848,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer néhány kihalt vagy kihalófélben lévő élőlényt, tájékozott a jelenség magyarázatában, és ezekről információt gyűjt fizikai és digitális környezetben is.',
		a: 1,
		gT: 847,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'A bibliai történetekben megnyilvánuló igazságos és megbocsátó magatartásra saját életéből példákat hoz, vagy megkezdett történetet a megadott szempont szerint fejez be.',
		a: 1,
		gT: 846,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a világvallások emberképéről és etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az olvasott vagy hallott bibliai tanításokban, mondákban, mesékben a megjelenő együttélési szabályokat.',
		a: 1,
		gT: 845,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a világvallások emberképéről és etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Más vallások ünnepei közül ismer néhányat.',
		a: 1,
		gT: 844,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a világvallások emberképéről és etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'A bibliai szövegekre támaszkodó történetek megismerése alapján értelmezi, milyen vallási eseményhez kapcsolódik egy-egy adott ünnep.',
		a: 1,
		gT: 843,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a világvallások emberképéről és etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Magatartásával az igazságosság, a fair play elveinek betartására törekszik, és ezáltal igyekszik mások bizalmát elnyerni.',
		a: 1,
		gT: 842,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Irodalmi szemelvények alapján példákat azonosít igazságos és igazságtalan cselekedetekre, saját élmény alapján példát hoz ilyen helyzetekre, valamint részt vesz ezek megbeszélésében, tanítói vezetéssel.',
		a: 1,
		gT: 841,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a képességek kibontakoztatását érintő gyermeki jogokról, ennek családi, iskolai és iskolán kívüli következményeiről, a gyermekek kötelességeiről.',
		a: 1,
		gT: 840,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a testi és érzelmi biztonságra vonatkozó gyermeki jogokról.',
		a: 1,
		gT: 839,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'A lakóhelyén élő nemzetiségek tagjai, hagyományai iránt nyitott, ezekről információkat gyűjt fizikai és digitális környezetben.',
		a: 1,
		gT: 838,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorához illeszkedő mélységben ismeri a nemzeti, az állami ünnepek, egyházi ünnepkörök jelentését, a hozzájuk kapcsolódó jelképeket.',
		a: 1,
		gT: 837,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődést mutat magyarország történelmi emlékei iránt, ismer közülük néhányat.',
		a: 1,
		gT: 836,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'A közvetlen lakóhelyéhez kapcsolódó nevezetességeket ismeri, ezekről információkat gyűjt fizikai és digitális környezetben, társaival együtt meghatározott formában bemutatót készít.',
		a: 1,
		gT: 835,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Képes azonosítani a szeretet és az elfogadás jelzéseit.',
		a: 1,
		gT: 834,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Szerepet vállal iskolai rendezvényeken, illetve azok előkészítésében, vagy iskolán belül szervezett szabadidős programban vesz részt.',
		a: 1,
		gT: 833,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az ünneplés jelentőségét, elkülöníti a családi, a nemzeti, az állami és egyéb ünnepeket, és az egyházi ünnepköröket, aktív résztvevője a közös ünnepek előkészületeinek.',
		a: 1,
		gT: 832,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a családi szokások jelentőségét és ezek természetes különbözőségét (alkalmazkodik az éjszakai pihenéshez, az étkezéshez, a testi higiénéhez fűződő, a tanulási és a játékidőt meghatározó családi szokásokhoz).',
		a: 1,
		gT: 831,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Erkölcsi érzékenységgel reagál az igazmondást, a becsületességet, a személyes és szellemi tulajdont, valamint az emberi méltóság tiszteletben tartását érintő helyzetekre fizikai és digitális környezetben is.',
		a: 1,
		gT: 830,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'értékekre és erkölcsi alapelvekre alapozott döntéshozatal'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a „jó\" és „rossz\" közötti különbséget a közösen megbeszélt eseményekben és történetekben.',
		a: 1,
		gT: 829,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'értékekre és erkölcsi alapelvekre alapozott döntéshozatal'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az asszertív viselkedés elemeit konfliktushelyzetben és másokkal kezdeményezett interakcióban, baráti kapcsolatokat tart fenn.',
		a: 1,
		gT: 828,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Saját érdekeit másokat nem bántó módon fejezi ki, az ehhez illeszkedő kifejezésmódokat ismeri és alkalmazza.',
		a: 1,
		gT: 827,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a sértő és tiszteletteljes közlési módokat fizikai és digitális környezetben egyaránt, barátsággá alakuló kapcsolatokat kezdeményez.',
		a: 1,
		gT: 826,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a felnőttekkel és társakkal folytatott társas helyzeteket.',
		a: 1,
		gT: 825,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz verbális és nem verbális jelzések között.',
		a: 1,
		gT: 824,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Mások helyzetébe tudja képzelni magát, és megérti a másik személy érzéseit.',
		a: 1,
		gT: 823,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az életkorának megfelelő beszélgetés alapvető szabályait.',
		a: 1,
		gT: 822,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése; interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri annak fontosságát, hogy sorsfordító családi események kapcsán saját érzelmeit felismerje, megélje, feldolgozza, s azokat elfogadható módon kommunikálja a környezete felé.',
		a: 1,
		gT: 821,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei (reziliencia)'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a nehéz élethelyzettel (pl.:új családtag érkezése vagy egy családtag eltávozása) kapcsolatos érzéseit.',
		a: 1,
		gT: 820,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei (reziliencia)'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az őt ért bántalmazást, ismer néhány olyan segítő bizalmi személyt, akihez segítségért fordulhat.',
		a: 1,
		gT: 819,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei (reziliencia)'])
	},
		{
		cG: 'altgim',
		gD: 'Rendelkezik a stresszhelyzetben keletkezett negatív érzelmek kezeléséhez saját módszerekkel.',
		a: 1,
		gT: 818,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei (reziliencia)'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a testi-lelki egészség fogalmát és főbb szempontjait , motivált a krízisek megelőzésében, és a megoldáskeresésben.',
		a: 1,
		gT: 817,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei (reziliencia)'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai megvalósítása során önkontrollt, siker esetén önjutalmazást gyakorol.',
		a: 1,
		gT: 816,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Meggyőződése, hogy a hiányosságok javíthatók, a gyengeségek fejleszthetők, és ehhez teljesíthető rövid távú célokat tűz maga elé saját tudásának és képességeinek fejlesztése céljából.',
		a: 1,
		gT: 815,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Célokat tűz ki maga elé, és azonosítja a saját céljai eléréséhez szükséges főbb lépéseket.',
		a: 1,
		gT: 814,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, milyen tevékenységeket, helyzeteket kedvel, illetve nem kedvel, azonosítja saját viselkedésének jellemző elemeit.',
		a: 1,
		gT: 813,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'A csoportos tevékenységek keretében felismeri és megjeleníti az alapérzelmeket, az alapérzelmeken kívül is felismeri és megnevezi a saját érzelmi állapotokat.',
		a: 1,
		gT: 812,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az élet tiszteletének és a felelősségvállalásának az elveit, hétköznapi szokásai alakításánál tekintettel van társas és fizikai környezetére.',
		a: 1,
		gT: 811,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Erkölcsi fogalomkészlete tudatosodik és gazdagodik, az erkölcsi értékfogalmak, a segítség, önzetlenség, tisztelet, szeretet, felelősség, igazságosság, méltányosság, lelkiismeretesség, mértékletesség jelentésével.',
		a: 1,
		gT: 810,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza gondolatait az élet néhány fontos kérdéséről és a róluk tanított elképzelésekkel kapcsolatosan.',
		a: 1,
		gT: 809,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődést tanúsít a gyermeki jogok és kötelezettségek megismerése iránt a családban, az iskolában és az iskolán kívüli közösségekben.',
		a: 1,
		gT: 808,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Pozitív attitűddel viszonyul a nemzeti és a nemzetiségi hagyományok, a nemzeti ünnepek és az egyházi ünnepkörök iránt.',
		a: 1,
		gT: 807,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri saját lelkiismerete működését.',
		a: 1,
		gT: 806,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik szabadságra, alkalmazkodásra, bizalomra, őszinteségre, tiszteletre és igazságosságra a különféle közösségekben.',
		a: 1,
		gT: 805,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egyes cselekvésekre vonatkozó erkölcsi szabályokat, viselkedése szervezésénél figyelembe veszi ezeket.',
		a: 1,
		gT: 804,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik az érzelmek konstruktív és együttérző kifejezésmódjainak alkalmazására.',
		a: 1,
		gT: 803,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a hatékony kommunikációt segítő és akadályozó verbális és nonverbális elemeket és magatartásformákat.',
		a: 1,
		gT: 802,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja saját helyzetét, erősségeit és fejlesztendő területeit, és ennek tudatában rövid távú célokat tartalmazó tervet tud kialakítani saját egyéni fejlődésére vonatkozóan.',
		a: 1,
		gT: 801,
		b: 4,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a teremtett rend, világ, a fenntarthatóság összefüggéseit, az emberiség ökológiai cselekvési lehetőségeit.',
		a: 5,
		gT: 898,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és véleményezi a természeti erőforrások felhasználására, a környezetszennyeződés, a globális és társadalmi egyenlőtlenségek problémájára vonatkozó etikai felvetéseket.',
		a: 5,
		gT: 897,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'Folyamatosan frissíti az emberi tevékenység környezetre gyakorolt hatásaival kapcsolatos ismereteit fizikai és digitális környezetében, mérlegelő szemlélettel vizsgálja a technikai fejlődés lehetőségeit.',
		a: 5,
		gT: 896,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társadalmi felelősségvállalás és elköteleződés a fenntartható jövő iránt'])
	},
		{
		cG: 'altgim',
		gD: 'Saját életét meghatározó világnézeti meggyőződés birtokában a kölcsönös tolerancia elveit valósítja meg a tőle eltérő nézetű személyekkel való kapcsolata során.',
		a: 5,
		gT: 895,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a vallás etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Egyéni cselekvési lehetőségeket fogalmaz meg az erkölcsi értékek érvényesítésére.',
		a: 5,
		gT: 894,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a vallás etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a szeretetnek, az élet tisztelete elvének a kultúrára gyakorolt hatását.',
		a: 5,
		gT: 893,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a vallás etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Feltárja, hogyan jelenik meg a hétköznapok során a vallás emberi életre vonatkozó tanítása.',
		a: 5,
		gT: 892,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'személyes vélemény kialakítása a vallás etikai tanításáról'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának megfelelő szinten értelmezi a családi élet mindennapjait befolyásoló fontosabb jogszabályok nyújtotta lehetőségeket (például családi pótlék, családi adókedvezmény, gyermekvédelmi támogatás).',
		a: 5,
		gT: 891,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az egyéni, családi és a társadalmi boldogulás, érvényesülés feltételeit.',
		a: 5,
		gT: 890,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a norma- és szabályszegés következményeit, és etikai kérdéseket vet fel velük kapcsolatban.',
		a: 5,
		gT: 889,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz a különleges bánásmódot igénylő tanulók megértését segítő feladatokban, programokban, kifejti saját véleményét.',
		a: 5,
		gT: 888,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a rá vonatkozó gyermekjogokat, az ezeket szabályozó főbb dokumentumokat, értelmezi kötelezettségeit, részt vesz a szabályalkotásban.',
		a: 5,
		gT: 887,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'közösségi aktivitás tervezése a jogrendszerek ismeretére támaszkodó gondolkodás alapján'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseket gyűjt a keresztény, keresztyén vallás és az európai, nemzeti értékvilágról, a közös jelképekről, szimbólumokról, az egyházi ünnepkörökről.',
		a: 5,
		gT: 886,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a nemzeti és az európai értékek közös jellemzőit, az európai kulturális szellemiség, értékrendszer meghatározó elemeit.',
		a: 5,
		gT: 885,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nemzeti identitást meghatározó kulturális értékeket, indokolja miért fontos ezek megőrzése.',
		a: 5,
		gT: 884,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Fizikai vagy digitális környezetben információt gyűjt és megosztja tudását a sport, a technika vagy a művészetek területén a nemzet és európa kultúráját meghatározó kiemelkedő személyiségekről és tevékenységükről.',
		a: 5,
		gT: 883,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nemzeti és európai identitást meghatározó kulturális értékek megismerése és pozitív értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza, hogy a szeretetnek, hűségnek, elkötelezettségnek, bizalomnak, tiszteletnek milyen szerepe van a társas lelkületi kapcsolatokban.',
		a: 5,
		gT: 882,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri saját családjának viszonyrendszerét, átéli a családot összetartó érzelmeket és társas lelkületi értékeket, a különböző generációk családot összetartó szerepét.',
		a: 5,
		gT: 881,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli a családban előforduló, bizalmat érintő konfliktusos területeket.',
		a: 5,
		gT: 880,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja és összehasonlítja a családban betöltött szerepeket és feladatokat.',
		a: 5,
		gT: 879,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'aktív szerepvállalás a családban és a családon kívüli közösségek életében'])
	},
		{
		cG: 'altgim',
		gD: 'A csoporthoz való csatlakozás vagy az onnan való kiválás esetén összeveti a csoportnormákat és saját értékrendjét, mérlegeli az őt érő előnyöket és hátrányokat.',
		a: 5,
		gT: 878,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'értékekre és erkölcsi alapelvekre alapozott döntéshozatal'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja, értékeli az etikus és nem etikus cselekvések lehetséges következményeit.',
		a: 5,
		gT: 877,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'értékekre és erkölcsi alapelvekre alapozott döntéshozatal'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a számára fontos közösségi értékeket, indokolja, hogy ezek milyen szerepet játszanak a saját életében.',
		a: 5,
		gT: 876,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'értékekre és erkölcsi alapelvekre alapozott döntéshozatal'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a szabadság és önkorlátozás, a tolerancia és a szeretet megjelenését és határait egyéni élethelyzeteiben.',
		a: 5,
		gT: 875,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott és segítőkész a nehéz helyzetben lévő személyek iránt.',
		a: 5,
		gT: 874,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik mások helyzetének megértésére, felismeri a mások érzelmi állapotára és igényeire utaló jelzéseket, a fizikai és a digitális környezetben egyaránt.',
		a: 5,
		gT: 873,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a csoportban elfoglalt helyét és szerepét, törekszik a személyiségének legjobban megfelelő feladatok ellátására.',
		a: 5,
		gT: 872,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a konfliktus kialakulására utaló jelzéseket, vannak megoldási javaslatai a konfliktusok békés megoldására.',
		a: 5,
		gT: 871,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a saját véleményétől eltérő véleményekhez tisztelettel viszonyulni, a saját álláspontja mellett érvelni, konszenzusra törekszik.',
		a: 5,
		gT: 870,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'társas helyzetek észlelése és interperszonális készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a valós és virtuális térben történő zaklatások fokozatait és módjait, van terve a zaklatások elkerülésére, kivédésére, tudja, hogy hová fordulhat segítségért.',
		a: 5,
		gT: 869,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer olyan mintákat és lehetőségeket, amelyek segítségével a krízishelyzetek megoldhatók, és tudja, hogy adott esetben hová fordulhat segítségért.',
		a: 5,
		gT: 868,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer testi és mentális egészséget őrző tevékenységeket és felismeri a saját egészségét veszélyeztető hatásokat; megfogalmazza saját intim terének határait.',
		a: 5,
		gT: 867,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'a nehéz élethelyzetekkel történő megküzdés készségei'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdőívek használatával felismeri pályaérdeklődését és továbbtanulási céljait.',
		a: 5,
		gT: 866,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Valósághűen elmondja, hogy a saját érzelmi állapotai milyen hatást gyakorolnak a társas kapcsolatai alakítására, a tanulási tevékenységére.',
		a: 5,
		gT: 865,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Dramatikus eszközökkel megjelenített helyzetekben különböző érzelmi állapotok által vezérelt viselkedést eljátszik, és ennek a másik személyre tett hatását a csoporttal közösen megfogalmazza.',
		a: 5,
		gT: 864,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Reflektív tanulási gyakorlatot alakít ki, önálló tanulási feladatot kezdeményez.',
		a: 5,
		gT: 863,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő döntéseket hoz arról, hogy az online térben milyen információkat oszthat meg önmagáról.',
		a: 5,
		gT: 862,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz a valóságos és a virtuális identitás között, megérti a virtuális identitás jellemzőit.',
		a: 5,
		gT: 861,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az identitás fogalmát és jellemzőit, azonosítja saját identitásának néhány elemét.',
		a: 5,
		gT: 860,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['etika', 'önismereti és önszabályozási készségek'])
	},
		{
		cG: 'altgim',
		gD: 'Strukturált önmegfigyelésre alapozva megismeri személyiségének egyes jellemzőit, saját érdeklődési körét, speciális pályaérdeklődését.',
		a: 5,
		gT: 859,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'A személyes életben is megvalósítható tevékenységeket végez, ami összhangban van a teremtett rend megőrzésével, a fenntartható jövővel.',
		a: 5,
		gT: 858,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményt formál a zsidó keresztény, keresztyén értékrenden alapuló vallások erkölcsi értékeiről, feltárja, hogy hogyan jelennek meg ezek az értékek az emberi viselkedésben a közösségi szabályokban.',
		a: 5,
		gT: 857,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Elfogadó attitűdöt tanúsít az eltérő társadalmi, kulturális helyzetű vagy különleges bánásmódot igénylő tanulók iránt.',
		a: 5,
		gT: 856,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri saját és mások érzelmi állapotát, az adott érzelmi állapotot kezelő viselkedést tud választani; a helyzethez igazodó társas konfliktus-megoldási eljárás alkalmazására törekszik.',
		a: 5,
		gT: 855,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja saját szerepét a családi viszonyrendszerben, felismeri azokat az értékeket, amelyek a család összetartozását, harmonikus működését és az egyén egészséges fejlődését biztosítják.',
		a: 5,
		gT: 854,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Környezetében felismeri azokat a személyeket, akiknek tevékenysége példaként szolgálhat mások számára; ismeri néhány kiemelkedő személyiség életművét, és elismeri hozzájárulását a tudomány, a technológia, a művészetek gyarapításához, nemzeti és európai történelmünk alakításához.',
		a: 5,
		gT: 853,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Erkölcsi szempontok alapján vizsgálja személyes helyzetét; etikai alapelvek és az alapvető jogok szerint értékeli saját és mások élethelyzetét, valamint néhány társadalmi problémát.',
		a: 5,
		gT: 852,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Fogalmi rendszerében kialakul az erkölcsi jó és rossz, mint minősítő kategória, az erkölcsi dilemma és az erkölcsi szabályok fogalma, ezeket valós vagy fiktív példákhoz tudja kötni.',
		a: 5,
		gT: 851,
		b: 8,
		e2: 'Etika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'etika'])
	},
		{
		cG: 'altgim',
		gD: 'Használ mérésre, adatelemzésre, folyamatelemzésre alkalmas összetett szoftvereket (például hang és mozgókép kezelésére alkalmas programokat).',
		a: 9,
		gT: 1063,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'mérési adatok számítógépes kiértékelése, táblázatok, grafikonok készítése'])
	},
		{
		cG: 'altgim',
		gD: 'A vizsgálatok során kinyert adatokat egyszerű táblázatkezelő szoftver segítségével elemzi, az adatokat grafikonok segítségével értelmezi.',
		a: 9,
		gT: 1062,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'mérési adatok számítógépes kiértékelése, táblázatok, grafikonok készítése'])
	},
		{
		cG: 'altgim',
		gD: 'A projektfeladatok megoldása során önállóan, illetve a csoporttagokkal közösen különböző médiatartalmakat, prezentációkat, rövidebb-hosszabb szöveges produktumokat hoz létre a tapasztalatok, eredmények, elemzések, illetve következtetések bemutatására.',
		a: 9,
		gT: 1061,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'számítógépes prezentációk készítése fizikai információk bemutatására, megosztására'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyszerű vizsgálatok eredményeinek, az elemzések, illetve a következtetések bemutatására prezentációt készít.',
		a: 9,
		gT: 1060,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'számítógépes prezentációk készítése fizikai információk bemutatására, megosztására'])
	},
		{
		cG: 'altgim',
		gD: 'A forrásokból gyűjtött információkat számítógépes prezentációban mutatja be.',
		a: 9,
		gT: 1059,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'számítógépes prezentációk készítése fizikai információk bemutatására, megosztására'])
	},
		{
		cG: 'altgim',
		gD: 'Az interneten talált tartalmakat több forrásból is ellenőrzi.',
		a: 9,
		gT: 1058,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'az internet kritikus használata fizikai információk gyűjtésére'])
	},
		{
		cG: 'altgim',
		gD: 'Fizikai szövegben, videóban el tudja különíteni a számára világos, valamint nem érthető, további magyarázatra szoruló részeket.',
		a: 9,
		gT: 1057,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'az internet kritikus használata fizikai információk gyűjtésére'])
	},
		{
		cG: 'altgim',
		gD: 'Készségszinten alkalmazza a különböző kommunikációs eszközöket, illetve az internetet a főként magyar, illetve idegen nyelvű, fizikai tárgyú tartalmak keresésére.',
		a: 9,
		gT: 1056,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'az internet kritikus használata fizikai információk gyűjtésére'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer magyar és idegen nyelvű megbízható fizikai tárgyú honlapokat.',
		a: 9,
		gT: 1055,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'az internet kritikus használata fizikai információk gyűjtésére'])
	},
		{
		cG: 'altgim',
		gD: 'A vizsgált fizikai jelenségeket, kísérleteket bemutató animációkat, videókat keres és értelmez.',
		a: 9,
		gT: 1054,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'fizikai adatbázisok, interaktív szimulációk használata'])
	},
		{
		cG: 'altgim',
		gD: 'Használ helymeghatározó szoftvereket, a közeli és távoli környezetünket leíró adatbázisokat, szoftvereket.',
		a: 9,
		gT: 1053,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'fizikai adatbázisok, interaktív szimulációk használata'])
	},
		{
		cG: 'altgim',
		gD: 'A legegyszerűbb esetekben azonosítja az alapvető fizikai kölcsönhatások és törvények szerepét a világegyetem felépítésében és időbeli változásaiban.',
		a: 9,
		gT: 1052,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja és szemlélteti a természetre jellemző fizikai mennyiségek nagyságrendjeit (atommag, élőlények, naprendszer, univerzum).',
		a: 9,
		gT: 1051,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nap, mint csillag legfontosabb fizikai tulajdonságait, a nap várható jövőjét, a csillagok lehetséges fejlődési folyamatait.',
		a: 9,
		gT: 1050,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Szabad szemmel vagy távcsővel megfigyeli a holdat, a hold felszínének legfontosabb jellemzőit, a holdfogyatkozás jelenségét, a látottakat fizikai ismeretei alapján értelmezi.',
		a: 9,
		gT: 1049,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Megvizsgálja a naprendszer bolygóin és holdjain uralkodó, a földétől eltérő fizikai környezet legjellemzőbb példáit, azonosítja ezen eltérések okát, a legfontosabb esetekben megmutatja, hogyan érvényesülnek a fizika törvényei a föld és a hold mozgása során.',
		a: 9,
		gT: 1048,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a felezési idő, aktivitás fogalmát, a sugárvédelem lehetőségeit.',
		a: 9,
		gT: 1047,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a radioaktív sugárzások típusait, az alfa-, béta- és gamma-sugárzások leírását és tulajdonságait.',
		a: 9,
		gT: 1046,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja, hogy a maghasadás és magfúzió miért alkalmas energiatermelésre, ismeri a gyakorlati megvalósulásuk lehetőségeit, az atomerőművek működésének alapelvét, a csillagok energiatermelésének lényegét.',
		a: 9,
		gT: 1045,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az atommag felépítését, a nukleonok típusait, az izotóp fogalmát, a nukleáris kölcsönhatás jellemzőit.',
		a: 9,
		gT: 1044,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja, hogyan használják a vonalas színképet az anyagvizsgálat során.',
		a: 9,
		gT: 1043,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Megmagyarázza az elektronmikroszkóp működését az elektron hullámtermészetének segítségével.',
		a: 9,
		gT: 1042,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az atomról alkotott elképzelések változásait, a rutherford-modellt és bohr-modellt, látja a modellek hiányosságait.',
		a: 9,
		gT: 1041,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri rutherford szórási kísérletét, mely az atommag felfedezéséhez vezetett.',
		a: 9,
		gT: 1040,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a fényelektromos jelenséget, tisztában van annak einstein által kidolgozott magyarázatával, a frekvencia (hullámhossz) és a foton energiája kapcsolatával.',
		a: 9,
		gT: 1039,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az optikai leképezés fogalmát, a valódi és látszólagos kép közötti különbséget. egyszerű kísérleteket tud végezni tükrökkel és lencsékkel.',
		a: 9,
		gT: 1038,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'A fókuszpont fogalmának felhasználásával értelmezi, hogyan térítik el a fényt a domború és homorú tükrök, a domború és homorú lencsék.',
		a: 9,
		gT: 1037,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fénytörés és visszaverődés törvényét, megmagyarázza, hogyan alkot képet a síktükör.',
		a: 9,
		gT: 1036,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a színek és a fény frekvenciája közötti kapcsolatot, a fehér fény összetett voltát, a kiegészítő színek fogalmát, a szivárvány színeit.',
		a: 9,
		gT: 1035,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromágneses hullámok jellemzőit (frekvencia, hullámhossz, terjedési sebesség), azt, hogy milyen körülmények határozzák meg ezeket. a mennyiségek kapcsolatára vonatkozó egyszerű számításokat végez.',
		a: 9,
		gT: 1034,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a fény elektromágneses hullám, és hogy terjedéséhez nem kell közeg.',
		a: 9,
		gT: 1033,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az atomok és a fény'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromágneses indukció jelenségének lényegét, fontosabb gyakorlati vonatkozásait, a váltakozó áram fogalmát.',
		a: 9,
		gT: 1032,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megmagyarázza, hogyan működnek az általa megfigyelt egyszerű felépítésű elektromos motorok: a mágneses mező erőt fejt ki az árammal átjárt vezetőre.',
		a: 9,
		gT: 1031,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Elektromágnes készítése közben megfigyeli és alkalmazza, hogy az elektromos áram mágneses mezőt hoz létre.',
		a: 9,
		gT: 1030,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezni tud egyszerűbb kapcsolási rajzokat, ismeri kísérleti vizsgálatok alapján a soros és a párhuzamos kapcsolások legfontosabb jellemzőit.',
		a: 9,
		gT: 1029,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyszerű áramkör és egyszerűbb hálózatok alkotórészeit, felépítését.',
		a: 9,
		gT: 1028,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ki tudja számolni egyenáramú fogyasztók teljesítményét, az általuk felhasznált energiát.',
		a: 9,
		gT: 1027,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti ohm törvényét, egyszerű esetekben alkalmazza a feszültség, áramerősség, ellenállás meghatározására, tudja, hogy az ellenállás függ a hőmérséklettől.',
		a: 9,
		gT: 1026,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati szinten ismeri az egyenáramok jellemzőit, a feszültség, áramerősség és ellenállás fogalmát.',
		a: 9,
		gT: 1025,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy az áram a töltött részecskék rendezett mozgása, és ez alapján szemléletes elképzelést alakít ki az elektromos áramról.',
		a: 9,
		gT: 1024,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy az elektromos kölcsönhatást az elektromos mező közvetíti.',
		a: 9,
		gT: 1023,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti coulomb törvényét, egyszerű esetekben alkalmazza elektromos töltéssel rendelkező testek közötti erő meghatározására.',
		a: 9,
		gT: 1022,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja, hogy az elektromos állapot kialakulása a töltések egyenletes eloszlásának megváltozásával van kapcsolatban.',
		a: 9,
		gT: 1021,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektrosztatikus alapjelenségeket (dörzselektromosság, töltött testek közötti kölcsönhatás, földelés), ezek gyakorlati alkalmazásait.',
		a: 9,
		gT: 1020,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hidrosztatika alapjait, a felhajtóerő fogalmát, hétköznapi példákon keresztül értelmezi a felemelkedés, elmerülés, úszás, lebegés jelenségét, tudja az ezt meghatározó tényezőket, ismeri a jelenségkörre épülő gyakorlati eszközöket.',
		a: 9,
		gT: 1019,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a repülés elvével, a légellenállás jelenségével.',
		a: 9,
		gT: 1018,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nyomás, hőmérséklet, páratartalom fogalmát, a levegő mint ideális gáz viselkedésének legfontosabb jellemzőit. egyszerű számításokat végez az állapothatározók megváltozásával kapcsolatban.',
		a: 9,
		gT: 1017,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az időjárás elemeit, a csapadékformákat, a csapadékok kialakulásának fizikai leírását.',
		a: 9,
		gT: 1016,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a víz különleges tulajdonságait (rendhagyó hőtágulás, nagy olvadáshő, forráshő, fajhő), ezek hatását a természetben, illetve mesterséges környezetünkben.',
		a: 9,
		gT: 1015,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a megfordítható és nem megfordítható folyamatok közötti különbséggel.',
		a: 9,
		gT: 1014,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hőtan első főtételét, és tudja alkalmazni néhány egyszerűbb gyakorlati szituációban (palackba zárt levegő, illetve állandó nyomású levegő melegítése).',
		a: 9,
		gT: 1013,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hőtágulás jelenségét, jellemző nagyságrendjét.',
		a: 9,
		gT: 1012,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a halmazállapot-változások energetikai viszonyaival, anyagszerkezeti magyarázatával, tudja, mit jelent az olvadáshő, forráshő, párolgáshő, egyszerű számításokat végez a halmazállapot-változásokat kísérő hőközlés meghatározására.',
		a: 9,
		gT: 1011,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja a halmazállapot-változások típusait (párolgás, forrás, lecsapódás, olvadás, fagyás, szublimáció).',
		a: 9,
		gT: 1010,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az anyag viselkedését hőközlés során, tudja, mit jelent az égéshő, a fűtőérték és a fajhő.',
		a: 9,
		gT: 1009,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati példákon keresztül ismeri a hővezetés, hőáramlás és hősugárzás jelenségét, a hőszigetelés lehetőségeit, ezek anyagszerkezeti magyarázatát.',
		a: 9,
		gT: 1008,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a celsius- és az abszolút hőmérsékleti skálát, a gyakorlat szempontjából nevezetes néhány hőmérsékletet, a termikus kölcsönhatás jellemzőit.',
		a: 9,
		gT: 1007,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány egyszerűbb, konkrét esetben (mérleg, libikóka) a forgatónyomatékok meghatározásának segítségével vizsgálja a testek egyensúlyi állapotának feltételeit, összeveti az eredményeket a megfigyelések és kísérletek tapasztalataival.',
		a: 9,
		gT: 1006,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az energia'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét esetekben alkalmazza a munkatételt, a mechanikai energia megmaradásának elvét a mozgás értelmezésére, a sebesség kiszámolására.',
		a: 9,
		gT: 1005,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az energia'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mechanikai munka fogalmát, kiszámításának módját, mértékegységét, a helyzeti energia, a mozgási energia, a rugalmas energia, a belső energia fogalmát.',
		a: 9,
		gT: 1004,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az energia'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a tömegvonzás általános törvényét, és azt, hogy a gravitációs erő bármely két test között hat.',
		a: 9,
		gT: 1003,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a testek súlya és a tömege közötti különbséget, a súlytalanság állapotát, a gravitációs mező szerepét a gravitációs erő közvetítésében.',
		a: 9,
		gT: 1002,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, mit jelentenek a kozmikus sebességek (körsebesség, szökési sebesség).',
		a: 9,
		gT: 1001,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a bolygók, üstökösök mozgásának jellegzetességeit.',
		a: 9,
		gT: 1000,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerűbb esetekben kiszámolja a mechanikai kölcsönhatásokban fellépő erőket (nehézségi erő, nyomóerő, fonálerő, súlyerő, súrlódási erők, rugóerő), meghatározza az erők eredőjét.',
		a: 9,
		gT: 999,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az erő mint fizikai mennyiség jelentésével, mértékegységével, ismeri a newtoni dinamika alaptörvényeit, egyszerűbb esetekben alkalmazza azokat a gyorsulás meghatározására, a korábban megismert mozgások értelmezésére.',
		a: 9,
		gT: 998,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerűbb esetekben alkalmazza a lendület-megmaradás törvényét, ismeri ennek általános érvényességét.',
		a: 9,
		gT: 997,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű esetekben kiszámolja a testek lendületének nagyságát, meghatározza irányát.',
		a: 9,
		gT: 996,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogyan alakulnak ki és terjednek a mechanikai hullámok, ismeri a hullámhossz és a terjedési sebesség fogalmát.',
		a: 9,
		gT: 995,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyenletes körmozgást leíró fizikai mennyiségeket (pályasugár, kerületi sebesség, fordulatszám, keringési idő, centripetális gyorsulás), azok jelentését, egymással való kapcsolatát.',
		a: 9,
		gT: 994,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a periodikus mozgásokat (ingamozgás, rezgőmozgás) jellemző fizikai mennyiségeket, néhány egyszerű esetben tudja mérni a periódusidőt, megállapítani az azt befolyásoló tényezőket.',
		a: 9,
		gT: 993,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű számításokat végez az állandó gyorsulással mozgó testek esetében.',
		a: 9,
		gT: 992,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szabadesés jelenségét, annak leírását, tud esésidőt számolni, mérni, becsapódási sebességet számolni.',
		a: 9,
		gT: 991,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Tud számításokat végezni az egyenes vonalú egyenletes mozgás esetében: állandó sebességű mozgások esetén a sebesség ismeretében meghatározza az elmozdulást, a sebesség nagyságának ismeretében a megtett utat, a céltól való távolság ismeretében a megérkezéshez szükséges időt.',
		a: 9,
		gT: 990,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja az út, a pálya és a hely fogalmát, valamint a sebesség, átlagsebesség, pillanatnyi sebesség, gyorsulás, elmozdulás fizikai mennyiségeket a mozgás leírására.',
		a: 9,
		gT: 989,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja a gyakran alkalmazott orvosdiagnosztikai vizsgálatok, illetve egyes kezelések fizikai megalapozottságát, felismeri a sarlatán, tudományosan megalapozatlan kezelési módokat.',
		a: 9,
		gT: 988,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szervezet energiaháztartásának legfontosabb tényezőit, az élelmiszerek energiatartalmának szerepét.',
		a: 9,
		gT: 987,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az elektromos áram élettani hatásaival, az emberi test áramvezetési tulajdonságaival, az idegi áramvezetés jelenségével.',
		a: 9,
		gT: 986,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a radioaktív izotópok néhány orvosi alkalmazását (nyomjelzés).',
		a: 9,
		gT: 985,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az emberi szemet mint képalkotó eszközt, a látás mechanizmusát, a gyakori látáshibák (rövid- és távollátás) okát, a szemüveg és a kontaktlencse jellemzőit, a dioptria fogalmát.',
		a: 9,
		gT: 984,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja a húros hangszerek és a sípok működésének elvét, az ultrahang szerepét a gyógyászatban, ismeri a zajszennyezés fogalmát.',
		a: 9,
		gT: 983,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az emberi hangérzékelés fizikai alapjait, a hang mint hullám jellemzőit, keltésének eljárásait.',
		a: 9,
		gT: 982,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a generátor, a motor és a transzformátor működési elvét, gyakorlati hasznát.',
		a: 9,
		gT: 981,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromos hálózatok kialakítását a lakásokban, épületekben, az elektromos kapcsolási rajzok használatát.',
		a: 9,
		gT: 980,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromos fogyasztók használatára vonatkozó balesetvédelmi szabályokat.',
		a: 9,
		gT: 979,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az elektromos áram veszélyeivel, a veszélyeket csökkentő legfontosabb megoldásokkal (gyerekbiztos csatlakozók, biztosíték, földvezeték szerepe).',
		a: 9,
		gT: 978,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az elektromágneses hullámok frekvenciatartományaival, a rádióhullámok, mikrohullámok, infravörös hullámok, a látható fény, az ultraibolya hullámok, a röntgensugárzás, a gamma-sugárzás gyakorlati felhasználásával.',
		a: 9,
		gT: 977,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a digitális fényképezőgép működésének elvét.',
		a: 9,
		gT: 976,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromágneses hullámok szerepét az információ- (hang-, kép-) átvitelben, ismeri a mobiltelefon legfontosabb tartozékait (sim kártya, akkumulátor stb.), azok kezelését, funkcióját.',
		a: 9,
		gT: 975,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mindennapi életben használt legfontosabb elektromos energiaforrásokat, a gépkocsi-, mobiltelefon-akkumulátorok legfontosabb jellemzőit.',
		a: 9,
		gT: 974,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az aktuálisan használt világító eszközeink működési elvével, energiafelhasználásának sajátosságaival, a korábban alkalmazott megoldásokhoz képesti előnyeivel.',
		a: 9,
		gT: 973,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyszerű gépek elvének megjelenését a hétköznapokban, mindennapi eszközeinkben.',
		a: 9,
		gT: 972,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja a jelen közlekedése, közlekedésbiztonsága szempontjából releváns gyakorlati ismereteket, azok fizikai hátterét.',
		a: 9,
		gT: 971,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a konyhai tevékenységek (melegítés, főzés, hűtés) fizikai vonatkozásaival.',
		a: 9,
		gT: 970,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a háztartásban használt fontosabb elektromos eszközöket, az elektromosság szerepét azok működésében, szemléletes képe van a váltakozó áramról.',
		a: 9,
		gT: 969,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja a korszerű lakások és házak hőszabályozásának fizikai kérdéseit (fűtés, hűtés, hőszigetelés).',
		a: 9,
		gT: 968,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a legfontosabb közlekedési eszközök -- gépjárművek, légi és vízi járművek -- működésének fizikai elveit.',
		a: 9,
		gT: 967,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a légnyomás változó jellegét, a légnyomás és az időjárás kapcsolatát.',
		a: 9,
		gT: 966,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a legáltalánosabb természeti jelenségek fizikai alapjai', 'a természeti jelenségek és technikai eszközök, technológiák fizikája'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a villámok veszélyét, a villámhárítók működését, a helyes magatartást zivataros, villámcsapás-veszélyes időben.',
		a: 9,
		gT: 965,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a legáltalánosabb természeti jelenségek fizikai alapjai', 'a természeti jelenségek és technikai eszközök, technológiák fizikája'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogyan jönnek létre a természet színei, és hogyan észleljük azokat.',
		a: 9,
		gT: 964,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a legáltalánosabb természeti jelenségek fizikai alapjai', 'a természeti jelenségek és technikai eszközök, technológiák fizikája'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb természeti jelenségeket (például légköri jelenségek, az égbolt változásai, a vízzel kapcsolatos jelenségek), azok megfelelően egyszerűsített, a fizikai mennyiségeken és törvényeken alapuló magyarázatait.',
		a: 9,
		gT: 963,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a legáltalánosabb természeti jelenségek fizikai alapjai', 'a természeti jelenségek és technikai eszközök, technológiák fizikája'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt és dolgoz fel a legismertebb fizikusok életével, tevékenységével, annak gazdasági, társadalmi hatásával, valamint emberi vonatkozásaival kapcsolatban (galileo galilei, michael faraday, james watt, eötvös loránd, marie curie, ernest rutherford, niels bohr, albert einstein, szilárd leó, wigner jenő, teller ede).',
		a: 9,
		gT: 962,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'neves fizikusok élete, munkássága'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja az emberiség és a világegyetem kapcsolatának kulcskérdéseit.',
		a: 9,
		gT: 961,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika és a társadalmi-gazdasági fejlődés összefüggései'])
	},
		{
		cG: 'altgim',
		gD: 'El tudja helyezni lakóhelyét a földön, a föld helyét a naprendszerben, a naprendszer helyét a galaxisunkban és az univerzumban.',
		a: 9,
		gT: 960,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika és a társadalmi-gazdasági fejlődés összefüggései'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány konkrét példa alapján felismeri a fizika tudásrendszerének fejlődése és a társadalmi-gazdasági folyamatok, történelmi események közötti kapcsolatot.',
		a: 9,
		gT: 959,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika és a társadalmi-gazdasági fejlődés összefüggései'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az űrkutatás ipari-technikai civilizációra gyakorolt hatásával, valamint az űrkutatás tágabb értelemben vett céljaival (értelmes élet keresése, új nyersanyagforrások felfedezése).',
		a: 9,
		gT: 958,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az űrkutatás történetének főbb fejezeteit, jövőbeli lehetőségeit, tervezett irányait.',
		a: 9,
		gT: 957,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az éghajlatváltozás kérdésével, az üvegházhatás jelenségével a természetben, a jelenség erőssége és az emberi tevékenység kapcsolatával.',
		a: 9,
		gT: 956,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja az ózonpajzs szerepét a földet ért ultraibolya sugárzással kapcsolatban.',
		a: 9,
		gT: 955,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a föld elsődleges energiaforrása a nap, ismeri a napenergia felhasználási lehetőségeit, a napkollektor és a napelem mibenlétét, a közöttük lévő különbséget.',
		a: 9,
		gT: 954,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai kérdései'])
	},
		{
		cG: 'altgim',
		gD: 'Az emberiség energiafelhasználásával kapcsolatos adatokat gyűjt, az információkat szemléletesen mutatja be.',
		a: 9,
		gT: 953,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai kérdései'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a megújuló és a nem megújuló energiaforrások használatának és az energia szállításának legfontosabb gyakorlati kérdéseit.',
		a: 9,
		gT: 952,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai kérdései'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a környezet szennyezésének leggyakoribb forrásait, fizikai vonatkozásait.',
		a: 9,
		gT: 951,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az atomreaktorok működésének lényegét, a radioaktív hulladékok elhelyezésének problémáit.',
		a: 9,
		gT: 950,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a különböző típusú erőművek használatának előnyeivel és környezeti kockázatával.',
		a: 9,
		gT: 949,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakult véleményét mérési eredményekkel, érvekkel támasztja alá.',
		a: 9,
		gT: 948,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a tudományos érvelés és vita, az eredmények prezentálása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fizika főbb szakterületeit, néhány új eredményét.',
		a: 9,
		gT: 947,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudománya, legújabb eredményei, módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a tudomány által vizsgálható jelenségeket, azonosítani tudja a tudományos érvelést, kritikusan vizsgálja egy elképzelés tudományos megalapozottságát.',
		a: 9,
		gT: 946,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudománya, legújabb eredményei, módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy a fizika átfogó törvényeket ismer fel, melyek alkalmazhatók jelenségek értelmezésére, egyes események minőségi és mennyiségi előrejelzésére.',
		a: 9,
		gT: 945,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudománya, legújabb eredményei, módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogyan születnek az elismert, új tudományos felismerések, ismeri a tudományosság kritériumait.',
		a: 9,
		gT: 944,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudománya, legújabb eredményei, módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati oldalról ismeri a tudományos megismerési folyamatot: megfigyelés, mérés, a tapasztalatok, mérési adatok rögzítése, rendszerezése, ezek összevetése valamilyen egyszerű modellel vagy matematikai összefüggéssel, a modell (összefüggés) továbbfejlesztése.',
		a: 9,
		gT: 943,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'El tudja választani egyszerű fizikai rendszerek esetén a lényeges elemeket a lényegtelenektől.',
		a: 9,
		gT: 942,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű, a megértést segítő számolási feladatokat old meg, táblázatokat, ábrákat, grafikonokat értelmez, következtetést von le, összehasonlít.',
		a: 9,
		gT: 941,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Megismételt mérések segítségével, illetve a mérés körülményeinek ismeretében következtet a mérés eredményét befolyásoló tényezőkre.',
		a: 9,
		gT: 940,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'A mérések és a kiértékelés során alkalmazza a rendelkezésre álló számítógépes eszközöket, programokat.',
		a: 9,
		gT: 939,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb mértékegységek jelentését, helyesen használja a mértékegységeket számításokban, illetve az eredmények összehasonlítása során.',
		a: 9,
		gT: 938,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Fizikai kísérleteket önállóan is el tud végezni.',
		a: 9,
		gT: 937,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű méréseket, kísérleteket végez, az eredményeket rögzíti.',
		a: 9,
		gT: 936,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Tudományos ismereteit érveléssel meg tudja védeni, vita során ki tudja fejteni véleményét, érveit és ellenérveit, mérlegelni tudja egy elképzelés tudományos megalapozottságát.',
		a: 9,
		gT: 935,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tud önállóan fizikai témájú ismeretterjesztő szövegeket olvasni, a lényeget kiemelni, el tudja különíteni a számára világos, valamint a nem érthető, további magyarázatra szoruló részeket.',
		a: 9,
		gT: 934,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Látja a fizikai ismeretek bővülése és a társadalmi-gazdasági folyamatok, történelmi események közötti kapcsolatot.',
		a: 9,
		gT: 933,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a földünket és környezetünket fenyegető globális problémákban, ismeri az emberi tevékenység szerepét ezek kialakulásában.',
		a: 9,
		gT: 932,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű fizikai rendszerek esetén a lényeges elemeket a lényegtelenektől el tudja választani, az egyszerűbb számításokat el tudja végezni és a helyes logikai következtetéseket le tudja vonni, illetve táblázatokat, ábrákat, grafikonokat tud értelmezni.',
		a: 9,
		gT: 931,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati oldalról ismeri a tudományos megismerési folyamatot: megfigyel, mér, adatait összeveti az egyszerű modellekkel, korábbi ismereteivel. ennek alapján következtet, megerősít, cáfol.',
		a: 9,
		gT: 930,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a világot leíró legfontosabb természeti jelenségeket, az azokat leíró fizikai mennyiségeket, azok jelentését, jellemző nagyságrendjeit.',
		a: 9,
		gT: 929,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogyan jelennek meg a fizikai ismeretek a mindennapi tevékenységek során, valamint a gyakran használt technikai eszközök működésében.',
		a: 9,
		gT: 928,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy a fizika átfogó törvényeket ismer fel, melyek alkalmazhatók jelenségek értelmezésére, egyes események minőségi és mennyiségi előrejelzésére.',
		a: 9,
		gT: 927,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a helyét a világegyetemben, látja a világegyetem időbeli fejlődését, lehetséges jövőjét, az emberiség és a világegyetem kapcsolatának kulcskérdéseit.',
		a: 9,
		gT: 926,
		b: 10,
		e2: 'Fizika',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja az egyén társadalmi szerepvállalásának lehetőségeit, a tevékeny közreműködés példáit a környezet védelme érdekében, illetve érvényesíti saját döntéseiben a környezeti szempontokat.',
		a: 9,
		gT: 1148,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a fenntartható gazdaság, a fenntartható gazdálkodás fogalmát, érveket fogalmaz meg a fenntarthatóságot szem előtt tartó gazdaság, illetve gazdálkodás fontossága mellett.',
		a: 9,
		gT: 1147,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevez a környezet védelmében, illetve humanitárius céllal tevékenykedő hazai és nemzetközi szervezeteket, példákat említ azok tevékenységére, belátja és igazolja a nemzetközi összefogás szükségességét.',
		a: 9,
		gT: 1146,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'A lakóhely adottságaiból kiindulva értelmezi a fenntartható fejlődés társadalmi, természeti, gazdasági, környezetvédelmi kihívásait.',
		a: 9,
		gT: 1145,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a fogyasztói társadalom és a tudatos fogyasztói közösség jellemzőit.',
		a: 9,
		gT: 1144,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza az energiahatékony, nyersanyag-takarékos, illetve „zöld\" gazdálkodás lényegét, valamint példákat nevez meg a környezeti szempontok érvényesíthetőségére a termelésben és a fogyasztásban.',
		a: 9,
		gT: 1143,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Globális problémákhoz vezető, földünkön egy időben jelenlévő, különböző természeti és társadalmi-gazdasági eredetű problémákat elemez, feltárja azok összefüggéseit, bemutatja mérséklésük lehetséges módjait és azok nehézségeit.',
		a: 9,
		gT: 1142,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal igazolja a természetkárosítás és a természeti, illetve környezeti katasztrófák társadalmi következményeit, a környezetkárosodás életkörülményekre, életminőségre gyakorolt hatását, a lokális szennyeződés globális következményeit.',
		a: 9,
		gT: 1141,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszerezi a geoszférákat ért környezetkárosító hatásokat, bemutatja a folyamatok kölcsönhatásait.',
		a: 9,
		gT: 1140,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és azonosítja a földrajzi tartalmú természeti, társadalmi-gazdasági és környezeti problémákat, megnevezi kialakulásuk okait, és javaslatokat fogalmaz meg megoldásukra.',
		a: 9,
		gT: 1139,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza megszerzett ismereteit pénzügyi döntéseiben, belátja a körültekintő, felelős pénzügyi tervezés és döntéshozatal fontosságát.',
		a: 9,
		gT: 1138,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a monetáris világ összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Pénzügyi lehetőségeit mérlegelve egyszerű költségvetést készít, értékeli a hitelfelvétel előnyeit és kockázatait.',
		a: 9,
		gT: 1137,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a monetáris világ összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Pénzügyi döntéshelyzeteket, aktuális pénzügyi folyamatokat értelmez és megfogalmazza a lehetséges következményeket.',
		a: 9,
		gT: 1136,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a monetáris világ összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a működőtőke- és a pénztőkeáramlás sajátos vonásait, magyarázza eltérésük okait.',
		a: 9,
		gT: 1135,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a monetáris világ összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarázza a monetáris világ működésének alapvető fogalmait, folyamatait és azok összefüggéseit, ismer nemzetközi pénzügyi szervezeteket.',
		a: 9,
		gT: 1134,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a monetáris világ összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli hazánk környezeti állapotát, megnevezi jelentősebb környezeti problémáit.',
		a: 9,
		gT: 1133,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a területi fejlettségi különbségek okait és következményeit magyarországon, megfogalmazza a felzárkózás lehetőségeit.',
		a: 9,
		gT: 1132,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján jellemzi és értékeli magyarország társadalmi-gazdasági szerepét annak szűkebb és tágabb nemzetközi környezetében, az európai unióban.',
		a: 9,
		gT: 1131,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerteti az európai unió működésének földrajzi alapjait, példák segítségével bemutatja az európai unión belüli társadalmi-gazdasági fejlettségbeli különbségeket, és megnevezi a felzárkózást segítő eszközöket.',
		a: 9,
		gT: 1130,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben mutatja be a perifériatérség társadalmi-gazdasági fejlődésének jellemző vonásait, a felzárkózás nehézségeit.',
		a: 9,
		gT: 1129,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja az európai, ázsiai és amerikai erőterek gazdaságilag meghatározó jelentőségű országainak, országcsoportjainak szerepét a globális világban.',
		a: 9,
		gT: 1128,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a világgazdaság működése szempontjából tipikus térségeket, országokat.',
		a: 9,
		gT: 1127,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján bemutatja a globalizáció társadalmi-gazdasági és környezeti következményeit, mindennapi életünkre gyakorolt hatását.',
		a: 9,
		gT: 1126,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a globalizáció fogalmát, a globális világ kialakulásának és működésének feltételeit, jellemző vonásait.',
		a: 9,
		gT: 1125,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerteti a világpolitika és a világgazdaság működését befolyásoló nemzetközi szervezetek, együttműködések legfontosabb jellemzőit.',
		a: 9,
		gT: 1124,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi és értékeli a gazdasági integrációk és a regionális együttműködések kialakulásában szerepet játszó tényezőket.',
		a: 9,
		gT: 1123,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Modellezi a piacgazdaság működését.',
		a: 9,
		gT: 1122,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli az eltérő adottságok, erőforrások szerepét a társadalmi-gazdasági fejlődésben.',
		a: 9,
		gT: 1121,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi és értékeli a társadalmi-gazdasági fejlettség összehasonlítására alkalmas mutatók adatait, a társadalmi-gazdasági fejlettség területi különbségeit a föld különböző térségeiben.',
		a: 9,
		gT: 1120,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerteti a gazdaság szerveződését befolyásoló telepítő tényezők szerepének átalakulását, bemutatja az egyes gazdasági ágazatok jellemzőit, értelmezi a gazdasági szerkezetváltás folyamatát.',
		a: 9,
		gT: 1119,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és követi a lakóhelye környékén zajló település- és területfejlődési, valamint demográfiai folyamatokat.',
		a: 9,
		gT: 1118,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző szempontok alapján csoportosítja és jellemzi az egyes településtípusokat, bemutatja szerepkörük és szerkezetük változásait.',
		a: 9,
		gT: 1117,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző népességi, társadalmi és kulturális jellemzők alapján bemutat egy kontinenst, országot, országcsoportot.',
		a: 9,
		gT: 1116,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a népességszám-változás időbeli és területi különbségeit, ismerteti okait és következményeit, összefüggését a fiatalodó és az öregedő társadalmak jellemző folyamataival és problémáival.',
		a: 9,
		gT: 1115,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az ember környezet átalakító szerepét, ember és környezete kapcsolatrendszerét, illetve példák alapján igazolja az egyes geoszférák folyamatainak, jelenségeinek gazdasági következményeit, összefüggéseit.',
		a: 9,
		gT: 1114,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a felszínformálás többtényezős összefüggéseit, ismeri és felismeri a különböző felszínformáló folyamatokhoz (szél, víz, jég) és kőzettípusokhoz kapcsolódóan kialakuló, felszíni és felszín alatti formakincset.',
		a: 9,
		gT: 1113,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben mutatja be a talajképződés folyamatát, tájékozott a talajok gazdasági jelentőségével kapcsolatos kérdésekben, ismeri magyarország fontosabb talajtípusait.',
		a: 9,
		gT: 1112,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben, kölcsönhatásaiban mutatja be a földrajzi övezetesség rendszerének egyes elemeit, a természeti jellemzők társadalmi-gazdasági vonatkozásait.',
		a: 9,
		gT: 1111,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatában van a személyes szerepvállalások értékének a globális vízgazdálkodás és éghajlatváltozás rendszerében.',
		a: 9,
		gT: 1110,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a vízburokkal kapcsolatos környezeti veszélyek okait, és reálisan számol a várható következményekkel.',
		a: 9,
		gT: 1109,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Igazolja a felszíni és felszín alatti vizek egyre fontosabbá váló erőforrásszerepét és gazdasági vonatkozásait, bizonyítja a víz társadalmi folyamatokat befolyásoló természetét, védelmének szükségességét.',
		a: 9,
		gT: 1108,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a felszíni és felszín alatti vizek főbb típusait, azok jellemzőit, mennyiségi és minőségi viszonyaikat befolyásoló tényezőket, a víztípusok közötti összefüggéseket.',
		a: 9,
		gT: 1107,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarázza az éghajlatváltozás okait, valamint helyi, regionális, globális következményeit.',
		a: 9,
		gT: 1106,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a légkör legfőbb szennyező forrásait és a szennyeződés következményeit, érti a lokálisan ható légszennyező folyamatok globális következményeit.',
		a: 9,
		gT: 1105,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'A légkör globális változásaival foglalkozó forrásokat kritikusan elemzi, érveken alapuló véleményt fogalmaz meg a témával összefüggésben.',
		a: 9,
		gT: 1104,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a szélsőséges időjárási helyzeteket és tud a helyzetnek megfelelően cselekedni.',
		a: 9,
		gT: 1103,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja az időjárási térképeket és előrejelzéseket értelmezni egyszerű prognózisok készítésére.',
		a: 9,
		gT: 1102,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben mutatja be a légköri folyamatokat és jelenségeket, illetve összekapcsolja ezeket az időjárás alakulásával.',
		a: 9,
		gT: 1101,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a légkör szerkezetét, fizikai és kémiai jellemzőit, magyarázza az ezekben bekövetkező változások mindennapi életre gyakorolt hatását.',
		a: 9,
		gT: 1100,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a különböző kőzettani felépítésű területek eltérő környezeti érzékenysége, terhelhetősége közti összefüggéseket.',
		a: 9,
		gT: 1099,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kőzetburok folyamataihoz kapcsolódó földtani veszélyek okait, következményeit, tér- és időbeli jellemzőit, illetve elemzi az alkalmazkodási, kármegelőzési lehetőségeket.',
		a: 9,
		gT: 1098,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az alapvető ásványokat és kőzeteket, tud példákat említeni azok gazdasági és mindennapi életben való hasznosítására.',
		a: 9,
		gT: 1097,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Párhuzamot tud vonni a jelenlegi és múltbeli földrajzi folyamatok között.',
		a: 9,
		gT: 1096,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a történelmi és a földtörténeti idő eltérő nagyságrendjét, ismeri a geoszférák fejlődésének időbeli szakaszait, meghatározó jelentőségű eseményeit.',
		a: 9,
		gT: 1095,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben mutatja be a lemeztektonika és az azt kísérő jelenségek (földrengések, vulkanizmus, hegységképződés) kapcsolatát, térbeliségét, illetve magyarázza a kőzetlemez-mozgások lokális és az adott helyen túlmutató globális hatásait.',
		a: 9,
		gT: 1094,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a föld felépítésének törvényszerűségeit.',
		a: 9,
		gT: 1093,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű csillagászati és időszámítással kapcsolatos feladatokat, számításokat végez.',
		a: 9,
		gT: 1092,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a nap és a naprendszer jelenségeit, folyamatait, azok földi hatásait.',
		a: 9,
		gT: 1091,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a föld, a hold és a bolygók jellemzőit, mozgásait és ezek következményeit, összefüggéseit.',
		a: 9,
		gT: 1090,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a világegyetem tér- és időbeli léptékeit, elhelyezi a földet a világegyetemben és a naprendszerben.',
		a: 9,
		gT: 1089,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Térszemlélettel rendelkezik a csillagászati és a földrajzi térben.',
		a: 9,
		gT: 1088,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Képes problémaközpontú feladatok megoldására, környezeti változások összehasonlító elemzésére térképek és légi- vagy űrfelvételek párhuzamos használatával.',
		a: 9,
		gT: 1087,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan használja a földrajzi és a kozmikus térben való tájékozódást segítő hagyományos és digitális eszközöket, ismeri a légi- és űrfelvételek sajátosságait, alkalmazási területeit.',
		a: 9,
		gT: 1086,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a kozmikus térben és az időben'])
	},
		{
		cG: 'altgim',
		gD: 'A közvetlen környezetének földrajzi megismerésére terepvizsgálódást tervez és kivitelez.',
		a: 9,
		gT: 1085,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján alapvető földrajzi-földtani folyamatokkal, tájakkal, országokkal kapcsolatos földrajzi tartalmú szövegeket, képi információhordozókat dolgoz fel.',
		a: 9,
		gT: 1084,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat rendszerez és ábrázol hagyományos és digitális eszközök segítségével.',
		a: 9,
		gT: 1083,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközök segítségével bemutat és értelmez földrajzi jelenségeket, folyamatokat, törvényszerűségeket, összefüggéseket.',
		a: 9,
		gT: 1082,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi tartalmú szövegek alapján lényegkiemelő összegzést készít szóban és írásban.',
		a: 9,
		gT: 1081,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Céljainak megfelelően kiválasztja és önállóan használja a hagyományos, illetve digitális információforrásokat, adatbázisokat.',
		a: 9,
		gT: 1080,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló, érvekkel alátámasztott véleményt fogalmaz meg földrajzi kérdésekben.',
		a: 9,
		gT: 1079,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a tényeket a véleményektől, adatokat, információkat kritikusan szemlél.',
		a: 9,
		gT: 1078,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Feltárja a földrajzi folyamatok, jelenségek közötti hasonlóságokat és eltéréseket, különböző szempontok alapján rendszerezi azokat.',
		a: 9,
		gT: 1077,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi megfigyelést, vizsgálatot, kísérletet tervez és valósít meg, az eredményeket értelmezi.',
		a: 9,
		gT: 1076,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi tartalmú adatok, információk alapján következtetéseket von le, tendenciákat ismer fel, és várható következményeket (prognózist) fogalmaz meg.',
		a: 9,
		gT: 1075,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a más tantárgyak tanulása során megszerzett ismereteit földrajzi problémák megoldása során.',
		a: 9,
		gT: 1074,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott a különböző szintű pénzügyi folyamatok és összefüggések megismerése iránt.',
		a: 9,
		gT: 1073,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Döntéseit a környezeti szempontok figyelembevételével mérlegeli, felelős fogyasztói magatartást tanúsít.',
		a: 9,
		gT: 1072,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Elkötelezett a természeti és a kulturális értékek, a kulturális sokszínűség megőrzése iránt.',
		a: 9,
		gT: 1071,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi tartalmú projektfeladatokat valósít meg társaival.',
		a: 9,
		gT: 1070,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményt alkot aktuális társadalmi-gazdasági és környezeti kérdésekben, véleménye alátámasztására logikus érveket fogalmaz meg.',
		a: 9,
		gT: 1069,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Összetettebb földrajzi számítási feladatokat megold, az eredmények alapján következtetéseket fogalmaz meg.',
		a: 9,
		gT: 1068,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Adott természeti, társadalmi-gazdasági témához kapcsolódóan írásbeli vagy szóbeli beszámolót készít, prezentációt állít össze.',
		a: 9,
		gT: 1067,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Képes összetettebb földrajzi tartalmú szövegek értelmezésére.',
		a: 9,
		gT: 1066,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei alapján biztonsággal tájékozódik a valós és a digitális eszközök által közvetített virtuális földrajzi térben, földrajzi tartalmú adatokban, a különböző típusú térképeken.',
		a: 9,
		gT: 1065,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan és kritikusan használja a földrajzi tartalmú nyomtatott és elektronikus információforrásokat a tanulásban és tudása önálló bővítésekor.',
		a: 9,
		gT: 1064,
		b: 10,
		e2: 'Földrajz',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározott helyzetekben önálló véleményt tud alkotni, a társak véleményének meghallgatását követően álláspontját felül tudja bírálni, döntéseit át tudja értékelni.',
		a: 6,
		gT: 1170,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a kommunikációs készség, a társas együttműködés fejlesztése, a véleményalkotás gyakorlatának erősít'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenyen részt vesz a csoportmunkában zajló együttműködő alkotási folyamatban, digitális források közös elemzésében.',
		a: 6,
		gT: 1169,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a kommunikációs készség, a társas együttműködés fejlesztése, a véleményalkotás gyakorlatának erősít'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a csoportban elfoglalt helyét és szerepét, törekszik a személyiségének, készségeinek és képességeinek, érdeklődési körének legjobban megfelelő feladatok vállalására.',
		a: 6,
		gT: 1168,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a kommunikációs készség, a társas együttműködés fejlesztése, a véleményalkotás gyakorlatának erősít'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveges és képi források, digitalizált archívumok elemzése, feldolgozása alapján bővíti tudását.',
		a: 6,
		gT: 1167,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'az önálló ismeretszerzésben való jártasság növelése'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló néprajzi gyűjtés során, digitális archívumok, írásos dokumentumok tanulmányozásával ismereteket szerez családja, lakóhelye múltjáról, hagyományairól.',
		a: 6,
		gT: 1166,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'az önálló ismeretszerzésben való jártasság növelése'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a gazdálkodó életmódra jellemző újrahasznosítás elvét, és saját életében is megpróbálja alkalmazni.',
		a: 6,
		gT: 1165,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a környezettudatos szemlélet fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Belátja, hogy a természet kínálta lehetőségek felhasználásának elsődleges szempontja a szükségletek kielégítése, a mértéktartás alapelvének követése.',
		a: 6,
		gT: 1164,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a környezettudatos szemlélet fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a természeti környezet meghatározó szerepét a más tájakon élő emberek életmódbeli különbségében.',
		a: 6,
		gT: 1163,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a környezettudatos szemlélet fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megbecsüli és megismeri az idősebb családtagok tudását, tapasztalatait, nyitott a korábbi nemzedékek életmódjának, normarendszerének megismerésére.',
		a: 6,
		gT: 1162,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a nemzedékek közötti távolság csökkentése'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődő attitűdjével erősíti a nemzedékek közötti párbeszédet.',
		a: 6,
		gT: 1161,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a nemzedékek közötti távolság csökkentése'])
	},
		{
		cG: 'altgim',
		gD: 'Tiszteletben tartja más kultúrák értékeit.',
		a: 6,
		gT: 1160,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a család, a családtagok, a közösség emberi értékei iránti érzékenység fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a néphagyományok közösségformáló, közösségmegtartó erejét.',
		a: 6,
		gT: 1159,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a család, a családtagok, a közösség emberi értékei iránti érzékenység fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitottá válik a hagyományos családi és közösségi értékek befogadására.',
		a: 6,
		gT: 1158,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a család, a családtagok, a közösség emberi értékei iránti érzékenység fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megtapasztalja a legszűkebb közösséghez, a családhoz, a lokális közösséghez tartozás érzését.',
		a: 6,
		gT: 1157,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a család, a családtagok, a közösség emberi értékei iránti érzékenység fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Megéli a közösséghez tartozást, nemzeti önazonosságát, kialakul benne a haza iránti szeretet és elköteleződés.',
		a: 6,
		gT: 1156,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Megbecsüli szűkebb lakókörnyezetének épített örökségét, természeti értékeit, helyi hagyományait.',
		a: 6,
		gT: 1155,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a közvetlen környezetében található helyi értékeket, felhasználva a digitálisan elérhető adatbázisokat is.',
		a: 6,
		gT: 1154,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['hon- és népismeret', 'a lokálpatriotizmus és a nemzeti identitás erősítése'])
	},
		{
		cG: 'altgim',
		gD: 'Képes az együttműködésre csoportmunkában, alkalmazza a tevékenységek lezárásakor az önértékelést és a társak értékelését.',
		a: 6,
		gT: 1153,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'hon- és népismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Az önálló ismeretszerzés során alkalmazni tudja az interjúkészítés, a forráselemzés módszerét.',
		a: 6,
		gT: 1152,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'hon- és népismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és adekvát módon használja az ismeretkör tartalmi kulcsfogalmait.',
		a: 6,
		gT: 1151,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'hon- és népismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri magyarország és a kárpát-medence kulturális hagyományait, tiszteletben tartja más kultúrák értékeit.',
		a: 6,
		gT: 1150,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'hon- és népismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Képessé válik a nemzedékek közötti párbeszédre.',
		a: 6,
		gT: 1149,
		b: 6,
		e2: 'Hon- és népismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'hon- és népismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a fehérjék aminosavakból épülnek fel, ismeri az aminosavak általános szerkezetét és azok legfontosabb tulajdonságait, ismeri a fehérjék elsődleges, másodlagos, harmadlagos és negyedleges szerkezetét, érti e fajlagos molekulák szerkezetének a kialakulását, példát mond a fehérjék szervezetben és élelmiszereinkben betöltött szerepére, ismeri a fehérjék kicsapásának módjait és ennek jelentőségét a mérgezések kapcsán.',
		a: 9,
		gT: 1331,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'biológiai szempontból jelentős szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szénhidrátok legalapvetőbb csoportjait, példát mond mindegyik csoportból egy-két képviselőre, ismeri a szőlőcukor képletét, összefüggéseket talál a szőlőcukor szerkezete és tulajdonságai között, ismeri a háztartásban található szénhidrátok besorolását a megfelelő csoportba, valamint köznapi tulajdonságaikat (ízük, oldhatóságuk) és felhasználásukat, összehasonlítja a keményítő és a cellulóz molekulaszerkezetét és tulajdonságait, valamint szerepüket a szervezetben és a táplálékaink között.',
		a: 9,
		gT: 1330,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'biológiai szempontból jelentős szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a lipid gyűjtőnevet, tudja, hogy ebbe a csoportba hasonló oldhatósági tulajdonságokkal rendelkező vegyületek tartoznak, felsorolja a lipidek legfontosabb képviselőit, felismeri azokat szerkezeti képlet alapján, ismeri a lipidek csoportjába tartozó vegyületek egy-egy fontos szerepét az élő szervezetben.',
		a: 9,
		gT: 1329,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'biológiai szempontból jelentős szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a biológiai szempontból fontos szerves vegyületek építőelemeit (kémiai összetételét, a nagyobbak alkotó molekuláit).',
		a: 9,
		gT: 1328,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'biológiai szempontból jelentős szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Szerkezetük alapján felismeri az aminok és az amidok egyszerűbb képviselőit, ismeri az aminocsoportot és az amidcsoportot.',
		a: 9,
		gT: 1327,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Az etil-acetát példáján bemutatja a kis szénatomszámú észterek jellemző tulajdonságait, tudja, hogy a zsírok, az olajok, a foszfatidok, a viaszok egyaránt az észterek csoportjába tartoznak.',
		a: 9,
		gT: 1326,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri, és vegyületek képletében felismeri a karboxilcsoportot és az észtercsoportot, ismeri az egyszerűbb és fontosabb karbonsavak (hangyasav, ecetsav, zsírsavak) szerkezetét és lényeges tulajdonságaikat.',
		a: 9,
		gT: 1325,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az aldehidcsoportot, ismeri a formaldehid tulajdonságait, az aldehidek kimutatásának módját, felismeri a ketocsoportot, ismeri az aceton tulajdonságait, felhasználását.',
		a: 9,
		gT: 1324,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az alkoholok fontosabb képviselőit (metanol, etanol, glikol, glicerin), azok fontosabb tulajdonságait, élettani hatásukat és felhasználásukat.',
		a: 9,
		gT: 1323,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri, és vegyületek képletében felismeri a legegyszerűbb oxigéntartalmú funkciós csoportokat: a hidroxilcsoportot, az oxocsoportot, az étercsoportot.',
		a: 9,
		gT: 1322,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Példát mond közismert halogéntartalmú szerves vegyületre (pl. kloroform, vinil-klorid, freonok, ddt, tetrafluoretén), és ismeri felhasználásukat.',
		a: 9,
		gT: 1321,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az aromás szerkezetet egy egyszerű vegyületben, ismeri a benzol molekulaszerkezetét és fontosabb tulajdonságait, tudja, hogy számos illékony aromás szénhidrogén mérgező.',
		a: 9,
		gT: 1320,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legegyszerűbb szerves kémiai reakciótípusokat.',
		a: 9,
		gT: 1319,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a telítetlen szénhidrogének fogalmát, az etén és az acetilén szerkezetét és fontosabb tulajdonságait, ismeri és reakcióegyenletekkel leírja a telítetlen szénhidrogének jellemző reakciótípusait, az égést, az addíciót és a polimerizációt.',
		a: 9,
		gT: 1318,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az izoméria jelenségét, példákat mond konstitúciós izomerekre.',
		a: 9,
		gT: 1317,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a telített szénhidrogének homológ sorának felépülési elvét és fontosabb képviselőiket, ismeri a metán fontosabb tulajdonságait, jellemzi az anyagok szempontrendszere alapján, ismeri a homológ soron belül a forráspont változásának az okát, valamint a szénhidrogének oldhatóságát, ismeri és egy-egy kémiai egyenlettel leírja az égés, a szubsztitúció és a hőbontás folyamatát.',
		a: 9,
		gT: 1316,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szerves vegyületeket felépítő organogén elemeket, érti a szerves vegyületek megkülönböztetésének, külön csoportban tárgyalásának az okát, az egyszerűbb szerves vegyületeket szerkezeti képlettel és összegképlettel jelöli.',
		a: 9,
		gT: 1315,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'egyszerű szerves vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer eljárásokat fémek ércekből történő előállítására (vas, alumínium).',
		a: 9,
		gT: 1314,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektrolizáló cella felépítését és az elektrolízis lényegét a hidrogén-klorid-oldat grafitelektródos elektrolízise kapcsán, érti, hogy az elektromos áram kémiai reakciók végbemenetelét segíti, példát ad ezek gyakorlati felhasználására (alumíniumgyártás, galvanizálás).',
		a: 9,
		gT: 1313,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az elektromos áram és a kémiai reakciók közötti összefüggéseket: a galvánelemek áramtermelésének és az elektrolízisnek a lényegét.',
		a: 9,
		gT: 1312,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az elektrokémiai áramforrások felépítésével és működésével, ismeri a daniell-elem felépítését és az abban végbemenő folyamatokat, az elem áramtermelését.',
		a: 9,
		gT: 1311,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fémek köznapi szempontból legfontosabb vegyületeit, azok alapvető tulajdonságait (nacl, na2co3, nahco3, na3po4, caco3, ca3(po4)2, al2o3, fe2o3, cuso4).',
		a: 9,
		gT: 1310,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fémek helyét a periódusos rendszerben, megkülönbözteti az alkálifémeket, az alkáliföldfémeket, ismeri a vas, az alumínium, a réz, valamint a nemesfémek legfontosabb tulajdonságait.',
		a: 9,
		gT: 1309,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérletek tapasztalatainak ismeretében értelmezi a fémek egymáshoz viszonyított reakciókészségét oxigénnel, sósavval, vízzel és más fémionok oldatával, érti a fémek redukáló sorának felépülését, következtet fémek reakciókészségére a sorban elfoglalt helyük alapján.',
		a: 9,
		gT: 1308,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fontosabb fémek (na, k, mg, ca, al, fe, cu, ag, au, zn) fizikai és kémiai tulajdonságait.',
		a: 9,
		gT: 1307,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'fémek és fémvegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja a gyémánt és a grafit szerkezetét és tulajdonságait, különbséget tesz a természetes és mesterséges szenek között, ismeri a természetes szenek felhasználását, ismeri a koksz és az aktív szén felhasználását, példát mond a szén reakcióira (pl. égés), ismeri a szén oxidjainak (co, co2) a tulajdonságait, élettani hatását, valamint a szénsavat és sóit, a karbonátokat.',
		a: 9,
		gT: 1306,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a vörösfoszfort és a foszforsavat, fontosabb tulajdonságaikat és a foszfor gyufagyártásban betöltött szerepét.',
		a: 9,
		gT: 1305,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nitrogént, az ammóniát, a nitrogén-dioxidot és a salétromsavat.',
		a: 9,
		gT: 1304,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a ként, a kén-dioxidot és a kénsavat.',
		a: 9,
		gT: 1303,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az oxigént és a vizet, ismeri az ózont, mint az oxigén allotróp módosulatát, ismeri mérgező hatását (szmogban) és uv-elnyelő hatását (ózonpajzsban).',
		a: 9,
		gT: 1302,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a halogének képviselőit, jellemzi a klórt, ismeri a hidrogén-klorid és a nátrium-klorid tulajdonságait.',
		a: 9,
		gT: 1301,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az anyagok jellemzésének szempontjait a hidrogénre, kapcsolatot teremt az anyag szerkezete és tulajdonságai között.',
		a: 9,
		gT: 1300,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hidrogén, a halogének, a kalkogének, a nitrogén, a szén és fontosabb vegyületeik fizikai és kémiai sajátságait, különös tekintettel a köznapi életben előforduló anyagokra.',
		a: 9,
		gT: 1299,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az anyagok jellemzésének logikus szempontrendszerét: anyagszerkezet -- fizikai tulajdonságok -- kémiai tulajdonságok -- előfordulás -- előállítás -- felhasználás.',
		a: 9,
		gT: 1298,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'nemfémes elemek és vegyületeik'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét példákon keresztül értelmezi a redoxireakciókat oxigénfelvétel és oxigénleadás alapján, ismeri a redoxireakciók tágabb értelmezését elektronátmenet alapján is, konkrét példákon bemutatja a redoxireakciót, eldönti egy egyszerű redoxireakció egyenlete ismeretében az elektronátadás irányát, az oxidációt és redukciót, megadja az oxidálószert és a redukálószert.',
		a: 9,
		gT: 1297,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fontosabb savakat, bázisokat, azok nevét, képletét, brønsted sav-bázis elmélete alapján értelmezi a sav és bázis fogalmát, ismeri a savak és bázisok erősségének és értékűségének a jelentését, konkrét példát mond ezekre a vegyületekre, érti a víz sav-bázis tulajdonságait, ismeri az autoprotolízis jelenségét és a víz autoprotolízisének a termékeit.',
		a: 9,
		gT: 1296,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer egyirányú és egyensúlyra vezető kémiai reakciókat, érti a dinamikus egyensúly fogalmát, ismeri és alkalmazza az egyensúly eltolásának lehetőségeit le châtelier elve alapján.',
		a: 9,
		gT: 1295,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a katalizátorok hatásának az elvi alapjait.',
		a: 9,
		gT: 1294,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét reakciókat termokémiai egyenlettel is felír, érti a termokémiai egyenlet jelentését, ismeri a reakcióhő fogalmát, a reakcióhő ismeretében megadja egy reakció energiaváltozását, energiadiagramot rajzol, értelmez, ismeri a termokémia főtételét és jelentőségét a többlépéses reakciók energiaváltozásának a meghatározásakor.',
		a: 9,
		gT: 1293,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'A kémiai reakciókat szimbólumokkal írja le.',
		a: 9,
		gT: 1292,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kémiai reakciók csoportosítását többféle szempont szerint: a reagáló és a képződő anyagok száma, a reakció energiaváltozása, időbeli lefolyása, iránya, a reakcióban részt vevő anyagok halmazállapota szerint.',
		a: 9,
		gT: 1291,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kémiai reakciók végbemenetelének feltételeit, ismeri, érti és alkalmazza a tömegmegmaradás törvényét a kémiai reakciókra.',
		a: 9,
		gT: 1290,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a fizikai és kémiai változások közötti különbségeket.',
		a: 9,
		gT: 1289,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'kémiai változások'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján összehasonlítja a három halmazállapotba (gáz, folyadék, szilárd) tartozó anyagok általános jellemzőit, ismeri avogadro gáztörvényét és egyszerű számításokat végez gázok térfogatával standard körülmények között, érti a halmazállapot-változások lényegét és energiaváltozását.',
		a: 9,
		gT: 1288,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a „hasonló a hasonlóban jól oldódik\" elvet, ismeri az oldatok töménységével és az oldhatósággal kapcsolatos legfontosabb ismereteket, egyszerű számítási feladatokat old meg az oldatok köréből (tömegszázalék, anyagmennyiség-koncentráció).',
		a: 9,
		gT: 1287,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az anyagok csoportosításának a módját a kémiai összetétel alapján, ismeri ezeknek az anyagcsoportoknak a legfontosabb közös tulajdonságait, példákat mond minden csoport képviselőire, tudja, hogy az oldatok a keverékek egy csoportja.',
		a: 9,
		gT: 1286,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fémrács szerkezetét és az ebből adódó alapvető fizikai tulajdonságokat.',
		a: 9,
		gT: 1285,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fémek helyét a periódusos rendszerben, érti a fémes kötés kialakulásának és a fémek kristályszerkezetének a lényegét, érti a kapcsolatot a fémek kristályszerkezete és fontosabb tulajdonságai között, konkrét példák segítségével (pl. fe, al, cu) jellemzi a fémes tulajdonságokat, összehasonlításokat végez.',
		a: 9,
		gT: 1284,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyszerű ionok atomokból való létrejöttének módját, ezt konkrét példákkal szemlélteti, ismeri a fontosabb összetett ionok molekulákból való képződésének módját, tudja a nevüket, összegképletüket, érti egy ionvegyület képletének a megszerkesztését az azt alkotó ionok képlete alapján, érti az ionrács felépülési elvét, az ionvegyület képletének jelentését, konkrét példák segítségével jellemzi az ionvegyületek fontosabb tulajdonságait.',
		a: 9,
		gT: 1283,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a részecske szerkezete és az anyag fizikai és kémiai tulajdonságai közötti alapvető összefüggéseket.',
		a: 9,
		gT: 1282,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'szerkezet és tulajdonság kapcsolata'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza egyszerű molekulák polaritását, és ennek alapján következtet a közöttük kialakuló másodrendű kémiai kötésekre, valamint oldhatósági jellemzőikre, érti, hogy a moláris tömeg és a molekulák között fellépő másodrendű kötések hogyan befolyásolják az olvadás- és forráspontot, ezeket konkrét példákkal támasztja alá.',
		a: 9,
		gT: 1281,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a molekulaképződés szabályait, ismeri az elektronegativitás fogalmát, és érti a kötéspolaritás lényegét, a kovalens kötést jellemzi száma és polaritása szerint, megalkotja egyszerű molekulák szerkezeti képletét, ismeri a legalapvetőbb molekulaalakokat (lineáris, síkháromszög, tetraéder, piramis, v-alak), valamint ezek meghatározó szerepét a molekulák polaritása szempontjából.',
		a: 9,
		gT: 1280,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a periódusos rendszer fontosabb adatait (vegyjel, rendszám, relatív atomtömeg), alkalmazza a periódusszám és a (fő)csoportszám jelentését a héjak és a vegyértékelektronok szempontjából, ismeri a periódusos rendszer fontosabb csoportjainak a nevét, és az azokat alkotó elemek vegyjelét.',
		a: 9,
		gT: 1279,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az atom elektronszerkezetének kiépülését a bohr-féle atommodell szintjén, tisztában van a vegyértékelektronok kémiai reakciókban betöltött szerepével.',
		a: 9,
		gT: 1278,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az atom felépítését, az elemi részecskéket, valamint azok jellemzőit, ismeri az izotópok legfontosabb tulajdonságait, érti a radioaktivitás lényegét és példát mond a radioaktív izotópok gyakorlati felhasználására.',
		a: 9,
		gT: 1277,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb (n-, p-, k-tartalmú) műtrágyák kémiai összetételét, előállítását és felhasználásának szükségszerűségét.',
		a: 9,
		gT: 1276,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'vegyszerismeret, biztonságos vegyszerhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mindennapi életben előforduló növényvédő szerek használatának alapvető szabályait, értelmezi a növényvédő szereknek a leírását, felhasználási útmutatóját, példát mond a növényvédő szerekre a múltból és a jelenből (bordói lé, korszerű peszticidek), ismeri ezek hatásának elvi alapjait.',
		a: 9,
		gT: 1275,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'vegyszerismeret, biztonságos vegyszerhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kemény víz és a lágy víz közötti különbséget, érti a kemény víz és egyes mosószerek közötti kölcsönhatás (kicsapódás) folyamatát.',
		a: 9,
		gT: 1274,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mosó- és tisztítószerek, valamint a fertőtlenítőszerek fogalmi megkülönböztetését, példát mond a környezetéből gyakran használt mosó-és tisztítószerre és fertőtlenítőszerre, ismeri a szappan összetételét és a szappangyártás módját, ismeri a hypo kémiai összetételét és felhasználási módját, érti a mosószerek mosóaktív komponenseinek (a felületaktív részecskéknek) a mosásban betöltött szerepét.',
		a: 9,
		gT: 1273,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a műanyag fogalmát és a műanyagok csoportosításának lehetőségeit eredetük, illetve hővel szemben mutatott viselkedésük alapján, konkrét példákat mond műanyagokra a környezetéből, érti azok felhasználásának előnyeit, ismeri a polimerizáció fogalmát, példát ad monomerekre és polimerekre, ismeri a műanyagok felhasználásának előnyeit és hátrányait, környezetre gyakorolt hatásukat.',
		a: 9,
		gT: 1272,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fosszilis energiahordozók fogalmát és azok legfontosabb képviselőit, érti a kőolaj ipari lepárlásának elvét, ismeri a legfontosabb párlatok nevét, összetételét és felhasználási lehetőségeit, példát mond motorhajtó anyagokra, ismeri a töltőállomásokon kapható üzemanyagok típusait és azok felhasználását.',
		a: 9,
		gT: 1271,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy a fémek többsége a természetben vegyületek formájában van jelen, ismeri a legfontosabb redukciós eljárásokat (szenes, elektrokémiai redukció), ismeri a legfontosabb ötvözeteket, érti az ötvözetek felhasználásának előnyeit.',
		a: 9,
		gT: 1270,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a mészkőalapú építőanyagok kémiai összetételét és átalakulásait (mészkő, égetett mész, oltott mész), ismeri a beton alapvető összetételét, előállítását és felhasználásának lehetőségeit, ismeri a legfontosabb hőszigetelő anyagokat.',
		a: 9,
		gT: 1269,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Képes az ismeretein alapuló tudatos vásárlással és tudatos életvitellel a környezetének megóvására.',
		a: 9,
		gT: 1268,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy az ipari (vegyipari) termelés során különféle, akár a környezetre vagy szervezetre káros anyagok is keletkezhetnek, amelyek közömbösítése, illetve kezelése fontos feladat.',
		a: 9,
		gT: 1267,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a különböző nyersanyagokból előállítható legfontosabb termékeket.',
		a: 9,
		gT: 1266,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az anyagok átalakításának hasznát, valamint konkrét példákat mond vegyipari termékek előállítására.',
		a: 9,
		gT: 1265,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a természetben megtalálható legfontosabb nyersanyagokat.',
		a: 9,
		gT: 1264,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a mindennapi életben használt legfontosabb anyagok fizikai és kémiai tulajdonságai, átalakulásai, e'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a méreg fogalmának jelentését, érti az anyagok mennyiségének jelentőségét a mérgező hatásuk tekintetében, példát mond növényi, állati és szintetikus mérgekre, ismeri a mérgek szervezetbe jutásának lehetőségeit (tápcsatorna, bőr, tüdő), ismeri és felismeri a különböző anyagok csomagolásán a mérgező anyag piktogramját, képes ezeknek az anyagoknak a felelősségteljes használatára, ismeri a köznapi életben előforduló leggyakoribb mérgeket, mérgezéseket (pl. szén-monoxid, penészgomba-toxinok, gombamérgezések, helytelen égetés során keletkező füst anyagai, drogok, nehézfémek), tudja, hogy a mérgező hatás nem az anyag szintetikus eredetének a következménye.',
		a: 9,
		gT: 1263,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'táplálkozás, egészségvédelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a leggyakrabban használt élvezeti szerek (szeszes italok, dohánytermékek, kávé, energiaitalok, drogok) hatóanyagát, ezen szerek használatának veszélyeit, érti az illegális drogok használatával kapcsolatos alapvető problémákat, példákat mond illegális drogokra, ismeri a doppingszer fogalmát, megérti és értékeli a doppingszerekkel kapcsolatos információkat.',
		a: 9,
		gT: 1262,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'táplálkozás, egészségvédelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a gyógyszer fogalmát és a gyógyszerek fontosabb csoportjait hatásuk alapján, alapvető szinten értelmezi a gyógyszerek mellékelt betegtájékoztatóját.',
		a: 9,
		gT: 1261,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'táplálkozás, egészségvédelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az élelmiszereink legfontosabb összetevőinek, a szénhidrátoknak, a fehérjéknek, valamint a zsíroknak és olajoknak a molekulaszerkezetét és a tulajdonságait, felsorolja a háztartásban megtalálható legfontosabb élelmiszerek tápanyagait, példát mond bizonyos összetevők (fehérjék, redukáló cukrok, keményítő) kimutatására, ismeri a legfontosabb élelmiszeradalék-csoportokat, alapvető szinten értelmezi egy élelmiszer tájékoztató címkéjét.',
		a: 9,
		gT: 1260,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'táplálkozás, egészségvédelem'])
	},
		{
		cG: 'altgim',
		gD: 'Látja az áltudományos megközelítés lényegét (feltételezés, szubjektivitás, bizonyítatlanság), felismeri az áltudományosságra utaló legfontosabb jeleket.',
		a: 9,
		gT: 1259,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'tudomány és áltudomány megkülönböztetése, a tényeken alapuló döntések jelentősége'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tudományos megközelítés lényegét (objektivitás, reprodukálhatóság, ellenőrizhetőség, bizonyíthatóság).',
		a: 9,
		gT: 1258,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'tudomány és áltudomány megkülönböztetése, a tényeken alapuló döntések jelentősége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a különbséget a tudományos és áltudományos információk között, konkrét példát mond a köznapi életből tudományos és áltudományos ismeretekre, információkra.',
		a: 9,
		gT: 1257,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'tudomány és áltudomány megkülönböztetése, a tényeken alapuló döntések jelentősége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a kőzetek és a környezeti tényezők talajképző szerepét, példát mond alapvető kőzetekre, ásványokra, érti a különbséget a hulladék és a szemét fogalmi megkülönböztetése között, ismeri a hulladékok típusait, kezelésük módját, környezetre gyakorolt hatásait.',
		a: 9,
		gT: 1256,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a természetes vizek típusait, azok legfontosabb kémiai összetevőit a víz körforgásának és tulajdonságainak tükrében, példákat mond vízszennyező anyagokra, azok forrására, a szennyezés lehetséges következményeire, ismeri a víztisztítás folyamatának alapvető lépéseit, valamint a tiszta ivóvíz előállításának a módját.',
		a: 9,
		gT: 1255,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a légkör kémiai összetételét és az azt alkotó gázok fontosabb tulajdonságait, példákat mond a légkör élőlényekre és élettelen környezetre gyakorolt hatásaira, ismeri a legfontosabb légszennyező gázokat, azok alapvető tulajdonságait, valamint a környezetszennyezésének hatásait, ismeri a légkört érintő globális környezeti problémák kémiai hátterét és ezen problémák megoldására tett erőfeszítéseket.',
		a: 9,
		gT: 1254,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Kiselőadás vagy projektmunka keretében mutatja be a 20. század néhány nagy környezeti katasztrófáját és azt, hogy milyen tanulságokat vonhatunk le azok megismeréséből.',
		a: 9,
		gT: 1253,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákon keresztül szemlélteti az antropogén tevékenységek kémiai vonatkozású környezeti következményeit.',
		a: 9,
		gT: 1252,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az emberiség előtt álló legnagyobb kihívásokat, kiemelten azok kémiai vonatkozásai (energiahordozók, környezetszennyezés, fenntarthatóság, új anyagok előállítása).',
		a: 9,
		gT: 1251,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal szemlélteti az emberiség legégetőbb globális problémáit (globális éghajlatváltozás, ózonlyuk, ivóvízkészlet csökkenése, energiaforrások kimerülése), és azok kémiai vonatkozásait.',
		a: 9,
		gT: 1250,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a bioüzemanyagok legfontosabb típusait.',
		a: 9,
		gT: 1249,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'energiagazdálkodás: energiaforrások és energiahordozók megismerése és összehasonlítása'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal szemlélteti egyes kémiai technológiák, illetve bizonyos anyagok felhasználásának környezetre gyakorolt pozitív és negatív hatásait.',
		a: 9,
		gT: 1248,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: veszélyes és különleges anyagok, nyersanyagok, anyagkörforgalom'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb környezetszennyező forrásokat és anyagokat, valamint ezeknek az anyagoknak a környezetre gyakorolt hatását.',
		a: 9,
		gT: 1247,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: veszélyes és különleges anyagok, nyersanyagok, anyagkörforgalom'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a zöld kémia lényegét, a környezetbarát folyamatok előtérbe helyezését, példákat mond újonnan előállított, az emberiség jólétét befolyásoló anyagokra (pl. új gyógyszerek, lebomló műanyagok, intelligens textíliák).',
		a: 9,
		gT: 1246,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: veszélyes és különleges anyagok, nyersanyagok, anyagkörforgalom'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a környezetünk megóvásának a jelentőségét az emberi civilizáció fennmaradása szempontjából.',
		a: 9,
		gT: 1245,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: veszélyes és különleges anyagok, nyersanyagok, anyagkörforgalom'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető szinten ismeri a természetes környezetet felépítő légkör, vízburok, kőzetburok és élővilág kémiai összetételét.',
		a: 9,
		gT: 1244,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: veszélyes és különleges anyagok, nyersanyagok, anyagkörforgalom'])
	},
		{
		cG: 'altgim',
		gD: 'Mobiltelefonos, táblagépes alkalmazások segítségével médiatartalmakat, illetve bemutatókat hoz létre.',
		a: 9,
		gT: 1243,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a digitális kompetencia fejlesztése', 'alkotás digitális eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző, megbízható forrásokból gyűjtött információkat számítógépes prezentációban mutatja be.',
		a: 9,
		gT: 1242,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a digitális kompetencia fejlesztése', 'alkotás digitális eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'Magabiztosan használ magyar és idegen nyelvű mobiltelefonos, táblagépes applikációkat kémiai tárgyú információk keresésére.',
		a: 9,
		gT: 1241,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a digitális kompetencia fejlesztése', 'szövegek, képek, adatok keresése, értelmezése, kritikus és etikus felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer megbízható magyar és idegen nyelvű internetes forrásokat kémiai tárgyú, elemekkel és vegyületekkel kapcsolatos képek és szövegek gyűjtésére.',
		a: 9,
		gT: 1240,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a digitális kompetencia fejlesztése', 'szövegek, képek, adatok keresése, értelmezése, kritikus és etikus felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a fémek redukáló sorát a fémek tulajdonságainak megjóslására, tulajdonságaik alátámasztására.',
		a: 9,
		gT: 1239,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Analógiás gondolkodással következtet a szerves vegyület tulajdonságára a funkciós csoportja ismeretében.',
		a: 9,
		gT: 1238,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az anyagmennyiség és a mól fogalmát, érti bevezetésük szükségességét és egyszerű számításokat végez m, n és m segítségével.',
		a: 9,
		gT: 1237,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Kémiai vizsgálatainak tervezése során alkalmazza az analógiás gondolkodás alapjait és használja az „egyszerre csak egy tényezőt változtatunk\" elvet.',
		a: 9,
		gT: 1236,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Egyedül vagy csoportban elvégez összetettebb, halmazállapot-változással és oldódással kapcsolatos kísérleteket és megbecsüli azok várható eredményét.',
		a: 9,
		gT: 1235,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a kémiai kísérlet mint megismerési módszer'])
	},
		{
		cG: 'altgim',
		gD: 'Egyedül vagy csoportban elvégez egyszerű kémiai kísérleteket leírás vagy szóbeli útmutatás alapján és értékeli azok eredményét.',
		a: 9,
		gT: 1234,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a kémiai kísérlet mint megismerési módszer'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a háztartásban leggyakrabban előforduló anyagok felhasználásának előnyeivel és veszélyeivel, a biztonságos vegyszerhasználat szabályaival.',
		a: 9,
		gT: 1233,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kémiának az egyén és a társadalom életében betöltött szerepét.',
		a: 9,
		gT: 1232,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja használni a részecskemodellt az anyagok tulajdonságainak és átalakulásainak értelmezésére.',
		a: 9,
		gT: 1231,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Képes számítógépes prezentáció formájában kémiával kapcsolatos eredmények, információk bemutatására, megosztására, a mérési adatok számítógépes feldolgozására, szemléltetésére.',
		a: 9,
		gT: 1230,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Képes az analógiás, a korrelatív és a mérlegelő gondolkodásra kémiai kontextusban.',
		a: 9,
		gT: 1229,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a természettudományos problémamegoldás lépéseit egyszerű kémiai problémák megoldásában.',
		a: 9,
		gT: 1228,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy csoportban el tud végezni egyszerű kémiai kísérleteket és megbecsüli azok várható eredményét.',
		a: 9,
		gT: 1227,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mindennapi életben előforduló fontosabb vegyülettípusokat, tisztában van az élettelen és élő természet legfontosabb kémiai fogalmaival, jelenségeivel és az azokat működtető reakciótípusokkal.',
		a: 9,
		gT: 1226,
		b: 10,
		e2: 'Kémia',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a növények csírázásának és növekedésének feltételeit, ezekre vonatkozóan egyszerű kísérletet végez.',
		a: 3,
		gT: 1415,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a mozgások sokféleségét, csoportosítja a mozgásformákat: hely- és helyzetváltoztató mozgás.',
		a: 3,
		gT: 1414,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi az időjárás fő elemeit, időjárási megfigyeléseket tesz, méréseket végez.',
		a: 3,
		gT: 1413,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a tűz és az égés szerepét az ember életében.',
		a: 3,
		gT: 1412,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Tanítói segítséggel égéssel kapcsolatos egyszerű kísérleteket végez, csoportosítja a megvizsgált éghető és éghetetlen anyagokat.',
		a: 3,
		gT: 1411,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és modellezi a víz természetben megtett útját, felismeri a folyamat ciklikus jellegét.',
		a: 3,
		gT: 1410,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű kísérletek során megfigyeli a halmazállapot-változásokat: fagyás, olvadás, forrás, párolgás, lecsapódás.',
		a: 3,
		gT: 1409,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az anyagok halmazállapotait, megnevezi és összehasonlítja azok alapvető jellemzőit.',
		a: 3,
		gT: 1408,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján élettelen anyagokat és élőlényeket összehasonlít, csoportosít.',
		a: 3,
		gT: 1407,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az élőlényeken, élettelen anyagokon az érzékelhető és mérhető tulajdonságokat.',
		a: 3,
		gT: 1406,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'anyagok és folyamatok', 'az élőlények és az élettelen anyagok tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Felelősségtudattal rendelkezik a szűkebb, illetve tágabb környezete iránt.',
		a: 3,
		gT: 1405,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember és környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Elsajátít olyan szokásokat és viselkedésformákat, amelyek a károsítások megelőzésére irányulnak (pl. hulladékminimalizálás -- anyagtakarékosság, újrahasználat és -felhasználás, tömegközlekedés, gyalogos vagy kerékpáros közlekedés előnyben részesítése, energiatakarékosság).',
		a: 3,
		gT: 1404,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember és környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, mely anyagok szennyezhetik környezetünket a mindennapi életben, mely szokások vezetnek környezetünk károsításához, egyéni és közösségi környezetvédelmi cselekvési formákat ismer meg és gyakorol közvetlen környezetében (pl. madárbarát kert, iskolakert kiépítésében, fenntartásában való részvétel, iskolai környezet kialakításában, rendben tartásában való részvétel, települési természet- és környezetvédelmi tevékenységben való részvétel).',
		a: 3,
		gT: 1403,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember és környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az egészséges életmód alapelveivel, összetevőivel, az emberi szervezet egészséges testi és lelki fejlődéséhez szükséges szokásokkal,azokat igyekszik betartani.',
		a: 3,
		gT: 1402,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember és környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egészséges, gondozott környezet jellemzőit, megfogalmazza, milyen hatással van a környezet az egészségére.',
		a: 3,
		gT: 1401,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember és környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer betegségeket, felismeri a legjellemzőbb betegségtüneteket, a betegségek megelőzésének alapvető módjait.',
		a: 3,
		gT: 1400,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Belátja az érzékszervek védelmének fontosságát, és ismeri ezek eszközeit, módjait.',
		a: 3,
		gT: 1399,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi az érzékszerveket és azok szerepét a megismerési folyamatokban.',
		a: 3,
		gT: 1398,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi az emberi test részeit, fő szerveit, ismeri ezek működését, szerepét.',
		a: 3,
		gT: 1397,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az emberi szervezet fő életfolyamatait.',
		a: 3,
		gT: 1396,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi az ember életszakaszait.',
		a: 3,
		gT: 1395,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'az ember szervezete'])
	},
		{
		cG: 'altgim',
		gD: 'Egyéni és közösségi környezetvédelmi cselekvési formákat ismer meg és gyakorol közvetlen környezetében.',
		a: 3,
		gT: 1394,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal mutatja be az emberi tevékenység természeti környezetre gyakorolt hatását, felismeri a természetvédelem jelentőségét.',
		a: 3,
		gT: 1393,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egyes életközösségek növényei és állatai közötti jellegzetes kapcsolatokat.',
		a: 3,
		gT: 1392,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy az egyes fajok környezeti igényei eltérőek.',
		a: 3,
		gT: 1391,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseit mérésekkel (például időjárási elemek, testméret), modellezéssel, egyszerű kísérletek végzésével (például láb- és csőrtípusok) egészíti ki.',
		a: 3,
		gT: 1390,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a lakóhelyéhez közeli életközösségek és az ott élő élőlények közötti különbségeket (pl. természetes -- mesterséges életközösség, erdő -- mező, rét -- víz, vízpart -- park, díszkert -- zöldséges, gyümölcsöskert esetében).',
		a: 3,
		gT: 1389,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét példán keresztül megfigyeli és felismeri az élőhely, életmód és testfelépítés kapcsolatát.',
		a: 3,
		gT: 1388,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a megismert életközösségekre jellemző élőlényeket, használja az életközösségekhez kapcsolódó kifejezéseket.',
		a: 3,
		gT: 1387,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Algoritmus alapján megfigyeli és összehasonlítja hazánk természetes és mesterséges élőhelyein, életközösségeiben élő növények és állatok jellemzőit, a megfigyelt jellemzőik alapján csoportokba rendezi azokat.',
		a: 3,
		gT: 1386,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a lakóhelyéhez közeli életközösségek (erdő, mező-rét, víz-vízpart) főbb jellemzőit.',
		a: 3,
		gT: 1385,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Algoritmus alapján megfigyeli és összehasonlítja a saját lakókörnyezetében fellelhető, jellemző növények és állatok jellemzőit, a megfigyelt tulajdonságok alapján csoportokba rendezi azokat.',
		a: 3,
		gT: 1384,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'életközösségek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, megnevezi és megfigyeli egy konkrét állat választott részeit, algoritmus alapján a részek tulajdonságait, megfogalmazza, mi a megismert rész szerepe az állat életében.',
		a: 3,
		gT: 1383,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'a növények és az állatok'])
	},
		{
		cG: 'altgim',
		gD: 'Növényt ültet és gondoz, megfigyeli a fejlődését, tapasztalatait rajzos formában rögzíti.',
		a: 3,
		gT: 1382,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'a növények és az állatok'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, megnevezi és megfigyeli egy konkrét növény választott részeit, algoritmus alapján a részek tulajdonságait, megfogalmazza, mi a növényi részek szerepe a növény életében.',
		a: 3,
		gT: 1381,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'a növények és az állatok'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, megnevezi és megfigyeli az életfeltételeket, életjelenségeket.',
		a: 3,
		gT: 1380,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'élő környezet', 'a növények és az állatok'])
	},
		{
		cG: 'altgim',
		gD: 'Térkép segítségével megmutatja hazánk nagytájait, felismeri azok jellemző felszínformáit.',
		a: 3,
		gT: 1379,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['topográfiai ismeretek', 'környezetismeret', 'tájékozódás a térben'])
	},
		{
		cG: 'altgim',
		gD: 'Térkép segítségével megnevezi magyarország jellemző felszínformáit (síkság, hegy, hegység, domb, dombság), vizeit (patak, folyó, tó), ezeket terepasztalon vagy saját készítésű modellen előállítja.',
		a: 3,
		gT: 1378,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['topográfiai ismeretek', 'környezetismeret', 'tájékozódás a térben'])
	},
		{
		cG: 'altgim',
		gD: 'Térkép segítségével megnevezi hazánk szomszédos országait, megyéit, saját megyéjét, megyeszékhelyét, környezetének nagyobb településeit, hazánk fővárosát, és ezeket megtalálja a térképen is.',
		a: 3,
		gT: 1377,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['topográfiai ismeretek', 'környezetismeret', 'tájékozódás a térben'])
	},
		{
		cG: 'altgim',
		gD: 'Domborzati térképen felismeri a felszínformák és vizek jelölését.',
		a: 3,
		gT: 1376,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri lakóhelyének jellegzetes felszínformáit.',
		a: 3,
		gT: 1375,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a különböző domborzati formákat, felszíni vizeket, ismeri jellemzőiket, ezeket terepasztalon vagy saját készítésű modellen előállítja.',
		a: 3,
		gT: 1374,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik az iskola környékéről és településéről készített térképvázlattal és térképpel, az iskola környezetéről egyszerű térképvázlatot készít.',
		a: 3,
		gT: 1373,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A tanterméről, otthona valamely helyiségéről egyszerű alaprajzot készít és leolvas.',
		a: 3,
		gT: 1372,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja az alapvető térképjeleket: felszínformák, vizek, települések, útvonalak, államhatárok.',
		a: 3,
		gT: 1371,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönböztet néhány térképfajtát: domborzati, közigazgatási, turista, autós.',
		a: 3,
		gT: 1370,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Irányokat ad meg viszonyítással.',
		a: 3,
		gT: 1369,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi és iránytű segítségével megállapítja a fő- és mellékvilágtájakat.',
		a: 3,
		gT: 1368,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja az életkorának megfelelő térbeli relációs szókincset.',
		a: 3,
		gT: 1367,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'tájékozódás a térben', 'térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Analóg és digitális óráról leolvassa a pontos időt.',
		a: 3,
		gT: 1366,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Napirendet tervez és használ.',
		a: 3,
		gT: 1365,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Naptárt használ, időintervallumokat számol, adott eseményeket időrend szerint sorba rendez.',
		a: 3,
		gT: 1364,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Figyelemmel kísér rövidebb-hosszabb ideig tartó folyamatokat (például víz körforgása, emberi élet szakaszai, növények csírázása, növekedése).',
		a: 3,
		gT: 1363,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Az évszakokra vonatkozó megfigyeléseket végez, tapasztalatait rögzíti, és az adatokból következtetéseket von le.',
		a: 3,
		gT: 1362,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a napszakok, évszakok változásai, valamint a föld mozgásai közötti összefüggéseket.',
		a: 3,
		gT: 1361,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő sorrendben sorolja fel a napszakokat, a hét napjait, a hónapokat, az évszakokat, ismeri ezek időtartamát, relációit.',
		a: 3,
		gT: 1360,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelően eligazodik az időbeli relációkban, ismeri és használja az életkorának megfelelő időbeli relációs szókincset.',
		a: 3,
		gT: 1359,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['tájékozódás az időben', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'A feladatvégzés során társaival együttműködik.',
		a: 3,
		gT: 1358,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'A vizsgálatok tapasztalatait megfogalmazza, rajzban, írásban rögzíti.',
		a: 3,
		gT: 1357,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'Figyelemmel kísér rövidebb-hosszabb ideig tartó folyamatokat (például a természet változásai, időjárási elemek).',
		a: 3,
		gT: 1356,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'A kísérletek tapasztalatait a mindennapi életben alkalmazza.',
		a: 3,
		gT: 1355,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'Az adott kísérlethez választott eszközöket megfelelően használja.',
		a: 3,
		gT: 1354,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanító által felvetett problémákkal kapcsolatosan hipotézist fogalmaz meg, a vizsgálatok eredményét összeveti hipotézisével.',
		a: 3,
		gT: 1353,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'A kísérletezés elemi lépéseit annak algoritmusa szerint megvalósítja.',
		a: 3,
		gT: 1352,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanítói segítséggel egyszerű kísérleteket végez.',
		a: 3,
		gT: 1351,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'kísérletezés'])
	},
		{
		cG: 'altgim',
		gD: 'A méréseket és azok tapasztalatait a mindennapi életben alkalmazza.',
		a: 3,
		gT: 1350,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'A mérésekhez kapcsolódó ismereteit felidézi.',
		a: 3,
		gT: 1349,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'Az adott alkalmi vagy szabvány mérőeszközt megfelelően használja.',
		a: 3,
		gT: 1348,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'A méréshez megválasztja az alkalmi vagy szabvány mérőeszközt, mértékegységet.',
		a: 3,
		gT: 1347,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'Algoritmus szerint, előzetes viszonyítás, majd becslés után méréseket végez, becsült és mért eredményeit összehasonlítja.',
		a: 3,
		gT: 1346,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az élettelen anyagokon és az élőlényeken a mérhető tulajdonságokat.',
		a: 3,
		gT: 1345,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'mérés'])
	},
		{
		cG: 'altgim',
		gD: 'A megfigyelésekhez, összehasonlításokhoz és csoportosításokhoz kapcsolódó ismereteit felidézi.',
		a: 3,
		gT: 1344,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Figyelemmel kísér rövidebb-hosszabb ideig tartó folyamatokat (például olvadás, forrás, fagyás, párolgás, lecsapódás, égés, ütközés).',
		a: 3,
		gT: 1343,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseinek, összehasonlításainak és csoportosításainak tapasztalatait szóban, rajzban, írásban rögzíti, megfogalmazza.',
		a: 3,
		gT: 1342,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján képes élőlényeket összehasonlítani, csoportosítani.',
		a: 3,
		gT: 1341,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján képes élettelen anyagokat összehasonlítani, csoportosítani.',
		a: 3,
		gT: 1340,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja az élőlényeket és az élettelen anyagokat.',
		a: 3,
		gT: 1339,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az élőlényeken, élettelen dolgokon az érzékelhető tulajdonságokat.',
		a: 3,
		gT: 1338,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján algoritmus szerint élettelen anyagokon és élőlényeken megfigyeléseket végez.',
		a: 3,
		gT: 1337,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['környezetismeret', 'megismerési módszerek', 'megfigyelés, összehasonlítás, csoportosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveggel, táblázattal és jelekkel adott információkat értelmez.',
		a: 3,
		gT: 1336,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a helyi természet- és környezetvédelmi problémákat.',
		a: 3,
		gT: 1335,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Projektmunkában, csoportos tevékenységekben vesz részt.',
		a: 3,
		gT: 1334,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyelés, mérés és kísérletezés közben szerzett tapasztalatairól szóban, rajzban, írásban beszámol.',
		a: 3,
		gT: 1333,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei bővítéséhez nyomtatott és digitális forrásokat használ.',
		a: 3,
		gT: 1332,
		b: 4,
		e2: 'Környezetismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'környezetismeret'])
	},
		{
		cG: 'altgim',
		gD: 'A kommunikációs helyzetnek és a célnak megfelelően tudatosan alkalmazza a beszélt és írott nyelvet, reflektál saját és társai nyelvhasználatára.',
		a: 9,
		gT: 1697,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A feladatokat komplex szempontoknak megfelelően oldja meg, azokat kiegészíti saját szempontjaival.',
		a: 9,
		gT: 1696,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, a források tartalmát mérlegelő módon gondolja végig.',
		a: 9,
		gT: 1695,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Vitahelyzetben figyelembe veszi mások álláspontját, a lehetséges ellenérveket is.',
		a: 9,
		gT: 1694,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megnyilvánulásaiban, a vitákban alkalmazza az érvelés alapvető szabályait.',
		a: 9,
		gT: 1693,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A környező világ jelenségeiről, szövegekről, műalkotásokról véleményt alkot, és azt érvekkel támasztja alá.',
		a: 9,
		gT: 1692,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz irodalmi mű kreatív feldolgozásában, bemutatásában (pl. animáció, dramaturgia, átirat).',
		a: 9,
		gT: 1691,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Önismeretét irodalmi művek révén fejleszti.',
		a: 9,
		gT: 1690,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Választott olvasmányaira is vonatkoztatja a tanórán megismert kontextusteremtő eljárások tanulságait.',
		a: 9,
		gT: 1689,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Társai érdeklődését figyelembe véve ajánl olvasmányokat.',
		a: 9,
		gT: 1688,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Olvasmányai kiválasztásakor figyelembe veszi az alkotások kulturális regiszterét.',
		a: 9,
		gT: 1687,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan keresi a történeti és esztétikai értékekkel rendelkező olvasmányokat, műalkotásokat.',
		a: 9,
		gT: 1686,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'A kötelező olvasmányokat elolvassa, és saját örömére is olvas.',
		a: 9,
		gT: 1685,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott vagy önállóan kiválasztott szempontok alapján az irodalmi művekről elemző esszét ír.',
		a: 9,
		gT: 1684,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző, a munka világában is használt hivatalos szövegeket alkot hagyományos és digitális felületeken (pl. kérvény, beadvány, nyilatkozat, egyszerű szerződés, meghatalmazás, önéletrajz, motivációs levél).',
		a: 9,
		gT: 1683,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri, érti és etikusan alkalmazza a hagyományos, digitális és multimédiás szemléltetést.',
		a: 9,
		gT: 1682,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Érvelő esszét alkot megadott szempontok vagy szövegrészletek alapján.',
		a: 9,
		gT: 1681,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Az írásbeli szövegalkotáskor alkalmazza a tanult szerkesztési, stilisztikai ismereteket és a helyesírási szabályokat.',
		a: 9,
		gT: 1680,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult szövegtípusoknak megfelelő tartalommal és szerkezettel önállóan alkot különféle írásbeli szövegeket.',
		a: 9,
		gT: 1679,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Írásbeli és szóbeli nyelvhasználata, stílusa az adott kommunikációs helyzetnek megfelelő. írásképe tagolt, beszéde érthető, artikulált.',
		a: 9,
		gT: 1678,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a szóbeli előadásmód hatáskeltő eszközeit, hatékonyan alkalmazza azokat.',
		a: 9,
		gT: 1677,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Rendelkezik korának megfelelő retorikai ismeretekkel.',
		a: 9,
		gT: 1676,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes eltérő műfajú szóbeli szövegek alkotására: felelet, kiselőadás, hozzászólás, felszólalás.',
		a: 9,
		gT: 1675,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontrendszer alapján szóbeli feleletet készít.',
		a: 9,
		gT: 1674,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tanult tantárgyak, tudományágak szakszókincsét, azokat a beszédhelyzetnek megfelelően használja.',
		a: 9,
		gT: 1673,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan értelmezi az ismeretlen kifejezéseket a szövegkörnyezet vagy digitális, illetve nyomtatott segédeszközök használatával.',
		a: 9,
		gT: 1672,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik arra, hogy a különböző típusú, stílusú és regiszterű szövegekben megismert, számára új kifejezéseket beépítse szókincsébe, azokat adekvát módon használja.',
		a: 9,
		gT: 1671,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megtalálja a közös és eltérő jellemzőket a hagyományos és a digitális technikával előállított, tárolt szövegek között, és véleményt formál azok sajátosságairól.',
		a: 9,
		gT: 1670,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és értelmezi a szövegben a kétértelműséget és a félrevezető információt, valamint elemzi és értelmezi a szerző szándékát.',
		a: 9,
		gT: 1669,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatai megoldásához önálló kutatómunkát végez nyomtatott és digitális forrásokban, ezek eredményeit szintetizálja.',
		a: 9,
		gT: 1668,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Folyamatos és nem folyamatos, hagyományos és digitális szövegeket olvas és értelmez maga által választott releváns szempontok alapján.',
		a: 9,
		gT: 1667,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és értelmezésében figyelembe veszi a hallott és az írott szövegek közötti funkcionális és stiláris különbségeket.',
		a: 9,
		gT: 1666,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggő szóbeli szöveg (előadás, megbeszélés, vita) alapján önállóan vázlatot készít.',
		a: 9,
		gT: 1665,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző típusú és célú szövegeket hallás alapján értelmez és megfelelő stratégia alkalmazásával értékel és összehasonlít.',
		a: 9,
		gT: 1664,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Egymással összefüggésben értelmezi a szöveg tartalmi elemeit és a hozzá kapcsolódó illusztrációkat, ábrákat.',
		a: 9,
		gT: 1663,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a szöveg szerkezeti elemeit, és figyelembe veszi azok funkcióit a szöveg értelmezésekor.',
		a: 9,
		gT: 1662,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Hosszabb terjedelmű szöveg alapján többszintű vázlatot vagy részletes gondolattérképet készít.',
		a: 9,
		gT: 1661,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'A megismert szöveg tartalmi és nyelvi minőségéről érvekkel alátámasztott véleményt alkot.',
		a: 9,
		gT: 1660,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző olvasási típusokat és a szövegfeldolgozási stratégiákat a szöveg típusának és az olvasás céljának megfelelően választja ki és kapcsolja össze.',
		a: 9,
		gT: 1659,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző megjelenésű, típusú, műfajú, korú és összetettségű szövegeket olvas, értelmez.',
		a: 9,
		gT: 1658,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanulmányai során ismereteket szerez a kulturális intézmények (múzeum, könyvtár, színház) és a nyomtatott, illetve digitális formában megjelenő kulturális folyóiratok, adatbázisok működéséről.',
		a: 9,
		gT: 1657,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozottságot szerez régiója magyar irodalmáról.',
		a: 9,
		gT: 1656,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A mű értelmezésében összekapcsolja a szöveg poétikai tulajdonságait a mű nemzeti hagyományban betöltött szerepével.',
		a: 9,
		gT: 1655,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Szükség esetén a mű értelmezéséhez felhasználja történeti ismereteit.',
		a: 9,
		gT: 1654,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A tantárgyhoz kapcsolódó fogalmakkal bemutatja a lírai mű hangulati és hangnemi sajátosságait, hivatkozik a mű verstani felépítésére.',
		a: 9,
		gT: 1653,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A líra mű értelmezésében alkalmazza az általa tanult líraelméleti és líratörténeti fogalmakat (pl. lírai én, beszédhelyzetek, beszédmódok, ars poetica, szereplíra).',
		a: 9,
		gT: 1652,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A drámai mű értelmezésében alkalmazza az általa tanult drámaelméleti és drámatörténeti fogalmakat (pl. analitikus és abszurd dráma, epikus színház, elidegenedés).',
		a: 9,
		gT: 1651,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Epikai művekben értelmezi a különböző elbeszélésmódok szerepét (tudatábrázolás, egyenes és függő beszéd, mindentudó és korlátozott elbeszélő stb.).',
		a: 9,
		gT: 1650,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Epikai és drámai művekben rendszerbe foglalja a szereplők viszonyait, valamint összekapcsolja azok motivációját és cselekedeteit.',
		a: 9,
		gT: 1649,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Epikai és drámai művekben önállóan értelmezi a cselekményszálak, a szerkezet, az időszerkezet (lineáris, nem lineáris), a helyszínek és a jellemek összefüggéseit.',
		a: 9,
		gT: 1648,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít egy adott irodalmi művet annak adaptációival (film, festmény, zenemű, animáció, stb.), összehasonlításkor figyelembe veszi az adott művészeti ágak jellemző tulajdonságait.',
		a: 9,
		gT: 1647,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsol irodalmi műveket különböző szempontok alapján (motívumok, történelmi, erkölcsi kérdésfelvetések, művek és parafrázisaik).',
		a: 9,
		gT: 1646,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja az irodalmi művek szövegének lehetséges értelmezéseit azok társadalmi-történelmi szerepével, jelentőségével.',
		a: 9,
		gT: 1645,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Az irodalmi mű értelmezése során figyelembe veszi a mű keletkezéstörténeti hátterét, a műhöz kapcsolható filozófiai, eszmetörténeti szempontokat is.',
		a: 9,
		gT: 1644,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja az irodalmi művek szerkezeti felépítését, nyelvi sajátosságait azok tartalmával és értékszerkezetével.',
		a: 9,
		gT: 1643,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezésében felhasználja irodalmi és művészeti, történelmi, művelődéstörténeti ismereteit.',
		a: 9,
		gT: 1642,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti, elemzi az irodalmi mű jelentésszerkezetének szintjeit.',
		a: 9,
		gT: 1641,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és elkülöníti a műnemeket, illetve a műnemekhez tartozó műfajokat, megnevezi azok poétikai és retorikai jellemzőit.',
		a: 9,
		gT: 1640,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Elolvassa a kötelező olvasmányokat, és saját örömére is olvas.',
		a: 9,
		gT: 1639,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Etikusan és kritikusan használja a hagyományos, papír alapú, illetve a világhálón található és egyéb digitális adatbázisokat.',
		a: 9,
		gT: 1638,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tud helyesen írni, szükség esetén nyomtatott és digitális helyesírási segédleteket használ.',
		a: 9,
		gT: 1637,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar nyelv helyesírási, nyelvhelyességi szabályait.',
		a: 9,
		gT: 1636,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy nyelvünk a történelemben folyamatosan változik, ismeri a magyar nyelvtörténet nagy korszakait, kiemelkedő jelentőségű nyelvemlékeit.',
		a: 9,
		gT: 1635,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar nyelv eredetének hipotéziseit, és azok tudományosan megalapozott bizonyítékait.',
		a: 9,
		gT: 1634,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és érti a nyelvrokonság fogalmát, annak kritériumait.',
		a: 9,
		gT: 1633,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A retorikai ismereteit a gyakorlatban is alkalmazza.',
		a: 9,
		gT: 1632,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az általa tanult nyelvi, nyelvtani, helyesírási, nyelvhelyességi ismereteket.',
		a: 9,
		gT: 1631,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nyelvhasználatban előforduló különféle nyelvváltozatokat (nyelvjárások, csoportnyelvek, rétegnyelvek), összehasonlítja azok főbb jellemzőit.',
		a: 9,
		gT: 1630,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Szövegelemzéskor felismeri az alakzatokat és a szóképeket, értelmezi azok hatását, szerepét, megnevezi típusaikat.',
		a: 9,
		gT: 1629,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a stílus fogalmát, a stíluselemeket, a stílushatást, a stíluskorszakokat, stílusrétegeket, ismereteit a szöveg befogadása és alkotása során alkalmazza.',
		a: 9,
		gT: 1628,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alkalmazza a szövegösszetartó grammatikai és jelentésbeli elemeket, szövegépítése arányos és koherens.',
		a: 9,
		gT: 1627,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szöveg fogalmát, jellemzőit, szerkezeti sajátosságait, valamint a különféle szövegtípusokat és megjelenésmódokat.',
		a: 9,
		gT: 1626,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a magyar és a tanult idegen nyelv közötti hasonlóságokat és eltéréseket.',
		a: 9,
		gT: 1625,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar nyelv hangtanát, alaktanát, szófajtanát, mondattanát, ismeri és alkalmazza a tanult elemzési eljárásokat.',
		a: 9,
		gT: 1624,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az anyanyelvét, annak szerkezeti felépítését, nyelvhasználata tudatos és helyes.',
		a: 9,
		gT: 1623,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Reflektál saját kommunikációjára, szükség esetén változtat azon.',
		a: 9,
		gT: 1622,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és elemzi a tömegkommunikáció befolyásoló eszközeit, azok céljait és hatásait.',
		a: 9,
		gT: 1621,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a kommunikáció zavarait, kezelésükre stratégiát dolgoz ki.',
		a: 9,
		gT: 1620,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Az anyanyelvről szerzett ismereteit alkalmazva képes a kommunikációjában a megfelelő nyelvváltozat kiválasztására, használatára.',
		a: 9,
		gT: 1619,
		b: 12,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A feladatvégzés során hatékony közös munkára, együttműködésre törekszik.',
		a: 5,
		gT: 1618,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Személyes tapasztalatait összeköti a művekben megismert konfliktusokkal, érzelmi állapotokkal.',
		a: 5,
		gT: 1617,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti mások álláspontját, elfogadja azt, vagy a sajátja mellett érveket fogalmaz meg.',
		a: 5,
		gT: 1616,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Személyes véleményt alakít ki a szövegek és művek által felvetett problémákról (pl. döntési helyzetek, motivációk, konfliktusok), és véleményét indokolja.',
		a: 5,
		gT: 1615,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'mérlegelő gondolkodás, véleményalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza vagy társaival együttműködve drámajátékban megjeleníti egy mű megismerése során szerzett tapasztalatait, élményeit.',
		a: 5,
		gT: 1614,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult szövegeket szöveghűen és mások számára követhetően tolmácsolja.',
		a: 5,
		gT: 1613,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Egy általa elolvasott művet ajánl kortársainak.',
		a: 5,
		gT: 1612,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Érthetően, kifejezően és pontosan olvas.',
		a: 5,
		gT: 1611,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának megfelelő irodalmi szövegeket olvas.',
		a: 5,
		gT: 1610,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű rímes és rímtelen verset alkot.',
		a: 5,
		gT: 1609,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel kreatív szöveget alkot a megismert műhöz kapcsolódóan hagyományos és digitális formában.',
		a: 5,
		gT: 1608,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyéni sajátosságaihoz mérten tagolt, rendezett, áttekinthető írásképpel, egyértelmű javításokkal alkot szöveget.',
		a: 5,
		gT: 1607,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegalkotás során alkalmazza a tanult helyesírási és szerkesztési szabályokat, használja a hagyományos és a digitális helyesírási szabályzatot és szótárt.',
		a: 5,
		gT: 1606,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Az általa tanult hagyományos és digitális szövegtípusok megfelelő tartalmi és műfaji követelményeinek megfelelően alkot szövegeket.',
		a: 5,
		gT: 1605,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult szövegeket szöveghűen és mások számára követhetően tolmácsolja.',
		a: 5,
		gT: 1604,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Gondolatait, érzelmeit, véleményét a kommunikációs helyzetnek megfelelően, érvekkel alátámasztva fogalmazza meg, és mások véleményét is figyelembe veszi.',
		a: 5,
		gT: 1603,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Érthetően, a kommunikációs helyzetnek megfelelően beszél.',
		a: 5,
		gT: 1602,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanulási tevékenységében hagyományos és digitális forrásokat használ, ezt mérlegelő gondolkodással és etikusan teszi.',
		a: 5,
		gT: 1601,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának megfelelő szöveg alapján jegyzetet, vázlatot készít.',
		a: 5,
		gT: 1600,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Szóbeli vagy képi módszerekkel megfogalmazza, megjeleníti a szöveg alapján kialakult érzéseit, gondolatait.',
		a: 5,
		gT: 1599,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Az olvasott szövegeket szerkezeti egységekre tagolja.',
		a: 5,
		gT: 1598,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja ismereteit a szöveg tartalmával, és reflektál azok összefüggéseire.',
		a: 5,
		gT: 1597,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a különböző olvasási típusokat és szöveg-feldolgozási módszereket.',
		a: 5,
		gT: 1596,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz a jelentésszerkezetben a szó szerinti és metaforikus értelmezés között.',
		a: 5,
		gT: 1595,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'A pedagógus irányításával kiválasztja a rendelkezésre álló digitális forrásokból a megfelelő információkat.',
		a: 5,
		gT: 1594,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'A lábjegyzetek, a digitális és nyomtatott szótárak használatával önállóan értelmezi az olvasott szöveget.',
		a: 5,
		gT: 1593,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és szükség szerint a tanár segítségével értelmezi a szövegben számára ismeretlen kifejezéseket.',
		a: 5,
		gT: 1592,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejezően tudja olvasni és értelmezni az életkorának megfelelő különböző műfajú és megjelenésű szövegeket. a tanuló felismeri és a tanár segítségével értelmezi a számára ismeretlen kifejezéseket.',
		a: 5,
		gT: 1591,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az életkorának megfelelő hallott és olvasott szövegeket.',
		a: 5,
		gT: 1590,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés'])
	},
		{
		cG: 'altgim',
		gD: 'A nemzeti hagyomány szempontjából meghatározó néhány mű esetén bemutatja a szerzőhöz és a korszakhoz kapcsolódó legfőbb jellemzőket.',
		a: 5,
		gT: 1589,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Drámai műveket olvas és értelmez, előadásokat, feldolgozásokat megnéz (pl.: mesedráma, vígjáték, ifjúsági regény adaptációja).',
		a: 5,
		gT: 1588,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveghűen, értőn mondja el a memoriterként tanult lírai műveket.',
		a: 5,
		gT: 1587,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és felismer néhány alapvető lírai műfajt.',
		a: 5,
		gT: 1586,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a tanult alapvető rímképleteket (páros rím, keresztrím, bokorrím), és azonosítja az olvasott versek ritmikai, hangzásbeli hasonlóságait és különbségeit.',
		a: 5,
		gT: 1585,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a versben a lírai én különböző megszólalásait, és elkülöníti a mű szerkezeti egységeit.',
		a: 5,
		gT: 1584,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegből vett idézetekkel támasztja alá, és saját szavaival fogalmazza meg a lírai szöveg hangulati jellemzőit, a befogadás során keletkezett érzéseit és gondolatait.',
		a: 5,
		gT: 1583,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és a szövegből vett példával igazolja az elbeszélő és a szereplő nézőpontja közötti eltérést.',
		a: 5,
		gT: 1582,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Elkülöníti és jellemzi a fő- és mellékszereplőket, megkülönbözteti a helyszíneket, az idősíkokat, azonosítja az előre- és visszautalásokat.',
		a: 5,
		gT: 1581,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A megismert epikus művek cselekményét összefoglalja, fordulópontjait önállóan ismerteti.',
		a: 5,
		gT: 1580,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Az irodalmi szövegek befogadása során felismer és értelmez néhány alapvető nyelvi-stilisztikai eszközt: szóképek, alakzatok stb..',
		a: 5,
		gT: 1579,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, és bemutatja egy adott műfaj főbb jellemzőit.',
		a: 5,
		gT: 1578,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít egy adott irodalmi művet annak adaptációival (film, festmény, stb.).',
		a: 5,
		gT: 1577,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Elkülöníti az irodalmi művek főbb szerkezeti egységeit.',
		a: 5,
		gT: 1576,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsol irodalmi műveket különböző szempontok alapján (téma, műfaj, nyelvi kifejezőeszközök).',
		a: 5,
		gT: 1575,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és elkülöníti a műnemeket, illetve a műnemekhez tartozó főbb műfajokat, felismeri és megnevezi azok poétikai és retorikai jellemzőit.',
		a: 5,
		gT: 1574,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult fogalmakat használva beszámol a megismert műről.',
		a: 5,
		gT: 1573,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az irodalmi mű szövegszerű és elvont jelentéseit.',
		a: 5,
		gT: 1572,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Elolvassa a kötelező olvasmányokat, és saját örömére is olvas.',
		a: 5,
		gT: 1571,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A tanuló etikusan és kritikusan használja a hagyományos papíralapú, illetve a világhálón található és egyéb digitális adatbázisokat.',
		a: 5,
		gT: 1570,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Társai és saját munkájában a tanult formáktól eltérő, gyakran előforduló helyesírási hibákat felismeri és javítja.',
		a: 5,
		gT: 1569,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza helyesírásunk alapelveit: kiejtés, szóelemzés, hagyomány, egyszerűsítés.',
		a: 5,
		gT: 1568,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az általa tanult nyelvi, nyelvtani, helyesírási, nyelvhelyességi ismereteket.',
		a: 5,
		gT: 1567,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a kommunikáció főbb zavarait, alkalmaz korrekciós lehetőségeket.',
		a: 5,
		gT: 1566,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli és értelmezi a tömegkommunikáció társadalmat befolyásoló szerepét.',
		a: 5,
		gT: 1565,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a digitális kommunikáció eszközeit, megnevezi azok főbb jellemző tulajdonságait.',
		a: 5,
		gT: 1564,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a nyelvi és nem nyelvi kommunikáció elemeit.',
		a: 5,
		gT: 1563,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli, elkülöníti és funkciót társítva értelmezi a környezetében előforduló nyelvváltozatokat (nyelvjárások, csoportnyelvek, rétegnyelvek).',
		a: 5,
		gT: 1562,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári irányítással, néhány szempont alapján összehasonlítja az anyanyelv és a tanult idegen nyelv sajátosságait.',
		a: 5,
		gT: 1561,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a főbb szóalkotási módokat: szóösszetétel, szóképzés, néhány ritkább szóalkotási mód.',
		a: 5,
		gT: 1560,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és megnevezi a tanult nyelvi egységek szövegbeli szerepét.',
		a: 5,
		gT: 1559,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli és elemzi a mondat szórendjét, a szórendi változatok, valamint a környező szöveg kölcsönhatását.',
		a: 5,
		gT: 1558,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és elemzi a főbb szóelemek mondat- és szövegbeli szerepét, törekszik helyes alkalmazásukra.',
		a: 5,
		gT: 1557,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Szerkezetük alapján megkülönbözteti az egyszerű és összetett mondatokat.',
		a: 5,
		gT: 1556,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegben felismer és funkciójuk alapján azonosít alapvető és gyakori szószerkezeteket (alanyos, határozós, jelzős, tárgyas).',
		a: 5,
		gT: 1555,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Funkciójuk alapján felismeri és megnevezi a szóelemeket és szófajokat.',
		a: 5,
		gT: 1554,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar hangrendszer főbb jellemzőit és a hangok kapcsolódási szabályait. írásban helyesen jelöli.',
		a: 5,
		gT: 1553,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Elkülöníti a nyelv szerkezeti egységeit, megnevezi a tanult elemeket.',
		a: 5,
		gT: 1552,
		b: 8,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri saját lakóhelyének irodalmi és kulturális értékeit.',
		a: 1,
		gT: 1551,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kultúra helyszínei'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer a szűkebb környezetéhez kötődő irodalmi és kulturális emlékeket, emlékhelyeket.',
		a: 1,
		gT: 1550,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kultúra helyszínei'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz gyerekeknek szóló kiállítások megismerésében, alkotásaival hozzájárul létrehozásukhoz.',
		a: 1,
		gT: 1549,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kultúra helyszínei'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer gyermekirodalmi alkotás alapján készült filmet, médiaterméket.',
		a: 1,
		gT: 1548,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kultúra helyszínei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerkedik régi magyar mesterségekkel, irodalmi művek olvasásával és gyűjtőmunkával.',
		a: 1,
		gT: 1547,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a keresztény, keresztyén ünnepköröket (karácsony, húsvét, pünkösd), jelképeket, nemzeti és állami ünnepeket (március 15., augusztus 20., október 23.), népszokásokat (márton-nap, luca-nap, betlehemezés, húsvéti locsolkodás, pünkösdölés).',
		a: 1,
		gT: 1546,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a világ tapasztalati úton történő megismerésére, értékeinek tudatos megóvására.',
		a: 1,
		gT: 1545,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes családjából származó közösségi élményeit megfogalmazni, összevetni az iskolai élet adottságaival, a témakört érintő beszélgetésekben aktívan részt venni.',
		a: 1,
		gT: 1544,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitottá válik a magyarság értékeinek megismerésére, megalapozódik nemzeti identitástudata, történelmi szemlélete.',
		a: 1,
		gT: 1543,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli az ünnepek, hagyományok éves körforgását.',
		a: 1,
		gT: 1542,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer a jeles napokhoz, ünnepekhez kapcsolódó szövegeket, dalokat, szokásokat, népi gyermekjátékokat.',
		a: 1,
		gT: 1541,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Megéli és az általa választott formában megjeleníti a közösséghez tartozás élményét.',
		a: 1,
		gT: 1540,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Jellemző és ismert részletek alapján azonosítja a nemzeti ünnepeken elhangzó költemények részleteit, szerzőjüket megnevezi.',
		a: 1,
		gT: 1539,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'a kulturális emlékezethez és nemzeti hagyományhoz kapcsolódó szövegek'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz legalább két hosszabb terjedelmű magyar gyermekirodalmi alkotás feldolgozásában.',
		a: 1,
		gT: 1538,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult verseket, mondókákat, rövidebb szövegeket szöveghűen, érthetően tolmácsolja.',
		a: 1,
		gT: 1537,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'Segítséggel, majd önállóan szöveghűen felidéz néhány könnyen tanulható, rövidebb verset, mondókát, versrészletet, prózai és dramatikus szöveget, szövegrészletet.',
		a: 1,
		gT: 1536,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'Élményt és tapasztalatot szerez különböző ritmikájú lírai művek megismerésével a kortárs és a klasszikus magyar gyermeklírából és a népköltészeti alkotásokból.',
		a: 1,
		gT: 1535,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer néhány klasszikus verset a magyar irodalomból.',
		a: 1,
		gT: 1534,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'Megismer néhány mesét és történetet a magyar és más népek irodalmából.',
		a: 1,
		gT: 1533,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'alkotók, művek a gyermekirodalomból'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz rövid mesék, történetek dramatikus, bábos és egyéb vizuális, digitális eszközökkel történő megjelenítésében, saját gondolkodási és nyelvi szintjén megfogalmazza a szöveg hatására benne kialakult képet.',
		a: 1,
		gT: 1532,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Szövegszerűen felidézi kölcsey ferenc: himnusz, vörösmarty mihály: szózat, petőfi sándor: nemzeti dal című verseinek részleteit.',
		a: 1,
		gT: 1531,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, indokolja a cím és a szöveg közötti összefüggést, azonosítja a történetekben, elbeszélő költeményekben a helyszínt, a szereplőket, a konfliktust és annak megoldását.',
		a: 1,
		gT: 1530,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'A tanító vagy társai segítségével, együttműködésével verssorokat, versrészleteket memorizál.',
		a: 1,
		gT: 1529,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'A versek hangulatát kifejezi különféle érzékszervi tapasztalatok segítségével (színek, hangok, illatok, tapintási élmények stb.).',
		a: 1,
		gT: 1528,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékeli és átéli a vers ritmusát és hangulatát.',
		a: 1,
		gT: 1527,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Megtapasztalja a vershallgatás, a versmondás, a versolvasás örömét és élményét.',
		a: 1,
		gT: 1526,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Olvas és megért rövidebb nép- és műköltészeti alkotásokat, rövidebb epikai műveket, verseket.',
		a: 1,
		gT: 1525,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Segítséggel vagy önállóan előad ritmuskísérettel verseket.',
		a: 1,
		gT: 1524,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz ismert szövegek (magyar népi mondókák, kiszámolók, nyelvtörők, népdalok, klasszikus és kortárs magyar gyerekversek, mesék) mozgásos-játékos feldolgozásában, dramatikus elemekkel történő élményszerű megjelenítésében, érzületileg, lelkületileg átérzi azokat.',
		a: 1,
		gT: 1523,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a költői nyelv sajátosságait; élményeit az általa választott módon megfogalmazza, megjeleníti.',
		a: 1,
		gT: 1522,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Megtapasztalja az életkorának, érdeklődésének megfelelő szövegek befogadásának és előadásának élményét és örömét.',
		a: 1,
		gT: 1521,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'A közös olvasás, szövegfeldolgozás során megismer néhány életkorának megfelelő mesét, elbeszélést.',
		a: 1,
		gT: 1520,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz különböző műfajú és megjelenésű szövegek olvasásában és feldolgozásában.',
		a: 1,
		gT: 1519,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Élményeket és tapasztalatokat szerez néhány szövegtípusról és műfajról, szépirodalmi és ismeretközlő szövegről.',
		a: 1,
		gT: 1518,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Élményeket és tapasztalatokat szerez változatos irodalmi szövegtípusok és műfajok -- magyar klasszikus, kortárs magyar alkotások -- megismerésével.',
		a: 1,
		gT: 1517,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'irodalmi kultúra, irodalmi ismeretek', 'az irodalmi nyelv sajátosságai, irodalmi műfajok'])
	},
		{
		cG: 'altgim',
		gD: 'Különféle módokon megjeleníti az ismert szólások, közmondások jelentését.',
		a: 1,
		gT: 1516,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'állandósult szókapcsolatok, szólások, közmondások'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és használja az ismert állandósult szókapcsolatokat.',
		a: 1,
		gT: 1515,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'állandósult szókapcsolatok, szólások, közmondások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és ért számos egyszerű közmondást és szólást, szóláshasonlatot, közmondást, találós kérdést, nyelvtörőt, kiszámolót, mondókát.',
		a: 1,
		gT: 1514,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'állandósult szókapcsolatok, szólások, közmondások'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a múltban, jelenben és jövőben zajló cselekvéseket, történéseket.',
		a: 1,
		gT: 1513,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, önállóan vagy segítséggel helyesen leírja az ismert cselekvést kifejező szavakat.',
		a: 1,
		gT: 1512,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és önállóan vagy segítséggel helyesen leírja a tulajdonságot kifejező szavakat és azok fokozott alakjait.',
		a: 1,
		gT: 1511,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a szavak egyes és többes számát.',
		a: 1,
		gT: 1510,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ellentétes jelentésű és rokon értelmű kifejezéseket gyűjt, azokat a beszédhelyzetnek megfelelően használja az írásbeli és szóbeli szövegalkotásban.',
		a: 1,
		gT: 1509,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'A kiejtéstől eltérő ismert szavakat megfigyelés, szóelemzés alkalmazásával megfelelően leírja.',
		a: 1,
		gT: 1508,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'A kiejtéssel megegyező rövid szavak leírásában követi a helyesírás szabályait.',
		a: 1,
		gT: 1507,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen alkalmazza a szóbeli és írásbeli szövegalkotásában az idő kifejezésének nyelvi eszközeit.',
		a: 1,
		gT: 1506,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Biztosan szótagol, alkalmazza az elválasztás szabályait.',
		a: 1,
		gT: 1505,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan felismeri és elkülöníti az egytövű ismert szavakban a szótövet és a toldalékot.',
		a: 1,
		gT: 1504,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdésre adott válaszában helyesen toldalékolja a szavakat.',
		a: 1,
		gT: 1503,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'a nyelvi, nyelvtani egységek, nyelvi elemzőkészség'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a tanult helyesírási ismeretek alkalmazására.',
		a: 1,
		gT: 1502,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'A személyneveket, állatneveket és a lakóhelyhez kötődő helyneveket nagy kezdőbetűvel írja le.',
		a: 1,
		gT: 1501,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'A több hasonló élőlény, tárgy nevét kis kezdőbetűvel írja.',
		a: 1,
		gT: 1500,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, jelentésük alapján csoportosítja, és önállóan vagy segítséggel helyesen leírja az élőlények, tárgyak, gondolati dolgok nevét.',
		a: 1,
		gT: 1499,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Biztosan ismeri a kis- és nagybetűs ábécét, azonos és különböző betűkkel kezdődő szavakat betűrendbe sorol; a megismert szabályokat alkalmazza digitális felületen való kereséskor is.',
		a: 1,
		gT: 1498,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'A mondatot nagybetűvel kezdi, alkalmazza a mondat hanglejtésének, a beszélő szándékának megfelelő mondatvégi írásjeleket.',
		a: 1,
		gT: 1497,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'A hangjelölés megismert szabályait jellemzően helyesen alkalmazza a tanult szavakban.',
		a: 1,
		gT: 1496,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz az egyjegyű, a kétjegyű és a háromjegyű betűk között.',
		a: 1,
		gT: 1495,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli, és tapasztalati úton megkülönbözteti egymástól a magánhangzókat és a mássalhangzókat, valamint időtartamukat.',
		a: 1,
		gT: 1494,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'anyanyelvi kultúra, anyanyelvi ismeretek', 'hangtani, alaktani és helyesírási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Írásbeli munkáját segítséggel vagy önállóan ellenőrzi és javítja.',
		a: 1,
		gT: 1493,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Bővíti a témáról szerzett ismereteit egyéb források feltárásával, gyűjtőmunkával, könyvtárhasználattal, filmek, médiatermékek megismerésével.',
		a: 1,
		gT: 1492,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Információkat, adatokat gyűjt a szövegből, kiemeli a bekezdések lényegét; tanítói segítséggel vagy önállóan megfogalmazza azt.',
		a: 1,
		gT: 1491,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorolja az ismeretfeldolgozás egyszerű technikáit.',
		a: 1,
		gT: 1490,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és alkalmaz néhány alapvető tanulási technikát.',
		a: 1,
		gT: 1489,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Képzeletét a megértés érdekében mozgósítja.',
		a: 1,
		gT: 1488,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'A feladatvégzéshez szükséges személyes élményeit, előzetes tudását felidézi.',
		a: 1,
		gT: 1487,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'önálló feladatvégzés'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz dramatikus játékokban.',
		a: 1,
		gT: 1486,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'kulturált véleménynyilvánítás, vitakultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli és összehasonlítja a történetek tartalmát és a saját élethelyzetét.',
		a: 1,
		gT: 1485,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'kulturált véleménynyilvánítás, vitakultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz mesés és valószerű történetek között.',
		a: 1,
		gT: 1484,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'kulturált véleménynyilvánítás, vitakultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza, néhány érvvel alátámasztja saját álláspontját; meghallgatja társai véleményét.',
		a: 1,
		gT: 1483,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'kulturált véleménynyilvánítás, vitakultúra'])
	},
		{
		cG: 'altgim',
		gD: 'A mesék, történetek szereplőinek cselekedeteiről kérdéseket fogalmaz meg, véleményt alkot.',
		a: 1,
		gT: 1482,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'gondolkodás, véleményalkotás', 'kulturált véleménynyilvánítás, vitakultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és használ az életkorának megfelelő nyomtatott és digitális forrásokat az ismeretei bővítéséhez, rendszerezéséhez.',
		a: 1,
		gT: 1481,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'hagyományos és digitális szövegek olvasása'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző célú, rövidebb tájékoztató, ismeretterjesztő szövegeket olvas hagyományos és digitális felületen.',
		a: 1,
		gT: 1480,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'hagyományos és digitális szövegek olvasása'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz népmesék és műmesék közös olvasásában, feldolgozásában.',
		a: 1,
		gT: 1479,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Verbális és vizuális módon vagy dramatikus eszközökkel reflektál a szövegre, megfogalmazza a szöveg alapján benne kialakult képet.',
		a: 1,
		gT: 1478,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz az adott közösség kultúrájának megfelelő gyermekirodalmi mű közös olvasásában, és nyitott annak befogadására.',
		a: 1,
		gT: 1477,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Ajánlással, illetve egyéni érdeklődésének és az életkori sajátosságainak megfelelően választott irodalmi alkotást ismer meg.',
		a: 1,
		gT: 1476,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Könyvet kölcsönöz a könyvtárból, és azt el is olvassa, élményeit, gondolatait megosztja.',
		a: 1,
		gT: 1475,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott az irodalmi művek befogadására.',
		a: 1,
		gT: 1474,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'olvasóvá nevelés', 'irodalmi alkotások befogadása'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető hagyományos és digitális kapcsolattartó formákat alkalmaz.',
		a: 1,
		gT: 1473,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'kreatív és digitális szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A megismert irodalmi szövegekhez, iskolai eseményekhez plakátot, meghívót, saját programjaihoz meghívót készít hagyományosan és digitálisan.',
		a: 1,
		gT: 1472,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'kreatív és digitális szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján rövid mesét ír, kiegészít vagy átalakít.',
		a: 1,
		gT: 1471,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'kreatív és digitális szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Tanítói segítséggel megadott rímpárokból, különböző témákban 2--4 soros verset alkot.',
		a: 1,
		gT: 1470,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'kreatív és digitális szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegalkotáskor törekszik a megismert helyesírási szabályok alkalmazására, meglévő szókincsének aktivizálására.',
		a: 1,
		gT: 1469,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'írásbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Gondolatait, érzelmeit, véleményét a kommunikációs helyzetnek megfelelően, néhány mondatban írásban is megfogalmazza.',
		a: 1,
		gT: 1468,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'írásbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Egyéni képességeinek megfelelően alkot szövegeket írásban.',
		a: 1,
		gT: 1467,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'írásbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A hallás és olvasás alapján megfigyelt szavakat, szószerkezeteket, mondatokat önállóan leírja.',
		a: 1,
		gT: 1466,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'írásbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult verseket, mondókákat, rövidebb szövegeket szöveghűen, érthetően tolmácsolja.',
		a: 1,
		gT: 1465,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Bekapcsolódik párbeszédek, dramatikus helyzetgyakorlatok, szituációs játékok megalkotásába.',
		a: 1,
		gT: 1464,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján szóban mondatokat és 3-4 mondatos szöveget alkot.',
		a: 1,
		gT: 1463,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Élményeiről segítséggel vagy önállóan beszámol.',
		a: 1,
		gT: 1462,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a kapcsolat-felvételi, kapcsolattartási, kapcsolatlezárási formákat: köszönés, kérés, megszólítás, kérdezés; testtartás, testtávolság, tekintettartás, hangsúly, hanglejtés, hangerő, hangszín, megköszönés, elköszönés.',
		a: 1,
		gT: 1461,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz a kortársakkal és felnőttekkel való kommunikációban, beszélgetésben, vitában, és alkalmazza a megismert kommunikációs szabályokat.',
		a: 1,
		gT: 1460,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Adottságaihoz mérten, életkorának megfelelően érthetően, az élethelyzethez igazodva kommunikál.',
		a: 1,
		gT: 1459,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'szóbeli szövegalkotás'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyéni sajátosságaihoz mérten olvashatóan ír, törekszik a rendezett írásképre, esztétikus füzetvezetésre.',
		a: 1,
		gT: 1458,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'íráskészséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Szavakat, szószerkezeteket, 3-4 szavas mondatokat leír megfigyelés, illetve diktálás alapján.',
		a: 1,
		gT: 1457,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'íráskészséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Saját tempójában elsajátítja az anyanyelvi írás jelrendszerét.',
		a: 1,
		gT: 1456,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'íráskészséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Tér- és síkbeli tájékozódást fejlesztő feladatokat megold.',
		a: 1,
		gT: 1455,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'íráskészséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz nagymozgást és finommotorikát fejlesztő tevékenységekben, érzékelő játékokban.',
		a: 1,
		gT: 1454,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegalkotás', 'íráskészséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az életkorának megfelelő nyelvi és nem nyelvi üzeneteket, és azokra a kommunikációs helyzetnek megfelelően reflektál.',
		a: 1,
		gT: 1453,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'hallás utáni megértés'])
	},
		{
		cG: 'altgim',
		gD: 'Mozgósítja a hallott szöveg tartalmával kapcsolatos ismereteit, élményeit, tapasztalatait, és összekapcsolja azokat.',
		a: 1,
		gT: 1452,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'hallás utáni megértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a szóbeli utasításokat, kérdéseket, az adottságainak és életkorának megfelelő szöveg tartalmát.',
		a: 1,
		gT: 1451,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'hallás utáni megértés'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű, játékos formában megismerkedik a szövegek különböző modalitásával, médiumok szövegalkotó sajátosságainak alapjaival.',
		a: 1,
		gT: 1450,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Az olvasott szövegekben kulcsszavakat azonosít, a főbb szerkezeti egységeket önállóan vagy segítséggel elkülöníti.',
		a: 1,
		gT: 1449,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Az olvasott szöveghez illusztrációt készít, a hiányos illusztrációt kiegészíti, vagy a meglévőt társítja a szöveggel.',
		a: 1,
		gT: 1448,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmaz alapvető olvasási stratégiákat.',
		a: 1,
		gT: 1447,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan, képek vagy tanítói segítség alapján a szöveg terjedelmétől függően kiemeli annak lényeges elemeit, összefoglalja azt.',
		a: 1,
		gT: 1446,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'A szöveg megértését igazoló feladatokat végez.',
		a: 1,
		gT: 1445,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Felkészülés után tagolt szöveget érthetően olvas hangosan.',
		a: 1,
		gT: 1444,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Értő figyelemmel követi a tanító, illetve társai felolvasását.',
		a: 1,
		gT: 1443,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan, képek, grafikai szervezők (kerettörténet, történettérkép, mesetáblázat, karakter-térkép, történetpiramis stb.) segítségével vagy tanítói segédlettel a szöveg terjedelmétől függően összefoglalja a történetet.',
		a: 1,
		gT: 1442,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a közösen olvasott rövid szövegeket, részt vesz azok olvasásában, feldolgozásában.',
		a: 1,
		gT: 1441,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Néma olvasás útján megérti az írott utasításokat, közléseket, kérdéseket, azokra adekvát módon reflektál.',
		a: 1,
		gT: 1440,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid meséket közösen olvas, megért, feldolgoz.',
		a: 1,
		gT: 1439,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz népmesék és műmesék, regék, mondák, történetek közös olvasásában és feldolgozásában.',
		a: 1,
		gT: 1438,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Adottságaihoz mérten, életkorának megfelelően szöveget hangos vagy néma olvasás útján megért.',
		a: 1,
		gT: 1437,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szövegértés, olvasási stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Használ életkorának megfelelő digitális és hagyományos szótárakat.',
		a: 1,
		gT: 1436,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szókincsfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A megismert szavakat, kifejezéseket a nyelvi fejlettségi szintjén alkalmazza.',
		a: 1,
		gT: 1435,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szókincsfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű magyarázat, szemléltetés (szóbeli, képi, dramatikus tevékenység) alapján megérti az új kifejezés jelentését.',
		a: 1,
		gT: 1434,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szókincsfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, értelmezi a szövegben a számára ismeretlen szavakat, kifejezéseket; digitális forrásokat is használ.',
		a: 1,
		gT: 1433,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'szókincsfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Biztosan ismeri az olvasás jelrendszerét.',
		a: 1,
		gT: 1432,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Hangokból, szótagokból szavakat épít.',
		a: 1,
		gT: 1431,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'A szavakat hangokra, szótagokra bontja.',
		a: 1,
		gT: 1430,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Beszédlégzése és artikulációja megfelelő; figyelmet fordít a hangok időtartamának helyes ejtésére, a beszéd helyes ritmusára, hangsúlyára, tempójára, az élethelyzetnek megfelelő hangerőválasztásra.',
		a: 1,
		gT: 1429,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Észleli, illetve megérti a nyelv alkotóelemeit, hangot, betűt, szótagot, szót, mondatot, szöveget, és azokra válaszokat fogalmaz meg.',
		a: 1,
		gT: 1428,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és használja a tér- és időbeli tájékozódáshoz szükséges szókincset.',
		a: 1,
		gT: 1427,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz a testséma-tudatosságot fejlesztő tevékenységekben (szem-kéz koordináció, térérzékelés, irányok, arányok, jobb-bal oldal összehangolása, testrészek tudatosítása) és érzékelő játékokban.',
		a: 1,
		gT: 1426,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['magyar nyelv és irodalom', 'szövegértés', 'olvasási készséget megalapozó képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Élményeket és tapasztalatokat szerez változatos irodalmi szövegek megismerésével, olvasásával.',
		a: 1,
		gT: 1425,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi, nyelvtani, helyesírási ismereteket képességeihez mérten alkalmazza.',
		a: 1,
		gT: 1424,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Egyéni sajátosságaihoz mérten törekszik a rendezett írásképre, esztétikus füzetvezetésre.',
		a: 1,
		gT: 1423,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza saját álláspontját, véleményét.',
		a: 1,
		gT: 1422,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődésének megfelelően, hagyományos és digitális szövegek által bővíti ismereteit.',
		a: 1,
		gT: 1421,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Segítséggel egyéni érdeklődésének megfelelő olvasmányt választ, amelyről beszámol.',
		a: 1,
		gT: 1420,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának és egyéni képességeinek megfelelően alkot szövegeket szóban és írásban.',
		a: 1,
		gT: 1419,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának megfelelően és adottságaihoz mérten kifejezően, érthetően, az élethelyzethez igazodva kommunikál.',
		a: 1,
		gT: 1418,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Felkészülés után tagolt szöveget érthetően és pontosan olvas hangosan.',
		a: 1,
		gT: 1417,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának és egyéni adottságainak megfelelő, hallott és olvasott szövegeket megérti.',
		a: 1,
		gT: 1416,
		b: 4,
		e2: 'Magyar nyelv és irodalom',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'magyar nyelv és irodalom'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik az érdeklődésének megfelelő akár autentikus szövegekkel elektronikus, digitális csatornákon tanórán kívül is.',
		a: 9,
		gT: 2269,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Egyénileg vagy társaival együttműködve szóban vagy írásban projektmunkát vagy kiselőadást készít, és ezeket digitális eszközök segítségével is meg tudja valósítani.',
		a: 9,
		gT: 2268,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'digitális eszközök és felületek használata idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Következetesen alkalmazza a célnyelvi betű és jelkészletet',
		a: 9,
		gT: 2267,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Idegen nyelvi kommunikációjában ismeri és használja a célnyelv főbb jellemzőit.',
		a: 9,
		gT: 2266,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'A célnyelvi kultúrákhoz kapcsolódó alapvető tanult nyelvi elemeket használja.',
		a: 9,
		gT: 2265,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrákhoz kapcsolódó nyelvi elemek'])
	},
		{
		cG: 'altgim',
		gD: 'Megismerkedik hazánk legfőbb országismereti és történelmi eseményeivel célnyelven.',
		a: 9,
		gT: 2264,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik a célnyelvi, életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel.',
		a: 9,
		gT: 2263,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'a hazai kultúra közvetítése célnyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik célnyelvi országismereti tartalmakkal.',
		a: 9,
		gT: 2262,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelvi kommunikációjába beépíti a tanult interkulturális ismereteket.',
		a: 9,
		gT: 2261,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'További országismereti tudásra tesz szert.',
		a: 9,
		gT: 2260,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a célnyelvi országok főbb jellemzőit és kulturális sajátosságait.',
		a: 9,
		gT: 2259,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interkulturalitás, országismeret', 'célnyelvi kultúrák'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez egyszerű, szórakoztató kisfilmeket',
		a: 9,
		gT: 2258,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközöket és felületeket is használ nyelvtudása fejlesztésére,',
		a: 9,
		gT: 2257,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'digitális nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet szórakozásra és játékos nyelvtanulásra.',
		a: 9,
		gT: 2256,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán kívüli, akár játékos nyelvtanulási lehetőségeket felismeri, és törekszik azokat kihasználni.',
		a: 9,
		gT: 2255,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'valós nyelvhasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Társai haladásának értékelésében segítően részt vesz.',
		a: 9,
		gT: 2254,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvi haladását többnyire fel tudja mérni,',
		a: 9,
		gT: 2253,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'haladás értékelése'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez társaival párban és csoportban együttműködik.',
		a: 9,
		gT: 2252,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Céljai eléréséhez megtalálja és használja a megfelelő eszközöket.',
		a: 9,
		gT: 2251,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Egy összetettebb nyelvi feladat, projekt végéig tartó célokat tűz ki magának.',
		a: 9,
		gT: 2250,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási célok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer szavakat, szókapcsolatokat a célnyelven a témakörre jellemző, életkorának és érdeklődésének megfelelő más tudásterületen megcélzott tartalmakból.',
		a: 9,
		gT: 2249,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Hibáit többnyire észreveszi és javítja.',
		a: 9,
		gT: 2248,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan használ alapszintű nyelvtanulási és nyelvhasználati stratégiákat.',
		a: 9,
		gT: 2247,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'önálló nyelvtanulás', 'nyelvtanulási és nyelvhasználati stratégiák'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerős és gyakori alapvető helyzetekben, akár telefonon vagy digitális csatornákon is, többnyire helyesen és érthetően fejezi ki magát az ismert nyelvi eszközök segítségével.',
		a: 9,
		gT: 2246,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megoszt alapvető személyes információkat és szükségleteket magáról egyszerű nyelvi elemekkel.',
		a: 9,
		gT: 2245,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Nem értés esetén a meg nem értett kulcsszavak vagy fordulatok ismétlését vagy magyarázatát kéri, visszakérdez, betűzést kér.',
		a: 9,
		gT: 2244,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmaz nyelvi funkciókat rövid társalgás megkezdéséhez, fenntartásához és befejezéséhez.',
		a: 9,
		gT: 2243,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretlen szavak valószínű jelentését szövegösszefüggések alapján kikövetkezteti az életkorának és érdeklődésének megfelelő, konkrét, rövid szövegekben.',
		a: 9,
		gT: 2242,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi eszközökkel és nonverbális elemek segítségével tisztázza mondanivalójának lényegét.',
		a: 9,
		gT: 2241,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű mondatokat összekapcsolva mond el egymást követő eseményekből álló történetet, vagy leírást ad valamilyen témáról.',
		a: 9,
		gT: 2240,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja az ismert nyelvi elemeket egyszerű kötőszavakkal (például: és, de, vagy).',
		a: 9,
		gT: 2239,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik életkorának és nyelvi szintjének megfelelő célnyelvi szórakoztató tartalmakkal.',
		a: 9,
		gT: 2238,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a célnyelvet életkorának és nyelvi szintjének megfelelő aktuális témákban és a hozzájuk tartozó szituációkban.',
		a: 9,
		gT: 2237,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet ismeretszerzésre.',
		a: 9,
		gT: 2236,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez és használja az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is,',
		a: 9,
		gT: 2235,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez és érvekkel alátámasztva mutat be szükségességet, lehetőséget, képességet, bizonyosságot, bizonytalanságot.',
		a: 9,
		gT: 2234,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez alapvető érzéseket, például örömöt, sajnálkozást, bánatot, elégedettséget, elégedetlenséget, bosszúságot, csodálkozást, reményt.',
		a: 9,
		gT: 2233,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez kérést, javaslatot, meghívást, kínálást és ezekre reagálást.',
		a: 9,
		gT: 2232,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Információt cserél, információt kér, információt ad.',
		a: 9,
		gT: 2231,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Kifejez tetszést, nem tetszést, akaratot, kívánságot, tudást és nem tudást, ígéretet, szándékot, dicséretet, kritikát.',
		a: 9,
		gT: 2230,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerűen megfogalmazza személyes véleményét, másoktól véleményük kifejtését kéri, és arra reagál, elismeri vagy cáfolja mások állítását, kifejezi egyetértését vagy egyet nem értését.',
		a: 9,
		gT: 2229,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'mindennapi idegennyelv-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány szóból vagy mondatból álló jegyzetet készít írott szöveg alapján.',
		a: 9,
		gT: 2228,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Találkozik az életkorának és nyelvi szintjének megfelelő célnyelvi ismeretterjesztő tartalmakkal.',
		a: 9,
		gT: 2227,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'írásbeli tudásmegosztás', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasználja a célnyelvet tudásmegosztásra.',
		a: 9,
		gT: 2226,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, egyszerű, ismert nyelvi eszközökből álló kiselőadást tart változatos feladatok kapcsán, hagyományos vagy digitális alapú vizuális eszközök támogatásával.',
		a: 9,
		gT: 2225,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['információközvetítés idegen nyelven', 'második idegen nyelv', 'szóbeli tudásmegosztás'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét írásban, egyszerű nyelvi eszközökkel megfogalmazza, és arról írásban interakciót folytat.',
		a: 9,
		gT: 2224,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Üzeneteket ír,',
		a: 9,
		gT: 2223,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'íráskészség: írásbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Bekapcsolódik a tanórán az interakciót igénylő nyelvi tevékenységekbe, abban társaival közösen részt vesz, a begyakorolt nyelvi elemeket tanári segítséggel a játék céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2222,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Váratlan, előre nem kiszámítható eseményekre, jelenségekre és történésekre is reagál egyszerű célnyelvi eszközökkel, személyes vagy online interakciókban.',
		a: 9,
		gT: 2221,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemeket többnyire megfelelően használja, beszédszándékainak megfelelően, egyszerű spontán helyzetekben.',
		a: 9,
		gT: 2220,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét, gondolatait, érzéseit egyre magabiztosabban fejezi ki a tanult nyelvi eszközökkel.',
		a: 9,
		gT: 2219,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának megfelelő mindennapi helyzetekben a tanult nyelvi eszközökkel megfogalmazott kérdéseket tesz fel, és válaszol a hozzá intézett kérdésekre.',
		a: 9,
		gT: 2218,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációt kezdeményez egyszerű hétköznapi témában, a beszélgetést követi, egyszerű, nyelvi eszközökkel fenntartja és lezárja.',
		a: 9,
		gT: 2217,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Megért és használ szavakat, szókapcsolatokat a célnyelvi, az életkorának és érdeklődésének megfelelő hazai és nemzetközi legfőbb hírekkel, eseményekkel kapcsolatban',
		a: 9,
		gT: 2216,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődése erősödik a célnyelvi irodalmi alkotások iránt.',
		a: 9,
		gT: 2215,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'A nyomtatott vagy digitális alapú írott szöveget felhasználja szórakozásra és ismeretszerzésre önállóan is.',
		a: 9,
		gT: 2214,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő írott, nyomtatott vagy digitális alapú szöveget a változatos nyelvórai tevékenységek és feladatmegoldás során.',
		a: 9,
		gT: 2213,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Összetettebb írott instrukciókat értelmez.',
		a: 9,
		gT: 2212,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a főbb, életkorának megfelelő írott szövegtípusokat.',
		a: 9,
		gT: 2211,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő szövegből, és azokat összekapcsolja más iskolai vagy iskolán kívül szerzett ismereteivel.',
		a: 9,
		gT: 2210,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó rövid írott szöveg tartalmát.',
		a: 9,
		gT: 2209,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának megfelelő szituációkhoz kapcsolódó, írott szövegekben megjelenő összetettebb információkat.',
		a: 9,
		gT: 2208,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Hallgat az érdeklődésének megfelelő autentikus szövegeket elektronikus, digitális csatornákon, tanórán kívül is, szórakozásra vagy ismeretszerzésre.',
		a: 9,
		gT: 2207,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a főbb, életkorának megfelelő hangzószöveg-típusokat.',
		a: 9,
		gT: 2206,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez életkorának megfelelő nyelvi helyzeteket hallott szöveg alapján.',
		a: 9,
		gT: 2205,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az életkorának és nyelvi szintjének megfelelő hangzó szöveget a változatos nyelvórai tevékenységek és a feladatmegoldás során.',
		a: 9,
		gT: 2204,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemel, kiszűr konkrét információkat a nyelvi szintjének megfelelő, élőszóban vagy digitális felületen elhangzó szövegből, és azokat összekapcsolja egyéb ismereteivel.',
		a: 9,
		gT: 2203,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nem kizárólag ismert nyelvi elemeket tartalmazó, élőszóban vagy digitális felületen elhangzó rövid szöveg tartalmát.',
		a: 9,
		gT: 2202,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának megfelelő, élőszóban vagy digitális felületen elhangzó szövegekben a beszélők gondolatmenetét.',
		a: 9,
		gT: 2201,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az életkorának és nyelvi szintjének megfelelő, egyszerű, hangzó szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2200,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a szintjének megfelelő, kevésbé ismert elemekből álló, nonverbális vagy vizuális eszközökkel támogatott célnyelvi óravezetést és utasításokat, kérdéseket.',
		a: 9,
		gT: 2199,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'A szövegek létrehozásához nyomtatott, illetve digitális alapú segédeszközt, szótárt használ.',
		a: 9,
		gT: 2198,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, összefüggő, papíralapú vagy ikt-eszközökkel segített írott projektmunkát készít önállóan vagy kooperatív munkaformákban.',
		a: 9,
		gT: 2197,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid szövegek írását igénylő kreatív munkát hoz létre önállóan.',
		a: 9,
		gT: 2196,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, egyszerű, összefüggő szövegeket ír a tanult nyelvi szerkezetek felhasználásával az ismert szövegtípusokban, az ajánlott tématartományokban.',
		a: 9,
		gT: 2195,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megold játékos és változatos írásbeli feladatokat rövid szövegek szintjén.',
		a: 9,
		gT: 2194,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Változatos, kognitív kihívást jelentő szóbeli feladatokat old meg önállóan vagy kooperatív munkaformában, a tanult nyelvi eszközökkel, szükség szerint tanári segítséggel, élőszóban és digitális felületen.',
		a: 9,
		gT: 2193,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Képet jellemez röviden, egyszerűen, ismert nyelvi fordulatok segítségével, segítő tanári kérdések alapján, önállóan.',
		a: 9,
		gT: 2192,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű nyelvi eszközökkel, felkészülést követően röviden, összefüggően beszél az ajánlott tématartományokhoz tartozó témákban, élőszóban és digitális felületen.',
		a: 9,
		gT: 2191,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Elmesél rövid történetet, egyszerűsített olvasmányt egyszerű nyelvi eszközökkel, önállóan, a cselekményt lineárisan összefűzve.',
		a: 9,
		gT: 2190,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Egyre magabiztosabban kapcsolódik be történetek kreatív alakításába, átfogalmazásába kooperatív munkaformában.',
		a: 9,
		gT: 2189,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan részt vesz az életkorának és érdeklődésének megfelelő gyermek-, illetve ifjúsági irodalmi alkotások közös előadásában.',
		a: 9,
		gT: 2188,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: összefüggő beszéd'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a nyelvtudás fontosságát, és motivációja a nyelvtanulásra tovább erősödik.',
		a: 9,
		gT: 2187,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a célnyelvi normához illeszkedő kiejtés, beszédtempó és intonáció megközelítésére.',
		a: 9,
		gT: 2186,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza nyelvtudását kommunikációra, közvetítésre, szórakozásra, ismeretszerzésre hagyományos és digitális csatornákon.',
		a: 9,
		gT: 2185,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Használ életkorának és nyelvi szintjének megfelelő hagyományos és digitális alapú nyelvtanulási forrásokat és eszközöket.',
		a: 9,
		gT: 2184,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvtudását egyre inkább képes fejleszteni tanórán kívüli helyzetekben is különböző eszközökkel és lehetőségekkel.',
		a: 9,
		gT: 2183,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációs szándékának megfelelően alkalmazza a tanult nyelvi funkciókat és a megszerzett szociolingvisztikai, pragmatikai és interkulturális jártasságát.',
		a: 9,
		gT: 2182,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult nyelvi elemek és kommunikációs stratégiák segítségével írásbeli és szóbeli interakciót folytat, valamint közvetít az élő idegen nyelven.',
		a: 9,
		gT: 2181,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmez korának és nyelvi szintjének megfelelő hallott és írott célnyelvi szövegeket az ismert témákban és szövegtípusokban.',
		a: 9,
		gT: 2180,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban létrehoz rövid szövegeket, ismert nyelvi eszközökkel, a korának megfelelő szövegtípusokban.',
		a: 9,
		gT: 2179,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban és írásban megold változatos kihívásokat igénylő feladatokat az élő idegen nyelven.',
		a: 9,
		gT: 2178,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Létrehoz nagyon egyszerű írott, pár szavas szöveget szóban vagy írásban digitális felületen.',
		a: 9,
		gT: 2177,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a tanult nyelvi elemeket életkorának megfelelő digitális tartalmakban, digitális csatornákon olvasott vagy hallott nagyon egyszerű szövegekben is.',
		a: 9,
		gT: 2176,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'digitális eszközök és felületek használata idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a főbb, célnyelvi kultúrához tartozó, ünnepekhez kapcsolódó alapszintű kifejezéseket, állandósult szókapcsolatokat és szokásokat.',
		a: 9,
		gT: 2175,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri a főbb, az adott célnyelvi kultúrákhoz tartozó országok nevét, földrajzi elhelyezkedését, főbb országismereti jellemzőit.',
		a: 9,
		gT: 2174,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'interkulturalitás, országismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető célzott információt megszerez a tanult témákban tudásának bővítésére.',
		a: 9,
		gT: 2173,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Felhasznál és létrehoz rövid, nagyon egyszerű célnyelvi szövegeket szabadidős tevékenységek során.',
		a: 9,
		gT: 2172,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az idegen nyelvű írott, olvasott és hallott tartalmakat a tanórán kívül is.',
		a: 9,
		gT: 2171,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Egy feladat megoldásának sikerességét segítséggel értékelni tudja.',
		a: 9,
		gT: 2170,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A célok eléréséhez társaival rövid feladatokban együttműködik.',
		a: 9,
		gT: 2169,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Szavak, kifejezések tanulásakor felismeri, ha új elemmel találkozik és rákérdez, vagy megfelelő tanulási stratégiával törekszik a megértésre.',
		a: 9,
		gT: 2168,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Új szavak, kifejezések tanulásakor ráismer a már korábban tanult szavakra, kifejezésekre.',
		a: 9,
		gT: 2167,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'önálló nyelvtanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Közöl alapvető személyes információkat magáról, egyszerű nyelvi elemek segítségével.',
		a: 9,
		gT: 2166,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a nem értés, visszakérdezés és ismétlés, kérés kifejezésére használt mindennapi nyelvi funkciókat életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2165,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a tudás és nem tudás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2164,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, a köszönet és az arra történő reagálás kifejezésére használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2163,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, megszólításra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2162,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, bemutatkozásra használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2161,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és alkalmazza a legegyszerűbb, üdvözlésre és elköszönésre használt mindennapi nyelvi funkciókat az életkorának és nyelvi szintjének megfelelő, egyszerű helyzetekben.',
		a: 9,
		gT: 2160,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'mindennapi idegennyelv-használat', 'interakció idegen nyelven'])
	},
		{
		cG: 'altgim',
		gD: 'Elsajátítja a tanult szavak és állandósult szókapcsolatok célnyelvi normához közelítő kiejtését tanári minta követése által, vagy autentikus hangzó anyag, digitális technológia segítségével.',
		a: 9,
		gT: 2159,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Érzéseit egy-két szóval vagy begyakorolt állandósult nyelvi fordulatok segítségével kifejezi, főként rákérdezés alapján, nonverbális eszközökkel kísérve a célnyelvi megnyilatkozást.',
		a: 9,
		gT: 2158,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán bekapcsolódik a már ismert, szóbeli interakciót igénylő nyelvi tevékenységekbe, a begyakorolt nyelvi elemeket tanári segítséggel a tevékenység céljainak megfelelően alkalmazza.',
		a: 9,
		gT: 2157,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid, néhány mondatból álló párbeszédet folytat, felkészülést követően.',
		a: 9,
		gT: 2156,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik arra, hogy a célnyelvet eszközként alkalmazza információszerzésre.',
		a: 9,
		gT: 2155,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'A tanórán begyakorolt, nagyon egyszerű, egyértelmű kommunikációs helyzetekben a megtanult, állandósult beszédfordulatok alkalmazásával kérdez vagy reagál, mondanivalóját segítséggel vagy nonverbális eszközökkel kifejezi.',
		a: 9,
		gT: 2154,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'interakció idegen nyelven', 'beszédkészség: szóbeli interakció'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan bekapcsolódik a közös meseolvasásba, a mese tartalmát követi.',
		a: 9,
		gT: 2153,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megtapasztalja a közös célnyelvi olvasás élményét.',
		a: 9,
		gT: 2152,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő írott szövegre az órai játékos alkotó, mozgásos vagy nyelvi fejlesztő tevékenységek során, kooperatív munkaformákban.',
		a: 9,
		gT: 2151,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemeli az ismert nyelvi elemeket tartalmazó, egyszerű, írott, pár mondatos szöveg fő mondanivalóját.',
		a: 9,
		gT: 2150,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a nyelvi szintjének megfelelő, akár vizuális eszközökkel is támogatott írott utasításokat és kérdéseket, és ezekre megfelelő válaszreakciókat ad.',
		a: 9,
		gT: 2149,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Csendes olvasás keretében feldolgozva megért ismert szavakat tartalmazó, pár szóból vagy mondatból álló, akár illusztrációval támogatott szöveget.',
		a: 9,
		gT: 2148,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosítja a célzott információt az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű, a nyelvtanításhoz készült, illetve eredeti szövegben.',
		a: 9,
		gT: 2147,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti az anyanyelvi és a célnyelvi írott szövegben a betű- és jelkészlet közti különbségeket.',
		a: 9,
		gT: 2146,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'olvasásértés'])
	},
		{
		cG: 'altgim',
		gD: 'Figyel a célnyelvre jellemző hangok kiejtésére.',
		a: 9,
		gT: 2145,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelve és a célnyelv közötti legalapvetőbb kiejtésbeli különbségeket.',
		a: 9,
		gT: 2144,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi azokat az idegen nyelven szóban elhangzó nyelvórai szituációkat, melyeket anyanyelvén már ismer.',
		a: 9,
		gT: 2143,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelv és az idegen nyelv hangkészletét.',
		a: 9,
		gT: 2142,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Támaszkodik az életkorának és nyelvi szintjének megfelelő hangzó szövegre az órai alkotó jellegű nyelvi, mozgásos nyelvi és játékos nyelvi tevékenységek során.',
		a: 9,
		gT: 2141,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a célzott információt a nyelvi szintjének és életkorának megfelelő rövid hangzó szövegben.',
		a: 9,
		gT: 2140,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszűri a lényeget az ismert nyelvi elemeket tartalmazó, nagyon rövid, egyszerű hangzó szövegből.',
		a: 9,
		gT: 2139,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Beazonosítja az életkorának megfelelő szituációkhoz kapcsolódó, rövid, egyszerű szövegben a tanult nyelvi elemeket.',
		a: 9,
		gT: 2138,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az élőszóban elhangzó, ismert témákhoz kapcsolódó, verbális, vizuális vagy nonverbális eszközökkel segített rövid kijelentéseket, kérdéseket.',
		a: 9,
		gT: 2137,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegértés idegen nyelven', 'beszédértés'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban megnevezi az ajánlott tématartományokban megjelölt, begyakorolt elemeket.',
		a: 9,
		gT: 2136,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz kooperatív munkaformában végzett kreatív tevékenységekben, projektmunkában szavak, szószerkezetek, rövid mondatok leírásával, esetleg képi kiegészítéssel.',
		a: 9,
		gT: 2135,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Megold játékos írásbeli feladatokat a szavak, szószerkezetek, rövid mondatok szintjén.',
		a: 9,
		gT: 2134,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Lemásol tanult szavakat játékos, alkotó nyelvórai tevékenységek során.',
		a: 9,
		gT: 2133,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az adott nyelv ábécéjét.',
		a: 9,
		gT: 2132,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az anyanyelvén, illetve a tanult idegen nyelven történő írásmód és betűkészlet közötti különbségeket.',
		a: 9,
		gT: 2131,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'íráskészség'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelven megoszt egyedül vagy társaival együttműködésben megszerzett, alapvető információkat szóban, akár vizuális elemekkel támogatva.',
		a: 9,
		gT: 2130,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Lebetűzi a tanult szavakat társaival közösen játékos tevékenységek kapcsán, szükség esetén segítséggel.',
		a: 9,
		gT: 2129,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Lebetűzi a nevét.',
		a: 9,
		gT: 2128,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Megismétli az élőszóban elhangzó egyszerű szavakat, kifejezéseket játékos, mozgást igénylő, kreatív nyelvórai tevékenységek során.',
		a: 9,
		gT: 2127,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['második idegen nyelv', 'szövegalkotás idegen nyelven', 'beszédkészség: szóbeliség'])
	},
		{
		cG: 'altgim',
		gD: 'Célnyelvi tanulmányain keresztül nyitottabbá, a világ felé érdeklődőbbé válik.',
		a: 9,
		gT: 2126,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a tanult nyelvi elemek megfelelő kiejtésére.',
		a: 9,
		gT: 2125,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az adott célnyelvi kultúrákhoz tartozó országok fontosabb jellemzőit és a hozzájuk tartozó alapvető nyelvi elemeket.',
		a: 9,
		gT: 2124,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Elmondja magáról a legalapvetőbb információkat.',
		a: 9,
		gT: 2123,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a legegyszerűbb, mindennapi nyelvi funkciókat.',
		a: 9,
		gT: 2122,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Követi a szintjének megfelelő, vizuális vagy nonverbális eszközökkel támogatott, ismert célnyelvi óravezetést, utasításokat.',
		a: 9,
		gT: 2121,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Lemásol, leír szavakat és rövid, nagyon egyszerű szövegeket.',
		a: 9,
		gT: 2120,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Szóban visszaad szavakat, esetleg rövid, nagyon egyszerű szövegeket hoz létre.',
		a: 9,
		gT: 2119,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Bekapcsolódik a szóbeliséget, írást, szövegértést vagy interakciót igénylő alapvető és korának megfelelő játékos, élményalapú élő idegen nyelvi tevékenységekbe.',
		a: 9,
		gT: 2118,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Megismerkedik az idegen nyelvvel, a nyelvtanulással és örömmel vesz részt az órákon.',
		a: 9,
		gT: 2117,
		b: 12,
		e2: 'Második idegen nyelv',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'második idegen nyelv'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a tanult infokommunikációs ismereteket matematikai problémák megoldása során.',
		a: 5,
		gT: 1979,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és használ digitális matematikai játékokat, programokat.',
		a: 5,
		gT: 1978,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és használ dinamikus geometriai szoftvereket, tisztában van alkalmazási lehetőségeikkel.',
		a: 5,
		gT: 1977,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'A fejszámoláson és az írásban végzendő műveleteken túlmutató számolási feladatokhoz és azok ellenőrzéséhez számológépet használ.',
		a: 5,
		gT: 1976,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer táblázatkezelő programot, tud adatokat összehasonlítani, elemezni.',
		a: 5,
		gT: 1975,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a táblázatok adatait, az adatoknak megfelelő ábrázolási módot kiválasztja, és az ábrát elkészíti.',
		a: 5,
		gT: 1974,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét esetekben halmazokat felismer és ábrázol.',
		a: 5,
		gT: 1973,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempont szerint adatokat gyűjt ki táblázatból, olvas le hagyományos vagy digitális forrásból származó diagramról, majd rendszerezés után következtetéseket fogalmaz meg.',
		a: 5,
		gT: 1972,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző típusú diagramokat megfeleltet egymásnak.',
		a: 5,
		gT: 1971,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat táblázatba rendez, diagramon ábrázol hagyományos és digitális eszközökkel is.',
		a: 5,
		gT: 1970,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a tanult matematikai fogalmakat megnevező szakkifejezéseket.',
		a: 5,
		gT: 1969,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a gyakoriság és a relatív gyakoriság fogalmát. ismereteit felhasználja a „lehetetlen\", a „biztos\" és a „kisebb, nagyobb eséllyel lehetséges\" kijelentések megfogalmazásánál.',
		a: 5,
		gT: 1968,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Valószínűségi játékokban érti a lehetséges kimeneteleket, játékában stratégiát követ.',
		a: 5,
		gT: 1967,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány tagjával adott sorozat esetén felismer és megfogalmaz képzési szabályt.',
		a: 5,
		gT: 1966,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Sorozatokat adott szabály alapján folytat.',
		a: 5,
		gT: 1965,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megalkotja az egyenes arányosság grafikonját.',
		a: 5,
		gT: 1964,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű grafikonokat jellemez.',
		a: 5,
		gT: 1963,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Értéktáblázatok adatait grafikusan ábrázolja.',
		a: 5,
		gT: 1962,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a koordináta-rendszerben: koordinátáival adott pontot ábrázol, megadott pont koordinátáit leolvassa.',
		a: 5,
		gT: 1961,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egyenes és a fordított arányosságot konkrét helyzetekben.',
		a: 5,
		gT: 1960,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét halmazok elemei között megfeleltetést hoz létre.',
		a: 5,
		gT: 1959,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'tájékozódás és alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Geometriai ismereteinek felhasználásával pontosan szerkeszt több adott feltételnek megfelelő ábrát.',
		a: 5,
		gT: 1958,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Megszerkeszti alakzatok tengelyes és középpontos tükörképét.',
		a: 5,
		gT: 1957,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az alapszerkesztéseket: szakaszfelező merőlegest, szögfelezőt, merőleges és párhuzamos egyeneseket szerkeszt, szöget másol.',
		a: 5,
		gT: 1956,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'A szerkesztéshez tervet, előzetes ábrát készít.',
		a: 5,
		gT: 1955,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a négyszögek tulajdonságait: belső és külső szögek összege, konvex és konkáv közti különbség, átló fogalma.',
		a: 5,
		gT: 1954,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a pitagorasz-tételt és alkalmazza számítási feladatokban.',
		a: 5,
		gT: 1953,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a háromszögek tulajdonságait: belső és külső szögek összege, háromszög-egyenlőtlenség.',
		a: 5,
		gT: 1952,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kör részeit; különbséget tesz egyenes, félegyenes és szakasz között.',
		a: 5,
		gT: 1951,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a kicsinyítést és a nagyítást hétköznapi helyzetekben.',
		a: 5,
		gT: 1950,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a síkban az egybevágó alakzatokat.',
		a: 5,
		gT: 1949,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatot szerez a síkbeli mozgásokról gyakorlati helyzetekben.',
		a: 5,
		gT: 1948,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a speciális négyszögeket: trapéz, paralelogramma, téglalap, deltoid, rombusz, húrtrapéz, négyzet.',
		a: 5,
		gT: 1947,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tengelyesen szimmetrikus háromszöget.',
		a: 5,
		gT: 1946,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kocka, a téglatest, a hasáb és a gúla következő tulajdonságait: határoló lapok típusa, száma, egymáshoz viszonyított helyzete; csúcsok, élek száma; lapátló, testátló.',
		a: 5,
		gT: 1945,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás és alkotás térben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a gömb tulajdonságait.',
		a: 5,
		gT: 1944,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás és alkotás térben'])
	},
		{
		cG: 'altgim',
		gD: 'Testeket épít képek, nézetek, alaprajzok, hálók alapján.',
		a: 5,
		gT: 1943,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás és alkotás térben'])
	},
		{
		cG: 'altgim',
		gD: 'A kocka, a téglatest, a hasáb és a gúla hálóját elkészíti.',
		a: 5,
		gT: 1942,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'tájékozódás és alkotás térben'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza háromszögek és speciális négyszögek kerületét, területét.',
		a: 5,
		gT: 1941,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Idő, tömeg, hosszúság, terület, térfogat és űrtartalom mértékegységeket átvált helyi értékes gondolkodás alapján, gyakorlati célszerűség szerint.',
		a: 5,
		gT: 1940,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Egyenes hasáb, téglatest, kocka alakú tárgyak felszínét és térfogatát méréssel megadja, egyenes hasáb felszínét és térfogatát képlet segítségével kiszámolja; a képleteket megalapozó összefüggéseket érti.',
		a: 5,
		gT: 1939,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az idő, a tömeg, a hosszúság, a terület, a térfogat és az űrtartalom szabványmértékegységeit, használja azokat mérések és számítások esetén.',
		a: 5,
		gT: 1938,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Elvégzi az alapműveleteket a racionális számok körében, eredményét összeveti előzetes becslésével.',
		a: 5,
		gT: 1937,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'A gyakorlati problémákban előforduló mennyiségeket becsülni tudja, feladatmegoldásához ennek megfelelő tervet készít.',
		a: 5,
		gT: 1936,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'A műveleti szabályok ismeretében ellenőrzi számolását. a kapott eredményt észszerűen kerekíti.',
		a: 5,
		gT: 1935,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati feladatok megoldása során tizedes törtet legfeljebb kétjegyű egész számmal írásban oszt. a hányadost megbecsüli.',
		a: 5,
		gT: 1934,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati feladatok megoldása során legfeljebb kétjegyű egész számmal írásban oszt. a hányadost megbecsüli.',
		a: 5,
		gT: 1933,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Írásban összead, kivon és szoroz.',
		a: 5,
		gT: 1932,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Egy- vagy kéttagú betűs kifejezést számmal szoroz, két tagból közös számtényezőt kiemel.',
		a: 5,
		gT: 1931,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű betűs kifejezésekkel összeadást, kivonást végez, és helyettesítési értéket számol.',
		a: 5,
		gT: 1930,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Négyzetszámok négyzetgyökét meghatározza.',
		a: 5,
		gT: 1929,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Pozitív egész számok pozitív egész kitevőjű hatványát kiszámolja.',
		a: 5,
		gT: 1928,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza természetes számok legnagyobb közös osztóját és legkisebb közös többszörösét.',
		a: 5,
		gT: 1927,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a prímszám és az összetett szám fogalmakat; el tudja készíteni összetett számok prímtényezős felbontását 1000-es számkörben.',
		a: 5,
		gT: 1926,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a 2-vel, 3-mal, 4-gyel, 5-tel, 6-tal, 9-cel, 10-zel, 100-zal való oszthatóság szabályait.',
		a: 5,
		gT: 1925,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és helyesen alkalmazza a műveleti sorrendre és a zárójelezésre vonatkozó szabályokat fejben, írásban és géppel számolás esetén is a racionális számok körében.',
		a: 5,
		gT: 1924,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'műveletek elvégzése'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza konkrét számok reciprokát.',
		a: 5,
		gT: 1923,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a racionális számokat, tud példát végtelen nem szakaszos tizedes törtre.',
		a: 5,
		gT: 1922,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelteti egymásnak a racionális számok közönséges tört és tizedes tört alakját.',
		a: 5,
		gT: 1921,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ábrázol törtrészeket, meghatároz törtrészeknek megfelelő törtszámokat.',
		a: 5,
		gT: 1920,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza konkrét számok ellentettjét, abszolút értékét.',
		a: 5,
		gT: 1919,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egész számokat.',
		a: 5,
		gT: 1918,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a római számjelek közül az l, c, d, m jeleket, felismeri az ezekkel képzett számokat a hétköznapi helyzetekben.',
		a: 5,
		gT: 1917,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és alkalmazza a számok helyi értékes írásmódját tizedes törtek esetén.',
		a: 5,
		gT: 1916,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és alkalmazza a számok helyi értékes írásmódját nagy számok esetén.',
		a: 5,
		gT: 1915,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'racionális számok felépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a százalék fogalmát, gazdasági, pénzügyi és mindennapi élethez kötődő százalékszámítási feladatokat megold.',
		a: 5,
		gT: 1914,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'rendszerező gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megoldását ellenőrzi.',
		a: 5,
		gT: 1913,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'rendszerező gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati problémák megoldása során előforduló mennyiségeknél becslést végez.',
		a: 5,
		gT: 1912,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'rendszerező gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Gazdasági, pénzügyi témájú egyszerű szöveges feladatokat következtetéssel vagy egyenlettel megold.',
		a: 5,
		gT: 1911,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'rendszerező gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Matematikából, más tantárgyakból és a mindennapi életből vett egyszerű szöveges feladatokat következtetéssel vagy egyenlettel megold.',
		a: 5,
		gT: 1910,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'rendszerező gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét adatsor esetén átlagot számol, megállapítja a leggyakoribb adatot (módusz), a középső adatot (medián), és ezeket összehasonlítja.',
		a: 5,
		gT: 1909,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'ismeretek alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'A kocka, a téglatest, a hasáb, a gúla, a gömb tulajdonságait alkalmazza feladatok megoldásában.',
		a: 5,
		gT: 1908,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'ismeretek alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'A háromszögek és a speciális négyszögek tulajdonságait alkalmazza feladatok megoldásában.',
		a: 5,
		gT: 1907,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'ismeretek alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Összeszámlálási feladatok megoldása során alkalmazza az összes eset áttekintéséhez szükséges módszereket.',
		a: 5,
		gT: 1906,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'ismeretek alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Valószínűségi játékokat, kísérleteket végez, ennek során az adatokat tervszerűen gyűjti, rendezi és ábrázolja digitálisan is.',
		a: 5,
		gT: 1905,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a speciális négyszögek legfontosabb tulajdonságait, ezek alapján elkészíti a halmazábrájukat.',
		a: 5,
		gT: 1904,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportosítja a háromszögeket szögeik és oldalaik szerint.',
		a: 5,
		gT: 1903,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Síkbeli tartományok közül kiválasztja a szögtartományokat, nagyság szerint összehasonlítja, méri, csoportosítja azokat.',
		a: 5,
		gT: 1902,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'A természetes számokat osztóik száma alapján és adott számmal való osztási maradékuk szerint csoportosítja.',
		a: 5,
		gT: 1901,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Véges halmaz kiegészítő halmazát (komplementerét), véges halmazok közös részét (metszetét), egyesítését (unióját) képezi és ábrázolja konkrét esetekben.',
		a: 5,
		gT: 1900,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Részhalmazokat konkrét esetekben felismer és ábrázol.',
		a: 5,
		gT: 1899,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'Elemeket halmazba rendez több szempont alapján.',
		a: 5,
		gT: 1898,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés'])
	},
		{
		cG: 'altgim',
		gD: 'A logikus érvelésben a matematikai szaknyelvet következetesen alkalmazza társai meggyőzésére.',
		a: 5,
		gT: 1897,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'állítások kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Tanult minták alapján néhány lépésből álló bizonyítási gondolatsort megért és önállóan összeállít.',
		a: 5,
		gT: 1896,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'állítások kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Igaz és hamis állításokat fogalmaz meg.',
		a: 5,
		gT: 1895,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'állítások kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Állítások logikai értékét (igaz vagy hamis) megállapítja.',
		a: 5,
		gT: 1894,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'állítások kezelése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyismeretlenes elsőfokú egyenletet lebontogatással és mérlegelvvel megold.',
		a: 5,
		gT: 1893,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'eszközrendszer alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét szituációkat szemléltet gráfok segítségével.',
		a: 5,
		gT: 1892,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'eszközrendszer alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Számokat, számhalmazokat, halmazműveleti eredményeket számegyenesen ábrázol.',
		a: 5,
		gT: 1891,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'eszközrendszer alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző szövegekhez megfelelő modelleket készít.',
		a: 5,
		gT: 1890,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'eszközrendszer alkalmazása'])
	},
		{
		cG: 'altgim',
		gD: 'Matematikai ismereteit alkalmazza a pénzügyi tudatosság területét érintő feladatok megoldásában.',
		a: 5,
		gT: 1889,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Matematikai ismereteit össze tudja kapcsolni más tanulásterületeken szerzett tapasztalatokkal.',
		a: 5,
		gT: 1888,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Tanulási módszerei változatosak: szóbeli közlés, írott szöveg és digitális csatornák útján egyaránt képes az ismeretek elsajátítására.',
		a: 5,
		gT: 1887,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Olvassa és érti az életkorának megfelelő matematikai tartalmú szövegeket.',
		a: 5,
		gT: 1886,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a matematikai jelöléseket írásban.',
		a: 5,
		gT: 1885,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmaz sejtéseket, és logikus érveléssel ellenőrzi azokat.',
		a: 5,
		gT: 1884,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a hétköznapi helyzetekben a matematikai vonatkozásokat, és ezek leírására megfelelő modellt használ.',
		a: 5,
		gT: 1883,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Rendelkezik a matematikai problémamegoldáshoz szükséges eszközrendszerrel, melyet az adott problémának megfelelően tud alkalmazni.',
		a: 5,
		gT: 1882,
		b: 8,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Szerkesztési feladatok euklideszi módon történő megoldásához dinamikus geometriai szoftvert használ.',
		a: 9,
		gT: 2116,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérletezéshez, sejtés megfogalmazásához, egyenlet grafikus megoldásához és ellenőrzéshez dinamikus geometriai, grafikus és táblázatkezelő szoftvereket használ.',
		a: 9,
		gT: 2115,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Prezentációhoz informatív diákat készít, ezeket logikusan és következetesen egymás után fűzi és bemutatja.',
		a: 9,
		gT: 2114,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismereteit digitális forrásokból kiegészíti, számítógép segítségével elemzi és bemutatja.',
		a: 9,
		gT: 2113,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő informatikai alkalmazás segítségével szöveget szerkeszt, táblázatkezelő programmal diagramokat készít.',
		a: 9,
		gT: 2112,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális környezetben matematikai alkalmazásokkal dolgozik.',
		a: 9,
		gT: 2111,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Számológép segítségével alapműveletekkel felírható számolási eredményt; négyzetgyököt; átlagot; szögfüggvények értékét, illetve abból szöget; logaritmust; faktoriálist; binomiális együtthatót; szórást meghatároz.',
		a: 9,
		gT: 2110,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'digitáliseszköz-használat', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer a tananyaghoz kapcsolódó matematikatörténeti vonatkozásokat.',
		a: 9,
		gT: 2109,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveg alapján táblázatot, grafikont készít, ábrát, kapcsolatokat szemléltető gráfot rajzol, és ezeket kombinálva prezentációt készít és mutat be.',
		a: 9,
		gT: 2108,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Matematika feladatok megoldását szakszerűen prezentálja írásban és szóban a szükséges alapfogalmak, azonosságok, definíciók és tételek segítségével.',
		a: 9,
		gT: 2107,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan kommunikál matematika tartalmú feladatokkal kapcsolatban.',
		a: 9,
		gT: 2106,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A matematikai fogalmakat és jelöléseket megfelelően használja.',
		a: 9,
		gT: 2105,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A megfelelő matematikai tankönyveket, feladatgyűjteményeket, internetes tartalmakat értőn olvassa, a matematikai tartalmat rendszerezetten kigyűjti és megérti.',
		a: 9,
		gT: 2104,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'matematikai kommunikáció', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza a valószínűséget visszatevéses, illetve visszatevés nélküli mintavétel esetén.',
		a: 9,
		gT: 2103,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és egyszerű esetekben alkalmazza a valószínűség geometriai modelljét.',
		a: 9,
		gT: 2102,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét valószínűségi kísérletek esetében az esemény, eseménytér, elemi esemény, relatív gyakoriság, valószínűség, egymást kizáró események, független események fogalmát megkülönbözteti és alkalmazza.',
		a: 9,
		gT: 2101,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Véletlen kísérletek adatait rendszerezi, relatív gyakoriságokat számol, nagy elemszám esetén számítógépet alkalmaz.',
		a: 9,
		gT: 2100,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a klasszikus valószínűségi modellt és a laplace-képletet.',
		a: 9,
		gT: 2099,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatai alapján véletlen jelenségek jövőbeni kimenetelére észszerűen tippel.',
		a: 9,
		gT: 2098,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'valószínűségszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismer grafikus manipulációkat diagramok esetén.',
		a: 9,
		gT: 2097,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a sodrófa (box-plot) diagramot adathalmazok jellemzésére, összehasonlítására.',
		a: 9,
		gT: 2096,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'altgim',
		gD: 'Adatsokaságból adott szempont szerint oszlop- és kördiagramot készít hagyományos és digitális eszközzel.',
		a: 9,
		gT: 2095,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'altgim',
		gD: 'Hagyományos és digitális forrásból származó adatsokaság alapvető statisztikai jellemzőit meghatározza, értelmezi és értékeli.',
		a: 9,
		gT: 2094,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'altgim',
		gD: 'Adott cél érdekében tudatos adatgyűjtést és rendszerezést végez.',
		a: 9,
		gT: 2093,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'valószínűségi gondolkodás', 'leíró statisztika'])
	},
		{
		cG: 'altgim',
		gD: 'Mértani sorozatokra vonatkozó ismereteit használja gazdasági, pénzügyi, természettudományi és társadalomtudományi problémák megoldásában.',
		a: 9,
		gT: 2092,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'altgim',
		gD: 'A számtani, mértani sorozatok első n tagjának összegét kiszámolja.',
		a: 9,
		gT: 2091,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'altgim',
		gD: 'A számtani, mértani sorozat n-edik tagját felírja az első tag és a különbség (differencia)/hányados (kvóciens) ismeretében.',
		a: 9,
		gT: 2090,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'altgim',
		gD: 'Számtani és mértani sorozatokat adott szabály alapján felír, folytat.',
		a: 9,
		gT: 2089,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'sorozatok'])
	},
		{
		cG: 'altgim',
		gD: 'A grafikonról megállapítja függvények alapvető tulajdonságait.',
		a: 9,
		gT: 2088,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Adott értékkészletbeli elemhez megtalálja az értelmezési tartomány azon elemeit, amelyekhez a függvény az adott értéket rendeli.',
		a: 9,
		gT: 2087,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Képlettel adott függvényt hagyományosan és digitális eszközzel ábrázol.',
		a: 9,
		gT: 2086,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Táblázattal megadott függvény összetartozó értékeit ábrázolja koordináta-rendszerben.',
		a: 9,
		gT: 2085,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Adott képlet alapján helyettesítési értékeket számol, és azokat táblázatba rendezi.',
		a: 9,
		gT: 2084,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Megad hétköznapi életben előforduló hozzárendeléseket.',
		a: 9,
		gT: 2083,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'függvények'])
	},
		{
		cG: 'altgim',
		gD: 'Megadja és alkalmazza a kör egyenletét a kör sugarának és a középpont koordinátáinak ismeretében.',
		a: 9,
		gT: 2082,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszámítja egyenesek metszéspontjainak koordinátáit az egyenesek egyenletének ismeretében.',
		a: 9,
		gT: 2081,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Egyenesek egyenletéből következtet az egyenesek kölcsönös helyzetére.',
		a: 9,
		gT: 2080,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az egyenes egyenletét.',
		a: 9,
		gT: 2079,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Koordináták alapján számításokat végez szakaszokkal, vektorokkal.',
		a: 9,
		gT: 2078,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Koordináta-rendszerben ábrázol adott feltételeknek megfelelő ponthalmazokat.',
		a: 9,
		gT: 2077,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Megad pontot és vektort koordinátáival a derékszögű koordináta-rendszerben.',
		a: 9,
		gT: 2076,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'koordinátageometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a hasonló testek felszínének és térfogatának arányára vonatkozó tételeket.',
		a: 9,
		gT: 2075,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszámítja a speciális testek felszínét és térfogatát egyszerű esetekben.',
		a: 9,
		gT: 2074,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'altgim',
		gD: 'Lerajzolja a kocka, téglatest, egyenes hasáb, egyenes körhenger, egyenes gúla, forgáskúp hálóját.',
		a: 9,
		gT: 2073,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a hasáb, a henger, a gúla, a kúp, a gömb, a csonkagúla, a csonkakúp (speciális testek) tulajdonságait.',
		a: 9,
		gT: 2072,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térgeometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a szinusz- és a koszinusztételt.',
		a: 9,
		gT: 2071,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'A szögfüggvény értékének ismeretében meghatározza a szöget.',
		a: 9,
		gT: 2070,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a szögfüggvényeket egyszerű geometriai számítási feladatokban.',
		a: 9,
		gT: 2069,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hegyes- és tompaszögek szögfüggvényeinek összefüggéseit.',
		a: 9,
		gT: 2068,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri tompaszögek szögfüggvényeinek származtatását a hegyesszögek szögfüggvényei alapján.',
		a: 9,
		gT: 2067,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri hegyesszögek szögfüggvényeinek definícióját a derékszögű háromszögben.',
		a: 9,
		gT: 2066,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'trigonometria'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a vektorokat feladatok megoldásában.',
		a: 9,
		gT: 2065,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és alkalmaz egyszerű vektorműveleteket.',
		a: 9,
		gT: 2064,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a vektorokkal kapcsolatos alapvető fogalmakat.',
		a: 9,
		gT: 2063,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Megszerkeszti egy alakzat tengelyes, illetve középpontos tükörképét, pont körüli elforgatottját, párhuzamos eltoltját hagyományosan és digitális eszközzel.',
		a: 9,
		gT: 2062,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a hasonló síkidomok kerületének és területének arányára vonatkozó tételeket.',
		a: 9,
		gT: 2061,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a középpontos hasonlósági transzformációt, a hasonlósági transzformációt és az alakzatok hasonlóságát.',
		a: 9,
		gT: 2060,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a síkbeli egybevágósági transzformációkat és tulajdonságaikat; alakzatok egybevágóságát.',
		a: 9,
		gT: 2059,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer példákat geometriai transzformációkra.',
		a: 9,
		gT: 2058,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a thalész-tételt és megfordítását.',
		a: 9,
		gT: 2057,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kör érintőjének fogalmát, kapcsolatát az érintési pontba húzott sugárral.',
		a: 9,
		gT: 2056,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'altgim',
		gD: 'Ki tudja számolni a kör és részeinek kerületét, területét.',
		a: 9,
		gT: 2055,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'a kör és részei'])
	},
		{
		cG: 'altgim',
		gD: 'Átdarabolással kiszámítja sokszögek területét.',
		a: 9,
		gT: 2054,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a szabályos sokszög fogalmát; kiszámítja a konvex sokszög belső és külső szögeinek összegét.',
		a: 9,
		gT: 2053,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza speciális négyszögek tulajdonságait, területüket kiszámítja.',
		a: 9,
		gT: 2052,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Kiszámítja háromszögek területét.',
		a: 9,
		gT: 2051,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a pitagorasz-tételt és megfordítását.',
		a: 9,
		gT: 2050,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a háromszög nevezetes vonalaira, pontjaira és köreire vonatkozó fogalmakat és tételeket.',
		a: 9,
		gT: 2049,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a háromszögek oldalai, szögei, oldalai és szögei közötti kapcsolatokat; a speciális háromszögek tulajdonságait.',
		a: 9,
		gT: 2048,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'háromszögek, négyszögek, sokszögek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az alapszerkesztéseket, és ezeket végre tudja hajtani hagyományos vagy digitális eszközzel.',
		a: 9,
		gT: 2047,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a nevezetes szögpárok tulajdonságait.',
		a: 9,
		gT: 2046,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és feladatmegoldásban alkalmazza a térelemek kölcsönös helyzetét, távolságát és hajlásszögét.',
		a: 9,
		gT: 2045,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a pont, egyenes, sík (térelemek) és szög fogalmát.',
		a: 9,
		gT: 2044,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'geometriai alapfogalmak'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a százalékalap, -érték, -láb, -pont fogalmát.',
		a: 9,
		gT: 2043,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az egyenes és a fordított arányosságot.',
		a: 9,
		gT: 2042,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'arányosság, százalékszámítás'])
	},
		{
		cG: 'altgim',
		gD: 'Átalakít algebrai kifejezéseket összevonás, szorzattá alakítás, nevezetes azonosságok alkalmazásával.',
		a: 9,
		gT: 2041,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és alkalmaz egyszerű algebrai azonosságokat.',
		a: 9,
		gT: 2040,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Műveleteket végez algebrai kifejezésekkel.',
		a: 9,
		gT: 2039,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a logaritmus fogalmát.',
		a: 9,
		gT: 2038,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a racionális kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2037,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az egész kitevőjű hatvány fogalmát és a hatványozás azonosságait.',
		a: 9,
		gT: 2036,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a normálalak fogalmát.',
		a: 9,
		gT: 2035,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az n-edik gyök fogalmát.',
		a: 9,
		gT: 2034,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a négyzetgyök fogalmát és azonosságait.',
		a: 9,
		gT: 2033,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'hatvány, gyök, logaritmus'])
	},
		{
		cG: 'altgim',
		gD: 'Valós számok közelítő alakjaival számol, és megfelelően kerekít.',
		a: 9,
		gT: 2032,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'A számolással kapott eredményeket nagyságrendileg megbecsüli, és így ellenőrzi az eredményt.',
		a: 9,
		gT: 2031,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az abszolút érték, az ellentett és a reciprok fogalmát.',
		a: 9,
		gT: 2030,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a valós számok és a számegyenes kapcsolatát.',
		a: 9,
		gT: 2029,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer példákat irracionális számokra.',
		a: 9,
		gT: 2028,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Racionális számokat tizedes tört és közönséges tört alakban is felír.',
		a: 9,
		gT: 2027,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'A kommutativitás, asszociativitás, disztributivitás műveleti azonosságokat helyesen alkalmazza különböző számolási helyzetekben.',
		a: 9,
		gT: 2026,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a számhalmazok épülésének matematikai vonatkozásait a természetes számoktól a valós számokig.',
		a: 9,
		gT: 2025,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'valós számok'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a helyi értékes írásmódot 10-es és más alapú számrendszerekben.',
		a: 9,
		gT: 2024,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az oszthatósági szabályokat.',
		a: 9,
		gT: 2023,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza két természetes szám legnagyobb közös osztóját és legkisebb közös többszörösét, és alkalmazza ezeket egyszerű gyakorlati feladatokban.',
		a: 9,
		gT: 2022,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összetett számokat felbont prímszámok szorzatára.',
		a: 9,
		gT: 2021,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az oszthatóság alapvető fogalmait.',
		a: 9,
		gT: 2020,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'a természetes számok halmaza, számelméleti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Sík- és térgeometriai feladatoknál a problémának megfelelő mértékegységben adja meg válaszát.',
		a: 9,
		gT: 2019,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hosszúság, terület, térfogat, űrtartalom, idő mértékegységeit és az átváltási szabályokat. származtatott mértékegységeket átvált.',
		a: 9,
		gT: 2018,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a mérés alapelvét, alkalmazza konkrét alap- és származtatott mennyiségek esetén.',
		a: 9,
		gT: 2017,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérés, mértékegységek'])
	},
		{
		cG: 'altgim',
		gD: 'Egyenletek megoldását behelyettesítéssel, értékkészlet-vizsgálattal ellenőrzi.',
		a: 9,
		gT: 2016,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Megold egyszerű, a megfelelő definíció alkalmazását igénylő exponenciális egyenleteket, egyenlőtlenségeket.',
		a: 9,
		gT: 2015,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Megold másodfokú egyismeretlenes egyenleteket és egyenlőtlenségeket; ismeri és alkalmazza a diszkriminánst, a megoldóképletet és a gyöktényezős alakot.',
		a: 9,
		gT: 2014,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Megold elsőfokú egyismeretlenes egyenleteket és egyenlőtlenségeket, elsőfokú kétismeretlenes egyenletrendszereket.',
		a: 9,
		gT: 2013,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza a következő egyenletmegoldási módszereket: mérlegelv, grafikus megoldás, szorzattá alakítás.',
		a: 9,
		gT: 2012,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'egyenletek, egyenlőtlenségek, egyenletrendszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Geometriai szerkesztési feladatoknál vizsgálja és megállapítja a szerkeszthetőség feltételeit.',
		a: 9,
		gT: 2011,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'A modellben kapott megoldását az eredeti problémába visszahelyettesítve értelmezi, ellenőrzi és az észszerűségi szempontokat figyelembe véve adja meg válaszát.',
		a: 9,
		gT: 2010,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'A kiválasztott modellben megoldja a problémát.',
		a: 9,
		gT: 2009,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'A problémának megfelelő matematikai modellt választ, alkot.',
		a: 9,
		gT: 2008,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Adott problémához megoldási stratégiát, algoritmust választ, készít.',
		a: 9,
		gT: 2007,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét szituációkat szemléltet és egyszerű feladatokat megold gráfok segítségével.',
		a: 9,
		gT: 2006,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'altgim',
		gD: 'Megold sorba rendezési és kiválasztási feladatokat.',
		a: 9,
		gT: 2005,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'kombinatorika, gráfok'])
	},
		{
		cG: 'altgim',
		gD: 'Tud egyszerű állításokat indokolni és tételeket bizonyítani.',
		a: 9,
		gT: 2004,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a „minden\" és „van olyan\" kifejezéseket.',
		a: 9,
		gT: 2003,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Megállapítja egyszerű „ha ... , akkor ...\" és „akkor és csak akkor\" típusú állítások logikai értékét.',
		a: 9,
		gT: 2002,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza adott állítás megfordítását.',
		a: 9,
		gT: 2001,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és alkalmazza az „és\", a (megengedő és kizáró) „vagy\" logikai jelentését.',
		a: 9,
		gT: 2000,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a tagadás műveletét egyszerű feladatokban.',
		a: 9,
		gT: 1999,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Adott állításról eldönti, hogy igaz vagy hamis.',
		a: 9,
		gT: 1998,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a logikai szita elvét.',
		a: 9,
		gT: 1997,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Véges halmazok elemszámát meghatározza.',
		a: 9,
		gT: 1996,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Halmazokkal műveleteket végez, azokat ábrázolja és értelmezi.',
		a: 9,
		gT: 1995,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Halmazokat különböző módokon megad.',
		a: 9,
		gT: 1994,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Látja a halmazműveletek és a logikai műveletek közötti kapcsolatokat.',
		a: 9,
		gT: 1993,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok, matematikai logika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatot.',
		a: 9,
		gT: 1992,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Matematikai vagy hétköznapi nyelven megfogalmazott szövegből a matematikai tartalmú információkat kigyűjti, rendszerezi.',
		a: 9,
		gT: 1991,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Adott halmazt diszjunkt részhalmazaira bont, osztályoz.',
		a: 9,
		gT: 1990,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Matematikai ismereteit alkalmazza a pénzügyi tudatosság területét érintő feladatok megoldásában.',
		a: 9,
		gT: 1989,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'A matematikát más tantárgyakhoz kapcsolódó témákban is használja.',
		a: 9,
		gT: 1988,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'A matematika tanulása során digitális eszközöket és különböző információforrásokat használ.',
		a: 9,
		gT: 1987,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a matematika különböző területei közötti kapcsolatokat.',
		a: 9,
		gT: 1986,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a hallott és olvasott matematikai tartalmú szövegeket.',
		a: 9,
		gT: 1985,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'A matematikai szakkifejezéseket és jelöléseket helyesen használja írásban és szóban egyaránt.',
		a: 9,
		gT: 1984,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt, rendez, ábrázol, értelmez.',
		a: 9,
		gT: 1983,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Sejtéseket fogalmaz meg és logikus lépésekkel igazolja azokat.',
		a: 9,
		gT: 1982,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a környezetében jelen lévő logikai, mennyiségi, függvényszerű, térbeli és statisztikai kapcsolatokat.',
		a: 9,
		gT: 1981,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei segítségével, a megfelelő modell alkalmazásával megold hétköznapi és matematikai problémákat, a megoldást ellenőrzi és értelmezi.',
		a: 9,
		gT: 1980,
		b: 12,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a tanult infokommunikációs ismereteket matematikai problémák megoldása során.',
		a: 1,
		gT: 1881,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Használ matematikai képességfejlesztő számítógépes játékokat, programokat.',
		a: 1,
		gT: 1880,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Nyelvi szempontból megfelelő választ ad a feladatokban megjelenő kérdésekre.',
		a: 1,
		gT: 1879,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdést fogalmaz meg, ha munkája során nehézségbe ütközik.',
		a: 1,
		gT: 1878,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Játékos feladatokban személyeket, tárgyakat, számokat, formákat néhány meghatározó tulajdonsággal jellemez.',
		a: 1,
		gT: 1877,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveget, ábrát alkot matematikai jelekhez, műveletekhez.',
		a: 1,
		gT: 1876,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelően használja szóban és írásban a nyelvtani szerkezeteket matematikai tartalmuk szerint.',
		a: 1,
		gT: 1875,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő szókincset és jeleket használ mennyiségi viszonyok kifejezésére szóban és írásban.',
		a: 1,
		gT: 1874,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveges feladatokban a különböző kifejezésekkel megfogalmazott műveleteket megérti.',
		a: 1,
		gT: 1873,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a mennyiségi viszonyokat kifejező szavakat, nyelvtani szerkezeteket.',
		a: 1,
		gT: 1872,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan értelmezi a hallott, olvasott matematikai tartalmú szöveget.',
		a: 1,
		gT: 1871,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'matematikai kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'A valószínűségi játékokban, kísérletekben megfogalmazott előzetes sejtését, tippjét összeveti a megfigyelt előfordulásokkal.',
		a: 1,
		gT: 1870,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Tetszőleges vagy megadott módszerrel összeszámlálja az egyes kimenetelek előfordulásait olyan egyszerű játékokban, kísérletekben, amelyekben a véletlen szerepet játszik.',
		a: 1,
		gT: 1869,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalatai alapján tippet fogalmaz meg arról, hogy két esemény közül melyik esemény valószínűbb olyan véletlentől függő szituációk során, melyekben a két esemény valószínűsége között jól belátható a különbség.',
		a: 1,
		gT: 1868,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megítéli „biztos\", „lehetetlen\", „lehetséges, de nem biztos\" eseményekkel kapcsolatos állítások igazságát.',
		a: 1,
		gT: 1867,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz tapasztalatai alapján a „biztos\", „lehetetlen\", „lehetséges, de nem biztos\" események között.',
		a: 1,
		gT: 1866,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz olyan játékokban, kísérletekben, melyekben a véletlen szerepet játszik.',
		a: 1,
		gT: 1865,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'valószínűségi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Jellemzi az összességeket.',
		a: 1,
		gT: 1864,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'adatok megfigyelése'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt ki táblázatból, adatokat olvas le diagramról.',
		a: 1,
		gT: 1863,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'adatok megfigyelése'])
	},
		{
		cG: 'altgim',
		gD: 'Gyűjtött adatokat táblázatba rendez, diagramon ábrázol.',
		a: 1,
		gT: 1862,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'adatok megfigyelése'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat rögzít későbbi elemzés céljából.',
		a: 1,
		gT: 1861,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'adatok megfigyelése'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt a környezetében.',
		a: 1,
		gT: 1860,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'adatok megfigyelése'])
	},
		{
		cG: 'altgim',
		gD: 'A sorozatban, táblázatban, gépjátékokban felismert összefüggést megfogalmazza saját szavaival, nyíljelöléssel vagy nyitott mondattal.',
		a: 1,
		gT: 1859,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Szabályjátékok során létrehoz a felismert kapcsolat alapján további elempárokat, elemhármasokat.',
		a: 1,
		gT: 1858,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismer kapcsolatot elempárok, elemhármasok tagjai között.',
		a: 1,
		gT: 1857,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Tárgyakkal, számokkal kapcsolatos gépjátékhoz szabályt alkot; felismeri az egyszerű gép megfordításával nyert gép szabályát.',
		a: 1,
		gT: 1856,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismert műveletekkel alkotott sorozat, táblázat szabályát felismeri; ismert szabály szerint megkezdett sorozatot, táblázatot helyesen, önállóan folytat.',
		a: 1,
		gT: 1855,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Elsorolja az évszakokat, hónapokat, napokat, napszakokat egymás után, tetszőleges kezdőponttól is.',
		a: 1,
		gT: 1854,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Tárgyakkal, logikai készletek elemeivel kirakott periodikus sorozatokat folytat.',
		a: 1,
		gT: 1853,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szabály szerint sorozatot alkot; megértett probléma értelmezéséhez, megoldásához sorozatot, táblázatot állít elő modellként.',
		a: 1,
		gT: 1852,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'szabályok értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseket keres sorozatok elemei között.',
		a: 1,
		gT: 1851,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'összefüggések és kapcsolatok felismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a felismert összefüggéseket.',
		a: 1,
		gT: 1850,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'összefüggések és kapcsolatok felismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a problémákban szereplő adatok viszonyát.',
		a: 1,
		gT: 1849,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'összefüggések és kapcsolatok felismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a személyek, tárgyak, dolgok, időpontok, számok, testek, síklapok közötti egyszerű viszonyokat, kapcsolatokat.',
		a: 1,
		gT: 1848,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'összefüggések és kapcsolatok felismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz memóriajátékokban különféle tulajdonságok szerinti párok keresésében.',
		a: 1,
		gT: 1847,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'függvényszerű gondolkodás', 'összefüggések és kapcsolatok felismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Térképen, négyzethálón megtalál pontot két adat segítségével.',
		a: 1,
		gT: 1846,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térbeli és síkbeli tájékozódás'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik lakóhelyén, bejárt terepen: bejárt útvonalon visszatalál adott helyre, adott utca és házszám alapján megtalál házat.',
		a: 1,
		gT: 1845,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térbeli és síkbeli tájékozódás'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja az irányokat és távolságokat jelölő kifejezéseket térben és síkon.',
		a: 1,
		gT: 1844,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'térbeli és síkbeli tájékozódás'])
	},
		{
		cG: 'altgim',
		gD: 'Térben, síkban az eredetihez hasonló testeket, síkidomokat alkot nagyított vagy kicsinyített elemekből; az eredetihez hasonló síkidomokat rajzol hálón.',
		a: 1,
		gT: 1843,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Követi a sormintában vagy a síkmintában lévő szimmetriát.',
		a: 1,
		gT: 1842,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Ellenőrzi a tükrözés, eltolás helyességét tükör vagy másolópapír segítségével.',
		a: 1,
		gT: 1841,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Megépíti, kirakja, megrajzolja hálón, jelölés nélküli lapon sablonnal, másolópapír segítségével alakzat tükörképét, eltolt képét.',
		a: 1,
		gT: 1840,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Szimmetrikus alakzatokat hoz létre térben, síkban különböző eszközökkel; felismeri a szimmetriát valóságos dolgokon, síkbeli alakzatokon.',
		a: 1,
		gT: 1839,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Tapasztalattal rendelkezik mozgással, kirakással a tükörkép előállításáról.',
		a: 1,
		gT: 1838,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'transzformációk'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyelt tulajdonságaival jellemzi a létrehozott síkbeli és térbeli alkotást, mintázatot.',
		a: 1,
		gT: 1837,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi megfigyelt tulajdonságai alapján a téglatestet, kockát, téglalapot, négyzetet.',
		a: 1,
		gT: 1836,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a kocka mint speciális téglatest és a négyzet mint speciális téglalap tulajdonságait.',
		a: 1,
		gT: 1835,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megmutatja a téglalap azonos hosszúságú oldalait és elhelyezkedésüket, megmutatja és megszámlálja a téglalap átlóit és szimmetriatengelyeit.',
		a: 1,
		gT: 1834,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja a téglalap oldalainak és csúcsainak számát, összehajtással megmutatja a téglalap szögeinek egyenlőségét.',
		a: 1,
		gT: 1833,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a téglatest lapjainak alakját, felismeri a téglatesten az egybevágó lapokat, megkülönbözteti a téglatesten az éleket, csúcsokat.',
		a: 1,
		gT: 1832,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megszámlálja az egyszerű szögletes test lapjait.',
		a: 1,
		gT: 1831,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönböztet tükrösen szimmetrikus és tükrösen nem szimmetrikus síkbeli alakzatokat.',
		a: 1,
		gT: 1830,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a háromszögeket, négyszögeket, köröket.',
		a: 1,
		gT: 1829,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Kiválasztja megadott síkidomok közül a sokszögeket.',
		a: 1,
		gT: 1828,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a sík és görbült felületeket, az egyenes és görbe vonalakat, szakaszokat tapasztalati ismeretei alapján.',
		a: 1,
		gT: 1827,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz testek és síkidomok között.',
		a: 1,
		gT: 1826,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a tevékenységei során előállított, válogatásai során előkerülő alakzatokon megfigyelt tulajdonságokat.',
		a: 1,
		gT: 1825,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megtalálja a közös tulajdonsággal nem rendelkező alakzatokat.',
		a: 1,
		gT: 1824,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli az alakzatok közös tulajdonságát, megfelelő címkéket talál megadott és halmazokba rendezett alakzatokhoz.',
		a: 1,
		gT: 1823,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti és szétválogatja szabadon választott vagy meghatározott geometriai tulajdonságok szerint a gyűjtött, megalkotott testeket, síkidomokat.',
		a: 1,
		gT: 1822,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alakzatok geometriai tulajdonságai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza az alkotásai közti különbözőséget.',
		a: 1,
		gT: 1821,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Megtalálja az összes, több feltételnek megfelelő építményt, síkbeli kirakást.',
		a: 1,
		gT: 1820,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Alaklemezt, vonalzót, körzőt használ alkotáskor.',
		a: 1,
		gT: 1819,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Síkidomokat hoz létre különféle eszközök segítségével.',
		a: 1,
		gT: 1818,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Testeket épít élekből, lapokból; elkészíti a testek élvázát, hálóját; testeket épít képek, alaprajzok alapján; elkészíti egyszerű testek alaprajzát.',
		a: 1,
		gT: 1817,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotásában követi az adott feltételeket.',
		a: 1,
		gT: 1816,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Sormintát, síkmintát felismer, folytat.',
		a: 1,
		gT: 1815,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Minta alapján létrehoz térbeli, síkbeli alkotásokat.',
		a: 1,
		gT: 1814,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Szabadon épít, kirak formát, mintát adott testekből, síklapokból.',
		a: 1,
		gT: 1813,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás és alkotás térben és síkon', 'alkotás térben és síkon'])
	},
		{
		cG: 'altgim',
		gD: 'Nagyság szerint összehasonlítja a természetes számokat és a negatív egész számokat a használt modellen belül.',
		a: 1,
		gT: 1812,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'törtrészek, negatív számok'])
	},
		{
		cG: 'altgim',
		gD: 'A negatív egész számokat irányított mennyiségként (hőmérséklet, tengerszint alatti magasság, idő) és hiányként (adósság) értelmezi.',
		a: 1,
		gT: 1811,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'törtrészek, negatív számok'])
	},
		{
		cG: 'altgim',
		gD: 'A kirakást, mérést és a rajzot mint modellt használja a törtrészek összehasonlítására.',
		a: 1,
		gT: 1810,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'törtrészek, negatív számok'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenységekkel megjelenít egységtörteket és azok többszöröseit különféle mennyiségek és többféle egységválasztás esetén.',
		a: 1,
		gT: 1809,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'törtrészek, negatív számok'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen végzi el az írásbeli szorzást egy- és kétjegyű szorzóval, az írásbeli osztást egyjegyű osztóval.',
		a: 1,
		gT: 1808,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen végzi el az írásbeli összeadást, kivonást.',
		a: 1,
		gT: 1807,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Teljes négyjegyűek összegét, különbségét százasokra kerekített értékekkel megbecsüli, teljes kétjegyűek két- és egyjegyűvel való szorzatát megbecsüli.',
		a: 1,
		gT: 1806,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Elvégzi a feladathoz szükséges észszerű becslést, mérlegeli a becslés során kapott eredményt.',
		a: 1,
		gT: 1805,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a 10-zel, 100-zal, 1000-rel való szorzás, osztás kapcsolatát a helyiérték-táblázatban való jobbra, illetve balra tolódással, fejben pontosan számol a 10 000-es számkörben a számok 10-zel, 100-zal, 1000-rel történő szorzásakor és maradék nélküli osztásakor.',
		a: 1,
		gT: 1804,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Fejben pontosan számol a 10 000-es számkörben a 100-as számkörben végzett műveletekkel analóg esetekben.',
		a: 1,
		gT: 1803,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Fejben pontosan számol a 100-as számkörben egyjegyűvel való szorzás és maradék nélküli osztás során.',
		a: 1,
		gT: 1802,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Emlékezetből tudja a kisegyszeregy és a megfelelő bennfoglalások, egyenlő részekre osztások eseteit a számok tízszereséig.',
		a: 1,
		gT: 1801,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a szorzó- és bennfoglaló táblák kapcsolatát.',
		a: 1,
		gT: 1800,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Fejben pontosan összead és kivon a 100-as számkörben.',
		a: 1,
		gT: 1799,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a számolást könnyítő eljárásokat.',
		a: 1,
		gT: 1798,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számolás'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveghez, valós helyzethez kapcsolva zárójelet tartalmazó műveletsort értelmez, elvégez.',
		a: 1,
		gT: 1797,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a műveletekben szereplő számok (kisebbítendő, kivonandó és különbség; tagok és összeg; tényezők és szorzat; osztandó, osztó és hányados) változtatásának következményeit.',
		a: 1,
		gT: 1796,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Megold hiányos műveletet, műveletsort az eredmény ismeretében, a műveletek megfordításával is.',
		a: 1,
		gT: 1795,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Számolásaiban felhasználja a műveletek közti kapcsolatokat, számolásai során alkalmazza konkrét esetekben a legfontosabb műveleti tulajdonságokat.',
		a: 1,
		gT: 1794,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a következő kifejezéseket: tagok, összeg, kisebbítendő, kivonandó, különbség, tényezők, szorzandó, szorzó, szorzat, osztandó, osztó, hányados, maradék.',
		a: 1,
		gT: 1793,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a műveleteket megjelenítéssel, modellezéssel, szöveges feladattal.',
		a: 1,
		gT: 1792,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Hozzákapcsolja a megfelelő műveletet adott helyzethez, történéshez, egyszerű szöveges feladathoz.',
		a: 1,
		gT: 1791,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a műveletek jeleit.',
		a: 1,
		gT: 1790,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen értelmezi a 10 000-es számkörben az összeadást, a kivonást, a szorzást, a bennfoglaló és az egyenlő részekre osztást.',
		a: 1,
		gT: 1789,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'alapműveletek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer a terület és kerület mérésére irányuló tevékenységeket.',
		a: 1,
		gT: 1788,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Területet mér különböző egységekkel lefedéssel vagy darabolással.',
		a: 1,
		gT: 1787,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Megméri különböző sokszögek kerületét különböző egységekkel.',
		a: 1,
		gT: 1786,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Összeveti azonos egységgel mért mennyiség és mérőszáma nagyságát, összeveti ugyanannak a mennyiségnek a különböző egységekkel való mérésekor kapott mérőszámait.',
		a: 1,
		gT: 1785,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a felváltást és beváltást különböző pénzcímletek között.',
		a: 1,
		gT: 1784,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer hazai és külföldi pénzcímleteket 10 000-es számkörben.',
		a: 1,
		gT: 1783,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az időmérés szabványegységeit: az órát, a percet, a másodpercet, a napot, a hetet, a hónapot, az évet.',
		a: 1,
		gT: 1782,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen használja a hosszúságmérés, az űrtartalommérés és a tömegmérés szabványegységei közül a következőket: mm, cm, dm, m, km; ml, cl, dl, l; g, dkg, kg.',
		a: 1,
		gT: 1781,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen alkalmazza a mérési módszereket, használ skálázott mérőeszközöket, helyes képzete van a mértékegységek nagyságáról.',
		a: 1,
		gT: 1780,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Megbecsül, mér alkalmi és szabványos mértékegységekkel hosszúságot, tömeget, űrtartalmat és időt.',
		a: 1,
		gT: 1779,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'mérőeszköz használata, mérési módszerek'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen írja és olvassa a számokat a tízes számrendszerben 10 000-ig.',
		a: 1,
		gT: 1778,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számok helyi értékes alakja'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a számok számjegyeinek helyi, alaki, valódi értékét.',
		a: 1,
		gT: 1777,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számok helyi értékes alakja'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a számok ezresekből, százasokból, tízesekből és egyesekből való épülését, ezresek, százasok, tízesek és egyesek összegére való bontását.',
		a: 1,
		gT: 1776,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számok helyi értékes alakja'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja a tízes számrendszerben a számok épülését a különféle számrendszerekben végzett tevékenységeivel.',
		a: 1,
		gT: 1775,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'számok helyi értékes alakja'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a római számjelek közül az i, v, x jeleket, hétköznapi helyzetekben felismeri az ezekkel képzett számokat.',
		a: 1,
		gT: 1774,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen írja az arab számjeleket.',
		a: 1,
		gT: 1773,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Számot jellemez más számokhoz való viszonyával.',
		a: 1,
		gT: 1772,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Számokat jellemez tartalmi és formai tulajdonságokkal.',
		a: 1,
		gT: 1771,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a 10 000-es számkör számainak egyes, tízes, százas, ezres szomszédjait, tízesekre, százasokra, ezresekre kerekített értékét.',
		a: 1,
		gT: 1770,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Megtalálja a számok helyét, közelítő helyét egyszerű számegyenesen, számtáblázatokban, a számegyenesnek ugyanahhoz a pontjához rendeli a számokat különféle alakjukban a 10 000-es számkörben.',
		a: 1,
		gT: 1769,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Megadja és azonosítja számok sokféle műveletes alakját.',
		a: 1,
		gT: 1768,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Nagyság szerint sorba rendez számokat, mennyiségeket.',
		a: 1,
		gT: 1767,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a következő becslési módszereket: közelítő számlálás, közelítő mérés, mérés az egység többszörösével; becslését finomítja újrabecsléssel.',
		a: 1,
		gT: 1766,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Megszámlál és leszámlál; adott (alkalmilag választott vagy szabványos) egységgel meg- és kimér a 10 000-es számkörben; oda-vissza számlál kerek tízesekkel, százasokkal, ezresekkel.',
		a: 1,
		gT: 1765,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Kis darabszámokat ránézésre felismer többféle rendezett alakban.',
		a: 1,
		gT: 1764,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a kisebb, nagyobb, egyenlő kifejezéseket a természetes számok körében.',
		a: 1,
		gT: 1763,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és helyesen használja a több, kevesebb, ugyanannyi relációkat halmazok elemszámával kapcsolatban, valamint a kisebb, nagyobb, ugyanakkora relációkat a megismert mennyiségekkel (hosszúság, tömeg, űrtartalom, idő, terület, pénz) kapcsolatban 10 000-es számkörben.',
		a: 1,
		gT: 1762,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'tájékozódás mennyiségi viszonyok között', 'természetes számok és kapcsolataik'])
	},
		{
		cG: 'altgim',
		gD: 'Egy- és többszemélyes logikai játékban döntéseit mérlegelve előre gondolkodik.',
		a: 1,
		gT: 1761,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei alapján megfogalmaz önállóan is egyszerű állításokat.',
		a: 1,
		gT: 1760,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Egy állításról ismeretei alapján eldönti, hogy igaz vagy hamis.',
		a: 1,
		gT: 1759,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat gyűjt konkrét tapasztalatai alapján matematikai állítások alátámasztására.',
		a: 1,
		gT: 1758,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Összekapcsolja az azonos matematikai tartalmú tevékenységek során szerzett tapasztalatait.',
		a: 1,
		gT: 1757,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a felismert törvényszerűségeket analógiás esetekben.',
		a: 1,
		gT: 1756,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Kérésre, illetve problémahelyzetben felidézi a kívánt, szükséges emlékképet.',
		a: 1,
		gT: 1755,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan emlékezetébe vés szavakat, számokat, utasítást, adott helyzetre vonatkozó megfogalmazást.',
		a: 1,
		gT: 1754,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan emlékezetébe vési az észlelt tárgyakat, személyeket, dolgokat, és ezek jellemző tulajdonságait, elrendezését, helyzetét.',
		a: 1,
		gT: 1753,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'ismeretek felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'Választ fogalmaz meg a felvetett kérdésre.',
		a: 1,
		gT: 1752,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'A modellben kapott megoldást értelmezi az eredeti problémára; arra vonatkoztatva ellenőrzi a megoldást.',
		a: 1,
		gT: 1751,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'A megválasztott modellen belül meghatározza a keresett adatokat.',
		a: 1,
		gT: 1750,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Az értelmezett szöveges feladathoz hozzákapcsol jól megismert matematikai modellt.',
		a: 1,
		gT: 1749,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a lényeges és a lényegtelen adatokat.',
		a: 1,
		gT: 1748,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti az ismert és a keresendő (ismeretlen) adatokat.',
		a: 1,
		gT: 1747,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenység, ábrarajzolás segítségével megold egyszerű, következtetéses, szöveges feladatokat.',
		a: 1,
		gT: 1746,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveges feladatokban megfogalmazott hétköznapi problémát megold matematikai ismeretei segítségével.',
		a: 1,
		gT: 1745,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi, elképzeli, megjeleníti a szöveges feladatban megfogalmazott hétköznapi szituációt.',
		a: 1,
		gT: 1744,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'szöveges feladatok megoldása'])
	},
		{
		cG: 'altgim',
		gD: 'Kérdést tesz fel a megfogalmazott probléma kapcsán.',
		a: 1,
		gT: 1743,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Megoldását értelmezi, ellenőrzi.',
		a: 1,
		gT: 1742,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'A problémamegoldás során a sorrendben végzett tevékenységeket szükség szerint visszafelé is elvégzi.',
		a: 1,
		gT: 1741,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Az értelmezett problémát megoldja.',
		a: 1,
		gT: 1740,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazott problémát tevékenységgel, megjelenítéssel, átfogalmazással értelmez.',
		a: 1,
		gT: 1739,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'A tevékenysége során felmerülő problémahelyzetben megoldást keres.',
		a: 1,
		gT: 1738,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'problémamegoldó gondolkodás', 'problémamegoldás'])
	},
		{
		cG: 'altgim',
		gD: 'Megkeresi két, három szempont szerint teljes rendszert alkotó, legfeljebb 48 elemű készlet hiányzó elemeit, felismeri az elemek által meghatározott rendszert.',
		a: 1,
		gT: 1737,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a rendezés felismert szempontjait.',
		a: 1,
		gT: 1736,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Megkeresi egyszerű esetekben a két, három feltételnek megfelelő összes elemet, alkotást.',
		a: 1,
		gT: 1735,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Két, három szempont szerint elrendez adott elemeket többféleképpen is; segédeszközként használja a táblázatos elrendezést és a fadiagramot.',
		a: 1,
		gT: 1734,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Sorba rendezett elemek közé elhelyez további elemeket a felismert szempont szerint.',
		a: 1,
		gT: 1733,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Adott elemeket elrendez választott és megadott szempont szerint is.',
		a: 1,
		gT: 1732,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'rendezés, rendszerezés'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen érti és alkalmazza a feladatokban a „valamennyivel\" több, kevesebb fogalmakat.',
		a: 1,
		gT: 1731,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok mint a természetes szám fogalmának egyik tapasztalati alapja'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen alkalmazza a feladatokban a több, kevesebb, ugyanannyi fogalmakat 10 000-es számkörben.',
		a: 1,
		gT: 1730,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok mint a természetes szám fogalmának egyik tapasztalati alapja'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri két halmaz elemeinek kölcsönösen egyértelmű megfeleltetését (párosítását) az elemszámok szerinti összehasonlításra.',
		a: 1,
		gT: 1729,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok mint a természetes szám fogalmának egyik tapasztalati alapja'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít véges halmazokat az elemek száma szerint.',
		a: 1,
		gT: 1728,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'halmazok mint a természetes szám fogalmának egyik tapasztalati alapja'])
	},
		{
		cG: 'altgim',
		gD: 'Hiányos állításokat igazzá tevő elemeket válogat megadott alaphalmazból.',
		a: 1,
		gT: 1727,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Keresi az okát annak, ha a halmazábra valamelyik részébe nem kerülhet egyetlen elem sem.',
		a: 1,
		gT: 1726,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megítéli, hogy adott halmazra vonatkozó állítás igaz-e, vagy hamis.',
		a: 1,
		gT: 1725,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza a halmazábra egyes részeibe kerülő elemek közös, meghatározó tulajdonságát; helyesen használja a logikai „nem\" és a logikai „és\" szavakat, valamint velük azonos értelmű kifejezéseket.',
		a: 1,
		gT: 1724,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Felsorol elemeket konkrét halmazok közös részéből.',
		a: 1,
		gT: 1723,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Két meghatározott tulajdonság egyszerre történő figyelembevételével szétválogat adott elemeket: tárgyakat, személyeket, szavakat, számokat, alakzatokat.',
		a: 1,
		gT: 1722,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Két szempontot is figyelembe vesz egyidejűleg.',
		a: 1,
		gT: 1721,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmaz adott halmazra vonatkozó állításokat; értelemszerűen használja a „mindegyik\", „nem mindegyik\", „van köztük...\", „\"egyik sem...\" és a velük rokon jelentésű szavakat.',
		a: 1,
		gT: 1720,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Talál megfelelő címkéket halmazokba rendezett elemekhez.',
		a: 1,
		gT: 1719,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Adott, címkékkel ellátott halmazábrán elhelyezett elemekről eldönti, hogy a megfelelő helyre kerültek-e; a hibás elhelyezést javítja.',
		a: 1,
		gT: 1718,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Halmazábrán is elhelyez elemeket adott címkék szerint.',
		a: 1,
		gT: 1717,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Barkochbázik valóságos és elképzelt dolgokkal is, kerüli a felesleges kérdéseket.',
		a: 1,
		gT: 1716,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi egy adott tulajdonság szerint ki nem válogatott elemek közös tulajdonságát a tulajdonság tagadásával.',
		a: 1,
		gT: 1715,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a közös tulajdonsággal rendelkező dolgok halmazába nem való elemeket.',
		a: 1,
		gT: 1714,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Személyek, tárgyak, dolgok, szavak, számok közül kiválogatja az adott tulajdonsággal rendelkező összes elemet.',
		a: 1,
		gT: 1713,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Folytatja a megkezdett válogatást felismert szempont szerint.',
		a: 1,
		gT: 1712,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a mások válogatásában együvé kerülő dolgok közös és a különválogatottak eltérő tulajdonságát.',
		a: 1,
		gT: 1711,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Válogatásokat végez saját szempont szerint személyek, tárgyak, dolgok, számok között.',
		a: 1,
		gT: 1710,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönböztet, azonosít egyedi konkrét látott, hallott, mozgással, tapintással érzékelhető tárgyakat, dolgokat, helyzeteket, jeleket.',
		a: 1,
		gT: 1709,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['matematika', 'rendszerező gondolkodás', 'válogatás, halmazok alkotása, vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Megszerzett ismereteit digitális eszközökön is alkalmazza.',
		a: 1,
		gT: 1708,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a korának megfelelő, matematikai tartalmú hallott és olvasott szövegeket.',
		a: 1,
		gT: 1707,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának megfelelően eligazodik környezetének térbeli és időbeli viszonyaiban.',
		a: 1,
		gT: 1706,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli jelenségek matematikai tartalmát, és le tudja ezeket írni számokkal, műveletekkel vagy geometriai alakzatokkal.',
		a: 1,
		gT: 1705,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Helyesen értelmezi az alapműveleteket tevékenységekkel, szövegekkel, és jártas azok elvégzésében fejben és írásban.',
		a: 1,
		gT: 1704,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Helyes képzete van a természetes számokról, érti a számnevek és számjelek épülésének rendjét.',
		a: 1,
		gT: 1703,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Jártas a mérőeszközök használatában, a mérési módszerekben.',
		a: 1,
		gT: 1702,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'A környezetében lévő dolgokat szétválogatja, összehasonlítja és rendszerezi egy-két szempont alapján.',
		a: 1,
		gT: 1701,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a tanult ismereteket és használja azokat a feladatok megoldása során.',
		a: 1,
		gT: 1700,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a környező világ mennyiségi és formai világában.',
		a: 1,
		gT: 1699,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatos megfigyeléseket tesz a környező világ tárgyaira, ezek viszonyára vonatkozóan.',
		a: 1,
		gT: 1698,
		b: 4,
		e2: 'Matematika',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'matematika'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosítja magában a nyilvános megszólalás szabadságával és felelősségével járó lehetőségeket és lehetséges következményeket, tisztában van a digitális zaklatás veszélyeivel. tudatos médiahasználóként állást tud foglalni a média által közvetített értékek minőségével kapcsolatban.',
		a: 12,
		gT: 2283,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a média véleményformáló szerepével, az alkotók és felhasználók felelősségével, az egyének és közösségek jogaival. ismeri a norma és normaszegés fogalmait a médiában.',
		a: 12,
		gT: 2282,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretekkel rendelkezik a médiaetika és a médiaszabályozás főbb kérdéseit illetően, saját álláspontot tud megfogalmazni azokkal kapcsolatban. érti a média etikai környezetének és jogi szabályozásának tétjeit.',
		a: 12,
		gT: 2281,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az internet-világ jelenségeit, a globális kommunikáció adta lehetőségeket. érti a hálózati kommunikáció és a közösségi média működési módját, képes abban felelősen részt venni, ismeri és megfelelően használja annak alapvető szövegtípusait. képes igényes önálló tartalmak alkotására és részt venni a lokális nyilvánosságban.',
		a: 12,
		gT: 2280,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a médiaipar, médiafogyasztás és -befogadás jellemzőivel. ismeri a kereskedelmi, közszolgálati és nonprofit média, az alkotói szándék, célcsoport, a közönség, mint vevő és áru, a médiafogyasztási szokások jellegzetességeit, a médiafüggőség tüneteit.',
		a: 12,
		gT: 2279,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a médiareprezentáció, valószerűség és hitelesség kritériumait, a fikciós műfajok illetve a dokumentumjelleg különbségeit, a sztereotípia, tematizáció, valóságábrázolás, hitelesség, hír fogalmait. képes saját értékelő viszonyt kialakítani ezekkel kapcsolatban.',
		a: 12,
		gT: 2278,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezni tudja a valóság és a média által a valóságról kialakított „kép\" viszonyát, ismeri a reprezentáció fogalmát, és rendelkezik a médiatudatosság képességével.',
		a: 12,
		gT: 2277,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a modern tömegkommunikáció fő működési elveit, jellemző vonásait, érti, milyen társadalmi és kulturális következményekkel járnak a kommunikációs rendszerben bekövetkező változások, ezek hatásait saját környezetében is észreveszi.',
		a: 12,
		gT: 2276,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a sztárfogalom kialakulásával és módosulásával. azonosítani tudja a sztárjelenséget a filmen és a médiában. képes ismert filmszereplők és médiaszemélyiségek imázsának elemzésére, a háttérben fellelhető archetípusok meghatározására.',
		a: 12,
		gT: 2275,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar filmművészet főbb szerzőit, jellegzetességeit és értékeit.',
		a: 12,
		gT: 2274,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismereteket szerez a filmkultúra területéről: érti a szerzői kultúra és a tömegkultúra eltérő működésmódját; felismeri az elterjedtebb filmműfajok jegyeit; különbséget tud tenni a különböző stílusirányzatokhoz tartozó alkotások között.',
		a: 12,
		gT: 2273,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid média-alkotások tervezése és kivitelezése révén szert tesz a különböző médiumok szövegalkotási folyamatainak elemi tapasztalataira, érti a különféle szövegtípusok eltérő működési elvét, s tud azok széles spektrumával kreatív befogadói viszonyt létrehozni.',
		a: 12,
		gT: 2272,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Képes különböző médiatermékek értő befogadására. ismeri a különböző médiumok formanyelvének alapvető eszköztárát, érzékeli ezek hatását az értelmezés folyamatára, valamint képes ezeknek az eszközöknek alapszintű alkalmazására is saját környezetében.',
		a: 12,
		gT: 2271,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Rendelkezik átfogó egyetemes és magyar médiatörténeti ismeretekkel. ismeri a különböző médiumok specifikumait, a fontosabb műfajokat, szerzőket, műveket.',
		a: 12,
		gT: 2270,
		b: 12,
		e2: 'Mozgóképkultúra és médiaismeret',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'mozgóképkultúra és médiaismeret'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a környezetében fellelhető, megfigyelhető szakmák, hivatások jellemzőit.',
		a: 1,
		gT: 2463,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'felkészülés a munka világára'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egymásért végzett munka fontosságát, a munkamegosztás értékét.',
		a: 1,
		gT: 2462,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'felkészülés a munka világára'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival munkamegosztás szerint együttműködik a csoportos munkavégzés során.',
		a: 1,
		gT: 2461,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'felkészülés a munka világára'])
	},
		{
		cG: 'altgim',
		gD: 'Az elvárt feladatokban önállóan dolgozik -- elvégzi a műveletet.',
		a: 1,
		gT: 2460,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan megtartja az egészséges és biztonságos munkakörnyezetét.',
		a: 1,
		gT: 2459,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használni, alkalmazni tudja a legfontosabb közlekedési lehetőségeket, szabályokat, viselkedési elvárásokat.',
		a: 1,
		gT: 2458,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'környezet- és egészségtudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egészségmegőrzés tevékenységeit.',
		a: 1,
		gT: 2457,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'környezet- és egészségtudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tudatos vásárlás néhány fontos elemét.',
		a: 1,
		gT: 2456,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'fogyasztói, pénzügyi-gazdálkodási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Takarékosan gazdálkodik az anyaggal, energiával, idővel.',
		a: 1,
		gT: 2455,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'fogyasztói, pénzügyi-gazdálkodási tudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Otthoni és iskolai környezetének, tevékenységeinek balesetveszélyes helyzeteit felismeri, és ismeri megelőzésük módját.',
		a: 1,
		gT: 2454,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'életvezetés, fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a családellátó tevékenységeket, melyek keretében vállalt feladatait az iskolai önellátás során munkamegosztásban végzi -- terítés, rendrakás, öltözködés, növények, állatok gondozása stb..',
		a: 1,
		gT: 2453,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'életvezetés, fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Rendelkezik az életkorának megfelelő szintű probléma-felismerési, probléma-megoldási képességgel.',
		a: 1,
		gT: 2452,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'technikai-problémamegoldó gondolkodás', 'probléma-megoldási stratégia'])
	},
		{
		cG: 'altgim',
		gD: 'Szelektíven gyűjti a hulladékot.',
		a: 1,
		gT: 2451,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'technikai-problémamegoldó gondolkodás', 'az emberi tevékenység környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a takarékos anyagfelhasználásra.',
		a: 1,
		gT: 2450,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'technikai-problémamegoldó gondolkodás', 'az emberi tevékenység környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Rendet tart a környezetében.',
		a: 1,
		gT: 2449,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'technikai-problémamegoldó gondolkodás', 'az emberi tevékenység környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy tevékenysége során tud változtatni közvetlen környezetén, megóvhatja, javíthat annak állapotán.',
		a: 1,
		gT: 2448,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'technikai-problémamegoldó gondolkodás', 'az emberi tevékenység környezete'])
	},
		{
		cG: 'altgim',
		gD: 'Értékelés után megfogalmazza tapasztalatait, következtetéseket von le a későbbi eredményesebb munkavégzés érdekében.',
		a: 1,
		gT: 2447,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tárgykészítés, tervezés, kivitelezés, értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Saját és társai tevékenységét a kitűzött célok mentén, megadott szempontok szerint reálisan értékeli.',
		a: 1,
		gT: 2446,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tárgykészítés, tervezés, kivitelezés, értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotótevékenysége során előkészítő, alakító, szerelő és felületkezelő műveleteket végez el.',
		a: 1,
		gT: 2445,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tárgykészítés, tervezés, kivitelezés, értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű szöveges, rajzos és képi utasításokat hajt végre a tevékenysége során.',
		a: 1,
		gT: 2444,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tárgykészítés, tervezés, kivitelezés, értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján egyszerűbb tárgyakat önállóan tervez, készít, alkalmazza a tanult munkafolyamatokat.',
		a: 1,
		gT: 2443,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tárgykészítés, tervezés, kivitelezés, értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotótevékenysége során figyelembe veszi az anyag tulajdonságait, felhasználhatóságát.',
		a: 1,
		gT: 2442,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'anyagok vizsgálata és kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Az anyagok tulajdonságairól érzékszervi úton, önállóan szerez ismereteket -- szín, alak, átlátszóság, szag, keménység, rugalmasság, felületi minőség.',
		a: 1,
		gT: 2441,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'anyagok vizsgálata és kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egymásért végzett munka fontosságát, a munkamegosztás értékét.',
		a: 1,
		gT: 2440,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenysége során munkatapasztalatot szerez, megéli az alkotás örömét, az egyéni és csapatsiker élményét.',
		a: 1,
		gT: 2439,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotótevékenysége során megéli, megismeri a jeles napokat, ünnepeket, hagyományokat mint értékeket.',
		a: 1,
		gT: 2438,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok mentén értékeli saját, a társak, a csoport munkáját, viszonyítja a kitűzött célokhoz.',
		a: 1,
		gT: 2437,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Munkafolyamatokat, technológiákat segítséggel algoritmizál.',
		a: 1,
		gT: 2436,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveg vagy rajz alapján épít, tárgyakat készít, alkalmazza a tanult munkafolyamatokat, terveit megosztja.',
		a: 1,
		gT: 2435,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Kitartó a munkavégzésben, szükség esetén segítséget kér, segítséget ad.',
		a: 1,
		gT: 2434,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy tevékenységei során változtatni tud a közvetlen környezetén.',
		a: 1,
		gT: 2433,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Elkülöníti a természeti és mesterséges környezet jellemzőit.',
		a: 1,
		gT: 2432,
		b: 4,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'A fizikai és digitális környezetből információt gyűjt a számára vonzó foglalkozások alkalmassági és képesítési feltételeiről, keresi a vállalkozási lehetőségeket, a jövedelmezőséget és a jellemző tanulási utakat.',
		a: 5,
		gT: 2511,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'felkészülés a munka világára -- pályaorientáció, életpálya-tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyes modulokhoz kapcsolódó foglalkozások jellemzőit, ezekkel kapcsolatban megfogalmazza saját preferenciáit.',
		a: 5,
		gT: 2510,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'felkészülés a munka világára -- pályaorientáció, életpálya-tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a társadalmi munkamegosztás lényegét, az egyes foglalkoztatási ágazatok jelentőségét.',
		a: 5,
		gT: 2509,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyes részfeladatokat rendszerszinten szemléli.',
		a: 5,
		gT: 2508,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a döntés-előkészítés, döntéshozatal eljárásait, hibás döntésein változtat.',
		a: 5,
		gT: 2507,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazkodik a változó munkafeladatokhoz, szerepelvárásokhoz; vezetőként tudatosan vezeti a csoport döntési folyamatát.',
		a: 5,
		gT: 2506,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Önismeretére építve vállal feladatokat, szem előtt tartva a csapat eredményességét.',
		a: 5,
		gT: 2505,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Terv szerint tevékenykedik, probléma esetén észszerű kockázatokat felvállal.',
		a: 5,
		gT: 2504,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'munkakultúra', 'munkavégzési szokások'])
	},
		{
		cG: 'altgim',
		gD: 'Egészség- és környezettudatosan dönt és tevékenykedik.',
		a: 5,
		gT: 2503,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'fogyasztói, pénzügyi-gazdálkodási, környezet- és egészségtudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a saját, a családi és a társadalmi erőforrásokkal és az azokkal való hatékony és tudatos gazdálkodás módjaival.',
		a: 5,
		gT: 2502,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'fogyasztói, pénzügyi-gazdálkodási, környezet- és egészségtudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszerszinten végzi az elemzést és az alkalmazást.',
		a: 5,
		gT: 2501,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'fogyasztói, pénzügyi-gazdálkodási, környezet- és egészségtudatosság'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri saját felelősségét életvezetése megtervezésében és megszervezésében, tudatosan gazdálkodik a rendelkezésre álló anyagi és nem anyagi erőforrásokkal.',
		a: 5,
		gT: 2500,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'tudatos életvezetés, környezeti, társadalmi és gazdasági fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a személyes cselekvés jelentőségét a globális problémák megoldásában.',
		a: 5,
		gT: 2499,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'tudatos életvezetés, környezeti, társadalmi és gazdasági fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Döntéseit tudatosság jellemzi, alternatívákat mérlegel.',
		a: 5,
		gT: 2498,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'tudatos életvezetés, környezeti, társadalmi és gazdasági fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Holisztikus szemlélettel rendelkezik, az összefüggések megértésére törekszik.',
		a: 5,
		gT: 2497,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'életvitel', 'tudatos életvezetés, környezeti, társadalmi és gazdasági fenntarthatóság'])
	},
		{
		cG: 'altgim',
		gD: 'Komplex szempontrendszer mentén választ stratégiát, optimalizál.',
		a: 5,
		gT: 2496,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A problémamegoldás során önállóan vagy társakkal együtt fogalmaz meg megoldási alternatívákat.',
		a: 5,
		gT: 2495,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a technikai fejlődés és a társadalmi, gazdasági fejlődés kapcsolatát.',
		a: 5,
		gT: 2494,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenységének tervezésénél és értékelésénél figyelembe vesz környezeti szempontokat.',
		a: 5,
		gT: 2493,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és értékeli a globális változásokat érintő lehetséges megoldások és az emberi tevékenység szerepét, jelentőségét.',
		a: 5,
		gT: 2492,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Szempontokat határoz meg a környezeti állapot felméréséhez, bizonyos eltéréseket számszerűsít.',
		a: 5,
		gT: 2491,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'technikai-problémamegoldó gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti az egyén felelősségét a közös értékteremtésben.',
		a: 5,
		gT: 2490,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'A használatbavétel során, az eltéréseket kiindulópontként alkalmazva javaslatot tesz produktuma továbbfejlesztésére.',
		a: 5,
		gT: 2489,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok mentén értékeli saját és mások munkáját.',
		a: 5,
		gT: 2488,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'értékelés'])
	},
		{
		cG: 'altgim',
		gD: 'A csoportban feladata szerint tevékenykedik, tudását megosztja.',
		a: 5,
		gT: 2487,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Felméri és tervezi a tevékenység munkavédelmi szabályait.',
		a: 5,
		gT: 2486,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportmunkában feladatot vállal, részt vesz a döntéshozatalban, és a döntésnek megfelelően tevékenykedik.',
		a: 5,
		gT: 2485,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Részt vesz a munkavégzési szabályok megalkotásában, betartja azokat.',
		a: 5,
		gT: 2484,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'A megismert szerszámokat és eszközöket önállóan, az újakat tanári útmutatással használja.',
		a: 5,
		gT: 2483,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a forma és funkció összefüggéseit, önállóan választ szerszámot, eszközt.',
		a: 5,
		gT: 2482,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'A terv szerinti lépések megtartásával, önellenőrzéssel halad alkotótevékenységében.',
		a: 5,
		gT: 2481,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Terveit a műszaki kommunikáció alkalmazásával osztja meg.',
		a: 5,
		gT: 2480,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenységét önállóan vagy társakkal együttműködve tervezi.',
		a: 5,
		gT: 2479,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'tervezés, kivitelezés'])
	},
		{
		cG: 'altgim',
		gD: 'Környezeti, fenntarthatósági szempontokat is mérlegelve, céljainak megfelelően választ a rendelkezésre álló anyagokból.',
		a: 5,
		gT: 2478,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'anyagok vizsgálata és kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan szerez információt megfigyelés, vizsgálat, adatgyűjtés útján.',
		a: 5,
		gT: 2477,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['technika és tervezés', 'alkotótevékenység', 'anyagok vizsgálata és kiválasztása'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az emberi cselekvés jelentőségét és felelősségét a környezetalakításban.',
		a: 5,
		gT: 2476,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Értékként tekint saját és mások alkotásaira, a létrehozott produktumokra.',
		a: 5,
		gT: 2475,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli az elvégzett munkákat, az értékelésben elhangzottakat felhasználja a későbbi munkavégzés során.',
		a: 5,
		gT: 2474,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Az elkészült produktumot használatba veszi, a tervhez viszonyítva értékeli saját, mások és a csoport munkáját.',
		a: 5,
		gT: 2473,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'A tevékenység során társaival együttműködik, feladatmegosztás szerint tevékenykedik.',
		a: 5,
		gT: 2472,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az egyes műveletek jelentőségét a munka biztonságának, eredményességének vonatkozásában.',
		a: 5,
		gT: 2471,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Munkavégzéskor szabálykövető, kooperatív magatartást követ.',
		a: 5,
		gT: 2470,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Törekszik a balesetmentes tevékenységre, a munkaterületen rendet tart.',
		a: 5,
		gT: 2469,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Célszerűen választja ki és rendeltetésszerűen használja a szükséges szerszámokat, eszközöket, digitális alkalmazásokat.',
		a: 5,
		gT: 2468,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Tervek mentén folytatja alkotótevékenységét.',
		a: 5,
		gT: 2467,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és betartja az alapvető munkavédelmi szabályokat.',
		a: 5,
		gT: 2466,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Tevékenységét megtervezi, terveit másokkal megosztja.',
		a: 5,
		gT: 2465,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a felhasznált anyagok vizsgálati lehetőségeit és módszereit, tulajdonságait, és céljainak megfelelően választ a rendelkezésre álló anyagokból.',
		a: 5,
		gT: 2464,
		b: 7,
		e2: 'Technika és tervezés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'technika és tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Piktogramok alapján megfogalmazza a várható időjárást.',
		a: 5,
		gT: 2639,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az időjárás-jelentést.',
		a: 5,
		gT: 2638,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi az évszakok változását.',
		a: 5,
		gT: 2637,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Jellemezi és összehasonlítja az egyes éghajlati övezeteket (forró, mérsékelt, hideg).',
		a: 5,
		gT: 2636,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi az éghajlat fő elemeit.',
		a: 5,
		gT: 2635,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarázza az éghajlat és a folyók vízjárása közötti összefüggéseket.',
		a: 5,
		gT: 2634,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarázza a felszín lejtése, a folyó vízhozama, munkavégző képessége és a felszínformálás közti összefüggéseket.',
		a: 5,
		gT: 2633,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és összehasonlítja a gyűrődés, a vetődés, a földrengés és a vulkáni tevékenység hatásait.',
		a: 5,
		gT: 2632,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer olyan módszereket, melyek a talajpusztulás ellen hatnak (tápanyag-visszapótlás, komposztkészítés, ökológiai kertművelés).',
		a: 5,
		gT: 2631,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy a talajpusztulás világméretű probléma.',
		a: 5,
		gT: 2630,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat hoz a kőzetek tulajdonságai és a felhasználásuk közötti összefüggésekre.',
		a: 5,
		gT: 2629,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megállapítja, összehasonlítja és csoportosítja néhány jellegzetes hazai kőzet egyszerűen vizsgálható tulajdonságait.',
		a: 5,
		gT: 2628,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a föld belső és külső erői és folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az energiatermelés hatását a természetes és a mesterséges környezetre.',
		a: 5,
		gT: 2627,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az energia fogalma'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat hoz a megújuló és a nem megújuló energiaforrások felhasználására.',
		a: 5,
		gT: 2626,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az energia fogalma'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportosítja az energiahordozókat különböző szempontok alapján.',
		a: 5,
		gT: 2625,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az energia fogalma'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a természeti erők szerepével a felszínalakításban.',
		a: 5,
		gT: 2624,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élettelen környezet elemei, alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a természeti erőforrások energiatermelésben betöltött szerepét.',
		a: 5,
		gT: 2623,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élettelen környezet elemei, alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Összetett rendszerként értelmezi az egyes földi szférák működését.',
		a: 5,
		gT: 2622,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élettelen környezet elemei, alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az egészséges életmód alapelveivel, azokat igyekszik betartani.',
		a: 5,
		gT: 2621,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a kamaszkori testi és lelki változások folyamatát, élettani hátterét.',
		a: 5,
		gT: 2620,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Látja az összefüggéseket az egyes szervek működése között.',
		a: 5,
		gT: 2619,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi az emberi test fő részeit, szerveit.',
		a: 5,
		gT: 2618,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az egészséges környezet és az egészségmegőrzés közti összefüggéssel.',
		a: 5,
		gT: 2617,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a testi és lelki egészség védelmének fontosságával.',
		a: 5,
		gT: 2616,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy a szervezet rendszerként működik.',
		a: 5,
		gT: 2615,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az emberi szervezet egészséges működése'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a vízi társulások természetvédelmi értékével, fontosnak tartja annak védelmét.',
		a: 5,
		gT: 2614,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákon keresztül bemutatja a vízhasznosítás és a vízszennyezés életközösségre gyakorolt hatásait.',
		a: 5,
		gT: 2613,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Táplálékláncokat és ezekből táplálékhálózatot állít össze a megismert vízi és vízparti növény- és állatfajokból.',
		a: 5,
		gT: 2612,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal bizonyítja, rendszerezi és következtetéseket von le a vízi élőlények környezethez történő alkalmazkodására vonatkozóan.',
		a: 5,
		gT: 2611,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és magyarázza az élőhely -- életmód - testfelépítés összefüggéseit a vízi és vízparti életközösségek esetén.',
		a: 5,
		gT: 2610,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja a vízi és szárazföldi élőhelyek környezeti tényezőit.',
		a: 5,
		gT: 2609,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli hazánk vízi és vízparti élőlénytársulásainak főbb jellemzőit.',
		a: 5,
		gT: 2608,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a fátlan társulások természetvédelmi értékével, fontosnak tartja annak védelmét.',
		a: 5,
		gT: 2607,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákon keresztül mutatja be a mezőgazdasági tevékenységek életközösségre gyakorolt hatásait.',
		a: 5,
		gT: 2606,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Táplálékláncokat és azokból táplálékhálózatot állít össze a megismert mezei növény- és állatfajokból.',
		a: 5,
		gT: 2605,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal bizonyítja, rendszerezi és következtetéseket von le a mezei élőlények környezethez történő alkalmazkodására vonatkozóan.',
		a: 5,
		gT: 2604,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és magyarázza az élőhely - életmód - testfelépítés összefüggéseit a rétek életközössége esetén.',
		a: 5,
		gT: 2603,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján összehasonlítja a rétek és a szántóföldek életközösségeit.',
		a: 5,
		gT: 2602,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli hazánk fátlan élőlénytársulásainak főbb jellemzőit.',
		a: 5,
		gT: 2601,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az erdő természetvédelmi értékével, fontosnak tartja annak védelmét.',
		a: 5,
		gT: 2600,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákon keresztül bemutatja az erdőgazdálkodási tevékenységek életközösségre gyakorolt hatásait.',
		a: 5,
		gT: 2599,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Táplálékláncokat és azokból táplálékhálózatot állít össze a megismert erdei növény- és állatfajokból.',
		a: 5,
		gT: 2598,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Példákkal bizonyítja, rendszerezi és következtetéseket von le az erdei élőlények környezethez történő alkalmazkodására vonatkozóan.',
		a: 5,
		gT: 2597,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és magyarázza az élőhely -- életmód - testfelépítés összefüggéseit az erdők életközössége esetén.',
		a: 5,
		gT: 2596,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Életközösségként értelmezi az erdőt, mezőt, vizes élőhelyeket.',
		a: 5,
		gT: 2595,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli hazánk erdei élőlénytársulásainak főbb jellemzőit.',
		a: 5,
		gT: 2594,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Mikroszkóp segítségével megfigyel egysejtű élőlényeket.',
		a: 5,
		gT: 2593,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a gerinctelen és a gerinces állatok testfelépítése közötti különbségeket.',
		a: 5,
		gT: 2592,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Az állatokat különböző szempontok szerint csoportosítja.',
		a: 5,
		gT: 2591,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi az állatok testrészeit, megfigyeli jellemzőiket, megfogalmazza ezek funkcióit.',
		a: 5,
		gT: 2590,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít ismert hazai házi vagy vadon élő állatokat adott szempontok (testfelépítés, életfeltételek, szaporodás) alapján.',
		a: 5,
		gT: 2589,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi az állatok életfeltételeit és életjelenségeit.',
		a: 5,
		gT: 2588,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az állatok testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a lágyszárú és a fás szárú növények testfelépítése közötti különbségeket.',
		a: 5,
		gT: 2587,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismert hazai termesztett vagy vadon élő növényeket különböző szempontok szerint csoportosít.',
		a: 5,
		gT: 2586,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja ismert hazai termesztett vagy vadon élő növények részeit megadott szempontok alapján.',
		a: 5,
		gT: 2585,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a növények részeit, megfigyeli jellemzőiket, megfogalmazza ezek funkcióit.',
		a: 5,
		gT: 2584,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít ismert hazai termesztett vagy vadon élő növényeket adott szempontok (testfelépítés, életfeltételek, szaporodás) alapján.',
		a: 5,
		gT: 2583,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a növények életfeltételeit, életjelenségeit.',
		a: 5,
		gT: 2582,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a növények testfelépítése'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy az élő rendszerekbe történő beavatkozás káros hatásokkal járhat.',
		a: 5,
		gT: 2581,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élőlények felépítése és az élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az életfeltételek és a testfelépítés közti kapcsolattal.',
		a: 5,
		gT: 2580,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élőlények felépítése és az élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Komplex rendszerként értelmezi az élő szervezeteket és az ezekből felépülő élőlénytársulásokat.',
		a: 5,
		gT: 2579,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élőlények felépítése és az élőlénytársulások alapvető folyamatai'])
	},
		{
		cG: 'altgim',
		gD: 'Használni tud néhány egyszerű térinformatikai alkalmazást.',
		a: 5,
		gT: 2578,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'gyakorlati jellegű térképészeti ismeretek (az iskola környékének megismerése során, terepi munkában'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározott szempontok alapján útvonalat tervez a térképen.',
		a: 5,
		gT: 2577,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'gyakorlati jellegű térképészeti ismeretek (az iskola környékének megismerése során, terepi munkában'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a terepen térképvázlat, iránytű és gps segítségével.',
		a: 5,
		gT: 2576,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'gyakorlati jellegű térképészeti ismeretek (az iskola környékének megismerése során, terepi munkában'])
	},
		{
		cG: 'altgim',
		gD: 'A valóságban megismert területről egyszerű, jelrendszerrel ellátott útvonaltervet, térképet készít.',
		a: 5,
		gT: 2575,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'gyakorlati jellegű térképészeti ismeretek (az iskola környékének megismerése során, terepi munkában'])
	},
		{
		cG: 'altgim',
		gD: 'Bejelöli a térképen budapestet és a saját lakóhelyéhez közeli fontosabb nagyvárosokat és a szomszédos országokat.',
		a: 5,
		gT: 2574,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megnevezi a legjelentősebb hazai álló- és folyóvizeket.',
		a: 5,
		gT: 2573,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a főfolyó, a mellékfolyó és a torkolat térképi ábrázolását.',
		a: 5,
		gT: 2572,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza európa és magyarország tényleges és viszonylagos földrajzi fekvését.',
		a: 5,
		gT: 2571,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a nevezetes szélességi köröket a térképen.',
		a: 5,
		gT: 2570,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a földrészeket és az óceánokat a különböző méretarányú és ábrázolásmódú térképeken.',
		a: 5,
		gT: 2569,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'topográfiai ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és használja a térképi jelrendszert és a térképfajtákat (domborzati térkép, közigazgatási térkép, autós térkép, turista térkép).',
		a: 5,
		gT: 2568,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'alapvető térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Fő- és mellékégtájak segítségével meghatározza különböző földrajzi objektumok egymáshoz viszonyított helyzetét.',
		a: 5,
		gT: 2567,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'alapvető térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a méretarány és az ábrázolás részletessége közötti összefüggéseket.',
		a: 5,
		gT: 2566,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'alapvető térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a felszínformák ábrázolását a térképen.',
		a: 5,
		gT: 2565,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'alapvető térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Mágneses kölcsönhatásként értelmezi az iránytű működését.',
		a: 5,
		gT: 2564,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'alapvető térképészeti ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a térképen és a földgömbön.',
		a: 5,
		gT: 2563,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a térbeli tájékozódás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a térkép és a valóság közötti viszonyt.',
		a: 5,
		gT: 2562,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a térbeli tájékozódás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza az irányt a valós térben.',
		a: 5,
		gT: 2561,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'a térbeli tájékozódás fejlesztése'])
	},
		{
		cG: 'altgim',
		gD: 'Modellezi a nap és a föld helyzetét a különböző napszakokban és évszakokban.',
		a: 5,
		gT: 2560,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti a föld mozgásai és a napi, évi időszámítás közötti összefüggéseket.',
		a: 5,
		gT: 2559,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a természet ciklikus változásait.',
		a: 5,
		gT: 2558,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Tervet készít saját időbeosztására vonatkozóan.',
		a: 5,
		gT: 2557,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja értelmezni az időt különböző dimenziójú skálákon.',
		a: 5,
		gT: 2556,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az idő múlásával bekövetkező változásokat és ezek összefüggéseit az élő és élettelen környezet elemein.',
		a: 5,
		gT: 2555,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'tájékozódás az időben'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérleti úton megfigyeli az időjárás alapvető folyamatait, magyarázza ezek okait és következményeit.',
		a: 5,
		gT: 2554,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'megfigyelés, kísérletezés, tapasztalás'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérletekkel igazolja a növények életfeltételeit.',
		a: 5,
		gT: 2553,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'megfigyelés, kísérletezés, tapasztalás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseken és kísérleten keresztül megismeri az energiatermelésben szerepet játszó anyagokat és az energiatermelés folyamatát.',
		a: 5,
		gT: 2552,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'megfigyelés, kísérletezés, tapasztalás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a testek elektromos állapotát és a köztük lévő kölcsönhatásokat, ismeri ennek gyakorlati életben való megjelenését.',
		a: 5,
		gT: 2551,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'megfigyelés, kísérletezés, tapasztalás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a mágneses kölcsönhatásokat, kísérlettel igazolja a vonzás és a taszítás jelenségét, példákat ismer a mágnesesség gyakorlati életben való felhasználására.',
		a: 5,
		gT: 2550,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'megfigyelés, kísérletezés, tapasztalás'])
	},
		{
		cG: 'altgim',
		gD: 'Leolvassa és értékeli a magyarországra vonatkozó éghajlati diagramok és éghajlati térképek adatait.',
		a: 5,
		gT: 2549,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'mérések, mértékegységek, mérőeszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Magyarországra vonatkozó adatok alapján kiszámítja a napi középhőmérsékletet, a napi és évi közepes hőingást.',
		a: 5,
		gT: 2548,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'mérések, mértékegységek, mérőeszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Észleli, méri az időjárási elemeket, a mért adatokat rögzíti, ábrázolja.',
		a: 5,
		gT: 2547,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'mérések, mértékegységek, mérőeszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan végez becsléseket, méréseket és használ mérőeszközöket a hőmérséklet, a hosszúság, a tömeg, az űrtartalom és az idő meghatározására.',
		a: 5,
		gT: 2546,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'mérések, mértékegységek, mérőeszközök'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a hely- és helyzetváltoztatást és példákat keres ezekre megadott szempontok alapján.',
		a: 5,
		gT: 2545,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Vizsgálat révén azonosítja a tipikus lágyszárú és fásszárú növények részeit.',
		a: 5,
		gT: 2544,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Korábbi tapasztalatai és megfigyelései révén felismeri a levegő egyes tulajdonságait.',
		a: 5,
		gT: 2543,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a talaj élő és élettelen alkotóelemeit, tulajdonságait, összehasonlít különböző típusú talajféleségeket, valamint következtetések révén felismeri a talajnak, mint rendszernek a komplexitását.',
		a: 5,
		gT: 2542,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Elsajátítja a tűzveszélyes anyagokkal való bánásmódot, ismeri tűz esetén a szükséges teendőket.',
		a: 5,
		gT: 2541,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az olvadás és az oldódás közötti különbséget kísérleti tapasztalatok alapján.',
		a: 5,
		gT: 2540,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérletek során megfigyeli a különböző halmazállapotú anyagok vízben oldódásának folyamatát.',
		a: 5,
		gT: 2539,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeli a különböző halmazállapot-változásokhoz (olvadás, fagyás, párolgás, forrás, lecsapódás) kapcsolódó folyamatokat, példákat gyűjt hozzájuk a természetben, a háztartásban és az iparban.',
		a: 5,
		gT: 2538,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Bizonyítja, és hétköznapi példákkal alátámasztja a víz fagyásakor történő térfogat-növekedést.',
		a: 5,
		gT: 2537,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Korábbi tapasztalatai és megfigyelései révén felismeri a víz különböző tulajdonságait, különböző szempontok alapján rendszerezi a vizek fajtáit.',
		a: 5,
		gT: 2536,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'anyagok és tulajdonságaik'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan végez egyszerű kísérleteket.',
		a: 5,
		gT: 2535,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élő és élettelen környezet vizsgálatának alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan végez becsléseket, méréseket és használ mérőeszközöket különféle fizikai paraméterek meghatározására.',
		a: 5,
		gT: 2534,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élő és élettelen környezet vizsgálatának alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismer és megfigyel különböző természetes és mesterséges anyagokat, ismeri azok tulajdonságait, felhasználhatóságukat, ismeri a természetes és mesterséges környezetre gyakorolt hatásukat.',
		a: 5,
		gT: 2533,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élő és élettelen környezet vizsgálatának alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és megfigyeli a környezetben előforduló élő és élettelen anyagokat, megadott vagy önállóan kitalált szempontok alapján csoportosítja azokat.',
		a: 5,
		gT: 2532,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['természettudomány', 'az élő és élettelen környezet vizsgálatának alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakul benne a természettudomány iránti érdeklődés.',
		a: 5,
		gT: 2531,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakul benne a szűkebb, illetve tágabb környezet iránti felelősségtudat.',
		a: 5,
		gT: 2530,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei bővítéséhez tanári útmutatás mellett kutatásokat végez a nyomtatott és digitális források felhasználásával.',
		a: 5,
		gT: 2529,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'A szöveggel, táblázattal és jelekkel kapott információt önállóan értelmezi, azokból következtetéseket von le.',
		a: 5,
		gT: 2528,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseiről, tapasztalatairól szóban, írásban, rajzban beszámol.',
		a: 5,
		gT: 2527,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseket, összehasonlításokat, csoportosításokat, méréseket és kísérleteket végez.',
		a: 5,
		gT: 2526,
		b: 6,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'természettudomány'])
	},
		{
		cG: 'altgim',
		gD: 'Képes saját ökológiai lábnyomának kiszámítására, helyesen értékeli a változtatási lehetőségeit.',
		a: 11,
		gT: 3984,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Jövőképek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a globális hálózatok kialakulásának folyamatait, az ebben rejlő veszélyeket.',
		a: 11,
		gT: 3983,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Jövőképek'])
	},
		{
		cG: 'altgim',
		gD: 'Reálisan értékeli a hulladékelhelyezés környezeti problémáit, az ebből származó hosszú távú kockázatokat, átlátja a probléma mérséklésében a személyes szerepvállalás lehetőségeit.',
		a: 11,
		gT: 3982,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Jövőképek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az alapvető ásványok és kőzetek, fosszilis energiahordozók 21. századi hasznosítási trendjeit, tájékozott az ásványvagyon kimerülési prognózisait illetően, átlátja az ebből eredő konfliktusforrásokat.',
		a: 11,
		gT: 3981,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Jövőképek'])
	},
		{
		cG: 'altgim',
		gD: 'Példák segítségével bemutatja a közeljövő lehetséges legfontosabb szintetikus anyagait.',
		a: 11,
		gT: 3980,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Jövőképek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes egyszerű online, szabadfelhasználású szoftverek segítségével egyszerű feladatok megoldására.',
		a: 11,
		gT: 3979,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az űrfelvételek sajátosságait, alkalmazási területeit.',
		a: 11,
		gT: 3978,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a mesterséges égitestek (műholdak) jelentőségét és szerepét a mindennapi életben.',
		a: 11,
		gT: 3977,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a Föld kozmikus hatások elleni védőernyőit, különös tekintettel az ózonpajzs szerepére, az azt károsító antropogén folyamatokra és következményeire.',
		a: 11,
		gT: 3976,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a napfény különféle tartományainak pozitív és káros földi hatásait, értékeli a földi élet kialakulásában és fennmaradásában játszott szerepét.',
		a: 11,
		gT: 3975,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a Föld, a Hold és a bolygók legfontosabb jellemzőit, mozgásait, valamint ezek következményeit, összefüggéseit.',
		a: 11,
		gT: 3974,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Elhelyezi a Földet a Világegyetemben és a Naprendszerben.',
		a: 11,
		gT: 3973,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Kozmikus környezetünk'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a szervi és pszichés betegségek korai felismerésének jelentőségéről, ismeri a legfontosabb tüneteket, jelentkezésük esetén szakszerű segítséget kér.',
		a: 11,
		gT: 3972,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a függőség veszélyeit, törekszik az egészségkárosító szenvedélyek elkerülésére.',
		a: 11,
		gT: 3971,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Étkezésében tudatosabban követi az egészségmegőrzés elveit, ügyel az élelmiszer-biztonsági szabályok betartására.',
		a: 11,
		gT: 3970,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy a szív- és érrendszeri, valamint a daganatos megbetegedésekben szerepük lehet a környezet bizonyos hatásainak, igyekszik ezeket csökkenteni, elkerülni.',
		a: 11,
		gT: 3969,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az ívóvíz meghatározó forrásait (felszín alatti vizek, felszíni vizek), példák alapján bemutatja az ivóvíz minőségét veszélyeztető emberi tevékenységeket.',
		a: 11,
		gT: 3968,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Reálisan értékeli a talaj meghatározó szerepét a tiszta, egészséges élelmiszer-termelésben, ismer a talajminőséget veszélyeztető antropogén folyamatokat.',
		a: 11,
		gT: 3967,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan értékeli a lakókörnyezetének levegőminőségére vonatkozó információkat, érti a szmogriadó különféle fokozatai esetén elrendelt intézkedések célját, támogatja a települési levegőminőség védelmét szolgáló intézkedéseket, adott esetben maga is kezdeményez.',
		a: 11,
		gT: 3966,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Környezet és egészség'])
	},
		{
		cG: 'altgim',
		gD: 'Kommunikációjában megfelelően használ természetvédelemmel kapcsolatos szakkifejezéseket (pl. biodiverzitás, ökológiai egyensúly, invazív faj…), környezeti kérdésekben vállalja a vitát, tényekre alapozottan érvel.',
		a: 11,
		gT: 3965,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az élővilág sokszínűsége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a környezeti minőséget jellemző főbb adatok jelentőségét, ismeri a levegő, a vizek és a talaj legfontosabb minőségjelzőit, ezek alapján következtet az élővilágra gyakorolt hatásukra.',
		a: 11,
		gT: 3964,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az élővilág sokszínűsége'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosabban figyeli a lakókörnyezetében élő növény- és állatvilágot, ismeri ezek védettségi helyzetét, igyekszik megőrizni a természeti értékeket.',
		a: 11,
		gT: 3963,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az élővilág sokszínűsége'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét példákkal támasztja alá az éghajlatváltozásnak az élővilágra gyakorolt hatását.',
		a: 11,
		gT: 3962,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az élővilág sokszínűsége'])
	},
		{
		cG: 'altgim',
		gD: 'Képeken, filmeken, leírásokban és saját megfigyelései során felismeri a Föld nagy biomjait, ismeri ezek elhelyezkedését a Földön, a területük gazdasági és társadalmi helyzetét összefüggésbe hozza a várható jövőjükke.',
		a: 11,
		gT: 3961,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az élővilág sokszínűsége'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az éghajlatváltozás mérséklésére tett nemzetközi és hazai kezdeményezéseket, reálisan értékeli személyes szerepvállalási lehetőségeit a kérdésben.',
		a: 11,
		gT: 3960,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az éghajlat várható alakulását vizsgáló számítógépes klímamodellek működését, főbb elemeit, elfogadja, hogy ezek eredményei valószínűségi jellegűek.',
		a: 11,
		gT: 3959,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy a már bekövetkezett, illetve a jövőben várható éghajlatváltozás kezelése egyszerre igényli a megelőzés, a csökkentés és az alkalmazkodás lehetőségeinek keresését.',
		a: 11,
		gT: 3958,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Reálisan látja az éghajlatváltozás következményeit, ennek különböző megjelenési formáit és mértékét a Föld különböző pontjain, ismeri az alkalmazkodás lehetséges módjait.',
		a: 11,
		gT: 3957,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Vizsgálja a Föld éghajlatának hosszabb és rövidebb időtávú, természetes jellegű változását, felismeri, hogy az emberi tevékenységből is következhet éghajlatváltoztató hatás.',
		a: 11,
		gT: 3956,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Egységes rendszerként értelmezi a Földre a Napból érkező hő következtében kialakult áramlási rendszereket, következtet ezek éghajlatmódosító hatására.',
		a: 11,
		gT: 3955,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az üvegházhatás fizikai, kémiai és földtudományi hátterét, ismeri a legfontosabb üvegházhatású gázokat és azok eredetét, változó szintjét.',
		a: 11,
		gT: 3954,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Változó éghajlat'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a másodlagos nyersanyagok felhasználásának fenntarthatósági, környezeti előnyeit, példákkal igazolja ennek technológiai lehetőségeit és korlátait.',
		a: 11,
		gT: 3953,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a megújuló energiaforrásokat, valamint az ezekhez való hozzáférés térbeli különbségeit, illetve a felhasználás esetleges korlátait.',
		a: 11,
		gT: 3952,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Felelősséggel figyeli és értékeli a fosszilis és megújuló energiahordozók napjaink energiagazdálkodásában betöltött szerepének alakulását, tapasztalatait a klímaváltozással összefüggésben elemzi.',
		a: 11,
		gT: 3951,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Az energiagazdálkodással összefüggő problémák elemzésében figyelembe veszi a hatékonyság, takarékosság lehetőségeit is.',
		a: 11,
		gT: 3950,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszerszinten átlátja a bányászat, energia-előállítás, ipar, hulladéklerakás vertikum összefüggéseit, regionális és globális következményeit.',
		a: 11,
		gT: 3949,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a nyersanyag, a fosszilis energiahordozók és az azokat felhasználók térbeli elhelyezkedésének összefüggéseit, átlátja az ebből adódó konfliktusokat.',
		a: 11,
		gT: 3948,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat gyűjt a 21. századi technológiák kulcsfontosságú alapanyagairól, elemzi az ipari nyersanyagok kitermelésével és felhasználásával kapcsolatos környezeti problémákat, illetve az újrahasznosítás lehetőségeit.',
		a: 11,
		gT: 3947,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri napjaink legjelentősebb ipari nyersanyagait (ércek és nemércek) és fosszilis energiahordozóit, érti a felhasználásukhoz kapcsolódó gazdasági és technológiai összefüggéseket.',
		a: 11,
		gT: 3946,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Nyersanyagok, energiaforrások'])
	},
		{
		cG: 'altgim',
		gD: 'Források segítségével feldolgoz és bemutat egy-egy aktuális nemzetközi vagy hazai, bányászat, ipar, közlekedés vagy mezőgazdasági eredetű környezeti káreseményt, értékeli következményeit és kármentesítési, rekultivációs lehetőségeit.',
		a: 11,
		gT: 3945,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Megnövekedett érdeklődéssel és felelősséggel figyeli és érti a bányászat, az ipar, a közlekedés, a mezőgazdaság és a települések jelentősebb, természeti környezetet átalakító folyamatait, ezeket nemzetközi és hazai példákkal támasztja alá.',
		a: 11,
		gT: 3944,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a Föld globális népességének növekedéséből következő környezeti hatásokat, ismeri a demográfiai válsághelyzetek rövid és hosszú távú következményeit és kockázatait, ezeket összefüggésbe hozza a technológiahasználat és az életmód jellemzőivel.',
		a: 11,
		gT: 3943,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány konkrét példán keresztül elemzi az emberi civilizáció fejlődése és környezetátalakító tevékenysége közötti összetett kapcsolatok történeti vonatkozásait (közlekedés, szállítás, hadviselés, vízhasználat).',
		a: 11,
		gT: 3942,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Számba veszi és elemzi a nagyléptékű környezetátalakító tevékenység legfontosabb társadalmi összefüggéseit.',
		a: 11,
		gT: 3941,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Környezeti problémák elemzésében figyelembe veszi az emberi szükségletek hierarchikus rendszerét, mérlegelő gondolkodással értékeli ennek fenntarthatósági kérdéseit.',
		a: 11,
		gT: 3940,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['Az ember környezetformáló tevékenysége'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tudományos megismerés lényegét (objektivitás, reprodukálhatóság, ellenőrizhetőség, bizonyítottság), ezt szembeállítja a tudománytalan és áltudományos megközelítések ismérveivel (feltételezés, szubjektivitás, bizonyítatlanság), felismeri az áltudományosságra utaló jeleket.',
		a: 11,
		gT: 3939,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['A természet megismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Elfogadja és példákkal igazolja, hogy a tudományos elméletek igazsága csak az adott kor és társadalom összefüggésében értelmezhető, az újabb adatok, ismeretek alapján új elméletek születhetnek.',
		a: 11,
		gT: 3938,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['A természet megismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatos stratégiaként alkalmazza a természettudományos vizsgálatok műveleteit, törekszik ezek minél szélesebb körű használatára.',
		a: 11,
		gT: 3937,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['A természet megismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Források alapján összehasonlít és értékel ókori, középkori és újkori tudományos elképzeléseket, jelentős tudósoktól származó szövegeket.',
		a: 11,
		gT: 3936,
		b: 11,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['A természet megismerése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kőolaj feldolgozásának módját, fő alkotóit, a szénhidrogéneket, tudja, hogy ezekből számos termék (motorhajtóanyag, kenőanyag, műanyag, textília, mosószer) is készül.',
		a: 7,
		gT: 3450,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'elemek és vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a különféle ásványokból, kőzetekből építőanyagokat (pl. meszet, betont, üveget) és fémeket (pl. vasat és alumíniumot) gyártanak.',
		a: 7,
		gT: 3449,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'elemek és vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes egyszerű kísérletek elvégzésére és elemzésére az elemekkel, vegyületekkel és keverékekkel kapcsolatban.',
		a: 7,
		gT: 3448,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'elemek és vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz elem, vegyület és keverék között.',
		a: 7,
		gT: 3447,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'elemek és vegyületek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a korrózió fogalmát és a fémek csoportokba sorolását korrózióállóságuk alapján, érti a vas korróziójának lényegét, valamint korrózióvédelmi módjait.',
		a: 7,
		gT: 3446,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer sav-bázis indikátorokat, érti felhasználásuk jelentőségét.',
		a: 7,
		gT: 3445,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a köznapi élet szempontjából legalapvetőbb kémiai reakciókat (pl. égési reakciók, egyesülések, bomlások, savak és bázisok reakciói, fotoszintézis).',
		a: 7,
		gT: 3444,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a katalizátor fogalmát, érti a katalizátorok működési elvének a lényegét.',
		a: 7,
		gT: 3443,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kémiai reakciók végbemenetelének legalapvetőbb feltételeit (ütközés, energia).',
		a: 7,
		gT: 3442,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'A részecskemodell alapján értelmezi az egyszerű kémiai reakciókat.',
		a: 7,
		gT: 3441,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a keverékek alkotórészeit az alkotórészek egyedi tulajdonságai alapján választhatjuk szét egymástól, ismer konkrét példákat az elválasztási műveletekre (pl. bepárlás, szűrés, ülepítés).',
		a: 7,
		gT: 3440,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Példát mond a valódi oldatra és a kolloid oldatra.',
		a: 7,
		gT: 3439,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Részecskeszemlélettel értelmezi az oldódás folyamatát és az oldatok összetételét.',
		a: 7,
		gT: 3438,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'A részecskemodell alapján értelmezi az oldódást.',
		a: 7,
		gT: 3437,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy melyek az anyag fizikai tulajdonságai.',
		a: 7,
		gT: 3436,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Érti, hogy az atomok és ionok között jellemzően erősebb, a molekulák között gyengébb kémiai kötések alakulhatnak ki.',
		a: 7,
		gT: 3435,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a köznapi anyagok molekula- és halmazszerkezetét (hidrogén, oxigén, nitrogén, víz, metán, szén-dioxid, gyémánt, grafit, vas, réz, nátrium-klorid).',
		a: 7,
		gT: 3434,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az ionvegyületek képletének megállapítását.',
		a: 7,
		gT: 3433,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az egyszerű ionok kialakulását (na+, k+, mg2+, ca2+, al3+, cl-, o2-) és analógiás gondolkodással következtet az egy oszlopban található elemekből képződő ionok képletére.',
		a: 7,
		gT: 3432,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Érti egyszerű molekulák kialakulását (h2, cl2, o2, n2, h2o, hcl, ch4, co2) és fel tudja írni a képletüket.',
		a: 7,
		gT: 3431,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy az atom külső elektronjainak jut fontos szerep a molekula- és ionképzés során.',
		a: 7,
		gT: 3430,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tudja írni a kisebb atomok elektronszerkezetét a héjakon lévő elektronok számával (bohr-féle atommodell).',
		a: 7,
		gT: 3429,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy az atom atommagból és elektronburokból épül fel.',
		a: 7,
		gT: 3428,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tesz elemi részecske és kémiai részecske, valamint atom, molekula és ion között.',
		a: 7,
		gT: 3427,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a halmazállapot-változásokat, konkrét példát mond a természetből (légköri jelenségek) és a mindennapokból.',
		a: 7,
		gT: 3426,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű modelleket (golyómodellt) használ az anyagot felépítő kémiai részecskék modellezésére.',
		a: 7,
		gT: 3425,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a részecskemodell'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb elemek vegyjelét, illetve vegyületek képletét.',
		a: 7,
		gT: 3424,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a kémia jelrendszere'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveges leírás vagy kémiai szimbólum alapján megkülönbözteti az atomokat, a molekulákat és ionokat.',
		a: 7,
		gT: 3423,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémiai szakismeretek', 'a kémia jelrendszere'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a forgalomban lévő kemikáliák (növényvédő szerek, háztartási mosó- és tisztítószerek) címkéjén feltüntetett használati útmutató értelmezésére, az azok felelősségteljes használatára.',
		a: 7,
		gT: 3422,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a táplálkozás, egészségvédelem kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tud érvelni a változatos táplálkozás és az egészséges életmód mellett.',
		a: 7,
		gT: 3421,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a táplálkozás, egészségvédelem kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van vele, hogy az életfolyamatainkhoz szükséges anyagokat a táplálékunkból vesszük fel zsírok, fehérjék, szénhidrátok, ásványi sók és vitaminok formájában.',
		a: 7,
		gT: 3420,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'kémia a mindennapokban', 'a táplálkozás, egészségvédelem kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a globális klímaváltozás, a savas esők, az ózonréteg károsodásának, valamint a szmogoknak a kialakulását és emberiségre gyakorolt hatását.',
		a: 7,
		gT: 3419,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'globális problémák kémiai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy a bennünket körülvevő anyagokat a természetben található anyagokból állítjuk elő.',
		a: 7,
		gT: 3418,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri természeti környezetének, azon belül a légkörnek, a kőzetburoknak, a természetes vizeknek és az élővilágnak a legalapvetőbb anyagait.',
		a: 7,
		gT: 3417,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja és példát hoz fel a környezetében előforduló leggyakoribb levegőt, vizet és talajt szennyező forrásokra.',
		a: 7,
		gT: 3416,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét lépéseket tesz a saját maga részéről annak érdekében, hogy mérsékelje a környezetszennyezést (pl. energiatakarékosság, szelektív hulladékgyűjtés, tudatos vásárlás).',
		a: 7,
		gT: 3415,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Kiselőadás keretében beszámol egy a saját települését érintő környezetvédelmi kérdés kémiai vonatkozásairól.',
		a: 7,
		gT: 3414,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Kiselőadás vagy projektmunka keretében ismerteti a háztartási hulladék összetételét, felhasználásának és csökkentésének lehetőségeit, különös figyelemmel a veszélyes hulladékokra.',
		a: 7,
		gT: 3413,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és példákkal szemlélteti az emberi tevékenység és a természeti környezet kölcsönös kapcsolatát kémiai szempontok alapján.',
		a: 7,
		gT: 3412,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia társadalmi vonatkozásai, környezet- és természettudatosság', 'környezetvédelem: a természeti és épített környezetre veszélyes anyagok'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a természettudományos vizsgálatok során alkalmazott legfontosabb mennyiségeket és azok kapcsolatát.',
		a: 7,
		gT: 3411,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'mennyiségi gondolkodás a kémiában: a sztöchiometria alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja és érti, hogy attól még, hogy egy elem vagy vegyület mesterségesen került előállításra vagy természetes úton került kinyerésre, még ugyanolyan tulajdonságai vannak, ugyanannyira lehet veszélyes vagy veszélytelen, mérgező vagy egészséges.',
		a: 7,
		gT: 3410,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja és érti, hogy a hétköznapi, a mindennapi tapasztalatokon alapuló gondolkodás nem elégséges a tudományos problémák megoldásához.',
		a: 7,
		gT: 3409,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja és érti, hogy közkeletű hiedelmeket nem szabad tényeknek tekinteni.',
		a: 7,
		gT: 3408,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a természettudományos gondolkodás alapvető műveletei'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri néhány köznapi anyag legfontosabb tulajdonságait és az anyagok vizsgálatának egyszerű módszereit.',
		a: 7,
		gT: 3407,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a kémiai kísérlet mint megismerési módszer'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri egy egyszerű laboratórium felépítését, anyagait és eszközeit.',
		a: 7,
		gT: 3406,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a kémiai kísérlet mint megismerési módszer'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a kísérletet, a tapasztalatot és a magyarázatot.',
		a: 7,
		gT: 3405,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'a kémia mint természettudományos megismerési módszer', 'a kémiai kísérlet mint megismerési módszer'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a környezetében végbemenő alapvető folyamatok tudományos hátterét.',
		a: 7,
		gT: 3404,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az alapvető laboratóriumi vegyszereket, azok tulajdonságait és felhasználását.',
		a: 7,
		gT: 3403,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a háztartásban leggyakrabban előforduló anyagok felhasználásának előnyeivel és veszélyeivel, a biztonságos vegyszerhasználat szabályaival',
		a: 7,
		gT: 3402,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kémiának az egyén és a társadalom életében betöltött szerepét, ezt konkrét példákkal tudja alátámasztani.',
		a: 7,
		gT: 3401,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja használni a részecskemodellt az anyagok tulajdonságainak értelmezésére.',
		a: 7,
		gT: 3400,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Képes mobiltelefon, táblagép segítségével a vizsgálatait fénykép, illetve videófelvétel formájában dokumentálni.',
		a: 7,
		gT: 3399,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja használni az internetet kémiai információk keresésére, képes számítógépes prezentáció formájában kémiával kapcsolatos eredmények, információk bemutatására, megosztására.',
		a: 7,
		gT: 3398,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Képes analógiás és mérlegelő gondolkodásra kémiai kontextusban.',
		a: 7,
		gT: 3397,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza a természettudományos problémamegoldás lépéseit egyszerű kémiai problémák megoldásában.',
		a: 7,
		gT: 3396,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel vagy csoportban el tud végezni egyszerű kémiai kísérleteket, és precízen meg tudja figyelni és lejegyezni a tapasztalatait.',
		a: 7,
		gT: 3395,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['kémia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'A környezeti kérdésekkel, globális problémákkal kapcsolatos álláspontját logikus érvekkel támasztja alá, javaslatot fogalmaz meg a környezeti problémák mérséklésére.',
		a: 7,
		gT: 3394,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Érveket fogalmaz meg a tudatos fogyasztói magatartás, a környezettudatos döntések fontossága mellett.',
		a: 7,
		gT: 3393,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a környezet- és a természetvédelem alapvető feladatait és lehetőségeit a földrajzi, környezeti eredetű problémák mérséklésében, megoldásában.',
		a: 7,
		gT: 3392,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján megfogalmazza a helyi környezetkárosítás tágabb környezetre kiterjedő következményeit, megnevezi és ok-okozati összefüggéseiben bemutatja a globálissá váló környezeti problémákat.',
		a: 7,
		gT: 3391,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Helyi, regionális és a föld egészére jellemző folyamatok közötti hasonlóságokat, összefüggéseket felismer.',
		a: 7,
		gT: 3390,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Szűkebb és tágabb környezetében földrajzi eredetű problémákat azonosít, magyarázza kialakulásuk okait.',
		a: 7,
		gT: 3389,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a globális problémák összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevezi a vállalkozás működését befolyásoló tényezőket.',
		a: 7,
		gT: 3388,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Életkori sajátosságainak megfelelő helyzetekben alkalmazza pénzügyi ismereteit (pl. egyszerű költségvetés készítése, valutaváltás, diákvállalkozás tervezése).',
		a: 7,
		gT: 3387,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a mindennapi életben jelen lévő pénzügyi tevékenységeket, szolgáltatásokat.',
		a: 7,
		gT: 3386,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Foglalkoztatási adatokat értelmez és elemez, következtetéseket von le belőlük.',
		a: 7,
		gT: 3385,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat sorol a globalizáció mindennapi életünket befolyásoló folyamataira.',
		a: 7,
		gT: 3384,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Népesség- és településföldrajzi információk alapján jellemzőket fogalmaz meg, következtetéseket von le.',
		a: 7,
		gT: 3383,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és értelmezi a társadalmi-gazdasági fejlettségbeli különbségek leírására alkalmazott mutatókat.',
		a: 7,
		gT: 3382,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a világ általános társadalom- és gazdaságföldrajzi folyamataiban'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyes térségek kapcsán földrajzi és környezeti veszélyeket és problémákat fogalmaz meg, valamint reflektál azokra.',
		a: 7,
		gT: 3381,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat nevez meg a természeti adottságok gazdálkodást, életvitelt befolyásoló szerepére.',
		a: 7,
		gT: 3380,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja az egyes övezetek, övek jellemzőit, törvényszerűségeket fogalmaz meg velük összefüggésben.',
		a: 7,
		gT: 3379,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a földrajzi övezetesség rendszerét, ismerteti az övezetek, övek kialakulásának okait és elhelyezkedésének térbeli jellemzőit.',
		a: 7,
		gT: 3378,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a geoszférák jellemzőinek és folyamatainak összefüggéseiben'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott más országok, nemzetiségek szokásainak, kultúrájának megismerése iránt.',
		a: 7,
		gT: 3377,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Reális alapokon nyugvó magyarság- és európa-tudattal rendelkezik.',
		a: 7,
		gT: 3376,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Híradásokban közölt regionális földrajzi információkra reflektál.',
		a: 7,
		gT: 3375,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a nemzetközi szintű munkamegosztás és fejlettségbeli különbségek kialakulásának okait és következményeit.',
		a: 7,
		gT: 3374,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Ismerteti az európai unió társadalmi-gazdasági jellemzőit, példákkal igazolja világgazdasági szerepét.',
		a: 7,
		gT: 3373,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Probléma- és értékközpontú megközelítéssel jellemzi európa és az európán kívüli kontinensek tipikus tájait, településeit, térségeit.',
		a: 7,
		gT: 3372,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevez az egyes kontinensekre, országcsoportokra, meghatározó jelentőségű országokra jellemző társadalmi-gazdasági folyamatokat, ott előállított termékeket, szolgáltatásokat.',
		a: 7,
		gT: 3371,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Elkötelezett szűkebb és tágabb környezete természeti és társadalmi-gazdasági értékeinek megismerése és megőrzése iránt.',
		a: 7,
		gT: 3370,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Következtet magyarország és a kárpát-medence térségében előforduló természeti és környezeti veszélyek kialakulásának okaira, várható következményeire, térbeli jellemzőire.',
		a: 7,
		gT: 3369,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít, illetve komplex módon, problémaközpontú megközelítéssel vizsgál pl. hazai nagytájakat, tájakat, régiókat, településeket.',
		a: 7,
		gT: 3368,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszerezi, csoportosítja és értékeli magyarország és a kárpát-medence térségének természeti és társadalmi-gazdasági erőforrásait, illetve bemutatja a természeti és társadalmi adottságok szerepének, jelentőségének időbeli változásait, a területi fejlettség különbségeit.',
		a: 7,
		gT: 3367,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Javaslatot fogalmaz meg lakókörnyezete jövőbeli, környezeti szempontokat szem előtt tartó, fenntartható fejlesztésére.',
		a: 7,
		gT: 3366,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja és értékeli lakókörnyezetének földrajzi jellemzőit, ismeri annak természeti és társadalmi erőforrásait.',
		a: 7,
		gT: 3365,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás regionális földrajzi kérdésekben -- a földrajzi jellemzők elemzése, összefüggések felis'])
	},
		{
		cG: 'altgim',
		gD: 'Képes egyszerű térképvázlatok, útvonaltervek elkészítésére.',
		a: 7,
		gT: 3364,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a földrajzi térben és időben'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik különböző típusú és tartalmú térképeken, biztonsággal leolvassa azok információtartalmát, a térképen elhelyez földrajzi elemeket.',
		a: 7,
		gT: 3363,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a földrajzi térben és időben'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati feladatokat (pl. távolság- és helymeghatározás, utazástervezés) old meg nyomtatott és digitális térkép segítségével.',
		a: 7,
		gT: 3362,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a földrajzi térben és időben'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a földrajzi térben való tájékozódást segítő hagyományos és digitális eszközöket.',
		a: 7,
		gT: 3361,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a földrajzi térben és időben'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a jelenségek időbeli jellemzőit.',
		a: 7,
		gT: 3360,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'tájékozódás a földrajzi térben és időben'])
	},
		{
		cG: 'altgim',
		gD: 'Közvetlen környezetének földrajzi megismerésére terepvizsgálódást tervez és kivitelez.',
		a: 7,
		gT: 3359,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján tájakkal, országokkal kapcsolatos földrajzi tartalmú szövegeket, képi információhordozókat dolgoz fel.',
		a: 7,
		gT: 3358,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközök segítségével bemutatja szűkebb és tágabb környezetének földrajzi jellemzőit.',
		a: 7,
		gT: 3357,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Adatokat rendszerez és ábrázol digitális eszközök segítségével.',
		a: 7,
		gT: 3356,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján információkat gyűjt hagyományos és digitális információforrásokból.',
		a: 7,
		gT: 3355,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi tartalmú információszerzés és -feldolgozás, digitáliseszköz-használat'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri hazánk és európa, majd a távoli kontinensek legalapvetőbb természet- és társadalomföldrajzi jellemzőit, melynek során kialakul a földről alkotott, a valóságot visszatükröző kognitív térképe.',
		a: 7,
		gT: 3354,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a tényeket a véleményektől.',
		a: 7,
		gT: 3353,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít tipikus tájakat, megfogalmazza azok közös és eltérő földrajzi vonásait.',
		a: 7,
		gT: 3352,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján rendszerezi földrajzi ismereteit, rendszerbeli viszonyokat állapít meg.',
		a: 7,
		gT: 3351,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi tartalmú adatok, adatsorok alapján következtéseket von le, következményeket fogalmaz meg.',
		a: 7,
		gT: 3350,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'földrajzi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes földrajzi ismeretei önálló bővítésére és rendszerezésére.',
		a: 7,
		gT: 3349,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Érdeklődik más országok földrajzi jellemzői, kultúrája, hagyományai iránt.',
		a: 7,
		gT: 3348,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tanulásához tudatosan használja a különböző típusú és tartalmú térképeket.',
		a: 7,
		gT: 3347,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza földrajzi tudását a mindennapi életben a környezettudatos döntések meghozatalában, felelősséget érez döntései következményeiért.',
		a: 7,
		gT: 3346,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival együttműködésben old meg földrajzi témájú feladatokat, képes a tudásmegosztásra.',
		a: 7,
		gT: 3345,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megold egyszerű földrajzi tartalmú logikai és számítási feladatokat.',
		a: 7,
		gT: 3344,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Vitában, szerepjátékban, szituációs játékban szerepének és az adott helyzetnek megfelelő, logikus érveket fogalmaz meg.',
		a: 7,
		gT: 3343,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményt alkot földrajzi témájú szövegekben bemutatott jelenségekről, folyamatokról, információkról.',
		a: 7,
		gT: 3342,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan készített prezentációban bemutatja és elemzi egy adott terület természet- és társadalomföldrajzi adottságait, ezekből fakadó környezeti és társadalmi problémáit, és megoldási lehetőség(ek)et kínál.',
		a: 7,
		gT: 3341,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Földrajzi tartalmú szövegeket értelmez.',
		a: 7,
		gT: 3340,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző földrajzi témákhoz kapcsolódóan adatokat, információkat gyűjt nyomtatott és elektronikus forrásokból, azokat értelmezi, rendszerezi, illetve ábrázolja.',
		a: 7,
		gT: 3339,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Céljaival, feladataival összhangban kiválasztja és használja a földrajzi térben való tájékozódást segítő hagyományos és digitális eszközöket.',
		a: 7,
		gT: 3338,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['földrajz', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a sportolást segítő kisalkalmazások által mért fizikai adatokat. méréseket végez a mobiltelefon szenzorainak segítségével.',
		a: 7,
		gT: 3337,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'mérés, tervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Projektfeladatok megoldása során önállóan, illetve a csoporttagokkal közösen különböző prezentációkat hoz létre a tapasztalatok és eredmények bemutatására.',
		a: 7,
		gT: 3336,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű számítógépes prezentációkat készít egy adott témakör bemutatására.',
		a: 7,
		gT: 3335,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer megbízható fizikai tárgyú magyar nyelvű internetes forrásokat.',
		a: 7,
		gT: 3334,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári útmutatás felhasználásával magabiztosan használ magyar nyelvű mobiltelefonos, táblagépes applikációkat fizikai tárgyú információk keresésére.',
		a: 7,
		gT: 3333,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Az internet segítségével adatokat gyűjt a legfontosabb fizikai jelenségekről.',
		a: 7,
		gT: 3332,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Fizikai szövegben, videóban el tudja különíteni a számára világos és nem érthető, további magyarázatra szoruló részeket.',
		a: 7,
		gT: 3331,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a digitális technológiák használata', 'internethasználat, prezentációkészítés'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a galaxisok mibenlétével, számuk és méretük nagyságrendjével. ismeri a naprendszer bolygóinak fontosabb fizikai jellemzőit.',
		a: 7,
		gT: 3330,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a csillagok fogalmát, számuk és méretük nagyságrendjét, ismeri a világűr fogalmát, a csillagászati időegységeket (nap, hónap, év) és azok kapcsolatát a föld és hold forgásával és keringésével.',
		a: 7,
		gT: 3329,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a nappalok és éjszakák változásának fizikai okát, megfigyelésekkel feltárja a holdfázisok változásának fizikai hátterét, látja a nap szerepét a naprendszerben mint gravitációs centrum és mint energiaforrás.',
		a: 7,
		gT: 3328,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'a világegyetem'])
	},
		{
		cG: 'altgim',
		gD: 'Gyakorlati példákon keresztül ismeri a fény és anyag legelemibb kölcsönhatásait (fénytörés, fényvisszaverődés, elnyelés, sugárzás), az árnyékjelenségeket, mint a fény egyenes vonalú terjedésének következményeit, a fehér fény felbonthatóságát.',
		a: 7,
		gT: 3327,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a fény egyenes vonalú terjedésével, szabályos visszaverődésének törvényével, erre hétköznapi példákat hoz.',
		a: 7,
		gT: 3326,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a földnek mágneses tere van, ismeri ennek legegyszerűbb dipól közelítését. ismeri az állandó mágnes sajátságait, az iránytűt.',
		a: 7,
		gT: 3325,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a feszültség, áramerősség, ellenállás mennyiségeket egyszerű áramkörök jellemzésére.',
		a: 7,
		gT: 3324,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Szemléletes képpel rendelkezik az elektromos áramról, ismeri az elektromos vezetők és szigetelők fogalmát.',
		a: 7,
		gT: 3323,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az elektromos állapot fogalmát, kialakulását, és magyarázza azt az anyagban lévő töltött részecskék és a közöttük fellépő erőhatások segítségével.',
		a: 7,
		gT: 3322,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'elektromos és mágneses jelenségek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a rugalmasság és rugalmatlanság fogalmával, az erő és az általa okozott deformáció közötti kapcsolat jellegével, be tudja mutatni az anyag belső szerkezetére vonatkozó legegyszerűbb modelleket, kvalitatív jellemzőket.',
		a: 7,
		gT: 3321,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja magyarázni a folyadékokban való úszás, lebegés és elmerülés jelenségét, az erre vonatkozó sűrűségfeltételt.',
		a: 7,
		gT: 3320,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Kísérletezés közben, illetve a háztartásban megfigyeli a folyadékok és szilárd anyagok melegítésének folyamatát, és szemléletes képet alkot a melegedést kísérő változásokról, a melegedési folyamatot befolyásoló tényezőkről.',
		a: 7,
		gT: 3319,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Jellemzi az anyag egyes halmazállapotait, annak sajátságait, ismeri a halmazállapot-változások jellemzőit, a halmazállapot-változások és a hőmérséklet alakulásának kapcsolatát.',
		a: 7,
		gT: 3318,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az anyag és halmazállapotai'])
	},
		{
		cG: 'altgim',
		gD: 'Előidéz egyszerű energiaátalakulással járó folyamatokat (melegítés, szabadesés), megnevezi az abban szereplő energiákat.',
		a: 7,
		gT: 3317,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az energia'])
	},
		{
		cG: 'altgim',
		gD: 'Kvalitatív ismeretekkel rendelkezik az energia szerepéről, az energiaforrásokról, az energiaátalakulásokról.',
		a: 7,
		gT: 3316,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'az energia'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a hullámmozgás lényegét és a jellemző legfontosabb mennyiségeket: frekvencia, amplitúdó, hullámhossz, terjedési sebesség.',
		a: 7,
		gT: 3315,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű eszközökkel létrehoz periodikus mozgásokat, méri a periódusidőt, fizikai kísérleteket végez azzal kapcsolatban, hogy mitől függ a periódusidő.',
		a: 7,
		gT: 3314,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a mozgások kialakulásának okával, ismeri az erő szerepét egy mozgó test megállításában, elindításában, valamilyen külső hatás kompenzálásában.',
		a: 7,
		gT: 3313,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Meghatározza az egyenes vonalú egyenletes mozgást végző test sebességét, a megtett utat, az út megtételéhez szükséges időt.',
		a: 7,
		gT: 3312,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelően tudja összekapcsolni a hely- és időadatokat. különbséget tesz az út és elmozdulás fogalma között, ismeri, és ki tudja számítani az átlagsebességet, a mértékegységeket megfelelően használja, tudja, hogy lehetnek egyenletes és nem egyenletes mozgások, ismeri a testek sebességének nagyságrendjét.',
		a: 7,
		gT: 3311,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'fizikai szakismeretek', 'mozgások a környezetünkben'])
	},
		{
		cG: 'altgim',
		gD: 'Átlátja a táplálékok energiatartalmának szerepét a szervezet energiaháztartásában és az ideális testsúly megtartásában.',
		a: 7,
		gT: 3310,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a látás folyamatát, a szem hibáit és a szemüveg szerepét ezek kijavításában, a szem megerőltetésének (például számítógép) következményeit.',
		a: 7,
		gT: 3309,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a hallás folyamatát, a levegő hullámzásának szerepét a hang továbbításában. meg tudja nevezni a halláskárosodáshoz vezető főbb tényezőket.',
		a: 7,
		gT: 3308,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'az egészséges életmód fizikai háttere'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a színek kialakulásának elemi fizikai hátterét.',
		a: 7,
		gT: 3307,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri néhány gyakran használt optikai eszköz részeit, átlátja működési elvüket.',
		a: 7,
		gT: 3306,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a villamos energia felhasználását a háztartásban, az energiatakarékosság módozatait, az érintésvédelmi és biztonsági rendszereket és szabályokat.',
		a: 7,
		gT: 3305,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az aktuálisan használt elektromos fényforrásokat, azok fogyasztását és fényerejét meghatározó mennyiségeket, a háztartásban gyakran használt áramforrásokat.',
		a: 7,
		gT: 3304,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az önvezérelt járművek működésének elvével, illetve néhány járműbiztonsági rendszer működésének fizikai hátterével.',
		a: 7,
		gT: 3303,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb, saját maga által használt eszközök (például közlekedési eszközök, elektromos háztartási eszközök, szerszámok) működésének fizikai lényegét.',
		a: 7,
		gT: 3302,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a gyakran használt technikai eszközök, technológiák fizikai alapjai, biztonságos használata'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, miben nyilvánulnak meg a kapilláris jelenségek, ismer ezekre példákat a gyakorlatból (pl. növények tápanyagfelvétele a talajból).',
		a: 7,
		gT: 3301,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a legáltalánosabb természeti jelenségek fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a környezetében előforduló legfontosabb természeti jelenségek (például időjárási jelenségek, fényviszonyok változásai, égi jelenségek) fizikai magyarázatát.',
		a: 7,
		gT: 3300,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a természeti jelenségek és a technikai eszközök, technológiák fizikája', 'a legáltalánosabb természeti jelenségek fizikai alapjai'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a fizikai kutatás által megalapozott technikai fejlődés egyes fejezeteinek a társadalomra, illetve a történelemre gyakorolt hatását, meg tudja fogalmazni a természettudomány fejlődésével kapcsolatos alapvető etikai kérdéseket.',
		a: 7,
		gT: 3299,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizikai ismeretek bővülésének gazdasági, társadalmi hatásai'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri jelentős fizikusok életének és tevékenységének legfontosabb részleteit, azok társadalmi összefüggéseit (pl. isaac newton, arkhimédész, galileo galilei, jedlik ányos).',
		a: 7,
		gT: 3298,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizikai ismeretek bővülésének gazdasági, társadalmi hatásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van az űrkutatás aktuális céljaival, legérdekesebb eredményeivel.',
		a: 7,
		gT: 3297,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák egyszerűbb fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatában van az emberi tevékenység természetre gyakorolt lehetséges negatív hatásainak és az ezek elkerülésére használható fizikai eszközöknek és eljárásoknak (pl. porszűrés, szennyezők távolról való érzékelése alapján elrendelt forgalomkorlátozás).',
		a: 7,
		gT: 3296,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák egyszerűbb fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az éghajlatváltozás problémájának összetevőit, lehetséges okait. tisztában van a hagyományos ipari nyersanyagok földi készleteinek végességével és e tény lehetséges következményeivel.',
		a: 7,
		gT: 3295,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a globális problémák egyszerűbb fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a zöldenergia és fosszilis energia fogalmát, az erőművek energiaátalakításban betöltött szerepét, az energiafelhasználás módjait és a háztartásokra jellemző fogyasztási adatokat.',
		a: 7,
		gT: 3294,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a jövő tervezett energiaforrásaira vonatkozó legfontosabb elképzeléseket.',
		a: 7,
		gT: 3293,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van azzal, hogy az energiának ára van, gyakorlati példákon keresztül ismerteti az energiatakarékosság fontosságát, ismeri az energiatermelés környezeti hatásait, az energiabiztonság fogalmát.',
		a: 7,
		gT: 3292,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'az energiagazdálkodás fizikai vonatkozásai'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az ózonpajzs elvékonyodásának és az ultraibolya sugárzás erősödésének tényét és lehetséges okait.',
		a: 7,
		gT: 3291,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Környezetében zajszintméréseket végez számítógépes mérőeszközzel, értelmezi a kapott eredményt.',
		a: 7,
		gT: 3290,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja azonosítani a széles körben használt technológiák környezetkárosító hatásait, és fizikai ismeretei alapján javaslatot tesz a károsító hatások csökkentésének módjára.',
		a: 7,
		gT: 3289,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika művelésének társadalmi vonatkozásai, környezet- és természettudatosság', 'a fizika szerepe a környezet megóvásában'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a fizika néhány új eredményével kapcsolatban.',
		a: 7,
		gT: 3288,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudományának területei, legújabb eredményei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a fizika fontosabb szakterületeit.',
		a: 7,
		gT: 3287,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'a fizika tudományának területei, legújabb eredményei'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezni tud egy jelenséget, megfigyelést valamilyen korábban megismert vagy saját maga által alkotott egyszerű elképzelés segítségével.',
		a: 7,
		gT: 3286,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Jó becsléseket tud adni egyszerű számítás, következtetés segítségével.',
		a: 7,
		gT: 3285,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Hétköznapi eszközökkel méréseket végez, rögzíti a mérések eredményeit, leírja a méréssorozatokban megfigyelhető tendenciákat, ennek során helyesen használja a közismert mértékegységeket.',
		a: 7,
		gT: 3284,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a tudomány által vizsgálható jelenségeket, azonosítani tudja a tudományos érvelést, kritikusan vizsgálja egy elképzelés tudományos megalapozottságát.',
		a: 7,
		gT: 3283,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseket és kísérleteket végez a környezetében, az abból származó tapasztalatokat rögzíti.',
		a: 7,
		gT: 3282,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'a fizika mint természettudományos megismerési módszer', 'fizikai megfigyelések, kísérletek végzése, az eredmények értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan keres és olvas fizikai témájú ismeretterjesztő szövegeket, törekszik a lényeg kiemelésére.',
		a: 7,
		gT: 3281,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Szemléletes példákon keresztül felismeri a fizikai ismeretek bővülése és a társadalmi-gazdasági folyamatok, történelmi események közötti kapcsolatot.',
		a: 7,
		gT: 3280,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű, a megértést segítő számítási feladatokat old meg.',
		a: 7,
		gT: 3279,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a világot leíró fontos fizikai mennyiségeket, azok jelentését, jellemző nagyságrendjeit a mindennapokban.',
		a: 7,
		gT: 3278,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogyan jelennek meg a fizikai ismeretek a gyakran használt technikai eszközök működésében.',
		a: 7,
		gT: 3277,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozott a földünket és környezetünket fenyegető globális problémákban, ismeri az emberi tevékenység lehetséges szerepét ezek kialakulásában.',
		a: 7,
		gT: 3276,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezni tudja lakóhelyét a földön, a föld helyét a naprendszerben, a naprendszer helyét a galaxisunkban és az univerzumban.',
		a: 7,
		gT: 3275,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a legfontosabb természeti jelenségeket, azok életkorának megfelelően egyszerűsített, a fizikai mennyiségeken és törvényeken alapuló magyarázatait.',
		a: 7,
		gT: 3274,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['fizika', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tényekkel igazolja a testi és lelki egészség közötti kapcsolatot, tud ennek egyéni és társadalmi összefüggéseiről, érvel az egészségkárosító szokások és függőségek ellen.',
		a: 7,
		gT: 3273,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja alkalmazni az alapszintű újraélesztést mellkas kompressziók és lélegeztetés (cpr) kivitelezésével, felismeri ennek szükségességét és vállalja a beavatkozást.',
		a: 7,
		gT: 3272,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'A bekövetkezett balesetet, rosszullétet felismeri, segítséget (szükség esetén mentőt) tud hívni, valamint a tőle elvárható módon (életkori sajátosságainak megfelelően) elsősegélyt tud nyújtani.',
		a: 7,
		gT: 3271,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Felméri a baleseti sérülések kockázatait, igyekszik ezeket elkerülni, a bekövetkezett balesetek esetében felismeri a sérülés, vérzés vagy mérgezés jeleit, ezekről megfelelő beszámolót tud adni.',
		a: 7,
		gT: 3270,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Érti az orvosi diagnosztikai eljárások célját, ismeri ennek elvét és főbb módszereit, értékeli a megfelelő diagnózis felállításának jelentőségét.',
		a: 7,
		gT: 3269,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Tudja, hogy a daganatos betegségek kialakulását az életmód és a környezet is befolyásolja, és hogy gyógyításuk esélyét a korai felismerés nagymértékben növeli.',
		a: 7,
		gT: 3268,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a szív- és érrendszeri betegségek kockázati tényezőit, igyekszik tudatosan alakítani étkezési szokásait, törekszik az életmódjának megfelelő energia- és tápanyagbevitelre, a normál testsúly megőrzésére.',
		a: 7,
		gT: 3267,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a kórokozó, a fertőzés és a járvány fogalmait, megkülönbözteti a vírusos és bakteriális fertőző betegségeket, felismeri az antibiotikumok helyes használatának fontosságát.',
		a: 7,
		gT: 3266,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli a személyi és környezeti higiénia egészségmegőrzéssel kapcsolatos jelentőségét, ennek alapelveit személyes környezetében is igyekszik alkalmazni.',
		a: 7,
		gT: 3265,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Az egészséget személyes és közösségi értékként értelmezi, érdeklődik az egészségmegőrzéssel kapcsolatos információk iránt, mérlegeli azok tudományos hitelességét, kritikusan kezeli a gyógyszerekkel, gyógyászattal kapcsolatos reklámokat.',
		a: 7,
		gT: 3264,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Az egészséggel, életmóddal foglalkozó weboldalak, tematikus média források információit kritikusan elemzi, igyekszik tudományos bizonyítékokra alapozott híreket, érveket és tanácsokat elfogadni.',
		a: 7,
		gT: 3263,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'egészségmegőrzés, elsősegély'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja az emberi egyedfejlődés főbb szakaszait, bemutatja az emberi nemek testi különbözőségének kialakulását, tisztában van a felelős szexuális magatartás ismérveivel, értékeli a szexualitás egyéni életviteli és párkapcsolati jelentőségét.',
		a: 7,
		gT: 3262,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy az immunrendszer is információkat dolgoz fel, azonosítja a rendszer főbb szerveit, sejtes elemeit és kémiai összetevőit.',
		a: 7,
		gT: 3261,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Ábrák, makettek alapján felismeri az ember ideg- és hormonrendszerének fontosabb szerveit, folyamatvázlatok, videók és szimulációk alapján azonosítja az alapvető biológiai funkcióit, értelmezi a szabályozás elvét.',
		a: 7,
		gT: 3260,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Szövegek, ábrák, folyamatvázlatok, videók és szimulációk alapján azonosítja a táplálkozási-, keringési-, légzési-, kiválasztási szervrendszerek alapvető biológiai funkcióit, az életfolyamatok lépéseit.',
		a: 7,
		gT: 3259,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a gyakorolt sportok testi és lelki fejlesztő hatását és a velük járó terheléseket, baleseti veszélyeket, tanácsokat fogalmaz meg ezek elkerülésére.',
		a: 7,
		gT: 3258,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az emberi bőr, a csontváz és vázizomzat főbb elemeit, ezek kapcsolódási módjait, értelmezi a mozgási szervrendszer felépítése és az ember mozgásképessége közötti összefüggéseket.',
		a: 7,
		gT: 3257,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Az emberi test megfigyelése alapján azonosítja a főbb testtájakat és testrészeket, elemzi ezek arányait és szimmetria viszonyait.',
		a: 7,
		gT: 3256,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Kiegyensúlyozott saját testképpel rendelkezik, amely figyelembe veszi az egyéni adottságokat, a nem és a korosztály fejlődési jellegzetességeit, valamint ezek sokféleségét.',
		a: 7,
		gT: 3255,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és megfelelő szempontok szerint értékeli az emberi szervezet állapotát, folyamatait jellemző fontosabb adatokat, azokat összefüggésbe hozza a testi és lelki állapotával, egészségével.',
		a: 7,
		gT: 3254,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az ember szervezete, az egészséges életmód', 'szervrendszerek és szervek felépítése és működése'])
	},
		{
		cG: 'altgim',
		gD: 'Kritikusan vizsgálja a haszonállatok tartási módjai és a fajra jellemző igények közötti ellentmondásokat, ismeri és érti a nagyüzemi technológiák és a humánus állattartási módok közötti különbségeket.',
		a: 7,
		gT: 3253,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a növények gondozásának biológiai alapjait, több szempontot is figyelembe véve értékeli a növények, a növénytermesztés élelmezési, ipari és környezeti jelentőségét.',
		a: 7,
		gT: 3252,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Egységben látja az életközösségek múltbeli, jelenkori és várható jövőbeli állapotát, azok jövőbeli állapotára valószínűségi előrejelzést fogalmaz meg, felismeri és vállalja a jövőjük iránti egyéni és közösségi felelősséget.',
		a: 7,
		gT: 3251,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Kritikusan és önkritikusan értékeli az emberi tevékenység természeti környezetre gyakorolt hatását, életvitelében tudatosan követi a természet- és környezetvédelem szempontjait.',
		a: 7,
		gT: 3250,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Tájékozódik a környezetében található védett fajokról, életközösségekről, ezek eszmei értékéről és biológiai jelentőségéről, ismeri a hazai nemzeti parkok számát, területi elhelyezkedését, bemutatja védendő életközösségeik alapvető jellemzőit.',
		a: 7,
		gT: 3249,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Az életformák sokféleségét megőrzendő értékként kezeli, felismeri a benne rejlő esztétikai szépséget, érvel a biológiai sokféleség veszélyeztetése ellen.',
		a: 7,
		gT: 3248,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és elfogadja, hogy az élő természet rendelkezik olyan értékekkel, amelyeket törvényi eszközökkel is védeni kell, ismeri ennek formáit, felhívja a figyelmet az általa észlelt természetkárosításra.',
		a: 7,
		gT: 3247,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Esetleírások, filmek és saját megfigyelései alapján felismeri az adott életközösségek biológiai értékeit, értékeli a lakókörnyezetében található életközösségek környezeti állapot és életminőség-javító hatását.',
		a: 7,
		gT: 3246,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Leírások, filmek és saját megfigyelései alapján elemzi az állatok viselkedésének alaptípusait, ezek lényegi jellemzőit konkrét példák alapján bemutatja.',
		a: 7,
		gT: 3245,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Leírások, fotók, ábrák, filmek alapján értelmezi és bemutatja az élőlények környezethez való alkalmazkodásának jellegzetes módjait és példáit.',
		a: 7,
		gT: 3244,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Másokkal együttműködve vizsgál környezetében található életközösségeket, az elkészített rajzok, fotók, videók és adatok alapján elemzi az élettelen környezeti tényezők és az élőlények közötti kapcsolatokat.',
		a: 7,
		gT: 3243,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'életközösségek vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány tengeri növény és állatfaj megismerése során felismeri, hogy bolygónk legnagyobb életközössége a világtengerekben él.',
		a: 7,
		gT: 3242,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'bolygónk élővilága'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány jellegzetes faj példáján keresztül felismeri a kontinensek jellegzetes növényei és az ott élő állatvilág közötti kapcsolatot.',
		a: 7,
		gT: 3241,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'bolygónk élővilága'])
	},
		{
		cG: 'altgim',
		gD: 'Néhány jellegzetes faj példáján keresztül felismeri a kontinensek éghajlati övezetei, kialakult talajtípusai és az ott élő növényvilág közötti kapcsolatokat.',
		a: 7,
		gT: 3240,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'bolygónk élővilága'])
	},
		{
		cG: 'altgim',
		gD: 'A földrészek természetes növényzetét ábrázoló tematikus térképek, fényképek, ábrák segítségével azonosítja bolygónk biomjait.',
		a: 7,
		gT: 3239,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'bolygónk élővilága'])
	},
		{
		cG: 'altgim',
		gD: 'Alapfokon ismeri a földrészek, óceánok legjellegzetesebb növény és állatfajait.',
		a: 7,
		gT: 3238,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'környezet és élővilág kapcsolata, fenntarthatóság', 'bolygónk élővilága'])
	},
		{
		cG: 'altgim',
		gD: 'Konkrét példák vizsgálata alapján összehasonlítja a gombák, a növények és az állatok testfelépítését, életműködéseit és életmódját, ennek alapján érvel az önálló rendszertani csoportba sorolásuk mellett.',
		a: 7,
		gT: 3237,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élővilág országai'])
	},
		{
		cG: 'altgim',
		gD: 'Alaktani jellemzők összehasonlítása alapján felismer néhány fontosabb növény- és állatcsoportot, ezekbe besorolást végez.',
		a: 7,
		gT: 3236,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élővilág országai'])
	},
		{
		cG: 'altgim',
		gD: 'Értelmezi a rátermettség és a természetes szelekció fogalmát, tudja, hogy azt a véletlenszerű események és az önszerveződés is befolyásolhatják.',
		a: 7,
		gT: 3235,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élővilág fejlődése'])
	},
		{
		cG: 'altgim',
		gD: 'A biológiai problémák vizsgálatában figyelembe veszi az evolúciós fejlődés szempontjait, a földtörténeti időskálán el tudja helyezni ennek mérföldköveit.',
		a: 7,
		gT: 3234,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élővilág fejlődése'])
	},
		{
		cG: 'altgim',
		gD: 'Képek, videók és mikroszkópos megfigyelések alapján összehasonlítja a növényi és az állati sejtek felépítését és működését, példák alapján értelmezi az egysejtű életmód jellegzetességeit.',
		a: 7,
		gT: 3233,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élet legegyszerűbb formái'])
	},
		{
		cG: 'altgim',
		gD: 'Vázlatrajz, fotó vagy mikroszkópos megfigyelés alapján felismeri és megnevezi a sejtmagvas sejttípus legfontosabb alkotórészeit, megfogalmazza a sejtekben zajló életfolyamatok lényegi jellemzőit.',
		a: 7,
		gT: 3232,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élet legegyszerűbb formái'])
	},
		{
		cG: 'altgim',
		gD: 'Tényekre alapozott érveket fogalmaz meg a baktériumok jelentőségével kapcsolatban, értékeli egészségügyi, környezeti és biotechnológiai jelentőségüket.',
		a: 7,
		gT: 3231,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'az élővilág fejlődése és szerveződése', 'az élet legegyszerűbb formái'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan vagy másokkal együttműködve kivitelez tanulási projekteket.',
		a: 7,
		gT: 3230,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Természetvédelmi, bioetikai, egészségműveltségi témákban tényekre alapozottan érvel, vitákban többféle nézőpontot is figyelembe vesz.',
		a: 7,
		gT: 3229,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'A vizsgált biológiai jelenségekkel kapcsolatos megfigyeléseit, következtetéseit és érveit érthetően és pontosan fogalmazza meg, ezeket szükség esetén rajzokkal, fotókkal, videókkal egészíti ki.',
		a: 7,
		gT: 3228,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Biológiai rendszerekkel, jelenségekkel kapcsolatos képi információkat szóban vagy írásban értelmez, alkalmazza a vizualizálás, az ábrákban való összefoglalás módszerét.',
		a: 7,
		gT: 3227,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a bulvár, a népszerűsítő és a tudományos típusú közléseket, médiatermékeket, törekszik a megtévesztés, az áltudományosság leleplezésére.',
		a: 7,
		gT: 3226,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Digitális eszközökkel képeket, videókat, adatokat rögzít, keres és értelmez, kritikus és etikus módon használ fel, alkotásokat készít.',
		a: 7,
		gT: 3225,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Alapfokon alkalmazza a rendszerszintű gondolkodás műveleteit, azonosítani tudja egy biológiai rendszer részeit, kapcsolatait és funkcióit, érti a csoportképzés jelentőségét, a tanult csoportokba besorolást végez.',
		a: 7,
		gT: 3224,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a mérhetőség jelentőségével, törekszik az elérhető legnagyobb pontosságra, de tisztában van ennek korlátaival is.',
		a: 7,
		gT: 3223,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Útmutató alapján, másokkal együttműködve kísérleteket hajt végre, azonosítja és beállítja a kísérleti változókat, a kapott adatok alapján következtetéseket fogalmaz meg.',
		a: 7,
		gT: 3222,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'A biológiai jelenségekkel kapcsolatban kérdéseket, előfeltevéseket fogalmaz meg, tudja, hogy ezek akkor vizsgálhatók tudományosan, ha lehetőség van a bizonyításra vagy cáfolatra.',
		a: 7,
		gT: 3221,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia tanulásához szükséges készségek, képességek'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és példákkal igazolja, hogy a tudományos elképzelések az adott kor tudásán és világképén nyugszanak, fejlődésük és cseréjük a megismerési folyamat természetes jellemzője.',
		a: 7,
		gT: 3220,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia kutatási céljai és módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a biológia tudományának kutatási céljait, elismeri a tudósok munkáját és felelősségét, képet alkot a biológia fejlődéséről, érti a jelenkori kutatások jelentőségét.',
		a: 7,
		gT: 3219,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'a biológia tudománya', 'a biológia kutatási céljai és módszerei'])
	},
		{
		cG: 'altgim',
		gD: 'Életmódját az egészségmegőrzés szempontjait figyelembe véve, tudatosabban alakítja.',
		a: 7,
		gT: 3218,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Több szempont figyelembevételével elemzi a környezet- és természetvédelmi problémákat, felismeri a védelemre szoruló élő természeti értékeket, ismeri az ezt szolgáló törvényi hátteret és a közösségi cselekvési lehetőségeket.',
		a: 7,
		gT: 3217,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és példákkal bizonyítja az élőlények és környezetük közötti kölcsönhatásokat, az alkalmazkodás evolúciós jelentőségét.',
		a: 7,
		gT: 3216,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Lényegi biológiai jellemzőik alapján megkülönbözteti az élővilág főbb csoportjait, a mikrobákat, növényeket és állatokat, tényekre alapozottan magyarázza a közöttük fennálló kapcsolatokat.',
		a: 7,
		gT: 3215,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és a biológiai jelenségek vizsgálata során figyelembe veszi az élő rendszerek egymásba épülő szerveződési szintjeit.',
		a: 7,
		gT: 3214,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'A biológiai problémák vizsgálata során keresi a kapcsolatot az okok és okozatok, az egyedi jelenségek és az általános törvényszerűségek között.',
		a: 7,
		gT: 3213,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönbözteti a természettudományosan vizsgálható és nem vizsgálható problémákat, ismeri és megfelelő támogatás mellett alkalmazza a megfigyelés, mérés, kísérletezés módszereit.',
		a: 7,
		gT: 3212,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['biológia', 'átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények'])
	},
		{
		cG: 'altgim',
		gD: 'Tanulási eredmény',
		a: 7,
		gT: 3211,
		b: 8,
		e2: 'Természettudomány',
		jE: _List_fromArray(
			['nat tantárgy', 'főtéma', 'altéma'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a helyes testtartás egészségre gyakorolt pozitív hatásait.',
		a: 1,
		gT: 2684,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A szabadban végzett foglalkozások során nem csupán ügyel környezete tisztaságára és rendjére, hanem erre felhívja társai figyelmét is.',
		a: 1,
		gT: 2683,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az életkorának megfelelő sporttáplálkozás alapelveit, képes különbséget tenni egészséges és egészségtelen tápanyagforrások között.',
		a: 1,
		gT: 2682,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Az öltözködés és a higiéniai szokások terén teljesen önálló, adott esetben segíti társait.',
		a: 1,
		gT: 2681,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A családi háttere és a közvetlen környezete adta lehetőségeihez mérten rendszeresen végez testmozgást.',
		a: 1,
		gT: 2680,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Aktívan vesz részt az uszodában végzett mozgásformák elsajátításában, gyakorlásában.',
		a: 1,
		gT: 2679,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári irányítással, ellenőrzött formában végzi a testnevelés -- számára nem ellenjavallt -- mozgásanyagát.',
		a: 1,
		gT: 2678,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel megvalósít a biomechanikailag helyes testtartás kialakítását elősegítő gyakorlatokat.',
		a: 1,
		gT: 2677,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a keringési, légzési és mozgatórendszerét fejlesztő alapvető mozgásformákat.',
		a: 1,
		gT: 2676,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a különböző veszély- és baleseti forrásokat, elkerülésükhöz tanári segítséget kér.',
		a: 1,
		gT: 2675,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a sportszerű és sportszerűtlen magatartásformákat, betartja a sportszerű magatartás alapvető szabályait.',
		a: 1,
		gT: 2674,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A szabályjátékok közben törekszik az egészséges versenyszellem megőrzésére.',
		a: 1,
		gT: 2673,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek tudatos szereplője, a közösséget pozitívan alakító résztvevő.',
		a: 1,
		gT: 2672,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek közben toleráns a csapattársaival és az ellenfeleivel szemben.',
		a: 1,
		gT: 2671,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'Játéktevékenysége közben a tanult szabályokat betartja.',
		a: 1,
		gT: 2670,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'Célszerűen alkalmaz sportági jellegű mozgásformákat sportjáték-előkészítő kisjátékokban.',
		a: 1,
		gT: 2669,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'Játék közben az egyszerű alaptaktikai elemek tudatos alkalmazására törekszik, játék- és együttműködési készsége megmutatkozik.',
		a: 1,
		gT: 2668,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'A testnevelési és népi játékokban tudatosan, célszerűen alkalmazza az alapvető mozgásformákat.',
		a: 1,
		gT: 2667,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'Az elsajátított egy (vagy több) úszásnemben helyes technikával úszik.',
		a: 1,
		gT: 2666,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Ellenőrzött tevékenység keretében mozog a szabad levegőn, egyúttal tudatosan felkészül az időjárás kellemetlen hatásainak elviselésére sportolás közben.',
		a: 1,
		gT: 2665,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és képes megnevezni a küzdőfeladatok, esések, tompítások játék- és baleset-megelőzési szabályait.',
		a: 1,
		gT: 2664,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Vállalja a társakkal szembeni fizikai kontaktust, sportszerű test-test elleni küzdelmet valósít meg.',
		a: 1,
		gT: 2663,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A megtanultak birtokában örömmel, a csapat teljes jogú tagjaként vesz részt a játékokban.',
		a: 1,
		gT: 2662,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Labdás ügyességi szintje lehetővé teszi az egyszerű taktikai helyzetekre épülő folyamatos, célszerű játéktevékenységet.',
		a: 1,
		gT: 2661,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A funkcionális hely- és helyzetváltoztató mozgásformáinak kombinációit változó feltételek között koordináltan hajtja végre.',
		a: 1,
		gT: 2660,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A támasz- és függésgyakorlatok végrehajtásában a testtömegéhez igazodó erő- és egyensúlyozási képességgel rendelkezik.',
		a: 1,
		gT: 2659,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző dobásmódok alaptechnikáit és előkészítő mozgásformáit a vezető műveletek ismeretében tudatosan és koordináltan hajtja végre.',
		a: 1,
		gT: 2658,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző ugrásmódok alaptechnikáit és előkészítő mozgásformáit a vezető műveletek ismeretében tudatosan és koordináltan hajtja végre.',
		a: 1,
		gT: 2657,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyszerűbb mozgásformákat jól koordináltan hajtja végre, a hasonló mozgások szimultán és egymást követő végrehajtásában megfelelő szintű tagoltságot mutat.',
		a: 1,
		gT: 2656,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző mozgásai jól koordináltak, a hasonló mozgások szimultán és egymást követő végrehajtása jól tagolt.',
		a: 1,
		gT: 2655,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Futását összerendezettség, lépésszabályozottság, ritmusosság jellemzi.',
		a: 1,
		gT: 2654,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Mozgásműveltsége szintjénél fogva pontosan hajtja végre a keresztező mozgásokat.',
		a: 1,
		gT: 2653,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Az alapvető mozgásformákat külsőleg meghatározott ritmushoz, a társak mozgásához igazított sebességgel és dinamikával képes végrehajtani.',
		a: 1,
		gT: 2652,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő általános állóképesség-fejlődést mutat.',
		a: 1,
		gT: 2651,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Olyan szintű relatív erővel rendelkezik, amely lehetővé teszi összefüggő cselekvéssorok kidolgozását, az elemek közötti összhang megteremtését.',
		a: 1,
		gT: 2650,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő motoros képességszinttel rendelkezik az alapvető mozgásformák viszonylag önálló és tudatos végrehajtásához.',
		a: 1,
		gT: 2649,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott az alapvető mozgásformák újszerű és alternatív környezetben történő alkalmazására, végrehajtására.',
		a: 1,
		gT: 2648,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A sportjátékok, a testnevelési és népi játékok művelése során egyaránt törekszik a szabályok betartására.',
		a: 1,
		gT: 2647,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult mozgásforma könnyed és pontos kivitelezésének elsajátításáig fenntartja érzelmi-akarati erőfeszítéseit.',
		a: 1,
		gT: 2646,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult mozgásformákat összefüggő cselekvéssorokban, jól koordináltan kivitelezi.',
		a: 1,
		gT: 2645,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Önismerete, érzelmi-akarati készségei és képességei a testmozgás, a testnevelés és a sport eszközei által megfelelően fejlődtek.',
		a: 1,
		gT: 2644,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri az elsősegélynyújtás jelentőségét, felismeri a baleseti és egészségkárosító veszélyforrásokat, képes azonnali segítséget kérni.',
		a: 1,
		gT: 2643,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a testnevelés életkorához igazodó elméleti ismeretanyagát, szakkifejezéseit, helyes terminológiáját, érti azok szükségességét.',
		a: 1,
		gT: 2642,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Mozgáskultúrája olyan szintre fejlődött, hogy képes a hatékony mozgásos cselekvéstanulásra, testedzésre.',
		a: 1,
		gT: 2641,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának és testi adottságának megfelelően fejlődött motoros teljesítőképessége a hozzá kapcsolódó ismeretekkel olyan mérvű, hogy képes a saját teljesítménye tudatos befolyásolására.',
		a: 1,
		gT: 2640,
		b: 4,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A helyes testtartás egészségre gyakorolt pozitív hatásai ismeretében önállóan is kezdeményez ilyen tevékenységet.',
		a: 5,
		gT: 2725,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A szabadban végzett foglalkozások során nem csupán ügyel környezete tisztaságára és rendjére, hanem erre felhívja társai figyelmét is.',
		a: 5,
		gT: 2724,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának és alkati paramétereinek megfelelően tervezett, rendezett és rendszeres, testmozgással összefüggő táplálkozási szokásokat alakít ki.',
		a: 5,
		gT: 2723,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A higiéniai szokások terén teljesen önálló, adott esetben segíti társait.',
		a: 5,
		gT: 2722,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A családi háttere és a közvetlen környezete adta lehetőségeihez mérten tervezetten, rendezetten és rendszeresen végez testmozgást.',
		a: 5,
		gT: 2721,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Megnevez és bemutat egyszerű relaxációs gyakorlatokat.',
		a: 5,
		gT: 2720,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a tanult mozgásformák gerinc- és ízületvédelmi szempontból helyes végrehajtását.',
		a: 5,
		gT: 2719,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszeresen végez számára megfelelő vízi játékokat, és hajt végre úszástechnikákat.',
		a: 5,
		gT: 2718,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Tudatosan, összehangoltan végzi a korrekciós gyakorlatait és uszodai tevékenységét, azok megvalósítása automatikussá, mindennapi életének részévé válik.',
		a: 5,
		gT: 2717,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'A mindennapi sporttevékenységébe tudatosan beépíti a korrekciós gyakorlatokat.',
		a: 5,
		gT: 2716,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Tervezetten, rendezetten és rendszeresen végez a biomechanikailag helyes testtartás kialakítását elősegítő gyakorlatokat.',
		a: 5,
		gT: 2715,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel, egyéni képességeihez mérten, tervezetten, rendezetten és rendszeresen fejleszti keringési, légzési és mozgatórendszerét.',
		a: 5,
		gT: 2714,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Megoldást keres a különböző veszély- és baleseti források elkerülésére.',
		a: 5,
		gT: 2713,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Egészséges versenyszellemmel rendelkezik, és tanári irányítás vagy ellenőrzés mellett képes a játékvezetésre.',
		a: 5,
		gT: 2712,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek közben közösségformáló, csapatkohéziót kialakító játékosként viselkedik.',
		a: 5,
		gT: 2711,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek közben toleráns a csapattársaival és az ellenfeleivel szemben, ezt tőlük is elvárja.',
		a: 5,
		gT: 2710,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A küzdő jellegű feladatokban életkorának megfelelő asszertivitást mutatva tudatosan és célszerűen alkalmazza a támadó és védő szerepeknek megfelelő technikai és taktikai elemeket.',
		a: 5,
		gT: 2709,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'A sportjátékok előkészítő kisjátékaiban tudatosan és célszerűen alkalmazza a technikai és taktikai elemeket.',
		a: 5,
		gT: 2708,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult testnevelési és népi játékok mellett folyamatosan, jól koordináltan végzi a választott sportjátékokat.',
		a: 5,
		gT: 2707,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'Az elsajátított egy (vagy több) úszásnemben helyes technikával, készségszinten úszik.',
		a: 5,
		gT: 2706,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Ellenőrzött tevékenység keretében rendszeresen mozog, edz, sportol a szabad levegőn, egyúttal tudatosan felkészül az időjárás kellemetlen hatásainak elviselésére sportolás közben.',
		a: 5,
		gT: 2705,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanári irányítást követve, a mozgás sebességét növelve hajt végre önvédelmi fogásokat, ütéseket, rúgásokat, védéseket és ellentámadásokat.',
		a: 5,
		gT: 2704,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A testnevelési és sportjáték közben célszerű, hatékony játék- és együttműködési készséget mutat.',
		a: 5,
		gT: 2703,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A torna, a ritmikus gimnasztika, tánc és aerobik jellegű mozgásformákon keresztül tanári irányítás mellett fejleszti esztétikai-művészeti tudatosságát és kifejezőképességét.',
		a: 5,
		gT: 2702,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Segítségadással képes egy-egy általa kiválasztott tornaelem bemutatására és a tanult elemekből önállóan alkotott gyakorlatsor kivitelezésére.',
		a: 5,
		gT: 2701,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Magabiztosan alkalmazza a távol- és magasugrás, valamint a kislabdahajítás és súlylökés -- számára megfelelő -- technikáit.',
		a: 5,
		gT: 2700,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A rajttechnikákat a játékok, a versengések és a versenyek közben készségszinten használja.',
		a: 5,
		gT: 2699,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Futótechnikája -- összefüggő cselekvéssor részeként -- eltérést mutat a vágta- és a tartós futás közben.',
		a: 5,
		gT: 2698,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A (meg)tanult erő-, gyorsaság-, állóképesség- és ügyességfejlesztő eljárásokat tanári irányítással tudatosan alkalmazza.',
		a: 5,
		gT: 2697,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Az alapvető mozgásainak koordinációjában megfelelő begyakorlottságot mutat, és képes a változó környezeti feltételekhez célszerűen illeszkedő végrehajtásra.',
		a: 5,
		gT: 2696,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Relatív erejének birtokában képes a sportágspecifikus mozgástechnikák koordinált, készségszintű kivitelezésére.',
		a: 5,
		gT: 2695,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A motoros képességeinek fejlődési szintje révén képes az összhang megteremtésére a cselekvéssorainak elemei között.',
		a: 5,
		gT: 2694,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott az alapvető mozgásformák újszerű és alternatív környezetben történő felhasználására, végrehajtására.',
		a: 5,
		gT: 2693,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Minden sporttevékenységében forma- és szabálykövető attitűddel rendelkezik, ez tevékenységének automatikus részévé válik.',
		a: 5,
		gT: 2692,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult mozgásforma készségszintű kivitelezése közben fenntartja érzelmi-akarati erőfeszítéseit.',
		a: 5,
		gT: 2691,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult alapvető mozgásformák kombinációiból álló cselekvéssorokat változó térbeli, időbeli, dinamikai feltételek mellett készségszinten kivitelezi.',
		a: 5,
		gT: 2690,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Képes értelmezni az életben adódó baleseti forrásokat és az egészséget károsító, veszélyes szokásokat, tevékenységeket.',
		a: 5,
		gT: 2689,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Önismerete, érzelmi-akarati készségei és képességei a testmozgás, a testnevelés és a sport eszközei által megfelelően fejlődtek.',
		a: 5,
		gT: 2688,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és használja a testnevelés életkorához igazodó elméleti ismeretanyagát, szakkifejezéseit, helyes terminológiáját.',
		a: 5,
		gT: 2687,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Sokoldalú mozgásműveltségének birtokában eredményesen tanul összetett mozgásformákat.',
		a: 5,
		gT: 2686,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Életkorának és testi adottságának megfelelően fejlődött motoros teljesítőképessége olyan mérvű, hogy képes a saját teljesítménye és fittségi szintje tudatos befolyásolására.',
		a: 5,
		gT: 2685,
		b: 8,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megoldást keres a testtartási rendellenesség kialakulásának megakadályozására, erre társait is motiválja.',
		a: 9,
		gT: 2767,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A szabadban végzett foglalkozások során nem csupán ügyel környezete tisztaságára és rendjére, hanem erre felhívja társai figyelmét is.',
		a: 9,
		gT: 2766,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Az életkorának és alkati paramétereinek megfelelő pozitív, egészégtudatos, testmozgással összefüggő táplálkozási szokásokat alakít ki.',
		a: 9,
		gT: 2765,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Mindennapi életének részeként kezeli a testmozgás, a sportolás közbeni higiéniai és tisztálkodási szabályok betartását.',
		a: 9,
		gT: 2764,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'egészséges testi fejlődés, egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Ismer és alkalmaz alapvető relaxációs technikákat.',
		a: 9,
		gT: 2763,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'A családi háttere és a közvetlen környezete adta lehetőségeihez mérten, belső igénytől vezérelve, alkotó módon, rendszeresen végez testmozgást.',
		a: 9,
		gT: 2762,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan, de tanári ellenőrzés mellett végez számára megfelelő uszodai tevékenységet.',
		a: 9,
		gT: 2761,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'A szárazföldi és az uszodai korrekciós gyakorlatait készségszinten sajátítja el, azokat tudatosan rögzíti.',
		a: 9,
		gT: 2760,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Mindennapi tevékenységének tudatos részévé válik a korrekciós gyakorlatok végzése.',
		a: 9,
		gT: 2759,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Belső igénytől vezérelve rendszeresen végez a biomechanikailag helyes testtartás kialakítását elősegítő gyakorlatokat.',
		a: 9,
		gT: 2758,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyéni képességeihez mérten, mindennapi szokásrendszerébe építve fejleszti keringési, légzési és mozgatórendszerét.',
		a: 9,
		gT: 2757,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'Megoldást keres a különböző veszély- és baleseti források elkerülésére, erre társait is motiválja.',
		a: 9,
		gT: 2756,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'prevenció, életvitel'])
	},
		{
		cG: 'altgim',
		gD: 'A szabályjátékok alkotó részese, képes szabálykövető játékvezetésre.',
		a: 9,
		gT: 2755,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek közben közösségformáló, csapatkohéziót kialakító játékosként viselkedik.',
		a: 9,
		gT: 2754,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'A versengések és a versenyek közben toleráns a csapattársaival és az ellenfeleivel szemben, ezt tőlük is elvárja.',
		a: 9,
		gT: 2753,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'versengések, versenyek'])
	},
		{
		cG: 'altgim',
		gD: 'Játéktevékenységét kreativitást mutató játék- és együttműködési készség jellemzi.',
		a: 9,
		gT: 2752,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult testnevelési, népi és sportjátékok összetett technikai és taktikai elemeit kreatívan, az adott játékhelyzetnek megfelelően, célszerűen, készségszinten alkalmazza.',
		a: 9,
		gT: 2751,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'játékok'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan képes az elkerülhetetlen vízi veszélyhelyzetek célszerű kezelésére.',
		a: 9,
		gT: 2750,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Az elsajátított egy (vagy több) úszásnemben vízbiztosan, készségszinten úszik, a természetes vizekben is.',
		a: 9,
		gT: 2749,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Rendszeresen mozog, edz, sportol a szabad levegőn, erre − lehetőségeihez mérten − társait is motiválja.',
		a: 9,
		gT: 2748,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző eséstechnikák készségszintű elsajátítása mellett a választott küzdősport speciális mozgásformáit célszerűen alkalmazza.',
		a: 9,
		gT: 2747,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan képes az életben adódó, elkerülhetetlen veszélyhelyzetek célszerű hárítására.',
		a: 9,
		gT: 2746,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A zenei ütemnek megfelelően, készségszintű koordinációval végzi a kiválasztott ritmikus gimnasztika, illetve aerobik mozgásformákat.',
		a: 9,
		gT: 2745,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A torna, ritmikus gimnasztika, aerobik és tánc jellegű mozgásformákon keresztül fejleszti esztétikai-művészeti tudatosságát és kifejezőképességét.',
		a: 9,
		gT: 2744,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan képes az általa kiválasztott elemkapcsolatokból tornagyakorlatot összeállítani, majd bemutatni.',
		a: 9,
		gT: 2743,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a kiválasztott ugró- és dobótechnikákat az ilyen jellegű játékok, versengések és versenyek közben, az eredményesség érdekében, egyéni sajátosságaihoz formálva hatékonyan alkalmazni.',
		a: 9,
		gT: 2742,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A rajtolási módokat a játékok, versenyek, versengések közben hatékonyan, kreatívan alkalmazza.',
		a: 9,
		gT: 2741,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'A korábbi évfolyamokon elért eredményeihez képest folyamatosan javítja futóteljesítményét, amelyet önmaga is tudatosan nyomon követ.',
		a: 9,
		gT: 2740,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskészség-kialakítás -- mozgástanulás'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári ellenőrzés mellett digitálisan méri és értékeli a kondicionális és koordinációs képességeinek változásait, ezekből kiindulva felismeri saját motoros képességbeli hiányosságait, és ezeket a képességeket tudatosan és rendszeresen fejleszti.',
		a: 9,
		gT: 2739,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A (meg)tanult erő-, gyorsaság-, állóképesség- és ügyességfejlesztő eljárásokat önállóan, tanári ellenőrzés nélkül alkalmazza.',
		a: 9,
		gT: 2738,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A különböző sportágspecifikus mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten hajtja végre.',
		a: 9,
		gT: 2737,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Relatív erejének birtokában a tanult mozgásformákat változó környezeti feltételek mellett, hatékonyan és készségszinten kivitelezi.',
		a: 9,
		gT: 2736,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Olyan szintű motoros képességekkel rendelkezik, amelyek lehetővé teszik a tanult mozgásformák alkotó módon történő végrehajtását.',
		a: 9,
		gT: 2735,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'motorosképesség-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Nyitott az alapvető és sportágspecifikus mozgásformák újszerű és alternatív környezetben történő felhasználására, végrehajtására.',
		a: 9,
		gT: 2734,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Sporttevékenységében spontán, automatikus forma- és szabálykövető attitűdöt követ.',
		a: 9,
		gT: 2733,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A testedzéshez, a sportoláshoz kívánatosnak tartott jellemzőknek megfelelően (fegyelmezetten, határozottan, lelkiismeretesen, innovatívan és kezdeményezően) törekszik végrehajtani az elsajátított mozgásformákat.',
		a: 9,
		gT: 2732,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult mozgásformákat alkotó módon, a testedzés és a sportolás minden területén használja.',
		a: 9,
		gT: 2731,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['testnevelés és egészségfejlesztés', 'mozgáskultúra-fejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Toleráns a testi és más fogyatékossággal élő személyek iránt, megismeri és tiszteletben tartja a szexuális kultúra alapelveit, elfogadja az egészségügyi szűrések és a környezetvédelem fontosságát.',
		a: 9,
		gT: 2730,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Társas-közösségi kapcsolatai, valamint stressztűrő és -kezelő képességei megfelelő szintre fejlődtek.',
		a: 9,
		gT: 2729,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Képes elhárítani a baleseti és veszélyforrásokat, magabiztosan segíteni és elsősegélyt nyújtani embertársainak.',
		a: 9,
		gT: 2728,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Megismeri és mindennapjai részévé teszi a mozgáshoz kapcsolódó helyes attitűdöket, a fizikailag aktív életmód és a társas-érzelmi jóllét élethosszig tartó jótékony hatásait.',
		a: 9,
		gT: 2727,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotó módon használja a testnevelés életkorához igazodó ismeretanyagát, szakkifejezéseit, helyes terminológiáját.',
		a: 9,
		gT: 2726,
		b: 12,
		e2: 'Testnevelés és egészségfejlesztés',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'testnevelés és egészségfejlesztés'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy a jelen társadalmi, gazdasági, politikai és kulturális viszonyai a múltbeli események, tényezők következményeiként alakultak ki.',
		a: 9,
		gT: 2913,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Feltevéseket fogalmaz meg, azok mellett érveket gyűjt, illetve mérlegeli az ellenérveket.',
		a: 9,
		gT: 2912,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja és kritikusan értékeli az egyes történelmi folyamatokkal, eseményekkel és személyekkel kapcsolatos eltérő álláspontokat.',
		a: 9,
		gT: 2911,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felismerni konkrét történelmi helyzetekben, jelenségekben és folyamatokban valamely általános szabályszerűség érvényesülését.',
		a: 9,
		gT: 2910,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlít különböző, egymáshoz hasonló történeti helyzeteket, folyamatokat, jelenségeket.',
		a: 9,
		gT: 2909,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes összevetni, csoportosítani és súlyozni az egyes történelmi folyamatok, jelenségek, események okait, következményeit, és ítéletet alkotni azokról, valamint a benne résztvevők szándékairól.',
		a: 9,
		gT: 2908,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A változás és a fejlődés fogalma közötti különbséget ismerve képes felismerni és bemutatni azokat azonos korszakon belül, vagy azokon átívelően.',
		a: 9,
		gT: 2907,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes különböző élethelyzetek, magatartásformák megfigyelése által következtetések levonására, erkölcsi kérdéseket is felvető történelmi helyzetek felismerésére és megítélésére.',
		a: 9,
		gT: 2906,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló véleményt tud alkotni történelmi eseményekről, folyamatokról, jelenségekről és személyekről.',
		a: 9,
		gT: 2905,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló kérdéseket fogalmaz meg történelmi folyamatok, jelenségek és események feltételeiről, okairól és következményeiről.',
		a: 9,
		gT: 2904,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Hipotéziseket alkot történelmi személyek, társadalmi csoportok és intézmények viselkedésének mozgatórugóiról.',
		a: 9,
		gT: 2903,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult ismereteket problémaközpontúan tudja rendezni.',
		a: 9,
		gT: 2902,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felismerni, megfogalmazni és összehasonlítani különböző társadalmi és történelmi problémákat, értékrendeket, jelenségeket, folyamatokat.',
		a: 9,
		gT: 2901,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Társaival képes megvitatni történelmi kérdéseket, amelynek során bizonyítékokon alapuló érvekkel megindokolja a véleményét, és választékosan reflektál mások véleményére, árnyalja saját álláspontját.',
		a: 9,
		gT: 2900,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján történelmi tárgyú szerkesztett szöveget (esszét) tud alkotni, amelynek során tételmondatokat fogalmaz meg, állításait több szempontból indokolja és következtetéseket von le.',
		a: 9,
		gT: 2899,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Történelmi tárgyú folyamatábrákat, digitális táblázatokat, diagramokat készít, történelmi, gazdasági, társadalmi és politikai modelleket vizuálisan is meg tud jeleníteni.',
		a: 9,
		gT: 2898,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Történelmi témáról kiselőadást, digitális prezentációt alkot és mutat be.',
		a: 9,
		gT: 2897,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes egy-egy korszakot átfogó módon bemutatni.',
		a: 9,
		gT: 2896,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes önállóan vázlatot készíteni és jegyzetelni.',
		a: 9,
		gT: 2895,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja foglalni rövid és egyszerű szaktudományos szöveg tartalmát.',
		a: 9,
		gT: 2894,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes kiválasztani, rendezni és alkalmazni az azonos korhoz, témához kapcsolható fogalmakat.',
		a: 9,
		gT: 2893,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tud ismerni fontosabb történelmi fogalmakat meghatározás alapján.',
		a: 9,
		gT: 2892,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a történelmi jelenségeket általános és konkrét történelmi fogalmak, tartalmi és értelmező kulcsfogalmak felhasználásával értelmezni és értékelni.',
		a: 9,
		gT: 2891,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes különböző időszakok történelmi térképeinek összehasonlítására, a történelmi tér változásainak és a történelmi mozgások követésére megadott szempontok alapján a változások hátterének feltárásával.',
		a: 9,
		gT: 2890,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'A földrajzi környezet és a történeti folyamatok összefüggéseit példákkal képes alátámasztani.',
		a: 9,
		gT: 2889,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű történelmi térképvázlatot alkot hagyományos és digitális eljárással.',
		a: 9,
		gT: 2888,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy a magyar történelem az európai történelem része, és példákat tud hozni a magyar és európai történelem kölcsönhatásaira.',
		a: 9,
		gT: 2887,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Képes azonosítani a tanult egyetemes és magyar történelmi személyiségek közül a kortársakat.',
		a: 9,
		gT: 2886,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja hasonlítani megadott szempontok alapján az egyes történelmi korszakok, időszakok jellegzetességeit az egyetemes és a magyar történelem egymáshoz kapcsolódó eseményeit.',
		a: 9,
		gT: 2885,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Az egyes események, folyamatok idejét konkrét történelmi korhoz, időszakhoz kapcsolja vagy viszonyítja, ismeri néhány kiemelten fontos esemény, jelenség időpontját, kronológiát használ és készít.',
		a: 9,
		gT: 2884,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar és az európai történelem tanult történelmi korszakait, időszakait, és képes azokat időben és térben elhelyezni.',
		a: 9,
		gT: 2883,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Képes kiválasztani a megfelelő forrást valamely történelmi állítás, vélemény alátámasztására vagy cáfolására.',
		a: 9,
		gT: 2882,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Összehasonlítja a forrásokban talált információkat saját ismereteivel, illetve más források információival és megmagyarázza az eltérések okait.',
		a: 9,
		gT: 2881,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a szándékainak megfelelő információkat kiválasztani különböző műfajú forrásokból.',
		a: 9,
		gT: 2880,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képes azonosítani a különböző források szerzőinek a szándékát, bizonyítékok alapján értékeli egy forrás hitelességét.',
		a: 9,
		gT: 2879,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Tud forráskritikát végezni és különbséget tenni a források között hitelesség, típus és szövegösszefüggés alapján.',
		a: 9,
		gT: 2878,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan információkat tud gyűjteni, áttekinteni, rendszerezni és értelmezni különböző médiumokból és írásos vagy képi forrásokból, statisztikákból, diagramokból, térképekről, nyomtatott és digitális felületekről.',
		a: 9,
		gT: 2877,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan tud használni általános és történelmi, nyomtatott és digitális információforrásokat (tankönyv, kézikönyvek, szakkönyvek, lexikonok, képzőművészeti alkotások, könyvtár és egyéb adatbázisok, filmek, keresők).',
		a: 9,
		gT: 2876,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri hazája államszervezetét, választási rendszerét.',
		a: 9,
		gT: 2875,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyarság, illetve a kárpát-medence népei együttélésének jellemzőit, példákat hoz a magyar nemzet és a közép-európai régió népeinek kapcsolatára, különös tekintettel a visegrádi együttműködésre.',
		a: 9,
		gT: 2874,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar cigányság történetének főbb állomásait, bemutatja jelenkori helyzetét.',
		a: 9,
		gT: 2873,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a határon túli magyarság helyzetét, a megmaradásért való küzdelmét trianontól napjainkig.',
		a: 9,
		gT: 2872,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és reálisan látja a többpólusú világ jellemzőit napjainkban, elhelyezi magyarországot a globális világ folyamataiban.',
		a: 9,
		gT: 2871,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a gyarmati rendszer felbomlásának következményeit, india, kína és a közel-keleti régió helyzetét és jelentőségét.',
		a: 9,
		gT: 2870,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a kommunista diktatúra magyarországi kiépítését, működését és változatait, az 1956-os forradalom és szabadságharc okait, eseményeit és hőseit, összefüggéseiben szemléli a rendszerváltoztatás folyamatát, felismerve annak történelmi jelentőségét.',
		a: 9,
		gT: 2869,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja hasonlítani a nyugati demokratikus világ és a kommunista szovjet blokk politikai és társadalmi berendezkedését, képes jellemezni a hidegháború időszakát, bemutatni a gyarmati rendszer felbomlását és az európai kommunista rendszerek összeomlását.',
		a: 9,
		gT: 2868,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja magyarország revíziós lépéseit, a háborús részvételét, az ország német megszállását, a magyar zsidóság tragédiáját, a szovjet megszállást, a polgári lakosság szenvedését, a hadifoglyok embertelen sorsát.',
		a: 9,
		gT: 2867,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felidézni a második világháború okait, a háború jellemzőit és fontosabb fordulópontjait, ismeri a holokausztot és a hozzávezető okokat.',
		a: 9,
		gT: 2866,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja hasonlítani a nemzetiszocialista és a kommunista ideológiát és diktatúrát, példák segítségével bemutatja a rendszerek embertelenségét és a velük szembeni ellenállás formáit.',
		a: 9,
		gT: 2865,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a trianoni békediktátum tartalmával és következményeivel, be tudja mutatni az ország talpra állását, a horthy-korszak politikai, gazdasági, társadalmi és kulturális viszonyait, felismeri a magyar külpolitika mozgásterének korlátozottságát.',
		a: 9,
		gT: 2864,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felidézni azokat az okokat és körülményeket, amelyek a történelmi magyarország felbomlásához vezettek.',
		a: 9,
		gT: 2863,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja az első világháború magyar vonatkozásait, a háborús vereség következményeit; példákat tud hozni a háborús helytállásra.',
		a: 9,
		gT: 2862,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tudja idézni az első világháború előzményeit, a háború jellemzőit és fontosabb fordulópontjait, értékeli a háborúkat lezáró békék tartalmát, és felismeri a háborúnak a 20. század egészére gyakorolt hatását.',
		a: 9,
		gT: 2861,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tudja idézni az ipari forradalom szakaszait, illetve azok gazdasági, társadalmi, kulturális és politikai hatásait; képes bemutatni a modern polgári társadalom és állam jellemzőit és a 19. század főbb politikai eszméit, valamint felismeri a hasonlóságot és különbséget azok mai formái között.',
		a: 9,
		gT: 2860,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és értékeli a magyar nemzetnek a polgári átalakulás és nemzeti függetlenség elérésére tett erőfeszítéseit a reformkor, az 1848/49-es forradalom és szabadságharc, illetve az azt követő időszakban; a kor kiemelkedő magyar politikusait és azok nézeteit, véleményt tud formálni a kiegyezésről.',
		a: 9,
		gT: 2859,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Összefüggéseiben és folyamatában fel tudja idézni, miként hatott a magyar történelemre a habsburg birodalomhoz való tartozás, bemutatja az együttműködés és konfrontáció megnyilvánulásait, a függetlenségi törekvéseket és értékeli a rákóczi-szabadságharc jelentőségét.',
		a: 9,
		gT: 2858,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Be tudja mutatni a kora újkor fő gazdasági és társadalmi folyamatait, ismeri a felvilágosodás eszméit, illetve azok kulturális és politikai hatását, valamint véleményt formál a francia forradalom európai hatásáról.',
		a: 9,
		gT: 2857,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyarság törökellenes küzdelmeit, fordulópontjait és hőseit; felismeri, hogy a magyar és az európai történelem alakulását meghatározóan befolyásolta a török megszállás.',
		a: 9,
		gT: 2856,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felidézi a középkori magyar állam történetének fordulópontjait, legfontosabb uralkodóink tetteit.',
		a: 9,
		gT: 2855,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Értékeli az államalapítás, valamint a kereszténység felvételének jelentőségét.',
		a: 9,
		gT: 2854,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar nép őstörténetére és a honfoglalásra vonatkozó tudományos elképzeléseket és tényeket, tisztában van legfőbb vitatott kérdéseivel, a különböző tudományterületek kutatásainak főbb eredményeivel.',
		a: 9,
		gT: 2853,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felidézni a középkor gazdasági és kulturális jellemzőit, világképét, a kor meghatározó birodalmait és bemutatni a rendi társadalmat.',
		a: 9,
		gT: 2852,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatja a keresztény vallás civilizációformáló hatását, a középkori egyházat, valamint a reformáció és a katolikus megújulás folyamatát és kulturális hatásait; érvel a vallási türelem, illetve a vallásszabadság mellett.',
		a: 9,
		gT: 2851,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felidézi a monoteista vallások kialakulását, legfontosabb jellemzőiket, tanításaik főbb elemeit, és bemutatja terjedésüket.',
		a: 9,
		gT: 2850,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri az ókori civilizációk legfontosabb jellemzőit, valamint az athéni demokrácia és a római állam működését, hatásukat az európai civilizációra.',
		a: 9,
		gT: 2849,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Megerősödik és elmélyül a társadalmi felelősség és normakövetés, az egyéni kezdeményezőkészség, a hazája, közösségei és embertársai iránt való felelősségvállalás, valamint a demokratikus elkötelezettség.',
		a: 9,
		gT: 2848,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Megerősödnek az európai civilizációs identitás alapelemei.',
		a: 9,
		gT: 2847,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Elmélyül a nemzeti identitás és hazaszeretet, büszke népe múltjára, ápolja hagyományait, és méltón emlékezik meg hazája nagyjairól.',
		a: 9,
		gT: 2846,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakulnak a saját értékrend és történelemszemlélet alapjai.',
		a: 9,
		gT: 2845,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakul és megerősödik a történelmi múlt, illetve a társadalmi, politikai, gazdasági és kulturális kérdések iránti érdeklődés.',
		a: 9,
		gT: 2844,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a demokratikus államszervezet működését, a társadalmi együttműködés szabályait, a piacgazdaság alapelveit; autonóm és felelős állampolgárként viselkedik.',
		a: 9,
		gT: 2843,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a múlt eseményeit és jelenségeit a saját történelmi összefüggésükben értelmezni, illetve a jelen viszonyait kapcsolatba hozni a múltban történtekkel.',
		a: 9,
		gT: 2842,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakul a hiteles és tárgyilagos forráshasználat és kritika igénye.',
		a: 9,
		gT: 2841,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a tanulási célhoz megfelelő információforrást választani, a források között szelektálni, azokat szakszerűen feldolgozni és értelmezni.',
		a: 9,
		gT: 2840,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Képes következtetni történelmi események, folyamatok és jelenségek okaira és következményeire.',
		a: 9,
		gT: 2839,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tud tenni történelmi tények és történelmi interpretáció, illetve vélemény között.',
		a: 9,
		gT: 2838,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a közös magyar nemzeti és európai, valamint az egyetemes emberi civilizáció kulturális örökségének, kódrendszerének lényeges elemeit.',
		a: 9,
		gT: 2837,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a múlt és jelen társadalmi, gazdasági, politikai és kulturális folyamatairól, jelenségeiről többszempontú, tárgyilagos érveléssel alátámasztott véleményt alkotni, ezekkel kapcsolatos problémákat megfogalmazni.',
		a: 9,
		gT: 2836,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Megbízható ismeretekkel bír az európai, valamint az egyetemes történelem és mélyebb tudással rendelkezik a magyar történelem fontosabb eseményeiről, történelmi folyamatairól, fordulópontjairól.',
		a: 9,
		gT: 2835,
		b: 12,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy az emberi cselekedet és annak következménye között szoros kapcsolat van.',
		a: 5,
		gT: 2834,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Több szempontból képes megkülönböztetni a történelmi jelenségek és események okait és következményeit (pl. hosszú vagy rövid távú, gazdasági, társadalmi vagy politikai).',
		a: 5,
		gT: 2833,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Feltételezéseket fogalmaz meg néhány fontos történelmi esemény és folyamat feltételeiről, okairól és következményeiről, és tényekkel alátámasztja azokat.',
		a: 5,
		gT: 2832,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat hoz a történelmi jelenségekre, folyamatokra.',
		a: 5,
		gT: 2831,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Társadalmi és erkölcsi problémákat azonosít adott történetek, történelmi események, különböző korok szokásai alapján.',
		a: 5,
		gT: 2830,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri és értékeli a különböző korokra és régiókra jellemző tárgyakat, alkotásokat, életmódokat, szokásokat, változásokat, képes azokat összehasonlítani egymással, illetve a mai korral.',
		a: 5,
		gT: 2829,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló véleményt képes megfogalmazni történelmi szereplőkről, eseményekről, folyamatokról.',
		a: 5,
		gT: 2828,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A történelmi szereplők megnyilvánulásainak szándékot tulajdonít, álláspontjukat azonosítja.',
		a: 5,
		gT: 2827,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Feltételezéseket fogalmaz meg történelmi személyek cselekedeteinek mozgatórugóiról, és adatokkal, érvekkel alátámasztja azokat.',
		a: 5,
		gT: 2826,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'A történelmi eseményekkel, folyamatokkal és személyekkel kapcsolatban önálló kérdéseket fogalmaz meg.',
		a: 5,
		gT: 2825,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Képes megfigyelni, értelmezni és összehasonlítani a történelemben előforduló különböző emberi magatartásformákat és élethelyzeteket.',
		a: 5,
		gT: 2824,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Adott történetben különbséget tud tenni fiktív és valós, irreális és reális elemek között.',
		a: 5,
		gT: 2823,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi gondolkodás'])
	},
		{
		cG: 'altgim',
		gD: 'Tanári segítséggel dramatikusan, szerepjáték formájában tud megjeleníteni történelmi eseményeket, jelenségeket, személyiségeket.',
		a: 5,
		gT: 2822,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Meghallgatja és megérti -- adott esetben elfogadja -- mások véleményét, érveit.',
		a: 5,
		gT: 2821,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű történelmi kérdésekről tárgyilagos véleményt tud megfogalmazni, állításait alátámasztja.',
		a: 5,
		gT: 2820,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű történelmi témáról tanári útmutatás segítségével kiselőadást és digitális prezentációt állít össze és mutat be.',
		a: 5,
		gT: 2819,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Tud egyszerű vizuális rendezőket készíteni és kiegészíteni hagyományos vagy digitális módon (táblázatok, ábrák, tablók, rajzok, vázlatok) egy történelmi témáról.',
		a: 5,
		gT: 2818,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző történelmi korszakok, történelmi és társadalmi kérdések tárgyalása során szakszerűen alkalmazza az értelmező és tartalmi kulcsfogalmakat, továbbá használja a témához kapcsolódó történelmi fogalmakat.',
		a: 5,
		gT: 2817,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes rövid fogalmazások készítésére egy-egy történetről, történelmi témáról.',
		a: 5,
		gT: 2816,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Képes önálló kérdések megfogalmazására a tárgyalt történelmi témával, eseményekkel, folyamatokkal kapcsolatban.',
		a: 5,
		gT: 2815,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Az általa gyűjtött történelmi adatokból, szövegekből rövid tartalmi ismertetőt tud készíteni.',
		a: 5,
		gT: 2814,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja foglalni saját szavaival hosszabb elbeszélő vagy leíró, valamint rövidebb magyarázó szövegek tartalmát.',
		a: 5,
		gT: 2813,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan, folyamatos beszéddel képes eseményeket, történeteket elmondani, történelmi személyeket bemutatni, saját véleményt megfogalmazni.',
		a: 5,
		gT: 2812,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'szaktárgyi kommunikáció'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű alaprajzokat, modelleket, térképvázlatokat (pl. települések, épületek, csaták) tervez és készít.',
		a: 5,
		gT: 2811,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Biztonsággal használ különböző történelmi térképeket a fontosabb történelmi események helyszíneinek azonosítására, egyszerű jelenségek, folyamatok leolvasására, értelmezésére, vaktérképen való elhelyezésére.',
		a: 5,
		gT: 2810,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'A tanult történelmi eseményeket, jelenségeket, személyeket, ikonikus szimbólumokat, tárgyakat, képeket hozzá tudja rendelni egy adott történelmi korhoz, régióhoz, államhoz.',
		a: 5,
		gT: 2809,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeretei segítségével időrendbe tud állítani történelmi eseményeket, képes az idő ábrázolására pl. időszalag segítségével.',
		a: 5,
		gT: 2808,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Biztonsággal használja az idő tagolására szolgáló kifejezéseket, történelmi eseményre, jelenségre, folyamatra, korszakra való utalással végez időmeghatározást.',
		a: 5,
		gT: 2807,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nagy történelmi korszakok elnevezését és időhatárait, néhány kiemelten fontos esemény, jelenség és történelmi folyamat időpontját.',
		a: 5,
		gT: 2806,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'tájékozódás időben és térben'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű következtetéseket von le, és véleményt tud alkotni különböző források hitelességéről és releváns voltáról.',
		a: 5,
		gT: 2805,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Meg tudja vizsgálni, hogy a történet szerzője résztvevője vagy kortársa volt-e az eseményeknek.',
		a: 5,
		gT: 2804,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Össze tudja vetni a forrásokban található információkat az ismereteivel, párhuzamot tud vonni különböző típusú (pl. szöveges és képi) történelmi források tartalma között.',
		a: 5,
		gT: 2803,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képes egyszerű esetekben forráskritikát végezni, valamint különbséget tenni források között típus és szövegösszefüggés alapján.',
		a: 5,
		gT: 2802,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képen, egyszerű ábrán, grafikonon, diagramon ábrázolt folyamatot, jelenséget saját szavaival le tud írni.',
		a: 5,
		gT: 2801,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri, hogy melyik szöveg, kép, egyszerű ábra, grafikon vagy diagram kapcsolódik az adott történelmi témához.',
		a: 5,
		gT: 2800,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján tudja értelmezni és rendszerezni a történelmi információkat.',
		a: 5,
		gT: 2799,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képes élethelyzetek, magatartásformák megfigyelése által értelmezni azokat.',
		a: 5,
		gT: 2798,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Megadott szempontok alapján, tanári útmutatás segítségével történelmi információkat gyűjt különböző médiumokból és forrásokból (könyvek, atlaszok, kronológiák, könyvtárak, múzeumok, médiatárak, filmek; nyomtatott és digitális, szöveges és vizuális források).',
		a: 5,
		gT: 2797,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Kiemel lényeges információkat (kulcsszavakat, tételmondatokat) elbeszélő vagy leíró, illetve rövidebb magyarázó írott és hallott szövegekből és az ezek alapján megfogalmazott kérdésekre egyszerű válaszokat adni.',
		a: 5,
		gT: 2796,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Képes ismereteket szerezni személyes beszélgetésekből, tárgyak, épületek megfigyeléséből, olvasott és hallott, valamint a különböző médiumok által felkínált szöveges és képi anyagokból.',
		a: 5,
		gT: 2795,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'ismeretszerzés és forráshasználat'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri hazája államszervezetét.',
		a: 5,
		gT: 2794,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Valós képet alkotva képes elhelyezni magyarországot a globális folyamatokban a történelem során és napjainkban.',
		a: 5,
		gT: 2793,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyarság, illetve a kárpát-medence népei együttélésének jellemzőit néhány történelmi korszakban, beleértve a határon kívüli magyarság sorsát, megmaradásáért folytatott küzdelmét, példákat hoz a magyar nemzet és a közép-európai régió népeinek kapcsolatára és együttműködésére.',
		a: 5,
		gT: 2792,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Példákat tud felhozni arra, hogy a történelem során miként járultak hozzá a magyarok európa és a világ kulturális, tudományos és politikai fejlődéséhez.',
		a: 5,
		gT: 2791,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a különbségeket a demokratikus és a diktatórikus berendezkedések között, érvel a demokrácia értékei mellett.',
		a: 5,
		gT: 2790,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a nemzetiszocialista és a kommunista diktatúrák főbb jellemzőit, az emberiség ellen elkövetett bűneiket, ellentmondásaikat és ezek következményeit, továbbá a velük szembeni ellenállás példáit.',
		a: 5,
		gT: 2789,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tudja idézni az első és második világháború borzalmait, érveket tud felsorakoztatni a békére való törekvés mellett.',
		a: 5,
		gT: 2788,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a különböző korok hadviselési szokásait, az első és a második világháború legfontosabb eseményeit, jellemzőit, valamint napjainkra is hatással bíró következményeit.',
		a: 5,
		gT: 2787,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és be tudja mutatni a 19. és 20. századi modernizáció gazdasági, társadalmi és kulturális hatásait magyarországon és a világban.',
		a: 5,
		gT: 2786,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a középkor és újkor világképének fő vonásaival, a 19. és 20. század fontosabb politikai eszméivel és azok hatásaival.',
		a: 5,
		gT: 2785,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Képes felidézni a magyar nemzet honvédő és szabadságharcait, példákat hoz a hazaszeretet, önfeláldozás és hősiesség megnyilvánulásaira.',
		a: 5,
		gT: 2784,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Fel tudja idézni a magyar történelem legfontosabb eseményeit, jelenségeit, folyamatait és fordulópontjait a honfoglalástól napjainkig.',
		a: 5,
		gT: 2783,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a magyar történelem kiemelkedő alakjait, cselekedeteiket, illetve szerepüket a magyar nemzet történetében.',
		a: 5,
		gT: 2782,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Tisztában van a kereszténység kialakulásának főbb állomásaival, ismeri a legfontosabb tanításait és hatását az európai civilizációra és magyarországra.',
		a: 5,
		gT: 2781,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Be tudja mutatni a különböző korok életmódjának és kultúrájának főbb vonásait és az egyes történelmi korszakokban élt emberek életét befolyásoló tényezőket.',
		a: 5,
		gT: 2780,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri és fel tudja idézni a magyar és az európai történelmi hagyományhoz kapcsolódó legfontosabb mítoszokat, mondákat, történeteket, elbeszéléseket.',
		a: 5,
		gT: 2779,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['történelem', 'történelmi ismeretek'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakulnak a társadalmi felelősség és normakövetés, az egyéni kezdeményezőkészség és a hazája, közösségei és embertársai iránti felelősségvállalás, az aktív állampolgárság, valamint a demokratikus elkötelezettség alapelemei.',
		a: 5,
		gT: 2778,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakulnak az európai civilizációs identitás alapelemei.',
		a: 5,
		gT: 2777,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Megerősödik benne a nemzeti identitás és hazaszeretet érzése; büszke népe múltjára, ápolja hagyományait, és méltón emlékezik meg hazája nagyjairól.',
		a: 5,
		gT: 2776,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Kialakul a múlt iránti érdeklődés.',
		a: 5,
		gT: 2775,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető ismereteket szerez a demokratikus államszervezetről, a társadalmi együttműködés szabályairól és a piacgazdaságról.',
		a: 5,
		gT: 2774,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és méltányolja, hogy a múlt viszonyai, az emberek gondolkodása, értékítélete eltért a maitól.',
		a: 5,
		gT: 2773,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Különbséget tud tenni a múltról szóló fiktív történetek és a történelmi tények között.',
		a: 5,
		gT: 2772,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a közös magyar nemzeti, az európai, valamint az egyetemes emberi civilizáció kulturális örökségének, kódrendszerének legalapvetőbb elemeit.',
		a: 5,
		gT: 2771,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti, hogy minden történelmi eseménynek és folyamatnak okai és következményei vannak.',
		a: 5,
		gT: 2770,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Képes a múlt és jelen alapvető társadalmi, gazdasági, politikai és kulturális folyamatairól, jelenségeiről véleményt alkotni.',
		a: 5,
		gT: 2769,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'Alapvető ismeretekkel rendelkezik a magyar nemzet, magyarország és az európai civilizáció és földünk legfontosabb régióinak múltjáról és jelenéről.',
		a: 5,
		gT: 2768,
		b: 8,
		e2: 'Történelem',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'történelem'])
	},
		{
		cG: 'altgim',
		gD: 'A leghatékonyabb megoldás megtalálása érdekében felméri a lehetőségeket és azok feltételeit, amelyek komplex mérlegelésével döntést hoz az adott feladatokban.',
		a: 9,
		gT: 3052,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'feladatmegoldás során stratégiai szempontból is értelmezhető döntés elérése'])
	},
		{
		cG: 'altgim',
		gD: 'Egyéni munkáját hajlandó a közösségi alkotás érdekei alá rendelni, a hatékonyság érdekében az együttműködésre törekszik.',
		a: 9,
		gT: 3051,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'kreatív problémamegoldás során hatékony együttműködés a társakkal'])
	},
		{
		cG: 'altgim',
		gD: 'Adott feladatmegoldás érdekében ötleteiből rendszert alkot, a célok érdekében alkalmas kifejezési eszközöket és technikákat választ, az újszerű ötletek megvalósítása érdekében szabályokat újraalkot.',
		a: 9,
		gT: 3050,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'kísérletezés problémamegoldás érdekében az ötletek vizuális magyarázatával és részletes kidolgozásá'])
	},
		{
		cG: 'altgim',
		gD: 'Technikai képnél és a számítógépes környezetben felismeri a manipuláció lehetőségét, és érti a befolyásolás vizuális eszközeinek jelentőségét.',
		a: 9,
		gT: 3049,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'mediális üzenetek mérlegelő szemléletű értelmezése'])
	},
		{
		cG: 'altgim',
		gD: 'Adott téma újszerű megjelenítéséhez illő technikai lehetőségeket kiválaszt, és adott vizuális feladatmegoldás érdekében megfelelően felhasznál.',
		a: 9,
		gT: 3048,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'könnyen elérhető, egyszerű technikai lehetőségek, alkalmazások használata a képalkotás érdekében'])
	},
		{
		cG: 'altgim',
		gD: 'Szabadon választott témában, társaival együtt ok-okozati összefüggéseken alapuló történetet alkot, amelynek részleteit vizuális eszközökkel is magyarázza, bemutatja.',
		a: 9,
		gT: 3047,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'közlési szándéknak megfelelő álló és mozgóképi közlés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Valós célokat szolgáló, saját kommunikációs helyzetnek megfelelő, képes és szöveges üzenetet felhasználó vizuális közlést hoz létre társaival együttműködésben is.',
		a: 9,
		gT: 3046,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'közlési szándéknak megfelelő álló és mozgóképi közlés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Vizuális megjelenéseket, alkotásokat újraértelmez, áttervez és módosított kifejezési szándék vagy funkció érdekében újraalkot.',
		a: 9,
		gT: 3045,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'személyes témák, gondolatok hiteles vizuális megjelenítése a választott médium sajátosságainak érvé'])
	},
		{
		cG: 'altgim',
		gD: 'Saját munkáit bátran újraértelmezi és felhasználja további alkotótevékenység során.',
		a: 9,
		gT: 3044,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'személyes témák, gondolatok hiteles vizuális megjelenítése a választott médium sajátosságainak érvé'])
	},
		{
		cG: 'altgim',
		gD: 'Képalkotás és tárgyformálás során autonóm módon felhasználja személyes tapasztalatait a hiteles kifejezési szándék érdekében a választott médiumnak is megfelelően.',
		a: 9,
		gT: 3043,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'személyes témák, gondolatok hiteles vizuális megjelenítése a választott médium sajátosságainak érvé'])
	},
		{
		cG: 'altgim',
		gD: 'Tervezési folyamat során a gondolkodás szemléltetése érdekében gondolatait mások számára is érthetően, szövegesen és képpel dokumentálja.',
		a: 9,
		gT: 3042,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'gondolatok vizuális bemutatása, illusztrálása magyarázat céljából'])
	},
		{
		cG: 'altgim',
		gD: 'Adott feladatnak megfelelően alkalmazza az analóg és a digitális prezentációs technikákat, illetve az ezekhez kapcsolható álló- és mozgóképi lehetőségeket.',
		a: 9,
		gT: 3041,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'gondolatok vizuális bemutatása, illusztrálása magyarázat céljából'])
	},
		{
		cG: 'altgim',
		gD: 'Bemutatás, felhívás, történetmesélés céljából térbeli és időbeli folyamatokat, történéseket, cselekményeket különböző eszközök segítségével rögzít.',
		a: 9,
		gT: 3040,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'adott koncepció érdekében térbeli és időbeli változások mozgóképi megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Az adott vagy a választott célnak megfelelően környezetátalakítás érdekében, társaival együttműködésben, környezetfelméréssel alátámasztva tervet készít, amelyet indokolni is tud.',
		a: 9,
		gT: 3039,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'saját koncepciónak megfelelő téralakítás'])
	},
		{
		cG: 'altgim',
		gD: 'Személyes élményei alapján elemzi a tárgy- és környezetkultúra, valamint a fogyasztói szokások mindennapi életre gyakorolt hatásait és veszélyeit, és ezeket társaival megvitatja.',
		a: 9,
		gT: 3038,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'az épített, tervezett környezet elemző vizsgálata'])
	},
		{
		cG: 'altgim',
		gD: 'Adott szempontok alapján érti és megkülönbözteti a történeti korok és a modern társadalmak tárgyi és épített környezetének legfontosabb jellemzőit, miközben értelmezi kulturális örökségünk jelentőségét is.',
		a: 9,
		gT: 3037,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'kultúrák, művészettörténeti korok és stílusok legfontosabb jellemzőinek és összefüggéseinek értelme'])
	},
		{
		cG: 'altgim',
		gD: 'Adott vagy választott kortárs művészeti üzenetet személyes viszonyulás alapján, a társadalmi reflexiók kiemelésével értelmez.',
		a: 9,
		gT: 3036,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'kultúrák, művészettörténeti korok és stílusok legfontosabb jellemzőinek és összefüggéseinek értelme'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és megkülönbözteti a klasszikus és a modern művészet kultúrtörténeti összetevőit, közlésformáinak azonosságait és különbségeit.',
		a: 9,
		gT: 3035,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'kultúrák, művészettörténeti korok és stílusok legfontosabb jellemzőinek és összefüggéseinek értelme'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző mediális produktumokat vizuális jelrendszer, kommunikációs szándék és hatáskeltés szempontjából elemez, összehasonlít, és következtetéseit társaival is megvitatja.',
		a: 9,
		gT: 3034,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megjelenések, képek, mozgóképek adott szempont szerinti értelmezése, összehasonlítása, köv'])
	},
		{
		cG: 'altgim',
		gD: 'Megfelelő érvekkel alátámasztva, mérlegelő szemlélettel viszonyul az őt körülvevő kulturális környezet vizuális értelmezéseinek mediális csatornáihoz, amit társaival is megvitat.',
		a: 9,
		gT: 3033,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megjelenések, képek, mozgóképek adott szempont szerinti értelmezése, összehasonlítása, köv'])
	},
		{
		cG: 'altgim',
		gD: 'Adott és választott vizuális művészeti témában önállóan gyűjtött képi és szöveges információk felhasználásával részletesebb helyzetfeltáró, elemző, összehasonlító projektmunkát végez.',
		a: 9,
		gT: 3032,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális elemzési, értelmezési lehetőségek tanulási célnak megfelelő felhasználása'])
	},
		{
		cG: 'altgim',
		gD: 'A művészi hatás megértése és magyarázata érdekében összehasonlít, és következtetéseket fogalmaz meg a különböző művészeti ágak kifejezési formáival kapcsolatban.',
		a: 9,
		gT: 3031,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális tapasztalatok és tudás eredményeinek felhasználása különböző elemzési helyzetekben bonyolu'])
	},
		{
		cG: 'altgim',
		gD: 'A vizuális megjelenések elemzése és értelmezése során a befogadó és az alkotó szerepkört egyaránt megismerve reflexióit szemléletesen és szakszerűen fogalmazza meg szövegesen és képi megjelenítéssel is.',
		a: 9,
		gT: 3030,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális tapasztalatok és tudás eredményeinek felhasználása különböző elemzési helyzetekben bonyolu'])
	},
		{
		cG: 'altgim',
		gD: 'Új ötleteket is felhasznál képek, tárgyak, terek megjelenítésének, átalakításának, rekonstruálásának megvalósításánál síkbeli, térbeli és időbeli produktumok létrehozása esetében.',
		a: 9,
		gT: 3029,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'feladatmegoldás során a belső képalkotás lehetőségének szabad felhasználása és hiteles magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotó feladatmegoldásai során az elraktározott, illetve a folyamatosan újraalkotott belső képeit, képzeteit szabadon párosítja a felkínált tartalmi elemek és látványok újrafogalmazásakor, amelyet indokolni is tud.',
		a: 9,
		gT: 3028,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'feladatmegoldás során a belső képalkotás lehetőségének szabad felhasználása és hiteles magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Az alkotótevékenység során szerzett tapasztalatait önálló feladatmegoldás során beépíti, és az eredményes feladatmegoldás érdekében szükség szerint továbbfejleszti.',
		a: 9,
		gT: 3027,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'feladatmegoldás során vizuális információk felidézése és következetes összegyűjtése a megoldás érde'])
	},
		{
		cG: 'altgim',
		gD: 'Adott feladatmegoldás érdekében meglévő vizuális ismeretei között megfelelően szelektál, a további szakszerű információszerzés érdekében adekvátan keres.',
		a: 9,
		gT: 3026,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'feladatmegoldás során vizuális információk felidézése és következetes összegyűjtése a megoldás érde'])
	},
		{
		cG: 'altgim',
		gD: 'A vizuális megjelenések mintáinak önálló megfigyelése és felismerése által konstrukciókat alkot, e megfigyelések szempontjainak összekapcsolásával definiál és következtet, mindezt társaival együttműködve alkotótevékenységébe is beilleszti.',
		a: 9,
		gT: 3025,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'feladatmegoldás során vizuális információk felidézése és következetes összegyűjtése a megoldás érde'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotó és befogadó tevékenységei során érti, és komplex módon használja a vizuális nyelv eszközeit.',
		a: 9,
		gT: 3024,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'önálló feladatmegoldásokban a vizuális megfigyelés és megismerés adekvát használata'])
	},
		{
		cG: 'altgim',
		gD: 'A látható világ vizuális összefüggéseinek megfigyeléseit ok-okozati viszonyoknak megfelelően rendszerezi.',
		a: 9,
		gT: 3023,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'önálló feladatmegoldásokban a vizuális megfigyelés és megismerés adekvát használata'])
	},
		{
		cG: 'altgim',
		gD: 'Adott területen megtalálja a számára érdekes és fontos kihívásokat.',
		a: 9,
		gT: 3022,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló véleményt alkot, és azt meggyőzően indokolja.',
		a: 9,
		gT: 3021,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportban végzett feladatmegoldás során részt vállal a feladatmegoldásban, önállóan megtalálja saját feladatát, figyelembe veszi társai álláspontját, de az optimális eredmény érdekében hatékonyan érvényesíti érdekeit.',
		a: 9,
		gT: 3020,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'A fenntarthatóság érdekében felelős döntéseket hoz a saját tervezett, épített környezetével kapcsolatban.',
		a: 9,
		gT: 3019,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a designgondolkodás sajátosságait az őt körülvevő tárgy- és környezetkultúra produktumaiban.',
		a: 9,
		gT: 3018,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri néhány példáját a digitális képalkotás közösségi médiában használt lehetőségének.',
		a: 9,
		gT: 3017,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Érti és meg tudja magyarázni a célzott vizuális közlések hatásmechanizmusát.',
		a: 9,
		gT: 3016,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján felismeri és értelmezi a kortárs művészetben a társadalmi reflexiókat.',
		a: 9,
		gT: 3015,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján művészettörténeti korszakokat, stílusokat felismer és egymáshoz képest időben viszonylagos pontossággal elhelyez.',
		a: 9,
		gT: 3014,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján érti a művészet kultúraközvetítő szerepét.',
		a: 9,
		gT: 3013,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldásai során saját ötleteit és eredményeit bátran bemutatja.',
		a: 9,
		gT: 3012,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldásai során a felhasználás érdekében hatékonyan szelektálja a korábban szerzett ismereteket.',
		a: 9,
		gT: 3011,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Adott tanulási helyzetben a tanulási előrehaladás érdekében problémákat keres, kérdéseket tesz fel, és ezekre önállóan is keresi a megoldásokat és válaszokat.',
		a: 9,
		gT: 3010,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Eszköz- és anyaghasználat során adekvát döntést hoz.',
		a: 9,
		gT: 3009,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldás közben kísérletezik, különböző megoldási utakat keres, és törekszik az egyéni megoldás igényes kivitelezésére.',
		a: 9,
		gT: 3008,
		b: 10,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Nem konvencionális feladatok kapcsán egyéni elképzeléseit, ötleteit rugalmasan alkalmazva megoldást talál.',
		a: 5,
		gT: 3007,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'problémamegoldás érdekében rugalmas és nyitott kísérletezés, többféle megoldás keresése'])
	},
		{
		cG: 'altgim',
		gD: 'Adott téma vizuális feldolgozása érdekében problémákat vet fel, megoldási lehetőségeket talál, javasol, a probléma megoldása érdekében kísérletezik.',
		a: 5,
		gT: 3006,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'problémamegoldás érdekében rugalmas és nyitott kísérletezés, többféle megoldás keresése'])
	},
		{
		cG: 'altgim',
		gD: 'Nem vizuális információkat (pl. számszerű adat, absztrakt fogalom) különböző célok (pl. tudományos, gazdasági, turisztikai) érdekében vizuális, képi üzenetté alakít.',
		a: 5,
		gT: 3005,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'direkt, célzott vizuális közlés', 'adott cél érdekében vizuális kommunikációs megjelenés létrehozása többféle, adekvát technikával'])
	},
		{
		cG: 'altgim',
		gD: 'Adott témát, időbeli, térbeli folyamatokat, történéseket közvetít újabb médiumok képírási formáinak segítségével egyénileg vagy csoportmunkában is.',
		a: 5,
		gT: 3004,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'direkt, célzott vizuális közlés', 'adott cél érdekében vizuális kommunikációs megjelenés létrehozása többféle, adekvát technikával'])
	},
		{
		cG: 'altgim',
		gD: 'A helyzetek, történetek ábrázolása, dokumentálása során egyénileg vagy csoportmunkában is felhasználja a kép és szöveg, a kép és hang viszonyában rejlő lehetőségeket.',
		a: 5,
		gT: 3003,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'direkt, célzott vizuális közlés', 'adott cél érdekében vizuális kommunikációs megjelenés létrehozása többféle, adekvát technikával'])
	},
		{
		cG: 'altgim',
		gD: 'Célzottan vizuális kommunikációt szolgáló megjelenéseket értelmez és tervez a kommunikációs szándék és a hatáskeltés szempontjait kiemelve.',
		a: 5,
		gT: 3002,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'direkt, célzott vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, elemzése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű tájékoztató, magyarázó rajzok, ábrák, jelek, szimbólumok tervezése érdekében önállóan információt gyűjt.',
		a: 5,
		gT: 3001,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'direkt, célzott vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, elemzése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Vizuális megjelenítés során egyénileg és csoportmunkában is használja a kiemelés, figyelemirányítás, egyensúlyteremtés vizuális eszközeit.',
		a: 5,
		gT: 3000,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'személyes témák, gondolatok vizuális megjelenítése kifejezési szándéknak megfelelő vizuális eszközö'])
	},
		{
		cG: 'altgim',
		gD: 'Látványok, képek, médiaszövegek, történetek, szituációk feldolgozása kapcsán személyes módon kifejezi, megjeleníti felszínre kerülő érzéseit, gondolatait, asszociációit.',
		a: 5,
		gT: 2999,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'személyes témák, gondolatok vizuális megjelenítése kifejezési szándéknak megfelelő vizuális eszközö'])
	},
		{
		cG: 'altgim',
		gD: 'Megfogalmazza személyes viszonyulását, értelmezését adott vagy választott művész alkotásai, társadalmi reflexiói kapcsán.',
		a: 5,
		gT: 2998,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'alkotások elemzése kifejezőerő és a közvetített hatás értelmezésével'])
	},
		{
		cG: 'altgim',
		gD: 'Tetszésítélete alapján alkotásokról információkat gyűjt, kifejezőerő és a közvetített hatás szempontjából csoportosítja, és megállapításait felhasználja más szituációban.',
		a: 5,
		gT: 2997,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'alkotások elemzése kifejezőerő és a közvetített hatás értelmezésével'])
	},
		{
		cG: 'altgim',
		gD: 'Gondolatait, terveit, észrevételeit, véleményét változatos vizuális eszközök segítségével prezentálja.',
		a: 5,
		gT: 2996,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'magyarázat érdekében gondolatok vizuális bemutatása, illusztrálása'])
	},
		{
		cG: 'altgim',
		gD: 'Ismeri a térábrázolás alapvető módszereit (pl. axonometria, perspektíva) és azokat alkotómunkájában felhasználja.',
		a: 5,
		gT: 2995,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'térbeli és időbeli változások álló és mozgóképi megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Adott cél és szempontok figyelembevételével térbeli, időbeli viszonyokat, változásokat, eseményeket, történeteket egyénileg és csoportmunkában is rögzít, megjelenít.',
		a: 5,
		gT: 2994,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'térbeli és időbeli változások álló és mozgóképi megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Adott koncepció figyelembevételével, tudatos anyag- és eszközhasználattal tárgyakat, tereket tervez és hoz létre, egyénileg vagy csoportmunkában is.',
		a: 5,
		gT: 2993,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'adott cél érdekében térbeli forma, építmény, tárgy tervezése, létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző művészettörténeti korokban, stílusokban készült alkotásokat, építményeket összehasonlít, megkülönböztet és összekapcsol más jelenségekkel, fogalmakkal, alkotásokkal, melyek segítségével alkotótevékenysége során újrafogalmazza a látványt.',
		a: 5,
		gT: 2992,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'különböző művészettörténeti korokban, stílusokban készült alkotások megkülönböztetése'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző korok és kultúrák szimbólumai és motívumai közül adott cél érdekében gyűjtést végez, és alkotó tevékenységében felhasználja a gyűjtés eredményeit.',
		a: 5,
		gT: 2991,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megjelenések, képek, mozgóképek önálló értelmezése, összehasonlítása többféle szempont sze'])
	},
		{
		cG: 'altgim',
		gD: 'Vizuális megjelenések, képek, mozgóképek, médiaszövegek vizsgálata, összehasonlítása során feltárt következtetéseit megfogalmazza, és alkotó tevékenységében, egyénileg és csoportmunkában is felhasználja.',
		a: 5,
		gT: 2990,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megjelenések, képek, mozgóképek önálló értelmezése, összehasonlítása többféle szempont sze'])
	},
		{
		cG: 'altgim',
		gD: 'Vizuális problémák vizsgálata során összegyűjtött információkat, gondolatokat különböző szempontok szerint rendez és összehasonlít, a tapasztalatait különböző helyzetekben a megoldás érdekében felhasználja.',
		a: 5,
		gT: 2989,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megfigyelések eredményeinek felhasználása különböző elemzési helyzetekben'])
	},
		{
		cG: 'altgim',
		gD: 'A látványokkal kapcsolatos objektív és szubjektív észrevételeket pontosan szétválasztja.',
		a: 5,
		gT: 2988,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'vizuális megfigyelések eredményeinek felhasználása különböző elemzési helyzetekben'])
	},
		{
		cG: 'altgim',
		gD: 'Látványok, képek részeinek, részleteinek alapján elképzeli a látvány egészét, fogalmi és vizuális eszközökkel bemutatja és megjeleníti, rekonstruálja azt.',
		a: 5,
		gT: 2987,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'belső képek és elképzelések önálló vagy adott szempontoknak megfelelő bemutatása, vizuális megjelen'])
	},
		{
		cG: 'altgim',
		gD: 'Szöveges vagy egyszerű képi inspiráció alapján elképzeli és megjeleníti a látványt, egyénileg és csoportmunkában is.',
		a: 5,
		gT: 2986,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'belső képek és elképzelések önálló vagy adott szempontoknak megfelelő bemutatása, vizuális megjelen'])
	},
		{
		cG: 'altgim',
		gD: 'A valóság vagy a vizuális alkotások, illetve azok elemei által felidézett asszociatív módon generált képeket, történeteket szövegesen megfogalmaz, vizuálisan megjelenít, egyénileg és csoportmunkában is.',
		a: 5,
		gT: 2985,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'belső képek és elképzelések önálló vagy adott szempontoknak megfelelő bemutatása, vizuális megjelen'])
	},
		{
		cG: 'altgim',
		gD: 'Adott tartalmi keretek figyelembevételével karaktereket, tereket, tárgyakat, helyzeteket, történeteket részletesen elképzel, fogalmi és vizuális eszközökkel bemutat és megjelenít, egyénileg és csoportmunkában is.',
		a: 5,
		gT: 2984,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'belső képek és elképzelések önálló vagy adott szempontoknak megfelelő bemutatása, vizuális megjelen'])
	},
		{
		cG: 'altgim',
		gD: 'Elvont fogalmakat, művészeti tartalmakat belső képek összekapcsolásával bemutat, magyaráz és különböző vizuális eszközökkel megjelenít.',
		a: 5,
		gT: 2983,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elvont fogalmak és belső képek összekapcsolása, megjelenítése és magyarázat'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző érzetek kapcsán belső képeinek, képzeteinek megfigyelésével tapasztalatait vizuálisan megjeleníti.',
		a: 5,
		gT: 2982,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elvont fogalmak és belső képek összekapcsolása, megjelenítése és magyarázat'])
	},
		{
		cG: 'altgim',
		gD: 'Megfigyeléseit, tapasztalatait, gondolatait vizuálisan rögzíti, mások számára érthető vázlatot készít.',
		a: 5,
		gT: 2981,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'megfigyelések értelmezhető vizuális rögzítése'])
	},
		{
		cG: 'altgim',
		gD: 'Adott témával, feladattal kapcsolatos vizuális információkat és képi inspirációkat keres többféle forrásból.',
		a: 5,
		gT: 2980,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'feladatmegoldás során vizuális információk adekvát keresése, felidézése'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotómunka során felhasználja a már látott képi inspirációkat.',
		a: 5,
		gT: 2979,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'feladatmegoldás során vizuális információk adekvát keresése, felidézése'])
	},
		{
		cG: 'altgim',
		gD: 'Látványok, vizuális jelenségek, alkotások lényeges, egyedi jellemzőit kiemeli, bemutatja.',
		a: 5,
		gT: 2978,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'önálló vizuális megfigyelések leírása, bemutatása'])
	},
		{
		cG: 'altgim',
		gD: 'Látványt, vizuális jelenségeket, műalkotásokat önállóan is pontosan, részletgazdagon szövegesen jellemez, bemutat.',
		a: 5,
		gT: 2977,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'önálló vizuális megfigyelések leírása, bemutatása'])
	},
		{
		cG: 'altgim',
		gD: 'Önállóan véleményt alkot, és azt röviden indokolja.',
		a: 5,
		gT: 2976,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldás során megállapodásokat köt, szabályt alkot, és betartja a közösen meghatározott feltételeket.',
		a: 5,
		gT: 2975,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportban végzett feladatmegoldás során részt vállal a feladatmegoldásban, önállóan megtalálja saját feladatát, és figyelembe veszi társai álláspontját is.',
		a: 5,
		gT: 2974,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Érti a magyar és egyetemes kulturális örökség és hagyomány jelentőségét.',
		a: 5,
		gT: 2973,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján meg tudja magyarázni a tervezett, épített környezet és a funkció összefüggéseit.',
		a: 5,
		gT: 2972,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján megérti a képmanipuláció és befolyásolás összefüggéseit.',
		a: 5,
		gT: 2971,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Használja a térbeli és az időbeli viszonyok megjelenítésének különböző vizuális lehetőségeit.',
		a: 5,
		gT: 2970,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri az egyes témakörök szemléltetésére használt műalkotásokat, alkotókat az ajánlott képanyag alapján.',
		a: 5,
		gT: 2969,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megkülönböztet művészettörténeti korszakokat, stílusokat.',
		a: 5,
		gT: 2968,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Használja és megkülönbözteti a különböző vizuális médiumok kifejezőeszközeit.',
		a: 5,
		gT: 2967,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Felismeri a vizuális művészeti műfajok példáit.',
		a: 5,
		gT: 2966,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldásai során felidézi és alkalmazza a korábban szerzett ismereteket, illetve kapcsolódó információkat keres.',
		a: 5,
		gT: 2965,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Adott tanulási helyzetben a tanulási előrehaladás érdekében adekvát kérdést tesz fel.',
		a: 5,
		gT: 2964,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatokat önállóan megold, eredményeit érthetően bemutatja.',
		a: 5,
		gT: 2963,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Anyaghasználata gazdaságos, átgondolt.',
		a: 5,
		gT: 2962,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Eszközhasználata begyakorlott, szakszerű.',
		a: 5,
		gT: 2961,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotó tevékenység közben önállóan kísérletezik, különböző megoldási utakat keres.',
		a: 5,
		gT: 2960,
		b: 8,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző egyszerű anyagokkal kísérletezik, szabadon épít, saját célok érdekében konstruál.',
		a: 1,
		gT: 2959,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'alkotótevékenység közben saját ötletek bátor használata'])
	},
		{
		cG: 'altgim',
		gD: 'Adott álló- vagy mozgóképi megjelenéseket egyéni elképzelés szerint átértelmez.',
		a: 1,
		gT: 2958,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'alkotótevékenység közben saját ötletek bátor használata'])
	},
		{
		cG: 'altgim',
		gD: 'Saját történetet alkot, és azt vizuális eszközökkel is tetszőlegesen megjeleníti.',
		a: 1,
		gT: 2957,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'kreativitás', 'alkotótevékenység közben saját ötletek bátor használata'])
	},
		{
		cG: 'altgim',
		gD: 'Időbeli történéseket egyszerű vizuális eszközökkel, segítséggel megjelenít.',
		a: 1,
		gT: 2956,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'adott cél érdekében egyszerű vizuális kommunikációs megjelenés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Saját kommunikációs célból egyszerű térbeli tájékozódást segítő ábrát -- alaprajz, térkép -- készít.',
		a: 1,
		gT: 2955,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'adott cél érdekében egyszerű vizuális kommunikációs megjelenés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Adott cél érdekében egyszerű vizuális kommunikációt szolgáló megjelenéseket -- jel, meghívó, plakát -- készít egyénileg vagy csoportmunkában.',
		a: 1,
		gT: 2954,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'adott cél érdekében egyszerű vizuális kommunikációs megjelenés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a nonverbális kommunikáció eszközeit: mimika, gesztus, ezzel kapcsolatos tapasztalatait közlési és kifejezési helyzetekben használja.',
		a: 1,
		gT: 2953,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'adott cél érdekében egyszerű vizuális kommunikációs megjelenés létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Azonosítja a gyerekeknek szóló vagy fogyasztásra ösztönző, célzottan kommunikációs szándékú vizuális közléseket.',
		a: 1,
		gT: 2952,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Az adott életkornak megfelelő tájékoztatást, meggyőzést, figyelemfelkeltést szolgáló, célzottan kommunikációs szándékú vizuális közléseket segítséggel értelmez.',
		a: 1,
		gT: 2951,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Pontosan ismeri államcímerünk és nemzeti zászlónk felépítését, összetevőit, színeit.',
		a: 1,
		gT: 2950,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű, mindennapok során használt jeleket felismer.',
		a: 1,
		gT: 2949,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'Az adott életkornak megfelelő rövid mozgóképi közléseket segítséggel elemez a vizuális kifejezőeszközök használatának tudatosítása érdekében.',
		a: 1,
		gT: 2948,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'célzottan kommunikációs szándékú vizuális közlések értelmezése, megvitatása'])
	},
		{
		cG: 'altgim',
		gD: 'A vizuális nyelv elemeinek értelmezésével és használatával kísérletezik.',
		a: 1,
		gT: 2947,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'célzott, direkt vizuális közlés', 'megadott szempontok segítségével vizuális kommunikációs elemek azonosítása'])
	},
		{
		cG: 'altgim',
		gD: 'Valós vagy digitális játékélményeit vizuálisan és dramatikusan feldolgozza: rajzol, fest, formáz, nyomtat, eljátszik, elmesél.',
		a: 1,
		gT: 2946,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'saját élmények megfogalmazása és vizuális megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Korábban átélt eseményeket, tapasztalatokat, élményeket különböző vizuális eszközökkel, élményszerűen megjelenít: rajzol, fest, nyomtat, formáz, épít, fotóz és magyarázza azt.',
		a: 1,
		gT: 2945,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'saját élmények megfogalmazása és vizuális megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Saját és mások érzelmeit, hangulatait segítséggel megfogalmazza és egyszerű dramatikus eszközökkel eljátssza, vizuális eszközökkel megjeleníti.',
		a: 1,
		gT: 2944,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális kifejezés', 'érzelmek, hangulatok azonosítása és megjelenítése különböző eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'A tanulás során szerzett tapasztalatait, saját céljait, gondolatait vizuális megjelenítés segítségével magyarázza, illusztrálja egyénileg és csoportmunkában.',
		a: 1,
		gT: 2943,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'magyarázat érdekében gondolatok vizuális bemutatása'])
	},
		{
		cG: 'altgim',
		gD: 'Gyűjtött természeti vagy mesterséges formák egyszerűsítésével, vagy a magyar díszítőművészet általa megismert mintakincsének felhasználásával mintát tervez.',
		a: 1,
		gT: 2942,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'adott vagy választott inspirációforrás alapján mintatervezés'])
	},
		{
		cG: 'altgim',
		gD: 'Adott cél érdekében alkalmazza a térbeli formaalkotás különböző technikáit egyénileg és csoportmunkában.',
		a: 1,
		gT: 2941,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'önállóan választott eszközökkel térbeli forma, építmény, tárgy tervezése, létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Alkalmazza az egyszerű tárgykészítés legfontosabb technikáit: vág, ragaszt, tűz, varr, kötöz, fűz, mintáz.',
		a: 1,
		gT: 2940,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'önállóan választott eszközökkel térbeli forma, építmény, tárgy tervezése, létrehozása'])
	},
		{
		cG: 'altgim',
		gD: 'Adott cél érdekében fotót vagy rövid mozgóképet készít.',
		a: 1,
		gT: 2939,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'látvány változatos megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző alakzatokat, motívumokat, egyszerű vizuális megjelenéseket látvány alapján, különböző vizuális eszközökkel, viszonylagos pontossággal megjelenít: rajzol, fest, nyomtat, formáz, épít.',
		a: 1,
		gT: 2938,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megjelenítés, ábrázolás, konstruálás', 'látvány változatos megjelenítése'])
	},
		{
		cG: 'altgim',
		gD: 'Képek, műalkotások, mozgóképi közlések megtekintése után adott szempontok szerint következtetést fogalmaz meg, megállapításait társaival is megvitatja.',
		a: 1,
		gT: 2937,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'megadott szempontok segítségével vizuális megjelenések, képek, mozgóképek értelmezése, összehasonlí'])
	},
		{
		cG: 'altgim',
		gD: 'Képek, műalkotások, mozgóképi közlések megtekintése után önállóan megfogalmazza és indokolja tetszésítéletét.',
		a: 1,
		gT: 2936,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'megadott szempontok segítségével vizuális megjelenések, képek, mozgóképek értelmezése, összehasonlí'])
	},
		{
		cG: 'altgim',
		gD: 'Saját munkákat, képeket, műalkotásokat, mozgóképi részleteket szereplők karaktere, szín-, fényhatás, kompozíció, kifejezőerő szempontjából szövegesen elemez, összehasonlít.',
		a: 1,
		gT: 2935,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'megadott szempontok segítségével vizuális megjelenések, képek, mozgóképek értelmezése, összehasonlí'])
	},
		{
		cG: 'altgim',
		gD: 'Saját és társai vizuális munkáit szövegesen értelmezi, kiegészíti, magyarázza.',
		a: 1,
		gT: 2934,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'vizuális elemzés, vizuális értelmezés', 'megadott szempontok segítségével vizuális megjelenések, képek, mozgóképek értelmezése, összehasonlí'])
	},
		{
		cG: 'altgim',
		gD: 'Elképzelt történeteket, irodalmi alkotásokat bemutat, dramatizál, ehhez egyszerű eszközöket: bábot, teret, díszletet, kelléket, egyszerű jelmezt készít csoportmunkában, és élményeit szövegesen megfogalmazza.',
		a: 1,
		gT: 2933,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elképzelt dolgok önálló vizuális megjelenítése és szöveges magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű eszközökkel és anyagokból elképzelt teret rendez, alakít, egyszerű makettet készít egyénileg vagy csoportmunkában, és az elképzelést szövegesen is bemutatja, magyarázza.',
		a: 1,
		gT: 2932,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elképzelt dolgok önálló vizuális megjelenítése és szöveges magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Rövid szövegekhez, egyéb tananyagtartalmakhoz síkbeli és térbeli vizuális illusztrációt készít különböző vizuális eszközökkel: rajzol, fest, nyomtat, fotóz, formáz, épít és a képet, tárgyat szövegesen értelmezi.',
		a: 1,
		gT: 2931,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elképzelt dolgok önálló vizuális megjelenítése és szöveges magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Élmények, elképzelt vagy hallott történetek, szövegek részleteit különböző vizuális eszközökkel egyszerűen megjeleníti: rajzol, fest, nyomtat, fotóz, formáz, épít.',
		a: 1,
		gT: 2930,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'belső képalkotás, képzetek', 'elképzelt dolgok önálló vizuális megjelenítése és szöveges magyarázata'])
	},
		{
		cG: 'altgim',
		gD: 'Vizuális jelenségeket, egyszerű látott képi elemeket különböző vizuális eszközökkel megjelenít: rajzol, fest, nyomtat, formáz, épít.',
		a: 1,
		gT: 2929,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'látott dolgok egyszerű megjelenítése különböző eszközökkel'])
	},
		{
		cG: 'altgim',
		gD: 'Látványt, vizuális jelenségeket, képeket viszonylagos pontossággal emlékezetből azonosít, kiválaszt, megnevez, különböző szempontok szerint rendez.',
		a: 1,
		gT: 2928,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'megadott szempontok segítségével, irányított megfigyelések alapján vizuális megjelenések azonosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Közvetlen vizuális megfigyeléssel leolvasható egyszerű jellemzők alapján vizuális jelenségeket, képeket méret, irány, elhelyezkedés, mennyiség, szín szempontjából azonosít, kiválaszt, rendez, szövegesen pontosan leír és összehasonlít.',
		a: 1,
		gT: 2927,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'megadott szempontok segítségével, irányított megfigyelések alapján vizuális megjelenések azonosítás'])
	},
		{
		cG: 'altgim',
		gD: 'Érzékszervi tapasztalatokat pontosan megfogalmaz mérettel, formával, színnel, felülettel, illattal, hanggal, mozgással kapcsolatban.',
		a: 1,
		gT: 2926,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['vizuális kultúra', 'megfigyelés, vizuális emlékezet', 'irányított megfigyelések tárgyának jellemzése, leírása'])
	},
		{
		cG: 'altgim',
		gD: 'Véleményét önállóan megfogalmazza.',
		a: 1,
		gT: 2925,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Egyszerű, begyakorolt feladatokat önállóan is elvégez.',
		a: 1,
		gT: 2924,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Feladatmegoldás során betartja az előre ismertetett szabályokat.',
		a: 1,
		gT: 2923,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportban végzett feladatmegoldás közben képes érvelésre.',
		a: 1,
		gT: 2922,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Csoportban végzett feladatmegoldás során részt vállal a feladatmegoldásban, és figyelembe veszi társai álláspontját.',
		a: 1,
		gT: 2921,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Önálló döntéseket hoz a környezet alakításának szempontjából.',
		a: 1,
		gT: 2920,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján azonosítja a médiafogyasztás mindennapi jelenségeit.',
		a: 1,
		gT: 2919,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Gondolatait vizuálisan is érthetően megmagyarázza.',
		a: 1,
		gT: 2918,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Példák alapján különbséget tesz a hétköznapi és a művészi között.',
		a: 1,
		gT: 2917,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Megérti és végrehajtja a feladatokat.',
		a: 1,
		gT: 2916,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Különböző eszközöket rendeltetésszerűen használ.',
		a: 1,
		gT: 2915,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	},
		{
		cG: 'altgim',
		gD: 'Alkotó tevékenység közben bátran kísérletezik.',
		a: 1,
		gT: 2914,
		b: 4,
		e2: 'Vizuális kultúra',
		jE: _List_fromArray(
			['átfogó célként kitűzött, valamint a fejlesztési területekhez kapcsolódó tanulási eredmények', 'vizuális kultúra'])
	}
	]);
var $author$project$LearningOutcome$getLoByID = function (id) {
	var result = A2(
		$elm$core$List$filter,
		function (lo) {
			return _Utils_eq(lo.gT, id);
		},
		$author$project$LearningOutcome$all);
	return $elm$core$List$head(result);
};
var $elm$json$Json$Decode$map7 = _Json_map7;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Util$Json$onlyJusts = function (failMessage) {
	return $elm$json$Json$Decode$andThen(
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map($elm$json$Json$Decode$succeed),
			$elm$core$Maybe$withDefault(
				$elm$json$Json$Decode$fail(failMessage))));
};
var $author$project$Rubric$RubricAssessment = F3(
	function (rubricId, rubric, selected) {
		return {mS: rubric, mT: rubricId, z: selected};
	});
var $author$project$Rubric$RubricContent = F2(
	function (levels, aspects) {
		return {ki: aspects, fG: levels};
	});
var $author$project$Rubric$Aspect = F3(
	function (title, levelDescriptions, subjectId) {
		return {lV: levelDescriptions, nf: subjectId, jJ: title};
	});
var $author$project$Rubric$aspectDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'subjectId',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'levelDescriptions',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'title',
			$elm$json$Json$Decode$string,
			$elm$json$Json$Decode$succeed($author$project$Rubric$Aspect))));
var $author$project$Rubric$Scale = F2(
	function (label, levels) {
		return {lO: label, fG: levels};
	});
var $author$project$Rubric$scaleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'levels',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'label',
		$elm$json$Json$Decode$string,
		$elm$json$Json$Decode$succeed($author$project$Rubric$Scale)));
var $author$project$Rubric$rubricContentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'aspects',
	$elm$json$Json$Decode$list($author$project$Rubric$aspectDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'scale',
		$author$project$Rubric$scaleDecoder,
		$elm$json$Json$Decode$succeed($author$project$Rubric$RubricContent)));
var $author$project$Rubric$rubricAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'selected',
	$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rubric',
		$author$project$Rubric$rubricContentDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'rubricId',
			$elm$json$Json$Decode$int,
			0,
			$elm$json$Json$Decode$succeed($author$project$Rubric$RubricAssessment))));
var $author$project$Badge$badgeDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Badge$Badge,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'is_locked', $elm$json$Json$Decode$bool),
	A2($elm$json$Json$Decode$field, 'story_id', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'learning_outcomes',
		$elm$json$Json$Decode$list(
			A2(
				$author$project$Util$Json$onlyJusts,
				'LO not found',
				A2($elm$json$Json$Decode$map, $author$project$LearningOutcome$getLoByID, $elm$json$Json$Decode$int)))),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'feedback', $author$project$Rubric$rubricAssessmentDecoder)),
	A2($elm$json$Json$Decode$field, 'created_by', $author$project$Person$nestedPersonDecoder));
var $author$project$ClassroomStudentSubmission$NestedClassroomStudentSubmission = F2(
	function (id, url) {
		return {gT: id, G: url};
	});
var $author$project$ClassroomStudentSubmission$embeddedClassroomStudentSubmissionDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'id',
		$elm$json$Json$Decode$int,
		$elm$json$Json$Decode$succeed($author$project$ClassroomStudentSubmission$NestedClassroomStudentSubmission)));
var $author$project$Module$NestedModule = F3(
	function (id, title, accountableTeacher) {
		return {j3: accountableTeacher, gT: id, jJ: title};
	});
var $author$project$Module$moduleIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$Module$nestedModuleDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'accountable_teacher',
	$author$project$Person$nestedPersonDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Module$moduleIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Module$NestedModule))));
var $author$project$Team$Team = F3(
	function (id, name, displayName) {
		return {kP: displayName, gT: id, ha: name};
	});
var $author$project$Team$teamDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'display_name',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'name',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$Team$teamIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$Team$Team))));
var $author$project$Team$nestedTeamDecoder = $author$project$Team$teamDecoder;
var $author$project$PortfolioStory$StoryMedia = F4(
	function (orig, small, preview, large) {
		return {iM: large, mq: orig, hi: preview, m4: small};
	});
var $author$project$PortfolioStory$storyMediaDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'large',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'preview',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'small',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'orig',
				$elm$json$Json$Decode$string,
				$elm$json$Json$Decode$succeed($author$project$PortfolioStory$StoryMedia)))));
var $author$project$PortfolioStory$ModuleClosure = 1;
var $author$project$PortfolioStory$Na = 0;
var $author$project$PortfolioStory$storyTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'na':
				return $elm$json$Json$Decode$succeed(0);
			case 'mclosure':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('don\'t know ' + (s + ' type'));
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$PortfolioStory$portfolioStoryDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'classroom_submission',
	$elm$json$Json$Decode$nullable($author$project$ClassroomStudentSubmission$embeddedClassroomStudentSubmissionDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'badges',
		$elm$json$Json$Decode$list($author$project$Badge$badgeDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'students',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'team',
				$author$project$Team$nestedTeamDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'created_by',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_locked',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'module',
								$elm$json$Json$Decode$nullable($author$project$Module$nestedModuleDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'media',
									$elm$json$Json$Decode$list($author$project$PortfolioStory$storyMediaDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'description',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'type',
											$author$project$PortfolioStory$storyTypeDecoder,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'id',
												$elm$json$Json$Decode$int,
												$elm$json$Json$Decode$succeed($author$project$PortfolioStory$PortfolioStory)))))))))))));
var $author$project$PortfolioStory$portfolioStoriesDecoder = $elm$json$Json$Decode$list($author$project$PortfolioStory$portfolioStoryDecoder);
var $author$project$Api$Endpoint$optional = F3(
	function (encoder, _v0, params) {
		var name = _v0.a;
		var value = _v0.b;
		return _Utils_ap(
			params,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					function (value_) {
						return _List_fromArray(
							[
								_Utils_Tuple2(
								name,
								encoder(value_))
							]);
					},
					value)));
	});
var $author$project$Api$Endpoint$optionalList = F3(
	function (encoder, _v0, params) {
		var name = _v0.a;
		var valueList = _v0.b;
		return _Utils_ap(
			params,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$elm$core$List$map(
						function (value) {
							return _Utils_Tuple2(
								name,
								encoder(value));
						}),
					valueList)));
	});
var $author$project$Api$Endpoint$toPortfolioStoriesListQueryParams = function (listParams) {
	return A3(
		$author$project$Api$Endpoint$optionalList,
		$elm$core$String$fromInt,
		_Utils_Tuple2('classrooms', listParams.gx),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('teachers', listParams.e5),
			A3(
				$author$project$Api$Endpoint$optionalList,
				$elm$core$String$fromInt,
				_Utils_Tuple2('students', listParams.e1),
				A3(
					$author$project$Api$Endpoint$optionalList,
					$elm$core$String$fromInt,
					_Utils_Tuple2('modules', listParams.g9),
					A3(
						$author$project$Api$Endpoint$optional,
						$elm$core$String$fromInt,
						_Utils_Tuple2('end', listParams.gG),
						A3(
							$author$project$Api$Endpoint$optional,
							$elm$core$String$fromInt,
							_Utils_Tuple2('start', listParams.hu),
							A3(
								$author$project$Api$Endpoint$optional,
								$elm$core$String$fromInt,
								_Utils_Tuple2('last_seen', listParams.cS),
								_List_fromArray(
									[
										_Utils_Tuple2(
										'size',
										$elm$core$String$fromInt(listParams.de)),
										_Utils_Tuple2('type', listParams.hH),
										_Utils_Tuple2('q', listParams.bw),
										_Utils_Tuple2('cat', listParams.bs)
									]))))))));
};
var $author$project$Api$Endpoint$portfolioStoriesList = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'portfolio-stories']),
			$author$project$Api$Endpoint$toPortfolioStoriesListQueryParams(listParams));
	});
var $author$project$PortfolioStory$fetchAllStudentStories = F3(
	function (config, personId, callback) {
		var params = {
			bs: '',
			gx: $elm$core$Maybe$Nothing,
			gG: $elm$core$Maybe$Nothing,
			cS: $elm$core$Maybe$Nothing,
			g9: $elm$core$Maybe$Nothing,
			bw: '',
			de: -1,
			hu: $elm$core$Maybe$Nothing,
			e1: $elm$core$Maybe$Just(
				_List_fromArray(
					[personId])),
			e5: $elm$core$Maybe$Nothing,
			hH: 'feedback'
		};
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$RemoteData$Failure = function (a) {
	return {$: 3, a: a};
};
var $author$project$RemoteData$Success = function (a) {
	return {$: 2, a: a};
};
var $author$project$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $author$project$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $author$project$RemoteData$Success(x);
	}
};
var $author$project$Api$Endpoint$studentProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'student-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$StudentProfile$StudentProfile = function (id) {
	return function (state) {
		return function (student) {
			return function (mothersMaidenName) {
				return function (admission) {
					return function (basicTask) {
						return function (termination) {
							return function (missedClasses) {
								return function (accidents) {
									return function (competencyTestResults) {
										return function (exams) {
											return function (disciplinaryAndCompensationCases) {
												return function (studentCardId) {
													return function (textbookSupply) {
														return function (schoolYearRepetition) {
															return function (tripAbroad) {
																return function (specialStatus) {
																	return function (isIndividualStudent) {
																		return function (currentSchoolYear) {
																			return function (nekId) {
																				return function (firstForeignLanguage) {
																					return function (secondForeignLanguage) {
																						return function (lastReportCardUrl) {
																							return function (evaluationUrl) {
																								return function (individualStudentUrl) {
																									return function (specialStatusUrl) {
																										return function (studentCardUrl) {
																											return function (birthCertificateUrl) {
																												return function (residencePermitUrl) {
																													return function (idCardUrl) {
																														return function (taxIdUrl) {
																															return function (ssnUrl) {
																																return function (nekIdUrl) {
																																	return {X: accidents, Y: admission, _: basicTask, n: birthCertificateUrl, ad: competencyTestResults, id: currentSchoolYear, ae: disciplinaryAndCompensationCases, v: evaluationUrl, ag: exams, a6: firstForeignLanguage, gT: id, o: idCardUrl, x: individualStudentUrl, ai: isIndividualStudent, E: lastReportCardUrl, al: missedClasses, aq: mothersMaidenName, m: nekId, d: nekIdUrl, q: residencePermitUrl, at: schoolYearRepetition, bb: secondForeignLanguage, au: specialStatus, A: specialStatusUrl, r: ssnUrl, eZ: state, ne: student, aw: studentCardId, F: studentCardUrl, s: taxIdUrl, ay: termination, az: textbookSupply, aB: tripAbroad};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$StudentProfile$Student = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlace) {
										return function (nationality) {
											return function (eduId) {
												return function (ssn) {
													return function (sponsoredBy) {
														return function (supervisingSchool) {
															return function (team) {
																return function (mentor) {
																	return {aE: birthDate, ac: birthPlace, aG: birthPlaceCountry, af: eduId, K: email, k3: firstName, gT: id, ak: lastName, l_: mentor, ar: nationality, c1: permanentAddress, aQ: phoneNumber, m9: sponsoredBy, av: ssn, ax: supervisingSchool, jF: team, nn: temporaryAddress};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$StudentProfile$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'team',
		$author$project$Team$nestedTeamDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'supervising_school',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_by',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ssn',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'edu_id',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'nationality',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'birthplace',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'birthplace_country',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'birthdate',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'temporary_address',
											$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'permanent_address',
												$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'phone_number',
													$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'email',
														$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'last_name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'first_name',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'id',
																	$elm$json$Json$Decode$int,
																	$elm$json$Json$Decode$succeed($author$project$StudentProfile$Student))))))))))))))))));
var $author$project$StudentProfile$StudentProfileId = $elm$core$Basics$identity;
var $author$project$StudentProfile$studentProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$StudentProfile$studentProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'nek_id_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ssn_url',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'tax_id_url',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'id_card_url',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'residence_permit_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birth_certificate_url',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'student_card_url',
							$elm$json$Json$Decode$string,
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'special_status_report_url',
								$elm$json$Json$Decode$string,
								'',
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'individual_student_url',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'evaluation_url',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'last_report_card_url',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'second_foreign_language',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_foreign_language',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'nek_id',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'current_school_year',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'is_individual_student',
																$elm$json$Json$Decode$bool,
																A4(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
																	'special_status_type',
																	$elm$json$Json$Decode$string,
																	'NONE',
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'trip_abroad',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'school_year_repetition',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'textbook_supply',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'student_card_id',
																					$elm$json$Json$Decode$string,
																					A3(
																						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																						'disciplinary_and_compensation_cases',
																						$elm$json$Json$Decode$string,
																						A3(
																							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																							'exams',
																							$elm$json$Json$Decode$string,
																							A3(
																								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																								'competency_test_results',
																								$elm$json$Json$Decode$string,
																								A3(
																									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																									'accidents',
																									$elm$json$Json$Decode$string,
																									A3(
																										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																										'missed_classes',
																										$elm$json$Json$Decode$string,
																										A3(
																											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																											'termination',
																											$elm$json$Json$Decode$string,
																											A3(
																												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																												'basic_task',
																												$elm$json$Json$Decode$string,
																												A3(
																													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																													'admission',
																													$elm$json$Json$Decode$string,
																													A3(
																														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																														'mothers_name',
																														$elm$json$Json$Decode$string,
																														A3(
																															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																															'student',
																															$author$project$StudentProfile$studentDecoder,
																															A3(
																																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																'state',
																																$elm$json$Json$Decode$string,
																																A3(
																																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																																	'id',
																																	$author$project$StudentProfile$studentProfileIdDecoder,
																																	$elm$json$Json$Decode$succeed($author$project$StudentProfile$StudentProfile))))))))))))))))))))))))))))))))));
var $author$project$StudentProfile$fetchStudentProfileV2 = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$studentProfile, config, id),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$StudentProfile$studentProfileDecoder));
	});
var $author$project$Api$Endpoint$subjects = F2(
	function (config, category) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'subjects']),
			_List_fromArray(
				[
					_Utils_Tuple2('cat', category)
				]));
	});
var $author$project$Subject$Subject = F5(
	function (id, name, officialName, slug, isCore) {
		return {gT: id, lq: isCore, ha: name, fQ: officialName, m3: slug};
	});
var $author$project$Subject$subjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_core',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'slug',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'official_name',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'id',
					$elm$json$Json$Decode$int,
					$elm$json$Json$Decode$succeed($author$project$Subject$Subject))))));
var $author$project$Subject$subjectsDecoder = $elm$json$Json$Decode$list($author$project$Subject$subjectDecoder);
var $author$project$Subject$fetchSubjects = F2(
	function (config, callback) {
		var noCategory = '';
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$subjects, config, noCategory),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Subject$subjectsDecoder));
	});
var $author$project$Element$GradeReportCard$init = F3(
	function (config, session, params) {
		var model = {bN: config, b9: $author$project$RemoteData$NotAsked, dR: $author$project$RemoteData$NotAsked, dZ: $elm$core$Dict$empty, c3: $elm$core$Maybe$Nothing, fU: $author$project$Element$GradeReportCard$PortfolioStoriesDownloading, bY: $elm$core$Maybe$Nothing, ea: $author$project$RemoteData$Loading, jB: $author$project$RemoteData$Loading, e4: _List_Nil};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$StudentProfile$fetchStudentProfileV2, config.gr, params.g2, $author$project$Element$GradeReportCard$StudentProfileDownloaded),
					A3($author$project$PortfolioStory$fetchAllStudentStories, config.gr, params.g2, $author$project$Element$GradeReportCard$StoriesDownloadResponse),
					A2($author$project$Subject$fetchSubjects, config.gr, $author$project$Element$GradeReportCard$SubjectListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Locale$Messages$GradeReportsDownloadError = {$: 75};
var $author$project$Locale$Messages$LearningAssessmentsDownloadError = {$: 131};
var $author$project$Element$GradeReportCard$ModuleDownloadResponse = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradeReportCard$NoOp = {$: 9};
var $author$project$Element$GradeReportCard$PortfolioStoriesDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$PortfoliosDownloadError = {$: 390};
var $author$project$Locale$Messages$StudentProfileFormDownloadError = {$: 564};
var $author$project$Locale$Messages$SubjectListDownloadError = {$: 596};
var $author$project$Element$GradeReportCard$GradeReportListDownloadResponse = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GradeReportCard$LearningAssessmentListDownloadedResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$gradeReportsByPerson = F2(
	function (config, personId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'grade-reports'
				]),
			_List_Nil);
	});
var $author$project$GradeReport$GradeReport = function (id) {
	return function (student) {
		return function (grade) {
			return function (type_) {
				return function (isLocked) {
					return function (comment) {
						return function (teacher) {
							return function (gradeUrl) {
								return function (feedbackUrl) {
									return function (startDate) {
										return function (endDate) {
											return function (isVisibleForSponsors) {
												return function (isVisibleForStudent) {
													return function (ignoredSubjects) {
														return function (subjects) {
															return {h9: comment, gH: endDate, k1: feedbackUrl, gO: grade, lc: gradeUrl, gT: id, lk: ignoredSubjects, lw: isLocked, lD: isVisibleForSponsors, lE: isVisibleForStudent, hv: startDate, ne: student, jB: subjects, gb: teacher, hH: type_};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$GradeReport$GradeReportItem = function (subject) {
	return function (goalToAchieve) {
		return function (achievedTotal) {
			return function (achievableTotal) {
				return function (achievedPercentage) {
					return function (mark) {
						return function (learningOutcomes) {
							return function (ignored) {
								return function (textAppraisal) {
									return function (showTextAppraisal) {
										return {j4: achievableTotal, j5: achievedPercentage, j6: achievedTotal, k8: goalToAchieve, iy: ignored, g3: learningOutcomes, iQ: mark, m2: showTextAppraisal, e2: subject, no: textAppraisal};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$GradeReport$learningOutcomeDecoder = A3(
	$elm$json$Json$Decode$map2,
	F2(
		function (id, desc) {
			return _Utils_Tuple2(id, desc);
		}),
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'description_hu', $elm$json$Json$Decode$string));
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt = F4(
	function (path, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3($NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder, path, valDecoder, fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$GradeReport$endYearItemDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['learning_outcomes', 'show_text_appraisal']),
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['learning_outcomes', 'text_appraisal']),
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['learning_outcomes', 'ignored_subject']),
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['learning_outcomes', 'recognized']),
				$elm$json$Json$Decode$list($author$project$GradeReport$learningOutcomeDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['learning_outcomes', 'grade']),
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['learning_outcomes', 'achieved_percentage']),
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['learning_outcomes', 'achievable_total']),
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['learning_outcomes', 'achieved_total']),
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['learning_outcomes', 'goal_to_achieve']),
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['subject']),
										$author$project$Subject$subjectDecoder,
										$elm$json$Json$Decode$succeed($author$project$GradeReport$GradeReportItem)))))))))));
var $author$project$GradeReport$EndOfYear = 1;
var $author$project$GradeReport$GradingExam = 2;
var $author$project$GradeReport$MidYear = 0;
var $author$project$GradeReport$gradeReportTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'mid_year':
				return $elm$json$Json$Decode$succeed(0);
			case 'end_of_year':
				return $elm$json$Json$Decode$succeed(1);
			case 'grading_exam':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$GradeReport$midYearItemDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
	_List_fromArray(
		['learning_outcomes', 'show_text_appraisal']),
	$elm$json$Json$Decode$bool,
	false,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalAt,
		_List_fromArray(
			['learning_outcomes', 'text_appraisal']),
		$elm$json$Json$Decode$string,
		'',
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
			_List_fromArray(
				['learning_outcomes', 'ignored_subject']),
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
				_List_fromArray(
					['learning_outcomes', 'recognized']),
				$elm$json$Json$Decode$list($author$project$GradeReport$learningOutcomeDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
					_List_fromArray(
						['learning_outcomes', 'trimester_grade']),
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
						_List_fromArray(
							['learning_outcomes', 'trimester_achieved_percentage']),
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
							_List_fromArray(
								['learning_outcomes', 'achievable_total']),
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
								_List_fromArray(
									['learning_outcomes', 'achieved_total']),
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
									_List_fromArray(
										['learning_outcomes', 'trimester_total']),
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['subject']),
										$author$project$Subject$subjectDecoder,
										$elm$json$Json$Decode$succeed($author$project$GradeReport$GradeReportItem)))))))))));
var $author$project$GradeReport$gradeReportDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (partial) {
		var report = partial(_List_Nil);
		var _v0 = report.hH;
		switch (_v0) {
			case 0:
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subjects',
					$elm$json$Json$Decode$list($author$project$GradeReport$midYearItemDecoder),
					$elm$json$Json$Decode$succeed(partial));
			case 1:
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subjects',
					$elm$json$Json$Decode$list($author$project$GradeReport$endYearItemDecoder),
					$elm$json$Json$Decode$succeed(partial));
			default:
				return A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'subjects',
					$elm$json$Json$Decode$list($author$project$GradeReport$endYearItemDecoder),
					$elm$json$Json$Decode$succeed(partial));
		}
	},
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'ignored_subjects',
		$elm$json$Json$Decode$list($author$project$Subject$subjectDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_visible_for_student',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_visible_for_sponsors',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'end_date',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'start_date',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'feedback_url',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'url',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'teacher',
									$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'teacher_comment',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'locking_done',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'type',
												$author$project$GradeReport$gradeReportTypeDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'grade',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'student',
														$author$project$Person$nestedPersonDecoder,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$GradeReport$GradeReport))))))))))))))));
var $author$project$GradeReport$gradeReportsDecoder = $elm$json$Json$Decode$list($author$project$GradeReport$gradeReportDecoder);
var $author$project$GradeReport$fetchGradeReportsByPersonV2 = F3(
	function (config, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$gradeReportsByPerson, config, personId),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$GradeReport$gradeReportsDecoder));
	});
var $author$project$LearningAssessment$LearningAssessment = function (id) {
	return function (student) {
		return function (grade) {
			return function (type_) {
				return function (subjects) {
					return function (absenceMinutes) {
						return function (justifiedAbsenceMinutes) {
							return function (unjustifiedAbsenceMinutes) {
								return function (startDate) {
									return function (endDate) {
										return function (reportCardSupplementUrl) {
											return function (reportWithMarksUrl) {
												return function (reportWithTextAppraisalUrl) {
													return function (isAssessmentProcessDone) {
														return function (isLocked) {
															return function (isSupervised) {
																return function (isPassed) {
																	return function (mustRepeatGrade) {
																		return function (canTakeRepeatExam) {
																			return function (canRequireMark) {
																				return {fc: absenceMinutes, kw: canRequireMark, fn: canTakeRepeatExam, gH: endDate, gO: grade, gT: id, fA: isAssessmentProcessDone, lw: isLocked, fC: isPassed, fD: isSupervised, fE: justifiedAbsenceMinutes, fL: mustRepeatGrade, fZ: reportCardSupplementUrl, mI: reportWithMarksUrl, mJ: reportWithTextAppraisalUrl, hv: startDate, ne: student, jB: subjects, hH: type_, ge: unjustifiedAbsenceMinutes};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningAssessment$EndOfYear = 1;
var $author$project$LearningAssessment$GradingExam = 2;
var $author$project$LearningAssessment$MidYear = 0;
var $author$project$LearningAssessment$learningAssessmentTypeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (s) {
		switch (s) {
			case 'mid_year':
				return $elm$json$Json$Decode$succeed(0);
			case 'end_of_year':
				return $elm$json$Json$Decode$succeed(1);
			case 'grading_exam':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown type: ' + s);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$SubjectAssessment$SubjectAssessment = F7(
	function (id, subject, ignored, mark, is_locked, is_waived, state) {
		return {gT: id, iy: ignored, lF: is_locked, lG: is_waived, iQ: mark, eZ: state, e2: subject};
	});
var $author$project$SubjectAssessment$Created = 0;
var $author$project$SubjectAssessment$FinalMark = 4;
var $author$project$SubjectAssessment$MarkRequired = 2;
var $author$project$SubjectAssessment$OfferedMark = 3;
var $author$project$SubjectAssessment$TextAppraisal = 1;
var $author$project$SubjectAssessment$stateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (state) {
		switch (state) {
			case 'created':
				return $elm$json$Json$Decode$succeed(0);
			case 'text_appraisal':
				return $elm$json$Json$Decode$succeed(1);
			case 'mark_required':
				return $elm$json$Json$Decode$succeed(2);
			case 'offered_mark':
				return $elm$json$Json$Decode$succeed(3);
			case 'final_mark':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid state');
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$SubjectAssessment$subjectAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'state',
	$author$project$SubjectAssessment$stateDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_waived',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_locked',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'mark',
				$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'ignored',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'subject',
						$author$project$Subject$subjectDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$elm$json$Json$Decode$int,
							$elm$json$Json$Decode$succeed($author$project$SubjectAssessment$SubjectAssessment))))))));
var $author$project$LearningAssessment$learningAssessmentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'can_require_mark',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'can_take_repeat_exam',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'must_repeat_grade',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'is_passed',
				$elm$json$Json$Decode$bool,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_supervised',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_locked',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_assessment_process_done',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'report_with_text_appraisal',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'report_with_marks',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'report_card_supplement',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'end_date',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'start_date',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'count_unjustified_absence_minutes',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'count_justified_absence_minutes',
														$elm$json$Json$Decode$int,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'count_absence_minutes',
															$elm$json$Json$Decode$int,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'subjects',
																$elm$json$Json$Decode$list($author$project$SubjectAssessment$subjectAssessmentDecoder),
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'type',
																	$author$project$LearningAssessment$learningAssessmentTypeDecoder,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'grade',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'student',
																			$author$project$Person$nestedPersonDecoder,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'id',
																				$elm$json$Json$Decode$int,
																				$elm$json$Json$Decode$succeed($author$project$LearningAssessment$LearningAssessment)))))))))))))))))))));
var $author$project$LearningAssessment$learningAssessmentListDecoder = $elm$json$Json$Decode$list($author$project$LearningAssessment$learningAssessmentDecoder);
var $author$project$Api$Endpoint$learningAssessmentsByPerson = F2(
	function (config, personId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'learning-assessments'
				]),
			_List_Nil);
	});
var $author$project$LearningAssessment$fetchLearningAssessmentsByPerson = F3(
	function (config, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$learningAssessmentsByPerson, config, personId),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$LearningAssessment$learningAssessmentListDecoder));
	});
var $author$project$Element$GradeReportCard$downloadGrades = F3(
	function (session, model, studentProfile) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$LearningAssessment$fetchLearningAssessmentsByPerson, model.bN.gr, studentProfile.ne.gT, $author$project$Element$GradeReportCard$LearningAssessmentListDownloadedResponse),
			A2(
				$author$project$Application$Boundaries$andThenCmd,
				A3($author$project$GradeReport$fetchGradeReportsByPersonV2, model.bN.gr, studentProfile.ne.gT, $author$project$Element$GradeReportCard$GradeReportListDownloadResponse),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							b9: $author$project$RemoteData$Loading,
							ea: $author$project$RemoteData$Success(studentProfile)
						}),
					session)));
	});
var $author$project$Module$ModuleDetailed = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isActive) {
											return function (isLocked) {
												return function (isTemplate) {
													return function (team) {
														return function (classroomCourses) {
															return function (accountableTeacher) {
																return function (teachers) {
																	return function (students) {
																		return function (learningOutcomes) {
																			return function (rubrics) {
																				return function (migrationReadyAt) {
																					return {j3: accountableTeacher, S: classroomCourses, gD: description, gH: endDate, gI: evaluation, k9: goalsKnowledge, la: goalsProduct, lb: goalsSkills, gT: id, lo: isActive, lw: isLocked, lC: isTemplate, g3: learningOutcomes, iR: materialsUrl, cZ: migrationReadyAt, eW: rubrics, hv: startDate, e1: students, e5: teachers, jF: team, jJ: title};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ClassroomCourse$NestedClassroomCourse = F3(
	function (id, title, url) {
		return {gT: id, jJ: title, G: url};
	});
var $author$project$ClassroomCourse$embeddedClassroomCourseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$ClassroomCourse$NestedClassroomCourse))));
var $author$project$Module$learningOutcomeIdDecoder = $elm$json$Json$Decode$int;
var $author$project$Module$learningOutcomeDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'id',
	$author$project$Module$learningOutcomeIdDecoder,
	$elm$json$Json$Decode$succeed($author$project$LearningOutcome$getLoByID));
var $author$project$Module$learningOutcomesDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$List$filterMap($elm$core$Basics$identity),
	$elm$json$Json$Decode$list($author$project$Module$learningOutcomeDecoder));
var $author$project$Util$Json$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Util$Json$doubleEncoded = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$author$project$Util$Json$fromResult,
				$elm$core$Result$mapError($elm$json$Json$Decode$errorToString)),
			$elm$json$Json$Decode$decodeString(decoder)),
		$elm$json$Json$Decode$string);
};
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Rubric$WithBps = 1;
var $author$project$Rubric$WithNobody = 0;
var $author$project$Rubric$sharingDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'nobody':
				return $elm$json$Json$Decode$succeed(0);
			case 'bps':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown sharing option: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Rubric$rubricDecoder = function () {
	var toRubric = F6(
		function (id, title, author, sharedWith, _v0, lastUpdated) {
			var levels = _v0.fG;
			var aspects = _v0.ki;
			return {ki: aspects, kn: author, gT: id, lR: lastUpdated, fG: levels, m0: sharedWith, jJ: title};
		});
	return A7(
		$elm$json$Json$Decode$map6,
		toRubric,
		A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
		A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'author', $author$project$Person$nestedPersonDecoder),
		A2($elm$json$Json$Decode$field, 'shared_with', $author$project$Rubric$sharingDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'content',
			$author$project$Util$Json$doubleEncoded($author$project$Rubric$rubricContentDecoder)),
		A2($elm$json$Json$Decode$field, 'last_updated', $elm$json$Json$Decode$int));
}();
var $author$project$Module$moduleDetailedDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'migration_ready_at',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rubrics',
		$elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'learning_outcomes',
			$author$project$Module$learningOutcomesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'students',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'teachers',
					$author$project$Person$nestedPeopleDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'accountable_teacher',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'classroom_courses',
							$elm$json$Json$Decode$list($author$project$ClassroomCourse$embeddedClassroomCourseDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'team',
								$author$project$Team$nestedTeamDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_template',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'is_locked',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'is_active',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'end_date',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'start_date',
													$elm$json$Json$Decode$int,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'materials_url',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'evaluation',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'goals_product',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'goals_skills',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'goals_knowledge',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'description',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'title',
																				$elm$json$Json$Decode$string,
																				A3(
																					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																					'id',
																					$author$project$Module$moduleIdDecoder,
																					$elm$json$Json$Decode$succeed($author$project$Module$ModuleDetailed))))))))))))))))))))));
var $author$project$Api$Endpoint$stringFromBool = function (x) {
	return x ? 'true' : 'false';
};
var $author$project$Api$Endpoint$module_ = F2(
	function (config, id) {
		var queryParams = _List_fromArray(
			[
				_Utils_Tuple2(
				'include_inactive',
				$author$project$Api$Endpoint$stringFromBool(true)),
				_Utils_Tuple2(
				'include_locked',
				$author$project$Api$Endpoint$stringFromBool(true))
			]);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'modules',
					$elm$core$String$fromInt(id)
				]),
			queryParams);
	});
var $author$project$Module$fetchOneModule = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$module_, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Module$moduleDetailedDecoder));
	});
var $author$project$Element$GradeReportCard$EndOfYear = 1;
var $author$project$Element$GradeReportCard$GR = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GradeReportCard$GradingExam = 2;
var $author$project$Element$GradeReportCard$MidYear = 0;
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Element$GradeReportCard$gradeReportToTab = function (gr) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(gr.hv));
	var gradeReportType = function () {
		var _v0 = gr.hH;
		switch (_v0) {
			case 0:
				return 0;
			case 1:
				return 1;
			default:
				return 2;
		}
	}();
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(gr.gH));
	return {
		dH: _Utils_eq(startYear, endYear) ? (endYear + 1) : endYear,
		eV: $author$project$Element$GradeReportCard$GR(gr),
		d9: startYear,
		hH: gradeReportType
	};
};
var $author$project$Element$GradeReportCard$compareTab = F2(
	function (left, right) {
		var _v0 = A2($elm$core$Basics$compare, left.d9, right.d9);
		switch (_v0) {
			case 0:
				return 0;
			case 2:
				return 2;
			default:
				var _v1 = A2($elm$core$Basics$compare, left.dH, right.dH);
				switch (_v1) {
					case 0:
						return 0;
					case 2:
						return 2;
					default:
						var _v2 = _Utils_Tuple2(left.hH, right.hH);
						_v2$3:
						while (true) {
							switch (_v2.a) {
								case 1:
									if (_v2.b === 1) {
										var _v3 = _v2.a;
										var _v4 = _v2.b;
										return 1;
									} else {
										var _v10 = _v2.a;
										return 2;
									}
								case 0:
									switch (_v2.b) {
										case 0:
											var _v5 = _v2.a;
											var _v6 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v11 = _v2.a;
											var _v12 = _v2.b;
											return 2;
									}
								default:
									switch (_v2.b) {
										case 2:
											var _v7 = _v2.a;
											var _v8 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v13 = _v2.a;
											var _v14 = _v2.b;
											return 0;
									}
							}
						}
						var _v9 = _v2.b;
						return 0;
				}
		}
	});
var $author$project$Element$GradeReportCard$LA = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradeReportCard$learningAssessmentToTab = function (la) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.hv));
	var learningAssessmentType = function () {
		var _v0 = la.hH;
		switch (_v0) {
			case 0:
				return 0;
			case 1:
				return 1;
			default:
				return 2;
		}
	}();
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.gH));
	return {
		dH: _Utils_eq(startYear, endYear) ? (endYear + 1) : endYear,
		eV: $author$project$Element$GradeReportCard$LA(la),
		d9: startYear,
		hH: learningAssessmentType
	};
};
var $author$project$Element$GradeReportCard$makeTabs = F2(
	function (gradeReports, learningAssessments) {
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$sortWith,
				$author$project$Element$GradeReportCard$compareTab,
				_Utils_ap(
					A2($elm$core$List$map, $author$project$Element$GradeReportCard$gradeReportToTab, gradeReports),
					A2($elm$core$List$map, $author$project$Element$GradeReportCard$learningAssessmentToTab, learningAssessments))));
	});
var $author$project$Application$Boundaries$wrap = F4(
	function (mapModel_, msgMap, reply2, return_) {
		return {
			dz: A2($elm$core$Platform$Cmd$map, msgMap, return_.dz),
			dY: mapModel_(return_.dY),
			fY: reply2,
			cv: return_.cv
		};
	});
var $author$project$Application$Boundaries$mapElement = F3(
	function (bigModel, element, return_) {
		return A4(
			$author$project$Application$Boundaries$wrap,
			element.h_(bigModel),
			element.iV,
			$elm$core$Maybe$Nothing,
			return_);
	});
var $author$project$Element$GradeReportCard$MentorCommentModel = $elm$core$Basics$identity;
var $author$project$Element$GradeReportCard$MentorCommentMsg = $elm$core$Basics$identity;
var $author$project$Element$GradeReportCard$PopupMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Student$asNestedPerson = function (student) {
	return {
		K: A2($elm$core$Maybe$withDefault, '', student.K),
		k3: student.k3,
		gT: student.gT,
		ak: student.ak
	};
};
var $author$project$Locale$Messages$MentorCommentFormCommentCaption = {$: 200};
var $author$project$Locale$Messages$MentorCommentFormCommentPlaceholder = function (a) {
	return {$: 201, a: a};
};
var $author$project$Element$MentorCommentForm$SetFormComment = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$MentorCommentForm$buildForm = F2(
	function (t_, family) {
		return {
			h9: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{h9: value});
					}),
				nD: function ($) {
					return $.h9;
				},
				nE: {
					kJ: 'comment',
					lO: t_($author$project$Locale$Messages$MentorCommentFormCommentCaption),
					aT: $author$project$Element$MentorCommentForm$SetFormComment,
					bv: t_(
						$author$project$Locale$Messages$MentorCommentFormCommentPlaceholder(
							A2(
								$elm$core$List$map,
								$author$project$Person$fullName(t_),
								family)))
				}
			}
		};
	});
var $author$project$Element$MentorCommentForm$fillForm = function (report) {
	return {h9: report.h9};
};
var $author$project$Element$MentorCommentForm$init = F3(
	function (config, session, _v0) {
		var t_ = session.hy;
		var student = _v0.a;
		var gradeReport = _v0.b;
		var model = {
			bN: config,
			bt: A2(
				$author$project$Element$MentorCommentForm$buildForm,
				t_,
				A2(
					$elm$core$List$cons,
					$author$project$Student$asNestedPerson(student),
					student.m9)),
			eV: gradeReport,
			ne: student,
			ej: $author$project$Element$MentorCommentForm$fillForm(gradeReport)
		};
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$MentorCommentForm$Error = {$: 1};
var $author$project$Element$MentorCommentForm$Exit = {$: 0};
var $author$project$Locale$Messages$MentorCommentSaveSuccess = {$: 202};
var $author$project$Element$MentorCommentForm$MentorCommentSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$MentorCommentForm$NoOp = {$: 0};
var $author$project$Element$MentorCommentForm$Saved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Application$Boundaries$addError = F3(
	function (error, err, _return) {
		return _Utils_update(
			_return,
			{
				cv: A3($author$project$Session$error, _return.cv, error, err)
			});
	});
var $author$project$Log$msgMentorCommentSave = 'mentor_comment_save';
var $author$project$Application$Boundaries$ok = F2(
	function (info, _return) {
		return _Utils_update(
			_return,
			{
				cv: A2($author$project$Session$ok, _return.cv, info)
			});
	});
var $author$project$Log$paramScopeStudents = 'scope_students';
var $author$project$Element$MentorCommentForm$saveForm = F3(
	function (form, values, report) {
		return _Utils_update(
			report,
			{
				h9: form.h9.nD(values)
			});
	});
var $author$project$GradeReport$MentorComment = function (comment) {
	return {h9: comment};
};
var $author$project$Api$Endpoint$gradeReport = F3(
	function (config, personId, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'grade-reports',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$GradeReport$mentorCommentEncode = function (report) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'teacher_comment',
				$elm$json$Json$Encode$string(report.h9))
			]));
};
var $author$project$Api$patch = F5(
	function (url, config, body, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				O: body,
				a4: A2($author$project$Api$expectJson, toMsg, decoder),
				ah: $author$project$Api$toHeaders(config),
				ba: 'PATCH',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$GradeReport$saveMentorComment = F3(
	function (config, report, callback) {
		return A5(
			$author$project$Api$patch,
			A3($author$project$Api$Endpoint$gradeReport, config, report.ne.gT, report.gT),
			config,
			$elm$http$Http$jsonBody(
				$author$project$GradeReport$mentorCommentEncode(
					$author$project$GradeReport$MentorComment(report.h9))),
			callback,
			$author$project$GradeReport$gradeReportDecoder);
	});
var $author$project$Element$MentorCommentForm$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		var form = model.bt;
		var values = model.ej;
		switch (msg.$) {
			case 2:
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$MentorCommentForm$Exit,
					A2($author$project$Application$Boundaries$save, model, session));
			case 3:
				var updatedReport = A3($author$project$Element$MentorCommentForm$saveForm, form, values, model.eV);
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$GradeReport$saveMentorComment, config.gr, updatedReport, $author$project$Element$MentorCommentForm$MentorCommentSaved),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var value = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bt: _Utils_update(
								form,
								{
									h9: $author$project$Form$markEdited(form.h9)
								}),
							ej: A2(form.h9.jR, value, values)
						}),
					session);
			case 4:
				if (!msg.a.$) {
					var report = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$reply,
						$author$project$Element$MentorCommentForm$Saved(report),
						A2(
							$author$project$Application$Boundaries$ok,
							t_($author$project$Locale$Messages$MentorCommentSaveSuccess),
							A2($author$project$Application$Boundaries$save, model, session)));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$reply,
						$author$project$Element$MentorCommentForm$Error,
						A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3(
									$author$project$Log$msgMentorCommentSave,
									$elm$core$Maybe$Just($author$project$Log$paramScopeStudents),
									error),
								$elm$core$Basics$always($author$project$Element$MentorCommentForm$NoOp)),
							A3(
								$author$project$Application$Boundaries$addError,
								error,
								t_($author$project$Locale$Messages$FormSaveError),
								A2($author$project$Application$Boundaries$save, model, session))));
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$BtnCancel = {$: 39};
var $author$project$Element$MentorCommentForm$ClosePopup = {$: 2};
var $author$project$Locale$Messages$MentorCommentTitle = {$: 199};
var $author$project$Element$MentorCommentForm$SubmitForm = {$: 3};
var $author$project$UI$closeButton = function (toMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
				$elm$html$Html$Attributes$class('delete'),
				$elm$html$Html$Events$onClick(toMsg)
			]),
		_List_Nil);
};
var $author$project$Element$MentorCommentForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.h9, values);
	});
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$UI$modalPanel = F4(
	function (title_, closeButton_, body, foot) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal is-active')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-background')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-card')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$header,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-head')
								]),
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('modal-card-title')
										]),
									title_),
								closeButton_)),
							A2(
							$elm$html$Html$section,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-body')
								]),
							body),
							A2(
							$elm$html$Html$footer,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('modal-card-foot buttons')
								]),
							foot)
						]))
				]));
	});
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$UI$bulmaTextarea = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$textarea,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textarea'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-danger', field.kU && (!valid)),
							_Utils_Tuple2('is-success', field.kU && valid)
						])),
					$elm$html$Html$Attributes$placeholder(field.nE.bv),
					$elm$html$Html$Attributes$value(
					field.nD(values)),
					$elm$html$Html$Events$onInput(field.nE.aT),
					$author$project$UI$attrCyData(field.nE.kJ)
				]),
			_List_Nil);
	});
var $author$project$UI$textareaFieldWrapper = F4(
	function (t_, field, values, renderTextarea) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(renderTextarea, field, values)
						])),
					function () {
					var _v0 = _Utils_Tuple2(
						A2($author$project$Form$fieldError, field, values),
						field.kU);
					if ((!_v0.a.$) && _v0.b) {
						var error = _v0.a.a;
						return A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('help is-danger'),
									$author$project$UI$attrCyData(field.nE.kJ + '-error')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(error)
								]));
					} else {
						return $author$project$UI$none;
					}
				}()
				]));
	});
var $author$project$UI$textareaField = F3(
	function (t_, field, values) {
		return A4($author$project$UI$textareaFieldWrapper, t_, field, values, $author$project$UI$bulmaTextarea);
	});
var $author$project$Element$MentorCommentForm$view = F2(
	function (_v0, _v1) {
		var t_ = _v0.hy;
		var form = _v1.bt;
		var values = _v1.ej;
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MentorCommentTitle)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$MentorCommentForm$ClosePopup)
				]),
			_List_fromArray(
				[
					A3($author$project$UI$textareaField, t_, form.h9, values)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$submitButton,
					t_($author$project$Locale$Messages$BtnSave),
					!A2($author$project$Element$MentorCommentForm$isFormValid, form, values),
					false,
					$author$project$Element$MentorCommentForm$SubmitForm),
					A4(
					$author$project$UI$resetButton,
					t_($author$project$Locale$Messages$BtnCancel),
					false,
					false,
					$author$project$Element$MentorCommentForm$ClosePopup)
				]));
	});
var $author$project$Element$MentorCommentForm$element = {iA: $author$project$Element$MentorCommentForm$init, jR: $author$project$Element$MentorCommentForm$update, nE: $author$project$Element$MentorCommentForm$view};
var $author$project$Element$GradeReportCard$mentorCommentPopup = {
	h_: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					c3: $elm$core$Maybe$Just(x)
				});
		}),
	gF: $author$project$Element$MentorCommentForm$element,
	iV: A2($elm$core$Basics$composeL, $author$project$Element$GradeReportCard$PopupMsg, $elm$core$Basics$identity)
};
var $author$project$Module$moduleIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Log$msgGradeReportsDownload = 'grade_reports_download';
var $author$project$Log$msgLearningAssessmentsDownload = 'learning_assessments_download';
var $author$project$Log$msgModulesDownload = 'modules_download';
var $author$project$Log$msgPortfoliosDownload = 'portfolios_download';
var $author$project$Log$msgStudentProfileDownload = 'student_profile_download';
var $author$project$Log$msgSubjectListDownload = 'subject_list_download';
var $author$project$Log$paramScopeGradeReport = 'scope_gradereport';
var $author$project$Log$paramScopeLearningAssessment = 'scope_learning_assessment';
var $elm$core$List$sortBy = _List_sortBy;
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Util$List$unique = function (x) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (item, acc) {
				return A2($elm$core$List$member, item, acc) ? acc : A2($elm$core$List$cons, item, acc);
			}),
		_List_Nil,
		x);
};
var $author$project$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 2) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Element$GradeReportCard$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		switch (msg.$) {
			case 2:
				var profileData = msg.a;
				switch (profileData.$) {
					case 2:
						var studentProfile = profileData.a;
						return A3($author$project$Element$GradeReportCard$downloadGrades, session, model, studentProfile);
					case 3:
						var error = profileData.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentProfileDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
									error),
								$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentProfileFormDownloadError))));
					case 0:
						return A2($author$project$Application$Boundaries$save, model, session);
					default:
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 3:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									jB: $author$project$RemoteData$Success(subjects)
								}),
							session);
					case 3:
						var error = msg.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSubjectListDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
									error),
								$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$SubjectListDownloadError))));
					default:
						var data = msg.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{jB: data}),
							session);
				}
			case 0:
				var gradeReportData = msg.a;
				switch (gradeReportData.$) {
					case 2:
						var gradeReports = gradeReportData.a;
						var tabs = A2(
							$author$project$Element$GradeReportCard$makeTabs,
							gradeReports,
							A2($author$project$RemoteData$withDefault, _List_Nil, model.dR));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									b9: $author$project$RemoteData$Success(gradeReports),
									bY: $elm$core$List$head(tabs),
									e4: tabs
								}),
							session);
					case 3:
						var error = gradeReportData.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgGradeReportsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
									error),
								$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$GradeReportsDownloadError))));
					default:
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{b9: gradeReportData}),
							session);
				}
			case 1:
				var learningAssessmentData = msg.a;
				switch (learningAssessmentData.$) {
					case 2:
						var learningAssessments = learningAssessmentData.a;
						var tabs = A2(
							$author$project$Element$GradeReportCard$makeTabs,
							A2($author$project$RemoteData$withDefault, _List_Nil, model.b9),
							learningAssessments);
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									dR: $author$project$RemoteData$Success(learningAssessments),
									bY: $elm$core$List$head(tabs),
									e4: tabs
								}),
							session);
					case 3:
						var error = learningAssessmentData.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgLearningAssessmentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeLearningAssessment),
									error),
								$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningAssessmentsDownloadError))));
					default:
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{dR: learningAssessmentData}),
							session);
				}
			case 4:
				if (!msg.a.$) {
					var stories = msg.a.a;
					var referencedModules = $author$project$Util$List$unique(
						$elm$core$List$sort(
							A2(
								$elm$core$List$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.gT;
									},
									$author$project$Module$moduleIdToInt),
								A2(
									$elm$core$List$filterMap,
									function ($) {
										return $.fK;
									},
									stories))));
					var emptyCache = $elm$core$Dict$fromList(
						A2(
							$elm$core$List$map,
							function (id) {
								return _Utils_Tuple2(id, $elm$core$Maybe$Nothing);
							},
							referencedModules));
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						$elm$core$Platform$Cmd$batch(
							A2(
								$elm$core$List$map,
								function (id) {
									return A3($author$project$Module$fetchOneModule, config.gr, id, $author$project$Element$GradeReportCard$ModuleDownloadResponse);
								},
								referencedModules)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									dZ: emptyCache,
									fU: $author$project$Element$GradeReportCard$PortfolioStoriesDownloaded(stories)
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
								error),
							$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosDownloadError))));
				}
			case 5:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					var updatedCache = A3(
						$elm$core$Dict$insert,
						$author$project$Module$moduleIdToInt(module_.gT),
						$elm$core$Maybe$Just(module_),
						model.dZ);
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{dZ: updatedCache}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgModulesDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeGradeReport),
								error),
							$elm$core$Basics$always($author$project$Element$GradeReportCard$NoOp)),
						A2($author$project$Application$Boundaries$save, model, session));
				}
			case 7:
				var student = msg.a;
				var gradeReport = msg.b;
				return A3(
					$author$project$Application$Boundaries$mapElement,
					model,
					$author$project$Element$GradeReportCard$mentorCommentPopup,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Element$GradeReportCard$mentorCommentPopup,
						_Utils_Tuple2(student, gradeReport)));
			case 6:
				var mentorCommentMsg = msg.a;
				var _v4 = model.c3;
				if (!_v4.$) {
					var mentorCommentModel = _v4.a;
					var _return = A3($author$project$Element$GradeReportCard$mentorCommentPopup.gF.jR, session, mentorCommentMsg, mentorCommentModel);
					var _v5 = _Utils_Tuple3(_return.fY, model.ea, model.b9);
					if (!_v5.a.$) {
						if (((_v5.a.a.$ === 2) && (_v5.b.$ === 2)) && (_v5.c.$ === 2)) {
							var gradeReport = _v5.a.a.a;
							var studentProfile = _v5.b.a;
							return A3(
								$author$project$Element$GradeReportCard$downloadGrades,
								_return.cv,
								_Utils_update(
									model,
									{
										c3: $elm$core$Maybe$Nothing,
										bY: $elm$core$Maybe$Just(
											$author$project$Element$GradeReportCard$gradeReportToTab(gradeReport))
									}),
								studentProfile);
						} else {
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{c3: $elm$core$Maybe$Nothing}),
								_return.cv);
						}
					} else {
						return A3($author$project$Application$Boundaries$mapElement, model, $author$project$Element$GradeReportCard$mentorCommentPopup, _return);
					}
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 8:
				var tab = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bY: $elm$core$Maybe$Just(tab)
						}),
					session);
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$GradeReportsNoGradesNotification = {$: 86};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Locale$Messages$GradeReportsLoadingProgress = {$: 79};
var $author$project$Locale$Messages$GradeReportsNone = {$: 80};
var $author$project$StudentProfile$asStudent = function (profile) {
	var student = profile.ne;
	return {j9: $elm$core$Maybe$Nothing, id: profile.id, K: student.K, k3: student.k3, gT: student.gT, ak: student.ak, l_: $elm$core$Maybe$Nothing, l$: '', aQ: student.aQ, c6: $author$project$Person$emptyRoles, m9: student.m9};
};
var $author$project$ACL$canViewGradeReportsGrades = F2(
	function (person, gradeReport) {
		return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || (($author$project$Person$isSponsor(person) && gradeReport.lD) || ($author$project$Person$isStudent(person) && gradeReport.lE)));
	});
var $author$project$ACL$canViewLearningAssessmentGrades = F2(
	function (_v0, _v1) {
		return true;
	});
var $author$project$Element$GradeReportCard$AddMentorComment = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Locale$Messages$GradeReportsAchievedLosShort = {$: 83};
var $author$project$Locale$Messages$GradeReportsDownloadGradesPDF = {$: 76};
var $author$project$Locale$Messages$GradeReportsExempted = {$: 78};
var $author$project$Locale$Messages$GradeReportsGrade = {$: 85};
var $author$project$Locale$Messages$GradeReportsSubject = {$: 81};
var $author$project$Locale$Messages$GradeReportsTargetEndYear = {$: 93};
var $author$project$Locale$Messages$GradeReportsTargetMidYear = {$: 92};
var $author$project$Locale$Messages$GradeReportsTitleEndYear = {$: 95};
var $author$project$Locale$Messages$GradeReportsTitleGradingExam = {$: 96};
var $author$project$Locale$Messages$GradeReportsTitleMidYear = {$: 94};
var $author$project$Locale$Messages$MentorCommentContent = function (a) {
	return {$: 198, a: a};
};
var $author$project$Locale$Messages$StudentListViewMentorComment = {$: 580};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $author$project$UI$Icon$feedback = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-comment-dots'),
			attributes));
};
var $author$project$UI$Icon$filePdf = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-file-pdf'),
			attributes));
};
var $author$project$Person$isSamePerson = F2(
	function (person1, person2) {
		return _Utils_eq(person1.gT, person2.gT);
	});
var $author$project$Person$isMentorOf = F2(
	function (mentee, person) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(mentee),
			person.lZ);
	});
var $author$project$UI$subtitle = function (content) {
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('subtitle is-5')
			]),
		content);
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$UI$title = function (content) {
	return A2(
		$elm$html$Html$h1,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('subtitle is-4')
			]),
		content);
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $author$project$UI$nav_ = F3(
	function (isAlwaysHorizontal, left, right) {
		return A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('level'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-mobile', isAlwaysHorizontal)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-left')
						]),
					A2(
						$elm$core$List$filterMap,
						function (item) {
							return _Utils_eq(item, $author$project$UI$none) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2(
									$elm$html$Html$small,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('level-item')
										]),
									_List_fromArray(
										[item])));
						},
						left)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('level-right')
						]),
					A2(
						$elm$core$List$map,
						function (item) {
							return A2(
								$elm$html$Html$small,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-item')
									]),
								_List_fromArray(
									[item]));
						},
						right))
				]));
	});
var $author$project$UI$nav = F2(
	function (left, right) {
		return A3($author$project$UI$nav_, false, left, right);
	});
var $author$project$Element$GradeReportCard$viewSubjectLink = F2(
	function (student, subject) {
		return _List_fromArray(
			[
				A2(
				$author$project$UI$nav,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								A2(
									$author$project$Route$SubjectFeedbackCard,
									student.gT,
									$elm$core$Maybe$Just(subject.gT))),
								$author$project$UI$attrCyData('subject-feedback-card')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(subject.fQ)
							]))
					]),
				_List_Nil)
			]);
	});
var $author$project$Element$GradeReportCard$viewGradeReport = F4(
	function (t_, viewer, student, gradeReport) {
		var viewReportHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block  is-uppercase')
				]),
			_List_fromArray(
				[
					$author$project$UI$title(
					_List_fromArray(
						[
							$elm$html$Html$text(
							function () {
								var _v1 = gradeReport.hH;
								switch (_v1) {
									case 0:
										return t_($author$project$Locale$Messages$GradeReportsTitleMidYear);
									case 1:
										return t_($author$project$Locale$Messages$GradeReportsTitleEndYear);
									default:
										return t_($author$project$Locale$Messages$GradeReportsTitleGradingExam);
								}
							}())
						])),
					$author$project$UI$subtitle(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, gradeReport.ne))
						]))
				]));
		var viewReportComment = A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block is-italic')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					$author$project$Locale$Messages$MentorCommentContent(gradeReport.h9))
				]));
		var viewMark = function (item) {
			return item.m2 ? item.no : $elm$core$String$fromInt(item.iQ);
		};
		var viewReportBody = A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped'),
					$author$project$UI$attrCyData('grade-report')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsSubject)
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsAchievedLosShort)
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											function () {
											var _v0 = gradeReport.hH;
											switch (_v0) {
												case 0:
													return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsTargetMidYear);
												case 1:
													return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsTargetEndYear);
												default:
													return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsTargetEndYear);
											}
										}()
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsGrade)
										]))
								]))
						])),
				A2(
					$elm$core$List$map,
					function (line) {
						return A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$td,
									_List_Nil,
									A2($author$project$Element$GradeReportCard$viewSubjectLink, student, line.e2)),
								line.iy ? _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-centered'),
												$elm$html$Html$Attributes$colspan(3)
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsExempted)
											]))
									]) : _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-centered')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(line.j6))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-centered')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$elm$core$String$fromInt(line.k8))
											])),
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-centered')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												viewMark(line))
											]))
									])));
					},
					A2(
						$author$project$Util$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e2;
							},
							function ($) {
								return $.fQ;
							}),
						gradeReport.jB))));
		var viewButtons = A2(
			$author$project$UI$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					gradeReport.lc,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadGradesPDF)
										]))
								]));
					}),
					A2(
					$author$project$UI$when,
					A2($author$project$Person$isMentorOf, student, viewer) && (!gradeReport.lw),
					A3(
						$author$project$UI$actionLink,
						A2($author$project$Element$GradeReportCard$AddMentorComment, student, gradeReport),
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$Icon$feedback(
								_List_fromArray(
									[
										$author$project$UI$Icon$style('has-text-info')
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewMentorComment)
									]))
							])))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					viewButtons,
					viewReportHeader,
					viewReportBody,
					A2(
					$author$project$UI$when,
					!$elm$core$String$isEmpty(gradeReport.h9),
					viewReportComment)
				]));
	});
var $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF = {$: 77};
var $author$project$Locale$Messages$GradeReportsTextAppraisal = {$: 82};
var $author$project$Element$GradeReportCard$viewLearningAssessment = F3(
	function (t_, student, learningAssessment) {
		var viewTitle = $author$project$UI$title(
			_List_fromArray(
				[
					$elm$html$Html$text(
					function () {
						var _v0 = learningAssessment.hH;
						switch (_v0) {
							case 0:
								return t_($author$project$Locale$Messages$GradeReportsTitleMidYear);
							case 1:
								return t_($author$project$Locale$Messages$GradeReportsTitleEndYear);
							default:
								return t_($author$project$Locale$Messages$GradeReportsTitleGradingExam);
						}
					}())
				]));
		var viewReportHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block  is-uppercase')
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$subtitle(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, learningAssessment.ne))
						]))
				]));
		var viewMark = function (item) {
			return A2($elm$core$Maybe$withDefault, '', item.iQ);
		};
		var viewReportBody = A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped'),
					$author$project$UI$attrCyData('grade-report')
				]),
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsSubject)
										])),
									A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsTextAppraisal)
										]))
								]))
						])),
				A2(
					$elm$core$List$map,
					function (line) {
						return A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$td,
									_List_Nil,
									A2($author$project$Element$GradeReportCard$viewSubjectLink, student, line.e2)),
								line.iy ? _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-justified'),
												$elm$html$Html$Attributes$colspan(3)
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsExempted)
											]))
									]) : _List_fromArray(
									[
										A2(
										$elm$html$Html$td,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-text-justified')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												viewMark(line))
											]))
									])));
					},
					A2(
						$author$project$Util$List$sortBy,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e2;
							},
							function ($) {
								return $.fQ;
							}),
						learningAssessment.jB))));
		var viewButtons = A2(
			$author$project$UI$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					learningAssessment.mI,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadGradesPDF)
										]))
								]));
					}),
					A2(
					$author$project$UI$maybe,
					learningAssessment.mJ,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF)
										]))
								]));
					})
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					viewButtons,
					viewReportHeader,
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(learningAssessment.jB),
					viewReportBody)
				]));
	});
var $author$project$Element$GradeReportCard$viewPopup = F2(
	function (session, model) {
		var _v0 = model.c3;
		if (!_v0.$) {
			var mcm = _v0.a;
			return A2(
				$elm$html$Html$map,
				A2($elm$core$Basics$composeL, $author$project$Element$GradeReportCard$PopupMsg, $elm$core$Basics$identity),
				A2($author$project$Element$GradeReportCard$mentorCommentPopup.gF.nE, session, mcm));
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Locale$Messages$GradeReportsAchievedLosLong = {$: 84};
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $author$project$Element$GradeReportCard$viewRecognizedLearningOutcomes = F2(
	function (t_, gradeReport) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			A2(
				$elm$core$List$cons,
				$author$project$UI$title(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsAchievedLosLong)
						])),
				A2(
					$elm$core$List$map,
					function (subjectLine) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block')
								]),
							_List_fromArray(
								[
									$author$project$UI$subtitle(
									_List_fromArray(
										[
											$elm$html$Html$text(subjectLine.e2.fQ)
										])),
									A2(
									$elm$html$Html$ol,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (lo) {
											return A2(
												$elm$html$Html$li,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(lo.b)
													]));
										},
										subjectLine.g3))
								]));
					},
					gradeReport.jB)));
	});
var $author$project$Element$GradeReportCard$TabSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$Locale$Messages$GradeReportCardTabEndOfYear = F2(
	function (a, b) {
		return {$: 90, a: a, b: b};
	});
var $author$project$Locale$Messages$GradeReportCardTabGradingExam = F2(
	function (a, b) {
		return {$: 91, a: a, b: b};
	});
var $author$project$Locale$Messages$GradeReportCardTabMidYear = F2(
	function (a, b) {
		return {$: 89, a: a, b: b};
	});
var $author$project$Element$GradeReportCard$tabCaption = function (_v0) {
	var startYear = _v0.d9;
	var endYear = _v0.dH;
	var type_ = _v0.hH;
	switch (type_) {
		case 0:
			return A2($author$project$Locale$Messages$GradeReportCardTabMidYear, startYear, endYear);
		case 1:
			return A2($author$project$Locale$Messages$GradeReportCardTabEndOfYear, startYear, endYear);
		default:
			return A2($author$project$Locale$Messages$GradeReportCardTabGradingExam, startYear, endYear);
	}
};
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Element$GradeReportCard$viewTabBar = F3(
	function (t_, selected, reports) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-boxed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												_Utils_eq(
													$elm$core$Maybe$Just(tab),
													selected))
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$GradeReportCard$TabSelected(tab),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Element$GradeReportCard$tabCaption(tab))
											]))
									]));
						},
						reports))
				]));
	});
var $author$project$Element$GradeReportCard$viewGradeReportsSection = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var studentProfile = model.ea;
		var gradeReportState = model.b9;
		var learningAssessmentState = model.dR;
		var _v0 = _Utils_Tuple3(studentProfile, gradeReportState, learningAssessmentState);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				_v0$5:
				while (true) {
					switch (_v0.a.$) {
						case 1:
							var _v1 = _v0.a;
							return _List_fromArray(
								[
									A2(
									$author$project$UI$progressBar,
									'is-info',
									t_($author$project$Locale$Messages$GradeReportsLoadingProgress))
								]);
						case 2:
							switch (_v0.b.$) {
								case 1:
									break _v0$1;
								case 2:
									switch (_v0.c.$) {
										case 1:
											break _v0$2;
										case 2:
											if ((!_v0.b.a.b) && (!_v0.c.a.b)) {
												return _List_fromArray(
													[
														$author$project$UI$notification(
														_List_fromArray(
															[
																A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsNone)
															]))
													]);
											} else {
												var sp = _v0.a.a;
												return _List_fromArray(
													[
														A3($author$project$Element$GradeReportCard$viewTabBar, t_, model.bY, model.e4),
														function () {
														var _v4 = model.bY;
														if (!_v4.$) {
															var tab = _v4.a;
															var _v5 = tab.eV;
															if (!_v5.$) {
																var gradeReport = _v5.a;
																return A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2($author$project$Element$GradeReportCard$viewPopup, session, model),
																			A2(
																			$author$project$UI$when,
																			A2($author$project$ACL$canViewGradeReportsGrades, viewer, gradeReport),
																			A4(
																				$author$project$Element$GradeReportCard$viewGradeReport,
																				t_,
																				viewer,
																				$author$project$StudentProfile$asStudent(sp),
																				gradeReport)),
																			A2($author$project$Element$GradeReportCard$viewRecognizedLearningOutcomes, t_, gradeReport)
																		]));
															} else {
																var learningAssessment = _v5.a;
																return A2(
																	$elm$html$Html$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2($author$project$Element$GradeReportCard$viewPopup, session, model),
																			A2(
																			$author$project$UI$when,
																			A2($author$project$ACL$canViewLearningAssessmentGrades, viewer, learningAssessment),
																			A3(
																				$author$project$Element$GradeReportCard$viewLearningAssessment,
																				t_,
																				$author$project$StudentProfile$asStudent(sp),
																				learningAssessment))
																		]));
															}
														} else {
															return $author$project$UI$none;
														}
													}()
													]);
											}
										default:
											break _v0$5;
									}
								default:
									if (_v0.c.$ === 1) {
										break _v0$2;
									} else {
										break _v0$5;
									}
							}
						default:
							if (_v0.b.$ === 1) {
								break _v0$1;
							} else {
								if (_v0.c.$ === 1) {
									break _v0$2;
								} else {
									break _v0$5;
								}
							}
					}
				}
				return _List_fromArray(
					[
						A2(
						$author$project$UI$progressBar,
						'is-warning',
						t_($author$project$Locale$Messages$GradeReportsDownloadError))
					]);
			}
			var _v3 = _v0.c;
			return _List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-success',
					t_($author$project$Locale$Messages$GradeReportsLoadingProgress))
				]);
		}
		var _v2 = _v0.b;
		return _List_fromArray(
			[
				A2(
				$author$project$UI$progressBar,
				'is-success',
				t_($author$project$Locale$Messages$GradeReportsLoadingProgress))
			]);
	});
var $author$project$Locale$Messages$PortfoliosLoadingProgress = {$: 412};
var $author$project$Locale$Messages$PortfoliosTitle = {$: 423};
var $author$project$PortfolioStory$isNotModuleClosure = function (story) {
	return story.hH !== 1;
};
var $author$project$Element$GradeReportCard$storiesRelatedToReport = F2(
	function (report, stories) {
		return A2(
			$elm$core$List$filter,
			function (story) {
				return (_Utils_cmp(report.hv, story.gz) < 1) && (_Utils_cmp(report.gH, story.gz) > -1);
			},
			stories);
	});
var $author$project$RemoteData$toMaybe = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Locale$Messages$GradeReportsClosedModules = {$: 74};
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$PortfolioStory$isModuleClosure = function (story) {
	return story.hH === 1;
};
var $author$project$Locale$Messages$ModulesAccountableTeacher = function (a) {
	return {$: 247, a: a};
};
var $author$project$UI$contentElem = function (cont) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		cont);
};
var $author$project$ACL$canDeleteBadge = F2(
	function (badge, person) {
		return A2($author$project$Person$isSamePerson, badge.kG, person);
	});
var $author$project$UI$mediaObjectXS = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-16x16', media, content, navigation, right);
	});
var $author$project$Util$List$filterMap2 = F4(
	function (filter, mapper, xs, ys) {
		var mapTuple = function (_v1) {
			var first = _v1.a;
			var second = _v1.b;
			return A2(mapper, first, second);
		};
		var filterTuple = function (_v0) {
			var first = _v0.a;
			var second = _v0.b;
			return A2(filter, first, second);
		};
		return A2(
			$elm$core$List$map,
			mapTuple,
			A2(
				$elm$core$List$filter,
				filterTuple,
				A3($elm$core$List$map2, $elm$core$Tuple$pair, xs, ys)));
	});
var $author$project$Rubric$ignored = -1;
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Util$List$find = F2(
	function (predicate, list) {
		return $elm$core$List$head(
			A2($elm$core$List$filter, predicate, list));
	});
var $author$project$Subject$findSubject = F2(
	function (subjects, id) {
		return A2(
			$author$project$Util$List$find,
			function (s) {
				return _Utils_eq(
					$elm$core$Maybe$Just(s.gT),
					id);
			},
			subjects);
	});
var $author$project$Subject$findSubjectName = F2(
	function (subjects, id) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ha;
			},
			A2($author$project$Subject$findSubject, subjects, id));
	});
var $author$project$Subject$findSubjectNameOrEmpty = F2(
	function (subjects, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($author$project$Subject$findSubjectName, subjects, id));
	});
var $author$project$Util$String$enclose = F3(
	function (left, right, t) {
		if (t === '') {
			return '';
		} else {
			return _Utils_ap(
				left,
				_Utils_ap(t, right));
		}
	});
var $author$project$Util$String$parenthesize = A2($author$project$Util$String$enclose, '(', ')');
var $author$project$UI$RubricAssessment$viewDescriptionCell = F3(
	function (selectedLevel, level, desc) {
		return A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'has-background-success',
							_Utils_eq(level, selectedLevel)),
							_Utils_Tuple2(
							'has-text-weight-light',
							!_Utils_eq(level, selectedLevel))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-small')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							($elm$core$String$isEmpty(desc) && _Utils_eq(level, selectedLevel)) ? '✓' : desc)
						]))
				]));
	});
var $author$project$UI$RubricAssessment$viewLevelRow = F4(
	function (assessment, aspect, selectedLevel, subjects) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$td,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(aspect.jJ),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							$elm$html$Html$text(
							$author$project$Util$String$parenthesize(
								A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nf)))
						])),
				A2(
					$elm$core$List$indexedMap,
					$author$project$UI$RubricAssessment$viewDescriptionCell(selectedLevel),
					A2(
						$elm$core$List$take,
						$elm$core$List$length(assessment.mS.fG.fG),
						aspect.lV))));
	});
var $author$project$UI$RubricAssessment$view = F2(
	function (subjects, assessment) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-narrow is-size-7')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$th, _List_Nil, _List_Nil),
						A2(
							$elm$core$List$map,
							function (l) {
								return A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(l)
										]));
							},
							assessment.mS.fG.fG))),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A4(
						$author$project$Util$List$filterMap2,
						function (_v0) {
							return function (level) {
								return !_Utils_eq(level, $author$project$Rubric$ignored);
							};
						},
						function (aspect) {
							return function (level) {
								return A4($author$project$UI$RubricAssessment$viewLevelRow, assessment, aspect, level, subjects);
							};
						},
						assessment.mS.ki,
						assessment.z))
				]));
	});
var $author$project$UI$Icon$delete = function (attributes) {
	return $author$project$UI$Icon$icon(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-trash-alt'),
					$author$project$UI$Icon$style('has-text-danger')
				]),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewLoBadgeDeleteLink = F2(
	function (badge, toMsg) {
		return A2(
			$elm$html$Html$small,
			_List_Nil,
			_List_fromArray(
				[
					A3(
					$author$project$UI$actionLink,
					toMsg(badge),
					_List_Nil,
					_List_fromArray(
						[
							$author$project$UI$Icon$delete(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('is-small')
								]))
						]))
				]));
	});
var $author$project$Element$PortfolioSingle$viewFeedbackBadge = F5(
	function (badge, feedback, subjects, showBadgeDescription, toDeleteMsg) {
		var viewFeedbackBadgeIcon = A2(
			$author$project$UI$when,
			showBadgeDescription(badge),
			$author$project$UI$Icon$feedback(_List_Nil));
		var viewFeedbackBadgeDescription = A2(
			$author$project$UI$when,
			showBadgeDescription(badge),
			A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(badge.gD)
					])));
		return A4(
			$author$project$UI$mediaObjectXS,
			_List_fromArray(
				[viewFeedbackBadgeIcon]),
			_List_fromArray(
				[
					viewFeedbackBadgeDescription,
					A2($author$project$UI$RubricAssessment$view, subjects, feedback)
				]),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$nav,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							toDeleteMsg,
							$author$project$Element$PortfolioSingle$viewLoBadgeDeleteLink(badge))
						]))
				]));
	});
var $author$project$UI$Icon$badge = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-medal'),
			attributes));
};
var $author$project$ACL$canManageLearningOutcomes = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$LoSearch$subject = F2(
	function (viewer, lo) {
		return $author$project$ACL$canManageLearningOutcomes(viewer) ? (lo.e2 + ('@' + ($elm$core$String$fromInt(lo.a) + ('-' + $elm$core$String$fromInt(lo.b))))) : lo.e2;
	});
var $author$project$Element$PortfolioSingle$viewLoBadge = F3(
	function (viewer, toDeleteMsg, badge) {
		var viewLearningOutcome = function (lo) {
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A2(
						$author$project$UI$tag,
						'is-rounded is-success is-light',
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$LoSearch$subject, viewer, lo))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('ml-2')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(lo.gD)
							]))
					]));
		};
		return A4(
			$author$project$UI$mediaObjectXS,
			_List_fromArray(
				[
					$author$project$UI$Icon$badge(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(badge.gD)
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2($elm$core$List$map, viewLearningOutcome, badge.g3))
				]),
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$nav,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							toDeleteMsg,
							$author$project$Element$PortfolioSingle$viewLoBadgeDeleteLink(badge))
						]))
				]));
	});
var $author$project$Element$PortfolioSingle$viewBadges = F6(
	function (_v0, subjects, showBadgeDescription, viewer, toDeleteMsg, badges) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('badges block')
				]),
			A2(
				$elm$core$List$map,
				function (badge) {
					var canDelete = A2($author$project$ACL$canDeleteBadge, badge, viewer) && (!badge.lw);
					var _v1 = _Utils_Tuple2(badge.gJ, canDelete);
					if (_v1.a.$ === 1) {
						if (_v1.b) {
							var _v2 = _v1.a;
							return A3($author$project$Element$PortfolioSingle$viewLoBadge, viewer, toDeleteMsg, badge);
						} else {
							var _v3 = _v1.a;
							return A3($author$project$Element$PortfolioSingle$viewLoBadge, viewer, $elm$core$Maybe$Nothing, badge);
						}
					} else {
						if (_v1.b) {
							var feedback = _v1.a.a;
							return A5($author$project$Element$PortfolioSingle$viewFeedbackBadge, badge, feedback, subjects, showBadgeDescription, toDeleteMsg);
						} else {
							var feedback = _v1.a.a;
							return A5($author$project$Element$PortfolioSingle$viewFeedbackBadge, badge, feedback, subjects, showBadgeDescription, $elm$core$Maybe$Nothing);
						}
					}
				},
				badges));
	});
var $author$project$Locale$Messages$ModulesFieldGoals = {$: 271};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $author$project$Util$Html$markdownOptions = {
	kN: $elm$core$Maybe$Nothing,
	k7: $elm$core$Maybe$Just(
		{ku: true, nj: false}),
	mU: true,
	m5: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $author$project$Util$Html$markdownToHtml = function (content) {
	return A3(
		$elm_explorations$markdown$Markdown$toHtmlWith,
		$author$project$Util$Html$markdownOptions,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		content);
};
var $author$project$Element$ModulesMain$viewModuleGoals = F2(
	function (t_, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldGoals)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.k9)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lb)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.la)
						]))
				]));
	});
var $author$project$Element$GradeReportCard$viewClosedModule = F5(
	function (t_, subjects, viewer, stories, module_) {
		var moduleStories = A2(
			$elm$core$List$filter,
			function (s) {
				return _Utils_eq(
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.gT;
						},
						s.fK),
					$elm$core$Maybe$Just(module_.gT));
			},
			stories);
		var closureStories = A2($elm$core$List$filter, $author$project$PortfolioStory$isModuleClosure, moduleStories);
		return $author$project$UI$panel(
			{
				kt: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								$author$project$UI$contentElem(
								_List_fromArray(
									[
										A2(
										$author$project$UI$caption,
										t_,
										$author$project$Locale$Messages$ModulesAccountableTeacher(
											A2($author$project$Person$fullName, t_, module_.j3)))
									])),
								$author$project$UI$section(
								_List_fromArray(
									[
										$elm$html$Html$text(module_.gD)
									])),
								$author$project$UI$section(
								_List_fromArray(
									[
										A2($author$project$Element$ModulesMain$viewModuleGoals, t_, module_)
									]))
							])),
					A2(
						$elm$core$List$map,
						function (story) {
							return A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A6(
										$author$project$Element$PortfolioSingle$viewBadges,
										t_,
										subjects,
										$elm$core$Basics$always(true),
										viewer,
										$elm$core$Maybe$Nothing,
										story.hZ)
									]));
						},
						closureStories)),
				kJ: 'module-close',
				le: _List_fromArray(
					[
						$elm$html$Html$text(module_.jJ)
					]),
				nk: _List_Nil,
				nq: 'is-link'
			});
	});
var $author$project$Element$GradeReportCard$viewModules = F5(
	function (t_, subjects, viewer, modules, stories) {
		var closedModules = A2(
			$elm$core$List$map,
			function (id) {
				return A2($elm$core$Dict$get, id, modules);
			},
			$elm$core$Set$toList(
				$elm$core$Set$fromList(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gT;
							},
							$author$project$Module$moduleIdToInt),
						A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.fK;
							},
							A2($elm$core$List$filter, $author$project$PortfolioStory$isModuleClosure, stories))))));
		return (!$elm$core$List$isEmpty(closedModules)) ? A2(
			$elm$core$List$cons,
			$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsClosedModules)
					])),
			A2(
				$elm$core$List$map,
				function (moduleDetail) {
					if ((!moduleDetail.$) && (!moduleDetail.a.$)) {
						var module_ = moduleDetail.a.a;
						return A5($author$project$Element$GradeReportCard$viewClosedModule, t_, subjects, viewer, stories, module_);
					} else {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					}
				},
				closedModules)) : _List_Nil;
	});
var $author$project$Locale$Messages$BtnDetail = {$: 38};
var $author$project$Locale$Messages$TimeDateFormat = F2(
	function (a, b) {
		return {$: 628, a: a, b: b};
	});
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$UI$Icon$file = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-file-alt'),
			attributes));
};
var $author$project$PortfolioStory$mediaPreview = function (media) {
	return A2($elm$core$Maybe$withDefault, media.mq, media.hi);
};
var $author$project$Util$Media$ExternalViewer = 3;
var $author$project$Util$Media$ImageViewer = 0;
var $author$project$Util$Media$PdfViewer = 2;
var $author$project$Util$Media$VideoViewer = 1;
var $author$project$Util$Media$mediaViewerByExt = function (filename) {
	var _v0 = $elm$core$List$head(
		$elm$core$List$reverse(
			A2($elm$core$String$split, '.', filename)));
	_v0$5:
	while (true) {
		if (!_v0.$) {
			switch (_v0.a) {
				case 'jpg':
					return 0;
				case 'png':
					return 0;
				case 'mp4':
					return 1;
				case 'mov':
					return 1;
				case 'pdf':
					return 2;
				default:
					break _v0$5;
			}
		} else {
			break _v0$5;
		}
	}
	return 3;
};
var $author$project$Element$GradeReportCard$viewStoryMediaItem = function (maybeMedia) {
	if (maybeMedia.$ === 1) {
		return $author$project$UI$none;
	} else {
		var media = maybeMedia.a;
		var _v1 = $author$project$Util$Media$mediaViewerByExt(media.mq);
		switch (_v1) {
			case 2:
				return $author$project$UI$Icon$filePdf(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-3x'),
							$author$project$UI$Icon$style('has-text-grey is-large')
						]));
			case 3:
				return $author$project$UI$Icon$file(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-3x'),
							$author$project$UI$Icon$style('has-text-info is-large')
						]));
			default:
				return A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(
							$author$project$PortfolioStory$mediaPreview(media))
						]),
					_List_Nil);
		}
	}
};
var $author$project$Element$GradeReportCard$viewPortfolioStories = F6(
	function (t_, subjects, viewer, stories, title, addModuleName) {
		var viewModuleText = function (story) {
			var _v0 = story.fK;
			if (!_v0.$) {
				var module_ = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(' @ '),
							$elm$html$Html$text(module_.jJ)
						]));
			} else {
				return $author$project$UI$none;
			}
		};
		return (!$elm$core$List$isEmpty(stories)) ? A2(
			$elm$core$List$cons,
			$author$project$UI$title(
				_List_fromArray(
					[
						$elm$html$Html$text(title)
					])),
			A2(
				$elm$core$List$map,
				function (story) {
					return A4(
						$author$project$UI$mediaObject,
						_List_fromArray(
							[
								$author$project$Element$GradeReportCard$viewStoryMediaItem(
								$elm$core$List$head(story.lY))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$strong,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												A2(
													$author$project$Locale$Messages$TimeDateFormat,
													$elm$time$Time$utc,
													$elm$time$Time$millisToPosix(story.gz))),
												$elm$html$Html$text(' — '),
												$elm$html$Html$text(
												A2($author$project$Person$fullName, t_, story.kG)),
												A2(
												$author$project$UI$when,
												addModuleName,
												viewModuleText(story))
											])),
										A2($elm$html$Html$br, _List_Nil, _List_Nil),
										$elm$html$Html$text(story.gD),
										A6(
										$author$project$Element$PortfolioSingle$viewBadges,
										t_,
										subjects,
										$elm$core$Basics$always(true),
										viewer,
										$elm$core$Maybe$Nothing,
										story.hZ)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$nav,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$Route$href(
												$author$project$Route$PortfoliosDetail(story.gT)),
												$author$project$UI$attrCyData('portfolios-item-detail')
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-eye')
													])),
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDetail)
											]))
									]),
								_List_Nil)
							]),
						_List_Nil);
				},
				stories)) : _List_Nil;
	});
var $author$project$Element$GradeReportCard$viewPortfolioStoriesSection = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var _v1 = _Utils_Tuple2(model.fU, model.bY);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 1) {
				if (!_v1.b.$) {
					var stories = _v1.a.a;
					var tab = _v1.b.a;
					var subjects_ = A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						$author$project$RemoteData$toMaybe(model.jB));
					var reportStories = function () {
						var _v2 = tab.eV;
						if (!_v2.$) {
							var gr = _v2.a;
							return A2($author$project$Element$GradeReportCard$storiesRelatedToReport, gr, stories);
						} else {
							var la = _v2.a;
							return A2($author$project$Element$GradeReportCard$storiesRelatedToReport, la, stories);
						}
					}();
					var nonModuleClosureStories = A2($elm$core$List$filter, $author$project$PortfolioStory$isNotModuleClosure, reportStories);
					return _Utils_ap(
						A5($author$project$Element$GradeReportCard$viewModules, t_, subjects_, viewer, model.dZ, reportStories),
						A6(
							$author$project$Element$GradeReportCard$viewPortfolioStories,
							t_,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$RemoteData$toMaybe(model.jB)),
							viewer,
							nonModuleClosureStories,
							t_($author$project$Locale$Messages$PortfoliosTitle),
							true));
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.$) {
					var _v3 = _v1.a;
					return _List_fromArray(
						[
							A2(
							$author$project$UI$progressBar,
							'is-link',
							t_($author$project$Locale$Messages$PortfoliosLoadingProgress))
						]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Locale$Messages$GradeReportsSubjectFeedbackNotification = {$: 88};
var $author$project$UI$Icon$filter = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-sliders-h'),
			attributes));
};
var $author$project$Element$GradeReportCard$viewSubjectFeedbackNotification = F2(
	function (_v0, _v1) {
		var t_ = _v0.hy;
		var studentProfile = _v1.ea;
		if (studentProfile.$ === 2) {
			var sp = studentProfile.a;
			return _List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$author$project$Route$href(
									A2($author$project$Route$SubjectFeedbackCard, sp.ne.gT, $elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filter(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsSubjectFeedbackNotification)
								]))
						]))
				]);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Element$GradeReportCard$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					$author$project$Person$isSponsor(viewer),
					$author$project$UI$notification(
						$author$project$UI$textToHtml(
							t_($author$project$Locale$Messages$GradeReportsNoGradesNotification)))),
					$author$project$UI$section(
					A2($author$project$Element$GradeReportCard$viewGradeReportsSection, session, model)),
					$author$project$UI$section(
					A2($author$project$Element$GradeReportCard$viewSubjectFeedbackNotification, session, model)),
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$UI$section(
					A2($author$project$Element$GradeReportCard$viewPortfolioStoriesSection, session, model))
				]));
	});
var $author$project$Element$GradeReportCard$element = {iA: $author$project$Element$GradeReportCard$init, jR: $author$project$Element$GradeReportCard$update, nE: $author$project$Element$GradeReportCard$view};
var $author$project$Element$GradeRequestList$FetchStudentProfile = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestList$LoadingPage = {$: 1};
var $author$project$Element$GradeRequestList$NotFoundPage = {$: 0};
var $author$project$Element$GradeRequestList$StudentProfileDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$StudentProfile$fetchStudentProfileV3 = F3(
	function (config, id, callback) {
		return {
			bN: config,
			dC: $author$project$StudentProfile$studentProfileDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$studentProfile, config, id)
		};
	});
var $author$project$Element$GradeRequestList$init = F3(
	function (config, session, params) {
		var model = {bN: config, bm: $author$project$Element$GradeRequestList$NotFoundPage, i5: params, c3: $elm$core$Maybe$Nothing, cv: session};
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bm: $author$project$Element$GradeRequestList$LoadingPage}),
			$author$project$Element$GradeRequestList$FetchStudentProfile(
				A3($author$project$StudentProfile$fetchStudentProfileV3, config.gr, params, $author$project$Element$GradeRequestList$StudentProfileDownloaded)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$getV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var decoder = _v0.dC;
	var toMsg = _v0.bZ;
	return $author$project$Api$Endpoint$request(
		{
			O: $elm$http$Http$emptyBody,
			a4: A2($author$project$Api$expectJson, toMsg, decoder),
			ah: $author$project$Api$toHeaders(config),
			ba: 'GET',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $author$project$Application$V3$Boundaries$performElement = F3(
	function (key, effect_, element) {
		return A2(
			$elm$core$Platform$Cmd$map,
			element.bZ,
			A2(element.gF.hh, key, effect_));
	});
var $author$project$Element$GradeRequestList$GradeRequestReasonFormEffect = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$GradeRequestReasonFormModel = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$GradeRequestReasonFormMsg = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestList$PopupEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$GradeRequestList$PopupMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NoEffect = {$: 0};
var $author$project$Element$GradeRequestReasonForm$FormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$GradeRequestReasonFormJustification = {$: 109};
var $author$project$Element$GradeRequestReasonForm$Reason = $elm$core$Basics$identity;
var $author$project$Element$GradeRequestReasonForm$buildForm = function (t_) {
	return {
		a$: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a$: value});
				}),
			nD: function ($) {
				return $.a$;
			},
			nE: {
				kJ: 'reason',
				lO: t_($author$project$Locale$Messages$GradeRequestReasonFormJustification),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestReasonForm$FormMsg, $elm$core$Basics$identity),
				bv: t_($author$project$Locale$Messages$GradeRequestReasonFormJustification)
			}
		}
	};
};
var $author$project$Element$GradeRequestReasonForm$emptyForm = {a$: ''};
var $author$project$Element$GradeRequestReasonForm$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			bt: $author$project$Element$GradeRequestReasonForm$buildForm(session.hy),
			bk: params.bk,
			bX: params.bX,
			cv: session,
			eZ: 0,
			ej: $author$project$Element$GradeRequestReasonForm$emptyForm
		};
		return _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Api$patchV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var decoder = _v0.dC;
	var toMsg = _v0.bZ;
	var body = _v0.O;
	return $author$project$Api$Endpoint$request(
		{
			O: $elm$http$Http$jsonBody(body),
			a4: A2($author$project$Api$expectJson, toMsg, decoder),
			ah: $author$project$Api$toHeaders(config.gr),
			ba: 'PATCH',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $elm$browser$Browser$Navigation$pushUrl = _Browser_pushUrl;
var $author$project$Element$GradeRequestReasonForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$GradeRequestReasonForm$perform(key),
						effects));
			case 3:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 5:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
			case 2:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var request = effect.a;
				return $author$project$Api$patchV2(request);
		}
	});
var $author$project$Element$GradeRequestReasonForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$CustomError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$GradeRequestReasonForm$Exit = 0;
var $author$project$Locale$Messages$GradeRequestSaveError = {$: 105};
var $author$project$Locale$Messages$GradeRequestSaveSuccess = {$: 106};
var $author$project$Element$GradeRequestReasonForm$LearningAssessmentUpdated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningGroupSaveError = {$: 167};
var $author$project$Element$GradeRequestReasonForm$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradeRequestReasonForm$LogOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NavRedirect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradeRequestReasonForm$NoOp = {$: 4};
var $author$project$Element$GradeRequestReasonForm$UpdateLearningAssessment = function (a) {
	return {$: 4, a: a};
};
var $author$project$Log$errV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var event = {h8: config.gr.g6, cE: config.gv, b3: eventName, cX: 0, cg: message};
		return {
			O: A2($author$project$Log$encodeLogEvent, config.gr.g7, event),
			bN: config,
			dC: $elm$json$Json$Decode$succeed(0),
			bZ: toMsg,
			G: $author$project$Api$Endpoint$log(config.gr)
		};
	});
var $author$project$Log$errorV2 = F3(
	function (config, _v0, toMsg) {
		var eventName = _v0.a;
		var message = _v0.b;
		var error_ = _v0.c;
		if (!message.$) {
			var message_ = message.a;
			return A3(
				$author$project$Log$errV2,
				config,
				_Utils_Tuple2(
					eventName,
					_Utils_ap(
						message_,
						_Utils_ap(
							$author$project$Log$msgSeperator,
							$author$project$Api$httpErrorToRobots(error_)))),
				toMsg);
		} else {
			return A3(
				$author$project$Log$errV2,
				config,
				_Utils_Tuple2(
					eventName,
					$author$project$Api$httpErrorToRobots(error_)),
				toMsg);
		}
	});
var $author$project$Element$GradeRequestReasonForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a$, values);
	});
var $author$project$Log$msgLearningAssessmentSave = 'learning_assessment_save';
var $author$project$Log$paramScopeGradeRequest = 'scope_graderequest';
var $author$project$LearningAssessment$UnsavedLearningAssessment = function (id) {
	return function (student) {
		return function (grade) {
			return function (type_) {
				return function (subjects) {
					return function (absenceMinutes) {
						return function (justifiedAbsenceMinutes) {
							return function (unjustifiedAbsenceMinutes) {
								return function (startDate) {
									return function (endDate) {
										return function (reportCardSupplementUrl) {
											return function (reportWithMarksUrl) {
												return function (reportWithTextAppraisalUrl) {
													return function (isAssessmentProcessDone) {
														return function (isLocked) {
															return function (isSupervised) {
																return function (isPassed) {
																	return function (mustRepeatGrade) {
																		return function (canTakeRepeatExam) {
																			return function (canRequireMark) {
																				return function (reason) {
																					return {fc: absenceMinutes, kw: canRequireMark, fn: canTakeRepeatExam, gH: endDate, gO: grade, gT: id, fA: isAssessmentProcessDone, lw: isLocked, fC: isPassed, fD: isSupervised, fE: justifiedAbsenceMinutes, fL: mustRepeatGrade, a$: reason, fZ: reportCardSupplementUrl, mI: reportWithMarksUrl, mJ: reportWithTextAppraisalUrl, hv: startDate, ne: student, jB: subjects, hH: type_, ge: unjustifiedAbsenceMinutes};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningAssessment$unsavedLearningAssessment = F3(
	function (learningAssessment, reason, subjects) {
		return $author$project$LearningAssessment$UnsavedLearningAssessment(learningAssessment.gT)(learningAssessment.ne)(learningAssessment.gO)(learningAssessment.hH)(subjects)(learningAssessment.fc)(learningAssessment.fE)(learningAssessment.ge)(learningAssessment.hv)(learningAssessment.gH)(learningAssessment.fZ)(learningAssessment.mI)(learningAssessment.mJ)(learningAssessment.fA)(learningAssessment.lw)(learningAssessment.fD)(learningAssessment.fC)(learningAssessment.fL)(learningAssessment.fn)(learningAssessment.kw)(reason);
	});
var $author$project$Element$GradeRequestReasonForm$updateForm = F3(
	function (msg, form, formValues) {
		var value = msg;
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{
					a$: $author$project$Form$markEdited(form.a$)
				}),
			A2(form.a$.jR, value, formValues));
	});
var $author$project$Api$Endpoint$learningAssessment = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-assessments',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$SubjectAssessment$stateEncoder = function (state) {
	switch (state) {
		case 0:
			return $elm$json$Json$Encode$string('created');
		case 1:
			return $elm$json$Json$Encode$string('text_appraisal');
		case 2:
			return $elm$json$Json$Encode$string('mark_required');
		case 3:
			return $elm$json$Json$Encode$string('offered_mark');
		default:
			return $elm$json$Json$Encode$string('final_mark');
	}
};
var $author$project$SubjectAssessment$subjectAssessmentEncoder = function (subjectAssessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(subjectAssessment.gT)),
				_Utils_Tuple2(
				'state',
				$author$project$SubjectAssessment$stateEncoder(subjectAssessment.eZ))
			]));
};
var $author$project$LearningAssessment$learningAssessmentEncoder = function (learningAssessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(learningAssessment.gT)),
				_Utils_Tuple2(
				'subjects',
				A2($elm$json$Json$Encode$list, $author$project$SubjectAssessment$subjectAssessmentEncoder, learningAssessment.jB)),
				_Utils_Tuple2(
				'reason',
				$elm$json$Json$Encode$string(learningAssessment.a$))
			]));
};
var $author$project$LearningAssessment$updateLearningAssessment = F3(
	function (config, learningAssessment, callback) {
		return {
			O: $author$project$LearningAssessment$learningAssessmentEncoder(learningAssessment),
			bN: config,
			dC: $author$project$LearningAssessment$learningAssessmentDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$learningAssessment, config.gr, learningAssessment.gT)
		};
	});
var $author$project$Element$GradeRequestReasonForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			a$: $author$project$Form$markEdited(form.a$)
		});
};
var $author$project$Element$GradeRequestReasonForm$update = F2(
	function (msg, model) {
		var session = model.cv;
		var config = model.bN;
		var form = model.bt;
		var values = model.ej;
		var noop = _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Element$GradeRequestReasonForm$NoEffect,
					$elm$core$Maybe$Just(0));
			case 0:
				if (A2($author$project$Element$GradeRequestReasonForm$isFormValid, form, values)) {
					var updatedLearningAssessment = A3($author$project$LearningAssessment$unsavedLearningAssessment, model.bk, values.a$, model.bX);
					var updateEffect = $author$project$Element$GradeRequestReasonForm$UpdateLearningAssessment(
						A3($author$project$LearningAssessment$updateLearningAssessment, config, updatedLearningAssessment, $author$project$Element$GradeRequestReasonForm$LearningAssessmentUpdated));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{eZ: 2}),
						updateEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var updatedmodel = _Utils_update(
						model,
						{
							bt: $author$project$Element$GradeRequestReasonForm$validateForm(form),
							eZ: 1
						});
					return _Utils_Tuple3(updatedmodel, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 2:
				var data = msg.a;
				switch (data.$) {
					case 2:
						var la = data.a;
						var updatedSession = A2(
							$author$project$Session$ok,
							session,
							model.cv.hy($author$project$Locale$Messages$GradeRequestSaveSuccess));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cv: updatedSession, eZ: 0}),
							$author$project$Element$GradeRequestReasonForm$BatchEffect(
								_List_fromArray(
									[
										$author$project$Element$GradeRequestReasonForm$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgLearningAssessmentSave,
												_List_fromArray(
													[
														$author$project$Log$paramScopeGradeRequest,
														$elm$core$String$fromInt(la.gT),
														$author$project$Log$paramOk
													])),
											$elm$core$Basics$always($author$project$Element$GradeRequestReasonForm$NoOp))),
										$author$project$Element$GradeRequestReasonForm$NavRedirect(
										$author$project$Route$GradeRequestList(la.ne.gT))
									])),
							$elm$core$Maybe$Just(0));
					case 1:
						return _Utils_Tuple3(model, $author$project$Element$GradeRequestReasonForm$NoEffect, $elm$core$Maybe$Nothing);
					case 3:
						var error = data.a;
						var updatedSession = A3(
							$author$project$Session$error,
							session,
							error,
							model.cv.hy($author$project$Locale$Messages$GradeRequestSaveError));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cv: updatedSession, eZ: 3}),
							$author$project$Element$GradeRequestReasonForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgLearningAssessmentSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
										error),
									$elm$core$Basics$always($author$project$Element$GradeRequestReasonForm$NoOp))),
							$elm$core$Maybe$Nothing);
					default:
						var error = $author$project$Api$CustomError('Unexpected msg (LearningAssessmentUpdated RemoteData.NotAsked)');
						var updatedSession = A3(
							$author$project$Session$error,
							session,
							error,
							model.cv.hy($author$project$Locale$Messages$LearningGroupSaveError));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cv: updatedSession}),
							$author$project$Element$GradeRequestReasonForm$NoEffect,
							$elm$core$Maybe$Nothing);
				}
			case 1:
				var fieldMsg = msg.a;
				var _v2 = A3($author$project$Element$GradeRequestReasonForm$updateForm, fieldMsg, form, values);
				var form2 = _v2.a;
				var values2 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{bt: form2, eZ: 1, ej: values2}),
					$author$project$Element$GradeRequestReasonForm$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				return noop;
		}
	});
var $author$project$Element$GradeRequestReasonForm$viewForm = F3(
	function (t_, form, values) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$UI$textareaField, t_, form.a$, values)
				]));
	});
var $author$project$Element$GradeRequestReasonForm$view = function (_v0) {
	var session = _v0.cv;
	var form = _v0.bt;
	var values = _v0.ej;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Element$GradeRequestReasonForm$viewForm, session.hy, form, values)
			]));
};
var $author$project$Element$GradeRequestReasonForm$element = {iA: $author$project$Element$GradeRequestReasonForm$init, hh: $author$project$Element$GradeRequestReasonForm$perform, jR: $author$project$Element$GradeRequestReasonForm$update, nE: $author$project$Element$GradeRequestReasonForm$view};
var $author$project$Element$GradeRequestList$popups = {
	cq: {
		gF: $author$project$Element$GradeRequestReasonForm$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$PopupEffect, $elm$core$Basics$identity),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$PopupMsg, $elm$core$Basics$identity),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$GradeRequestList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var popupEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$GradeRequestList$popups.cq);
		}
	});
var $author$project$Element$GradeRequestList$FetchLearningAssessments = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradeRequestList$LearningAssessmentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$GradeRequestList$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$GradeRequestList$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradeRequestList$NoEffect = {$: 0};
var $author$project$Element$GradeRequestList$NoOp = {$: 0};
var $author$project$Element$GradeRequestList$changeStateToMarkRequested = F2(
	function (learningAssessment, subjectAssessments) {
		var updatedSubjects = A2(
			$elm$core$List$map,
			function (subjectAssessment) {
				return A2($elm$core$List$member, subjectAssessment.gT, subjectAssessments) ? _Utils_update(
					subjectAssessment,
					{eZ: 2}) : subjectAssessment;
			},
			learningAssessment.jB);
		return _Utils_update(
			learningAssessment,
			{jB: updatedSubjects});
	});
var $author$project$Element$GradeRequestList$MidYear = 0;
var $author$project$LearningAssessment$blankLearningAssessmentId = -1;
var $author$project$Person$blankPersonId = -1;
var $author$project$Person$blankNestedPerson = {K: '', k3: '', gT: $author$project$Person$blankPersonId, ak: ''};
var $author$project$LearningAssessment$blankLearningAssessment = {fc: 0, kw: false, fn: false, gH: 0, gO: '', gT: $author$project$LearningAssessment$blankLearningAssessmentId, fA: false, lw: false, fC: false, fD: false, fE: 0, fL: false, fZ: $elm$core$Maybe$Nothing, mI: $elm$core$Maybe$Nothing, mJ: $elm$core$Maybe$Nothing, hv: 0, ne: $author$project$Person$blankNestedPerson, jB: _List_Nil, hH: 0, ge: 0};
var $author$project$Element$GradeRequestList$defaultTab = {dH: 0, bk: $author$project$LearningAssessment$blankLearningAssessment, bX: _List_Nil, d9: 0, hH: 0};
var $author$project$LearningAssessment$fetchLearningAssessmentsByPerson2 = F3(
	function (config, personId, callback) {
		return {
			bN: config,
			dC: $author$project$LearningAssessment$learningAssessmentListDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$learningAssessmentsByPerson, config, personId)
		};
	});
var $author$project$Element$GradeRequestList$initListPageModel = function (studentProfile) {
	return {fF: _List_Nil, bY: $elm$core$Maybe$Nothing, ea: studentProfile, e4: _List_Nil};
};
var $author$project$Element$GradeRequestList$compareTab = F2(
	function (left, right) {
		var _v0 = A2($elm$core$Basics$compare, left.d9, right.d9);
		switch (_v0) {
			case 0:
				return 0;
			case 2:
				return 2;
			default:
				var _v1 = A2($elm$core$Basics$compare, left.dH, right.dH);
				switch (_v1) {
					case 0:
						return 0;
					case 2:
						return 2;
					default:
						var _v2 = _Utils_Tuple2(left.hH, right.hH);
						_v2$3:
						while (true) {
							switch (_v2.a) {
								case 1:
									if (_v2.b === 1) {
										var _v3 = _v2.a;
										var _v4 = _v2.b;
										return 1;
									} else {
										var _v10 = _v2.a;
										return 2;
									}
								case 0:
									switch (_v2.b) {
										case 0:
											var _v5 = _v2.a;
											var _v6 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v11 = _v2.a;
											var _v12 = _v2.b;
											return 2;
									}
								default:
									switch (_v2.b) {
										case 2:
											var _v7 = _v2.a;
											var _v8 = _v2.b;
											return 1;
										case 1:
											break _v2$3;
										default:
											var _v13 = _v2.a;
											var _v14 = _v2.b;
											return 0;
									}
							}
						}
						var _v9 = _v2.b;
						return 0;
				}
		}
	});
var $author$project$Element$GradeRequestList$EndOfYear = 1;
var $author$project$Element$GradeRequestList$GradingExam = 2;
var $author$project$Element$GradeRequestList$learningAssessmentToTab = function (la) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.hv));
	var learningAssessmentType = function () {
		var _v0 = la.hH;
		switch (_v0) {
			case 0:
				return 0;
			case 1:
				return 1;
			default:
				return 2;
		}
	}();
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(la.gH));
	return {
		dH: _Utils_eq(startYear, endYear) ? (endYear + 1) : endYear,
		bk: la,
		bX: _List_Nil,
		d9: startYear,
		hH: learningAssessmentType
	};
};
var $author$project$Element$GradeRequestList$makeTabs = function (learningAssessments) {
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$sortWith,
			$author$project$Element$GradeRequestList$compareTab,
			A2($elm$core$List$map, $author$project$Element$GradeRequestList$learningAssessmentToTab, learningAssessments)));
};
var $author$project$Application$V3$Boundaries$initElement = F4(
	function (config, session, element, params) {
		return A3(element.gF.iA, config, session, params);
	});
var $author$project$Application$V3$Boundaries$mapElement = F3(
	function (containerModel, element, _v0) {
		var elementModel = _v0.a;
		var elementEffect = _v0.b;
		var reply = _v0.c;
		return _Utils_Tuple3(
			A2(
				element.jS,
				_Utils_update(
					containerModel,
					{cv: elementModel.cv}),
				elementModel),
			element.jK(elementEffect),
			reply);
	});
var $author$project$Element$GradeRequestList$openReasonFormPopup = F3(
	function (learningAssessment, selectedSubjects, _v0) {
		var model = _v0.a;
		var params = {bk: learningAssessment, bX: selectedSubjects};
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$GradeRequestList$popups.cq,
			A4($author$project$Application$V3$Boundaries$initElement, model.bN, model.cv, $author$project$Element$GradeRequestList$popups.cq, params));
		var popupModel = _v1.a;
		var popupEffect = _v1.b;
		return _Utils_Tuple3(popupModel, popupEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Application$V3$Boundaries$mapModel = F2(
	function (f, _v0) {
		var prevModel = _v0.a;
		var prevEffect = _v0.b;
		var prevReply = _v0.c;
		return _Utils_Tuple3(
			f(prevModel),
			prevEffect,
			prevReply);
	});
var $author$project$Element$GradeRequestList$closePopup = function (_return) {
	return A2(
		$author$project$Application$V3$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{c3: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Application$V3$Boundaries$updateElement = F4(
	function (session, msg, model, element) {
		return A2(
			element.gF.jR,
			msg,
			_Utils_update(
				model,
				{cv: session}));
	});
var $author$project$Element$GradeRequestList$updatePopup = F3(
	function (popupMsg, session, model) {
		var _v0 = _Utils_Tuple2(popupMsg, model.c3);
		if (!_v0.b.$) {
			var reasonFormMsg = _v0.a;
			var reasonFormModel = _v0.b.a;
			var _v1 = A3(
				$author$project$Application$V3$Boundaries$mapElement,
				model,
				$author$project$Element$GradeRequestList$popups.cq,
				A4($author$project$Application$V3$Boundaries$updateElement, session, reasonFormMsg, reasonFormModel, $author$project$Element$GradeRequestList$popups.cq));
			var model2 = _v1.a;
			var effect = _v1.b;
			var reply = _v1.c;
			if (!reply.$) {
				var _v3 = reply.a;
				return $author$project$Element$GradeRequestList$closePopup(
					_Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing));
			} else {
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			}
		} else {
			return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$GradeRequestList$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var noop = _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$7:
		while (true) {
			switch (_v0.a.$) {
				case 4:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPageModel = _v0.b.a;
						var selectedTab = A2($elm$core$Maybe$withDefault, $author$project$Element$GradeRequestList$defaultTab, listPageModel.bY);
						var updatedTab = _Utils_update(
							selectedTab,
							{bX: values});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bm: $author$project$Element$GradeRequestList$ListPage(
										_Utils_update(
											listPageModel,
											{
												bY: $elm$core$Maybe$Just(updatedTab)
											}))
								}),
							$author$project$Element$GradeRequestList$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				case 6:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var listPageModel = _v0.b.a;
						var selectedTab = A2($elm$core$Maybe$withDefault, $author$project$Element$GradeRequestList$defaultTab, listPageModel.bY);
						var updatedLearningAssessment = A2($author$project$Element$GradeRequestList$changeStateToMarkRequested, selectedTab.bk, selectedTab.bX);
						var selectedSubjects = A2(
							$elm$core$List$filter,
							function (subject) {
								return A2($elm$core$List$member, subject.gT, selectedTab.bX);
							},
							updatedLearningAssessment.jB);
						return A3($author$project$Element$GradeRequestList$openReasonFormPopup, updatedLearningAssessment, selectedSubjects, noop);
					} else {
						break _v0$7;
					}
				case 5:
					var popupMsg = _v0.a.a;
					return A3($author$project$Element$GradeRequestList$updatePopup, popupMsg, session, model);
				case 1:
					if (_v0.b.$ === 2) {
						var data = _v0.a.a;
						var listPageModel = _v0.b.a;
						switch (data.$) {
							case 2:
								var learningAssessments_ = data.a;
								var tabs = $author$project$Element$GradeRequestList$makeTabs(learningAssessments_);
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$GradeRequestList$ListPage(
											_Utils_update(
												listPageModel,
												{
													fF: learningAssessments_,
													bY: $elm$core$List$head(tabs),
													e4: tabs
												}))
									});
								return _Utils_Tuple3(model2, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											cv: A3(
												$author$project$Session$error,
												session,
												error,
												session.hy($author$project$Locale$Messages$LearningAssessmentsDownloadError))
										}),
									$author$project$Element$GradeRequestList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgLearningAssessmentsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
												error),
											$elm$core$Basics$always($author$project$Element$GradeRequestList$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$7;
					}
				case 2:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var _v3 = _v0.b;
						switch (data.$) {
							case 2:
								var studentProfile_ = data.a;
								var listPageModel = $author$project$Element$GradeRequestList$initListPageModel(studentProfile_);
								var updatedModel = _Utils_update(
									model,
									{
										bm: $author$project$Element$GradeRequestList$ListPage(listPageModel)
									});
								return _Utils_Tuple3(
									updatedModel,
									$author$project$Element$GradeRequestList$FetchLearningAssessments(
										A3($author$project$LearningAssessment$fetchLearningAssessmentsByPerson2, model.bN.gr, listPageModel.ea.ne.gT, $author$project$Element$GradeRequestList$LearningAssessmentListDownloaded)),
									$elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											cv: A3(
												$author$project$Session$error,
												session,
												error,
												session.hy($author$project$Locale$Messages$ProfilesDownloadError))
										}),
									$author$project$Element$GradeRequestList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgStudentProfileDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeGradeRequest),
												error),
											$elm$core$Basics$always($author$project$Element$GradeRequestList$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$GradeRequestList$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$7;
					}
				case 3:
					if (_v0.b.$ === 2) {
						var tab = _v0.a.a;
						var listPageModel = _v0.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bm: $author$project$Element$GradeRequestList$ListPage(
										_Utils_update(
											listPageModel,
											{
												bY: $elm$core$Maybe$Just(tab)
											}))
								}),
							$author$project$Element$GradeRequestList$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$7;
					}
				default:
					var _v5 = _v0.a;
					return noop;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$GradeRequestNoLearningAssessment = {$: 102};
var $author$project$Locale$Messages$GradeRequestListTitle = {$: 97};
var $author$project$ACL$canRequestGrade = function (person) {
	return $author$project$Person$isSponsor(person);
};
var $author$project$Element$GradeRequestList$isButtonEnabled = function (tab) {
	return tab.bk.kw && (!_Utils_eq(tab.bX, _List_Nil));
};
var $author$project$Locale$Messages$GradeRequestDescription = {$: 98};
var $author$project$Locale$Messages$GradeRequestFormSubmit = {$: 99};
var $author$project$Locale$Messages$GradeRequestFormTitle = {$: 100};
var $author$project$Locale$Messages$GradeRequestNoSubjects = {$: 103};
var $author$project$Locale$Messages$LoStudentOverviewSubjects = {$: 193};
var $author$project$Element$GradeRequestList$OpenReasonForm = {$: 6};
var $author$project$Element$GradeRequestList$SetSubject = function (a) {
	return {$: 4, a: a};
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$Util$List$findIndexHelp = F3(
	function (index, predicate, list) {
		findIndexHelp:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					return $elm$core$Maybe$Just(index);
				} else {
					var $temp$index = index + 1,
						$temp$predicate = predicate,
						$temp$list = xs;
					index = $temp$index;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findIndexHelp;
				}
			}
		}
	});
var $author$project$Util$List$findIndex = $author$project$Util$List$findIndexHelp(0);
var $author$project$Util$List$elemIndex = function (x) {
	return $author$project$Util$List$findIndex(
		$elm$core$Basics$eq(x));
};
var $author$project$Util$List$removeElem = F2(
	function (elem, list) {
		var _v0 = A2($author$project$Util$List$elemIndex, elem, list);
		if (_v0.$ === 1) {
			return list;
		} else {
			var index = _v0.a;
			return _Utils_ap(
				A2($elm$core$List$take, index, list),
				A2($elm$core$List$drop, index + 1, list));
		}
	});
var $author$project$UI$checkbox = F5(
	function (toMsg, dataTag, optionIsDisabled, selectedValues, option) {
		var checked_ = A2($elm$core$List$member, option.nD, selectedValues);
		var onClick_ = toMsg(
			checked_ ? A2($author$project$Util$List$removeElem, option.nD, selectedValues) : A2($elm$core$List$cons, option.nD, selectedValues));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(onClick_),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$name(dataTag),
									$author$project$UI$attrCyData(dataTag),
									$elm$html$Html$Attributes$checked(checked_),
									$elm$html$Html$Attributes$disabled(
									optionIsDisabled(option))
								]),
							_List_Nil),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(option.lO)
						]))
				]));
	});
var $author$project$Element$GradeRequestList$fromSubjectAssessmentsToValue = function (subjectAssessments) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, subjectAssessments);
};
var $author$project$Element$GradeRequestList$fromValueToSubjectAssessments = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $author$project$SubjectAssessment$isRequestable = function (subjectAssessment) {
	return (!subjectAssessment.lG) && ((!subjectAssessment.eZ) || (subjectAssessment.eZ === 1));
};
var $author$project$Locale$Messages$FormSelectAll = {$: 70};
var $author$project$Locale$Messages$FormSelectNone = {$: 71};
var $elm$html$Html$fieldset = _VirtualDom_node('fieldset');
var $elm$html$Html$legend = _VirtualDom_node('legend');
var $author$project$Element$GradeRequestList$viewMultiChoices = F2(
	function (t_, _v0) {
		var data = _v0.gB;
		var toSelectMsg = _v0.hF;
		var caption = _v0.gw;
		var toOptions = _v0.hE;
		var viewOption = _v0.hI;
		var viewSelectLinks = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(lst),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectAll)
							])),
						$elm$html$Html$text(' | '),
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(_List_Nil),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectNone)
							]))
					]));
		};
		var view_ = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$fieldset,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$legend,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[caption])),
							$elm$core$List$isEmpty(lst) ? _List_fromArray(
								[
									$author$project$UI$Icon$loadingOptions(_List_Nil)
								]) : A2(
								$elm$core$List$map,
								viewOption,
								toOptions(lst)))),
						A2(
						$author$project$UI$when,
						!$elm$core$List$isEmpty(lst),
						viewSelectLinks(lst))
					]));
		};
		if (data.$ === 1) {
			return view_(_List_Nil);
		} else {
			if (!data.a.b) {
				return $author$project$UI$none;
			} else {
				var lst = data.a;
				return view_(lst);
			}
		}
	});
var $author$project$Element$GradeRequestList$viewRequestForm = F4(
	function (t_, maybeSubjects, selectedSubjects, isSubmitable) {
		var viewCheckbox = A4(
			$author$project$UI$checkbox,
			A2($elm$core$Basics$composeL, $author$project$Element$GradeRequestList$SetSubject, $author$project$Element$GradeRequestList$fromValueToSubjectAssessments),
			'filter-subject',
			$elm$core$Basics$always(false),
			$author$project$Element$GradeRequestList$fromSubjectAssessmentsToValue(selectedSubjects));
		var toSubjectOptions = function (subjectAssessments) {
			return $author$project$Form$toSortedSelectOptions(
				A2(
					$elm$core$List$map,
					function (subjectAssessment) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(subjectAssessment.gT),
							subjectAssessment.e2.fQ);
					},
					subjectAssessments));
		};
		var filteredSubjectAssessments = function () {
			if (maybeSubjects.$ === 1) {
				return _List_Nil;
			} else {
				var subjects = maybeSubjects.a;
				return A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e2;
						},
						function ($) {
							return $.fQ;
						}),
					A2(
						$elm$core$List$filter,
						function (subject) {
							return $author$project$SubjectAssessment$isRequestable(subject);
						},
						subjects));
			}
		}();
		var viewForm = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					_Utils_eq(filteredSubjectAssessments, _List_Nil) ? $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNoSubjects)
						])) : A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestDescription),
					A2(
					$author$project$Element$GradeRequestList$viewMultiChoices,
					t_,
					{
						gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewSubjects),
						gB: $elm$core$Maybe$Just(filteredSubjectAssessments),
						hE: toSubjectOptions,
						hF: A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function ($) {
									return $.gT;
								}),
							$author$project$Element$GradeRequestList$SetSubject),
						hI: viewCheckbox
					}),
					A4(
					$author$project$UI$submitButton,
					t_($author$project$Locale$Messages$GradeRequestFormSubmit),
					!isSubmitable,
					false,
					$author$project$Element$GradeRequestList$OpenReasonForm)
				]));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$title(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestFormTitle)
						])),
					viewForm
				]));
	});
var $author$project$Locale$Messages$GradeRequestGrade = {$: 101};
var $author$project$Locale$Messages$GradeRequestNotRequested = {$: 104};
var $author$project$Locale$Messages$GradeRequestRequested = {$: 108};
var $author$project$Locale$Messages$GradeRequestSubject = {$: 107};
var $author$project$Locale$Messages$GradeRequestWaived = {$: 111};
var $author$project$SubjectAssessment$isNumeric = function (maybeString) {
	if (!maybeString.$) {
		var string = maybeString.a;
		return A2($elm$core$String$all, $elm$core$Char$isDigit, string);
	} else {
		return false;
	}
};
var $author$project$Element$GradeRequestList$viewSubjectListTable = F2(
	function (t_, subjectAssessments) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$table,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-striped')
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$tr,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestSubject)
												])),
											A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestGrade)
												]))
										]))
								])),
						A2(
							$elm$core$List$map,
							function (line) {
								return A2(
									$elm$html$Html$tr,
									_List_Nil,
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$td,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(line.e2.fQ)
												])),
										line.iy ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified'),
														$elm$html$Html$Attributes$colspan(3)
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsExempted)
													]))
											]) : (line.lG ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified'),
														$elm$html$Html$Attributes$colspan(3)
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestWaived)
													]))
											]) : ((!line.eZ) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNotRequested)
													]))
											]) : ((line.eZ === 2) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestRequested)
													]))
											]) : ((line.eZ === 3) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestRequested)
													]))
											]) : ($author$project$SubjectAssessment$isNumeric(line.iQ) ? _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($elm$core$Maybe$withDefault, '', line.iQ))
													]))
											]) : _List_fromArray(
											[
												A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('has-text-justified')
													]),
												_List_fromArray(
													[
														A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestNotRequested)
													]))
											]))))))));
							},
							A2(
								$author$project$Util$List$sortBy,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.e2;
									},
									function ($) {
										return $.fQ;
									}),
								subjectAssessments))))
				]));
	});
var $author$project$Element$GradeRequestList$viewLearningAssessment = F2(
	function (_v0, selectedTab) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var viewTitle = $author$project$UI$title(
			_List_fromArray(
				[
					$elm$html$Html$text(
					t_($author$project$Locale$Messages$GradeRequestListTitle))
				]));
		var viewRequestListHeader = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block is-uppercase')
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$subtitle(
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, selectedTab.bk.ne))
						]))
				]));
		var viewForm = $author$project$ACL$canRequestGrade(viewer) ? A4(
			$author$project$Element$GradeRequestList$viewRequestForm,
			t_,
			$elm$core$Maybe$Just(selectedTab.bk.jB),
			selectedTab.bX,
			$author$project$Element$GradeRequestList$isButtonEnabled(selectedTab)) : $author$project$UI$none;
		var viewButton = A2(
			$author$project$UI$level,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					selectedTab.bk.mI,
					function (url) {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$filePdf(
									_List_fromArray(
										[
											$author$project$UI$Icon$style('has-text-primary')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadGradesPDF)
										]))
								]));
					})
				]));
		var subjects = selectedTab.bk.jB;
		var viewTable = A2($author$project$Element$GradeRequestList$viewSubjectListTable, t_, subjects);
		var requestableSubjects = A2(
			$elm$core$List$filter,
			function (subjectAssessment) {
				return (!subjectAssessment.eZ) || (subjectAssessment.eZ === 1);
			},
			selectedTab.bk.jB);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					viewButton,
					viewRequestListHeader,
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(subjects),
					viewTable),
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(requestableSubjects),
					viewForm)
				]));
	});
var $author$project$Element$GradeRequestReasonForm$FormSubmitted = {$: 0};
var $author$project$Locale$Messages$GradeRequestReasonFormTitle = {$: 110};
var $author$project$Element$GradeRequestReasonForm$PopupClosed = {$: 3};
var $author$project$Locale$Messages$BtnOk = {$: 37};
var $author$project$UI$confirmDialog_ = F6(
	function (isBtnOkEnabled, isBtnCancelEnabled, t_, config, title_, content) {
		return A4(
			$author$project$UI$modalPanel,
			title_,
			_List_Nil,
			content,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-primary'),
							$elm$html$Html$Events$onClick(config.kD),
							$elm$html$Html$Attributes$disabled(!isBtnOkEnabled)
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button'),
							$elm$html$Html$Events$onClick(config.kM),
							$elm$html$Html$Attributes$disabled(!isBtnCancelEnabled)
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
						]))
				]));
	});
var $author$project$UI$confirmDialogOkCanBeDisabled = function (isBtnOkEnabled) {
	return A2($author$project$UI$confirmDialog_, isBtnOkEnabled, true);
};
var $author$project$Element$GradeRequestReasonForm$viewPopup = function (_v0) {
	var session = _v0.cv;
	var form = _v0.bt;
	var values = _v0.ej;
	var state = _v0.eZ;
	return A5(
		$author$project$UI$confirmDialogOkCanBeDisabled,
		state === 1,
		session.hy,
		{kD: $author$project$Element$GradeRequestReasonForm$FormSubmitted, kM: $author$project$Element$GradeRequestReasonForm$PopupClosed},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$GradeRequestReasonFormTitle)
			]),
		_List_fromArray(
			[
				A3($author$project$Element$GradeRequestReasonForm$viewForm, session.hy, form, values)
			]));
};
var $author$project$Element$GradeRequestList$viewPopup = F2(
	function (session, model) {
		var _v0 = model.c3;
		if (!_v0.$) {
			var popupModel = _v0.a;
			return A2(
				$elm$html$Html$map,
				$author$project$Element$GradeRequestList$popups.cq.bZ,
				$author$project$Element$GradeRequestReasonForm$viewPopup(
					_Utils_update(
						popupModel,
						{cv: session})));
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$GradeRequestList$TabSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$GradeRequestList$tabCaption = function (_v0) {
	var startYear = _v0.d9;
	var endYear = _v0.dH;
	var type_ = _v0.hH;
	switch (type_) {
		case 0:
			return A2($author$project$Locale$Messages$GradeReportCardTabMidYear, startYear, endYear);
		case 1:
			return A2($author$project$Locale$Messages$GradeReportCardTabEndOfYear, startYear, endYear);
		default:
			return A2($author$project$Locale$Messages$GradeReportCardTabGradingExam, startYear, endYear);
	}
};
var $author$project$Element$GradeRequestList$viewTabBar = F3(
	function (t_, selected, learningAssessments) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tabs is-boxed')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$classList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'is-active',
												_Utils_eq(
													$elm$core$Maybe$Just(tab),
													selected))
											]))
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$GradeRequestList$TabSelected(tab),
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Element$GradeRequestList$tabCaption(tab))
											]))
									]));
						},
						learningAssessments))
				]));
	});
var $author$project$Element$GradeRequestList$viewSubjectAssessmentSection = function (model) {
	var session = model.cv;
	var page = model.bm;
	switch (page.$) {
		case 0:
			return _List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-warning',
					session.hy($author$project$Locale$Messages$LearningAssessmentsDownloadError))
				]);
		case 1:
			return _List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-info',
					session.hy($author$project$Locale$Messages$GradeReportsLoadingProgress))
				]);
		default:
			var listPageModel = page.a;
			return _List_fromArray(
				[
					function () {
					var _v1 = _Utils_Tuple2(listPageModel.bY, listPageModel.fF);
					if (!_v1.a.$) {
						var tab = _v1.a.a;
						var learningAssessment = tab.bk;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Element$GradeRequestList$viewTabBar, session.hy, listPageModel.bY, listPageModel.e4),
									A2(
									$author$project$UI$when,
									A2($author$project$ACL$canViewLearningAssessmentGrades, session.nH, learningAssessment),
									A2($author$project$Element$GradeRequestList$viewLearningAssessment, session, tab)),
									A2($author$project$Element$GradeRequestList$viewPopup, session, model)
								]));
					} else {
						if (!_v1.b.b) {
							var _v2 = _v1.a;
							return $author$project$UI$notification(
								_List_fromArray(
									[
										A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$GradeRequestNoLearningAssessment)
									]));
						} else {
							var _v3 = _v1.a;
							return $author$project$UI$none;
						}
					}
				}()
				]);
	}
};
var $author$project$Element$GradeRequestList$view = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$UI$section(
				$author$project$Element$GradeRequestList$viewSubjectAssessmentSection(model))
			]));
};
var $author$project$Element$GradeRequestList$element = {iA: $author$project$Element$GradeRequestList$init, hh: $author$project$Element$GradeRequestList$perform, jR: $author$project$Element$GradeRequestList$update, nE: $author$project$Element$GradeRequestList$view};
var $author$project$Locale$Messages$GradesOverviewStudent = {$: 118};
var $author$project$Element$GradesOverview$GradeReportListDownloaded = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Api$Endpoint$gradeReportsByTeam = F2(
	function (config, teamId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'teams',
					$elm$core$String$fromInt(teamId),
					'grade-reports'
				]),
			_List_Nil);
	});
var $author$project$Team$teamIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$GradeReport$fetchGradeReportsByTeam = F3(
	function (config, teamId, callback) {
		return A3(
			$author$project$Api$get,
			A2(
				$author$project$Api$Endpoint$gradeReportsByTeam,
				config,
				$author$project$Team$teamIdToInt(teamId)),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$GradeReport$gradeReportsDecoder));
	});
var $author$project$Application$Boundaries$mapModel = F2(
	function (f, prev) {
		return _Utils_update(
			prev,
			{
				dY: f(prev.dY)
			});
	});
var $author$project$Element$GradesOverview$andFetchGradeReports = F2(
	function (teamId, _return) {
		var model = _return.dY;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$GradeReport$fetchGradeReportsByTeam,
				model.bN.gr,
				teamId,
				$author$project$Element$GradesOverview$GradeReportListDownloaded(false)),
			A2(
				$author$project$Application$Boundaries$mapModel,
				function (model_) {
					return _Utils_update(
						model_,
						{dN: $author$project$RemoteData$Loading});
				},
				_return));
	});
var $author$project$Element$GradesOverview$SchoolListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$schools = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'schools']),
		_List_Nil);
};
var $author$project$Team$teamsDecoder = $elm$json$Json$Decode$list($author$project$Team$teamDecoder);
var $author$project$Team$fetchSchools = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$schools(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Team$teamsDecoder));
	});
var $author$project$Element$GradesOverview$andFetchSchools = function (_return) {
	var model = _return.dY;
	return A2(
		$author$project$Application$Boundaries$andThenCmd,
		A2($author$project$Team$fetchSchools, model.bN.gr, $author$project$Element$GradesOverview$SchoolListDownloaded),
		A2(
			$author$project$Application$Boundaries$mapModel,
			function (model_) {
				return _Utils_update(
					model_,
					{jr: $author$project$RemoteData$Loading});
			},
			_return));
};
var $author$project$Person$teamsAsTom = function (person) {
	var _v0 = person.c6;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (_v1) {
				var role = _v1.a;
				return _Utils_eq(role, $author$project$Person$roleTeacher) || (_Utils_eq(role, $author$project$Person$roleModuleTeacher) || _Utils_eq(role, $author$project$Person$roleOperator));
			},
			roles));
};
var $author$project$Element$GradesOverview$defaultTeamId = A2($elm$core$Basics$composeR, $author$project$Person$teamsAsTom, $elm$core$List$head);
var $NoRedInk$elm_sortable_table$Table$State = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $NoRedInk$elm_sortable_table$Table$initialSort = function (header) {
	return A2($NoRedInk$elm_sortable_table$Table$State, header, false);
};
var $author$project$Element$GradesOverview$quote = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Encode$string,
	$elm$json$Json$Encode$encode(0));
var $author$project$GradeReport$termFieldDelimiter = ';';
var $author$project$GradeReport$reportTermDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (term_) {
		var _v0 = A2($elm$core$String$split, $author$project$GradeReport$termFieldDelimiter, term_);
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var startYear = _v0.a;
			var _v1 = _v0.b;
			var endYear = _v1.a;
			var _v2 = _v1.b;
			var type_ = _v2.a;
			var _v3 = _Utils_Tuple3(
				$elm$core$String$toInt(startYear),
				$elm$core$String$toInt(endYear),
				type_);
			_v3$3:
			while (true) {
				if ((!_v3.a.$) && (!_v3.b.$)) {
					switch (_v3.c) {
						case 'mid':
							var startYear_ = _v3.a.a;
							var endYear_ = _v3.b.a;
							return $elm$json$Json$Decode$succeed(
								{dH: endYear_, d9: startYear_, hH: 0});
						case 'end':
							var startYear_ = _v3.a.a;
							var endYear_ = _v3.b.a;
							return $elm$json$Json$Decode$succeed(
								{dH: endYear_, d9: startYear_, hH: 1});
						case 'exam':
							var startYear_ = _v3.a.a;
							var endYear_ = _v3.b.a;
							return $elm$json$Json$Decode$succeed(
								{dH: endYear_, d9: startYear_, hH: 2});
						default:
							break _v3$3;
					}
				} else {
					break _v3$3;
				}
			}
			return $elm$json$Json$Decode$fail('Unknown report term: ' + term_);
		} else {
			return $elm$json$Json$Decode$fail('Unknown report term: ' + term_);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Element$GradesOverview$queryToFilter = function (query) {
	var _v0 = _Utils_Tuple2(
		query.bp,
		A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Element$GradesOverview$quote,
				$elm$json$Json$Decode$decodeString($author$project$GradeReport$reportTermDecoder)),
			query.jH));
	if (!_v0.a.$) {
		if ((!_v0.b.$) && (!_v0.b.a.$)) {
			var schoolId = _v0.a.a;
			var reportTerm = _v0.b.a.a;
			return $elm$core$Maybe$Just(
				{
					bV: $elm$core$Maybe$Just(reportTerm),
					bp: schoolId,
					bI: query.gk
				});
		} else {
			var schoolId = _v0.a.a;
			return $elm$core$Maybe$Just(
				{bV: $elm$core$Maybe$Nothing, bp: schoolId, bI: query.gk});
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$GradesOverview$init = F3(
	function (config, session, query) {
		var t_ = session.hy;
		var viewer = session.nH;
		var model = {
			bN: config,
			bO: $author$project$Element$GradesOverview$queryToFilter(query),
			dN: $author$project$RemoteData$NotAsked,
			jr: $author$project$RemoteData$NotAsked,
			ga: $NoRedInk$elm_sortable_table$Table$initialSort(
				t_($author$project$Locale$Messages$GradesOverviewStudent))
		};
		var _v0 = _Utils_Tuple2(
			model.bO,
			$author$project$Element$GradesOverview$defaultTeamId(viewer));
		if (!_v0.a.$) {
			var filter = _v0.a.a;
			return A2(
				$author$project$Element$GradesOverview$andFetchGradeReports,
				filter.bp,
				$author$project$Element$GradesOverview$andFetchSchools(
					A2($author$project$Application$Boundaries$save, model, session)));
		} else {
			if (!_v0.b.$) {
				var _v1 = _v0.a;
				var teamId = _v0.b.a;
				return A2(
					$author$project$Element$GradesOverview$andFetchGradeReports,
					teamId,
					$author$project$Element$GradesOverview$andFetchSchools(
						A2($author$project$Application$Boundaries$save, model, session)));
			} else {
				return A2($author$project$Application$Boundaries$save, model, session);
			}
		}
	});
var $author$project$Element$GradesOverview$NoOp = {$: 6};
var $author$project$Locale$Messages$TeamListDownloadError = {$: 627};
var $author$project$GradeReport$term = function (gradeReport) {
	var startYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(gradeReport.hv));
	var endYear = A2(
		$elm$time$Time$toYear,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(gradeReport.gH));
	return {dH: endYear, d9: startYear, hH: gradeReport.hH};
};
var $author$project$GradeReport$compareTerm = F2(
	function (gradeReport1, gradeReport2) {
		var term2 = $author$project$GradeReport$term(gradeReport2);
		var term1 = $author$project$GradeReport$term(gradeReport1);
		if (_Utils_cmp(term1.dH, term2.dH) < 0) {
			return 0;
		} else {
			if (_Utils_eq(term1.dH, term2.dH)) {
				var _v0 = _Utils_Tuple2(term1.hH, term2.hH);
				_v0$3:
				while (true) {
					switch (_v0.a) {
						case 1:
							if (_v0.b === 1) {
								var _v1 = _v0.a;
								var _v2 = _v0.b;
								return 1;
							} else {
								var _v8 = _v0.a;
								return 2;
							}
						case 0:
							switch (_v0.b) {
								case 0:
									var _v3 = _v0.a;
									var _v4 = _v0.b;
									return 1;
								case 1:
									break _v0$3;
								default:
									var _v9 = _v0.a;
									var _v10 = _v0.b;
									return 2;
							}
						default:
							switch (_v0.b) {
								case 2:
									var _v5 = _v0.a;
									var _v6 = _v0.b;
									return 1;
								case 1:
									break _v0$3;
								default:
									var _v11 = _v0.a;
									var _v12 = _v0.b;
									return 0;
							}
					}
				}
				var _v7 = _v0.b;
				return 0;
			} else {
				return 2;
			}
		}
	});
var $author$project$Element$GradesOverview$availableReportTerms = function (gradeReports) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			$author$project$GradeReport$term,
			A2($elm$core$List$sortWith, $author$project$GradeReport$compareTerm, gradeReports)));
};
var $author$project$Element$GradesOverview$availableSchoolYearsByGradeReports = function (gradeReports) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.gO;
			},
			gradeReports));
};
var $author$project$Person$teams = function (person) {
	var _v0 = person.c6;
	var roles = _v0;
	return $author$project$Util$List$unique(
		A2($elm$core$List$map, $elm$core$Tuple$second, roles));
};
var $author$project$Person$isMemberOf = F2(
	function (teamId, person) {
		return A2(
			$elm$core$List$member,
			teamId,
			$author$project$Person$teams(person));
	});
var $author$project$Person$filterPersonTeams = F2(
	function (teams_, person) {
		return A2(
			$elm$core$List$filter,
			function (team) {
				return A2($author$project$Person$isMemberOf, team.gT, person);
			},
			teams_);
	});
var $author$project$Log$msgTeamsDownload = 'teams_download';
var $author$project$Log$paramScopeGrades = 'scope_grades';
var $author$project$GradeReport$encodeReportTerm = function (_v0) {
	var startYear = _v0.d9;
	var endYear = _v0.dH;
	var type_ = _v0.hH;
	var encodedType = function () {
		switch (type_) {
			case 0:
				return 'mid';
			case 1:
				return 'end';
			default:
				return 'exam';
		}
	}();
	return A2(
		$elm$core$String$join,
		$author$project$GradeReport$termFieldDelimiter,
		_List_fromArray(
			[
				$elm$core$String$fromInt(startYear),
				$elm$core$String$fromInt(endYear),
				encodedType
			]));
};
var $author$project$Element$GradesOverview$filterToQuery = function (filter) {
	var blankQuery = $author$project$Route$blankGradesListQuery;
	var _v0 = filter.bV;
	if (!_v0.$) {
		var reportTerm = _v0.a;
		return {
			bp: $elm$core$Maybe$Just(
				$author$project$Team$teamIdToInt(filter.bp)),
			jH: $elm$core$Maybe$Just(
				$author$project$GradeReport$encodeReportTerm(reportTerm)),
			gk: filter.bI
		};
	} else {
		return _Utils_update(
			blankQuery,
			{
				bp: $elm$core$Maybe$Just(
					$author$project$Team$teamIdToInt(filter.bp)),
				gk: filter.bI
			});
	}
};
var $author$project$Element$GradesOverview$updateFilterUrl = F2(
	function (config, filter) {
		return A2(
			$author$project$Route$replaceUrl,
			config.iJ,
			$author$project$Route$GradesOverview(
				$author$project$Element$GradesOverview$filterToQuery(filter)));
	});
var $author$project$Element$GradesOverview$updateFilter = F3(
	function (updater, model, session) {
		var _v0 = model.bO;
		if (!_v0.$) {
			var filter_ = _v0.a;
			var newFilter = updater(filter_);
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				A2($author$project$Element$GradesOverview$updateFilterUrl, model.bN, newFilter),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bO: $elm$core$Maybe$Just(newFilter)
						}),
					session));
		} else {
			return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$GradesOverview$updateFilters = F5(
	function (resetFilters, defaultReportTerm, availableSchoolYears, session, model) {
		var viewer = session.nH;
		var _v0 = _Utils_Tuple2(model.bO, resetFilters);
		if (_v0.a.$ === 1) {
			var _v1 = _v0.a;
			var _v2 = $author$project$Element$GradesOverview$defaultTeamId(viewer);
			if (!_v2.$) {
				var teamId = _v2.a;
				var newFilter = {bV: defaultReportTerm, bp: teamId, bI: availableSchoolYears};
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A2($author$project$Element$GradesOverview$updateFilterUrl, model.bN, newFilter),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(newFilter)
							}),
						session));
			} else {
				return A2($author$project$Application$Boundaries$save, model, session);
			}
		} else {
			if (!_v0.b) {
				return A2($author$project$Application$Boundaries$save, model, session);
			} else {
				var filter_ = _v0.a.a;
				var newFilter = _Utils_update(
					filter_,
					{bV: defaultReportTerm, bI: availableSchoolYears});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A2($author$project$Element$GradesOverview$updateFilterUrl, model.bN, newFilter),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(newFilter)
							}),
						session));
			}
		}
	});
var $author$project$Element$GradesOverview$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var config = model.bN;
		switch (msg.$) {
			case 6:
				return A2($author$project$Application$Boundaries$save, model, session);
			case 0:
				if (!msg.b.$) {
					var resetFilters = msg.a;
					var gradeReports = msg.b.a;
					var model2 = _Utils_update(
						model,
						{
							dN: $author$project$RemoteData$Success(gradeReports)
						});
					var defaultReportTerm = $elm$core$List$head(
						$author$project$Element$GradesOverview$availableReportTerms(gradeReports));
					var availableSchoolYears = $author$project$Element$GradesOverview$availableSchoolYearsByGradeReports(gradeReports);
					return A5($author$project$Element$GradesOverview$updateFilters, resetFilters, defaultReportTerm, availableSchoolYears, session, model2);
				} else {
					var error = msg.b.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgGradeReportsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeGrades),
								error),
							$elm$core$Basics$always($author$project$Element$GradesOverview$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$GradeReportsDownloadError))));
				}
			case 1:
				var data = msg.a;
				switch (data.$) {
					case 2:
						var schools = data.a;
						var viewerSchools = A2($author$project$Person$filterPersonTeams, schools, viewer);
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									jr: $author$project$RemoteData$Success(viewerSchools)
								}),
							session);
					case 3:
						var error = data.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgTeamsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeGrades),
									error),
								$elm$core$Basics$always($author$project$Element$GradesOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										jr: $author$project$RemoteData$Failure(error)
									}),
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$TeamListDownloadError))));
					default:
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 2:
				var newState = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{ga: newState}),
					session);
			case 4:
				var value = msg.a;
				var loadReportsForSchool = function (schoolId) {
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$GradeReport$fetchGradeReportsByTeam,
							config.gr,
							schoolId,
							$author$project$Element$GradesOverview$GradeReportListDownloaded(true)),
						A3(
							$author$project$Element$GradesOverview$updateFilter,
							function (filter_) {
								return _Utils_update(
									filter_,
									{bp: schoolId});
							},
							_Utils_update(
								model,
								{dN: $author$project$RemoteData$Loading}),
							session));
				};
				var _v2 = A2($elm$json$Json$Decode$decodeString, $author$project$Team$teamIdDecoder, value);
				if (!_v2.$) {
					var schoolId = _v2.a;
					return loadReportsForSchool(schoolId);
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 3:
				var value = msg.a;
				var _v3 = A2(
					$elm$json$Json$Decode$decodeString,
					$author$project$GradeReport$reportTermDecoder,
					$author$project$Element$GradesOverview$quote(value));
				if (!_v3.$) {
					var reportTerm = _v3.a;
					return A3(
						$author$project$Element$GradesOverview$updateFilter,
						function (filter_) {
							return _Utils_update(
								filter_,
								{
									bV: $elm$core$Maybe$Just(reportTerm)
								});
						},
						model,
						session);
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			default:
				var values = msg.a;
				return A3(
					$author$project$Element$GradesOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{
								bI: A2($elm$core$List$filterMap, $elm$core$String$toInt, values)
							});
					},
					model,
					session);
		}
	});
var $author$project$Locale$Messages$GradesOverviewLoadingProgress = {$: 114};
var $author$project$Locale$Messages$GradesOverviewNoStudents = {$: 120};
var $author$project$Locale$Messages$GradesOverviewTitle = {$: 113};
var $author$project$Element$GradesOverview$filterGradeReports = F2(
	function (filter, gradeReports) {
		return A2(
			$elm$core$List$filter,
			function (gr) {
				var matchesSchoolYear = A2($elm$core$List$member, gr.gO, filter.bI);
				var matchesReportTerm = _Utils_eq(
					$elm$core$Maybe$Just(
						$author$project$GradeReport$term(gr)),
					filter.bV);
				return matchesSchoolYear && matchesReportTerm;
			},
			gradeReports);
	});
var $author$project$Locale$Messages$GradesOverviewNoReports = {$: 119};
var $author$project$Locale$Messages$GradesOverviewSchoolYear = {$: 116};
var $author$project$Element$GradesOverview$SetTableState = function (a) {
	return {$: 2, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Config = $elm$core$Basics$identity;
var $NoRedInk$elm_sortable_table$Table$customConfig = function (_v0) {
	var toId = _v0.nt;
	var toMsg = _v0.bZ;
	var columns = _v0.kB;
	var customizations = _v0.kI;
	return {
		kB: A2(
			$elm$core$List$map,
			function (_v1) {
				var cData = _v1;
				return cData;
			},
			columns),
		kI: customizations,
		nt: toId,
		bZ: toMsg
	};
};
var $NoRedInk$elm_sortable_table$Table$simpleRowAttrs = function (_v0) {
	return _List_Nil;
};
var $NoRedInk$elm_sortable_table$Table$HtmlDetails = F2(
	function (attributes, children) {
		return {eq: attributes, eu: children};
	});
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $NoRedInk$elm_sortable_table$Table$darkGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#555')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' ' + symbol)
			]));
};
var $NoRedInk$elm_sortable_table$Table$lightGrey = function (symbol) {
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'color', '#ccc')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(' ' + symbol)
			]));
};
var $NoRedInk$elm_sortable_table$Table$simpleTheadHelp = function (_v0) {
	var name = _v0.a;
	var status = _v0.b;
	var onClick_ = _v0.c;
	var content = function () {
		switch (status.$) {
			case 0:
				return _List_fromArray(
					[
						$elm$html$Html$text(name)
					]);
			case 1:
				var selected = status.a;
				return _List_fromArray(
					[
						$elm$html$Html$text(name),
						selected ? $NoRedInk$elm_sortable_table$Table$darkGrey('↓') : $NoRedInk$elm_sortable_table$Table$lightGrey('↓')
					]);
			default:
				if (status.a.$ === 1) {
					var _v2 = status.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$NoRedInk$elm_sortable_table$Table$lightGrey('↕')
						]);
				} else {
					var isReversed = status.a.a;
					return _List_fromArray(
						[
							$elm$html$Html$text(name),
							$NoRedInk$elm_sortable_table$Table$darkGrey(
							isReversed ? '↑' : '↓')
						]);
				}
		}
	}();
	return A2(
		$elm$html$Html$th,
		_List_fromArray(
			[onClick_]),
		content);
};
var $NoRedInk$elm_sortable_table$Table$simpleThead = function (headers) {
	return A2(
		$NoRedInk$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		A2($elm$core$List$map, $NoRedInk$elm_sortable_table$Table$simpleTheadHelp, headers));
};
var $NoRedInk$elm_sortable_table$Table$defaultCustomizations = {gw: $elm$core$Maybe$Nothing, hk: $NoRedInk$elm_sortable_table$Table$simpleRowAttrs, ni: _List_Nil, hA: _List_Nil, hD: $elm$core$Maybe$Nothing, np: $NoRedInk$elm_sortable_table$Table$simpleThead};
var $author$project$Element$GradesOverview$Exempted = {$: 1};
var $author$project$Element$GradesOverview$Grade = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$GradesOverview$NotApplicable = {$: 2};
var $author$project$Element$GradesOverview$getGradeBySubject = F2(
	function (targetSubject, gr) {
		var getGradeHelp = F2(
			function (subject, acc) {
				return _Utils_eq(subject.e2, targetSubject) ? $author$project$Element$GradesOverview$Grade(subject.iQ) : acc;
			});
		return A2($elm$core$List$member, targetSubject, gr.lk) ? $author$project$Element$GradesOverview$Exempted : A3($elm$core$List$foldl, getGradeHelp, $author$project$Element$GradesOverview$NotApplicable, gr.jB);
	});
var $NoRedInk$elm_sortable_table$Table$IncOrDec = function (a) {
	return {$: 3, a: a};
};
var $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy = function (toComparable) {
	return $NoRedInk$elm_sortable_table$Table$IncOrDec(
		$elm$core$List$sortBy(toComparable));
};
var $NoRedInk$elm_sortable_table$Table$Column = $elm$core$Basics$identity;
var $NoRedInk$elm_sortable_table$Table$veryCustomColumn = $elm$core$Basics$identity;
var $author$project$UI$Table$htmlColumn = F3(
	function (name, toComparable, toHtml) {
		return $NoRedInk$elm_sortable_table$Table$veryCustomColumn(
			{
				ha: name,
				m6: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toComparable),
				nF: function (content) {
					return A2(
						$NoRedInk$elm_sortable_table$Table$HtmlDetails,
						_List_Nil,
						_List_fromArray(
							[
								toHtml(content)
							]));
				}
			});
	});
var $NoRedInk$elm_sortable_table$Table$textDetails = function (str) {
	return A2(
		$NoRedInk$elm_sortable_table$Table$HtmlDetails,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(str)
			]));
};
var $NoRedInk$elm_sortable_table$Table$intColumn = F2(
	function (name, toInt) {
		return {
			ha: name,
			m6: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toInt),
			nF: A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, $NoRedInk$elm_sortable_table$Table$textDetails, $elm$core$String$fromInt),
				toInt)
		};
	});
var $author$project$Element$GradesOverview$gradeToComparable = function (grade) {
	switch (grade.$) {
		case 0:
			var x = grade.a;
			return x;
		case 1:
			return 0;
		default:
			return -1;
	}
};
var $author$project$Locale$Messages$GradesOverviewExempted = {$: 112};
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $author$project$Element$GradesOverview$viewGradeText = F2(
	function (t_, grade) {
		switch (grade.$) {
			case 1:
				return A2(
					$NoRedInk$elm_sortable_table$Table$HtmlDetails,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$align('center')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewExempted)
						]));
			case 2:
				return A2($NoRedInk$elm_sortable_table$Table$HtmlDetails, _List_Nil, _List_Nil);
			default:
				if (grade.a === 1) {
					return A2(
						$NoRedInk$elm_sortable_table$Table$HtmlDetails,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$align('center'),
								$elm$html$Html$Attributes$class('is-warning')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(1))
							]));
				} else {
					var x = grade.a;
					return A2(
						$NoRedInk$elm_sortable_table$Table$HtmlDetails,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$align('center')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(x))
							]));
				}
		}
	});
var $author$project$Element$GradesOverview$viewGradeColumn = F3(
	function (t_, subject, toGrade) {
		return $NoRedInk$elm_sortable_table$Table$veryCustomColumn(
			{
				ha: subject.ha,
				m6: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(
					A2($elm$core$Basics$composeR, toGrade, $author$project$Element$GradesOverview$gradeToComparable)),
				nF: function (gradeReport) {
					return A2(
						$author$project$Element$GradesOverview$viewGradeText,
						t_,
						toGrade(gradeReport));
				}
			});
	});
var $author$project$UI$Table$theadCell = F3(
	function (status, attrs, heading) {
		var upIcon = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-sort-up'),
					$author$project$UI$Icon$style('has-text-link')
				]));
		var sortIcon = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-sort'),
					$author$project$UI$Icon$style('has-text-grey-light')
				]));
		var downIcon = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-sort-down'),
					$author$project$UI$Icon$style('has-text-link')
				]));
		var content = function () {
			switch (status.$) {
				case 1:
					var selected = status.a;
					return _List_fromArray(
						[
							heading,
							selected ? upIcon : downIcon
						]);
				case 2:
					if (status.a.$ === 1) {
						var _v1 = status.a;
						return _List_fromArray(
							[heading, sortIcon]);
					} else {
						var isReversed = status.a.a;
						return _List_fromArray(
							[
								heading,
								isReversed ? downIcon : upIcon
							]);
					}
				default:
					return _List_fromArray(
						[heading]);
			}
		}();
		return A2($elm$html$Html$th, attrs, content);
	});
var $author$project$Element$GradesOverview$viewTheadHelp = F2(
	function (hCols, _v0) {
		var name = _v0.a;
		var status = _v0.b;
		var onClick_ = _v0.c;
		var isVerticalHeading = !A2($elm$core$List$member, name, hCols);
		var heading = isVerticalHeading ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-vertical-heading')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(name)
						]))
				])) : A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
		return A3(
			$author$project$UI$Table$theadCell,
			status,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-vertical-bottom'),
					$elm$html$Html$Attributes$align('center'),
					onClick_
				]),
			heading);
	});
var $author$project$Element$GradesOverview$viewThead = F2(
	function (hCols, headers) {
		return A2(
			$NoRedInk$elm_sortable_table$Table$HtmlDetails,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Element$GradesOverview$viewTheadHelp(hCols),
				headers));
	});
var $author$project$Element$GradesOverview$tableViewConfig = F2(
	function (t_, subjects) {
		var viewStudentText = function (gr) {
			return A2($author$project$Person$fullName, t_, gr.ne);
		};
		var viewStudentLink = function (gr) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$GradeReportCard(gr.ne.gT))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						viewStudentText(gr))
					]));
		};
		var sortedSubjects = A2(
			$author$project$Util$List$sortBy,
			function ($) {
				return $.ha;
			},
			subjects);
		var horizontalCols = _List_fromArray(
			[
				t_($author$project$Locale$Messages$GradesOverviewStudent)
			]);
		var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
		return $NoRedInk$elm_sortable_table$Table$customConfig(
			{
				kB: _Utils_ap(
					_List_fromArray(
						[
							A3(
							$author$project$UI$Table$htmlColumn,
							t_($author$project$Locale$Messages$GradesOverviewStudent),
							viewStudentText,
							viewStudentLink),
							A2(
							$NoRedInk$elm_sortable_table$Table$intColumn,
							t_($author$project$Locale$Messages$GradesOverviewSchoolYear),
							function ($) {
								return $.gO;
							})
						]),
					A2(
						$elm$core$List$map,
						function (subject) {
							return A3(
								$author$project$Element$GradesOverview$viewGradeColumn,
								t_,
								subject,
								$author$project$Element$GradesOverview$getGradeBySubject(subject));
						},
						sortedSubjects)),
				kI: _Utils_update(
					customizations,
					{
						ni: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped ')
							]),
						np: $author$project$Element$GradesOverview$viewThead(horizontalCols)
					}),
				nt: A2(
					$elm$core$Basics$composeL,
					$elm$core$String$fromInt,
					function ($) {
						return $.gT;
					}),
				bZ: $author$project$Element$GradesOverview$SetTableState
			});
	});
var $elm$html$Html$caption = _VirtualDom_node('caption');
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $NoRedInk$elm_sortable_table$Table$applySorter = F3(
	function (isReversed, sorter, data) {
		switch (sorter.$) {
			case 0:
				return data;
			case 1:
				var sort_ = sorter.a;
				return sort_(data);
			case 2:
				var sort_ = sorter.a;
				return $elm$core$List$reverse(
					sort_(data));
			case 3:
				var sort_ = sorter.a;
				return isReversed ? $elm$core$List$reverse(
					sort_(data)) : sort_(data);
			default:
				var sort_ = sorter.a;
				return isReversed ? sort_(data) : $elm$core$List$reverse(
					sort_(data));
		}
	});
var $NoRedInk$elm_sortable_table$Table$findSorter = F2(
	function (selectedColumn, columnData) {
		findSorter:
		while (true) {
			if (!columnData.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var name = columnData.a.ha;
				var sorter = columnData.a.m6;
				var remainingColumnData = columnData.b;
				if (_Utils_eq(name, selectedColumn)) {
					return $elm$core$Maybe$Just(sorter);
				} else {
					var $temp$selectedColumn = selectedColumn,
						$temp$columnData = remainingColumnData;
					selectedColumn = $temp$selectedColumn;
					columnData = $temp$columnData;
					continue findSorter;
				}
			}
		}
	});
var $NoRedInk$elm_sortable_table$Table$sort = F3(
	function (_v0, columnData, data) {
		var selectedColumn = _v0.a;
		var isReversed = _v0.b;
		var _v1 = A2($NoRedInk$elm_sortable_table$Table$findSorter, selectedColumn, columnData);
		if (_v1.$ === 1) {
			return data;
		} else {
			var sorter = _v1.a;
			return A3($NoRedInk$elm_sortable_table$Table$applySorter, isReversed, sorter, data);
		}
	});
var $elm$html$Html$tfoot = _VirtualDom_node('tfoot');
var $NoRedInk$elm_sortable_table$Table$Reversible = function (a) {
	return {$: 2, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Sortable = function (a) {
	return {$: 1, a: a};
};
var $NoRedInk$elm_sortable_table$Table$Unsortable = {$: 0};
var $NoRedInk$elm_sortable_table$Table$onClick = F3(
	function (name, isReversed, toMsg) {
		return A2(
			$elm$html$Html$Events$on,
			'click',
			A2(
				$elm$json$Json$Decode$map,
				toMsg,
				A3(
					$elm$json$Json$Decode$map2,
					$NoRedInk$elm_sortable_table$Table$State,
					$elm$json$Json$Decode$succeed(name),
					$elm$json$Json$Decode$succeed(isReversed))));
	});
var $NoRedInk$elm_sortable_table$Table$toHeaderInfo = F3(
	function (_v0, toMsg, _v1) {
		var sortName = _v0.a;
		var isReversed = _v0.b;
		var name = _v1.ha;
		var sorter = _v1.m6;
		switch (sorter.$) {
			case 0:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Unsortable,
					A3($NoRedInk$elm_sortable_table$Table$onClick, sortName, isReversed, toMsg));
			case 1:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Sortable(
						_Utils_eq(name, sortName)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 2:
				return _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Sortable(
						_Utils_eq(name, sortName)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			case 3:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(isReversed)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
			default:
				return _Utils_eq(name, sortName) ? _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible(
						$elm$core$Maybe$Just(isReversed)),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, !isReversed, toMsg)) : _Utils_Tuple3(
					name,
					$NoRedInk$elm_sortable_table$Table$Reversible($elm$core$Maybe$Nothing),
					A3($NoRedInk$elm_sortable_table$Table$onClick, name, false, toMsg));
		}
	});
var $elm$virtual_dom$VirtualDom$lazy3 = _VirtualDom_lazy3;
var $elm$html$Html$Lazy$lazy3 = $elm$virtual_dom$VirtualDom$lazy3;
var $NoRedInk$elm_sortable_table$Table$viewCell = F2(
	function (data, _v0) {
		var viewData = _v0.nF;
		var details = viewData(data);
		return A2($elm$html$Html$td, details.eq, details.eu);
	});
var $NoRedInk$elm_sortable_table$Table$viewRowHelp = F3(
	function (columns, toRowAttrs, data) {
		return A2(
			$elm$html$Html$tr,
			toRowAttrs(data),
			A2(
				$elm$core$List$map,
				$NoRedInk$elm_sortable_table$Table$viewCell(data),
				columns));
	});
var $NoRedInk$elm_sortable_table$Table$viewRow = F4(
	function (toId, columns, toRowAttrs, data) {
		return _Utils_Tuple2(
			toId(data),
			A4($elm$html$Html$Lazy$lazy3, $NoRedInk$elm_sortable_table$Table$viewRowHelp, columns, toRowAttrs, data));
	});
var $NoRedInk$elm_sortable_table$Table$view = F3(
	function (_v0, state, data) {
		var toId = _v0.nt;
		var toMsg = _v0.bZ;
		var columns = _v0.kB;
		var customizations = _v0.kI;
		var theadDetails = customizations.np(
			A2(
				$elm$core$List$map,
				A2($NoRedInk$elm_sortable_table$Table$toHeaderInfo, state, toMsg),
				columns));
		var thead = A2($elm$html$Html$thead, theadDetails.eq, theadDetails.eu);
		var sortedData = A3($NoRedInk$elm_sortable_table$Table$sort, state, columns, data);
		var tbody = A3(
			$elm$html$Html$Keyed$node,
			'tbody',
			customizations.hA,
			A2(
				$elm$core$List$map,
				A3($NoRedInk$elm_sortable_table$Table$viewRow, toId, columns, customizations.hk),
				sortedData));
		var withFoot = function () {
			var _v2 = customizations.hD;
			if (_v2.$ === 1) {
				return A2($elm$core$List$cons, tbody, _List_Nil);
			} else {
				var attributes = _v2.a.eq;
				var children = _v2.a.eu;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$tfoot, attributes, children),
					A2($elm$core$List$cons, tbody, _List_Nil));
			}
		}();
		return A2(
			$elm$html$Html$table,
			customizations.ni,
			function () {
				var _v1 = customizations.gw;
				if (_v1.$ === 1) {
					return A2($elm$core$List$cons, thead, withFoot);
				} else {
					var attributes = _v1.a.eq;
					var children = _v1.a.eu;
					return A2(
						$elm$core$List$cons,
						A2($elm$html$Html$caption, attributes, children),
						A2($elm$core$List$cons, thead, withFoot));
				}
			}());
	});
var $author$project$Element$GradesOverview$viewGradesTable = F3(
	function (t_, tableState, gradeReports) {
		var distinctSubjects = A3(
			$elm$core$List$foldl,
			F2(
				function (subject, acc) {
					return A2($elm$core$List$member, subject, acc) ? acc : A2($elm$core$List$cons, subject, acc);
				}),
			_List_Nil,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.e2;
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.jB;
					},
					gradeReports)));
		return $elm$core$List$isEmpty(gradeReports) ? $author$project$UI$notification(
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewNoReports)
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box')
				]),
			_List_fromArray(
				[
					A3(
					$NoRedInk$elm_sortable_table$Table$view,
					A2($author$project$Element$GradesOverview$tableViewConfig, t_, distinctSubjects),
					tableState,
					A2(
						$author$project$Util$List$sortBy,
						function (gr) {
							return A2($author$project$Person$fullName, t_, gr.ne);
						},
						gradeReports))
				]));
	});
var $author$project$Locale$Messages$GradesOverviewReportTerm = {$: 115};
var $author$project$Element$GradesOverview$SetReportTermFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$filterOptions = function (viewConfig) {
	var view = function (content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[viewConfig.gw])),
						content))
				]));
	};
	var _v0 = _Utils_Tuple2(viewConfig.mp, viewConfig.gQ);
	if (_v0.a.$ === 1) {
		var _v1 = _v0.a;
		return view(
			_List_fromArray(
				[
					$author$project$UI$Icon$loadingOptions(_List_Nil)
				]));
	} else {
		if (!_v0.a.a.b) {
			return $author$project$UI$none;
		} else {
			if ((!_v0.a.a.b.b) && _v0.b) {
				var _v2 = _v0.a.a;
				return $author$project$UI$none;
			} else {
				var lst = _v0.a.a;
				return view(
					viewConfig.hJ(lst));
			}
		}
	}
};
var $author$project$UI$radioButton = F4(
	function (toMsg, dataTag, selectedValue, option) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('radio')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									toMsg(option.nD)),
									$elm$html$Html$Attributes$type_('radio'),
									$elm$html$Html$Attributes$name(dataTag),
									$author$project$UI$attrCyData(dataTag),
									$elm$html$Html$Attributes$checked(
									_Utils_eq(selectedValue, option.nD))
								]),
							_List_Nil),
							$elm$html$Html$text(' '),
							$elm$html$Html$text(option.lO)
						]))
				]));
	});
var $author$project$GradeReport$termCaption = function (_v0) {
	var startYear = _v0.d9;
	var endYear = _v0.dH;
	var type_ = _v0.hH;
	switch (type_) {
		case 0:
			return A2($author$project$Locale$Messages$GradeReportCardTabMidYear, startYear, endYear);
		case 1:
			return A2($author$project$Locale$Messages$GradeReportCardTabEndOfYear, startYear, endYear);
		default:
			return A2($author$project$Locale$Messages$GradeReportCardTabGradingExam, startYear, endYear);
	}
};
var $author$project$Element$GradesOverview$reportTermChoices = F2(
	function (t_, gradeReports) {
		return A2(
			$elm$core$List$map,
			function (term) {
				return _Utils_Tuple2(
					$author$project$GradeReport$encodeReportTerm(term),
					t_(
						$author$project$GradeReport$termCaption(term)));
			},
			$author$project$Element$GradesOverview$availableReportTerms(gradeReports));
	});
var $author$project$Element$GradesOverview$viewReportTermFilter = F3(
	function (t_, gradeReports, reportTerm) {
		var selectedTypeValue = $author$project$GradeReport$encodeReportTerm(reportTerm);
		var viewReportTermOptions = function (types) {
			return A2(
				$elm$core$List$map,
				A3($author$project$UI$radioButton, $author$project$Element$GradesOverview$SetReportTermFilter, 'grades-filter-reporttype', selectedTypeValue),
				$author$project$Form$toSortedSelectOptions(types));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewReportTerm),
				gQ: false,
				mp: $elm$core$Maybe$Just(
					A2($author$project$Element$GradesOverview$reportTermChoices, t_, gradeReports)),
				hJ: viewReportTermOptions
			});
	});
var $author$project$Element$GradesOverview$SetSchoolYearFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$GradesOverview$schoolYearChoices = function (gradeReports) {
	return A2(
		$elm$core$List$map,
		function (yr) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(yr),
				$elm$core$String$fromInt(yr));
		},
		$author$project$Element$GradesOverview$availableSchoolYearsByGradeReports(gradeReports));
};
var $author$project$Element$GradesOverview$viewSchoolYearFilter = F3(
	function (t_, gradeReports, schoolYears) {
		var viewSchoolYearOptions = function (years) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$GradesOverview$SetSchoolYearFilter,
					'grades-filter-schoolyear',
					$elm$core$Basics$always(false),
					A2($elm$core$List$map, $elm$core$String$fromInt, schoolYears)),
				$author$project$Form$toSortedSelectOptions(years));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewSchoolYear),
				gQ: false,
				mp: $elm$core$Maybe$Just(
					$author$project$Element$GradesOverview$schoolYearChoices(gradeReports)),
				hJ: viewSchoolYearOptions
			});
	});
var $author$project$Locale$Messages$GradesOverviewSchool = {$: 117};
var $author$project$Element$GradesOverview$SetSchoolFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Team$encodeTeamId = A2($elm$core$Basics$composeR, $author$project$Team$teamIdToInt, $elm$core$String$fromInt);
var $author$project$Form$toTeamOptions = function (teams) {
	return A2(
		$elm$core$List$map,
		function (team) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$author$project$Team$encodeTeamId(team.gT),
					team.kP));
		},
		A2(
			$author$project$Util$List$sortBy,
			function ($) {
				return $.kP;
			},
			teams));
};
var $author$project$Element$GradesOverview$viewTeamFilter = F3(
	function (t_, maybeSchools, school) {
		var selectedSchoolValue = $elm$core$String$fromInt(
			$author$project$Team$teamIdToInt(school));
		var viewSchoolOptions = function (schools) {
			return A2(
				$elm$core$List$map,
				A3($author$project$UI$radioButton, $author$project$Element$GradesOverview$SetSchoolFilter, 'grades-filter-school', selectedSchoolValue),
				$author$project$Form$toTeamOptions(schools));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewSchool),
				gQ: false,
				mp: maybeSchools,
				hJ: viewSchoolOptions
			});
	});
var $author$project$Element$GradesOverview$view = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var tableState = model.ga;
		var schools = model.jr;
		var viewFilterPane = F2(
			function (gradeReports, _v3) {
				var school = _v3.bp;
				var schoolYears = _v3.bI;
				var reportTerm = _v3.bV;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container columns')
						]),
					function () {
						if (!reportTerm.$) {
							var reportTerm_ = reportTerm.a;
							return _List_fromArray(
								[
									A3(
									$author$project$Element$GradesOverview$viewTeamFilter,
									t_,
									$author$project$RemoteData$toMaybe(schools),
									school),
									A3($author$project$Element$GradesOverview$viewReportTermFilter, t_, gradeReports, reportTerm_),
									A3($author$project$Element$GradesOverview$viewSchoolYearFilter, t_, gradeReports, schoolYears)
								]);
						} else {
							return _List_fromArray(
								[
									A3(
									$author$project$Element$GradesOverview$viewTeamFilter,
									t_,
									$author$project$RemoteData$toMaybe(schools),
									school)
								]);
						}
					}());
			});
		var _v1 = _Utils_Tuple3(model.jr, model.dN, model.bO);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 2) {
				if (!_v1.a.a.b) {
					return $author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewNoStudents)
							]));
				} else {
					if ((_v1.b.$ === 2) && (!_v1.c.$)) {
						var gradeReports = _v1.b.a;
						var filter = _v1.c.a;
						return A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									$author$project$UI$title(
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewTitle)
										])),
									A2(viewFilterPane, gradeReports, filter),
									A3(
									$author$project$Element$GradesOverview$viewGradesTable,
									t_,
									tableState,
									A2($author$project$Element$GradesOverview$filterGradeReports, filter, gradeReports))
								]));
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return A2(
			$author$project$UI$progressBar,
			'is-info',
			t_($author$project$Locale$Messages$GradesOverviewLoadingProgress));
	});
var $author$project$Element$GradesOverview$element = {iA: $author$project$Element$GradesOverview$init, jR: $author$project$Element$GradesOverview$update, nE: $author$project$Element$GradesOverview$view};
var $author$project$Element$HomePage$ActivityLogListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$HomePage$StudentsDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$HomePage$TimeIsNow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Endpoint$activeAndFutureStudents = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'students']),
		_List_fromArray(
			[
				_Utils_Tuple2('state', 'active_and_future')
			]));
};
var $author$project$Student$Student = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (mentor) {
						return function (mentorMemoUrl) {
							return function (sponsoredBy) {
								return function (activeLearningContract) {
									return function (currentSchoolYear) {
										return function (roles) {
											return {j9: activeLearningContract, id: currentSchoolYear, K: email, k3: firstName, gT: id, ak: lastName, l_: mentor, l$: mentorMemoUrl, aQ: phoneNumber, c6: roles, m9: sponsoredBy};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$LearningContract$LearningContract = F7(
	function (id, student, url, startDate, endDate, isActive, mentor) {
		return {gH: endDate, gT: id, lo: isActive, l_: mentor, hv: startDate, ne: student, G: url};
	});
var $author$project$LearningContract$LearningContractId = $elm$core$Basics$identity;
var $author$project$LearningContract$learningContractIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$LearningContract$learningContractDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_active',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_date',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_date',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'student',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'id',
							$author$project$LearningContract$learningContractIdDecoder,
							$elm$json$Json$Decode$succeed($author$project$LearningContract$LearningContract))))))));
var $author$project$Student$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'roles',
	$author$project$Person$rolesDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'current_school_year',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'active_learning_contract',
			$elm$json$Json$Decode$nullable($author$project$LearningContract$learningContractDecoder),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'sponsored_by',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mentor_memo_url',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mentor',
						$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'phone_number',
							$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'email',
								$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'last_name',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'first_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$elm$json$Json$Decode$int,
											$elm$json$Json$Decode$succeed($author$project$Student$Student))))))))))));
var $author$project$Student$studentsDecoder = $elm$json$Json$Decode$list($author$project$Student$studentDecoder);
var $author$project$Student$fetchActiveAndFutureStudents = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$activeAndFutureStudents(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Student$studentsDecoder));
	});
var $author$project$Api$Endpoint$activityLogs = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'activity-logs']),
		_List_Nil);
};
var $author$project$ActivityLog$PortfoliosActivity = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$ActivityLog$SimpleActivity = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ActivityType$LearningContract = 0;
var $author$project$ActivityType$MentorMemo = 1;
var $author$project$ActivityType$Portfolio = 2;
var $author$project$ActivityType$Profile = 3;
var $author$project$ActivityType$UnknownActivityType = 4;
var $author$project$ActivityType$toActivityType = function (type_) {
	switch (type_) {
		case 'learning_contract':
			return 0;
		case 'mentor_memo':
			return 1;
		case 'portfolio':
			return 2;
		case 'profile':
			return 3;
		default:
			return 4;
	}
};
var $author$project$ActivityLog$activityTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$ActivityType$toActivityType, $elm$json$Json$Decode$string);
var $author$project$ActivityLog$Message = F5(
	function (message_type, happened_at, activity_type, person, object_url) {
		return {ka: activity_type, ld: happened_at, l0: message_type, mi: object_url, mx: person};
	});
var $author$project$MessageType$LearningContractCreated = 0;
var $author$project$MessageType$LearningContractUpdated = 1;
var $author$project$MessageType$MentorMemoUpdated = 2;
var $author$project$MessageType$ModuleTeacherProfileUpdated = 3;
var $author$project$MessageType$PortfolioStoryCreated = 4;
var $author$project$MessageType$PortfolioStoryUpdated = 5;
var $author$project$MessageType$ProfileUpdated = 6;
var $author$project$MessageType$StudentProfileUpdated = 7;
var $author$project$MessageType$TeacherProfileUpdated = 8;
var $author$project$MessageType$UnknownMessageType = 9;
var $author$project$MessageType$toMessageType = function (type_) {
	switch (type_) {
		case 'learning_contract_created':
			return 0;
		case 'learning_contract_updated':
			return 1;
		case 'module_teacher_profile_updated':
			return 3;
		case 'portfolio_story_created':
			return 4;
		case 'portfolio_story_updated':
			return 5;
		case 'mentor_memo_updated':
			return 2;
		case 'profile_updated':
			return 6;
		case 'student_profile_updated':
			return 7;
		case 'teacher_profile_updated':
			return 8;
		default:
			return 9;
	}
};
var $author$project$ActivityLog$messageTypeDecoder = A2($elm$json$Json$Decode$map, $author$project$MessageType$toMessageType, $elm$json$Json$Decode$string);
var $author$project$ActivityLog$messageDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'object_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'person',
		$author$project$Person$nestedPersonDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'activity_type',
			$author$project$ActivityLog$activityTypeDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'happened_at',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'message_type',
					$author$project$ActivityLog$messageTypeDecoder,
					$elm$json$Json$Decode$succeed($author$project$ActivityLog$Message))))));
var $author$project$ActivityLog$PortfolioStoryMessageContext = function (media) {
	return {lY: media};
};
var $author$project$ActivityLog$portfolioStoryMessageContextDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
	_List_fromArray(
		['extra', 'media']),
	$author$project$PortfolioStory$storyMediaDecoder,
	$elm$json$Json$Decode$succeed($author$project$ActivityLog$PortfolioStoryMessageContext));
var $author$project$ActivityLog$SimpleMessageContext = F3(
	function (from, to, extra) {
		return {kZ: extra, k4: from, nr: to};
	});
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$ActivityLog$simpleMessageContextDecoder = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'extra',
	$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
	$elm$core$Dict$empty,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'to',
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'from',
			$elm$json$Json$Decode$dict($elm$json$Json$Decode$string),
			$elm$core$Dict$empty,
			$elm$json$Json$Decode$succeed($author$project$ActivityLog$SimpleMessageContext))));
var $author$project$ActivityLog$activityLogDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (message) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (activityType) {
				if (activityType === 2) {
					return A2(
						$elm$json$Json$Decode$map,
						function (messageContext) {
							return A2($author$project$ActivityLog$PortfoliosActivity, message, messageContext);
						},
						A2($elm$json$Json$Decode$field, 'message_context', $author$project$ActivityLog$portfolioStoryMessageContextDecoder));
				} else {
					return A2(
						$elm$json$Json$Decode$map,
						function (messageContext) {
							return A2($author$project$ActivityLog$SimpleActivity, message, messageContext);
						},
						A2($elm$json$Json$Decode$field, 'message_context', $author$project$ActivityLog$simpleMessageContextDecoder));
				}
			},
			A2($elm$json$Json$Decode$field, 'activity_type', $author$project$ActivityLog$activityTypeDecoder));
	},
	$author$project$ActivityLog$messageDecoder);
var $author$project$ActivityLog$activityLogsDecoder = $elm$json$Json$Decode$list($author$project$ActivityLog$activityLogDecoder);
var $author$project$ActivityLog$fetchActivityLogs = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$activityLogs(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ActivityLog$activityLogsDecoder));
	});
var $author$project$Element$HomePage$hasPortfolioFeed = function (viewer) {
	return $author$project$Person$isActiveMember(viewer) && ($author$project$Person$isSponsor(viewer) && (!$author$project$ACL$isStaff(viewer)));
};
var $author$project$Application$V2$Boundaries$mapElement = F3(
	function (containerReturn, element, elementReturn) {
		return {
			dz: $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						containerReturn.dz,
						A2($elm$core$Platform$Cmd$map, element.bZ, elementReturn.dz)
					])),
			dY: A2(element.jS, containerReturn.dY, elementReturn.dY),
			fY: elementReturn.fY,
			cv: elementReturn.cv
		};
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Element$PortfolioList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$ClassroomCourseListDownloaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$FetchClassroomCourseList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioList$FetchModuleDropdownList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$FetchPortfolioStoryList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioList$FetchStudentsAndTeachersList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioList$LoadingStories = {$: 0};
var $author$project$Element$PortfolioList$ModuleListDownloaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$PortfolioList$NoEffect = {$: 0};
var $author$project$Element$PortfolioList$PeopleListDownloaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioList$PortfolioStoryListDownloaded = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioList$SubjectListDownloaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$PortfolioStory$defaultListPageSize = 20;
var $author$project$Api$Endpoint$categoryAll = '';
var $author$project$Api$Endpoint$categoryChildren = 'sponsored';
var $author$project$Api$Endpoint$categoryCreator = 'self';
var $author$project$Api$Endpoint$categorySchools = 'team';
var $author$project$Element$PortfolioList$listFilterToCategory = function (filter) {
	var _v0 = filter.bs;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		case 2:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return $author$project$Api$Endpoint$categoryChildren;
	}
};
var $author$project$Api$Endpoint$typeAll = '';
var $author$project$Api$Endpoint$typeFeedback = 'feedback';
var $author$project$Api$Endpoint$typeMClosure = 'mclosure';
var $author$project$Element$PortfolioList$listFilterToType = function (filter) {
	var _v0 = filter.hH;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$typeAll;
		case 1:
			return $author$project$Api$Endpoint$typeFeedback;
		default:
			return $author$project$Api$Endpoint$typeMClosure;
	}
};
var $author$project$Data$toMaybe = F2(
	function (isEmpty, value) {
		return isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
	});
var $author$project$Element$PortfolioList$asListParams = function (_v0) {
	var loading = _v0.cY;
	var filter = _v0.bO;
	var query = _v0.bw;
	return {
		bs: $author$project$Element$PortfolioList$listFilterToCategory(filter),
		gx: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.gx),
		gG: filter.gG,
		cS: function () {
			if (loading.$ === 1) {
				var story = loading.a;
				return $elm$core$Maybe$Just(story.gT);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}(),
		g9: A2(
			$author$project$Data$toMaybe,
			$elm$core$List$isEmpty,
			A2($elm$core$List$map, $author$project$Module$moduleIdToInt, filter.g9)),
		bw: query,
		de: $author$project$PortfolioStory$defaultListPageSize,
		hu: filter.hu,
		e1: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.e1),
		e5: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.e5),
		hH: $author$project$Element$PortfolioList$listFilterToType(filter)
	};
};
var $author$project$ACL$canViewClassrooms = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$PortfolioList$TypeAll = 0;
var $author$project$Element$PortfolioList$TypeFeedback = 1;
var $author$project$Element$PortfolioList$FilterAll = 0;
var $author$project$Element$PortfolioList$emptyFilter = {bs: 0, gx: _List_Nil, gG: $elm$core$Maybe$Nothing, g9: _List_Nil, hu: $elm$core$Maybe$Nothing, e1: _List_Nil, e5: _List_Nil, hH: 0};
var $author$project$Element$PortfolioList$studentTypeToPeopleIds = F2(
	function (viewer, type_) {
		switch (type_.$) {
			case 0:
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.gT;
					},
					viewer.m8);
			case 2:
				return _List_Nil;
			default:
				var s = type_.a;
				return s;
		}
	});
var $author$project$Element$PortfolioList$defaultFilter = F2(
	function (viewer, params) {
		return _Utils_update(
			$author$project$Element$PortfolioList$emptyFilter,
			{
				gG: params.gG,
				g9: params.g9,
				hu: params.hu,
				e1: A2($author$project$Element$PortfolioList$studentTypeToPeopleIds, viewer, params.e1),
				hH: params.mn ? 1 : 0
			});
	});
var $author$project$Module$defaultListPageSize = 20;
var $author$project$Module$defaultListParams = {hR: false, bs: '', ie: false, iu: $elm$core$Maybe$Nothing, cS: $elm$core$Maybe$Nothing, l1: false, mw: _List_Nil, bw: '', jr: $elm$core$Maybe$Nothing, de: $author$project$Module$defaultListPageSize, jB: $elm$core$Maybe$Nothing, e5: $elm$core$Maybe$Nothing, jQ: true};
var $author$project$Module$ModuleDropdownItem = F6(
	function (id, title, team, accountableTeacher, teachers, students) {
		return {j3: accountableTeacher, gT: id, e1: students, e5: teachers, jF: team, jJ: title};
	});
var $author$project$Module$moduleDropdownItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'students',
	$author$project$Person$nestedPeopleDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'teachers',
		$author$project$Person$nestedPeopleDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'accountable_teacher',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'team',
				$author$project$Team$nestedTeamDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'title',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$Module$moduleIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$Module$ModuleDropdownItem)))))));
var $author$project$Module$moduleDropdownItemsDecoder = $elm$json$Json$Decode$list($author$project$Module$moduleDropdownItemDecoder);
var $author$project$Api$Endpoint$makeModulesQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('last_seen', params.cS),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('subjects', params.jB),
			A3(
				$author$project$Api$Endpoint$optionalList,
				$elm$core$String$fromInt,
				_Utils_Tuple2('schools', params.jr),
				A3(
					$author$project$Api$Endpoint$optionalList,
					$elm$core$String$fromInt,
					_Utils_Tuple2('teachers', params.e5),
					A3(
						$author$project$Api$Endpoint$optionalList,
						$elm$core$Basics$identity,
						_Utils_Tuple2('grades', params.iu),
						_List_fromArray(
							[
								_Utils_Tuple2(
								'size',
								$elm$core$String$fromInt(params.de)),
								_Utils_Tuple2(
								'include_inactive',
								$author$project$Api$Endpoint$stringFromBool(!params.hR)),
								_Utils_Tuple2(
								'include_locked',
								$author$project$Api$Endpoint$stringFromBool(!params.jQ)),
								_Utils_Tuple2(
								'include_before_current_school_year',
								$author$project$Api$Endpoint$stringFromBool(!params.ie)),
								_Utils_Tuple2('q', params.bw),
								_Utils_Tuple2('cat', params.bs)
							]))))));
};
var $author$project$Api$Endpoint$modulesForDropdown = F2(
	function (config, params) {
		var reducedFieldsParam = _Utils_Tuple2('fields', 'id,title,team,accountable_teacher,teachers,students');
		var queryParams = A2(
			$elm$core$List$cons,
			reducedFieldsParam,
			$author$project$Api$Endpoint$makeModulesQueryParams(params));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'modules']),
			queryParams);
	});
var $author$project$Module$fetchModulesForDropdown2 = F3(
	function (config, people, callback) {
		var listParams = _Utils_update(
			$author$project$Module$defaultListParams,
			{ie: true, mw: people, de: -1});
		return {
			bN: config,
			dC: $author$project$Module$moduleDropdownItemsDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$modulesForDropdown, config, listParams)
		};
	});
var $author$project$PortfolioStory$fetchStories2 = F3(
	function (config, params, callback) {
		return {
			bN: config,
			dC: $author$project$PortfolioStory$portfolioStoriesDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$portfolioStoriesList, config, params)
		};
	});
var $author$project$Api$Endpoint$peopleByRoles = F2(
	function (config, roles) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'people']),
			_List_fromArray(
				[
					_Utils_Tuple2('roles', roles)
				]));
	});
var $author$project$Api$Endpoint$peopleStudentsAndTeachers = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'teachers,module_teachers,students');
};
var $author$project$Person$phoneBookDecoder = $elm$json$Json$Decode$list($author$project$Person$personDecoder);
var $author$project$Person$fetchStudentsAndTeachers2 = F2(
	function (config, callback) {
		return {
			bN: config,
			dC: $author$project$Person$phoneBookDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$peopleStudentsAndTeachers(config)
		};
	});
var $author$project$Subject$fetchSubjectsV2 = F3(
	function (config, category, callback) {
		return {
			bN: config,
			dC: $author$project$Subject$subjectsDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$subjects, config, category)
		};
	});
var $author$project$Api$Endpoint$classrooms = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'classrooms']),
		_List_Nil);
};
var $author$project$ClassroomCourse$ClassroomCourse = F3(
	function (id, title, url) {
		return {gT: id, jJ: title, G: url};
	});
var $author$project$ClassroomCourse$classroomCourseDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$elm$json$Json$Decode$int,
			$elm$json$Json$Decode$succeed($author$project$ClassroomCourse$ClassroomCourse))));
var $author$project$ClassroomCourse$classroomsDecoder = $elm$json$Json$Decode$list($author$project$ClassroomCourse$classroomCourseDecoder);
var $author$project$ClassroomCourse$fetchUserClassrooms = F2(
	function (config, callback) {
		return {
			bN: config,
			dC: $author$project$ClassroomCourse$classroomsDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$classrooms(config)
		};
	});
var $author$project$Element$PortfolioList$init = F3(
	function (config, session, params) {
		var viewer = session.nH;
		var model = {
			bN: config,
			bO: A2($author$project$Element$PortfolioList$defaultFilter, viewer, params),
			eA: false,
			cY: $author$project$Element$PortfolioList$LoadingStories,
			bw: '',
			cv: session,
			cw: $elm$core$Dict$empty,
			bd: {gx: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing, mw: $elm$core$Maybe$Nothing},
			e$: _List_Nil,
			jB: $author$project$RemoteData$NotAsked
		};
		var listParams = $author$project$Element$PortfolioList$asListParams(model);
		var effects = $author$project$Element$PortfolioList$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchModuleDropdownList(
						A3(
							$author$project$Module$fetchModulesForDropdown2,
							config.gr,
							A2(
								$elm$core$List$cons,
								viewer.gT,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.gT;
									},
									viewer.m8)),
							$author$project$Element$PortfolioList$ModuleListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchPortfolioStoryList(
						A3($author$project$PortfolioStory$fetchStories2, config.gr, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchStudentsAndTeachersList(
						A2($author$project$Person$fetchStudentsAndTeachers2, config.gr, $author$project$Element$PortfolioList$PeopleListDownloaded))),
					$author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchSubjectList(
						A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$PortfolioList$SubjectListDownloaded))),
					$author$project$ACL$canViewClassrooms(session.nH) ? $author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchClassroomCourseList(
						A2($author$project$ClassroomCourse$fetchUserClassrooms, config.gr, $author$project$Element$PortfolioList$ClassroomCourseListDownloaded))) : $author$project$Element$PortfolioList$NoEffect
				]));
		return _Utils_Tuple3(model, effects, $elm$core$Maybe$Nothing);
	});
var $author$project$Util$Delay$after = F2(
	function (time, msg) {
		var delay = time * 1000;
		return A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(msg),
			$elm$core$Process$sleep(delay));
	});
var $author$project$Element$PortfolioList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$PortfolioList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Element$PortfolioSingle$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$FetchPortfolioStory = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FetchSubjectList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$NoEffect = {$: 0};
var $author$project$Element$PortfolioSingle$PortfolioStoryDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$SubjectListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Api$Endpoint$portfolioStory = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'portfolio-stories',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$PortfolioStory$fetchOneStory = F3(
	function (config, id, callback) {
		return {
			bN: config,
			dC: $author$project$PortfolioStory$portfolioStoryDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$portfolioStory, config, id)
		};
	});
var $author$project$Element$PortfolioSingle$init = F3(
	function (config, session, params) {
		var model = {bN: config, c3: $elm$core$Maybe$Nothing, cv: session, df: $author$project$RemoteData$NotAsked, jB: params.jB, nG: params.nG};
		var _v0 = params.nG;
		if (!_v0.$) {
			var storyId = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{df: $author$project$RemoteData$Loading}),
				$author$project$Element$PortfolioSingle$BatchEffect(
					_List_fromArray(
						[
							$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchPortfolioStory(
								A3($author$project$PortfolioStory$fetchOneStory, config.gr, storyId, $author$project$Element$PortfolioSingle$PortfolioStoryDownloaded))),
							$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$PortfolioSingle$SubjectListDownloaded)))
						])),
				$elm$core$Maybe$Nothing);
		} else {
			var story = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						df: $author$project$RemoteData$Success(story)
					}),
				$author$project$Element$PortfolioSingle$NoEffect,
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Api$resolveWithHeaders = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$author$project$Api$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($author$project$Api$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Api$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A3($author$project$Api$BadStatus, metadata.e_, metadata, body));
			default:
				var metadata = response.a;
				return A2(
					$elm$core$Result$mapError,
					$author$project$Api$BadBody,
					toResult(metadata));
		}
	});
var $author$project$Api$expectHeaders = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$author$project$Api$resolveWithHeaders($elm$core$Result$Ok));
};
var $author$project$Api$deleteV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var toMsg = _v0.bZ;
	return $author$project$Api$Endpoint$request(
		{
			O: $elm$http$Http$emptyBody,
			a4: $author$project$Api$expectHeaders(toMsg),
			ah: $author$project$Api$toHeaders(config),
			ba: 'DELETE',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $author$project$Element$PortfolioSingle$BadgeCreateEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeCreateModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeCreateMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeDeleteEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeDeleteModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$BadgeDeleteMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerModel = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$DocumentViewerMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackEffect = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$FeedbackMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$PopupEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$PopupMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteModel = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$StoryDeleteMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$BadgeDelete$NoEffect = 0;
var $author$project$Element$BadgeDelete$init = F3(
	function (config, session, badge) {
		return _Utils_Tuple3(
			{gt: badge, bN: config, cv: session},
			0,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$BadgeDelete$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$BadgeDelete$Exit = {$: 1};
var $author$project$Element$BadgeDelete$Ok = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$BadgeDelete$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just($author$project$Element$BadgeDelete$Exit));
		} else {
			var badge = msg.a;
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just(
					$author$project$Element$BadgeDelete$Ok(badge)));
		}
	});
var $author$project$Locale$Messages$BadgeDeleteHelp = {$: 22};
var $author$project$Locale$Messages$BadgeHeadingDelete = {$: 20};
var $author$project$Element$BadgeDelete$Confirmed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$BadgeDelete$Declined = {$: 0};
var $author$project$UI$confirmDialog = A2($author$project$UI$confirmDialog_, true, true);
var $author$project$Element$BadgeDelete$view = function (_v0) {
	var session = _v0.cv;
	var badge = _v0.gt;
	return A4(
		$author$project$UI$confirmDialog,
		session.hy,
		{
			kD: $author$project$Element$BadgeDelete$Confirmed(badge),
			kM: $author$project$Element$BadgeDelete$Declined
		},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$BadgeHeadingDelete)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$BadgeDeleteHelp)
					]))
			]));
};
var $author$project$Element$BadgeDelete$element = {iA: $author$project$Element$BadgeDelete$init, hh: $author$project$Element$BadgeDelete$perform, jR: $author$project$Element$BadgeDelete$update, nE: $author$project$Element$BadgeDelete$view};
var $author$project$Element$DocumentViewer$NoEffect = 0;
var $author$project$Element$DocumentViewer$init = F3(
	function (config, session, params) {
		var model = {bN: config, eM: params.eM, cv: session, G: params.G};
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$DocumentViewer$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$DocumentViewer$update = F2(
	function (_v0, model) {
		return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$DocumentViewer$Closed = 0;
var $author$project$UI$modalCloseButton = function (toMsg) {
	return A2(
		$elm$html$Html$button,
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'aria-label', 'close'),
				$elm$html$Html$Attributes$class('modal-close is-large'),
				$elm$html$Html$Events$onClick(toMsg)
			]),
		_List_Nil);
};
var $author$project$UI$modalWindow = F3(
	function (stretchContent, toCloseMsg, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('modal is-active')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-background')
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('modal-content'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2('is-fullwidth is-fullheight', stretchContent)
								]))
						]),
					_List_fromArray(
						[content])),
					$author$project$UI$modalCloseButton(toCloseMsg)
				]));
	});
var $author$project$Element$DocumentViewer$viewImage = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		false,
		0,
		A2(
			$elm$html$Html$p,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('image'),
					$author$project$UI$attrCyData('documentviewer-image')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$img,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$src(url)
						]),
					_List_Nil)
				])));
};
var $elm$html$Html$iframe = _VirtualDom_node('iframe');
var $author$project$Element$DocumentViewer$viewPdf = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		0,
		A2(
			$elm$html$Html$iframe,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth is-fullheight'),
					$author$project$UI$attrCyData('documentviewer-pdf'),
					$elm$html$Html$Attributes$src(url)
				]),
			_List_Nil));
};
var $elm$html$Html$Attributes$controls = $elm$html$Html$Attributes$boolProperty('controls');
var $elm$html$Html$video = _VirtualDom_node('video');
var $author$project$Element$DocumentViewer$viewVideo = function (url) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		0,
		A2(
			$elm$html$Html$video,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$src(url),
					$elm$html$Html$Attributes$controls(true),
					$author$project$UI$attrCyData('documentviewer-video')
				]),
			_List_Nil));
};
var $author$project$Element$DocumentViewer$view = function (_v0) {
	var url = _v0.G;
	var mime = _v0.eM;
	var _v1 = _Utils_Tuple2(
		mime,
		$author$project$Util$Media$mediaViewerByExt(url));
	_v1$6:
	while (true) {
		if (!_v1.a.$) {
			switch (_v1.a.a) {
				case 'application/pdf':
					return $author$project$Element$DocumentViewer$viewPdf(url);
				case 'image/png':
					return $author$project$Element$DocumentViewer$viewImage(url);
				case 'image/jpeg':
					return $author$project$Element$DocumentViewer$viewImage(url);
				default:
					break _v1$6;
			}
		} else {
			switch (_v1.b) {
				case 0:
					var _v2 = _v1.a;
					var _v3 = _v1.b;
					return $author$project$Element$DocumentViewer$viewImage(url);
				case 1:
					var _v4 = _v1.a;
					var _v5 = _v1.b;
					return $author$project$Element$DocumentViewer$viewVideo(url);
				case 2:
					var _v6 = _v1.a;
					var _v7 = _v1.b;
					return $author$project$Element$DocumentViewer$viewPdf(url);
				default:
					break _v1$6;
			}
		}
	}
	return $author$project$UI$none;
};
var $author$project$Element$DocumentViewer$element = {iA: $author$project$Element$DocumentViewer$init, hh: $author$project$Element$DocumentViewer$perform, jR: $author$project$Element$DocumentViewer$update, nE: $author$project$Element$DocumentViewer$view};
var $author$project$Element$LearningOutcomeBadge$Downloading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningOutcomeBadge$FetchModule = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningOutcomeBadge$FormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningOutcomeBadge$ModuleDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningOutcomeBadge$NoEffect = {$: 0};
var $author$project$Element$LearningOutcomeBadge$NoModule = {$: 0};
var $author$project$Locale$Messages$BadgeAppreciation = {$: 19};
var $author$project$Locale$Messages$BadgeWhyQuestion = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$LearningOutcomeBadge$Description = $elm$core$Basics$identity;
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Locale$Messages$FormTooShortText = {$: 67};
var $author$project$Form$minLengthText = F3(
	function (t_, minLen, value) {
		return (_Utils_cmp(
			$elm$core$String$length(value),
			minLen) > -1) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormTooShortText));
	});
var $author$project$Form$requiredRubricTextFeedback = function (t_) {
	return A2(
		$elm$core$Basics$composeR,
		$author$project$Form$requiredText(t_),
		$elm$core$Result$andThen(
			A2($author$project$Form$minLengthText, t_, 5)));
};
var $author$project$Element$LearningOutcomeBadge$buildForm = F3(
	function (t_, formMsg, children) {
		return {
			gD: {
				kU: false,
				mu: $author$project$Form$requiredRubricTextFeedback(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gD: value});
					}),
				nD: function ($) {
					return $.gD;
				},
				nE: {
					kJ: 'badge-description',
					lO: t_(
						$author$project$Locale$Messages$BadgeWhyQuestion(
							A2(
								$elm$core$List$map,
								$author$project$Person$fullName(t_),
								children))),
					aT: A2($elm$core$Basics$composeL, formMsg, $elm$core$Basics$identity),
					bv: t_($author$project$Locale$Messages$BadgeAppreciation)
				}
			}
		};
	});
var $author$project$Element$LearningOutcomeBadge$emptyForm = {gD: ''};
var $author$project$Module$fetchModule = F3(
	function (config, _v0, callback) {
		var moduleId = _v0;
		return {
			bN: config,
			dC: $author$project$Module$moduleDetailedDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$module_, config, moduleId)
		};
	});
var $author$project$Element$LearningOutcomeBadge$init = F3(
	function (config, session, params) {
		var t_ = session.hy;
		var learningOutcomeState = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Element$LearningOutcomeBadge$NoModule,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$author$project$Element$LearningOutcomeBadge$Downloading),
				params.df.fK));
		var model = {
			bN: config,
			bt: A3($author$project$Element$LearningOutcomeBadge$buildForm, t_, $author$project$Element$LearningOutcomeBadge$FormMsg, params.df.e1),
			eH: learningOutcomeState,
			fK: $elm$core$Maybe$Nothing,
			dc: _List_Nil,
			cv: session,
			df: params.df,
			ej: $author$project$Element$LearningOutcomeBadge$emptyForm
		};
		var effect = function () {
			if (learningOutcomeState.$ === 1) {
				var moduleId = learningOutcomeState.a;
				return $author$project$Element$LearningOutcomeBadge$FetchModule(
					A3($author$project$Module$fetchModule, config.gr, moduleId, $author$project$Element$LearningOutcomeBadge$ModuleDownloaded));
			} else {
				return $author$project$Element$LearningOutcomeBadge$NoEffect;
			}
		}();
		return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningOutcomeBadge$perform = F2(
	function (_v0, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			default:
				var request = effect.a;
				return $author$project$Api$getV2(request);
		}
	});
var $author$project$Element$LearningOutcomeBadge$Badge = function (a) {
	return {$: 2, a: a};
};
var $author$project$Badge$BadgeUnsaved = F4(
	function (description, storyId, learningOutcomes, feedback) {
		return {gD: description, gJ: feedback, g3: learningOutcomes, hx: storyId};
	});
var $author$project$Element$LearningOutcomeBadge$Downloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningOutcomeBadge$Error = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$LearningOutcomeBadge$Exit = {$: 0};
var $author$project$Element$LearningOutcomeBadge$LogError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningOutcomeBadge$ModuleHasNoLearningOutcomes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesDownloadError = {$: 261};
var $author$project$Element$LearningOutcomeBadge$NoOp = {$: 5};
var $author$project$Log$msgModuleDownload = 'module_download';
var $author$project$Log$paramScopeStoryRubricAssessment = 'scope_story_rubric_assessment';
var $author$project$Element$LearningOutcomeBadge$toggleLearningOutcome = F2(
	function (lo, model) {
		var oldSet = model.dc;
		var newSet = A2($elm$core$List$member, lo, oldSet) ? A2($author$project$Util$List$removeElem, lo, oldSet) : A2($elm$core$List$cons, lo, oldSet);
		return _Utils_update(
			model,
			{dc: newSet});
	});
var $author$project$Element$LearningOutcomeBadge$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		switch (msg.$) {
			case 4:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					return ($elm$core$List$length(module_.g3) > 0) ? _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eH: $author$project$Element$LearningOutcomeBadge$Downloaded(module_.g3),
								fK: $elm$core$Maybe$Just(module_)
							}),
						$author$project$Element$LearningOutcomeBadge$NoEffect,
						$elm$core$Maybe$Nothing) : _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eH: $author$project$Element$LearningOutcomeBadge$ModuleHasNoLearningOutcomes(module_),
								fK: $elm$core$Maybe$Just(module_)
							}),
						$author$project$Element$LearningOutcomeBadge$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))
							}),
						$author$project$Element$LearningOutcomeBadge$LogError(
							A3(
								$author$project$Log$errorV2,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModuleDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeStoryRubricAssessment),
									error),
								$elm$core$Basics$always($author$project$Element$LearningOutcomeBadge$NoOp))),
						$elm$core$Maybe$Just(
							A2($author$project$Element$LearningOutcomeBadge$Error, error, 'module of the story cannot be downloaded')));
				}
			case 3:
				var fieldMsg = msg.a;
				var value = fieldMsg;
				var form = model.bt;
				var model2 = _Utils_update(
					model,
					{
						bt: _Utils_update(
							form,
							{
								gD: $author$project$Form$markEdited(model.bt.gD)
							}),
						ej: A2(form.gD.jR, value, model.ej)
					});
				return _Utils_Tuple3(model2, $author$project$Element$LearningOutcomeBadge$NoEffect, $elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(
					model,
					$author$project$Element$LearningOutcomeBadge$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$LearningOutcomeBadge$Exit));
			case 1:
				var lo = msg.a;
				return _Utils_Tuple3(
					A2($author$project$Element$LearningOutcomeBadge$toggleLearningOutcome, lo, model),
					$author$project$Element$LearningOutcomeBadge$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				var newBadge = A4($author$project$Badge$BadgeUnsaved, model.ej.gD, model.df.gT, model.dc, $elm$core$Maybe$Nothing);
				return _Utils_Tuple3(
					model,
					$author$project$Element$LearningOutcomeBadge$NoEffect,
					$elm$core$Maybe$Just(
						$author$project$Element$LearningOutcomeBadge$Badge(newBadge)));
			default:
				return _Utils_Tuple3(model, $author$project$Element$LearningOutcomeBadge$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$BadgeBtnAddLos = function (a) {
	return {$: 18, a: a};
};
var $author$project$Locale$Messages$BadgeHeadingGrant = {$: 21};
var $author$project$Element$LearningOutcomeBadge$CloseBadgePopup = {$: 0};
var $author$project$Element$LearningOutcomeBadge$SaveBadge = {$: 2};
var $author$project$Element$LearningOutcomeBadge$isBadgeFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gD, values);
	});
var $elm$html$Html$Attributes$max = $elm$html$Html$Attributes$stringProperty('max');
var $author$project$Element$LearningOutcomeBadge$ToggleLearningOutcome = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningOutcomeBadge$viewBadgeCreator = F2(
	function (model, los) {
		var session = model.cv;
		var viewer = session.nH;
		var t_ = session.hy;
		return _List_fromArray(
			[
				A3($author$project$UI$textareaField, t_, model.bt.gD, model.ej),
				A2(
				$elm$html$Html$ul,
				_List_Nil,
				A2(
					$elm$core$List$map,
					function (lo) {
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('control')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$label,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('checkbox')
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$input,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$type_('checkbox'),
															$elm$html$Html$Attributes$checked(
															A2($elm$core$List$member, lo, model.dc)),
															$elm$html$Html$Events$onClick(
															$author$project$Element$LearningOutcomeBadge$ToggleLearningOutcome(lo))
														]),
													_List_Nil),
													$elm$html$Html$text(
													' ' + (lo.gD + (' (' + (A2($author$project$LoSearch$subject, viewer, lo) + ')'))))
												]))
										]))
								]));
					},
					los))
			]);
	});
var $author$project$Element$LearningOutcomeBadge$view = function (model) {
	var session = model.cv;
	var t_ = session.hy;
	var numberOfSelectedLos = $elm$core$List$length(model.dc);
	var modalContent = function () {
		var _v0 = model.eH;
		switch (_v0.$) {
			case 1:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$progress,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('progress is-danger'),
								$elm$html$Html$Attributes$max('100')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('30%')
							]))
					]);
			case 0:
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification is-danger')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('The story '),
								$elm$html$Html$text(' has no module assigned.'),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Right now')
									])),
								$elm$html$Html$text(' you can add only grant learning outcomes that are preset in the module. Sorry for the inconvinience. ')
							]))
					]);
			case 2:
				var module_ = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('notification is-danger')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('The module '),
								A2(
								$elm$html$Html$i,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text(module_.jJ)
									])),
								$elm$html$Html$text(' has no learning outcome assigned.'),
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Right now')
									])),
								$elm$html$Html$text(' you can add only grant learning outcomes that are preset in the module. Sorry for the inconvinience. ')
							]))
					]);
			default:
				var los = _v0.a;
				return A2($author$project$Element$LearningOutcomeBadge$viewBadgeCreator, model, los);
		}
	}();
	return A4(
		$author$project$UI$modalPanel,
		_List_fromArray(
			[
				$author$project$UI$Icon$badge(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('is-medium')
					])),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BadgeHeadingGrant)
			]),
		_List_fromArray(
			[
				$author$project$UI$closeButton($author$project$Element$LearningOutcomeBadge$CloseBadgePopup)
			]),
		modalContent,
		_List_fromArray(
			[
				A4(
				$author$project$UI$submitButton,
				t_(
					$author$project$Locale$Messages$BadgeBtnAddLos(numberOfSelectedLos)),
				(!numberOfSelectedLos) || (!A2($author$project$Element$LearningOutcomeBadge$isBadgeFormValid, model.bt, model.ej)),
				false,
				$author$project$Element$LearningOutcomeBadge$SaveBadge),
				A4(
				$author$project$UI$resetButton,
				t_($author$project$Locale$Messages$BtnCancel),
				false,
				false,
				$author$project$Element$LearningOutcomeBadge$CloseBadgePopup)
			]));
};
var $author$project$Element$LearningOutcomeBadge$element = {iA: $author$project$Element$LearningOutcomeBadge$init, hh: $author$project$Element$LearningOutcomeBadge$perform, jR: $author$project$Element$LearningOutcomeBadge$update, nE: $author$project$Element$LearningOutcomeBadge$view};
var $author$project$Element$PortfolioStoryDelete$NoEffect = 0;
var $author$project$Element$PortfolioStoryDelete$init = F3(
	function (config, session, story) {
		return _Utils_Tuple3(
			{bN: config, cv: session, df: story},
			0,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioStoryDelete$perform = F2(
	function (_v0, _v1) {
		return $elm$core$Platform$Cmd$none;
	});
var $author$project$Element$PortfolioStoryDelete$Ok = $elm$core$Basics$identity;
var $author$project$Element$PortfolioStoryDelete$update = F2(
	function (msg, model) {
		if (!msg.$) {
			return _Utils_Tuple3(model, 0, $elm$core$Maybe$Nothing);
		} else {
			var story = msg.a;
			return _Utils_Tuple3(
				model,
				0,
				$elm$core$Maybe$Just(story));
		}
	});
var $author$project$Element$PortfolioStoryDelete$Confirmed = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioStoryDelete$Declined = {$: 0};
var $author$project$Locale$Messages$PortfoliosDeleteHelp = {$: 413};
var $author$project$Locale$Messages$PortfoliosHeadingDelete = {$: 411};
var $author$project$Element$PortfolioStoryDelete$view = function (_v0) {
	var session = _v0.cv;
	var story = _v0.df;
	return A4(
		$author$project$UI$confirmDialog,
		session.hy,
		{
			kD: $author$project$Element$PortfolioStoryDelete$Confirmed(story),
			kM: $author$project$Element$PortfolioStoryDelete$Declined
		},
		_List_fromArray(
			[
				A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$PortfoliosHeadingDelete)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$PortfoliosDeleteHelp)
					]))
			]));
};
var $author$project$Element$PortfolioStoryDelete$element = {iA: $author$project$Element$PortfolioStoryDelete$init, hh: $author$project$Element$PortfolioStoryDelete$perform, jR: $author$project$Element$PortfolioStoryDelete$update, nE: $author$project$Element$PortfolioStoryDelete$view};
var $author$project$Element$StoryRubricAssessment$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$FetchModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$FetchRubrics = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StoryRubricAssessment$ModuleDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$RubricsDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Rubric$defaultListParams = {bs: '', bw: '', e1: $elm$core$Maybe$Nothing, jE: $elm$core$Maybe$Nothing};
var $author$project$Api$Endpoint$toRubricsListQueryParams = function (listParams) {
	return A3(
		$author$project$Api$Endpoint$optionalList,
		$elm$core$String$fromInt,
		_Utils_Tuple2('students', listParams.e1),
		A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$Basics$identity,
			_Utils_Tuple2('tags', listParams.jE),
			_List_fromArray(
				[
					_Utils_Tuple2('q', listParams.bw),
					_Utils_Tuple2('cat', listParams.bs)
				])));
};
var $author$project$Api$Endpoint$rubrics = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'rubrics']),
			$author$project$Api$Endpoint$toRubricsListQueryParams(listParams));
	});
var $author$project$Rubric$fetchRubricsV2 = F3(
	function (config, params, callback) {
		return {
			bN: config,
			dC: $elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
			bZ: callback,
			G: A2($author$project$Api$Endpoint$rubrics, config, params)
		};
	});
var $author$project$Element$StoryRubricAssessment$init = F3(
	function (config, session, params) {
		var model = {bN: config, c7: $elm$core$Maybe$Nothing, cv: session, df: params.df, jB: params.jB};
		var effect = function () {
			var _v0 = params.df.fK;
			if (_v0.$ === 1) {
				return $author$project$Element$StoryRubricAssessment$Cmd(
					$author$project$Element$StoryRubricAssessment$FetchRubrics(
						A3($author$project$Rubric$fetchRubricsV2, config.gr, $author$project$Rubric$defaultListParams, $author$project$Element$StoryRubricAssessment$RubricsDownloaded)));
			} else {
				var module_ = _v0.a;
				return $author$project$Element$StoryRubricAssessment$Cmd(
					$author$project$Element$StoryRubricAssessment$FetchModule(
						A3($author$project$Module$fetchModule, config.gr, module_.gT, $author$project$Element$StoryRubricAssessment$ModuleDownloaded)));
			}
		}();
		return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$StoryRubricAssessment$RubricEditorEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StoryRubricAssessment$RubricEditorMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricAssessment$FormMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricAssessment$NoEffect = {$: 0};
var $author$project$Element$RubricAssessment$RubricList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricAssessment$Description = $elm$core$Basics$identity;
var $author$project$Locale$Messages$FeedbackAppriciation = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$RubricAssessment$buildForm = F3(
	function (t_, formMsg, children) {
		return {
			gD: {
				kU: false,
				mu: $author$project$Form$requiredRubricTextFeedback(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gD: value});
					}),
				nD: function ($) {
					return $.gD;
				},
				nE: {
					kJ: 'badge-description',
					lO: t_(
						$author$project$Locale$Messages$FeedbackAppriciation(
							A2(
								$elm$core$List$map,
								$author$project$Person$fullName(t_),
								children))),
					aT: A2($elm$core$Basics$composeL, formMsg, $elm$core$Basics$identity),
					bv: t_($author$project$Locale$Messages$BadgeAppreciation)
				}
			}
		};
	});
var $author$project$Element$RubricAssessment$emptyForm = {gD: ''};
var $author$project$Element$RubricAssessment$AssessmentInProgress = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricAssessment$LogOk = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricAssessment$NoOp = {$: 6};
var $author$project$Log$msgRubricSelect = 'rubric_select';
var $author$project$Rubric$chop = function (rubric) {
	return _Utils_update(
		rubric,
		{
			ki: A2(
				$elm$core$List$filter,
				function (aspect) {
					return aspect.jJ !== '';
				},
				rubric.ki)
		});
};
var $author$project$Rubric$extractContent = function (rubric) {
	return {ki: rubric.ki, fG: rubric.fG};
};
var $author$project$Rubric$stencil = function (rubric) {
	var cleanedRubric = $author$project$Rubric$chop(
		$author$project$Rubric$extractContent(rubric));
	return {
		mS: cleanedRubric,
		mT: rubric.gT,
		z: A2(
			$elm$core$Array$initialize,
			$elm$core$List$length(cleanedRubric.ki),
			$elm$core$Basics$always($elm$core$Maybe$Nothing)),
		jJ: rubric.jJ
	};
};
var $author$project$Element$RubricAssessment$selectRubric = F2(
	function (rubric, model) {
		var logRequest = A3(
			$author$project$Log$okV2,
			model.bN,
			_Utils_Tuple2(
				$author$project$Log$msgRubricSelect,
				_List_fromArray(
					[
						$elm$core$String$fromInt(rubric.gT)
					])),
			$elm$core$Basics$always($author$project$Element$RubricAssessment$NoOp));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					b$: A2(
						$author$project$Element$RubricAssessment$AssessmentInProgress,
						rubric,
						$author$project$Rubric$stencil(rubric)),
					d6: false
				}),
			$author$project$Element$RubricAssessment$LogOk(logRequest),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricAssessment$init = F3(
	function (config, session, params) {
		var preselectedRubric = function () {
			var _v0 = params.eW;
			if (_v0.b && (!_v0.b.b)) {
				var rubric = _v0.a;
				return $elm$core$Maybe$Just(rubric);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		}();
		var model = {
			b$: $author$project$Element$RubricAssessment$RubricList(params.eW),
			bN: config,
			bt: A3($author$project$Element$RubricAssessment$buildForm, session.hy, $author$project$Element$RubricAssessment$FormMsg, params.e1),
			eD: 0,
			i2: params.i2,
			d6: false,
			cv: session,
			jB: params.jB,
			ej: $author$project$Element$RubricAssessment$emptyForm
		};
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple3(model, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Maybe$map,
				function (rubric) {
					return A2($author$project$Element$RubricAssessment$selectRubric, rubric, model);
				},
				preselectedRubric));
	});
var $author$project$Element$RubricAssessment$perform = F2(
	function (_v0, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var request = effect.a;
			return $author$project$Api$postV2(request);
		}
	});
var $author$project$Element$RubricAssessment$BadgeGranted = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricAssessment$Exit = {$: 0};
var $author$project$Log$msgRubricAssessmentSave = 'rubric_assessment_save';
var $author$project$Log$paramScopeRubricAssessment = 'scope_rubric_assessment';
var $author$project$Element$RubricAssessment$AssessmentReady = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$RubricAssessment$FilledRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Rubric$isAssessmentValid = function (assessment) {
	return !A2(
		$elm$core$List$all,
		$elm$core$Basics$eq($elm$core$Maybe$Nothing),
		$elm$core$Array$toList(assessment.z));
};
var $author$project$Rubric$dry = function (partial) {
	if ($author$project$Rubric$isAssessmentValid(partial)) {
		var filterSelected = function (levelSelection) {
			return A2(
				$elm$core$List$map,
				$elm$core$Maybe$withDefault($author$project$Rubric$ignored),
				$elm$core$Array$toList(levelSelection));
		};
		var assessment = partial.mS;
		return $elm$core$Maybe$Just(
			{
				mS: assessment,
				mT: partial.mT,
				z: filterSelected(partial.z)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Rubric$toggleLevelForAspect = F3(
	function (aspect, levelIndex, assessment) {
		var _v0 = A2($author$project$Util$List$elemIndex, aspect, assessment.mS.ki);
		if (_v0.$ === 1) {
			return assessment;
		} else {
			var aspectIndex = _v0.a;
			var selectLevelForAspect = _Utils_update(
				assessment,
				{
					z: A3(
						$elm$core$Array$set,
						aspectIndex,
						$elm$core$Maybe$Just(levelIndex),
						assessment.z)
				});
			var deselectLevelForAspect = _Utils_update(
				assessment,
				{
					z: A3($elm$core$Array$set, aspectIndex, $elm$core$Maybe$Nothing, assessment.z)
				});
			var aspectLevel = A2($elm$core$Array$get, aspectIndex, assessment.z);
			if (!aspectLevel.$) {
				if (!aspectLevel.a.$) {
					var levelIndex_ = aspectLevel.a.a;
					return _Utils_eq(levelIndex_, levelIndex) ? deselectLevelForAspect : selectLevelForAspect;
				} else {
					var _v2 = aspectLevel.a;
					return selectLevelForAspect;
				}
			} else {
				return assessment;
			}
		}
	});
var $author$project$Element$RubricAssessment$selectLevel = F5(
	function (aspect, levelIndex, rubric, assessment, model) {
		var assessment2 = A3($author$project$Rubric$toggleLevelForAspect, aspect, levelIndex, assessment);
		var model2 = _Utils_update(
			model,
			{
				b$: A2($author$project$Element$RubricAssessment$AssessmentInProgress, rubric, assessment2)
			});
		var _v0 = $author$project$Rubric$dry(assessment2);
		if (!_v0.$) {
			var finalAssessment = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model2,
					{
						b$: A3($author$project$Element$RubricAssessment$AssessmentReady, rubric, assessment2, finalAssessment)
					}),
				$author$project$Element$RubricAssessment$NoEffect,
				$elm$core$Maybe$Just(
					$author$project$Element$RubricAssessment$FilledRubric(finalAssessment)));
		} else {
			return _Utils_Tuple3(model2, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricAssessment$update = F2(
	function (msg, model) {
		var noop = _Utils_Tuple3(model, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 1:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d6: !model.d6}),
					$author$project$Element$RubricAssessment$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				var fieldMsg = msg.a;
				var value = fieldMsg;
				var form = model.bt;
				var newModel = _Utils_update(
					model,
					{
						bt: _Utils_update(
							form,
							{
								gD: $author$project$Form$markEdited(model.bt.gD)
							}),
						eD: 1,
						ej: A2(form.gD.jR, value, model.ej)
					});
				return _Utils_Tuple3(newModel, $author$project$Element$RubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricAssessment$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricAssessment$Exit));
			case 0:
				var rubric = msg.a;
				return A2($author$project$Element$RubricAssessment$selectRubric, rubric, model);
			case 5:
				var aspect = msg.a;
				var levelIndex = msg.b;
				var _v2 = model.b$;
				switch (_v2.$) {
					case 1:
						var rubric = _v2.a;
						var assessment = _v2.b;
						return A5($author$project$Element$RubricAssessment$selectLevel, aspect, levelIndex, rubric, assessment, model);
					case 2:
						var rubric = _v2.a;
						var assessment = _v2.b;
						return A5($author$project$Element$RubricAssessment$selectLevel, aspect, levelIndex, rubric, assessment, model);
					default:
						return noop;
				}
			case 4:
				var _v3 = model.b$;
				switch (_v3.$) {
					case 2:
						var rubric = _v3.a;
						var assessment = _v3.c;
						var updatedModel = _Utils_update(
							model,
							{eD: 2});
						var logRequest = A3(
							$author$project$Log$okV2,
							model.bN,
							_Utils_Tuple2(
								$author$project$Log$msgRubricAssessmentSave,
								_List_fromArray(
									[
										$author$project$Log$paramScopeRubricAssessment,
										$elm$core$String$fromInt(rubric.gT)
									])),
							$elm$core$Basics$always($author$project$Element$RubricAssessment$NoOp));
						return _Utils_Tuple3(
							updatedModel,
							$author$project$Element$RubricAssessment$LogOk(logRequest),
							$elm$core$Maybe$Just(
								A2($author$project$Element$RubricAssessment$BadgeGranted, updatedModel.ej.gD, assessment)));
					case 1:
						return noop;
					default:
						return noop;
				}
			default:
				return noop;
		}
	});
var $author$project$Locale$Messages$RubricAssessmentTitle = {$: 433};
var $author$project$UI$levelHorizontal = $author$project$UI$level_(true);
var $author$project$Locale$Messages$RubricAssessmentSelected = function (a) {
	return {$: 432, a: a};
};
var $author$project$Element$RubricAssessment$Save = {$: 4};
var $author$project$Element$RubricAssessment$isBadgeFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gD, values);
	});
var $author$project$Element$RubricAssessment$LevelSelected = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Rubric$isSelected = F3(
	function (assessment, aspect, ix) {
		var _v0 = A2($author$project$Util$List$elemIndex, aspect, assessment.mS.ki);
		if (_v0.$ === 1) {
			return false;
		} else {
			var aspectIx = _v0.a;
			return _Utils_eq(
				A2($elm$core$Array$get, aspectIx, assessment.z),
				$elm$core$Maybe$Just(
					$elm$core$Maybe$Just(ix)));
		}
	});
var $author$project$Element$RubricAssessment$viewRubricFiller = F2(
	function (assessment, subjects) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-narrow is-fullwidth')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					A2(
						$elm$core$List$cons,
						A2($elm$html$Html$th, _List_Nil, _List_Nil),
						A2(
							$elm$core$List$map,
							function (l) {
								return A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text(l)
										]));
							},
							assessment.mS.fG.fG))),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (aspect) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(aspect.jJ),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												$author$project$Util$String$parenthesize(
													A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nf)))
											])),
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (ix, desc) {
												return A2(
													$elm$html$Html$td,
													_List_fromArray(
														[
															$elm$html$Html$Events$onClick(
															A2($author$project$Element$RubricAssessment$LevelSelected, aspect, ix)),
															A3($author$project$Rubric$isSelected, assessment, aspect, ix) ? $elm$html$Html$Attributes$class('has-background-success') : $elm$html$Html$Attributes$class('has-text-weight-light')
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('content is-small')
																]),
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$p,
																	_List_fromArray(
																		[
																			$elm$html$Html$Attributes$class('is-small')
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(desc)
																		]))
																]))
														]));
											}),
										A2(
											$elm$core$List$take,
											$elm$core$List$length(assessment.mS.fG.fG),
											aspect.lV))));
						},
						assessment.mS.ki))
				]));
	});
var $author$project$Element$RubricAssessment$viewAssessmentForm = F3(
	function (t_, model, assessment) {
		return A2(
			$elm$html$Html$fieldset,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$legend,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$RubricAssessmentSelected(assessment.jJ))
						])),
					A2($author$project$Element$RubricAssessment$viewRubricFiller, assessment, model.jB),
					(!model.i2) ? A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, model.bt.gD, model.ej),
							$author$project$UI$section(
							_List_fromArray(
								[
									A4(
									$author$project$UI$submitButton,
									t_($author$project$Locale$Messages$BtnSave),
									(!$author$project$Rubric$isAssessmentValid(assessment)) || (!A2($author$project$Element$RubricAssessment$isBadgeFormValid, model.bt, model.ej)),
									$author$project$Form$isProcessing(model.eD),
									$author$project$Element$RubricAssessment$Save)
								]))
						])) : $author$project$UI$none
				]));
	});
var $author$project$Locale$Messages$RubricAssessmentSelect = {$: 431};
var $author$project$Element$RubricAssessment$RubricSelected = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricAssessment$ToggleRubricDropDown = {$: 1};
var $author$project$UI$dropDownSelect = function (config) {
	var items = config.lL;
	var selectedItem = config.mY;
	var showEmptyItem = config.m1;
	var emptyItemLabel = config.kV;
	var emptyItemSelectedMsg = config.kW;
	var itemLabel = config.lI;
	var isOpen = config.ly;
	var itemSelectedMsg = config.lJ;
	var isItemActive = config.lu;
	var itemToggledMsg = config.lK;
	var emptyItem = A3(
		$author$project$UI$actionLink,
		emptyItemSelectedMsg,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(emptyItemLabel)
			]));
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('field')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('label')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(config.lO)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('control is-expanded')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown '),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2('is-active', isOpen)
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-trigger'),
										$elm$html$Html$Events$onClick(itemToggledMsg)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu2'),
												A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
												$elm$html$Html$Attributes$class('button')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2(
															$elm$core$Maybe$withDefault,
															emptyItemLabel,
															A2($elm$core$Maybe$map, itemLabel, selectedItem)))
													])),
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-angle-down'),
														$author$project$UI$Icon$style('is-small')
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-menu'),
										$elm$html$Html$Attributes$id('dropdown-menu2'),
										A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('dropdown-content')
											]),
										_Utils_ap(
											showEmptyItem ? _List_fromArray(
												[emptyItem]) : _List_Nil,
											A2(
												$elm$core$List$map,
												function (item) {
													return A3(
														$author$project$UI$actionLink,
														itemSelectedMsg(item),
														_List_fromArray(
															[
																$elm$html$Html$Attributes$classList(
																_List_fromArray(
																	[
																		_Utils_Tuple2('dropdown-item', true),
																		_Utils_Tuple2(
																		'is-active',
																		isItemActive(item))
																	]))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(
																itemLabel(item))
															]));
												},
												items)))
									]))
							]))
					]))
			]));
};
var $author$project$Element$RubricAssessment$viewRubricSelect = F3(
	function (t_, isDropDownOpen, rubrics) {
		return $author$project$UI$dropDownSelect(
			{
				kV: t_($author$project$Locale$Messages$FormNotSelected),
				kW: $author$project$Element$RubricAssessment$NoOp,
				lu: $elm$core$Basics$always(false),
				ly: isDropDownOpen,
				lI: function ($) {
					return $.jJ;
				},
				lJ: $author$project$Element$RubricAssessment$RubricSelected,
				lK: $author$project$Element$RubricAssessment$ToggleRubricDropDown,
				lL: rubrics,
				lO: t_($author$project$Locale$Messages$RubricAssessmentSelect),
				mY: $elm$core$Maybe$Nothing,
				m1: false
			});
	});
var $author$project$Element$RubricAssessment$viewContent = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						function () {
						var _v1 = model.b$;
						switch (_v1.$) {
							case 2:
								var assessment = _v1.b;
								return A3($author$project$Element$RubricAssessment$viewAssessmentForm, t_, model, assessment);
							case 1:
								var assessment = _v1.b;
								return A3($author$project$Element$RubricAssessment$viewAssessmentForm, t_, model, assessment);
							default:
								var rubrics = _v1.a;
								return A3($author$project$Element$RubricAssessment$viewRubricSelect, t_, model.d6, rubrics);
						}
					}()
					]),
				kJ: 'rubrics-feedback-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAssessmentTitle)
							]),
						_List_Nil)
					]),
				nk: _List_Nil,
				nq: 'is-light has-background-white'
			});
	});
var $author$project$Element$RubricAssessment$view = function (model) {
	var session = model.cv;
	return A2($author$project$Element$RubricAssessment$viewContent, session, model);
};
var $author$project$Element$RubricAssessment$element = {iA: $author$project$Element$RubricAssessment$init, hh: $author$project$Element$RubricAssessment$perform, jR: $author$project$Element$RubricAssessment$update, nE: $author$project$Element$RubricAssessment$view};
var $author$project$Element$StoryRubricAssessment$rubricEditor = {
	gF: $author$project$Element$RubricAssessment$element,
	jK: $author$project$Element$StoryRubricAssessment$RubricEditorEffect,
	bZ: $author$project$Element$StoryRubricAssessment$RubricEditorMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					c7: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$StoryRubricAssessment$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var cmd = effect.a;
				switch (cmd.$) {
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
				}
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$StoryRubricAssessment$rubricEditor);
		}
	});
var $author$project$Element$StoryRubricAssessment$Badge = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StoryRubricAssessment$Exit = {$: 0};
var $author$project$Element$StoryRubricAssessment$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StoryRubricAssessment$NoEffect = {$: 0};
var $author$project$Element$StoryRubricAssessment$NoOp = {$: 3};
var $author$project$Locale$Messages$RubricsDownloadError = {$: 444};
var $author$project$Log$msgRubricsDownload = 'rubric_download';
var $author$project$Element$StoryRubricAssessment$openRubricEditor = F3(
	function (model, rubrics, students) {
		var session = model.cv;
		var subjects = model.jB;
		var params = {i2: false, eW: rubrics, e1: students, jB: subjects};
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$StoryRubricAssessment$rubricEditor,
			A4($author$project$Application$V3$Boundaries$initElement, model.bN, session, $author$project$Element$StoryRubricAssessment$rubricEditor, params));
		var model2 = _v0.a;
		var effect = _v0.b;
		return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$StoryRubricAssessment$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return A3($author$project$Element$StoryRubricAssessment$openRubricEditor, model, rubrics, model.df.e1);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgRubricsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStoryRubricAssessment),
										error),
									$elm$core$Basics$always($author$project$Element$StoryRubricAssessment$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 1:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					return ($elm$core$List$length(module_.eW) > 0) ? A3($author$project$Element$StoryRubricAssessment$openRubricEditor, model, module_.eW, model.df.e1) : _Utils_Tuple3(
						model,
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$FetchRubrics(
								A3($author$project$Rubric$fetchRubricsV2, model.bN.gr, $author$project$Rubric$defaultListParams, $author$project$Element$StoryRubricAssessment$RubricsDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))
							}),
						$author$project$Element$StoryRubricAssessment$Cmd(
							$author$project$Element$StoryRubricAssessment$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStoryRubricAssessment),
										error),
									$elm$core$Basics$always($author$project$Element$StoryRubricAssessment$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 2:
				var rubricEditorMsg = msg.a;
				var _v1 = model.c7;
				if (_v1.$ === 1) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3($author$project$Session$error, session, $author$project$Api$Timeout, 'wrong state 4938')
							}),
						$author$project$Element$StoryRubricAssessment$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var rubricEditorModel = _v1.a;
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$StoryRubricAssessment$rubricEditor,
						A4($author$project$Application$V3$Boundaries$updateElement, session, rubricEditorMsg, rubricEditorModel, $author$project$Element$StoryRubricAssessment$rubricEditor));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					var noop = _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					if (reply.$ === 1) {
						return noop;
					} else {
						var reply_ = reply.a;
						switch (reply_.$) {
							case 0:
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{c7: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Just($author$project$Element$StoryRubricAssessment$Exit));
							case 1:
								var appreciation = reply_.a;
								var rubricAssessment = reply_.b;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{c7: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Just(
										$author$project$Element$StoryRubricAssessment$Badge(
											A4(
												$author$project$Badge$BadgeUnsaved,
												appreciation,
												model.df.gT,
												_List_Nil,
												$elm$core$Maybe$Just(rubricAssessment)))));
							default:
								return noop;
						}
					}
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$StoryRubricAssessment$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricAssessment$PopupClosed = {$: 3};
var $author$project$Element$RubricAssessment$viewPopup = F2(
	function (session, model) {
		return A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$RubricAssessment$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$Element$RubricAssessment$viewContent, session, model)
					])));
	});
var $author$project$Element$StoryRubricAssessment$view = function (model) {
	var session = model.cv;
	var _v0 = model.c7;
	if (_v0.$ === 1) {
		return $author$project$UI$none;
	} else {
		var model_ = _v0.a;
		return A2(
			$elm$html$Html$map,
			$author$project$Element$StoryRubricAssessment$RubricEditorMsg,
			A2($author$project$Element$RubricAssessment$viewPopup, session, model_));
	}
};
var $author$project$Element$StoryRubricAssessment$element = {iA: $author$project$Element$StoryRubricAssessment$init, hh: $author$project$Element$StoryRubricAssessment$perform, jR: $author$project$Element$StoryRubricAssessment$update, nE: $author$project$Element$StoryRubricAssessment$view};
var $author$project$Element$PortfolioSingle$popups = {
	dw: {
		gF: $author$project$Element$LearningOutcomeBadge$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$BadgeCreateEffect),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$BadgeCreateMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$BadgeCreateModel(model))
					});
			})
	},
	b1: {
		gF: $author$project$Element$BadgeDelete$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$BadgeDeleteEffect),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$BadgeDeleteMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$BadgeDeleteModel(model))
					});
			})
	},
	dE: {
		gF: $author$project$Element$DocumentViewer$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$DocumentViewerEffect),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$DocumentViewerMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$DocumentViewerModel(model))
					});
			})
	},
	b4: {
		gF: $author$project$Element$StoryRubricAssessment$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$FeedbackEffect),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$FeedbackMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$FeedbackModel(model))
					});
			})
	},
	cx: {
		gF: $author$project$Element$PortfolioStoryDelete$element,
		jK: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupEffect, $author$project$Element$PortfolioSingle$StoryDeleteEffect),
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioSingle$PopupMsg, $author$project$Element$PortfolioSingle$StoryDeleteMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$PortfolioSingle$StoryDeleteModel(model))
					});
			})
	}
};
var $author$project$Api$putV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var decoder = _v0.dC;
	var toMsg = _v0.bZ;
	var body = _v0.O;
	return $author$project$Api$Endpoint$request(
		{
			O: $elm$http$Http$jsonBody(body),
			a4: A2($author$project$Api$expectJson, toMsg, decoder),
			ah: $author$project$Api$toHeaders(config.gr),
			ba: 'PUT',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $author$project$Element$PortfolioSingle$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioSingle$perform(key),
						effects));
			case 2:
				switch (effect.a.$) {
					case 0:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = effect.a.a;
						return $author$project$Api$putV2(request);
					case 2:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 4:
						var request = effect.a.a;
						return $author$project$Api$deleteV2(request);
					case 5:
						var request = effect.a.a;
						return $author$project$Api$deleteV2(request);
					default:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
				}
			default:
				switch (effect.a.$) {
					case 0:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.b4);
					case 1:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.dw);
					case 2:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.b1);
					case 3:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.cx);
					default:
						var popupEffect = effect.a.a;
						return A3($author$project$Application$V3$Boundaries$performElement, key, popupEffect, $author$project$Element$PortfolioSingle$popups.dE);
				}
		}
	});
var $author$project$Locale$Messages$BadgeCreated = function (a) {
	return {$: 27, a: a};
};
var $author$project$Locale$Messages$BadgeDeleteError = {$: 23};
var $author$project$Locale$Messages$BadgeDeleteSuccess = {$: 24};
var $author$project$Element$PortfolioSingle$Deleted = 0;
var $author$project$Element$PortfolioSingle$LogError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$PortfolioSingle$NoOp = {$: 12};
var $author$project$Element$PortfolioSingle$PortfolioStorySaved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$PortfoliosDeleteError = {$: 414};
var $author$project$Locale$Messages$PortfoliosDeleteSuccess = {$: 415};
var $author$project$Locale$Messages$PortfoliosSaveSuccess = {$: 417};
var $author$project$Element$PortfolioSingle$UpdatePortfolioStory = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 2:
				var value = data.a;
				return $author$project$RemoteData$Success(
					f(value));
			case 1:
				return $author$project$RemoteData$Loading;
			case 0:
				return $author$project$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $author$project$RemoteData$Failure(error);
		}
	});
var $author$project$Log$msgBadgeDelete = 'badge_delete';
var $author$project$Log$msgBadgeSave = 'badge_save';
var $author$project$Log$msgPortfoliosDelete = 'portfolios_delete';
var $author$project$Log$msgPortfoliosSave = 'portfolios_save';
var $author$project$Log$paramScopePortfolios = 'scope_portfolios';
var $author$project$PortfolioStory$unfreeze = function (story) {
	return {
		kG: story.kG.gT,
		gD: story.gD,
		gT: story.gT,
		lY: A2(
			$elm$core$List$map,
			function ($) {
				return $.mq;
			},
			story.lY),
		fK: A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.gT;
			},
			story.fK),
		e1: A2(
			$elm$core$List$map,
			function ($) {
				return $.gT;
			},
			story.e1),
		hH: story.hH
	};
};
var $author$project$Element$PortfolioSingle$BadgeDeleted = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$PortfolioSingle$BadgeSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$CreateBadge = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioSingle$DeleteBadge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioSingle$DeletePortfolioStory = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioSingle$PortfolioStoryDeleted = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioSingle$closePopup = function (model) {
	return _Utils_update(
		model,
		{c3: $elm$core$Maybe$Nothing});
};
var $author$project$Rubric$encodeAspect = function (aspect) {
	var optionalSubjectId = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (id) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'subjectId',
						$elm$json$Json$Encode$int(id))
					]);
			},
			aspect.nf));
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(aspect.jJ)),
					_Utils_Tuple2(
					'levelDescriptions',
					A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, aspect.lV))
				]),
			optionalSubjectId));
};
var $author$project$Rubric$encodeScale = function (scale) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'label',
				$elm$json$Json$Encode$string(scale.lO)),
				_Utils_Tuple2(
				'levels',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, scale.fG))
			]));
};
var $author$project$Rubric$encodeRubricContent = function (rubric) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'scale',
				$author$project$Rubric$encodeScale(rubric.fG)),
				_Utils_Tuple2(
				'aspects',
				A2($elm$json$Json$Encode$list, $author$project$Rubric$encodeAspect, rubric.ki))
			]));
};
var $author$project$Rubric$rubricAssessmentEncoder = function (assessment) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rubricId',
				$elm$json$Json$Encode$int(assessment.mT)),
				_Utils_Tuple2(
				'rubric',
				$author$project$Rubric$encodeRubricContent(assessment.mS)),
				_Utils_Tuple2(
				'selected',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, assessment.z))
			]));
};
var $author$project$Badge$badgeEncoder = function (badge) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(badge.gD)),
				_Utils_Tuple2(
				'story_id',
				$elm$json$Json$Encode$int(badge.hx)),
				_Utils_Tuple2(
				'learning_outcomes',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$int,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.gT;
						},
						badge.g3))),
				_Utils_Tuple2(
				'feedback',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Rubric$rubricAssessmentEncoder, badge.gJ)))
			]));
};
var $author$project$Api$Endpoint$badges = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'badges']),
		_List_Nil);
};
var $author$project$Badge$createBadge = F3(
	function (config, badge, callback) {
		return {
			O: $author$project$Badge$badgeEncoder(badge),
			bN: config,
			dC: $author$project$Badge$badgeDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$badges(config.gr)
		};
	});
var $author$project$Api$Endpoint$badge = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'badges',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Badge$deleteBadge = F3(
	function (config, badge, callback) {
		return {
			O: $elm$http$Http$emptyBody,
			bN: config,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$badge, config, badge.gT)
		};
	});
var $author$project$PortfolioStory$deleteStory = F3(
	function (config, story, callback) {
		return {
			O: $elm$http$Http$emptyBody,
			bN: config,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$portfolioStory, config, story.gT)
		};
	});
var $author$project$Element$PortfolioSingle$updatePopup = F3(
	function (popupMsg, popupModel, model) {
		var config = model.bN;
		var session = model.cv;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioSingle$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(popupMsg, popupModel);
		_v0$5:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.b.$) {
						var feedbackMsg = _v0.a.a;
						var feedbackModel = _v0.b.a;
						var _v1 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.b4,
							A4($author$project$Application$V3$Boundaries$updateElement, session, feedbackMsg, feedbackModel, $author$project$Element$PortfolioSingle$popups.b4));
						var model2 = _v1.a;
						var effect = _v1.b;
						var reply = _v1.c;
						if (!reply.$) {
							if (!reply.a.$) {
								var _v3 = reply.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model2),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								var newBadge = reply.a.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model2),
									$author$project$Element$PortfolioSingle$BatchEffect(
										_List_fromArray(
											[
												effect,
												$author$project$Element$PortfolioSingle$Cmd(
												$author$project$Element$PortfolioSingle$CreateBadge(
													A3($author$project$Badge$createBadge, config, newBadge, $author$project$Element$PortfolioSingle$BadgeSaved)))
											])),
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$5;
					}
				case 1:
					if (_v0.b.$ === 1) {
						var badgeMsg = _v0.a.a;
						var badgeModel = _v0.b.a;
						var _v4 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.dw,
							A4($author$project$Application$V3$Boundaries$updateElement, session, badgeMsg, badgeModel, $author$project$Element$PortfolioSingle$popups.dw));
						var model2 = _v4.a;
						var effect = _v4.b;
						var reply = _v4.c;
						if (!reply.$) {
							switch (reply.a.$) {
								case 0:
									var _v6 = reply.a;
									return _Utils_Tuple3(
										$author$project$Element$PortfolioSingle$closePopup(model),
										effect,
										$elm$core$Maybe$Nothing);
								case 2:
									var newBadge = reply.a.a;
									return _Utils_Tuple3(
										$author$project$Element$PortfolioSingle$closePopup(model),
										$author$project$Element$PortfolioSingle$BatchEffect(
											_List_fromArray(
												[
													effect,
													$author$project$Element$PortfolioSingle$Cmd(
													$author$project$Element$PortfolioSingle$CreateBadge(
														A3($author$project$Badge$createBadge, config, newBadge, $author$project$Element$PortfolioSingle$BadgeSaved)))
												])),
										$elm$core$Maybe$Nothing);
								default:
									var _v7 = reply.a;
									var error = _v7.a;
									var errorStr = _v7.b;
									var model3 = $author$project$Element$PortfolioSingle$closePopup(model2);
									return _Utils_Tuple3(
										_Utils_update(
											model3,
											{
												cv: A3($author$project$Session$error, session, error, errorStr)
											}),
										$author$project$Element$PortfolioSingle$BatchEffect(
											_List_fromArray(
												[
													effect,
													$author$project$Element$PortfolioSingle$Cmd(
													$author$project$Element$PortfolioSingle$LogError(
														A3(
															$author$project$Log$errorV2,
															config,
															_Utils_Tuple3($author$project$Log$msgBadgeSave, $elm$core$Maybe$Nothing, error),
															$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp))))
												])),
										$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$5;
					}
				case 2:
					if (_v0.b.$ === 2) {
						var deleteMsg = _v0.a.a;
						var deleteModel = _v0.b.a;
						var _v8 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.b1,
							A4($author$project$Application$V3$Boundaries$updateElement, session, deleteMsg, deleteModel, $author$project$Element$PortfolioSingle$popups.b1));
						var model2 = _v8.a;
						var effect = _v8.b;
						var reply = _v8.c;
						if (!reply.$) {
							if (!reply.a.$) {
								var badge = reply.a.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model),
									$author$project$Element$PortfolioSingle$Cmd(
										$author$project$Element$PortfolioSingle$DeleteBadge(
											A3(
												$author$project$Badge$deleteBadge,
												config.gr,
												badge,
												$author$project$Element$PortfolioSingle$BadgeDeleted(badge)))),
									$elm$core$Maybe$Nothing);
							} else {
								var _v10 = reply.a;
								return _Utils_Tuple3(
									$author$project$Element$PortfolioSingle$closePopup(model),
									$author$project$Element$PortfolioSingle$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$5;
					}
				case 3:
					if (_v0.b.$ === 3) {
						var deleteMsg = _v0.a.a;
						var deleteModel = _v0.b.a;
						var _v11 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.cx,
							A4($author$project$Application$V3$Boundaries$updateElement, session, deleteMsg, deleteModel, $author$project$Element$PortfolioSingle$popups.cx));
						var model2 = _v11.a;
						var effect = _v11.b;
						var reply = _v11.c;
						if (!reply.$) {
							var story_ = reply.a;
							return _Utils_Tuple3(
								$author$project$Element$PortfolioSingle$closePopup(model2),
								$author$project$Element$PortfolioSingle$BatchEffect(
									_List_fromArray(
										[
											effect,
											$author$project$Element$PortfolioSingle$Cmd(
											$author$project$Element$PortfolioSingle$DeletePortfolioStory(
												A3($author$project$PortfolioStory$deleteStory, config.gr, story_, $author$project$Element$PortfolioSingle$PortfolioStoryDeleted)))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								$author$project$Element$PortfolioSingle$closePopup(model2),
								effect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$5;
					}
				default:
					if (_v0.b.$ === 4) {
						var documentViewerMsg = _v0.a.a;
						var documentViewerModel = _v0.b.a;
						var _v13 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$PortfolioSingle$popups.dE,
							A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$PortfolioSingle$popups.dE));
						var model2 = _v13.a;
						var effect = _v13.b;
						return _Utils_Tuple3(
							$author$project$Element$PortfolioSingle$closePopup(model2),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$5;
					}
			}
		}
		return noop;
	});
var $author$project$PortfolioStory$storyTypeEncoder = function (type_) {
	if (!type_) {
		return $elm$json$Json$Encode$string('na');
	} else {
		return $elm$json$Json$Encode$string('mclosure');
	}
};
var $author$project$PortfolioStory$portfolioStoryEncoder = function (story) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(story.gT)),
				_Utils_Tuple2(
				'type',
				$author$project$PortfolioStory$storyTypeEncoder(story.hH)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(story.gD)),
				_Utils_Tuple2(
				'media',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, story.lY)),
				_Utils_Tuple2(
				'module',
				A2(
					$author$project$Data$encodeNullable,
					A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$json$Json$Encode$int),
					story.fK)),
				_Utils_Tuple2(
				'created_by',
				$elm$json$Json$Encode$int(story.kG)),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, story.e1))
			]));
};
var $author$project$PortfolioStory$updateStory = F3(
	function (config, story, callback) {
		return {
			O: $author$project$PortfolioStory$portfolioStoryEncoder(story),
			bN: config,
			dC: $author$project$PortfolioStory$portfolioStoryDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$portfolioStory, config.gr, story.gT)
		};
	});
var $author$project$Element$PortfolioSingle$update = F2(
	function (msg, model) {
		var config = model.bN;
		var story = model.df;
		var subjects = model.jB;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioSingle$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 12:
				return noop;
			case 11:
				var _v1 = $author$project$RemoteData$toMaybe(story);
				if (!_v1.$) {
					var story_ = _v1.a;
					var unsavedStory = $author$project$PortfolioStory$unfreeze(
						_Utils_update(
							story_,
							{hH: 1}));
					return _Utils_Tuple3(
						model,
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$UpdatePortfolioStory(
								A3($author$project$PortfolioStory$updateStory, config, unsavedStory, $author$project$Element$PortfolioSingle$PortfolioStorySaved))),
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 7:
				var _v2 = _Utils_Tuple2(
					$author$project$RemoteData$toMaybe(story),
					$author$project$RemoteData$toMaybe(subjects));
				if ((!_v2.a.$) && (!_v2.b.$)) {
					var story_ = _v2.a.a;
					var subjects_ = _v2.b.a;
					var _v3 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$PortfolioSingle$popups.b4,
						A4(
							$author$project$Application$V3$Boundaries$initElement,
							model.bN,
							session,
							$author$project$Element$PortfolioSingle$popups.b4,
							{df: story_, jB: subjects_}));
					var model2 = _v3.a;
					var effect = _v3.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 8:
				var badge = msg.a;
				var _v4 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model,
					$author$project$Element$PortfolioSingle$popups.b1,
					A4($author$project$Application$V3$Boundaries$initElement, model.bN, session, $author$project$Element$PortfolioSingle$popups.b1, badge));
				var model2 = _v4.a;
				var effect = _v4.b;
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			case 6:
				var _v5 = $author$project$RemoteData$toMaybe(story);
				if (!_v5.$) {
					var story_ = _v5.a;
					var _v6 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$PortfolioSingle$popups.cx,
						A4($author$project$Application$V3$Boundaries$initElement, model.bN, session, $author$project$Element$PortfolioSingle$popups.cx, story_));
					var model2 = _v6.a;
					var effect = _v6.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 9:
				var url = msg.a;
				var _v7 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model,
					$author$project$Element$PortfolioSingle$popups.dE,
					A4(
						$author$project$Application$V3$Boundaries$initElement,
						model.bN,
						session,
						$author$project$Element$PortfolioSingle$popups.dE,
						{eM: $elm$core$Maybe$Nothing, G: url}));
				var model2 = _v7.a;
				var effect = _v7.b;
				return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
			case 10:
				var popupMsg = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2(
						$elm$core$Maybe$map,
						function (popupModel) {
							return A3($author$project$Element$PortfolioSingle$updatePopup, popupMsg, popupModel, model);
						},
						model.c3));
			case 0:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$PortfoliosDeleteSuccess))
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDeleteError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 5:
				if (!msg.b.$) {
					var oldBadge = msg.a;
					var deleteBadge = F2(
						function (oldBadge_, story_) {
							return _Utils_update(
								story_,
								{
									hZ: A2(
										$elm$core$List$filter,
										function (b) {
											return !_Utils_eq(b, oldBadge_);
										},
										story_.hZ)
								});
						});
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$BadgeDeleteSuccess)),
								df: A2(
									$author$project$RemoteData$map,
									deleteBadge(oldBadge),
									story)
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$BadgeDeleteError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgBadgeDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 4:
				if (!msg.a.$) {
					var badge = msg.a.a;
					var _v8 = $author$project$RemoteData$toMaybe(story);
					if (!_v8.$) {
						var story_ = _v8.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A2(
										$author$project$Session$ok,
										session,
										t_(
											$author$project$Locale$Messages$BadgeCreated(
												A2(
													$elm$core$List$map,
													$author$project$Person$fullName(t_),
													story_.e1)))),
									df: $author$project$RemoteData$Success(
										_Utils_update(
											story_,
											{
												hZ: A2($elm$core$List$cons, badge, story_.hZ)
											}))
								}),
							$author$project$Element$PortfolioSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgBadgeSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 1:
				if (!msg.a.$) {
					var newStory = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$PortfoliosSaveSuccess)),
								df: $author$project$RemoteData$Success(newStory)
							}),
						$author$project$Element$PortfolioSingle$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError))
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPortfoliosSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 2:
				if (!msg.a.$) {
					var story_ = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								df: $author$project$RemoteData$Success(story_)
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$PortfolioSingle$SubjectListDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDownloadError)),
								df: $author$project$RemoteData$Failure(error)
							}),
						$author$project$Element$PortfolioSingle$Cmd(
							$author$project$Element$PortfolioSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				switch (msg.a.$) {
					case 2:
						var subjects_ = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jB: $author$project$RemoteData$Success(subjects_)
								}),
							$author$project$Element$PortfolioSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError)),
									jB: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$PortfolioSingle$Cmd(
								$author$project$Element$PortfolioSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return noop;
				}
		}
	});
var $author$project$Application$V3$Boundaries$viewElement = F3(
	function (session, model, element) {
		return A2(
			$elm$html$Html$map,
			element.bZ,
			element.gF.nE(
				_Utils_update(
					model,
					{cv: session})));
	});
var $author$project$Element$PortfolioSingle$viewPopup = F2(
	function (session, model) {
		switch (model.$) {
			case 0:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.b4);
			case 1:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.dw);
			case 2:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.b1);
			case 3:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.cx);
			default:
				var popupModel = model.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$PortfolioSingle$popups.dE);
		}
	});
var $author$project$Element$PortfolioSingle$OpenBadgeDeletePopup = function (a) {
	return {$: 8, a: a};
};
var $author$project$PortfolioStory$isEditable = function (story) {
	return !story.lw;
};
var $author$project$Locale$Messages$PortfoliosStudentsParticipants = function (a) {
	return {$: 422, a: a};
};
var $author$project$Element$PortfolioSingle$OpenDocumentViewer = function (a) {
	return {$: 9, a: a};
};
var $author$project$PortfolioStory$hasPreview = function (media) {
	return !_Utils_eq(media.hi, $elm$core$Maybe$Nothing);
};
var $author$project$PortfolioStory$mediaLarge = function (media) {
	return A2($elm$core$Maybe$withDefault, media.mq, media.iM);
};
var $author$project$Element$PortfolioSingle$viewStoryMediaItem = function (media) {
	return A2(
		$elm$html$Html$li,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('level-item')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$figure,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('image thumb')
					]),
				_List_fromArray(
					[
						function () {
						var _v0 = _Utils_Tuple2(
							$author$project$Util$Media$mediaViewerByExt(media.mq),
							$author$project$PortfolioStory$hasPreview(media));
						switch (_v0.a) {
							case 2:
								if (_v0.b) {
									var _v1 = _v0.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.mq),
												$elm$html$Html$Attributes$target('_blank'),
												$elm$html$Html$Attributes$class('media-overlay')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil),
												$author$project$UI$Icon$filePdf(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								} else {
									var _v2 = _v0.a;
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.mq),
												$elm$html$Html$Attributes$target('_blank')
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$filePdf(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								}
							case 3:
								var _v3 = _v0.a;
								return A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(media.mq),
											$elm$html$Html$Attributes$target('_blank')
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$file(
											_List_fromArray(
												[
													$author$project$UI$Icon$face('fa-3x'),
													$author$project$UI$Icon$style('has-text-info is-large')
												]))
										]));
							case 0:
								if (_v0.b) {
									var _v4 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(
											$author$project$PortfolioStory$mediaLarge(media)),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												$author$project$PortfolioStory$mediaLarge(media))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil)
											]));
								} else {
									var _v5 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(
											$author$project$PortfolioStory$mediaLarge(media)),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(
												$author$project$PortfolioStory$mediaLarge(media))
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-file-image fa-3x'),
														$author$project$UI$Icon$style('has-text-primary is-large')
													]))
											]));
								}
							default:
								if (_v0.b) {
									var _v6 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(media.mq),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.mq),
												$elm$html$Html$Attributes$class('media-overlay')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$img,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$src(
														$author$project$PortfolioStory$mediaPreview(media))
													]),
												_List_Nil),
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-play-circle fa-3x'),
														$author$project$UI$Icon$style('has-text-light is-large')
													]))
											]));
								} else {
									var _v7 = _v0.a;
									return A3(
										$author$project$UI$actionLink,
										$author$project$Element$PortfolioSingle$OpenDocumentViewer(media.mq),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$href(media.mq)
											]),
										_List_fromArray(
											[
												$author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-file-video fa-3x'),
														$author$project$UI$Icon$style('has-text-info is-large')
													]))
											]));
								}
						}
					}()
					]))
			]));
};
var $author$project$Element$PortfolioSingle$viewStoryContent = F2(
	function (t_, story) {
		var participants = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Person$isSamePerson(story.kG),
				$elm$core$Basics$not),
			story.e1);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block mt-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(story.gD)
						])),
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(story.lY),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block level')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('level-left')
									]),
								A2($elm$core$List$map, $author$project$Element$PortfolioSingle$viewStoryMediaItem, story.lY))
							]))),
					A2(
					$author$project$UI$when,
					$author$project$PortfolioStory$isNotModuleClosure(story) && (!$elm$core$List$isEmpty(participants)),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block has-text-grey')
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$caption,
								t_,
								$author$project$Locale$Messages$PortfoliosStudentsParticipants(
									A2(
										$elm$core$List$map,
										$author$project$Person$fullName(t_),
										participants)))
							])))
				]));
	});
var $author$project$Locale$Messages$PortfoliosClosed = {$: 380};
var $author$project$Locale$Messages$PortfoliosClosedEdit = {$: 381};
var $author$project$Locale$Messages$PortfoliosModuleClosed = F3(
	function (a, b, c) {
		return {$: 421, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$PortfoliosStoryShared = function (a) {
	return {$: 420, a: a};
};
var $author$project$Locale$Messages$TimeDateTimeFormat = F2(
	function (a, b) {
		return {$: 629, a: a, b: b};
	});
var $author$project$Locale$Messages$TooltipModule = function (a) {
	return {$: 665, a: a};
};
var $author$project$PortfolioStory$isCreator = F2(
	function (person, story) {
		return A2($author$project$Person$isSamePerson, story.kG, person);
	});
var $author$project$ACL$canManagePortfolio = F2(
	function (story, person) {
		return A2($author$project$PortfolioStory$isCreator, person, story);
	});
var $author$project$UI$gravatarSmall = function (email) {
	var size = 48;
	return A2(
		$elm$html$Html$img,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$src(
				A2($author$project$Util$Media$gravatar, size, email)),
				$elm$html$Html$Attributes$width(size),
				$elm$html$Html$Attributes$height(size)
			]),
		_List_Nil);
};
var $author$project$UI$Icon$locked = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-lock'),
			attributes));
};
var $author$project$UI$mediaObjectHighlights = function (items) {
	return A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('has-text-grey is-size-7 inline-list')
			]),
		A2(
			$elm$core$List$filterMap,
			function (item) {
				return _Utils_eq(item, $author$project$UI$none) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
					A2(
						$elm$html$Html$li,
						_List_Nil,
						_List_fromArray(
							[item])));
			},
			items));
};
var $author$project$UI$mediaObjectSmall = F4(
	function (media, content, navigation, right) {
		return A5($author$project$UI$mediaObject_, 'is-48x48', media, content, navigation, right);
	});
var $author$project$UI$Icon$module_ = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-cube'),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewStoryMeta = F3(
	function (t_, viewer, story) {
		var viewStandardStoryText = A2(
			$author$project$UI$caption,
			t_,
			$author$project$Locale$Messages$PortfoliosStoryShared(
				A2($author$project$Person$fullName, t_, story.kG)));
		var viewModuleLink = function (module_) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$ModulesDetail(
							$author$project$Module$moduleIdToInt(module_.gT))),
						$elm$html$Html$Attributes$title(
						t_(
							$author$project$Locale$Messages$TooltipModule(module_.jJ)))
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$module_(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(module_.jJ)
							]))
					]));
		};
		var viewLock = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManagePortfolio, story, viewer) ? t_($author$project$Locale$Messages$PortfoliosClosedEdit) : t_($author$project$Locale$Messages$PortfoliosClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(_List_Nil)
				]));
		var viewDateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosDetail(story.gT))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(story.gz)))
				]));
		var viewNoModuleMeta = _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('has-text-grey')
					]),
				_List_fromArray(
					[
						A2($author$project$UI$when, story.lw, viewLock),
						viewStandardStoryText
					])),
				$author$project$UI$mediaObjectHighlights(
				_List_fromArray(
					[viewDateLink]))
			]);
		var viewClosureStoryText = function (module_) {
			return A2(
				$author$project$UI$caption,
				t_,
				A3(
					$author$project$Locale$Messages$PortfoliosModuleClosed,
					A2($author$project$Person$fullName, t_, story.kG),
					A2(
						$elm$core$List$map,
						$author$project$Person$fullName(t_),
						story.e1),
					module_.jJ));
		};
		var viewModuleMeta = function (module_) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('has-text-grey')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$when, story.lw, viewLock),
							$author$project$PortfolioStory$isModuleClosure(story) ? viewClosureStoryText(module_) : viewStandardStoryText
						])),
					$author$project$UI$mediaObjectHighlights(
					_List_fromArray(
						[
							viewModuleLink(module_),
							viewDateLink
						]))
				]);
		};
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatarSmall(story.kG.K)
				]),
			A2(
				$elm$core$Maybe$withDefault,
				viewNoModuleMeta,
				A2($elm$core$Maybe$map, viewModuleMeta, story.fK)),
			_List_Nil,
			_List_Nil);
	});
var $author$project$ACL$canGiveFeedbackToPortfolios = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Data$toBool = function (value) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			value));
};
var $author$project$PortfolioStory$hasFeedback = function (story) {
	return A2(
		$elm$core$List$any,
		function (badge) {
			return $author$project$Data$toBool(badge.gJ);
		},
		story.hZ);
};
var $author$project$PortfolioStory$hasModule = function (story) {
	return $author$project$Data$toBool(story.fK);
};
var $author$project$PortfolioStory$isDeletable = function (story) {
	return $elm$core$List$isEmpty(story.hZ) && (!story.lw);
};
var $author$project$Locale$Messages$PortfoliosBtnClassroom = {$: 378};
var $author$project$UI$Icon$IconFaCategory = function (a) {
	return {$: 1, a: a};
};
var $author$project$UI$Icon$category = function (category_) {
	return $author$project$UI$Icon$IconFaCategory(category_);
};
var $author$project$UI$Icon$google = function (attributes) {
	return $author$project$UI$Icon$icon(
		_Utils_ap(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-google'),
					$author$project$UI$Icon$category('fab')
				]),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewClassroomSubmissionLink = F2(
	function (t_, submission) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('portfolios-item-classroom'),
					$elm$html$Html$Attributes$href(submission.G),
					$elm$html$Html$Attributes$target('_blank')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$google(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link-dark')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnClassroom)
				]));
	});
var $author$project$Locale$Messages$BtnDelete = {$: 32};
var $author$project$Element$PortfolioSingle$OpenStoryDeletePopup = {$: 6};
var $author$project$Element$PortfolioSingle$viewStoryDeleteLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$OpenStoryDeletePopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-delete')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$delete(_List_Nil),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
			]));
};
var $author$project$Locale$Messages$BtnEdit = {$: 33};
var $author$project$UI$Icon$edit = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-edit'),
			attributes));
};
var $author$project$Element$PortfolioSingle$viewStoryEditLink = F2(
	function (t_, story) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosUpdate(story.gT)),
					$author$project$UI$attrCyData('portfolios-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
	});
var $author$project$Element$PortfolioSingle$OpenFeedbackPopup = {$: 7};
var $author$project$Locale$Messages$PortfoliosBtnAddFeedback = {$: 377};
var $author$project$Element$PortfolioSingle$viewStoryFeedbackBadgeLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$OpenFeedbackPopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-add-feedback')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$feedback(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-info')
					])),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnAddFeedback)
			]));
};
var $author$project$Element$PortfolioSingle$MarkStoryAsModuleClosing = {$: 11};
var $author$project$Locale$Messages$PortfoliosBtnMarkClosing = {$: 379};
var $author$project$Element$PortfolioSingle$viewStoryModuleClosingLink = function (t_) {
	return A3(
		$author$project$UI$actionLink,
		$author$project$Element$PortfolioSingle$MarkStoryAsModuleClosing,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('portfolios-item-mark-closing')
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$module_(_List_Nil),
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosBtnMarkClosing)
			]));
};
var $author$project$Element$PortfolioSingle$viewStoryNavLinks = F3(
	function (t_, viewer, story) {
		return A2(
			$author$project$UI$nav,
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					story.h7,
					$author$project$Element$PortfolioSingle$viewClassroomSubmissionLink(t_)),
					A2(
					$author$project$UI$when,
					A2($author$project$ACL$canManagePortfolio, story, viewer) && ($author$project$PortfolioStory$isEditable(story) && $author$project$PortfolioStory$isNotModuleClosure(story)),
					A2($author$project$Element$PortfolioSingle$viewStoryEditLink, t_, story)),
					A2(
					$author$project$UI$when,
					$author$project$ACL$canGiveFeedbackToPortfolios(viewer) && ($author$project$PortfolioStory$isNotModuleClosure(story) && $author$project$PortfolioStory$isEditable(story)),
					$author$project$Element$PortfolioSingle$viewStoryFeedbackBadgeLink(t_)),
					A2(
					$author$project$UI$when,
					$author$project$PortfolioStory$isNotModuleClosure(story) && (($elm$core$List$length(story.e1) === 1) && ($author$project$PortfolioStory$hasFeedback(story) && ($author$project$PortfolioStory$hasModule(story) && (A2($author$project$ACL$canManagePortfolio, story, viewer) && $author$project$PortfolioStory$isEditable(story))))),
					$author$project$Element$PortfolioSingle$viewStoryModuleClosingLink(t_)),
					A2(
					$author$project$UI$when,
					A2($author$project$ACL$canManagePortfolio, story, viewer) && $author$project$PortfolioStory$isDeletable(story),
					$author$project$Element$PortfolioSingle$viewStoryDeleteLink(t_))
				]),
			_List_Nil);
	});
var $author$project$Element$PortfolioSingle$viewStoryItem = F4(
	function (t_, subjects, viewer, story) {
		var badgeDescriptionDiffersFromStoryDescription = function (badge) {
			return !_Utils_eq(story.gD, badge.gD);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('portfolios-item is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$PortfolioSingle$viewStoryMeta, t_, viewer, story),
					A2($author$project$Element$PortfolioSingle$viewStoryContent, t_, story),
					A6(
					$author$project$Element$PortfolioSingle$viewBadges,
					t_,
					subjects,
					badgeDescriptionDiffersFromStoryDescription,
					viewer,
					$author$project$PortfolioStory$isEditable(story) ? $elm$core$Maybe$Just($author$project$Element$PortfolioSingle$OpenBadgeDeletePopup) : $elm$core$Maybe$Nothing,
					story.hZ),
					A3($author$project$Element$PortfolioSingle$viewStoryNavLinks, t_, viewer, story)
				]));
	});
var $author$project$Element$PortfolioSingle$viewItem = function (_v0) {
	var session = _v0.cv;
	var story = _v0.df;
	var subjects = _v0.jB;
	var popupModel = _v0.c3;
	var subjects_ = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		$author$project$RemoteData$toMaybe(subjects));
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$author$project$UI$maybe,
				popupModel,
				$author$project$Element$PortfolioSingle$viewPopup(session)),
				A2(
				$author$project$UI$maybe,
				$author$project$RemoteData$toMaybe(story),
				A3($author$project$Element$PortfolioSingle$viewStoryItem, session.hy, subjects_, session.nH))
			]));
};
var $author$project$Element$PortfolioSingle$viewPage = function (model) {
	var session = model.cv;
	return $author$project$UI$panel(
		{
			kt: _List_fromArray(
				[
					$author$project$Element$PortfolioSingle$viewItem(model)
				]),
			kJ: 'portfolios-list',
			le: _List_fromArray(
				[
					A2($author$project$UI$caption, session.hy, $author$project$Locale$Messages$PortfoliosTitle)
				]),
			nk: _List_Nil,
			nq: 'is-link'
		});
};
var $author$project$Element$PortfolioSingle$view = function (model) {
	var _v0 = model.nG;
	if (!_v0.$) {
		return $author$project$Element$PortfolioSingle$viewPage(model);
	} else {
		return $author$project$Element$PortfolioSingle$viewItem(model);
	}
};
var $author$project$Element$PortfolioSingle$element = {iA: $author$project$Element$PortfolioSingle$init, hh: $author$project$Element$PortfolioSingle$perform, jR: $author$project$Element$PortfolioSingle$update, nE: $author$project$Element$PortfolioSingle$view};
var $author$project$Element$PortfolioList$singleElement = function (storyId) {
	return {
		gF: $author$project$Element$PortfolioSingle$element,
		jK: $author$project$Element$PortfolioList$SingleElementEffect(storyId),
		bZ: $author$project$Element$PortfolioList$SingleElementMsg(storyId),
		jS: F2(
			function (containerModel, model) {
				var singleElements2 = A3(
					$elm$core$Dict$update,
					storyId,
					$elm$core$Basics$always(
						$elm$core$Maybe$Just(model)),
					containerModel.cw);
				return _Utils_update(
					containerModel,
					{cw: singleElements2});
			})
	};
};
var $author$project$Element$PortfolioList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 6:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
					case 5:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
				}
			default:
				var storyId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$PortfolioList$singleElement(storyId));
		}
	});
var $author$project$Locale$Messages$ClassroomCourseListDownloadError = {$: 43};
var $author$project$Element$PortfolioList$Delay = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Element$PortfolioList$DelayedGotListQuery = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$PortfolioSingle$ListItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioList$NoOp = {$: 16};
var $author$project$Locale$Messages$PortfoliosPeopleDownloadError = {$: 391};
var $author$project$Element$PortfolioList$NoMoreStories = {$: 2};
var $author$project$Element$PortfolioList$StoriesLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$addNewStories = F2(
	function (newStories, model) {
		var loading = model.cY;
		var stories = model.e$;
		var _v0 = _Utils_Tuple3(
			loading,
			stories,
			$elm$core$List$reverse(newStories));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							model,
							{cY: $author$project$Element$PortfolioList$NoMoreStories, e$: newStories});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							model,
							{cY: $author$project$Element$PortfolioList$NoMoreStories});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStory = _v3.a;
						return _Utils_update(
							model,
							{
								cY: $author$project$Element$PortfolioList$StoriesLoaded(lastStory),
								e$: newStories
							});
					} else {
						var _v5 = _v0.a;
						var stories_ = _v0.b;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							model,
							{
								cY: $author$project$Element$PortfolioList$StoriesLoaded(lastStory),
								e$: _Utils_ap(stories_, newStories)
							});
					}
				}
			case 1:
				return model;
			default:
				var _v7 = _v0.a;
				return model;
		}
	});
var $author$project$Element$PortfolioList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 0:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$PortfolioList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$PortfolioList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$PortfolioList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$PortfolioList$emptyResults = function (model) {
	return _Utils_update(
		model,
		{cY: $author$project$Element$PortfolioList$LoadingStories, e$: _List_Nil});
};
var $author$project$Element$PortfolioList$filterStories = F2(
	function (model, newFilter) {
		var model2 = $author$project$Element$PortfolioList$emptyResults(
			_Utils_update(
				model,
				{bO: newFilter}));
		var listParams = $author$project$Element$PortfolioList$asListParams(model2);
		return _Utils_Tuple3(
			model2,
			$author$project$Element$PortfolioList$Cmd(
				$author$project$Element$PortfolioList$FetchPortfolioStoryList(
					A3($author$project$PortfolioStory$fetchStories2, model.bN.gr, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioList$TypeMClosure = 2;
var $author$project$Element$PortfolioList$formToFilter = function (value) {
	switch (value) {
		case '':
			return 0;
		case 'feedback':
			return 1;
		case 'mclosure':
			return 2;
		default:
			return 0;
	}
};
var $author$project$Log$msgClassroomsDownload = 'classroom_courses_download';
var $author$project$Log$msgPortfoliosPeopleDownload = 'portfolios_people_download';
var $author$project$Element$PortfolioList$update = F2(
	function (msg, model) {
		var config = model.bN;
		var store = model.bd;
		var filter = model.bO;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioList$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 9:
				var listParams = $author$project$Element$PortfolioList$asListParams(model);
				var _v1 = model.cY;
				switch (_v1.$) {
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cY: $author$project$Element$PortfolioList$LoadingStories}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$FetchPortfolioStoryList(
									A3($author$project$PortfolioStory$fetchStories2, config.gr, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))),
							$elm$core$Maybe$Nothing);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 0:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eA: !model.eA}),
					$author$project$Element$PortfolioList$NoEffect,
					$elm$core$Maybe$Nothing);
			case 1:
				var values = msg.a;
				var classroomIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{gx: classroomIds}));
			case 2:
				var values = msg.a;
				var moduleIds = A2(
					$elm$core$List$filterMap,
					function (id) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Basics$identity,
							$elm$core$String$toInt(id));
					},
					values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{g9: moduleIds}));
			case 3:
				var values = msg.a;
				var studentIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{e1: studentIds}));
			case 4:
				var values = msg.a;
				var teacherIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{e5: teacherIds}));
			case 5:
				var value = msg.a;
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{
							hH: $author$project$Element$PortfolioList$formToFilter(value)
						}));
			case 6:
				var categoryFilter = msg.a;
				return A2(
					$author$project$Element$PortfolioList$filterStories,
					model,
					_Utils_update(
						filter,
						{bs: categoryFilter}));
			case 7:
				var query = msg.a;
				return _Utils_Tuple3(
					$author$project$Element$PortfolioList$emptyResults(
						_Utils_update(
							model,
							{bw: query})),
					$author$project$Element$PortfolioList$Cmd(
						A2(
							$author$project$Element$PortfolioList$Delay,
							0.5,
							$author$project$Element$PortfolioList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 8:
				var newQuery = msg.a;
				var listParams = $author$project$Element$PortfolioList$asListParams(model);
				var effect = _Utils_eq(newQuery, model.bw) ? $author$project$Element$PortfolioList$Cmd(
					$author$project$Element$PortfolioList$FetchPortfolioStoryList(
						A3($author$project$PortfolioStory$fetchStories2, config.gr, listParams, $author$project$Element$PortfolioList$PortfolioStoryListDownloaded))) : $author$project$Element$PortfolioList$NoEffect;
				return _Utils_Tuple3(model, effect, $elm$core$Maybe$Nothing);
			case 15:
				var storyId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = function (singleModel_) {
					var single = $author$project$Element$PortfolioList$singleElement(storyId);
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						single,
						A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					if (!reply.$) {
						var _v4 = reply.a;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{
									cw: A2($elm$core$Dict$remove, storyId, model.cw)
								}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				};
				var singleModel = A2($elm$core$Dict$get, storyId, model.cw);
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2($elm$core$Maybe$map, updateSingleElement, singleModel));
			case 10:
				var newStories = msg.a;
				switch (newStories.$) {
					case 3:
						var error = newStories.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PortfoliosDownloadError))
								}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 2:
						var newStories_ = newStories.a;
						var startModel = A2($author$project$Element$PortfolioList$addNewStories, newStories_, model);
						return A3(
							$elm$core$List$foldl,
							F2(
								function (story, _v6) {
									var model_ = _v6.a;
									var effect_ = _v6.b;
									var single = $author$project$Element$PortfolioList$singleElement(story.gT);
									var params = {
										jB: model.jB,
										nG: $author$project$Element$PortfolioSingle$ListItem(story)
									};
									var _v7 = A3(
										$author$project$Application$V3$Boundaries$mapElement,
										model_,
										single,
										A4($author$project$Application$V3$Boundaries$initElement, model_.bN, model_.cv, single, params));
									var model2 = _v7.a;
									var effect2 = _v7.b;
									return _Utils_Tuple3(
										model2,
										A2($author$project$Element$PortfolioList$batchEffect, effect2, effect_),
										$elm$core$Maybe$Nothing);
								}),
							_Utils_Tuple3(startModel, $author$project$Element$PortfolioList$NoEffect, $elm$core$Maybe$Nothing),
							newStories_);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 13:
				var subjects = msg.a;
				switch (subjects.$) {
					case 3:
						var error = subjects.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$PortfolioList$Cmd(
								$author$project$Element$PortfolioList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 2:
						var subjects_ = subjects.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jB: $author$project$RemoteData$Success(subjects_)
								}),
							$author$project$Element$PortfolioList$NoEffect,
							$elm$core$Maybe$Nothing);
					case 0:
						return noop;
					default:
						return noop;
				}
			case 14:
				if (!msg.a.$) {
					var classrooms = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bd: _Utils_update(
									store,
									{
										gx: $elm$core$Maybe$Just(classrooms)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ClassroomCourseListDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgClassroomsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 11:
				if (!msg.a.$) {
					var modules = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bd: _Utils_update(
									store,
									{
										g9: $elm$core$Maybe$Just(modules)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModulesDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
										error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 12:
				if (!msg.a.$) {
					var people = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bd: _Utils_update(
									store,
									{
										mw: $elm$core$Maybe$Just(people)
									})
							}),
						$author$project$Element$PortfolioList$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosPeopleDownloadError))
							}),
						$author$project$Element$PortfolioList$Cmd(
							$author$project$Element$PortfolioList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgPortfoliosPeopleDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$PortfolioList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				return noop;
		}
	});
var $author$project$Locale$Messages$BtnToggleFilters = {$: 42};
var $author$project$Element$PortfolioList$GotListQuery = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$PortfoliosEmptyResults = {$: 416};
var $author$project$Locale$Messages$PortfoliosSearch = {$: 419};
var $author$project$Element$PortfolioList$ToggleFilterPanel = {$: 0};
var $author$project$UI$Icon$add = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-plus-square'),
			attributes));
};
var $author$project$ACL$canCreateModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$UI$Icon$warning = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-exclamation-circle'),
			attributes));
};
var $author$project$UI$List$emptyResultsInfo = F2(
	function (t_, message) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container has-text-centered')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mr-1')
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$warning(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-link')
								]))
						])),
					A2($author$project$UI$caption, t_, message)
				]));
	});
var $author$project$Person$isSponsorOf = F2(
	function (person, child) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(child),
			person.m8);
	});
var $author$project$UI$keyedPanel = function (_v0) {
	var theme = _v0.nq;
	var dataTag = _v0.kJ;
	var heading = _v0.le;
	var tabs = _v0.nk;
	var blocks = _v0.kt;
	var keyedBlocks = _v0.lN;
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('panel'),
				$elm$html$Html$Attributes$class(theme),
				$author$project$UI$attrCyData(dataTag)
			]),
		A2(
			$elm$core$List$cons,
			_Utils_Tuple2(
				'panel-heading-0',
				A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('panel-heading')
						]),
					heading)),
			A2(
				$elm$core$List$cons,
				_Utils_Tuple2(
					'panel-tabs-0',
					A2(
						$elm$html$Html$nav,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('panel-tabs')
							]),
						tabs)),
				_Utils_ap(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (idx, block) {
								return _Utils_Tuple2(
									'panel-block-' + $elm$core$String$fromInt(idx),
									$author$project$UI$panelBlock(block));
							}),
						blocks),
					A2(
						$elm$core$List$map,
						function (_v1) {
							var key = _v1.a;
							var block = _v1.b;
							return _Utils_Tuple2(
								'panel-block-key-' + key,
								$author$project$UI$panelBlock(block));
						},
						keyedBlocks)))));
};
var $author$project$UI$List$resultsLoadingProgressBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('container has-text-centered')
		]),
	_List_fromArray(
		[
			$author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-spinner fa-spin fa-2x'),
					$author$project$UI$Icon$style('is-large has-text-grey')
				]))
		]));
var $author$project$UI$List$searchBar = function (params) {
	return A2(
		$elm$html$Html$p,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('control has-icons-left')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('input'),
						$elm$html$Html$Attributes$placeholder(params.bv),
						$elm$html$Html$Attributes$type_('text'),
						$elm$html$Html$Events$onInput(params.aT),
						$author$project$UI$attrCyData('query'),
						$elm$html$Html$Attributes$value(params.bw)
					]),
				_List_Nil),
				$author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-search'),
						$author$project$UI$Icon$style('is-left')
					]))
			]));
};
var $author$project$Person$students = $elm$core$List$filter($author$project$Person$isStudent);
var $author$project$Person$teachers = $elm$core$List$filter(
	function (person) {
		return $author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person);
	});
var $author$project$Locale$Messages$PortfoliosFilterActive = {$: 392};
var $author$project$Locale$Messages$PortfoliosFilterClassrooms = {$: 397};
var $author$project$Locale$Messages$PortfoliosFilterModules = {$: 398};
var $author$project$Locale$Messages$PortfoliosFilterStudents = {$: 401};
var $author$project$Locale$Messages$PortfoliosFilterTeachers = {$: 402};
var $author$project$Locale$Messages$PortfoliosFilterType = {$: 403};
var $author$project$Element$PortfolioList$SetClassroomFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioList$SetModuleFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioList$SetStudentFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioList$SetTeacherFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioList$SetTypeFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioList$viewActiveFilters = F2(
	function (t_, filter) {
		var viewFilterPill = F2(
			function (caption, resetMsg) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tags has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$tag,
									'is-info',
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, caption)
										])),
									A3(
									$author$project$UI$actionLink,
									resetMsg,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag is-delete')
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]));
			});
		var empty = $author$project$Element$PortfolioList$emptyFilter;
		var hasActiveFilter = (!_Utils_eq(empty.gx, filter.gx)) || ((!_Utils_eq(empty.g9, filter.g9)) || ((!_Utils_eq(empty.e1, filter.e1)) || ((!_Utils_eq(empty.e5, filter.e5)) || (!_Utils_eq(empty.hH, filter.hH)))));
		return hasActiveFilter ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field is-grouped is-grouped-multiline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('heading mr-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterActive)
							])),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.gx, filter.gx),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterClassrooms,
							$author$project$Element$PortfolioList$SetClassroomFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.g9, filter.g9),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterModules,
							$author$project$Element$PortfolioList$SetModuleFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.e1, filter.e1),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterStudents,
							$author$project$Element$PortfolioList$SetStudentFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.e5, filter.e5),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterTeachers,
							$author$project$Element$PortfolioList$SetTeacherFilter(_List_Nil))),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.hH, filter.hH),
						A2(
							viewFilterPill,
							$author$project$Locale$Messages$PortfoliosFilterType,
							$author$project$Element$PortfolioList$SetTypeFilter('')))
					]))
			]) : _List_Nil;
	});
var $author$project$Locale$Messages$PortfoliosFilterNone = {$: 400};
var $author$project$Element$PortfolioList$viewClassroomFilters = F3(
	function (t_, maybeClassrooms, filter) {
		var selectedClassrooms = A2($elm$core$List$map, $elm$core$String$fromInt, filter.gx);
		var viewClassroomOptions = function (classrooms) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetClassroomFilter,
					'portfolios-filter-classrooms',
					$elm$core$Basics$always(false),
					selectedClassrooms),
				$author$project$Form$toSelectOptions(
					A2(
						$elm$core$List$append,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'-1',
								t_($author$project$Locale$Messages$PortfoliosFilterNone))
							]),
						A2(
							$elm$core$List$map,
							function (classroom) {
								return _Utils_Tuple2(
									$elm$core$String$fromInt(classroom.gT),
									classroom.jJ);
							},
							A2(
								$author$project$Util$List$sortBy,
								function ($) {
									return $.jJ;
								},
								classrooms)))));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterClassrooms),
				gQ: true,
				mp: maybeClassrooms,
				hJ: viewClassroomOptions
			});
	});
var $author$project$Locale$Messages$PortfoliosFilterOwnModules = {$: 399};
var $author$project$Element$PortfolioList$viewModuleFilters = F3(
	function (t_, maybeModules, filter) {
		var selectedModules = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$core$String$fromInt),
			filter.g9);
		var viewModuleOptions = function (modules) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetModuleFilter,
					'portfolios-filter-modules',
					$elm$core$Basics$always(false),
					selectedModules),
				$author$project$Form$toSortedSelectOptions(
					A2(
						$elm$core$List$map,
						function (module_) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(
									$author$project$Module$moduleIdToInt(module_.gT)),
								module_.jJ);
						},
						modules)));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterOwnModules),
				gQ: true,
				mp: maybeModules,
				hJ: viewModuleOptions
			});
	});
var $author$project$Element$PortfolioList$viewSingleElement = F3(
	function (session, story, singleElementModel) {
		var single = $author$project$Element$PortfolioList$singleElement(story.gT);
		return A3($author$project$Application$V3$Boundaries$viewElement, session, singleElementModel, single);
	});
var $author$project$Form$toPeopleOptions = F2(
	function (t_, people) {
		return A2(
			$elm$core$List$map,
			function (person) {
				return $author$project$Form$toSelectOption(
					_Utils_Tuple2(
						$elm$core$String$fromInt(person.gT),
						A2($author$project$Person$fullName, t_, person)));
			},
			A2(
				$author$project$Util$List$sortBy,
				$author$project$Person$fullName(t_),
				people));
	});
var $author$project$Element$PortfolioList$viewStudentFilters = F3(
	function (t_, maybeStudents, filter) {
		var selectedStudents = A2($elm$core$List$map, $elm$core$String$fromInt, filter.e1);
		var viewStudentOptions = function (students) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetStudentFilter,
					'portfolios-filter-students',
					$elm$core$Basics$always(false),
					selectedStudents),
				A2($author$project$Form$toPeopleOptions, t_, students));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterStudents),
				gQ: true,
				mp: maybeStudents,
				hJ: viewStudentOptions
			});
	});
var $author$project$Element$PortfolioList$FilterChildren = 3;
var $author$project$Element$PortfolioList$FilterCreator = 2;
var $author$project$Element$PortfolioList$FilterSchools = 1;
var $author$project$Element$PortfolioList$GotCategoryFilter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$PortfoliosFilterAll = {$: 393};
var $author$project$Locale$Messages$PortfoliosFilterChildren = {$: 394};
var $author$project$Locale$Messages$PortfoliosFilterOwnPortfolios = {$: 396};
var $author$project$Locale$Messages$PortfoliosFilterOwnSchools = {$: 395};
var $author$project$ACL$canViewPortfoliosAll = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$ACL$isAuditor(person);
};
var $author$project$UI$List$filterBar = F3(
	function (t_, _v0, filters) {
		var toMsg = _v0.a;
		var currentFilter = _v0.b;
		var hideSingleTab = function (filters_) {
			return ($elm$core$List$length(filters_) > 1) ? filters_ : _List_Nil;
		};
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var filter = _v1.bO;
				var dataTag = _v1.kJ;
				var label = _v1.lO;
				var isEnabled = _v1.g_;
				return A3(
					$author$project$UI$actionLink,
					toMsg(filter),
					_List_fromArray(
						[
							$author$project$UI$attrCyData('filter-' + dataTag),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'is-active',
									_Utils_eq(currentFilter, filter)),
									_Utils_Tuple2('is-disabled has-text-grey-light', !isEnabled)
								]))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, label)
						]));
			},
			hideSingleTab(
				A2(
					$elm$core$List$filter,
					function ($) {
						return $.g$;
					},
					filters)));
	});
var $author$project$Element$PortfolioList$viewTabFilters = F3(
	function (t_, viewer, filter) {
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$PortfolioList$GotCategoryFilter, filter),
			_List_fromArray(
				[
					{
					kJ: 'mine',
					bO: 2,
					g_: true,
					g$: $author$project$ACL$canCreatePortfolios(viewer),
					lO: $author$project$Locale$Messages$PortfoliosFilterOwnPortfolios
				},
					{
					kJ: 'children',
					bO: 3,
					g_: true,
					g$: $author$project$Person$isSponsor(viewer),
					lO: $author$project$Locale$Messages$PortfoliosFilterChildren
				},
					{
					kJ: 'own-schools',
					bO: 1,
					g_: true,
					g$: $author$project$ACL$canViewPortfoliosSchool(viewer),
					lO: $author$project$Locale$Messages$PortfoliosFilterOwnSchools
				},
					{
					kJ: 'all',
					bO: 0,
					g_: true,
					g$: $author$project$ACL$canViewPortfoliosAll(viewer),
					lO: $author$project$Locale$Messages$PortfoliosFilterAll
				}
				]));
	});
var $author$project$Element$PortfolioList$viewTeacherFilters = F3(
	function (t_, maybeTeachers, filter) {
		var selectedTeachers = A2($elm$core$List$map, $elm$core$String$fromInt, filter.e5);
		var viewTeacherOptions = function (teachers) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$PortfolioList$SetTeacherFilter,
					'portfolios-filter-teachers',
					$elm$core$Basics$always(false),
					selectedTeachers),
				A2($author$project$Form$toPeopleOptions, t_, teachers));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterTeachers),
				gQ: true,
				mp: maybeTeachers,
				hJ: viewTeacherOptions
			});
	});
var $author$project$Locale$Messages$PortfoliosFilterTypeAll = {$: 404};
var $author$project$Locale$Messages$PortfoliosFilterTypeFeedback = {$: 405};
var $author$project$Locale$Messages$PortfoliosFilterTypeMClosure = {$: 406};
var $author$project$Element$PortfolioList$filterToForm = function (type_) {
	switch (type_) {
		case 0:
			return '';
		case 1:
			return 'feedback';
		default:
			return 'mclosure';
	}
};
var $author$project$Element$PortfolioList$viewTypeFilter = F2(
	function (t_, filter) {
		var viewOption = function (option) {
			return A4(
				$author$project$UI$radioButton,
				$author$project$Element$PortfolioList$SetTypeFilter,
				'option-type-' + option.nD,
				$author$project$Element$PortfolioList$filterToForm(filter.hH),
				option);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterType)
								])),
							viewOption(
							{
								lO: t_($author$project$Locale$Messages$PortfoliosFilterTypeAll),
								nD: ''
							}),
							viewOption(
							{
								lO: t_($author$project$Locale$Messages$PortfoliosFilterTypeFeedback),
								nD: 'feedback'
							}),
							viewOption(
							{
								lO: t_($author$project$Locale$Messages$PortfoliosFilterTypeMClosure),
								nD: 'mclosure'
							})
						]))
				]));
	});
var $author$project$Element$PortfolioList$viewStoryList = F3(
	function (session, _v0, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var modules = _v0.g9;
		var people = _v0.mw;
		var classrooms = _v0.gx;
		var filter = model.bO;
		var stories = model.e$;
		var viewLoadingState = function () {
			var _v1 = _Utils_Tuple2(model.cY, stories);
			if (!_v1.b.b) {
				switch (_v1.a.$) {
					case 0:
						var _v2 = _v1.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$PortfoliosEmptyResults)
							]);
					default:
						var _v3 = _v1.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$PortfoliosEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewKeyedItem = function (story) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(story.gT),
				A2(
					$author$project$UI$maybe,
					A2($elm$core$Dict$get, story.gT, model.cw),
					A2($author$project$Element$PortfolioList$viewSingleElement, session, story)));
		};
		var viewFilterButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Events$onClick($author$project$Element$PortfolioList$ToggleFilterPanel),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-info', model.eA),
							_Utils_Tuple2('is-info is-light', !model.eA)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnToggleFilters)
						]))
				]));
		var students = ($author$project$ACL$isStaff(viewer) || $author$project$Person$isModuleTeacher(viewer)) ? A2($elm$core$Maybe$map, $author$project$Person$students, people) : ($author$project$Person$isSponsor(viewer) ? A2(
			$elm$core$Maybe$map,
			$elm$core$List$filter(
				$author$project$Person$isSponsorOf(viewer)),
			people) : $elm$core$Maybe$Just(
			_List_fromArray(
				[viewer])));
		var viewFilterPanel = model.eA ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container columns')
					]),
				_List_fromArray(
					[
						A2($author$project$Element$PortfolioList$viewTypeFilter, t_, filter),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canCreateModules(viewer),
						A3($author$project$Element$PortfolioList$viewModuleFilters, t_, modules, filter)),
						A3($author$project$Element$PortfolioList$viewStudentFilters, t_, students, filter),
						A3(
						$author$project$Element$PortfolioList$viewTeacherFilters,
						t_,
						A2($elm$core$Maybe$map, $author$project$Person$teachers, people),
						filter),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewClassrooms(viewer),
						A3($author$project$Element$PortfolioList$viewClassroomFilters, t_, classrooms, filter))
					]))
			]) : A2($author$project$Element$PortfolioList$viewActiveFilters, t_, filter);
		var maybeModuleId = A2(
			$elm$core$Maybe$map,
			$author$project$Module$moduleIdToInt,
			$elm$core$List$head(filter.g9));
		return $author$project$UI$keyedPanel(
			{
				kt: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											aT: $author$project$Element$PortfolioList$GotListQuery,
											bv: t_($author$project$Locale$Messages$PortfoliosSearch),
											bw: model.bw
										})
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column is-narrow')
									]),
								_List_fromArray(
									[viewFilterButton]))
							])),
					_Utils_ap(viewFilterPanel, viewLoadingState)),
				kJ: 'portfolios-list',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosTitle)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								$author$project$ACL$canCreatePortfolios(viewer),
								A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href(
											$author$project$Route$PortfoliosCreate(maybeModuleId)),
											$elm$html$Html$Attributes$title(
											t_($author$project$Locale$Messages$NavPortfoliosNew))
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$add(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-white')
												]))
										])))
							]))
					]),
				lN: A2($elm$core$List$map, viewKeyedItem, stories),
				nk: A3($author$project$Element$PortfolioList$viewTabFilters, t_, viewer, filter.bs),
				nq: 'is-link'
			});
	});
var $author$project$Locale$Messages$PortfoliosListLoadMore = {$: 407};
var $author$project$UI$Icon$sync = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-sync'),
			attributes));
};
var $author$project$Element$PortfolioList$viewStoryListPager = F2(
	function (t_, _v0) {
		var loading = _v0.cY;
		var stories = _v0.e$;
		var _v1 = _Utils_Tuple2(loading, stories);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$PortfolioList$LoadMoreStories,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$PortfolioList$view = function (model) {
	var store = model.bd;
	var session = model.cv;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Element$PortfolioList$viewStoryList, session, store, model),
				A2($author$project$Element$PortfolioList$viewStoryListPager, session.hy, model)
			]));
};
var $author$project$Element$PortfolioList$element = {iA: $author$project$Element$PortfolioList$init, hh: $author$project$Element$PortfolioList$perform, jR: $author$project$Element$PortfolioList$update, nE: $author$project$Element$PortfolioList$view};
var $author$project$Element$HomePage$portfolios = {
	gF: $author$project$Element$PortfolioList$element,
	bZ: $author$project$Element$HomePage$ListElementMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					eQ: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$HomePage$init = F3(
	function (config, session, _v0) {
		var params = $author$project$Element$PortfolioList$defaultParams;
		var model = {fd: $elm$core$Maybe$Nothing, bN: config, fN: $elm$core$Maybe$Nothing, eQ: $elm$core$Maybe$Nothing, e1: $elm$core$Maybe$Nothing};
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var openPortfolios = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			noop,
			$author$project$Element$HomePage$portfolios,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				config.iJ,
				$author$project$Application$V2$SharedConfig$fromV1(config),
				session,
				$author$project$Element$HomePage$portfolios,
				_Utils_update(
					params,
					{mn: true})));
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Element$HomePage$TimeIsNow, $elm$time$Time$now),
					A2($author$project$Student$fetchActiveAndFutureStudents, config.gr, $author$project$Element$HomePage$StudentsDownloaded),
					A2($author$project$ActivityLog$fetchActivityLogs, config.gr, $author$project$Element$HomePage$ActivityLogListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			$author$project$Element$HomePage$hasPortfolioFeed(session.nH) ? {dz: openPortfolios.dz, dY: openPortfolios.dY, fY: $elm$core$Maybe$Nothing, cv: openPortfolios.cv} : noop);
	});
var $author$project$Locale$Messages$ActivityLogsDownloadError = {$: 4};
var $author$project$Route$AnalyticsLearningContract = {$: 48};
var $author$project$Element$HomePage$NoOp = {$: 1};
var $author$project$Locale$Messages$StudentListDownloadError = {$: 573};
var $author$project$Log$msgActivityLogsDownload = 'activitylogs_download';
var $author$project$Log$msgStudentsDownload = 'students_download';
var $author$project$Locale$Messages$AnalyticsLearningContractTitle = {$: 17};
var $author$project$Locale$Messages$CounterPageTitle = {$: 45};
var $author$project$Locale$Messages$GenericPageTitle = {$: 73};
var $author$project$Locale$Messages$GradeReportsPageTitle = {$: 87};
var $author$project$Locale$Messages$LearningContractsTitle = {$: 146};
var $author$project$Locale$Messages$LearningGroupListTitle = {$: 166};
var $author$project$Locale$Messages$LoBrowserPageTitle = {$: 177};
var $author$project$Locale$Messages$LoginPageTitle = {$: 174};
var $author$project$Locale$Messages$ModuleClosureOverviewPageTitle = {$: 220};
var $author$project$Locale$Messages$ModuleTeacherProfilesPageTitle = {$: 244};
var $author$project$Locale$Messages$ModulesClosurePageTitle = {$: 259};
var $author$project$Locale$Messages$ModulesTitle = {$: 312};
var $author$project$Locale$Messages$NotificationsTitle = {$: 343};
var $author$project$Locale$Messages$PhoneBookTitle = {$: 376};
var $author$project$Locale$Messages$RubricSubjectOverviewTitle = {$: 459};
var $author$project$Locale$Messages$StudentListTitleStudents = {$: 577};
var $author$project$Locale$Messages$StudentProfileFormPageTitle = {$: 567};
var $author$project$Locale$Messages$SubjectFeedbackCardTitle = {$: 591};
var $author$project$Locale$Messages$TeacherProfilesPageTitle = {$: 623};
var $author$project$Locale$Messages$TimetablePageTitle = {$: 651};
var $author$project$Locale$Messages$TrimesterFeedbackReportPageTitle = {$: 676};
var $author$project$Route$pageTitle = F2(
	function (t_, route) {
		switch (route.$) {
			case 48:
				return t_($author$project$Locale$Messages$AnalyticsLearningContractTitle);
			case 0:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 1:
				return t_($author$project$Locale$Messages$LoginPageTitle);
			case 2:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 3:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 4:
				return t_($author$project$Locale$Messages$CounterPageTitle);
			case 5:
				return t_(
					$author$project$Locale$Messages$NOTRANS('Hiányzások'));
			case 6:
				return t_($author$project$Locale$Messages$GradeReportsPageTitle);
			case 8:
				return t_($author$project$Locale$Messages$GradesOverviewTitle);
			case 7:
				return t_($author$project$Locale$Messages$GradeRequestListTitle);
			case 9:
				return t_($author$project$Locale$Messages$GenericPageTitle);
			case 10:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 11:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 12:
				return t_($author$project$Locale$Messages$LearningContractsTitle);
			case 13:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 14:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 15:
				return t_($author$project$Locale$Messages$LearningGroupListTitle);
			case 16:
				return t_($author$project$Locale$Messages$LoBrowserPageTitle);
			case 17:
				return t_($author$project$Locale$Messages$ModuleClosureOverviewPageTitle);
			case 18:
				return t_($author$project$Locale$Messages$ModulesClosurePageTitle);
			case 19:
				return t_($author$project$Locale$Messages$ModuleTeacherProfilesPageTitle);
			case 20:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 21:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 22:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 23:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 24:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 25:
				return t_($author$project$Locale$Messages$ModulesTitle);
			case 26:
				return t_($author$project$Locale$Messages$NotificationsTitle);
			case 27:
				return t_($author$project$Locale$Messages$PhoneBookTitle);
			case 28:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 29:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 30:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 31:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 32:
				return t_($author$project$Locale$Messages$PortfoliosTitle);
			case 33:
				return t_($author$project$Locale$Messages$ProfilesTitle);
			case 34:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 35:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 38:
				return t_($author$project$Locale$Messages$RubricSubjectOverviewTitle);
			case 36:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 37:
				return t_($author$project$Locale$Messages$RubricsTitle);
			case 39:
				return t_($author$project$Locale$Messages$StudentProfileFormPageTitle);
			case 40:
				return t_($author$project$Locale$Messages$StudentProfileFormPageTitle);
			case 41:
				return t_($author$project$Locale$Messages$StudentListTitleStudents);
			case 42:
				return t_($author$project$Locale$Messages$SubjectFeedbackCardTitle);
			case 43:
				return t_($author$project$Locale$Messages$TeacherProfilesPageTitle);
			case 44:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			case 45:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			case 46:
				return t_($author$project$Locale$Messages$TimetablePageTitle);
			default:
				return t_($author$project$Locale$Messages$TrimesterFeedbackReportPageTitle);
		}
	});
var $author$project$Log$paramScopeHome = 'scope_home';
var $author$project$Ports$sendPageView = _Platform_outgoingPort(
	'sendPageView',
	function ($) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'pagePath',
					$elm$json$Json$Encode$string($.ms)),
					_Utils_Tuple2(
					'pageTitle',
					$elm$json$Json$Encode$string($.mt))
				]));
	});
var $author$project$Application$V2$Boundaries$updateElement = F5(
	function (key, session, msg, model, element) {
		var _v0 = A2(
			element.gF.jR,
			msg,
			_Utils_update(
				model,
				{cv: session}));
		var model2 = _v0.a;
		var effect = _v0.b;
		var reply = _v0.c;
		var cmd = A2(element.gF.hh, key, effect);
		return A2(
			$author$project$Application$V2$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$V2$Boundaries$addReply,
				reply,
				A2($author$project$Application$V2$Boundaries$save, model2, model2.cv)));
	});
var $author$project$Element$HomePage$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var updatePortfolios = F2(
			function (portfoliosMsg, portfoliosModel) {
				return A3(
					$author$project$Application$V2$Boundaries$mapElement,
					noop,
					$author$project$Element$HomePage$portfolios,
					A5($author$project$Application$V2$Boundaries$updateElement, model.bN.iJ, session, portfoliosMsg, portfoliosModel, $author$project$Element$HomePage$portfolios));
			});
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var list = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								fd: $elm$core$Maybe$Just(list)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3(
								$author$project$Log$msgActivityLogsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeHome),
								error),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$ActivityLogsDownloadError))));
				}
			case 1:
				return noop;
			case 2:
				var posix = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							fN: $elm$core$Maybe$Just(posix)
						}),
					session);
			case 3:
				if (!msg.a.$) {
					var students = msg.a.a;
					var isSponsoredOrViewer = function (student) {
						return A2($author$project$Person$isSponsorOf, session.nH, student) || A2($author$project$Person$isSamePerson, session.nH, student);
					};
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$ok,
							model.bN,
							_Utils_Tuple2(
								$author$project$Log$msgStudentsDownload,
								_List_fromArray(
									[$author$project$Log$paramScopeHome, $author$project$Log$paramOk])),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									e1: $elm$core$Maybe$Just(
										A2($elm$core$List$filter, isSponsoredOrViewer, students))
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3(
								$author$project$Log$msgStudentsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeHome),
								error),
							$elm$core$Basics$always($author$project$Element$HomePage$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$StudentListDownloadError))));
				}
			case 4:
				var cmd = $author$project$Ports$sendPageView(
					{
						ms: $author$project$Route$toString($author$project$Route$AnalyticsLearningContract),
						mt: A2($author$project$Route$pageTitle, t_, $author$project$Route$AnalyticsLearningContract)
					});
				return A2($author$project$Application$Boundaries$andThenCmd, cmd, noop);
			default:
				var portfoliosMsg = msg.a;
				var _v1 = model.eQ;
				if (!_v1.$) {
					var portfoliosModel = _v1.a;
					var portfoliosUpdated = A2(updatePortfolios, portfoliosMsg, portfoliosModel);
					return {dz: portfoliosUpdated.dz, dY: portfoliosUpdated.dY, fY: $elm$core$Maybe$Nothing, cv: portfoliosUpdated.cv};
				} else {
					return noop;
				}
		}
	});
var $author$project$Element$HomePage$hasStudentTiles = function (viewer) {
	return $author$project$Person$isSponsor(viewer) || $author$project$Person$isStudent(viewer);
};
var $author$project$Element$HomePage$hasTeacherTiles = function (viewer) {
	return $author$project$ACL$isStaff(viewer) || $author$project$Person$isModuleTeacher(viewer);
};
var $author$project$Locale$Messages$ActivityLogsEmpty = {$: 8};
var $author$project$Locale$Messages$ActivityLogsLoadingProgress = {$: 7};
var $author$project$Locale$Messages$ActivityLogsTitle = {$: 15};
var $author$project$Locale$Messages$ActivityLogsView = {$: 16};
var $author$project$Locale$Messages$TimeSingleFormat = F2(
	function (a, b) {
		return {$: 630, a: a, b: b};
	});
var $author$project$UI$Icon$learningContract = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-handshake'),
			attributes));
};
var $author$project$UI$Icon$mentorMemo = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-clipboard'),
			attributes));
};
var $author$project$Element$NotificationList$activityTypeToIcon = function (type_) {
	switch (type_) {
		case 0:
			return $author$project$UI$Icon$learningContract(_List_Nil);
		case 2:
			return $author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-image')
					]));
		case 3:
			return $author$project$UI$Icon$icon(
				_List_fromArray(
					[
						$author$project$UI$Icon$face('fa-id-card')
					]));
		case 1:
			return $author$project$UI$Icon$mentorMemo(_List_Nil);
		default:
			return $author$project$UI$none;
	}
};
var $author$project$Locale$Messages$ActivityLogsChangesCaption = {$: 1};
var $author$project$Locale$Messages$ActivityLogsChangesItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ActivityLogsChangesItemDiff = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$ActivityLog$changes = F2(
	function (dict1, dict2) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var field = _v0.a;
				var oldValue = _v0.b;
				var v = A2($elm$core$Dict$get, field, dict2);
				if (!v.$) {
					var newValue = v.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(field, oldValue, newValue));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			},
			$elm$core$Dict$toList(dict1));
	});
var $author$project$Locale$Messages$LearningContractsEndDate = {$: 132};
var $author$project$Locale$Messages$LearningContractsStartDate = {$: 133};
var $author$project$Locale$Messages$LearningContractsStudent = {$: 134};
var $author$project$Locale$Messages$LearningContractsUrl = {$: 135};
var $author$project$LearningContract$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'student':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsStudent));
			case 'end_date':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsEndDate));
			case 'start_date':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsStartDate));
			case 'url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$LearningContractsUrl));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesCompetencies = {$: 241};
var $author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress = {$: 240};
var $author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit = {$: 239};
var $author$project$ModuleTeacherProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'residence_permit':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit));
			case 'residence_address':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress));
			case 'competencies':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$PersonEduId = {$: 366};
var $author$project$Locale$Messages$PersonNationality = {$: 364};
var $author$project$Locale$Messages$PersonSsn = {$: 365};
var $author$project$Locale$Messages$PersonSupervisingSchool = {$: 367};
var $author$project$Locale$Messages$PersonTeam = {$: 352};
var $author$project$Person$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonFirstName));
			case 'last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonLastName));
			case 'phone_number':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonPhone));
			case 'email':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonEmail));
			case 'birthplace':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthPlaceTown));
			case 'birthplace_country':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthPlaceCountry));
			case 'birthdate':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonBirthDate));
			case 'nationality':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonNationality));
			case 'edu_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonEduId));
			case 'ssn':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonSsn));
			case 'supervising_school':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonSupervisingSchool));
			case 'address':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonAddress));
			case 'team':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PersonTeam));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$PortfolioStoryCreatedAt = {$: 387};
var $author$project$Locale$Messages$PortfolioStoryCreatedBy = {$: 386};
var $author$project$Locale$Messages$PortfolioStoryDescription = {$: 383};
var $author$project$Locale$Messages$PortfolioStoryMedia = {$: 384};
var $author$project$Locale$Messages$PortfolioStoryModule = {$: 385};
var $author$project$Locale$Messages$PortfolioStoryStudents = {$: 389};
var $author$project$Locale$Messages$PortfolioStoryTeam = {$: 388};
var $author$project$PortfolioStory$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'description':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryDescription));
			case 'media':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryMedia));
			case 'module':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryModule));
			case 'created_by':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryCreatedBy));
			case 'created_at':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryCreatedAt));
			case 'team':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryTeam));
			case 'students':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$PortfolioStoryStudents));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$StudentProfileFormAccidents = {$: 532};
var $author$project$Locale$Messages$StudentProfileFormAdmission = {$: 527};
var $author$project$Locale$Messages$StudentProfileFormBasicTask = {$: 529};
var $author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl = {$: 551};
var $author$project$Locale$Messages$StudentProfileFormCompetencyTestResults = {$: 533};
var $author$project$Locale$Messages$StudentProfileFormCurrentSchoolYear = {$: 547};
var $author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases = {$: 537};
var $author$project$Locale$Messages$StudentProfileFormEvaluationUrl = {$: 535};
var $author$project$Locale$Messages$StudentProfileFormExams = {$: 536};
var $author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage = {$: 548};
var $author$project$Locale$Messages$StudentProfileFormIdCardUrl = {$: 552};
var $author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl = {$: 546};
var $author$project$Locale$Messages$StudentProfileFormIsIndividualStudent = {$: 545};
var $author$project$Locale$Messages$StudentProfileFormLastReportCardUrl = {$: 534};
var $author$project$Locale$Messages$StudentProfileFormMissedClasses = {$: 531};
var $author$project$Locale$Messages$StudentProfileFormMothersMaidenName = {$: 528};
var $author$project$Locale$Messages$StudentProfileFormNekId = {$: 556};
var $author$project$Locale$Messages$StudentProfileFormNekIdUrl = {$: 557};
var $author$project$Locale$Messages$StudentProfileFormResidencePermitUrl = {$: 526};
var $author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition = {$: 540};
var $author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage = {$: 549};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatus = {$: 542};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl = {$: 544};
var $author$project$Locale$Messages$StudentProfileFormSsnUrl = {$: 555};
var $author$project$Locale$Messages$StudentProfileFormState = {$: 525};
var $author$project$Locale$Messages$StudentProfileFormStudentCardId = {$: 538};
var $author$project$Locale$Messages$StudentProfileFormTaxIdUrl = {$: 554};
var $author$project$Locale$Messages$StudentProfileFormTermination = {$: 530};
var $author$project$Locale$Messages$StudentProfileFormTextbookSupply = {$: 539};
var $author$project$Locale$Messages$StudentProfileFormTripAbroad = {$: 541};
var $author$project$StudentProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'state':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormState));
			case 'mothers_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName));
			case 'admission':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormAdmission));
			case 'basic_task':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormBasicTask));
			case 'termination':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTermination));
			case 'missed_classes':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormMissedClasses));
			case 'accidents':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormAccidents));
			case 'competency_test_results':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults));
			case 'exams':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormExams));
			case 'disciplinary_and_compensation_cases':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases));
			case 'student_card_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormStudentCardId));
			case 'textbook_supply':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply));
			case 'school_year_repetition':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition));
			case 'trip_abroad':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTripAbroad));
			case 'sni_status':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSpecialStatus));
			case 'is_individual_student':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIsIndividualStudent));
			case 'current_school_year':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormCurrentSchoolYear));
			case 'first_foreign_language':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage));
			case 'second_foreign_language':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage));
			case 'last_report_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl));
			case 'evaluation_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl));
			case 'individual_student_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl));
			case 'sni_report_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl));
			case 'student_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormStudentCardId));
			case 'birth_certificate_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl));
			case 'residence_permit_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl));
			case 'id_card_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl));
			case 'tax_id_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl));
			case 'ssn_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormSsnUrl));
			case 'nek_id':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormNekId));
			case 'nek_id_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl));
			default:
				var field_ = field;
				return A2($elm$core$String$startsWith, 'student_', field_) ? A2(
					$author$project$Person$fieldLabel,
					t_,
					A3($elm$core$String$replace, 'student_', '', field_)) : $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Locale$Messages$TeacherProfileApprenticeshipYears = {$: 611};
var $author$project$Locale$Messages$TeacherProfileBirthFirstName = {$: 603};
var $author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst = {$: 605};
var $author$project$Locale$Messages$TeacherProfileBirthLastName = {$: 604};
var $author$project$Locale$Messages$TeacherProfileDiplomaUrl = {$: 613};
var $author$project$Locale$Messages$TeacherProfileHighestEducationLevel = {$: 610};
var $author$project$Locale$Messages$TeacherProfileIsAcademicMember = {$: 612};
var $author$project$Locale$Messages$TeacherProfileMotherFirstName = {$: 607};
var $author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst = {$: 609};
var $author$project$Locale$Messages$TeacherProfileMotherLastName = {$: 608};
var $author$project$Locale$Messages$TeacherProfileMotherNamePrefix = {$: 606};
var $author$project$Locale$Messages$TeacherProfileState = {$: 601};
var $author$project$Locale$Messages$TeacherProfileTeacher = {$: 602};
var $author$project$TeacherProfile$fieldLabel = F2(
	function (t_, field) {
		switch (field) {
			case 'state':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileState));
			case 'teacher':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileTeacher));
			case 'birth_first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthFirstName));
			case 'birth_last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthLastName));
			case 'birth_has_family_name_first':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst));
			case 'mother_name_prefix':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix));
			case 'mother_first_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherFirstName));
			case 'mother_last_name':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherLastName));
			case 'mother_has_family_name_first':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst));
			case 'highest_education_level':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileHighestEducationLevel));
			case 'apprenticeship_years':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears));
			case 'is_academic_member':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileIsAcademicMember));
			case 'diploma_url':
				return $elm$core$Maybe$Just(
					t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl));
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Element$NotificationList$fieldLabel = F3(
	function (t_, messageType, field) {
		var noTrans = F2(
			function (_v1, x) {
				return $elm$core$Maybe$Just(x);
			});
		var label = function () {
			switch (messageType) {
				case 0:
					return $author$project$LearningContract$fieldLabel;
				case 1:
					return $author$project$LearningContract$fieldLabel;
				case 2:
					return noTrans;
				case 3:
					return $author$project$ModuleTeacherProfile$fieldLabel;
				case 4:
					return $author$project$PortfolioStory$fieldLabel;
				case 5:
					return $author$project$PortfolioStory$fieldLabel;
				case 6:
					return $author$project$Person$fieldLabel;
				case 7:
					return $author$project$StudentProfile$fieldLabel;
				case 8:
					return $author$project$TeacherProfile$fieldLabel;
				default:
					return noTrans;
			}
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			field,
			A2(label, t_, field));
	});
var $author$project$StudentProfile$studentDocumentFields = _List_fromArray(
	['last_report_card_url', 'evaluation_url', 'individual_student_url', 'sni_report_url', 'student_card_url', 'birth_certificate_url', 'residence_permit_url', 'id_card_url', 'tax_id_url', 'ssn_url', 'nek_id_url']);
var $author$project$TeacherProfile$teacherDocumentFields = _List_fromArray(
	['diploma_url']);
var $author$project$Element$NotificationList$viewChanges = F3(
	function (t_, msg, context) {
		var diffToText = function (_v1) {
			var fieldName = _v1.a;
			var oldValue = _v1.b;
			var newValue = _v1.c;
			return A2($elm$core$List$member, fieldName, $author$project$StudentProfile$studentDocumentFields) ? t_(
				$author$project$Locale$Messages$ActivityLogsChangesItem(
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.l0, fieldName))) : (A2($elm$core$List$member, fieldName, $author$project$TeacherProfile$teacherDocumentFields) ? t_(
				$author$project$Locale$Messages$ActivityLogsChangesItem(
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.l0, fieldName))) : t_(
				A3(
					$author$project$Locale$Messages$ActivityLogsChangesItemDiff,
					A3($author$project$Element$NotificationList$fieldLabel, t_, msg.l0, fieldName),
					oldValue,
					newValue)));
		};
		var changes = A2($author$project$ActivityLog$changes, context.k4, context.nr);
		var changesText = A2(
			$elm$core$String$join,
			', ',
			A2($elm$core$List$map, diffToText, changes));
		if (!changes.b) {
			return $author$project$UI$none;
		} else {
			return A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsChangesCaption),
						$elm$html$Html$text(changesText)
					]));
		}
	});
var $author$project$Locale$Messages$ActivityLogsLearningContractCreated = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsLearningContractUpdated = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsMentorMemoUpdated = function (a) {
	return {$: 9, a: a};
};
var $author$project$Locale$Messages$ActivityLogsModuleTeacherProfileUpdated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$ActivityLogsPortfolioStoryCreated = function (a) {
	return {$: 11, a: a};
};
var $author$project$Locale$Messages$ActivityLogsProfileUpdated = function (a) {
	return {$: 12, a: a};
};
var $author$project$Locale$Messages$ActivityLogsStudentProfileUpdated = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Locale$Messages$ActivityLogsTeacherProfileUpdated = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$NotificationList$viewMessage = F2(
	function (t_, log) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-marginless')
				]),
			_List_fromArray(
				[
					function () {
					if (!log.$) {
						var msg = log.a;
						var context = log.b;
						var _v1 = msg.l0;
						switch (_v1) {
							case 1:
								var teacher = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'teacher', context.kZ));
								var student = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsLearningContractUpdated, teacher, student))));
							case 0:
								var teacher = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'teacher', context.kZ));
								var student = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsLearningContractCreated, teacher, student))));
							case 6:
								var person = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsProfileUpdated(person))));
							case 7:
								var student = A2($author$project$Person$fullName, t_, msg.mx);
								var approvedBy = A2(
									$elm$core$Maybe$withDefault,
									'',
									A2($elm$core$Dict$get, 'approved_by', context.kZ));
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											A2($author$project$Locale$Messages$ActivityLogsStudentProfileUpdated, approvedBy, student))));
							case 8:
								var teacher = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsTeacherProfileUpdated(teacher))));
							case 3:
								var teacher = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsModuleTeacherProfileUpdated(teacher))));
							case 2:
								var person = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$span,
									_List_Nil,
									$author$project$UI$textToHtml(
										t_(
											$author$project$Locale$Messages$ActivityLogsMentorMemoUpdated(person))));
							default:
								return $author$project$UI$none;
						}
					} else {
						var msg = log.a;
						var context = log.b;
						var _v2 = msg.l0;
						switch (_v2) {
							case 4:
								var viewMedia = function (media) {
									return A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												function () {
												var _v3 = $author$project$Util$Media$mediaViewerByExt(media);
												if (!_v3) {
													return A2(
														$elm$html$Html$img,
														_List_fromArray(
															[
																$elm$html$Html$Attributes$src(media)
															]),
														_List_Nil);
												} else {
													return $author$project$UI$none;
												}
											}()
											]));
								};
								var student = A2($author$project$Person$fullName, t_, msg.mx);
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$author$project$UI$caption,
													t_,
													$author$project$Locale$Messages$ActivityLogsPortfolioStoryCreated(student))
												])),
											A2($author$project$UI$maybe, context.lY.m4, viewMedia)
										]));
							case 5:
								return $author$project$UI$none;
							default:
								return $author$project$UI$none;
						}
					}
				}()
				]));
	});
var $author$project$Element$NotificationList$viewActivityLog = F3(
	function (t_, now, log) {
		var viewTime = function (msg) {
			if (!now.$) {
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							A2(
								$author$project$Locale$Messages$TimeDateFormat,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(msg.ld))),
							$elm$html$Html$text(' '),
							A2(
							$author$project$UI$caption,
							t_,
							A2(
								$author$project$Locale$Messages$TimeSingleFormat,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(msg.ld)))
						]));
			} else {
				return $author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-spinner fa-spin fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]));
			}
		};
		var viewLink = function (msg) {
			return A2(
				$author$project$UI$when,
				!$elm$core$String$isEmpty(msg.mi),
				A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(msg.mi),
							$elm$html$Html$Attributes$class('mr-4')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsView)
						])));
		};
		var viewNav = function (msg) {
			return A2(
				$author$project$UI$nav,
				_List_fromArray(
					[
						viewLink(msg),
						viewTime(msg)
					]),
				_List_Nil);
		};
		var viewIcon = function (msg) {
			return $author$project$Element$NotificationList$activityTypeToIcon(msg.ka);
		};
		if (!log.$) {
			var msg = log.a;
			var context = log.b;
			return A4(
				$author$project$UI$mediaObjectXS,
				_List_fromArray(
					[
						viewIcon(msg)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$NotificationList$viewMessage, t_, log),
						A3($author$project$Element$NotificationList$viewChanges, t_, msg, context)
					]),
				_List_fromArray(
					[
						viewNav(msg)
					]),
				_List_Nil);
		} else {
			var msg = log.a;
			return A4(
				$author$project$UI$mediaObjectXS,
				_List_fromArray(
					[
						viewIcon(msg)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$NotificationList$viewMessage, t_, log)
					]),
				_List_fromArray(
					[
						viewNav(msg)
					]),
				_List_Nil);
		}
	});
var $author$project$Element$NotificationList$viewActivityLogs = F3(
	function (t_, now, maybeLogs) {
		if (!maybeLogs.$) {
			if (!maybeLogs.a.b) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsEmpty)
						]));
			} else {
				var logs = maybeLogs.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('heading')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ActivityLogsTitle)
								])),
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('list')
								]),
							A2(
								$elm$core$List$map,
								function (log) {
									return A2(
										$elm$html$Html$li,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('list-item')
											]),
										_List_fromArray(
											[
												A3($author$project$Element$NotificationList$viewActivityLog, t_, now, log)
											]));
								},
								A2(
									$elm$core$List$filter,
									function (log) {
										if (!log.$) {
											var msg = log.a;
											return msg.l0 !== 9;
										} else {
											var msg = log.a;
											return msg.l0 !== 9;
										}
									},
									logs)))
						]));
			}
		} else {
			return A2(
				$author$project$UI$progressBar,
				'is-link',
				t_($author$project$Locale$Messages$ActivityLogsLoadingProgress));
		}
	});
var $author$project$Application$V2$Boundaries$viewElement = F3(
	function (session, model, element) {
		return A2(
			$elm$html$Html$map,
			element.bZ,
			element.gF.nE(
				_Utils_update(
					model,
					{cv: session})));
	});
var $author$project$Element$HomePage$viewPortfolios = F2(
	function (session, model) {
		return A3($author$project$Application$V2$Boundaries$viewElement, session, model, $author$project$Element$HomePage$portfolios);
	});
var $author$project$Locale$Messages$HomePhoneBookTileContent = {$: 122};
var $author$project$Locale$Messages$HomePhoneBookTileTitle = {$: 123};
var $author$project$UI$tile = F4(
	function (style, route, title_, content) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent'),
					$author$project$Route$href(route)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$article,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child notification'),
							$elm$html$Html$Attributes$class(style)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h1,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(title_)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(content)
								]))
						]))
				]));
	});
var $author$project$Element$HomePage$viewTilePhonebook = function (t_) {
	return A4(
		$author$project$UI$tile,
		'is-success',
		$author$project$Route$PhoneBook,
		t_($author$project$Locale$Messages$HomePhoneBookTileTitle),
		t_($author$project$Locale$Messages$HomePhoneBookTileContent));
};
var $author$project$Locale$Messages$HomeStudentsTileContent = {$: 124};
var $author$project$Locale$Messages$HomeStudentsTileTitle = {$: 125};
var $author$project$Element$HomePage$viewTileStudents = function (t_) {
	return A4(
		$author$project$UI$tile,
		'is-warning',
		$author$project$Route$StudentList,
		t_($author$project$Locale$Messages$HomeStudentsTileTitle),
		t_($author$project$Locale$Messages$HomeStudentsTileContent));
};
var $author$project$Locale$Messages$StudentListLoadingProgress = {$: 576};
var $author$project$Locale$Messages$HomeChildrenSponsors = {$: 121};
var $author$project$ACL$canViewGradeRequests = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isModuleTeacher(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isSponsor(person)));
};
var $author$project$ACL$canViewProfiles = function (_v0) {
	return $author$project$ACL$everyone;
};
var $author$project$ACL$canViewStudentFeedbacks = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$ACL$canViewTimetables = function (person) {
	return $author$project$Person$isActiveMember(person) && $author$project$ACL$isSchoolMember(person);
};
var $author$project$UI$tile2 = F2(
	function (style, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$article,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child notification'),
							$elm$html$Html$Attributes$class(style)
						]),
					content)
				]));
	});
var $author$project$Locale$Messages$StudentListViewStudentAbsenceList = {$: 583};
var $author$project$UI$Icon$absence = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-helicopter'),
			attributes));
};
var $author$project$Element$HomePage$vieStudentAbsencesLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentAbsenceList(child.gT)),
					$author$project$UI$attrCyData(
					'student-absence-view ' + A2($elm$core$Maybe$withDefault, '', child.K)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$absence(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewStudentAbsenceList)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewGradeReport = {$: 582};
var $author$project$UI$Icon$grades = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-award'),
			attributes));
};
var $author$project$Element$HomePage$viewGradeReportsLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$GradeReportCard(child.gT)),
					$author$project$UI$attrCyData(
					'grade-report-view' + A2($elm$core$Maybe$withDefault, '', child.K)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewGradeReport)
						]))
				]));
	});
var $author$project$Element$HomePage$viewGradeRequestsLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$GradeRequestList(child.gT)),
					$author$project$UI$attrCyData(
					'grade-request-view' + A2($elm$core$Maybe$withDefault, '', child.K)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestListTitle)
						]))
				]));
	});
var $author$project$Element$HomePage$LearningContractOpened = {$: 4};
var $author$project$Locale$Messages$StudentListViewLearningContract = {$: 579};
var $author$project$UI$Icon$noData = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-ban'),
			attributes));
};
var $author$project$Element$HomePage$viewLearningContractLink = F2(
	function (t_, child) {
		var _v0 = child.j9;
		if (!_v0.$) {
			var contract = _v0.a;
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Element$HomePage$LearningContractOpened),
						$elm$html$Html$Attributes$href(contract.G),
						$elm$html$Html$Attributes$target('_blank'),
						$author$project$UI$attrCyData('home-learningcontracts-view'),
						$elm$html$Html$Attributes$class('button')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-info')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						$author$project$UI$Icon$noData(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
							]))
					]));
		}
	});
var $author$project$Locale$Messages$StudentMentor = function (a) {
	return {$: 490, a: a};
};
var $author$project$Locale$Messages$StudentMissingMentor = {$: 491};
var $elm$html$Html$mark = _VirtualDom_node('mark');
var $author$project$Element$StudentList$viewMentorText = F2(
	function (t_, maybeMentor) {
		if (!maybeMentor.$) {
			var mentor = maybeMentor.a;
			return A2(
				$elm$html$Html$span,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentMentor(
							A2($author$project$Person$fullName, t_, mentor)))
					]));
		} else {
			return A2(
				$elm$html$Html$mark,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentMissingMentor)
					]));
		}
	});
var $author$project$Locale$Messages$HomeStudentsProfile = {$: 126};
var $author$project$UI$Icon$profile = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-user'),
			attributes));
};
var $author$project$Element$HomePage$viewProfileLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentProfileUpdate(child.gT)),
					$author$project$UI$attrCyData('home-student-edit'),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$HomeStudentsProfile)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewSubjectFeedback = {$: 586};
var $author$project$Element$HomePage$viewSubjectFeedbackLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SubjectFeedbackCard, child.gT, $elm$core$Maybe$Nothing)),
					$author$project$UI$attrCyData(
					'subject-feedback-card-view ' + A2($elm$core$Maybe$withDefault, '', child.K)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewSubjectFeedback)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewTimetable = {$: 584};
var $author$project$UI$Icon$moduleEvent = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-clock'),
			attributes));
};
var $author$project$Element$HomePage$viewTimetableLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$author$project$Route$href(
					$author$project$Route$TimetableCalendar(
						_List_fromArray(
							[student.gT]))),
					$author$project$UI$attrCyData('timetable-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-dark')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTimetable)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentListViewTrimesterFeedback = {$: 585};
var $author$project$Element$HomePage$viewTrimesterFeedbacksLink = F2(
	function (t_, child) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(child.gT)),
					$author$project$UI$attrCyData(
					'trimester-feedback-report-view ' + A2($elm$core$Maybe$withDefault, '', child.K)),
					$elm$html$Html$Attributes$class('button')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$feedback(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTrimesterFeedback)
						]))
				]));
	});
var $author$project$Element$HomePage$viewTileChild = F3(
	function (t_, viewer, child) {
		var viewSponsorLink = function (sponsor) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$GenericProfileUpdate(sponsor.gT)),
						$author$project$UI$attrCyData('home-sponsor-edit')
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, sponsor))
					]));
		};
		var viewSponsors = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 mt-2')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('mr-2')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$HomeChildrenSponsors)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-inline')
						]),
					A2(
						$elm$core$List$map,
						function (sponsor) {
							return A2(
								$elm$html$Html$li,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-inline mr-2')
									]),
								_List_fromArray(
									[
										viewSponsorLink(sponsor)
									]));
						},
						child.m9))
				]));
		var viewMentor = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 mt-2'),
					$author$project$UI$attrCyData('home-mentor')
				]),
			_List_fromArray(
				[
					A2($author$project$Element$StudentList$viewMentorText, t_, child.l_)
				]));
		var viewMedia = A4(
			$author$project$UI$mediaObject,
			_List_fromArray(
				[
					$author$project$UI$gravatar(
					A2($elm$core$Maybe$withDefault, '', child.K))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-3 is-size-4-mobile mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($author$project$Person$fullName, t_, child))
						])),
					A2(
					$author$project$UI$maybe,
					child.K,
					function (email) {
						return A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(email)
								]));
					})
				]),
			_List_Nil,
			_List_Nil);
		var viewActions = A2(
			$elm$html$Html$nav,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns is-multiline mt-2')
				]),
			A2(
				$elm$core$List$filterMap,
				function (link) {
					return (!_Utils_eq(link, $author$project$UI$none)) ? $elm$core$Maybe$Just(
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column is-narrow')
								]),
							_List_fromArray(
								[link]))) : $elm$core$Maybe$Nothing;
				},
				_List_fromArray(
					[
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewLearningContracts(viewer),
						A2($author$project$Element$HomePage$viewLearningContractLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewProfiles(viewer),
						A2($author$project$Element$HomePage$vieStudentAbsencesLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewTimetables(viewer),
						A2($author$project$Element$HomePage$viewTimetableLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewTrimesterFeedbacksLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewSubjectFeedbackLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewStudentFeedbacks(viewer),
						A2($author$project$Element$HomePage$viewGradeReportsLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewGradeRequests(viewer),
						A2($author$project$Element$HomePage$viewGradeRequestsLink, t_, child)),
						A2(
						$author$project$UI$when,
						$author$project$ACL$canViewProfiles(viewer),
						A2($author$project$Element$HomePage$viewProfileLink, t_, child))
					])));
		return A2(
			$author$project$UI$tile2,
			'is-light',
			_List_fromArray(
				[viewMedia, viewSponsors, viewMentor, viewActions]));
	});
var $author$project$Element$HomePage$viewTilesChildren = F3(
	function (t_, viewer, maybeStudents) {
		var viewGrid = F2(
			function (size, children) {
				return (_Utils_cmp(
					$elm$core$List$length(children),
					size) > 0) ? _Utils_ap(
					A2(
						viewGrid,
						size,
						A2($elm$core$List$take, size, children)),
					A2(
						viewGrid,
						size,
						A2($elm$core$List$drop, size, children))) : _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile is-ancestor')
							]),
						A2(
							$elm$core$List$map,
							A2($author$project$Element$HomePage$viewTileChild, t_, viewer),
							children))
					]);
			});
		if (maybeStudents.$ === 1) {
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				t_($author$project$Locale$Messages$StudentListLoadingProgress));
		} else {
			if (!maybeStudents.a.b) {
				return $author$project$UI$none;
			} else {
				var students = maybeStudents.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					A2(viewGrid, 2, students));
			}
		}
	});
var $author$project$Element$HomePage$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					$author$project$Element$HomePage$hasTeacherTiles(viewer),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('tile is-ancestor')
							]),
						_List_fromArray(
							[
								$author$project$Element$HomePage$viewTileStudents(t_),
								$author$project$Element$HomePage$viewTilePhonebook(t_)
							]))),
					A2(
					$author$project$UI$when,
					$author$project$Element$HomePage$hasStudentTiles(viewer),
					A3($author$project$Element$HomePage$viewTilesChildren, t_, viewer, model.e1)),
					A2(
					$author$project$UI$when,
					!$author$project$Element$HomePage$hasPortfolioFeed(viewer),
					A3($author$project$Element$NotificationList$viewActivityLogs, t_, model.fN, model.fd)),
					A2(
					$author$project$UI$maybe,
					model.eQ,
					$author$project$Element$HomePage$viewPortfolios(session))
				]));
	});
var $author$project$Element$HomePage$element = {iA: $author$project$Element$HomePage$init, jR: $author$project$Element$HomePage$update, nE: $author$project$Element$HomePage$view};
var $author$project$Element$LearningContracts$NotFoundPage = {$: 0};
var $author$project$Element$LearningContracts$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningContracts$LearningContractListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningContracts$EndDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$LearningContracts$StartDate = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningContracts$Student = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningContracts$Url = function (a) {
	return {$: 4, a: a};
};
var $author$project$Form$requiredPersonSelected = F2(
	function (t_, value) {
		var maybeId = $elm$core$String$toInt(value);
		if (!maybeId.$) {
			var id = maybeId.a;
			return (!_Utils_eq(id, $author$project$Person$blankPersonId)) ? $elm$core$Result$Ok(id) : $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		}
	});
var $author$project$Locale$Messages$FormInvalidUrl = {$: 55};
var $author$project$Form$validUrlFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^https?://.+$'));
var $author$project$Form$requiredUrl = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validUrlFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidUrl)));
	});
var $author$project$Element$LearningContracts$buildForm = function (t_) {
	return {
		gH: {
			kU: false,
			mu: $author$project$Form$requiredDate(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gH: value});
				}),
			nD: function ($) {
				return $.gH;
			},
			nE: {
				kJ: 'end_date',
				lO: t_($author$project$Locale$Messages$LearningContractsEndDate),
				aT: $author$project$Element$LearningContracts$EndDate
			}
		},
		hv: {
			kU: false,
			mu: $author$project$Form$requiredDate(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{hv: value});
				}),
			nD: function ($) {
				return $.hv;
			},
			nE: {
				kJ: 'start_date',
				lO: t_($author$project$Locale$Messages$LearningContractsStartDate),
				aT: $author$project$Element$LearningContracts$StartDate
			}
		},
		ne: {
			kU: false,
			mu: $author$project$Form$requiredPersonSelected(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ne: value});
				}),
			nD: function ($) {
				return $.ne;
			},
			nE: {
				kJ: 'student',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$LearningContractsStudent),
				aT: $author$project$Element$LearningContracts$Student,
				mp: $elm$core$Maybe$Nothing
			}
		},
		G: {
			kU: false,
			mu: $author$project$Form$requiredUrl(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{G: value});
				}),
			nD: function ($) {
				return $.G;
			},
			nE: {
				kJ: 'url',
				lj: 'fa-link',
				lO: t_($author$project$Locale$Messages$LearningContractsUrl),
				aT: $author$project$Element$LearningContracts$Url,
				bv: 'https://',
				hH: 'text'
			}
		}
	};
};
var $author$project$Element$LearningContracts$emptyForm = {gH: '', hv: '', ne: '', G: ''};
var $author$project$Api$Endpoint$learningContracts = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'learning-contracts']),
		_List_fromArray(
			[
				_Utils_Tuple2('include_inactive', '1')
			]));
};
var $author$project$LearningContract$learningContractsDecoder = $elm$json$Json$Decode$list($author$project$LearningContract$learningContractDecoder);
var $author$project$LearningContract$fetchLearningContracts = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$learningContracts(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$LearningContract$learningContractsDecoder));
	});
var $author$project$Form$fillFieldOptions = F2(
	function (options, field) {
		var view = field.nE;
		return _Utils_update(
			field,
			{
				nE: _Utils_update(
					view,
					{
						mp: $elm$core$Maybe$Just(options)
					})
			});
	});
var $author$project$Element$LearningContracts$toStudentOptions = F2(
	function (t_, mentees) {
		return A2($author$project$Form$toPeopleOptions, t_, mentees);
	});
var $author$project$Element$LearningContracts$initPage = F3(
	function (pageType, session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		switch (pageType.$) {
			case 0:
				var form = $author$project$Element$LearningContracts$buildForm(t_);
				var page = $author$project$Element$LearningContracts$FormPage(
					{
						hQ: $author$project$Form$Create(0),
						bt: _Utils_update(
							form,
							{
								ne: A2(
									$author$project$Form$fillFieldOptions,
									A2($author$project$Element$LearningContracts$toStudentOptions, t_, viewer.lZ),
									form.ne)
							}),
						eZ: 0,
						dn: {cI: true},
						ej: $author$project$Element$LearningContracts$emptyForm
					});
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bm: page}),
					session);
			case 2:
				var id = pageType.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A2($author$project$LearningContract$fetchLearningContracts, model.bN.gr, $author$project$Element$LearningContracts$LearningContractListDownloaded),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bm: $author$project$Element$LearningContracts$LoadingPage(
									$elm$core$Maybe$Just(id))
							}),
						session));
			default:
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A2($author$project$LearningContract$fetchLearningContracts, model.bN.gr, $author$project$Element$LearningContracts$LearningContractListDownloaded),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bm: $author$project$Element$LearningContracts$LoadingPage($elm$core$Maybe$Nothing)
							}),
						session));
		}
	});
var $author$project$Element$LearningContracts$init = F3(
	function (config, session, pageType) {
		return A3(
			$author$project$Element$LearningContracts$initPage,
			pageType,
			session,
			{bN: config, bm: $author$project$Element$LearningContracts$NotFoundPage});
	});
var $author$project$Element$LearningContracts$LearningContractSaved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningContractsDownloadError = {$: 136};
var $author$project$Locale$Messages$LearningContractsSaveSuccess = {$: 143};
var $author$project$Element$LearningContracts$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningContracts$NoOp = {$: 8};
var $author$project$Form$Update = function (a) {
	return {$: 1, a: a};
};
var $author$project$Form$areDatesValid = F3(
	function (field1, field2, values) {
		var date2 = $author$project$Form$dateToMillis(
			field2.nD(values));
		var date1 = $author$project$Form$dateToMillis(
			field1.nD(values));
		var _v0 = A2($elm$core$Basics$compare, date1, date2);
		switch (_v0) {
			case 0:
				return true;
			case 1:
				return true;
			default:
				return false;
		}
	});
var $author$project$LearningContract$idToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$LearningContract$learningContractEncoder = function (contract) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$LearningContract$idToInt(contract.gT))),
				_Utils_Tuple2(
				'student',
				$elm$json$Json$Encode$int(contract.ne)),
				_Utils_Tuple2(
				'url',
				$elm$json$Json$Encode$string(contract.G)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$int(contract.hv)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$int(contract.gH))
			]));
};
var $author$project$LearningContract$createLearningContract = F3(
	function (config, contract, callback) {
		return A5(
			$author$project$Api$post,
			$author$project$Api$Endpoint$learningContracts(config),
			config,
			$elm$http$Http$jsonBody(
				$author$project$LearningContract$learningContractEncoder(contract)),
			callback,
			$author$project$LearningContract$learningContractDecoder);
	});
var $ryan_haskell$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryan_haskell$date_format$DateFormat$dayOfMonthFixed = $ryan_haskell$date_format$DateFormat$DayOfMonthFixed;
var $ryan_haskell$date_format$DateFormat$MonthFixed = {$: 2};
var $ryan_haskell$date_format$DateFormat$monthFixed = $ryan_haskell$date_format$DateFormat$MonthFixed;
var $author$project$Form$dateFromMillis = function (millis) {
	return A4(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$english,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$yearNumber,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$monthFixed,
				$ryan_haskell$date_format$DateFormat$text('-'),
				$ryan_haskell$date_format$DateFormat$dayOfMonthFixed
			]),
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$Element$LearningContracts$fillForm = function (contract) {
	return {
		gH: $author$project$Form$dateFromMillis(contract.gH),
		hv: $author$project$Form$dateFromMillis(contract.hv),
		ne: $elm$core$String$fromInt(contract.ne.gT),
		G: contract.G
	};
};
var $author$project$LearningContract$findLearningContract = F2(
	function (id, list) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (c) {
					return _Utils_eq(c.gT, id);
				},
				list));
	});
var $author$project$Element$LearningContracts$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.ne, values) && (A2($author$project$Form$isFieldValid, form.G, values) && (A2($author$project$Form$isFieldValid, form.hv, values) && (A2($author$project$Form$isFieldValid, form.gH, values) && A3($author$project$Form$areDatesValid, form.hv, form.gH, values))));
	});
var $author$project$Log$msgLearningContractSave = 'learningcontract_save';
var $author$project$Log$msgLearningContractsDownload = 'learningcontracts_download';
var $author$project$LearningContract$LearningContractUnsaved = F5(
	function (id, student, url, startDate, endDate) {
		return {gH: endDate, gT: id, hv: startDate, ne: student, G: url};
	});
var $author$project$Person$decodePersonId = A2(
	$elm$core$Basics$composeR,
	$elm$core$String$toInt,
	$elm$core$Maybe$withDefault($author$project$Person$blankPersonId));
var $author$project$Element$LearningContracts$saveForm = F3(
	function (form, values, contract) {
		return A5(
			$author$project$LearningContract$LearningContractUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					contract)),
			$author$project$Person$decodePersonId(
				form.ne.nD(values)),
			form.G.nD(values),
			$author$project$Form$dateToMillis(
				form.hv.nD(values)),
			$author$project$Form$dateToMillis(
				form.gH.nD(values)));
	});
var $author$project$Api$Endpoint$learningContract = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-contracts',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$LearningContract$updateLearningContract = F3(
	function (config, contract, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$learningContract,
				config,
				$author$project$LearningContract$idToInt(contract.gT)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$LearningContract$learningContractEncoder(contract)),
			callback,
			$author$project$LearningContract$learningContractDecoder);
	});
var $author$project$Element$LearningContracts$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			gH: $author$project$Form$markEdited(form.gH),
			hv: $author$project$Form$markEdited(form.hv),
			ne: $author$project$Form$markEdited(form.ne),
			G: $author$project$Form$markEdited(form.G)
		});
};
var $author$project$Element$LearningContracts$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					var id = _v0.a.a;
					return A3(
						$author$project$Element$LearningContracts$initPage,
						$author$project$Element$LearningContracts$Update(id),
						session,
						model);
				case 1:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							if (!_v0.b.a.$) {
								var list = _v0.a.a.a;
								var id = _v0.b.a.a;
								var maybeContract = A2($author$project$LearningContract$findLearningContract, id, list);
								if (!maybeContract.$) {
									var contract = maybeContract.a;
									var form = $author$project$Element$LearningContracts$buildForm(t_);
									var formPage = $author$project$Element$LearningContracts$FormPage(
										{
											hQ: $author$project$Form$Update(contract),
											bt: _Utils_update(
												form,
												{
													ne: A2(
														$author$project$Form$fillFieldOptions,
														A2($author$project$Element$LearningContracts$toStudentOptions, t_, viewer.lZ),
														form.ne)
												}),
											eZ: 0,
											dn: {cI: true},
											ej: $author$project$Element$LearningContracts$fillForm(contract)
										});
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: formPage}),
										session);
								} else {
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: $author$project$Element$LearningContracts$NotFoundPage}),
										session);
								}
							} else {
								var list = _v0.a.a.a;
								var _v2 = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$LearningContracts$ListPage(list)
										}),
									session);
							}
						} else {
							break _v0$11;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3($author$project$Log$msgLearningContractsDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$LearningContracts$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningContractsDownloadError))));
					}
				case 7:
					if (_v0.b.$ === 3) {
						var _v3 = _v0.a;
						var formPage = _v0.b.a;
						var action = formPage.hQ;
						var form = formPage.bt;
						var values = formPage.ej;
						if (A2($author$project$Element$LearningContracts$isFormValid, form, values)) {
							var formCmd = function () {
								if (!action.$) {
									var contractUnsaved = A3($author$project$Element$LearningContracts$saveForm, form, values, $elm$core$Maybe$Nothing);
									return A3($author$project$LearningContract$createLearningContract, model.bN.gr, contractUnsaved, $author$project$Element$LearningContracts$LearningContractSaved);
								} else {
									var contract = action.a;
									var contractUnsaved = A3(
										$author$project$Element$LearningContracts$saveForm,
										form,
										values,
										$elm$core$Maybe$Just(contract));
									return A3($author$project$LearningContract$updateLearningContract, model.bN.gr, contractUnsaved, $author$project$Element$LearningContracts$LearningContractSaved);
								}
							}();
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								formCmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$LearningContracts$FormPage(
												_Utils_update(
													formPage,
													{eZ: 2}))
										}),
									session));
						} else {
							var areDatesValid = A3($author$project$Form$areDatesValid, form.hv, form.gH, values);
							var page = $author$project$Element$LearningContracts$FormPage(
								_Utils_update(
									formPage,
									{
										bt: $author$project$Element$LearningContracts$validateForm(form),
										eZ: 1,
										dn: {cI: areDatesValid}
									}));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page}),
									session));
						}
					} else {
						break _v0$11;
					}
				case 2:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var newContract = _v0.a.a.a;
							var formPage = _v0.b.a;
							var page = $author$project$Element$LearningContracts$FormPage(
								_Utils_update(
									formPage,
									{
										hQ: $author$project$Form$Update(newContract),
										eZ: 0
									}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bm: page}),
								A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$LearningContractsSaveSuccess)));
						} else {
							break _v0$11;
						}
					} else {
						if (_v0.b.$ === 3) {
							var error = _v0.a.a.a;
							var formPage = _v0.b.a;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bm: $author$project$Element$LearningContracts$FormPage(
										_Utils_update(
											formPage,
											{eZ: 3}))
								});
							var cmd = A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3($author$project$Log$msgLearningContractSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$LearningContracts$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$11;
						}
					}
				case 3:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var values = formPage.ej;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{
											ne: $author$project$Form$markEdited(form.ne)
										}),
									eZ: 1,
									ej: A2(form.ne.jR, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bm: page}),
							session);
					} else {
						break _v0$11;
					}
				case 4:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var values = formPage.ej;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{
											G: $author$project$Form$markEdited(form.G)
										}),
									eZ: 1,
									ej: A2(form.G.jR, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bm: page}),
							session);
					} else {
						break _v0$11;
					}
				case 5:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var values = formPage.ej;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{
											hv: $author$project$Form$markEdited(form.hv)
										}),
									eZ: 1,
									dn: {cI: true},
									ej: A2(form.hv.jR, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bm: page}),
							session);
					} else {
						break _v0$11;
					}
				case 6:
					if (_v0.b.$ === 3) {
						var value = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var values = formPage.ej;
						var page = $author$project$Element$LearningContracts$FormPage(
							_Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{
											gH: $author$project$Form$markEdited(form.gH)
										}),
									eZ: 1,
									dn: {cI: true},
									ej: A2(form.gH.jR, value, values)
								}));
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bm: page}),
							session);
					} else {
						break _v0$11;
					}
				default:
					break _v0$11;
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$LearningContractsLoadingProgress = {$: 139};
var $author$project$Locale$Messages$LearningContractsNotFound = {$: 142};
var $author$project$Locale$Messages$LearningContractsNoneForSponsor = {$: 140};
var $author$project$Locale$Messages$LearningContractsNoneForTeacher = {$: 141};
var $author$project$Element$LearningContracts$viewEmpty = function (_v0) {
	var t_ = _v0.hy;
	var viewer = _v0.nH;
	return $author$project$ACL$isStaff(viewer) ? $author$project$UI$notification(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNoneForTeacher)
			])) : $author$project$UI$notification(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNoneForSponsor)
			]));
};
var $author$project$Locale$Messages$FormEndDateBeforeStartDate = {$: 59};
var $author$project$Locale$Messages$LearningContractsHeadingEdit = {$: 144};
var $author$project$Locale$Messages$LearningContractsHeadingNew = {$: 145};
var $author$project$Element$LearningContracts$ResetForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningContracts$SaveLearningContract = {$: 7};
var $author$project$Locale$Messages$BtnCreate = {$: 31};
var $author$project$UI$formButtons = F5(
	function (t_, formAction, formState, submitMsg, resetMsg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field is-grouped')
				]),
			function () {
				if (!formAction.$) {
					return _List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnCreate),
							formState !== 1,
							$author$project$Form$isProcessing(formState),
							submitMsg)
						]);
				} else {
					var x = formAction.a;
					return _List_fromArray(
						[
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							formState !== 1,
							$author$project$Form$isProcessing(formState),
							submitMsg),
							A4(
							$author$project$UI$resetButton,
							t_($author$project$Locale$Messages$BtnReset),
							$author$project$Form$resetDisabled(formState),
							$author$project$Form$isProcessing(formState),
							resetMsg(x))
						]);
				}
			}());
	});
var $author$project$UI$withErrorText = F3(
	function (t_, message, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-errors')
				]),
			_List_fromArray(
				[
					content,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'margin-top', '-8px')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$small,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('help is-danger')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$LearningContracts$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.hQ;
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var validations = _v0.dn;
		var validationError = function (content) {
			return (state === 1) ? (validations.cI ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var heading = function () {
			if (!action.$) {
				return t_($author$project$Locale$Messages$LearningContractsHeadingNew);
			} else {
				return t_($author$project$Locale$Messages$LearningContractsHeadingEdit);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(heading)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.ne, values),
							A3($author$project$UI$textField, t_, form.G, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4($author$project$UI$dateField, t_, form.hv, values, true),
							validationError(
							A4($author$project$UI$dateField, t_, form.gH, values, true))
						])),
					A5(
					$author$project$UI$formButtons,
					t_,
					action,
					state,
					$author$project$Element$LearningContracts$SaveLearningContract,
					function (contract) {
						return $author$project$Element$LearningContracts$ResetForm(
							$author$project$LearningContract$idToInt(contract.gT));
					})
				]));
	});
var $author$project$Locale$Messages$ItemTagActive = {$: 127};
var $author$project$Locale$Messages$ItemTagInactive = {$: 128};
var $author$project$Locale$Messages$LearningContractsItemDate = F3(
	function (a, b, c) {
		return {$: 137, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$LearningContractsItemName = function (a) {
	return {$: 138, a: a};
};
var $author$project$ACL$canManageLearningContract = F2(
	function (contract, person) {
		return A2($author$project$Person$isMentorOf, contract.ne, person);
	});
var $author$project$Element$LearningContracts$viewItem = F2(
	function (_v0, contract) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningContractsUpdate(
						$author$project$LearningContract$idToInt(contract.gT))),
					$author$project$UI$attrCyData('learningcontracts-edit')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit),
					$author$project$UI$Icon$edit(_List_Nil)
				]));
		var viewActiveTag = contract.lo ? A2(
			$author$project$UI$tag,
			'is-success',
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ItemTagActive)
				])) : A2(
			$author$project$UI$tag,
			'is-warning is-light',
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ItemTagInactive)
				]));
		return A4(
			$author$project$UI$mediaObject,
			_List_fromArray(
				[viewActiveTag]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('learningcontracts-item')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(contract.G)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$caption,
									t_,
									$author$project$Locale$Messages$LearningContractsItemName(
										A2($author$project$Person$fullName, t_, contract.ne))),
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-link')
										]))
								])),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2(
							$author$project$UI$caption,
							t_,
							A3(
								$author$project$Locale$Messages$LearningContractsItemDate,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(contract.hv),
								$elm$time$Time$millisToPosix(contract.gH))),
							A2($elm$html$Html$br, _List_Nil, _List_Nil),
							A2($author$project$Element$StudentList$viewMentorText, t_, contract.l_)
						]))
				]),
			A2($author$project$ACL$canManageLearningContract, contract, viewer) ? _List_fromArray(
				[viewEditLink]) : _List_Nil,
			_List_Nil);
	});
var $author$project$Element$LearningContracts$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 2:
				if (!_v0.a.b) {
					return $author$project$Element$LearningContracts$viewEmpty(session);
				} else {
					var contracts = _v0.a;
					return $author$project$UI$panel(
						{
							kt: A2(
								$elm$core$List$map,
								$author$project$Element$LearningContracts$viewItem(session),
								contracts),
							kJ: 'learningcontracts-list',
							le: _List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsTitle)
								]),
							nk: _List_Nil,
							nq: 'is-primary'
						});
				}
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsNotFound)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-info',
					t_($author$project$Locale$Messages$LearningContractsLoadingProgress));
			default:
				var formPage = _v0.a;
				return $author$project$UI$panel(
					{
						kt: _List_fromArray(
							[
								A2($author$project$Element$LearningContracts$viewForm, t_, formPage)
							]),
						kJ: 'learningcontracts-form',
						le: _List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningContractsTitle)
							]),
						nk: _List_Nil,
						nq: 'is-light'
					});
		}
	});
var $author$project$Element$LearningContracts$element = {iA: $author$project$Element$LearningContracts$init, jR: $author$project$Element$LearningContracts$update, nE: $author$project$Element$LearningContracts$view};
var $author$project$Element$LearningGroupForm$LoadingPage = {$: 0};
var $author$project$Element$LearningGroupForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$FetchLearningGroup = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$FetchSchools = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupForm$FetchStudents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningGroupForm$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$LearningGroupDownloadedForEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$LearningGroup$LearningGroupId = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupForm$LogOk = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupForm$NoOp = {$: 0};
var $author$project$Element$LearningGroupForm$SchoolListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupForm$StudentListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$LearningGroupForm$IsShared = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$LearningGroupFieldIsShared = {$: 153};
var $author$project$Locale$Messages$LearningGroupFieldName = {$: 154};
var $author$project$Locale$Messages$LearningGroupFieldSchool = {$: 155};
var $author$project$Locale$Messages$LearningGroupFieldStudents = {$: 156};
var $author$project$Element$LearningGroupForm$Name = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupForm$School = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupForm$initStudentsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				nl: 'Students',
				ej: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Form$requiredPeopleSelected = F2(
	function (t_, value) {
		var _v0 = A2($elm$core$List$filterMap, $elm$core$String$toInt, value);
		if (!_v0.b) {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			var list = _v0;
			return $elm$core$Result$Ok(list);
		}
	});
var $author$project$Team$blankTeamId = -1;
var $author$project$Form$requiredTeamSelected = F2(
	function (t_, value) {
		var maybeId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$elm$core$String$toInt(value));
		if (!maybeId.$) {
			var id = maybeId.a;
			return (!_Utils_eq(id, $author$project$Team$blankTeamId)) ? $elm$core$Result$Ok(id) : $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		}
	});
var $author$project$Element$LearningGroupForm$buildForm = F4(
	function (t_, schoolOptions, studentOptions, learningGroup) {
		var studentsField = {
			kU: false,
			mu: $author$project$Form$requiredPeopleSelected(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{e1: value});
				}),
			nD: function ($) {
				return $.e1;
			},
			nE: {
				kJ: 'students',
				lj: 'fa-users',
				lO: t_($author$project$Locale$Messages$LearningGroupFieldStudents),
				mp: studentOptions,
				eZ: $author$project$Element$LearningGroupForm$initStudentsField(studentOptions),
				bZ: $author$project$Element$LearningGroupForm$StudentsFieldMsg
			}
		};
		return {
			aj: {
				kU: false,
				mu: $elm$core$Result$Ok,
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{aj: value});
					}),
				nD: function ($) {
					return $.aj;
				},
				nE: {
					kJ: 'is_shared',
					lj: 'fa-share',
					lO: t_($author$project$Locale$Messages$LearningGroupFieldIsShared),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$IsShared)
				}
			},
			ha: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{ha: value});
					}),
				nD: function ($) {
					return $.ha;
				},
				nE: {
					kJ: 'name',
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$LearningGroupFieldName),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$Name),
					bv: '',
					hH: 'text'
				}
			},
			bp: {
				kU: false,
				mu: $author$project$Form$requiredTeamSelected(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{bp: value});
					}),
				nD: function ($) {
					return $.bp;
				},
				nE: {
					kJ: 'school',
					lj: 'fa-school',
					lO: t_($author$project$Locale$Messages$LearningGroupFieldSchool),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$LearningGroupForm$FormMsg, $author$project$Element$LearningGroupForm$School),
					mp: schoolOptions
				}
			},
			e1: A2(
				$elm$core$Maybe$withDefault,
				studentsField,
				A2(
					$elm$core$Maybe$map,
					function (group_) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							A2($author$project$Form$toPeopleOptions, t_, group_.e1),
							studentsField);
					},
					learningGroup))
		};
	});
var $author$project$Element$LearningGroupForm$emptyForm = {aj: false, ha: '', bp: '', e1: _List_Nil};
var $author$project$Api$Endpoint$learningGroup = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'learning-groups',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$LearningGroup$LearningGroup = F6(
	function (id, name, creator, team, sharedWith, students) {
		return {ib: creator, gT: id, ha: name, m0: sharedWith, e1: students, jF: team};
	});
var $author$project$LearningGroup$learningGroupIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$LearningGroup$WithNobody = 0;
var $author$project$LearningGroup$WithTeam = 1;
var $author$project$LearningGroup$sharingDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'nobody':
				return $elm$json$Json$Decode$succeed(0);
			case 'team':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var somethingElse = str;
				return $elm$json$Json$Decode$fail('Unknown sharing option: ' + somethingElse);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$LearningGroup$learningGroupDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'students_detail',
	$author$project$Person$nestedPeopleDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'shared_with',
		$author$project$LearningGroup$sharingDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'team_detail',
			$author$project$Team$teamDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'created_by_detail',
				$author$project$Person$nestedPersonDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$LearningGroup$learningGroupIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$LearningGroup$LearningGroup)))))));
var $author$project$LearningGroup$learningGroupIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$LearningGroup$fetchLearningGroup = F3(
	function (config, id, callback) {
		return {
			bN: config,
			dC: $author$project$LearningGroup$learningGroupDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2(
				$author$project$Api$Endpoint$learningGroup,
				config,
				$author$project$LearningGroup$learningGroupIdToInt(id))
		};
	});
var $author$project$Team$fetchSchools2 = F2(
	function (config, callback) {
		return {
			bN: config,
			dC: $author$project$Team$teamsDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: $author$project$Api$Endpoint$schools(config)
		};
	});
var $author$project$Api$Endpoint$peopleStudents = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'students');
};
var $author$project$Person$fetchStudents2 = F2(
	function (config, callback) {
		return {
			bN: config,
			dC: $author$project$Person$phoneBookDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: $author$project$Api$Endpoint$peopleStudents(config)
		};
	});
var $author$project$Log$msgLearningGroupCreate = 'learning_group_create';
var $author$project$Log$paramScopeLearningGroups = 'scope_learning_groups';
var $author$project$Element$LearningGroupForm$initPageByParams = F3(
	function (params, session, model) {
		var fetchStudents = $author$project$Element$LearningGroupForm$FetchStudents(
			A2($author$project$Person$fetchStudents2, model.bN.gr, $author$project$Element$LearningGroupForm$StudentListDownloaded));
		var fetchSchool = $author$project$Element$LearningGroupForm$FetchSchools(
			A2($author$project$Team$fetchSchools2, model.bN.gr, $author$project$Element$LearningGroupForm$SchoolListDownloaded));
		if (!params.$) {
			var store = {jr: $author$project$RemoteData$Loading, e1: $author$project$RemoteData$Loading};
			var page = $author$project$Element$LearningGroupForm$FormPage(
				{
					hQ: $author$project$Form$Create(0),
					bt: A4($author$project$Element$LearningGroupForm$buildForm, session.hy, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
					eZ: 0,
					ej: $author$project$Element$LearningGroupForm$emptyForm
				});
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bm: page, bd: store}),
				$author$project$Element$LearningGroupForm$BatchEffect(
					_List_fromArray(
						[
							fetchSchool,
							fetchStudents,
							$author$project$Element$LearningGroupForm$Cmd(
							A3(
								$author$project$Log$okV2,
								model.bN,
								_Utils_Tuple2(
									$author$project$Log$msgLearningGroupCreate,
									_List_fromArray(
										[$author$project$Log$paramScopeLearningGroups, $author$project$Log$paramOk])),
								$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp)))
						])),
				$elm$core$Maybe$Nothing);
		} else {
			var learningGroupId = params.a;
			var effect = $author$project$Element$LearningGroupForm$BatchEffect(
				_List_fromArray(
					[
						fetchStudents,
						fetchSchool,
						$author$project$Element$LearningGroupForm$FetchLearningGroup(
						A3($author$project$LearningGroup$fetchLearningGroup, model.bN.gr, learningGroupId, $author$project$Element$LearningGroupForm$LearningGroupDownloadedForEdit))
					]));
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{bm: $author$project$Element$LearningGroupForm$LoadingPage}),
				effect,
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$LearningGroupForm$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			bm: $author$project$Element$LearningGroupForm$LoadingPage,
			cv: session,
			bd: {jr: $author$project$RemoteData$NotAsked, e1: $author$project$RemoteData$NotAsked}
		};
		return A3($author$project$Element$LearningGroupForm$initPageByParams, params, session, model);
	});
var $author$project$Element$LearningGroupForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$LearningGroupForm$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				var request = cmd;
				return $author$project$Api$postV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 4:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 5:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 6:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 7:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 8:
				var request = effect.a;
				return $author$project$Api$putV2(request);
			case 9:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 10:
				return $author$project$Ports$scrollToFormError;
			default:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
		}
	});
var $author$project$Element$LearningGroupForm$CreateLearningGroup = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$LearningGroupDownloadError = {$: 151};
var $author$project$Locale$Messages$LearningGroupSaveSuccess = {$: 168};
var $author$project$Element$LearningGroupForm$LearningGroupSaved = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$LogError = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$LearningGroupForm$MultiselectEffect = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Element$LearningGroupForm$NavRedirect = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$LearningGroupForm$NoEffect = {$: 0};
var $author$project$Element$LearningGroupForm$ScrollToFormError = {$: 10};
var $author$project$Element$LearningGroupForm$Students = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupForm$UpdateLearningGroup = function (a) {
	return {$: 8, a: a};
};
var $author$project$LearningGroup$encodedLearningGroupToBackend = function (learningGroup) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT))),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(learningGroup.ha)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(learningGroup.jF))),
				_Utils_Tuple2(
				'shared_with',
				$elm$json$Json$Encode$string(
					function () {
						var _v0 = learningGroup.m0;
						if (!_v0) {
							return 'nobody';
						} else {
							return 'team';
						}
					}())),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, learningGroup.e1))
			]));
};
var $author$project$Api$Endpoint$learningGroupCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'learning-groups']),
		_List_Nil);
};
var $author$project$LearningGroup$createLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			O: $author$project$LearningGroup$encodedLearningGroupToBackend(learningGroup),
			bN: config,
			dC: $author$project$LearningGroup$learningGroupDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: $author$project$Api$Endpoint$learningGroupCreate(config.gr)
		};
	});
var $author$project$Form$getMultiselectFieldSelectedValues = function (field) {
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$first,
		$author$project$Multiselect$getSelectedValues(field.nE.eZ));
};
var $author$project$Element$LearningGroupForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.ha, values) && (A2($author$project$Form$isFieldValid, form.bp, values) && (A2($author$project$Form$isFieldValid, form.e1, values) && A2($author$project$Form$isFieldValid, form.aj, values)));
	});
var $author$project$Log$msgLearningGroupsDownload = 'learning_groups_download';
var $author$project$Element$LearningGroupForm$fillForm = function (learningGroup) {
	return {
		aj: learningGroup.m0 === 1,
		ha: learningGroup.ha,
		bp: $elm$core$String$fromInt(
			$author$project$Team$teamIdToInt(learningGroup.jF.gT)),
		e1: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			learningGroup.e1)
	};
};
var $author$project$Person$teamsAsStudent = function (person) {
	var _v0 = person.c6;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.a, $author$project$Person$roleStudent);
			},
			roles));
};
var $author$project$Person$teamsAsTeacher = function (person) {
	var _v0 = person.c6;
	var roles = _v0;
	return A2(
		$elm$core$List$map,
		$elm$core$Tuple$second,
		A2(
			$elm$core$List$filter,
			function (role) {
				return _Utils_eq(role.a, $author$project$Person$roleTeacher) || _Utils_eq(role.a, $author$project$Person$roleModuleTeacher);
			},
			roles));
};
var $author$project$Person$isTeacherOf = F2(
	function (teacher, student) {
		return A2(
			$elm$core$List$any,
			function (team) {
				return A2(
					$elm$core$List$member,
					team,
					$author$project$Person$teamsAsTeacher(teacher));
			},
			$author$project$Person$teamsAsStudent(student));
	});
var $author$project$Element$LearningGroupForm$filterPersonsToSelectOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$Person$isTeacherOf(viewer),
				people));
	});
var $author$project$Element$LearningGroupForm$toViewerSchoolOptions = F2(
	function (viewer, schools) {
		return $author$project$Form$toTeamOptions(
			A2($author$project$Person$filterPersonTeams, schools, viewer));
	});
var $author$project$Element$LearningGroupForm$openUpdateForm = F3(
	function (learningGroup, _v0, model) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var store = model.bd;
		var studentOptions = A3(
			$author$project$Element$LearningGroupForm$filterPersonsToSelectOptions,
			t_,
			viewer,
			A2($author$project$RemoteData$withDefault, _List_Nil, store.e1));
		var schoolOptions = A2(
			$author$project$Element$LearningGroupForm$toViewerSchoolOptions,
			viewer,
			A2($author$project$RemoteData$withDefault, _List_Nil, store.jr));
		var page = $author$project$Element$LearningGroupForm$FormPage(
			{
				hQ: $author$project$Form$Update(learningGroup),
				bt: A4(
					$author$project$Element$LearningGroupForm$buildForm,
					t_,
					$elm$core$Maybe$Just(schoolOptions),
					$elm$core$Maybe$Just(studentOptions),
					$elm$core$Maybe$Just(learningGroup)),
				eZ: 0,
				ej: $author$project$Element$LearningGroupForm$fillForm(learningGroup)
			});
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bm: page}),
			$author$project$Element$LearningGroupForm$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$LearningGroup$LearningGroupUnsaved = F6(
	function (id, name, creator, team, sharedWith, students) {
		return {ib: creator, gT: id, ha: name, m0: sharedWith, e1: students, jF: team};
	});
var $author$project$Element$LearningGroupForm$boolToSharing = function (sharing) {
	return sharing ? 1 : 0;
};
var $author$project$Element$LearningGroupForm$saveForm = F4(
	function (form, values, viewer, maybeLearningGroup) {
		return A6(
			$author$project$LearningGroup$LearningGroupUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					maybeLearningGroup)),
			form.ha.nD(values),
			viewer.gT,
			A2(
				$elm$core$Maybe$withDefault,
				$author$project$Team$blankTeamId,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$identity,
					$elm$core$String$toInt(
						form.bp.nD(values)))),
			$author$project$Element$LearningGroupForm$boolToSharing(
				form.aj.nD(values)),
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.e1.nD(values)));
	});
var $author$project$Element$LearningGroupForm$resetFormStudents = F2(
	function (session, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var studentsField = A2(
			$author$project$Form$setMultiselectSelection,
			A2($author$project$Form$toPeopleOptions, session.hy, _List_Nil),
			form.e1);
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{e1: studentsField}),
			A2(form.e1.jR, _List_Nil, values));
	});
var $author$project$Team$decodeTeamId = A2(
	$elm$core$Basics$composeR,
	$elm$json$Json$Decode$decodeString($author$project$Team$teamIdDecoder),
	$elm$core$Result$withDefault($author$project$Team$blankTeamId));
var $author$project$Form$setMultiselectOptions = F2(
	function (options, field) {
		var view = field.nE;
		var updatedState = A3(
			$author$project$Multiselect$populateValues,
			view.eZ,
			$author$project$Form$toMultiselectValues(
				$elm$core$Maybe$Just(options)),
			$author$project$Multiselect$getSelectedValues(view.eZ));
		return A2(
			$author$project$Form$fillFieldOptions,
			options,
			A2(
				$author$project$Form$mapMultiselect,
				$elm$core$Basics$always(updatedState),
				field));
	});
var $author$project$Person$hasRoleAt = F3(
	function (role, teamId, person) {
		var _v0 = person.c6;
		var roles = _v0;
		return A2(
			$elm$core$List$any,
			function (_v1) {
				var role_ = _v1.a;
				var teamId_ = _v1.b;
				return _Utils_eq(role, role_) && _Utils_eq(teamId, teamId_);
			},
			roles);
	});
var $author$project$Person$studentsInTeams = F2(
	function (teamIds, people) {
		return A2(
			$elm$core$List$filter,
			function (person) {
				return A2(
					$elm$core$List$any,
					function (teamId) {
						return A3($author$project$Person$hasRoleAt, $author$project$Person$roleStudent, teamId, person);
					},
					teamIds);
			},
			people);
	});
var $author$project$Element$LearningGroupForm$updateFormStudentsBySchool = F3(
	function (session, store, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var viewer = session.nH;
		var t_ = session.hy;
		var _v1 = _Utils_Tuple2(store.jr, store.e1);
		if ((_v1.a.$ === 2) && (_v1.b.$ === 2)) {
			var students_ = _v1.b.a;
			var schoolId = $author$project$Team$decodeTeamId(
				form.bp.nD(values));
			var schoolStudents = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? students_ : A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[schoolId]),
				students_);
			var studentOptions = A3($author$project$Element$LearningGroupForm$filterPersonsToSelectOptions, t_, viewer, schoolStudents);
			var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1);
			var studentValues = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? _List_Nil : A2(
				$elm$core$List$map,
				function (student) {
					return $elm$core$String$fromInt(student.gT);
				},
				schoolStudents);
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{e1: studentsField}),
				A2(form.e1.jR, studentValues, values));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Element$LearningGroupForm$updateForm = F5(
	function (session, store, msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ha: $author$project$Form$markEdited(form.ha)
						}),
					A2(form.ha.jR, value, formValues));
			case 1:
				var value = msg.a;
				return A2(
					$author$project$Element$LearningGroupForm$resetFormStudents,
					session,
					A3(
						$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
						session,
						store,
						_Utils_Tuple2(
							_Utils_update(
								form,
								{
									bp: $author$project$Form$markEdited(form.bp)
								}),
							A2(form.bp.jR, value, formValues))));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							e1: $author$project$Form$markEdited(form.e1)
						}),
					A2(form.e1.jR, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aj: $author$project$Form$markEdited(form.aj)
						}),
					A2(form.aj.jR, value, formValues));
		}
	});
var $author$project$Element$LearningGroupForm$updateFormWithSchools = F4(
	function (data, formPage, _v0, model) {
		var action = formPage.hQ;
		var form = formPage.bt;
		var values = formPage.ej;
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var config = model.bN;
		var session = model.cv;
		var store = model.bd;
		var updatedModel = _Utils_update(
			model,
			{
				bd: _Utils_update(
					store,
					{jr: data})
			});
		switch (data.$) {
			case 2:
				var schools = data.a;
				var teamValue = function () {
					if (action.$ === 1) {
						return form.bp.nD(values);
					} else {
						var _v4 = A2($author$project$Person$filterPersonTeams, schools, viewer);
						if (_v4.b && (!_v4.b.b)) {
							var school = _v4.a;
							return $elm$core$String$fromInt(
								$author$project$Team$teamIdToInt(school.gT));
						} else {
							return '';
						}
					}
				}();
				var values2 = _Utils_update(
					values,
					{bp: teamValue});
				var schoolOptions = A2($author$project$Element$LearningGroupForm$toViewerSchoolOptions, viewer, schools);
				var form2 = _Utils_update(
					form,
					{
						bp: A2($author$project$Form$fillFieldOptions, schoolOptions, form.bp)
					});
				var _v2 = A3(
					$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
					session,
					updatedModel.bd,
					_Utils_Tuple2(form2, values2));
				var form3 = _v2.a;
				var values3 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							bm: $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{bt: form3, ej: values3}))
						}),
					$author$project$Element$LearningGroupForm$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				var error = data.a;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							cv: A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$TeamListDownloadError))
						}),
					$author$project$Element$LearningGroupForm$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgTeamsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
								error),
							$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
					$elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$PhoneBookDownloadError = {$: 370};
var $author$project$Log$msgPeopleDownload = 'people_download';
var $author$project$Element$LearningGroupForm$updateFormWithStudents = F4(
	function (data, formPage, _v0, model) {
		var form = formPage.bt;
		var values = formPage.ej;
		var viewer = _v0.nH;
		var t_ = _v0.hy;
		var config = model.bN;
		var session = model.cv;
		var store = model.bd;
		var updatedModel = _Utils_update(
			model,
			{
				bd: _Utils_update(
					store,
					{e1: data})
			});
		switch (data.$) {
			case 2:
				var students = data.a;
				var studentOptions = A3($author$project$Element$LearningGroupForm$filterPersonsToSelectOptions, t_, viewer, students);
				var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1);
				var form2 = _Utils_update(
					form,
					{e1: studentsField});
				var _v2 = A3(
					$author$project$Element$LearningGroupForm$updateFormStudentsBySchool,
					session,
					updatedModel.bd,
					_Utils_Tuple2(form2, values));
				var form3 = _v2.a;
				var values2 = _v2.b;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							bm: $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{bt: form3, ej: values2}))
						}),
					$author$project$Element$LearningGroupForm$NoEffect,
					$elm$core$Maybe$Nothing);
			case 3:
				var error = data.a;
				return _Utils_Tuple3(
					_Utils_update(
						updatedModel,
						{
							cv: A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PhoneBookDownloadError))
						}),
					$author$project$Element$LearningGroupForm$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPeopleDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
								error),
							$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
					$elm$core$Maybe$Nothing);
			case 0:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$LearningGroup$updateLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			O: $author$project$LearningGroup$encodedLearningGroupToBackend(learningGroup),
			bN: config,
			dC: $author$project$LearningGroup$learningGroupDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2(
				$author$project$Api$Endpoint$learningGroup,
				config.gr,
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT))
		};
	});
var $author$project$Element$LearningGroupForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			aj: $author$project$Form$markEdited(form.aj),
			ha: $author$project$Form$markEdited(form.ha),
			bp: $author$project$Form$markEdited(form.bp),
			e1: $author$project$Form$markEdited(form.e1)
		});
};
var $author$project$Element$LearningGroupForm$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var store = model.bd;
		var viewer = session.nH;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$11:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (!_v0.b.$) {
						var data = _v0.a.a;
						var _v1 = _v0.b;
						switch (data.$) {
							case 2:
								var learningGroup = data.a;
								return A3($author$project$Element$LearningGroupForm$openUpdateForm, learningGroup, session, model);
							case 3:
								var error = data.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											cv: A3(
												$author$project$Session$error,
												session,
												error,
												t_($author$project$Locale$Messages$LearningGroupDownloadError))
										}),
									$author$project$Element$LearningGroupForm$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgLearningGroupsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
												error),
											$elm$core$Basics$always($author$project$Element$LearningGroupForm$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 2:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						switch (data.$) {
							case 2:
								var updatedSession = A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$LearningGroupSaveSuccess));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cv: updatedSession}),
									$author$project$Element$LearningGroupForm$NavRedirect($author$project$Route$LearningGroupList),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningGroupSaveError));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cv: updatedSession}),
									$author$project$Element$LearningGroupForm$NoEffect,
									$elm$core$Maybe$Nothing);
							default:
								var error = $author$project$Api$CustomError('Unexpected msg (LearningGroupSaved RemoteData.NotAsked)');
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$LearningGroupSaveError));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{cv: updatedSession}),
									$author$project$Element$LearningGroupForm$NoEffect,
									$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 3:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$LearningGroupForm$updateFormWithSchools, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bd: _Utils_update(
										store,
										{jr: data})
								}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				case 4:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$LearningGroupForm$updateFormWithStudents, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bd: _Utils_update(
										store,
										{e1: data})
								}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					}
				case 8:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var field = form.e1;
						var _v4 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
						var updatedField = _v4.a;
						var effect = _v4.b;
						var outMsg = _v4.c;
						var formMsg = $author$project$Element$LearningGroupForm$Students(
							$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
						var formPage2 = _Utils_update(
							formPage,
							{
								bt: _Utils_update(
									form,
									{e1: updatedField})
							});
						var _v5 = function () {
							if (!outMsg.$) {
								return A5($author$project$Element$LearningGroupForm$updateForm, session, store, formMsg, formPage2.bt, formPage2.ej);
							} else {
								return _Utils_Tuple2(formPage2.bt, formPage2.ej);
							}
						}();
						var form3 = _v5.a;
						var values3 = _v5.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bm: $author$project$Element$LearningGroupForm$FormPage(
										_Utils_update(
											formPage,
											{bt: form3, eZ: 1, ej: values3}))
								}),
							A2($author$project$Element$LearningGroupForm$MultiselectEffect, $author$project$Element$LearningGroupForm$StudentsFieldMsg, effect),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				case 5:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var _v7 = A5($author$project$Element$LearningGroupForm$updateForm, session, store, fieldMsg, formPage.bt, formPage.ej);
						var form2 = _v7.a;
						var values2 = _v7.b;
						var page2 = $author$project$Element$LearningGroupForm$FormPage(
							_Utils_update(
								formPage,
								{bt: form2, eZ: 1, ej: values2}));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bm: page2}),
							$author$project$Element$LearningGroupForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				case 7:
					if (_v0.b.$ === 1) {
						var _v8 = _v0.a;
						var action = _v0.b.a.hQ;
						if (action.$ === 1) {
							var learningGroup = action.a;
							return A3($author$project$Element$LearningGroupForm$openUpdateForm, learningGroup, session, model);
						} else {
							return _Utils_Tuple3(model, $author$project$Element$LearningGroupForm$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 6:
					if (_v0.b.$ === 1) {
						var _v10 = _v0.a;
						var formPage = _v0.b.a;
						var action = formPage.hQ;
						var form = formPage.bt;
						var values = formPage.ej;
						if (A2($author$project$Element$LearningGroupForm$isFormValid, form, values)) {
							var page = $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{eZ: 2}));
							var effect = function () {
								if (!action.$) {
									var unsavedLearningGroup = A4($author$project$Element$LearningGroupForm$saveForm, form, values, viewer, $elm$core$Maybe$Nothing);
									return $author$project$Element$LearningGroupForm$CreateLearningGroup(
										A3($author$project$LearningGroup$createLearningGroup, config, unsavedLearningGroup, $author$project$Element$LearningGroupForm$LearningGroupSaved));
								} else {
									var learningGroup = action.a;
									var unsavedLearningGroup = A4(
										$author$project$Element$LearningGroupForm$saveForm,
										form,
										values,
										viewer,
										$elm$core$Maybe$Just(learningGroup));
									return $author$project$Element$LearningGroupForm$UpdateLearningGroup(
										A3($author$project$LearningGroup$updateLearningGroup, config, unsavedLearningGroup, $author$project$Element$LearningGroupForm$LearningGroupSaved));
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bm: page}),
								effect,
								$elm$core$Maybe$Nothing);
						} else {
							var page = $author$project$Element$LearningGroupForm$FormPage(
								_Utils_update(
									formPage,
									{
										bt: $author$project$Element$LearningGroupForm$validateForm(form),
										eZ: 1
									}));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{bm: page}),
								$author$project$Element$LearningGroupForm$ScrollToFormError,
								$elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$11;
					}
				case 9:
					if (_v0.b.$ === 1) {
						var _v12 = _v0.a;
						return _Utils_Tuple3(
							model,
							$author$project$Element$LearningGroupForm$NavRedirect($author$project$Route$LearningGroupList),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$11;
					}
				default:
					break _v0$11;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$LearningGroupListLoadingProgress = {$: 162};
var $author$project$Element$LearningGroupForm$Exit = {$: 9};
var $author$project$Element$LearningGroupForm$FormReset = {$: 7};
var $author$project$Element$LearningGroupForm$FormSubmitted = {$: 6};
var $author$project$Locale$Messages$LearningGroupBtnOwn = {$: 147};
var $author$project$Locale$Messages$LearningGroupBtnSchool = {$: 148};
var $author$project$Locale$Messages$LearningGroupHeadingEdit = {$: 157};
var $author$project$Locale$Messages$LearningGroupHeadingNew = {$: 158};
var $author$project$Element$LearningGroupForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.hQ;
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var stringFromBool = function (value) {
			return value ? 'True' : 'False';
		};
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ha, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.bp, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$multiselectChoiceField, t_, form.e1, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											A2($elm$html$Html$Attributes$style, 'z-index', '0'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'is-selected is-link is-light',
													stringFromBool(
														form.aj.nD(values)) === 'False')
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$LearningGroupForm$FormMsg(
												$author$project$Element$LearningGroupForm$IsShared(false)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupBtnOwn)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											A2($elm$html$Html$Attributes$style, 'z-index', '0'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'is-selected is-link is-light',
													stringFromBool(
														form.aj.nD(values)) === 'True')
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$LearningGroupForm$FormMsg(
												$author$project$Element$LearningGroupForm$IsShared(true)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupBtnSchool)
										]))
								]))
						]))
				]));
		var headingText = function () {
			if (!action.$) {
				return $author$project$Locale$Messages$LearningGroupHeadingNew;
			} else {
				return $author$project$Locale$Messages$LearningGroupHeadingEdit;
			}
		}();
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						viewFormFields,
						A2(
						$author$project$UI$nav,
						_List_fromArray(
							[
								A5(
								$author$project$UI$formButtons,
								t_,
								action,
								state,
								$author$project$Element$LearningGroupForm$FormSubmitted,
								$elm$core$Basics$always($author$project$Element$LearningGroupForm$FormReset)),
								A3(
								$author$project$UI$actionLink,
								$author$project$Element$LearningGroupForm$Exit,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button is-light')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
									]))
							]),
						_List_Nil)
					]),
				kJ: 'learninggroup-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, headingText)
							]),
						_List_Nil)
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$LearningGroupForm$view = function (_v0) {
	var session = _v0.cv;
	var page = _v0.bm;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (page.$ === 1) {
					var formPage = page.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Element$LearningGroupForm$viewForm, session.hy, formPage)
							]));
				} else {
					return A2(
						$author$project$UI$progressBar,
						'is-link',
						session.hy($author$project$Locale$Messages$LearningGroupListLoadingProgress));
				}
			}()
			]));
};
var $author$project$Element$LearningGroupForm$element = {iA: $author$project$Element$LearningGroupForm$init, hh: $author$project$Element$LearningGroupForm$perform, jR: $author$project$Element$LearningGroupForm$update, nE: $author$project$Element$LearningGroupForm$view};
var $author$project$Element$LearningGroupList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupList$FetchLearningGroupList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupList$LearningGroupListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LearningGroupList$ListQuery = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupList$LoadingLearningGroups = 0;
var $author$project$Element$LearningGroupList$getListQuery = function (_v0) {
	var query = _v0;
	return query;
};
var $author$project$Element$LearningGroupList$listFilterToCategory = function (filter) {
	var _v0 = filter.bs;
	switch (_v0) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		default:
			return $author$project$Api$Endpoint$categoryCreator;
	}
};
var $author$project$Element$LearningGroupList$asListParams = function (_v0) {
	var filter = _v0.bO;
	var query = _v0.bw;
	return {
		bs: $author$project$Element$LearningGroupList$listFilterToCategory(filter),
		bw: $author$project$Element$LearningGroupList$getListQuery(query)
	};
};
var $author$project$Element$LearningGroupList$FilterAll = 0;
var $author$project$Element$LearningGroupList$ListFilter = function (category) {
	return {bs: category};
};
var $author$project$Element$LearningGroupList$defaultFilter = $author$project$Element$LearningGroupList$ListFilter(0);
var $author$project$Api$Endpoint$toLearningGroupListQueryParams = function (listParams) {
	return _List_fromArray(
		[
			_Utils_Tuple2('cat', listParams.bs),
			_Utils_Tuple2('q', listParams.bw)
		]);
};
var $author$project$Api$Endpoint$learningGroups = F2(
	function (config, listParams) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'learning-groups']),
			$author$project$Api$Endpoint$toLearningGroupListQueryParams(listParams));
	});
var $author$project$LearningGroup$fetchLearningGroups = F3(
	function (config, params, callback) {
		return {
			bN: config,
			dC: $elm$json$Json$Decode$list($author$project$LearningGroup$learningGroupDecoder),
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$learningGroups, config, params)
		};
	});
var $author$project$Element$LearningGroupList$init = F3(
	function (config, session, _v0) {
		var model = {bN: config, bO: $author$project$Element$LearningGroupList$defaultFilter, cc: _List_Nil, cY: 0, bw: '', cv: session, cw: $elm$core$Dict$empty};
		var listParams = $author$project$Element$LearningGroupList$asListParams(model);
		return _Utils_Tuple3(
			model,
			$author$project$Element$LearningGroupList$Cmd(
				$author$project$Element$LearningGroupList$FetchLearningGroupList(
					A3($author$project$LearningGroup$fetchLearningGroups, config.gr, listParams, $author$project$Element$LearningGroupList$LearningGroupListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$LearningGroupList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$LearningGroupSingle$NoEffect = {$: 0};
var $author$project$Element$LearningGroupSingle$init = F3(
	function (config, session, _v0) {
		var learningGroup = _v0.lS;
		var highlight = _v0.lg;
		var model = {bN: config, lg: highlight, lS: learningGroup, cv: session};
		return _Utils_Tuple3(model, $author$project$Element$LearningGroupSingle$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupSingle$perform = F2(
	function (key, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$deleteV2(request);
				case 2:
					var route = cmd.a;
					return A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Route$toString(route));
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$LearningGroupSingle$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$DeleteLearningGroup = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LearningGroupSingle$Deleted = 0;
var $author$project$Locale$Messages$LearningGroupDeleteError = {$: 149};
var $author$project$Locale$Messages$LearningGroupDeleteSuccess = {$: 150};
var $author$project$Element$LearningGroupSingle$LearningGroupDeleted = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$LogError = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSingle$NavRedirect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupSingle$NoOp = {$: 2};
var $author$project$LearningGroup$deleteLearningGroup = F3(
	function (config, learningGroup, callback) {
		return {
			O: $elm$http$Http$emptyBody,
			bN: config,
			bZ: callback,
			G: A2(
				$author$project$Api$Endpoint$learningGroup,
				config,
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT))
		};
	});
var $author$project$Log$msgLearningGroupDelete = 'learning_group_delete';
var $author$project$Element$LearningGroupSingle$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		switch (msg.$) {
			case 0:
				var learningGroup = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$LearningGroupSingle$Cmd(
						$author$project$Element$LearningGroupSingle$DeleteLearningGroup(
							A3($author$project$LearningGroup$deleteLearningGroup, config.gr, learningGroup, $author$project$Element$LearningGroupSingle$LearningGroupDeleted))),
					$elm$core$Maybe$Nothing);
			case 1:
				if (!msg.a.$) {
					var model2 = _Utils_update(
						model,
						{
							cv: A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$LearningGroupDeleteSuccess))
						});
					return _Utils_Tuple3(
						model2,
						$author$project$Element$LearningGroupSingle$Cmd(
							$author$project$Element$LearningGroupSingle$NavRedirect($author$project$Route$LearningGroupList)),
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$LearningGroupDeleteError))
							}),
						$author$project$Element$LearningGroupSingle$Cmd(
							$author$project$Element$LearningGroupSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgLearningGroupDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$LearningGroupSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$LearningGroupSingle$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$LearningGroupSingle$LearningGroupRemovalRequested = function (a) {
	return {$: 0, a: a};
};
var $author$project$ACL$canDeleteLearningGroup = F2(
	function (learningGroup, person) {
		return A2($author$project$Person$isSamePerson, learningGroup.ib, person);
	});
var $author$project$ACL$canEditLearningGroup = F2(
	function (learningGroup, person) {
		return A2($author$project$Person$isSamePerson, learningGroup.ib, person) || A2(
			$elm$core$List$member,
			learningGroup.jF.gT,
			$author$project$Person$teams(person));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupHighlights = F2(
	function (t_, learningGroup) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, learningGroup.ib)),
					$elm$html$Html$text(learningGroup.jF.kP)
				]));
	});
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $author$project$Util$Html$needle = function (needles) {
	return $elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$parser$Parser$backtrackable, $elm$parser$Parser$token),
				needles)));
};
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.f, s.mR, s.kA, s.e);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.e) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.f, adjustedOffset) < 0,
			0,
			{kA: newCol, l: s.l, p: s.p, f: adjustedOffset, mR: newRow, e: s.e});
	};
};
var $elm$parser$Parser$chompUntilEndOr = $elm$parser$Parser$Advanced$chompUntilEndOr;
var $author$project$Util$Html$notNeedle = function (needles) {
	return $elm$parser$Parser$getChompedString(
		$elm$parser$Parser$oneOf(
			A2(
				$elm$core$List$map,
				A2($elm$core$Basics$composeL, $elm$parser$Parser$backtrackable, $elm$parser$Parser$chompUntilEndOr),
				needles)));
};
var $author$project$Util$Html$fuzzyMatchTextHelp = F4(
	function (needles, mapNeedle, mapNotNeedle, revItems) {
		var stop = $elm$parser$Parser$map(
			$elm$core$Basics$always(
				$elm$parser$Parser$Done(
					$elm$core$List$reverse(revItems))));
		var next = $elm$parser$Parser$map(
			function (item) {
				return $elm$parser$Parser$Loop(
					A2($elm$core$List$cons, item, revItems));
			});
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					stop($elm$parser$Parser$end),
					next(
					A2(
						$elm$parser$Parser$map,
						mapNeedle,
						$author$project$Util$Html$needle(needles))),
					next(
					A2(
						$elm$parser$Parser$map,
						mapNotNeedle,
						$author$project$Util$Html$notNeedle(needles)))
				]));
	});
var $author$project$Util$Html$fuzzyMatchText = F4(
	function (needle_, haystack, mapNeedle, mapNotNeedle) {
		var regex = A2(
			$elm$core$Maybe$withDefault,
			$elm$regex$Regex$never,
			A2(
				$elm$regex$Regex$fromStringWith,
				{kx: true, l8: false},
				needle_));
		var needles = A2(
			$elm$core$List$map,
			function ($) {
				return $.lW;
			},
			A2($elm$regex$Regex$find, regex, haystack));
		return $elm$core$List$isEmpty(needles) ? A2(
			$elm$parser$Parser$map,
			A2($elm$core$Basics$composeR, mapNotNeedle, $elm$core$List$singleton),
			$elm$parser$Parser$succeed(haystack)) : A2(
			$elm$parser$Parser$loop,
			_List_Nil,
			A3($author$project$Util$Html$fuzzyMatchTextHelp, needles, mapNeedle, mapNotNeedle));
	});
var $author$project$UI$withHighlightedText = F2(
	function (highlight_, content) {
		var toHtml = $elm$html$Html$text;
		var highlightToHtml = function (match) {
			return A2(
				$elm$html$Html$mark,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(match)
					]));
		};
		return $elm$core$String$isEmpty(highlight_) ? toHtml(content) : A2(
			$elm$core$Result$withDefault,
			toHtml(content),
			A2(
				$elm$core$Result$map,
				$elm$html$Html$span(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('has-match')
						])),
				A2(
					$elm$parser$Parser$run,
					A4($author$project$Util$Html$fuzzyMatchText, highlight_, content, highlightToHtml, toHtml),
					content)));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupName = F2(
	function (learningGroup, highlight) {
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$withHighlightedText, highlight, learningGroup.ha)
				]));
	});
var $author$project$Locale$Messages$LearningGroupEmptyStudents = {$: 152};
var $author$project$Element$LearningGroupSingle$viewStudents = F3(
	function (t_, learningGroup, highlight) {
		var studentNames = $elm$core$List$isEmpty(learningGroup.e1) ? t_($author$project$Locale$Messages$LearningGroupEmptyStudents) : A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Person$fullName(t_),
				learningGroup.e1));
		return A2(
			$elm$html$Html$p,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$UI$withHighlightedText, highlight, studentNames)
				]));
	});
var $author$project$Element$LearningGroupSingle$viewLearningGroupItem = F4(
	function (t_, viewer, learningGroup, highlight) {
		var viewMediaObject = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(learningGroup.ib.K)
						]),
					_List_fromArray(
						[
							A2($author$project$Element$LearningGroupSingle$viewLearningGroupName, learningGroup, highlight),
							A2($author$project$Element$LearningGroupSingle$viewLearningGroupHighlights, t_, learningGroup)
						]),
					_List_Nil,
					_List_Nil)
				]));
		var editLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$LearningGroupUpdate(
						$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT))),
					$author$project$UI$attrCyData('learninggroup-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var deleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$LearningGroupSingle$LearningGroupRemovalRequested(learningGroup),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('learninggroup-item-delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewNav = A2(
			$author$project$UI$nav,
			_List_fromArray(
				[
					A2($author$project$ACL$canEditLearningGroup, learningGroup, viewer) ? editLink : $author$project$UI$none,
					A2($author$project$ACL$canDeleteLearningGroup, learningGroup, viewer) ? deleteLink : $author$project$UI$none
				]),
			_List_Nil);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('learninggroup-item'),
					$elm$html$Html$Attributes$class('box'),
					A2($elm$html$Html$Attributes$style, 'width', '100%')
				]),
			_List_fromArray(
				[
					viewMediaObject,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							A3($author$project$Element$LearningGroupSingle$viewStudents, t_, learningGroup, highlight)
						])),
					viewNav
				]));
	});
var $author$project$Element$LearningGroupSingle$view = function (_v0) {
	var session = _v0.cv;
	var learningGroup = _v0.lS;
	var highlight = _v0.lg;
	return A4($author$project$Element$LearningGroupSingle$viewLearningGroupItem, session.hy, session.nH, learningGroup, highlight);
};
var $author$project$Element$LearningGroupSingle$element = {iA: $author$project$Element$LearningGroupSingle$init, hh: $author$project$Element$LearningGroupSingle$perform, jR: $author$project$Element$LearningGroupSingle$update, nE: $author$project$Element$LearningGroupSingle$view};
var $author$project$Element$LearningGroupList$singleElement = function (learningGroupId) {
	return {
		gF: $author$project$Element$LearningGroupSingle$element,
		jK: $author$project$Element$LearningGroupList$SingleElementEffect(learningGroupId),
		bZ: $author$project$Element$LearningGroupList$SingleElementMsg(learningGroupId),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						cw: A3(
							$elm$core$Dict$update,
							$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
							$elm$core$Basics$always(
								$elm$core$Maybe$Just(model)),
							containerModel.cw)
					});
			})
	};
};
var $author$project$Element$LearningGroupList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 3:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$LearningGroupList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
				}
			default:
				var learningGroupId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$LearningGroupList$singleElement(learningGroupId));
		}
	});
var $author$project$Element$LearningGroupList$Delay = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$LearningGroupList$DelayedGotListQuery = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupList$NoEffect = {$: 3};
var $author$project$Element$LearningGroupList$NoOp = {$: 5};
var $author$project$Element$LearningGroupList$LearningGroupsLoaded = 1;
var $author$project$Element$LearningGroupList$addNewLearningGroups = F2(
	function (newGroups, model) {
		var loading = model.cY;
		var learningGroups = model.cc;
		var _v0 = _Utils_Tuple3(loading, learningGroups, newGroups);
		if ((!_v0.a) && (!_v0.b.b)) {
			var _v1 = _v0.a;
			return _Utils_update(
				model,
				{cc: newGroups, cY: 1});
		} else {
			return model;
		}
	});
var $author$project$Element$LearningGroupList$emptyList = function (model) {
	return _Utils_update(
		model,
		{cc: _List_Nil, cY: 0});
};
var $author$project$Element$LearningGroupList$filterLearningGroups = F2(
	function (model, newFilter) {
		var filter = model.bO;
		var model_ = $author$project$Element$LearningGroupList$emptyList(
			_Utils_update(
				model,
				{
					bO: _Utils_update(
						filter,
						{bs: newFilter})
				}));
		var listParams = $author$project$Element$LearningGroupList$asListParams(model_);
		return _Utils_Tuple3(
			model_,
			$author$project$Element$LearningGroupList$Cmd(
				$author$project$Element$LearningGroupList$FetchLearningGroupList(
					A3($author$project$LearningGroup$fetchLearningGroups, model.bN.gr, listParams, $author$project$Element$LearningGroupList$LearningGroupListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 3:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$LearningGroupList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$LearningGroupList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$LearningGroupList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$LearningGroupList$initLearningGroupSingles = F2(
	function (model, learningGroups) {
		var startModel = _Utils_update(
			model,
			{cc: learningGroups, cY: 1});
		var initLearningGroupSingle = F2(
			function (learningGroup, _v1) {
				var model_ = _v1.a;
				var effect_ = _v1.b;
				var single = $author$project$Element$LearningGroupList$singleElement(learningGroup.gT);
				var params = {
					lg: $author$project$Element$LearningGroupList$getListQuery(model.bw),
					lS: learningGroup
				};
				var _v0 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model_,
					single,
					A4($author$project$Application$V3$Boundaries$initElement, model_.bN, model_.cv, single, params));
				var model2 = _v0.a;
				var effect2 = _v0.b;
				return _Utils_Tuple3(
					model2,
					A2($author$project$Element$LearningGroupList$batchEffect, effect2, effect_),
					$elm$core$Maybe$Nothing);
			});
		return A3(
			$elm$core$List$foldl,
			initLearningGroupSingle,
			_Utils_Tuple3(startModel, $author$project$Element$LearningGroupList$NoEffect, $elm$core$Maybe$Nothing),
			learningGroups);
	});
var $author$project$Util$Delay$searchBarDelay = 0.5;
var $author$project$Element$LearningGroupList$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupList$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				var learningGroupId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = function (singleModel_) {
					var single = $author$project$Element$LearningGroupList$singleElement(learningGroupId);
					var _v1 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						single,
						A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
					var model2 = _v1.a;
					var effect = _v1.b;
					var reply = _v1.c;
					if (!reply.$) {
						var _v3 = reply.a;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{
									cw: A2(
										$elm$core$Dict$remove,
										$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
										model.cw)
								}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				};
				var singleModel = A2(
					$elm$core$Dict$get,
					$author$project$LearningGroup$learningGroupIdToInt(learningGroupId),
					model.cw);
				return A2(
					$elm$core$Maybe$withDefault,
					noop,
					A2($elm$core$Maybe$map, updateSingleElement, singleModel));
			case 1:
				var newFilter = msg.a;
				return A2($author$project$Element$LearningGroupList$filterLearningGroups, model, newFilter);
			case 2:
				var query = msg.a;
				return _Utils_Tuple3(
					$author$project$Element$LearningGroupList$emptyList(
						_Utils_update(
							model,
							{bw: query})),
					$author$project$Element$LearningGroupList$Cmd(
						A2(
							$author$project$Element$LearningGroupList$Delay,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$LearningGroupList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 3:
				var newQuery = msg.a;
				var cmd = _Utils_eq(newQuery, model.bw) ? $author$project$Element$LearningGroupList$Cmd(
					$author$project$Element$LearningGroupList$FetchLearningGroupList(
						A3(
							$author$project$LearningGroup$fetchLearningGroups,
							config.gr,
							$author$project$Element$LearningGroupList$asListParams(model),
							$author$project$Element$LearningGroupList$LearningGroupListDownloaded))) : $author$project$Element$LearningGroupList$NoEffect;
				return _Utils_Tuple3(model, cmd, $elm$core$Maybe$Nothing);
			case 4:
				var data = msg.a;
				switch (data.$) {
					case 2:
						var learningGroups = data.a;
						var updatedModel = A2($author$project$Element$LearningGroupList$addNewLearningGroups, learningGroups, model);
						return A2($author$project$Element$LearningGroupList$initLearningGroupSingles, updatedModel, updatedModel.cc);
					case 3:
						var error = data.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$LearningGroupDownloadError))
								}),
							$author$project$Element$LearningGroupList$Cmd(
								$author$project$Element$LearningGroupList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgLearningGroupsDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$LearningGroupList$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 1:
						return noop;
					default:
						return noop;
				}
			default:
				return noop;
		}
	});
var $author$project$Element$LearningGroupList$FilterOwn = 2;
var $author$project$Element$LearningGroupList$FilterTeam = 1;
var $author$project$Element$LearningGroupList$GotCategoryFilter = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupList$GotListQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$LearningGroupListAllFilter = {$: 160};
var $author$project$Locale$Messages$LearningGroupListEmptyResults = {$: 161};
var $author$project$Locale$Messages$LearningGroupListOwnFilter = {$: 163};
var $author$project$Locale$Messages$LearningGroupListSchoolFilter = {$: 164};
var $author$project$Locale$Messages$LearningGroupListSearch = {$: 165};
var $author$project$Locale$Messages$LearningGroupTitle = {$: 172};
var $author$project$ACL$canCreateLearningGroup = function (person) {
	return $author$project$ACL$isStaff(person) || ($author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person));
};
var $author$project$Element$LearningGroupList$viewSingleElement = F3(
	function (session, leaningGroup, singleModel) {
		return A3(
			$author$project$Application$V3$Boundaries$viewElement,
			session,
			singleModel,
			$author$project$Element$LearningGroupList$singleElement(leaningGroup.gT));
	});
var $author$project$Element$LearningGroupList$viewLearningGroupList = function (_v0) {
	var learningGroups = _v0.cc;
	var filter = _v0.bO;
	var query = _v0.bw;
	var singleElements = _v0.cw;
	var session = _v0.cv;
	var loading = _v0.cY;
	var viewer = session.nH;
	var viewKeyedItem = function (learningGroup) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(
				$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT)),
			A2(
				$author$project$UI$maybe,
				A2(
					$elm$core$Dict$get,
					$author$project$LearningGroup$learningGroupIdToInt(learningGroup.gT),
					singleElements),
				A2($author$project$Element$LearningGroupList$viewSingleElement, session, learningGroup)));
	};
	var t_ = session.hy;
	var viewCreateLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href($author$project$Route$LearningGroupCreate),
				$author$project$UI$attrCyData('learninggroup-create'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewFilterLinks = A3(
		$author$project$UI$List$filterBar,
		t_,
		_Utils_Tuple2($author$project$Element$LearningGroupList$GotCategoryFilter, filter.bs),
		_List_fromArray(
			[
				{
				kJ: 'all',
				bO: 0,
				g_: true,
				g$: $author$project$ACL$canViewLearningGroup(viewer),
				lO: $author$project$Locale$Messages$LearningGroupListAllFilter
			},
				{
				kJ: 'team',
				bO: 1,
				g_: true,
				g$: $author$project$ACL$canViewLearningGroup(viewer),
				lO: $author$project$Locale$Messages$LearningGroupListSchoolFilter
			},
				{
				kJ: 'own',
				bO: 2,
				g_: true,
				g$: $author$project$ACL$canViewLearningGroup(viewer),
				lO: $author$project$Locale$Messages$LearningGroupListOwnFilter
			}
			]));
	var viewHeading = A2(
		$author$project$UI$levelHorizontal,
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupTitle)
			]),
		$author$project$ACL$canCreateLearningGroup(viewer) ? _List_fromArray(
			[viewCreateLink]) : _List_Nil);
	var viewLoadingState = function () {
		var _v1 = _Utils_Tuple2(loading, learningGroups);
		_v1$2:
		while (true) {
			if (!_v1.a) {
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return _List_fromArray(
						[$author$project$UI$List$resultsLoadingProgressBar]);
				} else {
					break _v1$2;
				}
			} else {
				if (!_v1.b.b) {
					var _v3 = _v1.a;
					return _List_fromArray(
						[
							A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$LearningGroupListEmptyResults)
						]);
				} else {
					break _v1$2;
				}
			}
		}
		return _List_Nil;
	}();
	return $author$project$UI$keyedPanel(
		{
			kt: A2(
				$elm$core$List$cons,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									$author$project$UI$List$searchBar(
									{
										aT: function (input) {
											return $author$project$Element$LearningGroupList$GotListQuery(input);
										},
										bv: t_($author$project$Locale$Messages$LearningGroupListSearch),
										bw: $author$project$Element$LearningGroupList$getListQuery(query)
									})
								]))
						])),
				viewLoadingState),
			kJ: 'learninggroup-list',
			le: _List_fromArray(
				[viewHeading]),
			lN: A2($elm$core$List$map, viewKeyedItem, learningGroups),
			nk: viewFilterLinks,
			nq: 'is-warning'
		});
};
var $author$project$Element$LearningGroupList$view = $author$project$Element$LearningGroupList$viewLearningGroupList;
var $author$project$Element$LearningGroupList$element = {iA: $author$project$Element$LearningGroupList$init, hh: $author$project$Element$LearningGroupList$perform, jR: $author$project$Element$LearningGroupList$update, nE: $author$project$Element$LearningGroupList$view};
var $author$project$Element$LearningGroupSelector$LoadingPage = {$: 0};
var $author$project$Element$LearningGroupSelector$FetchLearningGroups = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LearningGroupSelector$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$LearningGroupListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$LearningGroupSelectorFieldGroups = {$: 169};
var $author$project$Element$LearningGroupSelector$initLearningGroupsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				nl: 'LearningGroups',
				ej: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Form$requiredLearningGroups = F2(
	function (_v0, value) {
		return $elm$core$Result$Ok(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$identity,
						$elm$core$Maybe$withDefault(0)),
					$elm$core$String$toInt),
				value));
	});
var $author$project$Element$LearningGroupSelector$buildForm = F2(
	function (t_, learningGroupOptions) {
		var viewF = {
			kJ: 'groups',
			lj: 'fa-people-group',
			lO: t_($author$project$Locale$Messages$LearningGroupSelectorFieldGroups),
			mp: learningGroupOptions,
			eZ: $author$project$Element$LearningGroupSelector$initLearningGroupsField(learningGroupOptions),
			bZ: $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg
		};
		var options = A2($elm$core$Maybe$withDefault, _List_Nil, learningGroupOptions);
		var learninGroupsField = {
			kU: false,
			mu: $author$project$Form$requiredLearningGroups(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{cc: value});
				}),
			nD: function ($) {
				return $.cc;
			},
			nE: viewF
		};
		return {
			cc: A2($author$project$Form$setMultiselectSelection, options, learninGroupsField)
		};
	});
var $author$project$LearningGroup$defaultListParams = {bs: $author$project$Api$Endpoint$categoryAll, bw: ''};
var $author$project$Element$LearningGroupSelector$emptyForm = {cc: _List_Nil};
var $author$project$Element$LearningGroupSelector$initPageByParams = F3(
	function (params, session, model) {
		var page = $author$project$Element$LearningGroupSelector$FormPage(
			{
				bt: A2($author$project$Element$LearningGroupSelector$buildForm, session.hy, $elm$core$Maybe$Nothing),
				eZ: 0,
				ej: $author$project$Element$LearningGroupSelector$emptyForm
			});
		var updatedModel = _Utils_update(
			model,
			{
				bm: page,
				bp: params.bp,
				bd: {cc: $author$project$RemoteData$Loading}
			});
		var listParams = $author$project$LearningGroup$defaultListParams;
		return _Utils_Tuple3(
			updatedModel,
			$author$project$Element$LearningGroupSelector$FetchLearningGroups(
				A3($author$project$LearningGroup$fetchLearningGroups, model.bN.gr, listParams, $author$project$Element$LearningGroupSelector$LearningGroupListDownloaded)),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$LearningGroupSelector$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			bm: $author$project$Element$LearningGroupSelector$LoadingPage,
			bp: params.bp,
			jw: _List_Nil,
			cv: session,
			bd: {cc: $author$project$RemoteData$NotAsked}
		};
		return A3($author$project$Element$LearningGroupSelector$initPageByParams, params, session, model);
	});
var $author$project$Element$LearningGroupSelector$perform = F2(
	function (_v0, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			default:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
		}
	});
var $author$project$Element$LearningGroupSelector$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$Exit = {$: 0};
var $author$project$Element$LearningGroupSelector$FormMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LearningGroupSelector$LearningGroups = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupSelector$LogError = $elm$core$Basics$identity;
var $author$project$Element$LearningGroupSelector$MultiselectEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$LearningGroupSelector$NoEffect = {$: 0};
var $author$project$Element$LearningGroupSelector$NoOp = {$: 5};
var $author$project$Element$LearningGroupSelector$SelectedStudents = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LearningGroupSelector$makeStudentSet = function (groups) {
	var addIfNotExists = F2(
		function (group, acc) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (student, acc_) {
						return A2($elm$core$List$member, student, acc_) ? acc_ : A2($elm$core$List$cons, student, acc_);
					}),
				acc,
				group.e1);
		});
	return A3($elm$core$List$foldl, addIfNotExists, _List_Nil, groups);
};
var $author$project$Form$toGroupsOptions = function (groups) {
	return A2(
		$elm$core$List$map,
		function (group) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$elm$core$String$fromInt(
						$author$project$LearningGroup$learningGroupIdToInt(group.gT)),
					group.ha));
		},
		A2(
			$author$project$Util$List$sortBy,
			function ($) {
				return $.ha;
			},
			groups));
};
var $author$project$Element$LearningGroupSelector$updateForm = F2(
	function (msg, formPage) {
		var form = formPage.bt;
		var values = formPage.ej;
		var editedFormPage = _Utils_update(
			formPage,
			{eZ: 1});
		if (msg.$ === 3) {
			var formMsg = msg.a;
			var groupIds = formMsg;
			return _Utils_update(
				editedFormPage,
				{
					bt: _Utils_update(
						form,
						{
							cc: $author$project$Form$markEdited(form.cc)
						}),
					ej: A2(form.cc.jR, groupIds, values)
				});
		} else {
			return formPage;
		}
	});
var $author$project$Element$LearningGroupSelector$update = F2(
	function (msg, model) {
		var noop = _Utils_Tuple3(model, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$6:
		while (true) {
			switch (_v0.a.$) {
				case 1:
					if (_v0.b.$ === 1) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var store = model.bd;
						var updatedModel = _Utils_update(
							model,
							{
								bd: _Utils_update(
									store,
									{cc: data})
							});
						switch (data.$) {
							case 2:
								var groups = data.a;
								var schoolGroups = A2(
									$elm$core$List$filter,
									function (group) {
										return _Utils_eq(group.jF.gT, model.bp);
									},
									groups);
								var groupsOptions = $author$project$Form$toGroupsOptions(schoolGroups);
								var multiselectGroupsField = A2($author$project$Form$setMultiselectOptions, groupsOptions, form.cc);
								var form2 = _Utils_update(
									form,
									{cc: multiselectGroupsField});
								return _Utils_Tuple3(
									_Utils_update(
										updatedModel,
										{
											bm: $author$project$Element$LearningGroupSelector$FormPage(
												_Utils_update(
													formPage,
													{bt: form2}))
										}),
									$author$project$Element$LearningGroupSelector$NoEffect,
									$elm$core$Maybe$Nothing);
							case 3:
								var error = data.a;
								var updatedSession = A3(
									$author$project$Session$error,
									model.cv,
									error,
									model.cv.hy($author$project$Locale$Messages$LearningGroupDownloadError));
								return _Utils_Tuple3(
									_Utils_update(
										updatedModel,
										{cv: updatedSession}),
									$author$project$Element$LearningGroupSelector$Cmd(
										A3(
											$author$project$Log$errorV2,
											model.bN,
											_Utils_Tuple3(
												$author$project$Log$msgLearningGroupsDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLearningGroups),
												error),
											$elm$core$Basics$always($author$project$Element$LearningGroupSelector$NoOp))),
									$elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
							default:
								return _Utils_Tuple3(updatedModel, $author$project$Element$LearningGroupSelector$NoEffect, $elm$core$Maybe$Nothing);
						}
					} else {
						break _v0$6;
					}
				case 2:
					var _v2 = _v0.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$LearningGroupSelector$NoEffect,
						$elm$core$Maybe$Just($author$project$Element$LearningGroupSelector$Exit));
				case 0:
					var _v3 = _v0.a;
					var page = _v0.b;
					var selectedGroupIds = function () {
						if (page.$ === 1) {
							var formPageModel = page.a;
							return A2(
								$elm$core$List$map,
								$elm$core$Maybe$withDefault(0),
								A2(
									$elm$core$List$map,
									$elm$core$String$toInt,
									formPageModel.bt.cc.nD(formPageModel.ej)));
						} else {
							return _List_Nil;
						}
					}();
					var selectedGroups = A2(
						$author$project$RemoteData$map,
						function (groups) {
							return A2(
								$elm$core$List$filter,
								function (group) {
									return A2(
										$elm$core$List$member,
										$author$project$LearningGroup$learningGroupIdToInt(group.gT),
										selectedGroupIds);
								},
								groups);
						},
						model.bd.cc);
					var selectedStudents = $author$project$Element$LearningGroupSelector$makeStudentSet(
						A2($author$project$RemoteData$withDefault, _List_Nil, selectedGroups));
					return _Utils_Tuple3(
						model,
						$author$project$Element$LearningGroupSelector$NoEffect,
						$elm$core$Maybe$Just(
							$author$project$Element$LearningGroupSelector$SelectedStudents(selectedStudents)));
				case 4:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var field = form.cc;
						var _v5 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
						var updatedField = _v5.a;
						var effect = _v5.b;
						var outMsg = _v5.c;
						var formMsg = $author$project$Element$LearningGroupSelector$FormMsg(
							$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
						var formPage2 = _Utils_update(
							formPage,
							{
								bt: _Utils_update(
									form,
									{cc: updatedField})
							});
						var formPage3 = function () {
							if (!outMsg.$) {
								return A2($author$project$Element$LearningGroupSelector$updateForm, formMsg, formPage2);
							} else {
								return formPage2;
							}
						}();
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bm: $author$project$Element$LearningGroupSelector$FormPage(formPage3)
								}),
							A2($author$project$Element$LearningGroupSelector$MultiselectEffect, $author$project$Element$LearningGroupSelector$LearningGroupsFieldMsg, effect),
							$elm$core$Maybe$Nothing);
					} else {
						break _v0$6;
					}
				case 3:
					if (_v0.b.$ === 1) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var formPage2 = $author$project$Element$LearningGroupSelector$FormPage(
							A2(
								$author$project$Element$LearningGroupSelector$updateForm,
								$author$project$Element$LearningGroupSelector$FormMsg(fieldMsg),
								formPage));
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{bm: formPage2}),
							$author$project$Element$LearningGroupSelector$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				default:
					break _v0$6;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$LearningGroupSelectorInstruction = {$: 170};
var $author$project$Locale$Messages$LearningGroupSelectorTitle = {$: 171};
var $author$project$Element$LearningGroupSelector$viewForm = F2(
	function (t_, _v0) {
		var form = _v0.bt;
		var values = _v0.ej;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-italic has-text-grey')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											t_($author$project$Locale$Messages$LearningGroupSelectorInstruction))
										]))
								]))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$UI$multiselectChoiceField, t_, form.cc, values)
								]))
						]))
				]));
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[viewFormFields]),
				kJ: 'modules-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LearningGroupSelectorTitle)
							]),
						_List_Nil)
					]),
				nk: _List_Nil,
				nq: 'is-primary has-background-white'
			});
	});
var $author$project$Element$LearningGroupSelector$PopupClosed = {$: 2};
var $author$project$Element$LearningGroupSelector$LearningGroupsSelected = {$: 0};
var $author$project$Element$LearningGroupSelector$viewSelectorNav = function (t_) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar is-fixed-bottom has-background-link-light')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LearningGroupSelector$LearningGroupsSelected,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-link')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
											])),
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LearningGroupSelector$PopupClosed,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-light')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Element$LearningGroupSelector$viewPopup = function (_v0) {
	var session = _v0.cv;
	var page = _v0.bm;
	if (page.$ === 1) {
		var formPageModel = page.a;
		return A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$LearningGroupSelector$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$Element$LearningGroupSelector$viewForm, session.hy, formPageModel),
						$author$project$Element$LearningGroupSelector$viewSelectorNav(session.hy)
					])));
	} else {
		return $author$project$UI$section(_List_Nil);
	}
};
var $author$project$Element$LearningGroupSelector$view = function (model) {
	var _v0 = model.bm;
	if (_v0.$ === 1) {
		var formPage = _v0.a;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Element$LearningGroupSelector$viewForm, model.cv.hy, formPage)
				]));
	} else {
		return $author$project$UI$section(
			_List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-info',
					model.cv.hy($author$project$Locale$Messages$LearningGroupListLoadingProgress)),
					$author$project$Element$LearningGroupSelector$viewPopup(model)
				]));
	}
};
var $author$project$Element$LearningGroupSelector$element = {iA: $author$project$Element$LearningGroupSelector$init, hh: $author$project$Element$LearningGroupSelector$perform, jR: $author$project$Element$LearningGroupSelector$update, nE: $author$project$Element$LearningGroupSelector$view};
var $author$project$Element$LoBrowser$ageGroups = function (curriculum) {
	var technikum = _List_fromArray(
		[
			_Utils_Tuple2(9, 13)
		]);
	var altgim = _List_fromArray(
		[
			_Utils_Tuple2(1, 4),
			_Utils_Tuple2(5, 8),
			_Utils_Tuple2(9, 12)
		]);
	switch (curriculum) {
		case 'code':
			return technikum;
		case 'studio':
			return technikum;
		case 'altgim':
			return altgim;
		case 'onboarding':
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 4)
				]);
		case 'pw21jan':
			return _List_fromArray(
				[
					_Utils_Tuple2(1, 4)
				]);
		default:
			return _List_Nil;
	}
};
var $author$project$LoSearch$maxYear = 13;
var $author$project$LoSearch$minYear = 1;
var $author$project$Element$LoBrowser$defaultAgeGroup = function (curriculum) {
	return A2(
		$elm$core$Maybe$withDefault,
		_Utils_Tuple2($author$project$LoSearch$minYear, $author$project$LoSearch$maxYear),
		$elm$core$List$head(
			$author$project$Element$LoBrowser$ageGroups(curriculum)));
};
var $author$project$LoSearch$emptyQuery = {dK: $elm$core$Maybe$Nothing, dQ: $elm$core$Maybe$Nothing, bA: $elm$core$Maybe$Nothing, e2: $elm$core$Maybe$Nothing, nl: $elm$core$Maybe$Nothing};
var $author$project$Element$LoBrowser$defaultQuery = function (curriculum) {
	var _v0 = $author$project$Element$LoBrowser$defaultAgeGroup(curriculum);
	var firstYear = _v0.a;
	var lastYear = _v0.b;
	return _Utils_update(
		$author$project$LoSearch$emptyQuery,
		{
			dK: $elm$core$Maybe$Just(firstYear),
			dQ: $elm$core$Maybe$Just(lastYear)
		});
};
var $author$project$Element$LoBrowser$init = F3(
	function (_v0, session, _v1) {
		var initCurriculum = 'altgim';
		var model = {
			cG: initCurriculum,
			cH: false,
			eF: false,
			iN: $elm$core$Maybe$Nothing,
			bw: $author$project$Element$LoBrowser$defaultQuery(initCurriculum),
			eT: $elm$core$Maybe$Nothing,
			cu: $elm$core$Maybe$Nothing,
			hz: $elm$core$Maybe$Nothing,
			eg: false,
			dr: false
		};
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$LoBrowser$SubjectFilterSet = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$LoBrowser$TimeOut = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LoBrowser$emptyIsNothing = function (s) {
	return (s === '') ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
};
var $author$project$Element$LoBrowser$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var query = model.bw;
			switch (msg.$) {
				case 0:
					var query_ = msg.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A2(
							$author$project$Util$Delay$after,
							1,
							$author$project$Element$LoBrowser$TimeOut(
								_Utils_Tuple2(
									$author$project$Element$LoBrowser$emptyIsNothing(query_),
									$elm$core$Maybe$Nothing))),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									eF: true,
									eT: $author$project$Element$LoBrowser$emptyIsNothing(query_)
								}),
							session));
				case 1:
					var _v1 = msg.a;
					var newQueryValue = _v1.a;
					var newTagValue = _v1.b;
					var hasDryed = F3(
						function (newValue, oldValue, valueOnScreen) {
							if (newValue.$ === 1) {
								return _Utils_Tuple2(false, oldValue);
							} else {
								var realNewValue = newValue.a;
								return _Utils_eq(realNewValue, valueOnScreen) ? _Utils_Tuple2(true, realNewValue) : _Utils_Tuple2(false, oldValue);
							}
						});
					var _v2 = A3(
						hasDryed,
						$elm$core$Maybe$Just(newTagValue),
						query.nl,
						model.hz);
					var tagDryed = _v2.a;
					var newTag = _v2.b;
					var _v3 = A3(
						hasDryed,
						$elm$core$Maybe$Just(newQueryValue),
						query.bA,
						model.eT);
					var queryDryed = _v3.a;
					var newQuery = _v3.b;
					return (tagDryed || queryDryed) ? A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								eF: false,
								bw: _Utils_update(
									query,
									{bA: newQuery, nl: newTag})
							}),
						session) : A2($author$project$Application$Boundaries$save, model, session);
				case 2:
					var yf = msg.a;
					var query2 = _Utils_update(
						query,
						{
							dK: $elm$core$Maybe$Just(yf.a),
							dQ: $elm$core$Maybe$Just(yf.b),
							e2: $elm$core$Maybe$Nothing
						});
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bw: query2, dr: false}),
						session);
				case 3:
					var curriculum = msg.a;
					var _v5 = $author$project$Element$LoBrowser$defaultAgeGroup(curriculum);
					var firstYear = _v5.a;
					var lastYear = _v5.b;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								cG: curriculum,
								cH: false,
								bw: _Utils_update(
									query,
									{
										dK: $elm$core$Maybe$Just(firstYear),
										dQ: $elm$core$Maybe$Just(lastYear)
									})
							}),
						session);
				case 4:
					var sf = msg.a;
					var query2 = _Utils_update(
						query,
						{e2: sf});
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bw: query2, eg: true}),
						session);
				case 5:
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{cH: false, cu: $elm$core$Maybe$Nothing, dr: !model.dr}),
						session);
				case 6:
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{cH: !model.cH, cu: $elm$core$Maybe$Nothing, dr: false}),
						session);
				case 7:
					var subject = msg.a;
					if (_Utils_eq(
						query.e2,
						$elm$core$Maybe$Just(subject))) {
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{cu: $elm$core$Maybe$Nothing, eg: !model.eg}),
							session);
					} else {
						var $temp$session = session,
							$temp$msg = $author$project$Element$LoBrowser$SubjectFilterSet(
							$elm$core$Maybe$Just(subject)),
							$temp$model = _Utils_update(
							model,
							{cu: $elm$core$Maybe$Nothing});
						session = $temp$session;
						msg = $temp$msg;
						model = $temp$model;
						continue update;
					}
				default:
					var topic = msg.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						$author$project$Ports$scrollToElement(
							$elm$core$String$concat(
								_List_fromArray(
									['div[data-topic=\'', topic, '\']']))),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									cu: $elm$core$Maybe$Just(topic)
								}),
							session));
			}
		}
	});
var $author$project$LearningOutcome$Subject = F3(
	function (name, first, last) {
		return {a: first, b: last, ha: name};
	});
var $author$project$LearningOutcome$subject = function (lo) {
	return A3($author$project$LearningOutcome$Subject, lo.e2, lo.a, lo.b);
};
var $author$project$LearningOutcome$distinctSubjects = function (los) {
	return $author$project$Util$List$unique(
		A2($elm$core$List$map, $author$project$LearningOutcome$subject, los));
};
var $author$project$LearningOutcome$getLearningOutcomes = function (curriculum) {
	return A2(
		$elm$core$List$filter,
		function (lo) {
			return _Utils_eq(lo.cG, curriculum);
		},
		$author$project$LearningOutcome$all);
};
var $author$project$LoSearch$SearchResult = F3(
	function (query, weight, lo) {
		return {bA: lo, bw: query, nI: weight};
	});
var $author$project$LoSearch$between = F3(
	function (x, first, last) {
		return (_Utils_cmp(first, x) < 1) && (_Utils_cmp(x, last) < 1);
	});
var $author$project$LoSearch$nMatchingNgrams = F2(
	function (query, doc) {
		var aux = F2(
			function (n, q) {
				aux:
				while (true) {
					if (q.b) {
						var h = q.a;
						var tail = q.b;
						if (A2($elm$core$List$member, h, doc)) {
							var $temp$n = n + 1,
								$temp$q = tail;
							n = $temp$n;
							q = $temp$q;
							continue aux;
						} else {
							var $temp$n = n,
								$temp$q = tail;
							n = $temp$n;
							q = $temp$q;
							continue aux;
						}
					} else {
						return n;
					}
				}
			});
		return A2(aux, 0, query);
	});
var $author$project$LoSearch$ngram = F2(
	function (n, xs) {
		return (_Utils_cmp(
			n,
			$elm$core$String$length(xs)) < 1) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$left, n, xs),
			A2(
				$author$project$LoSearch$ngram,
				n,
				A2($elm$core$String$dropLeft, 1, xs))) : _List_Nil;
	});
var $author$project$LoSearch$ngrams = function (text) {
	return A2(
		$elm$core$List$concatMap,
		$author$project$LoSearch$ngram(4),
		A2($elm$core$String$split, ' ', text));
};
var $author$project$LoSearch$makeSearchResult = F2(
	function (ngramQuery, lo) {
		var res = A3(
			$author$project$LoSearch$SearchResult,
			ngramQuery,
			A2(
				$author$project$LoSearch$nMatchingNgrams,
				ngramQuery,
				$author$project$LoSearch$ngrams(lo.gD)),
			lo);
		var ngramWeight = function (initial) {
			return $elm$core$List$length(
				$author$project$LoSearch$ngrams(lo.gD)) / (initial / $elm$core$List$length(ngramQuery));
		};
		return (res.nI < 1) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_update(
				res,
				{
					nI: ngramWeight(res.nI)
				}));
	});
var $author$project$LoSearch$search = F4(
	function (_v0, queryLo, tagq, los) {
		var first = _v0.a;
		var last = _v0.b;
		var losInThatYears = A2(
			$elm$core$List$filter,
			function (lo) {
				return A3($author$project$LoSearch$between, lo.a, first, last) || A3($author$project$LoSearch$between, lo.b, first, last);
			},
			los);
		var losWithMatchingTags = function () {
			if (!tagq.$) {
				var tag = tagq.a;
				return A2(
					$elm$core$List$filter,
					function (lo) {
						return A2($elm$core$List$member, tag, lo.jE);
					},
					losInThatYears);
			} else {
				return losInThatYears;
			}
		}();
		if (queryLo.$ === 1) {
			return A2(
				$elm$core$List$map,
				function (lo) {
					return A3($author$project$LoSearch$SearchResult, _List_Nil, 1.0, lo);
				},
				losWithMatchingTags);
		} else {
			var q = queryLo.a;
			var ngramQuery = A2($author$project$LoSearch$ngram, 4, q);
			return A2(
				$elm$core$List$filterMap,
				$author$project$LoSearch$makeSearchResult(ngramQuery),
				losWithMatchingTags);
		}
	});
var $author$project$LoSearch$searchResult = F2(
	function (los, query) {
		var lastYear = A2($elm$core$Maybe$withDefault, 12, query.dQ);
		var firstYear = A2($elm$core$Maybe$withDefault, 1, query.dK);
		var filterSubject = function (subjectQuery) {
			if (subjectQuery.$ === 1) {
				return los;
			} else {
				var subject_ = subjectQuery.a;
				return A2(
					$elm$core$List$filter,
					function (lo) {
						return _Utils_eq(
							$author$project$LearningOutcome$subject(lo),
							subject_);
					},
					los);
			}
		};
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.nI;
				},
				A4(
					$author$project$LoSearch$search,
					_Utils_Tuple2(firstYear, lastYear),
					query.bA,
					query.nl,
					filterSubject(query.e2))));
	});
var $author$project$LoSearch$getTopics = function (los) {
	var get_last_tag = function (tags) {
		return A2(
			$elm$core$Maybe$withDefault,
			'general',
			$elm$core$List$head(
				$elm$core$List$reverse(tags)));
	};
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			get_last_tag,
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jE;
				},
				los)));
};
var $author$project$Element$LoBrowser$topicWeight = function (results) {
	var weights = A2(
		$elm$core$List$map,
		function ($) {
			return $.nI;
		},
		results);
	var min = A3(
		$elm$core$List$foldl,
		F2(
			function (n, acc) {
				return (!acc) ? n : ((_Utils_cmp(n, acc) < 0) ? n : acc);
			}),
		0,
		weights);
	return min;
};
var $author$project$Element$LoBrowser$viewBrowserResults = F2(
	function (model, results) {
		var viewItemText = function (lo) {
			return A2(
				$author$project$UI$withHighlightedText,
				A2($elm$core$Maybe$withDefault, '', model.bw.bA),
				lo.gD);
		};
		var viewTopicResult = function (_v2) {
			var lo = _v2.bA;
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('list-item')
					]),
				_List_fromArray(
					[
						viewItemText(lo)
					]));
		};
		var topics = $author$project$LoSearch$getTopics(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.bA;
				},
				results));
		var resultsInTopic = function (topic) {
			return (topic === 'general') ? A2(
				$elm$core$List$filter,
				function (_v0) {
					var lo = _v0.bA;
					return _Utils_eq(lo.jE, _List_Nil);
				},
				results) : A2(
				$elm$core$List$filter,
				function (_v1) {
					var lo = _v1.bA;
					return _Utils_eq(
						$elm$core$List$head(
							$elm$core$List$reverse(lo.jE)),
						$elm$core$Maybe$Just(topic));
				},
				results);
		};
		var viewTopic = function (topic) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('card')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-header-title')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('subtitle'),
										A2($elm$html$Html$Attributes$attribute, 'data-topic', topic)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(topic)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('card-content')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								A2(
									$elm$core$List$map,
									viewTopicResult,
									resultsInTopic(topic)))
							]))
					]));
		};
		var topicsSorted = A2(
			$elm$core$List$map,
			viewTopic,
			A2(
				$elm$core$List$sortBy,
				function (topic) {
					return $author$project$Element$LoBrowser$topicWeight(
						resultsInTopic(topic));
				},
				topics));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'overflow-y', 'scroll')
				]),
			topicsSorted);
	});
var $author$project$Element$LoBrowser$Link = 0;
var $author$project$Locale$Messages$LoBrowserGoalHelp = F2(
	function (a, b) {
		return {$: 181, a: a, b: b};
	});
var $author$project$Locale$Messages$LoBrowserStatTotal = {$: 185};
var $author$project$Locale$Messages$LoBrowserStatTrimester = {$: 187};
var $author$project$Locale$Messages$LoBrowserStatYear = {$: 186};
var $author$project$Element$LoBrowser$Success = 1;
var $author$project$Element$LoBrowser$Warning = 2;
var $author$project$LoSearch$avgPerTrimester = F2(
	function (yspan, results) {
		var trimesterCount = 3;
		var len = $elm$core$List$length(results);
		var avg = len / (((!yspan) ? 1 : yspan) * trimesterCount);
		return avg;
	});
var $author$project$UI$Icon$info = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-info-circle'),
			attributes));
};
var $author$project$Element$LoBrowser$backgroundVariant = function (colorv) {
	switch (colorv) {
		case 0:
			return $elm$html$Html$Attributes$class('has-background-link');
		case 1:
			return $elm$html$Html$Attributes$class('has-background-success');
		default:
			return $elm$html$Html$Attributes$class('has-background-warning');
	}
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Element$LoBrowser$viewDashboardBlock = F3(
	function (style_, titleContent, subTitleContent) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-parent')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-child notification'),
							$author$project$Element$LoBrowser$backgroundVariant(style_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h3,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('title is-2 has-text-white')
								]),
							titleContent),
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('subtitle has-text-white')
								]),
							subTitleContent)
						]))
				]));
	});
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$LoSearch$getYears = function (los) {
	var min_year = A3(
		$elm$core$List$foldl,
		$elm$core$Basics$min,
		$author$project$LoSearch$maxYear,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.a;
			},
			los));
	var max_year = A3(
		$elm$core$List$foldl,
		$elm$core$Basics$max,
		$author$project$LoSearch$minYear,
		A2(
			$elm$core$List$map,
			function ($) {
				return $.b;
			},
			los));
	return _Utils_Tuple2(min_year, max_year);
};
var $author$project$LoSearch$yearSpan = function (results) {
	var len = $elm$core$List$length(results);
	var _v0 = $author$project$LoSearch$getYears(results);
	var miny = _v0.a;
	var maxy = _v0.b;
	var yspan = (len > 0) ? ((maxy - miny) + 1) : 0;
	return yspan;
};
var $author$project$Element$LoBrowser$viewDashboard = F2(
	function (t_, results) {
		var yspan = $author$project$LoSearch$yearSpan(results);
		var avg = A2($author$project$LoSearch$avgPerTrimester, yspan, results);
		var goalEnd = $elm$core$Basics$ceiling(avg * 0.71);
		var goalStart = $elm$core$Basics$ceiling(avg * 0.41);
		var goalRangeText = _Utils_eq(goalStart, goalEnd) ? $elm$core$String$fromInt(goalStart) : $elm$core$String$concat(
			_List_fromArray(
				[
					$elm$core$String$fromInt(goalStart),
					'-',
					$elm$core$String$fromInt(goalEnd)
				]));
		var viewGoalHelp = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('tile is-child notification')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$info(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2(
					$elm$html$Html$small,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('https://model.budapestschool.org/tanulasi-elmeny/bizonyitvany-evfolyamok.html#osztalyzatok-kialakitasa'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$caption,
									t_,
									A2($author$project$Locale$Messages$LoBrowserGoalHelp, goalStart, goalEnd))
								]))
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-ancestor has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Element$LoBrowser$viewDashboardBlock,
							1,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$elm$core$List$length(results)))
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserStatTotal)
								])),
							A3(
							$author$project$Element$LoBrowser$viewDashboardBlock,
							2,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(yspan))
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserStatYear)
								])),
							A3(
							$author$project$Element$LoBrowser$viewDashboardBlock,
							0,
							_List_fromArray(
								[
									$elm$html$Html$text(goalRangeText)
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserStatTrimester)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('tile is-ancestor')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tile is-parent')
								]),
							_List_fromArray(
								[viewGoalHelp]))
						]))
				]));
	});
var $author$project$Locale$Messages$LoBrowserCurriculum = {$: 179};
var $author$project$Locale$Messages$LoBrowserGrades = {$: 180};
var $author$project$Locale$Messages$LoBrowserSubject = function (a) {
	return {$: 182, a: a};
};
var $author$project$Locale$Messages$LoBrowserSubjects = {$: 183};
var $author$project$Element$LoBrowser$SubjectClicked = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$LoBrowser$TopicSelected = function (a) {
	return {$: 8, a: a};
};
var $elm$html$Html$aside = _VirtualDom_node('aside');
var $author$project$Element$LoBrowser$CurriculumSet = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LoBrowser$ToggleCurriculumDropdown = {$: 6};
var $author$project$Element$LoBrowser$curriculums = _List_fromArray(
	['pw21jan', 'altgim', 'code', 'onboarding', 'studio']);
var $author$project$Element$LoBrowser$dropDown = F7(
	function (toggleMsg, selectedItem, items, isOpen, itemToMenuLabel, isActive, actionLink) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('dropdown', true),
							_Utils_Tuple2('is-active', isOpen)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-trigger')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu'),
									A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
									$elm$html$Html$Attributes$class('button'),
									$elm$html$Html$Events$onClick(toggleMsg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_Nil,
									_List_fromArray(
										[
											itemToMenuLabel(selectedItem)
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('icon is-small')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$i,
											_List_fromArray(
												[
													A2($elm$html$Html$Attributes$attribute, 'aria-hidden', 'true'),
													$elm$html$Html$Attributes$class('fas fa-angle-down')
												]),
											_List_Nil)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							$elm$html$Html$Attributes$id('dropdown-menu'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-content')
								]),
							A2(
								$elm$core$List$map,
								function (item) {
									return A3(
										$author$project$UI$actionLink,
										actionLink(item),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('dropdown-item', true),
														_Utils_Tuple2(
														'is-active',
														isActive(item))
													]))
											]),
										_List_fromArray(
											[
												itemToMenuLabel(item)
											]));
								},
								items))
						]))
				]));
	});
var $author$project$Element$LoBrowser$curriculumFilterDropDown = function (model) {
	return A7(
		$author$project$Element$LoBrowser$dropDown,
		$author$project$Element$LoBrowser$ToggleCurriculumDropdown,
		model.cG,
		$author$project$Element$LoBrowser$curriculums,
		model.cH,
		$elm$html$Html$text,
		$elm$core$Basics$eq(model.cG),
		$author$project$Element$LoBrowser$CurriculumSet);
};
var $author$project$Session$featurePowerWeek = 'pw';
var $author$project$Session$isFeatureActive = F2(
	function (_v0, _v1) {
		return true;
	});
var $author$project$Element$LoBrowser$ToggleYearDropdown = {$: 5};
var $author$project$Element$LoBrowser$YearFilterSet = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LoBrowser$yearFilterDropDown = function (model) {
	var yearFilterToText = function (yf) {
		return $elm$html$Html$text(
			$elm$core$String$fromInt(yf.a) + ('-' + $elm$core$String$fromInt(yf.b)));
	};
	var ageGroups_ = $author$project$Element$LoBrowser$ageGroups(model.cG);
	var activeYearFilter = _Utils_Tuple2(
		A2($elm$core$Maybe$withDefault, $author$project$LoSearch$minYear, model.bw.dK),
		A2($elm$core$Maybe$withDefault, $author$project$LoSearch$maxYear, model.bw.dQ));
	return $elm$core$List$isEmpty(ageGroups_) ? $author$project$UI$none : A7(
		$author$project$Element$LoBrowser$dropDown,
		$author$project$Element$LoBrowser$ToggleYearDropdown,
		activeYearFilter,
		ageGroups_,
		model.dr,
		yearFilterToText,
		$elm$core$Basics$eq(activeYearFilter),
		$author$project$Element$LoBrowser$YearFilterSet);
};
var $author$project$Element$LoBrowser$viewMenu = F4(
	function (model, session, subjects, results) {
		var t_ = session.hy;
		var viewYearsSelect = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserGrades)
						])),
					$author$project$Element$LoBrowser$yearFilterDropDown(model)
				]));
		var viewCurriculumSelect = A2(
			$author$project$UI$when,
			A2($author$project$Session$isFeatureActive, session, $author$project$Session$featurePowerWeek),
			A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('menu-label')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserCurriculum)
							])),
						$author$project$Element$LoBrowser$curriculumFilterDropDown(model)
					])));
		var los = A2(
			$elm$core$List$map,
			function ($) {
				return $.bA;
			},
			results);
		var viewSubjectsSelect = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserSubjects)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-list')
						]),
					A2(
						$elm$core$List$map,
						function (subject) {
							var isActiveSubject = _Utils_eq(
								model.bw.e2,
								$elm$core$Maybe$Just(subject));
							var isActiveSubjectOpen = isActiveSubject && model.eg;
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$LoBrowser$SubjectClicked(subject),
										_List_fromArray(
											[
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2('is-active', isActiveSubject)
													]))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$UI$caption,
												t_,
												$author$project$Locale$Messages$LoBrowserSubject(subject)),
												isActiveSubject ? (isActiveSubjectOpen ? $author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-angle-up'),
														$author$project$UI$Icon$style('is-small is-pulled-right')
													])) : $author$project$UI$Icon$icon(
												_List_fromArray(
													[
														$author$project$UI$Icon$face('fa-angle-down'),
														$author$project$UI$Icon$style('is-small is-pulled-right')
													]))) : $author$project$UI$none
											])),
										A2(
										$author$project$UI$when,
										isActiveSubjectOpen,
										A2(
											$elm$html$Html$ul,
											_List_Nil,
											A2(
												$elm$core$List$map,
												function (topic) {
													return A2(
														$elm$html$Html$li,
														_List_Nil,
														_List_fromArray(
															[
																A3(
																$author$project$UI$actionLink,
																$author$project$Element$LoBrowser$TopicSelected(topic),
																_List_fromArray(
																	[
																		$elm$html$Html$Attributes$classList(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'is-active',
																				_Utils_eq(
																					model.cu,
																					$elm$core$Maybe$Just(topic)))
																			]))
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(topic)
																	]))
															]));
												},
												$author$project$LoSearch$getTopics(los))))
									]));
						},
						subjects))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$aside,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('menu-panel')
								]),
							_List_fromArray(
								[
									$author$project$UI$title(
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoBrowserTitle)
										]))
								])),
							viewCurriculumSelect,
							viewYearsSelect,
							viewSubjectsSelect
						]))
				]));
	});
var $author$project$Locale$Messages$LoBrowserSearch = {$: 184};
var $author$project$Element$LoBrowser$QueryInputChanged = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LoBrowser$viewSearchBar = F2(
	function (t_, query) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box')
				]),
			_List_fromArray(
				[
					$author$project$UI$List$searchBar(
					{
						aT: $author$project$Element$LoBrowser$QueryInputChanged,
						bv: t_($author$project$Locale$Messages$LoBrowserSearch),
						bw: A2($elm$core$Maybe$withDefault, '', query)
					})
				]));
	});
var $author$project$Element$LoBrowser$viewBrowser = F2(
	function (model, session) {
		var t_ = session.hy;
		var initialQuery = _Utils_update(
			$author$project$LoSearch$emptyQuery,
			{dK: model.bw.dK, dQ: model.bw.dQ});
		var losInSelectedYears = A2(
			$elm$core$List$map,
			function ($) {
				return $.bA;
			},
			A2(
				$author$project$LoSearch$searchResult,
				$author$project$LearningOutcome$getLearningOutcomes(model.cG),
				initialQuery));
		var results = A2($author$project$LoSearch$searchResult, losInSelectedYears, model.bw);
		var subjectsInSelectedYears = $author$project$LearningOutcome$distinctSubjects(losInSelectedYears);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('section has-text-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column is-one-quarter')
								]),
							_List_fromArray(
								[
									A4($author$project$Element$LoBrowser$viewMenu, model, session, subjectsInSelectedYears, results)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Element$LoBrowser$viewDashboard,
									t_,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.bA;
										},
										results)),
									A2($author$project$Element$LoBrowser$viewSearchBar, t_, model.eT),
									model.eF ? A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('box')
										]),
									_List_fromArray(
										[$author$project$UI$List$resultsLoadingProgressBar])) : A2($author$project$Element$LoBrowser$viewBrowserResults, model, results)
								]))
						]))
				]));
	});
var $author$project$Element$LoBrowser$view = F2(
	function (session, model) {
		return A2($author$project$Element$LoBrowser$viewBrowser, model, session);
	});
var $author$project$Element$LoBrowser$element = {iA: $author$project$Element$LoBrowser$init, jR: $author$project$Element$LoBrowser$update, nE: $author$project$Element$LoBrowser$view};
var $author$project$Element$LoStudentOverview$NoEffect = {$: 0};
var $author$project$Element$LoStudentOverview$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LoStudentOverview$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LoStudentOverview$FetchStudentList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LoStudentOverview$StudentListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Endpoint$makeStudentsQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('last_seen', params.cS),
		_List_fromArray(
			[
				_Utils_Tuple2(
				'size',
				$elm$core$String$fromInt(params.de)),
				_Utils_Tuple2('q', params.bw),
				_Utils_Tuple2('cat', params.bs)
			]));
};
var $author$project$Api$Endpoint$activeStudents = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeStudentsQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'students']),
			queryParams);
	});
var $author$project$Student$fetchActiveStudents2 = F3(
	function (config, params, callback) {
		return {
			bN: config,
			dC: $author$project$Student$studentsDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$activeStudents, config, params)
		};
	});
var $author$project$Student$defaultListPageSize = 20;
var $author$project$Student$defaultListParams = {bs: '', cS: $elm$core$Maybe$Nothing, bw: '', de: $author$project$Student$defaultListPageSize};
var $author$project$Element$LoStudentOverview$studentListParams = $author$project$Student$defaultListParams;
var $author$project$Element$LoStudentOverview$andThenFetchStudents = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	var reply = _v0.c;
	return _Utils_Tuple3(
		_Utils_update(
			model,
			{e1: $author$project$RemoteData$Loading}),
		$author$project$Element$LoStudentOverview$BatchEffect(
			_List_fromArray(
				[
					effect,
					$author$project$Element$LoStudentOverview$Cmd(
					$author$project$Element$LoStudentOverview$FetchStudentList(
						A3($author$project$Student$fetchActiveStudents2, model.bN.gr, $author$project$Element$LoStudentOverview$studentListParams, $author$project$Element$LoStudentOverview$StudentListDownloaded)))
				])),
		reply);
};
var $author$project$Element$LoStudentOverview$FetchSchoolList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$LoStudentOverview$SchoolListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LoStudentOverview$andThenMaybeFetchSchools = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	var reply = _v0.c;
	var fetchSchools = _Utils_Tuple3(
		_Utils_update(
			model,
			{jr: $author$project$RemoteData$Loading}),
		$author$project$Element$LoStudentOverview$BatchEffect(
			_List_fromArray(
				[
					effect,
					$author$project$Element$LoStudentOverview$Cmd(
					$author$project$Element$LoStudentOverview$FetchSchoolList(
						A2($author$project$Team$fetchSchools2, model.bN.gr, $author$project$Element$LoStudentOverview$SchoolListDownloaded)))
				])),
		reply);
	return A2(
		$author$project$RemoteData$withDefault,
		fetchSchools,
		A2(
			$author$project$RemoteData$map,
			$elm$core$Basics$always(
				_Utils_Tuple3(model, effect, reply)),
			model.jr));
};
var $author$project$Element$LoStudentOverview$andThenFetchAllData = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	var reply = _v0.c;
	var _v1 = model.bO;
	if (_v1.$ === 1) {
		return _Utils_Tuple3(model, effect, reply);
	} else {
		return $author$project$Element$LoStudentOverview$andThenFetchStudents(
			$author$project$Element$LoStudentOverview$andThenMaybeFetchSchools(
				_Utils_Tuple3(model, effect, reply)));
	}
};
var $author$project$Element$LoStudentOverview$initEmbeddedElement = F2(
	function (params, model) {
		var initFilter = {
			fK: $elm$core$Maybe$Just(params.fK),
			bp: params.bp,
			e1: params.e1,
			jB: _List_Nil
		};
		return $author$project$Element$LoStudentOverview$andThenFetchAllData(
			_Utils_Tuple3(
				_Utils_update(
					model,
					{
						bO: $elm$core$Maybe$Just(initFilter)
					}),
				$author$project$Element$LoStudentOverview$NoEffect,
				$elm$core$Maybe$Nothing));
	});
var $author$project$Element$LoStudentOverview$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			bO: $elm$core$Maybe$Nothing,
			jr: $author$project$RemoteData$NotAsked,
			cv: session,
			e0: $author$project$RemoteData$NotAsked,
			ea: $author$project$RemoteData$NotAsked,
			e1: $author$project$RemoteData$NotAsked,
			ga: $NoRedInk$elm_sortable_table$Table$initialSort('')
		};
		var params_ = params;
		return A2($author$project$Element$LoStudentOverview$initEmbeddedElement, params_, model);
	});
var $author$project$Element$LoStudentOverview$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				var navkey = key;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$LoStudentOverview$perform(navkey),
						effects));
			default:
				switch (effect.a.$) {
					case 3:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					default:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
				}
		}
	});
var $author$project$Element$LoStudentOverview$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$LoStudentOverview$NoOp = {$: 0};
var $author$project$Locale$Messages$StudentLearningOutcomesDownloadError = {$: 495};
var $author$project$Element$LoStudentOverview$FetchStudentLearningOutcomes = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$LoStudentOverview$StudentLearningOutcomeListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Api$Endpoint$requiredList = F3(
	function (encoder, _v0, params) {
		var name = _v0.a;
		var valueList = _v0.b;
		return _Utils_ap(
			params,
			A2(
				$elm$core$List$map,
				function (value) {
					return _Utils_Tuple2(
						name,
						encoder(value));
				},
				valueList));
	});
var $author$project$Api$Endpoint$studentLearningOutcomes = F4(
	function (config, studentIds, teamId, moduleId) {
		var params = A3(
			$author$project$Api$Endpoint$requiredList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('students', studentIds),
			A3(
				$author$project$Api$Endpoint$optional,
				$elm$core$String$fromInt,
				_Utils_Tuple2('module', moduleId),
				_List_fromArray(
					[
						_Utils_Tuple2(
						'team',
						$elm$core$String$fromInt(teamId))
					])));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'learning-outcomes']),
			params);
	});
var $author$project$StudentLearningOutcome$StudentLearningOutcome = F7(
	function (learningOutcome, subject, eligibleStudentsCount, recognizedStudentsCount, students, portfolioStories, modules) {
		return {ik: eligibleStudentsCount, iO: learningOutcome, g9: modules, jb: portfolioStories, mD: recognizedStudentsCount, e1: students, e2: subject};
	});
var $author$project$StudentLearningOutcome$learningOutcomeDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (id) {
		var _v0 = $author$project$LearningOutcome$getLoByID(id);
		if (!_v0.$) {
			var lo = _v0.a;
			return $elm$json$Json$Decode$succeed(lo);
		} else {
			return $elm$json$Json$Decode$fail(
				'Unknown learning outcome: ' + $elm$core$String$fromInt(id));
		}
	},
	$elm$json$Json$Decode$int);
var $author$project$StudentLearningOutcome$NestedModule = F2(
	function (id, title) {
		return {gT: id, jJ: title};
	});
var $author$project$StudentLearningOutcome$moduleDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$StudentLearningOutcome$NestedModule,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string));
var $author$project$StudentLearningOutcome$NestedPortfolioStory = F2(
	function (id, type_) {
		return {gT: id, hH: type_};
	});
var $author$project$StudentLearningOutcome$storyDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$StudentLearningOutcome$NestedPortfolioStory,
	A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'type', $author$project$PortfolioStory$storyTypeDecoder));
var $author$project$StudentLearningOutcome$studentsDecoder = $elm$json$Json$Decode$list($elm$json$Json$Decode$int);
var $author$project$StudentLearningOutcome$studentLearningOutcomeDecoder = A8(
	$elm$json$Json$Decode$map7,
	$author$project$StudentLearningOutcome$StudentLearningOutcome,
	A2($elm$json$Json$Decode$field, 'id', $author$project$StudentLearningOutcome$learningOutcomeDecoder),
	A2($elm$json$Json$Decode$field, 'subject', $author$project$Subject$subjectDecoder),
	A2($elm$json$Json$Decode$field, 'eligible_students_count', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'recognized_students_count', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'students', $author$project$StudentLearningOutcome$studentsDecoder),
	A2(
		$elm$json$Json$Decode$field,
		'portfolio_stories',
		$elm$json$Json$Decode$list($author$project$StudentLearningOutcome$storyDecoder)),
	A2(
		$elm$json$Json$Decode$field,
		'modules',
		$elm$json$Json$Decode$list($author$project$StudentLearningOutcome$moduleDecoder)));
var $author$project$StudentLearningOutcome$studentLearningOutcomesDecoder = $elm$json$Json$Decode$list($author$project$StudentLearningOutcome$studentLearningOutcomeDecoder);
var $author$project$StudentLearningOutcome$fetchStudentLearningOutcomes = F5(
	function (config, studentIds, teamId, moduleId, callback) {
		return {
			bN: config,
			dC: $author$project$StudentLearningOutcome$studentLearningOutcomesDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A4(
				$author$project$Api$Endpoint$studentLearningOutcomes,
				config,
				studentIds,
				$author$project$Team$teamIdToInt(teamId),
				A2($elm$core$Maybe$map, $author$project$Module$moduleIdToInt, moduleId))
		};
	});
var $author$project$Element$LoStudentOverview$andThenFetchLearningOutcomes = function (_v0) {
	var model = _v0.a;
	var effect = _v0.b;
	var reply = _v0.c;
	var _v1 = model.bO;
	if (!_v1.$) {
		var filter = _v1.a;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{e0: $author$project$RemoteData$Loading}),
			$author$project$Element$LoStudentOverview$BatchEffect(
				_List_fromArray(
					[
						effect,
						$author$project$Element$LoStudentOverview$Cmd(
						$author$project$Element$LoStudentOverview$FetchStudentLearningOutcomes(
							A5($author$project$StudentLearningOutcome$fetchStudentLearningOutcomes, model.bN.gr, filter.e1, filter.bp, filter.fK, $author$project$Element$LoStudentOverview$StudentLearningOutcomeListDownloaded)))
					])),
			reply);
	} else {
		return _Utils_Tuple3(model, effect, reply);
	}
};
var $author$project$Element$LoStudentOverview$availableSubjects = F2(
	function (selectedSubjects, los) {
		return $author$project$Util$List$unique(
			A2(
				$elm$core$List$filter,
				function (s) {
					return $elm$core$List$isEmpty(selectedSubjects) || A2($elm$core$List$member, s.gT, selectedSubjects);
				},
				A2(
					$elm$core$List$map,
					function ($) {
						return $.e2;
					},
					los)));
	});
var $author$project$Student$goesToSchool = function (student) {
	return A2(
		$elm$core$Maybe$withDefault,
		false,
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$always(true),
			$elm$core$String$toInt(student.id)));
};
var $author$project$Log$msgStudentLearningOutcomesDownload = 'student_learning_outcomes_download';
var $author$project$Log$paramScopeLoStudentOverview = 'scope_lo_student';
var $author$project$Element$LoStudentOverview$schoolStudents = F2(
	function (school, students) {
		return A2(
			$elm$core$List$filter,
			$author$project$Student$goesToSchool,
			A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[school]),
				students));
	});
var $author$project$Element$LoStudentOverview$updateFilter = F2(
	function (updater, model) {
		var _v0 = model.bO;
		if (!_v0.$) {
			var filter_ = _v0.a;
			var filter2 = updater(filter_);
			var model2 = _Utils_update(
				model,
				{
					bO: $elm$core$Maybe$Just(filter2)
				});
			return _Utils_Tuple3(model2, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
		} else {
			return _Utils_Tuple3(model, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$LoStudentOverview$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var viewer = session.nH;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 1:
				var newState = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ga: newState}),
					$author$project$Element$LoStudentOverview$NoEffect,
					$elm$core$Maybe$Nothing);
			case 2:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{e0: data});
				var _v1 = _Utils_Tuple2(model.bO, data);
				_v1$2:
				while (true) {
					switch (_v1.b.$) {
						case 2:
							if (!_v1.a.$) {
								var filter = _v1.a.a;
								var los = _v1.b.a;
								return A2(
									$author$project$Element$LoStudentOverview$updateFilter,
									function (filter_) {
										return _Utils_update(
											filter_,
											{
												jB: A2(
													$elm$core$List$map,
													function ($) {
														return $.gT;
													},
													A2($author$project$Element$LoStudentOverview$availableSubjects, filter.jB, los))
											});
									},
									model2);
							} else {
								break _v1$2;
							}
						case 3:
							var error = _v1.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model2,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$StudentLearningOutcomesDownloadError))
									}),
								$author$project$Element$LoStudentOverview$Cmd(
									$author$project$Element$LoStudentOverview$LogError(
										A3(
											$author$project$Log$errorV2,
											model.bN,
											_Utils_Tuple3(
												$author$project$Log$msgStudentLearningOutcomesDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLoStudentOverview),
												error),
											$elm$core$Basics$always($author$project$Element$LoStudentOverview$NoOp)))),
								$elm$core$Maybe$Nothing);
						default:
							break _v1$2;
					}
				}
				return _Utils_Tuple3(model2, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
			case 3:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{
						jr: A2(
							$author$project$RemoteData$map,
							function (schools) {
								return A2($author$project$Person$filterPersonTeams, schools, viewer);
							},
							data)
					});
				switch (data.$) {
					case 2:
						return _Utils_Tuple3(model2, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
					case 3:
						var error = data.a;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$TeamListDownloadError))
								}),
							$author$project$Element$LoStudentOverview$Cmd(
								$author$project$Element$LoStudentOverview$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgTeamsDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeLoStudentOverview),
											error),
										$elm$core$Basics$always($author$project$Element$LoStudentOverview$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(model2, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{
						e1: A2(
							$author$project$RemoteData$map,
							$elm$core$List$filter($author$project$Student$goesToSchool),
							data)
					});
				var _v3 = _Utils_Tuple2(model.bO, data);
				_v3$2:
				while (true) {
					switch (_v3.b.$) {
						case 2:
							if (!_v3.a.$) {
								var filter = _v3.a.a;
								var students = _v3.b.a;
								var validStudentIds = A2(
									$elm$core$List$filter,
									function (s) {
										return $elm$core$List$isEmpty(filter.e1) || A2($elm$core$List$member, s, filter.e1);
									},
									A2(
										$elm$core$List$map,
										function ($) {
											return $.gT;
										},
										A2($author$project$Element$LoStudentOverview$schoolStudents, filter.bp, students)));
								var updatedFilter = _Utils_update(
									filter,
									{e1: validStudentIds});
								return $author$project$Element$LoStudentOverview$andThenFetchLearningOutcomes(
									_Utils_Tuple3(
										_Utils_update(
											model2,
											{
												bO: $elm$core$Maybe$Just(updatedFilter)
											}),
										$author$project$Element$LoStudentOverview$NoEffect,
										$elm$core$Maybe$Nothing));
							} else {
								break _v3$2;
							}
						case 3:
							var error = _v3.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model2,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$PhoneBookDownloadError))
									}),
								$author$project$Element$LoStudentOverview$Cmd(
									$author$project$Element$LoStudentOverview$LogError(
										A3(
											$author$project$Log$errorV2,
											model.bN,
											_Utils_Tuple3(
												$author$project$Log$msgPeopleDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeLoStudentOverview),
												error),
											$elm$core$Basics$always($author$project$Element$LoStudentOverview$NoOp)))),
								$elm$core$Maybe$Nothing);
						default:
							break _v3$2;
					}
				}
				return _Utils_Tuple3(model2, $author$project$Element$LoStudentOverview$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$LoStudentOverviewNoStudents = {$: 190};
var $author$project$Locale$Messages$LoStudentOverviewNoLearningOutcomesEmbedded = {$: 189};
var $author$project$Element$LoStudentOverview$filterLearningOutcomes = F2(
	function (filter, los) {
		return A2(
			$elm$core$List$filter,
			function (lo) {
				return A2($elm$core$List$member, lo.e2.gT, filter.jB);
			},
			los);
	});
var $author$project$Locale$Messages$LoStudentOverviewLearningOutcomes = {$: 188};
var $author$project$Locale$Messages$LoStudentOverviewPortfolios = {$: 195};
var $author$project$Locale$Messages$LoStudentOverviewRecognized = {$: 194};
var $author$project$Locale$Messages$LoStudentOverviewStudents = {$: 192};
var $author$project$Element$LoStudentOverview$SetTableState = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$LoStudentOverview$storySorter = $elm$core$List$length;
var $NoRedInk$elm_sortable_table$Table$stringColumn = F2(
	function (name, toStr) {
		return {
			ha: name,
			m6: $NoRedInk$elm_sortable_table$Table$increasingOrDecreasingBy(toStr),
			nF: A2($elm$core$Basics$composeL, $NoRedInk$elm_sortable_table$Table$textDetails, toStr)
		};
	});
var $author$project$Locale$Messages$LoStudentOverviewViewModuleClosure = {$: 197};
var $author$project$Locale$Messages$LoStudentOverviewViewPortfolioStory = {$: 196};
var $author$project$Element$LoStudentOverview$viewStoryLinks = F2(
	function (t_, stories) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (story) {
					return $author$project$PortfolioStory$isModuleClosure(story) ? A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								$author$project$Route$PortfoliosDetail(story.gT)),
								$elm$html$Html$Attributes$title(
								t_($author$project$Locale$Messages$LoStudentOverviewViewModuleClosure))
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$badge(
								_List_fromArray(
									[
										$author$project$UI$Icon$style('has-text-success')
									]))
							])) : A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								$author$project$Route$PortfoliosDetail(story.gT)),
								$elm$html$Html$Attributes$title(
								t_($author$project$Locale$Messages$LoStudentOverviewViewPortfolioStory))
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$badge(_List_Nil)
							]));
				},
				stories));
	});
var $author$project$Element$LoStudentOverview$findStudent = F2(
	function (studentId, studentsData) {
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					function (s) {
						return _Utils_eq(s.gT, studentId);
					}),
				$elm$core$List$head),
			$author$project$RemoteData$toMaybe(studentsData));
	});
var $author$project$Element$LoStudentOverview$viewStudentLinks = F3(
	function (t_, studentsData, students) {
		var viewLinkItem = function (student) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								$author$project$Route$href(
								$author$project$Route$GradeReportCard(student.gT))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								A2($author$project$Person$fullName, t_, student))
							]))
					]));
		};
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (s) {
					return A2(
						$elm$core$Maybe$withDefault,
						A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(s))
								])),
						A2(
							$elm$core$Maybe$map,
							viewLinkItem,
							A2($author$project$Element$LoStudentOverview$findStudent, s, studentsData)));
				},
				students));
	});
var $author$project$Element$LoStudentOverview$viewTheadHelp = F2(
	function (t_, _v0) {
		var name = _v0.a;
		var status = _v0.b;
		var onClick_ = _v0.c;
		var heading = A2(
			$elm$html$Html$span,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(name)
				]));
		var attrs = A2(
			$elm$core$List$cons,
			onClick_,
			_Utils_eq(
				name,
				t_($author$project$Locale$Messages$LoStudentOverviewLearningOutcomes)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '30%')
				]) : (_Utils_eq(
				name,
				t_($author$project$Locale$Messages$LoStudentOverviewSubjects)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '25%')
				]) : (_Utils_eq(
				name,
				t_($author$project$Locale$Messages$LoStudentOverviewRecognized)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '5%')
				]) : (_Utils_eq(
				name,
				t_($author$project$Locale$Messages$LoStudentOverviewStudents)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '25%')
				]) : (_Utils_eq(
				name,
				t_($author$project$Locale$Messages$LoStudentOverviewPortfolios)) ? _List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'width', '5%')
				]) : _List_Nil)))));
		return A3($author$project$UI$Table$theadCell, status, attrs, heading);
	});
var $author$project$Element$LoStudentOverview$viewThead = F2(
	function (t_, headers) {
		return A2(
			$NoRedInk$elm_sortable_table$Table$HtmlDetails,
			_List_Nil,
			A2(
				$elm$core$List$map,
				$author$project$Element$LoStudentOverview$viewTheadHelp(t_),
				headers));
	});
var $author$project$Element$LoStudentOverview$tableViewConfig = F2(
	function (t_, studentsData) {
		var recognizedPercentage = function (glo) {
			var percent = (!glo.ik) ? 0 : (((glo.mD * 100) / glo.ik) | 0);
			return $elm$core$String$fromInt(percent) + '%';
		};
		var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
		return $NoRedInk$elm_sortable_table$Table$customConfig(
			{
				kB: _List_fromArray(
					[
						A2(
						$NoRedInk$elm_sortable_table$Table$stringColumn,
						t_($author$project$Locale$Messages$LoStudentOverviewLearningOutcomes),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.iO;
							},
							function ($) {
								return $.gD;
							})),
						A2(
						$NoRedInk$elm_sortable_table$Table$stringColumn,
						t_($author$project$Locale$Messages$LoStudentOverviewSubjects),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e2;
							},
							function ($) {
								return $.ha;
							})),
						A2(
						$NoRedInk$elm_sortable_table$Table$stringColumn,
						t_($author$project$Locale$Messages$LoStudentOverviewRecognized),
						recognizedPercentage),
						A3(
						$author$project$UI$Table$htmlColumn,
						t_($author$project$Locale$Messages$LoStudentOverviewStudents),
						$elm$core$Basics$always(0),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e1;
							},
							A2($author$project$Element$LoStudentOverview$viewStudentLinks, t_, studentsData))),
						A3(
						$author$project$UI$Table$htmlColumn,
						t_($author$project$Locale$Messages$LoStudentOverviewPortfolios),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jb;
							},
							$author$project$Element$LoStudentOverview$storySorter),
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jb;
							},
							$author$project$Element$LoStudentOverview$viewStoryLinks(t_)))
					]),
				kI: _Utils_update(
					customizations,
					{
						ni: _List_fromArray(
							[
								$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped is-narrow is-size-7')
							]),
						np: $author$project$Element$LoStudentOverview$viewThead(t_)
					}),
				nt: A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.iO;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.gT;
						},
						$elm$core$String$fromInt)),
				bZ: $author$project$Element$LoStudentOverview$SetTableState
			});
	});
var $author$project$Element$LoStudentOverview$viewEmbeddedElement = F3(
	function (t_, _v0, filter) {
		var tableState = _v0.ga;
		var students = _v0.e1;
		var studentLearningOutcomes = _v0.e0;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-relative')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = A2(
						$author$project$RemoteData$map,
						$author$project$Element$LoStudentOverview$filterLearningOutcomes(filter),
						studentLearningOutcomes);
					if (_v1.$ === 2) {
						if (!_v1.a.b) {
							return $author$project$UI$notification(
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewNoLearningOutcomesEmbedded)
									]));
						} else {
							var los = _v1.a;
							return A3(
								$NoRedInk$elm_sortable_table$Table$view,
								A2($author$project$Element$LoStudentOverview$tableViewConfig, t_, students),
								tableState,
								los);
						}
					} else {
						return $author$project$UI$List$resultsLoadingProgressBar;
					}
				}()
				]));
	});
var $author$project$Element$LoStudentOverview$view = function (model) {
	var session = model.cv;
	var t_ = session.hy;
	var _v0 = _Utils_Tuple2(model.jr, model.bO);
	_v0$2:
	while (true) {
		if (_v0.a.$ === 2) {
			if (!_v0.a.a.b) {
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewNoStudents)
						]));
			} else {
				if (!_v0.b.$) {
					var filter = _v0.b.a;
					return A3($author$project$Element$LoStudentOverview$viewEmbeddedElement, t_, model, filter);
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $author$project$UI$List$resultsLoadingProgressBar;
};
var $author$project$Element$LoStudentOverview$element = {iA: $author$project$Element$LoStudentOverview$init, hh: $author$project$Element$LoStudentOverview$perform, jR: $author$project$Element$LoStudentOverview$update, nE: $author$project$Element$LoStudentOverview$view};
var $author$project$Element$ModuleClosureOverview$ModuleListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosureOverview$PageError = {$: 3};
var $author$project$Element$ModuleClosureOverview$PageInit = {$: 0};
var $author$project$Element$ModuleClosureOverview$PageLoading = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosureOverview$PortfolioStoryListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosureOverview$StudentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$modules = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeModulesQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'modules']),
			queryParams);
	});
var $author$project$Module$ModuleListItem = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isActive) {
											return function (isLocked) {
												return function (isTemplate) {
													return function (team) {
														return function (accountableTeacher) {
															return function (teachers) {
																return function (students) {
																	return function (learningOutcomes) {
																		return function (rubrics) {
																			return function (migrationReadyAt) {
																				return {j3: accountableTeacher, gD: description, gH: endDate, gI: evaluation, k9: goalsKnowledge, la: goalsProduct, lb: goalsSkills, gT: id, lo: isActive, lw: isLocked, lC: isTemplate, g3: learningOutcomes, iR: materialsUrl, cZ: migrationReadyAt, eW: rubrics, hv: startDate, e1: students, e5: teachers, jF: team, jJ: title};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Module$moduleListItemDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'migration_ready_at',
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'rubrics',
		$elm$json$Json$Decode$list($author$project$Rubric$rubricDecoder),
		_List_Nil,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'learning_outcomes',
			$author$project$Module$learningOutcomesDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'students',
				$author$project$Person$nestedPeopleDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'teachers',
					$author$project$Person$nestedPeopleDecoder,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'accountable_teacher',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'team',
							$author$project$Team$nestedTeamDecoder,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'is_template',
								$elm$json$Json$Decode$bool,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'is_locked',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'is_active',
										$elm$json$Json$Decode$bool,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'end_date',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'start_date',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'materials_url',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'evaluation',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'goals_product',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'goals_skills',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'goals_knowledge',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'description',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'title',
																			$elm$json$Json$Decode$string,
																			A3(
																				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																				'id',
																				$author$project$Module$moduleIdDecoder,
																				$elm$json$Json$Decode$succeed($author$project$Module$ModuleListItem)))))))))))))))))))));
var $author$project$Module$modulesDecoder = $elm$json$Json$Decode$list($author$project$Module$moduleListItemDecoder);
var $author$project$Module$fetchModules = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$modules, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Module$modulesDecoder));
	});
var $author$project$PortfolioStory$fetchStories = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$Person$fetchStudents = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$peopleStudents(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$ModuleClosureOverview$defaultOnlyMentees = false;
var $author$project$Element$ModuleClosureOverview$defaultTeamId = A2($elm$core$Basics$composeR, $author$project$Person$teamsAsTom, $elm$core$List$head);
var $author$project$Element$ModuleClosureOverview$initFilter = F2(
	function (viewer, _v0) {
		var school = _v0.bp;
		var onlyMentees = _v0.cn;
		var selectedTeam = A2($elm$core$Maybe$map, $elm$core$Basics$identity, school);
		var selectedOnlyMentees = A2($elm$core$Maybe$withDefault, $author$project$Element$ModuleClosureOverview$defaultOnlyMentees, onlyMentees);
		var makeFilter = function (team) {
			return {cn: selectedOnlyMentees, bp: team};
		};
		var defaultTeam = $author$project$Element$ModuleClosureOverview$defaultTeamId(viewer);
		var _v1 = _Utils_Tuple2(selectedTeam, defaultTeam);
		if (!_v1.a.$) {
			var team = _v1.a.a;
			return $elm$core$Result$Ok(
				makeFilter(team));
		} else {
			if (!_v1.b.$) {
				var _v2 = _v1.a;
				var team = _v1.b.a;
				return $elm$core$Result$Ok(
					makeFilter(team));
			} else {
				var _v3 = _v1.a;
				var _v4 = _v1.b;
				return $elm$core$Result$Err(0);
			}
		}
	});
var $author$project$Element$ModuleClosureOverview$moduleListParams = function () {
	var defaults = $author$project$Module$defaultListParams;
	return _Utils_update(
		defaults,
		{bs: $author$project$Api$Endpoint$categorySchools, ie: true, de: -1});
}();
var $author$project$Api$Endpoint$allPortfoliosListParams = {bs: $author$project$Api$Endpoint$categoryAll, gx: $elm$core$Maybe$Nothing, gG: $elm$core$Maybe$Nothing, cS: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing, bw: '', de: -1, hu: $elm$core$Maybe$Nothing, e1: $elm$core$Maybe$Nothing, e5: $elm$core$Maybe$Nothing, hH: $author$project$Api$Endpoint$typeAll};
var $author$project$Element$ModuleClosureOverview$trimesterEnd = 1701644340000;
var $author$project$Element$ModuleClosureOverview$trimesterStart = 1693519200000;
var $author$project$Element$ModuleClosureOverview$portfoliosListParams = function () {
	var defaults = $author$project$Api$Endpoint$allPortfoliosListParams;
	return _Utils_update(
		defaults,
		{
			bs: $author$project$Api$Endpoint$categorySchools,
			gG: $elm$core$Maybe$Just($author$project$Element$ModuleClosureOverview$trimesterEnd),
			hu: $elm$core$Maybe$Just($author$project$Element$ModuleClosureOverview$trimesterStart),
			hH: $author$project$Api$Endpoint$typeMClosure
		});
}();
var $author$project$Element$ModuleClosureOverview$filterToQuery = function (filter) {
	var blankQuery = $author$project$Route$blankModuleClosureOverviewListQuery;
	return _Utils_update(
		blankQuery,
		{
			cn: $elm$core$Maybe$Just(filter.cn),
			bp: $elm$core$Maybe$Just(
				$author$project$Team$teamIdToInt(filter.bp))
		});
};
var $author$project$Element$ModuleClosureOverview$updateFilterUrl = F2(
	function (config, filter) {
		return A2(
			$author$project$Route$replaceUrl,
			config.iJ,
			$author$project$Route$ModuleClosureOverview(
				$author$project$Element$ModuleClosureOverview$filterToQuery(filter)));
	});
var $author$project$Element$ModuleClosureOverview$init = F3(
	function (config, session, params) {
		var viewer = session.nH;
		var model = {bN: config, bB: $author$project$RemoteData$NotAsked, g9: $author$project$RemoteData$NotAsked, bm: $author$project$Element$ModuleClosureOverview$PageInit, e1: $author$project$RemoteData$NotAsked};
		var filter = A2($author$project$Element$ModuleClosureOverview$initFilter, viewer, params);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Person$fetchStudents, config.gr, $author$project$Element$ModuleClosureOverview$StudentListDownloaded),
					A3($author$project$Module$fetchModules, config.gr, $author$project$Element$ModuleClosureOverview$moduleListParams, $author$project$Element$ModuleClosureOverview$ModuleListDownloaded),
					A3($author$project$PortfolioStory$fetchStories, config.gr, $author$project$Element$ModuleClosureOverview$portfoliosListParams, $author$project$Element$ModuleClosureOverview$PortfolioStoryListDownloaded),
					A2(
					$elm$core$Result$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Result$map,
						$author$project$Element$ModuleClosureOverview$updateFilterUrl(config),
						filter))
				]));
		if (filter.$ === 1) {
			return A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bm: $author$project$Element$ModuleClosureOverview$PageError}),
				session);
		} else {
			var filter_ = filter.a;
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bm: $author$project$Element$ModuleClosureOverview$PageLoading(filter_)
						}),
					session));
		}
	});
var $author$project$Element$ModuleClosureOverview$NoOp = {$: 0};
var $author$project$Element$ModuleClosureOverview$PageLoaded = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleClosureOverview$filterModulesByPeriod = F2(
	function (_v0, modules) {
		var start = _v0.a;
		var end = _v0.b;
		var isModuleOutOfPeriod = function (module_) {
			return (_Utils_cmp(module_.gH, start) < 0) || (_Utils_cmp(module_.hv, end) > 0);
		};
		return A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isModuleOutOfPeriod),
			modules);
	});
var $author$project$Module$hasTeacher = F2(
	function (person, module_) {
		return A2($author$project$Person$isSamePerson, module_.j3, person) || A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(person),
			module_.e5);
	});
var $author$project$Element$ModuleClosureOverview$TableDataItem = F3(
	function (student, module_, mclosures) {
		return {bB: mclosures, fK: module_, ne: student};
	});
var $author$project$Element$ModuleClosureOverview$filterModulesByStudent = F2(
	function (student, modules) {
		return A2(
			$elm$core$List$filter,
			function (m) {
				return A2(
					$elm$core$List$any,
					function (s) {
						return A2($author$project$Person$isSamePerson, s, student);
					},
					m.e1);
			},
			modules);
	});
var $author$project$Module$isSameModule = F2(
	function (module1, module2) {
		return _Utils_eq(module1.gT, module2.gT);
	});
var $author$project$Element$ModuleClosureOverview$filterStoriesByModule = F2(
	function (module_, stories) {
		var isSameModule = function (maybeModule) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					$author$project$Module$isSameModule(module_),
					maybeModule));
		};
		return A2(
			$elm$core$List$filter,
			function (story) {
				return isSameModule(story.fK);
			},
			stories);
	});
var $author$project$Element$ModuleClosureOverview$filterStoriesByStudent = F2(
	function (student, stories) {
		return A2(
			$elm$core$List$filter,
			function (story) {
				return A2(
					$elm$core$List$any,
					function (s) {
						return A2($author$project$Person$isSamePerson, s, student);
					},
					story.e1);
			},
			stories);
	});
var $author$project$Element$ModuleClosureOverview$makeTableData = F3(
	function (students, modules, mclosures) {
		var getModuleClosuresByStudent = function (student) {
			var studentModules = A2($author$project$Element$ModuleClosureOverview$filterModulesByStudent, student, modules);
			var studentModuleClosures = function (module_) {
				return A2(
					$author$project$Element$ModuleClosureOverview$filterStoriesByModule,
					module_,
					A2($author$project$Element$ModuleClosureOverview$filterStoriesByStudent, student, mclosures));
			};
			return A2(
				$elm$core$List$map,
				function (module_) {
					return A3(
						$author$project$Element$ModuleClosureOverview$TableDataItem,
						student,
						module_,
						studentModuleClosures(module_));
				},
				studentModules);
		};
		return A2($elm$core$List$concatMap, getModuleClosuresByStudent, students);
	});
var $author$project$Element$ModuleClosureOverview$initPageLoaded = F3(
	function (_v0, _v1, filter) {
		var viewer = _v0.nH;
		var t_ = _v0.hy;
		var students = _v1.e1;
		var modules = _v1.g9;
		var mclosures = _v1.bB;
		var tableState = $NoRedInk$elm_sortable_table$Table$initialSort('');
		var sortedStudents = A2(
			$author$project$Util$List$sortBy,
			$author$project$Person$fullName(t_),
			students);
		var activeModules = A2(
			$author$project$Element$ModuleClosureOverview$filterModulesByPeriod,
			_Utils_Tuple2($author$project$Element$ModuleClosureOverview$trimesterStart, $author$project$Element$ModuleClosureOverview$trimesterEnd),
			modules);
		var filteredModules = $author$project$Person$isModuleTeacher(viewer) ? A2(
			$elm$core$List$filter,
			$author$project$Module$hasTeacher(viewer),
			activeModules) : activeModules;
		var tableData = A3($author$project$Element$ModuleClosureOverview$makeTableData, sortedStudents, filteredModules, mclosures);
		return A3($author$project$Element$ModuleClosureOverview$PageLoaded, filter, tableState, tableData);
	});
var $author$project$Element$ModuleClosureOverview$mapPageLoading = F2(
	function (updater, model) {
		var _v0 = model.bm;
		switch (_v0.$) {
			case 0:
				return model;
			case 1:
				var filter = _v0.a;
				return _Utils_update(
					model,
					{
						bm: updater(filter)
					});
			case 2:
				return model;
			default:
				return model;
		}
	});
var $author$project$Element$ModuleClosureOverview$andThenSetTableData = function (_return) {
	var session = _return.cv;
	var model = _return.dY;
	var _v0 = _Utils_Tuple3(model.e1, model.g9, model.bB);
	if (((_v0.a.$ === 2) && (_v0.b.$ === 2)) && (_v0.c.$ === 2)) {
		var students = _v0.a.a;
		var modules = _v0.b.a;
		var mclosures = _v0.c.a;
		var data = {bB: mclosures, g9: modules, e1: students};
		var pageLoaded = A2($author$project$Element$ModuleClosureOverview$initPageLoaded, session, data);
		return A2(
			$author$project$Application$Boundaries$save,
			A2($author$project$Element$ModuleClosureOverview$mapPageLoading, pageLoaded, model),
			session);
	} else {
		return _return;
	}
};
var $author$project$Log$paramScopeModuleClosureOverview = 'scope_module_closure_overview';
var $author$project$Element$ModuleClosureOverview$mapPageLoaded = F2(
	function (updater, model) {
		var _v0 = model.bm;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var filter = _v0.a;
				var tableState = _v0.b;
				var tableData = _v0.c;
				var _v1 = A3(updater, filter, tableState, tableData);
				var page = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bm: page}),
					cmd);
			default:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Element$ModuleClosureOverview$updateFilter = F3(
	function (updater, session, model) {
		var _v0 = A2(
			$author$project$Element$ModuleClosureOverview$mapPageLoaded,
			F3(
				function (filter, tableState, tableData) {
					var updatedFilter = updater(filter);
					return _Utils_Tuple2(
						A3($author$project$Element$ModuleClosureOverview$PageLoaded, updatedFilter, tableState, tableData),
						A2($author$project$Element$ModuleClosureOverview$updateFilterUrl, model.bN, updatedFilter));
				}),
			model);
		var model2 = _v0.a;
		var cmd = _v0.b;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model2, session));
	});
var $author$project$Element$ModuleClosureOverview$updateTableState = F3(
	function (newTableState, session, model) {
		var _v0 = A2(
			$author$project$Element$ModuleClosureOverview$mapPageLoaded,
			F3(
				function (filter, _v1, tableData) {
					return _Utils_Tuple2(
						A3($author$project$Element$ModuleClosureOverview$PageLoaded, filter, newTableState, tableData),
						$elm$core$Platform$Cmd$none);
				}),
			model);
		var model2 = _v0.a;
		return A2($author$project$Application$Boundaries$save, model2, session);
	});
var $author$project$Element$ModuleClosureOverview$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		switch (msg.$) {
			case 0:
				return noop;
			case 4:
				var newTableState = msg.a;
				return A3($author$project$Element$ModuleClosureOverview$updateTableState, newTableState, session, model);
			case 5:
				var maybeTeamId = msg.a;
				if (!maybeTeamId.$) {
					var teamId = maybeTeamId.a;
					return A3(
						$author$project$Element$ModuleClosureOverview$updateFilter,
						function (filter) {
							return _Utils_update(
								filter,
								{bp: teamId});
						},
						session,
						model);
				} else {
					return noop;
				}
			case 6:
				var onlyMentees = msg.a;
				return A3(
					$author$project$Element$ModuleClosureOverview$updateFilter,
					function (filter) {
						return _Utils_update(
							filter,
							{cn: onlyMentees});
					},
					session,
					model);
			case 1:
				var students = msg.a;
				var model2 = _Utils_update(
					model,
					{e1: students});
				switch (students.$) {
					case 3:
						var error = students.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentListDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 2:
				var modules = msg.a;
				var model2 = _Utils_update(
					model,
					{g9: modules});
				switch (modules.$) {
					case 3:
						var error = modules.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModulesDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$ModulesDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			default:
				var mclosures = msg.a;
				var model2 = _Utils_update(
					model,
					{bB: mclosures});
				switch (mclosures.$) {
					case 3:
						var error = mclosures.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgPortfoliosDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosureOverview),
									error),
								$elm$core$Basics$always($author$project$Element$ModuleClosureOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$PortfoliosDownloadError))));
					case 2:
						return $author$project$Element$ModuleClosureOverview$andThenSetTableData(
							A2($author$project$Application$Boundaries$save, model2, session));
					case 0:
						return A2($author$project$Application$Boundaries$save, model2, session);
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
		}
	});
var $author$project$Team$isSameTeam = F2(
	function (teamId, team) {
		return _Utils_eq(teamId, team.gT);
	});
var $author$project$Module$hasTeam = F2(
	function (teamId, module_) {
		return A2($author$project$Team$isSameTeam, teamId, module_.jF);
	});
var $author$project$Element$ModuleClosureOverview$filterTableData = F3(
	function (viewer, filter, tableData) {
		var matches = function (item) {
			return A2($author$project$Module$hasTeam, filter.bp, item.fK) && (filter.cn ? A2($author$project$Person$isMentorOf, item.ne, viewer) : true);
		};
		return A2($elm$core$List$filter, matches, tableData);
	});
var $author$project$Locale$Messages$ModuleClosureOverviewSchool = {$: 224};
var $author$project$Element$ModuleClosureOverview$SetSchoolFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Team$fromTeamToValue = function (teamId) {
	return $elm$core$String$fromInt(
		$author$project$Team$teamIdToInt(teamId));
};
var $author$project$Team$fromValueToTeam = function (value) {
	return A2(
		$elm$core$Maybe$map,
		$elm$core$Basics$identity,
		$elm$core$String$toInt(value));
};
var $author$project$Element$ModuleClosureOverview$viewTeamFilter = F3(
	function (t_, schools, _v0) {
		var school = _v0.bp;
		var viewSchoolOptions = function (schools_) {
			return A2(
				$elm$core$List$map,
				A3(
					$author$project$UI$radioButton,
					A2($elm$core$Basics$composeL, $author$project$Element$ModuleClosureOverview$SetSchoolFilter, $author$project$Team$fromValueToTeam),
					'filter-school',
					$author$project$Team$fromTeamToValue(school)),
				$author$project$Form$toTeamOptions(schools_));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewSchool),
				gQ: false,
				mp: $elm$core$Maybe$Just(schools),
				hJ: viewSchoolOptions
			});
	});
var $author$project$Locale$Messages$ModuleClosureOverviewOnlyMentees = {$: 225};
var $author$project$Locale$Messages$ModuleClosureOverviewType = {$: 226};
var $author$project$Element$ModuleClosureOverview$SetMenteesFilter = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleClosureOverview$formValueMentees = 'mentees';
var $author$project$Element$ModuleClosureOverview$fromMenteesToValues = function (bool) {
	return bool ? _List_fromArray(
		[$author$project$Element$ModuleClosureOverview$formValueMentees]) : _List_Nil;
};
var $author$project$Element$ModuleClosureOverview$fromValueToMentees = function (values) {
	return A2($elm$core$List$member, $author$project$Element$ModuleClosureOverview$formValueMentees, values);
};
var $author$project$Element$ModuleClosureOverview$viewTypeFilter = F2(
	function (t_, filter) {
		var viewOption = function (option) {
			return A5(
				$author$project$UI$checkbox,
				A2($elm$core$Basics$composeL, $author$project$Element$ModuleClosureOverview$SetMenteesFilter, $author$project$Element$ModuleClosureOverview$fromValueToMentees),
				'filter-only-mentees',
				$elm$core$Basics$always(false),
				$author$project$Element$ModuleClosureOverview$fromMenteesToValues(filter.cn),
				option);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('column')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$fieldset,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$legend,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('label')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewType)
								])),
							viewOption(
							{
								lO: t_($author$project$Locale$Messages$ModuleClosureOverviewOnlyMentees),
								nD: $author$project$Element$ModuleClosureOverview$formValueMentees
							})
						]))
				]));
	});
var $author$project$Element$ModuleClosureOverview$viewFilters = F3(
	function (t_, filter, modules) {
		var schools = $author$project$Util$List$unique(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.jF;
				},
				modules));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container columns')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$ModuleClosureOverview$viewTeamFilter, t_, schools, filter),
					A2($author$project$Element$ModuleClosureOverview$viewTypeFilter, t_, filter)
				]));
	});
var $author$project$Locale$Messages$ModuleClosureOverviewHeading = {$: 218};
var $author$project$Element$ModuleClosureOverview$viewPageHeading = function (t_) {
	return $author$project$UI$title(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureOverviewHeading)
			]));
};
var $author$project$Locale$Messages$ModuleClosureOverviewLoadingProgress = {$: 219};
var $author$project$Element$ModuleClosureOverview$viewProgressBar = function (t_) {
	return A2(
		$author$project$UI$progressBar,
		'is-info',
		t_($author$project$Locale$Messages$ModuleClosureOverviewLoadingProgress));
};
var $author$project$Locale$Messages$ModuleClosureOverviewModule = {$: 222};
var $author$project$Locale$Messages$ModuleClosureOverviewModuleClosure = {$: 223};
var $author$project$Locale$Messages$ModuleClosureOverviewStudent = {$: 221};
var $author$project$Element$ModuleClosureOverview$SetTableState = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleClosureOverview$viewModuleClosuresItem = function (mclosures) {
	var viewModuleClosureLink = function (story) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$PortfoliosDetail(story.gT))
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$badge(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-success')
								]))
						]))
				]));
	};
	return A2(
		$elm$html$Html$ul,
		_List_Nil,
		A2($elm$core$List$map, viewModuleClosureLink, mclosures));
};
var $author$project$Locale$Messages$ModulesMissingStudents = {$: 303};
var $author$project$Locale$Messages$ModulesTerm = F3(
	function (a, b, c) {
		return {$: 308, a: a, b: b, c: c};
	});
var $author$project$Element$ModulesMain$viewModuleHighlights = F2(
	function (t_, module_) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, module_.j3)),
					$elm$html$Html$text(module_.jF.kP),
					A2(
					$author$project$UI$caption,
					t_,
					A3(
						$author$project$Locale$Messages$ModulesTerm,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(module_.hv),
						$elm$time$Time$millisToPosix(module_.gH))),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(module_.e1),
					A2(
						$elm$html$Html$mark,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesMissingStudents)
							])))
				]));
	});
var $author$project$Locale$Messages$ModulesClosed = {$: 257};
var $author$project$Locale$Messages$ModulesClosedEdit = {$: 258};
var $author$project$ACL$canManageModule = F2(
	function (module_, person) {
		return ($author$project$ACL$isStaff(person) && A2(
			$elm$core$List$member,
			module_.jF.gT,
			$author$project$Person$teams(person))) || (($author$project$Person$isModuleTeacher(person) && A2($author$project$Module$hasTeacher, person, module_)) || A2($author$project$Person$isSamePerson, person, module_.j3));
	});
var $author$project$Element$ModulesMain$viewModuleTitle = F3(
	function (_v0, isListItem, module_) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var viewLockFlag = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManageModule, module_, viewer) ? t_($author$project$Locale$Messages$ModulesClosedEdit) : t_($author$project$Locale$Messages$ModulesClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var viewActiveFlag = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-volume-up'),
					$author$project$UI$Icon$style('is-small')
				]));
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$when, module_.lw, viewLockFlag),
					A2($author$project$UI$when, module_.lo, viewActiveFlag),
					$elm$html$Html$text(' '),
					isListItem ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$ModulesDetail(
								$author$project$Module$moduleIdToInt(module_.gT))),
							$author$project$UI$attrCyData('modules-item-view modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.jJ)
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.jJ)
						]))
				]));
	});
var $author$project$Element$ModuleClosureOverview$viewModuleItem = F2(
	function (session, module_) {
		var t_ = session.hy;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A3($author$project$Element$ModulesMain$viewModuleTitle, session, true, module_),
					A2($author$project$Element$ModulesMain$viewModuleHighlights, t_, module_)
				]));
	});
var $author$project$Element$ModuleClosureOverview$tableViewConfig = function (session) {
	var t_ = session.hy;
	var toId = function (item) {
		return $elm$core$String$fromInt(item.ne.gT) + ('-' + $elm$core$String$fromInt(
			$author$project$Module$moduleIdToInt(item.fK.gT)));
	};
	var moduleItemSorter = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.fK;
		},
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.gT;
			},
			$author$project$Module$moduleIdToInt));
	var mclosureItemSorter = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.bB;
		},
		$elm$core$List$length);
	var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
	return $NoRedInk$elm_sortable_table$Table$customConfig(
		{
			kB: _List_fromArray(
				[
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewStudent),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ne;
						},
						$author$project$Person$fullName(t_))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewModule),
					moduleItemSorter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fK;
						},
						$author$project$Element$ModuleClosureOverview$viewModuleItem(session))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$ModuleClosureOverviewModuleClosure),
					mclosureItemSorter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bB;
						},
						$author$project$Element$ModuleClosureOverview$viewModuleClosuresItem))
				]),
			kI: _Utils_update(
				customizations,
				{
					ni: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped is-narrow')
						])
				}),
			nt: toId,
			bZ: $author$project$Element$ModuleClosureOverview$SetTableState
		});
};
var $author$project$Element$ModuleClosureOverview$viewTable = F3(
	function (session, tableState, tableData) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('box')
				]),
			_List_fromArray(
				[
					A3(
					$NoRedInk$elm_sortable_table$Table$view,
					$author$project$Element$ModuleClosureOverview$tableViewConfig(session),
					tableState,
					tableData)
				]));
	});
var $author$project$Element$ModuleClosureOverview$view = F2(
	function (session, _v0) {
		var t_ = session.hy;
		var viewer = session.nH;
		var page = _v0.bm;
		var modules = _v0.g9;
		switch (page.$) {
			case 0:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			case 1:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			case 3:
				return $author$project$Element$ModuleClosureOverview$viewProgressBar(t_);
			default:
				var filter = page.a;
				var tableState = page.b;
				var tableData = page.c;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$author$project$Element$ModuleClosureOverview$viewPageHeading(t_),
							A3(
							$author$project$Element$ModuleClosureOverview$viewFilters,
							t_,
							filter,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								$author$project$RemoteData$toMaybe(modules))),
							A4(
							$elm$html$Html$Lazy$lazy3,
							$author$project$Element$ModuleClosureOverview$viewTable,
							session,
							tableState,
							A3($author$project$Element$ModuleClosureOverview$filterTableData, viewer, filter, tableData))
						]));
		}
	});
var $author$project$Element$ModuleClosureOverview$element = {iA: $author$project$Element$ModuleClosureOverview$init, jR: $author$project$Element$ModuleClosureOverview$update, nE: $author$project$Element$ModuleClosureOverview$view};
var $author$project$Element$ModuleSingle$Closed = {$: 1};
var $author$project$Element$ModuleSingle$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleSingle$FetchModule = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleSingle$LoadingPage = {$: 0};
var $author$project$Element$ModuleSingle$ModuleDetailDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$init = F3(
	function (config, session, params) {
		var _v0 = function () {
			if (!params.$) {
				var moduleId_ = params.a;
				return _Utils_Tuple2(moduleId_, false);
			} else {
				var moduleId_ = params.a;
				return _Utils_Tuple2(moduleId_, true);
			}
		}();
		var moduleId = _v0.a;
		var hasClosurePopup = _v0.b;
		return _Utils_Tuple3(
			{
				bN: config,
				ez: $author$project$Element$ModuleSingle$Closed,
				gP: hasClosurePopup,
				eJ: $elm$core$Maybe$Nothing,
				d_: $elm$core$Maybe$Nothing,
				bm: $author$project$Element$ModuleSingle$LoadingPage,
				d2: $elm$core$Maybe$Nothing,
				d3: $elm$core$Maybe$Nothing,
				cv: session,
				bd: {fJ: $author$project$RemoteData$NotAsked, jB: $author$project$RemoteData$NotAsked}
			},
			$author$project$Element$ModuleSingle$Cmd(
				$author$project$Element$ModuleSingle$FetchModule(
					A3($author$project$Module$fetchModule, config.gr, moduleId, $author$project$Element$ModuleSingle$ModuleDetailDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$LoStudentOverviewEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$LoStudentOverviewMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$loStudentOverview = {
	gF: $author$project$Element$LoStudentOverview$element,
	jK: $author$project$Element$ModuleSingle$LoStudentOverviewEffect,
	bZ: $author$project$Element$ModuleSingle$LoStudentOverviewMsg,
	jS: F2(
		function (model, elementModel) {
			return _Utils_update(
				model,
				{
					eJ: $elm$core$Maybe$Just(elementModel)
				});
		})
};
var $author$project$Element$ModuleSingle$ModuleClosureEffect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleSingle$ModuleClosureMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleClosure$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosure$DataDownloading = {$: 0};
var $author$project$Element$ModuleClosure$FetchPortfolioStoryList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleClosure$PortfolioStoryListDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleClosure$init = F3(
	function (config, session, params) {
		var moduleId_ = $author$project$Module$moduleIdToInt(params.fK.gT);
		var model = {bN: config, fK: params.fK, cv: session, eZ: $author$project$Element$ModuleClosure$DataDownloading, e$: $author$project$RemoteData$NotAsked, cy: false, jB: params.jB};
		var allPortfoliosListParams = $author$project$Api$Endpoint$allPortfoliosListParams;
		var portfoliosListParams = _Utils_update(
			allPortfoliosListParams,
			{
				g9: $elm$core$Maybe$Just(
					_List_fromArray(
						[moduleId_])),
				hH: $author$project$Api$Endpoint$typeMClosure
			});
		return _Utils_Tuple3(
			model,
			$author$project$Element$ModuleClosure$Cmd(
				$author$project$Element$ModuleClosure$FetchPortfolioStoryList(
					A3($author$project$PortfolioStory$fetchStories2, config.gr, portfoliosListParams, $author$project$Element$ModuleClosure$PortfolioStoryListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleClosure$RubricAssessmentEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosure$RubricAssessmentMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleClosure$RubricSelecting = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleClosure$embeddedRubricAssessment = function () {
	var updateElementModel = F2(
		function (containerModel, model) {
			var _v0 = containerModel.eZ;
			switch (_v0.$) {
				case 2:
					var person = _v0.a;
					var module_ = _v0.b;
					return _Utils_update(
						containerModel,
						{
							eZ: A3($author$project$Element$ModuleClosure$RubricSelecting, person, module_, model)
						});
				case 3:
					var person = _v0.a;
					var module_ = _v0.b;
					return _Utils_update(
						containerModel,
						{
							eZ: A3($author$project$Element$ModuleClosure$RubricSelecting, person, module_, model)
						});
				case 0:
					return containerModel;
				case 1:
					return containerModel;
				default:
					return containerModel;
			}
		});
	return {gF: $author$project$Element$RubricAssessment$element, jK: $author$project$Element$ModuleClosure$RubricAssessmentEffect, bZ: $author$project$Element$ModuleClosure$RubricAssessmentMsg, jS: updateElementModel};
}();
var $author$project$Element$ModuleClosure$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$ModuleClosure$perform(key),
						effects));
			case 2:
				switch (effect.a.$) {
					case 2:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 3:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					case 0:
						var request = effect.a.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
					default:
						var request = effect.a.a;
						return $author$project$Api$postV2(request);
				}
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleClosure$embeddedRubricAssessment);
		}
	});
var $author$project$Element$ModuleClosure$BadgeSaved = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$ModuleClosure$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosure$CreateBadge = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleClosure$CreatePortfolioStory = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleClosure$Exit = 0;
var $author$project$Element$ModuleClosure$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleClosure$LogOk = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModuleClosureSaveError = {$: 215};
var $author$project$Locale$Messages$ModuleClosureSaveSuccess = {$: 216};
var $author$project$Locale$Messages$ModuleClosureTooManyStudents = {$: 217};
var $author$project$Element$ModuleClosure$NoEffect = {$: 0};
var $author$project$Element$ModuleClosure$NoOp = {$: 7};
var $author$project$Element$ModuleClosure$PortfolioStorySaved = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$PortfolioStory$PortfolioStoryUnsaved = F7(
	function (id, type_, description, media, module_, createdBy, students) {
		return {kG: createdBy, gD: description, gT: id, lY: media, fK: module_, e1: students, hH: type_};
	});
var $author$project$Locale$Messages$PortfoliosSaveError = {$: 418};
var $author$project$Element$ModuleClosure$Saved = 1;
var $author$project$Element$ModuleClosure$StudentSelected_ = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Element$ModuleClosure$StudentSelecting = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$portfolioStoriesCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'portfolio-stories']),
		_List_Nil);
};
var $author$project$PortfolioStory$createStory = F3(
	function (config, story, callback) {
		return {
			O: $author$project$PortfolioStory$portfolioStoryEncoder(story),
			bN: config,
			dC: $author$project$PortfolioStory$portfolioStoryDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$portfolioStoriesCreate(config.gr)
		};
	});
var $author$project$Log$paramScopeModuleClosure = 'scope_module_closure';
var $author$project$Element$ModuleClosure$NoRubricError = {$: 4};
var $author$project$Element$ModuleClosure$switchToStudentSelecting = function (model) {
	var module_ = model.fK;
	var config = model.bN;
	var session = model.cv;
	var _v0 = model.e$;
	switch (_v0.$) {
		case 2:
			return ($elm$core$List$length(module_.eW) > 0) ? _Utils_Tuple3(
				_Utils_update(
					model,
					{
						eZ: $author$project$Element$ModuleClosure$StudentSelecting(module_)
					}),
				$author$project$Element$ModuleClosure$NoEffect,
				$elm$core$Maybe$Nothing) : _Utils_Tuple3(
				_Utils_update(
					model,
					{eZ: $author$project$Element$ModuleClosure$NoRubricError}),
				$author$project$Element$ModuleClosure$NoEffect,
				$elm$core$Maybe$Nothing);
		case 3:
			var error = _v0.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						cv: A3(
							$author$project$Session$error,
							session,
							error,
							session.hy($author$project$Locale$Messages$PortfoliosDownloadError))
					}),
				$author$project$Element$ModuleClosure$Cmd(
					$author$project$Element$ModuleClosure$LogError(
						A3(
							$author$project$Log$errorV2,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
								error),
							$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
				$elm$core$Maybe$Nothing);
		case 0:
			return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
		default:
			return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
	}
};
var $author$project$Element$ModuleClosure$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		var _v0 = _Utils_Tuple2(msg, model.eZ);
		_v0$10:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					if (!_v0.b.$) {
						var stories = _v0.a.a;
						var _v1 = _v0.b;
						return $author$project$Element$ModuleClosure$switchToStudentSelecting(
							_Utils_update(
								model,
								{e$: stories}));
					} else {
						break _v0$10;
					}
				case 6:
					var _v2 = _v0.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$ModuleClosure$NoEffect,
						$elm$core$Maybe$Just(0));
				case 4:
					var _v3 = _v0.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{cy: !model.cy}),
						$author$project$Element$ModuleClosure$NoEffect,
						$elm$core$Maybe$Nothing);
				case 5:
					switch (_v0.b.$) {
						case 1:
							var student = _v0.a.a;
							var module_ = _v0.b.a;
							var params = {
								i2: false,
								eW: module_.eW,
								e1: _List_fromArray(
									[student]),
								jB: model.jB
							};
							var _v4 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								_Utils_update(
									model,
									{
										eZ: A2($author$project$Element$ModuleClosure$StudentSelected_, student, module_),
										cy: false
									}),
								$author$project$Element$ModuleClosure$embeddedRubricAssessment,
								A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$ModuleClosure$embeddedRubricAssessment, params));
							var model2 = _v4.a;
							var effect = _v4.b;
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						case 3:
							var student = _v0.a.a;
							var _v5 = _v0.b;
							var module_ = _v5.b;
							var params = {
								i2: false,
								eW: module_.eW,
								e1: _List_fromArray(
									[student]),
								jB: model.jB
							};
							var _v6 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								_Utils_update(
									model,
									{
										eZ: A2($author$project$Element$ModuleClosure$StudentSelected_, student, module_),
										cy: false
									}),
								$author$project$Element$ModuleClosure$embeddedRubricAssessment,
								A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$ModuleClosure$embeddedRubricAssessment, params));
							var model2 = _v6.a;
							var effect = _v6.b;
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						default:
							break _v0$10;
					}
				case 0:
					if (_v0.b.$ === 3) {
						var rubricAssessmentMsg = _v0.a.a;
						var _v7 = _v0.b;
						var student = _v7.a;
						var module_ = _v7.b;
						var model_ = _v7.c;
						var _v8 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$ModuleClosure$embeddedRubricAssessment,
							A4($author$project$Application$V3$Boundaries$updateElement, session, rubricAssessmentMsg, model_, $author$project$Element$ModuleClosure$embeddedRubricAssessment));
						var model2 = _v8.a;
						var effect = _v8.b;
						var reply = _v8.c;
						if (reply.$ === 1) {
							return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						} else {
							var reply_ = reply.a;
							switch (reply_.$) {
								case 0:
									return _Utils_Tuple3(
										model2,
										effect,
										$elm$core$Maybe$Just(0));
								case 1:
									var appreciation = reply_.a;
									var rubricAssessment = reply_.b;
									var storyUnsaved = A7(
										$author$project$PortfolioStory$PortfolioStoryUnsaved,
										-1,
										1,
										appreciation,
										_List_Nil,
										$elm$core$Maybe$Just(module_.gT),
										session.nH.gT,
										_List_fromArray(
											[student.gT]));
									var logRequest = A3(
										$author$project$Log$okV2,
										model.bN,
										_Utils_Tuple2(
											$author$project$Log$msgRubricAssessmentSave,
											_List_fromArray(
												[
													$author$project$Log$paramScopeModuleClosure,
													$elm$core$String$fromInt(rubricAssessment.mT)
												])),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp));
									var createPortfolioStoryRequest = A3(
										$author$project$PortfolioStory$createStory,
										config,
										storyUnsaved,
										$author$project$Element$ModuleClosure$PortfolioStorySaved(rubricAssessment));
									return _Utils_Tuple3(
										model2,
										$author$project$Element$ModuleClosure$BatchEffect(
											_List_fromArray(
												[
													$author$project$Element$ModuleClosure$Cmd(
													$author$project$Element$ModuleClosure$CreatePortfolioStory(createPortfolioStoryRequest)),
													$author$project$Element$ModuleClosure$Cmd(
													$author$project$Element$ModuleClosure$LogOk(logRequest))
												])),
										$elm$core$Maybe$Nothing);
								default:
									return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						}
					} else {
						break _v0$10;
					}
				case 1:
					if (_v0.a.b.$ === 1) {
						var _v11 = _v0.a;
						var error = _v11.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PortfoliosSaveError))
								}),
							$author$project$Element$ModuleClosure$Cmd(
								$author$project$Element$ModuleClosure$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgPortfoliosSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
							$elm$core$Maybe$Nothing);
					} else {
						var _v12 = _v0.a;
						var rubricAssessment = _v12.a;
						var story = _v12.b.a;
						var unsavedBadge = A4(
							$author$project$Badge$BadgeUnsaved,
							story.gD,
							story.gT,
							_List_Nil,
							$elm$core$Maybe$Just(rubricAssessment));
						var _v13 = story.e1;
						if (_v13.b && (!_v13.b.b)) {
							var student = _v13.a;
							return _Utils_Tuple3(
								model,
								$author$project$Element$ModuleClosure$BatchEffect(
									_List_fromArray(
										[
											$author$project$Element$ModuleClosure$Cmd(
											$author$project$Element$ModuleClosure$CreateBadge(
												A3(
													$author$project$Badge$createBadge,
													config,
													unsavedBadge,
													$author$project$Element$ModuleClosure$BadgeSaved(student)))),
											$author$project$Element$ModuleClosure$Cmd(
											$author$project$Element$ModuleClosure$LogOk(
												A3(
													$author$project$Log$okV2,
													config,
													_Utils_Tuple2(
														$author$project$Log$msgPortfoliosSave,
														_List_fromArray(
															[
																$author$project$Log$paramScopeModuleClosure,
																$elm$core$String$fromInt(story.gT),
																$elm$core$String$fromInt(student.gT),
																$author$project$Log$paramOk
															])),
													$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp))))
										])),
								$elm$core$Maybe$Nothing);
						} else {
							var error = $author$project$Api$CustomError(
								'module_closure_too_many_students ' + $elm$core$String$fromInt(story.gT));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$ModuleClosureTooManyStudents))
									}),
								$author$project$Element$ModuleClosure$Cmd(
									$author$project$Element$ModuleClosure$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgPortfoliosSave,
												$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
												error),
											$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
								$elm$core$Maybe$Nothing);
						}
					}
				case 3:
					if (_v0.a.b.$ === 1) {
						var _v14 = _v0.a;
						var error = _v14.b.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$ModuleClosureSaveError))
								}),
							$author$project$Element$ModuleClosure$Cmd(
								$author$project$Element$ModuleClosure$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgBadgeSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModuleClosure),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
							$elm$core$Maybe$Just(0));
					} else {
						if (_v0.b.$ === 3) {
							var _v15 = _v0.a;
							var student = _v15.a;
							var badge = _v15.b.a;
							var _v16 = _v0.b;
							var module_ = _v16.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A2(
											$author$project$Session$ok,
											session,
											t_($author$project$Locale$Messages$ModuleClosureSaveSuccess)),
										eZ: $author$project$Element$ModuleClosure$StudentSelecting(module_)
									}),
								$author$project$Element$ModuleClosure$Cmd(
									$author$project$Element$ModuleClosure$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgBadgeSave,
												_List_fromArray(
													[
														$author$project$Log$paramScopeModuleClosure,
														$elm$core$String$fromInt(badge.gT),
														$elm$core$String$fromInt(student.gT),
														$author$project$Log$paramOk
													])),
											$elm$core$Basics$always($author$project$Element$ModuleClosure$NoOp)))),
								$elm$core$Maybe$Just(1));
						} else {
							break _v0$10;
						}
					}
				default:
					break _v0$10;
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$ModuleClosure$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleClosure$PopupClosed = {$: 6};
var $author$project$Locale$Messages$ModuleClosureHeading = {$: 211};
var $author$project$Locale$Messages$ModuleClosureInfo = {$: 212};
var $author$project$Locale$Messages$ModuleClosureMissingRubrics = {$: 213};
var $author$project$Locale$Messages$ModuleClosureStudent = {$: 214};
var $author$project$Element$ModuleClosure$StudentSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleClosure$ToggleStudentDown = {$: 4};
var $author$project$Element$ModuleClosure$hasStudentFeedback = F2(
	function (stories, student) {
		var students = $author$project$Util$List$unique(
			A2(
				$elm$core$List$concatMap,
				function ($) {
					return $.e1;
				},
				stories));
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(student),
			students);
	});
var $author$project$Element$ModuleClosure$viewStudentSelector = F5(
	function (t_, isOpen, selectedStudent, module_, stories) {
		var students = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$not,
				$author$project$Element$ModuleClosure$hasStudentFeedback(stories)),
			module_.e1);
		var isActive = function (student) {
			if (!selectedStudent.$) {
				var student_ = selectedStudent.a;
				return _Utils_eq(student_, student);
			} else {
				return false;
			}
		};
		return $author$project$UI$dropDownSelect(
			{
				kV: t_($author$project$Locale$Messages$FormNotSelected),
				kW: $author$project$Element$ModuleClosure$NoOp,
				lu: isActive,
				ly: isOpen,
				lI: $author$project$Person$fullName(t_),
				lJ: $author$project$Element$ModuleClosure$StudentSelected,
				lK: $author$project$Element$ModuleClosure$ToggleStudentDown,
				lL: students,
				lO: t_($author$project$Locale$Messages$ModuleClosureStudent),
				mY: selectedStudent,
				m1: false
			});
	});
var $author$project$Element$ModuleClosure$viewContent = function (model) {
	var session = model.cv;
	var t_ = session.hy;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('box')
			]),
		_List_fromArray(
			[
				$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureHeading)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						$author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureInfo)
							]))
					])),
				function () {
				var _v0 = _Utils_Tuple2(model.eZ, model.e$);
				_v0$4:
				while (true) {
					switch (_v0.a.$) {
						case 0:
							var _v1 = _v0.a;
							return A2(
								$author$project$UI$progressBar,
								'is-info',
								t_($author$project$Locale$Messages$PortfoliosLoadingProgress));
						case 1:
							if (_v0.b.$ === 2) {
								var module_ = _v0.a.a;
								var stories = _v0.b.a;
								return A5($author$project$Element$ModuleClosure$viewStudentSelector, t_, model.cy, $elm$core$Maybe$Nothing, module_, stories);
							} else {
								break _v0$4;
							}
						case 3:
							if (_v0.b.$ === 2) {
								var _v2 = _v0.a;
								var student = _v2.a;
								var module_ = _v2.b;
								var model_ = _v2.c;
								var stories = _v0.b.a;
								return A2(
									$elm$html$Html$div,
									_List_Nil,
									_List_fromArray(
										[
											A5(
											$author$project$Element$ModuleClosure$viewStudentSelector,
											t_,
											model.cy,
											$elm$core$Maybe$Just(student),
											module_,
											stories),
											A3($author$project$Application$V3$Boundaries$viewElement, session, model_, $author$project$Element$ModuleClosure$embeddedRubricAssessment)
										]));
							} else {
								break _v0$4;
							}
						case 4:
							var _v3 = _v0.a;
							return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleClosureMissingRubrics);
						default:
							break _v0$4;
					}
				}
				return $author$project$UI$none;
			}()
			]));
};
var $author$project$Element$ModuleClosure$view = function (model) {
	return A3(
		$author$project$UI$modalWindow,
		true,
		$author$project$Element$ModuleClosure$PopupClosed,
		$author$project$UI$section(
			_List_fromArray(
				[
					$author$project$Element$ModuleClosure$viewContent(model)
				])));
};
var $author$project$Element$ModuleClosure$element = {iA: $author$project$Element$ModuleClosure$init, hh: $author$project$Element$ModuleClosure$perform, jR: $author$project$Element$ModuleClosure$update, nE: $author$project$Element$ModuleClosure$view};
var $author$project$Element$ModuleSingle$popups = {
	ci: {
		gF: $author$project$Element$ModuleClosure$element,
		jK: $author$project$Element$ModuleSingle$ModuleClosureEffect,
		bZ: $author$project$Element$ModuleSingle$ModuleClosureMsg,
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						d_: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$ModuleSingle$PortfolioListEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$portfolioList = {
	gF: $author$project$Element$PortfolioList$element,
	jK: $author$project$Element$ModuleSingle$PortfolioListEffect,
	bZ: $author$project$Element$ModuleSingle$PortfolioListMsg,
	jS: F2(
		function (model, elementModel) {
			return _Utils_update(
				model,
				{
					d3: $elm$core$Maybe$Just(elementModel)
				});
		})
};
var $author$project$Element$ModuleSingle$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$ModuleSingle$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 1:
						var route = cmd.a;
						return A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(route));
					case 2:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 4:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$deleteV2(request);
				}
			case 3:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleSingle$portfolioList);
			case 4:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleSingle$loStudentOverview);
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$ModuleSingle$popups.ci);
		}
	});
var $author$project$Element$ModuleSingle$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$DeleteModule = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleSingle$DetailPage = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Element$ModuleSingle$FetchModuleEventList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$FetchSubjectList = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleSingle$LogError = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$ModuleDeleted = function (a) {
	return {$: 11, a: a};
};
var $author$project$Locale$Messages$ModuleEventsDownloadError = {$: 237};
var $author$project$Element$ModuleSingle$ModuleEventsDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesDeleteError = {$: 299};
var $author$project$Locale$Messages$ModulesDeleteSuccess = {$: 300};
var $author$project$Element$ModuleSingle$NavRedirect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleSingle$NoEffect = {$: 0};
var $author$project$Element$ModuleSingle$NoOp = {$: 0};
var $author$project$Element$ModuleSingle$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleSingle$SubjectListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleSingle$andThenIf = F3(
	function (pred, mapFn, _return) {
		return pred ? mapFn(_return) : _return;
	});
var $author$project$ACL$canViewLearningOutcomesOfTeam = F2(
	function (team, person) {
		return $author$project$ACL$canViewLearningOutcomes(person) && A2($author$project$Person$isMemberOf, team.gT, person);
	});
var $author$project$Element$ModuleSingle$closePopup = function (model) {
	return _Utils_update(
		model,
		{d_: $elm$core$Maybe$Nothing});
};
var $author$project$Module$deleteModule2 = F3(
	function (config, moduleId, callback) {
		return {
			O: $elm$http$Http$emptyBody,
			bN: config,
			bZ: callback,
			G: A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(moduleId))
		};
	});
var $author$project$ModuleEvent$ModuleEventDetailed = F9(
	function (id, module_, title, notes, rrule, startTime, endTime, startDate, endDate) {
		return {gH: endDate, C: endTime, gT: id, fK: module_, aO: notes, hl: rrule, hv: startDate, M: startTime, jJ: title};
	});
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $author$project$RRule$RRule = F6(
	function (dtStart, frequency, interval, weekStart, until, weekdays) {
		return {kT: dtStart, Q: frequency, iF: interval, nA: until, jX: weekStart, J: weekdays};
	});
var $elm$parser$Parser$ExpectingVariable = {$: 7};
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$parser$Parser$Advanced$varHelp = F7(
	function (isGood, offset, row, col, src, indent, context) {
		varHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, src);
			if (_Utils_eq(newOffset, -1)) {
				return {kA: col, l: context, p: indent, f: offset, mR: row, e: src};
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$src = src,
						$temp$indent = indent,
						$temp$context = context;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					src = $temp$src;
					indent = $temp$indent;
					context = $temp$context;
					continue varHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$variable = function (i) {
	return function (s) {
		var firstOffset = A3($elm$parser$Parser$Advanced$isSubChar, i.hu, s.f, s.e);
		if (_Utils_eq(firstOffset, -1)) {
			return A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.$9));
		} else {
			var s1 = _Utils_eq(firstOffset, -2) ? A7($elm$parser$Parser$Advanced$varHelp, i.iD, s.f + 1, s.mR + 1, 1, s.e, s.p, s.l) : A7($elm$parser$Parser$Advanced$varHelp, i.iD, firstOffset, s.mR, s.kA + 1, s.e, s.p, s.l);
			var name = A3($elm$core$String$slice, s.f, s1.f, s.e);
			return A2($elm$core$Set$member, name, i.jo) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, i.$9)) : A3($elm$parser$Parser$Advanced$Good, true, name, s1);
		}
	};
};
var $elm$parser$Parser$variable = function (i) {
	return $elm$parser$Parser$Advanced$variable(
		{$9: $elm$parser$Parser$ExpectingVariable, iD: i.iD, jo: i.jo, hu: i.hu});
};
var $author$project$RRule$datetime = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed(
			F2(
				function (date_, time_) {
					return date_ + ('T' + time_);
				})),
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$variable(
				{iD: $elm$core$Char$isDigit, jo: $elm$core$Set$empty, hu: $elm$core$Char$isDigit}),
			$elm$parser$Parser$symbol('T'))),
	$elm$parser$Parser$variable(
		{iD: $elm$core$Char$isDigit, jo: $elm$core$Set$empty, hu: $elm$core$Char$isDigit}));
var $elm$parser$Parser$ExpectingKeyword = function (a) {
	return {$: 9, a: a};
};
var $elm$parser$Parser$Advanced$keyword = function (_v0) {
	var kwd = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(kwd);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, kwd, s.f, s.mR, s.kA, s.e);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return (_Utils_eq(newOffset, -1) || (0 <= A3(
			$elm$parser$Parser$Advanced$isSubChar,
			function (c) {
				return $elm$core$Char$isAlphaNum(c) || (c === '_');
			},
			newOffset,
			s.e))) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{kA: newCol, l: s.l, p: s.p, f: newOffset, mR: newRow, e: s.e});
	};
};
var $elm$parser$Parser$keyword = function (kwd) {
	return $elm$parser$Parser$Advanced$keyword(
		A2(
			$elm$parser$Parser$Advanced$Token,
			kwd,
			$elm$parser$Parser$ExpectingKeyword(kwd)));
};
var $author$project$RRule$mainSep = $elm$parser$Parser$symbol(':');
var $author$project$RRule$dtStart = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed($elm$core$Maybe$Just),
					$elm$parser$Parser$keyword('DTSTART')),
				$author$project$RRule$mainSep),
			A2(
				$elm$parser$Parser$ignorer,
				$author$project$RRule$datetime,
				$elm$parser$Parser$symbol('\n'))),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$Daily = 1;
var $author$project$RRule$Monthly = 2;
var $author$project$RRule$Weekly = 0;
var $author$project$RRule$frequency = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$ignorer,
		A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed($elm$core$Basics$identity),
			$elm$parser$Parser$keyword('FREQ')),
		$elm$parser$Parser$symbol('=')),
	$elm$parser$Parser$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(1),
				$elm$parser$Parser$keyword('DAILY')),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(0),
				$elm$parser$Parser$keyword('WEEKLY')),
				A2(
				$elm$parser$Parser$ignorer,
				$elm$parser$Parser$succeed(2),
				$elm$parser$Parser$keyword('MONTHLY'))
			])));
var $author$project$RRule$ruleSep = $elm$parser$Parser$symbol(';');
var $author$project$RRule$interval = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('INTERVAL')),
				$elm$parser$Parser$symbol('=')),
			$elm$parser$Parser$int),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$until = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('UNTIL')),
				$elm$parser$Parser$symbol('=')),
			$author$project$RRule$datetime),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$weekday = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('MO'),
			$elm$parser$Parser$keyword('MO')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('TU'),
			$elm$parser$Parser$keyword('TU')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('WE'),
			$elm$parser$Parser$keyword('WE')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('TH'),
			$elm$parser$Parser$keyword('TH')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('FR'),
			$elm$parser$Parser$keyword('FR')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('SA'),
			$elm$parser$Parser$keyword('SA')),
			A2(
			$elm$parser$Parser$ignorer,
			$elm$parser$Parser$succeed('SU'),
			$elm$parser$Parser$keyword('SU'))
		]));
var $author$project$RRule$weekStart = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('WKST')),
				$elm$parser$Parser$symbol('=')),
			$author$project$RRule$weekday),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $elm$parser$Parser$Forbidden = 0;
var $elm$parser$Parser$Advanced$revAlways = F2(
	function (_v0, b) {
		return b;
	});
var $elm$parser$Parser$Advanced$skip = F2(
	function (iParser, kParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$parser$Parser$Advanced$revAlways, iParser, kParser);
	});
var $elm$parser$Parser$Advanced$sequenceEndForbidden = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var chompRest = function (item) {
			return A5(
				$elm$parser$Parser$Advanced$sequenceEndForbidden,
				ender,
				ws,
				parseItem,
				sep,
				A2($elm$core$List$cons, item, revItems));
		};
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$map,
								function (item) {
									return $elm$parser$Parser$Advanced$Loop(
										A2($elm$core$List$cons, item, revItems));
								},
								parseItem))),
						A2(
						$elm$parser$Parser$Advanced$map,
						function (_v0) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(revItems));
						},
						ender)
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEndMandatory = F4(
	function (ws, parseItem, sep, revItems) {
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (item) {
						return $elm$parser$Parser$Advanced$Loop(
							A2($elm$core$List$cons, item, revItems));
					},
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						parseItem,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							ws,
							A2($elm$parser$Parser$Advanced$ignorer, sep, ws)))),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(
							$elm$core$List$reverse(revItems));
					},
					$elm$parser$Parser$Advanced$succeed(0))
				]));
	});
var $elm$parser$Parser$Advanced$sequenceEndOptional = F5(
	function (ender, ws, parseItem, sep, revItems) {
		var parseEnd = A2(
			$elm$parser$Parser$Advanced$map,
			function (_v0) {
				return $elm$parser$Parser$Advanced$Done(
					$elm$core$List$reverse(revItems));
			},
			ender);
		return A2(
			$elm$parser$Parser$Advanced$skip,
			ws,
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$Advanced$skip,
						sep,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							$elm$parser$Parser$Advanced$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$Advanced$map,
										function (item) {
											return $elm$parser$Parser$Advanced$Loop(
												A2($elm$core$List$cons, item, revItems));
										},
										parseItem),
										parseEnd
									])))),
						parseEnd
					])));
	});
var $elm$parser$Parser$Advanced$sequenceEnd = F5(
	function (ender, ws, parseItem, sep, trailing) {
		var chompRest = function (item) {
			switch (trailing) {
				case 0:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndForbidden, ender, ws, parseItem, sep));
				case 1:
					return A2(
						$elm$parser$Parser$Advanced$loop,
						_List_fromArray(
							[item]),
						A4($elm$parser$Parser$Advanced$sequenceEndOptional, ender, ws, parseItem, sep));
				default:
					return A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$skip,
							ws,
							A2(
								$elm$parser$Parser$Advanced$skip,
								sep,
								A2(
									$elm$parser$Parser$Advanced$skip,
									ws,
									A2(
										$elm$parser$Parser$Advanced$loop,
										_List_fromArray(
											[item]),
										A3($elm$parser$Parser$Advanced$sequenceEndMandatory, ws, parseItem, sep))))),
						ender);
			}
		};
		return $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2($elm$parser$Parser$Advanced$andThen, chompRest, parseItem),
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					ender)
				]));
	});
var $elm$parser$Parser$Advanced$sequence = function (i) {
	return A2(
		$elm$parser$Parser$Advanced$skip,
		$elm$parser$Parser$Advanced$token(i.hu),
		A2(
			$elm$parser$Parser$Advanced$skip,
			i.m7,
			A5(
				$elm$parser$Parser$Advanced$sequenceEnd,
				$elm$parser$Parser$Advanced$token(i.gG),
				i.m7,
				i.lH,
				$elm$parser$Parser$Advanced$token(i.m_),
				i.nz)));
};
var $elm$parser$Parser$Advanced$Forbidden = 0;
var $elm$parser$Parser$Advanced$Mandatory = 2;
var $elm$parser$Parser$Advanced$Optional = 1;
var $elm$parser$Parser$toAdvancedTrailing = function (trailing) {
	switch (trailing) {
		case 0:
			return 0;
		case 1:
			return 1;
		default:
			return 2;
	}
};
var $elm$parser$Parser$sequence = function (i) {
	return $elm$parser$Parser$Advanced$sequence(
		{
			gG: $elm$parser$Parser$toToken(i.gG),
			lH: i.lH,
			m_: $elm$parser$Parser$toToken(i.m_),
			m7: i.m7,
			hu: $elm$parser$Parser$toToken(i.hu),
			nz: $elm$parser$Parser$toAdvancedTrailing(i.nz)
		});
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $elm$parser$Parser$spaces = $elm$parser$Parser$Advanced$spaces;
var $author$project$RRule$weekdays = $elm$parser$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$ignorer,
				A2(
					$elm$parser$Parser$ignorer,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Maybe$Just),
						$elm$parser$Parser$backtrackable($author$project$RRule$ruleSep)),
					$elm$parser$Parser$keyword('BYDAY')),
				$elm$parser$Parser$symbol('=')),
			$elm$parser$Parser$sequence(
				{gG: '', lH: $author$project$RRule$weekday, m_: ',', m7: $elm$parser$Parser$spaces, hu: '', nz: 0})),
			$elm$parser$Parser$succeed($elm$core$Maybe$Nothing)
		]));
var $author$project$RRule$rRuleParser = A2(
	$elm$parser$Parser$keeper,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						$elm$parser$Parser$succeed($author$project$RRule$RRule),
						A2(
							$elm$parser$Parser$ignorer,
							A2(
								$elm$parser$Parser$ignorer,
								$author$project$RRule$dtStart,
								$elm$parser$Parser$keyword('RRULE')),
							$author$project$RRule$mainSep)),
					$author$project$RRule$frequency),
				$author$project$RRule$interval),
			$author$project$RRule$weekStart),
		$author$project$RRule$until),
	A2($elm$parser$Parser$ignorer, $author$project$RRule$weekdays, $elm$parser$Parser$end));
var $author$project$RRule$parse = function (s) {
	return A2($elm$parser$Parser$run, $author$project$RRule$rRuleParser, s);
};
var $author$project$RRule$decodeString = function (str) {
	var _v0 = $author$project$RRule$parse(str);
	if (!_v0.$) {
		var rrule = _v0.a;
		return $elm$json$Json$Decode$succeed(rrule);
	} else {
		var errors = _v0.a;
		return $elm$json$Json$Decode$fail(
			'Invalid RRULE: ' + $elm$parser$Parser$deadEndsToString(errors));
	}
};
var $author$project$ModuleEvent$ModuleEventId = $elm$core$Basics$identity;
var $author$project$ModuleEvent$moduleEventIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleEvent$moduleEventDetailedDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'end_date',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'start_date',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'end_time',
			$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'start_time',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rrule',
					A2($elm$json$Json$Decode$andThen, $author$project$RRule$decodeString, $elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'notes',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'title',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'module',
								$author$project$Module$moduleIdDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$author$project$ModuleEvent$moduleEventIdDecoder,
									$elm$json$Json$Decode$succeed($author$project$ModuleEvent$ModuleEventDetailed))))))))));
var $author$project$ModuleEvent$moduleEventDetailedListDecoder = $elm$json$Json$Decode$list($author$project$ModuleEvent$moduleEventDetailedDecoder);
var $author$project$Api$Endpoint$makeModuleEventsQueryParams = function (params) {
	return A3(
		$author$project$Api$Endpoint$optional,
		$elm$core$String$fromInt,
		_Utils_Tuple2('module_id', params.iS),
		_List_Nil);
};
var $author$project$Api$Endpoint$moduleEvents = F2(
	function (config, params) {
		var queryParams = $author$project$Api$Endpoint$makeModuleEventsQueryParams(params);
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'module-events']),
			queryParams);
	});
var $author$project$ModuleEvent$fetchModuleEvents2 = F3(
	function (config, params, callback) {
		return {
			bN: config,
			dC: $author$project$ModuleEvent$moduleEventDetailedListDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$moduleEvents, config, params)
		};
	});
var $author$project$Element$ModuleSingle$fillDetailPage = F2(
	function (_v0, moduleDetailed) {
		var model = _v0.a;
		var store = model.bd;
		var effect = _v0.b;
		var reply = _v0.c;
		var _v1 = _Utils_Tuple2(store.jB, store.fJ);
		if ((_v1.a.$ === 2) && (_v1.b.$ === 2)) {
			var subjects = _v1.a.a;
			var moduleEvents = _v1.b.a;
			return _Utils_Tuple3(
				_Utils_update(
					model,
					{
						bm: A3(
							$author$project$Element$ModuleSingle$DetailPage,
							moduleDetailed,
							subjects,
							$elm$core$Maybe$Just(moduleEvents))
					}),
				effect,
				reply);
		} else {
			return _Utils_Tuple3(model, effect, reply);
		}
	});
var $author$project$Log$msgModuleDelete = 'module_delete';
var $author$project$Log$msgModuleEventsDownload = 'module_events_download';
var $author$project$Element$LoStudentOverview$EmbeddedElement = $elm$core$Basics$identity;
var $author$project$Element$ModuleSingle$openLoStudentOverview = F2(
	function (module_, _v0) {
		var model = _v0.a;
		var session = model.cv;
		var effect = _v0.b;
		var params = {
			fK: module_.gT,
			bp: module_.jF.gT,
			e1: A2(
				$elm$core$List$map,
				function ($) {
					return $.gT;
				},
				module_.e1)
		};
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$ModuleSingle$loStudentOverview,
			A4($author$project$Application$V3$Boundaries$initElement, model.bN, session, $author$project$Element$ModuleSingle$loStudentOverview, params));
		var model2 = _v1.a;
		var effect2 = _v1.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$ModuleSingle$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$openModuleClosurePopup = F3(
	function (module_, subjects, _v0) {
		var model = _v0.a;
		var session = model.cv;
		var effect = _v0.b;
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$ModuleSingle$popups.ci,
			A4(
				$author$project$Application$V3$Boundaries$initElement,
				model.bN,
				session,
				$author$project$Element$ModuleSingle$popups.ci,
				{fK: module_, jB: subjects}));
		var model2 = _v1.a;
		var effect2 = _v1.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$ModuleSingle$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$openRelatedPortfolios = F2(
	function (module_, _v0) {
		var model = _v0.a;
		var session = model.cv;
		var effect = _v0.b;
		var params = $author$project$Element$PortfolioList$defaultParams;
		var _v1 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$ModuleSingle$portfolioList,
			A4(
				$author$project$Application$V3$Boundaries$initElement,
				model.bN,
				session,
				$author$project$Element$ModuleSingle$portfolioList,
				_Utils_update(
					params,
					{
						g9: _List_fromArray(
							[module_.gT])
					})));
		var model2 = _v1.a;
		var effect2 = _v1.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$ModuleSingle$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$paramScopeModules = 'scope_modules';
var $author$project$Element$ModuleSingle$processModuleDownloadError = F2(
	function (model, error) {
		var session = model.cv;
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{
					cv: A3(
						$author$project$Session$error,
						session,
						error,
						session.hy($author$project$Locale$Messages$ModulesDownloadError))
				}),
			$author$project$Element$ModuleSingle$Cmd(
				$author$project$Element$ModuleSingle$LogError(
					A3(
						$author$project$Log$errorV2,
						model.bN,
						_Utils_Tuple3(
							$author$project$Log$msgModuleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleSingle$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var viewer = session.nH;
		var noop = _Utils_Tuple3(model, $author$project$Element$ModuleSingle$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 7:
				var moduleId = msg.a;
				var toggleDropdown = function () {
					var _v1 = model.ez;
					if (!_v1.$) {
						var m = _v1.a;
						return _Utils_eq(m, moduleId) ? $author$project$Element$ModuleSingle$Closed : $author$project$Element$ModuleSingle$Open(moduleId);
					} else {
						return $author$project$Element$ModuleSingle$Open(moduleId);
					}
				}();
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{ez: toggleDropdown}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 1:
				if (!msg.a.$) {
					var module_ = msg.a.a;
					var params = {
						iS: $elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.gT))
					};
					var model2 = _Utils_update(
						model,
						{
							bm: A3($author$project$Element$ModuleSingle$DetailPage, module_, _List_Nil, $elm$core$Maybe$Nothing),
							d3: $elm$core$Maybe$Nothing
						});
					var effects = $author$project$Element$ModuleSingle$BatchEffect(
						_List_fromArray(
							[
								$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$FetchSubjectList(
									A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$ModuleSingle$SubjectListDownloaded))),
								$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$FetchModuleEventList(
									A3($author$project$ModuleEvent$fetchModuleEvents2, config.gr, params, $author$project$Element$ModuleSingle$ModuleEventsDownloaded)))
							]));
					return A3(
						$author$project$Element$ModuleSingle$andThenIf,
						A2($author$project$ACL$canViewLearningOutcomesOfTeam, module_.jF, viewer),
						$author$project$Element$ModuleSingle$openLoStudentOverview(module_),
						A2(
							$author$project$Element$ModuleSingle$openRelatedPortfolios,
							module_,
							_Utils_Tuple3(model2, effects, $elm$core$Maybe$Nothing)));
				} else {
					var error = msg.a.a;
					return A2($author$project$Element$ModuleSingle$processModuleDownloadError, model, error);
				}
			case 3:
				var data = msg.a;
				var _v2 = _Utils_Tuple2(data, model.bm);
				switch (_v2.a.$) {
					case 2:
						if (_v2.b.$ === 1) {
							var subjects = _v2.a.a;
							var _v3 = _v2.b;
							var moduleDetailed = _v3.a;
							var store = model.bd;
							var updatedStore = _Utils_update(
								store,
								{jB: data});
							return A3(
								$author$project$Element$ModuleSingle$andThenIf,
								model.gP,
								A2($author$project$Element$ModuleSingle$openModuleClosurePopup, moduleDetailed, subjects),
								A2(
									$author$project$Element$ModuleSingle$fillDetailPage,
									_Utils_Tuple3(
										_Utils_update(
											model,
											{bd: updatedStore}),
										$author$project$Element$ModuleSingle$NoEffect,
										$elm$core$Maybe$Nothing),
									moduleDetailed));
						} else {
							var _v6 = _v2.b;
							return noop;
						}
					case 3:
						var error = _v2.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgSubjectListDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
											error),
										$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 0:
						var _v4 = _v2.a;
						return noop;
					default:
						var _v5 = _v2.a;
						return noop;
				}
			case 2:
				var data = msg.a;
				var _v7 = _Utils_Tuple2(data, model.bm);
				switch (_v7.a.$) {
					case 2:
						if (_v7.b.$ === 1) {
							var _v8 = _v7.b;
							var moduleDetailed = _v8.a;
							var store = model.bd;
							var updatedStore = _Utils_update(
								store,
								{fJ: data});
							return A2(
								$author$project$Element$ModuleSingle$fillDetailPage,
								_Utils_Tuple3(
									_Utils_update(
										model,
										{bd: updatedStore}),
									$author$project$Element$ModuleSingle$NoEffect,
									$elm$core$Maybe$Nothing),
								moduleDetailed);
						} else {
							return noop;
						}
					case 3:
						var error = _v7.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$ModuleEventsDownloadError))
								}),
							$author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgModuleEventsDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					case 1:
						var _v9 = _v7.a;
						return noop;
					default:
						var _v10 = _v7.a;
						return noop;
				}
			case 11:
				if (!msg.a.$) {
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A2(
									$author$project$Session$ok,
									session,
									session.hy($author$project$Locale$Messages$ModulesDeleteSuccess))
							}),
						$author$project$Element$ModuleSingle$Cmd(
							$author$project$Element$ModuleSingle$NavRedirect($author$project$Route$ModulesList)),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$ModulesDeleteError))
							}),
						$author$project$Element$ModuleSingle$Cmd(
							$author$project$Element$ModuleSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDelete,
										$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 8:
				var module_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							d2: $elm$core$Maybe$Just(module_)
						}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 9:
				var module_ = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d2: $elm$core$Maybe$Nothing}),
					$author$project$Element$ModuleSingle$Cmd(
						$author$project$Element$ModuleSingle$DeleteModule(
							A3($author$project$Module$deleteModule2, config.gr, module_.gT, $author$project$Element$ModuleSingle$ModuleDeleted))),
					$elm$core$Maybe$Nothing);
			case 10:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{d2: $elm$core$Maybe$Nothing}),
					$author$project$Element$ModuleSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			case 4:
				var loStudentOverviewMsg = msg.a;
				var _v11 = model.eJ;
				if (!_v11.$) {
					var loStudentOverModel = _v11.a;
					var _v12 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$ModuleSingle$loStudentOverview,
						A4($author$project$Application$V3$Boundaries$updateElement, session, loStudentOverviewMsg, loStudentOverModel, $author$project$Element$ModuleSingle$loStudentOverview));
					var model2 = _v12.a;
					var effect = _v12.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 5:
				var portfolioListMsg = msg.a;
				var _v13 = model.d3;
				if (!_v13.$) {
					var portfolioModel = _v13.a;
					var _v14 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$ModuleSingle$portfolioList,
						A4($author$project$Application$V3$Boundaries$updateElement, session, portfolioListMsg, portfolioModel, $author$project$Element$ModuleSingle$portfolioList));
					var model2 = _v14.a;
					var effect = _v14.b;
					return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			default:
				var moduleClosureMsg = msg.a;
				var _v15 = _Utils_Tuple2(model.d_, model.bm);
				if ((!_v15.a.$) && (_v15.b.$ === 1)) {
					var moduleClosureModel = _v15.a.a;
					var _v16 = _v15.b;
					var module_ = _v16.a;
					var redirectToModulePage = function () {
						var _v21 = model.bm;
						if (_v21.$ === 1) {
							var moduleDetailed = _v21.a;
							return $author$project$Element$ModuleSingle$Cmd(
								$author$project$Element$ModuleSingle$NavRedirect(
									$author$project$Route$ModulesDetail(
										$author$project$Module$moduleIdToInt(moduleDetailed.gT))));
						} else {
							return $author$project$Element$ModuleSingle$NoEffect;
						}
					}();
					var _v17 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$ModuleSingle$popups.ci,
						A4($author$project$Application$V3$Boundaries$updateElement, session, moduleClosureMsg, moduleClosureModel, $author$project$Element$ModuleSingle$popups.ci));
					var model2 = _v17.a;
					var effect = _v17.b;
					var reply = _v17.c;
					var closePopupAndRedirectToModule = _Utils_Tuple3(
						$author$project$Element$ModuleSingle$closePopup(model2),
						$author$project$Element$ModuleSingle$BatchEffect(
							_List_fromArray(
								[effect, redirectToModulePage])),
						$elm$core$Maybe$Nothing);
					if (!reply.$) {
						if (!reply.a) {
							var _v19 = reply.a;
							return closePopupAndRedirectToModule;
						} else {
							var _v20 = reply.a;
							return A2($author$project$Element$ModuleSingle$openRelatedPortfolios, module_, closePopupAndRedirectToModule);
						}
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				} else {
					return noop;
				}
		}
	});
var $author$project$Locale$Messages$ModulesLoadingProgress = {$: 295};
var $author$project$Element$ModuleSingle$ModuleDeleteConfirmed = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModuleSingle$ModuleDeleteDeclined = {$: 10};
var $author$project$Locale$Messages$ModulesActionDelete = {$: 248};
var $author$project$Locale$Messages$ModulesDeleteHelp = function (a) {
	return {$: 260, a: a};
};
var $author$project$Element$ModuleSingle$viewConfirmDialog = F2(
	function (t_, module_) {
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{
				kD: $author$project$Element$ModuleSingle$ModuleDeleteConfirmed(module_),
				kM: $author$project$Element$ModuleSingle$ModuleDeleteDeclined
			},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesActionDelete)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							$author$project$Locale$Messages$ModulesDeleteHelp(module_.jJ))))
				]));
	});
var $author$project$Locale$Messages$ModulesFieldEvaluation = {$: 270};
var $author$project$Locale$Messages$ModulesFieldLearningOutcomes = {$: 284};
var $author$project$Locale$Messages$ModulesFieldMaterialsUrl = {$: 266};
var $author$project$Locale$Messages$ModulesFieldStudents = {$: 278};
var $author$project$Module$asListItem = function (module_) {
	return {j3: module_.j3, gD: module_.gD, gH: module_.gH, gI: module_.gI, k9: module_.k9, la: module_.la, lb: module_.lb, gT: module_.gT, lo: module_.lo, lw: module_.lw, lC: module_.lC, g3: module_.g3, iR: module_.iR, cZ: module_.cZ, eW: module_.eW, hv: module_.hv, e1: module_.e1, e5: module_.e5, jF: module_.jF, jJ: module_.jJ};
};
var $author$project$Element$ModuleSingle$viewLoStudentOverview = F2(
	function (session, model) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, model, $author$project$Element$ModuleSingle$loStudentOverview);
	});
var $author$project$Element$ModuleSingle$viewModuleDescription = function (module_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block')
			]),
		_List_fromArray(
			[
				$author$project$Util$Html$markdownToHtml(module_.gD)
			]));
};
var $author$project$Locale$Messages$ModulesModuleEvents = {$: 304};
var $author$project$Locale$Messages$ModuleModuleEvent = function (a) {
	return {$: 238, a: a};
};
var $author$project$RRule$frequencyToString = function (freq) {
	switch (freq) {
		case 0:
			return 'Weekly';
		case 1:
			return 'Daily';
		default:
			return 'Monthly';
	}
};
var $author$project$ModuleEvent$fromDateToValue = function (dt) {
	var yyyy = A3($elm$core$String$slice, 0, 4, dt);
	var mm = A3($elm$core$String$slice, 4, 6, dt);
	var dd = A3($elm$core$String$slice, 6, 8, dt);
	return yyyy + ('-' + (mm + ('-' + dd)));
};
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$ModuleEvent$isRecurring = function (event) {
	return A2(
		$elm$core$Maybe$withDefault,
		true,
		A3(
			$elm$core$Maybe$map2,
			F2(
				function (dtStart, until) {
					return !_Utils_eq(
						$author$project$ModuleEvent$fromDateToValue(dtStart),
						$author$project$ModuleEvent$fromDateToValue(until));
				}),
			event.hl.kT,
			event.hl.nA));
};
var $author$project$Element$ModuleSingle$viewModuleEvent = F2(
	function (_v0, moduleEvent) {
		var t_ = _v0.hy;
		var params = {
			gH: $author$project$Form$dateFromMillis(moduleEvent.gH),
			C: A2($elm$core$Maybe$withDefault, '', moduleEvent.C),
			Q: $author$project$RRule$frequencyToString(moduleEvent.hl.Q),
			iF: moduleEvent.hl.iF,
			lA: $author$project$ModuleEvent$isRecurring(moduleEvent),
			hv: $author$project$Form$dateFromMillis(moduleEvent.hv),
			M: A2($elm$core$Maybe$withDefault, '', moduleEvent.M),
			jJ: moduleEvent.jJ,
			J: moduleEvent.hl.J
		};
		return $elm$html$Html$text(
			t_(
				$author$project$Locale$Messages$ModuleModuleEvent(params)));
	});
var $author$project$Element$ModuleSingle$viewModuleEvents = F2(
	function (session, moduleEvents) {
		var t_ = session.hy;
		var moduleEventBullets = function () {
			if (!moduleEvents.$) {
				var events = moduleEvents.a;
				return $author$project$UI$contentElem(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (moduleEvent) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$Element$ModuleSingle$viewModuleEvent, session, moduleEvent)
											]));
								},
								events))
						]));
			} else {
				return $author$project$UI$List$resultsLoadingProgressBar;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesModuleEvents)
						])),
					moduleEventBullets
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleGoals = F2(
	function (t_, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldGoals)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.k9)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.lb)
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							$author$project$Util$Html$markdownToHtml(module_.la)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$NavToggled = function (a) {
	return {$: 7, a: a};
};
var $author$project$Locale$Messages$BtnActions = {$: 28};
var $author$project$UI$Icon$IconAlt = function (a) {
	return {$: 3, a: a};
};
var $author$project$UI$Icon$alt = function (text_) {
	return $author$project$UI$Icon$IconAlt(text_);
};
var $author$project$UI$actionLinksDropdown = F4(
	function (t_, isActiveNav, triggerMsg, actionLinks) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('dropdown is-right'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-active', isActiveNav)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-trigger'),
							$elm$html$Html$Events$onClick(triggerMsg)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'aria-controls', 'dropdown-menu'),
									A2($elm$html$Html$Attributes$attribute, 'aria-haspopup', 'true'),
									$elm$html$Html$Attributes$class('button is-small is-dark is-inverted'),
									$author$project$UI$attrCyData('modules-item-nav')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-ellipsis-h'),
											$author$project$UI$Icon$alt(
											t_($author$project$Locale$Messages$BtnActions))
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('dropdown-menu'),
							$elm$html$Html$Attributes$id('dropdown-menu'),
							A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$nav,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('dropdown-content')
								]),
							actionLinks)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$ModuleDeleteRequested = function (a) {
	return {$: 8, a: a};
};
var $author$project$Locale$Messages$ModulesBtnCreateFromTemplate = {$: 252};
var $author$project$Locale$Messages$ModulesBtnDuplicate = {$: 250};
var $author$project$Locale$Messages$ModulesBtnFeedback = {$: 249};
var $author$project$Locale$Messages$ModulesBtnPortfolioStory = {$: 255};
var $author$project$Locale$Messages$ModulesBtnSchedule = {$: 254};
var $author$project$Locale$Messages$ModulesMissingRubrics = {$: 302};
var $author$project$UI$Icon$portfolio = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-drum'),
			attributes));
};
var $author$project$Element$ModuleSingle$viewModuleActionLinks = F3(
	function (t_, viewer, module_) {
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesUpdate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-edit'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-warning')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var viewDuplicateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDuplicate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-duplicate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-clone'),
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnDuplicate)
				]));
		var viewDeleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$ModuleSingle$ModuleDeleteRequested(module_),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('modules-item-delete'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewCreateFromTemplateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesCreateFromTemplate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-create'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$add(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnCreateFromTemplate)
				]));
		var inactiveAttrsNoStudents = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingStudents))
			]);
		var inactiveAttrsNoRubrics = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingRubrics))
			]);
		var hasStudents = !$elm$core$List$isEmpty(module_.e1);
		var viewPortfolioStoryLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosCreate(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.gT)))),
					$author$project$UI$attrCyData('modules-item-story'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$portfolio(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnPortfolioStory)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var viewScheduleLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCreateEvent(
						{
							gG: $elm$core$Maybe$Nothing,
							iS: $elm$core$Maybe$Just(
								$author$project$Module$moduleIdToInt(module_.gT)),
							hu: $elm$core$Maybe$Nothing
						})),
					$author$project$UI$attrCyData('modules-item-schedule'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var hasRubrics = !$elm$core$List$isEmpty(module_.eW);
		var viewFinalEvaluationLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesClosure(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-evaluate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$feedback(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnFeedback)
				]);
			return (hasStudents && hasRubrics) ? A2($elm$html$Html$a, linkAttrs, caption) : ((!hasRubrics) ? A2($elm$html$Html$span, inactiveAttrsNoRubrics, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption));
		}();
		var _v0 = _Utils_Tuple3(
			module_.lw,
			$author$project$ACL$canCreateModules(viewer),
			A2($author$project$ACL$canManageModule, module_, viewer));
		_v0$5:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					if (_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[viewDuplicateLink]);
					}
				} else {
					break _v0$5;
				}
			} else {
				if (_v0.b) {
					if (!_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[
								viewEditLink,
								A2($author$project$UI$when, module_.lC, viewCreateFromTemplateLink),
								viewDuplicateLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					}
				} else {
					if (_v0.c) {
						return _List_fromArray(
							[
								viewEditLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					} else {
						break _v0$5;
					}
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Element$ModuleSingle$viewModuleHighlights = F2(
	function (t_, module_) {
		return $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					$elm$html$Html$text(
					A2($author$project$Person$fullName, t_, module_.j3)),
					$elm$html$Html$text(module_.jF.kP),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(module_.e1),
					A2(
						$elm$html$Html$mark,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesMissingStudents)
							])))
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleTitle = F3(
	function (_v0, isListItem, module_) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var viewLockFlag = A2(
			$elm$html$Html$span,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					A2($author$project$ACL$canManageModule, module_, viewer) ? t_($author$project$Locale$Messages$ModulesClosedEdit) : t_($author$project$Locale$Messages$ModulesClosed))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$locked(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var viewActiveFlag = $author$project$UI$Icon$icon(
			_List_fromArray(
				[
					$author$project$UI$Icon$face('fa-volume-up'),
					$author$project$UI$Icon$style('is-small')
				]));
		return A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					A2($author$project$UI$when, module_.lw, viewLockFlag),
					A2($author$project$UI$when, module_.lo, viewActiveFlag),
					$elm$html$Html$text(' '),
					isListItem ? A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$author$project$Route$href(
							$author$project$Route$ModulesDetail(
								$author$project$Module$moduleIdToInt(module_.gT))),
							$author$project$UI$attrCyData('modules-item-view modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.jJ)
						])) : A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							$author$project$UI$attrCyData('modules-item-title')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(module_.jJ)
						]))
				]));
	});
var $author$project$Element$ModuleSingle$viewModuleMeta = F4(
	function (session, isListItem, dropdown, module_) {
		var t_ = session.hy;
		var viewer = session.nH;
		var isActiveNav = _Utils_eq(
			dropdown,
			$author$project$Element$ModuleSingle$Open(module_.gT));
		var viewActionLinksDropdown = A4(
			$author$project$UI$actionLinksDropdown,
			t_,
			isActiveNav,
			$author$project$Element$ModuleSingle$NavToggled(module_.gT),
			A3($author$project$Element$ModuleSingle$viewModuleActionLinks, t_, viewer, module_));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2 panel-block')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(module_.j3.K)
						]),
					_List_fromArray(
						[
							A3($author$project$Element$ModuleSingle$viewModuleTitle, session, isListItem, module_),
							A2($author$project$Element$ModuleSingle$viewModuleHighlights, t_, module_)
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							A2($author$project$ACL$canManageModule, module_, viewer) || $author$project$ACL$canCreateModules(viewer),
							viewActionLinksDropdown)
						]))
				]));
	});
var $author$project$Locale$Messages$RubricAspect = {$: 434};
var $author$project$Element$RubricsSingle$viewRubricTable = F4(
	function (t_, rubric, subjects, highlight_) {
		return A2(
			$elm$html$Html$table,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('table is-striped is-bordered is-size-7')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$thead,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$tr,
							_List_Nil,
							A2(
								$elm$core$List$cons,
								A2(
									$elm$html$Html$th,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAspect)
										])),
								A2(
									$elm$core$List$map,
									function (l) {
										return A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$withHighlightedText, highlight_, l)
												]));
									},
									rubric.fG.fG)))
						])),
					A2(
					$elm$html$Html$tbody,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (aspect) {
							return A2(
								$elm$html$Html$tr,
								_List_Nil,
								A2(
									$elm$core$List$cons,
									A2(
										$elm$html$Html$td,
										_List_Nil,
										_List_fromArray(
											[
												A2($author$project$UI$withHighlightedText, highlight_, aspect.jJ),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text(
												$author$project$Util$String$parenthesize(
													A2($author$project$Subject$findSubjectNameOrEmpty, subjects, aspect.nf)))
											])),
									A2(
										$elm$core$List$map,
										function (desc) {
											return A2(
												$elm$html$Html$td,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$UI$withHighlightedText, highlight_, desc)
													]));
										},
										A2(
											$elm$core$List$take,
											$elm$core$List$length(rubric.fG.fG),
											aspect.lV))));
						},
						rubric.ki))
				]));
	});
var $author$project$Element$ModuleSingle$viewModulePage = F4(
	function (model, module_, allSubjects, allModuleEvents) {
		var dropdown = model.ez;
		var session = model.cv;
		var viewer = session.nH;
		var t_ = session.hy;
		var viewEvaluation = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_Utils_ap(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('subtitle')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldEvaluation)
							])),
						A2(
						$author$project$UI$when,
						!$elm$core$String$isEmpty(module_.gI),
						$author$project$Util$Html$markdownToHtml(module_.gI))
					]),
				A2(
					$elm$core$List$map,
					function (rubric) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('block')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('subtitle is-6')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(rubric.jJ)
										])),
									A4($author$project$Element$RubricsSingle$viewRubricTable, t_, rubric, allSubjects, '')
								]));
					},
					module_.eW)));
		var viewLearningOutcomes = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldLearningOutcomes)
						])),
					A2($author$project$ACL$canViewLearningOutcomesOfTeam, module_.jF, viewer) ? A2(
					$author$project$UI$maybe,
					model.eJ,
					$author$project$Element$ModuleSingle$viewLoStudentOverview(session)) : $author$project$UI$contentElem(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-size-7')
								]),
							A2(
								$elm$core$List$map,
								function (lo) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(lo.gD)
											]));
								},
								module_.g3))
						]))
				]));
		var viewMaterialsLink = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(module_.iR),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldMaterialsUrl)
						]))
				]));
		var viewStudents = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldStudents)
						])),
					$author$project$UI$contentElem(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								function (student) {
									return A2(
										$elm$html$Html$li,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$Person$fullName, t_, student))
											]));
								},
								module_.e1))
						]))
				]));
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$author$project$UI$attrCyData('modules-item'),
								$elm$html$Html$Attributes$class('container')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$Element$ModuleSingle$viewModuleMeta,
								session,
								false,
								dropdown,
								$author$project$Module$asListItem(module_)),
								$author$project$Element$ModuleSingle$viewModuleDescription(
								$author$project$Module$asListItem(module_)),
								A2($author$project$Element$ModuleSingle$viewModuleGoals, t_, module_),
								A3(
								$elm$core$Basics$apL,
								$author$project$UI$when,
								!$elm$core$List$isEmpty(module_.g3),
								viewLearningOutcomes),
								A2(
								$author$project$UI$when,
								(!$elm$core$String$isEmpty(module_.gI)) || (!$elm$core$List$isEmpty(module_.eW)),
								viewEvaluation),
								viewStudents,
								A2($author$project$Element$ModuleSingle$viewModuleEvents, session, allModuleEvents),
								A2(
								$author$project$UI$when,
								!$elm$core$String$isEmpty(module_.iR),
								viewMaterialsLink)
							]))
					]),
				kJ: 'modules-detail',
				le: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
					]),
				nk: _List_Nil,
				nq: 'is-info'
			});
	});
var $author$project$Element$ModuleSingle$viewPopup = function (model) {
	var _v0 = model.d_;
	if (!_v0.$) {
		var popupModel = _v0.a;
		return A3($author$project$Application$V3$Boundaries$viewElement, model.cv, popupModel, $author$project$Element$ModuleSingle$popups.ci);
	} else {
		return $author$project$UI$none;
	}
};
var $author$project$Element$ModuleSingle$viewPortfolioList = F2(
	function (session, model) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, model, $author$project$Element$ModuleSingle$portfolioList);
	});
var $author$project$Element$ModuleSingle$view = function (model) {
	var session = model.cv;
	var page = model.bm;
	var t_ = session.hy;
	if (!page.$) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$progressBar,
					'is-info',
					t_($author$project$Locale$Messages$ModulesLoadingProgress)),
					$author$project$Element$ModuleSingle$viewPopup(model)
				]));
	} else {
		var module_ = page.a;
		var subjects_ = page.b;
		var moduleEvents_ = page.c;
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Element$ModuleSingle$viewPopup(model),
					A4($author$project$Element$ModuleSingle$viewModulePage, model, module_, subjects_, moduleEvents_),
					A2(
					$author$project$UI$maybe,
					model.d3,
					$author$project$Element$ModuleSingle$viewPortfolioList(session)),
					A2(
					$author$project$UI$maybe,
					model.d2,
					$author$project$Element$ModuleSingle$viewConfirmDialog(t_))
				]));
	}
};
var $author$project$Element$ModuleSingle$element = {iA: $author$project$Element$ModuleSingle$init, hh: $author$project$Element$ModuleSingle$perform, jR: $author$project$Element$ModuleSingle$update, nE: $author$project$Element$ModuleSingle$view};
var $author$project$Element$ModuleTeacherProfiles$NotFoundPage = {$: 0};
var $author$project$Element$ModuleTeacherProfiles$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ModuleTeacherProfileDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Api$Endpoint$moduleTeacherProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-teacher-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$ModuleTeacherProfile$ModuleTeacherProfile = F6(
	function (id, state, teacher, residence_permit, residence_address, competencies) {
		return {a2: competencies, gT: id, mL: residence_address, mM: residence_permit, eZ: state, gb: teacher};
	});
var $author$project$ModuleTeacherProfile$ModuleTeacherProfileId = $elm$core$Basics$identity;
var $author$project$ModuleTeacherProfile$teacherProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleTeacherProfile$teacherProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'competencies',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'residence_address',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'residence_permit',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'teacher',
				$author$project$Person$nestedPersonDecoder,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'state',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$author$project$ModuleTeacherProfile$teacherProfileIdDecoder,
						$elm$json$Json$Decode$succeed($author$project$ModuleTeacherProfile$ModuleTeacherProfile)))))));
var $author$project$ModuleTeacherProfile$fetchTeacherProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$moduleTeacherProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleTeacherProfile$teacherProfileDecoder));
	});
var $author$project$Element$ModuleTeacherProfiles$openFormPage = F3(
	function (id, session, model) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$ModuleTeacherProfile$fetchTeacherProfile, model.bN.gr, id, $author$project$Element$ModuleTeacherProfiles$ModuleTeacherProfileDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bm: $author$project$Element$ModuleTeacherProfiles$LoadingPage(id)
					}),
				session));
	});
var $author$project$Element$ModuleTeacherProfiles$init = F3(
	function (config, session, id) {
		return A3(
			$author$project$Element$ModuleTeacherProfiles$openFormPage,
			id,
			session,
			{bN: config, bm: $author$project$Element$ModuleTeacherProfiles$NotFoundPage});
	});
var $author$project$Element$ModuleTeacherProfiles$FormPage = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesDownloadError = {$: 242};
var $author$project$Locale$Messages$ModuleTeacherProfilesSaveSuccess = {$: 243};
var $author$project$Element$ModuleTeacherProfiles$NoOp = {$: 5};
var $author$project$Element$ModuleTeacherProfiles$ProfileSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$Competencies = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ResidenceAddress = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$ResidencePermit = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$buildForm = function (t_) {
	return {
		a2: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a2: value});
				}),
			nD: function ($) {
				return $.a2;
			},
			nE: {
				kJ: 'competencies',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$Competencies),
				bv: t_($author$project$Locale$Messages$ModuleTeacherProfilesCompetencies),
				hH: 'text'
			}
		},
		bn: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bn: value});
				}),
			nD: function ($) {
				return $.bn;
			},
			nE: {
				kJ: 'residence_address',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$ResidenceAddress),
				bv: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidenceAddress),
				hH: 'text'
			}
		},
		bo: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bo: value});
				}),
			nD: function ($) {
				return $.bo;
			},
			nE: {
				kJ: 'residence_permit',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleTeacherProfiles$FormMsg, $author$project$Element$ModuleTeacherProfiles$ResidencePermit),
				bv: t_($author$project$Locale$Messages$ModuleTeacherProfilesResidencePermit),
				hH: 'text'
			}
		}
	};
};
var $author$project$Element$ModuleTeacherProfiles$fillForm = function (moduleTeacherProfile) {
	return {a2: moduleTeacherProfile.a2, bn: moduleTeacherProfile.mL, bo: moduleTeacherProfile.mM};
};
var $author$project$Log$msgModuleTeacherProfileDownload = 'module_teacher_profile_download';
var $author$project$Log$msgModuleTeacherProfileSave = 'module_teacher_profile_save';
var $author$project$ModuleTeacherProfile$ModuleTeacherProfileUnsaved = F6(
	function (id, state, teacher, residence_permit, residence_address, competencies) {
		return {a2: competencies, gT: id, mL: residence_address, mM: residence_permit, eZ: state, gb: teacher};
	});
var $author$project$Element$ModuleTeacherProfiles$saveForm = F3(
	function (form, values, moduleTeacherProfile) {
		return A6(
			$author$project$ModuleTeacherProfile$ModuleTeacherProfileUnsaved,
			moduleTeacherProfile.gT,
			moduleTeacherProfile.eZ,
			moduleTeacherProfile.gb.gT,
			form.bo.nD(values),
			form.bn.nD(values),
			form.a2.nD(values));
	});
var $author$project$Element$ModuleTeacherProfiles$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bo: $author$project$Form$markEdited(form.bo)
						}),
					A2(form.bo.jR, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bn: $author$project$Form$markEdited(form.bn)
						}),
					A2(form.bn.jR, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a2: $author$project$Form$markEdited(form.a2)
						}),
					A2(form.a2.jR, value, formValues));
		}
	});
var $author$project$ModuleTeacherProfile$teacherProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$ModuleTeacherProfile$teacherProfileEncoder = function (teacherProfile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleTeacherProfile$teacherProfileIdToInt(teacherProfile.gT))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(teacherProfile.eZ)),
				_Utils_Tuple2(
				'teacher',
				$elm$json$Json$Encode$int(teacherProfile.gb)),
				_Utils_Tuple2(
				'residence_permit',
				$elm$json$Json$Encode$string(teacherProfile.mM)),
				_Utils_Tuple2(
				'residence_address',
				$elm$json$Json$Encode$string(teacherProfile.mL)),
				_Utils_Tuple2(
				'competencies',
				$elm$json$Json$Encode$string(teacherProfile.a2))
			]));
};
var $author$project$ModuleTeacherProfile$updateTeacherProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$moduleTeacherProfile, config, profile.gb),
			config,
			$elm$http$Http$jsonBody(
				$author$project$ModuleTeacherProfile$teacherProfileEncoder(profile)),
			callback,
			$author$project$ModuleTeacherProfile$teacherProfileDecoder);
	});
var $author$project$Element$ModuleTeacherProfiles$update = F3(
	function (session, msg, model) {
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$8:
		while (true) {
			switch (_v0.a.$) {
				case 2:
					var id = _v0.a.a;
					return A3($author$project$Element$ModuleTeacherProfiles$openFormPage, id, session, model);
				case 4:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var profile = _v0.a.a.a;
							var teacherId = _v0.b.a;
							var blankForm = $author$project$Element$ModuleTeacherProfiles$buildForm(session.hy);
							return _Utils_eq(profile.gb.gT, teacherId) ? A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: A4(
											$author$project$Element$ModuleTeacherProfiles$FormPage,
											0,
											blankForm,
											$author$project$Element$ModuleTeacherProfiles$fillForm(profile),
											profile)
									}),
								session) : A2($author$project$Application$Boundaries$save, model, session);
						} else {
							break _v0$8;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3($author$project$Log$msgModuleTeacherProfileDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$ModuleTeacherProfiles$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$ModuleTeacherProfilesDownloadError))));
					}
				case 0:
					if (_v0.b.$ === 2) {
						var fieldMsg = _v0.a.a;
						var _v1 = _v0.b;
						var form = _v1.b;
						var values = _v1.c;
						var profile = _v1.d;
						var _v2 = A3($author$project$Element$ModuleTeacherProfiles$updateForm, fieldMsg, form, values);
						var form2 = _v2.a;
						var values2 = _v2.b;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bm: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 1, form2, values2, profile)
								}),
							session);
					} else {
						break _v0$8;
					}
				case 1:
					if (_v0.b.$ === 2) {
						var _v3 = _v0.a;
						var _v4 = _v0.b;
						var form = _v4.b;
						var values = _v4.c;
						var profile = _v4.d;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$ModuleTeacherProfile$updateTeacherProfile,
								model.bN.gr,
								A3($author$project$Element$ModuleTeacherProfiles$saveForm, form, values, profile),
								$author$project$Element$ModuleTeacherProfiles$ProfileSaved),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 2, form, values, profile)
									}),
								session));
					} else {
						break _v0$8;
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 2) {
							var newProfile = _v0.a.a.a;
							var _v5 = _v0.b;
							var form = _v5.b;
							var values = _v5.c;
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 0, form, values, newProfile)
									}),
								A2(
									$author$project$Session$ok,
									session,
									session.hy($author$project$Locale$Messages$ModuleTeacherProfilesSaveSuccess)));
						} else {
							break _v0$8;
						}
					} else {
						if (_v0.b.$ === 2) {
							var error = _v0.a.a.a;
							var _v6 = _v0.b;
							var form = _v6.b;
							var values = _v6.c;
							var profile = _v6.d;
							var session2 = A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$FormSaveError));
							var model2 = _Utils_update(
								model,
								{
									bm: A4($author$project$Element$ModuleTeacherProfiles$FormPage, 3, form, values, profile)
								});
							var cmd = A3(
								$author$project$Log$error,
								model.bN,
								_Utils_Tuple3($author$project$Log$msgModuleTeacherProfileSave, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$ModuleTeacherProfiles$NoOp));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2($author$project$Application$Boundaries$save, model2, session2));
						} else {
							break _v0$8;
						}
					}
				default:
					var _v7 = _v0.a;
					return A2($author$project$Application$Boundaries$save, model, session);
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Locale$Messages$ModuleTeacherProfilesLoadingProgress = {$: 245};
var $author$project$Locale$Messages$ModuleTeacherProfilesNotFound = {$: 246};
var $author$project$Element$ModuleTeacherProfiles$FormReset = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$TeacherProfilesTitle = function (a) {
	return {$: 624, a: a};
};
var $author$project$Element$ModuleTeacherProfiles$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.bo, values) && (A2($author$project$Form$isFieldValid, form.bn, values) && A2($author$project$Form$isFieldValid, form.a2, values));
	});
var $author$project$Element$ModuleTeacherProfiles$viewForm = F5(
	function (t_, formState, form, formValues, profile) {
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.bo, formValues)
									])),
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.bn, formValues)
									])),
								$author$project$UI$columns(
								_List_fromArray(
									[
										A3($author$project$UI$textField, t_, form.a2, formValues)
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('field is-grouped')
							]),
						_List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$BtnSave),
								A2(
									$author$project$Form$submissionDisabled,
									formState,
									A2($author$project$Element$ModuleTeacherProfiles$isFormValid, form, formValues)),
								$author$project$Form$isProcessing(formState),
								$author$project$Element$ModuleTeacherProfiles$FormSubmitted),
								A4(
								$author$project$UI$resetButton,
								t_($author$project$Locale$Messages$BtnReset),
								$author$project$Form$resetDisabled(formState),
								$author$project$Form$isProcessing(formState),
								$author$project$Element$ModuleTeacherProfiles$FormReset(profile.gb.gT))
							]))
					]),
				kJ: 'teacher-profile-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$TeacherProfilesTitle(
							A2($author$project$Person$fullName, t_, profile.gb)))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$ModuleTeacherProfiles$view = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var _v1 = model.bm;
		switch (_v1.$) {
			case 2:
				var formState = _v1.a;
				var form = _v1.b;
				var values = _v1.c;
				var profile = _v1.d;
				return A5($author$project$Element$ModuleTeacherProfiles$viewForm, t_, formState, form, values, profile);
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$ModuleTeacherProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModuleTeacherProfilesNotFound)
						]));
		}
	});
var $author$project$Element$ModuleTeacherProfiles$element = {iA: $author$project$Element$ModuleTeacherProfiles$init, jR: $author$project$Element$ModuleTeacherProfiles$update, nE: $author$project$Element$ModuleTeacherProfiles$view};
var $author$project$Element$ModulesMain$Closed = {$: 1};
var $author$project$Element$ModulesMain$NotFoundPage = {$: 0};
var $author$project$Element$ModulesMain$LoadingPage = {$: 1};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForDuplicate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForEdit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$ModuleDetailDownloadedForTemplate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$NoOp = {$: 20};
var $author$project$Element$ModulesMain$Create = {$: 0};
var $author$project$Element$ModulesMain$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$ClassroomCourseListDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModulesMain$PeopleDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModulesMain$SchoolListDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$StudentListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Api$Endpoint$teachers = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'teachers,module_teachers');
};
var $author$project$Person$fetchTeachers = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$teachers(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$ModulesMain$andFetchFormDependencies = function (_return) {
	var model = _return.dY;
	return A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($author$project$Team$fetchSchools, model.bN.gr, $author$project$Element$ModulesMain$SchoolListDownloaded),
					A2($author$project$Person$fetchTeachers, model.bN.gr, $author$project$Element$ModulesMain$PeopleDownloaded),
					A2($author$project$Person$fetchStudents, model.bN.gr, $author$project$Element$ModulesMain$StudentListDownloaded),
					$author$project$Api$getV2(
					A2($author$project$ClassroomCourse$fetchUserClassrooms, model.bN.gr, $author$project$Element$ModulesMain$ClassroomCourseListDownloaded))
				])),
		A2(
			$author$project$Application$Boundaries$mapModel,
			function (model_) {
				return _Utils_update(
					model_,
					{jr: $author$project$RemoteData$Loading, e1: $author$project$RemoteData$Loading});
			},
			_return));
};
var $author$project$Element$ModulesMain$AccountableTeacher = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModulesMain$ClassroomCourses = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$ModulesMain$Description = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$EndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModulesMain$GoalsKnowledge = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$GoalsProduct = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModulesMain$GoalsSkills = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModulesMain$IsMigratable = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$ModulesMain$MaterialsUrl = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModulesFieldAccountableTeacher = {$: 262};
var $author$project$Locale$Messages$ModulesFieldClassroomCourse = {$: 263};
var $author$project$Locale$Messages$ModulesFieldDescription = {$: 264};
var $author$project$Locale$Messages$ModulesFieldDescriptionPlaceholder = {$: 265};
var $author$project$Locale$Messages$ModulesFieldEndDate = {$: 283};
var $author$project$Locale$Messages$ModulesFieldGoalsKnowledge = {$: 272};
var $author$project$Locale$Messages$ModulesFieldGoalsKnowledgePlaceholder = {$: 273};
var $author$project$Locale$Messages$ModulesFieldGoalsProduct = {$: 276};
var $author$project$Locale$Messages$ModulesFieldGoalsProductPlaceholder = {$: 277};
var $author$project$Locale$Messages$ModulesFieldGoalsSkills = {$: 274};
var $author$project$Locale$Messages$ModulesFieldGoalsSkillsPlaceholder = {$: 275};
var $author$project$Locale$Messages$ModulesFieldIsMigratable = {$: 267};
var $author$project$Locale$Messages$ModulesFieldSchool = {$: 280};
var $author$project$Locale$Messages$ModulesFieldStartDate = {$: 282};
var $author$project$Locale$Messages$ModulesFieldTeachers = {$: 279};
var $author$project$Locale$Messages$ModulesFieldTitle = {$: 281};
var $author$project$Element$ModulesMain$School = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModulesMain$StartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModulesMain$Teachers = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$ModulesMain$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Form$optionalPeople = F2(
	function (_v0, value) {
		return $elm$core$Result$Ok(
			A2($elm$core$List$filterMap, $elm$core$String$toInt, value));
	});
var $author$project$Form$optionalUrl = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Form$validUrlFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidUrl)));
	});
var $author$project$Element$ModulesMain$buildForm = F2(
	function (t_, studentOptions) {
		var toMsg_ = A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Students);
		var initStudentsField = function () {
			var defaultConfig = $author$project$Multiselect$defaultConfig;
			return $author$project$Multiselect$initModel(
				_Utils_update(
					defaultConfig,
					{lx: true, nl: 'Students'}));
		}();
		var studentsField = {
			kU: false,
			mu: $author$project$Form$optionalPeople(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{e1: value});
				}),
			nD: function ($) {
				return $.e1;
			},
			nE: {
				kJ: 'students',
				lj: 'fa-users',
				lO: t_($author$project$Locale$Messages$ModulesFieldStudents),
				mp: $elm$core$Maybe$Nothing,
				eZ: initStudentsField,
				bZ: toMsg_
			}
		};
		return {
			j3: {
				kU: false,
				mu: $author$project$Form$requiredPersonSelected(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{j3: value});
					}),
				nD: function ($) {
					return $.j3;
				},
				nE: {
					kJ: 'accountable_teacher',
					lj: 'fa-user',
					lO: t_($author$project$Locale$Messages$ModulesFieldAccountableTeacher),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$AccountableTeacher),
					mp: $elm$core$Maybe$Nothing
				}
			},
			S: {
				kU: false,
				mu: A2(
					$elm$core$Basics$composeL,
					$elm$core$Result$Ok,
					$elm$core$List$filterMap($elm$core$String$toInt)),
				mK: false,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{S: value});
					}),
				nD: function ($) {
					return $.S;
				},
				nE: {
					kJ: 'classroom',
					kO: $elm$core$Maybe$Nothing,
					lj: 'fa-chalkboard-teacher',
					lO: t_($author$project$Locale$Messages$ModulesFieldClassroomCourse),
					mj: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$ClassroomCourses),
					mp: $elm$core$Maybe$Nothing
				}
			},
			gD: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gD: value});
					}),
				nD: function ($) {
					return $.gD;
				},
				nE: {
					kJ: 'description',
					lO: t_($author$project$Locale$Messages$ModulesFieldDescription),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Description),
					bv: t_($author$project$Locale$Messages$ModulesFieldDescriptionPlaceholder)
				}
			},
			gH: {
				kU: false,
				mu: $author$project$Form$requiredDate(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gH: value});
					}),
				nD: function ($) {
					return $.gH;
				},
				nE: {
					kJ: 'end_date',
					lO: t_($author$project$Locale$Messages$ModulesFieldEndDate),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$EndDate)
				}
			},
			k9: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{k9: value});
					}),
				nD: function ($) {
					return $.k9;
				},
				nE: {
					kJ: 'goals_knowledge',
					lO: t_($author$project$Locale$Messages$ModulesFieldGoalsKnowledge),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsKnowledge),
					bv: t_($author$project$Locale$Messages$ModulesFieldGoalsKnowledgePlaceholder)
				}
			},
			la: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{la: value});
					}),
				nD: function ($) {
					return $.la;
				},
				nE: {
					kJ: 'goals_product',
					lO: t_($author$project$Locale$Messages$ModulesFieldGoalsProduct),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsProduct),
					bv: t_($author$project$Locale$Messages$ModulesFieldGoalsProductPlaceholder)
				}
			},
			lb: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{lb: value});
					}),
				nD: function ($) {
					return $.lb;
				},
				nE: {
					kJ: 'goals_skills',
					lO: t_($author$project$Locale$Messages$ModulesFieldGoalsSkills),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$GoalsSkills),
					bv: t_($author$project$Locale$Messages$ModulesFieldGoalsSkillsPlaceholder)
				}
			},
			aS: {
				kU: false,
				mu: $elm$core$Result$Ok,
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{aS: value});
					}),
				nD: function ($) {
					return $.aS;
				},
				nE: {
					kJ: 'is_migratable',
					lj: 'fa-list',
					lO: t_($author$project$Locale$Messages$ModulesFieldIsMigratable),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$IsMigratable)
				}
			},
			iR: {
				kU: false,
				mu: $author$project$Form$optionalUrl(t_),
				mK: false,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{iR: value});
					}),
				nD: function ($) {
					return $.iR;
				},
				nE: {
					kJ: 'url',
					lj: 'fa-link',
					lO: t_($author$project$Locale$Messages$ModulesFieldMaterialsUrl),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$MaterialsUrl),
					bv: 'https://',
					hH: 'text'
				}
			},
			bp: {
				kU: false,
				mu: $author$project$Form$requiredTeamSelected(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{bp: value});
					}),
				nD: function ($) {
					return $.bp;
				},
				nE: {
					kJ: 'school',
					lj: 'fa-school',
					lO: t_($author$project$Locale$Messages$ModulesFieldSchool),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$School),
					mp: $elm$core$Maybe$Nothing
				}
			},
			hv: {
				kU: false,
				mu: $author$project$Form$requiredDate(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{hv: value});
					}),
				nD: function ($) {
					return $.hv;
				},
				nE: {
					kJ: 'start_date',
					lO: t_($author$project$Locale$Messages$ModulesFieldStartDate),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$StartDate)
				}
			},
			e1: A2($author$project$Form$setMultiselectSelection, studentOptions, studentsField),
			e5: {
				kU: false,
				mu: $author$project$Form$optionalPeople(t_),
				mK: false,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{e5: value});
					}),
				nD: function ($) {
					return $.e5;
				},
				nE: {
					kJ: 'teachers',
					kO: $elm$core$Maybe$Nothing,
					lj: 'fa-users',
					lO: t_($author$project$Locale$Messages$ModulesFieldTeachers),
					mj: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Teachers),
					mp: $elm$core$Maybe$Nothing
				}
			},
			jJ: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{jJ: value});
					}),
				nD: function ($) {
					return $.jJ;
				},
				nE: {
					kJ: 'title',
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$ModulesFieldTitle),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$FormMsg, $author$project$Element$ModulesMain$Title),
					bv: '',
					hH: 'text'
				}
			}
		};
	});
var $author$project$Element$ModulesMain$emptyForm = {j3: '', S: _List_Nil, gD: '', gH: '', k9: '', la: '', lb: '', aS: false, iR: '', bp: '', hv: '', e1: _List_Nil, e5: _List_Nil, jJ: ''};
var $author$project$Log$msgModuleCreate = 'module_create';
var $author$project$Element$ModulesMain$buildFormPage = F2(
	function (session, model) {
		var t_ = session.hy;
		var page = $author$project$Element$ModulesMain$FormPage(
			{
				hQ: $author$project$Element$ModulesMain$Create,
				by: false,
				bt: A2($author$project$Element$ModulesMain$buildForm, t_, _List_Nil),
				cO: false,
				g5: false,
				dX: false,
				fN: $elm$core$Maybe$Nothing,
				eX: _List_Nil,
				ct: _List_Nil,
				eZ: 0,
				dn: {cI: true},
				ej: $author$project$Element$ModulesMain$emptyForm
			});
		return $author$project$Element$ModulesMain$andFetchFormDependencies(
			A2(
				$author$project$Application$Boundaries$andThenCmd,
				A3(
					$author$project$Log$ok,
					model.bN,
					_Utils_Tuple2(
						$author$project$Log$msgModuleCreate,
						_List_fromArray(
							[$author$project$Log$paramScopeModules, $author$project$Log$paramOk])),
					$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bm: page}),
					session)));
	});
var $author$project$Element$ModulesMain$ModuleListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$SubjectListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModulesMain$listFilterToCategory = function (_v0) {
	var category = _v0.bs;
	switch (category) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categorySchools;
		case 2:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return 'templates';
	}
};
var $author$project$Element$ModulesMain$asListParams = function (listPage) {
	var filter = listPage.bO;
	var defaults = $author$project$Module$defaultListParams;
	return _Utils_update(
		defaults,
		{
			bs: $author$project$Element$ModulesMain$listFilterToCategory(filter),
			iu: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.iu),
			cS: function () {
				var _v0 = listPage.cY;
				if (_v0.$ === 1) {
					var module_ = _v0.a;
					return $elm$core$Maybe$Just(
						$author$project$Module$moduleIdToInt(module_.gT));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			bw: listPage.bw,
			jr: A2(
				$author$project$Data$toMaybe,
				$elm$core$List$isEmpty,
				A2($elm$core$List$map, $author$project$Team$teamIdToInt, filter.jr)),
			jB: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.jB),
			e5: A2($author$project$Data$toMaybe, $elm$core$List$isEmpty, filter.e5),
			jQ: false
		});
};
var $author$project$Element$ModulesMain$LoadingModules = {$: 0};
var $author$project$Element$ModulesMain$FilterAll = 0;
var $author$project$Element$ModulesMain$FilterCreator = 2;
var $author$project$Element$ModulesMain$emptyFilter = {bs: 0, iu: _List_Nil, jr: _List_Nil, jB: _List_Nil, e5: _List_Nil};
var $author$project$Element$ModulesMain$defaultFilter = function (viewer) {
	return _Utils_update(
		$author$project$Element$ModulesMain$emptyFilter,
		{
			bs: $author$project$ACL$canCreateModules(viewer) ? 2 : 0
		});
};
var $author$project$Element$ModulesMain$emptyList = function (viewer) {
	return {
		bO: $author$project$Element$ModulesMain$defaultFilter(viewer),
		eA: false,
		cY: $author$project$Element$ModulesMain$LoadingModules,
		g9: _List_Nil,
		bw: ''
	};
};
var $author$project$Module$fetchModules_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$modules, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Module$modulesDecoder));
	});
var $author$project$Element$ModulesMain$openListPage = F2(
	function (session, model) {
		var viewer = session.nH;
		var config = model.bN;
		var emptyList_ = $author$project$Element$ModulesMain$emptyList(viewer);
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3(
					$author$project$Module$fetchModules_,
					config.gr,
					$author$project$Element$ModulesMain$asListParams(emptyList_),
					$author$project$Element$ModulesMain$ModuleListDownloaded),
					A2($author$project$Team$fetchSchools, config.gr, $author$project$Element$ModulesMain$SchoolListDownloaded),
					A2($author$project$Person$fetchTeachers, config.gr, $author$project$Element$ModulesMain$PeopleDownloaded),
					A2($author$project$Subject$fetchSubjects, config.gr, $author$project$Element$ModulesMain$SubjectListDownloaded),
					$author$project$ACL$canViewClassrooms(viewer) ? $author$project$Api$getV2(
					A2($author$project$ClassroomCourse$fetchUserClassrooms, config.gr, $author$project$Element$ModulesMain$ClassroomCourseListDownloaded)) : $elm$core$Platform$Cmd$none
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bm: $author$project$Element$ModulesMain$LoadingPage}),
				session));
	});
var $author$project$Log$paramModulesDuplicate = 'duplicate';
var $author$project$Log$paramModulesTemplate = 'template';
var $author$project$Element$ModulesMain$initPageByParam = F3(
	function (params, session, model) {
		var config = model.bN;
		switch (params.$) {
			case 0:
				return A2($author$project$Element$ModulesMain$buildFormPage, session, model);
			case 1:
				var moduleId = params.a;
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Module$fetchOneModule,
							config.gr,
							$author$project$Module$moduleIdToInt(moduleId),
							$author$project$Element$ModulesMain$ModuleDetailDownloadedForTemplate),
							A3(
							$author$project$Log$ok,
							config,
							_Utils_Tuple2(
								$author$project$Log$msgModuleCreate,
								_List_fromArray(
									[$author$project$Log$paramScopeModules, $author$project$Log$paramModulesTemplate])),
							$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp))
						]));
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					cmd,
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bm: $author$project$Element$ModulesMain$LoadingPage}),
						session));
			case 2:
				return A2($author$project$Element$ModulesMain$openListPage, session, model);
			case 3:
				var moduleId = params.a;
				var cmd = $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							A3(
							$author$project$Module$fetchOneModule,
							config.gr,
							$author$project$Module$moduleIdToInt(moduleId),
							$author$project$Element$ModulesMain$ModuleDetailDownloadedForDuplicate),
							A3(
							$author$project$Log$ok,
							config,
							_Utils_Tuple2(
								$author$project$Log$msgModuleCreate,
								_List_fromArray(
									[$author$project$Log$paramScopeModules, $author$project$Log$paramModulesDuplicate])),
							$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp))
						]));
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					cmd,
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bm: $author$project$Element$ModulesMain$LoadingPage}),
						session));
			default:
				var moduleId = params.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Module$fetchOneModule,
						config.gr,
						$author$project$Module$moduleIdToInt(moduleId),
						$author$project$Element$ModulesMain$ModuleDetailDownloadedForEdit),
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{bm: $author$project$Element$ModulesMain$LoadingPage}),
						session));
		}
	});
var $author$project$Element$ModulesMain$init = F3(
	function (config, session, params) {
		var model = {gx: _List_Nil, bN: config, ez: $author$project$Element$ModulesMain$Closed, bm: $author$project$Element$ModulesMain$NotFoundPage, d2: $elm$core$Maybe$Nothing, c3: $elm$core$Maybe$Nothing, jr: $author$project$RemoteData$NotAsked, e1: $author$project$RemoteData$NotAsked, jB: $author$project$RemoteData$NotAsked, e5: $author$project$RemoteData$NotAsked};
		return A3($author$project$Element$ModulesMain$initPageByParam, params, session, model);
	});
var $author$project$Element$ModulesMain$CreateFromDuplicate = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$CreateFromTemplate = {$: 1};
var $author$project$Element$ModulesMain$DelayedGotListQuery = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$ModulesMain$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleted = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$ModulesMain$ModuleSaved = function (a) {
	return {$: 10, a: a};
};
var $author$project$Locale$Messages$ModulesCopyTitle = function (a) {
	return {$: 256, a: a};
};
var $author$project$Locale$Messages$ModulesSaveSuccess = {$: 305};
var $author$project$Element$ModulesMain$Open = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$TimeIsNow = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$ModulesMain$Update = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModulesMain$ModulesLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$NoMoreModules = {$: 2};
var $author$project$Element$ModulesMain$addNewModules = F2(
	function (newModules, listPage) {
		var loading = listPage.cY;
		var modules = listPage.g9;
		var _v0 = _Utils_Tuple3(
			loading,
			modules,
			$elm$core$List$reverse(newModules));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							listPage,
							{cY: $author$project$Element$ModulesMain$NoMoreModules, g9: newModules});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							listPage,
							{cY: $author$project$Element$ModulesMain$NoMoreModules});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStory = _v3.a;
						return _Utils_update(
							listPage,
							{
								cY: $author$project$Element$ModulesMain$ModulesLoaded(lastStory),
								g9: newModules
							});
					} else {
						var _v5 = _v0.a;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							listPage,
							{
								cY: $author$project$Element$ModulesMain$ModulesLoaded(lastStory),
								g9: _Utils_ap(modules, newModules)
							});
					}
				}
			case 1:
				return listPage;
			default:
				var _v7 = _v0.a;
				return listPage;
		}
	});
var $author$project$Element$ModulesMain$ModuleEventListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$ModuleEvent$fetchModuleEvents = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$moduleEvents, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$ModuleEvent$moduleEventDetailedListDecoder));
	});
var $author$project$Element$ModulesMain$andFetchFormDependenciesWithModuleEvents = F2(
	function (moduleId, _return) {
		var model = _return.dY;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$ModuleEvent$fetchModuleEvents,
				model.bN.gr,
				{
					iS: $elm$core$Maybe$Just(
						$author$project$Module$moduleIdToInt(moduleId))
				},
				$author$project$Element$ModulesMain$ModuleEventListDownloaded),
			$author$project$Element$ModulesMain$andFetchFormDependencies(_return));
	});
var $author$project$Module$isMigrationReady = function (module_) {
	return !_Utils_eq(module_.cZ, $elm$core$Maybe$Nothing);
};
var $author$project$Element$ModulesMain$fillForm = function (module_) {
	return {
		j3: $elm$core$String$fromInt(module_.j3.gT),
		S: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			module_.S),
		gD: module_.gD,
		gH: $author$project$Form$dateFromMillis(module_.gH),
		k9: module_.k9,
		la: module_.la,
		lb: module_.lb,
		aS: $author$project$Module$isMigrationReady(module_),
		iR: module_.iR,
		bp: $author$project$Team$encodeTeamId(module_.jF.gT),
		hv: $author$project$Form$dateFromMillis(module_.hv),
		e1: A2(
			$elm$core$List$map,
			function (student) {
				return $elm$core$String$fromInt(student.gT);
			},
			module_.e1),
		e5: A2(
			$elm$core$List$map,
			function (teacher) {
				return $elm$core$String$fromInt(teacher.gT);
			},
			module_.e5),
		jJ: module_.jJ
	};
};
var $author$project$Element$ModulesMain$namedPersonsToFormSelectOptions = F2(
	function (t_, students) {
		return A2($author$project$Form$toPeopleOptions, t_, students);
	});
var $author$project$Element$ModulesMain$buildFormPageFromModule = F4(
	function (session, model, action, module_) {
		var t_ = session.hy;
		var selectedStudents = A2($author$project$Element$ModulesMain$namedPersonsToFormSelectOptions, t_, module_.e1);
		var page = $author$project$Element$ModulesMain$FormPage(
			{
				hQ: action,
				by: module_.lC,
				bt: A2($author$project$Element$ModulesMain$buildForm, t_, selectedStudents),
				cO: false,
				g5: false,
				dX: false,
				fN: $elm$core$Maybe$Nothing,
				eX: A2(
					$elm$core$List$map,
					function ($) {
						return $.gT;
					},
					module_.g3),
				ct: module_.eW,
				eZ: 0,
				dn: {cI: true},
				ej: $author$project$Element$ModulesMain$fillForm(module_)
			});
		return A2(
			$author$project$Element$ModulesMain$andFetchFormDependenciesWithModuleEvents,
			module_.gT,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bm: page}),
				session));
	});
var $author$project$Module$learningOutcomesEncoder = function (learningOutcomeIds) {
	return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, learningOutcomeIds);
};
var $author$project$Module$moduleEncoder = function (module_) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$Module$moduleIdToInt(module_.gT))),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(module_.jJ)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(module_.gD)),
				_Utils_Tuple2(
				'goals_knowledge',
				$elm$json$Json$Encode$string(module_.k9)),
				_Utils_Tuple2(
				'goals_skills',
				$elm$json$Json$Encode$string(module_.lb)),
				_Utils_Tuple2(
				'goals_product',
				$elm$json$Json$Encode$string(module_.la)),
				_Utils_Tuple2(
				'evaluation',
				$elm$json$Json$Encode$string(module_.gI)),
				_Utils_Tuple2(
				'materials_url',
				$elm$json$Json$Encode$string(module_.iR)),
				_Utils_Tuple2(
				'start_date',
				$elm$json$Json$Encode$int(module_.hv)),
				_Utils_Tuple2(
				'end_date',
				$elm$json$Json$Encode$int(module_.gH)),
				_Utils_Tuple2(
				'is_template',
				$elm$json$Json$Encode$bool(module_.lC)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(module_.jF))),
				_Utils_Tuple2(
				'classroom_courses',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.S)),
				_Utils_Tuple2(
				'accountable_teacher',
				$elm$json$Json$Encode$int(module_.j3)),
				_Utils_Tuple2(
				'teachers',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.e5)),
				_Utils_Tuple2(
				'students',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, module_.e1)),
				_Utils_Tuple2(
				'learning_outcomes',
				$author$project$Module$learningOutcomesEncoder(module_.g3)),
				_Utils_Tuple2(
				'rubrics',
				A2(
					$elm$json$Json$Encode$list,
					$elm$json$Json$Encode$int,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.gT;
						},
						module_.eW))),
				_Utils_Tuple2(
				'migration_ready_at',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $elm$json$Json$Encode$int, module_.cZ)))
			]));
};
var $author$project$Module$createModule = F3(
	function (config, module_, callback) {
		return A5(
			$author$project$Api$post,
			A2($author$project$Api$Endpoint$modules, config, $author$project$Module$defaultListParams),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Module$moduleEncoder(module_)),
			callback,
			$author$project$Module$moduleDetailedDecoder);
	});
var $author$project$Api$delete = F3(
	function (url, config, toMsg) {
		return $author$project$Api$Endpoint$request(
			{
				O: $elm$http$Http$emptyBody,
				a4: $author$project$Api$expectHeaders(toMsg),
				ah: $author$project$Api$toHeaders(config),
				ba: 'DELETE',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$Module$deleteModule = F3(
	function (config, moduleId, callback) {
		return A3(
			$author$project$Api$delete,
			A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(moduleId)),
			config,
			callback);
	});
var $author$project$Element$ModulesMain$emptyResults = function (listPage) {
	return _Utils_update(
		listPage,
		{cY: $author$project$Element$ModulesMain$LoadingModules, g9: _List_Nil});
};
var $author$project$Element$ModulesMain$filterModules = F4(
	function (session, model, listPage, newFilter) {
		var filteredPage = $author$project$Element$ModulesMain$emptyResults(
			_Utils_update(
				listPage,
				{bO: newFilter}));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Module$fetchModules_,
				model.bN.gr,
				$author$project$Element$ModulesMain$asListParams(filteredPage),
				$author$project$Element$ModulesMain$ModuleListDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bm: $author$project$Element$ModulesMain$ListPage(filteredPage)
					}),
				session));
	});
var $author$project$Element$ModulesMain$formVariation = F3(
	function (form, t_, isTemplate) {
		var students = form.e1;
		return _Utils_update(
			form,
			{
				e1: isTemplate ? _Utils_update(
					students,
					{
						mu: $author$project$Form$optionalPeople(t_)
					}) : _Utils_update(
					students,
					{
						mu: $author$project$Form$requiredPeopleSelected(t_)
					})
			});
	});
var $author$project$Element$ModulesMain$isCreateAction = function (model) {
	var _v0 = model.bm;
	if (_v0.$ === 3) {
		var formPageModel = _v0.a;
		return A2(
			$elm$core$List$member,
			formPageModel.hQ,
			_List_fromArray(
				[$author$project$Element$ModulesMain$Create, $author$project$Element$ModulesMain$CreateFromTemplate]));
	} else {
		return false;
	}
};
var $author$project$Element$ModulesMain$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.jJ, values) && (A2($author$project$Form$isFieldValid, form.gD, values) && (A2($author$project$Form$isFieldValid, form.iR, values) && (A2($author$project$Form$isFieldValid, form.k9, values) && (A2($author$project$Form$isFieldValid, form.lb, values) && (A2($author$project$Form$isFieldValid, form.la, values) && (A2($author$project$Form$isFieldValid, form.hv, values) && (A2($author$project$Form$isFieldValid, form.gH, values) && (A2($author$project$Form$isFieldValid, form.j3, values) && (A2($author$project$Form$isFieldValid, form.bp, values) && (A2($author$project$Form$isFieldValid, form.S, values) && (A2($author$project$Form$isFieldValid, form.e5, values) && (A2($author$project$Form$isFieldValid, form.e1, values) && A3($author$project$Form$areDatesValid, form.hv, form.gH, values)))))))))))));
	});
var $author$project$Log$msgModuleSave = 'module_save';
var $author$project$Element$ModulesMain$LearningGroupSelectorModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModulesMain$RubricsFormModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$RubricsFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModulesMain$RubricsListModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModulesMain$RubricsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$CreateRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsForm$FetchRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$Loading = {$: 0};
var $author$project$Element$RubricsForm$NewRubricCreated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsForm$RubricDetailDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Rubric$standard = {
	lO: 'Standard',
	fG: _List_fromArray(
		['Felülmúltad a várt szintet', 'Teljesítetted a szintet', 'Megközelítetted a várt szintet', 'Még nem érted el a megfelelő szintet'])
};
var $author$project$Rubric$blankRubric = function (author) {
	return {ki: _List_Nil, kn: author, gT: -1, lR: 0, fG: $author$project$Rubric$standard, m0: 0, jJ: '(no title)'};
};
var $author$project$Rubric$encodedRubricToBackend = function (rubric) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(rubric.gT)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(rubric.jJ)),
				_Utils_Tuple2(
				'author',
				$elm$json$Json$Encode$int(rubric.kn.gT)),
				_Utils_Tuple2(
				'shared_with',
				$elm$json$Json$Encode$string(
					function () {
						var _v0 = rubric.m0;
						if (!_v0) {
							return 'nobody';
						} else {
							return 'bps';
						}
					}())),
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(
					A2(
						$elm$json$Json$Encode$encode,
						4,
						$author$project$Rubric$encodeRubricContent(
							$author$project$Rubric$extractContent(rubric)))))
			]));
};
var $author$project$Api$Endpoint$rubricsCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'rubrics']),
		_List_Nil);
};
var $author$project$Rubric$createRubric = F3(
	function (config, rubric, callback) {
		return {
			O: $author$project$Rubric$encodedRubricToBackend(rubric),
			bN: config,
			dC: $author$project$Rubric$rubricDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$rubricsCreate(config.gr)
		};
	});
var $author$project$Api$Endpoint$rubric = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'rubrics',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$Rubric$fetchRubric = F3(
	function (config, id, callback) {
		return {
			bN: config,
			dC: $author$project$Rubric$rubricDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$rubric, config, id)
		};
	});
var $author$project$Person$toNested = function (person) {
	return {K: person.K, k3: person.k3, gT: person.gT, ak: person.ak};
};
var $author$project$Element$RubricsForm$init = F3(
	function (config, session, params) {
		var viewer = session.nH;
		var model = {bN: config, lz: params.lz, bF: $author$project$Element$RubricsForm$Loading, cv: session, jB: $author$project$RemoteData$Loading};
		var cmd = function () {
			var _v0 = params.mS;
			if (_v0.$ === 1) {
				return $author$project$Element$RubricsForm$CreateRubric(
					A3(
						$author$project$Rubric$createRubric,
						config,
						$author$project$Rubric$blankRubric(
							$author$project$Person$toNested(viewer)),
						$author$project$Element$RubricsForm$NewRubricCreated));
			} else {
				var rubricId = _v0.a;
				return $author$project$Element$RubricsForm$FetchRubric(
					A3($author$project$Rubric$fetchRubric, config.gr, rubricId, $author$project$Element$RubricsForm$RubricDetailDownloaded));
			}
		}();
		return _Utils_Tuple3(
			model,
			$author$project$Element$RubricsForm$Cmd(cmd),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$RubricsForm$perform(key),
						effects));
			default:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$putV2(request);
					case 3:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 4:
						var route = cmd.a;
						return A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(route));
					case 5:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 6:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var elementName = cmd.a;
						var toMsg = cmd.b;
						return A2(
							$elm$core$Task$attempt,
							toMsg,
							$elm$browser$Browser$Dom$focus(elementName));
				}
		}
	});
var $author$project$Element$RubricsForm$Exit = 0;
var $author$project$Element$RubricsForm$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsForm$NavRedirect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsForm$NoEdit = {$: 0};
var $author$project$Element$RubricsForm$NoEffect = {$: 0};
var $author$project$Element$RubricsForm$NoOp = {$: 0};
var $author$project$Element$RubricsForm$RubricLoaded = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$RubricsCreateError = {$: 436};
var $author$project$Locale$Messages$RubricsSaveError = {$: 440};
var $author$project$Locale$Messages$RubricsSaveSuccess = {$: 439};
var $author$project$Element$RubricsForm$SaveError = {$: 6};
var $author$project$Element$RubricsForm$AddAspect = {$: 11};
var $author$project$Element$RubricsForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsForm$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$SubjectListDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$AspectTitle = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricsForm$LevelDimension = {$: 3};
var $author$project$Element$RubricsForm$LogOk = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$RubricTitle = {$: 4};
var $author$project$Element$RubricsForm$RubricUpdated = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$Saving = {$: 5};
var $author$project$Element$RubricsForm$ScaleCell = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Element$RubricsForm$Submit = {$: 10};
var $author$project$Element$RubricsForm$UpdateRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$FocusInput = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Element$RubricsForm$focusTextEditor = $author$project$Element$RubricsForm$Cmd(
	A2(
		$author$project$Element$RubricsForm$FocusInput,
		'text-editor',
		$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)));
var $author$project$Util$List$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Util$List$insertAt = F3(
	function (index, items, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			return _Utils_ap(
				head,
				_Utils_ap(items, tail));
		}
	});
var $author$project$Element$RubricsForm$insertAspects = F3(
	function (index, newAspects, aspects) {
		return A3($author$project$Util$List$insertAt, index, newAspects, aspects);
	});
var $author$project$Element$RubricsForm$isBlank = function (string) {
	var regexFromString = A2(
		$elm$core$Basics$composeR,
		$elm$regex$Regex$fromString,
		$elm$core$Maybe$withDefault($elm$regex$Regex$never));
	return A2(
		$elm$regex$Regex$contains,
		regexFromString('^\\s*$'),
		string);
};
var $author$project$Util$List$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Util$List$uncons = function (list) {
	if (!list.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var first = list.a;
		var rest = list.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(first, rest));
	}
};
var $author$project$Util$List$swapAt = F3(
	function (index1, index2, l) {
		swapAt:
		while (true) {
			if (_Utils_eq(index1, index2) || (index1 < 0)) {
				return l;
			} else {
				if (_Utils_cmp(index1, index2) > 0) {
					var $temp$index1 = index2,
						$temp$index2 = index1,
						$temp$l = l;
					index1 = $temp$index1;
					index2 = $temp$index2;
					l = $temp$l;
					continue swapAt;
				} else {
					var _v0 = A2($author$project$Util$List$splitAt, index1, l);
					var part1 = _v0.a;
					var tail1 = _v0.b;
					var _v1 = A2($author$project$Util$List$splitAt, index2 - index1, tail1);
					var head2 = _v1.a;
					var tail2 = _v1.b;
					var _v2 = _Utils_Tuple2(
						$author$project$Util$List$uncons(head2),
						$author$project$Util$List$uncons(tail2));
					if ((!_v2.a.$) && (!_v2.b.$)) {
						var _v3 = _v2.a.a;
						var value1 = _v3.a;
						var part2 = _v3.b;
						var _v4 = _v2.b.a;
						var value2 = _v4.a;
						var part3 = _v4.b;
						return $elm$core$List$concat(
							_List_fromArray(
								[
									part1,
									A2($elm$core$List$cons, value2, part2),
									A2($elm$core$List$cons, value1, part3)
								]));
					} else {
						return l;
					}
				}
			}
		}
	});
var $author$project$Util$List$moveAhead = F2(
	function (index, list) {
		if (!index) {
			return list;
		} else {
			var i = index;
			return A3($author$project$Util$List$swapAt, i - 1, i, list);
		}
	});
var $author$project$Util$List$moveBack = F2(
	function (index, list) {
		var last = $elm$core$List$length(list) - 1;
		return (_Utils_cmp(index, last) > 0) ? list : A3($author$project$Util$List$swapAt, index, index + 1, list);
	});
var $author$project$Log$msgRubricPaste = 'rubric_paste';
var $author$project$Rubric$numOfScaleLevels = function (rubric) {
	return $elm$core$List$length(rubric.fG.fG);
};
var $author$project$Rubric$parseTsv = function (value) {
	var lineSeparator = '\n';
	var cellSeparator = '\t';
	var parseAspect = function (line) {
		var _v0 = A2($elm$core$String$split, cellSeparator, line);
		if (_v0.b) {
			if (!_v0.b.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var x = _v0.a;
				var xs = _v0.b;
				return $elm$core$Maybe$Just(
					{
						lV: A2(
							$elm$core$List$filter,
							A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
							xs),
						nf: $elm$core$Maybe$Nothing,
						jJ: x
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$core$List$filterMap,
		parseAspect,
		A2($elm$core$String$split, lineSeparator, value));
};
var $author$project$Util$List$removeAt = F2(
	function (index, list) {
		var tail = A2($elm$core$List$drop, index + 1, list);
		var head = A2($elm$core$List$take, index, list);
		return _Utils_ap(head, tail);
	});
var $author$project$Element$RubricsForm$removeBlankAspects = function (rubric) {
	var isAspectEmpty = function (aspect) {
		return $author$project$Element$RubricsForm$isBlank(aspect.jJ) && A2(
			$elm$core$List$all,
			$elm$core$Basics$eq(true),
			A2($elm$core$List$map, $author$project$Element$RubricsForm$isBlank, aspect.lV));
	};
	return _Utils_update(
		rubric,
		{
			ki: A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAspectEmpty),
				rubric.ki)
		});
};
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $author$project$Util$List$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			var head = A2($elm$core$List$take, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					head,
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $author$project$Util$List$setAt = F2(
	function (index, value) {
		return A2(
			$author$project$Util$List$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Element$RubricsForm$updateAspects = F3(
	function (index, updatedAspect, aspects) {
		return A3($author$project$Util$List$setAt, index, updatedAspect, aspects);
	});
var $author$project$Rubric$updateRubric = F3(
	function (config, rubric, callback) {
		return {
			O: $author$project$Rubric$encodedRubricToBackend(rubric),
			bN: config,
			dC: $author$project$Rubric$rubricDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$rubric, config.gr, rubric.gT)
		};
	});
var $author$project$Element$RubricsForm$submitPendingEdit = F3(
	function (config, editState, rubric) {
		var _v15 = A4($author$project$Element$RubricsForm$updateEditor, config, $author$project$Element$RubricsForm$Submit, editState, rubric);
		var rubric2 = _v15.b;
		var effect = _v15.c;
		return _Utils_Tuple2(rubric2, effect);
	});
var $author$project$Element$RubricsForm$updateEditor = F4(
	function (config, editMsg, editState, rubric) {
		var noop = _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
		switch (editMsg.$) {
			case 4:
				var _v1 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v1.a;
				var effect = _v1.b;
				switch (editState.$) {
					case 1:
						return _Utils_Tuple3($author$project$Element$RubricsForm$LevelDimension, rubric2, effect);
					case 0:
						return _Utils_Tuple3($author$project$Element$RubricsForm$LevelDimension, rubric2, effect);
					case 2:
						return noop;
					case 3:
						return noop;
					case 4:
						return noop;
					case 5:
						return noop;
					default:
						return noop;
				}
			case 3:
				var sharing = editMsg.a;
				var _v3 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v3.a;
				var effect = _v3.b;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric2,
						{m0: sharing}),
					effect);
			case 2:
				return _Utils_Tuple3($author$project$Element$RubricsForm$RubricTitle, rubric, $author$project$Element$RubricsForm$NoEffect);
			case 0:
				var rowIndex = editMsg.a;
				var maybeAspect = A2($author$project$Util$List$getAt, rowIndex, rubric.ki);
				var _v4 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v4.a;
				var effect = _v4.b;
				if (!maybeAspect.$) {
					var aspect = maybeAspect.a;
					return _Utils_Tuple3(
						A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex),
						rubric2,
						$author$project$Element$RubricsForm$BatchEffect(
							_List_fromArray(
								[effect, $author$project$Element$RubricsForm$focusTextEditor])));
				} else {
					return noop;
				}
			case 1:
				var rowIndex = editMsg.a;
				var levelIndex = editMsg.b;
				var maybeAspect = A2($author$project$Util$List$getAt, rowIndex, rubric.ki);
				var _v6 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v6.a;
				var effect = _v6.b;
				if (!maybeAspect.$) {
					var aspect = maybeAspect.a;
					return _Utils_Tuple3(
						A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, levelIndex),
						rubric2,
						$author$project$Element$RubricsForm$BatchEffect(
							_List_fromArray(
								[effect, $author$project$Element$RubricsForm$focusTextEditor])));
				} else {
					return noop;
				}
			case 6:
				var value = editMsg.a;
				if (editState.$ === 1) {
					var aspect = editState.a;
					var rowIndex = editState.b;
					var newLevelDescriptions = function () {
						switch (value) {
							case 'Önállóság':
								return _List_fromArray(
									['Egyedül hozol döntéseket, javaslatokat teszel, mikor, mi történjen, felismered és kezeled a saját szükségleteidet', 'Jelzed ha valamire szükséged van, de már a megoldást is ismered', 'Még nem minden esetben ismered fel saját szükségleteidet', 'Még szükséged van mások segítségére abban, hogy felismerd és megoldást találj szükségleteid kielégítésére']);
							case 'Figyelem, aktivitás':
								return _List_fromArray(
									['Addig tudsz figyelni, míg kész nem vagy a rád bízott feladattal, társaidnak segítesz ha elakadnak, részt veszel a munka előkészítésében, utómunkáiban', 'Sokáig tudsz figyelni, észre veszed ha valakinek segítségre van szüksége, elvégzed a feladatot', 'Vannak napok amikor sikerül figyelned, befejezni a feladatot, máskor kevesebb erőd van hozzá', 'Nem szeretsz a társaiddal együtt részt venni a munkában, nem érdekel, mit csinálnak']);
							default:
								return aspect.lV;
						}
					}();
					var updatedAspect = _Utils_update(
						aspect,
						{lV: newLevelDescriptions, jJ: value});
					var _v9 = _Utils_Tuple2(
						$author$project$Element$RubricsForm$isBlank(aspect.jJ),
						$author$project$Rubric$parseTsv(value));
					if (!_v9.a) {
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, updatedAspect, rowIndex),
							_Utils_update(
								rubric,
								{
									ki: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.ki)
								}),
							$author$project$Element$RubricsForm$NoEffect);
					} else {
						if (!_v9.b.b) {
							return _Utils_Tuple3(
								A2($author$project$Element$RubricsForm$AspectTitle, updatedAspect, rowIndex),
								_Utils_update(
									rubric,
									{
										ki: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.ki)
									}),
								$author$project$Element$RubricsForm$NoEffect);
						} else {
							var pastedAspects = _v9.b;
							return _Utils_Tuple3(
								A2(
									$author$project$Element$RubricsForm$AspectTitle,
									aspect,
									rowIndex + $elm$core$List$length(pastedAspects)),
								_Utils_update(
									rubric,
									{
										ki: A3($author$project$Element$RubricsForm$insertAspects, rowIndex, pastedAspects, rubric.ki)
									}),
								$author$project$Element$RubricsForm$Cmd(
									$author$project$Element$RubricsForm$LogOk(
										A3(
											$author$project$Log$okV2,
											config,
											_Utils_Tuple2(
												$author$project$Log$msgRubricPaste,
												_List_fromArray(
													[
														$elm$core$String$fromInt(rubric.gT),
														$elm$core$String$fromInt(
														$elm$core$List$length(pastedAspects))
													])),
											$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))));
						}
					}
				} else {
					return _Utils_Tuple3(editState, rubric, $author$project$Element$RubricsForm$NoEffect);
				}
			case 7:
				var aspect = editMsg.a;
				var rowIndex = editMsg.b;
				var subjectIdAsString = editMsg.c;
				var updatedAspect = _Utils_update(
					aspect,
					{
						nf: $elm$core$String$toInt(subjectIdAsString)
					});
				return _Utils_Tuple3(
					A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex),
					_Utils_update(
						rubric,
						{
							ki: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.ki)
						}),
					$author$project$Element$RubricsForm$focusTextEditor);
			case 9:
				var aspect = editMsg.a;
				var rowIndex = editMsg.b;
				var level = editMsg.c;
				var value = editMsg.d;
				var newLevelDescriptions = A3($author$project$Util$List$setAt, level, value, aspect.lV);
				var updatedAspect = _Utils_update(
					aspect,
					{lV: newLevelDescriptions});
				return _Utils_Tuple3(
					A3($author$project$Element$RubricsForm$ScaleCell, updatedAspect, rowIndex, level),
					_Utils_update(
						rubric,
						{
							ki: A3($author$project$Element$RubricsForm$updateAspects, rowIndex, updatedAspect, rubric.ki)
						}),
					$author$project$Element$RubricsForm$NoEffect);
			case 5:
				var levels = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric,
						{fG: levels}),
					$author$project$Element$RubricsForm$NoEffect);
			case 8:
				var value = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$RubricTitle,
					_Utils_update(
						rubric,
						{jJ: value}),
					$author$project$Element$RubricsForm$NoEffect);
			case 14:
				var rowIndex = editMsg.a;
				switch (editState.$) {
					case 0:
						return noop;
					case 3:
						return noop;
					case 5:
						return noop;
					case 6:
						return noop;
					case 4:
						return noop;
					case 2:
						return noop;
					default:
						var aspect = editState.a;
						var newRowIndex = (!rowIndex) ? rowIndex : (rowIndex - 1);
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, aspect, newRowIndex),
							_Utils_update(
								rubric,
								{
									ki: A2($author$project$Util$List$moveAhead, rowIndex, rubric.ki)
								}),
							$author$project$Element$RubricsForm$NoEffect);
				}
			case 15:
				var rowIndex = editMsg.a;
				switch (editState.$) {
					case 0:
						return noop;
					case 3:
						return noop;
					case 5:
						return noop;
					case 6:
						return noop;
					case 4:
						return noop;
					case 2:
						return noop;
					default:
						var aspect = editState.a;
						var newRowIndex = _Utils_eq(
							rowIndex,
							$elm$core$List$length(rubric.ki) - 1) ? rowIndex : (rowIndex + 1);
						return _Utils_Tuple3(
							A2($author$project$Element$RubricsForm$AspectTitle, aspect, newRowIndex),
							_Utils_update(
								rubric,
								{
									ki: A2($author$project$Util$List$moveBack, rowIndex, rubric.ki)
								}),
							$author$project$Element$RubricsForm$NoEffect);
				}
			case 12:
				var rowIndex = editMsg.a;
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$NoEdit,
					_Utils_update(
						rubric,
						{
							ki: A2($author$project$Util$List$removeAt, rowIndex, rubric.ki)
						}),
					$author$project$Element$RubricsForm$NoEffect);
			case 10:
				switch (editState.$) {
					case 0:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 3:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 5:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 6:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 4:
						return _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					case 2:
						var aspect = editState.a;
						var rowIndex = editState.b;
						var scaleIx = editState.c;
						return (_Utils_cmp(
							scaleIx,
							$author$project$Rubric$numOfScaleLevels(rubric) - 1) < 0) ? _Utils_Tuple3(
							A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, scaleIx + 1),
							rubric,
							$author$project$Element$RubricsForm$focusTextEditor) : _Utils_Tuple3($author$project$Element$RubricsForm$NoEdit, rubric, $author$project$Element$RubricsForm$NoEffect);
					default:
						return noop;
				}
			case 11:
				var lastIndex = $elm$core$List$length(rubric.ki);
				var emptyAspect = {
					lV: A2(
						$elm$core$List$repeat,
						$author$project$Rubric$numOfScaleLevels(rubric),
						''),
					nf: $elm$core$Maybe$Nothing,
					jJ: ''
				};
				return _Utils_Tuple3(
					A2($author$project$Element$RubricsForm$AspectTitle, emptyAspect, lastIndex),
					_Utils_update(
						rubric,
						{
							ki: A3(
								$author$project$Element$RubricsForm$insertAspects,
								lastIndex,
								_List_fromArray(
									[emptyAspect]),
								rubric.ki)
						}),
					$author$project$Element$RubricsForm$focusTextEditor);
			default:
				var _v14 = A3($author$project$Element$RubricsForm$submitPendingEdit, config, editState, rubric);
				var rubric2 = _v14.a;
				var effect = _v14.b;
				var rubric3 = $author$project$Element$RubricsForm$removeBlankAspects(rubric2);
				var effect2 = _Utils_eq(rubric3.gT, -1) ? $author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$CreateRubric(
						A3($author$project$Rubric$createRubric, config, rubric3, $author$project$Element$RubricsForm$RubricUpdated))) : $author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$UpdateRubric(
						A3($author$project$Rubric$updateRubric, config, rubric3, $author$project$Element$RubricsForm$RubricUpdated)));
				return _Utils_Tuple3(
					$author$project$Element$RubricsForm$Saving,
					rubric3,
					$author$project$Element$RubricsForm$BatchEffect(
						_List_fromArray(
							[effect, effect2])));
		}
	});
var $author$project$Element$RubricsForm$initEditor = F2(
	function (model, rubric) {
		var _v0 = A4($author$project$Element$RubricsForm$updateEditor, model.bN, $author$project$Element$RubricsForm$AddAspect, $author$project$Element$RubricsForm$NoEdit, rubric);
		var editState = _v0.a;
		var rubric_ = _v0.b;
		var effect = _v0.c;
		var effect2 = $author$project$Element$RubricsForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$RubricsForm$Cmd(
					$author$project$Element$RubricsForm$FetchSubjectList(
						A3($author$project$Subject$fetchSubjectsV2, model.bN.gr, '', $author$project$Element$RubricsForm$SubjectListDownloaded))),
					effect
				]));
		return (!$elm$core$List$length(rubric.ki)) ? _Utils_Tuple3(
			_Utils_update(
				model,
				{
					bF: A3($author$project$Element$RubricsForm$RubricLoaded, rubric_, editState, false)
				}),
			effect2,
			$elm$core$Maybe$Nothing) : _Utils_Tuple3(
			_Utils_update(
				model,
				{
					bF: A3($author$project$Element$RubricsForm$RubricLoaded, rubric, $author$project$Element$RubricsForm$NoEdit, false)
				}),
			effect2,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$msgRubricCreate = 'rubric_create';
var $author$project$Log$msgRubricSave = 'rubric_save';
var $author$project$Element$RubricsForm$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 1:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsForm$NoEffect,
					$elm$core$Maybe$Just(0));
			case 5:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return model.lz ? A2($author$project$Element$RubricsForm$initEditor, model, rubric) : _Utils_Tuple3(
						model,
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$NavRedirect(
								$author$project$Route$RubricsUpdate(rubric.gT))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsCreateError))
							}),
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricCreate, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 3:
				if (!msg.a.$) {
					var rubric_ = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bF: A3($author$project$Element$RubricsForm$RubricLoaded, rubric_, $author$project$Element$RubricsForm$NoEdit, false),
								cv: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$RubricsSaveSuccess))
							}),
						$author$project$Element$RubricsForm$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					var error = msg.a.a;
					var _v1 = model.bF;
					if ((_v1.$ === 1) && (_v1.b.$ === 5)) {
						var rubric = _v1.a;
						var _v2 = _v1.b;
						var hasChanged = _v1.c;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									bF: A3($author$project$Element$RubricsForm$RubricLoaded, rubric, $author$project$Element$RubricsForm$SaveError, hasChanged),
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$RubricsSaveError))
								}),
							$author$project$Element$RubricsForm$Cmd(
								$author$project$Element$RubricsForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgRubricSave,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(rubric.gT)),
											error),
										$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			case 4:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return A2($author$project$Element$RubricsForm$initEditor, model, rubric);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsForm$Cmd(
							$author$project$Element$RubricsForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 6:
				var data = msg.a;
				var updatedModel = _Utils_update(
					model,
					{jB: data});
				switch (data.$) {
					case 2:
						return _Utils_Tuple3(updatedModel, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
					case 3:
						var error = data.a;
						return _Utils_Tuple3(
							_Utils_update(
								updatedModel,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError))
								}),
							$author$project$Element$RubricsForm$Cmd(
								$author$project$Element$RubricsForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsForm$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(updatedModel, $author$project$Element$RubricsForm$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				var editMsg = msg.a;
				var _v4 = model.bF;
				if (_v4.$ === 1) {
					var rubric = _v4.a;
					var editState = _v4.b;
					var hasChanged = _v4.c;
					var _v5 = A4($author$project$Element$RubricsForm$updateEditor, config, editMsg, editState, rubric);
					var editState_ = _v5.a;
					var rubric_ = _v5.b;
					var effect = _v5.c;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								bF: A3(
									$author$project$Element$RubricsForm$RubricLoaded,
									rubric_,
									editState_,
									hasChanged || (!_Utils_eq(rubric, rubric_)))
							}),
						effect,
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
		}
	});
var $author$project$Locale$Messages$RubricsHeadingEdit = {$: 449};
var $author$project$Locale$Messages$RubricsHelpCreate = {$: 450};
var $author$project$Locale$Messages$RubricsLoadingProgress = {$: 452};
var $author$project$UI$Icon$help = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-question-circle'),
			attributes));
};
var $author$project$Element$RubricsForm$EditMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsForm$OpenAspectSelector = {$: 4};
var $author$project$Locale$Messages$RubricsBtnPrivate = {$: 441};
var $author$project$Locale$Messages$RubricsBtnSharedWithBps = {$: 443};
var $author$project$Locale$Messages$RubricsHelpEdit = {$: 451};
var $author$project$Element$RubricsForm$Save = {$: 13};
var $author$project$Element$RubricsForm$SetSharing = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsForm$AspectTitleInput = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsForm$MoveAspectDown = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$RubricsForm$MoveAspectUp = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$RubricsForm$StartEditAspectTitle = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsForm$columns = F2(
	function (left, right) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('columns')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column is-10')
						]),
					right),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('column')
						]),
					left)
				]));
	});
var $author$project$Element$RubricsForm$Delete = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$RubricsForm$viewControls = function (rowIndex) {
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit)),
					$elm$html$Html$Attributes$title('Done')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$check(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('is-small')
						]))
				])),
			A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$Delete(rowIndex))),
					$elm$html$Html$Attributes$title('Delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-minus'),
							$author$project$UI$Icon$style('is-small')
						]))
				]))
		]);
};
var $author$project$Element$RubricsForm$AspectSubjectInput = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $author$project$Locale$Messages$RubricAspectSubject = {$: 435};
var $author$project$Element$RubricsForm$viewSubjectSelector = F4(
	function (t_, subjects, aspect, rowIndex) {
		var subjectsFormValues = {
			f8: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $elm$core$String$fromInt, aspect.nf))
		};
		var subjectOptions = function () {
			switch (subjects.$) {
				case 2:
					var subjectList = subjects.a;
					return A3(
						$elm$core$List$map2,
						$elm$core$Tuple$pair,
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.gT;
								},
								$elm$core$String$fromInt),
							subjectList),
						A2(
							$elm$core$List$map,
							function ($) {
								return $.ha;
							},
							subjectList));
				case 3:
					return _List_Nil;
				default:
					return _List_Nil;
			}
		}();
		var subjectsFormFields = {
			kU: false,
			mu: function (_v0) {
				return $elm$core$Result$Ok('?');
			},
			mK: false,
			jR: F2(
				function (_v1, _v2) {
					return {f8: ''};
				}),
			nD: function ($) {
				return $.f8;
			},
			nE: {
				kJ: 'subject',
				lj: '',
				lO: t_($author$project$Locale$Messages$RubricAspectSubject),
				aT: A2(
					$elm$core$Basics$composeL,
					$author$project$Element$RubricsForm$EditMsg,
					A2($author$project$Element$RubricsForm$AspectSubjectInput, aspect, rowIndex)),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(subjectOptions))
			}
		};
		return A3($author$project$UI$choiceField, t_, subjectsFormFields, subjectsFormValues);
	});
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $author$project$Util$Html$onEnter = function (msg) {
	var isEnter = function (code) {
		return (code === 13) ? $elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)) : $elm$json$Json$Decode$fail('not ENTER');
	};
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'keydown',
		A2($elm$json$Json$Decode$andThen, isEnter, $elm$html$Html$Events$keyCode));
};
var $author$project$Element$RubricsForm$viewTextAreaEditor = F3(
	function (value_, onInput_, onEnter_) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(value_),
					A2(
					$elm$html$Html$textarea,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('textarea is-info'),
							A2($elm$html$Html$Attributes$style, 'min-height', '1em'),
							A2($elm$html$Html$Attributes$style, 'width', '100%'),
							A2($elm$html$Html$Attributes$style, 'height', '100%'),
							A2($elm$html$Html$Attributes$style, 'top', '0'),
							A2($elm$html$Html$Attributes$style, 'right', '0'),
							A2($elm$html$Html$Attributes$style, 'left', '0'),
							A2($elm$html$Html$Attributes$style, 'bottom', '0'),
							A2($elm$html$Html$Attributes$style, 'resize', 'none'),
							A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
							$elm$html$Html$Attributes$id('text-editor'),
							$elm$html$Html$Attributes$value(value_),
							$elm$html$Html$Events$onInput(onInput_),
							$author$project$Util$Html$onEnter(onEnter_)
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$RubricsForm$viewAspectTitleCell = F6(
	function (t_, editing, isLastRow, rowIndex, aspect, subjects) {
		var buttonMoveUp = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					A2($elm$html$Html$Attributes$style, 'width', '10px'),
					A2($elm$html$Html$Attributes$style, 'height', '10px'),
					A2($elm$html$Html$Attributes$style, 'left', '-20px'),
					A2($elm$html$Html$Attributes$style, 'top', '50%'),
					A2($elm$html$Html$Attributes$style, 'resize', 'none'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$MoveAspectUp(rowIndex)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-arrow-up fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		var buttonMoveDown = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button is-small'),
					A2($elm$html$Html$Attributes$style, 'width', '10px'),
					A2($elm$html$Html$Attributes$style, 'height', '10px'),
					A2($elm$html$Html$Attributes$style, 'left', '-20px'),
					A2($elm$html$Html$Attributes$style, 'top', '70%'),
					A2($elm$html$Html$Attributes$style, 'resize', 'none'),
					A2($elm$html$Html$Attributes$style, 'position', 'absolute'),
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$MoveAspectDown(rowIndex)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-arrow-down fa-sm'),
							$author$project$UI$Icon$style('is-small')
						]))
				]));
		return editing ? A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Element$RubricsForm$columns,
					$author$project$Element$RubricsForm$viewControls(rowIndex),
					_List_fromArray(
						[
							A3(
							$author$project$Element$RubricsForm$viewTextAreaEditor,
							aspect.jJ,
							A2($elm$core$Basics$composeL, $author$project$Element$RubricsForm$EditMsg, $author$project$Element$RubricsForm$AspectTitleInput),
							$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit)),
							A4($author$project$Element$RubricsForm$viewSubjectSelector, t_, subjects, aspect, rowIndex)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$when, rowIndex > 0, buttonMoveUp),
							A2($author$project$UI$when, !isLastRow, buttonMoveDown)
						]))
				])) : A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						$author$project$Element$RubricsForm$StartEditAspectTitle(rowIndex)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(aspect.jJ),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					A2($elm$html$Html$br, _List_Nil, _List_Nil),
					function () {
					if (subjects.$ === 2) {
						var subjects_ = subjects.a;
						var subjectName = A2($author$project$Subject$findSubjectNameOrEmpty, subjects_, aspect.nf);
						return $elm$html$Html$text(
							$author$project$Util$String$parenthesize(subjectName));
					} else {
						return $author$project$UI$none;
					}
				}()
				]));
	});
var $author$project$Element$RubricsForm$AspectLevelDescriptionInput = F4(
	function (a, b, c, d) {
		return {$: 9, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$RubricsForm$StartEditScaleCell = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$RubricsForm$viewScaleDescriptionCell = F5(
	function (editing, value_, aspect, rowIndex, cellIndex) {
		return (!editing) ? A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(
					$author$project$Element$RubricsForm$EditMsg(
						A2($author$project$Element$RubricsForm$StartEditScaleCell, rowIndex, cellIndex)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(value_)
				])) : A2(
			$elm$html$Html$td,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Element$RubricsForm$viewTextAreaEditor,
					value_,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Element$RubricsForm$EditMsg,
						A3($author$project$Element$RubricsForm$AspectLevelDescriptionInput, aspect, rowIndex, cellIndex)),
					$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
				]));
	});
var $author$project$Element$RubricsForm$viewAspectRow = F6(
	function (t_, rubric, editState, subjects, rowIndex, aspect) {
		return A2(
			$elm$html$Html$tr,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-text-left')
				]),
			A2(
				$elm$core$List$cons,
				A6(
					$author$project$Element$RubricsForm$viewAspectTitleCell,
					t_,
					_Utils_eq(
						editState,
						A2($author$project$Element$RubricsForm$AspectTitle, aspect, rowIndex)),
					_Utils_eq(
						$elm$core$List$length(rubric.ki) - 1,
						rowIndex),
					rowIndex,
					aspect,
					subjects),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (cellIndex, value) {
							return A5(
								$author$project$Element$RubricsForm$viewScaleDescriptionCell,
								_Utils_eq(
									editState,
									A3($author$project$Element$RubricsForm$ScaleCell, aspect, rowIndex, cellIndex)),
								value,
								aspect,
								rowIndex,
								cellIndex);
						}),
					A2(
						$elm$core$List$take,
						$elm$core$List$length(rubric.fG.fG),
						aspect.lV))));
	});
var $author$project$Element$RubricsForm$SetScale = function (a) {
	return {$: 5, a: a};
};
var $author$project$Rubric$growthMindset = {
	lO: 'Erőfeszítés',
	fG: _List_fromArray(
		['Nagyon sok erőfeszítést tettél', 'Sokat tettél érte', 'Valamit tettél érte', 'Nem sokat tettél érte'])
};
var $author$project$Rubric$sikerult = {
	lO: 'Sikerült - még nem',
	fG: _List_fromArray(
		['Sikerült', 'Sikerült és még...', 'Már haladsz', 'Még nem'])
};
var $author$project$Rubric$skill = {
	lO: 'Standard',
	fG: _List_fromArray(
		['Mester', 'Haladó', 'Középhaladó', 'Újonc'])
};
var $author$project$Rubric$yesAndNotYetBut = {
	lO: 'Hogy ment?',
	fG: _List_fromArray(
		['Jól ment', 'Már megy, és még...', 'Még nem megy, de már...', 'Még nem megy'])
};
var $author$project$Rubric$allAvailableLevelStructure = _List_fromArray(
	[$author$project$Rubric$standard, $author$project$Rubric$sikerult, $author$project$Rubric$yesAndNotYetBut, $author$project$Rubric$skill, $author$project$Rubric$growthMindset]);
var $author$project$Element$RubricsForm$viewAspectSelector = function (activeLevels) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$classList(
				_List_fromArray(
					[
						_Utils_Tuple2('dropdown', true),
						_Utils_Tuple2('is-active', true)
					]))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('dropdown-menu'),
						$elm$html$Html$Attributes$id('dropdown-menu'),
						A2($elm$html$Html$Attributes$attribute, 'role', 'menu')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('dropdown-content')
							]),
						A2(
							$elm$core$List$map,
							function (levels) {
								return A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('dropdown-item', true),
													_Utils_Tuple2(
													'is-active',
													_Utils_eq(levels, activeLevels))
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetScale(levels)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(levels.lO)
										]));
							},
							$author$project$Rubric$allAvailableLevelStructure))
					]))
			]));
};
var $author$project$Element$RubricsForm$RubricTitleInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$RubricsForm$StartEditTitle = {$: 2};
var $author$project$Element$RubricsForm$viewRubricTitle = F3(
	function (_v0, rubric, editState) {
		if (editState.$ === 4) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field has-addons')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$input,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('input'),
										$elm$html$Html$Attributes$value(rubric.jJ),
										$elm$html$Html$Events$onInput(
										A2($elm$core$Basics$composeL, $author$project$Element$RubricsForm$EditMsg, $author$project$Element$RubricsForm$RubricTitleInput)),
										$author$project$Util$Html$onEnter(
										$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$p,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('control')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('button'),
										$elm$html$Html$Events$onClick(
										$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Submit))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$check(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('is-small')
											]))
									]))
							]))
					]));
		} else {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h2,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('subtitle is-inline-block')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rubric.jJ)
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick(
								$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$StartEditTitle)),
								$elm$html$Html$Attributes$class('ml-2')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$edit(_List_Nil)
							]))
					]));
		}
	});
var $author$project$Element$RubricsForm$viewEditorForm = F5(
	function (t_, rubric, editState, subjects, hasChanged) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$notification(
					$author$project$UI$textToHtml(
						t_($author$project$Locale$Messages$RubricsHelpEdit))),
					A3($author$project$Element$RubricsForm$viewRubricTitle, t_, rubric, editState),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$table,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('table is-striped is-bordered')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$thead,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('has-background-info-light')
										]),
									A2(
										$elm$core$List$cons,
										A2(
											$elm$html$Html$th,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_Nil,
													_List_fromArray(
														[
															A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricAspect),
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	$elm$html$Html$Attributes$class('ml-2'),
																	$elm$html$Html$Events$onClick(
																	$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$OpenAspectSelector))
																]),
															_List_fromArray(
																[
																	$author$project$UI$Icon$edit(_List_Nil)
																]))
														])),
													A2(
													$author$project$UI$when,
													_Utils_eq(editState, $author$project$Element$RubricsForm$LevelDimension),
													$author$project$Element$RubricsForm$viewAspectSelector(rubric.fG))
												])),
										A2(
											$elm$core$List$map,
											function (l) {
												return A2(
													$elm$html$Html$th,
													_List_Nil,
													_List_fromArray(
														[
															$elm$html$Html$text(l)
														]));
											},
											rubric.fG.fG))),
									A2(
									$elm$html$Html$tbody,
									_List_Nil,
									_Utils_ap(
										A2(
											$elm$core$List$indexedMap,
											A4($author$project$Element$RubricsForm$viewAspectRow, t_, rubric, editState, subjects),
											rubric.ki),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$tr,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$td,
														_List_fromArray(
															[
																$elm$html$Html$Events$onClick(
																$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$AddAspect))
															]),
														_List_fromArray(
															[
																$author$project$UI$Icon$add(_List_Nil)
															]))
													]))
											])))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('buttons has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('is-selected is-info is-light', !rubric.m0)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetSharing(0)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnPrivate)
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-rounded'),
											$elm$html$Html$Attributes$classList(
											_List_fromArray(
												[
													_Utils_Tuple2('is-selected is-info is-light', rubric.m0 === 1)
												])),
											$elm$html$Html$Events$onClick(
											$author$project$Element$RubricsForm$EditMsg(
												$author$project$Element$RubricsForm$SetSharing(1)))
										]),
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnSharedWithBps)
										]))
								])),
							A4(
							$author$project$UI$submitButton,
							t_($author$project$Locale$Messages$BtnSave),
							!hasChanged,
							_Utils_eq(editState, $author$project$Element$RubricsForm$Saving),
							$author$project$Element$RubricsForm$EditMsg($author$project$Element$RubricsForm$Save))
						]))
				]));
	});
var $author$project$Element$RubricsForm$viewEditorPane = F3(
	function (t_, pageState, subjects) {
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						function () {
						if (pageState.$ === 1) {
							var rubric = pageState.a;
							var editState = pageState.b;
							var hasChanged = pageState.c;
							return A5($author$project$Element$RubricsForm$viewEditorForm, t_, rubric, editState, subjects, hasChanged);
						} else {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('container')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$UI$progressBar,
										'is-primary',
										t_($author$project$Locale$Messages$RubricsLoadingProgress))
									]));
						}
					}()
					]),
				kJ: 'rubrics-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsHeadingEdit)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/8860843645944c8eaef60cb14a1f152e'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$RubricsHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				nk: _List_Nil,
				nq: 'is-light has-background-white'
			});
	});
var $author$project$Element$RubricsForm$PopupClosed = {$: 1};
var $author$project$Element$RubricsForm$withPopup = F2(
	function (isPopup, view_) {
		return isPopup ? A3(
			$author$project$UI$modalWindow,
			true,
			$author$project$Element$RubricsForm$PopupClosed,
			$author$project$UI$section(
				_List_fromArray(
					[view_]))) : view_;
	});
var $author$project$Element$RubricsForm$view = function (model) {
	var session = model.cv;
	return A2(
		$author$project$Element$RubricsForm$withPopup,
		model.lz,
		A3($author$project$Element$RubricsForm$viewEditorPane, session.hy, model.bF, model.jB));
};
var $author$project$Element$RubricsForm$element = {iA: $author$project$Element$RubricsForm$init, hh: $author$project$Element$RubricsForm$perform, jR: $author$project$Element$RubricsForm$update, nE: $author$project$Element$RubricsForm$view};
var $author$project$Element$RubricsList$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$FetchRubrics = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsList$FetchSubjects = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$FilterAll = 0;
var $author$project$Element$RubricsList$FilterCreator = 1;
var $author$project$Element$RubricsList$FilterSelected = 2;
var $author$project$Element$RubricsList$RubricsListDownloaded = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsList$SubjectListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsList$listFilterToCategory = function (filter) {
	switch (filter) {
		case 0:
			return $author$project$Api$Endpoint$categoryAll;
		case 1:
			return $author$project$Api$Endpoint$categoryCreator;
		default:
			return $author$project$Api$Endpoint$categoryAll;
	}
};
var $author$project$Element$RubricsList$asListParams = function (_v0) {
	var filter = _v0.bO;
	var query = _v0.bw;
	var params = $author$project$Rubric$defaultListParams;
	return _Utils_update(
		params,
		{
			bs: $author$project$Element$RubricsList$listFilterToCategory(filter),
			bw: query
		});
};
var $author$project$ACL$canCreateRubric = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$RubricsList$init = F3(
	function (config, session, viewMode) {
		var viewer = session.nH;
		var model = {
			bN: config,
			bO: function () {
				if ((viewMode.$ === 1) && viewMode.a.b) {
					var _v1 = viewMode.a;
					return 2;
				} else {
					return $author$project$ACL$canCreateRubric(viewer) ? 1 : 0;
				}
			}(),
			bw: '',
			eW: $elm$core$Maybe$Nothing,
			cv: session,
			cw: $elm$core$Dict$empty,
			jB: $author$project$RemoteData$NotAsked,
			nG: viewMode
		};
		return _Utils_Tuple3(
			model,
			$author$project$Element$RubricsList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3(
								$author$project$Rubric$fetchRubricsV2,
								config.gr,
								$author$project$Element$RubricsList$asListParams(model),
								$author$project$Element$RubricsList$RubricsListDownloaded))),
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchSubjects(
							A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$RubricsList$SubjectListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsList$SingleElementEffect = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$RubricsList$SingleElementMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$RubricsSingle$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$FetchRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$NoEffect = {$: 0};
var $author$project$Element$RubricsSingle$RubricDetailDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$RubricsSingle$init = F3(
	function (config, session, viewMode) {
		var subjects = function () {
			switch (viewMode.$) {
				case 0:
					return $author$project$RemoteData$NotAsked;
				case 1:
					var subjects_ = viewMode.b;
					return $author$project$RemoteData$Success(subjects_);
				default:
					var subjects_ = viewMode.b;
					return $author$project$RemoteData$Success(subjects_);
			}
		}();
		var model = {bN: config, mS: $author$project$RemoteData$NotAsked, cv: session, jB: subjects, nG: viewMode};
		switch (viewMode.$) {
			case 0:
				var rubricId = viewMode.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{mS: $author$project$RemoteData$Loading}),
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$FetchRubric(
							A3($author$project$Rubric$fetchRubric, config.gr, rubricId, $author$project$Element$RubricsSingle$RubricDetailDownloaded))),
					$elm$core$Maybe$Nothing);
			case 1:
				var rubric_ = viewMode.a;
				var subjects_ = viewMode.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mS: $author$project$RemoteData$Success(rubric_),
							jB: $author$project$RemoteData$Success(subjects_)
						}),
					$author$project$Element$RubricsSingle$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				var rubric_ = viewMode.a;
				var subjects_ = viewMode.b;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{
							mS: $author$project$RemoteData$Success(rubric_),
							jB: $author$project$RemoteData$Success(subjects_)
						}),
					$author$project$Element$RubricsSingle$NoEffect,
					$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricsSingle$perform = F2(
	function (key, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 1:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				case 2:
					var request = cmd.a;
					return $author$project$Api$deleteV2(request);
				case 4:
					var route = cmd.a;
					return A2(
						$elm$browser$Browser$Navigation$pushUrl,
						key,
						$author$project$Route$toString(route));
				case 3:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$RubricsSingle$CopyRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$DeleteRubric = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsSingle$DeletedRubric = {$: 2};
var $author$project$Element$RubricsSingle$DeselectRubric = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$FetchSubjectList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricsSingle$LogError = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsSingle$NavRedirect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricsSingle$NoOp = {$: 8};
var $author$project$Element$RubricsSingle$RubricCopied = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricsSingle$RubricDeleted = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$RubricsDeleteError = {$: 438};
var $author$project$Locale$Messages$RubricsDeleteSuccess = {$: 437};
var $author$project$Element$RubricsSingle$SelectRubric = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$SelectableListItem = F4(
	function (a, b, c, d) {
		return {$: 2, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$RubricsSingle$SubjectListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Rubric$deleteRubric = F3(
	function (config, id, callback) {
		return {
			O: $elm$http$Http$emptyBody,
			bN: config,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$rubric, config, id)
		};
	});
var $author$project$Element$RubricsSingle$highlight = function (viewMode) {
	switch (viewMode.$) {
		case 0:
			return '';
		case 1:
			var highlight_ = viewMode.c;
			return highlight_;
		default:
			var highlight_ = viewMode.c;
			return highlight_;
	}
};
var $author$project$Log$msgRubricDelete = 'rubric_delete';
var $author$project$Element$RubricsSingle$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var combineMaybe = F2(
			function (left, right) {
				return A3(
					$elm$core$Maybe$map2,
					function (x) {
						return function (y) {
							return _Utils_Tuple2(x, y);
						};
					},
					left,
					right);
			});
		switch (msg.$) {
			case 0:
				var rubric = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$DeleteRubric(
							A3($author$project$Rubric$deleteRubric, config.gr, rubric.gT, $author$project$Element$RubricsSingle$RubricDeleted))),
					$elm$core$Maybe$Nothing);
			case 1:
				var rubric = msg.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsSingle$Cmd(
						$author$project$Element$RubricsSingle$CopyRubric(
							A3($author$project$Rubric$createRubric, config, rubric, $author$project$Element$RubricsSingle$RubricCopied))),
					$elm$core$Maybe$Nothing);
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (_v1) {
							var rubric = _v1.a;
							var subjects = _v1.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										nG: A4(
											$author$project$Element$RubricsSingle$SelectableListItem,
											rubric,
											subjects,
											$author$project$Element$RubricsSingle$highlight(model.nG),
											true)
									}),
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just(
									$author$project$Element$RubricsSingle$SelectRubric(rubric)));
						},
						A2(
							combineMaybe,
							$author$project$RemoteData$toMaybe(model.mS),
							$author$project$RemoteData$toMaybe(model.jB))));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (_v2) {
							var rubric = _v2.a;
							var subjects = _v2.b;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										nG: A4(
											$author$project$Element$RubricsSingle$SelectableListItem,
											rubric,
											subjects,
											$author$project$Element$RubricsSingle$highlight(model.nG),
											false)
									}),
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just(
									$author$project$Element$RubricsSingle$DeselectRubric(rubric)));
						},
						A2(
							combineMaybe,
							$author$project$RemoteData$toMaybe(model.mS),
							$author$project$RemoteData$toMaybe(model.jB))));
			case 4:
				if (!msg.a.$) {
					var model2 = _Utils_update(
						model,
						{
							cv: A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$RubricsDeleteSuccess))
						});
					var _v3 = model.nG;
					switch (_v3.$) {
						case 0:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$Cmd(
									$author$project$Element$RubricsSingle$NavRedirect($author$project$Route$RubricsList)),
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just($author$project$Element$RubricsSingle$DeletedRubric));
						default:
							return _Utils_Tuple3(
								model2,
								$author$project$Element$RubricsSingle$NoEffect,
								$elm$core$Maybe$Just($author$project$Element$RubricsSingle$DeletedRubric));
					}
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$RubricsDeleteError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricDelete, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 5:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$NavRedirect(
								$author$project$Route$RubricsUpdate(rubric.gT))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$RubricsCreateError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricCreate, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 6:
				if (!msg.a.$) {
					var rubric = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mS: $author$project$RemoteData$Success(rubric)
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$FetchSubjectList(
								A3($author$project$Subject$fetchSubjectsV2, config.gr, '', $author$project$Element$RubricsSingle$SubjectListDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								mS: $author$project$RemoteData$Failure(error),
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsSingle$Cmd(
							$author$project$Element$RubricsSingle$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 7:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jB: $author$project$RemoteData$Success(subjects)
								}),
							$author$project$Element$RubricsSingle$NoEffect,
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$SubjectListDownloadError)),
									jB: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$RubricsSingle$Cmd(
								$author$project$Element$RubricsSingle$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsSingle$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						return _Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$RubricsSingle$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$SubjectListLoadingProgress = {$: 595};
var $author$project$Locale$Messages$BtnDeselect = {$: 41};
var $author$project$Locale$Messages$BtnSelect = {$: 40};
var $author$project$Element$RubricsSingle$RubricCopyRequested = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsSingle$RubricDeselected = {$: 3};
var $author$project$Element$RubricsSingle$RubricRemovalRequested = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsSingle$RubricSelected = {$: 2};
var $author$project$Locale$Messages$RubricsBtnRemix = {$: 442};
var $author$project$ACL$canManageRubric = F2(
	function (rubric, person) {
		return A2($author$project$Person$isSamePerson, rubric.kn, person);
	});
var $author$project$UI$Icon$toggleCheck = function (attributes) {
	return $author$project$UI$Icon$icon(
		A2(
			$elm$core$List$cons,
			$author$project$UI$Icon$face('fa-check-circle'),
			attributes));
};
var $author$project$Element$RubricsSingle$viewRubricItem = F5(
	function (t_, viewer, rubric, subjects, viewMode) {
		var selectLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricSelected,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-select'),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$BtnSelect))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$toggleCheck(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-lg'),
							$author$project$UI$Icon$style('has-text-grey-lighter')
						]))
				]));
		var highlight_ = $author$project$Element$RubricsSingle$highlight(viewMode);
		var viewMeta = $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					A2(
					$author$project$UI$withHighlightedText,
					highlight_,
					A2($author$project$Person$fullName, t_, rubric.kn)),
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(rubric.lR)))
				]));
		var viewTitle = A2(
			$elm$html$Html$h1,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('title is-size-6 mb-2')
				]),
			_List_fromArray(
				[
					function () {
					switch (viewMode.$) {
						case 0:
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$RubricsView(rubric.gT))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(rubric.jJ)
									]));
						case 1:
							return A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$author$project$Route$href(
										$author$project$Route$RubricsView(rubric.gT))
									]),
								_List_fromArray(
									[
										A2($author$project$UI$withHighlightedText, highlight_, rubric.jJ)
									]));
						default:
							return A2($author$project$UI$withHighlightedText, highlight_, rubric.jJ);
					}
				}()
				]));
		var editLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$RubricsUpdate(rubric.gT)),
					$author$project$UI$attrCyData('rubric-item-edit')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var deselectLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricDeselected,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-deselect'),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$BtnDeselect))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$toggleCheck(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-lg'),
							$author$project$UI$Icon$style('has-text-success')
						]))
				]));
		var viewRightAction = function () {
			if (viewMode.$ === 2) {
				if (viewMode.d) {
					return deselectLink;
				} else {
					return selectLink;
				}
			} else {
				return $author$project$UI$none;
			}
		}();
		var viewMediaObject = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(rubric.kn.K)
						]),
					_List_fromArray(
						[viewTitle, viewMeta]),
					_List_Nil,
					_List_fromArray(
						[viewRightAction]))
				]));
		var deleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricRemovalRequested(rubric),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-delete')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var copyLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$RubricsSingle$RubricCopyRequested(rubric),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubric-item-copy')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-copy'),
							$author$project$UI$Icon$style('has-text-info')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsBtnRemix)
				]));
		var viewNav = function () {
			switch (viewMode.$) {
				case 0:
					return A2(
						$author$project$UI$nav,
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								A2($author$project$ACL$canManageRubric, rubric, viewer),
								editLink),
								A2(
								$author$project$UI$when,
								$author$project$ACL$canCreateRubric(viewer),
								copyLink),
								A2(
								$author$project$UI$when,
								A2($author$project$ACL$canManageRubric, rubric, viewer),
								deleteLink)
							]),
						_List_Nil);
				case 1:
					return $author$project$UI$none;
				default:
					return $author$project$UI$none;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$author$project$UI$attrCyData('rubrics-item'),
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					viewMediaObject,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[
							A4($author$project$Element$RubricsSingle$viewRubricTable, t_, rubric, subjects, highlight_)
						])),
					viewNav
				]));
	});
var $author$project$Element$RubricsSingle$viewPage = F4(
	function (_v0, rubric, subjects, viewMode) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						A5($author$project$Element$RubricsSingle$viewRubricItem, t_, viewer, rubric, subjects, viewMode)
					]),
				kJ: 'rubrics-list',
				le: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsTitle)
					]),
				nk: _List_Nil,
				nq: 'is-primary'
			});
	});
var $author$project$Element$RubricsSingle$view = function (model) {
	var session = model.cv;
	var _v0 = _Utils_Tuple3(
		$author$project$RemoteData$toMaybe(model.mS),
		$author$project$RemoteData$toMaybe(model.jB),
		model.nG);
	if (!_v0.a.$) {
		if (!_v0.b.$) {
			switch (_v0.c.$) {
				case 0:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					return A4($author$project$Element$RubricsSingle$viewPage, session, rubric, subjects, model.nG);
				case 1:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					var _v1 = _v0.c;
					return A5($author$project$Element$RubricsSingle$viewRubricItem, session.hy, session.nH, rubric, subjects, model.nG);
				default:
					var rubric = _v0.a.a;
					var subjects = _v0.b.a;
					var _v2 = _v0.c;
					return A5($author$project$Element$RubricsSingle$viewRubricItem, session.hy, session.nH, rubric, subjects, model.nG);
			}
		} else {
			var _v4 = _v0.b;
			return A2(
				$author$project$UI$progressBar,
				'is-primary',
				session.hy($author$project$Locale$Messages$SubjectListLoadingProgress));
		}
	} else {
		var _v3 = _v0.a;
		return A2(
			$author$project$UI$progressBar,
			'is-primary',
			session.hy($author$project$Locale$Messages$RubricsLoadingProgress));
	}
};
var $author$project$Element$RubricsSingle$element = {iA: $author$project$Element$RubricsSingle$init, hh: $author$project$Element$RubricsSingle$perform, jR: $author$project$Element$RubricsSingle$update, nE: $author$project$Element$RubricsSingle$view};
var $author$project$Element$RubricsList$singleElement = function (rubricId) {
	return {
		gF: $author$project$Element$RubricsSingle$element,
		jK: $author$project$Element$RubricsList$SingleElementEffect(rubricId),
		bZ: $author$project$Element$RubricsList$SingleElementMsg(rubricId),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						cw: A3(
							$elm$core$Dict$update,
							rubricId,
							$elm$core$Basics$always(
								$elm$core$Maybe$Just(model)),
							containerModel.cw)
					});
			})
	};
};
var $author$project$Element$RubricsList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$RubricsList$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var seconds = cmd.a;
						var toMsg = cmd.b;
						return A2($author$project$Util$Delay$after, seconds, toMsg);
				}
			default:
				var rubricId = effect.a;
				var elementEffect = effect.b;
				return A3(
					$author$project$Application$V3$Boundaries$performElement,
					key,
					elementEffect,
					$author$project$Element$RubricsList$singleElement(rubricId));
		}
	});
var $author$project$Element$RubricsList$CreateRubric = {$: 2};
var $author$project$Element$RubricsList$Delay = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Element$RubricsList$DelayedGotListQuery = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$Exit = {$: 0};
var $author$project$Element$RubricsList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricsList$NoEffect = {$: 0};
var $author$project$Element$RubricsList$NoOp = {$: 9};
var $author$project$Element$RubricsList$SelectedRubrics = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$Selector = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$emptyResults = function (model) {
	return _Utils_update(
		model,
		{eW: $elm$core$Maybe$Nothing});
};
var $author$project$Element$RubricsList$filterRubrics = F2(
	function (model, newFilter) {
		var newModel = $author$project$Element$RubricsList$emptyResults(
			_Utils_update(
				model,
				{bO: newFilter}));
		return _Utils_Tuple3(
			newModel,
			$author$project$Element$RubricsList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3(
								$author$project$Rubric$fetchRubricsV2,
								model.bN.gr,
								$author$project$Element$RubricsList$asListParams(newModel),
								$author$project$Element$RubricsList$RubricsListDownloaded))),
						$author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchSubjects(
							A3($author$project$Subject$fetchSubjectsV2, model.bN.gr, '', $author$project$Element$RubricsList$SubjectListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$RubricsSingle$ListItem = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Element$RubricsList$batchEffect = F2(
	function (newEffect, effect) {
		switch (effect.$) {
			case 0:
				return newEffect;
			case 1:
				var effects = effect.a;
				return $author$project$Element$RubricsList$BatchEffect(
					A2($elm$core$List$cons, newEffect, effects));
			case 2:
				return $author$project$Element$RubricsList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
			default:
				return $author$project$Element$RubricsList$BatchEffect(
					_List_fromArray(
						[newEffect, effect]));
		}
	});
var $author$project$Element$RubricsList$initRubricsSingles = F2(
	function (model, rubrics) {
		var subjects = A2($author$project$RemoteData$withDefault, _List_Nil, model.jB);
		var makeParams = function (rubric) {
			var _v4 = model.nG;
			if (!_v4.$) {
				return A3($author$project$Element$RubricsSingle$ListItem, rubric, subjects, model.bw);
			} else {
				var selected = _v4.a;
				return A4(
					$author$project$Element$RubricsSingle$SelectableListItem,
					rubric,
					subjects,
					model.bw,
					A2($elm$core$List$member, rubric, selected));
			}
		};
		var initRubricSingle = F2(
			function (rubric, _v3) {
				var model_ = _v3.a;
				var effect_ = _v3.b;
				var single = $author$project$Element$RubricsList$singleElement(rubric.gT);
				var params = makeParams(rubric);
				var _v2 = A3(
					$author$project$Application$V3$Boundaries$mapElement,
					model_,
					single,
					A4($author$project$Application$V3$Boundaries$initElement, model_.bN, model_.cv, single, params));
				var model2 = _v2.a;
				var effect2 = _v2.b;
				return _Utils_Tuple3(
					model2,
					A2($author$project$Element$RubricsList$batchEffect, effect2, effect_),
					$elm$core$Maybe$Nothing);
			});
		var filterRubricsForSelected = function (selected) {
			return A2(
				$elm$core$List$filter,
				function (r) {
					return A2($elm$core$List$member, r, selected);
				},
				rubrics);
		};
		var addSelectedRubrics = F2(
			function (selected, rubrics_) {
				return $author$project$Util$List$unique(
					_Utils_ap(rubrics_, selected));
			});
		var allRubricsToShow = function () {
			var _v0 = _Utils_Tuple2(model.bO, model.nG);
			if (_v0.b.$ === 1) {
				if (_v0.a === 2) {
					var _v1 = _v0.a;
					var selected = _v0.b.a;
					return A2(
						addSelectedRubrics,
						selected,
						filterRubricsForSelected(selected));
				} else {
					var selected = _v0.b.a;
					return A2(addSelectedRubrics, selected, rubrics);
				}
			} else {
				return rubrics;
			}
		}();
		var startModel = _Utils_update(
			model,
			{
				eW: $elm$core$Maybe$Just(allRubricsToShow)
			});
		return A3(
			$elm$core$List$foldl,
			initRubricSingle,
			_Utils_Tuple3(startModel, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing),
			allRubricsToShow);
	});
var $author$project$Element$RubricsList$listQueryDelaySeconds = 0.5;
var $author$project$Element$RubricsList$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		switch (msg.$) {
			case 0:
				var filter = msg.a;
				return A2($author$project$Element$RubricsList$filterRubrics, model, filter);
			case 1:
				var query = msg.a;
				var newModel = $author$project$Element$RubricsList$emptyResults(
					_Utils_update(
						model,
						{bw: query}));
				return _Utils_Tuple3(
					newModel,
					$author$project$Element$RubricsList$Cmd(
						A2(
							$author$project$Element$RubricsList$Delay,
							$author$project$Element$RubricsList$listQueryDelaySeconds,
							$author$project$Element$RubricsList$DelayedGotListQuery(query))),
					$elm$core$Maybe$Nothing);
			case 2:
				var newQuery = msg.a;
				var listParams = $author$project$Element$RubricsList$asListParams(model);
				return _Utils_Tuple3(
					model,
					_Utils_eq(newQuery, model.bw) ? $author$project$Element$RubricsList$Cmd(
						$author$project$Element$RubricsList$FetchRubrics(
							A3($author$project$Rubric$fetchRubricsV2, config.gr, listParams, $author$project$Element$RubricsList$RubricsListDownloaded))) : $author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Nothing);
			case 5:
				var rubricId = msg.a;
				var singleMsg = msg.b;
				var updateSingleElement = F2(
					function (singleModel_, single) {
						var _v1 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							single,
							A4($author$project$Application$V3$Boundaries$updateElement, session, singleMsg, singleModel_, single));
						var model2 = _v1.a;
						var effect = _v1.b;
						var reply = _v1.c;
						var noop = _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
						var _v2 = _Utils_Tuple2(reply, model2.nG);
						if (!_v2.a.$) {
							switch (_v2.a.a.$) {
								case 2:
									if (!_v2.b.$) {
										var _v3 = _v2.a.a;
										var _v4 = _v2.b;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													cw: A2($elm$core$Dict$remove, rubricId, model.cw)
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										var _v5 = _v2.a.a;
										return noop;
									}
								case 0:
									if (_v2.b.$ === 1) {
										var rubric = _v2.a.a.a;
										var selected = _v2.b.a;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													nG: $author$project$Element$RubricsList$Selector(
														A2($elm$core$List$cons, rubric, selected))
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										return noop;
									}
								default:
									if (_v2.b.$ === 1) {
										var rubric = _v2.a.a.a;
										var selected = _v2.b.a;
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{
													nG: $author$project$Element$RubricsList$Selector(
														A2($author$project$Util$List$removeElem, rubric, selected))
												}),
											effect,
											$elm$core$Maybe$Nothing);
									} else {
										return noop;
									}
							}
						} else {
							var _v6 = _v2.a;
							return noop;
						}
					});
				var singleModel = A2($elm$core$Dict$get, rubricId, model.cw);
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing),
					A2(
						$elm$core$Maybe$map,
						function (singleModel_) {
							return A2(
								updateSingleElement,
								singleModel_,
								$author$project$Element$RubricsList$singleElement(rubricId));
						},
						singleModel));
			case 6:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricsList$Exit));
			case 7:
				var _v7 = model.nG;
				if (_v7.$ === 1) {
					var rubrics = _v7.a;
					return _Utils_Tuple3(
						model,
						$author$project$Element$RubricsList$NoEffect,
						$elm$core$Maybe$Just(
							$author$project$Element$RubricsList$SelectedRubrics(rubrics)));
				} else {
					return _Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing);
				}
			case 8:
				return _Utils_Tuple3(
					model,
					$author$project$Element$RubricsList$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$RubricsList$CreateRubric));
			case 3:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return A2($author$project$Element$RubricsList$initRubricsSingles, model, rubrics);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$RubricsList$Cmd(
							$author$project$Element$RubricsList$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgRubricsDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$RubricsList$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			case 4:
				switch (msg.a.$) {
					case 2:
						var subjects = msg.a.a;
						var listParams = $author$project$Element$RubricsList$asListParams(model);
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									jB: $author$project$RemoteData$Success(subjects)
								}),
							$author$project$Element$RubricsList$Cmd(
								$author$project$Element$RubricsList$FetchRubrics(
									A3($author$project$Rubric$fetchRubricsV2, model.bN.gr, listParams, $author$project$Element$RubricsList$RubricsListDownloaded))),
							$elm$core$Maybe$Nothing);
					case 3:
						var error = msg.a.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$SubjectListDownloadError)),
									jB: $author$project$RemoteData$Failure(error)
								}),
							$author$project$Element$RubricsList$Cmd(
								$author$project$Element$RubricsList$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgSubjectListDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$RubricsList$NoOp)))),
							$elm$core$Maybe$Nothing);
					default:
						var subjects = msg.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jB: subjects}),
							$author$project$Element$RubricsList$NoEffect,
							$elm$core$Maybe$Nothing);
				}
			default:
				return _Utils_Tuple3(model, $author$project$Element$RubricsList$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$RubricsList$FilterSet = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricsList$GotListQuery = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricsList$OpenCreatePopup = {$: 8};
var $author$project$Locale$Messages$RubricSelectorTitle = {$: 455};
var $author$project$Locale$Messages$RubricsEmptyResults = {$: 445};
var $author$project$Locale$Messages$RubricsFilterAllShared = {$: 447};
var $author$project$Locale$Messages$RubricsFilterOwnRubrics = {$: 446};
var $author$project$Locale$Messages$RubricsFilterSelected = {$: 448};
var $author$project$Locale$Messages$RubricsSearch = {$: 453};
var $author$project$Element$RubricsList$automaticallyGeneratedRubricTitle = 'Visszajelzésből automatikusan generálva';
var $author$project$Element$RubricsList$viewSingleElement = F3(
	function (session, rubric, singleModel) {
		return A3(
			$author$project$Application$V3$Boundaries$viewElement,
			session,
			singleModel,
			$author$project$Element$RubricsList$singleElement(rubric.gT));
	});
var $author$project$Element$RubricsList$viewRubricsList = function (_v0) {
	var filter = _v0.bO;
	var query = _v0.bw;
	var rubrics = _v0.eW;
	var singleElements = _v0.cw;
	var session = _v0.cv;
	var viewMode = _v0.nG;
	var viewer = session.nH;
	var viewKeyedItem = function (rubric) {
		return _Utils_Tuple2(
			$elm$core$String$fromInt(rubric.gT),
			A2(
				$author$project$UI$maybe,
				A2($elm$core$Dict$get, rubric.gT, singleElements),
				A2($author$project$Element$RubricsList$viewSingleElement, session, rubric)));
	};
	var t_ = session.hy;
	var viewCreateLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$author$project$Route$href($author$project$Route$RubricsCreate),
				$author$project$UI$attrCyData('rubrics-create'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewCreatePopupLink = A3(
		$author$project$UI$actionLink,
		$author$project$Element$RubricsList$OpenCreatePopup,
		_List_fromArray(
			[
				$author$project$UI$attrCyData('rubrics-create-popup'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$BtnCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$add(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewFilterLinks = A3(
		$author$project$UI$List$filterBar,
		t_,
		_Utils_Tuple2($author$project$Element$RubricsList$FilterSet, filter),
		_List_fromArray(
			[
				{
				kJ: 'selected',
				bO: 2,
				g_: true,
				g$: !_Utils_eq(viewMode, $author$project$Element$RubricsList$Page),
				lO: $author$project$Locale$Messages$RubricsFilterSelected
			},
				{
				kJ: 'mine',
				bO: 1,
				g_: true,
				g$: $author$project$ACL$canCreateRubric(viewer),
				lO: $author$project$Locale$Messages$RubricsFilterOwnRubrics
			},
				{
				kJ: 'all',
				bO: 0,
				g_: true,
				g$: $author$project$ACL$canViewRubrics(viewer),
				lO: $author$project$Locale$Messages$RubricsFilterAllShared
			}
			]));
	var viewHelpLink = A2(
		$elm$html$Html$a,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$href('https://www.loom.com/share/8860843645944c8eaef60cb14a1f152e'),
				$elm$html$Html$Attributes$target('_blank'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$RubricsHelpCreate))
			]),
		_List_fromArray(
			[
				$author$project$UI$Icon$help(
				_List_fromArray(
					[
						$author$project$UI$Icon$style('has-text-white')
					]))
			]));
	var viewHeading = function () {
		if (!viewMode.$) {
			return A2(
				$author$project$UI$levelHorizontal,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricsTitle)
					]),
				$author$project$ACL$canCreateRubric(viewer) ? _List_fromArray(
					[viewCreateLink, viewHelpLink]) : _List_Nil);
		} else {
			return A2(
				$author$project$UI$levelHorizontal,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSelectorTitle)
					]),
				$author$project$ACL$canCreateRubric(viewer) ? _List_fromArray(
					[viewCreatePopupLink, viewHelpLink]) : _List_Nil);
		}
	}();
	var viewLoadingState = function () {
		if (rubrics.$ === 1) {
			return _List_fromArray(
				[$author$project$UI$List$resultsLoadingProgressBar]);
		} else {
			if (!rubrics.a.b) {
				return _List_fromArray(
					[
						A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$RubricsEmptyResults)
					]);
			} else {
				return _List_Nil;
			}
		}
	}();
	var hideAutomaticallyGeneratedRubrics = function (rubrics_) {
		return A2(
			$elm$core$List$filter,
			function (r) {
				return !_Utils_eq(r.jJ, $author$project$Element$RubricsList$automaticallyGeneratedRubricTitle);
			},
			rubrics_);
	};
	return $author$project$UI$keyedPanel(
		{
			kt: A2(
				$elm$core$List$cons,
				$author$project$UI$List$searchBar(
					{
						aT: $author$project$Element$RubricsList$GotListQuery,
						bv: t_($author$project$Locale$Messages$RubricsSearch),
						bw: query
					}),
				viewLoadingState),
			kJ: 'rubric-list',
			le: _List_fromArray(
				[viewHeading]),
			lN: A2(
				$elm$core$List$map,
				viewKeyedItem,
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2($elm$core$Maybe$map, hideAutomaticallyGeneratedRubrics, rubrics))),
			nk: viewFilterLinks,
			nq: 'is-primary has-background-white'
		});
};
var $author$project$Element$RubricsList$view = $author$project$Element$RubricsList$viewRubricsList;
var $author$project$Element$RubricsList$element = {iA: $author$project$Element$RubricsList$init, hh: $author$project$Element$RubricsList$perform, jR: $author$project$Element$RubricsList$update, nE: $author$project$Element$RubricsList$view};
var $author$project$Element$ModulesMain$popups = {
	cU: {
		gF: $author$project$Element$LearningGroupSelector$element,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$LearningGroupSelectorMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$LearningGroupSelectorModel(model))
					});
			})
	},
	c8: {
		gF: $author$project$Element$RubricsForm$element,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$RubricsFormMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$RubricsFormModel(model))
					});
			})
	},
	da: {
		gF: $author$project$Element$RubricsList$element,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$ModulesMain$PopupMsg, $author$project$Element$ModulesMain$RubricsListMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(
							$author$project$Element$ModulesMain$RubricsListModel(model))
					});
			})
	}
};
var $author$project$Element$ModulesMain$openGroupSelectorPopup = F2(
	function (formPage, _return) {
		var session = _return.cv;
		var model = _return.dY;
		var cmd = _return.dz;
		var selectedTeamId = A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$identity,
			$elm$core$String$toInt(
				formPage.bt.bp.nD(formPage.ej)));
		if (!selectedTeamId.$) {
			var teamId = selectedTeamId.a;
			var params = {bp: teamId};
			var selectorPopup = A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A3(
					$author$project$Application$V2$Boundaries$mapElement,
					A2($author$project$Application$Boundaries$save, model, session),
					$author$project$Element$ModulesMain$popups.cU,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						model.bN.iJ,
						$author$project$Application$V2$SharedConfig$fromV1(model.bN),
						session,
						$author$project$Element$ModulesMain$popups.cU,
						params)));
			return {dz: selectorPopup.dz, dY: selectorPopup.dY, fY: $elm$core$Maybe$Nothing, cv: selectorPopup.cv};
		} else {
			return _return;
		}
	});
var $author$project$Element$ModulesMain$openRubricsListPopup = F2(
	function (formPage, _v0) {
		var session = _v0.cv;
		var model = _v0.dY;
		var cmd = _v0.dz;
		var params = $author$project$Element$RubricsList$Selector(formPage.ct);
		var openRubricsList = A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				$author$project$Element$ModulesMain$popups.da,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.bN.iJ,
					$author$project$Application$V2$SharedConfig$fromV1(model.bN),
					session,
					$author$project$Element$ModulesMain$popups.da,
					params)));
		return {dz: openRubricsList.dz, dY: openRubricsList.dY, fY: $elm$core$Maybe$Nothing, cv: openRubricsList.cv};
	});
var $author$project$Element$ModulesMain$processModuleDownloadError = F3(
	function (session, model, error) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Log$error,
				model.bN,
				_Utils_Tuple3(
					$author$project$Log$msgModuleDownload,
					$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
					error),
				$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
			A2(
				$author$project$Application$Boundaries$save,
				model,
				A3(
					$author$project$Session$error,
					session,
					error,
					session.hy($author$project$Locale$Messages$ModulesDownloadError))));
	});
var $author$project$Module$ModuleUnsaved = function (id) {
	return function (title) {
		return function (description) {
			return function (goalsKnowledge) {
				return function (goalsSkills) {
					return function (goalsProduct) {
						return function (evaluation) {
							return function (materialsUrl) {
								return function (startDate) {
									return function (endDate) {
										return function (isTemplate) {
											return function (team) {
												return function (classroomCourses) {
													return function (accountableTeacher) {
														return function (teachers) {
															return function (students) {
																return function (learningOutcomes) {
																	return function (rubrics) {
																		return function (migrationReadyAt) {
																			return {j3: accountableTeacher, S: classroomCourses, gD: description, gH: endDate, gI: evaluation, k9: goalsKnowledge, la: goalsProduct, lb: goalsSkills, gT: id, lC: isTemplate, g3: learningOutcomes, iR: materialsUrl, cZ: migrationReadyAt, eW: rubrics, hv: startDate, e1: students, e5: teachers, jF: team, jJ: title};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$ModulesMain$saveForm = F6(
	function (form, values, module_, selectedLos, selectedRubrics, time) {
		var fromBoolToDate = function (value) {
			return value ? $elm$core$Maybe$Just(
				$elm$time$Time$posixToMillis(time)) : $elm$core$Maybe$Nothing;
		};
		return $author$project$Module$ModuleUnsaved(
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					module_)))(
			form.jJ.nD(values))(
			form.gD.nD(values))(
			form.k9.nD(values))(
			form.lb.nD(values))(
			form.la.nD(values))(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gI;
					},
					module_)))(
			form.iR.nD(values))(
			$author$project$Form$dateToMillis(
				form.hv.nD(values)))(
			$author$project$Form$dateToMillis(
				form.gH.nD(values)))(
			A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.lC;
					},
					module_)))(
			$author$project$Team$decodeTeamId(
				form.bp.nD(values)))(
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.S.nD(values)))(
			$author$project$Person$decodePersonId(
				form.j3.nD(values)))(
			A2(
				$elm$core$List$map,
				$author$project$Person$decodePersonId,
				form.e5.nD(values)))(
			A2(
				$elm$core$List$map,
				$author$project$Person$decodePersonId,
				form.e1.nD(values)))(selectedLos)(selectedRubrics)(
			fromBoolToDate(
				form.aS.nD(values)));
	});
var $author$project$Element$ModulesMain$toClassroomOptions = function (classrooms) {
	return $author$project$Form$toSortedSelectOptions(
		A2(
			$elm$core$List$map,
			function (course) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(course.gT),
					course.jJ);
			},
			classrooms));
};
var $author$project$Element$ModulesMain$resetFormStudents = F2(
	function (session, _v0) {
		var form = _v0.a;
		var values = _v0.b;
		var studentsField = A2(
			$author$project$Form$setMultiselectSelection,
			A2($author$project$Form$toPeopleOptions, session.hy, _List_Nil),
			form.e1);
		return _Utils_Tuple2(
			_Utils_update(
				form,
				{e1: studentsField}),
			A2(form.e1.jR, _List_Nil, values));
	});
var $author$project$Element$ModulesMain$updateFormStudentsBySchool = F4(
	function (_v0, schools, students, _v1) {
		var t_ = _v0.hy;
		var form = _v1.a;
		var values = _v1.b;
		var _v2 = _Utils_Tuple2(schools, students);
		if ((_v2.a.$ === 2) && (_v2.b.$ === 2)) {
			var students_ = _v2.b.a;
			var selectedStudentIds = form.e1.nD(values);
			var schoolId = $author$project$Team$decodeTeamId(
				form.bp.nD(values));
			var schoolStudents = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? students_ : A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[schoolId]),
				students_);
			var schoolStudentIds = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$elm$core$String$fromInt),
				schoolStudents);
			var selectedStudentIds2 = $elm$core$List$isEmpty(selectedStudentIds) ? schoolStudentIds : A2(
				$elm$core$List$filter,
				function (studentId) {
					return A2($elm$core$List$member, studentId, schoolStudentIds);
				},
				selectedStudentIds);
			var selectedStudents = A2(
				$elm$core$List$filter,
				function (student) {
					return A2(
						$elm$core$List$member,
						$elm$core$String$fromInt(student.gT),
						schoolStudentIds);
				},
				students_);
			var studentsOptions = A2($author$project$Form$toPeopleOptions, t_, selectedStudents);
			var multiselectStudentsField = $author$project$Form$markEdited(
				A2($author$project$Form$setMultiselectOptions, studentsOptions, form.e1));
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{e1: multiselectStudentsField}),
				A2(form.e1.jR, selectedStudentIds2, values));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Person$teachesAt = F2(
	function (teamId, person) {
		return A3($author$project$Person$hasRoleAt, $author$project$Person$roleTeacher, teamId, person) || A3($author$project$Person$hasRoleAt, $author$project$Person$roleModuleTeacher, teamId, person);
	});
var $author$project$Person$teachersInTeams = F2(
	function (teamIds, people) {
		return A2(
			$elm$core$List$filter,
			function (person) {
				return A2(
					$elm$core$List$any,
					function (teamId) {
						return A2($author$project$Person$teachesAt, teamId, person);
					},
					teamIds);
			},
			people);
	});
var $author$project$Element$ModulesMain$toTeacherOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$author$project$Person$teachersInTeams,
				$author$project$Person$teamsAsTeacher(viewer),
				people));
	});
var $author$project$Element$ModulesMain$updateFormTeachersBySchool = F4(
	function (_v0, schools, teachers, _v1) {
		var viewer = _v0.nH;
		var t_ = _v0.hy;
		var form = _v1.a;
		var values = _v1.b;
		var _v2 = _Utils_Tuple2(schools, teachers);
		if ((_v2.a.$ === 2) && (_v2.b.$ === 2)) {
			var teachers_ = _v2.b.a;
			var selectedTeacherIds = form.e5.nD(values);
			var selectedAccountableTeacherId = form.j3.nD(values);
			var schoolId = $author$project$Team$decodeTeamId(
				form.bp.nD(values));
			var schoolTeachers = _Utils_eq(schoolId, $author$project$Team$blankTeamId) ? teachers_ : A2(
				$author$project$Person$teachersInTeams,
				_List_fromArray(
					[schoolId]),
				teachers_);
			var schoolTeacherIds = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$elm$core$String$fromInt),
				schoolTeachers);
			var selectedAccountableTeacherId2 = A2($elm$core$List$member, selectedAccountableTeacherId, schoolTeacherIds) ? selectedAccountableTeacherId : '';
			var selectedTeacherIds2 = A2(
				$elm$core$List$filter,
				function (teacherId) {
					return A2($elm$core$List$member, teacherId, schoolTeacherIds);
				},
				selectedTeacherIds);
			var teachersField = $author$project$Form$markEdited(
				A2(
					$author$project$Form$fillFieldOptions,
					A3($author$project$Element$ModulesMain$toTeacherOptions, t_, viewer, schoolTeachers),
					form.e5));
			var accountableTeacherField = $author$project$Form$markEdited(
				A2(
					$author$project$Form$fillFieldOptions,
					A3($author$project$Element$ModulesMain$toTeacherOptions, t_, viewer, schoolTeachers),
					form.j3));
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{j3: accountableTeacherField, e5: teachersField}),
				A2(
					form.j3.jR,
					selectedAccountableTeacherId2,
					A2(form.e5.jR, selectedTeacherIds2, values)));
		} else {
			return _Utils_Tuple2(form, values);
		}
	});
var $author$project$Element$ModulesMain$updateForm = F5(
	function (session, _v0, msg, form, formValues) {
		var schools = _v0.jr;
		var teachers = _v0.e5;
		var students = _v0.e1;
		switch (msg.$) {
			case 0:
				var title = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jJ: $author$project$Form$markEdited(form.jJ)
						}),
					A2(form.jJ.jR, title, formValues));
			case 1:
				var description = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							gD: $author$project$Form$markEdited(form.gD)
						}),
					A2(form.gD.jR, description, formValues));
			case 2:
				var url = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							iR: $author$project$Form$markEdited(form.iR)
						}),
					A2(form.iR.jR, url, formValues));
			case 3:
				var knowledge = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							k9: $author$project$Form$markEdited(form.k9)
						}),
					A2(form.k9.jR, knowledge, formValues));
			case 4:
				var skills = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							lb: $author$project$Form$markEdited(form.lb)
						}),
					A2(form.lb.jR, skills, formValues));
			case 5:
				var product = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							la: $author$project$Form$markEdited(form.la)
						}),
					A2(form.la.jR, product, formValues));
			case 6:
				var startDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							hv: $author$project$Form$markEdited(form.hv)
						}),
					A2(form.hv.jR, startDate, formValues));
			case 7:
				var endDate = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							gH: $author$project$Form$markEdited(form.gH)
						}),
					A2(form.gH.jR, endDate, formValues));
			case 8:
				var teacherId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							j3: $author$project$Form$markEdited(form.j3)
						}),
					A2(form.j3.jR, teacherId, formValues));
			case 9:
				var schoolId = msg.a;
				return A2(
					$author$project$Element$ModulesMain$resetFormStudents,
					session,
					A4(
						$author$project$Element$ModulesMain$updateFormStudentsBySchool,
						session,
						schools,
						students,
						A4(
							$author$project$Element$ModulesMain$updateFormTeachersBySchool,
							session,
							schools,
							teachers,
							_Utils_Tuple2(
								_Utils_update(
									form,
									{
										bp: $author$project$Form$markEdited(form.bp)
									}),
								A2(form.bp.jR, schoolId, formValues)))));
			case 10:
				var ids = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							S: $author$project$Form$markEdited(form.S)
						}),
					A2(form.S.jR, ids, formValues));
			case 11:
				var teacherIds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							e5: $author$project$Form$markEdited(form.e5)
						}),
					A2(form.e5.jR, teacherIds, formValues));
			case 12:
				var fieldMsg = msg.a;
				var field = form.e1;
				var _v2 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
				var updatedField = _v2.a;
				var studentIds = $author$project$Form$getMultiselectFieldSelectedValues(updatedField);
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							e1: $author$project$Form$markEdited(updatedField)
						}),
					A2(form.e1.jR, studentIds, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aS: $author$project$Form$markEdited(form.aS)
						}),
					A2(form.aS.jR, value, formValues));
		}
	});
var $author$project$Element$ModulesMain$toViewerSchoolOptions = F2(
	function (viewer, schools) {
		return $author$project$Form$toTeamOptions(
			A2($author$project$Person$filterPersonTeams, schools, viewer));
	});
var $author$project$Element$ModulesMain$updateFormWithSchools = F4(
	function (data, formPage, session, model) {
		var action = formPage.hQ;
		var form = formPage.bt;
		var values = formPage.ej;
		var viewer = session.nH;
		var config = model.bN;
		var updatedModel = _Utils_update(
			model,
			{jr: data});
		switch (data.$) {
			case 2:
				var schools = data.a;
				var teamValue = function () {
					switch (action.$) {
						case 3:
							return form.bp.nD(values);
						case 2:
							return form.bp.nD(values);
						default:
							var _v3 = A2($author$project$Person$filterPersonTeams, schools, viewer);
							if (_v3.b && (!_v3.b.b)) {
								var school = _v3.a;
								return $elm$core$String$fromInt(
									$author$project$Team$teamIdToInt(school.gT));
							} else {
								return '';
							}
					}
				}();
				var values2 = _Utils_update(
					values,
					{bp: teamValue});
				var schoolOptions = A2($author$project$Element$ModulesMain$toViewerSchoolOptions, viewer, schools);
				var form2 = _Utils_update(
					form,
					{
						bp: A2($author$project$Form$fillFieldOptions, schoolOptions, form.bp)
					});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.jr,
					updatedModel.e1,
					A4(
						$author$project$Element$ModulesMain$updateFormTeachersBySchool,
						session,
						updatedModel.jr,
						updatedModel.e5,
						_Utils_Tuple2(form2, values2)));
				var form3 = _v1.a;
				var values3 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bm: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bt: form3, ej: values3}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgTeamsDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.hy($author$project$Locale$Messages$TeamListDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Element$ModulesMain$filterPersonsToSelectOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$Person$isTeacherOf(viewer),
				people));
	});
var $author$project$Element$ModulesMain$updateFormWithStudents = F4(
	function (data, formPage, session, model) {
		var form = formPage.bt;
		var values = formPage.ej;
		var viewer = session.nH;
		var t_ = session.hy;
		var config = model.bN;
		var updatedModel = _Utils_update(
			model,
			{e1: data});
		switch (data.$) {
			case 2:
				var students = data.a;
				var studentOptions = A3($author$project$Element$ModulesMain$filterPersonsToSelectOptions, t_, viewer, students);
				var studentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1);
				var form2 = _Utils_update(
					form,
					{e1: studentsField});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.jr,
					updatedModel.e1,
					_Utils_Tuple2(form2, values));
				var form3 = _v1.a;
				var values2 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bm: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bt: form3, ej: values2}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgPeopleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.hy($author$project$Locale$Messages$PhoneBookDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Element$ModulesMain$updateFormWithTeachers = F4(
	function (data, formPage, session, model) {
		var action = formPage.hQ;
		var form = formPage.bt;
		var values = formPage.ej;
		var viewer = session.nH;
		var config = model.bN;
		var updatedModel = _Utils_update(
			model,
			{e5: data});
		switch (data.$) {
			case 2:
				var teachers = data.a;
				var teacherOptions = A3($author$project$Element$ModulesMain$toTeacherOptions, session.hy, viewer, teachers);
				var form2 = _Utils_update(
					form,
					{
						j3: A2($author$project$Form$fillFieldOptions, teacherOptions, form.j3),
						e5: A2($author$project$Form$fillFieldOptions, teacherOptions, form.e5)
					});
				var defaultAccountableTeacherId = function () {
					if (!action.$) {
						return $elm$core$String$fromInt(viewer.gT);
					} else {
						return form.j3.nD(values);
					}
				}();
				var values2 = _Utils_update(
					values,
					{j3: defaultAccountableTeacherId});
				var _v1 = A4(
					$author$project$Element$ModulesMain$updateFormStudentsBySchool,
					session,
					updatedModel.jr,
					updatedModel.e1,
					A4(
						$author$project$Element$ModulesMain$updateFormTeachersBySchool,
						session,
						updatedModel.jr,
						updatedModel.e5,
						_Utils_Tuple2(form2, values2)));
				var form3 = _v1.a;
				var values3 = _v1.b;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						updatedModel,
						{
							bm: $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{bt: form3, ej: values3}))
						}),
					session);
			case 3:
				var error = data.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3(
						$author$project$Log$error,
						config,
						_Utils_Tuple3(
							$author$project$Log$msgPeopleDownload,
							$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
							error),
						$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
					A2(
						$author$project$Application$Boundaries$save,
						updatedModel,
						A3(
							$author$project$Session$error,
							session,
							error,
							session.hy($author$project$Locale$Messages$PhoneBookDownloadError))));
			case 0:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
			default:
				return A2($author$project$Application$Boundaries$save, updatedModel, session);
		}
	});
var $author$project$Module$updateModule = F3(
	function (config, module_, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$module_,
				config,
				$author$project$Module$moduleIdToInt(module_.gT)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$Module$moduleEncoder(module_)),
			callback,
			$author$project$Module$moduleDetailedDecoder);
	});
var $author$project$Element$ModulesMain$closePopup = function (_return) {
	return A2(
		$author$project$Application$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{c3: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Utils$mergeIntoSet = F2(
	function (targetList, sourceList) {
		var initialList = targetList;
		var newList = A3(
			$elm$core$List$foldl,
			F2(
				function (item, acc) {
					return A2($elm$core$List$member, item, acc) ? acc : A2($elm$core$List$cons, item, acc);
				}),
			initialList,
			sourceList);
		return newList;
	});
var $author$project$Element$ModulesMain$openRubricsFormPopup = F2(
	function (params, _v0) {
		var session = _v0.cv;
		var model = _v0.dY;
		var cmd = _v0.dz;
		var openRubricsForm = A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				$author$project$Element$ModulesMain$popups.c8,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.bN.iJ,
					$author$project$Application$V2$SharedConfig$fromV1(model.bN),
					session,
					$author$project$Element$ModulesMain$popups.c8,
					params)));
		return {dz: openRubricsForm.dz, dY: openRubricsForm.dY, fY: $elm$core$Maybe$Nothing, cv: openRubricsForm.cv};
	});
var $author$project$Element$ModulesMain$updatePopup = F4(
	function (popupMsg, page, session, model) {
		var config = model.bN;
		var _v0 = _Utils_Tuple3(popupMsg, model.c3, page);
		_v0$3:
		while (true) {
			if ((!_v0.b.$) && (_v0.c.$ === 3)) {
				switch (_v0.a.$) {
					case 1:
						if (_v0.b.a.$ === 1) {
							var rubricsFormMsg = _v0.a.a;
							var rubricsFormModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A3(
								$author$project$Application$V2$Boundaries$mapElement,
								A2($author$project$Application$Boundaries$save, model, session),
								$author$project$Element$ModulesMain$popups.c8,
								A5($author$project$Application$V2$Boundaries$updateElement, config.iJ, session, rubricsFormMsg, rubricsFormModel, $author$project$Element$ModulesMain$popups.c8));
							var _v1 = _return.fY;
							if (!_v1.$) {
								var _v2 = _v1.a;
								return A2($author$project$Element$ModulesMain$openRubricsListPopup, formPage, _return);
							} else {
								return {dz: _return.dz, dY: _return.dY, fY: $elm$core$Maybe$Nothing, cv: _return.cv};
							}
						} else {
							break _v0$3;
						}
					case 0:
						if (!_v0.b.a.$) {
							var rubricsListMsg = _v0.a.a;
							var rubricsListModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.bN.iJ, session, rubricsListMsg, rubricsListModel, $author$project$Element$ModulesMain$popups.da);
							var _v3 = _return.fY;
							if (!_v3.$) {
								var reply = _v3.a;
								switch (reply.$) {
									case 1:
										var rubrics = reply.a;
										var hasChanged = !_Utils_eq(rubrics, formPage.ct);
										var newFormState = hasChanged ? 1 : formPage.eZ;
										var page2 = $author$project$Element$ModulesMain$FormPage(
											_Utils_update(
												formPage,
												{ct: rubrics, eZ: newFormState}));
										return $author$project$Element$ModulesMain$closePopup(
											A2(
												$author$project$Application$Boundaries$save,
												_Utils_update(
													model,
													{bm: page2}),
												_return.cv));
									case 2:
										return A2(
											$author$project$Element$ModulesMain$openRubricsFormPopup,
											{lz: true, mS: $elm$core$Maybe$Nothing},
											A2($author$project$Application$Boundaries$save, model, _return.cv));
									default:
										return $author$project$Element$ModulesMain$closePopup(
											A2($author$project$Application$Boundaries$save, model, _return.cv));
								}
							} else {
								var rubricsListReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$ModulesMain$popups.da,
									_return);
								return {dz: rubricsListReturn.dz, dY: rubricsListReturn.dY, fY: $elm$core$Maybe$Nothing, cv: rubricsListReturn.cv};
							}
						} else {
							break _v0$3;
						}
					default:
						if (_v0.b.a.$ === 2) {
							var groupSelectorMsg = _v0.a.a;
							var groupSelectorModel = _v0.b.a.a;
							var formPage = _v0.c.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.bN.iJ, session, groupSelectorMsg, groupSelectorModel, $author$project$Element$ModulesMain$popups.cU);
							var _v5 = _return.fY;
							if (!_v5.$) {
								var reply = _v5.a;
								if (reply.$ === 1) {
									var students = reply.a;
									var values = formPage.ej;
									var newSelectedStudents = A2(
										$author$project$Utils$mergeIntoSet,
										A2(
											$elm$core$List$map,
											function (person) {
												return $elm$core$String$fromInt(person.gT);
											},
											students),
										formPage.bt.e1.nD(formPage.ej));
									var newSelectedStudentIDs = A2(
										$elm$core$List$map,
										function (id) {
											return $author$project$Person$decodePersonId(id);
										},
										newSelectedStudents);
									var newSelectedStudents_ = A2(
										$elm$core$List$filter,
										function (student) {
											return A2($elm$core$List$member, student.gT, newSelectedStudentIDs);
										},
										A2($author$project$RemoteData$withDefault, _List_Nil, model.e1));
									var form = formPage.bt;
									var schoolId = $author$project$Team$decodeTeamId(
										form.bp.nD(values));
									var optionalStudents = A2(
										$author$project$Person$studentsInTeams,
										_List_fromArray(
											[schoolId]),
										A2($author$project$RemoteData$withDefault, _List_Nil, model.e1));
									var studentOptions = A2($author$project$Form$toPeopleOptions, session.hy, optionalStudents);
									var multiselectModuleField = A2(
										$author$project$Form$setMultiselectSelection,
										A2($author$project$Form$toPeopleOptions, session.hy, newSelectedStudents_),
										A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1));
									var page2 = $author$project$Element$ModulesMain$FormPage(
										_Utils_update(
											formPage,
											{
												bt: _Utils_update(
													form,
													{e1: multiselectModuleField}),
												eZ: 1,
												ej: _Utils_update(
													values,
													{e1: newSelectedStudents})
											}));
									return $author$project$Element$ModulesMain$closePopup(
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page2}),
											_return.cv));
								} else {
									return $author$project$Element$ModulesMain$closePopup(
										A2($author$project$Application$Boundaries$save, model, _return.cv));
								}
							} else {
								var studentsReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$ModulesMain$popups.cU,
									_return);
								return {dz: studentsReturn.dz, dY: studentsReturn.dY, fY: $elm$core$Maybe$Nothing, cv: studentsReturn.cv};
							}
						} else {
							break _v0$3;
						}
				}
			} else {
				break _v0$3;
			}
		}
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$ModulesMain$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			j3: $author$project$Form$markEdited(form.j3),
			S: $author$project$Form$markEdited(form.S),
			gD: $author$project$Form$markEdited(form.gD),
			gH: $author$project$Form$markEdited(form.gH),
			k9: $author$project$Form$markEdited(form.k9),
			la: $author$project$Form$markEdited(form.la),
			lb: $author$project$Form$markEdited(form.lb),
			iR: $author$project$Form$markEdited(form.iR),
			bp: $author$project$Form$markEdited(form.bp),
			hv: $author$project$Form$markEdited(form.hv),
			e1: $author$project$Form$markEdited(form.e1),
			e5: $author$project$Form$markEdited(form.e5),
			jJ: $author$project$Form$markEdited(form.jJ)
		});
};
var $author$project$Element$ModulesMain$update = F3(
	function (session, msg, model) {
		var viewer = session.nH;
		var config = model.bN;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$45:
		while (true) {
			switch (_v0.a.$) {
				case 0:
					if (!_v0.a.a.$) {
						switch (_v0.b.$) {
							case 1:
								var modules = _v0.a.a.a;
								var _v1 = _v0.b;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$ListPage(
												A2(
													$author$project$Element$ModulesMain$addNewModules,
													modules,
													$author$project$Element$ModulesMain$emptyList(viewer)))
										}),
									session);
							case 2:
								var modules = _v0.a.a.a;
								var listPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$ListPage(
												A2($author$project$Element$ModulesMain$addNewModules, modules, listPage))
										}),
									session);
							default:
								break _v0$45;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModulesDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$ModulesDownloadError))));
					}
				case 1:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v2 = _v0.b;
							return A4(
								$author$project$Element$ModulesMain$buildFormPageFromModule,
								session,
								model,
								$author$project$Element$ModulesMain$Update(module_),
								module_);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 2:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v3 = _v0.b;
							var copy = _Utils_update(
								module_,
								{
									jJ: session.hy(
										$author$project$Locale$Messages$ModulesCopyTitle(module_.jJ))
								});
							return A4(
								$author$project$Element$ModulesMain$buildFormPageFromModule,
								session,
								model,
								$author$project$Element$ModulesMain$CreateFromDuplicate(module_),
								copy);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 3:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 1) {
							var module_ = _v0.a.a.a;
							var _v4 = _v0.b;
							return A4($author$project$Element$ModulesMain$buildFormPageFromModule, session, model, $author$project$Element$ModulesMain$CreateFromTemplate, module_);
						} else {
							break _v0$45;
						}
					} else {
						var error = _v0.a.a.a;
						return A3($author$project$Element$ModulesMain$processModuleDownloadError, session, model, error);
					}
				case 6:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var classrooms = _v0.a.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var page = $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{
										bt: _Utils_update(
											form,
											{
												S: A2(
													$author$project$Form$fillFieldOptions,
													$author$project$Element$ModulesMain$toClassroomOptions(classrooms),
													form.S)
											})
									}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{gx: classrooms, bm: page}),
								session);
						} else {
							var classrooms = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{gx: classrooms}),
								session);
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgClassroomsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$ClassroomCourseListDownloadError))));
					}
				case 5:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithSchools, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{jr: data}),
							session);
					}
				case 7:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithTeachers, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{e5: data}),
							session);
					}
				case 8:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formPage = _v0.b.a;
						return A4($author$project$Element$ModulesMain$updateFormWithStudents, data, formPage, session, model);
					} else {
						var data = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{e1: data}),
							session);
					}
				case 9:
					var data = _v0.a.a;
					var page = _v0.b;
					var updatedModel = _Utils_update(
						model,
						{jB: data});
					var _v5 = _Utils_Tuple2(data, page);
					if (_v5.a.$ === 3) {
						var error = _v5.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSubjectListDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								updatedModel,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$SubjectListDownloadError))));
					} else {
						return A2($author$project$Application$Boundaries$save, updatedModel, session);
					}
				case 4:
					if (_v0.b.$ === 3) {
						var data = _v0.a.a;
						var formpage = _v0.b.a;
						switch (data.$) {
							case 2:
								var events = data.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formpage,
													{
														cO: !$elm$core$List$isEmpty(events)
													}))
										}),
									session);
							case 3:
								var error = data.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgModuleEventsDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
											error),
										$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$ModuleEventsDownloadError))));
							default:
								return noop;
						}
					} else {
						break _v0$45;
					}
				case 16:
					if (_v0.b.$ === 2) {
						var _v7 = _v0.a;
						var listPage = _v0.b.a;
						var listParams = $author$project$Element$ModulesMain$asListParams(listPage);
						var _v8 = listPage.cY;
						if (_v8.$ === 1) {
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3($author$project$Module$fetchModules_, config.gr, listParams, $author$project$Element$ModulesMain$ModuleListDownloaded),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$ListPage(
												_Utils_update(
													listPage,
													{cY: $author$project$Element$ModulesMain$LoadingModules}))
										}),
									session));
						} else {
							return noop;
						}
					} else {
						break _v0$45;
					}
				case 22:
					if (_v0.b.$ === 2) {
						var _v9 = _v0.a;
						var listPage = _v0.b.a;
						var filtersExpanded = listPage.eA;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bm: $author$project$Element$ModulesMain$ListPage(
										_Utils_update(
											listPage,
											{eA: !filtersExpanded}))
								}),
							session);
					} else {
						break _v0$45;
					}
				case 23:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.bO;
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{iu: values}));
					} else {
						break _v0$45;
					}
				case 24:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.bO;
						var teacherIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{e5: teacherIds}));
					} else {
						break _v0$45;
					}
				case 25:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.bO;
						var schoolIds = A2(
							$elm$core$List$filterMap,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$String$toInt,
								$elm$core$Maybe$map($elm$core$Basics$identity)),
							values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{jr: schoolIds}));
					} else {
						break _v0$45;
					}
				case 26:
					if (_v0.b.$ === 2) {
						var values = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.bO;
						var subjectIds = A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
						return A4(
							$author$project$Element$ModulesMain$filterModules,
							session,
							model,
							listPage,
							_Utils_update(
								filter,
								{jB: subjectIds}));
					} else {
						break _v0$45;
					}
				case 27:
					if (_v0.b.$ === 2) {
						var category = _v0.a.a;
						var listPage = _v0.b.a;
						var filter = listPage.bO;
						var newFilter = _Utils_update(
							filter,
							{bs: category});
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A2($author$project$Subject$fetchSubjects, config.gr, $author$project$Element$ModulesMain$SubjectListDownloaded),
							A4($author$project$Element$ModulesMain$filterModules, session, model, listPage, newFilter));
					} else {
						break _v0$45;
					}
				case 28:
					if (_v0.b.$ === 2) {
						var query = _v0.a.a;
						var listPage = _v0.b.a;
						var delayCmd = A2(
							$author$project$Util$Delay$after,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$ModulesMain$DelayedGotListQuery(query));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							delayCmd,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: $author$project$Element$ModulesMain$ListPage(
											$author$project$Element$ModulesMain$emptyResults(
												_Utils_update(
													listPage,
													{bw: query})))
									}),
								session));
					} else {
						break _v0$45;
					}
				case 29:
					if (_v0.b.$ === 2) {
						var newQuery = _v0.a.a;
						var listPage = _v0.b.a;
						var cmd = _Utils_eq(newQuery, listPage.bw) ? A3(
							$author$project$Module$fetchModules_,
							config.gr,
							$author$project$Element$ModulesMain$asListParams(listPage),
							$author$project$Element$ModulesMain$ModuleListDownloaded) : $elm$core$Platform$Cmd$none;
						return A2($author$project$Application$Boundaries$andThenCmd, cmd, noop);
					} else {
						break _v0$45;
					}
				case 15:
					if (_v0.b.$ === 3) {
						var fieldMsg = _v0.a.a;
						var formPage = _v0.b.a;
						var form = formPage.bt;
						var values = formPage.ej;
						var formPage2 = _Utils_eq(
							fieldMsg,
							$author$project$Element$ModulesMain$IsMigratable(true)) ? _Utils_update(
							formPage,
							{dX: true}) : formPage;
						var _v10 = A5($author$project$Element$ModulesMain$updateForm, session, model, fieldMsg, form, values);
						var form2 = _v10.a;
						var values2 = _v10.b;
						var page = function () {
							var dateValidation = function () {
								switch (fieldMsg.$) {
									case 6:
										return true;
									case 7:
										return true;
									default:
										return formPage2.dn.cI;
								}
							}();
							return $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage2,
									{
										bt: form2,
										eZ: 1,
										dn: {cI: dateValidation},
										ej: values2
									}));
						}();
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{bm: page}),
							session);
					} else {
						break _v0$45;
					}
				case 18:
					if (_v0.b.$ === 3) {
						var _v12 = _v0.a;
						return A2($author$project$Element$ModulesMain$buildFormPage, session, model);
					} else {
						break _v0$45;
					}
				case 17:
					if (_v0.b.$ === 3) {
						var asTemplate = _v0.a.a.by;
						var formPage = _v0.b.a;
						var action = formPage.hQ;
						var form = formPage.bt;
						var values = formPage.ej;
						var _v13 = _Utils_Tuple2(
							A2(
								$author$project$Element$ModulesMain$isFormValid,
								A3($author$project$Element$ModulesMain$formVariation, form, session.hy, asTemplate),
								values),
							action);
						if (_v13.a) {
							var cmd = A2($elm$core$Task$perform, $author$project$Element$ModulesMain$TimeIsNow, $elm$time$Time$now);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{by: asTemplate}))
										}),
									session));
						} else {
							var areDatesValid = A3($author$project$Form$areDatesValid, form.hv, form.gH, values);
							var page = $author$project$Element$ModulesMain$FormPage(
								_Utils_update(
									formPage,
									{
										bt: $author$project$Element$ModulesMain$validateForm(
											A3($author$project$Element$ModulesMain$formVariation, form, session.hy, asTemplate)),
										eZ: 1,
										dn: {cI: areDatesValid}
									}));
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page}),
									session));
						}
					} else {
						break _v0$45;
					}
				case 10:
					if (!_v0.a.a.$) {
						if (_v0.b.$ === 3) {
							var newModule = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								($author$project$Element$ModulesMain$isCreateAction(model) && (!newModule.lC)) ? A2(
									$elm$browser$Browser$Navigation$pushUrl,
									config.iJ,
									$author$project$Route$toString(
										$author$project$Route$TimetableCreateEvent(
											{
												gG: $elm$core$Maybe$Nothing,
												iS: $elm$core$Maybe$Just(
													$author$project$Module$moduleIdToInt(newModule.gT)),
												hu: $elm$core$Maybe$Nothing
											}))) : A2(
									$elm$browser$Browser$Navigation$pushUrl,
									config.iJ,
									$author$project$Route$toString(
										$author$project$Route$ModulesDetail(
											$author$project$Module$moduleIdToInt(newModule.gT)))),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A2(
										$author$project$Session$ok,
										session,
										session.hy($author$project$Locale$Messages$ModulesSaveSuccess))));
						} else {
							break _v0$45;
						}
					} else {
						if (_v0.b.$ === 3) {
							var error = _v0.a.a.a;
							var formPage = _v0.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{eZ: 3}))
										}),
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormSaveError))));
						} else {
							break _v0$45;
						}
					}
				case 14:
					if (!_v0.a.a.$) {
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A2(
								$elm$browser$Browser$Navigation$pushUrl,
								config.iJ,
								$author$project$Route$toString($author$project$Route$ModulesList)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A2(
									$author$project$Session$ok,
									session,
									session.hy($author$project$Locale$Messages$ModulesDeleteSuccess))));
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgModuleDelete,
									$elm$core$Maybe$Just($author$project$Log$paramScopeModules),
									error),
								$elm$core$Basics$always($author$project$Element$ModulesMain$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$ModulesDeleteError))));
					}
				case 21:
					if (_v0.b.$ === 3) {
						var time = _v0.a.a;
						var formPage = _v0.b.a;
						var action = formPage.hQ;
						var form = formPage.bt;
						var values = formPage.ej;
						var selectedLos = formPage.eX;
						var selectedRubrics = formPage.ct;
						var asTemplate = formPage.by;
						if (action.$ === 3) {
							var module_ = action.a;
							var cmd = A3(
								$author$project$Module$updateModule,
								config.gr,
								A6(
									$author$project$Element$ModulesMain$saveForm,
									form,
									values,
									$elm$core$Maybe$Just(module_),
									selectedLos,
									selectedRubrics,
									time),
								$author$project$Element$ModulesMain$ModuleSaved);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{eZ: 2}))
										}),
									session));
						} else {
							var module_ = A6($author$project$Element$ModulesMain$saveForm, form, values, $elm$core$Maybe$Nothing, selectedLos, selectedRubrics, time);
							var cmd = A3(
								$author$project$Module$createModule,
								config.gr,
								_Utils_update(
									module_,
									{lC: asTemplate}),
								$author$project$Element$ModulesMain$ModuleSaved);
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								cmd,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$ModulesMain$FormPage(
												_Utils_update(
													formPage,
													{eZ: 2}))
										}),
									session));
						}
					} else {
						break _v0$45;
					}
				case 33:
					if (_v0.b.$ === 3) {
						var _v15 = _v0.a;
						var formPage = _v0.b.a;
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bm: $author$project$Element$ModulesMain$FormPage(
										_Utils_update(
											formPage,
											{dX: false}))
								}),
							session);
					} else {
						break _v0$45;
					}
				case 11:
					var module_ = _v0.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								d2: $elm$core$Maybe$Just(module_)
							}),
						session);
				case 12:
					var module_ = _v0.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3($author$project$Module$deleteModule, config.gr, module_.gT, $author$project$Element$ModulesMain$ModuleDeleted),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{d2: $elm$core$Maybe$Nothing}),
							session));
				case 13:
					var _v16 = _v0.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{d2: $elm$core$Maybe$Nothing}),
						session);
				case 31:
					if (_v0.b.$ === 3) {
						var _v17 = _v0.a;
						var formPage = _v0.b.a;
						return A2($author$project$Element$ModulesMain$openRubricsListPopup, formPage, noop);
					} else {
						break _v0$45;
					}
				case 32:
					if (_v0.b.$ === 3) {
						var _v18 = _v0.a;
						var formPage = _v0.b.a;
						return A2($author$project$Element$ModulesMain$openGroupSelectorPopup, formPage, noop);
					} else {
						break _v0$45;
					}
				case 30:
					var popupMsg = _v0.a.a;
					var page = _v0.b;
					return A4($author$project$Element$ModulesMain$updatePopup, popupMsg, page, session, model);
				case 19:
					var moduleId = _v0.a.a;
					var toggleDropdown = function () {
						var _v19 = model.ez;
						if (!_v19.$) {
							var m = _v19.a;
							return _Utils_eq(m, moduleId) ? $author$project$Element$ModulesMain$Closed : $author$project$Element$ModulesMain$Open(moduleId);
						} else {
							return $author$project$Element$ModulesMain$Open(moduleId);
						}
					}();
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{ez: toggleDropdown}),
						session);
				default:
					break _v0$45;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$ModulesNotFound = {$: 298};
var $author$project$Element$ModulesMain$ModuleDeleteConfirmed = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleteDeclined = {$: 13};
var $author$project$Element$ModulesMain$viewConfirmDialog = F2(
	function (t_, module_) {
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{
				kD: $author$project$Element$ModulesMain$ModuleDeleteConfirmed(module_),
				kM: $author$project$Element$ModulesMain$ModuleDeleteDeclined
			},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesActionDelete)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							$author$project$Locale$Messages$ModulesDeleteHelp(module_.jJ))))
				]));
	});
var $author$project$Locale$Messages$FormMultiSelectionHelp = {$: 64};
var $author$project$Element$ModulesMain$FormReset = {$: 18};
var $author$project$Element$ModulesMain$FormSubmitted = function (a) {
	return {$: 17, a: a};
};
var $author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent = {$: 251};
var $author$project$Locale$Messages$ModulesBtnSaveAsTemplate = {$: 253};
var $author$project$Locale$Messages$ModulesFieldIsMigratableFalse = {$: 268};
var $author$project$Locale$Messages$ModulesFieldIsMigratableTrue = {$: 269};
var $author$project$Locale$Messages$ModulesGroupsBtnAdd = {$: 307};
var $author$project$Locale$Messages$ModulesHeadingCreate = {$: 310};
var $author$project$Locale$Messages$ModulesHeadingCreateFromTemplate = {$: 311};
var $author$project$Locale$Messages$ModulesHeadingEdit = {$: 309};
var $author$project$Locale$Messages$ModulesHelpCreate = {$: 294};
var $author$project$Locale$Messages$ModulesLoloHeadingResults = function (a) {
	return {$: 313, a: a};
};
var $author$project$Element$ModulesMain$OpenGroupSelector = {$: 32};
var $elm$html$Html$Attributes$multiple = $elm$html$Html$Attributes$boolProperty('multiple');
var $author$project$UI$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $author$project$UI$targetSelectedOptions = function () {
	var options = A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'selectedOptions']),
		$elm$json$Json$Decode$keyValuePairs(
			A2($elm$json$Json$Decode$field, 'value', $elm$json$Json$Decode$string)));
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map($elm$core$Tuple$second),
		options);
}();
var $author$project$UI$onMultiSelect = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'change',
		A2(
			$elm$json$Json$Decode$map,
			$author$project$UI$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $author$project$UI$targetSelectedOptions)));
};
var $author$project$UI$multiSelect_ = F3(
	function (classList_, view, options) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control has-icons-left')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('select is-multiple'),
							$elm$html$Html$Attributes$classList(classList_)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$select,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$id(view.kJ),
									$author$project$UI$onMultiSelect(view.mj),
									$elm$html$Html$Attributes$multiple(true),
									$author$project$UI$attrCyData(view.kJ)
								]),
							A2($elm$core$List$map, $author$project$UI$selectOption, options)),
							$author$project$UI$Icon$icon(
							_List_fromArray(
								[
									$author$project$UI$Icon$face(view.lj),
									$author$project$UI$Icon$style('is-left')
								]))
						]))
				]));
	});
var $author$project$UI$multiChoiceField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLabel, t_, field),
					function () {
					var _v0 = field.nE.mp;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						if (!_v0.a.b) {
							return A3(
								$author$project$UI$multiSelect_,
								A2($author$project$UI$validationClassList, field, values),
								field.nE,
								_List_fromArray(
									[
										{
										dD: true,
										c_: A2(
											$author$project$Form$SelectOption,
											'',
											t_($author$project$Locale$Messages$FormEmptyOptions)),
										z: false
									}
									]));
						} else {
							var options = _v0.a;
							return A3(
								$author$project$UI$multiSelect_,
								A2($author$project$UI$validationClassList, field, values),
								field.nE,
								A2(
									$elm$core$List$map,
									function (option) {
										return {
											dD: false,
											c_: option,
											z: A2(
												$elm$core$List$member,
												option.nD,
												field.nD(values))
										};
									},
									options));
						}
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$UI$richTextEditor = F2(
	function (field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		return A3(
			$elm$html$Html$node,
			'rich-text-editor',
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('textarea rich-text-editor'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-danger', field.kU && (!valid)),
							_Utils_Tuple2('is-success', field.kU && valid)
						])),
					A2(
					$elm$html$Html$Attributes$property,
					'placeholder',
					$elm$json$Json$Encode$string(field.nE.bv)),
					A2(
					$elm$html$Html$Attributes$property,
					'initial',
					$elm$json$Json$Encode$string(
						field.nD(values))),
					A2(
					$elm$html$Html$Events$on,
					'contentChanged',
					A2(
						$elm$json$Json$Decode$map,
						field.nE.aT,
						A2(
							$elm$json$Json$Decode$at,
							_List_fromArray(
								['detail']),
							$elm$json$Json$Decode$string))),
					$author$project$UI$attrCyData(field.nE.kJ)
				]),
			_List_Nil);
	});
var $author$project$UI$richTextEditorField = F3(
	function (t_, field, values) {
		return A4($author$project$UI$textareaFieldWrapper, t_, field, values, $author$project$UI$richTextEditor);
	});
var $author$project$LoSearch$categorizeByTopicsHelper = F2(
	function (lo, dict) {
		var topic = function () {
			var _v1 = $elm$core$List$head(
				$elm$core$List$reverse(lo.jE));
			if (!_v1.$) {
				var tag = _v1.a;
				return tag;
			} else {
				return 'general';
			}
		}();
		var _v0 = A2($elm$core$Dict$get, topic, dict);
		if (_v0.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				topic,
				_List_fromArray(
					[lo]),
				dict);
		} else {
			var l = _v0.a;
			return A3(
				$elm$core$Dict$insert,
				topic,
				A2($elm$core$List$cons, lo, l),
				dict);
		}
	});
var $author$project$LoSearch$categorizeByTopics = function (los) {
	return $elm$core$Dict$toList(
		A3($elm$core$List$foldl, $author$project$LoSearch$categorizeByTopicsHelper, $elm$core$Dict$empty, los));
};
var $author$project$Element$ModulesMain$viewLearningOutcomeTopic = F2(
	function (viewer, _v0) {
		var topic = _v0.a;
		var learningOutcomes = _v0.b;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('subtitle is-6')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(topic)
						])),
					A2(
					$elm$html$Html$ul,
					_List_Nil,
					A2(
						$elm$core$List$map,
						function (lo) {
							return A2(
								$elm$html$Html$li,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$author$project$UI$tag,
										'is-rounded is-info is-light',
										_List_fromArray(
											[
												$elm$html$Html$text(lo.cG)
											])),
										A2(
										$author$project$UI$tag,
										'is-rounded is-success is-light',
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($author$project$LoSearch$subject, viewer, lo))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('ml-2')
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(lo.gD)
											]))
									]));
						},
						learningOutcomes))
				]));
	});
var $author$project$Element$ModulesMain$viewLearningOutcomeList = F2(
	function (viewer, selectedLos) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			A2(
				$elm$core$List$map,
				$author$project$Element$ModulesMain$viewLearningOutcomeTopic(viewer),
				$author$project$LoSearch$categorizeByTopics(
					A2($elm$core$List$filterMap, $author$project$LearningOutcome$getLoByID, selectedLos))));
	});
var $author$project$Locale$Messages$ModulesRubricsBtnChoose = {$: 316};
var $author$project$Locale$Messages$ModulesRubricsBtnNew = {$: 315};
var $author$project$Locale$Messages$ModulesRubricsHeading = {$: 314};
var $author$project$Element$ModulesMain$OpenRubricsList = {$: 31};
var $author$project$Element$ModulesMain$viewRubricsList = F2(
	function (t_, rubrics) {
		var viewExcerpt = function (rubric) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-weight-semibold')
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(rubric.jJ)
							])),
						$elm$html$Html$text(' ('),
						$elm$html$Html$text(
						A2(
							$elm$core$String$join,
							', ',
							A2(
								$elm$core$List$map,
								function ($) {
									return $.jJ;
								},
								rubric.ki))),
						$elm$html$Html$text(')')
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('content')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsHeading)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					A2($elm$core$List$map, viewExcerpt, rubrics)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('field')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('button is-link is-light'),
									$author$project$UI$attrCyData('add-rubrics'),
									$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$OpenRubricsList)
								]),
							_List_fromArray(
								[
									function () {
									if (!rubrics.b) {
										return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsBtnNew);
									} else {
										return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesRubricsBtnChoose);
									}
								}()
								]))
						]))
				]));
	});
var $author$project$UI$withInfoText = F4(
	function (attributes, t_, message, content) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					content,
					A2(
					$elm$html$Html$div,
					attributes,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('has-text-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$info(_List_Nil)
								])),
							A2(
							$elm$html$Html$small,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$ModulesMain$viewForm = F3(
	function (t_, viewer, formPage) {
		var action = formPage.hQ;
		var state = formPage.eZ;
		var form = formPage.bt;
		var values = formPage.ej;
		var selectedLos = formPage.eX;
		var selectedRubrics = formPage.ct;
		var validations = formPage.dn;
		var viewTemplateButton = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('control')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-link is-light'),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'is-loading',
									$author$project$Form$isProcessing(state))
								])),
							$elm$html$Html$Attributes$disabled(state !== 1),
							$author$project$UI$attrCyData('template'),
							$elm$html$Html$Events$onClick(
							$author$project$Element$ModulesMain$FormSubmitted(
								{by: true}))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSaveAsTemplate)
						]))
				]));
		var validationError = function (content) {
			return (state === 1) ? (validations.cI ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var stringFromBool = function (value) {
			return value ? 'True' : 'False';
		};
		var viewMigratableToggleButton = function () {
			var isEnabled = function () {
				switch (action.$) {
					case 3:
						var module_ = action.a;
						return (!$elm$core$List$isEmpty(
							form.e1.nD(values))) && (formPage.cO && (!$author$project$Module$isMigrationReady(module_)));
					case 2:
						var module_ = action.a;
						return (!$elm$core$List$isEmpty(
							form.e1.nD(values))) && (formPage.cO && (!$author$project$Module$isMigrationReady(module_)));
					default:
						return (!$elm$core$List$isEmpty(
							form.e1.nD(values))) && formPage.cO;
				}
			}();
			return $author$project$UI$columns(
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$style, 'display', 'flex'),
								A2($elm$html$Html$Attributes$style, 'flex-direction', 'column')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$fieldLabel, t_, form.aS),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons has-addons')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-rounded'),
												A2($elm$html$Html$Attributes$style, 'z-index', '0'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'is-selected is-link is-light',
														stringFromBool(
															form.aS.nD(values)) === 'False')
													])),
												$elm$html$Html$Events$onClick(
												$author$project$Element$ModulesMain$FormMsg(
													$author$project$Element$ModulesMain$IsMigratable(false))),
												$elm$html$Html$Attributes$disabled(!isEnabled)
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldIsMigratableFalse)
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-rounded'),
												A2($elm$html$Html$Attributes$style, 'z-index', '0'),
												$elm$html$Html$Attributes$classList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'is-selected is-link is-light',
														stringFromBool(
															form.aS.nD(values)) === 'True')
													])),
												$elm$html$Html$Events$onClick(
												$author$project$Element$ModulesMain$FormMsg(
													$author$project$Element$ModulesMain$IsMigratable(true))),
												$elm$html$Html$Attributes$disabled(!isEnabled)
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFieldIsMigratableTrue)
											]))
									]))
							]))
					]));
		}();
		var dateFieldEditable = function () {
			switch (action.$) {
				case 3:
					var module_ = action.a;
					return !$author$project$Module$isMigrationReady(module_);
				case 2:
					var module_ = action.a;
					return !$author$project$Module$isMigrationReady(module_);
				default:
					return true;
			}
		}();
		var createView = _List_fromArray(
			[
				A4(
				$author$project$UI$submitButton,
				t_($author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent),
				state !== 1,
				$author$project$Form$isProcessing(state),
				$author$project$Element$ModulesMain$FormSubmitted(
					{by: false})),
				viewTemplateButton
			]);
		var viewFormButtons = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field is-grouped')
				]),
			function () {
				switch (action.$) {
					case 0:
						return createView;
					case 2:
						return createView;
					case 1:
						return _List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$ModulesBtnCreateAndAddModuleEvent),
								state !== 1,
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormSubmitted(
									{by: false}))
							]);
					default:
						var module_ = action.a;
						return _List_fromArray(
							[
								A4(
								$author$project$UI$submitButton,
								t_($author$project$Locale$Messages$BtnSave),
								state !== 1,
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormSubmitted(
									{by: module_.lC})),
								A4(
								$author$project$UI$resetButton,
								t_($author$project$Locale$Messages$BtnReset),
								$author$project$Form$resetDisabled(state),
								$author$project$Form$isProcessing(state),
								$author$project$Element$ModulesMain$FormReset)
							]);
				}
			}());
		var createHeadingText = t_($author$project$Locale$Messages$ModulesHeadingCreate);
		var headingText = function () {
			switch (action.$) {
				case 0:
					return createHeadingText;
				case 2:
					return createHeadingText;
				case 1:
					return t_($author$project$Locale$Messages$ModulesHeadingCreateFromTemplate);
				default:
					return t_($author$project$Locale$Messages$ModulesHeadingEdit);
			}
		}();
		var buttonDisabled = $elm$core$String$isEmpty(
			form.bp.nD(values));
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(headingText)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.jJ, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.gD, values),
							A3($author$project$UI$richTextEditorField, t_, form.k9, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.lb, values),
							A3($author$project$UI$richTextEditorField, t_, form.la, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.iR, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2($author$project$Element$ModulesMain$viewRubricsList, t_, selectedRubrics)
						])),
					(!$elm$core$List$isEmpty(selectedLos)) ? $author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$author$project$UI$attrCyData('nat-los')
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$p,
											_List_fromArray(
												[
													$elm$html$Html$Attributes$class('label'),
													$author$project$UI$attrCyData('nat-los-head')
												]),
											_List_fromArray(
												[
													A2(
													$author$project$UI$caption,
													t_,
													$author$project$Locale$Messages$ModulesLoloHeadingResults(
														$elm$core$List$length(selectedLos)))
												])),
											A2($author$project$Element$ModulesMain$viewLearningOutcomeList, viewer, selectedLos)
										]))
								]))
						])) : $author$project$UI$none,
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4($author$project$UI$dateField, t_, form.hv, values, dateFieldEditable),
							validationError(
							A4($author$project$UI$dateField, t_, form.gH, values, dateFieldEditable))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.j3, values),
							A3($author$project$UI$choiceField, t_, form.bp, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A4(
									$author$project$UI$withInfoText,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-hidden-touch')
										]),
									t_,
									$author$project$Locale$Messages$FormMultiSelectionHelp,
									A3($author$project$UI$multiChoiceField, t_, form.e5, values))
								])),
							A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$UI$multiselectChoiceField, t_, form.e1, values),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('button is-link is-light'),
											$author$project$UI$attrCyData('add-groups'),
											$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$OpenGroupSelector),
											$elm$html$Html$Attributes$disabled(buttonDisabled)
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$icon(
											_List_fromArray(
												[
													$author$project$UI$Icon$face('fa-people-group')
												])),
											A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesGroupsBtnAdd)
										]))
								]))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-hidden-touch')
								]),
							t_,
							$author$project$Locale$Messages$FormMultiSelectionHelp,
							A3($author$project$UI$multiChoiceField, t_, form.S, values)),
							viewMigratableToggleButton
						]))
				]));
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[viewFormFields, viewFormButtons]),
				kJ: 'modules-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/10dae6d08e3b44059c03a14e7368e481'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$ModulesHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$ModulesMain$MigrationWarningConfirmed = {$: 33};
var $author$project$Locale$Messages$ModulesWarning = {$: 317};
var $author$project$Locale$Messages$ModulesWarningText = {$: 318};
var $author$project$UI$confirmDialogWithoutDecline_ = F5(
	function (isBtnOkEnabled, t_, config, title_, content) {
		return A4(
			$author$project$UI$modalPanel,
			title_,
			_List_Nil,
			content,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-primary'),
							$elm$html$Html$Events$onClick(config.kD),
							$elm$html$Html$Attributes$disabled(!isBtnOkEnabled)
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
						]))
				]));
	});
var $author$project$UI$confirmDialogWithoutDecline = $author$project$UI$confirmDialogWithoutDecline_(true);
var $author$project$Element$ModulesMain$viewMigrationWarningDialog = function (t_) {
	return A4(
		$author$project$UI$confirmDialogWithoutDecline,
		t_,
		{kD: $author$project$Element$ModulesMain$MigrationWarningConfirmed},
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesWarning)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				$author$project$UI$textToHtml(
					t_($author$project$Locale$Messages$ModulesWarningText)))
			]));
};
var $author$project$Element$ModulesMain$FilterTemplates = 3;
var $author$project$Element$ModulesMain$GotListQuery = function (a) {
	return {$: 28, a: a};
};
var $author$project$Locale$Messages$ModulesEmptyResults = {$: 297};
var $author$project$Locale$Messages$ModulesSearch = {$: 306};
var $author$project$Element$ModulesMain$ToggleFilterPanel = {$: 22};
var $author$project$ACL$canFilterModules = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$ModulesMain$schoolYearRange = function (subjects) {
	var getYears = function (range) {
		return A2(
			$elm$core$List$filterMap,
			$elm$core$String$toInt,
			A2($elm$core$String$split, '-', range));
	};
	var getYearRanges = function (subject) {
		return $elm$core$List$head(
			$elm$core$List$reverse(
				A2($elm$core$String$split, '@', subject.ha)));
	};
	var years = A2(
		$elm$core$List$concatMap,
		getYears,
		A2($elm$core$List$filterMap, getYearRanges, subjects));
	var max = $elm$core$List$maximum(years);
	var min = $elm$core$List$minimum(years);
	var _v0 = _Utils_Tuple2(min, max);
	if ((!_v0.a.$) && (!_v0.b.$)) {
		var min_ = _v0.a.a;
		var max_ = _v0.b.a;
		return A2($elm$core$List$range, min_, max_);
	} else {
		return _List_Nil;
	}
};
var $author$project$Locale$Messages$ModulesFilterActive = {$: 289};
var $author$project$Locale$Messages$ModulesFilterGrades = {$: 285};
var $author$project$Locale$Messages$ModulesFilterSchools = {$: 287};
var $author$project$Locale$Messages$ModulesFilterSubjects = {$: 288};
var $author$project$Locale$Messages$ModulesFilterTeachers = {$: 286};
var $author$project$Element$ModulesMain$SetGradeFilter = function (a) {
	return {$: 23, a: a};
};
var $author$project$Element$ModulesMain$SetSchoolFilter = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$ModulesMain$SetSubjectFilter = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$ModulesMain$SetTeacherFilter = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$ModulesMain$viewActiveFilters = F2(
	function (t_, filter) {
		var viewFilterPill = F2(
			function (caption, toMsg) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('tags has-addons')
								]),
							_List_fromArray(
								[
									A2(
									$author$project$UI$tag,
									'is-info',
									_List_fromArray(
										[
											A2($author$project$UI$caption, t_, caption)
										])),
									A3(
									$author$project$UI$actionLink,
									toMsg(_List_Nil),
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('tag is-delete')
										]),
									_List_fromArray(
										[$author$project$UI$none]))
								]))
						]));
			});
		var empty = $author$project$Element$ModulesMain$emptyFilter;
		var hasActiveFilter = (!_Utils_eq(empty.iu, filter.iu)) || ((!_Utils_eq(empty.e5, filter.e5)) || ((!_Utils_eq(empty.jr, filter.jr)) || (!_Utils_eq(empty.jB, filter.jB))));
		return hasActiveFilter ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('field is-grouped is-grouped-multiline')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('heading mr-2')
							]),
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterActive)
							])),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.iu, filter.iu),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterGrades, $author$project$Element$ModulesMain$SetGradeFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.e5, filter.e5),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterTeachers, $author$project$Element$ModulesMain$SetTeacherFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.jr, filter.jr),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterSchools, $author$project$Element$ModulesMain$SetSchoolFilter)),
						A2(
						$author$project$UI$when,
						!_Utils_eq(empty.jB, filter.jB),
						A2(viewFilterPill, $author$project$Locale$Messages$ModulesFilterSubjects, $author$project$Element$ModulesMain$SetSubjectFilter))
					]))
			]) : _List_Nil;
	});
var $author$project$Element$ModulesMain$viewGradeFilters = F3(
	function (t_, grades, filter) {
		var viewGradeOptions = function (grades_) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetGradeFilter,
					'modules-filter-grades',
					$elm$core$Basics$always(false),
					filter.iu),
				$author$project$Form$toSelectOptions(
					A2(
						$elm$core$List$map,
						function (g) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(g),
								$elm$core$String$fromInt(g));
						},
						grades_)));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterGrades),
				gQ: true,
				mp: grades,
				hJ: viewGradeOptions
			});
	});
var $author$project$Element$ModulesMain$viewModuleDescription = function (module_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block')
			]),
		_List_fromArray(
			[
				$author$project$Util$Html$markdownToHtml(module_.gD)
			]));
};
var $author$project$Element$ModulesMain$NavToggled = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$ModulesMain$ModuleDeleteRequested = function (a) {
	return {$: 11, a: a};
};
var $author$project$Locale$Messages$ModulesMigrationDateSet = {$: 301};
var $author$project$Element$ModulesMain$viewModuleActionLinks = F3(
	function (t_, viewer, module_) {
		var viewEditLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesUpdate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-edit'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-warning')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnEdit)
				]));
		var viewDuplicateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDuplicate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-duplicate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-clone'),
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnDuplicate)
				]));
		var viewDeleteLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$ModulesMain$ModuleDeleteRequested(module_),
			_List_fromArray(
				[
					$author$project$UI$attrCyData('modules-item-delete'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnDelete)
				]));
		var viewCreateFromTemplateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesCreateFromTemplate(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-create'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$add(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-grey')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnCreateFromTemplate)
				]));
		var inactiveAttrsNoStudents = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingStudents))
			]);
		var inactiveAttrsNoRubrics = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMissingRubrics))
			]);
		var inactiveAttrsMigrationDateSet = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('dropdown-item has-text-grey-light'),
				$elm$html$Html$Attributes$title(
				t_($author$project$Locale$Messages$ModulesMigrationDateSet))
			]);
		var hasStudents = !$elm$core$List$isEmpty(module_.e1);
		var viewPortfolioStoryLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$PortfoliosCreate(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(module_.gT)))),
					$author$project$UI$attrCyData('modules-item-story'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$portfolio(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnPortfolioStory)
				]);
			return hasStudents ? A2($elm$html$Html$a, linkAttrs, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption);
		}();
		var viewScheduleLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCreateEvent(
						{
							gG: $elm$core$Maybe$Nothing,
							iS: $elm$core$Maybe$Just(
								$author$project$Module$moduleIdToInt(module_.gT)),
							hu: $elm$core$Maybe$Nothing
						})),
					$author$project$UI$attrCyData('modules-item-schedule'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			if (hasStudents && (!$author$project$Module$isMigrationReady(module_))) {
				var caption = _List_fromArray(
					[
						$author$project$UI$Icon$moduleEvent(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-info')
							])),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
					]);
				return A2($elm$html$Html$a, linkAttrs, caption);
			} else {
				var caption = _List_fromArray(
					[
						$author$project$UI$Icon$moduleEvent(_List_Nil),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnSchedule)
					]);
				return A2($elm$html$Html$span, inactiveAttrsMigrationDateSet, caption);
			}
		}();
		var hasRubrics = !$elm$core$List$isEmpty(module_.eW);
		var viewFinalEvaluationLink = function () {
			var linkAttrs = _List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesClosure(
						$author$project$Module$moduleIdToInt(module_.gT))),
					$author$project$UI$attrCyData('modules-item-evaluate'),
					$elm$html$Html$Attributes$class('dropdown-item')
				]);
			var caption = _List_fromArray(
				[
					$author$project$UI$Icon$feedback(_List_Nil),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesBtnFeedback)
				]);
			return (hasStudents && hasRubrics) ? A2($elm$html$Html$a, linkAttrs, caption) : ((!hasRubrics) ? A2($elm$html$Html$span, inactiveAttrsNoRubrics, caption) : A2($elm$html$Html$span, inactiveAttrsNoStudents, caption));
		}();
		var _v0 = _Utils_Tuple3(
			module_.lw,
			$author$project$ACL$canCreateModules(viewer),
			A2($author$project$ACL$canManageModule, module_, viewer));
		_v0$5:
		while (true) {
			if (_v0.a) {
				if (_v0.b) {
					if (_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[viewDuplicateLink]);
					}
				} else {
					break _v0$5;
				}
			} else {
				if (_v0.b) {
					if (!_v0.c) {
						return _List_fromArray(
							[viewDuplicateLink]);
					} else {
						return _List_fromArray(
							[
								viewEditLink,
								A2($author$project$UI$when, module_.lC, viewCreateFromTemplateLink),
								viewDuplicateLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					}
				} else {
					if (_v0.c) {
						return _List_fromArray(
							[
								viewEditLink,
								viewFinalEvaluationLink,
								viewScheduleLink,
								viewPortfolioStoryLink,
								A2(
								$elm$html$Html$hr,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('dropdown-divider')
									]),
								_List_Nil),
								viewDeleteLink
							]);
					} else {
						break _v0$5;
					}
				}
			}
		}
		return _List_Nil;
	});
var $author$project$Element$ModulesMain$viewModuleMeta = F4(
	function (session, isListItem, dropdown, module_) {
		var t_ = session.hy;
		var viewer = session.nH;
		var isActiveNav = _Utils_eq(
			dropdown,
			$author$project$Element$ModulesMain$Open(module_.gT));
		var viewActionLinksDropdown = A4(
			$author$project$UI$actionLinksDropdown,
			t_,
			isActiveNav,
			$author$project$Element$ModulesMain$NavToggled(module_.gT),
			A3($author$project$Element$ModulesMain$viewModuleActionLinks, t_, viewer, module_));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('mb-2')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObjectSmall,
					_List_fromArray(
						[
							$author$project$UI$gravatar(module_.j3.K)
						]),
					_List_fromArray(
						[
							A3($author$project$Element$ModulesMain$viewModuleTitle, session, isListItem, module_),
							A2($author$project$Element$ModulesMain$viewModuleHighlights, t_, module_)
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							A2($author$project$ACL$canManageModule, module_, viewer) || $author$project$ACL$canCreateModules(viewer),
							viewActionLinksDropdown)
						]))
				]));
	});
var $author$project$Element$ModulesMain$viewItem = F3(
	function (session, dropdown, module_) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container'),
					$author$project$UI$attrCyData('modules-item')
				]),
			_List_fromArray(
				[
					A4($author$project$Element$ModulesMain$viewModuleMeta, session, true, dropdown, module_),
					$author$project$Element$ModulesMain$viewModuleDescription(module_)
				]));
	});
var $author$project$Element$ModulesMain$viewSchoolFilters = F4(
	function (t_, viewer, maybeSchools, filter) {
		var selectedSchools = A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeR, $author$project$Team$teamIdToInt, $elm$core$String$fromInt),
			filter.jr);
		var viewSchoolOptions = function (schools) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetSchoolFilter,
					'modules-filter-schools',
					$elm$core$Basics$always(false),
					selectedSchools),
				$author$project$Form$toTeamOptions(schools));
		};
		var filterByCategory = function (schools) {
			var _v0 = filter.bs;
			switch (_v0) {
				case 0:
					return schools;
				case 1:
					return A2($author$project$Person$filterPersonTeams, schools, viewer);
				default:
					return _List_Nil;
			}
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterSchools),
				gQ: true,
				mp: A2($elm$core$Maybe$map, filterByCategory, maybeSchools),
				hJ: viewSchoolOptions
			});
	});
var $author$project$Element$ModulesMain$viewSubjectFilters = F3(
	function (t_, maybeSubjects, filter) {
		var selectedSubjects = A2($elm$core$List$map, $elm$core$String$fromInt, filter.jB);
		var viewSubjectOptions = function (subjects) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetSubjectFilter,
					'modules-filter-subjects',
					$elm$core$Basics$always(false),
					selectedSubjects),
				$author$project$Form$toSortedSelectOptions(
					A2(
						$elm$core$List$map,
						function (s) {
							return _Utils_Tuple2(
								$elm$core$String$fromInt(s.gT),
								s.ha);
						},
						subjects)));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterSubjects),
				gQ: true,
				mp: maybeSubjects,
				hJ: viewSubjectOptions
			});
	});
var $author$project$Element$ModulesMain$FilterSchools = 1;
var $author$project$Element$ModulesMain$GotCategoryFilter = function (a) {
	return {$: 27, a: a};
};
var $author$project$Locale$Messages$ModulesFilterAll = {$: 290};
var $author$project$Locale$Messages$ModulesFilterCreator = {$: 292};
var $author$project$Locale$Messages$ModulesFilterSchool = {$: 291};
var $author$project$Locale$Messages$ModulesFilterTemplates = {$: 293};
var $author$project$ACL$canViewModulesAll = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$ACL$isAuditor(person);
};
var $author$project$Element$ModulesMain$viewTabFilters = F3(
	function (t_, viewer, _v0) {
		var category = _v0.bs;
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$ModulesMain$GotCategoryFilter, category),
			_List_fromArray(
				[
					{
					kJ: 'teacher',
					bO: 2,
					g_: true,
					g$: $author$project$ACL$canCreateModules(viewer),
					lO: $author$project$Locale$Messages$ModulesFilterCreator
				},
					{
					kJ: 'school',
					bO: 1,
					g_: true,
					g$: $author$project$ACL$canCreateModules(viewer),
					lO: $author$project$Locale$Messages$ModulesFilterSchool
				},
					{
					kJ: 'all',
					bO: 0,
					g_: true,
					g$: $author$project$ACL$canViewModulesAll(viewer),
					lO: $author$project$Locale$Messages$ModulesFilterAll
				},
					{
					kJ: 'templates',
					bO: 3,
					g_: true,
					g$: $author$project$ACL$canCreateModules(viewer),
					lO: $author$project$Locale$Messages$ModulesFilterTemplates
				}
				]));
	});
var $author$project$Element$ModulesMain$viewTeacherFilters = F4(
	function (t_, viewer, maybeTeachers, filter) {
		var selectedTeachers = A2($elm$core$List$map, $elm$core$String$fromInt, filter.e5);
		var viewTeacherOptions = function (teachers) {
			return A2(
				$elm$core$List$map,
				A4(
					$author$project$UI$checkbox,
					$author$project$Element$ModulesMain$SetTeacherFilter,
					'modules-filter-teachers',
					$elm$core$Basics$always(false),
					selectedTeachers),
				A2($author$project$Form$toPeopleOptions, t_, teachers));
		};
		var filterByCategory = function (teachers) {
			var _v0 = filter.bs;
			switch (_v0) {
				case 0:
					return teachers;
				case 1:
					return A2(
						$author$project$Person$teachersInTeams,
						$author$project$Person$teams(viewer),
						teachers);
				default:
					return _List_Nil;
			}
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesFilterTeachers),
				gQ: true,
				mp: A2($elm$core$Maybe$map, filterByCategory, maybeTeachers),
				hJ: viewTeacherOptions
			});
	});
var $author$project$Element$ModulesMain$viewModuleList = F4(
	function (session, dropdown, store, listPage) {
		var t_ = session.hy;
		var viewer = session.nH;
		var filter = listPage.bO;
		var query = listPage.bw;
		var modules = listPage.g9;
		var filtersExpanded = listPage.eA;
		var viewLoadingState = function () {
			var _v0 = _Utils_Tuple2(listPage.cY, modules);
			if (!_v0.b.b) {
				switch (_v0.a.$) {
					case 0:
						var _v1 = _v0.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$ModulesEmptyResults)
							]);
					default:
						var _v2 = _v0.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$ModulesEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewKeyedItem = function (module_) {
			return _Utils_Tuple2(
				$elm$core$String$fromInt(
					$author$project$Module$moduleIdToInt(module_.gT)),
				A3($author$project$Element$ModulesMain$viewItem, session, dropdown, module_));
		};
		var viewFilterPanel = filtersExpanded ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('container columns')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$Element$ModulesMain$viewGradeFilters,
						t_,
						A2(
							$elm$core$Maybe$map,
							$author$project$Element$ModulesMain$schoolYearRange,
							$author$project$RemoteData$toMaybe(store.jB)),
						filter),
						A4(
						$author$project$Element$ModulesMain$viewTeacherFilters,
						t_,
						viewer,
						$author$project$RemoteData$toMaybe(store.e5),
						filter),
						A4(
						$author$project$Element$ModulesMain$viewSchoolFilters,
						t_,
						viewer,
						$author$project$RemoteData$toMaybe(store.jr),
						filter),
						A3(
						$author$project$Element$ModulesMain$viewSubjectFilters,
						t_,
						$author$project$RemoteData$toMaybe(store.jB),
						filter)
					]))
			]) : A2($author$project$Element$ModulesMain$viewActiveFilters, t_, filter);
		var viewFilterButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$disabled(filter.bs === 3),
					$elm$html$Html$Events$onClick($author$project$Element$ModulesMain$ToggleFilterPanel),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('is-info', filtersExpanded),
							_Utils_Tuple2('is-info is-light', !filtersExpanded)
						]))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnToggleFilters)
						]))
				]));
		return $author$project$UI$keyedPanel(
			{
				kt: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											aT: $author$project$Element$ModulesMain$GotListQuery,
											bv: t_($author$project$Locale$Messages$ModulesSearch),
											bw: query
										})
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column is-narrow')
									]),
								_List_fromArray(
									[
										A2(
										$author$project$UI$when,
										$author$project$ACL$canFilterModules(viewer),
										viewFilterButton)
									]))
							])),
					_Utils_ap(
						($author$project$ACL$canFilterModules(viewer) && (filter.bs !== 3)) ? viewFilterPanel : _List_Nil,
						viewLoadingState)),
				kJ: 'modules-list',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesTitle)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$UI$when,
								$author$project$ACL$canManageModules(viewer),
								A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$author$project$Route$href($author$project$Route$ModulesCreate),
											$elm$html$Html$Attributes$title(
											t_($author$project$Locale$Messages$NavModulesNew))
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$add(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-white')
												]))
										])))
							]))
					]),
				lN: A2($elm$core$List$map, viewKeyedItem, modules),
				nk: A3($author$project$Element$ModulesMain$viewTabFilters, t_, viewer, filter),
				nq: 'is-info'
			});
	});
var $author$project$Locale$Messages$ModulesListLoadMore = {$: 296};
var $author$project$Element$ModulesMain$viewModuleListPager = F2(
	function (t_, _v0) {
		var loading = _v0.cY;
		var modules = _v0.g9;
		var _v1 = _Utils_Tuple2(loading, modules);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$ModulesMain$LoadMoreModules,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$RubricsList$PopupClosed = {$: 6};
var $author$project$Element$RubricsList$RubricsSelected = {$: 7};
var $author$project$Element$RubricsList$viewSelectorNav = function (t_) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar is-fixed-bottom has-background-link-light')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-end')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('buttons')
									]),
								_List_fromArray(
									[
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$RubricsList$RubricsSelected,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-link')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnOk)
											])),
										A3(
										$author$project$UI$actionLink,
										$author$project$Element$RubricsList$PopupClosed,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('button is-light')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$BtnCancel)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Element$RubricsList$viewPopup = function (model) {
	var session = model.cv;
	return A3(
		$author$project$UI$modalWindow,
		true,
		$author$project$Element$RubricsList$PopupClosed,
		$author$project$UI$section(
			_List_fromArray(
				[
					$author$project$Element$RubricsList$viewRubricsList(model),
					$author$project$Element$RubricsList$viewSelectorNav(session.hy)
				])));
};
var $author$project$Element$ModulesMain$viewPopup = F2(
	function (session, model) {
		var _v0 = model.c3;
		if (!_v0.$) {
			switch (_v0.a.$) {
				case 0:
					var popupModel = _v0.a.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Element$ModulesMain$popups.da.bZ,
						$author$project$Element$RubricsList$viewPopup(
							_Utils_update(
								popupModel,
								{cv: session})));
				case 1:
					var popupModel = _v0.a.a;
					return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$ModulesMain$popups.c8);
				default:
					var popupModel = _v0.a.a;
					return A2(
						$elm$html$Html$map,
						$author$project$Element$ModulesMain$popups.cU.bZ,
						$author$project$Element$LearningGroupSelector$viewPopup(
							_Utils_update(
								popupModel,
								{cv: session})));
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$ModulesMain$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 2:
				var listPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A4($author$project$Element$ModulesMain$viewModuleList, session, model.ez, model, listPage),
							A2($author$project$Element$ModulesMain$viewModuleListPager, t_, listPage),
							A2(
							$author$project$UI$maybe,
							model.d2,
							$author$project$Element$ModulesMain$viewConfirmDialog(t_))
						]));
			case 3:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Element$ModulesMain$viewPopup, session, model),
							A3($author$project$Element$ModulesMain$viewForm, t_, viewer, formPage),
							A2(
							$author$project$UI$when,
							formPage.dX,
							$author$project$Element$ModulesMain$viewMigrationWarningDialog(t_))
						]));
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$ModulesNotFound)
						]));
			default:
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$progressBar,
							'is-info',
							t_($author$project$Locale$Messages$ModulesLoadingProgress)),
							A2($author$project$Element$ModulesMain$viewPopup, session, model)
						]));
		}
	});
var $author$project$Element$ModulesMain$element = {iA: $author$project$Element$ModulesMain$init, jR: $author$project$Element$ModulesMain$update, nE: $author$project$Element$ModulesMain$view};
var $author$project$Element$NotificationList$ActivityLogListDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$NotificationList$TimeIsNow = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$NotificationList$init = F3(
	function (config, session, _v0) {
		var model = {fd: $elm$core$Maybe$Nothing, bN: config, fN: $elm$core$Maybe$Nothing};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A2($elm$core$Task$perform, $author$project$Element$NotificationList$TimeIsNow, $elm$time$Time$now),
					A2($author$project$ActivityLog$fetchActivityLogs, config.gr, $author$project$Element$NotificationList$ActivityLogListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$NotificationList$NoOp = {$: 1};
var $author$project$Log$paramScopeNotifications = 'scope_notifications';
var $author$project$Element$NotificationList$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					var list = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								fd: $elm$core$Maybe$Just(list)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3(
								$author$project$Log$msgActivityLogsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeNotifications),
								error),
							$elm$core$Basics$always($author$project$Element$NotificationList$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$ActivityLogsDownloadError))));
				}
			case 1:
				return A2($author$project$Application$Boundaries$save, model, session);
			default:
				var posix = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							fN: $elm$core$Maybe$Just(posix)
						}),
					session);
		}
	});
var $author$project$Element$NotificationList$view = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		return A3($author$project$Element$NotificationList$viewActivityLogs, t_, model.fN, model.fd);
	});
var $author$project$Element$NotificationList$element = {iA: $author$project$Element$NotificationList$init, jR: $author$project$Element$NotificationList$update, nE: $author$project$Element$NotificationList$view};
var $author$project$Element$PhoneBook$All = 0;
var $author$project$Element$PhoneBook$GotPhoneBook = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$people = function (config) {
	return A2($author$project$Api$Endpoint$peopleByRoles, config, 'operators,teachers,sponsors,module_teachers');
};
var $author$project$Person$fetchPhoneBook = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$people(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$PhoneBook$init = F3(
	function (config, session, _v0) {
		var model = {bN: config, bO: 0, fT: $elm$core$Maybe$Nothing, bw: '', eb: $elm$core$Maybe$Nothing};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2($author$project$Person$fetchPhoneBook, config.gr, $author$project$Element$PhoneBook$GotPhoneBook),
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$PhoneBook$NoOp = {$: 0};
var $author$project$Log$paramScopePhoneBook = 'scope_phonebook';
var $author$project$Element$PhoneBook$SwitchUserFormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$SwitchUserForm$SetFormReason = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$SwitchUserFormReason = {$: 598};
var $author$project$Element$SwitchUserForm$buildForm = function (t_) {
	return {
		a$: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a$: value});
				}),
			nD: function ($) {
				return $.a$;
			},
			nE: {
				kJ: 'reason',
				lO: t_($author$project$Locale$Messages$SwitchUserFormReason),
				aT: $author$project$Element$SwitchUserForm$SetFormReason,
				bv: ''
			}
		}
	};
};
var $author$project$Element$SwitchUserForm$emptyForm = {a$: ''};
var $author$project$Element$SwitchUserForm$init = F3(
	function (config, session, person) {
		var t_ = session.hy;
		var model = {
			bN: config,
			bt: $author$project$Element$SwitchUserForm$buildForm(t_),
			mx: person,
			ej: $author$project$Element$SwitchUserForm$emptyForm
		};
		return A2($author$project$Application$Boundaries$save, model, session);
	});
var $author$project$Element$SwitchUserForm$Error = 1;
var $author$project$Element$SwitchUserForm$Exit = 0;
var $author$project$Element$SwitchUserForm$GotSwitchUserAttempt = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$SwitchUserForm$NoOp = {$: 0};
var $author$project$Locale$Messages$SwitchUserAttemptSuccess = function (a) {
	return {$: 599, a: a};
};
var $author$project$Element$SwitchUserForm$UserSwitched = 2;
var $author$project$Log$msgSwitchUser = 'su';
var $author$project$Element$SwitchUserForm$saveForm = F2(
	function (form, values) {
		return form.a$.nD(values);
	});
var $author$project$SwitchUser$formDataEncoder = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(data.K)),
				_Utils_Tuple2(
				'reason',
				$elm$json$Json$Encode$string(data.a$))
			]));
};
var $author$project$Api$postExpectingHeaders = F4(
	function (url, config, body, toMsg) {
		return $author$project$Api$Endpoint$request(
			{
				O: body,
				a4: $author$project$Api$expectHeaders(toMsg),
				ah: $author$project$Api$toHeaders(config),
				ba: 'POST',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$Api$Endpoint$switchUser = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['su']),
		_List_Nil);
};
var $author$project$SwitchUser$switchUser = F3(
	function (config, data, callback) {
		return A4(
			$author$project$Api$postExpectingHeaders,
			$author$project$Api$Endpoint$switchUser(config),
			config,
			$elm$http$Http$jsonBody(
				$author$project$SwitchUser$formDataEncoder(data)),
			callback);
	});
var $author$project$Element$SwitchUserForm$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		var form = model.bt;
		var values = model.ej;
		var person = model.mx;
		switch (msg.$) {
			case 2:
				return A2(
					$author$project$Application$Boundaries$reply,
					0,
					A2($author$project$Application$Boundaries$save, model, session));
			case 3:
				var data = {
					K: person.K,
					a$: A2($author$project$Element$SwitchUserForm$saveForm, form, values)
				};
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$SwitchUser$switchUser, config.gr, data, $author$project$Element$SwitchUserForm$GotSwitchUserAttempt),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var value = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bt: _Utils_update(
								form,
								{
									a$: $author$project$Form$markEdited(form.a$)
								}),
							ej: A2(form.a$.jR, value, values)
						}),
					session);
			case 4:
				if (!msg.a.$) {
					return A2(
						$author$project$Application$Boundaries$reply,
						2,
						A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$ok,
								model.bN,
								_Utils_Tuple2(
									$author$project$Log$msgSwitchUser,
									_List_fromArray(
										[person.K])),
								$elm$core$Basics$always($author$project$Element$SwitchUserForm$NoOp)),
							A2(
								$author$project$Application$Boundaries$ok,
								t_(
									$author$project$Locale$Messages$SwitchUserAttemptSuccess(
										A2($author$project$Person$fullName, t_, person))),
								A2($author$project$Application$Boundaries$save, model, session))));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$reply,
						1,
						A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgSwitchUser,
									$elm$core$Maybe$Just(person.K),
									error),
								$elm$core$Basics$always($author$project$Element$SwitchUserForm$NoOp)),
							A3(
								$author$project$Application$Boundaries$addError,
								error,
								t_($author$project$Locale$Messages$FormSaveError),
								A2($author$project$Application$Boundaries$save, model, session))));
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$SwitchUserForm$ClosePopup = {$: 2};
var $author$project$Element$SwitchUserForm$SubmitForm = {$: 3};
var $author$project$Locale$Messages$SwitchUserTitle = {$: 600};
var $author$project$Element$SwitchUserForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a$, values);
	});
var $author$project$Element$SwitchUserForm$view = F2(
	function (_v0, _v1) {
		var t_ = _v0.hy;
		var form = _v1.bt;
		var values = _v1.ej;
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$SwitchUserTitle)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$SwitchUserForm$ClosePopup)
				]),
			_List_fromArray(
				[
					A3($author$project$UI$textareaField, t_, form.a$, values)
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$submitButton,
					t_($author$project$Locale$Messages$BtnSave),
					!A2($author$project$Element$SwitchUserForm$isFormValid, form, values),
					false,
					$author$project$Element$SwitchUserForm$SubmitForm),
					A4(
					$author$project$UI$resetButton,
					t_($author$project$Locale$Messages$BtnCancel),
					false,
					false,
					$author$project$Element$SwitchUserForm$ClosePopup)
				]));
	});
var $author$project$Element$SwitchUserForm$element = {iA: $author$project$Element$SwitchUserForm$init, jR: $author$project$Element$SwitchUserForm$update, nE: $author$project$Element$SwitchUserForm$view};
var $author$project$Element$PhoneBook$switchUserForm = {
	h_: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					eb: $elm$core$Maybe$Just(x)
				});
		}),
	gF: $author$project$Element$SwitchUserForm$element,
	iV: $author$project$Element$PhoneBook$SwitchUserFormMsg
};
var $author$project$Element$PhoneBook$update = F3(
	function (session, msg, model) {
		switch (msg.$) {
			case 1:
				if (!msg.a.$) {
					var phonebook = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$ok,
							model.bN,
							_Utils_Tuple2(
								$author$project$Log$msgPeopleDownload,
								_List_fromArray(
									[$author$project$Log$paramOk])),
							$elm$core$Basics$always($author$project$Element$PhoneBook$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									fT: $elm$core$Maybe$Just(phonebook)
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3(
								$author$project$Log$msgPeopleDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopePhoneBook),
								error),
							$elm$core$Basics$always($author$project$Element$PhoneBook$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$PhoneBookDownloadError))));
				}
			case 2:
				var f = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bO: f}),
					session);
			case 3:
				var q = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{bw: q}),
					session);
			case 4:
				var person = msg.a;
				return A3(
					$author$project$Application$Boundaries$mapElement,
					model,
					$author$project$Element$PhoneBook$switchUserForm,
					A4($author$project$Application$Boundaries$initElement, model.bN, session, $author$project$Element$PhoneBook$switchUserForm, person));
			case 5:
				var formMsg = msg.a;
				var _v1 = model.eb;
				if (!_v1.$) {
					var formModel = _v1.a;
					var _return = A3($author$project$Element$PhoneBook$switchUserForm.gF.jR, session, formMsg, formModel);
					var _v2 = _return.fY;
					if (!_v2.$) {
						return A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{eb: $elm$core$Maybe$Nothing}),
							_return.cv);
					} else {
						return A3($author$project$Application$Boundaries$mapElement, model, $author$project$Element$PhoneBook$switchUserForm, _return);
					}
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$PhoneBookLoadingProgress = {$: 374};
var $author$project$Element$PhoneBook$FilterSet = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$PhoneBookFilterAll = {$: 371};
var $author$project$Locale$Messages$PhoneBookFilterSponsors = {$: 372};
var $author$project$Locale$Messages$PhoneBookFilterTeachers = {$: 373};
var $author$project$Locale$Messages$PhoneBookSearch = {$: 375};
var $author$project$Element$PhoneBook$Query = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PhoneBook$Sponsors = 1;
var $author$project$Element$PhoneBook$Teachers = 2;
var $author$project$Element$PhoneBook$matches = F2(
	function (filter, person) {
		switch (filter) {
			case 0:
				return true;
			case 1:
				return $author$project$Person$isSponsor(person);
			default:
				return $author$project$Person$isTeacher(person) || $author$project$Person$isModuleTeacher(person);
		}
	});
var $author$project$Data$toCharAscii = function (chr) {
	var conversionTable = $elm$core$Dict$fromList(
		_List_fromArray(
			[
				_Utils_Tuple2('á', 'a'),
				_Utils_Tuple2('é', 'e'),
				_Utils_Tuple2('í', 'i'),
				_Utils_Tuple2('ó', 'o'),
				_Utils_Tuple2('ö', 'o'),
				_Utils_Tuple2('ő', 'o'),
				_Utils_Tuple2('ú', 'u'),
				_Utils_Tuple2('ü', 'u'),
				_Utils_Tuple2('ű', 'u')
			]));
	return A2(
		$elm$core$Maybe$withDefault,
		chr,
		A2($elm$core$Dict$get, chr, conversionTable));
};
var $author$project$Data$toSearchKeyword = function (string) {
	return A3(
		$elm$core$String$foldl,
		F2(
			function (chr, acc) {
				return _Utils_ap(
					acc,
					$elm$core$String$fromChar(
						$author$project$Data$toCharAscii(chr)));
			}),
		'',
		$elm$core$String$toLower(string));
};
var $author$project$Element$PhoneBook$queryMatches = F3(
	function (t_, query, person) {
		var name = $author$project$Data$toSearchKeyword(
			A2($author$project$Person$fullName, t_, person));
		var keyword = $author$project$Data$toSearchKeyword(
			$elm$core$String$trim(query));
		return A2($elm$core$String$contains, keyword, name);
	});
var $author$project$Element$PhoneBook$filterPhoneBook = F4(
	function (t_, filter, query, phonebook) {
		return A2(
			$elm$core$List$filter,
			A2($author$project$Element$PhoneBook$queryMatches, t_, query),
			A2(
				$elm$core$List$filter,
				$author$project$Element$PhoneBook$matches(filter),
				phonebook));
	});
var $author$project$Locale$Messages$SwitchUserAction = {$: 597};
var $author$project$Element$PhoneBook$SwitchUserRequested = function (a) {
	return {$: 4, a: a};
};
var $author$project$ACL$canSwitchUser = function (person) {
	return A2($author$project$Person$hasAccessRole, person, 2);
};
var $author$project$UI$protoLink = F2(
	function (protocol, data) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(
					$elm$core$String$concat(
						_List_fromArray(
							[protocol, data])))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(data)
				]));
	});
var $author$project$Element$PhoneBook$viewContact = F3(
	function (t_, viewer, person) {
		var viewSuLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$PhoneBook$SwitchUserRequested(person),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$SwitchUserAction))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face('fa-theater-masks')
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObject,
					_List_fromArray(
						[
							$author$project$UI$gravatar(person.K)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$author$project$UI$attrCyData('contact')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Person$fullName, t_, person)),
											$elm$html$Html$text(' ')
										])),
									A2(
									$elm$html$Html$span,
									_List_Nil,
									A2(
										$elm$core$List$map,
										function (child) {
											return A2(
												$elm$html$Html$small,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($author$project$Person$fullName, t_, child)),
														$elm$html$Html$text(' ')
													]));
										},
										person.m8)),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2($author$project$UI$protoLink, 'tel:', person.aQ),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2($author$project$UI$protoLink, 'mailto:', person.K)
								]))
						]),
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							$author$project$ACL$canSwitchUser(viewer),
							viewSuLink)
						]))
				]));
	});
var $author$project$Element$PhoneBook$viewPhoneBook = F4(
	function (t_, viewer, model, phonebook) {
		var viewFilterLinks = A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$PhoneBook$FilterSet, model.bO),
			_List_fromArray(
				[
					{kJ: 'all', bO: 0, g_: true, g$: true, lO: $author$project$Locale$Messages$PhoneBookFilterAll},
					{kJ: 'sponsor', bO: 1, g_: true, g$: true, lO: $author$project$Locale$Messages$PhoneBookFilterSponsors},
					{kJ: 'teacher', bO: 2, g_: true, g$: true, lO: $author$project$Locale$Messages$PhoneBookFilterTeachers}
				]));
		var filteredPhoneBook = A2(
			$author$project$Util$List$sortBy,
			$author$project$Person$fullName(t_),
			A4($author$project$Element$PhoneBook$filterPhoneBook, t_, model.bO, model.bw, phonebook));
		return $author$project$UI$panel(
			{
				kt: A2(
					$elm$core$List$cons,
					$author$project$UI$List$searchBar(
						{
							aT: $author$project$Element$PhoneBook$Query,
							bv: t_($author$project$Locale$Messages$PhoneBookSearch),
							bw: model.bw
						}),
					A2(
						$elm$core$List$map,
						A2($author$project$Element$PhoneBook$viewContact, t_, viewer),
						filteredPhoneBook)),
				kJ: 'phonebook',
				le: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PhoneBookTitle)
					]),
				nk: viewFilterLinks,
				nq: 'is-success'
			});
	});
var $author$project$Element$PhoneBook$viewSwitchUserPopup = F2(
	function (session, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Element$PhoneBook$switchUserForm.iV,
			A2($author$project$Element$PhoneBook$switchUserForm.gF.nE, session, model));
	});
var $author$project$Element$PhoneBook$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var _v0 = model.fT;
		if (_v0.$ === 1) {
			return A2(
				$author$project$UI$progressBar,
				'is-primary',
				t_($author$project$Locale$Messages$PhoneBookLoadingProgress));
		} else {
			var phonebook = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A4($author$project$Element$PhoneBook$viewPhoneBook, t_, viewer, model, phonebook),
						function () {
						var _v1 = model.eb;
						if (!_v1.$) {
							var formModel = _v1.a;
							return A2($author$project$Element$PhoneBook$viewSwitchUserPopup, session, formModel);
						} else {
							return $author$project$UI$none;
						}
					}()
					]));
		}
	});
var $author$project$Element$PhoneBook$element = {iA: $author$project$Element$PhoneBook$init, jR: $author$project$Element$PhoneBook$update, nE: $author$project$Element$PhoneBook$view};
var $author$project$Element$PortfolioForm$LoadingPage = {$: 0};
var $author$project$Element$PortfolioForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$FetchModuleDropdownList = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$FetchStudentsAndTeachersList = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$FormPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$ModuleListDownloaded = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$PeopleListDownloaded = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioForm$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$PortfolioForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioForm$MediaUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/jpeg', 'image/png', 'video/mp4', 'video/quicktime']);
var $author$project$Element$PortfolioForm$initModuleField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				lx: false,
				nl: 'Module',
				ej: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Element$PortfolioForm$initStudentsField = function (options) {
	var defaultConfig = $author$project$Multiselect$defaultConfig;
	return $author$project$Multiselect$initModel(
		_Utils_update(
			defaultConfig,
			{
				nl: 'Students',
				ej: $author$project$Form$toMultiselectValues(options)
			}));
};
var $author$project$Element$PortfolioForm$maxFileSize = (400 * 1024) * 1024;
var $author$project$Locale$Messages$FormInvalidFileMime = function (a) {
	return {$: 56, a: a};
};
var $author$project$Locale$Messages$FormTooLargeFileSize = function (a) {
	return {$: 58, a: a};
};
var $elm$file$File$mime = _File_mime;
var $elm$file$File$size = _File_size;
var $author$project$Form$validateFile = F3(
	function (t_, _v0, file) {
		var maxSize = _v0.lX;
		var acceptedMimeTypes = _v0.j2;
		return (!A2(
			$elm$core$List$member,
			$elm$file$File$mime(file),
			acceptedMimeTypes)) ? $elm$core$Result$Err(
			t_(
				$author$project$Locale$Messages$FormInvalidFileMime(
					$elm$file$File$mime(file)))) : ((_Utils_cmp(
			$elm$file$File$size(file),
			maxSize) > 0) ? $elm$core$Result$Err(
			t_(
				$author$project$Locale$Messages$FormTooLargeFileSize(
					$elm$file$File$size(file)))) : $elm$core$Result$Ok(''));
	});
var $author$project$Form$optionalFile = F3(
	function (t_, constraints, value) {
		switch (value.$) {
			case 0:
				return $elm$core$Result$Ok('');
			case 1:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			case 3:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			default:
				var url = value.a;
				return $elm$core$Result$Ok(url);
		}
	});
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Element$PortfolioForm$parseOptionalModuleId = F2(
	function (t_, value) {
		return $elm$core$String$isEmpty(value) ? $elm$core$Result$Ok($elm$core$Maybe$Nothing) : A2(
			$elm$core$Result$map,
			A2($elm$core$Basics$composeR, $elm$core$Basics$identity, $elm$core$Maybe$Just),
			A2(
				$elm$core$Result$fromMaybe,
				t_($author$project$Locale$Messages$FormRequiredSelection),
				$elm$core$String$toInt(value)));
	});
var $author$project$Module$fromModuleToValue = function (id) {
	return $elm$core$String$fromInt(
		$author$project$Module$moduleIdToInt(id));
};
var $author$project$Element$PortfolioForm$toModuleOptions = function (modules) {
	return A2(
		$elm$core$List$map,
		function (m) {
			return $author$project$Form$toSelectOption(
				_Utils_Tuple2(
					$author$project$Module$fromModuleToValue(m.gT),
					m.jJ));
		},
		modules);
};
var $author$project$Element$PortfolioForm$buildForm = F4(
	function (t_, moduleOptions, studentOptions, story) {
		var studentsField = {
			kU: false,
			mu: $author$project$Form$requiredPeopleSelected(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{e1: value});
				}),
			nD: function ($) {
				return $.e1;
			},
			nE: {
				kJ: 'students',
				lj: 'fa-users',
				lO: t_($author$project$Locale$Messages$PortfolioStoryStudents),
				mp: studentOptions,
				eZ: $author$project$Element$PortfolioForm$initStudentsField(studentOptions),
				bZ: $author$project$Element$PortfolioForm$StudentsFieldMsg
			}
		};
		var moduleField = {
			kU: false,
			mu: $author$project$Element$PortfolioForm$parseOptionalModuleId(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{fK: value});
				}),
			nD: function ($) {
				return $.fK;
			},
			nE: {
				kJ: 'module',
				lj: 'fa-cube',
				lO: t_($author$project$Locale$Messages$PortfolioStoryModule),
				mp: moduleOptions,
				eZ: $author$project$Element$PortfolioForm$initModuleField(moduleOptions),
				bZ: $author$project$Element$PortfolioForm$ModuleFieldMsg
			}
		};
		return {
			gD: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gD: value});
					}),
				nD: function ($) {
					return $.gD;
				},
				nE: {
					kJ: 'description',
					lO: t_($author$project$Locale$Messages$PortfolioStoryDescription),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioForm$FormMsg, $author$project$Element$PortfolioForm$Description),
					bv: t_($author$project$Locale$Messages$PortfolioStoryDescription)
				}
			},
			u: {
				kU: false,
				mu: A2(
					$author$project$Form$optionalFile,
					t_,
					{j2: $author$project$Element$PortfolioForm$acceptedMimeTypes, lX: $author$project$Element$PortfolioForm$maxFileSize}),
				mK: false,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{u: value});
					}),
				nD: function ($) {
					return $.u;
				},
				nE: {
					kJ: 'portfolios',
					lj: 'fa-image',
					lO: t_($author$project$Locale$Messages$PortfolioStoryMedia),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$PortfolioForm$FormMsg, $author$project$Element$PortfolioForm$MediaUrl),
					bv: t_($author$project$Locale$Messages$PortfolioStoryMedia)
				}
			},
			fK: A2(
				$elm$core$Maybe$withDefault,
				moduleField,
				A2(
					$elm$core$Maybe$map,
					function (m) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							$author$project$Element$PortfolioForm$toModuleOptions(
								_List_fromArray(
									[m])),
							moduleField);
					},
					A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.fK;
						},
						story))),
			e1: A2(
				$elm$core$Maybe$withDefault,
				studentsField,
				A2(
					$elm$core$Maybe$map,
					function (story_) {
						return A2(
							$author$project$Form$setMultiselectSelection,
							A2($author$project$Form$toPeopleOptions, t_, story_.e1),
							studentsField);
					},
					story))
		};
	});
var $author$project$Form$NoFile = {$: 0};
var $author$project$Element$PortfolioForm$emptyForm = F2(
	function (viewer, maybeModuleId) {
		return {
			gD: '',
			u: $author$project$Form$NoFile,
			fK: A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					A2($elm$core$Basics$composeR, $author$project$Module$moduleIdToInt, $elm$core$String$fromInt),
					maybeModuleId)),
			e1: $author$project$Person$isStudent(viewer) ? _List_fromArray(
				[
					$elm$core$String$fromInt(viewer.gT)
				]) : _List_Nil
		};
	});
var $author$project$Module$fetchViewerModulesForDropdown = F3(
	function (config, viewer, callback) {
		return A3(
			$author$project$Module$fetchModulesForDropdown2,
			config,
			A2(
				$elm$core$List$cons,
				viewer.gT,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.gT;
					},
					viewer.m8)),
			callback);
	});
var $author$project$Element$PortfolioForm$openCreateForm = F3(
	function (maybeModuleId, _v0, model) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var config = model.bN;
		var page = $author$project$Element$PortfolioForm$FormPage(
			{
				hQ: $author$project$Form$Create(maybeModuleId),
				bt: A4($author$project$Element$PortfolioForm$buildForm, t_, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
				eZ: 0,
				ej: A2($author$project$Element$PortfolioForm$emptyForm, viewer, maybeModuleId)
			});
		var effect = $author$project$Element$PortfolioForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioForm$FetchModuleDropdownList(
					A3(
						$author$project$Module$fetchViewerModulesForDropdown,
						config.gr,
						viewer,
						$author$project$Element$PortfolioForm$ModuleListDownloaded(maybeModuleId))),
					$author$project$Element$PortfolioForm$FetchStudentsAndTeachersList(
					A2($author$project$Person$fetchStudentsAndTeachers2, config.gr, $author$project$Element$PortfolioForm$PeopleListDownloaded))
				]));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bm: page}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioForm$FetchPortfolioStory = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$PortfolioForm$PortfolioStoryDownloadedForEdit = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioForm$openUpdateFormStep1 = F3(
	function (storyId, _v0, model) {
		var viewer = _v0.nH;
		var config = model.bN;
		var effect = $author$project$Element$PortfolioForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$PortfolioForm$FetchModuleDropdownList(
					A3(
						$author$project$Module$fetchViewerModulesForDropdown,
						config.gr,
						viewer,
						$author$project$Element$PortfolioForm$ModuleListDownloaded($elm$core$Maybe$Nothing))),
					$author$project$Element$PortfolioForm$FetchStudentsAndTeachersList(
					A2($author$project$Person$fetchStudentsAndTeachers2, config.gr, $author$project$Element$PortfolioForm$PeopleListDownloaded)),
					$author$project$Element$PortfolioForm$FetchPortfolioStory(
					A3($author$project$PortfolioStory$fetchOneStory, config.gr, storyId, $author$project$Element$PortfolioForm$PortfolioStoryDownloadedForEdit))
				]));
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bm: $author$project$Element$PortfolioForm$LoadingPage}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$PortfolioForm$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			dE: $elm$core$Maybe$Nothing,
			bm: $author$project$Element$PortfolioForm$LoadingPage,
			cv: session,
			bd: {gx: $elm$core$Maybe$Nothing, g9: $elm$core$Maybe$Nothing, mw: $elm$core$Maybe$Nothing}
		};
		if (!params.$) {
			var maybeModuleId = params.a;
			return A3(
				$author$project$Element$PortfolioForm$openCreateForm,
				A2($elm$core$Maybe$map, $elm$core$Basics$identity, maybeModuleId),
				session,
				model);
		} else {
			var moduleId = params.a;
			return A3($author$project$Element$PortfolioForm$openUpdateFormStep1, moduleId, session, model);
		}
	});
var $author$project$Element$PortfolioForm$DocumentViewerEffect = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$PortfolioForm$DocumentViewerMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$PortfolioForm$documentViewer = {
	gF: $author$project$Element$DocumentViewer$element,
	jK: $author$project$Element$PortfolioForm$DocumentViewerEffect,
	bZ: $author$project$Element$PortfolioForm$DocumentViewerMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dE: $elm$core$Maybe$Just(model)
				});
		})
};
var $elm$file$File$Select$file = F2(
	function (mimes, toMsg) {
		return A2(
			$elm$core$Task$perform,
			toMsg,
			_File_uploadOne(mimes));
	});
var $author$project$Api$postExpectingHeadersV2 = function (_v0) {
	var config = _v0.bN;
	var url = _v0.G;
	var toMsg = _v0.bZ;
	var body = _v0.O;
	return $author$project$Api$Endpoint$request(
		{
			O: body,
			a4: $author$project$Api$expectHeaders(toMsg),
			ah: $author$project$Api$toHeaders(config),
			ba: 'POST',
			be: $elm$core$Maybe$Nothing,
			bf: $elm$core$Maybe$Nothing,
			G: url
		});
};
var $author$project$Element$PortfolioForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$PortfolioForm$perform(key),
						effects));
			case 2:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 3:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 4:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 5:
				var toMsg = effect.a;
				var effect_ = effect.b;
				return A2(
					$elm$core$Platform$Cmd$map,
					toMsg,
					$author$project$Multiselect$perform(effect_));
			case 6:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 7:
				var request = effect.a;
				return $author$project$Api$putV2(request);
			case 8:
				var request = effect.a;
				return $author$project$Api$postV2(request);
			case 9:
				return $author$project$Ports$scrollToFormError;
			case 10:
				var route = effect.a;
				return A2(
					$elm$browser$Browser$Navigation$pushUrl,
					key,
					$author$project$Route$toString(route));
			case 11:
				var mimeTypes = effect.a;
				var toMsg = effect.b;
				return A2($elm$file$File$Select$file, mimeTypes, toMsg);
			case 12:
				var request = effect.a;
				return $author$project$Api$getV2(request);
			case 13:
				var request = effect.a;
				return $author$project$Api$postExpectingHeadersV2(request);
			default:
				var effect_ = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, effect_, $author$project$Element$PortfolioForm$documentViewer);
		}
	});
var $author$project$Api$BadHeader = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$PortfolioForm$CreatePortfolioStory = function (a) {
	return {$: 6, a: a};
};
var $author$project$Form$FileSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$FormFileUploadError = {$: 61};
var $author$project$Form$InvalidFile = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$LogError = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$PortfolioForm$MediaFileSelected = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$MediaFileUploaded = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$MediaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Element$PortfolioForm$Module = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$PortfolioForm$MultiselectEffect = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$NavRedirect = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$PortfolioForm$NoEffect = {$: 0};
var $author$project$Element$PortfolioForm$NoOp = {$: 0};
var $author$project$Element$PortfolioForm$PortfolioStorySaved = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$PortfolioForm$RequestPolicy = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$PortfolioForm$ScrollToFormError = {$: 9};
var $author$project$Element$PortfolioForm$SelectFile = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$Students = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$PortfolioForm$UpdatePortfolioStory = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$PortfolioForm$UploadFile = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$PortfolioForm$awsPolicyScope = 'portfolio';
var $author$project$S3$headerLocation = 'location';
var $author$project$Element$PortfolioForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gD, values) && (A2($author$project$Form$isFieldValid, form.u, values) && A2($author$project$Form$isFieldValid, form.e1, values));
	});
var $author$project$Log$msgAwsPolicyDownload = 'aws_policy_download';
var $author$project$Log$msgFileUpload = 'file_upload';
var $author$project$Form$FileUploaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Form$fromFileUrl = function (url) {
	return $elm$core$String$isEmpty(url) ? $author$project$Form$NoFile : $author$project$Form$FileUploaded(url);
};
var $author$project$Element$PortfolioForm$fillForm = function (story) {
	return {
		gD: story.gD,
		u: $author$project$Form$fromFileUrl(
			A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.mq;
					},
					$elm$core$List$head(story.lY)))),
		fK: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$author$project$Module$fromModuleToValue),
				story.fK)),
		e1: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			story.e1)
	};
};
var $author$project$Module$schoolModules = F2(
	function (viewer, modules) {
		return A2(
			$elm$core$List$filter,
			function (module_) {
				return A2($author$project$Person$isMemberOf, module_.jF.gT, viewer) || ($author$project$Person$isSponsor(viewer) && A2(
					$elm$core$List$any,
					$author$project$Person$isSponsorOf(viewer),
					module_.e1));
			},
			modules);
	});
var $author$project$Module$toSchoolModuleOptions = F2(
	function (viewer, modules) {
		return $author$project$Form$toSortedSelectOptions(
			A2(
				$elm$core$List$map,
				function (module_) {
					return _Utils_Tuple2(
						$author$project$Module$fromModuleToValue(module_.gT),
						module_.jJ);
				},
				A2($author$project$Module$schoolModules, viewer, modules)));
	});
var $author$project$ACL$canCreatePortfolioForStudent = F2(
	function (person, student) {
		return A2($author$project$Person$isTeacherOf, person, student) || (A2($author$project$Person$isSponsorOf, person, student) || A2($author$project$Person$isSamePerson, person, student));
	});
var $author$project$Element$PortfolioForm$toStudentOptions = F3(
	function (t_, viewer, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$elm$core$List$filter,
				$author$project$ACL$canCreatePortfolioForStudent(viewer),
				people));
	});
var $author$project$Element$PortfolioForm$openUpdateFormStep2 = F3(
	function (story, _v0, model) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var store = model.bd;
		var studentOptions = A2(
			$elm$core$Maybe$map,
			A2($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer),
			store.mw);
		var moduleOptions = A2(
			$elm$core$Maybe$map,
			$author$project$Module$toSchoolModuleOptions(viewer),
			store.g9);
		var page = $author$project$Element$PortfolioForm$FormPage(
			{
				hQ: $author$project$Form$Update(story),
				bt: A4(
					$author$project$Element$PortfolioForm$buildForm,
					t_,
					moduleOptions,
					studentOptions,
					$elm$core$Maybe$Just(story)),
				eZ: 0,
				ej: $author$project$Element$PortfolioForm$fillForm(story)
			});
		return _Utils_Tuple3(
			_Utils_update(
				model,
				{bm: page}),
			$author$project$Element$PortfolioForm$NoEffect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Api$Endpoint$awsPolicy = F3(
	function (config, scope, params) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'aws-policy', scope]),
			params);
	});
var $author$project$S3$PostPolicy = function (bucketName) {
	return function (bucketKey) {
		return function (s3RegionEndpoint) {
			return function (xAmzAlgorithm) {
				return function (xAmzCredential) {
					return function (xAmzDate) {
						return function (xAmzSignature) {
							return function (xAmzExpires) {
								return function (xAmzContentDisposition) {
									return function (xAmzContentType) {
										return function (policy) {
											return function (acl) {
												return {hP: acl, fk: bucketKey, fl: bucketName, i9: policy, f3: s3RegionEndpoint, gg: xAmzAlgorithm, j_: xAmzContentDisposition, j$: xAmzContentType, gh: xAmzCredential, gi: xAmzDate, hM: xAmzExpires, gj: xAmzSignature};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$S3$postPolicyDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'acl',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'policy',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'content_type',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'content_disposition',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x_amz_expires',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'x_amz_signature',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'x_amz_date',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'x_amz_credential',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'x_amz_algorithm',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										's3_region_endpoint',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bucket_key',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'bucket_name',
												$elm$json$Json$Decode$string,
												$elm$json$Json$Decode$succeed($author$project$S3$PostPolicy)))))))))))));
var $author$project$S3$requestPolicyV2 = F3(
	function (config, _v0, callback) {
		var scope = _v0.mV;
		var personId = _v0.my;
		var documentType = _v0.kR;
		var mimeType = _v0.l2;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('person_id', personId),
				_Utils_Tuple2('document_type', documentType),
				_Utils_Tuple2('mime_type', mimeType)
			]);
		return {
			bN: config,
			dC: $author$project$S3$postPolicyDecoder,
			bZ: callback,
			G: A3($author$project$Api$Endpoint$awsPolicy, config, scope, params)
		};
	});
var $author$project$Form$toFileUrl = function (value) {
	if (value.$ === 2) {
		var url = value.a;
		return url;
	} else {
		return '';
	}
};
var $author$project$Element$PortfolioForm$saveFormMedia = F3(
	function (form, values, maybeStory) {
		var classroomSubmission = A2(
			$elm$core$Maybe$andThen,
			function ($) {
				return $.h7;
			},
			maybeStory);
		var _v0 = _Utils_Tuple3(
			maybeStory,
			classroomSubmission,
			form.u.nD(values));
		if (!_v0.b.$) {
			if (!_v0.a.$) {
				var story = _v0.a.a;
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.mq;
					},
					story.lY);
			} else {
				return _List_Nil;
			}
		} else {
			if (!_v0.c.$) {
				var _v1 = _v0.b;
				var _v2 = _v0.c;
				return _List_Nil;
			} else {
				var _v3 = _v0.b;
				var file = _v0.c;
				return _List_fromArray(
					[
						$author$project$Form$toFileUrl(file)
					]);
			}
		}
	});
var $author$project$Element$PortfolioForm$saveForm = F4(
	function (form, values, viewer, maybeStory) {
		return A7(
			$author$project$PortfolioStory$PortfolioStoryUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					maybeStory)),
			A2(
				$elm$core$Maybe$withDefault,
				0,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.hH;
					},
					maybeStory)),
			form.gD.nD(values),
			A3($author$project$Element$PortfolioForm$saveFormMedia, form, values, maybeStory),
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$elm$core$String$toInt(
					form.fK.nD(values))),
			viewer.gT,
			A2(
				$elm$core$List$filterMap,
				$elm$core$String$toInt,
				form.e1.nD(values)));
	});
var $author$project$Module$findModule = F2(
	function (id, modules) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (module_) {
					return _Utils_eq(module_.gT, id);
				},
				modules));
	});
var $author$project$Person$findPerson = F2(
	function (id, people) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (person) {
					return _Utils_eq(person.gT, id);
				},
				people));
	});
var $author$project$Element$PortfolioForm$updateModuleField = F6(
	function (t_, viewer, modules, maybePeople, value, formPage) {
		var form = formPage.bt;
		var values = formPage.ej;
		var maybeModule = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return A2($author$project$Module$findModule, id, modules);
			},
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$identity,
				$elm$core$String$toInt(value)));
		var formPageWithNewModule = _Utils_update(
			formPage,
			{
				bt: _Utils_update(
					form,
					{
						fK: $author$project$Form$markEdited(form.fK)
					}),
				ej: A2(form.fK.jR, value, values)
			});
		var formWithNewModule = formPageWithNewModule.bt;
		var _v0 = _Utils_Tuple2(maybeModule, maybePeople);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var module_ = _v0.a.a;
					var people = _v0.b.a;
					var valuesWithNewModule = formPageWithNewModule.ej;
					var selectedStudentOptions = A2(
						$elm$core$List$filter,
						function (s) {
							return A2(
								$elm$core$List$member,
								$elm$core$String$fromInt(s.gT),
								form.e1.nD(values));
						},
						people);
					var selectedValues = A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.gT;
							},
							$elm$core$String$fromInt),
						selectedStudentOptions);
					var moduleStudents = A2(
						$elm$core$List$filterMap,
						function (s) {
							return A2($author$project$Person$findPerson, s.gT, people);
						},
						module_.e1);
					var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, moduleStudents);
					return _Utils_update(
						formPageWithNewModule,
						{
							bt: _Utils_update(
								formWithNewModule,
								{
									e1: $author$project$Form$markEdited(
										A2(
											$author$project$Form$setMultiselectSelection,
											A2($author$project$Form$toPeopleOptions, t_, selectedStudentOptions),
											A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1)))
								}),
							ej: A2(form.e1.jR, selectedValues, valuesWithNewModule)
						});
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var people = _v0.b.a;
					var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, people);
					return _Utils_update(
						formPageWithNewModule,
						{
							bt: _Utils_update(
								formWithNewModule,
								{
									e1: $author$project$Form$markEdited(
										A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1))
								})
						});
				} else {
					break _v0$2;
				}
			}
		}
		return formPageWithNewModule;
	});
var $author$project$Element$PortfolioForm$updateForm = F5(
	function (t_, viewer, store, msg, formPage) {
		var form = formPage.bt;
		var values = formPage.ej;
		var editedFormPage = _Utils_update(
			formPage,
			{eZ: 1});
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bt: _Utils_update(
							form,
							{
								gD: $author$project$Form$markEdited(form.gD)
							}),
						ej: A2(form.gD.jR, value, values)
					});
			case 1:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bt: _Utils_update(
							form,
							{
								u: $author$project$Form$markEdited(form.u)
							}),
						ej: A2(
							form.u.jR,
							$author$project$Form$fromFileUrl(value),
							values)
					});
			case 2:
				var value = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					formPage,
					A2(
						$elm$core$Maybe$map,
						function (modules) {
							return A6($author$project$Element$PortfolioForm$updateModuleField, t_, viewer, modules, store.mw, value, editedFormPage);
						},
						store.g9));
			default:
				var value = msg.a;
				return _Utils_update(
					editedFormPage,
					{
						bt: _Utils_update(
							form,
							{
								e1: $author$project$Form$markEdited(form.e1)
							}),
						ej: A2(form.e1.jR, value, values)
					});
		}
	});
var $elm$http$Http$filePart = _Http_pair;
var $author$project$S3$makeFormData = F2(
	function (policy, file) {
		return $elm$http$Http$multipartBody(
			_List_fromArray(
				[
					A2($elm$http$Http$stringPart, 'key', policy.fk),
					A2($elm$http$Http$stringPart, 'acl', policy.hP),
					A2($elm$http$Http$stringPart, 'x-amz-algorithm', policy.gg),
					A2($elm$http$Http$stringPart, 'x-amz-credential', policy.gh),
					A2($elm$http$Http$stringPart, 'x-amz-date', policy.gi),
					A2($elm$http$Http$stringPart, 'x-amz-signature', policy.gj),
					A2($elm$http$Http$stringPart, 'content-disposition', policy.j_),
					A2($elm$http$Http$stringPart, 'content-type', policy.j$),
					A2($elm$http$Http$stringPart, 'success_action_status', '200'),
					A2($elm$http$Http$stringPart, 'policy', policy.i9),
					A2($elm$http$Http$filePart, 'file', file)
				]));
	});
var $author$project$S3$s3Endpoint = function (postPolicy) {
	var host = 'https://' + postPolicy.f3;
	return A3(
		$elm$url$Url$Builder$crossOrigin,
		host,
		_List_fromArray(
			[postPolicy.fl]),
		_List_Nil);
};
var $author$project$S3$uploadFileV2 = F4(
	function (config, postPolicy, file, callback) {
		return {
			O: A2($author$project$S3$makeFormData, postPolicy, file),
			bN: config,
			bZ: callback,
			G: $author$project$S3$s3Endpoint(postPolicy)
		};
	});
var $author$project$Element$PortfolioForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			gD: $author$project$Form$markEdited(form.gD),
			u: $author$project$Form$markEdited(form.u),
			fK: $author$project$Form$markEdited(form.fK),
			e1: $author$project$Form$markEdited(form.e1)
		});
};
var $author$project$Element$PortfolioForm$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var config = model.bN;
			var session = model.cv;
			var store = model.bd;
			var viewer = session.nH;
			var t_ = session.hy;
			var noop = _Utils_Tuple3(model, $author$project$Element$PortfolioForm$NoEffect, $elm$core$Maybe$Nothing);
			var _v0 = _Utils_Tuple2(msg, model.bm);
			_v0$24:
			while (true) {
				switch (_v0.a.$) {
					case 2:
						if (_v0.b.$ === 1) {
							var location = _v0.a.a;
							return A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$PortfolioForm$documentViewer,
								A4(
									$author$project$Application$V3$Boundaries$initElement,
									config,
									session,
									$author$project$Element$PortfolioForm$documentViewer,
									{eM: $elm$core$Maybe$Nothing, G: location}));
						} else {
							break _v0$24;
						}
					case 1:
						if (_v0.b.$ === 1) {
							var documentViewerMsg = _v0.a.a;
							var _v1 = model.dE;
							if (!_v1.$) {
								var documentViewerModel = _v1.a;
								var _v2 = A3(
									$author$project$Application$V3$Boundaries$mapElement,
									model,
									$author$project$Element$PortfolioForm$documentViewer,
									A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$PortfolioForm$documentViewer));
								var model2 = _v2.a;
								var effect = _v2.b;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{dE: $elm$core$Maybe$Nothing}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								return noop;
							}
						} else {
							break _v0$24;
						}
					case 6:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var field = form.fK;
							var _v3 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
							var updatedField = _v3.a;
							var effect = _v3.b;
							var outMsg = _v3.c;
							var formMsg = $author$project$Element$PortfolioForm$Module(
								$author$project$Form$getMultiselectFieldSelectedValue(updatedField));
							var formPage2 = _Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{fK: updatedField})
								});
							var formPage3 = function () {
								if (!outMsg.$) {
									return A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, formMsg, formPage2);
								} else {
									return formPage2;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bm: $author$project$Element$PortfolioForm$FormPage(formPage3)
									}),
								A2($author$project$Element$PortfolioForm$MultiselectEffect, $author$project$Element$PortfolioForm$ModuleFieldMsg, effect),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 7:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var field = form.e1;
							var _v5 = A2($author$project$Form$updateMultiselectField, fieldMsg, field);
							var updatedField = _v5.a;
							var effect = _v5.b;
							var outMsg = _v5.c;
							var formMsg = $author$project$Element$PortfolioForm$Students(
								$author$project$Form$getMultiselectFieldSelectedValues(updatedField));
							var formPage2 = _Utils_update(
								formPage,
								{
									bt: _Utils_update(
										form,
										{e1: updatedField})
								});
							var formPage3 = function () {
								if (!outMsg.$) {
									return A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, formMsg, formPage2);
								} else {
									return formPage2;
								}
							}();
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bm: $author$project$Element$PortfolioForm$FormPage(formPage3)
									}),
								A2($author$project$Element$PortfolioForm$MultiselectEffect, $author$project$Element$PortfolioForm$StudentsFieldMsg, effect),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 5:
						if (_v0.b.$ === 1) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										bm: $author$project$Element$PortfolioForm$FormPage(
											A5($author$project$Element$PortfolioForm$updateForm, t_, viewer, store, fieldMsg, formPage))
									}),
								$author$project$Element$PortfolioForm$NoEffect,
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 4:
						if (_v0.b.$ === 1) {
							var _v7 = _v0.a;
							var action = _v0.b.a.hQ;
							if (action.$ === 1) {
								var story = action.a;
								return A3($author$project$Element$PortfolioForm$openUpdateFormStep2, story, session, model);
							} else {
								var maybeModuleId = action.a;
								return A3($author$project$Element$PortfolioForm$openCreateForm, maybeModuleId, session, model);
							}
						} else {
							break _v0$24;
						}
					case 3:
						if (_v0.b.$ === 1) {
							var _v9 = _v0.a;
							var formPage = _v0.b.a;
							var action = formPage.hQ;
							var form = formPage.bt;
							var values = formPage.ej;
							if (A2($author$project$Element$PortfolioForm$isFormValid, form, values)) {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{eZ: 2}));
								var effect = function () {
									if (!action.$) {
										var unsavedStory = A4($author$project$Element$PortfolioForm$saveForm, form, values, viewer, $elm$core$Maybe$Nothing);
										return $author$project$Element$PortfolioForm$CreatePortfolioStory(
											A3($author$project$PortfolioStory$createStory, config, unsavedStory, $author$project$Element$PortfolioForm$PortfolioStorySaved));
									} else {
										var story = action.a;
										var unsavedStory = A4(
											$author$project$Element$PortfolioForm$saveForm,
											form,
											values,
											viewer,
											$elm$core$Maybe$Just(story));
										return $author$project$Element$PortfolioForm$UpdatePortfolioStory(
											A3($author$project$PortfolioStory$updateStory, config, unsavedStory, $author$project$Element$PortfolioForm$PortfolioStorySaved));
									}
								}();
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: $author$project$Element$PortfolioForm$validateForm(form),
											eZ: 1
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page}),
									$author$project$Element$PortfolioForm$ScrollToFormError,
									$elm$core$Maybe$Nothing);
							}
						} else {
							break _v0$24;
						}
					case 15:
						if (!_v0.a.b.$) {
							if (_v0.b.$ === 1) {
								var _v11 = _v0.a;
								var moduleId = _v11.a;
								var modules = _v11.b.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var selectedModule = $elm$core$List$head(
									A2(
										$elm$core$List$filter,
										function (m) {
											return _Utils_eq(
												$elm$core$Maybe$Just(m.gT),
												moduleId);
										},
										modules));
								var moduleOptions = A2($author$project$Module$toSchoolModuleOptions, viewer, modules);
								var multiselectModuleField = function () {
									if (!selectedModule.$) {
										var selected = selectedModule.a;
										return A2(
											$author$project$Form$setMultiselectSelection,
											$author$project$Element$PortfolioForm$toModuleOptions(
												_List_fromArray(
													[selected])),
											A2($author$project$Form$setMultiselectOptions, moduleOptions, form.fK));
									} else {
										return A2($author$project$Form$setMultiselectOptions, moduleOptions, form.fK);
									}
								}();
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{fK: multiselectModuleField})
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bm: page,
											bd: _Utils_update(
												store,
												{
													g9: $elm$core$Maybe$Just(modules)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							} else {
								var _v13 = _v0.a;
								var modules = _v13.b.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bd: _Utils_update(
												store,
												{
													g9: $elm$core$Maybe$Just(modules)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							var _v14 = _v0.a;
							var error = _v14.b.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$ModulesDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgModulesDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 14:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var people = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var studentOptions = A3($author$project$Element$PortfolioForm$toStudentOptions, t_, viewer, people);
								var multiselectStudentsField = A2($author$project$Form$setMultiselectOptions, studentOptions, form.e1);
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{e1: multiselectStudentsField})
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bm: page,
											bd: _Utils_update(
												store,
												{
													mw: $elm$core$Maybe$Just(people)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							} else {
								var people = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											bd: _Utils_update(
												store,
												{
													mw: $elm$core$Maybe$Just(people)
												})
										}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							var error = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$PortfoliosPeopleDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosPeopleDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 12:
						if (!_v0.a.a.$) {
							if (!_v0.b.$) {
								var story = _v0.a.a.a;
								var _v15 = _v0.b;
								return A3($author$project$Element$PortfolioForm$openUpdateFormStep2, story, session, model);
							} else {
								break _v0$24;
							}
						} else {
							var error = _v0.a.a.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A3(
											$author$project$Session$error,
											session,
											error,
											t_($author$project$Locale$Messages$PortfoliosDownloadError))
									}),
								$author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgPortfoliosDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp))),
								$elm$core$Maybe$Nothing);
						}
					case 13:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var newStory = _v0.a.a.a;
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											cv: A2(
												$author$project$Session$ok,
												session,
												t_($author$project$Locale$Messages$PortfoliosSaveSuccess))
										}),
									$author$project$Element$PortfolioForm$NavRedirect(
										$author$project$Route$PortfoliosDetail(newStory.gT)),
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var error = _v0.a.a.a;
								var formPage = _v0.b.a;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormSaveError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{eZ: 3}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgPortfoliosSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page, cv: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					case 8:
						if (_v0.b.$ === 1) {
							var _v16 = _v0.a;
							var documentAvailableMsg = _v16.a;
							var documentType = _v16.b;
							return _Utils_Tuple3(
								model,
								A2(
									$author$project$Element$PortfolioForm$SelectFile,
									$author$project$Element$PortfolioForm$acceptedMimeTypes,
									A2($author$project$Element$PortfolioForm$MediaFileSelected, documentAvailableMsg, documentType)),
								$elm$core$Maybe$Nothing);
						} else {
							break _v0$24;
						}
					case 9:
						if (_v0.b.$ === 1) {
							var _v17 = _v0.a;
							var documentAvailableMsg = _v17.a;
							var documentType = _v17.b;
							var file = _v17.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var valuesWithFileSelected = A2(
								form.u.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.u.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(session.nH.gT),
								mV: $author$project$Element$PortfolioForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.u, valuesWithFileSelected)) {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													u: $author$project$Form$markEdited(form.u)
												}),
											ej: valuesWithFileSelected
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page}),
									$author$project$Element$PortfolioForm$RequestPolicy(
										A3(
											$author$project$S3$requestPolicyV2,
											config.gr,
											params,
											A2($author$project$Element$PortfolioForm$MediaPolicyDownloaded, documentAvailableMsg, file))),
									$elm$core$Maybe$Nothing);
							} else {
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													u: $author$project$Form$markEdited(form.u)
												}),
											ej: valuesWithFileError
										}));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page}),
									$author$project$Element$PortfolioForm$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						} else {
							break _v0$24;
						}
					case 10:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 1) {
								var _v18 = _v0.a;
								var documentAvailableMsg = _v18.a;
								var file = _v18.b;
								var policy = _v18.c.a;
								return _Utils_Tuple3(
									model,
									$author$project$Element$PortfolioForm$UploadFile(
										A4(
											$author$project$S3$uploadFileV2,
											config.gr,
											policy,
											file,
											A2($author$project$Element$PortfolioForm$MediaFileUploaded, documentAvailableMsg, file))),
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var _v19 = _v0.a;
								var error = _v19.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormFileUploadError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											ej: A2(form.u.jR, $author$project$Form$NoFile, values)
										}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page, cv: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					case 11:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 1) {
								var _v20 = _v0.a;
								var documentAvailableMsg = _v20.a;
								var file = _v20.b;
								var metadata = _v20.c.a;
								var _v21 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v21.$) {
									var location = _v21.a;
									var $temp$msg = documentAvailableMsg(location),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$msg = A3(
										$author$project$Element$PortfolioForm$MediaFileUploaded,
										documentAvailableMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$24;
							}
						} else {
							if (_v0.b.$ === 1) {
								var _v22 = _v0.a;
								var error = _v22.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$FormFileUploadError));
								var page = $author$project$Element$PortfolioForm$FormPage(
									_Utils_update(
										formPage,
										{
											ej: A2(form.u.jR, $author$project$Form$NoFile, values)
										}));
								var effect = $author$project$Element$PortfolioForm$LogError(
									A3(
										$author$project$Log$errorV2,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just($author$project$Log$paramScopePortfolios),
											error),
										$elm$core$Basics$always($author$project$Element$PortfolioForm$NoOp)));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{bm: page, cv: session2}),
									effect,
									$elm$core$Maybe$Nothing);
							} else {
								break _v0$24;
							}
						}
					default:
						var _v23 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Element$PortfolioForm$viewDocumentViewer = F2(
	function (session, documentModel) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, documentModel, $author$project$Element$PortfolioForm$documentViewer);
	});
var $author$project$Element$PortfolioForm$FormReset = {$: 4};
var $author$project$Element$PortfolioForm$FormSubmitted = {$: 3};
var $author$project$Element$PortfolioForm$MediaFileUploadRequested = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Element$PortfolioForm$OpenDocumentViewer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$PortfoliosHeadingEdit = {$: 409};
var $author$project$Locale$Messages$PortfoliosHeadingNew = {$: 410};
var $author$project$Locale$Messages$PortfoliosHelpCreate = {$: 382};
var $author$project$Locale$Messages$PortfoliosMediaUploadHelp = function (a) {
	return {$: 408, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormDocumentUploaded = {$: 561};
var $author$project$Locale$Messages$StudentProfileFormDocumentView = {$: 560};
var $author$project$Locale$Messages$StudentProfileFormNewDocument = {$: 559};
var $author$project$UI$fieldCustomLabel = F3(
	function (t_, field, message) {
		return A4($author$project$UI$label_, $elm$html$Html$label, t_, message, field);
	});
var $author$project$Form$isUploading = F2(
	function (fileField, values) {
		var _v0 = fileField.nD(values);
		if (_v0.$ === 1) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$UI$fileField_ = F6(
	function (t_, field, customLabel, values, toUploadMsg, toDownloadMsg) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var uploadButton = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'is-loading',
							A2($author$project$Form$isUploading, field, values))
						])),
					$elm$html$Html$Events$onClick(
					A2(toUploadMsg, field.nE.aT, field.nE.kJ))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$icon(
					_List_fromArray(
						[
							$author$project$UI$Icon$face(field.nE.lj)
						])),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormNewDocument)
						]))
				]));
		var hiddenInput = function () {
			var _v1 = field.nD(values);
			if (_v1.$ === 2) {
				var location = _v1.a;
				return A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$value(location),
							$author$project$UI$attrCyData(field.nE.kJ)
						]),
					_List_Nil);
			} else {
				return A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$type_('hidden'),
							$elm$html$Html$Attributes$value(''),
							$author$project$UI$attrCyData(field.nE.kJ)
						]),
					_List_Nil);
			}
		}();
		var fileCaption = function () {
			var _v0 = field.nD(values);
			if (_v0.$ === 2) {
				var location = _v0.a;
				return A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							(field.kU && valid) ? $author$project$UI$Icon$check(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-grey')
								])) : $author$project$UI$none,
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormDocumentUploaded),
							A3(
							$author$project$UI$actionLink,
							toDownloadMsg(location),
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(location),
									$author$project$UI$attrCyData(field.nE.kJ + '-preview')
								]),
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormDocumentView)
								]))
						]));
			} else {
				return $author$project$UI$none;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A3($author$project$UI$fieldCustomLabel, t_, field, customLabel),
					hiddenInput,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('control block')
						]),
					_List_fromArray(
						[uploadButton])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('block')
						]),
					_List_fromArray(
						[fileCaption])),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$fileField = F5(
	function (t_, field, values, toUploadMsg, toDownloadMsg) {
		return A6($author$project$UI$fileField_, t_, field, $elm$core$Maybe$Nothing, values, toUploadMsg, toDownloadMsg);
	});
var $author$project$Form$toSavedObject = function (action) {
	if (!action.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var x = action.a;
		return $elm$core$Maybe$Just(x);
	}
};
var $author$project$Element$PortfolioForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.hQ;
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var maxFileSizeInMb = ((($author$project$Element$PortfolioForm$maxFileSize / 1024) | 0) / 1024) | 0;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$richTextEditorField, t_, form.gD, values)
						])),
					function () {
					var _v2 = A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.h7;
						},
						$author$project$Form$toSavedObject(action));
					if (!_v2.$) {
						return $author$project$UI$none;
					} else {
						return $author$project$UI$columns(
							_List_fromArray(
								[
									A4(
									$author$project$UI$withInfoText,
									_List_Nil,
									t_,
									$author$project$Locale$Messages$PortfoliosMediaUploadHelp(maxFileSizeInMb),
									A5($author$project$UI$fileField, t_, form.u, values, $author$project$Element$PortfolioForm$MediaFileUploadRequested, $author$project$Element$PortfolioForm$OpenDocumentViewer))
								]));
					}
				}(),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$multiselectChoiceField, t_, form.e1, values),
							A3($author$project$UI$multiselectChoiceField, t_, form.fK, values)
						]))
				]));
		var headingText = function () {
			if (!action.$) {
				return $author$project$Locale$Messages$PortfoliosHeadingNew;
			} else {
				return $author$project$Locale$Messages$PortfoliosHeadingEdit;
			}
		}();
		var formState = A2($author$project$Form$isUploading, form.u, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						viewFormFields,
						A5(
						$author$project$UI$formButtons,
						t_,
						action,
						formState,
						$author$project$Element$PortfolioForm$FormSubmitted,
						$elm$core$Basics$always($author$project$Element$PortfolioForm$FormReset))
					]),
				kJ: 'portfolios-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, headingText)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('https://www.loom.com/share/2a59b4e4d08049ff9aa74019f5289474'),
										$elm$html$Html$Attributes$target('_blank'),
										$elm$html$Html$Attributes$title(
										t_($author$project$Locale$Messages$PortfoliosHelpCreate))
									]),
								_List_fromArray(
									[
										$author$project$UI$Icon$help(
										_List_fromArray(
											[
												$author$project$UI$Icon$style('has-text-info')
											]))
									]))
							]))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$PortfolioForm$view = function (model) {
	var page = model.bm;
	var session = model.cv;
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				function () {
				if (page.$ === 1) {
					var formPage = page.a;
					return A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$Element$PortfolioForm$viewForm, session.hy, formPage),
								A2(
								$author$project$UI$maybe,
								model.dE,
								$author$project$Element$PortfolioForm$viewDocumentViewer(session))
							]));
				} else {
					return A2(
						$author$project$UI$progressBar,
						'is-link',
						session.hy($author$project$Locale$Messages$PortfoliosLoadingProgress));
				}
			}()
			]));
};
var $author$project$Element$PortfolioForm$element = {iA: $author$project$Element$PortfolioForm$init, hh: $author$project$Element$PortfolioForm$perform, jR: $author$project$Element$PortfolioForm$update, nE: $author$project$Element$PortfolioForm$view};
var $author$project$Element$RubricSubjectOverview$EvaluationsDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Api$Endpoint$evaluation = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'evaluation']),
		_List_Nil);
};
var $author$project$Evaluation$Evaluation = F2(
	function (student, subjects) {
		return {ne: student, jB: subjects};
	});
var $author$project$Evaluation$Student = F6(
	function (id, firstName, lastName, email, school, grade) {
		return {K: email, k3: firstName, gO: grade, gT: id, ak: lastName, bp: school};
	});
var $author$project$Evaluation$studentDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'grade',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'school',
		$author$project$Team$nestedTeamDecoder,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'email',
			$elm$json$Json$Decode$string,
			'',
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'last_name',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'first_name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$Evaluation$Student)))))));
var $author$project$Evaluation$Subject = F4(
	function (subject, available, achievedUntilMidYear, achievedUntilEndOfYear) {
		return {j7: achievedUntilEndOfYear, j8: achievedUntilMidYear, ko: available, e2: subject};
	});
var $author$project$Evaluation$subjectDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'achieved_until_end_of_year',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'achieved_until_midyear',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'available',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'subject',
				$author$project$Subject$subjectDecoder,
				$elm$json$Json$Decode$succeed($author$project$Evaluation$Subject)))));
var $author$project$Evaluation$evaluationDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'subjects',
	$elm$json$Json$Decode$list($author$project$Evaluation$subjectDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'student',
		$author$project$Evaluation$studentDecoder,
		$elm$json$Json$Decode$succeed($author$project$Evaluation$Evaluation)));
var $author$project$Evaluation$fetchEvaluations = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$evaluation(config),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$elm$json$Json$Decode$list($author$project$Evaluation$evaluationDecoder)));
	});
var $author$project$Element$RubricSubjectOverview$andThenFetchEvaluations = function (_return) {
	var model = _return.dY;
	var fetchEvaluations_ = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dz,
					A2($author$project$Evaluation$fetchEvaluations, model.bN.gr, $author$project$Element$RubricSubjectOverview$EvaluationsDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{dI: $author$project$RemoteData$Loading}),
			_return.cv));
	return fetchEvaluations_;
};
var $author$project$Element$RubricSubjectOverview$StudentListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Student$fetchActiveStudents_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$activeStudents, config, params),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$Student$studentsDecoder));
	});
var $author$project$Element$RubricSubjectOverview$studentListParams = $author$project$Student$defaultListParams;
var $author$project$Element$RubricSubjectOverview$andThenFetchStudents = function (_return) {
	var model = _return.dY;
	var fetchStudents = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dz,
					A3($author$project$Student$fetchActiveStudents_, model.bN.gr, $author$project$Element$RubricSubjectOverview$studentListParams, $author$project$Element$RubricSubjectOverview$StudentListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{e1: $author$project$RemoteData$Loading}),
			_return.cv));
	return fetchStudents;
};
var $author$project$Element$RubricSubjectOverview$SubjectListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$RubricSubjectOverview$andThenFetchSubjects = function (_return) {
	var model = _return.dY;
	var fetchSubjects = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dz,
					A2($author$project$Subject$fetchSubjects, model.bN.gr, $author$project$Element$RubricSubjectOverview$SubjectListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{jB: $author$project$RemoteData$Loading}),
			_return.cv));
	return fetchSubjects;
};
var $author$project$Element$RubricSubjectOverview$SchoolListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$RubricSubjectOverview$andThenMaybeFetchSchools = function (_return) {
	var model = _return.dY;
	var fetchSchools = A2(
		$author$project$Application$Boundaries$andThenCmd,
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					_return.dz,
					A2($author$project$Team$fetchSchools, model.bN.gr, $author$project$Element$RubricSubjectOverview$SchoolListDownloaded)
				])),
		A2(
			$author$project$Application$Boundaries$save,
			_Utils_update(
				model,
				{jr: $author$project$RemoteData$Loading}),
			_return.cv));
	return A2(
		$author$project$RemoteData$withDefault,
		fetchSchools,
		A2(
			$author$project$RemoteData$map,
			$elm$core$Basics$always(_return),
			model.jr));
};
var $author$project$Element$RubricSubjectOverview$andThenFetchData = function (_v0) {
	var model = _v0.dY;
	var session = _v0.cv;
	var cmd = _v0.dz;
	return $author$project$Element$RubricSubjectOverview$andThenFetchEvaluations(
		$author$project$Element$RubricSubjectOverview$andThenFetchSubjects(
			$author$project$Element$RubricSubjectOverview$andThenFetchStudents(
				$author$project$Element$RubricSubjectOverview$andThenMaybeFetchSchools(
					A2(
						$author$project$Application$Boundaries$andThenCmd,
						cmd,
						A2($author$project$Application$Boundaries$save, model, session))))));
};
var $author$project$Element$RubricSubjectOverview$defaultFilter = F2(
	function (teamId, moduleId) {
		return {iu: _List_Nil, fK: moduleId, bp: teamId, e1: _List_Nil, jB: _List_Nil};
	});
var $author$project$Element$RubricSubjectOverview$defaultTeamId = A2($elm$core$Basics$composeR, $author$project$Person$teamsAsTom, $elm$core$List$head);
var $author$project$Element$RubricSubjectOverview$initPage = F3(
	function (query, session, model) {
		var viewer = session.nH;
		var _v0 = _Utils_Tuple3(
			query.bp,
			query.e1,
			$author$project$Element$RubricSubjectOverview$defaultTeamId(viewer));
		if (_v0.a.$ === 1) {
			if (!_v0.c.$) {
				var _v1 = _v0.a;
				var teamId = _v0.c.a;
				var initFilter = A2(
					$author$project$Element$RubricSubjectOverview$defaultFilter,
					teamId,
					A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.fK));
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			} else {
				return A2($author$project$Application$Boundaries$save, model, session);
			}
		} else {
			if (!_v0.b.b) {
				var teamId = _v0.a.a;
				var initFilter = A2(
					$author$project$Element$RubricSubjectOverview$defaultFilter,
					teamId,
					A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.fK));
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			} else {
				var teamId = _v0.a.a;
				var studentIds = _v0.b;
				var initFilter = {
					iu: _List_Nil,
					fK: A2($elm$core$Maybe$map, $elm$core$Basics$identity, query.fK),
					bp: teamId,
					e1: studentIds,
					jB: query.jB
				};
				return $author$project$Element$RubricSubjectOverview$andThenFetchData(
					A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bO: $elm$core$Maybe$Just(initFilter)
							}),
						session));
			}
		}
	});
var $author$project$Element$RubricSubjectOverview$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			dI: $author$project$RemoteData$NotAsked,
			bO: $elm$core$Maybe$Nothing,
			iu: $elm$core$Maybe$Nothing,
			jr: $author$project$RemoteData$NotAsked,
			e1: $author$project$RemoteData$NotAsked,
			jB: $author$project$RemoteData$NotAsked,
			ga: $NoRedInk$elm_sortable_table$Table$initialSort('')
		};
		var query = params;
		return A3($author$project$Element$RubricSubjectOverview$initPage, query, session, model);
	});
var $author$project$Locale$Messages$EvaluationListDownloadError = {$: 51};
var $author$project$Element$RubricSubjectOverview$NoOp = {$: 0};
var $author$project$Util$List$flatten = function (nestedList) {
	return A3($elm$core$List$foldl, $elm$core$Basics$append, _List_Nil, nestedList);
};
var $author$project$Element$RubricSubjectOverview$extractSubjectsFromEvaluations = function (evaluations) {
	return $author$project$Util$List$unique(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.e2;
			},
			$author$project$Util$List$flatten(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.jB;
					},
					evaluations))));
};
var $author$project$Element$RubricSubjectOverview$filterEvaluationsWithStudents = F2(
	function (evals, students) {
		var studentIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.gT;
			},
			A2($author$project$RemoteData$withDefault, _List_Nil, students));
		return A2(
			$elm$core$List$filter,
			function (e) {
				return $elm$core$List$isEmpty(studentIds) || A2($elm$core$List$member, e.ne.gT, studentIds);
			},
			evals);
	});
var $author$project$Element$RubricSubjectOverview$Exempted = {$: 1};
var $author$project$Element$RubricSubjectOverview$Grade = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$RubricSubjectOverview$NotApplicable = {$: 2};
var $author$project$Element$RubricSubjectOverview$gradeFromString = function (string) {
	switch (string) {
		case 'exempted':
			return $author$project$Element$RubricSubjectOverview$Exempted;
		case 'n/a':
			return $author$project$Element$RubricSubjectOverview$NotApplicable;
		default:
			var grade_as_string = string;
			var maybe_grade = $elm$core$String$toInt(grade_as_string);
			return A2(
				$elm$core$Maybe$withDefault,
				$author$project$Element$RubricSubjectOverview$NotApplicable,
				A2($elm$core$Maybe$map, $author$project$Element$RubricSubjectOverview$Grade, maybe_grade));
	}
};
var $author$project$Log$msgEvaluationsDownload = 'evaluations_download';
var $author$project$Log$paramScopeRubricSubjectOverview = 'scope_rubric_subject_overview';
var $author$project$Element$RubricSubjectOverview$schoolStudents = F2(
	function (school, students) {
		return A2(
			$elm$core$List$filter,
			$author$project$Student$goesToSchool,
			A2(
				$author$project$Person$studentsInTeams,
				_List_fromArray(
					[school]),
				students));
	});
var $author$project$Element$RubricSubjectOverview$filterToQuery = function (filter) {
	var blankQuery = $author$project$Route$blankLoStudentOverviewListQuery;
	return _Utils_update(
		blankQuery,
		{
			fK: A2($elm$core$Maybe$map, $author$project$Module$moduleIdToInt, filter.fK),
			bp: $elm$core$Maybe$Just(
				$author$project$Team$teamIdToInt(filter.bp)),
			e1: filter.e1,
			jB: filter.jB
		});
};
var $author$project$Element$RubricSubjectOverview$updateFilterUrl = F2(
	function (config, filter) {
		return A2(
			$author$project$Route$replaceUrl,
			config.iJ,
			$author$project$Route$RubricSubjectOverview(
				$author$project$Element$RubricSubjectOverview$filterToQuery(filter)));
	});
var $author$project$Element$RubricSubjectOverview$updateFilter = F3(
	function (updater, model, session) {
		var _v0 = model.bO;
		if (!_v0.$) {
			var filter_ = _v0.a;
			var newFilter = updater(filter_);
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				A2($author$project$Element$RubricSubjectOverview$updateFilterUrl, model.bN, newFilter),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bO: $elm$core$Maybe$Just(newFilter)
						}),
					session));
		} else {
			return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Element$RubricSubjectOverview$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var config = model.bN;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		switch (msg.$) {
			case 0:
				return A2($author$project$Application$Boundaries$save, model, session);
			case 1:
				var newState = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{ga: newState}),
					session);
			case 5:
				var values = msg.a;
				return A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{iu: values});
					},
					model,
					session);
			case 2:
				var values = msg.a;
				return A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{jB: values});
					},
					model,
					session);
			case 3:
				var values = msg.a;
				var _return = A3(
					$author$project$Element$RubricSubjectOverview$updateFilter,
					function (filter_) {
						return _Utils_update(
							filter_,
							{e1: values});
					},
					model,
					session);
				return _return;
			case 4:
				var value = msg.a;
				if (!value.$) {
					var teamId = value.a;
					return $author$project$Element$RubricSubjectOverview$andThenFetchData(
						A3(
							$author$project$Element$RubricSubjectOverview$updateFilter,
							function (filter_) {
								return _Utils_update(
									filter_,
									{bp: teamId, e1: _List_Nil, jB: _List_Nil});
							},
							_Utils_update(
								model,
								{jB: $author$project$RemoteData$NotAsked}),
							session));
				} else {
					return noop;
				}
			case 6:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{dI: data});
				switch (data.$) {
					case 2:
						var evals = data.a;
						var model3 = _Utils_update(
							model2,
							{
								jB: $author$project$RemoteData$Success(
									$author$project$Element$RubricSubjectOverview$extractSubjectsFromEvaluations(
										A2($author$project$Element$RubricSubjectOverview$filterEvaluationsWithStudents, evals, model.e1)))
							});
						return A2($author$project$Application$Boundaries$save, model3, session);
					case 3:
						var error = data.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgEvaluationsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
									error),
								$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$EvaluationListDownloadError))));
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 7:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{
						jr: A2(
							$author$project$RemoteData$map,
							function (schools) {
								return A2($author$project$Person$filterPersonTeams, schools, viewer);
							},
							data)
					});
				switch (data.$) {
					case 2:
						return A2($author$project$Application$Boundaries$save, model2, session);
					case 3:
						var error = data.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgTeamsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
									error),
								$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model2,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TeamListDownloadError))));
					default:
						return A2($author$project$Application$Boundaries$save, model2, session);
				}
			case 9:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{jB: data});
				var _v4 = _Utils_Tuple2(model.bO, data);
				_v4$2:
				while (true) {
					switch (_v4.b.$) {
						case 2:
							if (!_v4.a.$) {
								var filter = _v4.a.a;
								var subjects = _v4.b.a;
								var validSubjectIds = A2(
									$elm$core$List$map,
									function ($) {
										return $.gT;
									},
									subjects);
								var updatedFilter = _Utils_update(
									filter,
									{jB: validSubjectIds});
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model2,
										{
											bO: $elm$core$Maybe$Just(updatedFilter)
										}),
									session);
							} else {
								break _v4$2;
							}
						case 3:
							var error = _v4.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
										error),
									$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model2,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PhoneBookDownloadError))));
						default:
							break _v4$2;
					}
				}
				return A2($author$project$Application$Boundaries$save, model2, session);
			default:
				var data = msg.a;
				var model2 = _Utils_update(
					model,
					{e1: data});
				var _v5 = _Utils_Tuple2(model.bO, data);
				_v5$2:
				while (true) {
					switch (_v5.b.$) {
						case 2:
							if (!_v5.a.$) {
								var filter = _v5.a.a;
								var students = _v5.b.a;
								var validStudentIds = A2(
									$elm$core$List$filter,
									function (s) {
										return $elm$core$List$isEmpty(filter.e1) || A2($elm$core$List$member, s, filter.e1);
									},
									A2(
										$elm$core$List$map,
										function ($) {
											return $.gT;
										},
										A2($author$project$Element$RubricSubjectOverview$schoolStudents, filter.bp, students)));
								var validStudentGrades = A2(
									$elm$core$List$map,
									$author$project$Element$RubricSubjectOverview$gradeFromString,
									$author$project$Util$List$unique(
										$elm$core$List$sort(
											A2(
												$elm$core$List$map,
												function ($) {
													return $.id;
												},
												A2($author$project$Element$RubricSubjectOverview$schoolStudents, filter.bp, students)))));
								var updatedFilter = _Utils_update(
									filter,
									{iu: validStudentGrades, e1: validStudentIds});
								var model3 = _Utils_update(
									model2,
									{
										iu: $elm$core$Maybe$Just(validStudentGrades),
										e1: A2(
											$author$project$RemoteData$map,
											$elm$core$List$filter($author$project$Student$goesToSchool),
											data)
									});
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model3,
										{
											bO: $elm$core$Maybe$Just(updatedFilter)
										}),
									session);
							} else {
								break _v5$2;
							}
						case 3:
							var error = _v5.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeRubricSubjectOverview),
										error),
									$elm$core$Basics$always($author$project$Element$RubricSubjectOverview$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model2,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$PhoneBookDownloadError))));
						default:
							break _v5$2;
					}
				}
				return A2($author$project$Application$Boundaries$save, model2, session);
		}
	});
var $author$project$Locale$Messages$RubricSubjectOverviewNoStudents = {$: 457};
var $author$project$Locale$Messages$RubricSubjectOverviewProgress = {$: 458};
var $author$project$Locale$Messages$RubricSubjectOverviewNoEvaluations = {$: 456};
var $author$project$Locale$Messages$RubricSubjectOverviewSummary = {$: 460};
var $author$project$Locale$Messages$RubricSubjectOverviewAvailableFeedbackCount = {$: 465};
var $author$project$Locale$Messages$RubricSubjectOverviewGrade = {$: 463};
var $author$project$Locale$Messages$RubricSubjectOverviewMidYearFeedbackCount = {$: 466};
var $author$project$Locale$Messages$RubricSubjectOverviewName = {$: 462};
var $author$project$Locale$Messages$RubricSubjectOverviewSchool = {$: 461};
var $author$project$Locale$Messages$RubricSubjectOverviewSchoolYearFeedbackCount = {$: 467};
var $author$project$Locale$Messages$RubricSubjectOverviewSubject = {$: 464};
var $author$project$Element$RubricSubjectOverview$SetTableState = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$RubricSubjectOverview$tableViewConfig = function (t_) {
	var viewStudentText = A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.ne;
		},
		$author$project$Person$fullName(t_));
	var viewStudentLink = function (ess) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2(
						$author$project$Route$SubjectFeedbackCard,
						ess.ne.gT,
						$elm$core$Maybe$Just(ess.e2.e2.gT)))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					viewStudentText(ess))
				]));
	};
	var toId = function (ess) {
		return $elm$core$String$fromInt(ess.ne.gT) + ('x' + $elm$core$String$fromInt(ess.e2.e2.gT));
	};
	var customizations = $NoRedInk$elm_sortable_table$Table$defaultCustomizations;
	return $NoRedInk$elm_sortable_table$Table$customConfig(
		{
			kB: _List_fromArray(
				[
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSchool),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ne;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bp;
							},
							function ($) {
								return $.kP;
							}))),
					A3(
					$author$project$UI$Table$htmlColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewName),
					viewStudentText,
					viewStudentLink),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewGrade),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ne;
						},
						function ($) {
							return $.gO;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$stringColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSubject),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e2;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.e2;
							},
							function ($) {
								return $.ha;
							}))),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewAvailableFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e2;
						},
						function ($) {
							return $.ko;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewMidYearFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e2;
						},
						function ($) {
							return $.j8;
						})),
					A2(
					$NoRedInk$elm_sortable_table$Table$intColumn,
					t_($author$project$Locale$Messages$RubricSubjectOverviewSchoolYearFeedbackCount),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.e2;
						},
						function ($) {
							return $.j7;
						}))
				]),
			kI: _Utils_update(
				customizations,
				{
					ni: _List_fromArray(
						[
							$elm$html$Html$Attributes$class('table is-fullwidth is-bordered is-striped is-narrow is-size-7')
						])
				}),
			nt: toId,
			bZ: $author$project$Element$RubricSubjectOverview$SetTableState
		});
};
var $author$project$Element$RubricSubjectOverview$SetGradesFilter = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$RubricSubjectOverview$gradeToString = function (grade) {
	switch (grade.$) {
		case 0:
			var g = grade.a;
			return $elm$core$String$fromInt(g);
		case 1:
			return 'exempted';
		default:
			return 'n/a';
	}
};
var $author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter = F2(
	function (t_, _v0) {
		var data = _v0.gB;
		var toSelectMsg = _v0.hF;
		var caption = _v0.gw;
		var toOptions = _v0.hE;
		var viewOption = _v0.hI;
		var viewSelectLinks = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-size-7')
					]),
				_List_fromArray(
					[
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(lst),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectAll)
							])),
						$elm$html$Html$text(' | '),
						A3(
						$author$project$UI$actionLink,
						toSelectMsg(_List_Nil),
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$FormSelectNone)
							]))
					]));
		};
		var view_ = function (lst) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('column')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$fieldset,
						_List_Nil,
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$legend,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('label')
									]),
								_List_fromArray(
									[caption])),
							$elm$core$List$isEmpty(lst) ? _List_fromArray(
								[
									$author$project$UI$Icon$loadingOptions(_List_Nil)
								]) : A2(
								$elm$core$List$map,
								viewOption,
								toOptions(lst)))),
						A2(
						$author$project$UI$when,
						!$elm$core$List$isEmpty(lst),
						viewSelectLinks(lst))
					]));
		};
		if (data.$ === 1) {
			return view_(_List_Nil);
		} else {
			if (!data.a.b) {
				return $author$project$UI$none;
			} else {
				var lst = data.a;
				return view_(lst);
			}
		}
	});
var $author$project$Element$RubricSubjectOverview$viewGradeFilter = F3(
	function (t_, options, selected) {
		var viewGradeOption = function (option) {
			return A5(
				$author$project$UI$checkbox,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map($author$project$Element$RubricSubjectOverview$gradeFromString),
					$author$project$Element$RubricSubjectOverview$SetGradesFilter),
				'grades-filter-schoolyear',
				$elm$core$Basics$always(false),
				A2($elm$core$List$map, $author$project$Element$RubricSubjectOverview$gradeToString, selected),
				option);
		};
		var toGradeChoice = function (grade) {
			return _Utils_Tuple2(
				$author$project$Element$RubricSubjectOverview$gradeToString(grade),
				$author$project$Element$RubricSubjectOverview$gradeToString(grade));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewGrade),
				gB: options,
				hE: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(toGradeChoice),
					$author$project$Form$toSelectOptions),
				hF: $author$project$Element$RubricSubjectOverview$SetGradesFilter,
				hI: viewGradeOption
			});
	});
var $author$project$Element$RubricSubjectOverview$viewPageHeading = function (t_) {
	return $author$project$UI$title(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewTitle)
			]));
};
var $author$project$Locale$Messages$LoStudentOverviewStudentOptionLabel = F2(
	function (a, b) {
		return {$: 191, a: a, b: b};
	});
var $author$project$Element$RubricSubjectOverview$SetStudentFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$RubricSubjectOverview$fromStudentsToValue = function (students) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, students);
};
var $author$project$Element$RubricSubjectOverview$fromValueToStudents = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $author$project$Element$RubricSubjectOverview$viewStudentFilter = F3(
	function (t_, maybeStudents, filter) {
		var viewCheckbox = A4(
			$author$project$UI$checkbox,
			A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetStudentFilter, $author$project$Element$RubricSubjectOverview$fromValueToStudents),
			'filter-students',
			$elm$core$Basics$always(false),
			$author$project$Element$RubricSubjectOverview$fromStudentsToValue(filter.e1));
		var toStudentOptions = function (students) {
			return A2(
				$elm$core$List$map,
				function (student) {
					var name = A2($author$project$Person$fullName, t_, student);
					return $author$project$Form$toSelectOption(
						_Utils_Tuple2(
							$elm$core$String$fromInt(student.gT),
							t_(
								A2($author$project$Locale$Messages$LoStudentOverviewStudentOptionLabel, name, student.id))));
				},
				A2(
					$author$project$Util$List$sortBy,
					$author$project$Person$fullName(t_),
					students));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PortfoliosFilterStudents),
				gB: A2(
					$elm$core$Maybe$map,
					$author$project$Element$RubricSubjectOverview$schoolStudents(filter.bp),
					maybeStudents),
				hE: toStudentOptions,
				hF: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function ($) {
							return $.gT;
						}),
					$author$project$Element$RubricSubjectOverview$SetStudentFilter),
				hI: viewCheckbox
			});
	});
var $author$project$Element$RubricSubjectOverview$SetSubjectFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$RubricSubjectOverview$fromSubjectsToValue = function (subjects) {
	return A2($elm$core$List$map, $elm$core$String$fromInt, subjects);
};
var $author$project$Element$RubricSubjectOverview$fromValueToSubjects = function (values) {
	return A2($elm$core$List$filterMap, $elm$core$String$toInt, values);
};
var $author$project$Element$RubricSubjectOverview$viewSubjectFilter = F3(
	function (t_, maybeSubjects, selectedSubjects) {
		var viewCheckbox = A4(
			$author$project$UI$checkbox,
			A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetSubjectFilter, $author$project$Element$RubricSubjectOverview$fromValueToSubjects),
			'filter-subject',
			$elm$core$Basics$always(false),
			$author$project$Element$RubricSubjectOverview$fromSubjectsToValue(selectedSubjects));
		var toSubjectOptions = function (subjects) {
			return $author$project$Form$toSortedSelectOptions(
				A2(
					$elm$core$List$map,
					function (subject) {
						return _Utils_Tuple2(
							$elm$core$String$fromInt(subject.gT),
							subject.ha);
					},
					subjects));
		};
		return A2(
			$author$project$Element$RubricSubjectOverview$viewMultiChoicesFilter,
			t_,
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$LoStudentOverviewSubjects),
				gB: maybeSubjects,
				hE: toSubjectOptions,
				hF: A2(
					$elm$core$Basics$composeR,
					$elm$core$List$map(
						function ($) {
							return $.gT;
						}),
					$author$project$Element$RubricSubjectOverview$SetSubjectFilter),
				hI: viewCheckbox
			});
	});
var $author$project$Element$RubricSubjectOverview$SetSchoolFilter = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$RubricSubjectOverview$viewTeamFilter = F3(
	function (t_, maybeSchools, selectedSchool) {
		var viewSchoolOptions = function (schools) {
			return A2(
				$elm$core$List$map,
				A3(
					$author$project$UI$radioButton,
					A2($elm$core$Basics$composeL, $author$project$Element$RubricSubjectOverview$SetSchoolFilter, $author$project$Team$fromValueToTeam),
					'filter-school',
					$author$project$Team$fromTeamToValue(selectedSchool)),
				$author$project$Form$toTeamOptions(schools));
		};
		return $author$project$UI$filterOptions(
			{
				gw: A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradesOverviewSchool),
				gQ: false,
				mp: maybeSchools,
				hJ: viewSchoolOptions
			});
	});
var $author$project$Element$RubricSubjectOverview$viewPage = F3(
	function (t_, _v0, filter) {
		var tableState = _v0.ga;
		var schools = _v0.jr;
		var students = _v0.e1;
		var subjects = _v0.jB;
		var evaluations = _v0.dI;
		var grades = _v0.iu;
		var viewFilters = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container columns')
				]),
			_List_fromArray(
				[
					A3(
					$author$project$Element$RubricSubjectOverview$viewTeamFilter,
					t_,
					$author$project$RemoteData$toMaybe(schools),
					filter.bp),
					A3(
					$author$project$Element$RubricSubjectOverview$viewStudentFilter,
					t_,
					$author$project$RemoteData$toMaybe(students),
					filter),
					A3(
					$author$project$Element$RubricSubjectOverview$viewSubjectFilter,
					t_,
					$author$project$RemoteData$toMaybe(subjects),
					filter.jB),
					A3($author$project$Element$RubricSubjectOverview$viewGradeFilter, t_, grades, filter.iu)
				]));
		var flattenEval = function (_eval) {
			return A2(
				$elm$core$List$map,
				function (s) {
					return {ne: _eval.ne, e2: s};
				},
				_eval.jB);
		};
		var flattenEvals = function (evals) {
			return $author$project$Util$List$flatten(
				A2($elm$core$List$map, flattenEval, evals));
		};
		var filterEvals = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$List$filter(
					function (_eval) {
						return A2($elm$core$List$member, _eval.e2.e2.gT, filter.jB);
					}),
				$elm$core$List$filter(
					function (_eval) {
						return A2($elm$core$List$member, _eval.ne.gT, filter.e1);
					})),
			$elm$core$List$filter(
				function (_eval) {
					return A2(
						$elm$core$List$member,
						$author$project$Element$RubricSubjectOverview$Grade(_eval.ne.gO),
						filter.iu);
				}));
		var filteredEvals = function (evals) {
			return filterEvals(
				flattenEvals(evals));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Element$RubricSubjectOverview$viewPageHeading(t_),
					$author$project$UI$notification(
					$author$project$UI$textToHtml(
						t_($author$project$Locale$Messages$RubricSubjectOverviewSummary))),
					viewFilters,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-relative')
						]),
					_List_fromArray(
						[
							function () {
							if (evaluations.$ === 2) {
								if (!evaluations.a.b) {
									return $author$project$UI$notification(
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewNoEvaluations)
											]));
								} else {
									var evals = evaluations.a;
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('box')
											]),
										_List_fromArray(
											[
												A3(
												$NoRedInk$elm_sortable_table$Table$view,
												$author$project$Element$RubricSubjectOverview$tableViewConfig(t_),
												tableState,
												filteredEvals(evals))
											]));
								}
							} else {
								return $author$project$UI$List$resultsLoadingProgressBar;
							}
						}()
						]))
				]));
	});
var $author$project$Element$RubricSubjectOverview$view = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var viewPageLoadingBar = A2(
			$author$project$UI$progressBar,
			'is-info',
			t_($author$project$Locale$Messages$RubricSubjectOverviewProgress));
		var _v1 = _Utils_Tuple2(model.dI, model.bO);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 2) {
				if (!_v1.a.a.b) {
					return $author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$RubricSubjectOverviewNoStudents)
							]));
				} else {
					if (!_v1.b.$) {
						var filter = _v1.b.a;
						return A3($author$project$Element$RubricSubjectOverview$viewPage, t_, model, filter);
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return viewPageLoadingBar;
	});
var $author$project$Element$RubricSubjectOverview$element = {iA: $author$project$Element$RubricSubjectOverview$init, jR: $author$project$Element$RubricSubjectOverview$update, nE: $author$project$Element$RubricSubjectOverview$view};
var $author$project$Element$StudentAbsenceList$AbsencesDownloaded = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$BatchEffect = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$Cmd = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentAbsenceList$DownloadAbsences = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentAbsenceList$DownloadStudent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentAbsenceList$StudentDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$studentAbsenceList = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(studentId),
					'absences'
				]),
			_List_Nil);
	});
var $author$project$StudentAbsence$StudentAbsence = F9(
	function (id, student, isJustified, state, startDate, endDate, minutes, reasonText, reasonUrl) {
		return {gH: endDate, gT: id, lv: isJustified, l5: minutes, jj: reasonText, fX: reasonUrl, hv: startDate, eZ: state, ne: student};
	});
var $author$project$StudentAbsence$JustifiedByDoctor = 2;
var $author$project$StudentAbsence$JustifiedByMentor = 3;
var $author$project$StudentAbsence$JustifiedByParent = 1;
var $author$project$StudentAbsence$Questioned = 4;
var $author$project$StudentAbsence$Unjustified = 0;
var $author$project$StudentAbsence$absenceStateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'unjustified':
				return $elm$json$Json$Decode$succeed(0);
			case 'justified_by_parent':
				return $elm$json$Json$Decode$succeed(1);
			case 'justified_by_doctor':
				return $elm$json$Json$Decode$succeed(2);
			case 'justified_by_mentor':
				return $elm$json$Json$Decode$succeed(3);
			case 'questioned':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid StudentAbsence.state value ' + str);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$StudentAbsence$studentAbsenceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'reason_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'reason_text',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'minutes',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'end_date',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'start_date',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'state',
						$author$project$StudentAbsence$absenceStateDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'is_justified',
							$elm$json$Json$Decode$bool,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'student',
								$author$project$Person$nestedPersonDecoder,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'id',
									$elm$json$Json$Decode$int,
									$elm$json$Json$Decode$succeed($author$project$StudentAbsence$StudentAbsence))))))))));
var $author$project$StudentAbsence$studentAbsenceListDecoder = $elm$json$Json$Decode$list($author$project$StudentAbsence$studentAbsenceDecoder);
var $author$project$StudentAbsence$fetchStudentAbsenceList = F3(
	function (config, studentId, callback) {
		return {
			bN: config,
			dC: $author$project$StudentAbsence$studentAbsenceListDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$studentAbsenceList, config, studentId)
		};
	});
var $author$project$Element$StudentAbsenceList$Description = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentAbsenceList$JustificationFormMsg = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$StudentAbsenceList$MediaUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceJustificationDescription = {$: 475};
var $author$project$Locale$Messages$StudentAbsenceJustificationMedia = {$: 476};
var $author$project$Element$StudentAbsenceList$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/jpeg', 'image/png']);
var $author$project$Element$StudentAbsenceList$maxFileSize = (20 * 1024) * 1024;
var $author$project$Element$StudentAbsenceList$initJustificationForm = function (t_) {
	return {
		gD: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gD: value});
				}),
			nD: function ($) {
				return $.gD;
			},
			nE: {
				kJ: 'description',
				lj: 'fa-edit',
				lO: '',
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$Description),
				bv: t_($author$project$Locale$Messages$StudentAbsenceJustificationDescription),
				hH: 'text'
			}
		},
		u: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentAbsenceList$acceptedMimeTypes, lX: $author$project$Element$StudentAbsenceList$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{lY: value});
				}),
			nD: function ($) {
				return $.lY;
			},
			nE: {
				kJ: 'justification',
				lj: 'fa-image',
				lO: t_($author$project$Locale$Messages$StudentAbsenceJustificationMedia),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$MediaUrl),
				bv: t_($author$project$Locale$Messages$StudentAbsenceJustificationMedia)
			}
		}
	};
};
var $author$project$Element$StudentAbsenceList$initJustificationFormValues = F2(
	function (desc, media) {
		return {gD: desc, lY: media};
	});
var $author$project$Element$StudentAbsenceList$initJustificationFormModel = function (t_) {
	return {
		bt: $author$project$Element$StudentAbsenceList$initJustificationForm(t_),
		eZ: 0,
		ej: A2($author$project$Element$StudentAbsenceList$initJustificationFormValues, '', $author$project$Form$NoFile)
	};
};
var $author$project$Element$StudentAbsenceList$init = F3(
	function (config, session, _v0) {
		var studentId = _v0.jz;
		return _Utils_Tuple3(
			{
				dt: $author$project$RemoteData$NotAsked,
				bN: config,
				dE: $elm$core$Maybe$Nothing,
				D: $author$project$Element$StudentAbsenceList$initJustificationFormModel(session.hy),
				c$: $elm$core$Maybe$Nothing,
				c0: $elm$core$Maybe$Nothing,
				cv: session,
				ne: $author$project$RemoteData$NotAsked
			},
			$author$project$Element$StudentAbsenceList$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$StudentAbsenceList$Cmd(
						$author$project$Element$StudentAbsenceList$DownloadStudent(
							A3($author$project$StudentProfile$fetchStudentProfileV3, config.gr, studentId, $author$project$Element$StudentAbsenceList$StudentDownloaded))),
						$author$project$Element$StudentAbsenceList$Cmd(
						$author$project$Element$StudentAbsenceList$DownloadAbsences(
							A3($author$project$StudentAbsence$fetchStudentAbsenceList, config.gr, studentId, $author$project$Element$StudentAbsenceList$AbsencesDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$StudentAbsenceList$DocumentViewerEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentAbsenceList$DocumentViewerMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$StudentAbsenceList$documentViewer = {
	gF: $author$project$Element$DocumentViewer$element,
	jK: $author$project$Element$StudentAbsenceList$DocumentViewerEffect,
	bZ: $author$project$Element$StudentAbsenceList$DocumentViewerMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dE: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$StudentAbsenceList$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effect_ = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, effect_, $author$project$Element$StudentAbsenceList$documentViewer);
			case 2:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$StudentAbsenceList$perform(key),
						effects));
			default:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 3:
						var mimeTypes = cmd.a;
						var toMsg = cmd.b;
						return A2($elm$file$File$Select$file, mimeTypes, toMsg);
					case 4:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 5:
						var request = cmd.a;
						return $author$project$Api$postExpectingHeadersV2(request);
					case 6:
						var request = cmd.a;
						return $author$project$Api$patchV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$patchV2(request);
				}
		}
	});
var $author$project$Element$StudentAbsenceList$JustifyStudentAbsence = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$StudentAbsenceList$LogError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentAbsenceList$MediaFileSelected = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$MediaFileUploaded = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$MediaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$NoEffect = {$: 0};
var $author$project$Element$StudentAbsenceList$NoOp = {$: 0};
var $author$project$Element$StudentAbsenceList$QuestionStudentAbsence = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentAbsenceList$RequestPolicy = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentAbsenceList$SelectFile = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentAbsenceJustificationError = {$: 479};
var $author$project$Locale$Messages$StudentAbsenceJustificationSaveSuccess = {$: 478};
var $author$project$Element$StudentAbsenceList$StudentAbsenceSaved = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentAbsenceList$UploadFile = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentAbsenceList$awsPolicyScope = 'portfolio';
var $author$project$Log$msgStudentAbsenceJustificationUnknownError = 'student_absence_unknown_error';
var $author$project$Element$StudentAbsenceList$customErrorNotificationAndLog = F3(
	function (config, session, customMessage) {
		var error = $author$project$Api$CustomError(customMessage);
		return _Utils_Tuple2(
			A3(
				$author$project$Session$error,
				session,
				error,
				session.hy($author$project$Locale$Messages$StudentAbsenceJustificationError)),
			$author$project$Element$StudentAbsenceList$Cmd(
				$author$project$Element$StudentAbsenceList$LogError(
					A3(
						$author$project$Log$errorV2,
						config,
						_Utils_Tuple3($author$project$Log$msgStudentAbsenceJustificationUnknownError, $elm$core$Maybe$Nothing, error),
						$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp)))));
	});
var $author$project$Element$StudentAbsenceList$isJustificationFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gD, values) && A2($author$project$Form$isFieldValid, form.u, values);
	});
var $author$project$Api$Endpoint$studentAbsence = F2(
	function (config, absenceId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'absences',
					$elm$core$String$fromInt(absenceId)
				]),
			_List_Nil);
	});
var $author$project$StudentAbsence$absenceStateEncoder = function (state) {
	switch (state) {
		case 0:
			return $elm$json$Json$Encode$string('unjustified');
		case 1:
			return $elm$json$Json$Encode$string('justified_by_parent');
		case 2:
			return $elm$json$Json$Encode$string('justified_by_doctor');
		case 3:
			return $elm$json$Json$Encode$string('justified_by_mentor');
		default:
			return $elm$json$Json$Encode$string('questioned');
	}
};
var $author$project$StudentAbsence$studentAbsenceEncoder = function (absence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(absence.gT)),
				_Utils_Tuple2(
				'state',
				$author$project$StudentAbsence$absenceStateEncoder(absence.eZ)),
				_Utils_Tuple2(
				'reason_text',
				$elm$json$Json$Encode$string(absence.jj)),
				_Utils_Tuple2(
				'reason_url',
				$elm$json$Json$Encode$string(absence.fX))
			]));
};
var $author$project$StudentAbsence$justifyAbsence = F3(
	function (config, absence, callback) {
		return {
			O: $author$project$StudentAbsence$studentAbsenceEncoder(absence),
			bN: config,
			dC: $author$project$StudentAbsence$studentAbsenceDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$studentAbsence, config.gr, absence.gT)
		};
	});
var $author$project$Log$paramScopeStudentAbsenceList = 'scope_student_absence_list';
var $author$project$Locale$Messages$JustifyingDocumentRequired = {$: 129};
var $author$project$Form$requiredFileWithCustomMessage = F4(
	function (t_, constraints, errorMessage, value) {
		switch (value.$) {
			case 0:
				return $elm$core$Result$Err(
					t_(errorMessage));
			case 1:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			case 3:
				var file = value.a;
				return A3($author$project$Form$validateFile, t_, constraints, file);
			default:
				var url = value.a;
				return $elm$core$Result$Ok(url);
		}
	});
var $author$project$Element$StudentAbsenceList$requireMedia = F2(
	function (t_, formModel) {
		var mediaUrl = formModel.bt.u;
		var form = formModel.bt;
		var errorMessage = $author$project$Locale$Messages$JustifyingDocumentRequired;
		var updatedParser = A3(
			$author$project$Form$requiredFileWithCustomMessage,
			t_,
			{j2: $author$project$Element$StudentAbsenceList$acceptedMimeTypes, lX: $author$project$Element$StudentAbsenceList$maxFileSize},
			errorMessage);
		return _Utils_update(
			formModel,
			{
				bt: _Utils_update(
					form,
					{
						u: _Utils_update(
							mediaUrl,
							{mu: updatedParser, mK: true})
					})
			});
	});
var $author$project$Element$StudentAbsenceList$saveJustificationForm = F2(
	function (_v0, _v1) {
		var form = _v0.bt;
		var values = _v0.ej;
		var type_ = _v1.hH;
		var absence = _v1.ds;
		var state = function () {
			switch (type_) {
				case 0:
					return 2;
				case 1:
					return 1;
				default:
					return 3;
			}
		}();
		var saveMediaUrl = function () {
			var _v2 = form.u.nD(values);
			if (!_v2.$) {
				return '';
			} else {
				var file = _v2;
				return $author$project$Form$toFileUrl(file);
			}
		}();
		return _Utils_update(
			absence,
			{jj: values.gD, fX: saveMediaUrl, eZ: state});
	});
var $author$project$Element$StudentAbsenceList$updateJustificationFormModel = F2(
	function (formMsg, formModel) {
		var form = formModel.bt;
		var values = formModel.ej;
		var editedFormModel = _Utils_update(
			formModel,
			{eZ: 1});
		switch (formMsg.$) {
			case 0:
				var value = formMsg.a;
				return _Utils_update(
					editedFormModel,
					{
						bt: _Utils_update(
							form,
							{
								gD: $author$project$Form$markEdited(form.gD)
							}),
						ej: A2(form.gD.jR, value, values)
					});
			case 1:
				var value = formMsg.a;
				return _Utils_update(
					editedFormModel,
					{
						bt: _Utils_update(
							form,
							{
								u: $author$project$Form$markEdited(form.u)
							}),
						ej: A2(
							form.u.jR,
							$author$project$Form$fromFileUrl(value),
							values)
					});
			default:
				return formModel;
		}
	});
var $author$project$Util$List$updateWhen = F2(
	function (tester, updater) {
		return $elm$core$List$map(
			function (elem) {
				return tester(elem) ? updater(elem) : elem;
			});
	});
var $author$project$Element$StudentAbsenceList$validateJustificationForm = function (form) {
	return _Utils_update(
		form,
		{
			gD: $author$project$Form$markEdited(form.gD),
			u: $author$project$Form$markEdited(form.u)
		});
};
var $author$project$Element$StudentAbsenceList$update = F2(
	function (msg, model) {
		update:
		while (true) {
			var config = model.bN;
			var session = model.cv;
			switch (msg.$) {
				case 1:
					var data = msg.a;
					switch (data.$) {
						case 2:
							var studentProfile = data.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										ne: $author$project$RemoteData$Success(
											$author$project$StudentProfile$asStudent(studentProfile))
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 3:
							var error = data.a;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										cv: A3(
											$author$project$Session$error,
											model.cv,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormDownloadError))
									}),
								$author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgStudentProfileDownload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeStudentAbsenceList),
												error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp)))),
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{ne: $author$project$RemoteData$Loading}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{ne: $author$project$RemoteData$NotAsked}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
					}
				case 2:
					var data = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{dt: data}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 6:
					var request = msg.a;
					var initialModel = _Utils_update(
						model,
						{
							D: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.cv.hy),
							c$: $elm$core$Maybe$Just(request)
						});
					var updatedModel = function () {
						var _v2 = request.hH;
						if (!_v2) {
							return _Utils_update(
								initialModel,
								{
									D: A2($author$project$Element$StudentAbsenceList$requireMedia, session.hy, initialModel.D)
								});
						} else {
							return initialModel;
						}
					}();
					return _Utils_Tuple3(updatedModel, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
				case 7:
					var formModel = model.D;
					var form = formModel.bt;
					var _v3 = model.c$;
					if (!_v3.$) {
						var request = _v3.a;
						if (A2($author$project$Element$StudentAbsenceList$isJustificationFormValid, model.D.bt, model.D.ej)) {
							var justifiedAbsence = A2($author$project$Element$StudentAbsenceList$saveJustificationForm, formModel, request);
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										D: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.cv.hy),
										c$: $elm$core$Maybe$Nothing
									}),
								$author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$JustifyStudentAbsence(
										A3($author$project$StudentAbsence$justifyAbsence, config, justifiedAbsence, $author$project$Element$StudentAbsenceList$StudentAbsenceSaved))),
								$elm$core$Maybe$Nothing);
						} else {
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										D: _Utils_update(
											formModel,
											{
												bt: $author$project$Element$StudentAbsenceList$validateJustificationForm(form)
											})
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						var _v4 = A3($author$project$Element$StudentAbsenceList$customErrorNotificationAndLog, model.bN, session, 'Expected but missing StudentAbsenceList.Model.pendingJustificationRequest');
						var updatedSession = _v4.a;
						var effect = _v4.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cv: updatedSession}),
							effect,
							$elm$core$Maybe$Nothing);
					}
				case 8:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								D: $author$project$Element$StudentAbsenceList$initJustificationFormModel(model.cv.hy),
								c$: $elm$core$Maybe$Nothing
							}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 3:
					var absence = msg.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								c0: $elm$core$Maybe$Just(absence)
							}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 4:
					var _v5 = model.c0;
					if (!_v5.$) {
						var absence = _v5.a;
						var questionedAbsence = _Utils_update(
							absence,
							{eZ: 4});
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{c0: $elm$core$Maybe$Nothing}),
							$author$project$Element$StudentAbsenceList$Cmd(
								$author$project$Element$StudentAbsenceList$QuestionStudentAbsence(
									A3($author$project$StudentAbsence$justifyAbsence, config, questionedAbsence, $author$project$Element$StudentAbsenceList$StudentAbsenceSaved))),
							$elm$core$Maybe$Nothing);
					} else {
						var _v6 = A3($author$project$Element$StudentAbsenceList$customErrorNotificationAndLog, model.bN, session, 'Expected but missing StudentAbsenceList.Model.pendingQuestionedAbsence');
						var updatedSession = _v6.a;
						var effect = _v6.b;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{cv: updatedSession}),
							effect,
							$elm$core$Maybe$Nothing);
					}
				case 5:
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{c0: $elm$core$Maybe$Nothing}),
						$author$project$Element$StudentAbsenceList$NoEffect,
						$elm$core$Maybe$Nothing);
				case 9:
					var data = msg.a;
					switch (data.$) {
						case 2:
							var updatedAbsence = data.a;
							var updatedSession = A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$StudentAbsenceJustificationSaveSuccess));
							var updateAbsenceList = A2(
								$author$project$Util$List$updateWhen,
								function (a) {
									return _Utils_eq(a.gT, updatedAbsence.gT);
								},
								$elm$core$Basics$always(updatedAbsence));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										dt: A2($author$project$RemoteData$map, updateAbsenceList, model.dt),
										cv: updatedSession
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
						case 3:
							var error = data.a;
							var updatedSession = A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$StudentAbsenceJustificationError));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{cv: updatedSession}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						default:
							var error = $author$project$Api$CustomError('Unexpected msg (StudentAbsenceSaved RemoteData.NotAsked)');
							var updatedSession = A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$StudentAbsenceJustificationError));
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{cv: updatedSession}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
					}
				case 11:
					var location = msg.a;
					return A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$StudentAbsenceList$documentViewer,
						A4(
							$author$project$Application$V3$Boundaries$initElement,
							config,
							session,
							$author$project$Element$StudentAbsenceList$documentViewer,
							{eM: $elm$core$Maybe$Nothing, G: location}));
				case 12:
					var documentViewerMsg = msg.a;
					var _v8 = model.dE;
					if (!_v8.$) {
						var documentViewerModel = _v8.a;
						var _v9 = A3(
							$author$project$Application$V3$Boundaries$mapElement,
							model,
							$author$project$Element$StudentAbsenceList$documentViewer,
							A4($author$project$Application$V3$Boundaries$updateElement, session, documentViewerMsg, documentViewerModel, $author$project$Element$StudentAbsenceList$documentViewer));
						var model2 = _v9.a;
						var effect = _v9.b;
						return _Utils_Tuple3(
							_Utils_update(
								model2,
								{dE: $elm$core$Maybe$Nothing}),
							effect,
							$elm$core$Maybe$Nothing);
					} else {
						return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
					}
				case 10:
					var formMsg = msg.a;
					switch (formMsg.$) {
						case 0:
							var formModel = model.D;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										D: A2($author$project$Element$StudentAbsenceList$updateJustificationFormModel, formMsg, formModel)
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 1:
							var formModel = model.D;
							return _Utils_Tuple3(
								_Utils_update(
									model,
									{
										D: A2($author$project$Element$StudentAbsenceList$updateJustificationFormModel, formMsg, formModel)
									}),
								$author$project$Element$StudentAbsenceList$NoEffect,
								$elm$core$Maybe$Nothing);
						case 2:
							var documentAvailableMsg = formMsg.a;
							var documentType = formMsg.b;
							return _Utils_Tuple3(
								model,
								$author$project$Element$StudentAbsenceList$Cmd(
									A2(
										$author$project$Element$StudentAbsenceList$SelectFile,
										$author$project$Element$StudentAbsenceList$acceptedMimeTypes,
										A2(
											$elm$core$Basics$composeL,
											$author$project$Element$StudentAbsenceList$JustificationFormMsg,
											A2($author$project$Element$StudentAbsenceList$MediaFileSelected, documentAvailableMsg, documentType)))),
								$elm$core$Maybe$Nothing);
						case 4:
							if (!formMsg.c.$) {
								var documentAvailableMsg = formMsg.a;
								var file = formMsg.b;
								var policy = formMsg.c.a;
								return _Utils_Tuple3(
									model,
									$author$project$Element$StudentAbsenceList$Cmd(
										$author$project$Element$StudentAbsenceList$UploadFile(
											A4(
												$author$project$S3$uploadFileV2,
												config.gr,
												policy,
												file,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Element$StudentAbsenceList$JustificationFormMsg,
													A2($author$project$Element$StudentAbsenceList$MediaFileUploaded, documentAvailableMsg, file))))),
									$elm$core$Maybe$Nothing);
							} else {
								var error = formMsg.c.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var removeMediaUrl = function (_v11) {
									var state = _v11.eZ;
									var form = _v11.bt;
									var values = _v11.ej;
									return {
										bt: form,
										eZ: state,
										ej: A2(form.u.jR, $author$project$Form$NoFile, values)
									};
								};
								var effect = $author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											D: removeMediaUrl(model.D),
											cv: updatedSession
										}),
									effect,
									$elm$core$Maybe$Nothing);
							}
						case 3:
							var documentAvailableMsg = formMsg.a;
							var documentType = formMsg.b;
							var file = formMsg.c;
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(session.nH.gT),
								mV: $author$project$Element$StudentAbsenceList$awsPolicyScope
							};
							var formModel = model.D;
							var values = formModel.ej;
							var form = formModel.bt;
							var mediaUrl = form.u;
							var valuesWithFileError = A2(
								mediaUrl.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var valuesWithFileSelected = A2(
								mediaUrl.jR,
								$author$project$Form$FileSelected(file),
								values);
							if (A2($author$project$Form$isFieldValid, mediaUrl, valuesWithFileSelected)) {
								var justificationFormModel = _Utils_update(
									formModel,
									{
										bt: _Utils_update(
											form,
											{
												u: $author$project$Form$markEdited(form.u)
											}),
										ej: valuesWithFileSelected
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{D: justificationFormModel}),
									$author$project$Element$StudentAbsenceList$Cmd(
										$author$project$Element$StudentAbsenceList$RequestPolicy(
											A3(
												$author$project$S3$requestPolicyV2,
												config.gr,
												params,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Element$StudentAbsenceList$JustificationFormMsg,
													A2($author$project$Element$StudentAbsenceList$MediaPolicyDownloaded, documentAvailableMsg, file))))),
									$elm$core$Maybe$Nothing);
							} else {
								var justificationFormModel = _Utils_update(
									formModel,
									{
										bt: _Utils_update(
											form,
											{
												u: $author$project$Form$markEdited(form.u)
											}),
										ej: valuesWithFileError
									});
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{D: justificationFormModel}),
									$author$project$Element$StudentAbsenceList$NoEffect,
									$elm$core$Maybe$Nothing);
							}
						default:
							if (!formMsg.c.$) {
								var documentAvailableMsg = formMsg.a;
								var file = formMsg.b;
								var metadata = formMsg.c.a;
								var _v12 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v12.$) {
									var location = _v12.a;
									var $temp$msg = documentAvailableMsg(location),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$msg = $author$project$Element$StudentAbsenceList$JustificationFormMsg(
										A3(
											$author$project$Element$StudentAbsenceList$MediaFileUploaded,
											documentAvailableMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata)))),
										$temp$model = model;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								var error = formMsg.c.a;
								var updatedSession = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var removeMediaUrl = function (_v13) {
									var state = _v13.eZ;
									var form = _v13.bt;
									var values = _v13.ej;
									return {
										bt: form,
										eZ: state,
										ej: A2(form.u.jR, $author$project$Form$NoFile, values)
									};
								};
								var effect = $author$project$Element$StudentAbsenceList$Cmd(
									$author$project$Element$StudentAbsenceList$LogError(
										A3(
											$author$project$Log$errorV2,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgFileUpload,
												$elm$core$Maybe$Just($author$project$Log$paramScopeStudentAbsenceList),
												error),
											$elm$core$Basics$always($author$project$Element$StudentAbsenceList$NoOp))));
								return _Utils_Tuple3(
									_Utils_update(
										model,
										{
											D: removeMediaUrl(model.D),
											cv: updatedSession
										}),
									effect,
									$elm$core$Maybe$Nothing);
							}
					}
				default:
					return _Utils_Tuple3(model, $author$project$Element$StudentAbsenceList$NoEffect, $elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Locale$Messages$StudentAbsenceListLoadingError = {$: 481};
var $author$project$Locale$Messages$StudentAbsenceListLoadingProgress = {$: 482};
var $author$project$Locale$Messages$StudentAbsenceListNoAbsences = {$: 483};
var $author$project$Locale$Messages$StudentAbsenceListTitle = function (a) {
	return {$: 484, a: a};
};
var $author$project$Element$StudentAbsenceList$defaultFilterAbsences = function () {
	var absenceHasMinutes = function (absence) {
		return absence.l5 > 0;
	};
	return $elm$core$List$filter(absenceHasMinutes);
}();
var $author$project$Locale$Messages$StudentAbsenceListItemDetails = F3(
	function (a, b, c) {
		return {$: 480, a: a, b: b, c: c};
	});
var $author$project$UI$columnsWithAttribs = function (cols) {
	var col = function (_v0) {
		var attribs = _v0.a;
		var c = _v0.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				$elm$html$Html$Attributes$class('column'),
				attribs),
			_List_fromArray(
				[c]));
	};
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('columns is-fullwidth')
			]),
		A2($elm$core$List$map, col, cols));
};
var $author$project$Element$StudentAbsenceList$OpenDocumentViewer = function (a) {
	return {$: 11, a: a};
};
var $author$project$Util$String$surround = F2(
	function (_with, t) {
		return A3($author$project$Util$String$enclose, _with, _with, t);
	});
var $author$project$Util$String$quote = $author$project$Util$String$surround('\"');
var $author$project$Element$StudentAbsenceList$viewAbsenceMeta = function (absence) {
	var reasonText = A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('is-italic')
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(
				$author$project$Util$String$quote(absence.jj))
			]));
	return _List_fromArray(
		[
			$elm$core$String$isEmpty(absence.fX) ? reasonText : A3(
			$author$project$UI$actionLink,
			$author$project$Element$StudentAbsenceList$OpenDocumentViewer(absence.fX),
			_List_fromArray(
				[
					$elm$html$Html$Attributes$href(absence.fX),
					$author$project$UI$attrCyData('absence-reason-url-preview')
				]),
			_List_fromArray(
				[reasonText]))
		]);
};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByDoctor = {$: 486};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByMentor = {$: 488};
var $author$project$Locale$Messages$StudentAbsenceStateJustifiedByParent = {$: 487};
var $author$project$Locale$Messages$StudentAbsenceStateQuestioned = {$: 489};
var $author$project$Locale$Messages$StudentAbsenceStateUnjustified = {$: 485};
var $author$project$Element$StudentAbsenceList$viewAbsenceState = F2(
	function (t_, state) {
		var style = function () {
			switch (state) {
				case 0:
					return 'is-info';
				case 2:
					return 'is-success';
				case 1:
					return 'is-success';
				case 3:
					return 'is-success';
				default:
					return 'is-warning';
			}
		}();
		var stateMessage = function () {
			switch (state) {
				case 0:
					return $author$project$Locale$Messages$StudentAbsenceStateUnjustified;
				case 2:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByDoctor;
				case 1:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByParent;
				case 3:
					return $author$project$Locale$Messages$StudentAbsenceStateJustifiedByMentor;
				default:
					return $author$project$Locale$Messages$StudentAbsenceStateQuestioned;
			}
		}();
		return A2(
			$author$project$UI$tag,
			'is-light' + (' ' + style),
			_List_fromArray(
				[
					$elm$html$Html$text(
					t_(stateMessage))
				]));
	});
var $author$project$Element$StudentAbsenceList$ByMentor = 2;
var $author$project$Element$StudentAbsenceList$JustificationRequested = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor = {$: 470};
var $author$project$Element$StudentAbsenceList$requestJustification = F3(
	function (type_, absence, viewer) {
		return {ds: absence, hH: type_, nH: viewer};
	});
var $author$project$Element$StudentAbsenceList$viewSmallButton = F3(
	function (t_, m, onClick) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('button'),
					$elm$html$Html$Attributes$class('is-small'),
					$elm$html$Html$Events$onClick(onClick)
				]),
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, m)
				]));
	});
var $author$project$Element$StudentAbsenceList$viewActionsForMentor = F4(
	function (t_, student, viewer, absence) {
		return A2($author$project$Person$isMentorOf, student, viewer) ? _List_fromArray(
			[
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 2, absence, viewer)))
			]) : _List_Nil;
	});
var $author$project$Element$StudentAbsenceList$ByDoctor = 0;
var $author$project$Element$StudentAbsenceList$ByParent = 1;
var $author$project$Element$StudentAbsenceList$QuestionAbsenceRequested = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor = {$: 468};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByParent = {$: 469};
var $author$project$Locale$Messages$StudentAbsenceActionQuestion = {$: 473};
var $author$project$Element$StudentAbsenceList$viewActionsForParent = F4(
	function (t_, student, viewer, absence) {
		return A2($author$project$Person$isSponsorOf, viewer, student) ? _List_fromArray(
			[
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 0, absence, viewer))),
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionJustifyByParent,
				$author$project$Element$StudentAbsenceList$JustificationRequested(
					A3($author$project$Element$StudentAbsenceList$requestJustification, 1, absence, viewer))),
				A3(
				$author$project$Element$StudentAbsenceList$viewSmallButton,
				t_,
				$author$project$Locale$Messages$StudentAbsenceActionQuestion,
				$author$project$Element$StudentAbsenceList$QuestionAbsenceRequested(absence))
			]) : _List_Nil;
	});
var $author$project$Element$StudentAbsenceList$viewActions = F4(
	function (t_, student, viewer, absence) {
		var actionsForParent = A4($author$project$Element$StudentAbsenceList$viewActionsForParent, t_, student, viewer, absence);
		var actionsForMentor = A4($author$project$Element$StudentAbsenceList$viewActionsForMentor, t_, student, viewer, absence);
		return _Utils_ap(actionsForMentor, actionsForParent);
	});
var $author$project$Element$StudentAbsenceList$viewAbsence = F3(
	function (t_, viewer, absence) {
		var student = absence.ne;
		var startDate = absence.hv;
		var endDate = absence.gH;
		var state = absence.eZ;
		var paragraph = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$p(_List_Nil),
				$author$project$UI$textToHtml),
			t_);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columnsWithAttribs(
					_List_fromArray(
						[
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-one-fifth')
								]),
							paragraph(
								A3(
									$author$project$Locale$Messages$StudentAbsenceListItemDetails,
									$elm$time$Time$utc,
									$elm$time$Time$millisToPosix(startDate),
									$elm$time$Time$millisToPosix(endDate)))),
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-one-fifth')
								]),
							A2($author$project$Element$StudentAbsenceList$viewAbsenceState, t_, state)),
							_Utils_Tuple2(
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-three-fifths')
								]),
							A2(
								$author$project$UI$level,
								function () {
									switch (state) {
										case 0:
											return A4($author$project$Element$StudentAbsenceList$viewActions, t_, student, viewer, absence);
										case 2:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										case 1:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										case 3:
											return $author$project$Element$StudentAbsenceList$viewAbsenceMeta(absence);
										default:
											return _List_Nil;
									}
								}(),
								_List_Nil))
						]))
				]));
	});
var $author$project$Element$StudentAbsenceList$viewAbsenceList = F4(
	function (t_, viewer, student, absences) {
		var viewCaption = A2(
			$author$project$UI$caption,
			t_,
			$author$project$Locale$Messages$StudentAbsenceListTitle(
				A2($author$project$Person$fullName, t_, student)));
		var filteredAbsences = $author$project$Element$StudentAbsenceList$defaultFilterAbsences(absences);
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$panel(
					{
						kt: A2(
							$elm$core$List$map,
							A2($author$project$Element$StudentAbsenceList$viewAbsence, t_, viewer),
							filteredAbsences),
						kJ: 'student-absence',
						le: _List_fromArray(
							[viewCaption]),
						nk: _List_Nil,
						nq: 'is-info'
					}),
					A2(
					$author$project$UI$when,
					$elm$core$List$isEmpty(filteredAbsences),
					$author$project$UI$notification(
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentAbsenceListNoAbsences)
							])))
				]));
	});
var $author$project$Element$StudentAbsenceList$viewDocumentViewer = F2(
	function (session, documentModel) {
		return A3($author$project$Application$V3$Boundaries$viewElement, session, documentModel, $author$project$Element$StudentAbsenceList$documentViewer);
	});
var $author$project$Element$StudentAbsenceList$JustificationConfirmed = {$: 7};
var $author$project$Element$StudentAbsenceList$JustificationDeclined = {$: 8};
var $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctorHelp = F4(
	function (a, b, c, d) {
		return {$: 472, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$StudentAbsenceActionJustifyHelp = F4(
	function (a, b, c, d) {
		return {$: 471, a: a, b: b, c: c, d: d};
	});
var $author$project$Locale$Messages$JustifyingDocumentStorage = {$: 130};
var $author$project$Element$StudentAbsenceList$MediaFileUploadRequested = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentAbsenceJustificationMediaUploadHelp = function (a) {
	return {$: 477, a: a};
};
var $author$project$Element$StudentAbsenceList$composeL12 = F4(
	function (g, f, x, y) {
		return g(
			A2(f, x, y));
	});
var $author$project$Element$StudentAbsenceList$viewJustificationForm = F2(
	function (t_, _v0) {
		var form = _v0.bt;
		var values = _v0.ej;
		var mediaFileUploadRequested = A2($author$project$Element$StudentAbsenceList$composeL12, $author$project$Element$StudentAbsenceList$JustificationFormMsg, $author$project$Element$StudentAbsenceList$MediaFileUploadRequested);
		var maxFileSizeInMb = ((($author$project$Element$StudentAbsenceList$maxFileSize / 1024) | 0) / 1024) | 0;
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$UI$textField, t_, form.gD, values),
					A4(
					$author$project$UI$withInfoText,
					_List_Nil,
					t_,
					$author$project$Locale$Messages$JustifyingDocumentStorage,
					A4(
						$author$project$UI$withInfoText,
						_List_Nil,
						t_,
						$author$project$Locale$Messages$StudentAbsenceJustificationMediaUploadHelp(maxFileSizeInMb),
						A5($author$project$UI$fileField, t_, form.u, values, mediaFileUploadRequested, $author$project$Element$StudentAbsenceList$OpenDocumentViewer)))
				]));
		return A2(
			$author$project$UI$level,
			_List_fromArray(
				[viewFormFields]),
			_List_Nil);
	});
var $author$project$Element$StudentAbsenceList$viewJustificationDialog = F3(
	function (t_, formModel, request) {
		var form = formModel.bt;
		var state = formModel.eZ;
		var values = formModel.ej;
		var student = request.ds.ne;
		var startDate = request.ds.hv;
		var formState = A2($author$project$Form$isUploading, form.u, values) ? 2 : state;
		var endDate = request.ds.gH;
		var helpText = function () {
			var _v1 = request.hH;
			if (!_v1) {
				return t_(
					A4(
						$author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctorHelp,
						A2($author$project$Person$fullName, t_, student),
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(startDate),
						$elm$time$Time$millisToPosix(endDate)));
			} else {
				return t_(
					A4(
						$author$project$Locale$Messages$StudentAbsenceActionJustifyHelp,
						A2($author$project$Person$fullName, t_, student),
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(startDate),
						$elm$time$Time$millisToPosix(endDate)));
			}
		}();
		var dialogTitle = function () {
			var _v0 = request.hH;
			switch (_v0) {
				case 2:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByMentor;
				case 0:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByDoctor;
				default:
					return $author$project$Locale$Messages$StudentAbsenceActionJustifyByParent;
			}
		}();
		return A5(
			$author$project$UI$confirmDialogOkCanBeDisabled,
			formState === 1,
			t_,
			{kD: $author$project$Element$StudentAbsenceList$JustificationConfirmed, kM: $author$project$Element$StudentAbsenceList$JustificationDeclined},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, dialogTitle)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(helpText)),
					A2($author$project$Element$StudentAbsenceList$viewJustificationForm, t_, formModel)
				]));
	});
var $author$project$Element$StudentAbsenceList$QuestionAbsenceConfirmed = {$: 4};
var $author$project$Element$StudentAbsenceList$QuestionAbsenceDeclined = {$: 5};
var $author$project$Locale$Messages$StudentAbsenceActionQuestionHelp = F3(
	function (a, b, c) {
		return {$: 474, a: a, b: b, c: c};
	});
var $author$project$Element$StudentAbsenceList$viewQuestionAbsenceConfirmDialog = F2(
	function (t_, _v0) {
		var startDate = _v0.hv;
		var endDate = _v0.gH;
		return A4(
			$author$project$UI$confirmDialog,
			t_,
			{kD: $author$project$Element$StudentAbsenceList$QuestionAbsenceConfirmed, kM: $author$project$Element$StudentAbsenceList$QuestionAbsenceDeclined},
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentAbsenceActionQuestion)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_Nil,
					$author$project$UI$textToHtml(
						t_(
							A3(
								$author$project$Locale$Messages$StudentAbsenceActionQuestionHelp,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(startDate),
								$elm$time$Time$millisToPosix(endDate)))))
				]));
	});
var $author$project$Element$StudentAbsenceList$view = function (model) {
	var session = model.cv;
	var _v0 = _Utils_Tuple2(model.ne, model.dt);
	_v0$1:
	while (true) {
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 2:
								switch (_v0.b.$) {
									case 2:
										var student_ = _v0.a.a;
										var absences_ = _v0.b.a;
										return A2(
											$elm$html$Html$div,
											_List_Nil,
											_List_fromArray(
												[
													A4($author$project$Element$StudentAbsenceList$viewAbsenceList, session.hy, session.nH, student_, absences_),
													A2(
													$author$project$UI$maybe,
													model.c$,
													A2($author$project$Element$StudentAbsenceList$viewJustificationDialog, session.hy, model.D)),
													A2(
													$author$project$UI$maybe,
													model.c0,
													$author$project$Element$StudentAbsenceList$viewQuestionAbsenceConfirmDialog(session.hy)),
													A2(
													$author$project$UI$maybe,
													model.dE,
													$author$project$Element$StudentAbsenceList$viewDocumentViewer(session))
												]));
									case 1:
										break _v0$1;
									case 3:
										break _v0$4;
									default:
										break _v0$5;
								}
							case 1:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$2;
									default:
										break _v0$2;
								}
							case 3:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 1:
										break _v0$1;
									case 3:
										break _v0$4;
									default:
										break _v0$5;
								}
						}
					}
					return A2(
						$author$project$UI$progressBar,
						'is-info',
						session.hy($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
				}
				return A2(
					$author$project$UI$progressBar,
					'is-warning',
					session.hy($author$project$Locale$Messages$StudentAbsenceListLoadingError));
			}
			return A2(
				$author$project$UI$progressBar,
				'is-warning',
				session.hy($author$project$Locale$Messages$StudentAbsenceListLoadingError));
		}
		var _v2 = _v0.a;
		return A2(
			$author$project$UI$progressBar,
			'is-success',
			session.hy($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
	}
	var _v1 = _v0.b;
	return A2(
		$author$project$UI$progressBar,
		'is-success',
		session.hy($author$project$Locale$Messages$StudentAbsenceListLoadingProgress));
};
var $author$project$Element$StudentAbsenceList$element = {iA: $author$project$Element$StudentAbsenceList$init, hh: $author$project$Element$StudentAbsenceList$perform, jR: $author$project$Element$StudentAbsenceList$update, nE: $author$project$Element$StudentAbsenceList$view};
var $author$project$Element$StudentList$LoadingPage = {$: 1};
var $author$project$Element$StudentList$NotFoundPage = {$: 0};
var $author$project$Element$StudentList$StudentListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentList$getListQuery = function (_v0) {
	var query = _v0;
	return query;
};
var $author$project$Api$Endpoint$categoryMentees = 'mentored';
var $author$project$Element$StudentList$listFilterToCategory = function (filter) {
	if (!filter) {
		return $author$project$Api$Endpoint$categoryAll;
	} else {
		return $author$project$Api$Endpoint$categoryMentees;
	}
};
var $author$project$Element$StudentList$asListParams = function (listPage) {
	var defaults = $author$project$Student$defaultListParams;
	return _Utils_update(
		defaults,
		{
			bs: $author$project$Element$StudentList$listFilterToCategory(listPage.bO),
			cS: function () {
				var _v0 = listPage.cY;
				if (_v0.$ === 1) {
					var student_ = _v0.a;
					return $elm$core$Maybe$Just(student_.ne.gT);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}(),
			bw: $author$project$Element$StudentList$getListQuery(listPage.bw)
		});
};
var $author$project$Element$StudentList$FilterAll = 0;
var $author$project$Element$StudentList$ListQuery = $elm$core$Basics$identity;
var $author$project$Element$StudentList$LoadingStudents = {$: 0};
var $author$project$Element$StudentList$emptyList = {bO: 0, cY: $author$project$Element$StudentList$LoadingStudents, bw: '', e1: _List_Nil};
var $author$project$Student$fetchActiveStudents = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$activeStudents, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Student$studentsDecoder));
	});
var $author$project$Element$StudentList$init = F3(
	function (config, session, _v0) {
		var model = {bN: config, bm: $author$project$Element$StudentList$NotFoundPage};
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3(
				$author$project$Student$fetchActiveStudents,
				config.gr,
				$author$project$Element$StudentList$asListParams($author$project$Element$StudentList$emptyList),
				$author$project$Element$StudentList$StudentListDownloaded),
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{bm: $author$project$Element$StudentList$LoadingPage}),
				session));
	});
var $author$project$Element$StudentList$DelayedGotListQuery = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentList$ListPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentList$NoOp = {$: 0};
var $author$project$Element$StudentList$NoMoreStudents = {$: 2};
var $author$project$Element$StudentList$StudentsLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentList$toStudentListItem = F2(
	function (query, student) {
		return {
			lg: $author$project$Element$StudentList$getListQuery(query),
			ne: student
		};
	});
var $author$project$Element$StudentList$addNewStudents = F2(
	function (newStudents, listPage) {
		var loading = listPage.cY;
		var students = listPage.e1;
		var query = listPage.bw;
		var toAdd = A2(
			$elm$core$List$map,
			$author$project$Element$StudentList$toStudentListItem(query),
			newStudents);
		var _v0 = _Utils_Tuple3(
			loading,
			students,
			$elm$core$List$reverse(toAdd));
		switch (_v0.a.$) {
			case 0:
				if (!_v0.c.b) {
					if (!_v0.b.b) {
						var _v1 = _v0.a;
						return _Utils_update(
							listPage,
							{cY: $author$project$Element$StudentList$NoMoreStudents, e1: toAdd});
					} else {
						var _v4 = _v0.a;
						return _Utils_update(
							listPage,
							{cY: $author$project$Element$StudentList$NoMoreStudents});
					}
				} else {
					if (!_v0.b.b) {
						var _v2 = _v0.a;
						var _v3 = _v0.c;
						var lastStudent = _v3.a;
						return _Utils_update(
							listPage,
							{
								cY: $author$project$Element$StudentList$StudentsLoaded(lastStudent),
								e1: toAdd
							});
					} else {
						var _v5 = _v0.a;
						var _v6 = _v0.c;
						var lastStory = _v6.a;
						return _Utils_update(
							listPage,
							{
								cY: $author$project$Element$StudentList$StudentsLoaded(lastStory),
								e1: _Utils_ap(students, toAdd)
							});
					}
				}
			case 1:
				return listPage;
			default:
				var _v7 = _v0.a;
				return listPage;
		}
	});
var $author$project$Element$StudentList$initialList = function (listPage) {
	return _Utils_update(
		listPage,
		{cY: $author$project$Element$StudentList$LoadingStudents, e1: _List_Nil});
};
var $author$project$Element$StudentList$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		var noop = A2($author$project$Application$Boundaries$save, model, session);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		_v0$9:
		while (true) {
			switch (_v0.a.$) {
				case 3:
					if (_v0.b.$ === 2) {
						var category = _v0.a.a;
						var newListPage = _Utils_update(
							$author$project$Element$StudentList$emptyList,
							{bO: category});
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Student$fetchActiveStudents,
								config.gr,
								$author$project$Element$StudentList$asListParams(newListPage),
								$author$project$Element$StudentList$StudentListDownloaded),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: $author$project$Element$StudentList$ListPage(newListPage)
									}),
								session));
					} else {
						break _v0$9;
					}
				case 6:
					if (_v0.b.$ === 2) {
						var _v1 = _v0.a;
						var listPage = _v0.b.a;
						var listParams = $author$project$Element$StudentList$asListParams(listPage);
						var _v2 = listPage.cY;
						if (_v2.$ === 1) {
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3($author$project$Student$fetchActiveStudents, config.gr, listParams, $author$project$Element$StudentList$StudentListDownloaded),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$StudentList$ListPage(
												_Utils_update(
													listPage,
													{cY: $author$project$Element$StudentList$LoadingStudents}))
										}),
									session));
						} else {
							return noop;
						}
					} else {
						break _v0$9;
					}
				case 1:
					if (!_v0.a.a.$) {
						switch (_v0.b.$) {
							case 1:
								var students = _v0.a.a.a;
								var _v3 = _v0.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$ok,
										config,
										_Utils_Tuple2(
											$author$project$Log$msgStudentsDownload,
											_List_fromArray(
												[$author$project$Log$paramScopeStudents, $author$project$Log$paramOk])),
										$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentList$ListPage(
													A2($author$project$Element$StudentList$addNewStudents, students, $author$project$Element$StudentList$emptyList))
											}),
										session));
							case 2:
								var students = _v0.a.a.a;
								var listPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$ok,
										config,
										_Utils_Tuple2(
											$author$project$Log$msgStudentsDownload,
											_List_fromArray(
												[$author$project$Log$paramScopeStudents, $author$project$Log$paramOk])),
										$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentList$ListPage(
													A2($author$project$Element$StudentList$addNewStudents, students, listPage))
											}),
										session));
							default:
								break _v0$9;
						}
					} else {
						var error = _v0.a.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3(
									$author$project$Log$msgStudentsDownload,
									$elm$core$Maybe$Just($author$project$Log$paramScopeStudents),
									error),
								$elm$core$Basics$always($author$project$Element$StudentList$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$StudentListDownloadError))));
					}
				case 2:
					var _v4 = _v0.a;
					var cmd = $author$project$Ports$sendPageView(
						{
							ms: $author$project$Route$toString($author$project$Route$AnalyticsLearningContract),
							mt: A2($author$project$Route$pageTitle, t_, $author$project$Route$AnalyticsLearningContract)
						});
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						cmd,
						A2($author$project$Application$Boundaries$save, model, session));
				case 4:
					var query = _v0.a.a;
					var _v5 = model.bm;
					if (_v5.$ === 2) {
						var listPageModel = _v5.a;
						var delayCmd = A2(
							$author$project$Util$Delay$after,
							$author$project$Util$Delay$searchBarDelay,
							$author$project$Element$StudentList$DelayedGotListQuery(query));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							delayCmd,
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: $author$project$Element$StudentList$ListPage(
											$author$project$Element$StudentList$initialList(
												_Utils_update(
													listPageModel,
													{bw: query})))
									}),
								session));
					} else {
						return noop;
					}
				case 5:
					var newQuery = _v0.a.a;
					var _v6 = model.bm;
					if (_v6.$ === 2) {
						var listPageModel = _v6.a;
						var cmd = _Utils_eq(newQuery, listPageModel.bw) ? A3(
							$author$project$Student$fetchActiveStudents,
							config.gr,
							$author$project$Element$StudentList$asListParams(listPageModel),
							$author$project$Element$StudentList$StudentListDownloaded) : $elm$core$Platform$Cmd$none;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							A2($author$project$Application$Boundaries$save, model, session));
					} else {
						return noop;
					}
				default:
					var _v7 = _v0.a;
					return noop;
			}
		}
		return noop;
	});
var $author$project$Locale$Messages$StudentsNotFound = {$: 493};
var $author$project$Element$StudentList$FilterMentees = 1;
var $author$project$Element$StudentList$GotCategoryFilter = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentList$GotListQuery = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$StudentListFilterAll = {$: 574};
var $author$project$Locale$Messages$StudentListFilterMyMentees = {$: 575};
var $author$project$Locale$Messages$StudentSearch = {$: 587};
var $author$project$Locale$Messages$StudentsEmptyResults = {$: 492};
var $author$project$Element$StudentList$typeFilter = F3(
	function (filter, mentor, student) {
		return (!filter) || ((filter === 1) && A2($author$project$Person$isMentorOf, student, mentor));
	});
var $author$project$Element$StudentList$filterStudents = F3(
	function (currentFilter, mentor, studentListItems) {
		return A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ne;
				},
				A2($author$project$Element$StudentList$typeFilter, currentFilter, mentor)),
			studentListItems);
	});
var $author$project$Person$hasMentees = function (person) {
	return !$elm$core$List$isEmpty(person.lZ);
};
var $author$project$Locale$Messages$StudentSponsors = function (a) {
	return {$: 494, a: a};
};
var $author$project$Element$StudentList$viewGradeReportLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$GradeReportCard(student.gT)),
					$author$project$UI$attrCyData(
					'grade-report-view ' + A2($elm$core$Maybe$withDefault, '', student.K))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewGradeReport)
				]));
	});
var $author$project$Element$StudentList$viewGradeRequestsLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$GradeRequestList(id)),
					$author$project$UI$attrCyData('grade-request-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$grades(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeRequestListTitle)
				]));
	});
var $author$project$Element$StudentList$LearningContractOpened = {$: 2};
var $author$project$Locale$Messages$StudentListAddLearningContract = {$: 578};
var $author$project$ACL$canCreateLearningContract = F2(
	function (student, person) {
		return A2($author$project$Person$isMentorOf, student, person);
	});
var $author$project$Element$StudentList$viewLearningContractLink = F3(
	function (t_, viewer, student) {
		var viewLink = function (contract) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick($author$project$Element$StudentList$LearningContractOpened),
						$elm$html$Html$Attributes$href(contract.G),
						$elm$html$Html$Attributes$target('_blank'),
						$author$project$UI$attrCyData('learningcontracts-view')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(_List_Nil),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewLearningContract)
					]));
		};
		var createLink = A2(
			$author$project$UI$when,
			A2($author$project$ACL$canCreateLearningContract, student, viewer),
			A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href($author$project$Route$LearningContractsCreate),
						$author$project$UI$attrCyData('learningcontracts-new')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$learningContract(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-warning')
							])),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListAddLearningContract)
					])));
		return A2(
			$elm$core$Maybe$withDefault,
			createLink,
			A2($elm$core$Maybe$map, viewLink, student.j9));
	});
var $author$project$Locale$Messages$StudentListViewProfile = {$: 581};
var $author$project$Element$StudentList$viewProfileLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentProfileUpdate(id)),
					$author$project$UI$attrCyData('studentprofiles-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-primary')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewProfile)
				]));
	});
var $author$project$Element$StudentList$viewStudentAbsenceListLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$StudentAbsenceList(student.gT))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$absence(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewStudentAbsenceList)
				]));
	});
var $author$project$Element$StudentList$viewSubjectFeedbacksLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					A2($author$project$Route$SubjectFeedbackCard, student.gT, $elm$core$Maybe$Nothing))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$filter(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewSubjectFeedback)
				]));
	});
var $author$project$Element$StudentList$viewTimetableLink = F2(
	function (t_, id) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TimetableCalendar(
						_List_fromArray(
							[id]))),
					$author$project$UI$attrCyData('timetable-view')
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$moduleEvent(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-dark')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTimetable)
				]));
	});
var $author$project$Element$StudentList$viewTrimesterFeedbacksLink = F2(
	function (t_, student) {
		return A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(student.gT))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$feedback(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						])),
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListViewTrimesterFeedback)
				]));
	});
var $author$project$Element$StudentList$viewStudent = F3(
	function (t_, viewer, _v0) {
		var student = _v0.ne;
		var highlight = _v0.lg;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					A4(
					$author$project$UI$mediaObject,
					_List_fromArray(
						[
							$author$project$UI$gravatar(
							A2($elm$core$Maybe$withDefault, '', student.K))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$strong,
									_List_fromArray(
										[
											$author$project$UI$attrCyData('students-item')
										]),
									_List_fromArray(
										[
											A2(
											$author$project$UI$withHighlightedText,
											highlight,
											A2($author$project$Person$fullName, t_, student)),
											$elm$html$Html$text(' ')
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2(
											$author$project$UI$caption,
											t_,
											$author$project$Locale$Messages$StudentSponsors(
												A2(
													$elm$core$List$map,
													$author$project$Person$fullName(t_),
													student.m9)))
										])),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									A2(
									$elm$html$Html$small,
									_List_Nil,
									_List_fromArray(
										[
											A2($author$project$Element$StudentList$viewMentorText, t_, student.l_)
										])),
									function () {
									var _v1 = student.aQ;
									if (!_v1.$) {
										var phoneNumber = _v1.a;
										return A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($elm$html$Html$br, _List_Nil, _List_Nil),
													A2($author$project$UI$protoLink, 'tel:', phoneNumber)
												]));
									} else {
										return $author$project$UI$none;
									}
								}(),
									A2($elm$html$Html$br, _List_Nil, _List_Nil),
									function () {
									var _v2 = student.K;
									if (!_v2.$) {
										var email = _v2.a;
										return A2($author$project$UI$protoLink, 'mailto:', email);
									} else {
										return $author$project$UI$none;
									}
								}()
								]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$nav,
							_List_fromArray(
								[
									A3($author$project$Element$StudentList$viewLearningContractLink, t_, viewer, student),
									A2($author$project$Element$StudentList$viewTimetableLink, t_, student.gT),
									A2($author$project$Element$StudentList$viewStudentAbsenceListLink, t_, student),
									A2($author$project$Element$StudentList$viewTrimesterFeedbacksLink, t_, student),
									A2($author$project$Element$StudentList$viewSubjectFeedbacksLink, t_, student),
									A2($author$project$Element$StudentList$viewGradeReportLink, t_, student),
									A2($author$project$Element$StudentList$viewGradeRequestsLink, t_, student.gT),
									A2($author$project$Element$StudentList$viewProfileLink, t_, student.gT)
								]),
							_List_Nil)
						]),
					_List_Nil)
				]));
	});
var $author$project$Element$StudentList$viewStudentList = F2(
	function (_v0, _v1) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var filter = _v1.bO;
		var query = _v1.bw;
		var students = _v1.e1;
		var loading = _v1.cY;
		var viewLoadingState = function () {
			var _v2 = _Utils_Tuple2(loading, students);
			if (!_v2.b.b) {
				switch (_v2.a.$) {
					case 0:
						var _v3 = _v2.a;
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					case 1:
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$StudentsEmptyResults)
							]);
					default:
						var _v4 = _v2.a;
						return _List_fromArray(
							[
								A2($author$project$UI$List$emptyResultsInfo, t_, $author$project$Locale$Messages$StudentsEmptyResults)
							]);
				}
			} else {
				return _List_Nil;
			}
		}();
		var viewFilterLinks = A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$StudentList$GotCategoryFilter, filter),
			_List_fromArray(
				[
					{kJ: 'all', bO: 0, g_: true, g$: true, lO: $author$project$Locale$Messages$StudentListFilterAll},
					{
					kJ: 'mentees',
					bO: 1,
					g_: true,
					g$: $author$project$Person$hasMentees(viewer),
					lO: $author$project$Locale$Messages$StudentListFilterMyMentees
				}
				]));
		var sortStudents = $author$project$Util$List$sortBy(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ne;
				},
				$author$project$Person$fullName(t_)));
		return $author$project$UI$panel(
			{
				kt: A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('columns container')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('column')
									]),
								_List_fromArray(
									[
										$author$project$UI$List$searchBar(
										{
											aT: function (input) {
												return $author$project$Element$StudentList$GotListQuery(input);
											},
											bv: t_($author$project$Locale$Messages$StudentSearch),
											bw: $author$project$Element$StudentList$getListQuery(query)
										})
									]))
							])),
					_Utils_ap(
						A2(
							$elm$core$List$map,
							A2($author$project$Element$StudentList$viewStudent, t_, viewer),
							sortStudents(
								A3($author$project$Element$StudentList$filterStudents, filter, viewer, students))),
						viewLoadingState)),
				kJ: 'students-list',
				le: _List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListTitleStudents)
					]),
				nk: viewFilterLinks,
				nq: 'is-warning'
			});
	});
var $author$project$Locale$Messages$StudentListLoadMore = {$: 496};
var $author$project$Element$StudentList$viewStudentListPager = F2(
	function (t_, _v0) {
		var loading = _v0.cY;
		var students = _v0.e1;
		var _v1 = _Utils_Tuple2(loading, students);
		switch (_v1.a.$) {
			case 0:
				if (!_v1.b.b) {
					var _v2 = _v1.a;
					return $author$project$UI$none;
				} else {
					var _v3 = _v1.a;
					return $author$project$UI$List$resultsLoadingProgressBar;
				}
			case 1:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('container has-text-centered')
						]),
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$StudentList$LoadMoreStudents,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('is-link')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$sync(_List_Nil),
									A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentListLoadMore)
								]))
						]));
			default:
				var _v4 = _v1.a;
				return $author$project$UI$none;
		}
	});
var $author$project$Element$StudentList$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 2:
				var listPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2($author$project$Element$StudentList$viewStudentList, session, listPage),
							A2($author$project$Element$StudentList$viewStudentListPager, t_, listPage)
						]));
			case 0:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentsNotFound)
						]));
			default:
				return A2(
					$author$project$UI$progressBar,
					'is-warning',
					t_($author$project$Locale$Messages$StudentListLoadingProgress));
		}
	});
var $author$project$Element$StudentList$element = {iA: $author$project$Element$StudentList$init, jR: $author$project$Element$StudentList$update, nE: $author$project$Element$StudentList$view};
var $author$project$Element$StudentProfileForm$NotFoundPage = {$: 0};
var $author$project$Element$StudentProfileForm$LoadingNekPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$PhoneBookDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$StudentProfileForm$SchoolListDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentProfileForm$StudentProfileDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$ACL$canManageStudentAdminData = $author$project$ACL$isStaff;
var $author$project$StudentProfile$fetchStudentProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$studentProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$StudentProfile$studentProfileDecoder));
	});
var $author$project$Element$StudentProfileForm$initPage = F3(
	function (pageType, session, model) {
		var viewer = session.nH;
		var config = model.bN;
		if (!pageType.$) {
			var id = pageType.a;
			var model2 = _Utils_update(
				model,
				{
					bm: $author$project$Element$StudentProfileForm$LoadingPage(id),
					jr: $author$project$RemoteData$Loading
				});
			var cmd = $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A3($author$project$StudentProfile$fetchStudentProfile, config.gr, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
						A2($author$project$Team$fetchSchools, config.gr, $author$project$Element$StudentProfileForm$SchoolListDownloaded),
						$author$project$ACL$canManageStudentAdminData(viewer) ? A2($author$project$Person$fetchPhoneBook, config.gr, $author$project$Element$StudentProfileForm$PhoneBookDownloaded) : $elm$core$Platform$Cmd$none
					]));
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				cmd,
				A2($author$project$Application$Boundaries$save, model2, session));
		} else {
			var id = pageType.a;
			return A2(
				$author$project$Application$Boundaries$andThenCmd,
				A3($author$project$StudentProfile$fetchStudentProfile, config.gr, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
				A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{
							bm: $author$project$Element$StudentProfileForm$LoadingNekPage(id)
						}),
					session));
		}
	});
var $author$project$Element$StudentProfileForm$init = F3(
	function (config, session, pageType) {
		var model = {bN: config, bm: $author$project$Element$StudentProfileForm$NotFoundPage, fT: _List_Nil, c3: $elm$core$Maybe$Nothing, jr: $author$project$RemoteData$NotAsked};
		return A3($author$project$Element$StudentProfileForm$initPage, pageType, session, model);
	});
var $author$project$Element$StudentProfileForm$BirthCertificateFileSelected = F3(
	function (a, b, c) {
		return {$: 12, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificateFileUploaded = F3(
	function (a, b, c) {
		return {$: 14, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificatePolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 13, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$BirthCertificateSignatureDownloaded = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationFileSelected = F3(
	function (a, b, c) {
		return {$: 66, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationFileUploaded = F3(
	function (a, b, c) {
		return {$: 68, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 67, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$EvaluationSignatureDownloaded = function (a) {
	return {$: 70, a: a};
};
var $author$project$Element$StudentProfileForm$FormPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardFileSelected = F3(
	function (a, b, c) {
		return {$: 36, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardFileUploaded = F3(
	function (a, b, c) {
		return {$: 38, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 37, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IdCardSignatureDownloaded = function (a) {
	return {$: 40, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentFileSelected = F3(
	function (a, b, c) {
		return {$: 60, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentFileUploaded = F3(
	function (a, b, c) {
		return {$: 62, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 61, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentSignatureDownloaded = function (a) {
	return {$: 64, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardFileSelected = F3(
	function (a, b, c) {
		return {$: 54, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$LastReportCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 55, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$LastReportCardSignatureDownloaded = function (a) {
	return {$: 58, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardUploaded = F3(
	function (a, b, c) {
		return {$: 56, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekFormPage = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdFileSelected = F3(
	function (a, b, c) {
		return {$: 72, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdFileUploaded = F3(
	function (a, b, c) {
		return {$: 74, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 73, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$NekIdSignatureDownloaded = function (a) {
	return {$: 76, a: a};
};
var $author$project$Element$StudentProfileForm$NoOp = {$: 10};
var $author$project$Element$StudentProfileForm$ProfileSaved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitFileSelected = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitFileUploaded = F3(
	function (a, b, c) {
		return {$: 20, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 19, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitSignatureDownloaded = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusFileSelected = F3(
	function (a, b, c) {
		return {$: 48, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusFileUploaded = F3(
	function (a, b, c) {
		return {$: 50, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusReportPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 49, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusReportSignatureDownloaded = function (a) {
	return {$: 52, a: a};
};
var $author$project$Element$StudentProfileForm$SsnFileSelected = F3(
	function (a, b, c) {
		return {$: 24, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnFileUploaded = F3(
	function (a, b, c) {
		return {$: 26, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 25, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$SsnSignatureDownloaded = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardFileSelected = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardFileUploaded = F3(
	function (a, b, c) {
		return {$: 32, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 31, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$StudentCardSignatureDownloaded = function (a) {
	return {$: 34, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormFileDownloadError = {$: 565};
var $author$project$Locale$Messages$StudentProfileFormSaveSuccess = {$: 566};
var $author$project$Element$StudentProfileForm$TaxIdFileSelected = F3(
	function (a, b, c) {
		return {$: 42, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdFileUploaded = F3(
	function (a, b, c) {
		return {$: 44, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 43, a: a, b: b, c: c};
	});
var $author$project$Element$StudentProfileForm$TaxIdSignatureDownloaded = function (a) {
	return {$: 46, a: a};
};
var $author$project$Element$StudentProfileForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/png', 'image/jpeg']);
var $author$project$Element$StudentProfileForm$awsPolicyScope = 'people';
var $author$project$Element$StudentProfileForm$Accidents = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$StudentProfileForm$Admission = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$BasicTask = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$StudentProfileForm$BirthCertificateUrl = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$StudentProfileForm$BirthDate = function (a) {
	return {$: 43, a: a};
};
var $author$project$Element$StudentProfileForm$BirthPlace = function (a) {
	return {$: 42, a: a};
};
var $author$project$Element$StudentProfileForm$BirthPlaceCountry = function (a) {
	return {$: 41, a: a};
};
var $author$project$Element$StudentProfileForm$CompetencyTestResults = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$StudentProfileForm$CurrentSchoolYear = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$StudentProfileForm$DisciplinaryAndCompensationCases = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$StudentProfileForm$EduId = function (a) {
	return {$: 46, a: a};
};
var $author$project$Element$StudentProfileForm$Email = function (a) {
	return {$: 30, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationUrl = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$StudentProfileForm$Exams = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$StudentProfileForm$FirstForeignLanguage = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$StudentProfileForm$FirstName = function (a) {
	return {$: 31, a: a};
};
var $author$project$Element$StudentProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardUrl = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentUrl = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$StudentProfileForm$IsIndividualStudent = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$StudentProfileForm$LastName = function (a) {
	return {$: 32, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardUrl = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$StudentProfileForm$Mentor = function (a) {
	return {$: 49, a: a};
};
var $author$project$Element$StudentProfileForm$MissedClasses = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$MothersMaidenName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$Nationality = function (a) {
	return {$: 44, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressCountry = function (a) {
	return {$: 34, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 35, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 40, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 37, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 39, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 38, a: a};
};
var $author$project$Element$StudentProfileForm$PermanentAddressTown = function (a) {
	return {$: 36, a: a};
};
var $author$project$Locale$Messages$PersonMentor = {$: 350};
var $author$project$Element$StudentProfileForm$PhoneNumber = function (a) {
	return {$: 33, a: a};
};
var $author$project$Element$StudentProfileForm$ProfileNekId = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$StudentProfileForm$ProfileNekIdUrl = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitUrl = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$StudentProfileForm$SchoolYearRepetition = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$StudentProfileForm$SecondForeignLanguage = function (a) {
	return {$: 18, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatus = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusUrl = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$StudentProfileForm$Ssn = function (a) {
	return {$: 45, a: a};
};
var $author$project$Element$StudentProfileForm$SsnUrl = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardId = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardUrl = function (a) {
	return {$: 23, a: a};
};
var $author$project$Locale$Messages$StudentProfileFormStudentCardUrl = {$: 550};
var $author$project$Element$StudentProfileForm$SupervisingSchool = function (a) {
	return {$: 47, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdUrl = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$StudentProfileForm$Team = function (a) {
	return {$: 48, a: a};
};
var $author$project$Element$StudentProfileForm$Termination = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$TextbookSupply = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$StudentProfileForm$TripAbroad = function (a) {
	return {$: 12, a: a};
};
var $author$project$Locale$Messages$StudentProfileBasicTaskC = {$: 497};
var $author$project$Locale$Messages$StudentProfileBasicTaskG = {$: 498};
var $author$project$Locale$Messages$StudentProfileBasicTaskI = {$: 499};
var $author$project$StudentProfile$basicTaskOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'C',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskC)),
			_Utils_Tuple2(
			'G',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskG)),
			_Utils_Tuple2(
			'I',
			t_($author$project$Locale$Messages$StudentProfileBasicTaskI))
		]);
};
var $author$project$Locale$Messages$StudentProfileForeignLanguageEnglish = {$: 504};
var $author$project$Locale$Messages$StudentProfileForeignLanguageFrench = {$: 506};
var $author$project$Locale$Messages$StudentProfileForeignLanguageGerman = {$: 505};
var $author$project$Locale$Messages$StudentProfileForeignLanguageItalian = {$: 508};
var $author$project$Locale$Messages$StudentProfileForeignLanguageSpanish = {$: 507};
var $author$project$StudentProfile$foreignLanguageEnglish = 'Angol';
var $author$project$StudentProfile$foreignLanguageFrench = 'Francia';
var $author$project$StudentProfile$foreignLanguageGerman = 'Német';
var $author$project$StudentProfile$foreignLanguageItalian = 'Olasz';
var $author$project$StudentProfile$foreignLanguageSpanish = 'Spanyol';
var $author$project$StudentProfile$foreignLanguageOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageEnglish,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageEnglish)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageGerman,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageGerman)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageFrench,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageFrench)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageSpanish,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageSpanish)),
			_Utils_Tuple2(
			$author$project$StudentProfile$foreignLanguageItalian,
			t_($author$project$Locale$Messages$StudentProfileForeignLanguageItalian))
		]);
};
var $author$project$Element$StudentProfileForm$maxFileSize = (10 * 1024) * 1024;
var $author$project$Locale$Messages$PersonInvalidEduId = {$: 368};
var $author$project$Person$validEduIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{11}$'));
var $author$project$Person$optionalEduId = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Person$validEduIdFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$PersonInvalidEduId)));
	});
var $author$project$StudentProfile$validForeignLanguages = _List_fromArray(
	[$author$project$StudentProfile$foreignLanguageEnglish, $author$project$StudentProfile$foreignLanguageGerman, $author$project$StudentProfile$foreignLanguageSpanish, $author$project$StudentProfile$foreignLanguageFrench, $author$project$StudentProfile$foreignLanguageItalian]);
var $author$project$StudentProfile$optionalForeignLanguage = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$core$List$member, cleanValue, $author$project$StudentProfile$validForeignLanguages) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredSelection)));
	});
var $author$project$Locale$Messages$StudentProfileInvalidNekId = {$: 509};
var $author$project$StudentProfile$validNekIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9a-zA-Z]{16}$'));
var $author$project$StudentProfile$optionalNekId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$regex$Regex$contains, $author$project$StudentProfile$validNekIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileInvalidNekId)));
	});
var $author$project$Form$optionalPhoneNumber = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Ok(value) : (A2($elm$regex$Regex$contains, $author$project$Form$validPhoneNumberFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidPhoneNumber)));
	});
var $author$project$Locale$Messages$PersonInvalidSsn = {$: 369};
var $author$project$Person$validSsnFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{9}$'));
var $author$project$Person$requireValidSsn = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return A2($elm$regex$Regex$contains, $author$project$Person$validSsnFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$PersonInvalidSsn));
	});
var $author$project$Locale$Messages$FormRequiredFile = {$: 65};
var $author$project$Form$requiredFile = F3(
	function (t_, constraints, value) {
		var defaultErrorMessage = $author$project$Locale$Messages$FormRequiredFile;
		return A4($author$project$Form$requiredFileWithCustomMessage, t_, constraints, defaultErrorMessage, value);
	});
var $author$project$Locale$Messages$StudentProfileSchoolYear1 = {$: 513};
var $author$project$Locale$Messages$StudentProfileSchoolYear10 = {$: 522};
var $author$project$Locale$Messages$StudentProfileSchoolYear11 = {$: 523};
var $author$project$Locale$Messages$StudentProfileSchoolYear12 = {$: 524};
var $author$project$Locale$Messages$StudentProfileSchoolYear2 = {$: 514};
var $author$project$Locale$Messages$StudentProfileSchoolYear3 = {$: 515};
var $author$project$Locale$Messages$StudentProfileSchoolYear4 = {$: 516};
var $author$project$Locale$Messages$StudentProfileSchoolYear5 = {$: 517};
var $author$project$Locale$Messages$StudentProfileSchoolYear6 = {$: 518};
var $author$project$Locale$Messages$StudentProfileSchoolYear7 = {$: 519};
var $author$project$Locale$Messages$StudentProfileSchoolYear8 = {$: 520};
var $author$project$Locale$Messages$StudentProfileSchoolYear9 = {$: 521};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten1 = {$: 510};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten2 = {$: 511};
var $author$project$Locale$Messages$StudentProfileSchoolYearKindergarten3 = {$: 512};
var $author$project$StudentProfile$schoolYearOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'ovi 1',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten1)),
			_Utils_Tuple2(
			'ovi 2',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten2)),
			_Utils_Tuple2(
			'ovi 3',
			t_($author$project$Locale$Messages$StudentProfileSchoolYearKindergarten3)),
			_Utils_Tuple2(
			'1',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear1)),
			_Utils_Tuple2(
			'2',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear2)),
			_Utils_Tuple2(
			'3',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear3)),
			_Utils_Tuple2(
			'4',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear4)),
			_Utils_Tuple2(
			'5',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear5)),
			_Utils_Tuple2(
			'6',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear6)),
			_Utils_Tuple2(
			'7',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear7)),
			_Utils_Tuple2(
			'8',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear8)),
			_Utils_Tuple2(
			'9',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear9)),
			_Utils_Tuple2(
			'10',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear10)),
			_Utils_Tuple2(
			'11',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear11)),
			_Utils_Tuple2(
			'12',
			t_($author$project$Locale$Messages$StudentProfileSchoolYear12))
		]);
};
var $author$project$Locale$Messages$StudentProfileSpecialStatusBtmn = {$: 500};
var $author$project$Locale$Messages$StudentProfileSpecialStatusNone = {$: 503};
var $author$project$Locale$Messages$StudentProfileSpecialStatusSni1 = {$: 501};
var $author$project$Locale$Messages$StudentProfileSpecialStatusSni2 = {$: 502};
var $author$project$StudentProfile$specialStatusOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'BTMN',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusBtmn)),
			_Utils_Tuple2(
			'SNI1',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusSni1)),
			_Utils_Tuple2(
			'SNI2',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusSni2)),
			_Utils_Tuple2(
			'NONE',
			t_($author$project$Locale$Messages$StudentProfileSpecialStatusNone))
		]);
};
var $author$project$Locale$Messages$StudentProfileFormInvalidStudentCardId = {$: 563};
var $author$project$StudentProfile$validStudentCardIdFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{10}$'));
var $author$project$StudentProfile$validStudentCardId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return (cleanValue === '') ? $elm$core$Result$Ok(cleanValue) : (A2($elm$regex$Regex$contains, $author$project$StudentProfile$validStudentCardIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileFormInvalidStudentCardId)));
	});
var $author$project$Element$StudentProfileForm$buildForm = function (t_) {
	return {
		X: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{X: value});
				}),
			nD: function ($) {
				return $.X;
			},
			nE: {
				kJ: 'accidents',
				lO: t_($author$project$Locale$Messages$StudentProfileFormAccidents),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Accidents),
				bv: t_($author$project$Locale$Messages$StudentProfileFormAccidents)
			}
		},
		Y: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{Y: value});
				}),
			nD: function ($) {
				return $.Y;
			},
			nE: {
				kJ: 'admission',
				lO: t_($author$project$Locale$Messages$StudentProfileFormAdmission),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Admission),
				bv: t_($author$project$Locale$Messages$StudentProfileFormAdmission)
			}
		},
		_: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{_: value});
				}),
			nD: function ($) {
				return $._;
			},
			nE: {
				kJ: 'basic_task',
				lj: 'fa-list',
				lO: t_($author$project$Locale$Messages$StudentProfileFormBasicTask),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BasicTask),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$basicTaskOptions(t_)))
			}
		},
		n: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{n: value});
				}),
			nD: function ($) {
				return $.n;
			},
			nE: {
				kJ: 'birth_certificate',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthCertificateUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormBirthCertificateUrl)
			}
		},
		aE: {
			kU: false,
			mu: $author$project$Form$requiredDate(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aE: value});
				}),
			nD: function ($) {
				return $.aE;
			},
			nE: {
				kJ: 'birth_date',
				lO: t_($author$project$Locale$Messages$PersonBirthDate),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthDate)
			}
		},
		ac: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ac: value});
				}),
			nD: function ($) {
				return $.ac;
			},
			nE: {
				kJ: 'birth_place',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthPlace),
				bv: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				hH: 'text'
			}
		},
		aG: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aG: value});
				}),
			nD: function ($) {
				return $.aG;
			},
			nE: {
				kJ: 'birthplace_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$BirthPlaceCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		ad: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ad: value});
				}),
			nD: function ($) {
				return $.ad;
			},
			nE: {
				kJ: 'survey_id',
				lO: t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$CompetencyTestResults),
				bv: t_($author$project$Locale$Messages$StudentProfileFormCompetencyTestResults)
			}
		},
		id: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{id: value});
				}),
			nD: function ($) {
				return $.id;
			},
			nE: {
				kJ: 'is_individual_student',
				lj: 'fa-calendar',
				lO: t_($author$project$Locale$Messages$StudentProfileFormCurrentSchoolYear),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$CurrentSchoolYear),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$schoolYearOptions(t_)))
			}
		},
		ae: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ae: value});
				}),
			nD: function ($) {
				return $.ae;
			},
			nE: {
				kJ: 'disciplinary_and_compensation_cases',
				lO: t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$DisciplinaryAndCompensationCases),
				bv: t_($author$project$Locale$Messages$StudentProfileFormDisciplinaryAndCompensationCases)
			}
		},
		af: {
			kU: false,
			mu: $author$project$Person$optionalEduId(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{af: value});
				}),
			nD: function ($) {
				return $.af;
			},
			nE: {
				kJ: 'edu_id',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$PersonEduId),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$EduId),
				bv: t_($author$project$Locale$Messages$PersonEduId),
				hH: 'text'
			}
		},
		K: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{K: value});
				}),
			nD: function ($) {
				return $.K;
			},
			nE: {
				kJ: 'email',
				lj: 'fa-envelope',
				lO: t_($author$project$Locale$Messages$PersonEmail),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Email),
				bv: t_($author$project$Locale$Messages$PersonEmail),
				hH: 'email'
			}
		},
		v: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{v: value});
				}),
			nD: function ($) {
				return $.v;
			},
			nE: {
				kJ: 'evaluation',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$EvaluationUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormEvaluationUrl)
			}
		},
		ag: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ag: value});
				}),
			nD: function ($) {
				return $.ag;
			},
			nE: {
				kJ: 'exams',
				lO: t_($author$project$Locale$Messages$StudentProfileFormExams),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Exams),
				bv: t_($author$project$Locale$Messages$StudentProfileFormExams)
			}
		},
		a6: {
			kU: false,
			mu: $author$project$StudentProfile$optionalForeignLanguage(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a6: value});
				}),
			nD: function ($) {
				return $.a6;
			},
			nE: {
				kJ: 'first_foreign_language',
				lj: 'fa-flag',
				lO: t_($author$project$Locale$Messages$StudentProfileFormFirstForeignLanguage),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$FirstForeignLanguage),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$foreignLanguageOptions(t_)))
			}
		},
		k3: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{k3: value});
				}),
			nD: function ($) {
				return $.k3;
			},
			nE: {
				kJ: 'firstname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonFirstName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$FirstName),
				bv: t_($author$project$Locale$Messages$PersonFirstName),
				hH: 'text'
			}
		},
		o: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{o: value});
				}),
			nD: function ($) {
				return $.o;
			},
			nE: {
				kJ: 'id_card',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IdCardUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormIdCardUrl)
			}
		},
		x: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{x: value});
				}),
			nD: function ($) {
				return $.x;
			},
			nE: {
				kJ: 'individual_student',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IndividualStudentUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormIndividualStudentUrl)
			}
		},
		ai: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ai: value});
				}),
			nD: function ($) {
				return $.ai;
			},
			nE: {
				kJ: 'is_individual_student',
				lj: 'fa-list',
				lO: t_($author$project$Locale$Messages$StudentProfileFormIsIndividualStudent),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$IsIndividualStudent)
			}
		},
		ak: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ak: value});
				}),
			nD: function ($) {
				return $.ak;
			},
			nE: {
				kJ: 'lastname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonLastName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$LastName),
				bv: t_($author$project$Locale$Messages$PersonLastName),
				hH: 'text'
			}
		},
		E: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{E: value});
				}),
			nD: function ($) {
				return $.E;
			},
			nE: {
				kJ: 'last_report_card',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$LastReportCardUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormLastReportCardUrl)
			}
		},
		l_: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{l_: value});
				}),
			nD: function ($) {
				return $.l_;
			},
			nE: {
				kJ: 'mentor',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonMentor),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Mentor),
				mp: $elm$core$Maybe$Nothing
			}
		},
		al: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{al: value});
				}),
			nD: function ($) {
				return $.al;
			},
			nE: {
				kJ: 'missed_classes',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$StudentProfileFormMissedClasses),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$MissedClasses),
				bv: t_($author$project$Locale$Messages$StudentProfileFormMissedClasses),
				hH: 'text'
			}
		},
		aq: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aq: value});
				}),
			nD: function ($) {
				return $.aq;
			},
			nE: {
				kJ: 'mothers_name',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$MothersMaidenName),
				bv: t_($author$project$Locale$Messages$StudentProfileFormMothersMaidenName),
				hH: 'text'
			}
		},
		ar: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ar: value});
				}),
			nD: function ($) {
				return $.ar;
			},
			nE: {
				kJ: 'nationality',
				lj: 'fa-flag',
				lO: t_($author$project$Locale$Messages$PersonNationality),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Nationality),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		m: {
			kU: false,
			mu: $author$project$StudentProfile$optionalNekId(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{m: value});
				}),
			nD: function ($) {
				return $.m;
			},
			nE: {
				kJ: 'nek_id',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ProfileNekId),
				bv: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				hH: 'text'
			}
		},
		d: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{d: value});
				}),
			nD: function ($) {
				return $.d;
			},
			nE: {
				kJ: 'nek_id',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ProfileNekIdUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl)
			}
		},
		aU: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aU: value});
				}),
			nD: function ($) {
				return $.aU;
			},
			nE: {
				kJ: 'permanent_address_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aV: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aV: value});
				}),
			nD: function ($) {
				return $.aV;
			},
			nE: {
				kJ: 'permanent_address_postcode',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressPostcode),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressPostcode),
				bv: t_($author$project$Locale$Messages$PersonAddressPostcode),
				hH: 'text'
			}
		},
		aW: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aW: value});
				}),
			nD: function ($) {
				return $.aW;
			},
			nE: {
				kJ: 'permanent_address_street_door',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetDoor),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				hH: 'text'
			}
		},
		aX: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aX: value});
				}),
			nD: function ($) {
				return $.aX;
			},
			nE: {
				kJ: 'permanent_address_street_name',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetName),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetName),
				hH: 'text'
			}
		},
		aY: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aY: value});
				}),
			nD: function ($) {
				return $.aY;
			},
			nE: {
				kJ: 'permanent_address_street_number',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetNumber),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				hH: 'text'
			}
		},
		aZ: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aZ: value});
				}),
			nD: function ($) {
				return $.aZ;
			},
			nE: {
				kJ: 'permanent_address_street_type',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetType),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressStreetType),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetType),
				hH: 'text'
			}
		},
		a_: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a_: value});
				}),
			nD: function ($) {
				return $.a_;
			},
			nE: {
				kJ: 'permanent_address_town',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PermanentAddressTown),
				bv: t_($author$project$Locale$Messages$PersonAddressTown),
				hH: 'text'
			}
		},
		aQ: {
			kU: false,
			mu: $author$project$Form$optionalPhoneNumber(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aQ: value});
				}),
			nD: function ($) {
				return $.aQ;
			},
			nE: {
				kJ: 'phone',
				lj: 'fa-phone',
				lO: t_($author$project$Locale$Messages$PersonPhone),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$PhoneNumber),
				bv: t_($author$project$Locale$Messages$PersonPhone),
				hH: 'phone'
			}
		},
		q: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{q: value});
				}),
			nD: function ($) {
				return $.q;
			},
			nE: {
				kJ: 'residence_permit',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$ResidencePermitUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormResidencePermitUrl)
			}
		},
		at: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{at: value});
				}),
			nD: function ($) {
				return $.at;
			},
			nE: {
				kJ: 'school_year_repetition',
				lO: t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SchoolYearRepetition),
				bv: t_($author$project$Locale$Messages$StudentProfileFormSchoolYearRepetition)
			}
		},
		bb: {
			kU: false,
			mu: $author$project$StudentProfile$optionalForeignLanguage(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{bb: value});
				}),
			nD: function ($) {
				return $.bb;
			},
			nE: {
				kJ: 'second_foreign_language',
				lj: 'fa-flag',
				lO: t_($author$project$Locale$Messages$StudentProfileFormSecondForeignLanguage),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SecondForeignLanguage),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$foreignLanguageOptions(t_)))
			}
		},
		au: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{au: value});
				}),
			nD: function ($) {
				return $.au;
			},
			nE: {
				kJ: 'sni_status',
				lj: 'fa-list',
				lO: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatus),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SpecialStatus),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$StudentProfile$specialStatusOptions(t_)))
			}
		},
		A: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{A: value});
				}),
			nD: function ($) {
				return $.A;
			},
			nE: {
				kJ: 'sni_report',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SpecialStatusUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormSpecialStatusUrl)
			}
		},
		av: {
			kU: false,
			mu: $author$project$Person$requireValidSsn(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{av: value});
				}),
			nD: function ($) {
				return $.av;
			},
			nE: {
				kJ: 'ssn',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$PersonSsn),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Ssn),
				bv: t_($author$project$Locale$Messages$PersonSsn),
				hH: 'text'
			}
		},
		r: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{r: value});
				}),
			nD: function ($) {
				return $.r;
			},
			nE: {
				kJ: 'ssn',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormSsnUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SsnUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormSsnUrl)
			}
		},
		aw: {
			kU: false,
			mu: $author$project$StudentProfile$validStudentCardId(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aw: value});
				}),
			nD: function ($) {
				return $.aw;
			},
			nE: {
				kJ: 'student_card_id',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$StudentProfileFormStudentCardId),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$StudentCardId),
				bv: t_($author$project$Locale$Messages$StudentProfileFormStudentCardId),
				hH: 'text'
			}
		},
		F: {
			kU: false,
			mu: A2(
				$author$project$Form$optionalFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{F: value});
				}),
			nD: function ($) {
				return $.F;
			},
			nE: {
				kJ: 'student_card',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormStudentCardUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$StudentCardUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormStudentCardUrl)
			}
		},
		ax: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ax: value});
				}),
			nD: function ($) {
				return $.ax;
			},
			nE: {
				kJ: 'supervising_school',
				lj: 'fa-school',
				lO: t_($author$project$Locale$Messages$PersonSupervisingSchool),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$SupervisingSchool),
				bv: t_($author$project$Locale$Messages$PersonSupervisingSchool),
				hH: 'text'
			}
		},
		s: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{s: value});
				}),
			nD: function ($) {
				return $.s;
			},
			nE: {
				kJ: 'tax_id',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TaxIdUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormTaxIdUrl)
			}
		},
		jF: {
			kU: false,
			mu: $author$project$Form$requiredTeamSelected(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{jF: value});
				}),
			nD: function ($) {
				return $.jF;
			},
			nE: {
				kJ: 'team',
				lj: 'fa-school',
				lO: t_($author$project$Locale$Messages$PersonTeam),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Team),
				mp: $elm$core$Maybe$Nothing
			}
		},
		ay: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ay: value});
				}),
			nD: function ($) {
				return $.ay;
			},
			nE: {
				kJ: 'termination',
				lO: t_($author$project$Locale$Messages$StudentProfileFormTermination),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$Termination),
				bv: t_($author$project$Locale$Messages$StudentProfileFormTermination)
			}
		},
		az: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{az: value});
				}),
			nD: function ($) {
				return $.az;
			},
			nE: {
				kJ: 'textbook_supply',
				lO: t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TextbookSupply),
				bv: t_($author$project$Locale$Messages$StudentProfileFormTextbookSupply)
			}
		},
		aB: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aB: value});
				}),
			nD: function ($) {
				return $.aB;
			},
			nE: {
				kJ: 'trip_abroad',
				lO: t_($author$project$Locale$Messages$StudentProfileFormTripAbroad),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$FormMsg, $author$project$Element$StudentProfileForm$TripAbroad),
				bv: t_($author$project$Locale$Messages$StudentProfileFormTripAbroad)
			}
		}
	};
};
var $author$project$Element$StudentProfileForm$NekFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$StudentProfileForm$NekId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$StudentProfile$requiredNekId = F2(
	function (t_, value) {
		var cleanValue = $elm$core$String$trim(value);
		return A2($elm$regex$Regex$contains, $author$project$StudentProfile$validNekIdFormat, cleanValue) ? $elm$core$Result$Ok(cleanValue) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$StudentProfileInvalidNekId));
	});
var $author$project$Element$StudentProfileForm$buildNekForm = function (t_) {
	return {
		m: {
			kU: false,
			mu: $author$project$StudentProfile$requiredNekId(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{m: value});
				}),
			nD: function ($) {
				return $.m;
			},
			nE: {
				kJ: 'nek_id',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$NekFormMsg, $author$project$Element$StudentProfileForm$NekId),
				bv: t_($author$project$Locale$Messages$StudentProfileFormNekId),
				hH: 'text'
			}
		},
		d: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$StudentProfileForm$acceptedMimeTypes, lX: $author$project$Element$StudentProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{d: value});
				}),
			nD: function ($) {
				return $.d;
			},
			nE: {
				kJ: 'nek_id',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$NekFormMsg, $author$project$Element$StudentProfileForm$NekIdUrl),
				bv: t_($author$project$Locale$Messages$StudentProfileFormNekIdUrl)
			}
		}
	};
};
var $author$project$S3$mime = function (signature) {
	return signature.gy;
};
var $author$project$S3$url = function (signature) {
	var params = _List_fromArray(
		[
			_Utils_Tuple2('X-Amz-Algorithm', signature.gg),
			_Utils_Tuple2('X-Amz-Credential', signature.gh),
			_Utils_Tuple2('X-Amz-Date', signature.gi),
			_Utils_Tuple2(
			'X-Amz-Expires',
			$elm$core$String$fromInt(signature.hM)),
			_Utils_Tuple2('X-Amz-SignedHeaders', signature.j0),
			_Utils_Tuple2('X-Amz-Signature', signature.gj),
			_Utils_Tuple2('response-content-disposition', 'inline'),
			_Utils_Tuple2('response-content-type', signature.gy)
		]);
	var host = 'https://' + signature.f3;
	return A3(
		$author$project$Api$Endpoint$url,
		host,
		_List_fromArray(
			[signature.fl, signature.fk]),
		params);
};
var $author$project$S3$document = function (signature) {
	return {
		eM: $author$project$S3$mime(signature),
		G: $author$project$S3$url(signature)
	};
};
var $author$project$Element$StudentProfileForm$fillForm = function (profile) {
	var student = profile.ne;
	return {
		X: profile.X,
		Y: profile.Y,
		_: profile._,
		n: $author$project$Form$fromFileUrl(profile.n),
		aE: A2($elm$core$Maybe$withDefault, '', student.aE),
		ac: A2($elm$core$Maybe$withDefault, '', student.ac),
		aG: student.aG,
		ad: profile.ad,
		id: profile.id,
		ae: profile.ae,
		af: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, student.af)),
		K: A2($elm$core$Maybe$withDefault, '', student.K),
		v: $author$project$Form$fromFileUrl(profile.v),
		ag: profile.ag,
		a6: profile.a6,
		k3: student.k3,
		o: $author$project$Form$fromFileUrl(profile.o),
		x: $author$project$Form$fromFileUrl(profile.x),
		ai: profile.ai,
		ak: student.ak,
		E: $author$project$Form$fromFileUrl(profile.E),
		l_: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$elm$core$String$fromInt),
				student.l_)),
		al: profile.al,
		aq: profile.aq,
		ar: student.ar,
		m: profile.m,
		d: $author$project$Form$fromFileUrl(profile.d),
		aU: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kF;
				},
				student.c1)),
		aV: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mA;
				},
				student.c1)),
		aW: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.na;
				},
				student.c1)),
		aX: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				student.c1)),
		aY: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nc;
				},
				student.c1)),
		aZ: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nd;
				},
				student.c1)),
		a_: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ny;
				},
				student.c1)),
		aQ: A2($elm$core$Maybe$withDefault, '', student.aQ),
		q: $author$project$Form$fromFileUrl(profile.q),
		at: profile.at,
		bb: profile.bb,
		au: profile.au,
		A: $author$project$Form$fromFileUrl(profile.A),
		av: student.av,
		r: $author$project$Form$fromFileUrl(profile.r),
		aw: profile.aw,
		F: $author$project$Form$fromFileUrl(profile.F),
		ax: A2($elm$core$Maybe$withDefault, '', student.ax),
		s: $author$project$Form$fromFileUrl(profile.s),
		jF: $elm$core$String$fromInt(
			$author$project$Team$teamIdToInt(student.jF.gT)),
		ay: profile.ay,
		az: profile.az,
		aB: profile.aB
	};
};
var $author$project$Element$StudentProfileForm$fillNekForm = function (profile) {
	return {
		m: profile.m,
		d: $author$project$Form$fromFileUrl(profile.d)
	};
};
var $author$project$Element$StudentProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.Y, values) && (A2($author$project$Form$isFieldValid, form.aq, values) && (A2($author$project$Form$isFieldValid, form._, values) && (A2($author$project$Form$isFieldValid, form.ay, values) && (A2($author$project$Form$isFieldValid, form.al, values) && (A2($author$project$Form$isFieldValid, form.X, values) && (A2($author$project$Form$isFieldValid, form.ad, values) && (A2($author$project$Form$isFieldValid, form.ag, values) && (A2($author$project$Form$isFieldValid, form.ae, values) && (A2($author$project$Form$isFieldValid, form.aw, values) && (A2($author$project$Form$isFieldValid, form.az, values) && (A2($author$project$Form$isFieldValid, form.at, values) && (A2($author$project$Form$isFieldValid, form.aB, values) && (A2($author$project$Form$isFieldValid, form.au, values) && (A2($author$project$Form$isFieldValid, form.ai, values) && (A2($author$project$Form$isFieldValid, form.id, values) && (A2($author$project$Form$isFieldValid, form.E, values) && (A2($author$project$Form$isFieldValid, form.v, values) && (A2($author$project$Form$isFieldValid, form.x, values) && (A2($author$project$Form$isFieldValid, form.A, values) && (A2($author$project$Form$isFieldValid, form.n, values) && (A2($author$project$Form$isFieldValid, form.q, values) && (A2($author$project$Form$isFieldValid, form.o, values) && (A2($author$project$Form$isFieldValid, form.s, values) && (A2($author$project$Form$isFieldValid, form.r, values) && (A2($author$project$Form$isFieldValid, form.k3, values) && (A2($author$project$Form$isFieldValid, form.ak, values) && (A2($author$project$Form$isFieldValid, form.K, values) && (A2($author$project$Form$isFieldValid, form.aQ, values) && (A2($author$project$Form$isFieldValid, form.aU, values) && (A2($author$project$Form$isFieldValid, form.aV, values) && (A2($author$project$Form$isFieldValid, form.a_, values) && (A2($author$project$Form$isFieldValid, form.aX, values) && (A2($author$project$Form$isFieldValid, form.aZ, values) && (A2($author$project$Form$isFieldValid, form.aY, values) && (A2($author$project$Form$isFieldValid, form.aW, values) && (A2($author$project$Form$isFieldValid, form.aG, values) && (A2($author$project$Form$isFieldValid, form.ac, values) && (A2($author$project$Form$isFieldValid, form.aE, values) && (A2($author$project$Form$isFieldValid, form.ar, values) && (A2($author$project$Form$isFieldValid, form.av, values) && (A2($author$project$Form$isFieldValid, form.af, values) && (A2($author$project$Form$isFieldValid, form.ax, values) && (A2($author$project$Form$isFieldValid, form.jF, values) && (A2($author$project$Form$isFieldValid, form.l_, values) && (A2($author$project$Form$isFieldValid, form.m, values) && A2($author$project$Form$isFieldValid, form.d, values))))))))))))))))))))))))))))))))))))))))))))));
	});
var $author$project$Element$StudentProfileForm$isNekFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.m, values) && A2($author$project$Form$isFieldValid, form.d, values);
	});
var $author$project$Log$msgAwsSignatureDownload = 'aws_signature_download';
var $author$project$Log$msgStudentProfileSave = 'student_profile_save';
var $author$project$Element$StudentProfileForm$DocumentViewerModel = $elm$core$Basics$identity;
var $author$project$Element$StudentProfileForm$DocumentViewerMsg = $elm$core$Basics$identity;
var $author$project$Element$StudentProfileForm$PopupMsg = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$StudentProfileForm$popups = {
	dE: {
		gF: $author$project$Element$DocumentViewer$element,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$StudentProfileForm$PopupMsg, $elm$core$Basics$identity),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$Element$StudentProfileForm$openDocumentViewer = F3(
	function (session, model, doc) {
		return A3(
			$author$project$Application$V2$Boundaries$mapElement,
			A2($author$project$Application$Boundaries$save, model, session),
			$author$project$Element$StudentProfileForm$popups.dE,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				model.bN.iJ,
				$author$project$Application$V2$SharedConfig$fromV1(model.bN),
				session,
				$author$project$Element$StudentProfileForm$popups.dE,
				{
					eM: $elm$core$Maybe$Just(doc.eM),
					G: doc.G
				}));
	});
var $author$project$Log$paramScopeStudentProfiles = 'scope_student_profiles';
var $author$project$S3$requestPolicy = F3(
	function (config, _v0, callback) {
		var scope = _v0.mV;
		var personId = _v0.my;
		var documentType = _v0.kR;
		var mimeType = _v0.l2;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('person_id', personId),
				_Utils_Tuple2('document_type', documentType),
				_Utils_Tuple2('mime_type', mimeType)
			]);
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$awsPolicy, config, scope, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$S3$postPolicyDecoder));
	});
var $author$project$Api$Endpoint$awsSignature = F3(
	function (config, scope, params) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'aws-signature', scope]),
			params);
	});
var $author$project$S3$Signature = function (bucketName) {
	return function (bucketKey) {
		return function (s3RegionEndpoint) {
			return function (xAmzAlgorithm) {
				return function (xAmzCredential) {
					return function (xAmzDate) {
						return function (xAmzSignature) {
							return function (xAmzExpires) {
								return function (xAmzSignedHeaders) {
									return function (xAmzContent) {
										return function (contentType) {
											return {fk: bucketKey, fl: bucketName, gy: contentType, f3: s3RegionEndpoint, gg: xAmzAlgorithm, nM: xAmzContent, gh: xAmzCredential, gi: xAmzDate, hM: xAmzExpires, gj: xAmzSignature, j0: xAmzSignedHeaders};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$S3$getSignatureDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'content_type',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'x_amz_content_sha256',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'x_amz_signed_headers',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'x_amz_expires',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'x_amz_signature',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'x_amz_date',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'x_amz_credential',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'x_amz_algorithm',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									's3_region_endpoint',
									$elm$json$Json$Decode$string,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'bucket_key',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'bucket_name',
											$elm$json$Json$Decode$string,
											$elm$json$Json$Decode$succeed($author$project$S3$Signature))))))))))));
var $author$project$S3$requestSignature = F3(
	function (config, _v0, callback) {
		var scope = _v0.mV;
		var documentUrl = _v0.bh;
		var params = _List_fromArray(
			[
				_Utils_Tuple2('document_url', documentUrl)
			]);
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$awsSignature, config, scope, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$S3$getSignatureDecoder));
	});
var $author$project$StudentProfile$StudentProfileUnsaved = function (id) {
	return function (state) {
		return function (student) {
			return function (mothersMaidenName) {
				return function (admission) {
					return function (basicTask) {
						return function (termination) {
							return function (missedClasses) {
								return function (accidents) {
									return function (competencyTestResults) {
										return function (exams) {
											return function (disciplinaryAndCompensationCases) {
												return function (studentCardId) {
													return function (textbookSupply) {
														return function (schoolYearRepetition) {
															return function (tripAbroad) {
																return function (specialStatus) {
																	return function (isIndividualStudent) {
																		return function (currentSchoolYear) {
																			return function (nekId) {
																				return function (firstForeignLanguage) {
																					return function (secondForeignLanguage) {
																						return function (lastReportCardUrl) {
																							return function (evaluationUrl) {
																								return function (individualStudentUrl) {
																									return function (specialStatusUrl) {
																										return function (studentCardUrl) {
																											return function (birthCertificateUrl) {
																												return function (residencePermitUrl) {
																													return function (idCardUrl) {
																														return function (taxIdUrl) {
																															return function (ssnUrl) {
																																return function (nekIdUrl) {
																																	return {X: accidents, Y: admission, _: basicTask, n: birthCertificateUrl, ad: competencyTestResults, id: currentSchoolYear, ae: disciplinaryAndCompensationCases, v: evaluationUrl, ag: exams, a6: firstForeignLanguage, gT: id, o: idCardUrl, x: individualStudentUrl, ai: isIndividualStudent, E: lastReportCardUrl, al: missedClasses, aq: mothersMaidenName, m: nekId, d: nekIdUrl, q: residencePermitUrl, at: schoolYearRepetition, bb: secondForeignLanguage, au: specialStatus, A: specialStatusUrl, r: ssnUrl, eZ: state, ne: student, aw: studentCardId, F: studentCardUrl, s: taxIdUrl, ay: termination, az: textbookSupply, aB: tripAbroad};
																																};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$StudentProfile$StudentUnsaved = function (id) {
	return function (firstName) {
		return function (lastName) {
			return function (email) {
				return function (phoneNumber) {
					return function (permanentAddress) {
						return function (temporaryAddress) {
							return function (birthDate) {
								return function (birthPlaceCountry) {
									return function (birthPlace) {
										return function (nationality) {
											return function (eduId) {
												return function (ssn) {
													return function (supervisingSchool) {
														return function (team) {
															return function (mentor) {
																return {aE: birthDate, ac: birthPlace, aG: birthPlaceCountry, af: eduId, K: email, k3: firstName, gT: id, ak: lastName, l_: mentor, ar: nationality, c1: permanentAddress, aQ: phoneNumber, av: ssn, ax: supervisingSchool, jF: team, nn: temporaryAddress};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$StudentProfileForm$saveForm = F3(
	function (form, values, profile) {
		var studentUnsaved = $author$project$StudentProfile$StudentUnsaved(profile.ne.gT)(
			form.k3.nD(values))(
			form.ak.nD(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.K.nD(values)))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.aQ.nD(values)))(
			$elm$core$Maybe$Just(
				A9(
					$author$project$Person$Address,
					true,
					form.aU.nD(values),
					form.a_.nD(values),
					form.aV.nD(values),
					'',
					form.aX.nD(values),
					form.aZ.nD(values),
					form.aY.nD(values),
					form.aW.nD(values))))($elm$core$Maybe$Nothing)(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.aE.nD(values)))(
			form.aG.nD(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.ac.nD(values)))(
			form.ar.nD(values))(
			$elm$core$String$toInt(
				form.af.nD(values)))(
			form.av.nD(values))(
			A2(
				$author$project$Data$toMaybe,
				$elm$core$String$isEmpty,
				form.ax.nD(values)))(
			$author$project$Team$decodeTeamId(
				form.jF.nD(values)))(
			$elm$core$String$toInt(
				form.l_.nD(values)));
		return $author$project$StudentProfile$StudentProfileUnsaved(profile.gT)(profile.eZ)(studentUnsaved)(
			form.aq.nD(values))(
			form.Y.nD(values))(
			form._.nD(values))(
			form.ay.nD(values))(
			form.al.nD(values))(
			form.X.nD(values))(
			form.ad.nD(values))(
			form.ag.nD(values))(
			form.ae.nD(values))(
			form.aw.nD(values))(
			form.az.nD(values))(
			form.at.nD(values))(
			form.aB.nD(values))(
			form.au.nD(values))(
			form.ai.nD(values))(
			form.id.nD(values))(
			form.m.nD(values))(
			form.a6.nD(values))(
			form.bb.nD(values))(
			$author$project$Form$toFileUrl(
				form.E.nD(values)))(
			$author$project$Form$toFileUrl(
				form.v.nD(values)))(
			$author$project$Form$toFileUrl(
				form.x.nD(values)))(
			$author$project$Form$toFileUrl(
				form.A.nD(values)))(
			$author$project$Form$toFileUrl(
				form.F.nD(values)))(
			$author$project$Form$toFileUrl(
				form.n.nD(values)))(
			$author$project$Form$toFileUrl(
				form.q.nD(values)))(
			$author$project$Form$toFileUrl(
				form.o.nD(values)))(
			$author$project$Form$toFileUrl(
				form.s.nD(values)))(
			$author$project$Form$toFileUrl(
				form.r.nD(values)))(
			$author$project$Form$toFileUrl(
				form.d.nD(values)));
	});
var $author$project$Element$StudentProfileForm$saveNekForm = F3(
	function (form, values, profile) {
		var student = profile.ne;
		return $author$project$StudentProfile$StudentProfileUnsaved(profile.gT)(profile.eZ)(
			$author$project$StudentProfile$StudentUnsaved(student.gT)(student.k3)(student.ak)(student.K)(student.aQ)(student.c1)(student.nn)(student.aE)(student.aG)(student.ac)(student.ar)(student.af)(student.av)(student.ax)(student.jF.gT)(
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					student.l_)))(profile.aq)(profile.Y)(profile._)(profile.ay)(profile.al)(profile.X)(profile.ad)(profile.ag)(profile.ae)(profile.aw)(profile.az)(profile.at)(profile.aB)(profile.au)(profile.ai)(profile.id)(
			form.m.nD(values))(profile.a6)(profile.bb)(profile.E)(profile.v)(profile.x)(profile.A)(profile.F)(profile.n)(profile.q)(profile.o)(profile.s)(profile.r)(
			$author$project$Form$toFileUrl(
				form.d.nD(values)));
	});
var $author$project$StudentProfile$studentProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$StudentProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aq: $author$project$Form$markEdited(form.aq)
						}),
					A2(form.aq.jR, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							Y: $author$project$Form$markEdited(form.Y)
						}),
					A2(form.Y.jR, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							_: $author$project$Form$markEdited(form._)
						}),
					A2(form._.jR, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ay: $author$project$Form$markEdited(form.ay)
						}),
					A2(form.ay.jR, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							al: $author$project$Form$markEdited(form.al)
						}),
					A2(form.al.jR, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							X: $author$project$Form$markEdited(form.X)
						}),
					A2(form.X.jR, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ad: $author$project$Form$markEdited(form.ad)
						}),
					A2(form.ad.jR, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ag: $author$project$Form$markEdited(form.ag)
						}),
					A2(form.ag.jR, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ae: $author$project$Form$markEdited(form.ae)
						}),
					A2(form.ae.jR, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aw: $author$project$Form$markEdited(form.aw)
						}),
					A2(form.aw.jR, value, formValues));
			case 10:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							az: $author$project$Form$markEdited(form.az)
						}),
					A2(form.az.jR, value, formValues));
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							at: $author$project$Form$markEdited(form.at)
						}),
					A2(form.at.jR, value, formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aB: $author$project$Form$markEdited(form.aB)
						}),
					A2(form.aB.jR, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							au: $author$project$Form$markEdited(form.au)
						}),
					A2(form.au.jR, value, formValues));
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ai: $author$project$Form$markEdited(form.ai)
						}),
					A2(form.ai.jR, value, formValues));
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							id: $author$project$Form$markEdited(form.id)
						}),
					A2(form.id.jR, value, formValues));
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							m: $author$project$Form$markEdited(form.m)
						}),
					A2(form.m.jR, value, formValues));
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a6: $author$project$Form$markEdited(form.a6)
						}),
					A2(form.a6.jR, value, formValues));
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							bb: $author$project$Form$markEdited(form.bb)
						}),
					A2(form.bb.jR, value, formValues));
			case 31:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							k3: $author$project$Form$markEdited(form.k3)
						}),
					A2(form.k3.jR, value, formValues));
			case 32:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ak: $author$project$Form$markEdited(form.ak)
						}),
					A2(form.ak.jR, value, formValues));
			case 30:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							K: $author$project$Form$markEdited(form.K)
						}),
					A2(form.K.jR, value, formValues));
			case 33:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aQ: $author$project$Form$markEdited(form.aQ)
						}),
					A2(form.aQ.jR, value, formValues));
			case 34:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aU: $author$project$Form$markEdited(form.aU)
						}),
					A2(form.aU.jR, value, formValues));
			case 35:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aV: $author$project$Form$markEdited(form.aV)
						}),
					A2(form.aV.jR, value, formValues));
			case 36:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a_: $author$project$Form$markEdited(form.a_)
						}),
					A2(form.a_.jR, value, formValues));
			case 37:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aX: $author$project$Form$markEdited(form.aX)
						}),
					A2(form.aX.jR, value, formValues));
			case 38:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aZ: $author$project$Form$markEdited(form.aZ)
						}),
					A2(form.aZ.jR, value, formValues));
			case 39:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aY: $author$project$Form$markEdited(form.aY)
						}),
					A2(form.aY.jR, value, formValues));
			case 40:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aW: $author$project$Form$markEdited(form.aW)
						}),
					A2(form.aW.jR, value, formValues));
			case 41:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aG: $author$project$Form$markEdited(form.aG)
						}),
					A2(form.aG.jR, value, formValues));
			case 42:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ac: $author$project$Form$markEdited(form.ac)
						}),
					A2(form.ac.jR, value, formValues));
			case 43:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aE: $author$project$Form$markEdited(form.aE)
						}),
					A2(form.aE.jR, value, formValues));
			case 44:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ar: $author$project$Form$markEdited(form.ar)
						}),
					A2(form.ar.jR, value, formValues));
			case 45:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							av: $author$project$Form$markEdited(form.av)
						}),
					A2(form.av.jR, value, formValues));
			case 46:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							af: $author$project$Form$markEdited(form.af)
						}),
					A2(form.af.jR, value, formValues));
			case 47:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ax: $author$project$Form$markEdited(form.ax)
						}),
					A2(form.ax.jR, value, formValues));
			case 48:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jF: $author$project$Form$markEdited(form.jF)
						}),
					A2(form.jF.jR, value, formValues));
			case 49:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							l_: $author$project$Form$markEdited(form.l_)
						}),
					A2(form.l_.jR, value, formValues));
			case 19:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							E: $author$project$Form$markEdited(form.E)
						}),
					A2(
						form.E.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 25:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							q: $author$project$Form$markEdited(form.q)
						}),
					A2(
						form.q.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 20:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							v: $author$project$Form$markEdited(form.v)
						}),
					A2(
						form.v.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 22:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							A: $author$project$Form$markEdited(form.A)
						}),
					A2(
						form.A.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 21:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							x: $author$project$Form$markEdited(form.x)
						}),
					A2(
						form.x.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 23:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							F: $author$project$Form$markEdited(form.F)
						}),
					A2(
						form.F.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 24:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							n: $author$project$Form$markEdited(form.n)
						}),
					A2(
						form.n.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 26:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							o: $author$project$Form$markEdited(form.o)
						}),
					A2(
						form.o.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 27:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							s: $author$project$Form$markEdited(form.s)
						}),
					A2(
						form.s.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 28:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							r: $author$project$Form$markEdited(form.r)
						}),
					A2(
						form.r.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			default:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							d: $author$project$Form$markEdited(form.d)
						}),
					A2(
						form.d.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
		}
	});
var $author$project$Element$StudentProfileForm$toTeacherOptions = F3(
	function (t_, student, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2(
				$author$project$Person$teachersInTeams,
				_List_fromArray(
					[student.jF.gT]),
				people));
	});
var $author$project$Element$StudentProfileForm$updateMentorOptions = F4(
	function (t_, student, mentors, form) {
		if (!mentors.b) {
			return form;
		} else {
			var people = mentors;
			return _Utils_update(
				form,
				{
					l_: A2(
						$author$project$Form$fillFieldOptions,
						A3($author$project$Element$StudentProfileForm$toTeacherOptions, t_, student, people),
						form.l_)
				});
		}
	});
var $author$project$Element$StudentProfileForm$updateNekForm = F3(
	function (msg, form, formValues) {
		if (!msg.$) {
			var value = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{
						m: $author$project$Form$markEdited(form.m)
					}),
				A2(form.m.jR, value, formValues));
		} else {
			var location = msg.a;
			return _Utils_Tuple2(
				_Utils_update(
					form,
					{
						d: $author$project$Form$markEdited(form.d)
					}),
				A2(
					form.d.jR,
					$author$project$Form$fromFileUrl(location),
					formValues));
		}
	});
var $author$project$Element$StudentProfileForm$updateSchoolOptions = F2(
	function (schools, form) {
		if (!schools.$) {
			if (!schools.a.b) {
				return form;
			} else {
				var schools_ = schools.a;
				return _Utils_update(
					form,
					{
						jF: A2(
							$author$project$Form$fillFieldOptions,
							$author$project$Form$toTeamOptions(schools_),
							form.jF)
					});
			}
		} else {
			return form;
		}
	});
var $author$project$StudentProfile$studentEncoder = function (student) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(student.gT)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(student.k3)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(student.ak)),
				_Utils_Tuple2(
				'email',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.K)),
				_Utils_Tuple2(
				'phone_number',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.aQ)),
				_Utils_Tuple2(
				'permanent_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, student.c1)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, student.nn)),
				_Utils_Tuple2(
				'birthdate',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.aE)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(student.aG)),
				_Utils_Tuple2(
				'birthplace',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.ac)),
				_Utils_Tuple2(
				'nationality',
				$elm$json$Json$Encode$string(student.ar)),
				_Utils_Tuple2(
				'edu_id',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, student.af)),
				_Utils_Tuple2(
				'ssn',
				$elm$json$Json$Encode$string(student.av)),
				_Utils_Tuple2(
				'supervising_school',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, student.ax)),
				_Utils_Tuple2(
				'team',
				$elm$json$Json$Encode$int(
					$author$project$Team$teamIdToInt(student.jF))),
				_Utils_Tuple2(
				'mentor',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, student.l_))
			]));
};
var $author$project$StudentProfile$studentProfileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(profile.eZ)),
				_Utils_Tuple2(
				'student',
				$author$project$StudentProfile$studentEncoder(profile.ne)),
				_Utils_Tuple2(
				'mothers_name',
				$elm$json$Json$Encode$string(profile.aq)),
				_Utils_Tuple2(
				'admission',
				$elm$json$Json$Encode$string(profile.Y)),
				_Utils_Tuple2(
				'basic_task',
				$elm$json$Json$Encode$string(profile._)),
				_Utils_Tuple2(
				'termination',
				$elm$json$Json$Encode$string(profile.ay)),
				_Utils_Tuple2(
				'missed_classes',
				$elm$json$Json$Encode$string(profile.al)),
				_Utils_Tuple2(
				'accidents',
				$elm$json$Json$Encode$string(profile.X)),
				_Utils_Tuple2(
				'competency_test_results',
				$elm$json$Json$Encode$string(profile.ad)),
				_Utils_Tuple2(
				'exams',
				$elm$json$Json$Encode$string(profile.ag)),
				_Utils_Tuple2(
				'disciplinary_and_compensation_cases',
				$elm$json$Json$Encode$string(profile.ae)),
				_Utils_Tuple2(
				'student_card_id',
				$elm$json$Json$Encode$string(profile.aw)),
				_Utils_Tuple2(
				'textbook_supply',
				$elm$json$Json$Encode$string(profile.az)),
				_Utils_Tuple2(
				'school_year_repetition',
				$elm$json$Json$Encode$string(profile.at)),
				_Utils_Tuple2(
				'trip_abroad',
				$elm$json$Json$Encode$string(profile.aB)),
				_Utils_Tuple2(
				'sni_status',
				$elm$json$Json$Encode$string(profile.au)),
				_Utils_Tuple2(
				'is_individual_student',
				$elm$json$Json$Encode$bool(profile.ai)),
				_Utils_Tuple2(
				'current_school_year',
				$elm$json$Json$Encode$string(profile.id)),
				_Utils_Tuple2(
				'nek_id',
				$elm$json$Json$Encode$string(profile.m)),
				_Utils_Tuple2(
				'first_foreign_language',
				$elm$json$Json$Encode$string(profile.a6)),
				_Utils_Tuple2(
				'second_foreign_language',
				$elm$json$Json$Encode$string(profile.bb)),
				_Utils_Tuple2(
				'last_report_card_url',
				$elm$json$Json$Encode$string(profile.E)),
				_Utils_Tuple2(
				'evaluation_url',
				$elm$json$Json$Encode$string(profile.v)),
				_Utils_Tuple2(
				'individual_student_url',
				$elm$json$Json$Encode$string(profile.x)),
				_Utils_Tuple2(
				'sni_report_url',
				$elm$json$Json$Encode$string(profile.A)),
				_Utils_Tuple2(
				'student_card_url',
				$elm$json$Json$Encode$string(profile.F)),
				_Utils_Tuple2(
				'birth_certificate_url',
				$elm$json$Json$Encode$string(profile.n)),
				_Utils_Tuple2(
				'residence_permit_url',
				$elm$json$Json$Encode$string(profile.q)),
				_Utils_Tuple2(
				'id_card_url',
				$elm$json$Json$Encode$string(profile.o)),
				_Utils_Tuple2(
				'tax_id_url',
				$elm$json$Json$Encode$string(profile.s)),
				_Utils_Tuple2(
				'ssn_url',
				$elm$json$Json$Encode$string(profile.r)),
				_Utils_Tuple2(
				'nek_id_url',
				$elm$json$Json$Encode$string(profile.d))
			]));
};
var $author$project$StudentProfile$updateStudentProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$studentProfile, config, profile.ne.gT),
			config,
			$elm$http$Http$jsonBody(
				$author$project$StudentProfile$studentProfileEncoder(profile)),
			callback,
			$author$project$StudentProfile$studentProfileDecoder);
	});
var $author$project$S3$uploadFile = F4(
	function (config, postPolicy, file, callback) {
		return A4(
			$author$project$Api$postExpectingHeaders,
			$author$project$S3$s3Endpoint(postPolicy),
			config,
			A2($author$project$S3$makeFormData, postPolicy, file),
			callback);
	});
var $author$project$Element$StudentProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			X: $author$project$Form$markEdited(form.X),
			Y: $author$project$Form$markEdited(form.Y),
			_: $author$project$Form$markEdited(form._),
			n: $author$project$Form$markEdited(form.n),
			aE: $author$project$Form$markEdited(form.aE),
			ac: $author$project$Form$markEdited(form.ac),
			aG: $author$project$Form$markEdited(form.aG),
			ad: $author$project$Form$markEdited(form.ad),
			id: $author$project$Form$markEdited(form.id),
			ae: $author$project$Form$markEdited(form.ae),
			af: $author$project$Form$markEdited(form.af),
			K: $author$project$Form$markEdited(form.K),
			v: $author$project$Form$markEdited(form.v),
			ag: $author$project$Form$markEdited(form.ag),
			k3: $author$project$Form$markEdited(form.k3),
			o: $author$project$Form$markEdited(form.o),
			x: $author$project$Form$markEdited(form.x),
			ai: $author$project$Form$markEdited(form.ai),
			ak: $author$project$Form$markEdited(form.ak),
			E: $author$project$Form$markEdited(form.E),
			l_: $author$project$Form$markEdited(form.l_),
			al: $author$project$Form$markEdited(form.al),
			aq: $author$project$Form$markEdited(form.aq),
			ar: $author$project$Form$markEdited(form.ar),
			m: $author$project$Form$markEdited(form.m),
			d: $author$project$Form$markEdited(form.d),
			aU: $author$project$Form$markEdited(form.aU),
			aV: $author$project$Form$markEdited(form.aV),
			aW: $author$project$Form$markEdited(form.aW),
			aX: $author$project$Form$markEdited(form.aX),
			aY: $author$project$Form$markEdited(form.aY),
			aZ: $author$project$Form$markEdited(form.aZ),
			a_: $author$project$Form$markEdited(form.a_),
			aQ: $author$project$Form$markEdited(form.aQ),
			q: $author$project$Form$markEdited(form.q),
			at: $author$project$Form$markEdited(form.at),
			au: $author$project$Form$markEdited(form.au),
			A: $author$project$Form$markEdited(form.A),
			av: $author$project$Form$markEdited(form.av),
			r: $author$project$Form$markEdited(form.r),
			aw: $author$project$Form$markEdited(form.aw),
			F: $author$project$Form$markEdited(form.F),
			ax: $author$project$Form$markEdited(form.ax),
			s: $author$project$Form$markEdited(form.s),
			jF: $author$project$Form$markEdited(form.jF),
			ay: $author$project$Form$markEdited(form.ay),
			az: $author$project$Form$markEdited(form.az),
			aB: $author$project$Form$markEdited(form.aB)
		});
};
var $author$project$Element$StudentProfileForm$validateNekForm = function (form) {
	return _Utils_update(
		form,
		{
			m: $author$project$Form$markEdited(form.m),
			d: $author$project$Form$markEdited(form.d)
		});
};
var $author$project$Element$StudentProfileForm$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var viewer = session.nH;
			var config = model.bN;
			var _v0 = _Utils_Tuple2(msg, model.bm);
			_v0$127:
			while (true) {
				switch (_v0.a.$) {
					case 9:
						var popupMsg = _v0.a.a;
						var _v1 = _Utils_Tuple2(popupMsg, model.c3);
						if (!_v1.b.$) {
							var documentViewerMsg = _v1.a;
							var documentViewerModel = _v1.b.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.iJ, session, documentViewerMsg, documentViewerModel, $author$project$Element$StudentProfileForm$popups.dE);
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{c3: $elm$core$Maybe$Nothing}),
								_return.cv);
						} else {
							return A2($author$project$Application$Boundaries$save, model, session);
						}
					case 15:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$BirthCertificateSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 16:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 21:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$ResidencePermitSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 22:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 27:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$SsnSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 28:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 33:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$StudentCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 34:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 39:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$IdCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 40:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 45:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$TaxIdSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 46:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 51:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$SpecialStatusReportSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 52:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 57:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$LastReportCardSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 58:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 63:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$IndividualStudentSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 64:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 69:
						if (_v0.b.$ === 3) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
									$author$project$Element$StudentProfileForm$EvaluationSignatureDownloaded),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 70:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var signature = _v0.a.a.a;
								return A3(
									$author$project$Element$StudentProfileForm$openDocumentViewer,
									session,
									model,
									$author$project$S3$document(signature));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$127;
							}
						}
					case 65:
						if (_v0.b.$ === 3) {
							var _v2 = _v0.a;
							var fieldMsg = _v2.a;
							var documentType = _v2.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$EvaluationFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 66:
						if (_v0.b.$ === 3) {
							var _v3 = _v0.a;
							var fieldMsg = _v3.a;
							var documentType = _v3.b;
							var file = _v3.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.v.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.v.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.v, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													v: $author$project$Form$markEdited(form.v)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$EvaluationPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{ej: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 67:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v4 = _v0.a;
								var fieldMsg = _v4.a;
								var file = _v4.b;
								var policy = _v4.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$EvaluationFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v5 = _v0.a;
								var error = _v5.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.v.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 68:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v6 = _v0.a;
								var fieldMsg = _v6.a;
								var file = _v6.b;
								var metadata = _v6.c.a;
								var _v7 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v7.$) {
									var location = _v7.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$EvaluationFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v8 = _v0.a;
								var error = _v8.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.v.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 53:
						if (_v0.b.$ === 3) {
							var _v9 = _v0.a;
							var fieldMsg = _v9.a;
							var documentType = _v9.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$LastReportCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 54:
						if (_v0.b.$ === 3) {
							var _v10 = _v0.a;
							var fieldMsg = _v10.a;
							var documentType = _v10.b;
							var file = _v10.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.E.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.E.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.E, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													E: $author$project$Form$markEdited(form.E)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$LastReportCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{ej: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 55:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v11 = _v0.a;
								var fieldMsg = _v11.a;
								var file = _v11.b;
								var policy = _v11.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$LastReportCardUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v12 = _v0.a;
								var error = _v12.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.E.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 56:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v13 = _v0.a;
								var fieldMsg = _v13.a;
								var file = _v13.b;
								var metadata = _v13.c.a;
								var _v14 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v14.$) {
									var location = _v14.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$LastReportCardUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v15 = _v0.a;
								var error = _v15.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.E.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 59:
						if (_v0.b.$ === 3) {
							var _v16 = _v0.a;
							var fieldMsg = _v16.a;
							var documentType = _v16.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$IndividualStudentFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 60:
						if (_v0.b.$ === 3) {
							var _v17 = _v0.a;
							var fieldMsg = _v17.a;
							var documentType = _v17.b;
							var file = _v17.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.x.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.x.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.x, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													x: $author$project$Form$markEdited(form.x)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$IndividualStudentPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{ej: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 61:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v18 = _v0.a;
								var fieldMsg = _v18.a;
								var file = _v18.b;
								var policy = _v18.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$IndividualStudentFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v19 = _v0.a;
								var error = _v19.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.x.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 62:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v20 = _v0.a;
								var fieldMsg = _v20.a;
								var file = _v20.b;
								var metadata = _v20.c.a;
								var _v21 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v21.$) {
									var location = _v21.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$IndividualStudentFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v22 = _v0.a;
								var error = _v22.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.x.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 47:
						if (_v0.b.$ === 3) {
							var _v23 = _v0.a;
							var fieldMsg = _v23.a;
							var documentType = _v23.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$SpecialStatusFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 48:
						if (_v0.b.$ === 3) {
							var _v24 = _v0.a;
							var fieldMsg = _v24.a;
							var documentType = _v24.b;
							var file = _v24.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.A.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.A.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.A, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													A: $author$project$Form$markEdited(form.A)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$SpecialStatusReportPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{ej: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 49:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v25 = _v0.a;
								var fieldMsg = _v25.a;
								var file = _v25.b;
								var policy = _v25.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$SpecialStatusFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v26 = _v0.a;
								var error = _v26.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.A.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 50:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v27 = _v0.a;
								var fieldMsg = _v27.a;
								var file = _v27.b;
								var metadata = _v27.c.a;
								var _v28 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v28.$) {
									var location = _v28.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$SpecialStatusFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v29 = _v0.a;
								var error = _v29.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.A.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 29:
						if (_v0.b.$ === 3) {
							var _v30 = _v0.a;
							var fieldMsg = _v30.a;
							var documentType = _v30.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$StudentCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 30:
						if (_v0.b.$ === 3) {
							var _v31 = _v0.a;
							var fieldMsg = _v31.a;
							var documentType = _v31.b;
							var file = _v31.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.F.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.F.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.F, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													F: $author$project$Form$markEdited(form.F)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$StudentCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{ej: valuesWithFileError}))
											}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 31:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v32 = _v0.a;
								var fieldMsg = _v32.a;
								var file = _v32.b;
								var policy = _v32.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$StudentCardFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v33 = _v0.a;
								var error = _v33.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.F.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 32:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v34 = _v0.a;
								var fieldMsg = _v34.a;
								var file = _v34.b;
								var metadata = _v34.c.a;
								var _v35 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v35.$) {
									var location = _v35.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$StudentCardFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v36 = _v0.a;
								var error = _v36.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.F.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 11:
						if (_v0.b.$ === 3) {
							var _v37 = _v0.a;
							var fieldMsg = _v37.a;
							var documentType = _v37.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$BirthCertificateFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 12:
						if (_v0.b.$ === 3) {
							var _v38 = _v0.a;
							var fieldMsg = _v38.a;
							var documentType = _v38.b;
							var file = _v38.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.n.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.n.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.n, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													n: $author$project$Form$markEdited(form.n)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$BirthCertificatePolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													n: $author$project$Form$markEdited(form.n)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 13:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v39 = _v0.a;
								var fieldMsg = _v39.a;
								var file = _v39.b;
								var policy = _v39.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$BirthCertificateFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v40 = _v0.a;
								var error = _v40.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.n.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 14:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v41 = _v0.a;
								var fieldMsg = _v41.a;
								var file = _v41.b;
								var metadata = _v41.c.a;
								var _v42 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v42.$) {
									var location = _v42.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$BirthCertificateFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v43 = _v0.a;
								var error = _v43.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.n.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 17:
						if (_v0.b.$ === 3) {
							var _v44 = _v0.a;
							var fieldMsg = _v44.a;
							var documentType = _v44.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$ResidencePermitFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 18:
						if (_v0.b.$ === 3) {
							var _v45 = _v0.a;
							var fieldMsg = _v45.a;
							var documentType = _v45.b;
							var file = _v45.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.q.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.q.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.q, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													q: $author$project$Form$markEdited(form.q)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$ResidencePermitPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													q: $author$project$Form$markEdited(form.q)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page}),
									session);
							}
						} else {
							break _v0$127;
						}
					case 19:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v46 = _v0.a;
								var fieldMsg = _v46.a;
								var file = _v46.b;
								var policy = _v46.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$ResidencePermitFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v47 = _v0.a;
								var error = _v47.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.q.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 20:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v48 = _v0.a;
								var fieldMsg = _v48.a;
								var file = _v48.b;
								var metadata = _v48.c.a;
								var _v49 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v49.$) {
									var location = _v49.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$ResidencePermitFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v50 = _v0.a;
								var error = _v50.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.q.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 35:
						if (_v0.b.$ === 3) {
							var _v51 = _v0.a;
							var fieldMsg = _v51.a;
							var documentType = _v51.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$IdCardFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 36:
						if (_v0.b.$ === 3) {
							var _v52 = _v0.a;
							var fieldMsg = _v52.a;
							var documentType = _v52.b;
							var file = _v52.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.o.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.o.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.o, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													o: $author$project$Form$markEdited(form.o)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$IdCardPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													o: $author$project$Form$markEdited(form.o)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page}),
									session);
							}
						} else {
							break _v0$127;
						}
					case 37:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v53 = _v0.a;
								var fieldMsg = _v53.a;
								var file = _v53.b;
								var policy = _v53.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$IdCardFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v54 = _v0.a;
								var error = _v54.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.o.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 38:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v55 = _v0.a;
								var fieldMsg = _v55.a;
								var file = _v55.b;
								var metadata = _v55.c.a;
								var _v56 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v56.$) {
									var location = _v56.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$IdCardFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v57 = _v0.a;
								var error = _v57.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.o.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 41:
						if (_v0.b.$ === 3) {
							var _v58 = _v0.a;
							var fieldMsg = _v58.a;
							var documentType = _v58.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$TaxIdFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 42:
						if (_v0.b.$ === 3) {
							var _v59 = _v0.a;
							var fieldMsg = _v59.a;
							var documentType = _v59.b;
							var file = _v59.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.s.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.s.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.s, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													s: $author$project$Form$markEdited(form.s)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$TaxIdPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													s: $author$project$Form$markEdited(form.s)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 43:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v60 = _v0.a;
								var fieldMsg = _v60.a;
								var file = _v60.b;
								var policy = _v60.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$TaxIdFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v61 = _v0.a;
								var error = _v61.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.s.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 44:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v62 = _v0.a;
								var fieldMsg = _v62.a;
								var file = _v62.b;
								var metadata = _v62.c.a;
								var _v63 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v63.$) {
									var location = _v63.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$TaxIdFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v64 = _v0.a;
								var error = _v64.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.s.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 23:
						if (_v0.b.$ === 3) {
							var _v65 = _v0.a;
							var fieldMsg = _v65.a;
							var documentType = _v65.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$StudentProfileForm$acceptedMimeTypes,
									A2($author$project$Element$StudentProfileForm$SsnFileSelected, fieldMsg, documentType)),
								A2($author$project$Application$Boundaries$save, model, session));
						} else {
							break _v0$127;
						}
					case 24:
						if (_v0.b.$ === 3) {
							var _v66 = _v0.a;
							var fieldMsg = _v66.a;
							var documentType = _v66.b;
							var file = _v66.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.r.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.r.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.ne.gT),
								mV: $author$project$Element$StudentProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.r, valuesWithFileSelected)) {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													r: $author$project$Form$markEdited(form.r)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$StudentProfileForm$SsnPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													r: $author$project$Form$markEdited(form.r)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									$elm$core$Platform$Cmd$none,
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							}
						} else {
							break _v0$127;
						}
					case 25:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v67 = _v0.a;
								var fieldMsg = _v67.a;
								var file = _v67.b;
								var policy = _v67.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$StudentProfileForm$SsnFileUploaded, fieldMsg, file)),
									A2($author$project$Application$Boundaries$save, model, session));
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v68 = _v0.a;
								var error = _v68.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.r.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 26:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 3) {
								var _v69 = _v0.a;
								var fieldMsg = _v69.a;
								var file = _v69.b;
								var metadata = _v69.c.a;
								var _v70 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v70.$) {
									var location = _v70.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$StudentProfileForm$SsnFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$127;
							}
						} else {
							if (_v0.b.$ === 3) {
								var _v71 = _v0.a;
								var error = _v71.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var session2 = A3(
									$author$project$Session$error,
									session,
									error,
									session.hy($author$project$Locale$Messages$FormFileUploadError));
								var model2 = _Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{
													ej: A2(form.r.jR, $author$project$Form$NoFile, values)
												}))
									});
								var cmd = A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgFileUpload,
										$elm$core$Maybe$Just('student_profiles'),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									cmd,
									A2($author$project$Application$Boundaries$save, model2, session2));
							} else {
								break _v0$127;
							}
						}
					case 75:
						switch (_v0.b.$) {
							case 3:
								var documentUrl = _v0.a.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestSignature,
										config.gr,
										{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
										$author$project$Element$StudentProfileForm$NekIdSignatureDownloaded),
									A2($author$project$Application$Boundaries$save, model, session));
							case 4:
								var documentUrl = _v0.a.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestSignature,
										config.gr,
										{bh: documentUrl, mV: $author$project$Element$StudentProfileForm$awsPolicyScope},
										$author$project$Element$StudentProfileForm$NekIdSignatureDownloaded),
									A2($author$project$Application$Boundaries$save, model, session));
							default:
								break _v0$127;
						}
					case 76:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 3:
									var signature = _v0.a.a.a;
									return A3(
										$author$project$Element$StudentProfileForm$openDocumentViewer,
										session,
										model,
										$author$project$S3$document(signature));
								case 4:
									var signature = _v0.a.a.a;
									return A3(
										$author$project$Element$StudentProfileForm$openDocumentViewer,
										session,
										model,
										$author$project$S3$document(signature));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var error = _v0.a.a.a;
									var profile = _v0.b.a.j;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgAwsSignatureDownload,
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(
														$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
												error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
								case 4:
									var error = _v0.a.a.a;
									var profile = _v0.b.a.j;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3(
												$author$project$Log$msgAwsSignatureDownload,
												$elm$core$Maybe$Just(
													$elm$core$String$fromInt(
														$author$project$StudentProfile$studentProfileIdToInt(profile.gT))),
												error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
								default:
									break _v0$127;
							}
						}
					case 71:
						switch (_v0.b.$) {
							case 3:
								var _v72 = _v0.a;
								var fieldMsg = _v72.a;
								var documentType = _v72.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A2(
										$elm$file$File$Select$file,
										$author$project$Element$StudentProfileForm$acceptedMimeTypes,
										A2($author$project$Element$StudentProfileForm$NekIdFileSelected, fieldMsg, documentType)),
									A2($author$project$Application$Boundaries$save, model, session));
							case 4:
								var _v79 = _v0.a;
								var fieldMsg = _v79.a;
								var documentType = _v79.b;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A2(
										$elm$file$File$Select$file,
										$author$project$Element$StudentProfileForm$acceptedMimeTypes,
										A2($author$project$Element$StudentProfileForm$NekIdFileSelected, fieldMsg, documentType)),
									A2($author$project$Application$Boundaries$save, model, session));
							default:
								break _v0$127;
						}
					case 72:
						switch (_v0.b.$) {
							case 3:
								var _v73 = _v0.a;
								var fieldMsg = _v73.a;
								var documentType = _v73.b;
								var file = _v73.c;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var profile = formPage.j;
								var valuesWithFileSelected = A2(
									form.d.jR,
									$author$project$Form$FileSelected(file),
									values);
								var valuesWithFileError = A2(
									form.d.jR,
									$author$project$Form$InvalidFile(file),
									values);
								var params = {
									kR: documentType,
									l2: $elm$file$File$mime(file),
									my: $elm$core$String$fromInt(profile.ne.gT),
									mV: $author$project$Element$StudentProfileForm$awsPolicyScope
								};
								if (A2($author$project$Form$isFieldValid, form.d, valuesWithFileSelected)) {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bt: _Utils_update(
													form,
													{
														d: $author$project$Form$markEdited(form.d)
													}),
												ej: valuesWithFileSelected
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$S3$requestPolicy,
											config.gr,
											params,
											A2($author$project$Element$StudentProfileForm$NekIdPolicyDownloaded, fieldMsg, file)),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bt: _Utils_update(
													form,
													{
														d: $author$project$Form$markEdited(form.d)
													}),
												ej: valuesWithFileError
											}));
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session);
								}
							case 4:
								var _v80 = _v0.a;
								var fieldMsg = _v80.a;
								var documentType = _v80.b;
								var file = _v80.c;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var profile = formPage.j;
								var valuesWithFileSelected = A2(
									form.d.jR,
									$author$project$Form$FileSelected(file),
									values);
								var valuesWithFileError = A2(
									form.d.jR,
									$author$project$Form$InvalidFile(file),
									values);
								var params = {
									kR: documentType,
									l2: $elm$file$File$mime(file),
									my: $elm$core$String$fromInt(profile.ne.gT),
									mV: $author$project$Element$StudentProfileForm$awsPolicyScope
								};
								if (A2($author$project$Form$isFieldValid, form.d, valuesWithFileSelected)) {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bt: _Utils_update(
													form,
													{
														d: $author$project$Form$markEdited(form.d)
													}),
												ej: valuesWithFileSelected
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$S3$requestPolicy,
											config.gr,
											params,
											A2($author$project$Element$StudentProfileForm$NekIdPolicyDownloaded, fieldMsg, file)),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bt: _Utils_update(
													form,
													{
														d: $author$project$Form$markEdited(form.d)
													}),
												ej: valuesWithFileError
											}));
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session);
								}
							default:
								break _v0$127;
						}
					case 73:
						if (!_v0.a.c.$) {
							switch (_v0.b.$) {
								case 3:
									var _v74 = _v0.a;
									var fieldMsg = _v74.a;
									var file = _v74.b;
									var policy = _v74.c.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A4(
											$author$project$S3$uploadFile,
											config.gr,
											policy,
											file,
											A2($author$project$Element$StudentProfileForm$NekIdFileUploaded, fieldMsg, file)),
										A2($author$project$Application$Boundaries$save, model, session));
								case 4:
									var _v81 = _v0.a;
									var fieldMsg = _v81.a;
									var file = _v81.b;
									var policy = _v81.c.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A4(
											$author$project$S3$uploadFile,
											config.gr,
											policy,
											file,
											A2($author$project$Element$StudentProfileForm$NekIdFileUploaded, fieldMsg, file)),
										A2($author$project$Application$Boundaries$save, model, session));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v75 = _v0.a;
									var error = _v75.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bt;
									var values = formPage.ej;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														ej: A2(form.d.jR, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var _v82 = _v0.a;
									var error = _v82.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bt;
									var values = formPage.ej;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{
														ej: A2(form.d.jR, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					case 74:
						if (!_v0.a.c.$) {
							switch (_v0.b.$) {
								case 3:
									var _v76 = _v0.a;
									var fieldMsg = _v76.a;
									var file = _v76.b;
									var metadata = _v76.c.a;
									var _v77 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
									if (!_v77.$) {
										var location = _v77.a;
										var $temp$session = session,
											$temp$msg = fieldMsg(location),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										var $temp$session = session,
											$temp$msg = A3(
											$author$project$Element$StudentProfileForm$NekIdFileUploaded,
											fieldMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata))),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									}
								case 4:
									var _v83 = _v0.a;
									var fieldMsg = _v83.a;
									var file = _v83.b;
									var metadata = _v83.c.a;
									var _v84 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
									if (!_v84.$) {
										var location = _v84.a;
										var $temp$session = session,
											$temp$msg = fieldMsg(location),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									} else {
										var $temp$session = session,
											$temp$msg = A3(
											$author$project$Element$StudentProfileForm$NekIdFileUploaded,
											fieldMsg,
											file,
											$elm$core$Result$Err(
												$author$project$Api$BadHeader(metadata))),
											$temp$model = model;
										session = $temp$session;
										msg = $temp$msg;
										model = $temp$model;
										continue update;
									}
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var _v78 = _v0.a;
									var error = _v78.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bt;
									var values = formPage.ej;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														ej: A2(form.d.jR, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('student_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var _v85 = _v0.a;
									var error = _v85.c.a;
									var formPage = _v0.b.a;
									var form = formPage.bt;
									var values = formPage.ej;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormFileUploadError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{
														ej: A2(form.d.jR, $author$project$Form$NoFile, values)
													}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('student_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					case 3:
						var id = _v0.a.a;
						var model2 = _Utils_update(
							model,
							{
								bm: $author$project$Element$StudentProfileForm$LoadingPage(id),
								jr: $author$project$RemoteData$Loading
							});
						var cmd = $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A3($author$project$StudentProfile$fetchStudentProfile, config.gr, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
									A2($author$project$Team$fetchSchools, config.gr, $author$project$Element$StudentProfileForm$SchoolListDownloaded),
									$author$project$ACL$canManageStudentAdminData(viewer) ? A2($author$project$Person$fetchPhoneBook, config.gr, $author$project$Element$StudentProfileForm$PhoneBookDownloaded) : $elm$core$Platform$Cmd$none
								]));
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							A2($author$project$Application$Boundaries$save, model2, session));
					case 4:
						var id = _v0.a.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3($author$project$StudentProfile$fetchStudentProfile, config.gr, id, $author$project$Element$StudentProfileForm$StudentProfileDownloaded),
							A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{
										bm: $author$project$Element$StudentProfileForm$LoadingNekPage(id)
									}),
								session));
					case 6:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 1:
									var profile = _v0.a.a.a;
									var studentId = _v0.b.a;
									if (_Utils_eq(profile.ne.gT, studentId)) {
										var form = A4(
											$author$project$Element$StudentProfileForm$updateMentorOptions,
											session.hy,
											profile.ne,
											model.fT,
											A2(
												$author$project$Element$StudentProfileForm$updateSchoolOptions,
												$author$project$RemoteData$toMaybe(model.jr),
												$author$project$Element$StudentProfileForm$buildForm(session.hy)));
										var page = $author$project$Element$StudentProfileForm$FormPage(
											{
												bt: form,
												j: profile,
												eZ: 0,
												ej: $author$project$Element$StudentProfileForm$fillForm(profile)
											});
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session);
									} else {
										return A2($author$project$Application$Boundaries$save, model, session);
									}
								case 2:
									var profile = _v0.a.a.a;
									var studentId = _v0.b.a;
									if (_Utils_eq(profile.ne.gT, studentId)) {
										var page = $author$project$Element$StudentProfileForm$NekFormPage(
											{
												bt: $author$project$Element$StudentProfileForm$buildNekForm(session.hy),
												j: profile,
												eZ: 0,
												ej: $author$project$Element$StudentProfileForm$fillNekForm(profile)
											});
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session);
									} else {
										return A2($author$project$Application$Boundaries$save, model, session);
									}
								default:
									break _v0$127;
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgStudentProfileDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$StudentProfileFormDownloadError))));
						}
					case 7:
						var data = _v0.a.a;
						var page = _v0.b;
						var model2 = _Utils_update(
							model,
							{jr: data});
						var _v86 = _Utils_Tuple2(data, page);
						_v86$2:
						while (true) {
							switch (_v86.a.$) {
								case 2:
									if (_v86.b.$ === 3) {
										var schools = _v86.a.a;
										var formPage = _v86.b.a;
										var form = formPage.bt;
										var form2 = A2(
											$author$project$Element$StudentProfileForm$updateSchoolOptions,
											$elm$core$Maybe$Just(schools),
											form);
										var page2 = $author$project$Element$StudentProfileForm$FormPage(
											_Utils_update(
												formPage,
												{bt: form2}));
										return A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model2,
												{bm: page2}),
											session);
									} else {
										break _v86$2;
									}
								case 3:
									var error = _v86.a.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$Log$error,
											config,
											_Utils_Tuple3($author$project$Log$msgTeamsDownload, $elm$core$Maybe$Nothing, error),
											$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
										A2(
											$author$project$Application$Boundaries$save,
											model2,
											A3(
												$author$project$Session$error,
												session,
												error,
												session.hy($author$project$Locale$Messages$TeamListDownloadError))));
								default:
									break _v86$2;
							}
						}
						return A2($author$project$Application$Boundaries$save, model2, session);
					case 8:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 3) {
								var phonebook = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var profile = formPage.j;
								var page = $author$project$Element$StudentProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: A4($author$project$Element$StudentProfileForm$updateMentorOptions, session.hy, profile.ne, phonebook, form)
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page, fT: phonebook}),
									session);
							} else {
								var phonebook = _v0.a.a.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{fT: phonebook}),
									session);
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeStudentProfiles),
										error),
									$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$PhoneBookDownloadError))));
						}
					case 0:
						if (_v0.b.$ === 3) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v87 = A3($author$project$Element$StudentProfileForm$updateForm, fieldMsg, formPage.bt, formPage.ej);
							var form2 = _v87.a;
							var values2 = _v87.b;
							var page = $author$project$Element$StudentProfileForm$FormPage(
								_Utils_update(
									formPage,
									{bt: form2, eZ: 1, ej: values2}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bm: page}),
								session);
						} else {
							break _v0$127;
						}
					case 1:
						if (_v0.b.$ === 4) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v89 = A3($author$project$Element$StudentProfileForm$updateNekForm, fieldMsg, formPage.bt, formPage.ej);
							var form2 = _v89.a;
							var values2 = _v89.b;
							var page = $author$project$Element$StudentProfileForm$NekFormPage(
								_Utils_update(
									formPage,
									{bt: form2, eZ: 1, ej: values2}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bm: page}),
								session);
						} else {
							break _v0$127;
						}
					case 2:
						switch (_v0.b.$) {
							case 3:
								var _v88 = _v0.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var profile = formPage.j;
								if (A2($author$project$Element$StudentProfileForm$isFormValid, form, values)) {
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$StudentProfile$updateStudentProfile,
											config.gr,
											A3($author$project$Element$StudentProfileForm$saveForm, form, values, profile),
											$author$project$Element$StudentProfileForm$ProfileSaved),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bm: $author$project$Element$StudentProfileForm$FormPage(
														_Utils_update(
															formPage,
															{eZ: 2}))
												}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$FormPage(
										_Utils_update(
											formPage,
											{
												bt: $author$project$Element$StudentProfileForm$validateForm(form),
												eZ: 1
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$author$project$Ports$scrollToFormError,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session));
								}
							case 4:
								var _v90 = _v0.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var profile = formPage.j;
								if (A2($author$project$Element$StudentProfileForm$isNekFormValid, form, values)) {
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A3(
											$author$project$StudentProfile$updateStudentProfile,
											config.gr,
											A3($author$project$Element$StudentProfileForm$saveNekForm, form, values, profile),
											$author$project$Element$StudentProfileForm$ProfileSaved),
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bm: $author$project$Element$StudentProfileForm$NekFormPage(
														_Utils_update(
															formPage,
															{eZ: 2}))
												}),
											session));
								} else {
									var page = $author$project$Element$StudentProfileForm$NekFormPage(
										_Utils_update(
											formPage,
											{
												bt: $author$project$Element$StudentProfileForm$validateNekForm(form),
												eZ: 1
											}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$author$project$Ports$scrollToFormError,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{bm: page}),
											session));
								}
							default:
								break _v0$127;
						}
					case 5:
						if (!_v0.a.a.$) {
							switch (_v0.b.$) {
								case 3:
									var formPage = _v0.b.a;
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$StudentProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eZ: 0}))
											}),
										A2(
											$author$project$Session$ok,
											session,
											session.hy($author$project$Locale$Messages$StudentProfileFormSaveSuccess)));
								case 4:
									var formPage = _v0.b.a;
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										$elm$core$Platform$Cmd$none,
										A2(
											$author$project$Application$Boundaries$save,
											_Utils_update(
												model,
												{
													bm: $author$project$Element$StudentProfileForm$NekFormPage(
														_Utils_update(
															formPage,
															{eZ: 0}))
												}),
											A2(
												$author$project$Session$ok,
												session,
												session.hy($author$project$Locale$Messages$StudentProfileFormSaveSuccess))));
								default:
									break _v0$127;
							}
						} else {
							switch (_v0.b.$) {
								case 3:
									var error = _v0.a.a.a;
									var formPage = _v0.b.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormSaveError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$FormPage(
												_Utils_update(
													formPage,
													{eZ: 3}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgStudentProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								case 4:
									var error = _v0.a.a.a;
									var formPage = _v0.b.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormSaveError));
									var model2 = _Utils_update(
										model,
										{
											bm: $author$project$Element$StudentProfileForm$NekFormPage(
												_Utils_update(
													formPage,
													{eZ: 3}))
										});
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgStudentProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$StudentProfileForm$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2($author$project$Application$Boundaries$save, model2, session2));
								default:
									break _v0$127;
							}
						}
					default:
						var _v91 = _v0.a;
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			}
			return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$StudentProfileFormLoadingProgress = {$: 571};
var $author$project$Locale$Messages$StudentProfileFormNotFound = {$: 572};
var $author$project$Element$StudentProfileForm$BirthCertificateFileDownloadRequested = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$StudentProfileForm$BirthCertificateFileUploadRequested = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$EvaluationFileDownloadRequested = function (a) {
	return {$: 69, a: a};
};
var $author$project$Element$StudentProfileForm$EvaluationFileUploadRequested = F2(
	function (a, b) {
		return {$: 65, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$FormPageSelected = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$StudentProfileForm$FormSubmitted = {$: 2};
var $author$project$Element$StudentProfileForm$IdCardFileDownloadRequested = function (a) {
	return {$: 39, a: a};
};
var $author$project$Element$StudentProfileForm$IdCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$IndividualStudentFileDownloadRequested = function (a) {
	return {$: 63, a: a};
};
var $author$project$Element$StudentProfileForm$IndividualStudentFileUploadRequested = F2(
	function (a, b) {
		return {$: 59, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$LastReportCardFileDownloadRequested = function (a) {
	return {$: 57, a: a};
};
var $author$project$Element$StudentProfileForm$LastReportCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested = function (a) {
	return {$: 75, a: a};
};
var $author$project$Element$StudentProfileForm$NekIdFileUploadRequested = F2(
	function (a, b) {
		return {$: 71, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$ResidencePermitFileDownloadRequested = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$StudentProfileForm$ResidencePermitFileUploadRequested = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$SpecialStatusFileDownloadRequested = function (a) {
	return {$: 51, a: a};
};
var $author$project$Element$StudentProfileForm$SpecialStatusFileUploadRequested = F2(
	function (a, b) {
		return {$: 47, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$SsnFileDownloadRequested = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$StudentProfileForm$SsnFileUploadRequested = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Element$StudentProfileForm$StudentCardFileDownloadRequested = function (a) {
	return {$: 33, a: a};
};
var $author$project$Element$StudentProfileForm$StudentCardFileUploadRequested = F2(
	function (a, b) {
		return {$: 29, a: a, b: b};
	});
var $author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp = {$: 562};
var $author$project$Locale$Messages$StudentProfileFormHeadingSchool = {$: 570};
var $author$project$Locale$Messages$StudentProfileFormHeadingSponsor = {$: 569};
var $author$project$Locale$Messages$StudentProfileFormRequiredIfStudentGoesToSchool = {$: 553};
var $author$project$Locale$Messages$StudentProfileFormSpecialStatusHelp = {$: 543};
var $author$project$Locale$Messages$StudentProfileFormTitle = function (a) {
	return {$: 568, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdFileDownloadRequested = function (a) {
	return {$: 45, a: a};
};
var $author$project$Element$StudentProfileForm$TaxIdFileUploadRequested = F2(
	function (a, b) {
		return {$: 41, a: a, b: b};
	});
var $author$project$UI$frozenChoiceField = $author$project$UI$choiceField_(false);
var $author$project$UI$toggleField = F3(
	function (_v0, field, values) {
		var on = field.nD(values);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('checkbox')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									field.nE.aT(!on)),
									$elm$html$Html$Attributes$type_('checkbox'),
									$author$project$UI$attrCyData(field.nE.kJ),
									$elm$html$Html$Attributes$checked(on)
								]),
							_List_Nil),
							$elm$html$Html$text(field.nE.lO)
						]))
				]));
	});
var $author$project$Locale$Messages$StudentProfileFormSponsors = function (a) {
	return {$: 558, a: a};
};
var $author$project$Element$StudentProfileForm$viewSponsors = F2(
	function (t_, sponsors) {
		var viewSponsorLink = function (person) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$GenericProfileUpdate(person.gT))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, person))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('label')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$StudentProfileFormSponsors(
								$elm$core$List$length(sponsors)))
						])),
					A2(
					$author$project$UI$level,
					A2($elm$core$List$map, viewSponsorLink, sponsors),
					_List_Nil)
				]));
	});
var $author$project$Element$StudentProfileForm$viewForm = F4(
	function (t_, language, viewer, _v0) {
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var profile = _v0.j;
		var heading = function (caption) {
			return A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('heading has-background-light')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-info')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$profile(
								_List_fromArray(
									[
										$author$project$UI$Icon$face('fa-lg'),
										$author$project$UI$Icon$style('is-medium')
									]))
							])),
						caption
					]));
		};
		var viewFormFieldsAdmin = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							heading(
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormHeadingSchool))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.l_, values),
							A3($author$project$UI$choiceField, t_, form._, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.jF, values),
							A3($author$project$UI$textField, t_, form.ax, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$frozenChoiceField, t_, form.id, values),
							A3($author$project$UI$textField, t_, form.al, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.a6, values),
							A3($author$project$UI$choiceField, t_, form.bb, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.m, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.d, values, $author$project$Element$StudentProfileForm$NekIdFileUploadRequested, $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ay, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.X, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ad, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.v, values, $author$project$Element$StudentProfileForm$EvaluationFileUploadRequested, $author$project$Element$StudentProfileForm$EvaluationFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ag, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.Y, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.ae, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.az, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.at, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textareaField, t_, form.aB, values)
						]))
				]));
		var viewFormFieldsBasics = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							heading(
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormHeadingSponsor))
						])),
					$author$project$UI$columns(
					language.ls ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.k3, values),
							A3($author$project$UI$textField, t_, form.ak, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ak, values),
							A3($author$project$UI$textField, t_, form.k3, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.K, values),
							A3($author$project$UI$textField, t_, form.aQ, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aG, values),
							A3($author$project$UI$textField, t_, form.ac, values),
							A4($author$project$UI$dateField, t_, form.aE, values, true)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aq, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.n, values, $author$project$Element$StudentProfileForm$BirthCertificateFileUploadRequested, $author$project$Element$StudentProfileForm$BirthCertificateFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.ar, values),
							$author$project$UI$none
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aU, values),
							A3($author$project$UI$textField, t_, form.a_, values),
							A3($author$project$UI$textField, t_, form.aV, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aX, values),
							A3($author$project$UI$textField, t_, form.aZ, values),
							A3($author$project$UI$textField, t_, form.aY, values),
							A3($author$project$UI$textField, t_, form.aW, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.q, values, $author$project$Element$StudentProfileForm$ResidencePermitFileUploadRequested, $author$project$Element$StudentProfileForm$ResidencePermitFileDownloadRequested)),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.o, values, $author$project$Element$StudentProfileForm$IdCardFileUploadRequested, $author$project$Element$StudentProfileForm$IdCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.av, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.r, values, $author$project$Element$StudentProfileForm$SsnFileUploadRequested, $author$project$Element$StudentProfileForm$SsnFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.af, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.s, values, $author$project$Element$StudentProfileForm$TaxIdFileUploadRequested, $author$project$Element$StudentProfileForm$TaxIdFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aw, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.F, values, $author$project$Element$StudentProfileForm$StudentCardFileUploadRequested, $author$project$Element$StudentProfileForm$StudentCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							$author$project$UI$none,
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A6(
								$author$project$UI$fileField_,
								t_,
								form.E,
								$elm$core$Maybe$Just($author$project$Locale$Messages$StudentProfileFormRequiredIfStudentGoesToSchool),
								values,
								$author$project$Element$StudentProfileForm$LastReportCardFileUploadRequested,
								$author$project$Element$StudentProfileForm$LastReportCardFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormSpecialStatusHelp,
							A3($author$project$UI$choiceField, t_, form.au, values)),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.A, values, $author$project$Element$StudentProfileForm$SpecialStatusFileUploadRequested, $author$project$Element$StudentProfileForm$SpecialStatusFileDownloadRequested))
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.ai, values),
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.x, values, $author$project$Element$StudentProfileForm$IndividualStudentFileUploadRequested, $author$project$Element$StudentProfileForm$IndividualStudentFileDownloadRequested))
						]))
				]));
		var formState = (A2($author$project$Form$isUploading, form.v, values) || (A2($author$project$Form$isUploading, form.x, values) || (A2($author$project$Form$isUploading, form.A, values) || (A2($author$project$Form$isUploading, form.F, values) || (A2($author$project$Form$isUploading, form.n, values) || (A2($author$project$Form$isUploading, form.q, values) || (A2($author$project$Form$isUploading, form.o, values) || (A2($author$project$Form$isUploading, form.s, values) || A2($author$project$Form$isUploading, form.r, values))))))))) ? 2 : state;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						A2($author$project$Element$StudentProfileForm$viewSponsors, t_, profile.ne.m9),
						viewFormFieldsBasics,
						A2(
						$author$project$UI$when,
						$author$project$ACL$canManageStudentAdminData(viewer),
						viewFormFieldsAdmin),
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile),
						formState,
						$author$project$Element$StudentProfileForm$FormSubmitted,
						function (profile_) {
							return $author$project$Element$StudentProfileForm$FormPageSelected(profile_.ne.gT);
						})
					]),
				kJ: 'student-profile-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentProfileFormTitle(
							A2($author$project$Person$fullName, t_, profile.ne)))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$StudentProfileForm$NekFormPageSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$StudentProfileForm$viewNekForm = F2(
	function (t_, _v0) {
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var profile = _v0.j;
		var formState = A2($author$project$Form$isUploading, form.d, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						$author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$textField, t_, form.m, values),
								A4(
								$author$project$UI$withInfoText,
								_List_Nil,
								t_,
								$author$project$Locale$Messages$StudentProfileFormDocumentUploadHelp,
								A5($author$project$UI$fileField, t_, form.d, values, $author$project$Element$StudentProfileForm$NekIdFileUploadRequested, $author$project$Element$StudentProfileForm$NekIdFileDownloadRequested))
							])),
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile),
						formState,
						$author$project$Element$StudentProfileForm$FormSubmitted,
						function (profile_) {
							return $author$project$Element$StudentProfileForm$NekFormPageSelected(profile_.ne.gT);
						})
					]),
				kJ: 'nek-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$StudentProfileFormTitle(
							A2($author$project$Person$fullName, t_, profile.ne)))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$StudentProfileForm$viewPopup = F2(
	function (session, model) {
		var popupModel = model;
		return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$StudentProfileForm$popups.dE);
	});
var $author$project$Element$StudentProfileForm$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 3:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.c3,
							$author$project$Element$StudentProfileForm$viewPopup(session)),
							A4($author$project$Element$StudentProfileForm$viewForm, t_, session.lP, session.nH, formPage)
						]));
			case 4:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.c3,
							$author$project$Element$StudentProfileForm$viewPopup(session)),
							A2($author$project$Element$StudentProfileForm$viewNekForm, t_, formPage)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$StudentProfileFormLoadingProgress));
			case 2:
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$StudentProfileFormLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$StudentProfileFormNotFound)
						]));
		}
	});
var $author$project$Element$StudentProfileForm$element = {iA: $author$project$Element$StudentProfileForm$init, jR: $author$project$Element$StudentProfileForm$update, nE: $author$project$Element$StudentProfileForm$view};
var $author$project$Element$SubjectFeedbackCard$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$SubjectFeedbackCard$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$SubjectFeedbackCard$FetchSubjectFeedbacks = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$SubjectFeedbackCard$FetchSubjectList = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$SubjectFeedbackCard$SubjectFeedbacksDownloaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$SubjectFeedbackCard$SubjectListDownloaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Api$Endpoint$peopleSubjectFeedbackList = F3(
	function (config, personId, subjectId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'people',
					$elm$core$String$fromInt(personId),
					'subject-feedbacks'
				]),
			A3(
				$author$project$Api$Endpoint$optional,
				$elm$core$String$fromInt,
				_Utils_Tuple2('subject', subjectId),
				_List_Nil));
	});
var $author$project$SubjectFeedback$SubjectFeedbackPayload = F4(
	function (student, studentProfile, subject, feedbacks) {
		return {k2: feedbacks, ne: student, ea: studentProfile, e2: subject};
	});
var $author$project$SubjectFeedback$SubjectFeedback = F9(
	function (feedbackType, feedbackId, feedbackUrl, baseFeedbackId, createdAt, updatedAt, createdBy, relatedModule, assessment) {
		return {b$: assessment, kr: baseFeedbackId, gz: createdAt, kG: createdBy, k$: feedbackId, k0: feedbackType, k1: feedbackUrl, mF: relatedModule, nC: updatedAt};
	});
var $author$project$SubjectFeedback$subjectFeedbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'rubric_assessment',
	$author$project$Rubric$rubricAssessmentDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'related_module',
		$elm$json$Json$Decode$maybe($author$project$Module$nestedModuleDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'updated_at',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'created_at',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'base_feedback_id',
						$elm$json$Json$Decode$int,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'feedback_url',
							$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'feedback_id',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'feedback_type',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$SubjectFeedback$SubjectFeedback))))))))));
var $author$project$SubjectFeedback$subjectFeedbackListDecoder = $elm$json$Json$Decode$list($author$project$SubjectFeedback$subjectFeedbackDecoder);
var $author$project$SubjectFeedback$subjectFeedbackPayloadDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'feedbacks',
	$author$project$SubjectFeedback$subjectFeedbackListDecoder,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'subject',
		$elm$json$Json$Decode$maybe($author$project$Subject$subjectDecoder),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'student_profile',
			$author$project$StudentProfile$studentProfileDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'student',
				$author$project$Person$nestedPersonDecoder,
				$elm$json$Json$Decode$succeed($author$project$SubjectFeedback$SubjectFeedbackPayload)))));
var $author$project$SubjectFeedback$fetchSubjectFeedbacks = F4(
	function (config, personId, subjectId, callback) {
		return {
			bN: config,
			dC: $author$project$SubjectFeedback$subjectFeedbackPayloadDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A3($author$project$Api$Endpoint$peopleSubjectFeedbackList, config, personId, subjectId)
		};
	});
var $author$project$Api$Endpoint$subjectsForStudent = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'subjects']),
			_List_fromArray(
				[
					_Utils_Tuple2('cat', 'student'),
					_Utils_Tuple2(
					'student',
					$elm$core$String$fromInt(studentId))
				]));
	});
var $author$project$Subject$fetchSubjectsForStudentV2 = F3(
	function (config, studentId, callback) {
		return {
			bN: config,
			dC: $author$project$Subject$subjectsDecoder,
			bZ: A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
			G: A2($author$project$Api$Endpoint$subjectsForStudent, config, studentId)
		};
	});
var $author$project$Element$SubjectFeedbackCard$init = F3(
	function (config, session, _v0) {
		var studentId = _v0.jz;
		var subjectId = _v0.nf;
		return _Utils_Tuple3(
			{bN: config, f5: studentId, eY: subjectId, cv: session, e3: false, di: $author$project$RemoteData$Loading, jB: $author$project$RemoteData$Loading},
			$author$project$Element$SubjectFeedbackCard$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$SubjectFeedbackCard$Cmd(
						$author$project$Element$SubjectFeedbackCard$FetchSubjectFeedbacks(
							A4($author$project$SubjectFeedback$fetchSubjectFeedbacks, config.gr, studentId, subjectId, $author$project$Element$SubjectFeedbackCard$SubjectFeedbacksDownloaded))),
						$author$project$Element$SubjectFeedbackCard$Cmd(
						$author$project$Element$SubjectFeedbackCard$FetchSubjectList(
							A3($author$project$Subject$fetchSubjectsForStudentV2, config.gr, studentId, $author$project$Element$SubjectFeedbackCard$SubjectListDownloaded)))
					])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$SubjectFeedbackCard$updateFilterUrl = F3(
	function (key, selectedStudentId, selectedSubjectId) {
		return A2(
			$author$project$Route$replaceUrl,
			key,
			A2($author$project$Route$SubjectFeedbackCard, selectedStudentId, selectedSubjectId));
	});
var $author$project$Element$SubjectFeedbackCard$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$SubjectFeedbackCard$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						var studentId = cmd.a;
						var maybeSubjectId = cmd.b;
						return A3($author$project$Element$SubjectFeedbackCard$updateFilterUrl, key, studentId, maybeSubjectId);
					default:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
				}
			default:
				return $elm$core$Platform$Cmd$none;
		}
	});
var $author$project$Element$SubjectFeedbackCard$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$SubjectFeedbackCard$NoEffect = {$: 0};
var $author$project$Element$SubjectFeedbackCard$NoOp = {$: 4};
var $author$project$Locale$Messages$SubjectFeedbacksDownloadError = {$: 593};
var $author$project$Element$SubjectFeedbackCard$UpdateFilterUrl = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Log$msgSubjectFeedbacksDownload = 'subject_feedbacks_download';
var $author$project$Log$paramScopeSubjectFeedbackCard = 'scope_subject_feedback_card';
var $author$project$Element$SubjectFeedbackCard$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var result = msg.a;
				switch (result.$) {
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{di: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{di: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{di: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					default:
						var error = result.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										model.cv,
										error,
										model.cv.hy($author$project$Locale$Messages$SubjectFeedbacksDownloadError)),
									di: result
								}),
							$author$project$Element$SubjectFeedbackCard$Cmd(
								$author$project$Element$SubjectFeedbackCard$LogError(
									A3(
										$author$project$Log$errorV2,
										model.bN,
										_Utils_Tuple3(
											$author$project$Log$msgSubjectFeedbacksDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeSubjectFeedbackCard),
											error),
										$elm$core$Basics$always($author$project$Element$SubjectFeedbackCard$NoOp)))),
							$elm$core$Maybe$Nothing);
				}
			case 1:
				var result = msg.a;
				switch (result.$) {
					case 2:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jB: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					case 1:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jB: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					case 0:
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{jB: result}),
							$author$project$Element$SubjectFeedbackCard$NoEffect,
							$elm$core$Maybe$Nothing);
					default:
						var error = result.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									cv: A3(
										$author$project$Session$error,
										model.cv,
										error,
										model.cv.hy($author$project$Locale$Messages$SubjectListDownloadError)),
									jB: result
								}),
							$author$project$Element$SubjectFeedbackCard$Cmd(
								$author$project$Element$SubjectFeedbackCard$LogError(
									A3(
										$author$project$Log$errorV2,
										model.bN,
										_Utils_Tuple3(
											$author$project$Log$msgSubjectListDownload,
											$elm$core$Maybe$Just($author$project$Log$paramScopeSubjectFeedbackCard),
											error),
										$elm$core$Basics$always($author$project$Element$SubjectFeedbackCard$NoOp)))),
							$elm$core$Maybe$Nothing);
				}
			case 2:
				var maybeSubjectId = msg.a;
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{eY: maybeSubjectId}),
					$author$project$Element$SubjectFeedbackCard$BatchEffect(
						_List_fromArray(
							[
								$author$project$Element$SubjectFeedbackCard$Cmd(
								$author$project$Element$SubjectFeedbackCard$FetchSubjectFeedbacks(
									A4($author$project$SubjectFeedback$fetchSubjectFeedbacks, model.bN.gr, model.f5, maybeSubjectId, $author$project$Element$SubjectFeedbackCard$SubjectFeedbacksDownloaded))),
								$author$project$Element$SubjectFeedbackCard$Cmd(
								A2($author$project$Element$SubjectFeedbackCard$UpdateFilterUrl, model.f5, maybeSubjectId))
							])),
					$elm$core$Maybe$Nothing);
			case 3:
				return _Utils_Tuple3(
					_Utils_update(
						model,
						{e3: !model.e3}),
					$author$project$Element$SubjectFeedbackCard$NoEffect,
					$elm$core$Maybe$Nothing);
			default:
				return _Utils_Tuple3(model, $author$project$Element$SubjectFeedbackCard$NoEffect, $elm$core$Maybe$Nothing);
		}
	});
var $author$project$Locale$Messages$SubjectFeedbacksLoadingProgress = {$: 594};
var $author$project$Locale$Messages$TrimesterClosureFeedbackGiven = F2(
	function (a, b) {
		return {$: 666, a: a, b: b};
	});
var $author$project$Element$SubjectFeedbackCard$viewFeedbackMeta = F3(
	function (t_, student, feedback) {
		var viewModuleLink = function (module_) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$author$project$Route$href(
						$author$project$Route$ModulesDetail(
							$author$project$Module$moduleIdToInt(module_.gT))),
						$elm$html$Html$Attributes$title(
						t_(
							$author$project$Locale$Messages$TooltipModule(module_.jJ)))
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$module_(_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(module_.jJ)
							]))
					]));
		};
		var viewFeedbackText = function () {
			var _v1 = feedback.k0;
			switch (_v1) {
				case 'portfolio_story':
					return A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$PortfoliosStoryShared(
							A2($author$project$Person$fullName, t_, feedback.kG)));
				case 'trimester_feedback':
					return A2(
						$author$project$UI$caption,
						t_,
						A2(
							$author$project$Locale$Messages$TrimesterClosureFeedbackGiven,
							A2($author$project$Person$fullName, t_, feedback.kG),
							A2($author$project$Person$fullName, t_, student)));
				default:
					return $elm$html$Html$text('?');
			}
		}();
		var createdAtFormatted = t_(
			A2(
				$author$project$Locale$Messages$TimeDateTimeFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(feedback.gz)));
		var viewFeedbackHighlights = $author$project$UI$mediaObjectHighlights(
			_List_fromArray(
				[
					A2($author$project$UI$maybe, feedback.mF, viewModuleLink),
					function () {
					var _v0 = feedback.k1;
					if (!_v0.$) {
						var url = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(url)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(createdAtFormatted)
								]));
					} else {
						return $elm$html$Html$text(createdAtFormatted);
					}
				}()
				]));
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatarSmall(feedback.kG.K)
				]),
			_List_fromArray(
				[viewFeedbackText, viewFeedbackHighlights]),
			_List_Nil,
			_List_Nil);
	});
var $author$project$Element$SubjectFeedbackCard$viewFeedbacks = F4(
	function (t_, subjects, student, subjectFeedbacks) {
		var viewFeedback = function (fb) {
			return _List_fromArray(
				[
					A3($author$project$Element$SubjectFeedbackCard$viewFeedbackMeta, t_, student, fb),
					A2($author$project$UI$RubricAssessment$view, subjects, fb.b$)
				]);
		};
		return $author$project$Util$List$flatten(
			A2($elm$core$List$map, viewFeedback, subjectFeedbacks));
	});
var $author$project$Locale$Messages$SubjectFeedbackCardHeading = F3(
	function (a, b, c) {
		return {$: 589, a: a, b: b, c: c};
	});
var $author$project$Element$SubjectFeedbackCard$viewPageHeading = F4(
	function (t_, subjects, profile, subjectId) {
		var subjectName = A2($author$project$Subject$findSubjectName, subjects, subjectId);
		var message = A3(
			$author$project$Locale$Messages$SubjectFeedbackCardHeading,
			A2($author$project$Person$fullName, t_, profile.ne),
			profile.id,
			subjectName);
		return _List_fromArray(
			[
				$author$project$UI$title(
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, message)
					]))
			]);
	});
var $author$project$Locale$Messages$SubjectFeedbackCardSummary = {$: 590};
var $author$project$Element$SubjectFeedbackCard$viewPageSummary = function (t_) {
	return $author$project$UI$notification(
		$author$project$UI$textToHtml(
			t_($author$project$Locale$Messages$SubjectFeedbackCardSummary)));
};
var $author$project$Element$SubjectFeedbackCard$SetSubjectFilter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$SubjectFeedbackCardAllSubjects = {$: 588};
var $author$project$Locale$Messages$SubjectFeedbackCardSelectSubject = {$: 592};
var $author$project$Element$SubjectFeedbackCard$ToggleSubjectDropdown = {$: 3};
var $author$project$Element$SubjectFeedbackCard$viewSubjectSelector = F4(
	function (t_, isOpen, subjects, selectedSubjectId) {
		var label = t_($author$project$Locale$Messages$SubjectFeedbackCardSelectSubject);
		var items = A2($elm$core$Maybe$withDefault, _List_Nil, subjects);
		var selectedItem = A2($author$project$Subject$findSubject, items, selectedSubjectId);
		var itemLabel = function ($) {
			return $.ha;
		};
		var isActive = function (subject) {
			if (!selectedSubjectId.$) {
				var subjectId = selectedSubjectId.a;
				return _Utils_eq(subject.gT, subjectId);
			} else {
				return false;
			}
		};
		return $author$project$UI$dropDownSelect(
			{
				kV: t_($author$project$Locale$Messages$SubjectFeedbackCardAllSubjects),
				kW: $author$project$Element$SubjectFeedbackCard$SetSubjectFilter($elm$core$Maybe$Nothing),
				lu: isActive,
				ly: isOpen,
				lI: itemLabel,
				lJ: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Element$SubjectFeedbackCard$SetSubjectFilter, $elm$core$Maybe$Just),
					function ($) {
						return $.gT;
					}),
				lK: $author$project$Element$SubjectFeedbackCard$ToggleSubjectDropdown,
				lL: items,
				lO: label,
				mY: selectedItem,
				m1: true
			});
	});
var $author$project$Element$SubjectFeedbackCard$viewPage = F2(
	function (model, subjectFeedbacksForStudent) {
		var viewFilters = $author$project$UI$section(
			_List_fromArray(
				[
					A4(
					$author$project$Element$SubjectFeedbackCard$viewSubjectSelector,
					model.cv.hy,
					model.e3,
					$author$project$RemoteData$toMaybe(model.jB),
					model.eY)
				]));
		var subjects = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			$author$project$RemoteData$toMaybe(model.jB));
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$UI$section(
					A4($author$project$Element$SubjectFeedbackCard$viewPageHeading, model.cv.hy, subjects, subjectFeedbacksForStudent.ea, model.eY)),
					$author$project$Element$SubjectFeedbackCard$viewPageSummary(model.cv.hy),
					viewFilters,
					A2($elm$html$Html$hr, _List_Nil, _List_Nil),
					$author$project$UI$section(
					A4($author$project$Element$SubjectFeedbackCard$viewFeedbacks, model.cv.hy, subjects, subjectFeedbacksForStudent.ne, subjectFeedbacksForStudent.k2))
				]));
	});
var $author$project$Element$SubjectFeedbackCard$view = function (model) {
	var _v0 = model.di;
	switch (_v0.$) {
		case 1:
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				model.cv.hy($author$project$Locale$Messages$SubjectFeedbacksLoadingProgress));
		case 2:
			var subjectFeedbacksForStudent = _v0.a;
			return A2($author$project$Element$SubjectFeedbackCard$viewPage, model, subjectFeedbacksForStudent);
		default:
			return $author$project$UI$none;
	}
};
var $author$project$Element$SubjectFeedbackCard$element = {iA: $author$project$Element$SubjectFeedbackCard$init, hh: $author$project$Element$SubjectFeedbackCard$perform, jR: $author$project$Element$SubjectFeedbackCard$update, nE: $author$project$Element$SubjectFeedbackCard$view};
var $author$project$Element$TeacherProfileForm$NotFoundPage = {$: 0};
var $author$project$Element$TeacherProfileForm$LoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TeacherProfileForm$PhoneBookDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TeacherProfileForm$TeacherProfileDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$teacherProfile = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'teacher-profiles',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$TeacherProfile$TeacherProfile = function (id) {
	return function (state) {
		return function (teacher) {
			return function (birthFirstName) {
				return function (birthLastName) {
					return function (birthHasFamilyNameFirst) {
						return function (motherNamePrefix) {
							return function (motherFirstName) {
								return function (motherLastName) {
									return function (motherHasFamilyNameFirst) {
										return function (highestEducationLevel) {
											return function (apprenticeshipYears) {
												return function (isAcademicMember) {
													return function (diplomaUrl) {
														return {aD: apprenticeshipYears, aa: birthFirstName, aF: birthHasFamilyNameFirst, ab: birthLastName, t: diplomaUrl, aJ: highestEducationLevel, gT: id, aK: isAcademicMember, an: motherFirstName, aM: motherHasFamilyNameFirst, ao: motherLastName, ap: motherNamePrefix, eZ: state, gb: teacher};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$Teacher = function (id) {
	return function (namePrefix) {
		return function (firstName) {
			return function (lastName) {
				return function (isFamilyNameFirst) {
					return function (email) {
						return function (phoneNumber) {
							return function (permanentAddress) {
								return function (temporaryAddress) {
									return function (birthDate) {
										return function (birthPlaceCountry) {
											return function (birthPlaceTown) {
												return function (nationality) {
													return function (eduId) {
														return function (mentor) {
															return {aE: birthDate, aG: birthPlaceCountry, aH: birthPlaceTown, af: eduId, K: email, k3: firstName, gT: id, a8: isFamilyNameFirst, ak: lastName, l_: mentor, aN: namePrefix, ar: nationality, c1: permanentAddress, aQ: phoneNumber, nn: temporaryAddress};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$teacherDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'mentor',
	$elm$json$Json$Decode$nullable($author$project$Person$nestedPersonDecoder),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'edu_id',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'nationality',
			$elm$json$Json$Decode$string,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'birthplace',
				$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'birthplace_country',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'birthdate',
						$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'temporary_address',
							$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'permanent_address',
								$elm$json$Json$Decode$nullable($author$project$Person$addressDecoder),
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'phone_number',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'email',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'is_family_name_first',
											$elm$json$Json$Decode$bool,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'last_name',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'first_name',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'name_prefix',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'id',
															$elm$json$Json$Decode$int,
															$elm$json$Json$Decode$succeed($author$project$TeacherProfile$Teacher))))))))))))))));
var $author$project$TeacherProfile$TeacherProfileId = $elm$core$Basics$identity;
var $author$project$TeacherProfile$teacherProfileIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$TeacherProfile$teacherProfileDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'diploma_url',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_academic_member',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'apprenticeship_years',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'highest_education_level',
				$elm$json$Json$Decode$int,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'mother_has_family_name_first',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'mother_last_name',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'mother_first_name',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'mother_name_prefix',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'birth_has_family_name_first',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'birth_last_name',
										$elm$json$Json$Decode$string,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'birth_first_name',
											$elm$json$Json$Decode$string,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'teacher',
												$author$project$TeacherProfile$teacherDecoder,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'state',
													$elm$json$Json$Decode$string,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'id',
														$author$project$TeacherProfile$teacherProfileIdDecoder,
														$elm$json$Json$Decode$succeed($author$project$TeacherProfile$TeacherProfile)))))))))))))));
var $author$project$TeacherProfile$fetchTeacherProfile = F3(
	function (config, id, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$teacherProfile, config, id),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$TeacherProfile$teacherProfileDecoder));
	});
var $author$project$Element$TeacherProfileForm$openFormPage = F3(
	function (personId, session, model) {
		var config = model.bN;
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$TeacherProfile$fetchTeacherProfile, config.gr, personId, $author$project$Element$TeacherProfileForm$TeacherProfileDownloaded),
					A2($author$project$Person$fetchPhoneBook, config.gr, $author$project$Element$TeacherProfileForm$PhoneBookDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2(
				$author$project$Application$Boundaries$save,
				_Utils_update(
					model,
					{
						bm: $author$project$Element$TeacherProfileForm$LoadingPage(personId)
					}),
				session));
	});
var $author$project$Element$TeacherProfileForm$init = F3(
	function (config, session, personId) {
		var model = {bN: config, bm: $author$project$Element$TeacherProfileForm$NotFoundPage, fT: _List_Nil, c3: $elm$core$Maybe$Nothing};
		return A3($author$project$Element$TeacherProfileForm$openFormPage, personId, session, model);
	});
var $author$project$Element$TeacherProfileForm$DiplomaFileSelected = F3(
	function (a, b, c) {
		return {$: 9, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaFileUploaded = F3(
	function (a, b, c) {
		return {$: 11, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaPolicyDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Element$TeacherProfileForm$DiplomaSignatureDownloaded = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$TeacherProfileForm$FormPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$NoOp = {$: 7};
var $author$project$Element$TeacherProfileForm$ProfileSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TeacherProfilesDownloadError = {$: 620};
var $author$project$Locale$Messages$TeacherProfilesSaveSuccess = {$: 622};
var $author$project$Element$TeacherProfileForm$acceptedMimeTypes = _List_fromArray(
	['application/pdf', 'image/png', 'image/jpeg']);
var $author$project$Element$TeacherProfileForm$awsPolicyScope = 'people';
var $author$project$Element$TeacherProfileForm$ApprenticeshipYears = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthDate = function (a) {
	return {$: 26, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthFirstName = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthHasFamilyNameFirst = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthLastName = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthPlaceCountry = function (a) {
	return {$: 24, a: a};
};
var $author$project$Element$TeacherProfileForm$BirthPlaceTown = function (a) {
	return {$: 25, a: a};
};
var $author$project$Element$TeacherProfileForm$DiplomaUrl = function (a) {
	return {$: 10, a: a};
};
var $author$project$Element$TeacherProfileForm$EduId = function (a) {
	return {$: 28, a: a};
};
var $author$project$Element$TeacherProfileForm$Email = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$TeacherProfileForm$FirstName = function (a) {
	return {$: 13, a: a};
};
var $author$project$Element$TeacherProfileForm$FormMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TeacherProfileForm$HighestEducationLevel = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$TeacherProfileForm$IsAcademicMember = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$TeacherProfileForm$IsFamilyNameFirst = function (a) {
	return {$: 15, a: a};
};
var $author$project$Element$TeacherProfileForm$LastName = function (a) {
	return {$: 14, a: a};
};
var $author$project$Element$TeacherProfileForm$Mentor = function (a) {
	return {$: 29, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherFirstName = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherHasFamilyNameFirst = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherLastName = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TeacherProfileForm$MotherNamePrefix = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TeacherProfileForm$NamePrefix = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$TeacherProfileForm$Nationality = function (a) {
	return {$: 27, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressCountry = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressPostcode = function (a) {
	return {$: 18, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetDoor = function (a) {
	return {$: 23, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetName = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetNumber = function (a) {
	return {$: 22, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressStreetType = function (a) {
	return {$: 21, a: a};
};
var $author$project$Element$TeacherProfileForm$PermanentAddressTown = function (a) {
	return {$: 19, a: a};
};
var $author$project$Locale$Messages$PersonIsFamilyNameFirst = {$: 348};
var $author$project$Locale$Messages$PersonNamePrefix = {$: 345};
var $author$project$Element$TeacherProfileForm$PhoneNumber = function (a) {
	return {$: 16, a: a};
};
var $author$project$Locale$Messages$TeacherProfileEducationLevelBachelor = {$: 615};
var $author$project$Locale$Messages$TeacherProfileEducationLevelMaster = {$: 614};
var $author$project$Locale$Messages$TeacherProfileEducationLevelSecondary = {$: 616};
var $author$project$TeacherProfile$educationLevels = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'0',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelMaster)),
			_Utils_Tuple2(
			'1',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelBachelor)),
			_Utils_Tuple2(
			'2',
			t_($author$project$Locale$Messages$TeacherProfileEducationLevelSecondary))
		]);
};
var $author$project$Element$TeacherProfileForm$maxFileSize = (10 * 1024) * 1024;
var $author$project$Element$TeacherProfileForm$buildForm = function (t_) {
	return {
		aD: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aD: value});
				}),
			nD: function ($) {
				return $.aD;
			},
			nE: {
				kJ: 'apprenticeship_years',
				lj: 'fa-graduation-cap',
				lO: t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$ApprenticeshipYears),
				bv: t_($author$project$Locale$Messages$TeacherProfileApprenticeshipYears),
				hH: 'text'
			}
		},
		aE: {
			kU: false,
			mu: $author$project$Form$requiredDate(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aE: value});
				}),
			nD: function ($) {
				return $.aE;
			},
			nE: {
				kJ: 'birth_date',
				lO: t_($author$project$Locale$Messages$PersonBirthDate),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthDate)
			}
		},
		aa: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aa: value});
				}),
			nD: function ($) {
				return $.aa;
			},
			nE: {
				kJ: 'birth_first_name',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$TeacherProfileBirthFirstName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthFirstName),
				bv: t_($author$project$Locale$Messages$TeacherProfileBirthFirstName),
				hH: 'text'
			}
		},
		aF: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aF: value});
				}),
			nD: function ($) {
				return $.aF;
			},
			nE: {
				kJ: 'birth_has_family_name_first',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$TeacherProfileBirthHasFamilyNameFirst),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthHasFamilyNameFirst)
			}
		},
		ab: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ab: value});
				}),
			nD: function ($) {
				return $.ab;
			},
			nE: {
				kJ: 'birth_last_name',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$TeacherProfileBirthLastName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthLastName),
				bv: t_($author$project$Locale$Messages$TeacherProfileBirthLastName),
				hH: 'text'
			}
		},
		aG: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aG: value});
				}),
			nD: function ($) {
				return $.aG;
			},
			nE: {
				kJ: 'birthplace_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthPlaceCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aH: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aH: value});
				}),
			nD: function ($) {
				return $.aH;
			},
			nE: {
				kJ: 'birth_place_town',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$BirthPlaceTown),
				bv: t_($author$project$Locale$Messages$PersonBirthPlaceTown),
				hH: 'text'
			}
		},
		t: {
			kU: false,
			mu: A2(
				$author$project$Form$requiredFile,
				t_,
				{j2: $author$project$Element$TeacherProfileForm$acceptedMimeTypes, lX: $author$project$Element$TeacherProfileForm$maxFileSize}),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{t: value});
				}),
			nD: function ($) {
				return $.t;
			},
			nE: {
				kJ: 'diploma',
				lj: 'fa-file-pdf',
				lO: t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$DiplomaUrl),
				bv: t_($author$project$Locale$Messages$TeacherProfileDiplomaUrl)
			}
		},
		af: {
			kU: false,
			mu: $author$project$Person$optionalEduId(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{af: value});
				}),
			nD: function ($) {
				return $.af;
			},
			nE: {
				kJ: 'edu_id',
				lj: 'fa-id-card',
				lO: t_($author$project$Locale$Messages$PersonEduId),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$EduId),
				bv: t_($author$project$Locale$Messages$PersonEduId),
				hH: 'text'
			}
		},
		K: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{K: value});
				}),
			nD: function ($) {
				return $.K;
			},
			nE: {
				kJ: 'email',
				lj: 'fa-envelope',
				lO: t_($author$project$Locale$Messages$PersonEmail),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Email),
				bv: t_($author$project$Locale$Messages$PersonEmail),
				hH: 'email'
			}
		},
		k3: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{k3: value});
				}),
			nD: function ($) {
				return $.k3;
			},
			nE: {
				kJ: 'firstname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonFirstName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$FirstName),
				bv: t_($author$project$Locale$Messages$PersonFirstName),
				hH: 'text'
			}
		},
		aJ: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aJ: value});
				}),
			nD: function ($) {
				return $.aJ;
			},
			nE: {
				kJ: 'highest_education_level',
				lj: 'fa-graduation-cap',
				lO: t_($author$project$Locale$Messages$TeacherProfileHighestEducationLevel),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$HighestEducationLevel),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSelectOptions(
						$author$project$TeacherProfile$educationLevels(t_)))
			}
		},
		aK: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aK: value});
				}),
			nD: function ($) {
				return $.aK;
			},
			nE: {
				kJ: 'is_academic_member',
				lj: 'keyboard-user',
				lO: t_($author$project$Locale$Messages$TeacherProfileIsAcademicMember),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$IsAcademicMember)
			}
		},
		a8: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a8: value});
				}),
			nD: function ($) {
				return $.a8;
			},
			nE: {
				kJ: 'is_family_name_first',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonIsFamilyNameFirst),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$IsFamilyNameFirst)
			}
		},
		ak: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ak: value});
				}),
			nD: function ($) {
				return $.ak;
			},
			nE: {
				kJ: 'lastname',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonLastName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$LastName),
				bv: t_($author$project$Locale$Messages$PersonLastName),
				hH: 'text'
			}
		},
		l_: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{l_: value});
				}),
			nD: function ($) {
				return $.l_;
			},
			nE: {
				kJ: 'mentor',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$PersonMentor),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Mentor),
				mp: $elm$core$Maybe$Nothing
			}
		},
		an: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{an: value});
				}),
			nD: function ($) {
				return $.an;
			},
			nE: {
				kJ: 'mother_first_name',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$TeacherProfileMotherFirstName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherFirstName),
				bv: t_($author$project$Locale$Messages$TeacherProfileMotherFirstName),
				hH: 'text'
			}
		},
		aM: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aM: value});
				}),
			nD: function ($) {
				return $.aM;
			},
			nE: {
				kJ: 'mother_has_family_name_first',
				lj: 'fa-user',
				lO: t_($author$project$Locale$Messages$TeacherProfileMotherHasFamilyNameFirst),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherHasFamilyNameFirst)
			}
		},
		ao: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ao: value});
				}),
			nD: function ($) {
				return $.ao;
			},
			nE: {
				kJ: 'mother_last_name',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$TeacherProfileMotherLastName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherLastName),
				bv: t_($author$project$Locale$Messages$TeacherProfileMotherLastName),
				hH: 'text'
			}
		},
		ap: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ap: value});
				}),
			nD: function ($) {
				return $.ap;
			},
			nE: {
				kJ: 'mother_name_prefix',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$MotherNamePrefix),
				bv: t_($author$project$Locale$Messages$TeacherProfileMotherNamePrefix),
				hH: 'text'
			}
		},
		aN: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aN: value});
				}),
			nD: function ($) {
				return $.aN;
			},
			nE: {
				kJ: 'name_prefix',
				lj: 'fa-keyboard',
				lO: t_($author$project$Locale$Messages$PersonNamePrefix),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$NamePrefix),
				bv: t_($author$project$Locale$Messages$PersonNamePrefix),
				hH: 'text'
			}
		},
		ar: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{ar: value});
				}),
			nD: function ($) {
				return $.ar;
			},
			nE: {
				kJ: 'nationality',
				lj: 'fa-flag',
				lO: t_($author$project$Locale$Messages$PersonNationality),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$Nationality),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aU: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aU: value});
				}),
			nD: function ($) {
				return $.aU;
			},
			nE: {
				kJ: 'permanent_address_country',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressCountry),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressCountry),
				mp: $elm$core$Maybe$Just(
					$author$project$Form$toSortedSelectOptions(
						$author$project$Person$countries(t_)))
			}
		},
		aV: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aV: value});
				}),
			nD: function ($) {
				return $.aV;
			},
			nE: {
				kJ: 'permanent_address_postcode',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressPostcode),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressPostcode),
				bv: t_($author$project$Locale$Messages$PersonAddressPostcode),
				hH: 'text'
			}
		},
		aW: {
			kU: false,
			mu: $elm$core$Result$Ok,
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aW: value});
				}),
			nD: function ($) {
				return $.aW;
			},
			nE: {
				kJ: 'permanent_address_street_door',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetDoor),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetDoor),
				hH: 'text'
			}
		},
		aX: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aX: value});
				}),
			nD: function ($) {
				return $.aX;
			},
			nE: {
				kJ: 'permanent_address_street_name',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetName),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetName),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetName),
				hH: 'text'
			}
		},
		aY: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aY: value});
				}),
			nD: function ($) {
				return $.aY;
			},
			nE: {
				kJ: 'permanent_address_street_number',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetNumber),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetNumber),
				hH: 'text'
			}
		},
		aZ: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aZ: value});
				}),
			nD: function ($) {
				return $.aZ;
			},
			nE: {
				kJ: 'permanent_address_street_type',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressStreetType),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressStreetType),
				bv: t_($author$project$Locale$Messages$PersonAddressStreetType),
				hH: 'text'
			}
		},
		a_: {
			kU: false,
			mu: $author$project$Form$requiredText(t_),
			mK: true,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{a_: value});
				}),
			nD: function ($) {
				return $.a_;
			},
			nE: {
				kJ: 'permanent_address_town',
				lj: 'fa-map-marker',
				lO: t_($author$project$Locale$Messages$PersonAddressTown),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PermanentAddressTown),
				bv: t_($author$project$Locale$Messages$PersonAddressTown),
				hH: 'text'
			}
		},
		aQ: {
			kU: false,
			mu: $author$project$Form$optionalPhoneNumber(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{aQ: value});
				}),
			nD: function ($) {
				return $.aQ;
			},
			nE: {
				kJ: 'phone',
				lj: 'fa-phone',
				lO: t_($author$project$Locale$Messages$PersonPhone),
				aT: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$FormMsg, $author$project$Element$TeacherProfileForm$PhoneNumber),
				bv: t_($author$project$Locale$Messages$PersonPhone),
				hH: 'phone'
			}
		}
	};
};
var $author$project$Element$TeacherProfileForm$fillForm = function (profile) {
	var teacher = profile.gb;
	return {
		aD: $elm$core$String$fromInt(profile.aD),
		aE: A2($elm$core$Maybe$withDefault, '', teacher.aE),
		aa: profile.aa,
		aF: profile.aF,
		ab: profile.ab,
		aG: teacher.aG,
		aH: A2($elm$core$Maybe$withDefault, '', teacher.aH),
		t: $author$project$Form$fromFileUrl(profile.t),
		af: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2($elm$core$Maybe$map, $elm$core$String$fromInt, teacher.af)),
		K: A2($elm$core$Maybe$withDefault, '', teacher.K),
		k3: teacher.k3,
		aJ: $elm$core$String$fromInt(profile.aJ),
		aK: profile.aK,
		a8: teacher.a8,
		ak: teacher.ak,
		l_: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gT;
					},
					$elm$core$String$fromInt),
				teacher.l_)),
		an: profile.an,
		aM: profile.aM,
		ao: profile.ao,
		ap: profile.ap,
		aN: teacher.aN,
		ar: teacher.ar,
		aU: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.kF;
				},
				teacher.c1)),
		aV: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.mA;
				},
				teacher.c1)),
		aW: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.na;
				},
				teacher.c1)),
		aX: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nb;
				},
				teacher.c1)),
		aY: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nc;
				},
				teacher.c1)),
		aZ: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.nd;
				},
				teacher.c1)),
		a_: A2(
			$elm$core$Maybe$withDefault,
			'',
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ny;
				},
				teacher.c1)),
		aQ: A2($elm$core$Maybe$withDefault, '', teacher.aQ)
	};
};
var $author$project$Element$TeacherProfileForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.aa, values) && (A2($author$project$Form$isFieldValid, form.ab, values) && (A2($author$project$Form$isFieldValid, form.aF, values) && (A2($author$project$Form$isFieldValid, form.ap, values) && (A2($author$project$Form$isFieldValid, form.an, values) && (A2($author$project$Form$isFieldValid, form.ao, values) && (A2($author$project$Form$isFieldValid, form.aM, values) && (A2($author$project$Form$isFieldValid, form.aJ, values) && (A2($author$project$Form$isFieldValid, form.aD, values) && (A2($author$project$Form$isFieldValid, form.aK, values) && (A2($author$project$Form$isFieldValid, form.t, values) && (A2($author$project$Form$isFieldValid, form.aN, values) && (A2($author$project$Form$isFieldValid, form.k3, values) && (A2($author$project$Form$isFieldValid, form.ak, values) && (A2($author$project$Form$isFieldValid, form.a8, values) && (A2($author$project$Form$isFieldValid, form.K, values) && (A2($author$project$Form$isFieldValid, form.aQ, values) && (A2($author$project$Form$isFieldValid, form.aU, values) && (A2($author$project$Form$isFieldValid, form.aV, values) && (A2($author$project$Form$isFieldValid, form.a_, values) && (A2($author$project$Form$isFieldValid, form.aX, values) && (A2($author$project$Form$isFieldValid, form.aZ, values) && (A2($author$project$Form$isFieldValid, form.aY, values) && (A2($author$project$Form$isFieldValid, form.aW, values) && (A2($author$project$Form$isFieldValid, form.aG, values) && (A2($author$project$Form$isFieldValid, form.aH, values) && (A2($author$project$Form$isFieldValid, form.aE, values) && (A2($author$project$Form$isFieldValid, form.ar, values) && (A2($author$project$Form$isFieldValid, form.af, values) && A2($author$project$Form$isFieldValid, form.l_, values)))))))))))))))))))))))))))));
	});
var $author$project$Log$msgTeacherProfileDownload = 'teacher_profile_download';
var $author$project$Log$msgTeacherProfileSave = 'teacher_profile_save';
var $author$project$Log$paramScopeTeacherProfiles = 'scope_teacher_profiles';
var $author$project$Element$TeacherProfileForm$DocumentViewerModel = $elm$core$Basics$identity;
var $author$project$Element$TeacherProfileForm$DocumentViewerMsg = $elm$core$Basics$identity;
var $author$project$Element$TeacherProfileForm$PopupMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TeacherProfileForm$popups = {
	dE: {
		gF: $author$project$Element$DocumentViewer$element,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$TeacherProfileForm$PopupMsg, $elm$core$Basics$identity),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c3: $elm$core$Maybe$Just(model)
					});
			})
	}
};
var $author$project$TeacherProfile$TeacherProfileUnsaved = function (id) {
	return function (state) {
		return function (teacher) {
			return function (birthFirstName) {
				return function (birthLastName) {
					return function (birthHasFamilyNameFirst) {
						return function (motherNamePrefix) {
							return function (motherFirstName) {
								return function (motherLastName) {
									return function (motherHasFamilyNameFirst) {
										return function (highestEducationLevel) {
											return function (apprenticeshipYears) {
												return function (isAcademicMember) {
													return function (diplomaUrl) {
														return {aD: apprenticeshipYears, aa: birthFirstName, aF: birthHasFamilyNameFirst, ab: birthLastName, t: diplomaUrl, aJ: highestEducationLevel, gT: id, aK: isAcademicMember, an: motherFirstName, aM: motherHasFamilyNameFirst, ao: motherLastName, ap: motherNamePrefix, eZ: state, gb: teacher};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TeacherProfile$TeacherUnsaved = function (id) {
	return function (namePrefix) {
		return function (firstName) {
			return function (lastName) {
				return function (isFamilyNameFirst) {
					return function (email) {
						return function (phoneNumber) {
							return function (permanentAddress) {
								return function (temporaryAddress) {
									return function (birthDate) {
										return function (birthPlaceCountry) {
											return function (birthPlaceTown) {
												return function (nationality) {
													return function (eduId) {
														return function (mentor) {
															return {aE: birthDate, aG: birthPlaceCountry, aH: birthPlaceTown, af: eduId, K: email, k3: firstName, gT: id, a8: isFamilyNameFirst, ak: lastName, l_: mentor, aN: namePrefix, ar: nationality, c1: permanentAddress, aQ: phoneNumber, nn: temporaryAddress};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Element$TeacherProfileForm$saveForm = F3(
	function (form, values, profile) {
		return $author$project$TeacherProfile$TeacherProfileUnsaved(profile.gT)(profile.eZ)(
			$author$project$TeacherProfile$TeacherUnsaved(profile.gb.gT)(
				form.aN.nD(values))(
				form.k3.nD(values))(
				form.ak.nD(values))(
				form.a8.nD(values))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.K.nD(values)))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.aQ.nD(values)))(
				$elm$core$Maybe$Just(
					A9(
						$author$project$Person$Address,
						true,
						form.aU.nD(values),
						form.a_.nD(values),
						form.aV.nD(values),
						'',
						form.aX.nD(values),
						form.aZ.nD(values),
						form.aY.nD(values),
						form.aW.nD(values))))($elm$core$Maybe$Nothing)(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.aE.nD(values)))(
				form.aG.nD(values))(
				A2(
					$author$project$Data$toMaybe,
					$elm$core$String$isEmpty,
					form.aH.nD(values)))(
				form.ar.nD(values))(
				$elm$core$String$toInt(
					form.af.nD(values)))(
				$elm$core$String$toInt(
					form.l_.nD(values))))(
			form.aa.nD(values))(
			form.ab.nD(values))(
			form.aF.nD(values))(
			form.ap.nD(values))(
			form.an.nD(values))(
			form.ao.nD(values))(
			form.aM.nD(values))(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					form.aJ.nD(values))))(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					form.aD.nD(values))))(
			form.aK.nD(values))(
			$author$project$Form$toFileUrl(
				form.t.nD(values)));
	});
var $author$project$TeacherProfile$teacherProfileIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$TeacherProfileForm$updateForm = F3(
	function (msg, form, formValues) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aa: $author$project$Form$markEdited(form.aa)
						}),
					A2(form.aa.jR, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ab: $author$project$Form$markEdited(form.ab)
						}),
					A2(form.ab.jR, value, formValues));
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aF: $author$project$Form$markEdited(form.aF)
						}),
					A2(form.aF.jR, value, formValues));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ap: $author$project$Form$markEdited(form.ap)
						}),
					A2(form.ap.jR, value, formValues));
			case 4:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							an: $author$project$Form$markEdited(form.an)
						}),
					A2(form.an.jR, value, formValues));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ao: $author$project$Form$markEdited(form.ao)
						}),
					A2(form.ao.jR, value, formValues));
			case 6:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aM: $author$project$Form$markEdited(form.aM)
						}),
					A2(form.aM.jR, value, formValues));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aJ: $author$project$Form$markEdited(form.aJ)
						}),
					A2(form.aJ.jR, value, formValues));
			case 8:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aD: $author$project$Form$markEdited(form.aD)
						}),
					A2(form.aD.jR, value, formValues));
			case 9:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aK: $author$project$Form$markEdited(form.aK)
						}),
					A2(form.aK.jR, value, formValues));
			case 10:
				var location = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							t: $author$project$Form$markEdited(form.t)
						}),
					A2(
						form.t.jR,
						$author$project$Form$FileUploaded(location),
						formValues));
			case 12:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aN: $author$project$Form$markEdited(form.aN)
						}),
					A2(form.aN.jR, value, formValues));
			case 13:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							k3: $author$project$Form$markEdited(form.k3)
						}),
					A2(form.k3.jR, value, formValues));
			case 14:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ak: $author$project$Form$markEdited(form.ak)
						}),
					A2(form.ak.jR, value, formValues));
			case 15:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a8: $author$project$Form$markEdited(form.a8)
						}),
					A2(form.a8.jR, value, formValues));
			case 11:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							K: $author$project$Form$markEdited(form.K)
						}),
					A2(form.K.jR, value, formValues));
			case 16:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aQ: $author$project$Form$markEdited(form.aQ)
						}),
					A2(form.aQ.jR, value, formValues));
			case 17:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aU: $author$project$Form$markEdited(form.aU)
						}),
					A2(form.aU.jR, value, formValues));
			case 18:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aV: $author$project$Form$markEdited(form.aV)
						}),
					A2(form.aV.jR, value, formValues));
			case 19:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							a_: $author$project$Form$markEdited(form.a_)
						}),
					A2(form.a_.jR, value, formValues));
			case 20:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aX: $author$project$Form$markEdited(form.aX)
						}),
					A2(form.aX.jR, value, formValues));
			case 21:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aZ: $author$project$Form$markEdited(form.aZ)
						}),
					A2(form.aZ.jR, value, formValues));
			case 22:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aY: $author$project$Form$markEdited(form.aY)
						}),
					A2(form.aY.jR, value, formValues));
			case 23:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aW: $author$project$Form$markEdited(form.aW)
						}),
					A2(form.aW.jR, value, formValues));
			case 24:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aG: $author$project$Form$markEdited(form.aG)
						}),
					A2(form.aG.jR, value, formValues));
			case 25:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aH: $author$project$Form$markEdited(form.aH)
						}),
					A2(form.aH.jR, value, formValues));
			case 26:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aE: $author$project$Form$markEdited(form.aE)
						}),
					A2(form.aE.jR, value, formValues));
			case 27:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							ar: $author$project$Form$markEdited(form.ar)
						}),
					A2(form.ar.jR, value, formValues));
			case 28:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							af: $author$project$Form$markEdited(form.af)
						}),
					A2(form.af.jR, value, formValues));
			default:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							l_: $author$project$Form$markEdited(form.l_)
						}),
					A2(form.l_.jR, value, formValues));
		}
	});
var $author$project$Person$canBeMentor = function (person) {
	return $author$project$Person$isTeacher(person) || ($author$project$Person$isModuleTeacher(person) || $author$project$Person$isOperator(person));
};
var $author$project$Element$TeacherProfileForm$toMentorOptions = F2(
	function (t_, people) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			A2($elm$core$List$filter, $author$project$Person$canBeMentor, people));
	});
var $author$project$Element$TeacherProfileForm$updateMentorOptions = F3(
	function (t_, people, form) {
		if (!people.b) {
			return form;
		} else {
			var people_ = people;
			return _Utils_update(
				form,
				{
					l_: A2(
						$author$project$Form$fillFieldOptions,
						A2($author$project$Element$TeacherProfileForm$toMentorOptions, t_, people_),
						form.l_)
				});
		}
	});
var $author$project$TeacherProfile$teacherEncoder = function (teacher) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(teacher.gT)),
				_Utils_Tuple2(
				'name_prefix',
				$elm$json$Json$Encode$string(teacher.aN)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(teacher.k3)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(teacher.ak)),
				_Utils_Tuple2(
				'is_family_name_first',
				$elm$json$Json$Encode$bool(teacher.a8)),
				_Utils_Tuple2(
				'email',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.K)),
				_Utils_Tuple2(
				'phone_number',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.aQ)),
				_Utils_Tuple2(
				'permanent_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, teacher.c1)),
				_Utils_Tuple2(
				'temporary_address',
				A2($author$project$Data$encodeNullable, $author$project$Person$addressEncoder, teacher.nn)),
				_Utils_Tuple2(
				'birthdate',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.aE)),
				_Utils_Tuple2(
				'birthplace_country',
				$elm$json$Json$Encode$string(teacher.aG)),
				_Utils_Tuple2(
				'birthplace',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$string, teacher.aH)),
				_Utils_Tuple2(
				'nationality',
				$elm$json$Json$Encode$string(teacher.ar)),
				_Utils_Tuple2(
				'edu_id',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, teacher.af)),
				_Utils_Tuple2(
				'mentor',
				A2($author$project$Data$encodeNullable, $elm$json$Json$Encode$int, teacher.l_))
			]));
};
var $author$project$TeacherProfile$teacherProfileEncoder = function (profile) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$TeacherProfile$teacherProfileIdToInt(profile.gT))),
				_Utils_Tuple2(
				'state',
				$elm$json$Json$Encode$string(profile.eZ)),
				_Utils_Tuple2(
				'teacher',
				$author$project$TeacherProfile$teacherEncoder(profile.gb)),
				_Utils_Tuple2(
				'birth_first_name',
				$elm$json$Json$Encode$string(profile.aa)),
				_Utils_Tuple2(
				'birth_last_name',
				$elm$json$Json$Encode$string(profile.ab)),
				_Utils_Tuple2(
				'birth_has_family_name_first',
				$elm$json$Json$Encode$bool(profile.aF)),
				_Utils_Tuple2(
				'mother_name_prefix',
				$elm$json$Json$Encode$string(profile.ap)),
				_Utils_Tuple2(
				'mother_first_name',
				$elm$json$Json$Encode$string(profile.an)),
				_Utils_Tuple2(
				'mother_last_name',
				$elm$json$Json$Encode$string(profile.ao)),
				_Utils_Tuple2(
				'mother_has_family_name_first',
				$elm$json$Json$Encode$bool(profile.aM)),
				_Utils_Tuple2(
				'highest_education_level',
				$elm$json$Json$Encode$int(profile.aJ)),
				_Utils_Tuple2(
				'apprenticeship_years',
				$elm$json$Json$Encode$int(profile.aD)),
				_Utils_Tuple2(
				'is_academic_member',
				$elm$json$Json$Encode$bool(profile.aK)),
				_Utils_Tuple2(
				'diploma_url',
				$elm$json$Json$Encode$string(profile.t))
			]));
};
var $author$project$TeacherProfile$updateTeacherProfile = F3(
	function (config, profile, callback) {
		return A5(
			$author$project$Api$put,
			A2($author$project$Api$Endpoint$teacherProfile, config, profile.gb.gT),
			config,
			$elm$http$Http$jsonBody(
				$author$project$TeacherProfile$teacherProfileEncoder(profile)),
			callback,
			$author$project$TeacherProfile$teacherProfileDecoder);
	});
var $author$project$Element$TeacherProfileForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			aD: $author$project$Form$markEdited(form.aD),
			aE: $author$project$Form$markEdited(form.aE),
			aa: $author$project$Form$markEdited(form.aa),
			aF: $author$project$Form$markEdited(form.aF),
			ab: $author$project$Form$markEdited(form.ab),
			aG: $author$project$Form$markEdited(form.aG),
			aH: $author$project$Form$markEdited(form.aH),
			t: $author$project$Form$markEdited(form.t),
			af: $author$project$Form$markEdited(form.af),
			K: $author$project$Form$markEdited(form.K),
			k3: $author$project$Form$markEdited(form.k3),
			aJ: $author$project$Form$markEdited(form.aJ),
			aK: $author$project$Form$markEdited(form.aK),
			ak: $author$project$Form$markEdited(form.ak),
			l_: $author$project$Form$markEdited(form.l_),
			an: $author$project$Form$markEdited(form.an),
			aM: $author$project$Form$markEdited(form.aM),
			ao: $author$project$Form$markEdited(form.ao),
			ap: $author$project$Form$markEdited(form.ap),
			aN: $author$project$Form$markEdited(form.k3),
			ar: $author$project$Form$markEdited(form.ar),
			aU: $author$project$Form$markEdited(form.aU),
			aV: $author$project$Form$markEdited(form.aV),
			aW: $author$project$Form$markEdited(form.aW),
			aX: $author$project$Form$markEdited(form.aX),
			aY: $author$project$Form$markEdited(form.aY),
			aZ: $author$project$Form$markEdited(form.aZ),
			a_: $author$project$Form$markEdited(form.a_),
			aQ: $author$project$Form$markEdited(form.aQ)
		});
};
var $author$project$Element$TeacherProfileForm$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var config = model.bN;
			var noop = A2($author$project$Application$Boundaries$save, model, session);
			var _v0 = _Utils_Tuple2(msg, model.bm);
			_v0$21:
			while (true) {
				switch (_v0.a.$) {
					case 3:
						var popupMsg = _v0.a.a;
						var _v1 = _Utils_Tuple2(popupMsg, model.c3);
						if (!_v1.b.$) {
							var documentViewerMsg = _v1.a;
							var documentViewerModel = _v1.b.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.iJ, session, documentViewerMsg, documentViewerModel, $author$project$Element$TeacherProfileForm$popups.dE);
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{c3: $elm$core$Maybe$Nothing}),
								_return.cv);
						} else {
							return noop;
						}
					case 5:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 1) {
								var profile = _v0.a.a.a;
								var teacherId = _v0.b.a;
								var formValues = $author$project$Element$TeacherProfileForm$fillForm(profile);
								var form = A3(
									$author$project$Element$TeacherProfileForm$updateMentorOptions,
									session.hy,
									model.fT,
									$author$project$Element$TeacherProfileForm$buildForm(session.hy));
								if (_Utils_eq(profile.gb.gT, teacherId)) {
									var page = $author$project$Element$TeacherProfileForm$FormPage(
										{bt: form, j: profile, eZ: 0, ej: formValues});
									return A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session);
								} else {
									return noop;
								}
							} else {
								break _v0$21;
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgTeacherProfileDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$TeacherProfilesDownloadError))));
						}
					case 6:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var phonebook = _v0.a.a.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: A3($author$project$Element$TeacherProfileForm$updateMentorOptions, session.hy, phonebook, form)
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page, fT: phonebook}),
									session);
							} else {
								var phonebook = _v0.a.a.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{fT: phonebook}),
									session);
							}
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgPeopleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTeacherProfiles),
										error),
									$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$PhoneBookDownloadError))));
						}
					case 12:
						if (_v0.b.$ === 2) {
							var documentUrl = _v0.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$S3$requestSignature,
									config.gr,
									{bh: documentUrl, mV: $author$project$Element$TeacherProfileForm$awsPolicyScope},
									$author$project$Element$TeacherProfileForm$DiplomaSignatureDownloaded),
								noop);
						} else {
							break _v0$21;
						}
					case 13:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var signature = _v0.a.a.a;
								var doc = $author$project$S3$document(signature);
								var params = {
									eM: $elm$core$Maybe$Just(doc.eM),
									G: doc.G
								};
								return A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$TeacherProfileForm$popups.dE,
									A5(
										$author$project$Application$V2$Boundaries$initElement,
										model.bN.iJ,
										$author$project$Application$V2$SharedConfig$fromV1(model.bN),
										session,
										$author$project$Element$TeacherProfileForm$popups.dE,
										params));
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var error = _v0.a.a.a;
								var profile = _v0.b.a.j;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgAwsSignatureDownload,
											$elm$core$Maybe$Just(
												$elm$core$String$fromInt(
													$author$project$TeacherProfile$teacherProfileIdToInt(profile.gT))),
											error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										model,
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$StudentProfileFormFileDownloadError))));
							} else {
								break _v0$21;
							}
						}
					case 8:
						if (_v0.b.$ === 2) {
							var _v2 = _v0.a;
							var fieldMsg = _v2.a;
							var documentType = _v2.b;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A2(
									$elm$file$File$Select$file,
									$author$project$Element$TeacherProfileForm$acceptedMimeTypes,
									A2($author$project$Element$TeacherProfileForm$DiplomaFileSelected, fieldMsg, documentType)),
								noop);
						} else {
							break _v0$21;
						}
					case 9:
						if (_v0.b.$ === 2) {
							var _v3 = _v0.a;
							var fieldMsg = _v3.a;
							var documentType = _v3.b;
							var file = _v3.c;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							var valuesWithFileSelected = A2(
								form.t.jR,
								$author$project$Form$FileSelected(file),
								values);
							var valuesWithFileError = A2(
								form.t.jR,
								$author$project$Form$InvalidFile(file),
								values);
							var params = {
								kR: documentType,
								l2: $elm$file$File$mime(file),
								my: $elm$core$String$fromInt(profile.gb.gT),
								mV: $author$project$Element$TeacherProfileForm$awsPolicyScope
							};
							if (A2($author$project$Form$isFieldValid, form.t, valuesWithFileSelected)) {
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													t: $author$project$Form$markEdited(form.t)
												}),
											ej: valuesWithFileSelected
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$S3$requestPolicy,
										config.gr,
										params,
										A2($author$project$Element$TeacherProfileForm$DiplomaPolicyDownloaded, fieldMsg, file)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										session));
							} else {
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											bt: _Utils_update(
												form,
												{
													t: $author$project$Form$markEdited(form.t)
												}),
											ej: valuesWithFileError
										}));
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{bm: page}),
									session);
							}
						} else {
							break _v0$21;
						}
					case 10:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 2) {
								var _v4 = _v0.a;
								var fieldMsg = _v4.a;
								var file = _v4.b;
								var policy = _v4.c.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A4(
										$author$project$S3$uploadFile,
										config.gr,
										policy,
										file,
										A2($author$project$Element$TeacherProfileForm$DiplomaFileUploaded, fieldMsg, file)),
									noop);
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var _v5 = _v0.a;
								var error = _v5.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											ej: A2(form.t.jR, $author$project$Form$NoFile, values)
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgAwsPolicyDownload, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$FormFileUploadError))));
							} else {
								break _v0$21;
							}
						}
					case 11:
						if (!_v0.a.c.$) {
							if (_v0.b.$ === 2) {
								var _v6 = _v0.a;
								var fieldMsg = _v6.a;
								var file = _v6.b;
								var metadata = _v6.c.a;
								var _v7 = A2($elm$core$Dict$get, $author$project$S3$headerLocation, metadata.ah);
								if (!_v7.$) {
									var location = _v7.a;
									var $temp$session = session,
										$temp$msg = fieldMsg(location),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								} else {
									var $temp$session = session,
										$temp$msg = A3(
										$author$project$Element$TeacherProfileForm$DiplomaFileUploaded,
										fieldMsg,
										file,
										$elm$core$Result$Err(
											$author$project$Api$BadHeader(metadata))),
										$temp$model = model;
									session = $temp$session;
									msg = $temp$msg;
									model = $temp$model;
									continue update;
								}
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var _v8 = _v0.a;
								var error = _v8.c.a;
								var formPage = _v0.b.a;
								var form = formPage.bt;
								var values = formPage.ej;
								var page = $author$project$Element$TeacherProfileForm$FormPage(
									_Utils_update(
										formPage,
										{
											ej: A2(form.t.jR, $author$project$Form$NoFile, values)
										}));
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgFileUpload,
											$elm$core$Maybe$Just('teacher_profiles'),
											error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{bm: page}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$FormFileUploadError))));
							} else {
								break _v0$21;
							}
						}
					case 0:
						if (_v0.b.$ === 2) {
							var fieldMsg = _v0.a.a;
							var formPage = _v0.b.a;
							var _v9 = A3($author$project$Element$TeacherProfileForm$updateForm, fieldMsg, formPage.bt, formPage.ej);
							var form = _v9.a;
							var values = _v9.b;
							var page = $author$project$Element$TeacherProfileForm$FormPage(
								_Utils_update(
									formPage,
									{bt: form, eZ: 1, ej: values}));
							return A2(
								$author$project$Application$Boundaries$save,
								_Utils_update(
									model,
									{bm: page}),
								session);
						} else {
							break _v0$21;
						}
					case 2:
						if (_v0.b.$ === 2) {
							var personId = _v0.a.a;
							return A3($author$project$Element$TeacherProfileForm$openFormPage, personId, session, model);
						} else {
							break _v0$21;
						}
					case 1:
						if (_v0.b.$ === 2) {
							var _v10 = _v0.a;
							var formPage = _v0.b.a;
							var form = formPage.bt;
							var values = formPage.ej;
							var profile = formPage.j;
							return A2($author$project$Element$TeacherProfileForm$isFormValid, form, values) ? A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$TeacherProfile$updateTeacherProfile,
									config.gr,
									A3($author$project$Element$TeacherProfileForm$saveForm, form, values, profile),
									$author$project$Element$TeacherProfileForm$ProfileSaved),
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{eZ: 2}))
										}),
									session)) : A2(
								$author$project$Application$Boundaries$andThenCmd,
								$author$project$Ports$scrollToFormError,
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{
														bt: $author$project$Element$TeacherProfileForm$validateForm(form),
														eZ: 1
													}))
										}),
									session));
						} else {
							break _v0$21;
						}
					case 4:
						if (!_v0.a.a.$) {
							if (_v0.b.$ === 2) {
								var newProfile = _v0.a.a.a;
								var formPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: $author$project$Element$TeacherProfileForm$FormPage(
												_Utils_update(
													formPage,
													{j: newProfile, eZ: 0}))
										}),
									A2(
										$author$project$Session$ok,
										session,
										session.hy($author$project$Locale$Messages$TeacherProfilesSaveSuccess)));
							} else {
								break _v0$21;
							}
						} else {
							if (_v0.b.$ === 2) {
								var error = _v0.a.a.a;
								var formPage = _v0.b.a;
								return A2(
									$author$project$Application$Boundaries$andThenCmd,
									A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3($author$project$Log$msgTeacherProfileSave, $elm$core$Maybe$Nothing, error),
										$elm$core$Basics$always($author$project$Element$TeacherProfileForm$NoOp)),
									A2(
										$author$project$Application$Boundaries$save,
										_Utils_update(
											model,
											{
												bm: $author$project$Element$TeacherProfileForm$FormPage(
													_Utils_update(
														formPage,
														{eZ: 3}))
											}),
										A3(
											$author$project$Session$error,
											session,
											error,
											session.hy($author$project$Locale$Messages$FormSaveError))));
							} else {
								break _v0$21;
							}
						}
					default:
						var _v11 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Locale$Messages$TeacherProfilesLoadingProgress = {$: 625};
var $author$project$Locale$Messages$TeacherProfilesNotFound = {$: 626};
var $author$project$Element$TeacherProfileForm$DiplomaFileDownloadRequested = function (a) {
	return {$: 12, a: a};
};
var $author$project$Element$TeacherProfileForm$DiplomaFileUploadRequested = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Element$TeacherProfileForm$FormReset = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TeacherProfileForm$FormSubmitted = {$: 1};
var $author$project$Locale$Messages$TeacherProfilesDocumentUploadHelp = {$: 621};
var $author$project$Locale$Messages$TeacherProfilesHeadingBirth = {$: 617};
var $author$project$Locale$Messages$TeacherProfilesHeadingContact = {$: 618};
var $author$project$Locale$Messages$TeacherProfilesHeadingProfessional = {$: 619};
var $author$project$Element$TeacherProfileForm$viewForm = F3(
	function (t_, language, _v0) {
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var profile = _v0.j;
		var heading = function (caption) {
			return A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('heading has-background-light')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('has-text-info')
							]),
						_List_fromArray(
							[
								$author$project$UI$Icon$profile(
								_List_fromArray(
									[
										$author$project$UI$Icon$face('fa-lg'),
										$author$project$UI$Icon$style('is-medium')
									]))
							])),
						caption
					]));
		};
		var viewFormFields = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-fullwidth')
				]),
			_List_fromArray(
				[
					function () {
					var _v1 = profile.gb.K;
					if (!_v1.$) {
						var email = _v1.a;
						return $author$project$UI$columns(
							_List_fromArray(
								[
									A4(
									$author$project$UI$mediaObject,
									_List_fromArray(
										[
											$author$project$UI$gravatar(email)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$small,
											_List_Nil,
											$author$project$UI$textToHtml(
												t_(
													$author$project$Locale$Messages$ProfilesGravatar(email))))
										]),
									_List_Nil,
									_List_Nil)
								]));
					} else {
						return $author$project$UI$none;
					}
				}(),
					$author$project$UI$columns(
					language.ls ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aN, values),
							A3($author$project$UI$textField, t_, form.k3, values),
							A3($author$project$UI$textField, t_, form.ak, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aN, values),
							A3($author$project$UI$textField, t_, form.ak, values),
							A3($author$project$UI$textField, t_, form.k3, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.a8, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingBirth)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aG, values),
							A3($author$project$UI$textField, t_, form.aH, values),
							A4($author$project$UI$dateField, t_, form.aE, values, true)
						])),
					$author$project$UI$columns(
					language.ls ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aa, values),
							A3($author$project$UI$textField, t_, form.ab, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ab, values),
							A3($author$project$UI$textField, t_, form.aa, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aF, values)
						])),
					$author$project$UI$columns(
					language.ls ? _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ap, values),
							A3($author$project$UI$textField, t_, form.an, values),
							A3($author$project$UI$textField, t_, form.ao, values)
						]) : _List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.ap, values),
							A3($author$project$UI$textField, t_, form.ao, values),
							A3($author$project$UI$textField, t_, form.an, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aM, values),
							A3($author$project$UI$choiceField, t_, form.ar, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingContact)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$staticTextField, t_, form.K, values),
							A3($author$project$UI$textField, t_, form.aQ, values)
						])),
					A2(
					$elm$html$Html$p,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('heading')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$PersonAddress)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aU, values),
							A3($author$project$UI$textField, t_, form.a_, values),
							A3($author$project$UI$textField, t_, form.aV, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$textField, t_, form.aX, values),
							A3($author$project$UI$textField, t_, form.aZ, values),
							A3($author$project$UI$textField, t_, form.aY, values),
							A3($author$project$UI$textField, t_, form.aW, values)
						])),
					heading(
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesHeadingProfessional)),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$choiceField, t_, form.aJ, values),
							A3($author$project$UI$textField, t_, form.aD, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A4(
							$author$project$UI$withInfoText,
							_List_Nil,
							t_,
							$author$project$Locale$Messages$TeacherProfilesDocumentUploadHelp,
							A5($author$project$UI$fileField, t_, form.t, values, $author$project$Element$TeacherProfileForm$DiplomaFileUploadRequested, $author$project$Element$TeacherProfileForm$DiplomaFileDownloadRequested)),
							A3($author$project$UI$textField, t_, form.af, values)
						])),
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$toggleField, t_, form.aK, values),
							A3($author$project$UI$choiceField, t_, form.l_, values)
						]))
				]));
		var formState = A2($author$project$Form$isUploading, form.t, values) ? 2 : state;
		return $author$project$UI$panel(
			{
				kt: _List_fromArray(
					[
						viewFormFields,
						A5(
						$author$project$UI$formButtons,
						t_,
						$author$project$Form$Update(profile.gb.gT),
						formState,
						$author$project$Element$TeacherProfileForm$FormSubmitted,
						$author$project$Element$TeacherProfileForm$FormReset)
					]),
				kJ: 'teacher-profile-form',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$caption,
						t_,
						$author$project$Locale$Messages$TeacherProfilesTitle(
							A2($author$project$Person$fullName, t_, profile.gb)))
					]),
				nk: _List_Nil,
				nq: 'is-light'
			});
	});
var $author$project$Element$TeacherProfileForm$viewPopup = F2(
	function (session, model) {
		var popupModel = model;
		return A3($author$project$Application$V2$Boundaries$viewElement, session, popupModel, $author$project$Element$TeacherProfileForm$popups.dE);
	});
var $author$project$Element$TeacherProfileForm$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var _v0 = model.bm;
		switch (_v0.$) {
			case 2:
				var formPage = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$maybe,
							model.c3,
							$author$project$Element$TeacherProfileForm$viewPopup(session)),
							A3($author$project$Element$TeacherProfileForm$viewForm, t_, session.lP, formPage)
						]));
			case 1:
				return A2(
					$author$project$UI$progressBar,
					'is-primary',
					t_($author$project$Locale$Messages$TeacherProfilesLoadingProgress));
			default:
				return $author$project$UI$notification(
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TeacherProfilesNotFound)
						]));
		}
	});
var $author$project$Element$TeacherProfileForm$element = {iA: $author$project$Element$TeacherProfileForm$init, jR: $author$project$Element$TeacherProfileForm$update, nE: $author$project$Element$TeacherProfileForm$view};
var $author$project$Element$TimetableCalendar$PeopleSelected = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$TimetableCalendarMsg = function (a) {
	return {$: 19, a: a};
};
var $author$project$Element$TimetableCalendar$PeopleListDownloaded = function (a) {
	return {$: 12, a: a};
};
var $author$project$ACL$canViewTimetablesOther = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$TimetableCalendar$emptyFilters = {mw: _List_Nil, jG: _List_Nil};
var $author$project$Person$fetchStudentsAndTeachers = F2(
	function (config, callback) {
		return A3(
			$author$project$Api$get,
			$author$project$Api$Endpoint$peopleStudentsAndTeachers(config),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$Person$phoneBookDecoder));
	});
var $author$project$Element$TimetableCalendar$updatePeopleSelected = F3(
	function (viewer, selected, filter) {
		return _Utils_update(
			filter,
			{
				mw: $elm$core$List$isEmpty(selected) ? _List_fromArray(
					[viewer.gT]) : selected
			});
	});
var $author$project$Element$TimetableCalendar$init = F3(
	function (config, session, params) {
		var model = {
			bN: config,
			a3: $elm$core$Dict$empty,
			bO: A3($author$project$Element$TimetableCalendar$updatePeopleSelected, session.nH, params, $author$project$Element$TimetableCalendar$emptyFilters),
			mw: $elm$core$Maybe$Nothing,
			$7: $elm$core$Maybe$Nothing
		};
		var cmd = $author$project$ACL$canViewTimetablesOther(session.nH) ? A2($author$project$Person$fetchStudentsAndTeachers, config.gr, $author$project$Element$TimetableCalendar$PeopleListDownloaded) : $elm$core$Platform$Cmd$none;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$TimetableCalendar$CreateForm = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TimetableCalendar$DetailView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TimetableCalendar$ModuleEventOccurenceResized = function (a) {
	return {$: 11, a: a};
};
var $author$project$Element$TimetableCalendar$NoOp = {$: 0};
var $author$project$Element$TimetableCalendar$RecordDailyAttendance = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$TimetableDownloadError = {$: 636};
var $author$project$Locale$Messages$TimetableOccurenceSaveError = {$: 653};
var $author$project$Locale$Messages$TimetableOccurenceSaveSuccess = {$: 652};
var $author$project$Element$TimetableCalendar$ModuleEventOccurencesDownloaded = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$ModuleEvent$defaultTimetableListParams = {iF: $elm$core$Maybe$Nothing, i6: $elm$core$Maybe$Nothing, jp: $elm$core$Maybe$Nothing, jX: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$ModuleEventOccurence = function (id) {
	return function (module_) {
		return function (moduleEvent) {
			return function (startTime) {
				return function (endTime) {
					return function (isRescheduled) {
						return function (isCancelled) {
							return function (modificationReason) {
								return function (attendants) {
									return function (absentees) {
										return function (conferenceUrl) {
											return {gl: absentees, gq: attendants, kC: conferenceUrl, C: endTime, gT: id, lp: isCancelled, lB: isRescheduled, l7: modificationReason, d$: moduleEvent, fK: module_, M: startTime};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$ModuleEvent$ModuleEventOccurenceId = $elm$core$Basics$identity;
var $author$project$ModuleEvent$moduleEventOccurenceIdDecoder = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$int);
var $author$project$ModuleEvent$NestedModuleEvent = F3(
	function (id, title, notes) {
		return {gT: id, aO: notes, jJ: title};
	});
var $author$project$ModuleEvent$nestedModuleEventDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'notes',
	$elm$json$Json$Decode$string,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'title',
		$elm$json$Json$Decode$string,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'id',
			$author$project$ModuleEvent$moduleEventIdDecoder,
			$elm$json$Json$Decode$succeed($author$project$ModuleEvent$NestedModuleEvent))));
var $author$project$ModuleEvent$moduleEventOccurenceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'conference_url',
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'absentees',
		$author$project$Person$nestedPeopleDecoder,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'attendants',
			$author$project$Person$nestedPeopleDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'modification_reason',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'is_cancelled',
					$elm$json$Json$Decode$bool,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'is_rescheduled',
						$elm$json$Json$Decode$bool,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'end_time',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'start_time',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'module_event',
									$author$project$ModuleEvent$nestedModuleEventDecoder,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'module',
										$author$project$Module$nestedModuleDecoder,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$ModuleEvent$moduleEventOccurenceIdDecoder,
											$elm$json$Json$Decode$succeed($author$project$ModuleEvent$ModuleEventOccurence))))))))))));
var $author$project$ModuleEvent$moduleEventOccurencesDecoder = $elm$json$Json$Decode$list($author$project$ModuleEvent$moduleEventOccurenceDecoder);
var $author$project$Api$Endpoint$timetable = F2(
	function (config, _v0) {
		var role = _v0.jp;
		var people_ = _v0.i6;
		var weekStart = _v0.jX;
		var interval = _v0.iF;
		var params = A3(
			$author$project$Api$Endpoint$optionalList,
			$elm$core$String$fromInt,
			_Utils_Tuple2('p', people_),
			A3(
				$author$project$Api$Endpoint$optional,
				A2($elm$core$Basics$composeR, $elm$core$Tuple$second, $elm$core$String$fromInt),
				_Utils_Tuple2('end', interval),
				A3(
					$author$project$Api$Endpoint$optional,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$String$fromInt),
					_Utils_Tuple2('start', interval),
					A3(
						$author$project$Api$Endpoint$optional,
						$elm$core$String$fromInt,
						_Utils_Tuple2('week_start', weekStart),
						A3(
							$author$project$Api$Endpoint$optional,
							$elm$core$Basics$identity,
							_Utils_Tuple2('role', role),
							_List_Nil)))));
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'module-event-occurences']),
			params);
	});
var $author$project$ModuleEvent$fetchOccurences = F4(
	function (config, interval, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2(
				$author$project$Api$Endpoint$timetable,
				config,
				_Utils_update(
					$author$project$ModuleEvent$defaultTimetableListParams,
					{
						iF: $elm$core$Maybe$Just(interval),
						i6: $elm$core$Maybe$Just(
							_List_fromArray(
								[personId]))
					})),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleEvent$moduleEventOccurencesDecoder));
	});
var $author$project$Element$TimetableCalendar$prefetchInterval = F3(
	function (personId, viewState, eventStore) {
		if (!viewState.$) {
			var currentDate = viewState.a.gA;
			var monthInMillis = (((1000 * 60) * 60) * 24) * 30;
			var prefetchRadiusInMillis = monthInMillis * 2;
			var start_ = currentDate - prefetchRadiusInMillis;
			var end_ = currentDate + prefetchRadiusInMillis;
			var _v1 = A2($elm$core$Dict$get, personId, eventStore);
			if (!_v1.$) {
				var dataStart = _v1.a.ey;
				var dataEnd = _v1.a.ew;
				return (_Utils_cmp(start_, dataStart) < 0) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(start_, dataStart)) : ((_Utils_cmp(end_, dataEnd) > 0) ? $elm$core$Maybe$Just(
					_Utils_Tuple2(dataEnd, end_)) : $elm$core$Maybe$Nothing);
			} else {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(start_, end_));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Element$TimetableCalendar$fetchTimetable = function (_v0) {
	var config = _v0.bN;
	var viewState = _v0.$7;
	var filter = _v0.bO;
	var eventStore = _v0.a3;
	var fetchInterval = function (personId) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (interval) {
					return A4(
						$author$project$ModuleEvent$fetchOccurences,
						config.gr,
						interval,
						personId,
						A2($author$project$Element$TimetableCalendar$ModuleEventOccurencesDownloaded, interval, personId));
				},
				A3($author$project$Element$TimetableCalendar$prefetchInterval, personId, viewState, eventStore)));
	};
	return $elm$core$Platform$Cmd$batch(
		A2($elm$core$List$map, fetchInterval, filter.mw));
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $author$project$ModuleEvent$isSameOccurence = F2(
	function (occ1, occ2) {
		return _Utils_eq(occ1.gT, occ2.gT);
	});
var $author$project$Element$TimetableCalendar$andRefetchStaleTimetables = F2(
	function (occurence, _return) {
		var model = _return.dY;
		var wipeStaleTimetables = $elm$core$Dict$filter(
			F2(
				function (_v0, _v1) {
					var occurences = _v1.cm;
					return !A2(
						$elm$core$List$any,
						$author$project$ModuleEvent$isSameOccurence(occurence),
						occurences);
				}));
		var model2 = _Utils_update(
			model,
			{
				a3: wipeStaleTimetables(model.a3)
			});
		return _Utils_update(
			_return,
			{
				dz: $elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[
							_return.dz,
							$author$project$Element$TimetableCalendar$fetchTimetable(model2)
						])),
				dY: model2
			});
	});
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $author$project$Element$TimetableCalendar$andUpdateLocalTimetables = F2(
	function (occurence, _return) {
		var model = _return.dY;
		var updateStaleTimetables = $elm$core$Dict$map(
			F2(
				function (_v0, data) {
					return _Utils_update(
						data,
						{
							cm: A3(
								$author$project$Util$List$updateWhen,
								$author$project$ModuleEvent$isSameOccurence(occurence),
								$elm$core$Basics$always(occurence),
								data.cm)
						});
				}));
		var model2 = _Utils_update(
			model,
			{
				a3: updateStaleTimetables(model.a3)
			});
		return _Utils_update(
			_return,
			{dY: model2});
	});
var $author$project$Log$msgModuleEventOccurenceSave = 'module_event_occurence_save';
var $author$project$Log$paramScopeTimetable = 'scope_timetable';
var $author$project$ModuleEvent$unfreeze = function (occ) {
	return {
		gq: A2(
			$elm$core$List$map,
			function ($) {
				return $.gT;
			},
			occ.gq),
		C: occ.C,
		gT: occ.gT,
		M: occ.M
	};
};
var $author$project$Element$TimetableCalendar$updateEventStoreByPerson = F4(
	function (personId, _v0, newOccurences, eventStore) {
		var start = _v0.a;
		var end = _v0.b;
		var updatePersonStore = function (_v1) {
			var dataStart = _v1.ey;
			var dataEnd = _v1.ew;
			var occurences = _v1.cm;
			return {
				ew: (_Utils_cmp(end, dataEnd) > 0) ? end : dataEnd,
				ey: (_Utils_cmp(start, dataStart) < 0) ? start : dataStart,
				cm: $author$project$Util$List$unique(
					_Utils_ap(occurences, newOccurences))
			};
		};
		var initialStore = {ew: end, ey: start, cm: newOccurences};
		var personStore = A2(
			$elm$core$Maybe$withDefault,
			initialStore,
			A2(
				$elm$core$Maybe$map,
				updatePersonStore,
				A2($elm$core$Dict$get, personId, eventStore)));
		return A3($elm$core$Dict$insert, personId, personStore, eventStore);
	});
var $author$project$Api$Endpoint$moduleEventOccurence = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-event-occurences',
					$elm$core$String$fromInt(id)
				]),
			_List_Nil);
	});
var $author$project$ModuleEvent$moduleEventOccurenceIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$ModuleEvent$moduleEventOccurenceEncoder = function (occurence) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.gT))),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$int(occurence.M)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$int(occurence.C)),
				_Utils_Tuple2(
				'attendants',
				A2(
					$elm$json$Json$Encode$list,
					function (student) {
						return $elm$json$Json$Encode$int(student);
					},
					occurence.gq))
			]));
};
var $author$project$ModuleEvent$updateModuleEventOccurence = F3(
	function (config, occurence, callback) {
		return A5(
			$author$project$Api$put,
			A2(
				$author$project$Api$Endpoint$moduleEventOccurence,
				config,
				$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.gT)),
			config,
			$elm$http$Http$jsonBody(
				$author$project$ModuleEvent$moduleEventOccurenceEncoder(occurence)),
			callback,
			$author$project$ModuleEvent$moduleEventOccurenceDecoder);
	});
var $author$project$Element$TimetableCalendar$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var config = model.bN;
		var filter = model.bO;
		switch (msg.$) {
			case 0:
				return A2($author$project$Application$Boundaries$save, model, session);
			case 2:
				var emptyStore = _Utils_update(
					model,
					{a3: $elm$core$Dict$empty});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(emptyStore),
					A2($author$project$Application$Boundaries$save, emptyStore, session));
			case 4:
				var occurence = msg.a;
				return A2(
					$author$project$Element$TimetableCalendar$andUpdateLocalTimetables,
					occurence,
					A2($author$project$Application$Boundaries$save, model, session));
			case 3:
				var occurence = msg.a;
				return A2(
					$author$project$Element$TimetableCalendar$andRefetchStaleTimetables,
					occurence,
					A2($author$project$Application$Boundaries$save, model, session));
			case 7:
				var occurence = msg.a.i$;
				var start = msg.a.hu;
				var end = msg.a.gG;
				var occurenceUpdated = _Utils_update(
					occurence,
					{C: end, M: start});
				var occurenceUnsaved = $author$project$ModuleEvent$unfreeze(occurence);
				var occurenceUnsaved2 = _Utils_update(
					occurenceUnsaved,
					{C: end, M: start});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$ModuleEvent$updateModuleEventOccurence, config.gr, occurenceUnsaved2, $author$project$Element$TimetableCalendar$ModuleEventOccurenceResized),
					A2(
						$author$project$Element$TimetableCalendar$andUpdateLocalTimetables,
						occurenceUpdated,
						A2($author$project$Application$Boundaries$save, model, session)));
			case 5:
				var occurence = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$DetailView(occurence),
					A2($author$project$Application$Boundaries$save, model, session));
			case 6:
				var viewState = msg.a;
				var model2 = _Utils_update(
					model,
					{
						$7: $elm$core$Maybe$Just(viewState)
					});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(model2),
					A2($author$project$Application$Boundaries$save, model2, session));
			case 8:
				var slot = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$CreateForm(slot),
					A2($author$project$Application$Boundaries$save, model, session));
			case 1:
				var peopleIds = msg.a;
				var model2 = _Utils_update(
					model,
					{
						bO: A3($author$project$Element$TimetableCalendar$updatePeopleSelected, viewer, peopleIds, filter)
					});
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					$author$project$Element$TimetableCalendar$fetchTimetable(model2),
					A2($author$project$Application$Boundaries$save, model2, session));
			case 12:
				if (!msg.a.$) {
					var people = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								mw: $elm$core$Maybe$Just(people)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPeopleDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosPeopleDownloadError))));
				}
			case 10:
				if (!msg.c.$) {
					var interval = msg.a;
					var personId = msg.b;
					var newOccurences = msg.c.a;
					var eventStore = A4($author$project$Element$TimetableCalendar$updateEventStoreByPerson, personId, interval, newOccurences, model.a3);
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{a3: eventStore}),
						session);
				} else {
					var error = msg.c.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							model.bN,
							_Utils_Tuple3(
								$author$project$Log$msgModuleEventsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$TimetableDownloadError))));
				}
			case 11:
				if (!msg.a.$) {
					return A2(
						$author$project$Application$Boundaries$save,
						model,
						A2(
							$author$project$Session$ok,
							session,
							session.hy($author$project$Locale$Messages$TimetableOccurenceSaveSuccess)));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgModuleEventOccurenceSave,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
								error),
							$elm$core$Basics$always($author$project$Element$TimetableCalendar$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$TimetableOccurenceSaveError))));
				}
			default:
				var date = msg.a;
				return A2(
					$author$project$Application$Boundaries$reply,
					$author$project$Element$TimetableCalendar$RecordDailyAttendance(date),
					A2($author$project$Application$Boundaries$save, model, session));
		}
	});
var $author$project$Locale$Messages$TimetableLoadingProgress = {$: 650};
var $author$project$Locale$Messages$TimetableStudents = {$: 649};
var $author$project$Locale$Messages$TimetableTeachers = {$: 648};
var $author$project$UI$checkboxStyled = F5(
	function (style, toMsg, dataTag, selectedValues, option) {
		var checked_ = A2($elm$core$List$member, option.nD, selectedValues);
		var onClick_ = toMsg(
			checked_ ? A2($author$project$Util$List$removeElem, option.nD, selectedValues) : A2($elm$core$List$cons, option.nD, selectedValues));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Events$onClick(onClick_)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(dataTag),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$class('is-checkradio ' + style),
							$elm$html$Html$Attributes$name(dataTag),
							$author$project$UI$attrCyData(dataTag),
							$elm$html$Html$Attributes$checked(checked_)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$for(dataTag)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(option.lO)
						]))
				]));
	});
var $author$project$Form$decodePersonIdList = $elm$core$List$filterMap($elm$core$String$toInt);
var $author$project$Element$TimetableCalendar$colorPaletteSize = 12;
var $author$project$Element$TimetableCalendar$getColorIndexByPerson = F2(
	function (viewer, personId) {
		return _Utils_eq(viewer.gT, personId) ? 0 : (personId % $author$project$Element$TimetableCalendar$colorPaletteSize);
	});
var $author$project$Element$TimetableCalendar$personHasMissingEvents = F3(
	function (viewState, eventStore, personId) {
		var _v0 = _Utils_Tuple2(
			A2($elm$core$Dict$get, personId, eventStore),
			viewState);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var dataStart = _v0.a.a.ey;
			var dataEnd = _v0.a.a.ew;
			var viewStart = _v0.b.a.jU;
			var viewEnd = _v0.b.a.jT;
			return (_Utils_cmp(viewStart, dataStart) < 0) || (_Utils_cmp(viewEnd, dataEnd) > 0);
		} else {
			return true;
		}
	});
var $author$project$Element$TimetableCalendar$personEventsLoading = F4(
	function (viewState, filter, eventStore, person) {
		return A2($elm$core$List$member, person.gT, filter.mw) && A3($author$project$Element$TimetableCalendar$personHasMissingEvents, viewState, eventStore, person.gT);
	});
var $author$project$Element$TimetableCalendar$viewCalendarsSidebar = F3(
	function (_v0, model, people) {
		var viewer = _v0.nH;
		var t_ = _v0.hy;
		var teachersInViewerTeams = A2(
			$author$project$Person$teachersInTeams,
			$author$project$Person$teamsAsTom(viewer),
			people);
		var studentsInViewerTeams = A2(
			$author$project$Person$studentsInTeams,
			$author$project$Person$teamsAsTom(viewer),
			people);
		var selectedValues = A2($elm$core$List$map, $elm$core$String$fromInt, model.bO.mw);
		var viewCheckboxes = F2(
			function (dataTag, people_) {
				return A2(
					$elm$core$List$map,
					function (person) {
						var dataTagWithParam = dataTag + (' ' + person.K);
						var computedStyle = 'has-background-color is-small is-calendar-' + $elm$core$String$fromInt(
							A2($author$project$Element$TimetableCalendar$getColorIndexByPerson, viewer, person.gT));
						return A4($author$project$Element$TimetableCalendar$personEventsLoading, model.$7, model.bO, model.a3, person) ? A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field')
								]),
							_List_fromArray(
								[
									$author$project$UI$Icon$icon(
									_List_fromArray(
										[
											$author$project$UI$Icon$face('fa-spinner fa-spin'),
											$author$project$UI$Icon$style('icon-calendar')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$class('is-size-7')
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A2($author$project$Person$fullName, t_, person))
										]))
								])) : A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('field')
								]),
							_List_fromArray(
								[
									A5(
									$author$project$UI$checkboxStyled,
									computedStyle,
									A2($elm$core$Basics$composeL, $author$project$Element$TimetableCalendar$PeopleSelected, $author$project$Form$decodePersonIdList),
									dataTagWithParam,
									selectedValues,
									$author$project$Form$toSelectOption(
										_Utils_Tuple2(
											$elm$core$String$fromInt(person.gT),
											A2($author$project$Person$fullName, t_, person))))
								]));
					},
					A2(
						$author$project$Util$List$sortBy,
						$author$project$Person$fullName(t_),
						people_));
			});
		return A2(
			$elm$html$Html$aside,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('menu menu-calendar')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableTeachers)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-list')
						]),
					A2(viewCheckboxes, 'timetable-filter-teachers', teachersInViewerTeams)),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-label')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableStudents)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('menu-list')
						]),
					A2(viewCheckboxes, 'timetable-filter-students', studentsInViewerTeams))
				]));
	});
var $author$project$Element$TimetableCalendar$CalendarViewChanged = function (a) {
	return {$: 6, a: a};
};
var $author$project$Locale$Messages$DailyAttendanceButtonText = {$: 47};
var $author$project$Element$TimetableCalendar$DailyAttendanceSelected = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$TimetableCalendar$OccurenceDetailViewSelected = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TimetableCalendar$OccurenceTimeChanged = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$TimetableCalendar$TimeSlotSelected = function (a) {
	return {$: 8, a: a};
};
var $author$project$ACL$canManageDailyAttendance = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isTeacher(person);
};
var $author$project$ACL$canManageTimetable = function (person) {
	return $author$project$ACL$isStaff(person) || $author$project$Person$isModuleTeacher(person);
};
var $author$project$Element$TimetableCalendar$CalendarView = F4(
	function (currentDate, viewStart, viewEnd, viewType) {
		return {gA: currentDate, jT: viewEnd, jU: viewStart, jV: viewType};
	});
var $author$project$Element$TimetableCalendar$decodeIso8601 = A2(
	$elm$json$Json$Decode$andThen,
	function (dateStr) {
		return A2(
			$elm$core$Result$withDefault,
			$elm$json$Json$Decode$fail('Invalid date format, ISO8601 expected: ' + dateStr),
			A2(
				$elm$core$Result$map,
				A2($elm$core$Basics$composeR, $elm$time$Time$posixToMillis, $elm$json$Json$Decode$succeed),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(dateStr)));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Element$TimetableCalendar$decodeCalendarView = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A5(
		$elm$json$Json$Decode$map4,
		$author$project$Element$TimetableCalendar$CalendarView,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['currentDate']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewStart']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewEnd']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['viewType']),
			$elm$json$Json$Decode$string)));
var $author$project$Element$TimetableCalendar$decodeDate = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'date']),
	$author$project$Element$TimetableCalendar$decodeIso8601);
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $author$project$Element$TimetableCalendar$findOccurenceById = F2(
	function (eventStore, id) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (occ) {
					return _Utils_eq(occ.gT, id);
				},
				A2(
					$elm$core$List$concatMap,
					function ($) {
						return $.cm;
					},
					$elm$core$Dict$values(eventStore))));
	});
var $author$project$Element$TimetableCalendar$decodeOccurence = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (id) {
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('Module event occurence was not found: ' + id),
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Decode$succeed,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$identity,
							$author$project$Element$TimetableCalendar$findOccurenceById(eventStore)),
						$elm$core$String$toInt(id))));
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Element$TimetableCalendar$decodeOccurenceDetail = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail']),
		$author$project$Element$TimetableCalendar$decodeOccurence(eventStore));
};
var $author$project$Element$TimetableCalendar$OccurenceTimeChange = F3(
	function (occurence, start, end) {
		return {gG: end, i$: occurence, hu: start};
	});
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Element$TimetableCalendar$decodeOccurenceTimeChange = function (eventStore) {
	return A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['detail']),
		A4(
			$elm$json$Json$Decode$map3,
			$author$project$Element$TimetableCalendar$OccurenceTimeChange,
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['eventId']),
				$author$project$Element$TimetableCalendar$decodeOccurence(eventStore)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['start']),
				$author$project$Element$TimetableCalendar$decodeIso8601),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['end']),
				$author$project$Element$TimetableCalendar$decodeIso8601)));
};
var $author$project$Element$TimetableCalendar$decodeTimeSlot = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail']),
	A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['start']),
			$author$project$Element$TimetableCalendar$decodeIso8601),
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['end']),
			$author$project$Element$TimetableCalendar$decodeIso8601)));
var $author$project$Element$TimetableCalendar$HSLColor = F3(
	function (hue, saturation, lightness) {
		return {gS: hue, g4: lightness, hm: saturation};
	});
var $author$project$Element$TimetableCalendar$colorByPerson = F2(
	function (viewer, personId) {
		var saturation = 71;
		var lightness = 44;
		var idx = A2($author$project$Element$TimetableCalendar$getColorIndexByPerson, viewer, personId);
		var brandBlueHue = 217;
		var hue = brandBlueHue + (((360 / $author$project$Element$TimetableCalendar$colorPaletteSize) | 0) * idx);
		return A3($author$project$Element$TimetableCalendar$HSLColor, hue, saturation, lightness);
	});
var $author$project$Element$TimetableCalendar$encodeHSLColor = function (_v0) {
	var hue = _v0.gS;
	var saturation = _v0.hm;
	var lightness = _v0.g4;
	return $elm$json$Json$Encode$string(
		'hsl(' + ($elm$core$String$fromInt(hue) + (',' + ($elm$core$String$fromInt(saturation) + ('%,' + ($elm$core$String$fromInt(lightness) + '%)'))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Element$TimetableCalendar$encodeCalendarEvent = F3(
	function (hslColor, personId, occ) {
		var makeLighter = $elm$core$Basics$add(35);
		var modifyColor = function (_v1) {
			var hue = _v1.gS;
			var saturation = _v1.hm;
			var lightness = _v1.g4;
			var _v0 = A2(
				$author$project$Util$List$find,
				function (person) {
					return _Utils_eq(person.gT, personId);
				},
				occ.gl);
			if (!_v0.$) {
				return A3(
					$author$project$Element$TimetableCalendar$HSLColor,
					hue,
					saturation,
					makeLighter(lightness));
			} else {
				return hslColor;
			}
		};
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					$elm$json$Json$Encode$int(
						$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occ.gT))),
					_Utils_Tuple2(
					'title',
					$elm$json$Json$Encode$string(occ.d$.jJ)),
					_Utils_Tuple2(
					'start',
					$elm$json$Json$Encode$string(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							$elm$time$Time$millisToPosix(occ.M)))),
					_Utils_Tuple2(
					'end',
					$elm$json$Json$Encode$string(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
							$elm$time$Time$millisToPosix(occ.C)))),
					_Utils_Tuple2(
					'backgroundColor',
					$author$project$Element$TimetableCalendar$encodeHSLColor(
						modifyColor(hslColor)))
				]));
	});
var $author$project$Element$TimetableCalendar$encodeCalendarEventSources = F2(
	function (viewer, eventStore) {
		var encodeCalendarEventSource = function (_v1) {
			var personId = _v1.a;
			var occurences = _v1.b;
			var color = _v1.c;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'id',
						$elm$json$Json$Encode$int(personId)),
						_Utils_Tuple2(
						'events',
						A2(
							$elm$json$Json$Encode$list,
							A2($author$project$Element$TimetableCalendar$encodeCalendarEvent, color, personId),
							occurences)),
						_Utils_Tuple2(
						'color',
						$author$project$Element$TimetableCalendar$encodeHSLColor(color))
					]));
		};
		return A2(
			$elm$json$Json$Encode$list,
			encodeCalendarEventSource,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var personId = _v0.a;
					var occurences = _v0.b.cm;
					return _Utils_Tuple3(
						personId,
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.lp;
								}),
							occurences),
						A2($author$project$Element$TimetableCalendar$colorByPerson, viewer, personId));
				},
				$elm$core$Dict$toList(eventStore)));
	});
var $author$project$Element$TimetableCalendar$encodeIso8601 = function (millis) {
	return $elm$json$Json$Encode$string(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(
			$elm$time$Time$millisToPosix(millis)));
};
var $author$project$Element$TimetableCalendar$viewEvents = F2(
	function (_v0, _v1) {
		var language = _v0.lP;
		var viewer = _v0.nH;
		var t_ = _v0.hy;
		var filter = _v1.bO;
		var viewState = _v1.$7;
		var eventStore = _v1.a3;
		var selectedStore = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$filter,
				function (_v2) {
					var personId = _v2.a;
					return A2($elm$core$List$member, personId, filter.mw);
				},
				$elm$core$Dict$toList(eventStore)));
		var viewFullCalendar = A3(
			$elm$html$Html$node,
			'full-calendar',
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$UI$attrCyData('timetable-calendar'),
						A2(
						$elm$html$Html$Attributes$property,
						'locale',
						$elm$json$Json$Encode$string(language.kz)),
						A2(
						$elm$html$Html$Attributes$property,
						'eventSources',
						A2($author$project$Element$TimetableCalendar$encodeCalendarEventSources, viewer, selectedStore)),
						A2(
						$elm$html$Html$Attributes$property,
						'canManageEvents',
						$elm$json$Json$Encode$bool(
							$author$project$ACL$canManageTimetable(viewer))),
						A2(
						$elm$html$Html$Attributes$property,
						'canManageDailyAttendance',
						$elm$json$Json$Encode$bool(
							$author$project$ACL$canManageDailyAttendance(viewer))),
						A2(
						$elm$html$Html$Attributes$property,
						'dailyAttendanceText',
						$elm$json$Json$Encode$string(
							t_($author$project$Locale$Messages$DailyAttendanceButtonText))),
						A2(
						$elm$html$Html$Events$on,
						'eventClicked',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Element$TimetableCalendar$OccurenceDetailViewSelected,
							$author$project$Element$TimetableCalendar$decodeOccurenceDetail(eventStore))),
						A2(
						$elm$html$Html$Events$on,
						'eventTimeChanged',
						A2(
							$elm$json$Json$Decode$map,
							$author$project$Element$TimetableCalendar$OccurenceTimeChanged,
							$author$project$Element$TimetableCalendar$decodeOccurenceTimeChange(eventStore))),
						A2(
						$elm$html$Html$Events$on,
						'viewChanged',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$CalendarViewChanged, $author$project$Element$TimetableCalendar$decodeCalendarView)),
						A2(
						$elm$html$Html$Events$on,
						'timeSlotSelected',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$TimeSlotSelected, $author$project$Element$TimetableCalendar$decodeTimeSlot)),
						A2(
						$elm$html$Html$Events$on,
						'fullDayAbsenceButtonClicked',
						A2($elm$json$Json$Decode$map, $author$project$Element$TimetableCalendar$DailyAttendanceSelected, $author$project$Element$TimetableCalendar$decodeDate))
					]),
				A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						function (viewState_) {
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$property,
									'initialDate',
									$author$project$Element$TimetableCalendar$encodeIso8601(viewState_.gA)),
									A2(
									$elm$html$Html$Attributes$property,
									'initialView',
									$elm$json$Json$Encode$string(viewState_.jV))
								]);
						},
						viewState))),
			_List_Nil);
		return viewFullCalendar;
	});
var $author$project$Element$TimetableCalendar$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewer = session.nH;
		var _v0 = _Utils_Tuple2(
			$author$project$ACL$canViewTimetablesOther(viewer),
			model.mw);
		if (_v0.a) {
			if (!_v0.b.$) {
				var people = _v0.b.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('columns is-flex-direction-row-reverse')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column timetable-calendar-wrapper')
								]),
							_List_fromArray(
								[
									A2($author$project$Element$TimetableCalendar$viewEvents, session, model)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('column is-one-fifth')
								]),
							_List_fromArray(
								[
									A3($author$project$Element$TimetableCalendar$viewCalendarsSidebar, session, model, people)
								]))
						]));
			} else {
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$TimetableLoadingProgress));
			}
		} else {
			return A2($author$project$Element$TimetableCalendar$viewEvents, session, model);
		}
	});
var $author$project$Element$TimetableCalendar$element = {iA: $author$project$Element$TimetableCalendar$init, jR: $author$project$Element$TimetableCalendar$update, nE: $author$project$Element$TimetableCalendar$view};
var $author$project$Element$Timetable$timetableCalendar = {
	h_: F2(
		function (model, x) {
			return _Utils_update(
				model,
				{
					dx: $elm$core$Maybe$Just(x)
				});
		}),
	gF: $author$project$Element$TimetableCalendar$element,
	iV: $author$project$Element$Timetable$TimetableCalendarMsg
};
var $author$project$Element$Timetable$AttendanceFormView = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Locale$Messages$DailyAttendanceDownloadError = {$: 48};
var $author$project$Element$Timetable$DailyAttendanceFormView = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$Timetable$DeleteView = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Element$Timetable$DetailView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$DetailViewLoaded = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Element$TimetableCalendar$EventDeleted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TimetableCalendar$EventsChanged = {$: 2};
var $author$project$Element$Timetable$ModuleEventDeleted = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Element$Timetable$ModuleEventOccurenceCanceled = function (a) {
	return {$: 16, a: a};
};
var $author$project$Element$Timetable$NoOp = {$: 0};
var $author$project$Element$TimetableCalendar$OccurenceChanged = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TimetableModuleEventDeleteError = {$: 661};
var $author$project$Locale$Messages$TimetableModuleEventDeleteSuccess = {$: 660};
var $author$project$Locale$Messages$TimetableModuleEventOccurenceCancelSuccess = {$: 663};
var $author$project$Api$cancel = F4(
	function (url, config, toMsg, decoder) {
		return $author$project$Api$Endpoint$request(
			{
				O: $elm$http$Http$emptyBody,
				a4: A2($author$project$Api$expectJson, toMsg, decoder),
				ah: $author$project$Api$toHeaders(config),
				ba: 'DELETE',
				be: $elm$core$Maybe$Nothing,
				bf: $elm$core$Maybe$Nothing,
				G: url
			});
	});
var $author$project$ModuleEvent$cancelModuleEventOccurence = F3(
	function (config, _v0, callback) {
		var id = _v0;
		return A4(
			$author$project$Api$cancel,
			A2($author$project$Api$Endpoint$moduleEventOccurence, config, id),
			config,
			callback,
			$author$project$ModuleEvent$moduleEventOccurenceDecoder);
	});
var $author$project$Element$Timetable$closePopup = function (_return) {
	return A2(
		$author$project$Application$Boundaries$mapModel,
		function (model_) {
			return _Utils_update(
				model_,
				{c2: $elm$core$Maybe$Nothing});
		},
		_return);
};
var $author$project$Api$Endpoint$moduleEventsDeleteAfter = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$deleteAfterModuleEvent = F4(
	function (config, _v0, _v1, callback) {
		var eventId = _v0;
		var occId = _v1;
		return A3(
			$author$project$Api$delete,
			A3($author$project$Api$Endpoint$moduleEventsDeleteAfter, config, eventId, occId),
			config,
			callback);
	});
var $author$project$Api$Endpoint$moduleEventsDeleteAll = F2(
	function (config, id) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(id)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2('force_delete', '1')
				]));
	});
var $author$project$ModuleEvent$deleteAllModuleEvent = F3(
	function (config, _v0, callback) {
		var id = _v0;
		return A3(
			$author$project$Api$delete,
			A2($author$project$Api$Endpoint$moduleEventsDeleteAll, config, id),
			config,
			callback);
	});
var $author$project$Element$Timetable$DailyAttendanceDownloaded = function (a) {
	return {$: 11, a: a};
};
var $author$project$Api$Endpoint$dailyAttendance = F2(
	function (config, date) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'daily-attendance']),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'day',
					$elm$core$String$fromInt(date))
				]));
	});
var $author$project$DailyAttendance$DailyAttendance = F3(
	function (day, attendants, absentees) {
		return {gl: absentees, gq: attendants, fq: day};
	});
var $author$project$DailyAttendance$dailyAttendanceDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'absentees',
	$author$project$Person$nestedPeopleDecoder,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'attendants',
		$author$project$Person$nestedPeopleDecoder,
		_List_Nil,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'day',
			$elm$json$Json$Decode$int,
			0,
			$elm$json$Json$Decode$succeed($author$project$DailyAttendance$DailyAttendance))));
var $author$project$DailyAttendance$fetchDailyAttendance = F3(
	function (config, date, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$dailyAttendance, config, date),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$DailyAttendance$dailyAttendanceDecoder));
	});
var $author$project$Element$Timetable$downloadDailyAttendance = F2(
	function (date, _return) {
		var model = _return.dY;
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A3($author$project$DailyAttendance$fetchDailyAttendance, model.bN.gr, date, $author$project$Element$Timetable$DailyAttendanceDownloaded),
			_return);
	});
var $author$project$Element$Timetable$isAttendanceFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.gq, values);
	});
var $author$project$Element$Timetable$DetailViewLoading = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$ModuleEventDetailDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Api$Endpoint$moduleEvent = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'occurence',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$fetchOneEvent = F4(
	function (config, eventId, occId, callback) {
		return A3(
			$author$project$Api$get,
			A3($author$project$Api$Endpoint$moduleEvent, config, eventId, occId),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$ModuleEvent$moduleEventDetailedDecoder));
	});
var $author$project$ModuleEvent$moduleEventIdToInt = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Element$Timetable$updatePopup = F2(
	function (popup, _return) {
		return A2(
			$author$project$Application$Boundaries$mapModel,
			function (model_) {
				return _Utils_update(
					model_,
					{
						c2: $elm$core$Maybe$Just(popup)
					});
			},
			_return);
	});
var $author$project$Element$Timetable$openPopup = F2(
	function (popup, _return) {
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always($author$project$Element$Timetable$NoOp),
				$elm$browser$Browser$Dom$focus('timetable-popup')),
			A2($author$project$Element$Timetable$updatePopup, popup, _return));
	});
var $author$project$Element$Timetable$loadDetailView = F2(
	function (occurence, _return) {
		var model = _return.dY;
		var occId = $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occurence.gT);
		var eventId = $author$project$ModuleEvent$moduleEventIdToInt(occurence.d$.gT);
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			A4($author$project$ModuleEvent$fetchOneEvent, model.bN.gr, eventId, occId, $author$project$Element$Timetable$ModuleEventDetailDownloaded),
			A2(
				$author$project$Element$Timetable$openPopup,
				$author$project$Element$Timetable$DetailView(
					$author$project$Element$Timetable$DetailViewLoading(occurence)),
				_return));
	});
var $author$project$Element$Timetable$markAttendanceFormEdited = function (form) {
	return _Utils_update(
		form,
		{
			gq: $author$project$Form$markEdited(form.gq)
		});
};
var $author$project$Element$Timetable$EventFormView = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$ModuleEventFormMsg = function (a) {
	return {$: 20, a: a};
};
var $author$project$Element$ModuleEventForm$NotFoundPage = {$: 3};
var $author$project$Element$ModuleEventForm$Cmd = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$CreateEventFormLoadingPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$FetchModule = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$Module = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleDetailDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$NoEffect = {$: 0};
var $author$project$Element$ModuleEventForm$FetchModuleList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleListDownloaded = function (a) {
	return {$: 9, a: a};
};
var $author$project$Element$ModuleEventForm$TimeSlot = function (a) {
	return {$: 1, a: a};
};
var $author$project$Module$fetchAllModulesByPeople = F3(
	function (config, people, callback) {
		var params = _Utils_update(
			$author$project$Module$defaultListParams,
			{mw: people, de: -1});
		return {
			bN: config,
			dC: $author$project$Module$modulesDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$modules, config, params)
		};
	});
var $author$project$Module$fetchViewerModules = F3(
	function (config, viewer, callback) {
		return A3(
			$author$project$Module$fetchAllModulesByPeople,
			config,
			A2(
				$elm$core$List$cons,
				viewer.gT,
				A2(
					$elm$core$List$map,
					function ($) {
						return $.gT;
					},
					viewer.m8)),
			callback);
	});
var $author$project$Element$ModuleEventForm$EventFormPage = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$NotTouched = 0;
var $author$project$RRule$blank = {kT: $elm$core$Maybe$Nothing, Q: 0, iF: $elm$core$Maybe$Nothing, nA: $elm$core$Maybe$Nothing, jX: $elm$core$Maybe$Nothing, J: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$blankEvent = {gH: 0, C: $elm$core$Maybe$Nothing, gT: -1, fK: -1, aO: '', hl: $author$project$RRule$blank, hv: 0, M: $elm$core$Maybe$Nothing, jJ: ''};
var $author$project$Element$ModuleEventForm$EndDate = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$EndTime = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleEventForm$Frequency = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$ModuleEventEndDate = {$: 236};
var $author$project$Locale$Messages$ModuleEventEndTime = {$: 233};
var $author$project$Element$ModuleEventForm$ModuleEventFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$ModuleEventFrequency = {$: 230};
var $author$project$Locale$Messages$ModuleEventModule = {$: 227};
var $author$project$Locale$Messages$ModuleEventNotes = {$: 229};
var $author$project$Locale$Messages$ModuleEventStartDate = {$: 235};
var $author$project$Locale$Messages$ModuleEventStartTime = {$: 232};
var $author$project$Locale$Messages$ModuleEventTitle = {$: 228};
var $author$project$Locale$Messages$ModuleEventWeekdays = {$: 231};
var $author$project$Element$ModuleEventForm$Module_ = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModuleEventForm$Notes = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$ModuleEventForm$StartDate = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleEventForm$StartTime = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$ModuleEventForm$Title = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$ModuleEventForm$Weekdays = function (a) {
	return {$: 3, a: a};
};
var $author$project$Locale$Messages$TimetableRRuleBiweekly = {$: 633};
var $author$project$Locale$Messages$TimetableRRuleSingle = {$: 634};
var $author$project$Locale$Messages$TimetableRRuleWeekly = {$: 632};
var $author$project$Element$ModuleEventForm$frequencyOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'WEEKLY',
			t_($author$project$Locale$Messages$TimetableRRuleWeekly)),
			_Utils_Tuple2(
			'BIWEEKLY',
			t_($author$project$Locale$Messages$TimetableRRuleBiweekly)),
			_Utils_Tuple2(
			'NOREPEAT',
			t_($author$project$Locale$Messages$TimetableRRuleSingle))
		]);
};
var $author$project$Form$requiredSelection = F2(
	function (t_, values) {
		if (!values.b) {
			return $elm$core$Result$Err(
				t_($author$project$Locale$Messages$FormRequiredSelection));
		} else {
			var list = values;
			return $elm$core$Result$Ok(list);
		}
	});
var $author$project$Locale$Messages$FormInvalidTime = {$: 57};
var $author$project$Form$validTimeFormat = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[0-9]{2}:[0-9]{2}$'));
var $author$project$Form$requiredTime = F2(
	function (t_, value) {
		return (value === '') ? $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormRequiredValue)) : (A2($elm$regex$Regex$contains, $author$project$Form$validTimeFormat, value) ? $elm$core$Result$Ok(value) : $elm$core$Result$Err(
			t_($author$project$Locale$Messages$FormInvalidTime)));
	});
var $author$project$Locale$Messages$TimetableWeekday = function (a) {
	return {$: 635, a: a};
};
var $author$project$Element$ModuleEventForm$weekdayOptions = function (t_) {
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'MO',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(0))),
			_Utils_Tuple2(
			'TU',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(1))),
			_Utils_Tuple2(
			'WE',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(2))),
			_Utils_Tuple2(
			'TH',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(3))),
			_Utils_Tuple2(
			'FR',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(4))),
			_Utils_Tuple2(
			'SA',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(5))),
			_Utils_Tuple2(
			'SU',
			t_(
				$author$project$Locale$Messages$TimetableWeekday(6)))
		]);
};
var $author$project$Element$ModuleEventForm$buildModuleEventForm = F2(
	function (t_, moduleOptions) {
		return {
			gH: {
				kU: false,
				mu: $author$project$Form$requiredDate(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{gH: value});
					}),
				nD: function ($) {
					return $.gH;
				},
				nE: {
					kJ: 'end_date',
					lO: t_($author$project$Locale$Messages$ModuleEventEndDate),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$EndDate)
				}
			},
			C: {
				kU: false,
				mu: $author$project$Form$requiredTime(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{C: value});
					}),
				nD: function ($) {
					return $.C;
				},
				nE: {
					kJ: 'end_time',
					lO: t_($author$project$Locale$Messages$ModuleEventEndTime),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$EndTime)
				}
			},
			Q: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{Q: value});
					}),
				nD: function ($) {
					return $.Q;
				},
				nE: {
					kJ: 'frequency',
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$ModuleEventFrequency),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Frequency),
					mp: $elm$core$Maybe$Just(
						$author$project$Form$toSelectOptions(
							$author$project$Element$ModuleEventForm$frequencyOptions(t_)))
				}
			},
			fK: {
				kU: false,
				mu: A2($author$project$Form$requiredChoice, t_, '-1'),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{fK: value});
					}),
				nD: function ($) {
					return $.fK;
				},
				nE: {
					kJ: 'module',
					lj: 'fa-cube',
					lO: t_($author$project$Locale$Messages$ModuleEventModule),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Module_),
					mp: moduleOptions
				}
			},
			aO: {
				kU: false,
				mu: $elm$core$Result$Ok,
				mK: false,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{aO: value});
					}),
				nD: function ($) {
					return $.aO;
				},
				nE: {
					kJ: 'notes',
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$ModuleEventNotes),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Notes),
					bv: t_($author$project$Locale$Messages$ModuleEventNotes),
					hH: 'text'
				}
			},
			hv: {
				kU: false,
				mu: $author$project$Form$requiredDate(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{hv: value});
					}),
				nD: function ($) {
					return $.hv;
				},
				nE: {
					kJ: 'start_date',
					lO: t_($author$project$Locale$Messages$ModuleEventStartDate),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$StartDate)
				}
			},
			M: {
				kU: false,
				mu: $author$project$Form$requiredTime(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{M: value});
					}),
				nD: function ($) {
					return $.M;
				},
				nE: {
					kJ: 'start_time',
					lO: t_($author$project$Locale$Messages$ModuleEventStartTime),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$StartTime)
				}
			},
			jJ: {
				kU: false,
				mu: $author$project$Form$requiredText(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{jJ: value});
					}),
				nD: function ($) {
					return $.jJ;
				},
				nE: {
					kJ: 'title',
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$ModuleEventTitle),
					aT: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Title),
					bv: t_($author$project$Locale$Messages$ModuleEventTitle),
					hH: 'text'
				}
			},
			J: {
				kU: false,
				mu: $author$project$Form$requiredSelection(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{J: value});
					}),
				nD: function ($) {
					return $.J;
				},
				nE: {
					kJ: 'weekdays',
					kO: $elm$core$Maybe$Nothing,
					lj: 'fa-keyboard',
					lO: t_($author$project$Locale$Messages$ModuleEventWeekdays),
					mj: A2($elm$core$Basics$composeL, $author$project$Element$ModuleEventForm$ModuleEventFormMsg, $author$project$Element$ModuleEventForm$Weekdays),
					mp: $elm$core$Maybe$Just(
						$author$project$Form$toSelectOptions(
							$author$project$Element$ModuleEventForm$weekdayOptions(t_)))
				}
			}
		};
	});
var $author$project$RRule$encodeWeekday = function (weekday_) {
	switch (weekday_) {
		case 0:
			return 'MO';
		case 1:
			return 'TU';
		case 2:
			return 'WE';
		case 3:
			return 'TH';
		case 4:
			return 'FR';
		case 5:
			return 'SA';
		default:
			return 'SU';
	}
};
var $author$project$ModuleEvent$fromFrequencyToValue = function (event) {
	var rrule = event.hl;
	var _v0 = _Utils_Tuple3(
		$author$project$ModuleEvent$isRecurring(event),
		rrule.Q,
		rrule.iF);
	if (!_v0.a) {
		return 'NOREPEAT';
	} else {
		if (((!_v0.b) && (!_v0.c.$)) && (_v0.c.a === 2)) {
			var _v1 = _v0.b;
			return 'BIWEEKLY';
		} else {
			return 'WEEKLY';
		}
	}
};
var $author$project$Element$ModuleEventForm$fillModuleEventForm = function (event) {
	return {
		gH: $author$project$Form$dateFromMillis(event.gH),
		C: A2($elm$core$Maybe$withDefault, '09:00', event.C),
		Q: $author$project$ModuleEvent$fromFrequencyToValue(event),
		fK: $elm$core$String$fromInt(
			$author$project$Module$moduleIdToInt(event.fK)),
		aO: event.aO,
		hv: $author$project$Form$dateFromMillis(event.hv),
		M: A2($elm$core$Maybe$withDefault, '08:00', event.M),
		jJ: event.jJ,
		J: A2($elm$core$Maybe$withDefault, _List_Nil, event.hl.J)
	};
};
var $ryan_haskell$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryan_haskell$date_format$DateFormat$hourMilitaryFixed = $ryan_haskell$date_format$DateFormat$HourMilitaryFixed;
var $author$project$Form$timeFromMillis = function (millis) {
	return A4(
		$ryan_haskell$date_format$DateFormat$formatWithLanguage,
		$ryan_haskell$date_format$DateFormat$Language$english,
		_List_fromArray(
			[
				$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
				$ryan_haskell$date_format$DateFormat$text(':'),
				$ryan_haskell$date_format$DateFormat$minuteFixed
			]),
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$Locale$Messages$TimetableModuleOption = F4(
	function (a, b, c, d) {
		return {$: 664, a: a, b: b, c: c, d: d};
	});
var $author$project$Element$ModuleEventForm$toModuleOptions = F2(
	function (t_, modules) {
		return $author$project$Form$toSortedSelectOptions(
			A2(
				$elm$core$List$map,
				function (m) {
					return _Utils_Tuple2(
						$author$project$Module$fromModuleToValue(m.gT),
						t_(
							A4(
								$author$project$Locale$Messages$TimetableModuleOption,
								m.jJ,
								$elm$time$Time$utc,
								$elm$time$Time$millisToPosix(m.hv),
								$elm$time$Time$millisToPosix(m.gH))));
				},
				modules));
	});
var $author$project$Element$ModuleEventForm$toWeekday = function (millis) {
	return A2(
		$elm$time$Time$toWeekday,
		$elm$time$Time$utc,
		$elm$time$Time$millisToPosix(millis));
};
var $author$project$Element$ModuleEventForm$updatePage = F2(
	function (page, model) {
		return _Utils_update(
			model,
			{bm: page});
	});
var $author$project$Element$ModuleEventForm$openCreateForm = F4(
	function (session, model, _v0, modules) {
		var start = _v0.a;
		var end = _v0.b;
		var blankRecurrence = $author$project$RRule$blank;
		var blankEvent = $author$project$ModuleEvent$blankEvent;
		var event = _Utils_update(
			blankEvent,
			{
				gH: end,
				C: $elm$core$Maybe$Just(
					$author$project$Form$timeFromMillis(end)),
				hl: _Utils_update(
					blankRecurrence,
					{
						J: $elm$core$Maybe$Just(
							_List_fromArray(
								[
									$author$project$RRule$encodeWeekday(
									$author$project$Element$ModuleEventForm$toWeekday(start))
								]))
					}),
				hv: start,
				M: $elm$core$Maybe$Just(
					$author$project$Form$timeFromMillis(start))
			});
		var activeModulesWithStudents = A2(
			$elm$core$List$filter,
			function (m) {
				return (_Utils_cmp(m.hv, start) < 1) && ((_Utils_cmp(m.gH, end) > -1) && ((!$elm$core$List$isEmpty(m.e1)) && (!$author$project$Module$isMigrationReady(m))));
			},
			modules);
		var moduleOptions = A2(
			$author$project$Element$ModuleEventForm$toModuleOptions,
			session.hy,
			A2($author$project$Module$schoolModules, session.nH, activeModulesWithStudents));
		var form = A2(
			$author$project$Element$ModuleEventForm$buildModuleEventForm,
			session.hy,
			$elm$core$Maybe$Just(moduleOptions));
		var formModel = {
			hQ: $author$project$Form$Create($elm$core$Maybe$Nothing),
			bt: _Utils_update(
				form,
				{
					C: $author$project$Form$markEdited(form.C),
					hv: $author$project$Form$markEdited(form.hv),
					M: $author$project$Form$markEdited(form.M),
					J: $author$project$Form$markEdited(form.J)
				}),
			eZ: 0,
			dn: {cI: true},
			ej: $author$project$Element$ModuleEventForm$fillModuleEventForm(event)
		};
		return A2(
			$author$project$Element$ModuleEventForm$updatePage,
			$author$project$Element$ModuleEventForm$EventFormPage(formModel),
			model);
	});
var $author$project$Element$ModuleEventForm$loadCreateFormWithTimeSlot = F3(
	function (session, model, timeslot) {
		var config = model.bN;
		var _v0 = model.g9;
		if (!_v0.$) {
			var modules = _v0.a;
			return _Utils_Tuple3(
				A4($author$project$Element$ModuleEventForm$openCreateForm, session, model, timeslot, modules),
				$author$project$Element$ModuleEventForm$NoEffect,
				$elm$core$Maybe$Nothing);
		} else {
			return _Utils_Tuple3(
				A2(
					$author$project$Element$ModuleEventForm$updatePage,
					$author$project$Element$ModuleEventForm$CreateEventFormLoadingPage(
						$author$project$Element$ModuleEventForm$TimeSlot(timeslot)),
					model),
				$author$project$Element$ModuleEventForm$Cmd(
					$author$project$Element$ModuleEventForm$FetchModuleList(
						A3($author$project$Module$fetchViewerModules, config.gr, session.nH, $author$project$Element$ModuleEventForm$ModuleListDownloaded))),
				$elm$core$Maybe$Nothing);
		}
	});
var $author$project$Element$ModuleEventForm$loadCreateForm = F3(
	function (session, model, query) {
		var config = model.bN;
		var _v0 = _Utils_Tuple3(query.iS, query.hu, query.gG);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if ((_v0.b.$ === 1) && (_v0.c.$ === 1)) {
					var moduleId = _v0.a.a;
					var _v1 = _v0.b;
					var _v2 = _v0.c;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updatePage,
							$author$project$Element$ModuleEventForm$CreateEventFormLoadingPage(
								$author$project$Element$ModuleEventForm$Module(moduleId)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$FetchModule(
								A3($author$project$Module$fetchModule, config.gr, moduleId, $author$project$Element$ModuleEventForm$ModuleDetailDownloaded))),
						$elm$core$Maybe$Nothing);
				} else {
					break _v0$2;
				}
			} else {
				if ((!_v0.b.$) && (!_v0.c.$)) {
					var _v3 = _v0.a;
					var start = _v0.b.a;
					var end = _v0.c.a;
					return A3(
						$author$project$Element$ModuleEventForm$loadCreateFormWithTimeSlot,
						session,
						model,
						_Utils_Tuple2(start, end));
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(model, $author$project$Element$ModuleEventForm$NoEffect, $elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleEventForm$FetchModuleEvent = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleEventDetailDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$ModuleEventForm$UpdateEventFormLoadingPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$ModuleEvent$fetchModuleEvent = F4(
	function (config, _v0, _v1, callback) {
		var eventId = _v0;
		var occId = _v1;
		return {
			bN: config,
			dC: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			bZ: callback,
			G: A3($author$project$Api$Endpoint$moduleEvent, config, eventId, occId)
		};
	});
var $author$project$Element$ModuleEventForm$loadUpdateForm = F2(
	function (model, params) {
		var config = model.bN;
		var eventId = params.im;
		var occId = params.he;
		return _Utils_Tuple3(
			A2(
				$author$project$Element$ModuleEventForm$updatePage,
				$author$project$Element$ModuleEventForm$UpdateEventFormLoadingPage(params),
				model),
			$author$project$Element$ModuleEventForm$Cmd(
				$author$project$Element$ModuleEventForm$FetchModuleEvent(
					A4($author$project$ModuleEvent$fetchModuleEvent, config.gr, eventId, occId, $author$project$Element$ModuleEventForm$ModuleEventDetailDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$ModuleEventForm$init = F3(
	function (config, session, params) {
		var model = {bN: config, g9: $elm$core$Maybe$Nothing, bm: $author$project$Element$ModuleEventForm$NotFoundPage, cv: session};
		if (!params.$) {
			var query = params.a;
			return A3($author$project$Element$ModuleEventForm$loadCreateForm, session, model, query);
		} else {
			var query = params.a;
			return A2($author$project$Element$ModuleEventForm$loadUpdateForm, model, query);
		}
	});
var $author$project$Element$ModuleEventForm$perform = F2(
	function (_v0, effect) {
		if (!effect.$) {
			return $elm$core$Platform$Cmd$none;
		} else {
			var cmd = effect.a;
			switch (cmd.$) {
				case 0:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 1:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 2:
					var request = cmd.a;
					return $author$project$Api$getV2(request);
				case 3:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
				case 4:
					var request = cmd.a;
					return $author$project$Api$putV2(request);
				case 5:
					var request = cmd.a;
					return $author$project$Api$putV2(request);
				case 6:
					return $author$project$Ports$scrollToFormError;
				default:
					var request = cmd.a;
					return $author$project$Api$postV2(request);
			}
		}
	});
var $author$project$Element$ModuleEventForm$CreateModuleEvent = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleEventForm$EditedButNotSaved = 1;
var $author$project$Element$ModuleEventForm$EventSaveOk = 0;
var $author$project$Element$ModuleEventForm$Exit = 1;
var $author$project$Element$ModuleEventForm$LogError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Element$ModuleEventForm$ModuleEventSaved = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$ModuleEventForm$NoOp = {$: 0};
var $author$project$Element$ModuleEventForm$Saving = 3;
var $author$project$Element$ModuleEventForm$SavingError = 4;
var $author$project$Element$ModuleEventForm$ScrollToFormError = {$: 6};
var $author$project$Locale$Messages$TimetableModuleEventSaveSuccess = {$: 662};
var $author$project$Element$ModuleEventForm$UpdateAllOccurences = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$ModuleEventForm$UpdateScopeRequired = 2;
var $author$project$Element$ModuleEventForm$UpdateThisAndFutureOccurences = function (a) {
	return {$: 4, a: a};
};
var $author$project$ModuleEvent$defaultEventListParams = {iS: $elm$core$Maybe$Nothing};
var $author$project$ModuleEvent$moduleEventEncoder = function (event) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					$author$project$ModuleEvent$moduleEventIdToInt(event.gT))),
				_Utils_Tuple2(
				'module',
				$elm$json$Json$Encode$int(
					$author$project$Module$moduleIdToInt(event.fK))),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(event.jJ)),
				_Utils_Tuple2(
				'notes',
				$elm$json$Json$Encode$string(event.aO)),
				_Utils_Tuple2(
				'rrule',
				$elm$json$Json$Encode$string(event.hl)),
				_Utils_Tuple2(
				'start_time',
				$elm$json$Json$Encode$string(event.M)),
				_Utils_Tuple2(
				'end_time',
				$elm$json$Json$Encode$string(event.C))
			]));
};
var $author$project$ModuleEvent$createModuleEvent = F3(
	function (config, event, callback) {
		return {
			O: $author$project$ModuleEvent$moduleEventEncoder(event),
			bN: config,
			dC: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			bZ: callback,
			G: A2($author$project$Api$Endpoint$moduleEvents, config.gr, $author$project$ModuleEvent$defaultEventListParams)
		};
	});
var $author$project$Element$ModuleEventForm$isModuleEventFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.jJ, values) && (A2($author$project$Form$isFieldValid, form.aO, values) && (A2($author$project$Form$isFieldValid, form.Q, values) && (A2($author$project$Form$isFieldValid, form.J, values) && (A2($author$project$Form$isFieldValid, form.M, values) && (A2($author$project$Form$isFieldValid, form.C, values) && (A2($author$project$Form$isFieldValid, form.hv, values) && (A2($author$project$Form$isFieldValid, form.gH, values) && (A2($author$project$Form$isFieldValid, form.fK, values) && A3($author$project$Form$areDatesValid, form.hv, form.gH, values)))))))));
	});
var $author$project$Element$ModuleEventForm$markModuleEventFormEdited = function (form) {
	return _Utils_update(
		form,
		{
			gH: $author$project$Form$markEdited(form.gH),
			C: $author$project$Form$markEdited(form.C),
			Q: $author$project$Form$markEdited(form.Q),
			fK: $author$project$Form$markEdited(form.fK),
			aO: $author$project$Form$markEdited(form.aO),
			hv: $author$project$Form$markEdited(form.hv),
			M: $author$project$Form$markEdited(form.M),
			jJ: $author$project$Form$markEdited(form.jJ),
			J: $author$project$Form$markEdited(form.J)
		});
};
var $author$project$Log$msgModuleEventDownload = 'module_event_download';
var $author$project$Log$msgModuleEventSave = 'module_event_save';
var $author$project$Element$ModuleEventForm$openUpdateForm = F3(
	function (session, model, module_) {
		var moduleOptions = A2(
			$author$project$Element$ModuleEventForm$toModuleOptions,
			session.hy,
			_List_fromArray(
				[
					$author$project$Module$asListItem(module_)
				]));
		var form = A2(
			$author$project$Element$ModuleEventForm$buildModuleEventForm,
			session.hy,
			$elm$core$Maybe$Just(moduleOptions));
		var blankEvent = $author$project$ModuleEvent$blankEvent;
		var newModuleEvent = _Utils_update(
			blankEvent,
			{gH: module_.gH, C: $elm$core$Maybe$Nothing, fK: module_.gT, hl: $author$project$RRule$blank, hv: module_.hv, M: $elm$core$Maybe$Nothing, jJ: module_.jJ});
		var formModel = {
			hQ: $author$project$Form$Create(
				$elm$core$Maybe$Just(
					$author$project$Module$asListItem(module_))),
			bt: _Utils_update(
				form,
				{
					gH: $author$project$Form$markEdited(form.gH),
					hv: $author$project$Form$markEdited(form.hv),
					jJ: $author$project$Form$markEdited(form.jJ)
				}),
			eZ: 0,
			dn: {cI: true},
			ej: $author$project$Element$ModuleEventForm$fillModuleEventForm(newModuleEvent)
		};
		return A2(
			$author$project$Element$ModuleEventForm$updatePage,
			$author$project$Element$ModuleEventForm$EventFormPage(formModel),
			model);
	});
var $author$project$Api$Endpoint$moduleEventsUpdateAll = F2(
	function (config, eventId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_Nil);
	});
var $author$project$ModuleEvent$replaceModuleEventOccurences = F3(
	function (config, event, callback) {
		return {
			O: $author$project$ModuleEvent$moduleEventEncoder(event),
			bN: config,
			dC: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			bZ: callback,
			G: A2(
				$author$project$Api$Endpoint$moduleEventsUpdateAll,
				config.gr,
				$author$project$ModuleEvent$moduleEventIdToInt(event.gT))
		};
	});
var $author$project$ModuleEvent$ModuleEventUnsaved = F7(
	function (id, module_, title, notes, rrule, startTime, endTime) {
		return {C: endTime, gT: id, fK: module_, aO: notes, hl: rrule, M: startTime, jJ: title};
	});
var $author$project$RRule$encodeDtStart = function (dtStart_) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (value) {
				return 'DTSTART:' + (value + '\n');
			},
			dtStart_));
};
var $author$project$RRule$encodeFrequency = function (freq) {
	switch (freq) {
		case 1:
			return 'DAILY';
		case 0:
			return 'WEEKLY';
		default:
			return 'MONTHLY';
	}
};
var $author$project$RRule$encodeOptional = F3(
	function (field, encoder, maybeValue) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				function (value) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							field,
							encoder(value))
						]);
				},
				maybeValue));
	});
var $author$project$RRule$encodeRequired = F3(
	function (field, encoder, value) {
		return _List_fromArray(
			[
				_Utils_Tuple2(
				field,
				encoder(value))
			]);
	});
var $author$project$RRule$encode = function (rrule) {
	var ruleParts = _Utils_ap(
		A3($author$project$RRule$encodeRequired, 'FREQ', $author$project$RRule$encodeFrequency, rrule.Q),
		_Utils_ap(
			A3($author$project$RRule$encodeOptional, 'INTERVAL', $elm$core$String$fromInt, rrule.iF),
			_Utils_ap(
				A3($author$project$RRule$encodeOptional, 'WKST', $elm$core$Basics$identity, rrule.jX),
				_Utils_ap(
					A3($author$project$RRule$encodeOptional, 'UNTIL', $elm$core$Basics$identity, rrule.nA),
					A3(
						$author$project$RRule$encodeOptional,
						'BYDAY',
						$elm$core$String$join(','),
						rrule.J)))));
	return A2(
		$elm$core$String$append,
		$author$project$RRule$encodeDtStart(rrule.kT),
		A2(
			$elm$core$String$append,
			'RRULE:',
			A2(
				$elm$core$String$join,
				';',
				A2(
					$elm$core$List$map,
					function (_v0) {
						var part = _v0.a;
						var value = _v0.b;
						return part + ('=' + value);
					},
					ruleParts))));
};
var $author$project$ModuleEvent$fromValueToFrequency = function (freqValue) {
	switch (freqValue) {
		case 'WEEKLY':
			return 0;
		case 'BIWEEKLY':
			return 0;
		default:
			return 1;
	}
};
var $author$project$ModuleEvent$fromValueToInterval = function (interval) {
	if (interval === 'BIWEEKLY') {
		return $elm$core$Maybe$Just(2);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ModuleEvent$fromValueToDateTime = F2(
	function (isMin, dateValue) {
		var yyyy = A3($elm$core$String$slice, 0, 4, dateValue);
		var time = isMin ? 'T000000' : 'T235959';
		var mm = A3($elm$core$String$slice, 5, 7, dateValue);
		var dd = A3($elm$core$String$slice, 8, 10, dateValue);
		return $elm$core$String$isEmpty(dateValue) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			_Utils_ap(
				yyyy,
				_Utils_ap(
					mm,
					_Utils_ap(dd, time))));
	});
var $author$project$ModuleEvent$fromValueToMaxDateTime = $author$project$ModuleEvent$fromValueToDateTime(false);
var $author$project$ModuleEvent$fromValueToMinDateTime = $author$project$ModuleEvent$fromValueToDateTime(true);
var $author$project$Element$ModuleEventForm$saveRRule = F2(
	function (form, values) {
		var weekdays = A2(
			$author$project$Data$toMaybe,
			$elm$core$List$isEmpty,
			form.J.nD(values));
		var until = $author$project$ModuleEvent$fromValueToMaxDateTime(
			form.gH.nD(values));
		var interval = $author$project$ModuleEvent$fromValueToInterval(
			form.Q.nD(values));
		var freq = $author$project$ModuleEvent$fromValueToFrequency(
			form.Q.nD(values));
		var dtStart = $author$project$ModuleEvent$fromValueToMinDateTime(
			form.hv.nD(values));
		return {kT: dtStart, Q: freq, iF: interval, nA: until, jX: $elm$core$Maybe$Nothing, J: weekdays};
	});
var $author$project$Element$ModuleEventForm$saveModuleEventForm = F3(
	function (form, values, event) {
		return A7(
			$author$project$ModuleEvent$ModuleEventUnsaved,
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.gT;
					},
					event)),
			A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2(
					$elm$core$Maybe$map,
					$elm$core$Basics$identity,
					$elm$core$String$toInt(
						form.fK.nD(values)))),
			form.jJ.nD(values),
			form.aO.nD(values),
			$author$project$RRule$encode(
				A2($author$project$Element$ModuleEventForm$saveRRule, form, values)),
			form.M.nD(values),
			form.C.nD(values));
	});
var $author$project$Api$Endpoint$moduleEventsUpdateFuture = F3(
	function (config, eventId, occId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'module-events',
					$elm$core$String$fromInt(eventId)
				]),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'start',
					$elm$core$String$fromInt(occId))
				]));
	});
var $author$project$ModuleEvent$updateFutureModuleEventOccurences = F4(
	function (config, event, occId, callback) {
		return {
			O: $author$project$ModuleEvent$moduleEventEncoder(event),
			bN: config,
			dC: $author$project$ModuleEvent$moduleEventDetailedDecoder,
			bZ: callback,
			G: A3(
				$author$project$Api$Endpoint$moduleEventsUpdateFuture,
				config.gr,
				$author$project$ModuleEvent$moduleEventIdToInt(event.gT),
				$author$project$ModuleEvent$moduleEventOccurenceIdToInt(occId))
		};
	});
var $author$project$Util$Time$adjustEndTime = F3(
	function (oldStartTime, newStartTime, endTime) {
		var duration = (!endTime) ? ((60 * 60) * 1000) : (endTime - oldStartTime);
		return newStartTime + duration;
	});
var $author$project$Element$ModuleEventForm$andThenUpdateWeekdays = function (_v0) {
	var form = _v0.a;
	var formValues = _v0.b;
	return (form.Q.nD(formValues) === 'NOREPEAT') ? _Utils_Tuple2(
		_Utils_update(
			form,
			{
				gH: $author$project$Form$markEdited(form.gH),
				J: $author$project$Form$markEdited(form.J)
			}),
		A2(
			form.J.jR,
			_List_fromArray(
				[
					$author$project$RRule$encodeWeekday(
					$author$project$Element$ModuleEventForm$toWeekday(
						$author$project$Form$dateToMillis(
							form.hv.nD(formValues))))
				]),
			A2(
				form.gH.jR,
				form.hv.nD(formValues),
				formValues))) : _Utils_Tuple2(form, formValues);
};
var $author$project$Element$ModuleEventForm$findModuleByFormValue = F2(
	function (idStr, modules) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				function (m) {
					return _Utils_eq(
						$elm$core$Maybe$Just(
							$author$project$Module$moduleIdToInt(m.gT)),
						$elm$core$String$toInt(idStr));
				},
				modules));
	});
var $author$project$Locale$isoTimeFormatter = A2(
	$ryan_haskell$date_format$DateFormat$formatWithLanguage,
	$ryan_haskell$date_format$DateFormat$Language$english,
	_List_fromArray(
		[
			$ryan_haskell$date_format$DateFormat$hourMilitaryFixed,
			$ryan_haskell$date_format$DateFormat$text(':'),
			$ryan_haskell$date_format$DateFormat$minuteFixed
		]));
var $author$project$Util$Time$toMillis = function (timeStr) {
	var mins = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(
			A2($elm$core$String$right, 2, timeStr)));
	var hours = A2(
		$elm$core$Maybe$withDefault,
		0,
		$elm$core$String$toInt(
			A2($elm$core$String$left, 2, timeStr)));
	return (((hours * 60) * 60) * 1000) + ((mins * 60) * 1000);
};
var $author$project$Element$ModuleEventForm$updateModuleEventForm = F4(
	function (msg, form, formValues, modules) {
		switch (msg.$) {
			case 0:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							jJ: $author$project$Form$markEdited(form.jJ)
						}),
					A2(form.jJ.jR, value, formValues));
			case 1:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							aO: $author$project$Form$markEdited(form.aO)
						}),
					A2(form.aO.jR, value, formValues));
			case 2:
				var value = msg.a;
				return $author$project$Element$ModuleEventForm$andThenUpdateWeekdays(
					_Utils_Tuple2(
						_Utils_update(
							form,
							{
								Q: $author$project$Form$markEdited(form.Q)
							}),
						A2(form.Q.jR, value, formValues)));
			case 3:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							J: $author$project$Form$markEdited(form.J)
						}),
					A2(form.J.jR, value, formValues));
			case 4:
				var startTimeValue = msg.a;
				var oldStartTime = $author$project$Util$Time$toMillis(
					form.M.nD(formValues));
				var newStartTime = $author$project$Util$Time$toMillis(startTimeValue);
				var endTime = $author$project$Util$Time$toMillis(
					form.C.nD(formValues));
				var newEndTimeValue = A2(
					$author$project$Locale$isoTimeFormatter,
					$elm$time$Time$utc,
					$elm$time$Time$millisToPosix(
						A3($author$project$Util$Time$adjustEndTime, oldStartTime, newStartTime, endTime)));
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							C: $author$project$Form$markEdited(form.C),
							M: $author$project$Form$markEdited(form.M)
						}),
					A2(
						form.C.jR,
						newEndTimeValue,
						A2(form.M.jR, startTimeValue, formValues)));
			case 5:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							C: $author$project$Form$markEdited(form.C)
						}),
					A2(form.C.jR, value, formValues));
			case 6:
				var value = msg.a;
				return $author$project$Element$ModuleEventForm$andThenUpdateWeekdays(
					_Utils_Tuple2(
						_Utils_update(
							form,
							{
								hv: $author$project$Form$markEdited(form.hv)
							}),
						A2(form.hv.jR, value, formValues)));
			case 7:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						form,
						{
							gH: $author$project$Form$markEdited(form.gH)
						}),
					A2(form.gH.jR, value, formValues));
			default:
				var moduleIdValue = msg.a;
				var prefillForm = function (module_) {
					return _Utils_Tuple2(
						_Utils_update(
							form,
							{
								gH: $author$project$Form$markEdited(form.gH),
								fK: $author$project$Form$markEdited(form.fK),
								jJ: $author$project$Form$markEdited(form.jJ)
							}),
						A2(
							form.gH.jR,
							$author$project$Form$dateFromMillis(module_.gH),
							A2(
								form.jJ.jR,
								module_.jJ,
								A2(form.fK.jR, moduleIdValue, formValues))));
				};
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(form, formValues),
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Element$ModuleEventForm$findModuleByFormValue(moduleIdValue),
							$elm$core$Maybe$map(prefillForm)),
						modules));
		}
	});
var $author$project$Element$ModuleEventForm$updateSession = F2(
	function (session, model) {
		return _Utils_update(
			model,
			{cv: session});
	});
var $author$project$Element$ModuleEventForm$update = F2(
	function (msg, model) {
		var config = model.bN;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$ModuleEventForm$NoEffect, $elm$core$Maybe$Nothing);
		var _v0 = _Utils_Tuple2(msg, model.bm);
		switch (_v0.a.$) {
			case 0:
				var _v1 = _v0.a;
				return noop;
			case 10:
				var _v2 = _v0.a;
				return _Utils_Tuple3(
					model,
					$author$project$Element$ModuleEventForm$NoEffect,
					$elm$core$Maybe$Just(1));
			case 1:
				if (!_v0.b.$) {
					var fieldMsg = _v0.a.a;
					var formModel = _v0.b.a;
					var _v3 = A4($author$project$Element$ModuleEventForm$updateModuleEventForm, fieldMsg, formModel.bt, formModel.ej, model.g9);
					var form = _v3.a;
					var values = _v3.b;
					var eventForm = _Utils_update(
						formModel,
						{bt: form, eZ: 1, ej: values});
					var page = function () {
						var dateValidation = function () {
							switch (fieldMsg.$) {
								case 6:
									return true;
								case 7:
									return true;
								default:
									return formModel.dn.cI;
							}
						}();
						return $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								eventForm,
								{
									dn: {cI: dateValidation}
								}));
					}();
					return _Utils_Tuple3(
						A2($author$project$Element$ModuleEventForm$updatePage, page, model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					return noop;
				}
			case 3:
				var params = _v0.a.a;
				return A2($author$project$Element$ModuleEventForm$loadUpdateForm, model, params);
			case 2:
				if (!_v0.b.$) {
					var _v5 = _v0.a;
					var formPage = _v0.b.a;
					var action = formPage.hQ;
					var form = formPage.bt;
					var values = formPage.ej;
					var _v6 = _Utils_Tuple2(
						A2($author$project$Element$ModuleEventForm$isModuleEventFormValid, form, values),
						action);
					if (_v6.a) {
						if (!_v6.b.$) {
							var page = $author$project$Element$ModuleEventForm$EventFormPage(
								_Utils_update(
									formPage,
									{eZ: 3}));
							return _Utils_Tuple3(
								A2($author$project$Element$ModuleEventForm$updatePage, page, model),
								$author$project$Element$ModuleEventForm$Cmd(
									$author$project$Element$ModuleEventForm$CreateModuleEvent(
										A3(
											$author$project$ModuleEvent$createModuleEvent,
											config,
											A3($author$project$Element$ModuleEventForm$saveModuleEventForm, form, values, $elm$core$Maybe$Nothing),
											$author$project$Element$ModuleEventForm$ModuleEventSaved))),
								$elm$core$Maybe$Nothing);
						} else {
							var page = $author$project$Element$ModuleEventForm$EventFormPage(
								_Utils_update(
									formPage,
									{eZ: 2}));
							return _Utils_Tuple3(
								A2($author$project$Element$ModuleEventForm$updatePage, page, model),
								$author$project$Element$ModuleEventForm$NoEffect,
								$elm$core$Maybe$Nothing);
						}
					} else {
						var areDatesValid = A3($author$project$Form$areDatesValid, form.hv, form.gH, values);
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formPage,
								{
									bt: $author$project$Element$ModuleEventForm$markModuleEventFormEdited(form),
									eZ: 1,
									dn: {cI: areDatesValid}
								}));
						return _Utils_Tuple3(
							A2($author$project$Element$ModuleEventForm$updatePage, page, model),
							$author$project$Element$ModuleEventForm$Cmd($author$project$Element$ModuleEventForm$ScrollToFormError),
							$elm$core$Maybe$Nothing);
					}
				} else {
					var _v7 = _v0.a;
					return noop;
				}
			case 5:
				if (!_v0.b.$) {
					var _v8 = _v0.a;
					var formModel = _v0.b.a;
					var page = $author$project$Element$ModuleEventForm$EventFormPage(
						_Utils_update(
							formModel,
							{eZ: 1}));
					return _Utils_Tuple3(
						A2($author$project$Element$ModuleEventForm$updatePage, page, model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var _v9 = _v0.a;
					return noop;
				}
			case 4:
				if (!_v0.b.$) {
					var scope = _v0.a.a;
					var formModel = _v0.b.a;
					var action = formModel.hQ;
					var form = formModel.bt;
					var values = formModel.ej;
					if (action.$ === 1) {
						var _v11 = action.a;
						var event = _v11.a;
						var occId = _v11.b;
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formModel,
								{eZ: 3}));
						var cmd = function () {
							if (!scope) {
								return $author$project$Element$ModuleEventForm$UpdateThisAndFutureOccurences(
									A4(
										$author$project$ModuleEvent$updateFutureModuleEventOccurences,
										config,
										A3(
											$author$project$Element$ModuleEventForm$saveModuleEventForm,
											form,
											values,
											$elm$core$Maybe$Just(event)),
										occId,
										$author$project$Element$ModuleEventForm$ModuleEventSaved));
							} else {
								return $author$project$Element$ModuleEventForm$UpdateAllOccurences(
									A3(
										$author$project$ModuleEvent$replaceModuleEventOccurences,
										config,
										A3(
											$author$project$Element$ModuleEventForm$saveModuleEventForm,
											form,
											values,
											$elm$core$Maybe$Just(event)),
										$author$project$Element$ModuleEventForm$ModuleEventSaved));
							}
						}();
						return _Utils_Tuple3(
							A2($author$project$Element$ModuleEventForm$updatePage, page, model),
							$author$project$Element$ModuleEventForm$Cmd(cmd),
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					return noop;
				}
			case 6:
				if (!_v0.a.a.$) {
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$TimetableModuleEventSaveSuccess)),
							model),
						$author$project$Element$ModuleEventForm$NoEffect,
						$elm$core$Maybe$Just(0));
				} else {
					if (!_v0.b.$) {
						var error = _v0.a.a.a;
						var formModel = _v0.b.a;
						var action = formModel.hQ;
						var session2 = A3(
							$author$project$Session$error,
							session,
							error,
							session.hy($author$project$Locale$Messages$FormSaveError));
						var page = $author$project$Element$ModuleEventForm$EventFormPage(
							_Utils_update(
								formModel,
								{eZ: 4}));
						var occId = A2(
							$elm$core$Maybe$withDefault,
							'-1',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Tuple$second,
									A2($elm$core$Basics$composeR, $author$project$ModuleEvent$moduleEventOccurenceIdToInt, $elm$core$String$fromInt)),
								$author$project$Form$toSavedObject(action)));
						var model2 = A2(
							$author$project$Element$ModuleEventForm$updateSession,
							session2,
							A2($author$project$Element$ModuleEventForm$updatePage, page, model));
						var effect = $author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventSave,
										$elm$core$Maybe$Just(occId),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp))));
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			case 7:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				} else {
					if ((_v0.b.$ === 1) && (!_v0.b.a.$)) {
						var module_ = _v0.a.a.a;
						var moduleId = _v0.b.a.a;
						return _Utils_eq(module_.gT, moduleId) ? _Utils_Tuple3(
							A3($author$project$Element$ModuleEventForm$openUpdateForm, session, model, module_),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing) : noop;
					} else {
						return noop;
					}
				}
			case 8:
				if (_v0.a.a.$ === 1) {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								session.hy($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleEventDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				} else {
					if (_v0.b.$ === 2) {
						var event = _v0.a.a.a;
						var occId = _v0.b.a.he;
						var formModel = {
							hQ: $author$project$Form$Update(
								_Utils_Tuple2(event, occId)),
							bt: A2($author$project$Element$ModuleEventForm$buildModuleEventForm, session.hy, $elm$core$Maybe$Nothing),
							eZ: 0,
							dn: {cI: true},
							ej: $author$project$Element$ModuleEventForm$fillModuleEventForm(event)
						};
						return _Utils_Tuple3(
							A2(
								$author$project$Element$ModuleEventForm$updatePage,
								$author$project$Element$ModuleEventForm$EventFormPage(formModel),
								model),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				}
			default:
				if (!_v0.a.a.$) {
					if ((_v0.b.$ === 1) && (_v0.b.a.$ === 1)) {
						var modules = _v0.a.a.a;
						var timeslot = _v0.b.a.a;
						return _Utils_Tuple3(
							A4(
								$author$project$Element$ModuleEventForm$openCreateForm,
								session,
								_Utils_update(
									model,
									{
										g9: $elm$core$Maybe$Just(modules)
									}),
								timeslot,
								modules),
							$author$project$Element$ModuleEventForm$NoEffect,
							$elm$core$Maybe$Nothing);
					} else {
						return noop;
					}
				} else {
					var error = _v0.a.a.a;
					return _Utils_Tuple3(
						A2(
							$author$project$Element$ModuleEventForm$updateSession,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$ModulesDownloadError)),
							model),
						$author$project$Element$ModuleEventForm$Cmd(
							$author$project$Element$ModuleEventForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModulesDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$ModuleEventForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Element$ModuleEventForm$EventFormReset = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$ModuleEventForm$EventFormSubmitted = {$: 2};
var $author$project$Locale$Messages$ModuleEventDate = {$: 234};
var $author$project$Element$ModuleEventForm$PopupClosed = {$: 10};
var $author$project$Locale$Messages$TimetableHeadingEdit = {$: 638};
var $author$project$Locale$Messages$TimetableHeadingNew = {$: 637};
var $author$project$UI$fieldLegend = F2(
	function (t_, field) {
		return A4($author$project$UI$label_, $elm$html$Html$legend, t_, $elm$core$Maybe$Nothing, field);
	});
var $author$project$UI$checkboxField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValues = field.nD(values);
		var checkboxIsDisabled = function (option) {
			var _v1 = field.nE.kO;
			if (!_v1.$) {
				var listOfDisabledOptions = _v1.a;
				return A2($elm$core$List$member, option, listOfDisabledOptions);
			} else {
				return false;
			}
		};
		var viewCheckboxes = $elm$core$List$map(
			A4($author$project$UI$checkbox, field.nE.mj, field.nE.kJ, checkboxIsDisabled, selectedValues));
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLegend, t_, field),
					function () {
					var _v0 = field.nE.mp;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						var options = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('control has-icons-right'),
									$elm$html$Html$Attributes$classList(
									A2($author$project$UI$validationClassList, field, values))
								]),
							_Utils_ap(
								viewCheckboxes(options),
								_List_fromArray(
									[
										A2($author$project$UI$fieldValidationStatus, field.kU, valid)
									])));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$UI$radioField = F3(
	function (t_, field, values) {
		var valid = A2($author$project$Form$isFieldValid, field, values);
		var selectedValue = field.nD(values);
		var viewButtons = $elm$core$List$map(
			A3($author$project$UI$radioButton, field.nE.aT, field.nE.kJ, selectedValue));
		return A2(
			$elm$html$Html$fieldset,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('field'),
					$elm$html$Html$Attributes$classList(
					_List_fromArray(
						[
							_Utils_Tuple2('has-errors', !valid)
						]))
				]),
			_List_fromArray(
				[
					A2($author$project$UI$fieldLegend, t_, field),
					function () {
					var _v0 = field.nE.mp;
					if (_v0.$ === 1) {
						return $author$project$UI$Icon$loadingOptions(_List_Nil);
					} else {
						var options = _v0.a;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('control has-icons-right'),
									$elm$html$Html$Attributes$classList(
									A2($author$project$UI$validationClassList, field, values))
								]),
							_Utils_ap(
								viewButtons(options),
								_List_fromArray(
									[
										A2($author$project$UI$fieldValidationStatus, field.kU, valid)
									])));
					}
				}(),
					A2($author$project$UI$validationError, field, values)
				]));
	});
var $author$project$Locale$Messages$FormTimeFormat = {$: 72};
var $author$project$UI$timeField = F3(
	function (t_, field, values) {
		return A3(
			$author$project$UI$textField,
			t_,
			{
				kU: field.kU,
				mu: field.mu,
				mK: field.mK,
				jR: field.jR,
				nD: field.nD,
				nE: {
					kJ: field.nE.kJ,
					lj: 'fa-clock',
					lO: field.nE.lO,
					aT: field.nE.aT,
					bv: t_($author$project$Locale$Messages$FormTimeFormat),
					hH: 'time'
				}
			},
			values);
	});
var $author$project$Element$ModuleEventForm$toGenericFormState = function (state) {
	switch (state) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 2;
		default:
			return 3;
	}
};
var $author$project$Element$ModuleEventForm$viewForm = F2(
	function (t_, _v0) {
		var action = _v0.hQ;
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var validations = _v0.dn;
		var viewSingleOccurenceFields = function () {
			var startDateView = form.hv.nE;
			var startDate = form.hv;
			var nonRecurringDateField = _Utils_update(
				startDate,
				{
					nE: _Utils_update(
						startDateView,
						{
							lO: t_($author$project$Locale$Messages$ModuleEventDate)
						})
				});
			return _List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$radioField, t_, form.Q, values),
							A4($author$project$UI$dateField, t_, nonRecurringDateField, values, true)
						]))
				]);
		}();
		var viewModuleField = function () {
			if (!action.$) {
				if (action.a.$ === 1) {
					var _v5 = action.a;
					return $author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$choiceField, t_, form.fK, values)
							]));
				} else {
					return $author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$frozenChoiceField, t_, form.fK, values)
							]));
				}
			} else {
				return $author$project$UI$none;
			}
		}();
		var viewHeadingText = function () {
			if (!action.$) {
				return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableHeadingNew);
			} else {
				return A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableHeadingEdit);
			}
		}();
		var viewCommonFields = _List_fromArray(
			[
				viewModuleField,
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$textField, t_, form.jJ, values),
						A3($author$project$UI$textField, t_, form.aO, values)
					])),
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$timeField, t_, form.M, values),
						A3($author$project$UI$timeField, t_, form.C, values)
					]))
			]);
		var viewButtons = A5(
			$author$project$UI$formButtons,
			t_,
			action,
			$author$project$Element$ModuleEventForm$toGenericFormState(state),
			$author$project$Element$ModuleEventForm$EventFormSubmitted,
			function (_v2) {
				var event = _v2.a;
				var occId = _v2.b;
				return $author$project$Element$ModuleEventForm$EventFormReset(
					{
						im: $author$project$ModuleEvent$moduleEventIdToInt(event.gT),
						he: $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occId)
					});
			});
		var validationError = function (content) {
			return (state === 1) ? (validations.cI ? content : A3($author$project$UI$withErrorText, t_, $author$project$Locale$Messages$FormEndDateBeforeStartDate, content)) : content;
		};
		var viewRecurringFields = _List_fromArray(
			[
				$author$project$UI$columns(
				_List_fromArray(
					[
						A3($author$project$UI$radioField, t_, form.Q, values),
						A3($author$project$UI$checkboxField, t_, form.J, values)
					])),
				$author$project$UI$columns(
				function () {
					if (!action.$) {
						return _List_fromArray(
							[
								A4($author$project$UI$dateField, t_, form.hv, values, true),
								validationError(
								A4($author$project$UI$dateField, t_, form.gH, values, true))
							]);
					} else {
						return _List_fromArray(
							[
								$author$project$UI$none,
								validationError(
								A4($author$project$UI$dateField, t_, form.gH, values, true))
							]);
					}
				}())
			]);
		var isRecurring = form.Q.nD(values) !== 'NOREPEAT';
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[viewHeadingText]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$ModuleEventForm$PopupClosed)
				]),
			_Utils_ap(
				viewCommonFields,
				isRecurring ? viewRecurringFields : viewSingleOccurenceFields),
			_List_fromArray(
				[viewButtons]));
	});
var $author$project$Element$ModuleEventForm$viewProgressBar = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			$elm$html$Html$Attributes$class('is-overlay is-extra-small')
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$progress,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('progress is-extra-small')
				]),
			_List_Nil)
		]));
var $author$project$Element$ModuleEventForm$EventUpdateScopeSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Locale$Messages$TimetableBtnEditAllOccurences = {$: 647};
var $author$project$Locale$Messages$TimetableBtnEditThisAndFutureOccurences = {$: 646};
var $author$project$Locale$Messages$TimetableModuleEventChangeHeading = {$: 656};
var $author$project$Locale$Messages$TimetableModuleEventChangeHelp = {$: 657};
var $author$project$Element$ModuleEventForm$UpdateAll = 1;
var $author$project$Element$ModuleEventForm$UpdateScopeNotSelected = {$: 5};
var $author$project$Element$ModuleEventForm$UpdateThisAndFuture = 0;
var $author$project$Element$ModuleEventForm$viewUpdateSelectionModal = function (t_) {
	return A4(
		$author$project$UI$modalPanel,
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventChangeHeading)
			]),
		_List_fromArray(
			[
				$author$project$UI$closeButton($author$project$Element$ModuleEventForm$UpdateScopeNotSelected)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('content')
					]),
				$author$project$UI$textToHtml(
					t_($author$project$Locale$Messages$TimetableModuleEventChangeHelp)))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-link'),
						$elm$html$Html$Events$onClick(
						$author$project$Element$ModuleEventForm$EventUpdateScopeSelected(0))
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnEditThisAndFutureOccurences)
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-warning'),
						$elm$html$Html$Events$onClick(
						$author$project$Element$ModuleEventForm$EventUpdateScopeSelected(1))
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnEditAllOccurences)
					]))
			]));
};
var $author$project$Element$ModuleEventForm$view = function (model) {
	var session = model.cv;
	var _v0 = model.bm;
	switch (_v0.$) {
		case 3:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		case 1:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		case 2:
			return $author$project$Element$ModuleEventForm$viewProgressBar;
		default:
			var formModel = _v0.a;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2($author$project$Element$ModuleEventForm$viewForm, session.hy, formModel),
						function () {
						var _v1 = formModel.eZ;
						if (_v1 === 2) {
							return $author$project$Element$ModuleEventForm$viewUpdateSelectionModal(session.hy);
						} else {
							return $author$project$UI$none;
						}
					}()
					]));
	}
};
var $author$project$Element$ModuleEventForm$element = {iA: $author$project$Element$ModuleEventForm$init, hh: $author$project$Element$ModuleEventForm$perform, jR: $author$project$Element$ModuleEventForm$update, nE: $author$project$Element$ModuleEventForm$view};
var $author$project$Element$Timetable$moduleEventForm = {
	gF: $author$project$Element$ModuleEventForm$element,
	bZ: $author$project$Element$Timetable$ModuleEventFormMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					c2: $elm$core$Maybe$Just(
						$author$project$Element$Timetable$EventFormView(model))
				});
		})
};
var $author$project$Log$msgDailyAttendanceDownload = 'daily_attendance_download';
var $author$project$Log$msgDailyAttendanceSave = 'daily_attendance_save';
var $author$project$Log$msgModuleEventDelete = 'module_event_delete';
var $author$project$Element$Timetable$Occurence = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$FieldAttendantsSet = function (a) {
	return {$: 12, a: a};
};
var $author$project$Locale$Messages$TimetableAttendanceParticipants = {$: 654};
var $author$project$Element$Timetable$buildAttendanceForm = function (t_) {
	return {
		gq: {
			kU: false,
			mu: $author$project$Form$optionalPeople(t_),
			mK: false,
			jR: F2(
				function (value, values) {
					return _Utils_update(
						values,
						{gq: value});
				}),
			nD: function ($) {
				return $.gq;
			},
			nE: {
				kJ: 'attendants',
				kO: $elm$core$Maybe$Nothing,
				lj: 'fa-users',
				lO: t_($author$project$Locale$Messages$TimetableAttendanceParticipants),
				mj: $author$project$Element$Timetable$FieldAttendantsSet,
				mp: $elm$core$Maybe$Nothing
			}
		}
	};
};
var $author$project$Element$Timetable$fillAttendanceForm = function (attendants) {
	return {
		gq: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			attendants)
	};
};
var $author$project$Element$Timetable$moduleEventOccurenceToStudentOptions = F2(
	function (t_, occurence) {
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			_Utils_ap(occurence.gq, occurence.gl));
	});
var $author$project$Element$Timetable$openAttendanceForm = F3(
	function (event, occurence, _return) {
		var session = _return.cv;
		var blankForm = $author$project$Element$Timetable$buildAttendanceForm(session.hy);
		var formModel = {
			ex: $author$project$Element$Timetable$Occurence(occurence),
			bt: _Utils_update(
				blankForm,
				{
					gq: A2(
						$author$project$Form$fillFieldOptions,
						A2($author$project$Element$Timetable$moduleEventOccurenceToStudentOptions, session.hy, occurence),
						blankForm.gq)
				}),
			eZ: 0,
			ej: $author$project$Element$Timetable$fillAttendanceForm(occurence.gq)
		};
		return A2(
			$author$project$Element$Timetable$openPopup,
			A2($author$project$Element$Timetable$AttendanceFormView, event, formModel),
			_return);
	});
var $author$project$Element$ModuleEventForm$CreateEvent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$Timetable$openCreateForm = F2(
	function (query, _return) {
		var session = _return.cv;
		var model = _return.dY;
		var createFormOpened = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			_return,
			$author$project$Element$Timetable$moduleEventForm,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				model.bN.iJ,
				$author$project$Application$V2$SharedConfig$fromV1(model.bN),
				session,
				$author$project$Element$Timetable$moduleEventForm,
				$author$project$Element$ModuleEventForm$CreateEvent(query)));
		return {dz: createFormOpened.dz, dY: createFormOpened.dY, fY: $elm$core$Maybe$Nothing, cv: createFormOpened.cv};
	});
var $author$project$Element$Timetable$Daily = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$dailyAttendanceToStudentOptions = F2(
	function (t_, _v0) {
		var attendants = _v0.gq;
		var absentees = _v0.gl;
		return A2(
			$author$project$Form$toPeopleOptions,
			t_,
			$author$project$Util$List$unique(
				_Utils_ap(attendants, absentees)));
	});
var $author$project$Element$Timetable$openDailyAttendanceForm = F2(
	function (attendance, _return) {
		var session = _return.cv;
		var blankForm = $author$project$Element$Timetable$buildAttendanceForm(session.hy);
		var attendantIdsAsString = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			attendance.gq);
		var absenteeIdsAsString = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.gT;
				},
				$elm$core$String$fromInt),
			attendance.gl);
		var isFullDayAbsent = function (personIdAsString) {
			return A2($elm$core$List$member, personIdAsString, absenteeIdsAsString) && (!A2($elm$core$List$member, personIdAsString, attendantIdsAsString));
		};
		var fillFieldOptionsDisableNotSelected = F2(
			function (options, field) {
				return _Utils_update(
					field,
					{
						nE: {
							kJ: field.nE.kJ,
							kO: $elm$core$Maybe$Just(
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeL,
										isFullDayAbsent,
										function ($) {
											return $.nD;
										}),
									options)),
							lj: field.nE.lj,
							lO: field.nE.lO,
							mj: field.nE.mj,
							mp: $elm$core$Maybe$Just(options)
						}
					});
			});
		var formModel = {
			ex: $author$project$Element$Timetable$Daily(attendance),
			bt: _Utils_update(
				blankForm,
				{
					gq: A2(
						fillFieldOptionsDisableNotSelected,
						A2($author$project$Element$Timetable$dailyAttendanceToStudentOptions, session.hy, attendance),
						blankForm.gq)
				}),
			eZ: 0,
			ej: $author$project$Element$Timetable$fillAttendanceForm(attendance.gq)
		};
		return A2(
			$author$project$Element$Timetable$openPopup,
			$author$project$Element$Timetable$DailyAttendanceFormView(formModel),
			_return);
	});
var $author$project$Element$ModuleEventForm$UpdateEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$Timetable$openUpdateForm = F2(
	function (query, _return) {
		var session = _return.cv;
		var model = _return.dY;
		var updateFormOpened = A2(
			$author$project$Application$Boundaries$andThenCmd,
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always($author$project$Element$Timetable$NoOp),
				$elm$browser$Browser$Dom$focus('timetable-popup')),
			A3(
				$author$project$Application$V2$Boundaries$mapElement,
				_return,
				$author$project$Element$Timetable$moduleEventForm,
				A5(
					$author$project$Application$V2$Boundaries$initElement,
					model.bN.iJ,
					$author$project$Application$V2$SharedConfig$fromV1(model.bN),
					session,
					$author$project$Element$Timetable$moduleEventForm,
					$author$project$Element$ModuleEventForm$UpdateEvent(query))));
		return {dz: updateFormOpened.dz, dY: updateFormOpened.dY, fY: $elm$core$Maybe$Nothing, cv: updateFormOpened.cv};
	});
var $author$project$Element$Timetable$DailyAttendanceSaved = function (a) {
	return {$: 15, a: a};
};
var $author$project$DailyAttendance$DailyAttendanceUnsaved = F3(
	function (day, attendants, absentees) {
		return {gl: absentees, gq: attendants, fq: day};
	});
var $author$project$Element$Timetable$ModuleEventOccurenceSaved = function (a) {
	return {$: 17, a: a};
};
var $author$project$Element$Timetable$saveAttendanceForm = F3(
	function (form, values, occurence) {
		var occurenceUnsaved = $author$project$ModuleEvent$unfreeze(occurence);
		return _Utils_update(
			occurenceUnsaved,
			{
				gq: A2(
					$elm$core$List$map,
					$author$project$Person$decodePersonId,
					form.gq.nD(values))
			});
	});
var $author$project$Util$List$subtract = F2(
	function (x, y) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (item, acc) {
					return A2($elm$core$List$member, item, y) ? acc : A2($elm$core$List$cons, item, acc);
				}),
			_List_Nil,
			x);
	});
var $author$project$DailyAttendance$dailyAttendanceEncoder = function (data) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'day',
				$elm$json$Json$Encode$int(data.fq)),
				_Utils_Tuple2(
				'attendants',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, data.gq)),
				_Utils_Tuple2(
				'absentees',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, data.gl))
			]));
};
var $author$project$DailyAttendance$updateDailyAttendance = F3(
	function (config, data, callback) {
		return A5(
			$author$project$Api$patch,
			A2($author$project$Api$Endpoint$dailyAttendance, config, data.fq),
			config,
			$elm$http$Http$jsonBody(
				$author$project$DailyAttendance$dailyAttendanceEncoder(data)),
			callback,
			$author$project$DailyAttendance$dailyAttendanceDecoder);
	});
var $author$project$Element$Timetable$updateAttendance = F2(
	function (config, _v0) {
		var form = _v0.bt;
		var values = _v0.ej;
		var dataSource = _v0.ex;
		if (!dataSource.$) {
			var occurence = dataSource.a;
			var occurenceUnsaved = A3($author$project$Element$Timetable$saveAttendanceForm, form, values, occurence);
			return A3($author$project$ModuleEvent$updateModuleEventOccurence, config.gr, occurenceUnsaved, $author$project$Element$Timetable$ModuleEventOccurenceSaved);
		} else {
			var attendance = dataSource.a;
			var newAttendants = A2(
				$elm$core$List$map,
				$author$project$Person$decodePersonId,
				form.gq.nD(values));
			var attendantIds = A2(
				$elm$core$List$map,
				function ($) {
					return $.gT;
				},
				attendance.gq);
			var absenteeIds = A2(
				$elm$core$List$map,
				function ($) {
					return $.gT;
				},
				attendance.gl);
			var allStudents = $author$project$Util$List$unique(
				_Utils_ap(attendantIds, absenteeIds));
			var attendanceUnsaved = A3(
				$author$project$DailyAttendance$DailyAttendanceUnsaved,
				attendance.fq,
				newAttendants,
				A2($author$project$Util$List$subtract, allStudents, newAttendants));
			return A3($author$project$DailyAttendance$updateDailyAttendance, config.gr, attendanceUnsaved, $author$project$Element$Timetable$DailyAttendanceSaved);
		}
	});
var $author$project$Element$Timetable$update = F3(
	function (session, msg, model) {
		update:
		while (true) {
			var t_ = session.hy;
			var config = model.bN;
			var noop = A2($author$project$Application$Boundaries$save, model, session);
			var _v0 = _Utils_Tuple2(msg, model.c2);
			_v0$41:
			while (true) {
				switch (_v0.a.$) {
					case 2:
						var query = _v0.a.a;
						return A2($author$project$Element$Timetable$openCreateForm, query, noop);
					case 3:
						var query = _v0.a.a;
						return A2($author$project$Element$Timetable$openUpdateForm, query, noop);
					case 5:
						if (!_v0.b.$) {
							if ((_v0.b.a.$ === 1) && (_v0.b.a.a.$ === 1)) {
								var _v1 = _v0.a;
								var _v2 = _v0.b.a.a;
								var event = _v2.a;
								var occurence = _v2.b;
								return A3($author$project$Element$Timetable$openAttendanceForm, event, occurence, noop);
							} else {
								break _v0$41;
							}
						} else {
							var _v3 = _v0.a;
							var _v4 = _v0.b;
							return noop;
						}
					case 4:
						var occurence = _v0.a.a;
						return A2($author$project$Element$Timetable$loadDetailView, occurence, noop);
					case 6:
						if (!_v0.b.$) {
							if ((_v0.b.a.$ === 1) && (_v0.b.a.a.$ === 1)) {
								var _v5 = _v0.a;
								var _v6 = _v0.b.a.a;
								var event = _v6.a;
								var occurence = _v6.b;
								return A2(
									$author$project$Element$Timetable$openPopup,
									A2($author$project$Element$Timetable$DeleteView, event, occurence),
									noop);
							} else {
								break _v0$41;
							}
						} else {
							var _v7 = _v0.a;
							var _v8 = _v0.b;
							return noop;
						}
					case 8:
						var _v9 = _v0.a;
						return $author$project$Element$Timetable$closePopup(noop);
					case 7:
						var _v10 = _v0.a;
						var scope = _v10.a;
						var occurence = _v10.b;
						var cmd = function () {
							switch (scope) {
								case 0:
									return A3($author$project$ModuleEvent$cancelModuleEventOccurence, config.gr, occurence.gT, $author$project$Element$Timetable$ModuleEventOccurenceCanceled);
								case 1:
									return A4(
										$author$project$ModuleEvent$deleteAfterModuleEvent,
										config.gr,
										occurence.d$.gT,
										occurence.gT,
										$author$project$Element$Timetable$ModuleEventDeleted(occurence));
								default:
									return A3(
										$author$project$ModuleEvent$deleteAllModuleEvent,
										config.gr,
										occurence.d$.gT,
										$author$project$Element$Timetable$ModuleEventDeleted(occurence));
							}
						}();
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							cmd,
							$author$project$Element$Timetable$closePopup(noop));
					case 18:
						if (!_v0.a.b.$) {
							var _v12 = _v0.a;
							var occurence = _v12.a;
							var $temp$session = A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$TimetableModuleEventDeleteSuccess)),
								$temp$msg = $author$project$Element$Timetable$TimetableCalendarMsg(
								$author$project$Element$TimetableCalendar$EventDeleted(occurence)),
								$temp$model = model;
							session = $temp$session;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							var _v13 = _v0.a;
							var error = _v13.b.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventDelete,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$TimetableModuleEventDeleteError))));
						}
					case 16:
						if (!_v0.a.a.$) {
							var occurence = _v0.a.a.a;
							var $temp$session = A2(
								$author$project$Session$ok,
								session,
								session.hy($author$project$Locale$Messages$TimetableModuleEventOccurenceCancelSuccess)),
								$temp$msg = $author$project$Element$Timetable$TimetableCalendarMsg(
								$author$project$Element$TimetableCalendar$OccurenceChanged(occurence)),
								$temp$model = model;
							session = $temp$session;
							msg = $temp$msg;
							model = $temp$model;
							continue update;
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgModuleEventOccurenceSave,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$TimetableOccurenceSaveError))));
						}
					case 9:
						if (_v0.a.a.$ === 1) {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3($author$project$Log$msgModuleEventDownload, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$ModulesDownloadError))));
						} else {
							if (!_v0.b.$) {
								if ((_v0.b.a.$ === 1) && (!_v0.b.a.a.$)) {
									var event = _v0.a.a.a;
									var occurence = _v0.b.a.a.a;
									return A2(
										$author$project$Element$Timetable$openPopup,
										$author$project$Element$Timetable$DetailView(
											A2($author$project$Element$Timetable$DetailViewLoaded, event, occurence)),
										noop);
								} else {
									break _v0$41;
								}
							} else {
								var _v14 = _v0.b;
								return noop;
							}
						}
					case 11:
						if (!_v0.a.a.$) {
							var attendance = _v0.a.a.a;
							return A2($author$project$Element$Timetable$openDailyAttendanceForm, attendance, noop);
						} else {
							var error = _v0.a.a.a;
							return A2(
								$author$project$Application$Boundaries$andThenCmd,
								A3(
									$author$project$Log$error,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgDailyAttendanceDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
										error),
									$elm$core$Basics$always($author$project$Element$Timetable$NoOp)),
								A2(
									$author$project$Application$Boundaries$save,
									model,
									A3(
										$author$project$Session$error,
										session,
										error,
										t_($author$project$Locale$Messages$DailyAttendanceDownloadError))));
						}
					case 1:
						switch (_v0.a.a) {
							case 0:
								var _v15 = _v0.a.a;
								return $author$project$Element$Timetable$closePopup(noop);
							case 1:
								if (((!_v0.b.$) && (_v0.b.a.$ === 1)) && (_v0.b.a.a.$ === 1)) {
									var _v16 = _v0.a.a;
									var _v17 = _v0.b.a.a;
									var event = _v17.a;
									var occurence = _v17.b;
									return A2(
										$author$project$Element$Timetable$openPopup,
										A2($author$project$Element$Timetable$DeleteView, event, occurence),
										noop);
								} else {
									break _v0$41;
								}
							default:
								var _v18 = _v0.a.a;
								return noop;
						}
					case 10:
						var _v19 = _v0.a;
						return $author$project$Element$Timetable$closePopup(noop);
					case 12:
						if (!_v0.b.$) {
							switch (_v0.b.a.$) {
								case 2:
									var value = _v0.a.a;
									var _v20 = _v0.b.a;
									var event = _v20.a;
									var formModel = _v20.b;
									var form = formModel.bt;
									var values = formModel.ej;
									var popup = A2(
										$author$project$Element$Timetable$AttendanceFormView,
										event,
										_Utils_update(
											formModel,
											{
												bt: _Utils_update(
													form,
													{
														gq: $author$project$Form$markEdited(form.gq)
													}),
												eZ: 1,
												ej: A2(form.gq.jR, value, values)
											}));
									return A2($author$project$Element$Timetable$updatePopup, popup, noop);
								case 3:
									var value = _v0.a.a;
									var formModel = _v0.b.a.a;
									var form = formModel.bt;
									var values = formModel.ej;
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{
												bt: _Utils_update(
													form,
													{
														gq: $author$project$Form$markEdited(form.gq)
													}),
												eZ: 1,
												ej: A2(form.gq.jR, value, values)
											}));
									return A2($author$project$Element$Timetable$updatePopup, popup, noop);
								default:
									break _v0$41;
							}
						} else {
							var _v21 = _v0.b;
							return noop;
						}
					case 13:
						if (!_v0.b.$) {
							if (_v0.b.a.$ === 2) {
								var _v22 = _v0.a;
								var _v23 = _v0.b.a;
								var event = _v23.a;
								var formModel = _v23.b;
								var form = formModel.bt;
								var values = formModel.ej;
								if (A2($author$project$Element$Timetable$isAttendanceFormValid, form, values)) {
									var popup = A2(
										$author$project$Element$Timetable$AttendanceFormView,
										event,
										_Utils_update(
											formModel,
											{eZ: 2}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A2($author$project$Element$Timetable$updateAttendance, config, formModel),
										A2($author$project$Element$Timetable$updatePopup, popup, noop));
								} else {
									var popup = A2(
										$author$project$Element$Timetable$AttendanceFormView,
										event,
										_Utils_update(
											formModel,
											{
												bt: $author$project$Element$Timetable$markAttendanceFormEdited(form),
												eZ: 1
											}));
									return A2($author$project$Element$Timetable$updatePopup, popup, noop);
								}
							} else {
								break _v0$41;
							}
						} else {
							var _v24 = _v0.a;
							var _v25 = _v0.b;
							return noop;
						}
					case 14:
						if (!_v0.b.$) {
							if (_v0.b.a.$ === 3) {
								var _v26 = _v0.a;
								var formModel = _v0.b.a.a;
								var form = formModel.bt;
								var values = formModel.ej;
								if (A2($author$project$Element$Timetable$isAttendanceFormValid, form, values)) {
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{eZ: 2}));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										A2($author$project$Element$Timetable$updateAttendance, config, formModel),
										A2($author$project$Element$Timetable$updatePopup, popup, noop));
								} else {
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{
												bt: $author$project$Element$Timetable$markAttendanceFormEdited(form),
												eZ: 1
											}));
									return A2($author$project$Element$Timetable$updatePopup, popup, noop);
								}
							} else {
								break _v0$41;
							}
						} else {
							var _v27 = _v0.a;
							var _v28 = _v0.b;
							return noop;
						}
					case 15:
						if (!_v0.a.a.$) {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 3) {
									return $author$project$Element$Timetable$closePopup(
										A3(
											$author$project$Element$Timetable$update,
											A2(
												$author$project$Session$ok,
												session,
												session.hy($author$project$Locale$Messages$TimetableOccurenceSaveSuccess)),
											$author$project$Element$Timetable$TimetableCalendarMsg($author$project$Element$TimetableCalendar$EventsChanged),
											model));
								} else {
									break _v0$41;
								}
							} else {
								var _v29 = _v0.b;
								return noop;
							}
						} else {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 3) {
									var error = _v0.a.a.a;
									var formModel = _v0.b.a.a;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormSaveError));
									var popup = $author$project$Element$Timetable$DailyAttendanceFormView(
										_Utils_update(
											formModel,
											{eZ: 3}));
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgDailyAttendanceSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
											error),
										$elm$core$Basics$always($author$project$Element$Timetable$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2(
											$author$project$Element$Timetable$openPopup,
											popup,
											A2($author$project$Application$Boundaries$save, model, session2)));
								} else {
									break _v0$41;
								}
							} else {
								var _v30 = _v0.b;
								return noop;
							}
						}
					case 17:
						if (!_v0.a.a.$) {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 2) {
									var occurence = _v0.a.a.a;
									var _v31 = _v0.b.a;
									var event = _v31.a;
									return A2(
										$author$project$Element$Timetable$openPopup,
										$author$project$Element$Timetable$DetailView(
											A2($author$project$Element$Timetable$DetailViewLoaded, event, occurence)),
										A3(
											$author$project$Element$Timetable$update,
											A2(
												$author$project$Session$ok,
												session,
												session.hy($author$project$Locale$Messages$TimetableOccurenceSaveSuccess)),
											$author$project$Element$Timetable$TimetableCalendarMsg(
												$author$project$Element$TimetableCalendar$OccurenceChanged(occurence)),
											model));
								} else {
									break _v0$41;
								}
							} else {
								var _v32 = _v0.b;
								return noop;
							}
						} else {
							if (!_v0.b.$) {
								if (_v0.b.a.$ === 2) {
									var error = _v0.a.a.a;
									var _v33 = _v0.b.a;
									var event = _v33.a;
									var formModel = _v33.b;
									var session2 = A3(
										$author$project$Session$error,
										session,
										error,
										session.hy($author$project$Locale$Messages$FormSaveError));
									var popup = A2(
										$author$project$Element$Timetable$AttendanceFormView,
										event,
										_Utils_update(
											formModel,
											{eZ: 3}));
									var cmd = A3(
										$author$project$Log$error,
										config,
										_Utils_Tuple3(
											$author$project$Log$msgModuleEventOccurenceSave,
											$elm$core$Maybe$Just($author$project$Log$paramScopeTimetable),
											error),
										$elm$core$Basics$always($author$project$Element$Timetable$NoOp));
									return A2(
										$author$project$Application$Boundaries$andThenCmd,
										cmd,
										A2(
											$author$project$Element$Timetable$updatePopup,
											popup,
											A2($author$project$Application$Boundaries$save, model, session2)));
								} else {
									break _v0$41;
								}
							} else {
								var _v34 = _v0.b;
								return noop;
							}
						}
					case 19:
						var calendarMsg = _v0.a.a;
						var _v35 = model.dx;
						if (!_v35.$) {
							var calendarModel = _v35.a;
							var _return = A3($author$project$Element$Timetable$timetableCalendar.gF.jR, session, calendarMsg, calendarModel);
							var _v36 = _return.fY;
							if (!_v36.$) {
								switch (_v36.a.$) {
									case 0:
										var timeslot = _v36.a.a;
										var query = {
											gG: $elm$core$Maybe$Just(timeslot.b),
											iS: $elm$core$Maybe$Nothing,
											hu: $elm$core$Maybe$Just(timeslot.a)
										};
										return A2($author$project$Element$Timetable$openCreateForm, query, noop);
									case 1:
										var occurence = _v36.a.a;
										return A2($author$project$Element$Timetable$loadDetailView, occurence, noop);
									default:
										var date = _v36.a.a;
										return A2($author$project$Element$Timetable$downloadDailyAttendance, date, noop);
								}
							} else {
								return A3($author$project$Application$Boundaries$mapElement, model, $author$project$Element$Timetable$timetableCalendar, _return);
							}
						} else {
							return noop;
						}
					case 20:
						if ((!_v0.b.$) && (!_v0.b.a.$)) {
							var eventFormMsg = _v0.a.a;
							var eventFormModel = _v0.b.a.a;
							var _return = A5($author$project$Application$V2$Boundaries$updateElement, config.iJ, session, eventFormMsg, eventFormModel, $author$project$Element$Timetable$moduleEventForm);
							var _v37 = _return.fY;
							if (!_v37.$) {
								var reply = _v37.a;
								if (!reply) {
									return $author$project$Element$Timetable$closePopup(
										A3(
											$author$project$Element$Timetable$update,
											_return.cv,
											$author$project$Element$Timetable$TimetableCalendarMsg($author$project$Element$TimetableCalendar$EventsChanged),
											model));
								} else {
									return $author$project$Element$Timetable$closePopup(
										A2($author$project$Application$Boundaries$save, model, _return.cv));
								}
							} else {
								var moduleEventFormReturn = A3(
									$author$project$Application$V2$Boundaries$mapElement,
									A2($author$project$Application$Boundaries$save, model, session),
									$author$project$Element$Timetable$moduleEventForm,
									_return);
								return {dz: moduleEventFormReturn.dz, dY: moduleEventFormReturn.dY, fY: $elm$core$Maybe$Nothing, cv: moduleEventFormReturn.cv};
							}
						} else {
							return noop;
						}
					default:
						var _v39 = _v0.a;
						return noop;
				}
			}
			return noop;
		}
	});
var $author$project$Element$Timetable$loadCalendar = F3(
	function (people, session, model) {
		var selectPeopleInCalendar = function (people_) {
			return A3(
				$author$project$Element$Timetable$update,
				session,
				$author$project$Element$Timetable$TimetableCalendarMsg(
					$author$project$Element$TimetableCalendar$PeopleSelected(people_)),
				model);
		};
		var _return = A3(
			$author$project$Application$Boundaries$mapElement,
			model,
			$author$project$Element$Timetable$timetableCalendar,
			A4($author$project$Application$Boundaries$initElement, model.bN, session, $author$project$Element$Timetable$timetableCalendar, people));
		return A2(
			$elm$core$Maybe$withDefault,
			_return,
			A2(
				$elm$core$Maybe$map,
				$elm$core$Basics$always(
					selectPeopleInCalendar(people)),
				model.dx));
	});
var $author$project$Element$Timetable$init = F3(
	function (config, session, params) {
		var model = {dx: $elm$core$Maybe$Nothing, bN: config, g9: $elm$core$Maybe$Nothing, c2: $elm$core$Maybe$Nothing};
		switch (params.$) {
			case 0:
				var people = params.a;
				return A3($author$project$Element$Timetable$loadCalendar, people, session, model);
			case 1:
				var query = params.a;
				return A2(
					$author$project$Element$Timetable$openCreateForm,
					query,
					A3($author$project$Element$Timetable$loadCalendar, _List_Nil, session, model));
			default:
				var query = params.a;
				return A2(
					$author$project$Element$Timetable$openUpdateForm,
					query,
					A3($author$project$Element$Timetable$loadCalendar, _List_Nil, session, model));
		}
	});
var $author$project$Element$Timetable$KeyEvent = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TimetableCalendar$anyEventsLoading = F3(
	function (viewState, filter, eventStore) {
		return A2(
			$elm$core$List$any,
			A2($author$project$Element$TimetableCalendar$personHasMissingEvents, viewState, eventStore),
			filter.mw);
	});
var $author$project$Element$TimetableCalendar$isBusy = F2(
	function (viewer, _v0) {
		var filter = _v0.bO;
		var viewState = _v0.$7;
		var eventStore = _v0.a3;
		var people = _v0.mw;
		var isLoaded = function () {
			var _v1 = _Utils_Tuple2(
				$author$project$ACL$canViewTimetablesOther(viewer),
				people);
			if (_v1.a) {
				if (!_v1.b.$) {
					return true;
				} else {
					return false;
				}
			} else {
				return true;
			}
		}();
		return isLoaded && A3($author$project$Element$TimetableCalendar$anyEventsLoading, viewState, filter, eventStore);
	});
var $author$project$KeyEvents$Delete = 1;
var $author$project$KeyEvents$Escape = 0;
var $author$project$KeyEvents$Other = 2;
var $author$project$KeyEvents$keyDecoder = F2(
	function (isPreventDefaultOn, toMsg) {
		return A2(
			$elm$json$Json$Decode$map,
			function (key) {
				switch (key) {
					case 'Delete':
						return _Utils_Tuple2(
							toMsg(1),
							isPreventDefaultOn);
					case 'Backspace':
						return _Utils_Tuple2(
							toMsg(1),
							isPreventDefaultOn);
					case 'Escape':
						return _Utils_Tuple2(
							toMsg(0),
							isPreventDefaultOn);
					default:
						return _Utils_Tuple2(
							toMsg(2),
							isPreventDefaultOn);
				}
			},
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
	});
var $author$project$KeyEvents$onKeyDown = function (toMsg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'keydown',
		A2($author$project$KeyEvents$keyDecoder, false, toMsg));
};
var $elm$html$Html$Attributes$tabindex = function (n) {
	return A2(
		_VirtualDom_attribute,
		'tabIndex',
		$elm$core$String$fromInt(n));
};
var $author$project$Element$Timetable$AttendanceFormSubmitted = {$: 13};
var $author$project$Element$Timetable$DailyAttendanceFormSubmitted = {$: 14};
var $author$project$Element$Timetable$OccurenceDetailViewSelected = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$Timetable$PopupClosed = {$: 10};
var $author$project$UI$modalDialog = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('modal is-active')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-background')
					]),
				_List_Nil),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('modal-content')
					]),
				_List_fromArray(
					[content]))
			]));
};
var $author$project$Element$Timetable$resetAttendanceForm = function (data) {
	if (!data.$) {
		var occurence = data.a;
		return $author$project$Element$Timetable$OccurenceDetailViewSelected(occurence);
	} else {
		var attendance = data.a;
		return $author$project$Element$Timetable$DailyAttendanceDownloaded(
			$elm$core$Result$Ok(attendance));
	}
};
var $author$project$Locale$Messages$DailyAttendanceFormInstructions = {$: 50};
var $author$project$Locale$Messages$DailyAttendanceFormTitle = {$: 49};
var $author$project$Element$Timetable$viewDailyAttendanceMeta = F2(
	function (t_, attendance) {
		var viewTime = A2(
			$author$project$UI$caption,
			t_,
			A2(
				$author$project$Locale$Messages$TimeDateFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(attendance.fq)));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title is-6 mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							t_($author$project$Locale$Messages$DailyAttendanceFormTitle))
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-7 inline-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewTime]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(
							t_($author$project$Locale$Messages$DailyAttendanceFormInstructions))
						]))
				]));
	});
var $author$project$Locale$Messages$TimeDateTimeRangeFormat = F3(
	function (a, b, c) {
		return {$: 631, a: a, b: b, c: c};
	});
var $author$project$Element$Timetable$viewOccurenceMeta = F2(
	function (t_, occ) {
		var viewTime = A2(
			$author$project$UI$caption,
			t_,
			A3(
				$author$project$Locale$Messages$TimeDateTimeRangeFormat,
				$elm$time$Time$utc,
				$elm$time$Time$millisToPosix(occ.M),
				$elm$time$Time$millisToPosix(occ.C)));
		var viewModuleLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$ModulesDetail(
						$author$project$Module$moduleIdToInt(occ.fK.gT)))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$module_(_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(occ.fK.jJ)
						]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('block')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h1,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('title is-6 mb-1')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(occ.d$.jJ)
						])),
					A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-size-7 inline-list')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewTime])),
							A2(
							$elm$html$Html$li,
							_List_Nil,
							_List_fromArray(
								[viewModuleLink]))
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text(occ.d$.aO)
						]))
				]));
	});
var $author$project$Element$Timetable$viewAttendanceForm = F2(
	function (t_, _v0) {
		var state = _v0.eZ;
		var form = _v0.bt;
		var values = _v0.ej;
		var dataSource = _v0.ex;
		var submitForm_ = function () {
			if (!dataSource.$) {
				return $author$project$Element$Timetable$AttendanceFormSubmitted;
			} else {
				return $author$project$Element$Timetable$DailyAttendanceFormSubmitted;
			}
		}();
		var viewForm_ = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container')
				]),
			_List_fromArray(
				[
					$author$project$UI$columns(
					_List_fromArray(
						[
							A3($author$project$UI$checkboxField, t_, form.gq, values)
						])),
					A5(
					$author$project$UI$formButtons,
					t_,
					$author$project$Form$Update(dataSource),
					state,
					submitForm_,
					$author$project$Element$Timetable$resetAttendanceForm)
				]));
		if (!dataSource.$) {
			var occurence = dataSource.a;
			return $author$project$UI$modalDialog(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$UI$mediaObject,
							_List_fromArray(
								[
									$author$project$UI$gravatar(occurence.fK.j3.K)
								]),
							_List_fromArray(
								[
									A2($author$project$Element$Timetable$viewOccurenceMeta, t_, occurence),
									viewForm_
								]),
							_List_Nil,
							_List_fromArray(
								[
									$author$project$UI$closeButton(
									$author$project$Element$Timetable$OccurenceDetailViewSelected(occurence))
								]))
						])));
		} else {
			var attendance = dataSource.a;
			return $author$project$UI$modalDialog(
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('box')
						]),
					_List_fromArray(
						[
							A4(
							$author$project$UI$mediaObject,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$Element$Timetable$viewDailyAttendanceMeta, t_, attendance),
									viewForm_
								]),
							_List_Nil,
							_List_fromArray(
								[
									$author$project$UI$closeButton($author$project$Element$Timetable$PopupClosed)
								]))
						])));
		}
	});
var $author$project$Element$Timetable$DeleteThis = 0;
var $author$project$Element$Timetable$ModuleEventDeleteConfirmed = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Element$Timetable$ModuleEventDeleteDeclined = {$: 8};
var $author$project$Locale$Messages$TimetableActionModuleEventDelete = {$: 642};
var $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence = {$: 644};
var $author$project$Locale$Messages$TimetableModuleEventNonRecurringDeleteHelp = {$: 659};
var $author$project$Element$Timetable$viewNonRecurringDeleteDialog = F2(
	function (t_, occurence) {
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableActionModuleEventDelete)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$Timetable$ModuleEventDeleteDeclined)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventNonRecurringDeleteHelp)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 0, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence)
						]))
				]));
	});
var $author$project$Locale$Messages$TimetableAttendanceAbsents = {$: 655};
var $author$project$Element$Timetable$viewAttendanceSheet = F2(
	function (t_, occ) {
		var viewPersonName = function (person) {
			return A2(
				$elm$html$Html$li,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2($author$project$Person$fullName, t_, person))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(occ.gq),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableAttendanceParticipants)
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								A2($elm$core$List$map, viewPersonName, occ.gq))
							]))),
					A2(
					$author$project$UI$when,
					!$elm$core$List$isEmpty(occ.gl),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('block')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableAttendanceAbsents)
									])),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('is-size-6')
									]),
								A2($elm$core$List$map, viewPersonName, occ.gl))
							])))
				]));
	});
var $author$project$Element$Timetable$ModuleEventDeleteRequested = {$: 6};
var $author$project$Element$Timetable$OccurenceAttendanceSelected = {$: 5};
var $author$project$Locale$Messages$TimetableActionAttendanceEdit = {$: 640};
var $author$project$Locale$Messages$TimetableActionModuleEventEdit = {$: 641};
var $author$project$Locale$Messages$TimetableGoogleMeet = {$: 639};
var $author$project$UI$navHorizontal = F2(
	function (left, right) {
		return A3($author$project$UI$nav_, true, left, right);
	});
var $author$project$Element$Timetable$viewNavLinks = F3(
	function (t_, viewer, occ) {
		var viewConferenceLink = function (url) {
			return A2(
				$elm$html$Html$a,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$href(url),
						$elm$html$Html$Attributes$target('_blank')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$google(
						_List_fromArray(
							[
								$author$project$UI$Icon$style('has-text-link-dark')
							])),
						A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableGoogleMeet)
							]))
					]));
		};
		var leftLinks = _List_fromArray(
			[
				A2($author$project$UI$maybe, occ.kC, viewConferenceLink)
			]);
		var isEmptyUI = A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				$elm$core$Basics$neq($author$project$UI$none)),
			$elm$core$List$isEmpty);
		var editRoute = $author$project$Route$TimetableUpdateEvent(
			{
				im: $author$project$ModuleEvent$moduleEventIdToInt(occ.d$.gT),
				he: $author$project$ModuleEvent$moduleEventOccurenceIdToInt(occ.gT)
			});
		var editEventLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(editRoute),
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionModuleEventEdit))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$edit(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-link')
						]))
				]));
		var editAttendanceLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$Timetable$OccurenceAttendanceSelected,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionAttendanceEdit))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$profile(
					_List_fromArray(
						[
							$author$project$UI$Icon$style('has-text-info')
						]))
				]));
		var deleteEventLink = A3(
			$author$project$UI$actionLink,
			$author$project$Element$Timetable$ModuleEventDeleteRequested,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$title(
					t_($author$project$Locale$Messages$TimetableActionModuleEventDelete))
				]),
			_List_fromArray(
				[
					$author$project$UI$Icon$delete(_List_Nil)
				]));
		var rightLinks = $author$project$ACL$canManageTimetable(viewer) ? _List_fromArray(
			[editAttendanceLink, editEventLink, deleteEventLink]) : _List_Nil;
		return isEmptyUI(
			_Utils_ap(leftLinks, rightLinks)) ? $author$project$UI$none : A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('my-2')
						]),
					_List_Nil),
					A2($author$project$UI$navHorizontal, leftLinks, rightLinks)
				]));
	});
var $author$project$Element$Timetable$viewOccurence = F2(
	function (_v0, occ) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		return $author$project$UI$modalDialog(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('box'),
						$author$project$UI$attrCyData('timetable-detail')
					]),
				_List_fromArray(
					[
						A4(
						$author$project$UI$mediaObject,
						_List_fromArray(
							[
								$author$project$UI$gravatar(occ.fK.j3.K)
							]),
						_List_fromArray(
							[
								A2($author$project$Element$Timetable$viewOccurenceMeta, t_, occ),
								A2($author$project$Element$Timetable$viewAttendanceSheet, t_, occ)
							]),
						_List_fromArray(
							[
								A3($author$project$Element$Timetable$viewNavLinks, t_, viewer, occ)
							]),
						_List_fromArray(
							[
								$author$project$UI$closeButton($author$project$Element$Timetable$PopupClosed)
							]))
					])));
	});
var $author$project$Element$Timetable$DeleteAll = 2;
var $author$project$Element$Timetable$DeleteThisAndFuture = 1;
var $author$project$Locale$Messages$TimetableBtnDeleteAllOccurences = {$: 643};
var $author$project$Locale$Messages$TimetableBtnDeleteThisAndFutureOccurences = {$: 645};
var $author$project$Locale$Messages$TimetableModuleEventRecurringDeleteHelp = {$: 658};
var $author$project$Element$Timetable$viewRecurringDeleteDialog = F2(
	function (t_, occurence) {
		return A4(
			$author$project$UI$modalPanel,
			_List_fromArray(
				[
					A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableActionModuleEventDelete)
				]),
			_List_fromArray(
				[
					$author$project$UI$closeButton($author$project$Element$Timetable$ModuleEventDeleteDeclined)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('content')
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableModuleEventRecurringDeleteHelp)
						]))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 0, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisOccurence)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-grey'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 1, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteThisAndFutureOccurences)
						])),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('button is-danger'),
							$elm$html$Html$Events$onClick(
							A2($author$project$Element$Timetable$ModuleEventDeleteConfirmed, 2, occurence))
						]),
					_List_fromArray(
						[
							A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TimetableBtnDeleteAllOccurences)
						]))
				]));
	});
var $author$project$Element$Timetable$view = F2(
	function (session, _v0) {
		var t_ = session.hy;
		var viewer = session.nH;
		var calendar = _v0.dx;
		var popup = _v0.c2;
		var viewProgressBar = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('is-overlay is-extra-small')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$progress,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('progress is-extra-small')
						]),
					_List_Nil)
				]));
		var viewModuleEventForm = function (formModel) {
			return A3($author$project$Application$V2$Boundaries$viewElement, session, formModel, $author$project$Element$Timetable$moduleEventForm);
		};
		var viewClosablePanel = function (content) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id('timetable-popup'),
						$author$project$KeyEvents$onKeyDown($author$project$Element$Timetable$KeyEvent),
						$elm$html$Html$Attributes$tabindex(0)
					]),
				content);
		};
		var viewCalendar = function (calendarModel) {
			return A2(
				$elm$html$Html$map,
				$author$project$Element$Timetable$timetableCalendar.iV,
				A2($author$project$Element$Timetable$timetableCalendar.gF.nE, session, calendarModel));
		};
		if (!calendar.$) {
			var calendarModel = calendar.a;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('is-relative pt-3')
					]),
				_List_fromArray(
					[
						viewCalendar(calendarModel),
						A2(
						$author$project$UI$when,
						A2($author$project$Element$TimetableCalendar$isBusy, viewer, calendarModel),
						viewProgressBar),
						function () {
						if (popup.$ === 1) {
							return $author$project$UI$none;
						} else {
							switch (popup.a.$) {
								case 1:
									if (popup.a.a.$ === 1) {
										var _v3 = popup.a.a;
										var occurence = _v3.b;
										return viewClosablePanel(
											_List_fromArray(
												[
													A2($author$project$Element$Timetable$viewOccurence, session, occurence)
												]));
									} else {
										return viewProgressBar;
									}
								case 4:
									var _v4 = popup.a;
									var event = _v4.a;
									var occurence = _v4.b;
									return $author$project$ModuleEvent$isRecurring(event) ? viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewRecurringDeleteDialog, t_, occurence)
											])) : viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewNonRecurringDeleteDialog, t_, occurence)
											]));
								case 2:
									var _v5 = popup.a;
									var formModel = _v5.b;
									return viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewAttendanceForm, t_, formModel)
											]));
								case 3:
									var formModel = popup.a.a;
									return viewClosablePanel(
										_List_fromArray(
											[
												A2($author$project$Element$Timetable$viewAttendanceForm, t_, formModel)
											]));
								default:
									var formModel = popup.a.a;
									return viewClosablePanel(
										_List_fromArray(
											[
												viewModuleEventForm(formModel)
											]));
							}
						}
					}()
					]));
		} else {
			return A2(
				$author$project$UI$progressBar,
				'is-info',
				t_($author$project$Locale$Messages$TimetableLoadingProgress));
		}
	});
var $author$project$Element$Timetable$element = {iA: $author$project$Element$Timetable$init, jR: $author$project$Element$Timetable$update, nE: $author$project$Element$Timetable$view};
var $author$project$Element$TrimesterFeedbackReport$GradeReportListDownloaded = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$NotFoundPage = {$: 4};
var $author$project$Element$TrimesterFeedbackReport$SubjectListDownloaded = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackReportsDownloaded = function (a) {
	return {$: 7, a: a};
};
var $author$project$GradeReport$fetchGradeReportsByPerson = F3(
	function (config, personId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$gradeReportsByPerson, config, personId),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$GradeReport$gradeReportsDecoder));
	});
var $author$project$Api$Endpoint$trimesterFeedbackList = F2(
	function (config, studentId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				['v2', 'trimester-feedback']),
			_List_fromArray(
				[
					_Utils_Tuple2(
					'student',
					$elm$core$String$fromInt(studentId))
				]));
	});
var $author$project$TrimesterFeedback$TrimesterFeedbackReport = function (id) {
	return function (startYear) {
		return function (trimester) {
			return function (startDate) {
				return function (endDate) {
					return function (adminStartDate) {
						return function (adminEndDate) {
							return function (student) {
								return function (url) {
									return function (trimesterFeedback) {
										return function (isDisabled) {
											return function (isInCurrentTrimester) {
												return function (isInCurrentSchoolYear) {
													return {kb: adminEndDate, kc: adminStartDate, gH: endDate, gT: id, lr: isDisabled, iG: isInCurrentSchoolYear, lt: isInCurrentTrimester, hv: startDate, d9: startYear, ne: student, jP: trimester, hG: trimesterFeedback, G: url};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TrimesterFeedback$TrimesterFeedback = F6(
	function (id, description, feedback, createdBy, createdAt, report) {
		return {gz: createdAt, kG: createdBy, gD: description, gJ: feedback, gT: id, eV: report};
	});
var $author$project$TrimesterFeedback$trimesterFeedbackDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'report',
	$elm$json$Json$Decode$int,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'created_at',
		$elm$json$Json$Decode$int,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'created_by',
			$author$project$Person$nestedPersonDecoder,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'feedback',
				$elm$json$Json$Decode$nullable($author$project$Rubric$rubricAssessmentDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'description',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$int,
						$elm$json$Json$Decode$succeed($author$project$TrimesterFeedback$TrimesterFeedback)))))));
var $author$project$TrimesterFeedback$trimesterFeedbackReportDecoder = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'is_in_current_school_year',
	$elm$json$Json$Decode$bool,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'is_in_current_trimester',
		$elm$json$Json$Decode$bool,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'is_disabled',
			$elm$json$Json$Decode$bool,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'trimester_feedback',
				$elm$json$Json$Decode$nullable($author$project$TrimesterFeedback$trimesterFeedbackDecoder),
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'url',
					$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'student',
						$author$project$Person$nestedPersonDecoder,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'admin_end_date',
							$elm$json$Json$Decode$int,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'admin_start_date',
								$elm$json$Json$Decode$int,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'end_date',
									$elm$json$Json$Decode$int,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'start_date',
										$elm$json$Json$Decode$int,
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'trimester',
											$elm$json$Json$Decode$int,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'school_year_start_year',
												$elm$json$Json$Decode$int,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'id',
													$elm$json$Json$Decode$int,
													$elm$json$Json$Decode$succeed($author$project$TrimesterFeedback$TrimesterFeedbackReport))))))))))))));
var $author$project$TrimesterFeedback$trimesterFeedbackReportListDecoder = $elm$json$Json$Decode$list($author$project$TrimesterFeedback$trimesterFeedbackReportDecoder);
var $author$project$TrimesterFeedback$fetchTrimesterFeedbackReports = F3(
	function (config, studentId, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$trimesterFeedbackList, config, studentId),
			config,
			A2(
				$author$project$Api$expectJson,
				A2($elm$core$Basics$composeR, $author$project$RemoteData$fromResult, callback),
				$author$project$TrimesterFeedback$trimesterFeedbackReportListDecoder));
	});
var $author$project$Element$TrimesterFeedbackReport$init = F3(
	function (config, session, params) {
		var studentId = params.jz;
		var model = {
			bN: config,
			dB: $elm$core$String$length(session.nH.k3),
			dN: $elm$core$Maybe$Nothing,
			bm: $author$project$Element$TrimesterFeedbackReport$NotFoundPage,
			bU: $author$project$RemoteData$NotAsked,
			d4: $author$project$RemoteData$NotAsked,
			jz: params.jz,
			jB: $author$project$RemoteData$NotAsked,
			dl: $elm$core$Maybe$Nothing
		};
		var cmd = $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					A3($author$project$TrimesterFeedback$fetchTrimesterFeedbackReports, config.gr, studentId, $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackReportsDownloaded),
					A3($author$project$GradeReport$fetchGradeReportsByPerson, config.gr, studentId, $author$project$Element$TrimesterFeedbackReport$GradeReportListDownloaded),
					A2($author$project$Subject$fetchSubjects, config.gr, $author$project$Element$TrimesterFeedbackReport$SubjectListDownloaded)
				]));
		return A2(
			$author$project$Application$Boundaries$andThenCmd,
			cmd,
			A2($author$project$Application$Boundaries$save, model, session));
	});
var $author$project$Element$TrimesterFeedbackReport$NoOp = {$: 10};
var $author$project$Locale$Messages$TrimesterFeedbackDeleteError = {$: 691};
var $author$project$Locale$Messages$TrimesterFeedbackDeleteSuccess = {$: 687};
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleted = function (a) {
	return {$: 9, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadError = {$: 679};
var $author$project$Element$TrimesterFeedbackReport$PortfolioStoriesDownloaded = function (a) {
	return {$: 5, a: a};
};
var $author$project$Api$Endpoint$pageSizeNoPaging = -1;
var $author$project$Element$TrimesterFeedbackReport$asListParams = F2(
	function (studentId, report) {
		return {
			bs: '',
			gx: $elm$core$Maybe$Nothing,
			gG: $elm$core$Maybe$Just(report.kb),
			cS: $elm$core$Maybe$Nothing,
			g9: $elm$core$Maybe$Nothing,
			bw: '',
			de: $author$project$Api$Endpoint$pageSizeNoPaging,
			hu: $elm$core$Maybe$Just(report.kc),
			e1: $elm$core$Maybe$Just(
				_List_fromArray(
					[studentId])),
			e5: $elm$core$Maybe$Nothing,
			hH: $author$project$Api$Endpoint$typeMClosure
		};
	});
var $author$project$PortfolioStory$fetchStories_ = F3(
	function (config, params, callback) {
		return A3(
			$author$project$Api$get,
			A2($author$project$Api$Endpoint$portfolioStoriesList, config, params),
			config,
			A2($author$project$Api$expectJson, callback, $author$project$PortfolioStory$portfolioStoriesDecoder));
	});
var $author$project$Element$TrimesterFeedbackReport$pageToReport = function (page) {
	switch (page.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		case 2:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		case 3:
			var report = page.a;
			return $elm$core$Maybe$Just(report);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures = function (_return) {
	var model = _return.dY;
	var model2 = _Utils_update(
		model,
		{bU: $author$project$RemoteData$Loading});
	var fetchParams = function (report) {
		return A2($author$project$Element$TrimesterFeedbackReport$asListParams, model.jz, report);
	};
	var fetch = function (report) {
		return A3(
			$author$project$PortfolioStory$fetchStories_,
			model.bN.gr,
			fetchParams(report),
			$author$project$Element$TrimesterFeedbackReport$PortfolioStoriesDownloaded);
	};
	return A2(
		$elm$core$Maybe$withDefault,
		A2($author$project$Application$Boundaries$save, model, _return.cv),
		A2(
			$elm$core$Maybe$map,
			function (report) {
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					fetch(report),
					A2($author$project$Application$Boundaries$save, model2, _return.cv));
			},
			$author$project$Element$TrimesterFeedbackReport$pageToReport(model.bm)));
};
var $author$project$Element$TrimesterFeedbackReport$PreviousYearsTab = 0;
var $author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage = {$: 0};
var $author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$findReportByTrimester = F2(
	function (reports, trimester) {
		return A2(
			$author$project$Util$List$find,
			function (r) {
				return r.iG && _Utils_eq(trimester, r.jP);
			},
			reports);
	});
var $author$project$Element$TrimesterFeedbackReport$switchTab = F2(
	function (reports, tab) {
		switch (tab) {
			case 1:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 1)));
			case 2:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 2)));
			case 3:
				return A2(
					$elm$core$Maybe$withDefault,
					$author$project$Element$TrimesterFeedbackReport$NotFoundPage,
					A2(
						$elm$core$Maybe$map,
						$author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage,
						A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, 3)));
			case 0:
				return $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage;
			default:
				return $author$project$Element$TrimesterFeedbackReport$NotFoundPage;
		}
	});
var $author$project$Element$TrimesterFeedbackReport$FirstTrimesterTab = 1;
var $author$project$Element$TrimesterFeedbackReport$SecondTrimesterTab = 2;
var $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterTab = 3;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{W: nodeList, R: nodeListSize, V: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Element$TrimesterFeedbackReport$tabs = $elm$core$Array$fromList(
	_List_fromArray(
		[0, 1, 2, 3]));
var $author$project$Element$TrimesterFeedbackReport$andThenInitPage = F2(
	function (reports, _return) {
		var model = _return.dY;
		var currentReport = A2(
			$author$project$Util$List$find,
			function ($) {
				return $.lt;
			},
			reports);
		var currentTab = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2(
				$elm$core$Array$get,
				A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.jP;
						},
						currentReport)),
				$author$project$Element$TrimesterFeedbackReport$tabs));
		var page = A2($author$project$Element$TrimesterFeedbackReport$switchTab, reports, currentTab);
		var model2 = _Utils_update(
			model,
			{
				bm: page,
				d4: $author$project$RemoteData$Success(reports)
			});
		return A2($author$project$Application$Boundaries$save, model2, _return.cv);
	});
var $author$project$Element$TrimesterFeedbackReport$PortfolioSingleElementMsg = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Element$TrimesterFeedbackReport$portfolioSingle = function (storyId) {
	return {
		gF: $author$project$Element$PortfolioSingle$element,
		bZ: $author$project$Element$TrimesterFeedbackReport$PortfolioSingleElementMsg(storyId),
		jS: F2(
			function (containerModel, model) {
				var portfolioSinglesModel2 = A2(
					$author$project$RemoteData$map,
					A2(
						$elm$core$Dict$update,
						storyId,
						$elm$core$Basics$always(
							$elm$core$Maybe$Just(model))),
					containerModel.bU);
				return _Utils_update(
					containerModel,
					{bU: portfolioSinglesModel2});
			})
	};
};
var $author$project$Element$TrimesterFeedbackReport$andThenInitPortfolioSingleElements = F2(
	function (stories, _return) {
		var returnNoReply = function (return_) {
			return {dz: return_.dz, dY: return_.dY, fY: $elm$core$Maybe$Nothing, cv: return_.cv};
		};
		return returnNoReply(
			A3(
				$elm$core$List$foldl,
				F2(
					function (story, return_) {
						var model = return_.dY;
						var singleElement = $author$project$Element$TrimesterFeedbackReport$portfolioSingle(story.gT);
						var params = {
							jB: model.jB,
							nG: $author$project$Element$PortfolioSingle$ListItem(story)
						};
						var elementReturn = A5(
							$author$project$Application$V2$Boundaries$initElement,
							model.bN.iJ,
							$author$project$Application$V2$SharedConfig$fromV1(model.bN),
							return_.cv,
							singleElement,
							params);
						var return2 = returnNoReply(
							A3($author$project$Application$V2$Boundaries$mapElement, return_, singleElement, elementReturn));
						return return2;
					}),
				_return,
				stories));
	});
var $author$project$Api$Endpoint$trimesterFeedbackDelete = F2(
	function (config, feedbackId) {
		return A3(
			$author$project$Api$Endpoint$endpoint,
			config,
			_List_fromArray(
				[
					'v2',
					'trimester-feedback',
					$elm$core$String$fromInt(feedbackId)
				]),
			_List_Nil);
	});
var $author$project$TrimesterFeedback$deleteTrimesterFeedback = F3(
	function (config, feedback, callback) {
		return A3(
			$author$project$Api$delete,
			A2($author$project$Api$Endpoint$trimesterFeedbackDelete, config, feedback.eV),
			config,
			callback);
	});
var $author$project$Element$TrimesterFeedbackReport$mapTrimesterPage = F2(
	function (func, page) {
		switch (page.$) {
			case 0:
				return $author$project$Element$TrimesterFeedbackReport$PreviousYearsPage;
			case 1:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$FirstTrimesterPage(
					func(report));
			case 2:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$SecondTrimesterPage(
					func(report));
			case 3:
				var report = page.a;
				return $author$project$Element$TrimesterFeedbackReport$ThirdTrimesterPage(
					func(report));
			default:
				return $author$project$Element$TrimesterFeedbackReport$NotFoundPage;
		}
	});
var $author$project$Log$msgTrimesterFeedbackDelete = 'trimester_feedback_delete';
var $author$project$Log$msgTrimesterFeedbackDownload = 'trimester_feedback_download';
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$Cmd = function (a) {
	return {$: 2, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FetchRubrics = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListDownloaded = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$FormMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$TextFeedback = $elm$core$Basics$identity;
var $author$project$Locale$Messages$TrimesterFeedbackFormTextFeedback = function (a) {
	return {$: 667, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$buildForm = F2(
	function (t_, student) {
		var studentName = A2($author$project$Person$fullName, t_, student);
		return {
			a0: {
				kU: false,
				mu: $author$project$Form$requiredRubricTextFeedback(t_),
				mK: true,
				jR: F2(
					function (value, values) {
						return _Utils_update(
							values,
							{a0: value});
					}),
				nD: function ($) {
					return $.a0;
				},
				nE: {
					kJ: 'trimester-text-feedback',
					lO: '',
					aT: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$FormMsg, $elm$core$Basics$identity),
					bv: t_(
						$author$project$Locale$Messages$TrimesterFeedbackFormTextFeedback(studentName))
				}
			}
		};
	});
var $author$project$Element$TrimesterFeedbackForm$emptyForm = {a0: ''};
var $author$project$Element$TrimesterFeedbackForm$tagTrimesterClosing = 'trimester-closing';
var $author$project$Element$TrimesterFeedbackForm$init = F3(
	function (config, session, params) {
		var t_ = session.hy;
		var model = {
			bN: config,
			cJ: $elm$core$Maybe$Nothing,
			bt: A2($author$project$Element$TrimesterFeedbackForm$buildForm, t_, params.eV.ne),
			eD: 0,
			c2: $elm$core$Maybe$Nothing,
			eS: $elm$core$Maybe$Nothing,
			d5: $elm$core$Maybe$Nothing,
			dd: $elm$core$Maybe$Nothing,
			cv: session,
			f6: false,
			jB: params.jB,
			eh: params.eV,
			ej: $author$project$Element$TrimesterFeedbackForm$emptyForm
		};
		var defaultParams = $author$project$Rubric$defaultListParams;
		var listParams = _Utils_update(
			defaultParams,
			{
				e1: $elm$core$Maybe$Just(
					_List_fromArray(
						[params.eV.ne.gT])),
				jE: $elm$core$Maybe$Just(
					_List_fromArray(
						[$author$project$Element$TrimesterFeedbackForm$tagTrimesterClosing]))
			});
		return _Utils_Tuple3(
			model,
			$author$project$Element$TrimesterFeedbackForm$Cmd(
				$author$project$Element$TrimesterFeedbackForm$FetchRubrics(
					A3($author$project$Rubric$fetchRubricsV2, config.gr, listParams, $author$project$Element$TrimesterFeedbackForm$RubricsListDownloaded))),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$RubricAssessmentEffect = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricAssessmentMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment = {
	gF: $author$project$Element$RubricAssessment$element,
	jK: $author$project$Element$TrimesterFeedbackForm$RubricAssessmentEffect,
	bZ: $author$project$Element$TrimesterFeedbackForm$RubricAssessmentMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					d5: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$TrimesterFeedbackForm$PopupMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormEffect = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormModel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsFormMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListEffect = function (a) {
	return {$: 5, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListModel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$RubricsListMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$popups = {
	c8: {
		gF: $author$project$Element$RubricsForm$element,
		jK: $author$project$Element$TrimesterFeedbackForm$RubricsFormEffect,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsFormMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c2: $elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$RubricsFormModel(model))
					});
			})
	},
	da: {
		gF: $author$project$Element$RubricsList$element,
		jK: $author$project$Element$TrimesterFeedbackForm$RubricsListEffect,
		bZ: A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsListMsg),
		jS: F2(
			function (containerModel, model) {
				return _Utils_update(
					containerModel,
					{
						c2: $elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$RubricsListModel(model))
					});
			})
	}
};
var $author$project$Element$TrimesterFeedbackForm$perform = F2(
	function (key, effect) {
		switch (effect.$) {
			case 0:
				return $elm$core$Platform$Cmd$none;
			case 1:
				var effects = effect.a;
				return $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						$author$project$Element$TrimesterFeedbackForm$perform(key),
						effects));
			case 2:
				var cmd = effect.a;
				switch (cmd.$) {
					case 0:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					case 1:
						var request = cmd.a;
						return $author$project$Api$getV2(request);
					case 2:
						return $author$project$Ports$scrollToFormError;
					case 3:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
					default:
						var request = cmd.a;
						return $author$project$Api$postV2(request);
				}
			case 3:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment);
			case 4:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$popups.c8);
			default:
				var elementEffect = effect.a;
				return A3($author$project$Application$V3$Boundaries$performElement, key, elementEffect, $author$project$Element$TrimesterFeedbackForm$popups.da);
		}
	});
var $author$project$Element$TrimesterFeedbackForm$BatchEffect = function (a) {
	return {$: 1, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$Exit = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$LogError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$LogOk = function (a) {
	return {$: 4, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$NoEffect = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$NoOp = {$: 0};
var $author$project$Element$TrimesterFeedbackForm$Saved = function (a) {
	return {$: 1, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackFormSaveError = {$: 672};
var $author$project$Locale$Messages$TrimesterFeedbackFormSaveSuccess = {$: 671};
var $author$project$Log$msgTrimesterFeedbackSave = 'trimester_feedback_save';
var $author$project$Element$TrimesterFeedbackForm$openRubricsListPopup = F2(
	function (model, effect) {
		var session = model.cv;
		var selected = function () {
			var _v1 = _Utils_Tuple2(model.dd, model.eS);
			_v1$2:
			while (true) {
				if (!_v1.a.$) {
					if (!_v1.b.$) {
						var rubric_ = _v1.a.a;
						return _List_fromArray(
							[rubric_]);
					} else {
						break _v1$2;
					}
				} else {
					if (!_v1.b.$) {
						var _v2 = _v1.a;
						var rubrics_ = _v1.b.a;
						return rubrics_;
					} else {
						break _v1$2;
					}
				}
			}
			return _List_Nil;
		}();
		var params = $author$project$Element$RubricsList$Selector(selected);
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model,
			$author$project$Element$TrimesterFeedbackForm$popups.da,
			A4($author$project$Application$V3$Boundaries$initElement, model.bN, session, $author$project$Element$TrimesterFeedbackForm$popups.da, params));
		var model2 = _v0.a;
		var effect2 = _v0.b;
		return _Utils_Tuple3(
			model2,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[effect2, effect])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Log$paramScopeTrimesterFeedbackForm = 'scope_trimester_feedback_form';
var $author$project$Element$TrimesterFeedbackForm$CreateTrimesterFeedback = function (a) {
	return {$: 0, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$ScrollToFormError = {$: 2};
var $author$project$Element$TrimesterFeedbackForm$TrimesterFeedbackSaved = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Api$Endpoint$trimesterFeedbackCreate = function (config) {
	return A3(
		$author$project$Api$Endpoint$endpoint,
		config,
		_List_fromArray(
			['v2', 'trimester-feedback']),
		_List_Nil);
};
var $author$project$TrimesterFeedback$trimesterFeedbackEncoder = function (tf) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(tf.gD)),
				_Utils_Tuple2(
				'report',
				$elm$json$Json$Encode$int(tf.eV)),
				_Utils_Tuple2(
				'feedback',
				A2(
					$elm$core$Maybe$withDefault,
					$elm$json$Json$Encode$null,
					A2($elm$core$Maybe$map, $author$project$Rubric$rubricAssessmentEncoder, tf.gJ)))
			]));
};
var $author$project$TrimesterFeedback$createTrimesterFeedbackV2 = F3(
	function (config, tf, callback) {
		return {
			O: $author$project$TrimesterFeedback$trimesterFeedbackEncoder(tf),
			bN: config,
			dC: $author$project$TrimesterFeedback$trimesterFeedbackDecoder,
			bZ: callback,
			G: $author$project$Api$Endpoint$trimesterFeedbackCreate(config.gr)
		};
	});
var $author$project$Element$TrimesterFeedbackForm$isFormValid = F2(
	function (form, values) {
		return A2($author$project$Form$isFieldValid, form.a0, values);
	});
var $author$project$Log$msgTrimesterFeedbackFormSubmitted = 'trimester_feedback_form_submitted';
var $author$project$Log$msgTrimesterFeedbackFormValidationError = 'trimester_feedback_form_validation_error';
var $author$project$Element$TrimesterFeedbackForm$parseRubricAssessment = function (_v0) {
	var selectedRubric = _v0.dd;
	var filledRubric = _v0.cJ;
	var _v1 = _Utils_Tuple2(selectedRubric, filledRubric);
	if ((!_v1.a.$) && (!_v1.b.$)) {
		var selectedRubric_ = _v1.a.a;
		var filledRubric_ = _v1.b.a;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(selectedRubric_, filledRubric_));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Element$TrimesterFeedbackForm$validateForm = function (form) {
	return _Utils_update(
		form,
		{
			a0: $author$project$Form$markEdited(form.a0)
		});
};
var $author$project$Element$TrimesterFeedbackForm$submitForm = function (model) {
	var config = model.bN;
	var form = model.bt;
	var values = model.ej;
	var trimesterFeedbackReport = model.eh;
	var validationError = $author$project$Api$CustomError(
		'trimester_feedback_form_validation_failed ' + $elm$core$String$fromInt(trimesterFeedbackReport.ne.gT));
	var model2 = _Utils_update(
		model,
		{eD: 2});
	var logValidationError = A3(
		$author$project$Log$errorV2,
		config,
		_Utils_Tuple3(
			$author$project$Log$msgTrimesterFeedbackFormValidationError,
			$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
			validationError),
		$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
	var createTrimesterFeedback = function (maybeRubricAssessment) {
		var rubricAssessment = A2($elm$core$Maybe$map, $elm$core$Tuple$second, maybeRubricAssessment);
		var tfUnsaved = {
			gD: form.a0.nD(values),
			gJ: rubricAssessment,
			eV: model2.eh.gT
		};
		var rubric = A2($elm$core$Maybe$map, $elm$core$Tuple$first, maybeRubricAssessment);
		var logRequest = A3(
			$author$project$Log$okV2,
			config,
			_Utils_Tuple2(
				$author$project$Log$msgTrimesterFeedbackFormSubmitted,
				_List_fromArray(
					[
						$author$project$Log$paramScopeTrimesterFeedbackForm,
						A2(
						$elm$core$Maybe$withDefault,
						'none',
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$String$fromInt,
								function ($) {
									return $.mT;
								}),
							tfUnsaved.gJ)),
						$elm$core$String$fromInt(tfUnsaved.eV),
						$author$project$Log$paramOk
					])),
			$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
		return _Utils_Tuple3(
			model2,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$CreateTrimesterFeedback(
							A3(
								$author$project$TrimesterFeedback$createTrimesterFeedbackV2,
								config,
								tfUnsaved,
								$author$project$Element$TrimesterFeedbackForm$TrimesterFeedbackSaved(rubric)))),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
						$author$project$Element$TrimesterFeedbackForm$LogOk(logRequest))
					])),
			$elm$core$Maybe$Nothing);
	};
	return A2($author$project$Element$TrimesterFeedbackForm$isFormValid, form, values) ? createTrimesterFeedback(
		$author$project$Element$TrimesterFeedbackForm$parseRubricAssessment(model2)) : _Utils_Tuple3(
		_Utils_update(
			model,
			{
				bt: $author$project$Element$TrimesterFeedbackForm$validateForm(form),
				f6: true
			}),
		$author$project$Element$TrimesterFeedbackForm$BatchEffect(
			_List_fromArray(
				[
					$author$project$Element$TrimesterFeedbackForm$Cmd($author$project$Element$TrimesterFeedbackForm$ScrollToFormError),
					$author$project$Element$TrimesterFeedbackForm$Cmd(
					$author$project$Element$TrimesterFeedbackForm$LogError(logValidationError))
				])),
		$elm$core$Maybe$Nothing);
};
var $author$project$Element$TrimesterFeedbackForm$openRubricAssessment = F3(
	function (model, effect, rubric) {
		var config = model.bN;
		var session = model.cv;
		var model2 = _Utils_update(
			model,
			{cJ: $elm$core$Maybe$Nothing, eD: 1});
		var params = {
			i2: true,
			eW: _List_fromArray(
				[rubric]),
			e1: _List_fromArray(
				[model2.eh.ne]),
			jB: model2.jB
		};
		var _v0 = A3(
			$author$project$Application$V3$Boundaries$mapElement,
			model2,
			$author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment,
			A4($author$project$Application$V3$Boundaries$initElement, config, session, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment, params));
		var model3 = _v0.a;
		var effect2 = _v0.b;
		return _Utils_Tuple3(
			model3,
			$author$project$Element$TrimesterFeedbackForm$BatchEffect(
				_List_fromArray(
					[effect, effect2])),
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$toggleRubricAssessment = F3(
	function (model, effect, maybeRubric) {
		var model2 = _Utils_update(
			model,
			{dd: maybeRubric});
		var _v0 = _Utils_Tuple2(model.dd, maybeRubric);
		_v0$2:
		while (true) {
			if (!_v0.a.$) {
				if (!_v0.b.$) {
					var prevRubric = _v0.a.a;
					var newRubric = _v0.b.a;
					return (!_Utils_eq(prevRubric.gT, newRubric.gT)) ? A3($author$project$Element$TrimesterFeedbackForm$openRubricAssessment, model2, effect, newRubric) : _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
				} else {
					break _v0$2;
				}
			} else {
				if (!_v0.b.$) {
					var _v1 = _v0.a;
					var newRubric = _v0.b.a;
					return A3($author$project$Element$TrimesterFeedbackForm$openRubricAssessment, model2, effect, newRubric);
				} else {
					break _v0$2;
				}
			}
		}
		return _Utils_Tuple3(
			_Utils_update(
				model2,
				{cJ: $elm$core$Maybe$Nothing, d5: $elm$core$Maybe$Nothing}),
			effect,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Element$TrimesterFeedbackForm$update = F2(
	function (msg, model) {
		var config = model.bN;
		var form = model.bt;
		var values = model.ej;
		var session = model.cv;
		var t_ = session.hy;
		var noop = _Utils_Tuple3(model, $author$project$Element$TrimesterFeedbackForm$NoEffect, $elm$core$Maybe$Nothing);
		switch (msg.$) {
			case 0:
				return noop;
			case 1:
				return A2($author$project$Element$TrimesterFeedbackForm$openRubricsListPopup, model, $author$project$Element$TrimesterFeedbackForm$NoEffect);
			case 2:
				return _Utils_Tuple3(
					model,
					$author$project$Element$TrimesterFeedbackForm$NoEffect,
					$elm$core$Maybe$Just($author$project$Element$TrimesterFeedbackForm$Exit));
			case 3:
				return $author$project$Element$TrimesterFeedbackForm$submitForm(model);
			case 6:
				var rubricAssessmentMsg = msg.a;
				var _v1 = model.d5;
				if (!_v1.$) {
					var rubricAssessmentModel = _v1.a;
					var _v2 = A3(
						$author$project$Application$V3$Boundaries$mapElement,
						model,
						$author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment,
						A4($author$project$Application$V3$Boundaries$updateElement, session, rubricAssessmentMsg, rubricAssessmentModel, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment));
					var model2 = _v2.a;
					var effect = _v2.b;
					var reply = _v2.c;
					if (!reply.$) {
						var reply_ = reply.a;
						switch (reply_.$) {
							case 0:
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							case 1:
								return _Utils_Tuple3(
									model2,
									effect,
									$elm$core$Maybe$Just($author$project$Element$TrimesterFeedbackForm$Exit));
							default:
								var assessment = reply_.a;
								return _Utils_Tuple3(
									_Utils_update(
										model2,
										{
											cJ: $elm$core$Maybe$Just(assessment)
										}),
									effect,
									$elm$core$Maybe$Nothing);
						}
					} else {
						return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
					}
				} else {
					return noop;
				}
			case 5:
				var fieldMsg = msg.a;
				var value = fieldMsg;
				var model2 = _Utils_update(
					model,
					{
						bt: _Utils_update(
							form,
							{
								a0: $author$project$Form$markEdited(model.bt.a0)
							}),
						eD: 1,
						ej: A2(form.a0.jR, value, values)
					});
				return _Utils_Tuple3(model2, $author$project$Element$TrimesterFeedbackForm$NoEffect, $elm$core$Maybe$Nothing);
			case 4:
				var popupMsg = msg.a;
				var _v6 = _Utils_Tuple2(popupMsg, model.c2);
				_v6$2:
				while (true) {
					if (_v6.a.$ === 1) {
						if ((!_v6.b.$) && (_v6.b.a.$ === 1)) {
							var rubricsFormMsg = _v6.a.a;
							var rubricsFormModel = _v6.b.a.a;
							var _v7 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$TrimesterFeedbackForm$popups.c8,
								A4($author$project$Application$V3$Boundaries$updateElement, session, rubricsFormMsg, rubricsFormModel, $author$project$Element$TrimesterFeedbackForm$popups.c8));
							var model2 = _v7.a;
							var effect = _v7.b;
							var reply = _v7.c;
							if (!reply.$) {
								var _v9 = reply.a;
								return A2($author$project$Element$TrimesterFeedbackForm$openRubricsListPopup, model2, effect);
							} else {
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						} else {
							break _v6$2;
						}
					} else {
						if ((!_v6.b.$) && (!_v6.b.a.$)) {
							var rubricsListMsg = _v6.a.a;
							var rubricsListModel = _v6.b.a.a;
							var _v10 = A3(
								$author$project$Application$V3$Boundaries$mapElement,
								model,
								$author$project$Element$TrimesterFeedbackForm$popups.da,
								A4($author$project$Application$V3$Boundaries$updateElement, session, rubricsListMsg, rubricsListModel, $author$project$Element$TrimesterFeedbackForm$popups.da));
							var model2 = _v10.a;
							var effect = _v10.b;
							var reply = _v10.c;
							if (!reply.$) {
								var reply_ = reply.a;
								switch (reply_.$) {
									case 1:
										var rubrics = reply_.a;
										var maybeSelected = $elm$core$List$head(rubrics);
										var _v13 = A3($author$project$Element$TrimesterFeedbackForm$toggleRubricAssessment, model2, effect, maybeSelected);
										var model3 = _v13.a;
										var effect2 = _v13.b;
										return _Utils_Tuple3(
											_Utils_update(
												model3,
												{c2: $elm$core$Maybe$Nothing}),
											effect2,
											$elm$core$Maybe$Nothing);
									case 2:
										var _v14 = A3(
											$author$project$Application$V3$Boundaries$mapElement,
											model2,
											$author$project$Element$TrimesterFeedbackForm$popups.c8,
											A4(
												$author$project$Application$V3$Boundaries$initElement,
												config,
												model2.cv,
												$author$project$Element$TrimesterFeedbackForm$popups.c8,
												{lz: true, mS: $elm$core$Maybe$Nothing}));
										var model3 = _v14.a;
										var effect2 = _v14.b;
										return _Utils_Tuple3(
											model3,
											$author$project$Element$TrimesterFeedbackForm$BatchEffect(
												_List_fromArray(
													[effect, effect2])),
											$elm$core$Maybe$Nothing);
									default:
										return _Utils_Tuple3(
											_Utils_update(
												model2,
												{c2: $elm$core$Maybe$Nothing}),
											effect,
											$elm$core$Maybe$Nothing);
								}
							} else {
								return _Utils_Tuple3(model2, effect, $elm$core$Maybe$Nothing);
							}
						} else {
							break _v6$2;
						}
					}
				}
				return noop;
			case 7:
				if (!msg.b.$) {
					var maybeRubric = msg.a;
					var trimesterFeedback = msg.b.a;
					var logParams = _List_fromArray(
						[
							$elm$core$String$fromInt(trimesterFeedback.gT),
							A2(
							$elm$core$Maybe$withDefault,
							'none',
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.gT;
									},
									$elm$core$String$fromInt),
								maybeRubric))
						]);
					var logRequest = A3(
						$author$project$Log$okV2,
						model.bN,
						_Utils_Tuple2($author$project$Log$msgTrimesterFeedbackSave, logParams),
						$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp));
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eD: 0,
								cv: A2(
									$author$project$Session$ok,
									session,
									t_($author$project$Locale$Messages$TrimesterFeedbackFormSaveSuccess))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogOk(logRequest)),
						$elm$core$Maybe$Just(
							$author$project$Element$TrimesterFeedbackForm$Saved(trimesterFeedback)));
				} else {
					var error = msg.b.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TrimesterFeedbackFormSaveError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackSave, $elm$core$Maybe$Nothing, error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
			default:
				if (!msg.a.$) {
					var rubrics = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								eS: $elm$core$Maybe$Just(rubrics)
							}),
						$author$project$Element$TrimesterFeedbackForm$NoEffect,
						$elm$core$Maybe$Nothing);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple3(
						_Utils_update(
							model,
							{
								cv: A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$RubricsDownloadError))
							}),
						$author$project$Element$TrimesterFeedbackForm$Cmd(
							$author$project$Element$TrimesterFeedbackForm$LogError(
								A3(
									$author$project$Log$errorV2,
									config,
									_Utils_Tuple3(
										$author$project$Log$msgRubricsDownload,
										$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackForm),
										error),
									$elm$core$Basics$always($author$project$Element$TrimesterFeedbackForm$NoOp)))),
						$elm$core$Maybe$Nothing);
				}
		}
	});
var $author$project$Element$TrimesterFeedbackForm$ClosePopup = {$: 2};
var $author$project$Element$TrimesterFeedbackForm$OpenRubricSelector = {$: 1};
var $author$project$Element$TrimesterFeedbackForm$SubmitForm = {$: 3};
var $author$project$Locale$Messages$TrimesterFeedbackFormFilledRubricRequired = {$: 673};
var $author$project$Locale$Messages$TrimesterFeedbackFormRubricSelector = {$: 670};
var $author$project$Locale$Messages$TrimesterFeedbackFormTitle = {$: 668};
var $author$project$Element$TrimesterFeedbackForm$isRubricAssessmentValid = function (_v0) {
	var selectedRubric = _v0.dd;
	var filledRubric = _v0.cJ;
	var _v1 = _Utils_Tuple2(selectedRubric, filledRubric);
	if (_v1.a.$ === 1) {
		var _v2 = _v1.a;
		return true;
	} else {
		if (!_v1.b.$) {
			return true;
		} else {
			var _v3 = _v1.b;
			return false;
		}
	}
};
var $author$project$Locale$Messages$TrimesterFeedbackFormSubtitle = function (a) {
	return {$: 669, a: a};
};
var $author$project$Element$TrimesterFeedbackForm$viewMeta = F2(
	function (t_, report) {
		var params = {
			dH: report.d9 + 1,
			ha: A2($author$project$Person$fullName, t_, report.ne),
			d9: report.d9,
			jP: report.jP
		};
		return $author$project$UI$subtitle(
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					$author$project$Locale$Messages$TrimesterFeedbackFormSubtitle(params))
				]));
	});
var $author$project$Element$TrimesterFeedbackForm$viewPopup = F2(
	function (session, model) {
		var _v0 = model.c2;
		if (!_v0.$) {
			if (!_v0.a.$) {
				var popupModel = _v0.a.a;
				return A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, $author$project$Element$TrimesterFeedbackForm$PopupMsg, $author$project$Element$TrimesterFeedbackForm$RubricsListMsg),
					$author$project$Element$RubricsList$viewPopup(
						_Utils_update(
							popupModel,
							{cv: session})));
			} else {
				var popupModel = _v0.a.a;
				return A3($author$project$Application$V3$Boundaries$viewElement, session, popupModel, $author$project$Element$TrimesterFeedbackForm$popups.c8);
			}
		} else {
			return $author$project$UI$none;
		}
	});
var $author$project$Element$TrimesterFeedbackForm$view = function (model) {
	var form = model.bt;
	var values = model.ej;
	var formState = model.eD;
	var session = model.cv;
	var viewRubricAssessment = A2(
		$elm$core$Maybe$withDefault,
		$author$project$UI$none,
		A2(
			$elm$core$Maybe$map,
			function (rubricsModel) {
				return A3($author$project$Application$V3$Boundaries$viewElement, session, rubricsModel, $author$project$Element$TrimesterFeedbackForm$embeddedRubricAssessment);
			},
			model.d5));
	var t_ = session.hy;
	var viewRubricsButton = function () {
		var _v0 = model.eS;
		if (!_v0.$) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('button is-link is-light'),
						$elm$html$Html$Events$onClick($author$project$Element$TrimesterFeedbackForm$OpenRubricSelector)
					]),
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormRubricSelector)
					]));
		} else {
			return $author$project$UI$Icon$loadingOptions(_List_Nil);
		}
	}();
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('container')
			]),
		_List_fromArray(
			[
				A4(
				$author$project$UI$modalPanel,
				_List_fromArray(
					[
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormTitle)
					]),
				_List_fromArray(
					[
						$author$project$UI$closeButton($author$project$Element$TrimesterFeedbackForm$ClosePopup)
					]),
				_List_fromArray(
					[
						A2($author$project$Element$TrimesterFeedbackForm$viewMeta, t_, model.eh),
						$author$project$UI$columns(
						_List_fromArray(
							[
								A3($author$project$UI$richTextEditorField, t_, form.a0, values)
							])),
						$author$project$UI$columns(
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										viewRubricAssessment,
										((!$author$project$Element$TrimesterFeedbackForm$isRubricAssessmentValid(model)) && model.f6) ? A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('has-errors help is-danger')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackFormFilledRubricRequired)
											])) : $author$project$UI$none
									]))
							])),
						$author$project$UI$columns(
						_List_fromArray(
							[viewRubricsButton]))
					]),
				_List_fromArray(
					[
						A4(
						$author$project$UI$submitButton,
						t_($author$project$Locale$Messages$BtnSave),
						formState !== 1,
						$author$project$Form$isProcessing(formState),
						$author$project$Element$TrimesterFeedbackForm$SubmitForm),
						A4(
						$author$project$UI$resetButton,
						t_($author$project$Locale$Messages$BtnCancel),
						$author$project$Form$resetDisabled(formState),
						$author$project$Form$isProcessing(formState),
						$author$project$Element$TrimesterFeedbackForm$ClosePopup)
					])),
				A2($author$project$Element$TrimesterFeedbackForm$viewPopup, session, model)
			]));
};
var $author$project$Element$TrimesterFeedbackForm$element = {iA: $author$project$Element$TrimesterFeedbackForm$init, hh: $author$project$Element$TrimesterFeedbackForm$perform, jR: $author$project$Element$TrimesterFeedbackForm$update, nE: $author$project$Element$TrimesterFeedbackForm$view};
var $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm = {
	gF: $author$project$Element$TrimesterFeedbackForm$element,
	bZ: $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackFormMsg,
	jS: F2(
		function (containerModel, model) {
			return _Utils_update(
				containerModel,
				{
					dl: $elm$core$Maybe$Just(model)
				});
		})
};
var $author$project$Element$TrimesterFeedbackReport$openTrimesterFeedbackForm = F5(
	function (config, session, report, subjects, model) {
		var trimesterFeedbackFormOpened = A3(
			$author$project$Application$V2$Boundaries$mapElement,
			A2($author$project$Application$Boundaries$save, model, session),
			$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
			A5(
				$author$project$Application$V2$Boundaries$initElement,
				config.iJ,
				$author$project$Application$V2$SharedConfig$fromV1(config),
				session,
				$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
				{eV: report, jB: subjects}));
		return {dz: trimesterFeedbackFormOpened.dz, dY: trimesterFeedbackFormOpened.dY, fY: $elm$core$Maybe$Nothing, cv: trimesterFeedbackFormOpened.cv};
	});
var $author$project$Log$paramScopeTrimesterFeedbackReport = 'scope_trimester_feedback_report';
var $author$project$Element$TrimesterFeedbackReport$updatePortfolioSinglesModel = F5(
	function (session, model, storyId, elementMsg, portfolioSinglesModel) {
		var single = $author$project$Element$TrimesterFeedbackReport$portfolioSingle(storyId);
		var updateSingleModel = function (singleModel) {
			var _return = A3(
				$author$project$Application$V2$Boundaries$mapElement,
				A2($author$project$Application$Boundaries$save, model, session),
				single,
				A5($author$project$Application$V2$Boundaries$updateElement, model.bN.iJ, session, elementMsg, singleModel, single));
			var returnNoReply = {dz: _return.dz, dY: _return.dY, fY: $elm$core$Maybe$Nothing, cv: _return.cv};
			var _v0 = _return.fY;
			if (!_v0.$) {
				var _v1 = _v0.a;
				return A2(
					$author$project$Application$Boundaries$mapModel,
					function (model_) {
						return _Utils_update(
							model_,
							{
								bU: $author$project$RemoteData$Success(
									A2($elm$core$Dict$remove, storyId, portfolioSinglesModel))
							});
					},
					returnNoReply);
			} else {
				return returnNoReply;
			}
		};
		var maybeSingleModel = A2($elm$core$Dict$get, storyId, portfolioSinglesModel);
		return A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$Application$Boundaries$save, model, session),
			A2($elm$core$Maybe$map, updateSingleModel, maybeSingleModel));
	});
var $author$project$Element$TrimesterFeedbackReport$updateTrimesterFeedbackFormModel = F4(
	function (session, model, elementMsg, trimesterFeedbackFormModel) {
		var returnNoReply = function (return_) {
			return {dz: return_.dz, dY: return_.dY, fY: $elm$core$Maybe$Nothing, cv: return_.cv};
		};
		var _return = A5($author$project$Application$V2$Boundaries$updateElement, model.bN.iJ, session, elementMsg, trimesterFeedbackFormModel, $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm);
		var _v0 = _return.fY;
		if (_v0.$ === 1) {
			return returnNoReply(
				A3(
					$author$project$Application$V2$Boundaries$mapElement,
					A2($author$project$Application$Boundaries$save, model, session),
					$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
					_return));
		} else {
			var reply_ = _v0.a;
			if (!reply_.$) {
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{dl: $elm$core$Maybe$Nothing}),
					session);
			} else {
				var trimesterFeedback = reply_.a;
				return returnNoReply(
					A2(
						$author$project$Application$Boundaries$mapModel,
						function (model_) {
							return _Utils_update(
								model_,
								{
									bm: A2(
										$author$project$Element$TrimesterFeedbackReport$mapTrimesterPage,
										function (report_) {
											return _Utils_update(
												report_,
												{
													hG: $elm$core$Maybe$Just(trimesterFeedback)
												});
										},
										model.bm),
									dl: $elm$core$Maybe$Nothing
								});
						},
						A3(
							$author$project$Application$V2$Boundaries$mapElement,
							A2($author$project$Application$Boundaries$save, model, session),
							$author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm,
							_return)));
			}
		}
	});
var $author$project$Element$TrimesterFeedbackReport$update = F3(
	function (session, msg, model) {
		var t_ = session.hy;
		var config = model.bN;
		switch (msg.$) {
			case 0:
				var storyId = msg.a;
				var elementMsg = msg.b;
				return A2(
					$author$project$RemoteData$withDefault,
					A2($author$project$Application$Boundaries$save, model, session),
					A2(
						$author$project$RemoteData$map,
						A4($author$project$Element$TrimesterFeedbackReport$updatePortfolioSinglesModel, session, model, storyId, elementMsg),
						model.bU));
			case 1:
				var elementMsg = msg.a;
				var _v1 = _Utils_Tuple2(
					model.dl,
					$author$project$Element$TrimesterFeedbackReport$pageToReport(model.bm));
				if ((!_v1.a.$) && (!_v1.b.$)) {
					var trimesterFeedbackFormModel = _v1.a.a;
					return A4($author$project$Element$TrimesterFeedbackReport$updateTrimesterFeedbackFormModel, session, model, elementMsg, trimesterFeedbackFormModel);
				} else {
					return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 2:
				var tab = msg.a;
				return A2(
					$author$project$RemoteData$withDefault,
					A2($author$project$Application$Boundaries$save, model, session),
					A2(
						$author$project$RemoteData$map,
						function (reports) {
							return $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures(
								A2(
									$author$project$Application$Boundaries$save,
									_Utils_update(
										model,
										{
											bm: A2($author$project$Element$TrimesterFeedbackReport$switchTab, reports, tab)
										}),
									session));
						},
						model.d4));
			case 3:
				var report = msg.a;
				var subjects = msg.b;
				return A5($author$project$Element$TrimesterFeedbackReport$openTrimesterFeedbackForm, config, session, report, subjects, model);
			case 8:
				var feedback = msg.a;
				return A2(
					$author$project$Application$Boundaries$andThenCmd,
					A3($author$project$TrimesterFeedback$deleteTrimesterFeedback, model.bN.gr, feedback, $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleted),
					A2($author$project$Application$Boundaries$save, model, session));
			case 4:
				if (!msg.a.$) {
					var gradeReports = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								dN: $elm$core$Maybe$Just(gradeReports)
							}),
						session);
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgGradeReportsDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackReport),
								error),
							$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$GradeReportsDownloadError))));
				}
			case 6:
				var data = msg.a;
				return A2(
					$author$project$Application$Boundaries$save,
					_Utils_update(
						model,
						{jB: data}),
					session);
			case 5:
				if (!msg.a.$) {
					var stories = msg.a.a;
					return A2(
						$author$project$Element$TrimesterFeedbackReport$andThenInitPortfolioSingleElements,
						stories,
						A2(
							$author$project$Application$Boundaries$save,
							_Utils_update(
								model,
								{
									bU: $author$project$RemoteData$Success($elm$core$Dict$empty)
								}),
							session));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3(
								$author$project$Log$msgPortfoliosDownload,
								$elm$core$Maybe$Just($author$project$Log$paramScopeTrimesterFeedbackReport),
								error),
							$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$PortfoliosDownloadError))));
				}
			case 7:
				var reports = msg.a;
				switch (reports.$) {
					case 2:
						var reports_ = reports.a;
						return $author$project$Element$TrimesterFeedbackReport$andThenFetchModuleClosures(
							A2(
								$author$project$Element$TrimesterFeedbackReport$andThenInitPage,
								reports_,
								A2($author$project$Application$Boundaries$save, model, session)));
					case 3:
						var error = reports.a;
						return A2(
							$author$project$Application$Boundaries$andThenCmd,
							A3(
								$author$project$Log$error,
								config,
								_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackDownload, $elm$core$Maybe$Nothing, error),
								$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
							A2(
								$author$project$Application$Boundaries$save,
								model,
								A3(
									$author$project$Session$error,
									session,
									error,
									t_($author$project$Locale$Messages$TrimesterFeedbackReportDownloadError))));
					case 0:
						return A2($author$project$Application$Boundaries$save, model, session);
					default:
						return A2($author$project$Application$Boundaries$save, model, session);
				}
			case 9:
				if (!msg.a.$) {
					return A2(
						$author$project$Application$Boundaries$save,
						_Utils_update(
							model,
							{
								bm: A2(
									$author$project$Element$TrimesterFeedbackReport$mapTrimesterPage,
									function (report) {
										return _Utils_update(
											report,
											{hG: $elm$core$Maybe$Nothing});
									},
									model.bm)
							}),
						A2(
							$author$project$Session$ok,
							session,
							t_($author$project$Locale$Messages$TrimesterFeedbackDeleteSuccess)));
				} else {
					var error = msg.a.a;
					return A2(
						$author$project$Application$Boundaries$andThenCmd,
						A3(
							$author$project$Log$error,
							config,
							_Utils_Tuple3($author$project$Log$msgTrimesterFeedbackDelete, $elm$core$Maybe$Nothing, error),
							$elm$core$Basics$always($author$project$Element$TrimesterFeedbackReport$NoOp)),
						A2(
							$author$project$Application$Boundaries$save,
							model,
							A3(
								$author$project$Session$error,
								session,
								error,
								t_($author$project$Locale$Messages$TrimesterFeedbackDeleteError))));
				}
			default:
				return A2($author$project$Application$Boundaries$save, model, session);
		}
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportLoadingProgress = {$: 677};
var $author$project$Locale$Messages$TrimesterFeedbackReportNotFound = {$: 678};
var $author$project$Element$TrimesterFeedbackReport$viewNotFoundPage = function (t_) {
	return $author$project$UI$notification(
		_List_fromArray(
			[
				A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportNotFound)
			]));
};
var $author$project$Locale$Messages$TrimesterFeedbackReportTitle = {$: 675};
var $author$project$Element$TrimesterFeedbackReport$NoSelectedTab = 4;
var $author$project$Element$TrimesterFeedbackReport$pageToTab = function (page) {
	switch (page.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadEndYearFeedback = function (a) {
	return {$: 689, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadMidYearFeedback = function (a) {
	return {$: 688, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewDownloadLink = F3(
	function (t_, message, url) {
		return A2(
			$elm$html$Html$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(url),
							$elm$html$Html$Attributes$target('_blank')
						]),
					_List_fromArray(
						[
							$author$project$UI$Icon$filePdf(
							_List_fromArray(
								[
									$author$project$UI$Icon$style('has-text-primary')
								])),
							A2(
							$elm$html$Html$span,
							_List_Nil,
							_List_fromArray(
								[
									A2($author$project$UI$caption, t_, message)
								]))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewGradeReportFeedbackLink = F2(
	function (t_, gr) {
		var _v0 = gr.hH;
		switch (_v0) {
			case 0:
				return A2(
					$author$project$UI$maybe,
					gr.k1,
					A2(
						$author$project$Element$TrimesterFeedbackReport$viewDownloadLink,
						t_,
						$author$project$Locale$Messages$TrimesterFeedbackReportDownloadMidYearFeedback(gr.gO)));
			case 1:
				return A2(
					$author$project$UI$maybe,
					gr.k1,
					A2(
						$author$project$Element$TrimesterFeedbackReport$viewDownloadLink,
						t_,
						$author$project$Locale$Messages$TrimesterFeedbackReportDownloadEndYearFeedback(gr.gO)));
			default:
				return $author$project$UI$none;
		}
	});
var $author$project$Element$TrimesterFeedbackReport$TabSelected = function (a) {
	return {$: 2, a: a};
};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabFirstTrimester = {$: 684};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabPreviousYears = {$: 683};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabSecondTrimester = {$: 685};
var $author$project$Locale$Messages$TrimesterFeedbackReportTabThirdTrimester = {$: 686};
var $author$project$Element$TrimesterFeedbackReport$viewTabs = F3(
	function (t_, reports, selectedTab) {
		var isEnabledTrimesterReportTab = function (tabPos) {
			return A2(
				$elm$core$Maybe$withDefault,
				false,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$Basics$not,
						function ($) {
							return $.lr;
						}),
					A2($author$project$Element$TrimesterFeedbackReport$findReportByTrimester, reports, tabPos)));
		};
		return A3(
			$author$project$UI$List$filterBar,
			t_,
			_Utils_Tuple2($author$project$Element$TrimesterFeedbackReport$TabSelected, selectedTab),
			_List_fromArray(
				[
					{kJ: 'previous', bO: 0, g_: true, g$: true, lO: $author$project$Locale$Messages$TrimesterFeedbackReportTabPreviousYears},
					{
					kJ: 'first',
					bO: 1,
					g_: isEnabledTrimesterReportTab(1),
					g$: true,
					lO: $author$project$Locale$Messages$TrimesterFeedbackReportTabFirstTrimester
				},
					{
					kJ: 'second',
					bO: 2,
					g_: isEnabledTrimesterReportTab(2),
					g$: true,
					lO: $author$project$Locale$Messages$TrimesterFeedbackReportTabSecondTrimester
				},
					{
					kJ: 'third',
					bO: 3,
					g_: isEnabledTrimesterReportTab(3),
					g$: true,
					lO: $author$project$Locale$Messages$TrimesterFeedbackReportTabThirdTrimester
				}
				]));
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportDownloadTrimesterFeedback = F2(
	function (a, b) {
		return {$: 690, a: a, b: b};
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackLink = F2(
	function (t_, report) {
		return A2(
			$author$project$UI$maybe,
			report.G,
			A2(
				$author$project$Element$TrimesterFeedbackReport$viewDownloadLink,
				t_,
				A2($author$project$Locale$Messages$TrimesterFeedbackReportDownloadTrimesterFeedback, report.d9, report.jP)));
	});
var $author$project$Element$TrimesterFeedbackReport$viewPreviousYearsPage = F4(
	function (t_, reports, gradeReports, page) {
		return $author$project$UI$panel(
			{
				kt: function () {
					var _v0 = _Utils_Tuple2(reports, gradeReports);
					if ((_v0.a.$ === 2) && (!_v0.b.$)) {
						var reports_ = _v0.a.a;
						var gradeReports_ = _v0.b.a;
						var pastReports = A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeL,
								$elm$core$Basics$not,
								function ($) {
									return $.iG;
								}),
							reports_);
						return _List_fromArray(
							[
								A2(
								$elm$html$Html$ul,
								_List_Nil,
								_Utils_ap(
									A2(
										$elm$core$List$map,
										$author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackLink(t_),
										pastReports),
									A2(
										$elm$core$List$map,
										$author$project$Element$TrimesterFeedbackReport$viewGradeReportFeedbackLink(t_),
										gradeReports_)))
							]);
					} else {
						return _List_fromArray(
							[$author$project$UI$List$resultsLoadingProgressBar]);
					}
				}(),
				kJ: 'feedback-list-archive',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportTitle)
							]),
						_List_Nil)
					]),
				nk: A3(
					$author$project$Element$TrimesterFeedbackReport$viewTabs,
					t_,
					A2($author$project$RemoteData$withDefault, _List_Nil, reports),
					$author$project$Element$TrimesterFeedbackReport$pageToTab(page)),
				nq: 'is-link'
			});
	});
var $author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportNew = {$: 674};
var $author$project$ACL$canCreateTrimesterClosingFeedback = F2(
	function (person, student) {
		return A2(
			$elm$core$List$any,
			$author$project$Person$isSamePerson(student),
			person.lZ);
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportAddFeedback = {$: 682};
var $author$project$Locale$Messages$TrimesterFeedbackReportMissingFeedback = function (a) {
	return {$: 680, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewMissingTrimesterFeedback = F3(
	function (_v0, report, subjects) {
		var t_ = _v0.hy;
		var viewer = _v0.nH;
		var student = report.ne;
		var studentName = A2($author$project$Person$fullName, t_, student);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$TrimesterFeedbackReportMissingFeedback(studentName)),
							A3(
							$elm$core$Basics$apL,
							$author$project$UI$when,
							A2($author$project$ACL$canCreateTrimesterClosingFeedback, viewer, student),
							A3(
								$author$project$UI$actionLink,
								A2($author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm, report, subjects),
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportAddFeedback)
									])))
						]))
				]));
	});
var $author$project$Locale$Messages$TrimesterFeedbackReportMissingModuleClosures = function (a) {
	return {$: 681, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewMissingModuleClosures = F2(
	function (t_, student) {
		var studentName = A2($author$project$Person$fullName, t_, student);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					$author$project$UI$notification(
					_List_fromArray(
						[
							A2(
							$author$project$UI$caption,
							t_,
							$author$project$Locale$Messages$TrimesterFeedbackReportMissingModuleClosures(studentName))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewSingleElement = F3(
	function (session, story, portfolioSinglesModel) {
		return A3(
			$author$project$Application$V2$Boundaries$viewElement,
			session,
			portfolioSinglesModel,
			$author$project$Element$TrimesterFeedbackReport$portfolioSingle(story.gT));
	});
var $author$project$Element$TrimesterFeedbackReport$viewStoryList = F3(
	function (session, student, portfolioSinglesModel) {
		var t_ = session.hy;
		if (portfolioSinglesModel.$ === 2) {
			var portfolioSinglesModel_ = portfolioSinglesModel.a;
			var viewKeyedItem = function (story) {
				return _Utils_Tuple2(
					$elm$core$String$fromInt(story.gT),
					A2(
						$author$project$UI$maybe,
						A2($elm$core$Dict$get, story.gT, portfolioSinglesModel_),
						A2($author$project$Element$TrimesterFeedbackReport$viewSingleElement, session, story)));
			};
			var stories = A2(
				$elm$core$List$filterMap,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.df;
					},
					$author$project$RemoteData$toMaybe),
				$elm$core$Dict$values(portfolioSinglesModel_));
			return $elm$core$List$isEmpty(stories) ? _List_fromArray(
				[
					_Utils_Tuple2(
					'',
					A2($author$project$Element$TrimesterFeedbackReport$viewMissingModuleClosures, t_, student))
				]) : A2($elm$core$List$map, viewKeyedItem, stories);
		} else {
			return _List_fromArray(
				[
					_Utils_Tuple2('', $author$project$UI$List$resultsLoadingProgressBar)
				]);
		}
	});
var $author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleteRequested = function (a) {
	return {$: 8, a: a};
};
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackContent = function (trimesterFeedback) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('block mt-2')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('block')
					]),
				_List_fromArray(
					[
						$author$project$Util$Html$markdownToHtml(trimesterFeedback.gD)
					]))
			]));
};
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackMeta = F3(
	function (t_, student, trimesterFeedback) {
		var viewTitle = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('has-text-grey')
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TrimesterClosureFeedbackGiven,
						A2($author$project$Person$fullName, t_, trimesterFeedback.kG),
						A2($author$project$Person$fullName, t_, student)))
				]));
		var viewDateLink = A2(
			$elm$html$Html$a,
			_List_fromArray(
				[
					$author$project$Route$href(
					$author$project$Route$TrimesterFeedbackReport(student.gT))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					A2(
						$author$project$Locale$Messages$TimeDateTimeFormat,
						$elm$time$Time$utc,
						$elm$time$Time$millisToPosix(trimesterFeedback.gz)))
				]));
		return A4(
			$author$project$UI$mediaObjectSmall,
			_List_fromArray(
				[
					$author$project$UI$gravatar(trimesterFeedback.kG.K)
				]),
			_List_fromArray(
				[
					viewTitle,
					$author$project$UI$mediaObjectHighlights(
					_List_fromArray(
						[viewDateLink]))
				]),
			_List_Nil,
			_List_Nil);
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedback = F4(
	function (t_, subjects, student, trimesterFeedback) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('container is-fullwidth')
				]),
			_List_fromArray(
				[
					A3($author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackMeta, t_, student, trimesterFeedback),
					$author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedbackContent(trimesterFeedback),
					A2(
					$author$project$UI$maybe,
					trimesterFeedback.gJ,
					$author$project$UI$RubricAssessment$view(subjects)),
					A2(
					$author$project$UI$levelHorizontal,
					_List_Nil,
					_List_fromArray(
						[
							A3(
							$author$project$UI$actionLink,
							$author$project$Element$TrimesterFeedbackReport$TrimesterFeedbackDeleteRequested(trimesterFeedback),
							_List_Nil,
							_List_fromArray(
								[
									$author$project$UI$Icon$delete(_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Element$TrimesterFeedbackReport$viewTrimesterPage = F6(
	function (session, reports, portfolioSinglesModel, page, report, subjects) {
		var t_ = session.hy;
		var viewer = session.nH;
		var trimesterFeedback = report.hG;
		var student = report.ne;
		var url = report.G;
		var viewDownloadBar = function (url_) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('is-fullwidth')
						]),
					_List_fromArray(
						[
							A2(
							$author$project$UI$level,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$href(url_)
										]),
									_List_fromArray(
										[
											$author$project$UI$Icon$filePdf(
											_List_fromArray(
												[
													$author$project$UI$Icon$style('has-text-primary')
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$UI$caption, t_, $author$project$Locale$Messages$GradeReportsDownloadFeedbackPDF)
												]))
										]))
								]))
						]))
				]);
		};
		var viewAddIcon = function () {
			if (!trimesterFeedback.$) {
				return $author$project$UI$none;
			} else {
				return A3(
					$elm$core$Basics$apL,
					$author$project$UI$when,
					A2($author$project$ACL$canCreateTrimesterClosingFeedback, viewer, student),
					A3(
						$author$project$UI$actionLink,
						A2($author$project$Element$TrimesterFeedbackReport$OpenTrimesterFeedbackForm, report, subjects),
						_List_Nil,
						_List_fromArray(
							[
								$author$project$UI$Icon$add(
								_List_fromArray(
									[
										$author$project$UI$Icon$style('has-text-white'),
										$author$project$UI$Icon$alt(
										t_($author$project$Locale$Messages$TrimesterFeedbackReportNew))
									]))
							])));
			}
		}();
		return $author$project$UI$keyedPanel(
			{
				kt: _Utils_ap(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2($elm$core$Maybe$map, viewDownloadBar, url)),
					_List_fromArray(
						[
							A2(
							$elm$core$Maybe$withDefault,
							A3($author$project$Element$TrimesterFeedbackReport$viewMissingTrimesterFeedback, session, report, subjects),
							A2(
								$elm$core$Maybe$map,
								A3($author$project$Element$TrimesterFeedbackReport$viewTrimesterFeedback, t_, subjects, student),
								trimesterFeedback))
						])),
				kJ: 'feedback-list-current',
				le: _List_fromArray(
					[
						A2(
						$author$project$UI$levelHorizontal,
						_List_fromArray(
							[
								A2($author$project$UI$caption, t_, $author$project$Locale$Messages$TrimesterFeedbackReportTitle)
							]),
						_List_fromArray(
							[viewAddIcon]))
					]),
				lN: A3($author$project$Element$TrimesterFeedbackReport$viewStoryList, session, student, portfolioSinglesModel),
				nk: A3(
					$author$project$Element$TrimesterFeedbackReport$viewTabs,
					t_,
					A2($author$project$RemoteData$withDefault, _List_Nil, reports),
					$author$project$Element$TrimesterFeedbackReport$pageToTab(page)),
				nq: 'is-link'
			});
	});
var $author$project$Element$TrimesterFeedbackReport$viewPage = F2(
	function (session, _v0) {
		var t_ = session.hy;
		var portfolioSinglesModel = _v0.bU;
		var gradeReports = _v0.dN;
		var page = _v0.bm;
		var reports = _v0.d4;
		var subjects = _v0.jB;
		var viewTrimesterPage_ = function (report) {
			return A6(
				$author$project$Element$TrimesterFeedbackReport$viewTrimesterPage,
				session,
				reports,
				portfolioSinglesModel,
				page,
				report,
				A2($author$project$RemoteData$withDefault, _List_Nil, subjects));
		};
		switch (page.$) {
			case 1:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 2:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 3:
				var report = page.a;
				return viewTrimesterPage_(report);
			case 0:
				return A4($author$project$Element$TrimesterFeedbackReport$viewPreviousYearsPage, t_, reports, gradeReports, page);
			default:
				return $author$project$Element$TrimesterFeedbackReport$viewNotFoundPage(t_);
		}
	});
var $author$project$Element$TrimesterFeedbackReport$view = F2(
	function (session, model) {
		var t_ = session.hy;
		var viewReportsLoading = A2(
			$author$project$UI$progressBar,
			'is-link',
			t_($author$project$Locale$Messages$TrimesterFeedbackReportLoadingProgress));
		var viewReports = A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					A2($author$project$Element$TrimesterFeedbackReport$viewPage, session, model),
					A2(
					$elm$core$Maybe$withDefault,
					$author$project$UI$none,
					A2(
						$elm$core$Maybe$map,
						function (model_) {
							return A3($author$project$Application$V2$Boundaries$viewElement, session, model_, $author$project$Element$TrimesterFeedbackReport$trimesterFeedbackForm);
						},
						model.dl))
				]));
		return A2(
			$author$project$RemoteData$withDefault,
			viewReportsLoading,
			A2(
				$author$project$RemoteData$map,
				$elm$core$Basics$always(viewReports),
				model.d4));
	});
var $author$project$Element$TrimesterFeedbackReport$element = {iA: $author$project$Element$TrimesterFeedbackReport$init, jR: $author$project$Element$TrimesterFeedbackReport$update, nE: $author$project$Element$TrimesterFeedbackReport$view};
var $author$project$Pages$pages = {
	dB: {
		gF: $author$project$Element$Counter$element,
		bZ: $author$project$Pages$CounterMsg,
		jS: $elm$core$Basics$always($author$project$Pages$CounterModel)
	},
	b7: {
		h_: $elm$core$Basics$always($author$project$Pages$GenericProfileFormModel),
		gF: $author$project$Element$GenericProfileForm$element,
		iV: $author$project$Pages$GenericProfileFormMsg
	},
	b8: {
		h_: $elm$core$Basics$always($author$project$Pages$GradeReportCardModel),
		gF: $author$project$Element$GradeReportCard$element,
		iV: $author$project$Pages$GradeReportCardMsg
	},
	cN: {
		gF: $author$project$Element$GradeRequestList$element,
		bZ: $author$project$Pages$GradeRequestListMsg,
		jS: $elm$core$Basics$always($author$project$Pages$GradeRequestListModel)
	},
	ca: {
		h_: $elm$core$Basics$always($author$project$Pages$GradesOverviewModel),
		gF: $author$project$Element$GradesOverview$element,
		iV: $author$project$Pages$GradesOverviewMsg
	},
	cb: {
		h_: $elm$core$Basics$always($author$project$Pages$HomePageModel),
		gF: $author$project$Element$HomePage$element,
		iV: $author$project$Pages$HomePageMsg
	},
	bl: {
		h_: $elm$core$Basics$always($author$project$Pages$LearningContractsModel),
		gF: $author$project$Element$LearningContracts$element,
		iV: $author$project$Pages$LearningContractsMsg
	},
	bP: {
		gF: $author$project$Element$LearningGroupForm$element,
		bZ: $author$project$Pages$LearningGroupFormMsg,
		jS: $elm$core$Basics$always($author$project$Pages$LearningGroupFormModel)
	},
	cT: {
		gF: $author$project$Element$LearningGroupList$element,
		bZ: $author$project$Pages$LearningGroupListMsg,
		jS: $elm$core$Basics$always($author$project$Pages$LearningGroupListModel)
	},
	eG: {
		gF: $author$project$Element$LearningGroupSelector$element,
		bZ: $author$project$Pages$LearningGroupSelectorMsg,
		jS: $elm$core$Basics$always($author$project$Pages$LearningGroupSelectorModel)
	},
	ce: {
		h_: $elm$core$Basics$always($author$project$Pages$LoBrowserModel),
		gF: $author$project$Element$LoBrowser$element,
		iV: $author$project$Pages$LoBrowserMsg
	},
	eK: {
		gF: $author$project$Element$LoStudentOverview$element,
		bZ: $author$project$Pages$LoStudentOverviewMsg,
		jS: $elm$core$Basics$always($author$project$Pages$LoStudentOverviewModel)
	},
	ch: {
		h_: $elm$core$Basics$always($author$project$Pages$ModuleClosureOverviewModel),
		gF: $author$project$Element$ModuleClosureOverview$element,
		iV: $author$project$Pages$ModuleClosureOverviewMsg
	},
	bR: {
		gF: $author$project$Element$ModuleSingle$element,
		bZ: $author$project$Pages$ModuleSingleMsg,
		jS: $elm$core$Basics$always($author$project$Pages$ModuleSingleModel)
	},
	cj: {
		h_: $elm$core$Basics$always($author$project$Pages$ModuleTeacherProfilesModel),
		gF: $author$project$Element$ModuleTeacherProfiles$element,
		iV: $author$project$Pages$ModuleTeacherProfilesMsg
	},
	am: {
		h_: $elm$core$Basics$always($author$project$Pages$ModulesMainModel),
		gF: $author$project$Element$ModulesMain$element,
		iV: $author$project$Pages$ModulesMainMsg
	},
	ck: {
		h_: $elm$core$Basics$always($author$project$Pages$NotificationListModel),
		gF: $author$project$Element$NotificationList$element,
		iV: $author$project$Pages$NotificationListMsg
	},
	co: {
		h_: $elm$core$Basics$always($author$project$Pages$PhoneBookModel),
		gF: $author$project$Element$PhoneBook$element,
		iV: $author$project$Pages$PhoneBookMsg
	},
	bS: {
		gF: $author$project$Element$PortfolioForm$element,
		bZ: $author$project$Pages$PortfolioFormMsg,
		jS: $elm$core$Basics$always($author$project$Pages$PortfolioFormModel)
	},
	bT: {
		gF: $author$project$Element$PortfolioList$element,
		bZ: $author$project$Pages$PortfolioListMsg,
		jS: $elm$core$Basics$always($author$project$Pages$PortfolioListModel)
	},
	c4: {
		gF: $author$project$Element$PortfolioSingle$element,
		bZ: $author$project$Pages$PortfolioSingleMsg,
		jS: $elm$core$Basics$always($author$project$Pages$PortfolioSingleModel)
	},
	cs: {
		h_: F2(
			function (_v0, model) {
				return $author$project$Pages$RubricSubjectOverviewModel(model);
			}),
		gF: $author$project$Element$RubricSubjectOverview$element,
		iV: $author$project$Pages$RubricSubjectOverviewMsg
	},
	bW: {
		gF: $author$project$Element$RubricsForm$element,
		bZ: $author$project$Pages$RubricsFormMsg,
		jS: $elm$core$Basics$always($author$project$Pages$RubricsFormModel)
	},
	c9: {
		gF: $author$project$Element$RubricsList$element,
		bZ: $author$project$Pages$RubricsListMsg,
		jS: $elm$core$Basics$always($author$project$Pages$RubricsListModel)
	},
	db: {
		gF: $author$project$Element$RubricsSingle$element,
		bZ: $author$project$Pages$RubricsSingleMsg,
		jS: $elm$core$Basics$always($author$project$Pages$RubricsSingleModel)
	},
	dg: {
		gF: $author$project$Element$StudentAbsenceList$element,
		bZ: $author$project$Pages$StudentAbsenceListMsg,
		jS: $elm$core$Basics$always($author$project$Pages$StudentAbsenceListModel)
	},
	cz: {
		h_: $elm$core$Basics$always($author$project$Pages$StudentListModel),
		gF: $author$project$Element$StudentList$element,
		iV: $author$project$Pages$StudentListMsg
	},
	bK: {
		h_: $elm$core$Basics$always($author$project$Pages$StudentProfileFormModel),
		gF: $author$project$Element$StudentProfileForm$element,
		iV: $author$project$Pages$StudentProfileFormMsg
	},
	dh: {
		gF: $author$project$Element$SubjectFeedbackCard$element,
		bZ: $author$project$Pages$SubjectFeedbackCardMsg,
		jS: $elm$core$Basics$always($author$project$Pages$SubjectFeedbackCardModel)
	},
	cA: {
		h_: $elm$core$Basics$always($author$project$Pages$TeacherProfileFormModel),
		gF: $author$project$Element$TeacherProfileForm$element,
		iV: $author$project$Pages$TeacherProfileFormMsg
	},
	aA: {
		h_: $elm$core$Basics$always($author$project$Pages$TimetableModel),
		gF: $author$project$Element$Timetable$element,
		iV: $author$project$Pages$TimetableMsg
	},
	cB: {
		h_: $elm$core$Basics$always($author$project$Pages$TrimesterFeedbackReportModel),
		gF: $author$project$Element$TrimesterFeedbackReport$element,
		iV: $author$project$Pages$TrimesterFeedbackReportMsg
	}
};
var $author$project$Application$Boundaries$updateElement = F4(
	function (session, msg, model, element) {
		return A3(element.gF.jR, session, msg, model);
	});
var $author$project$Pages$init = F5(
	function (key, config, route, session, model) {
		var obsoletePageClosed = _Utils_Tuple3($author$project$Pages$NotLoaded, $elm$core$Platform$Cmd$none, session);
		var noop = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, session);
		var _v0 = _Utils_Tuple2(route, model);
		switch (_v0.a.$) {
			case 4:
				if (_v0.b.$ === 2) {
					return noop;
				} else {
					var params = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.dB,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.dB,
							params));
				}
			case 5:
				if (_v0.b.$ === 3) {
					return noop;
				} else {
					var studentId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.dg,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.dg,
							{jz: studentId}));
				}
			case 6:
				if (_v0.b.$ === 4) {
					return noop;
				} else {
					var personId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.b8,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.b8,
							{g2: personId}));
				}
			case 8:
				if (_v0.b.$ === 6) {
					return noop;
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.ca,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ca, query));
				}
			case 7:
				var personId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.cN,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.cN,
						personId));
			case 9:
				if (_v0.b.$ === 7) {
					var _v1 = _v0.a;
					return noop;
				} else {
					var _v2 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cb,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cb, 0));
				}
			case 10:
				var _v3 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bl,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.bl, $author$project$Element$LearningContracts$Create));
			case 11:
				var _v4 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bl,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.bl, $author$project$Element$LearningContracts$List));
			case 12:
				var id = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.bl,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.bl,
						$author$project$Element$LearningContracts$Update(id)));
			case 13:
				if (_v0.b.$ === 10) {
					var _v5 = _v0.a;
					return noop;
				} else {
					var _v6 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bP,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bP,
							$author$project$Element$LearningGroupForm$Create));
				}
			case 14:
				if (_v0.b.$ === 1) {
					var _v7 = _v0.a;
					return noop;
				} else {
					var _v8 = _v0.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.cT,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.cT,
							0));
				}
			case 15:
				if (_v0.b.$ === 10) {
					return noop;
				} else {
					var learningGroupId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bP,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bP,
							$author$project$Element$LearningGroupForm$UpdateGroup(learningGroupId)));
				}
			case 16:
				if (_v0.b.$ === 12) {
					var _v9 = _v0.a;
					return noop;
				} else {
					var _v10 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.ce,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ce, 0));
				}
			case 17:
				if (_v0.b.$ === 16) {
					return noop;
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.ch,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ch, query));
				}
			case 19:
				if (_v0.b.$ === 8) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cj,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cj, id));
				}
			case 20:
				var _v11 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.am,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.am, $author$project$Element$ModulesMain$CreateModule));
			case 24:
				var _v12 = _v0.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.am,
					A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.am, $author$project$Element$ModulesMain$ListModules));
			case 22:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.bR,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.bR,
						$author$project$Element$ModuleSingle$ViewModule(moduleId)));
			case 18:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.bR,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						config.iJ,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.bR,
						$author$project$Element$ModuleSingle$CloseModule(moduleId)));
			case 21:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.am,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.am,
						$author$project$Element$ModulesMain$CreateModuleFromTemplate(moduleId)));
			case 23:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.am,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.am,
						$author$project$Element$ModulesMain$DuplicateModule(moduleId)));
			case 25:
				var moduleId = _v0.a.a;
				return A3(
					$author$project$Pages$mapProgram,
					model,
					$author$project$Pages$pages.am,
					A4(
						$author$project$Application$Boundaries$initElement,
						config,
						session,
						$author$project$Pages$pages.am,
						$author$project$Element$ModulesMain$UpdateModule(moduleId)));
			case 26:
				if (_v0.b.$ === 17) {
					var _v13 = _v0.a;
					return noop;
				} else {
					var _v14 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.ck,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.ck, 0));
				}
			case 27:
				if (_v0.b.$ === 18) {
					var _v15 = _v0.a;
					return noop;
				} else {
					var _v16 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.co,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.co, 0));
				}
			case 33:
				if (_v0.b.$ === 19) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.b7,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.b7, id));
				}
			case 28:
				if (_v0.b.$ === 20) {
					return noop;
				} else {
					var moduleId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bS,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bS,
							$author$project$Element$PortfolioForm$Create(moduleId)));
				}
			case 29:
				if (_v0.b.$ === 21) {
					return noop;
				} else {
					var storyId = _v0.a.a;
					var params = {
						jB: $author$project$RemoteData$NotAsked,
						nG: $author$project$Element$PortfolioSingle$Page(storyId)
					};
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.c4,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.iJ,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.c4,
							params));
				}
			case 30:
				if (_v0.b.$ === 22) {
					return noop;
				} else {
					var query = _v0.a.a;
					var defaults = $author$project$Element$PortfolioList$defaultParams;
					var params = _Utils_update(
						defaults,
						{
							gG: A2($elm$core$Maybe$map, $author$project$Form$dateToMillis, query.gH),
							mn: A2($elm$core$Maybe$withDefault, false, query.nJ),
							hu: A2($elm$core$Maybe$map, $author$project$Form$dateToMillis, query.hv),
							e1: $author$project$Element$PortfolioList$SpecificStudents(query.e1)
						});
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bT,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.iJ,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bT,
							params));
				}
			case 31:
				if (_v0.b.$ === 22) {
					var _v17 = _v0.a;
					return noop;
				} else {
					var _v18 = _v0.a;
					var defaults = $author$project$Element$PortfolioList$defaultParams;
					var params = _Utils_update(
						defaults,
						{e1: $author$project$Element$PortfolioList$MyChildren});
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bT,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							config.iJ,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bT,
							params));
				}
			case 32:
				if (_v0.b.$ === 20) {
					return noop;
				} else {
					var storyId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgramV2,
						model,
						$author$project$Pages$pages.bS,
						A5(
							$author$project$Application$V2$Boundaries$initElement,
							key,
							$author$project$Application$V2$SharedConfig$fromV1(config),
							session,
							$author$project$Pages$pages.bS,
							$author$project$Element$PortfolioForm$Update(storyId)));
				}
			case 34:
				var _v19 = _v0.a;
				var params = {lz: false, mS: $elm$core$Maybe$Nothing};
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.bW,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.bW,
						params));
			case 36:
				var rubricId = _v0.a.a;
				var params = {
					lz: false,
					mS: $elm$core$Maybe$Just(rubricId)
				};
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.bW,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.bW,
						params));
			case 35:
				var _v20 = _v0.a;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.c9,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.c9,
						$author$project$Element$RubricsList$Page));
			case 38:
				if (_v0.b.$ === 26) {
					return noop;
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cs,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cs, query));
				}
			case 37:
				var rubricId = _v0.a.a;
				var params = $author$project$Element$RubricsSingle$Page(rubricId);
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.db,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.db,
						params));
			case 40:
				if (_v0.b.$ === 27) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.bK,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.bK,
							$author$project$Element$StudentProfileForm$FullProfile(id)));
				}
			case 39:
				if (_v0.b.$ === 27) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.bK,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.bK,
							$author$project$Element$StudentProfileForm$NekProfile(id)));
				}
			case 41:
				if (_v0.b.$ === 28) {
					var _v21 = _v0.a;
					return noop;
				} else {
					var _v22 = _v0.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cz,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cz, 0));
				}
			case 42:
				var _v23 = _v0.a;
				var studentId = _v23.a;
				var maybeSubjectId = _v23.b;
				return A3(
					$author$project$Pages$mapProgramV2,
					model,
					$author$project$Pages$pages.dh,
					A5(
						$author$project$Application$V2$Boundaries$initElement,
						key,
						$author$project$Application$V2$SharedConfig$fromV1(config),
						session,
						$author$project$Pages$pages.dh,
						{jz: studentId, nf: maybeSubjectId}));
			case 43:
				if (_v0.b.$ === 30) {
					return noop;
				} else {
					var id = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cA,
						A4($author$project$Application$Boundaries$initElement, config, session, $author$project$Pages$pages.cA, id));
				}
			case 46:
				if (_v0.b.$ === 31) {
					var query = _v0.a.a;
					var timetableModel = _v0.b.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aA,
						A4(
							$author$project$Application$Boundaries$updateElement,
							session,
							$author$project$Element$Timetable$UpdateEventSelected(query),
							timetableModel,
							$author$project$Pages$pages.aA));
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aA,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aA,
							$author$project$Element$Timetable$UpdateEvent(query)));
				}
			case 45:
				if (_v0.b.$ === 31) {
					var query = _v0.a.a;
					var timetableModel = _v0.b.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aA,
						A4(
							$author$project$Application$Boundaries$updateElement,
							session,
							$author$project$Element$Timetable$CreateEventSelected(query),
							timetableModel,
							$author$project$Pages$pages.aA));
				} else {
					var query = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aA,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aA,
							$author$project$Element$Timetable$CreateEvent(query)));
				}
			case 44:
				if (_v0.b.$ === 31) {
					return noop;
				} else {
					var people = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.aA,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.aA,
							$author$project$Element$Timetable$Calendar(people)));
				}
			case 47:
				if (_v0.b.$ === 32) {
					return noop;
				} else {
					var studentId = _v0.a.a;
					return A3(
						$author$project$Pages$mapProgram,
						model,
						$author$project$Pages$pages.cB,
						A4(
							$author$project$Application$Boundaries$initElement,
							config,
							session,
							$author$project$Pages$pages.cB,
							{jz: studentId}));
				}
			case 48:
				var _v24 = _v0.a;
				return obsoletePageClosed;
			case 0:
				return obsoletePageClosed;
			case 1:
				var _v25 = _v0.a;
				return obsoletePageClosed;
			case 2:
				var _v26 = _v0.a;
				return obsoletePageClosed;
			default:
				return obsoletePageClosed;
		}
	});
var $author$project$Main$session = function (model) {
	var _v0 = model.aR;
	if ((_v0.$ === 2) && (_v0.a.$ === 2)) {
		var s = _v0.a.a;
		return $elm$core$Maybe$Just(s);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Main$openPageByRoute = function (model) {
	var _v0 = $author$project$Main$session(model);
	if (_v0.$ === 1) {
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{bu: $author$project$Pages$notLoaded}),
			$elm$core$Platform$Cmd$none);
	} else {
		var session_ = _v0.a;
		return $author$project$Main$andThenLoadManifest(
			A2(
				$author$project$Main$mapPagesToProgram,
				model,
				A5($author$project$Pages$init, model.iJ, model.bx, model.cr, session_, model.bu)));
	}
};
var $author$project$Api$Endpoint$CsrfToken = $elm$core$Basics$identity;
var $author$project$Api$Endpoint$parseCsrfToken = function (value) {
	return $elm$core$String$isEmpty(value) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(value);
};
var $elm$browser$Browser$Navigation$reload = _Browser_reload(false);
var $author$project$Ports$saveLastRequestedUrl = _Platform_outgoingPort('saveLastRequestedUrl', $elm$json$Json$Encode$string);
var $author$project$Main$trackPageView = function (model) {
	var t_ = A2(
		$elm$core$Maybe$withDefault,
		model.lP.hy,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.hy;
			},
			$author$project$Main$session(model)));
	return $author$project$Ports$sendPageView(
		{
			ms: $author$project$Route$toString(model.cr),
			mt: A2($author$project$Route$pageTitle, t_, model.cr)
		});
};
var $author$project$Pages$update = F4(
	function (key, session, msg, model) {
		var noop = _Utils_Tuple3(model, $elm$core$Platform$Cmd$none, session);
		var _v0 = _Utils_Tuple2(msg, model);
		switch (_v0.a.$) {
			case 0:
				if (_v0.b.$ === 2) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dB);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dB, _return);
				} else {
					return noop;
				}
			case 1:
				if (_v0.b.$ === 3) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dg);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dg, _return);
				} else {
					return noop;
				}
			case 2:
				if (_v0.b.$ === 4) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.b8);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.b8, _return);
				} else {
					return noop;
				}
			case 3:
				if (_v0.b.$ === 5) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.cN);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.cN, _return);
				} else {
					return noop;
				}
			case 4:
				if (_v0.b.$ === 6) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ca);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ca, _return);
				} else {
					return noop;
				}
			case 5:
				if (_v0.b.$ === 7) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cb);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cb, _return);
				} else {
					return noop;
				}
			case 7:
				if (_v0.b.$ === 9) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.bl);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.bl, _return);
				} else {
					return noop;
				}
			case 8:
				if (_v0.b.$ === 10) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.bP);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.bP, _return);
				} else {
					return noop;
				}
			case 9:
				if (_v0.b.$ === 1) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.cT);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.cT, _return);
				} else {
					return noop;
				}
			case 10:
				if (_v0.b.$ === 11) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.eG);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.eG, _return);
				} else {
					return noop;
				}
			case 11:
				if (_v0.b.$ === 12) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ce);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ce, _return);
				} else {
					return noop;
				}
			case 12:
				if (_v0.b.$ === 13) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.eK);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.eK, _return);
				} else {
					return noop;
				}
			case 13:
				if (_v0.b.$ === 16) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ch);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ch, _return);
				} else {
					return noop;
				}
			case 14:
				if (_v0.b.$ === 14) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.am);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.am, _return);
				} else {
					return noop;
				}
			case 15:
				if (_v0.b.$ === 15) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.bR);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.bR, _return);
				} else {
					return noop;
				}
			case 6:
				if (_v0.b.$ === 8) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cj);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cj, _return);
				} else {
					return noop;
				}
			case 16:
				if (_v0.b.$ === 17) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.ck);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.ck, _return);
				} else {
					return noop;
				}
			case 17:
				if (_v0.b.$ === 18) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.co);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.co, _return);
				} else {
					return noop;
				}
			case 18:
				if (_v0.b.$ === 19) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.b7);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.b7, _return);
				} else {
					return noop;
				}
			case 19:
				if (_v0.b.$ === 20) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.bS);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.bS, _return);
				} else {
					return noop;
				}
			case 20:
				if (_v0.b.$ === 22) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.bT);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.bT, _return);
				} else {
					return noop;
				}
			case 21:
				if (_v0.b.$ === 21) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c4);
					var _v1 = A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c4, _return);
					var model2 = _v1.a;
					var cmd = _v1.b;
					var session2 = _v1.c;
					var _v2 = _return.fY;
					if (!_v2.$) {
						var _v3 = _v2.a;
						var redirectCmd = A2(
							$elm$browser$Browser$Navigation$pushUrl,
							key,
							$author$project$Route$toString(
								$author$project$Route$PortfoliosList($author$project$Route$blankPortfoliosListQuery)));
						return _Utils_Tuple3(
							model2,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[cmd, redirectCmd])),
							session2);
					} else {
						return _Utils_Tuple3(model2, cmd, session2);
					}
				} else {
					return noop;
				}
			case 22:
				if (_v0.b.$ === 23) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.c9);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.c9, _return);
				} else {
					return noop;
				}
			case 24:
				if (_v0.b.$ === 25) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.db);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.db, _return);
				} else {
					return noop;
				}
			case 25:
				if (_v0.b.$ === 26) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cs);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cs, _return);
				} else {
					return noop;
				}
			case 23:
				if (_v0.b.$ === 24) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.bW);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.bW, _return);
				} else {
					return noop;
				}
			case 26:
				if (_v0.b.$ === 27) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.bK);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.bK, _return);
				} else {
					return noop;
				}
			case 27:
				if (_v0.b.$ === 28) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cz);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cz, _return);
				} else {
					return noop;
				}
			case 28:
				if (_v0.b.$ === 29) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A5($author$project$Application$V2$Boundaries$updateElement, key, session, msg_, model_, $author$project$Pages$pages.dh);
					return A3($author$project$Pages$mapProgramV2, model, $author$project$Pages$pages.dh, _return);
				} else {
					return noop;
				}
			case 29:
				if (_v0.b.$ === 30) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cA);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cA, _return);
				} else {
					return noop;
				}
			case 30:
				if (_v0.b.$ === 31) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.aA);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.aA, _return);
				} else {
					return noop;
				}
			default:
				if (_v0.b.$ === 32) {
					var msg_ = _v0.a.a;
					var model_ = _v0.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session, msg_, model_, $author$project$Pages$pages.cB);
					return A3($author$project$Pages$mapProgram, model, $author$project$Pages$pages.cB, _return);
				} else {
					return noop;
				}
		}
	});
var $author$project$Main$ClearNotification = function (a) {
	return {$: 7, a: a};
};
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $author$project$Notification$diff = F2(
	function (n1, n2) {
		return $elm$core$Dict$toList(
			A2($elm$core$Dict$diff, n1, n2));
	});
var $author$project$Notification$isOk = function (notification) {
	return notification.cX === 1;
};
var $author$project$Main$newNotifications = F2(
	function (oldSession, newSession) {
		return A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var id = _v0.a;
				var notif = _v0.b;
				return $author$project$Notification$isOk(notif) ? $elm$core$Maybe$Just(id) : $elm$core$Maybe$Nothing;
			},
			A2($author$project$Notification$diff, newSession.fM, oldSession.fM));
	});
var $author$project$Main$withToastNotifications = F2(
	function (oldSession, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		var timeout = 3;
		var toastCmd = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Platform$Cmd$none,
			A2(
				$elm$core$Maybe$map,
				function (newSession) {
					return $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Main$ClearNotification,
								$author$project$Util$Delay$after(timeout)),
							A2($author$project$Main$newNotifications, oldSession, newSession)));
				},
				$author$project$Main$session(model)));
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[cmd, toastCmd])));
	});
var $author$project$Main$broadcastScrollEvent = function (model) {
	var subscriptions_ = _List_fromArray(
		[
			$author$project$Main$PageMsg(
			$author$project$Pages$HomePageMsg(
				$author$project$Element$HomePage$ListElementMsg($author$project$Element$PortfolioList$LoadMoreStories))),
			$author$project$Main$PageMsg(
			$author$project$Pages$ModulesMainMsg($author$project$Element$ModulesMain$LoadMoreModules)),
			$author$project$Main$PageMsg(
			$author$project$Pages$ModuleSingleMsg(
				$author$project$Element$ModuleSingle$PortfolioListMsg($author$project$Element$PortfolioList$LoadMoreStories))),
			$author$project$Main$PageMsg(
			$author$project$Pages$StudentListMsg($author$project$Element$StudentList$LoadMoreStudents))
		]);
	var batchUpdate = F2(
		function (scrollMsg, _v18) {
			var prevModel = _v18.a;
			var prevCmd = _v18.b;
			var _v17 = A2($author$project$Main$update, scrollMsg, prevModel);
			var newModel = _v17.a;
			var newCmd = _v17.b;
			return _Utils_Tuple2(
				newModel,
				$elm$core$Platform$Cmd$batch(
					_List_fromArray(
						[prevCmd, newCmd])));
		});
	return A3(
		$elm$core$List$foldl,
		batchUpdate,
		_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
		subscriptions_);
};
var $author$project$Main$openStartPage = F2(
	function (session_, model) {
		var _v15 = A2($author$project$Main$openNavbar, session_, model);
		var model2 = _v15.a;
		var navbarCmd = _v15.b;
		var _v16 = A2($author$project$Main$updateRoute, model2.cr, model2);
		var model3 = _v16.a;
		var routeCmd = _v16.b;
		return _Utils_Tuple2(
			model3,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						navbarCmd,
						routeCmd,
						A3(
						$author$project$Log$ok,
						model.bx,
						_Utils_Tuple2(
							$author$project$Log$msgOpenStartPage,
							_List_fromArray(
								[
									$elm$core$String$fromInt(session_.nH.gT)
								])),
						$elm$core$Basics$always($author$project$Main$NoOp))
					])));
	});
var $author$project$Main$update = F2(
	function (msg, model) {
		var sharedConfig = model.bx;
		var t__ = model.lP.hy;
		switch (msg.$) {
			case 0:
				if (!msg.a.$) {
					return $author$project$Main$fetchViewer(model);
				} else {
					var error = msg.a.a;
					if (error.$ === 3) {
						var status = error.a;
						return _Utils_Tuple2(
							model,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										$elm$browser$Browser$Navigation$load(
										A2($author$project$Auth0$auth0AuthorizeURL, model.kl, false)),
										$author$project$Ports$saveLastRequestedUrl(
										$author$project$Route$toString(model.cr)),
										function () {
										if (status === 401) {
											return A3(
												$author$project$Log$ok,
												sharedConfig,
												_Utils_Tuple2(
													$author$project$Log$msgAutoLogin,
													_List_fromArray(
														[
															$author$project$Api$httpErrorToRobots(error)
														])),
												$author$project$Main$LogResponse);
										} else {
											return A3(
												$author$project$Log$error,
												sharedConfig,
												_Utils_Tuple3($author$project$Log$msgAutoLogin, $elm$core$Maybe$Nothing, error),
												$author$project$Main$LogResponse);
										}
									}()
									])));
					} else {
						return _Utils_Tuple2(
							A3(
								$author$project$Main$addError,
								_Utils_update(
									model,
									{aR: $author$project$Main$LoggedOut}),
								t__($author$project$Locale$Messages$MainErrorLogin),
								error),
							A3(
								$author$project$Log$error,
								sharedConfig,
								_Utils_Tuple3($author$project$Log$msgLogin, $elm$core$Maybe$Nothing, error),
								$author$project$Main$LogResponse));
					}
				}
			case 2:
				if (!msg.a.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aR: $author$project$Main$LoggedOut}),
						A2($author$project$Route$replaceUrl, sharedConfig.iJ, $author$project$Route$Login));
				} else {
					var error = msg.a.a;
					var _v8 = model.aR;
					if (!_v8.$) {
						return _Utils_Tuple2(
							model,
							A2($author$project$Route$replaceUrl, sharedConfig.iJ, $author$project$Route$Login));
					} else {
						return _Utils_Tuple2(
							A3(
								$author$project$Main$addError,
								model,
								t__($author$project$Locale$Messages$MainErrorLogout),
								error),
							A3(
								$author$project$Log$error,
								sharedConfig,
								_Utils_Tuple3($author$project$Log$msgLogout, $elm$core$Maybe$Nothing, error),
								$author$project$Main$LogResponse));
					}
				}
			case 3:
				if (msg.a.$ === 1) {
					var error = msg.a.a;
					return _Utils_Tuple2(
						A3(
							$author$project$Main$addError,
							model,
							t__($author$project$Locale$Messages$MainErrorProfileDownload),
							error),
						A3(
							$author$project$Log$error,
							sharedConfig,
							_Utils_Tuple3(
								$author$project$Log$msgProfileDownload,
								$elm$core$Maybe$Just('me'),
								error),
							$author$project$Main$LogResponse));
				} else {
					var person = msg.a.a;
					var session_ = $author$project$Session$create(person);
					var model2 = _Utils_update(
						model,
						{
							aR: $author$project$Main$Authenticated(
								$author$project$Main$Viewer(session_))
						});
					return A2($author$project$Main$openStartPage, session_, model2);
				}
			case 4:
				return _Utils_Tuple2(
					model,
					A2($author$project$Api$logout, sharedConfig.gr, $author$project$Main$LogoutResponse));
			case 6:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{bz: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 7:
				var id = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aR: function () {
								var _v9 = model.aR;
								if ((_v9.$ === 2) && (_v9.a.$ === 2)) {
									var session_ = _v9.a.a;
									return $author$project$Main$Authenticated(
										$author$project$Main$Viewer(
											A2($author$project$Session$clearNotification, id, session_)));
								} else {
									var x = _v9;
									return x;
								}
							}()
						}),
					$elm$core$Platform$Cmd$none);
			case 8:
				var urlRequest = msg.a;
				if (!urlRequest.$) {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$browser$Browser$Navigation$pushUrl,
									sharedConfig.iJ,
									$elm$url$Url$toString(url)),
									$author$project$Main$trackPageView(model)
								])));
				} else {
					var url = urlRequest.a;
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Ports$saveLastRequestedUrl(
									$author$project$Route$toString(model.cr)),
									$elm$browser$Browser$Navigation$load(url)
								])));
				}
			case 5:
				var url = msg.a;
				return A2(
					$author$project$Main$updateRoute,
					$author$project$Route$fromUrl(url),
					model);
			case 1:
				if (!msg.a.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var error = msg.a.a;
					return _Utils_Tuple2(
						model,
						$author$project$Ports$consoleError(
							'log' + (' ' + $author$project$Api$httpErrorToRobots(error))));
				}
			case 9:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{fB: true}),
					$elm$core$Platform$Cmd$none);
			case 11:
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A3(
								$author$project$Log$ok,
								sharedConfig,
								_Utils_Tuple2($author$project$Log$msgAppUpdateRequest, _List_Nil),
								$author$project$Main$LogResponse),
								$elm$browser$Browser$Navigation$reload
							])));
			case 10:
				var value = msg.a;
				var csrfToken = $author$project$Api$Endpoint$parseCsrfToken(value);
				var backend = sharedConfig.gr;
				var newBackend = _Utils_update(
					backend,
					{kH: csrfToken});
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bx: _Utils_update(
								sharedConfig,
								{gr: newBackend})
						}),
					A2($author$project$Main$authenticateStep2, model.aR, newBackend));
			case 12:
				return $author$project$Main$broadcastScrollEvent(model);
			case 13:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 14:
				var pageMsg = msg.a;
				if ((((pageMsg.$ === 17) && (pageMsg.a.$ === 5)) && (pageMsg.a.a.$ === 4)) && (!pageMsg.a.a.a.$)) {
					return $author$project$Main$fetchViewer(model);
				} else {
					var _v12 = $author$project$Main$session(model);
					if (_v12.$ === 1) {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					} else {
						var session_ = _v12.a;
						return A2(
							$author$project$Main$withToastNotifications,
							session_,
							A2(
								$author$project$Main$mapPagesToProgram,
								model,
								A4($author$project$Pages$update, model.iJ, session_, pageMsg, model.bu)));
					}
				}
			default:
				var navbarMsg = msg.a;
				var _v13 = _Utils_Tuple2(
					model.d0,
					$author$project$Main$session(model));
				if ((!_v13.a.$) && (!_v13.b.$)) {
					var navbarModel = _v13.a.a;
					var session_ = _v13.b.a;
					var _return = A4($author$project$Application$Boundaries$updateElement, session_, navbarMsg, navbarModel, $author$project$Main$navbar);
					var _v14 = _return.fY;
					if (!_v14.$) {
						var lang = _v14.a;
						return A2(
							$author$project$Main$withToastNotifications,
							session_,
							A2(
								$author$project$Main$openStartPage,
								_return.cv,
								_Utils_update(
									model,
									{lP: lang})));
					} else {
						return A3($author$project$Main$mapProgram, model, $author$project$Main$navbar, _return);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Main$updateRoute = F2(
	function (route, model) {
		var model0 = _Utils_update(
			model,
			{cr: route});
		var _v0 = function () {
			var _v1 = _Utils_Tuple2(
				model.d0,
				$author$project$Main$session(model));
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var navbarModel = _v1.a.a;
				var session_ = _v1.b.a;
				return A3(
					$author$project$Main$mapProgram,
					model0,
					$author$project$Main$navbar,
					A3(
						$author$project$Main$navbar.gF.jR,
						session_,
						$author$project$Element$Navbar$RouteChanged(route),
						navbarModel));
			} else {
				return _Utils_Tuple2(model0, $elm$core$Platform$Cmd$none);
			}
		}();
		var model1 = _v0.a;
		var _v2 = $author$project$Main$openPageByRoute(model1);
		var model2 = _v2.a;
		var pageCmd = _v2.b;
		if ($author$project$Pages$isPageLoaded(model2.bu)) {
			return _Utils_Tuple2(model2, pageCmd);
		} else {
			var _v3 = model2.cr;
			switch (_v3.$) {
				case 3:
					var url = _v3.a;
					return _Utils_Tuple2(
						model2,
						A3(
							$author$project$Log$err,
							model.bx,
							_Utils_Tuple2(
								$author$project$Log$msgPageNotFound,
								$elm$url$Url$toString(url)),
							$author$project$Main$LogResponse));
				case 1:
					var _v4 = $author$project$Main$session(model2);
					if (!_v4.$) {
						return _Utils_Tuple2(
							_Utils_update(
								model2,
								{cr: $author$project$Route$Home}),
							A2($author$project$Route$replaceUrl, model.bx.iJ, $author$project$Route$Home));
					} else {
						return _Utils_Tuple2(model2, $elm$core$Platform$Cmd$none);
					}
				case 2:
					return A2($author$project$Main$update, $author$project$Main$LogOutRequest, model2);
				default:
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}
	});
var $author$project$Locale$Messages$LoadingPageProgress = {$: 173};
var $author$project$Main$ClearErrors = {$: 6};
var $author$project$Locale$Messages$MainErrorGeneral = {$: 203};
var $author$project$Locale$Messages$MainErrorSelfHelp = {$: 208};
var $author$project$Main$viewError = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('content')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$p,
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(error)
					]))
			]));
};
var $author$project$Main$viewErrors = F2(
	function (language, appErrors) {
		if (!appErrors.b) {
			return $author$project$UI$none;
		} else {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('columns')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('column is-two-thirds')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$article,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('message is-danger')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('message-header')
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_Nil,
												_List_fromArray(
													[
														A2($author$project$UI$caption, language.hy, $author$project$Locale$Messages$MainErrorGeneral)
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$class('delete'),
														$elm$html$Html$Events$onClick($author$project$Main$ClearErrors)
													]),
												_List_Nil)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$class('message-body content')
											]),
										A2(
											$elm$core$List$append,
											A2(
												$elm$core$List$map,
												$author$project$Main$viewError,
												$elm$core$List$reverse(appErrors)),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$strong,
															_List_Nil,
															$author$project$UI$textToHtml(
																language.hy($author$project$Locale$Messages$MainErrorSelfHelp)))
														]))
												])))
									]))
							]))
					]));
		}
	});
var $author$project$Element$Navbar$viewLogo = function (logoPath) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-brand')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(logoPath)
									]),
								_List_Nil)
							]))
					]))
			]));
};
var $author$project$Main$loginInProgressPage = F3(
	function (model, caption, style) {
		return A2(
			$elm$html$Html$div,
			_List_Nil,
			_List_fromArray(
				[
					$author$project$Element$Navbar$viewLogo(model.dW),
					$author$project$UI$section(
					_List_fromArray(
						[
							$elm$core$List$isEmpty(model.bz) ? A2($author$project$UI$progressBar, style, caption) : A2($author$project$Main$viewErrors, model.lP, model.bz)
						]))
				]));
	});
var $author$project$Locale$Messages$LoginPageInfo = {$: 175};
var $author$project$Locale$Messages$BtnLogin = {$: 34};
var $author$project$Element$Navbar$viewAnonymous = function (model) {
	return A2(
		$elm$html$Html$nav,
		_List_fromArray(
			[
				$elm$html$Html$Attributes$class('navbar')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-brand')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-item')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$img,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$src(model.dW)
									]),
								_List_Nil)
							]))
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('navbar-menu is-active')
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$class('navbar-start')
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$class('navbar-item has-text-centered ')
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$author$project$UI$attrCyData('login'),
												$elm$html$Html$Attributes$href(
												A2($author$project$Auth0$auth0AuthorizeURL, model.kl, false)),
												$elm$html$Html$Attributes$class(' button is-success')
											]),
										_List_fromArray(
											[
												A2($author$project$UI$caption, model.lP.hy, $author$project$Locale$Messages$BtnLogin)
											]))
									]))
							]))
					]))
			]));
};
var $author$project$Main$loginPage = function (model) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Element$Navbar$viewAnonymous(model),
				$author$project$UI$section(
				_List_fromArray(
					[
						A2($author$project$UI$caption, model.lP.hy, $author$project$Locale$Messages$LoginPageInfo),
						A2($author$project$Main$viewErrors, model.lP, model.bz)
					]))
			]));
};
var $author$project$Notification$isEmpty = function (notifications) {
	return !$elm$core$Dict$size(notifications);
};
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $author$project$Main$ScrolledToBottom = {$: 12};
var $author$project$Util$Html$ScrollEvent = F3(
	function (offsetHeight, scrollHeight, scrollTop) {
		return {i1: offsetHeight, js: scrollHeight, jt: scrollTop};
	});
var $author$project$Util$Html$scrollEventDecoder = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Util$Html$ScrollEvent,
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'offsetHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollHeight']),
		$elm$json$Json$Decode$float),
	A2(
		$elm$json$Json$Decode$at,
		_List_fromArray(
			['target', 'scrollTop']),
		$elm$json$Json$Decode$float));
var $author$project$Util$Html$onScrollToBottom = function (tagger) {
	var isBottom = function (evt) {
		return (_Utils_cmp(evt.jt + evt.i1, evt.js - 5) > -1) ? $elm$json$Json$Decode$succeed(tagger) : $elm$json$Json$Decode$fail('not bottom');
	};
	return A2(
		$elm$html$Html$Events$on,
		'scroll',
		A2($elm$json$Json$Decode$andThen, isBottom, $author$project$Util$Html$scrollEventDecoder));
};
var $author$project$Main$scrollablePanel = function (content) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$author$project$Util$Html$onScrollToBottom($author$project$Main$ScrolledToBottom),
				$elm$html$Html$Attributes$class('is-scrollable')
			]),
		content);
};
var $author$project$UI$toastNotifications = F2(
	function (toMsg, notifications_) {
		var getNotificationClass = function (noticeLevel) {
			if (!noticeLevel) {
				return 'is-danger';
			} else {
				return 'is-success';
			}
		};
		var toastNotificationItem = F2(
			function (id, item) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$class('notification'),
							$elm$html$Html$Attributes$class(
							getNotificationClass(item.cX)),
							$author$project$UI$attrCyData('notification')
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$class('delete'),
									$elm$html$Html$Events$onClick(
									toMsg(id))
								]),
							_List_fromArray(
								[$author$project$UI$none])),
							$elm$html$Html$text(item.cg)
						]));
			});
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('toast')
				]),
			$elm$core$Dict$values(
				A2($elm$core$Dict$map, toastNotificationItem, notifications_)));
	});
var $author$project$Main$AppUpdateRequested = {$: 11};
var $author$project$Locale$Messages$MainUpdateAvailableAction = {$: 210};
var $author$project$Locale$Messages$MainUpdateAvailableInfo = {$: 209};
var $author$project$Main$viewAppUpdateNotification = function (t_) {
	return $author$project$UI$section(
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$class('notification is-dark')
					]),
				_List_fromArray(
					[
						$author$project$UI$Icon$icon(
						_List_fromArray(
							[
								$author$project$UI$Icon$face('fa-bell'),
								$author$project$UI$Icon$style('has-text-primary')
							])),
						$elm$html$Html$text(' '),
						A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MainUpdateAvailableInfo),
						$elm$html$Html$text(' '),
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								A3(
								$author$project$UI$actionLink,
								$author$project$Main$AppUpdateRequested,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$caption, t_, $author$project$Locale$Messages$MainUpdateAvailableAction)
									]))
							]))
					]))
			]));
};
var $author$project$Main$viewNavbar = F2(
	function (session_, model) {
		return A2(
			$elm$html$Html$map,
			$author$project$Main$navbar.iV,
			A2($author$project$Main$navbar.gF.nE, session_, model));
	});
var $author$project$Pages$view = F2(
	function (session, model) {
		switch (model.$) {
			case 0:
				return $elm$html$Html$text('');
			case 2:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dB);
			case 3:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dg);
			case 4:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.b8.iV,
					A2($author$project$Pages$pages.b8.gF.nE, session, pageModel));
			case 5:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.cN);
			case 6:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ca.iV,
					A2($author$project$Pages$pages.ca.gF.nE, session, pageModel));
			case 7:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cb.iV,
					A2($author$project$Pages$pages.cb.gF.nE, session, pageModel));
			case 9:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.bl.iV,
					A2($author$project$Pages$pages.bl.gF.nE, session, pageModel));
			case 10:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.bP);
			case 1:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.cT);
			case 11:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.eG);
			case 12:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ce.iV,
					A2($author$project$Pages$pages.ce.gF.nE, session, pageModel));
			case 13:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.eK);
			case 16:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ch.iV,
					A2($author$project$Pages$pages.ch.gF.nE, session, pageModel));
			case 14:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.am.iV,
					A2($author$project$Pages$pages.am.gF.nE, session, pageModel));
			case 15:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.bR);
			case 8:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cj.iV,
					A2($author$project$Pages$pages.cj.gF.nE, session, pageModel));
			case 17:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.ck.iV,
					A2($author$project$Pages$pages.ck.gF.nE, session, pageModel));
			case 18:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.co.iV,
					A2($author$project$Pages$pages.co.gF.nE, session, pageModel));
			case 19:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.b7.iV,
					A2($author$project$Pages$pages.b7.gF.nE, session, pageModel));
			case 20:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.bS);
			case 22:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.bT);
			case 21:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c4);
			case 23:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.c9);
			case 25:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.db);
			case 24:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.bW);
			case 26:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cs.iV,
					A2($author$project$Pages$pages.cs.gF.nE, session, pageModel));
			case 27:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.bK.iV,
					A2($author$project$Pages$pages.bK.gF.nE, session, pageModel));
			case 28:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cz.iV,
					A2($author$project$Pages$pages.cz.gF.nE, session, pageModel));
			case 29:
				var pageModel = model.a;
				return A3($author$project$Application$V2$Boundaries$viewElement, session, pageModel, $author$project$Pages$pages.dh);
			case 30:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cA.iV,
					A2($author$project$Pages$pages.cA.gF.nE, session, pageModel));
			case 31:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.aA.iV,
					A2($author$project$Pages$pages.aA.gF.nE, session, pageModel));
			default:
				var pageModel = model.a;
				return A2(
					$elm$html$Html$map,
					$author$project$Pages$pages.cB.iV,
					A2($author$project$Pages$pages.cB.gF.nE, session, pageModel));
		}
	});
var $author$project$Locale$Messages$LogoutPageProgress = {$: 176};
var $author$project$Locale$Messages$MainErrorPageNotFound = function (a) {
	return {$: 206, a: a};
};
var $author$project$Main$viewPageNotFound = F2(
	function (t_, route) {
		return $author$project$UI$notification(
			_List_fromArray(
				[
					A2(
					$author$project$UI$caption,
					t_,
					$author$project$Locale$Messages$MainErrorPageNotFound(
						$author$project$Route$toString(route)))
				]));
	});
var $author$project$Main$viewSpecialPageByRoute = F2(
	function (_v0, model) {
		var t_ = _v0.hy;
		var viewNotFoundPage = A2($author$project$Main$viewPageNotFound, model.lP.hy, model.cr);
		var _v1 = model.cr;
		switch (_v1.$) {
			case 2:
				return A2(
					$author$project$UI$progressBar,
					'is-link',
					t_($author$project$Locale$Messages$LogoutPageProgress));
			case 1:
				return $author$project$Main$loginPage(model);
			case 3:
				return viewNotFoundPage;
			case 0:
				return viewNotFoundPage;
			case 48:
				return viewNotFoundPage;
			default:
				return viewNotFoundPage;
		}
	});
var $author$project$Main$viewPage = F2(
	function (session_, model) {
		var _v0 = model.bz;
		if (!_v0.b) {
			return $author$project$Pages$isPageLoaded(model.bu) ? A2(
				$elm$html$Html$map,
				$author$project$Main$PageMsg,
				A2($author$project$Pages$view, session_, model.bu)) : A2($author$project$Main$viewSpecialPageByRoute, session_, model);
		} else {
			return A2($author$project$Main$viewErrors, model.lP, model.bz);
		}
	});
var $author$project$Main$viewSessionPage = F2(
	function (model, session_) {
		return $author$project$Main$scrollablePanel(
			_List_fromArray(
				[
					A2(
					$author$project$UI$maybe,
					model.d0,
					$author$project$Main$viewNavbar(session_)),
					A2(
					$elm$html$Html$main_,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$UI$when,
							model.fB,
							$author$project$Main$viewAppUpdateNotification(session_.hy)),
							A2(
							$author$project$UI$when,
							!$author$project$Notification$isEmpty(session_.fM),
							A2(
								$elm$html$Html$section,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$UI$toastNotifications, $author$project$Main$ClearNotification, session_.fM)
									]))),
							$author$project$UI$section(
							_List_fromArray(
								[
									A2($author$project$Main$viewPage, session_, model)
								]))
						]))
				]));
	});
var $author$project$Main$view = function (model) {
	var t__ = model.lP.hy;
	var _v0 = model.aR;
	switch (_v0.$) {
		case 0:
			return {
				O: _List_fromArray(
					[
						$author$project$Main$loginPage(model)
					]),
				jJ: A2($author$project$Route$pageTitle, t__, model.cr)
			};
		case 1:
			return {
				O: _List_fromArray(
					[
						A3(
						$author$project$Main$loginInProgressPage,
						model,
						t__($author$project$Locale$Messages$LoadingPageProgress),
						'is-primary')
					]),
				jJ: A2($author$project$Route$pageTitle, t__, model.cr)
			};
		default:
			switch (_v0.a.$) {
				case 0:
					return {
						O: _List_fromArray(
							[
								A3(
								$author$project$Main$loginInProgressPage,
								model,
								t__($author$project$Locale$Messages$LoadingPageProgress),
								'is-warning')
							]),
						jJ: A2($author$project$Route$pageTitle, t__, model.cr)
					};
				case 1:
					var _v1 = _v0.a;
					return {
						O: _List_fromArray(
							[
								A3(
								$author$project$Main$loginInProgressPage,
								model,
								t__($author$project$Locale$Messages$LoadingPageProgress),
								'is-info')
							]),
						jJ: A2($author$project$Route$pageTitle, t__, model.cr)
					};
				default:
					var sess = _v0.a.a;
					return {
						O: _List_fromArray(
							[
								A2($author$project$Main$viewSessionPage, model, sess)
							]),
						jJ: A2($author$project$Route$pageTitle, sess.hy, model.cr)
					};
			}
	}
};
var $author$project$Main$main = $elm$browser$Browser$application(
	{iA: $author$project$Main$init, ml: $author$project$Main$UrlChange, mm: $author$project$Main$LinkClicked, nh: $author$project$Main$subscriptions, jR: $author$project$Main$update, nE: $author$project$Main$view});
_Platform_export({'Main':{'init':$author$project$Main$main(
	A2(
		$elm$json$Json$Decode$andThen,
		function (logoPath) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (logMaxLength) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (logAppName) {
							return A2(
								$elm$json$Json$Decode$andThen,
								function (lastRequestedUrl) {
									return A2(
										$elm$json$Json$Decode$andThen,
										function (buildRev) {
											return A2(
												$elm$json$Json$Decode$andThen,
												function (auth0Domain) {
													return A2(
														$elm$json$Json$Decode$andThen,
														function (auth0ClientId) {
															return A2(
																$elm$json$Json$Decode$andThen,
																function (auth0Callback) {
																	return A2(
																		$elm$json$Json$Decode$andThen,
																		function (apiBase) {
																			return $elm$json$Json$Decode$succeed(
																				{fg: apiBase, kj: auth0Callback, kk: auth0ClientId, km: auth0Domain, gv: buildRev, lQ: lastRequestedUrl, g6: logAppName, g7: logMaxLength, dW: logoPath});
																		},
																		A2($elm$json$Json$Decode$field, 'apiBase', $elm$json$Json$Decode$string));
																},
																A2($elm$json$Json$Decode$field, 'auth0Callback', $elm$json$Json$Decode$string));
														},
														A2($elm$json$Json$Decode$field, 'auth0ClientId', $elm$json$Json$Decode$string));
												},
												A2($elm$json$Json$Decode$field, 'auth0Domain', $elm$json$Json$Decode$string));
										},
										A2($elm$json$Json$Decode$field, 'buildRev', $elm$json$Json$Decode$string));
								},
								A2(
									$elm$json$Json$Decode$field,
									'lastRequestedUrl',
									$elm$json$Json$Decode$oneOf(
										_List_fromArray(
											[
												$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
												A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $elm$json$Json$Decode$string)
											]))));
						},
						A2($elm$json$Json$Decode$field, 'logAppName', $elm$json$Json$Decode$string));
				},
				A2($elm$json$Json$Decode$field, 'logMaxLength', $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$field, 'logoPath', $elm$json$Json$Decode$string)))(0)}});}(this));